var uR = Object.defineProperty;
var fR = (t, e, r) => e in t ? uR(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var Zt = (t, e, r) => (fR(t, typeof e != "symbol" ? e + "" : e, r), r), d1 = (t, e, r) => {
  if (!e.has(t))
    throw TypeError("Cannot " + r);
};
var ke = (t, e, r) => (d1(t, e, "read from private field"), r ? r.call(t) : e.get(t)), ct = (t, e, r) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, ir = (t, e, r, n) => (d1(t, e, "write to private field"), n ? n.call(t, r) : e.set(t, r), r);
var Oo = (t, e, r) => (d1(t, e, "access private method"), r);
function dR(t, e) {
  for (var r = 0; r < e.length; r++) {
    const n = e[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const i in n)
        if (i !== "default" && !(i in t)) {
          const s = Object.getOwnPropertyDescriptor(n, i);
          s && Object.defineProperty(t, i, s.get ? s : {
            enumerable: !0,
            get: () => n[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
function lR(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Bx = { exports: {} }, gn = Bx.exports = {}, Fs, js;
function Hm() {
  throw new Error("setTimeout has not been defined");
}
function Gm() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Fs = setTimeout : Fs = Hm;
  } catch {
    Fs = Hm;
  }
  try {
    typeof clearTimeout == "function" ? js = clearTimeout : js = Gm;
  } catch {
    js = Gm;
  }
})();
function Mx(t) {
  if (Fs === setTimeout)
    return setTimeout(t, 0);
  if ((Fs === Hm || !Fs) && setTimeout)
    return Fs = setTimeout, setTimeout(t, 0);
  try {
    return Fs(t, 0);
  } catch {
    try {
      return Fs.call(null, t, 0);
    } catch {
      return Fs.call(this, t, 0);
    }
  }
}
function hR(t) {
  if (js === clearTimeout)
    return clearTimeout(t);
  if ((js === Gm || !js) && clearTimeout)
    return js = clearTimeout, clearTimeout(t);
  try {
    return js(t);
  } catch {
    try {
      return js.call(null, t);
    } catch {
      return js.call(this, t);
    }
  }
}
var Pa = [], wu = !1, Ho, Dh = -1;
function pR() {
  !wu || !Ho || (wu = !1, Ho.length ? Pa = Ho.concat(Pa) : Dh = -1, Pa.length && Cx());
}
function Cx() {
  if (!wu) {
    var t = Mx(pR);
    wu = !0;
    for (var e = Pa.length; e; ) {
      for (Ho = Pa, Pa = []; ++Dh < e; )
        Ho && Ho[Dh].run();
      Dh = -1, e = Pa.length;
    }
    Ho = null, wu = !1, hR(t);
  }
}
gn.nextTick = function(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var r = 1; r < arguments.length; r++)
      e[r - 1] = arguments[r];
  Pa.push(new Nx(t, e)), Pa.length === 1 && !wu && Mx(Cx);
};
function Nx(t, e) {
  this.fun = t, this.array = e;
}
Nx.prototype.run = function() {
  this.fun.apply(null, this.array);
};
gn.title = "browser";
gn.browser = !0;
gn.env = {};
gn.argv = [];
gn.version = "";
gn.versions = {};
function Fa() {
}
gn.on = Fa;
gn.addListener = Fa;
gn.once = Fa;
gn.off = Fa;
gn.removeListener = Fa;
gn.removeAllListeners = Fa;
gn.emit = Fa;
gn.prependListener = Fa;
gn.prependOnceListener = Fa;
gn.listeners = function(t) {
  return [];
};
gn.binding = function(t) {
  throw new Error("process.binding is not supported");
};
gn.cwd = function() {
  return "/";
};
gn.chdir = function(t) {
  throw new Error("process.chdir is not supported");
};
gn.umask = function() {
  return 0;
};
var yR = Bx.exports;
const ut = /* @__PURE__ */ lR(yR);
function Zm() {
  const t = {};
  return t.promise = new Promise((e, r) => {
    t.resolve = e, t.reject = r;
  }), t;
}
var lr;
(function(t) {
  t.assertEqual = (i) => i;
  function e(i) {
  }
  t.assertIs = e;
  function r(i) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (i) => {
    const s = {};
    for (const a of i)
      s[a] = a;
    return s;
  }, t.getValidEnumValues = (i) => {
    const s = t.objectKeys(i).filter((o) => typeof i[i[o]] != "number"), a = {};
    for (const o of s)
      a[o] = i[o];
    return t.objectValues(a);
  }, t.objectValues = (i) => t.objectKeys(i).map(function(s) {
    return i[s];
  }), t.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const s = [];
    for (const a in i)
      Object.prototype.hasOwnProperty.call(i, a) && s.push(a);
    return s;
  }, t.find = (i, s) => {
    for (const a of i)
      if (s(a))
        return a;
  }, t.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function n(i, s = " | ") {
    return i.map((a) => typeof a == "string" ? `'${a}'` : a).join(s);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (i, s) => typeof s == "bigint" ? s.toString() : s;
})(lr || (lr = {}));
var Jm;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(Jm || (Jm = {}));
const rt = lr.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), eo = (t) => {
  switch (typeof t) {
    case "undefined":
      return rt.undefined;
    case "string":
      return rt.string;
    case "number":
      return isNaN(t) ? rt.nan : rt.number;
    case "boolean":
      return rt.boolean;
    case "function":
      return rt.function;
    case "bigint":
      return rt.bigint;
    case "symbol":
      return rt.symbol;
    case "object":
      return Array.isArray(t) ? rt.array : t === null ? rt.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? rt.promise : typeof Map < "u" && t instanceof Map ? rt.map : typeof Set < "u" && t instanceof Set ? rt.set : typeof Date < "u" && t instanceof Date ? rt.date : rt.object;
    default:
      return rt.unknown;
  }
}, qe = lr.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), bR = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class $i extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const r = e || function(s) {
      return s.message;
    }, n = { _errors: [] }, i = (s) => {
      for (const a of s.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(i);
        else if (a.code === "invalid_return_type")
          i(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          i(a.argumentsError);
        else if (a.path.length === 0)
          n._errors.push(r(a));
        else {
          let o = n, c = 0;
          for (; c < a.path.length; ) {
            const f = a.path[c];
            c === a.path.length - 1 ? (o[f] = o[f] || { _errors: [] }, o[f]._errors.push(r(a))) : o[f] = o[f] || { _errors: [] }, o = o[f], c++;
          }
        }
    };
    return i(this), n;
  }
  static assert(e) {
    if (!(e instanceof $i))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, lr.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const i of this.issues)
      i.path.length > 0 ? (r[i.path[0]] = r[i.path[0]] || [], r[i.path[0]].push(e(i))) : n.push(e(i));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
$i.create = (t) => new $i(t);
const Fu = (t, e) => {
  let r;
  switch (t.code) {
    case qe.invalid_type:
      t.received === rt.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case qe.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, lr.jsonStringifyReplacer)}`;
      break;
    case qe.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${lr.joinValues(t.keys, ", ")}`;
      break;
    case qe.invalid_union:
      r = "Invalid input";
      break;
    case qe.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${lr.joinValues(t.options)}`;
      break;
    case qe.invalid_enum_value:
      r = `Invalid enum value. Expected ${lr.joinValues(t.options)}, received '${t.received}'`;
      break;
    case qe.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case qe.invalid_return_type:
      r = "Invalid function return type";
      break;
    case qe.invalid_date:
      r = "Invalid date";
      break;
    case qe.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : lr.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case qe.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case qe.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case qe.custom:
      r = "Invalid input";
      break;
    case qe.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case qe.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case qe.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, lr.assertNever(t);
  }
  return { message: r };
};
let Ux = Fu;
function gR(t) {
  Ux = t;
}
function ip() {
  return Ux;
}
const sp = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: i } = t, s = [...r, ...i.path || []], a = {
    ...i,
    path: s
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: s,
      message: i.message
    };
  let o = "";
  const c = n.filter((f) => !!f).slice().reverse();
  for (const f of c)
    o = f(a, { data: e, defaultError: o }).message;
  return {
    ...i,
    path: s,
    message: o
  };
}, mR = [];
function Xe(t, e) {
  const r = ip(), n = sp({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      r,
      r === Fu ? void 0 : Fu
      // then global default map
    ].filter((i) => !!i)
  });
  t.common.issues.push(n);
}
class ui {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const i of r) {
      if (i.status === "aborted")
        return It;
      i.status === "dirty" && e.dirty(), n.push(i.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const i of r) {
      const s = await i.key, a = await i.value;
      n.push({
        key: s,
        value: a
      });
    }
    return ui.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const i of r) {
      const { key: s, value: a } = i;
      if (s.status === "aborted" || a.status === "aborted")
        return It;
      s.status === "dirty" && e.dirty(), a.status === "dirty" && e.dirty(), s.value !== "__proto__" && (typeof a.value < "u" || i.alwaysSet) && (n[s.value] = a.value);
    }
    return { status: e.value, value: n };
  }
}
const It = Object.freeze({
  status: "aborted"
}), bu = (t) => ({ status: "dirty", value: t }), hi = (t) => ({ status: "valid", value: t }), Ym = (t) => t.status === "aborted", Qm = (t) => t.status === "dirty", yd = (t) => t.status === "valid", bd = (t) => typeof Promise < "u" && t instanceof Promise;
function ap(t, e, r, n) {
  if (r === "a" && !n)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !n : !e.has(t))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(t) : n ? n.value : e.get(t);
}
function Lx(t, e, r, n, i) {
  if (n === "m")
    throw new TypeError("Private method is not writable");
  if (n === "a" && !i)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? i.call(t, r) : i ? i.value = r : e.set(t, r), r;
}
var yt;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(yt || (yt = {}));
var Yf, Qf;
class Qs {
  constructor(e, r, n, i) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const e3 = (t, e) => {
  if (yd(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new $i(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function Ut(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: i } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: i } : { errorMap: (a, o) => {
    var c, f;
    const { message: u } = t;
    return a.code === "invalid_enum_value" ? { message: u ?? o.defaultError } : typeof o.data > "u" ? { message: (c = u ?? n) !== null && c !== void 0 ? c : o.defaultError } : a.code !== "invalid_type" ? { message: o.defaultError } : { message: (f = u ?? r) !== null && f !== void 0 ? f : o.defaultError };
  }, description: i };
}
class zt {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return eo(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: eo(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new ui(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: eo(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (bd(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const i = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: eo(e)
    }, s = this._parseSync({ data: e, path: i.path, parent: i });
    return e3(i, s);
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: eo(e)
    }, i = this._parse({ data: e, path: n.path, parent: n }), s = await (bd(i) ? i : Promise.resolve(i));
    return e3(n, s);
  }
  refine(e, r) {
    const n = (i) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(i) : r;
    return this._refinement((i, s) => {
      const a = e(i), o = () => s.addIssue({
        code: qe.custom,
        ...n(i)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((c) => c ? !0 : (o(), !1)) : a ? !0 : (o(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, i) => e(n) ? !0 : (i.addIssue(typeof r == "function" ? r(n, i) : r), !1));
  }
  _refinement(e) {
    return new xs({
      schema: this,
      typeName: At.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return Zs.create(this, this._def);
  }
  nullable() {
    return _o.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return _s.create(this, this._def);
  }
  promise() {
    return $u.create(this, this._def);
  }
  or(e) {
    return wd.create([this, e], this._def);
  }
  and(e) {
    return _d.create(this, e, this._def);
  }
  transform(e) {
    return new xs({
      ...Ut(this._def),
      schema: this,
      typeName: At.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Id({
      ...Ut(this._def),
      innerType: this,
      defaultValue: r,
      typeName: At.ZodDefault
    });
  }
  brand() {
    return new g2({
      typeName: At.ZodBranded,
      type: this,
      ...Ut(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Td({
      ...Ut(this._def),
      innerType: this,
      catchValue: r,
      typeName: At.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return vl.create(this, e);
  }
  readonly() {
    return kd.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const vR = /^c[^\s-]{8,}$/i, wR = /^[0-9a-z]+$/, _R = /^[0-9A-HJKMNP-TV-Z]{26}$/, SR = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, ER = /^[a-z0-9_-]{21}$/i, xR = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, AR = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, IR = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let l1;
const TR = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, kR = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, RR = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Dx = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", PR = new RegExp(`^${Dx}$`);
function Fx(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function OR(t) {
  return new RegExp(`^${Fx(t)}$`);
}
function jx(t) {
  let e = `${Dx}T${Fx(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function BR(t, e) {
  return !!((e === "v4" || !e) && TR.test(t) || (e === "v6" || !e) && kR.test(t));
}
class vs extends zt {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== rt.string) {
      const s = this._getOrReturnCtx(e);
      return Xe(s, {
        code: qe.invalid_type,
        expected: rt.string,
        received: s.parsedType
      }), It;
    }
    const n = new ui();
    let i;
    for (const s of this._def.checks)
      if (s.kind === "min")
        e.data.length < s.value && (i = this._getOrReturnCtx(e, i), Xe(i, {
          code: qe.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        e.data.length > s.value && (i = this._getOrReturnCtx(e, i), Xe(i, {
          code: qe.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const a = e.data.length > s.value, o = e.data.length < s.value;
        (a || o) && (i = this._getOrReturnCtx(e, i), a ? Xe(i, {
          code: qe.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && Xe(i, {
          code: qe.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        AR.test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          validation: "email",
          code: qe.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        l1 || (l1 = new RegExp(IR, "u")), l1.test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          validation: "emoji",
          code: qe.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        SR.test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          validation: "uuid",
          code: qe.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        ER.test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          validation: "nanoid",
          code: qe.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        vR.test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          validation: "cuid",
          code: qe.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        wR.test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          validation: "cuid2",
          code: qe.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        _R.test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          validation: "ulid",
          code: qe.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(e.data);
        } catch {
          i = this._getOrReturnCtx(e, i), Xe(i, {
            validation: "url",
            code: qe.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else
        s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          validation: "regex",
          code: qe.invalid_string,
          message: s.message
        }), n.dirty())) : s.kind === "trim" ? e.data = e.data.trim() : s.kind === "includes" ? e.data.includes(s.value, s.position) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          code: qe.invalid_string,
          validation: { includes: s.value, position: s.position },
          message: s.message
        }), n.dirty()) : s.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : s.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : s.kind === "startsWith" ? e.data.startsWith(s.value) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          code: qe.invalid_string,
          validation: { startsWith: s.value },
          message: s.message
        }), n.dirty()) : s.kind === "endsWith" ? e.data.endsWith(s.value) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          code: qe.invalid_string,
          validation: { endsWith: s.value },
          message: s.message
        }), n.dirty()) : s.kind === "datetime" ? jx(s).test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          code: qe.invalid_string,
          validation: "datetime",
          message: s.message
        }), n.dirty()) : s.kind === "date" ? PR.test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          code: qe.invalid_string,
          validation: "date",
          message: s.message
        }), n.dirty()) : s.kind === "time" ? OR(s).test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          code: qe.invalid_string,
          validation: "time",
          message: s.message
        }), n.dirty()) : s.kind === "duration" ? xR.test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          validation: "duration",
          code: qe.invalid_string,
          message: s.message
        }), n.dirty()) : s.kind === "ip" ? BR(e.data, s.version) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          validation: "ip",
          code: qe.invalid_string,
          message: s.message
        }), n.dirty()) : s.kind === "base64" ? RR.test(e.data) || (i = this._getOrReturnCtx(e, i), Xe(i, {
          validation: "base64",
          code: qe.invalid_string,
          message: s.message
        }), n.dirty()) : lr.assertNever(s);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((i) => e.test(i), {
      validation: r,
      code: qe.invalid_string,
      ...yt.errToObj(n)
    });
  }
  _addCheck(e) {
    return new vs({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...yt.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...yt.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...yt.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...yt.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...yt.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...yt.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...yt.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...yt.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...yt.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...yt.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...yt.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...yt.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...yt.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...yt.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...yt.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...yt.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...yt.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...yt.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...yt.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...yt.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, yt.errToObj(e));
  }
  trim() {
    return new vs({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new vs({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new vs({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
vs.create = (t) => {
  var e;
  return new vs({
    checks: [],
    typeName: At.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...Ut(t)
  });
};
function MR(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, i = r > n ? r : n, s = parseInt(t.toFixed(i).replace(".", "")), a = parseInt(e.toFixed(i).replace(".", ""));
  return s % a / Math.pow(10, i);
}
class mo extends zt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== rt.number) {
      const s = this._getOrReturnCtx(e);
      return Xe(s, {
        code: qe.invalid_type,
        expected: rt.number,
        received: s.parsedType
      }), It;
    }
    let n;
    const i = new ui();
    for (const s of this._def.checks)
      s.kind === "int" ? lr.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), Xe(n, {
        code: qe.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), i.dirty()) : s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), Xe(n, {
        code: qe.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), i.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), Xe(n, {
        code: qe.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), i.dirty()) : s.kind === "multipleOf" ? MR(e.data, s.value) !== 0 && (n = this._getOrReturnCtx(e, n), Xe(n, {
        code: qe.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), i.dirty()) : s.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), Xe(n, {
        code: qe.not_finite,
        message: s.message
      }), i.dirty()) : lr.assertNever(s);
    return { status: i.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, yt.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, yt.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, yt.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, yt.toString(r));
  }
  setLimit(e, r, n, i) {
    return new mo({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: yt.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new mo({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: yt.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: yt.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: yt.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: yt.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: yt.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: yt.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: yt.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: yt.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: yt.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && lr.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
mo.create = (t) => new mo({
  checks: [],
  typeName: At.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...Ut(t)
});
class vo extends zt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== rt.bigint) {
      const s = this._getOrReturnCtx(e);
      return Xe(s, {
        code: qe.invalid_type,
        expected: rt.bigint,
        received: s.parsedType
      }), It;
    }
    let n;
    const i = new ui();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), Xe(n, {
        code: qe.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), i.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), Xe(n, {
        code: qe.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), i.dirty()) : s.kind === "multipleOf" ? e.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), Xe(n, {
        code: qe.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), i.dirty()) : lr.assertNever(s);
    return { status: i.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, yt.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, yt.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, yt.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, yt.toString(r));
  }
  setLimit(e, r, n, i) {
    return new vo({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: yt.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new vo({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: yt.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: yt.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: yt.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: yt.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: yt.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
vo.create = (t) => {
  var e;
  return new vo({
    checks: [],
    typeName: At.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...Ut(t)
  });
};
class gd extends zt {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== rt.boolean) {
      const n = this._getOrReturnCtx(e);
      return Xe(n, {
        code: qe.invalid_type,
        expected: rt.boolean,
        received: n.parsedType
      }), It;
    }
    return hi(e.data);
  }
}
gd.create = (t) => new gd({
  typeName: At.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...Ut(t)
});
class vc extends zt {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== rt.date) {
      const s = this._getOrReturnCtx(e);
      return Xe(s, {
        code: qe.invalid_type,
        expected: rt.date,
        received: s.parsedType
      }), It;
    }
    if (isNaN(e.data.getTime())) {
      const s = this._getOrReturnCtx(e);
      return Xe(s, {
        code: qe.invalid_date
      }), It;
    }
    const n = new ui();
    let i;
    for (const s of this._def.checks)
      s.kind === "min" ? e.data.getTime() < s.value && (i = this._getOrReturnCtx(e, i), Xe(i, {
        code: qe.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? e.data.getTime() > s.value && (i = this._getOrReturnCtx(e, i), Xe(i, {
        code: qe.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : lr.assertNever(s);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new vc({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: yt.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: yt.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
vc.create = (t) => new vc({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: At.ZodDate,
  ...Ut(t)
});
class op extends zt {
  _parse(e) {
    if (this._getType(e) !== rt.symbol) {
      const n = this._getOrReturnCtx(e);
      return Xe(n, {
        code: qe.invalid_type,
        expected: rt.symbol,
        received: n.parsedType
      }), It;
    }
    return hi(e.data);
  }
}
op.create = (t) => new op({
  typeName: At.ZodSymbol,
  ...Ut(t)
});
class md extends zt {
  _parse(e) {
    if (this._getType(e) !== rt.undefined) {
      const n = this._getOrReturnCtx(e);
      return Xe(n, {
        code: qe.invalid_type,
        expected: rt.undefined,
        received: n.parsedType
      }), It;
    }
    return hi(e.data);
  }
}
md.create = (t) => new md({
  typeName: At.ZodUndefined,
  ...Ut(t)
});
class vd extends zt {
  _parse(e) {
    if (this._getType(e) !== rt.null) {
      const n = this._getOrReturnCtx(e);
      return Xe(n, {
        code: qe.invalid_type,
        expected: rt.null,
        received: n.parsedType
      }), It;
    }
    return hi(e.data);
  }
}
vd.create = (t) => new vd({
  typeName: At.ZodNull,
  ...Ut(t)
});
class ju extends zt {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return hi(e.data);
  }
}
ju.create = (t) => new ju({
  typeName: At.ZodAny,
  ...Ut(t)
});
class fc extends zt {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return hi(e.data);
  }
}
fc.create = (t) => new fc({
  typeName: At.ZodUnknown,
  ...Ut(t)
});
class Na extends zt {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return Xe(r, {
      code: qe.invalid_type,
      expected: rt.never,
      received: r.parsedType
    }), It;
  }
}
Na.create = (t) => new Na({
  typeName: At.ZodNever,
  ...Ut(t)
});
class cp extends zt {
  _parse(e) {
    if (this._getType(e) !== rt.undefined) {
      const n = this._getOrReturnCtx(e);
      return Xe(n, {
        code: qe.invalid_type,
        expected: rt.void,
        received: n.parsedType
      }), It;
    }
    return hi(e.data);
  }
}
cp.create = (t) => new cp({
  typeName: At.ZodVoid,
  ...Ut(t)
});
class _s extends zt {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), i = this._def;
    if (r.parsedType !== rt.array)
      return Xe(r, {
        code: qe.invalid_type,
        expected: rt.array,
        received: r.parsedType
      }), It;
    if (i.exactLength !== null) {
      const a = r.data.length > i.exactLength.value, o = r.data.length < i.exactLength.value;
      (a || o) && (Xe(r, {
        code: a ? qe.too_big : qe.too_small,
        minimum: o ? i.exactLength.value : void 0,
        maximum: a ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), n.dirty());
    }
    if (i.minLength !== null && r.data.length < i.minLength.value && (Xe(r, {
      code: qe.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), n.dirty()), i.maxLength !== null && r.data.length > i.maxLength.value && (Xe(r, {
      code: qe.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((a, o) => i.type._parseAsync(new Qs(r, a, r.path, o)))).then((a) => ui.mergeArray(n, a));
    const s = [...r.data].map((a, o) => i.type._parseSync(new Qs(r, a, r.path, o)));
    return ui.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new _s({
      ...this._def,
      minLength: { value: e, message: yt.toString(r) }
    });
  }
  max(e, r) {
    return new _s({
      ...this._def,
      maxLength: { value: e, message: yt.toString(r) }
    });
  }
  length(e, r) {
    return new _s({
      ...this._def,
      exactLength: { value: e, message: yt.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
_s.create = (t, e) => new _s({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: At.ZodArray,
  ...Ut(e)
});
function ou(t) {
  if (t instanceof Xr) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = Zs.create(ou(n));
    }
    return new Xr({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof _s ? new _s({
      ...t._def,
      type: ou(t.element)
    }) : t instanceof Zs ? Zs.create(ou(t.unwrap())) : t instanceof _o ? _o.create(ou(t.unwrap())) : t instanceof Xs ? Xs.create(t.items.map((e) => ou(e))) : t;
}
class Xr extends zt {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = lr.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== rt.object) {
      const f = this._getOrReturnCtx(e);
      return Xe(f, {
        code: qe.invalid_type,
        expected: rt.object,
        received: f.parsedType
      }), It;
    }
    const { status: n, ctx: i } = this._processInputParams(e), { shape: s, keys: a } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Na && this._def.unknownKeys === "strip"))
      for (const f in i.data)
        a.includes(f) || o.push(f);
    const c = [];
    for (const f of a) {
      const u = s[f], d = i.data[f];
      c.push({
        key: { status: "valid", value: f },
        value: u._parse(new Qs(i, d, i.path, f)),
        alwaysSet: f in i.data
      });
    }
    if (this._def.catchall instanceof Na) {
      const f = this._def.unknownKeys;
      if (f === "passthrough")
        for (const u of o)
          c.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: i.data[u] }
          });
      else if (f === "strict")
        o.length > 0 && (Xe(i, {
          code: qe.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (f !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const f = this._def.catchall;
      for (const u of o) {
        const d = i.data[u];
        c.push({
          key: { status: "valid", value: u },
          value: f._parse(
            new Qs(i, d, i.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const f = [];
      for (const u of c) {
        const d = await u.key, l = await u.value;
        f.push({
          key: d,
          value: l,
          alwaysSet: u.alwaysSet
        });
      }
      return f;
    }).then((f) => ui.mergeObjectSync(n, f)) : ui.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return yt.errToObj, new Xr({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var i, s, a, o;
          const c = (a = (s = (i = this._def).errorMap) === null || s === void 0 ? void 0 : s.call(i, r, n).message) !== null && a !== void 0 ? a : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (o = yt.errToObj(e).message) !== null && o !== void 0 ? o : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new Xr({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Xr({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Xr({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Xr({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: At.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Xr({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return lr.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new Xr({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return lr.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new Xr({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ou(this);
  }
  partial(e) {
    const r = {};
    return lr.objectKeys(this.shape).forEach((n) => {
      const i = this.shape[n];
      e && !e[n] ? r[n] = i : r[n] = i.optional();
    }), new Xr({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return lr.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof Zs; )
          s = s._def.innerType;
        r[n] = s;
      }
    }), new Xr({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return $x(lr.objectKeys(this.shape));
  }
}
Xr.create = (t, e) => new Xr({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Na.create(),
  typeName: At.ZodObject,
  ...Ut(e)
});
Xr.strictCreate = (t, e) => new Xr({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Na.create(),
  typeName: At.ZodObject,
  ...Ut(e)
});
Xr.lazycreate = (t, e) => new Xr({
  shape: t,
  unknownKeys: "strip",
  catchall: Na.create(),
  typeName: At.ZodObject,
  ...Ut(e)
});
class wd extends zt {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function i(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const a = s.map((o) => new $i(o.ctx.common.issues));
      return Xe(r, {
        code: qe.invalid_union,
        unionErrors: a
      }), It;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const a = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: a
          }),
          ctx: a
        };
      })).then(i);
    {
      let s;
      const a = [];
      for (const c of n) {
        const f = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = c._parseSync({
          data: r.data,
          path: r.path,
          parent: f
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !s && (s = { result: u, ctx: f }), f.common.issues.length && a.push(f.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = a.map((c) => new $i(c));
      return Xe(r, {
        code: qe.invalid_union,
        unionErrors: o
      }), It;
    }
  }
  get options() {
    return this._def.options;
  }
}
wd.create = (t, e) => new wd({
  options: t,
  typeName: At.ZodUnion,
  ...Ut(e)
});
const ba = (t) => t instanceof Ed ? ba(t.schema) : t instanceof xs ? ba(t.innerType()) : t instanceof xd ? [t.value] : t instanceof wo ? t.options : t instanceof Ad ? lr.objectValues(t.enum) : t instanceof Id ? ba(t._def.innerType) : t instanceof md ? [void 0] : t instanceof vd ? [null] : t instanceof Zs ? [void 0, ...ba(t.unwrap())] : t instanceof _o ? [null, ...ba(t.unwrap())] : t instanceof g2 || t instanceof kd ? ba(t.unwrap()) : t instanceof Td ? ba(t._def.innerType) : [];
class p0 extends zt {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== rt.object)
      return Xe(r, {
        code: qe.invalid_type,
        expected: rt.object,
        received: r.parsedType
      }), It;
    const n = this.discriminator, i = r.data[n], s = this.optionsMap.get(i);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (Xe(r, {
      code: qe.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), It);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const i = /* @__PURE__ */ new Map();
    for (const s of r) {
      const a = ba(s.shape[e]);
      if (!a.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of a) {
        if (i.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        i.set(o, s);
      }
    }
    return new p0({
      typeName: At.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: i,
      ...Ut(n)
    });
  }
}
function Xm(t, e) {
  const r = eo(t), n = eo(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === rt.object && n === rt.object) {
    const i = lr.objectKeys(e), s = lr.objectKeys(t).filter((o) => i.indexOf(o) !== -1), a = { ...t, ...e };
    for (const o of s) {
      const c = Xm(t[o], e[o]);
      if (!c.valid)
        return { valid: !1 };
      a[o] = c.data;
    }
    return { valid: !0, data: a };
  } else if (r === rt.array && n === rt.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const i = [];
    for (let s = 0; s < t.length; s++) {
      const a = t[s], o = e[s], c = Xm(a, o);
      if (!c.valid)
        return { valid: !1 };
      i.push(c.data);
    }
    return { valid: !0, data: i };
  } else
    return r === rt.date && n === rt.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class _d extends zt {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), i = (s, a) => {
      if (Ym(s) || Ym(a))
        return It;
      const o = Xm(s.value, a.value);
      return o.valid ? ((Qm(s) || Qm(a)) && r.dirty(), { status: r.value, value: o.data }) : (Xe(n, {
        code: qe.invalid_intersection_types
      }), It);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, a]) => i(s, a)) : i(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
_d.create = (t, e, r) => new _d({
  left: t,
  right: e,
  typeName: At.ZodIntersection,
  ...Ut(r)
});
class Xs extends zt {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== rt.array)
      return Xe(n, {
        code: qe.invalid_type,
        expected: rt.array,
        received: n.parsedType
      }), It;
    if (n.data.length < this._def.items.length)
      return Xe(n, {
        code: qe.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), It;
    !this._def.rest && n.data.length > this._def.items.length && (Xe(n, {
      code: qe.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((a, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new Qs(n, a, n.path, o)) : null;
    }).filter((a) => !!a);
    return n.common.async ? Promise.all(s).then((a) => ui.mergeArray(r, a)) : ui.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Xs({
      ...this._def,
      rest: e
    });
  }
}
Xs.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Xs({
    items: t,
    typeName: At.ZodTuple,
    rest: null,
    ...Ut(e)
  });
};
class Sd extends zt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== rt.object)
      return Xe(n, {
        code: qe.invalid_type,
        expected: rt.object,
        received: n.parsedType
      }), It;
    const i = [], s = this._def.keyType, a = this._def.valueType;
    for (const o in n.data)
      i.push({
        key: s._parse(new Qs(n, o, n.path, o)),
        value: a._parse(new Qs(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? ui.mergeObjectAsync(r, i) : ui.mergeObjectSync(r, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof zt ? new Sd({
      keyType: e,
      valueType: r,
      typeName: At.ZodRecord,
      ...Ut(n)
    }) : new Sd({
      keyType: vs.create(),
      valueType: e,
      typeName: At.ZodRecord,
      ...Ut(r)
    });
  }
}
class up extends zt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== rt.map)
      return Xe(n, {
        code: qe.invalid_type,
        expected: rt.map,
        received: n.parsedType
      }), It;
    const i = this._def.keyType, s = this._def.valueType, a = [...n.data.entries()].map(([o, c], f) => ({
      key: i._parse(new Qs(n, o, n.path, [f, "key"])),
      value: s._parse(new Qs(n, c, n.path, [f, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of a) {
          const f = await c.key, u = await c.value;
          if (f.status === "aborted" || u.status === "aborted")
            return It;
          (f.status === "dirty" || u.status === "dirty") && r.dirty(), o.set(f.value, u.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const c of a) {
        const f = c.key, u = c.value;
        if (f.status === "aborted" || u.status === "aborted")
          return It;
        (f.status === "dirty" || u.status === "dirty") && r.dirty(), o.set(f.value, u.value);
      }
      return { status: r.value, value: o };
    }
  }
}
up.create = (t, e, r) => new up({
  valueType: e,
  keyType: t,
  typeName: At.ZodMap,
  ...Ut(r)
});
class wc extends zt {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== rt.set)
      return Xe(n, {
        code: qe.invalid_type,
        expected: rt.set,
        received: n.parsedType
      }), It;
    const i = this._def;
    i.minSize !== null && n.data.size < i.minSize.value && (Xe(n, {
      code: qe.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), r.dirty()), i.maxSize !== null && n.data.size > i.maxSize.value && (Xe(n, {
      code: qe.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function a(c) {
      const f = /* @__PURE__ */ new Set();
      for (const u of c) {
        if (u.status === "aborted")
          return It;
        u.status === "dirty" && r.dirty(), f.add(u.value);
      }
      return { status: r.value, value: f };
    }
    const o = [...n.data.values()].map((c, f) => s._parse(new Qs(n, c, n.path, f)));
    return n.common.async ? Promise.all(o).then((c) => a(c)) : a(o);
  }
  min(e, r) {
    return new wc({
      ...this._def,
      minSize: { value: e, message: yt.toString(r) }
    });
  }
  max(e, r) {
    return new wc({
      ...this._def,
      maxSize: { value: e, message: yt.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
wc.create = (t, e) => new wc({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: At.ZodSet,
  ...Ut(e)
});
class _u extends zt {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== rt.function)
      return Xe(r, {
        code: qe.invalid_type,
        expected: rt.function,
        received: r.parsedType
      }), It;
    function n(o, c) {
      return sp({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          ip(),
          Fu
        ].filter((f) => !!f),
        issueData: {
          code: qe.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function i(o, c) {
      return sp({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          ip(),
          Fu
        ].filter((f) => !!f),
        issueData: {
          code: qe.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const s = { errorMap: r.common.contextualErrorMap }, a = r.data;
    if (this._def.returns instanceof $u) {
      const o = this;
      return hi(async function(...c) {
        const f = new $i([]), u = await o._def.args.parseAsync(c, s).catch((h) => {
          throw f.addIssue(n(c, h)), f;
        }), d = await Reflect.apply(a, this, u);
        return await o._def.returns._def.type.parseAsync(d, s).catch((h) => {
          throw f.addIssue(i(d, h)), f;
        });
      });
    } else {
      const o = this;
      return hi(function(...c) {
        const f = o._def.args.safeParse(c, s);
        if (!f.success)
          throw new $i([n(c, f.error)]);
        const u = Reflect.apply(a, this, f.data), d = o._def.returns.safeParse(u, s);
        if (!d.success)
          throw new $i([i(u, d.error)]);
        return d.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new _u({
      ...this._def,
      args: Xs.create(e).rest(fc.create())
    });
  }
  returns(e) {
    return new _u({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new _u({
      args: e || Xs.create([]).rest(fc.create()),
      returns: r || fc.create(),
      typeName: At.ZodFunction,
      ...Ut(n)
    });
  }
}
class Ed extends zt {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Ed.create = (t, e) => new Ed({
  getter: t,
  typeName: At.ZodLazy,
  ...Ut(e)
});
class xd extends zt {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return Xe(r, {
        received: r.data,
        code: qe.invalid_literal,
        expected: this._def.value
      }), It;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
xd.create = (t, e) => new xd({
  value: t,
  typeName: At.ZodLiteral,
  ...Ut(e)
});
function $x(t, e) {
  return new wo({
    values: t,
    typeName: At.ZodEnum,
    ...Ut(e)
  });
}
class wo extends zt {
  constructor() {
    super(...arguments), Yf.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return Xe(r, {
        expected: lr.joinValues(n),
        received: r.parsedType,
        code: qe.invalid_type
      }), It;
    }
    if (ap(this, Yf, "f") || Lx(this, Yf, new Set(this._def.values), "f"), !ap(this, Yf, "f").has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return Xe(r, {
        received: r.data,
        code: qe.invalid_enum_value,
        options: n
      }), It;
    }
    return hi(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return wo.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return wo.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
Yf = /* @__PURE__ */ new WeakMap();
wo.create = $x;
class Ad extends zt {
  constructor() {
    super(...arguments), Qf.set(this, void 0);
  }
  _parse(e) {
    const r = lr.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== rt.string && n.parsedType !== rt.number) {
      const i = lr.objectValues(r);
      return Xe(n, {
        expected: lr.joinValues(i),
        received: n.parsedType,
        code: qe.invalid_type
      }), It;
    }
    if (ap(this, Qf, "f") || Lx(this, Qf, new Set(lr.getValidEnumValues(this._def.values)), "f"), !ap(this, Qf, "f").has(e.data)) {
      const i = lr.objectValues(r);
      return Xe(n, {
        received: n.data,
        code: qe.invalid_enum_value,
        options: i
      }), It;
    }
    return hi(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Qf = /* @__PURE__ */ new WeakMap();
Ad.create = (t, e) => new Ad({
  values: t,
  typeName: At.ZodNativeEnum,
  ...Ut(e)
});
class $u extends zt {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== rt.promise && r.common.async === !1)
      return Xe(r, {
        code: qe.invalid_type,
        expected: rt.promise,
        received: r.parsedType
      }), It;
    const n = r.parsedType === rt.promise ? r.data : Promise.resolve(r.data);
    return hi(n.then((i) => this._def.type.parseAsync(i, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
$u.create = (t, e) => new $u({
  type: t,
  typeName: At.ZodPromise,
  ...Ut(e)
});
class xs extends zt {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === At.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), i = this._def.effect || null, s = {
      addIssue: (a) => {
        Xe(n, a), a.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), i.type === "preprocess") {
      const a = i.transform(n.data, s);
      if (n.common.async)
        return Promise.resolve(a).then(async (o) => {
          if (r.value === "aborted")
            return It;
          const c = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return c.status === "aborted" ? It : c.status === "dirty" || r.value === "dirty" ? bu(c.value) : c;
        });
      {
        if (r.value === "aborted")
          return It;
        const o = this._def.schema._parseSync({
          data: a,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? It : o.status === "dirty" || r.value === "dirty" ? bu(o.value) : o;
      }
    }
    if (i.type === "refinement") {
      const a = (o) => {
        const c = i.refinement(o, s);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? It : (o.status === "dirty" && r.dirty(), a(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? It : (o.status === "dirty" && r.dirty(), a(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (i.type === "transform")
      if (n.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!yd(a))
          return a;
        const o = i.transform(a.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((a) => yd(a) ? Promise.resolve(i.transform(a.value, s)).then((o) => ({ status: r.value, value: o })) : a);
    lr.assertNever(i);
  }
}
xs.create = (t, e, r) => new xs({
  schema: t,
  typeName: At.ZodEffects,
  effect: e,
  ...Ut(r)
});
xs.createWithPreprocess = (t, e, r) => new xs({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: At.ZodEffects,
  ...Ut(r)
});
class Zs extends zt {
  _parse(e) {
    return this._getType(e) === rt.undefined ? hi(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Zs.create = (t, e) => new Zs({
  innerType: t,
  typeName: At.ZodOptional,
  ...Ut(e)
});
class _o extends zt {
  _parse(e) {
    return this._getType(e) === rt.null ? hi(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
_o.create = (t, e) => new _o({
  innerType: t,
  typeName: At.ZodNullable,
  ...Ut(e)
});
class Id extends zt {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === rt.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Id.create = (t, e) => new Id({
  innerType: t,
  typeName: At.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...Ut(e)
});
class Td extends zt {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return bd(i) ? i.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new $i(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new $i(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Td.create = (t, e) => new Td({
  innerType: t,
  typeName: At.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...Ut(e)
});
class fp extends zt {
  _parse(e) {
    if (this._getType(e) !== rt.nan) {
      const n = this._getOrReturnCtx(e);
      return Xe(n, {
        code: qe.invalid_type,
        expected: rt.nan,
        received: n.parsedType
      }), It;
    }
    return { status: "valid", value: e.data };
  }
}
fp.create = (t) => new fp({
  typeName: At.ZodNaN,
  ...Ut(t)
});
const CR = Symbol("zod_brand");
class g2 extends zt {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class vl extends zt {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? It : s.status === "dirty" ? (r.dirty(), bu(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return i.status === "aborted" ? It : i.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new vl({
      in: e,
      out: r,
      typeName: At.ZodPipeline
    });
  }
}
class kd extends zt {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (i) => (yd(i) && (i.value = Object.freeze(i.value)), i);
    return bd(r) ? r.then((i) => n(i)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
kd.create = (t, e) => new kd({
  innerType: t,
  typeName: At.ZodReadonly,
  ...Ut(e)
});
function qx(t, e = {}, r) {
  return t ? ju.create().superRefine((n, i) => {
    var s, a;
    if (!t(n)) {
      const o = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, c = (a = (s = o.fatal) !== null && s !== void 0 ? s : r) !== null && a !== void 0 ? a : !0, f = typeof o == "string" ? { message: o } : o;
      i.addIssue({ code: "custom", ...f, fatal: c });
    }
  }) : ju.create();
}
const NR = {
  object: Xr.lazycreate
};
var At;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(At || (At = {}));
const UR = (t, e = {
  message: `Input not instance of ${t.name}`
}) => qx((r) => r instanceof t, e), Wx = vs.create, zx = mo.create, LR = fp.create, DR = vo.create, Kx = gd.create, FR = vc.create, jR = op.create, $R = md.create, qR = vd.create, WR = ju.create, zR = fc.create, KR = Na.create, VR = cp.create, HR = _s.create, GR = Xr.create, ZR = Xr.strictCreate, JR = wd.create, YR = p0.create, QR = _d.create, XR = Xs.create, eP = Sd.create, tP = up.create, rP = wc.create, nP = _u.create, iP = Ed.create, sP = xd.create, aP = wo.create, oP = Ad.create, cP = $u.create, t3 = xs.create, uP = Zs.create, fP = _o.create, dP = xs.createWithPreprocess, lP = vl.create, hP = () => Wx().optional(), pP = () => zx().optional(), yP = () => Kx().optional(), bP = {
  string: (t) => vs.create({ ...t, coerce: !0 }),
  number: (t) => mo.create({ ...t, coerce: !0 }),
  boolean: (t) => gd.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => vo.create({ ...t, coerce: !0 }),
  date: (t) => vc.create({ ...t, coerce: !0 })
}, gP = It;
var Cn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Fu,
  setErrorMap: gR,
  getErrorMap: ip,
  makeIssue: sp,
  EMPTY_PATH: mR,
  addIssueToContext: Xe,
  ParseStatus: ui,
  INVALID: It,
  DIRTY: bu,
  OK: hi,
  isAborted: Ym,
  isDirty: Qm,
  isValid: yd,
  isAsync: bd,
  get util() {
    return lr;
  },
  get objectUtil() {
    return Jm;
  },
  ZodParsedType: rt,
  getParsedType: eo,
  ZodType: zt,
  datetimeRegex: jx,
  ZodString: vs,
  ZodNumber: mo,
  ZodBigInt: vo,
  ZodBoolean: gd,
  ZodDate: vc,
  ZodSymbol: op,
  ZodUndefined: md,
  ZodNull: vd,
  ZodAny: ju,
  ZodUnknown: fc,
  ZodNever: Na,
  ZodVoid: cp,
  ZodArray: _s,
  ZodObject: Xr,
  ZodUnion: wd,
  ZodDiscriminatedUnion: p0,
  ZodIntersection: _d,
  ZodTuple: Xs,
  ZodRecord: Sd,
  ZodMap: up,
  ZodSet: wc,
  ZodFunction: _u,
  ZodLazy: Ed,
  ZodLiteral: xd,
  ZodEnum: wo,
  ZodNativeEnum: Ad,
  ZodPromise: $u,
  ZodEffects: xs,
  ZodTransformer: xs,
  ZodOptional: Zs,
  ZodNullable: _o,
  ZodDefault: Id,
  ZodCatch: Td,
  ZodNaN: fp,
  BRAND: CR,
  ZodBranded: g2,
  ZodPipeline: vl,
  ZodReadonly: kd,
  custom: qx,
  Schema: zt,
  ZodSchema: zt,
  late: NR,
  get ZodFirstPartyTypeKind() {
    return At;
  },
  coerce: bP,
  any: WR,
  array: HR,
  bigint: DR,
  boolean: Kx,
  date: FR,
  discriminatedUnion: YR,
  effect: t3,
  enum: aP,
  function: nP,
  instanceof: UR,
  intersection: QR,
  lazy: iP,
  literal: sP,
  map: tP,
  nan: LR,
  nativeEnum: oP,
  never: KR,
  null: qR,
  nullable: fP,
  number: zx,
  object: GR,
  oboolean: yP,
  onumber: pP,
  optional: uP,
  ostring: hP,
  pipeline: lP,
  preprocess: dP,
  promise: cP,
  record: eP,
  set: rP,
  strictObject: ZR,
  string: Wx,
  symbol: jR,
  transformer: t3,
  tuple: XR,
  undefined: $R,
  union: JR,
  unknown: zR,
  void: VR,
  NEVER: gP,
  ZodIssueCode: qe,
  quotelessJson: bR,
  ZodError: $i
});
const r3 = Cn.object({
  dangerouslyInjectWindow: Cn.boolean().optional().default(!1),
  walletStandard: Cn.boolean().optional().default(!0)
}), n3 = Cn.object({
  dangerouslyInjectWindow: Cn.boolean().optional().default(!1),
  eip6963: Cn.boolean().optional().default(!0)
}), i3 = Cn.object({
  dangerouslyInjectWindow: Cn.boolean().optional().default(!1),
  walletStandard: Cn.boolean().optional().default(!0)
}), s3 = Cn.object({
  bitcoin: Cn.union([Cn.boolean(), r3]).default(!1).transform((t) => t === !0 ? r3.parse({}) : t),
  ethereum: Cn.union([Cn.boolean(), n3]).default(!1).transform((t) => t === !0 ? n3.parse({}) : t),
  solana: Cn.union([Cn.boolean(), i3]).default(!1).transform((t) => t === !0 ? i3.parse({}) : t)
}), mP = Cn.object({
  appId: Cn.string().uuid().optional(),
  providers: s3.optional().default({}),
  /** @deprecated Use `providers` instead. */
  networks: s3.optional()
}).default({});
function vP(t) {
  return mP.parse(t);
}
const jo = "https://embedded.passkeys.foundation", wP = "wallet:ready", _P = "wallet:locked", SP = "wallet:navigate", EP = "wallet:widget:config", xP = "provider:request", AP = "provider:response", ev = "rpc";
var qu = "isPasskeys", m2 = "isPasskey", v2 = "Passkeys", w2 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMWVtIiBoZWlnaHQ9IjFlbSIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJ0cmFuc2l0aW9uLWFsbCBib3gtY29udGVudCBhbmltYXRlLW5vbmUiIHNpemU9IjE4IiBzdHlsZT0id2lkdGg6IDE4cHg7IGhlaWdodDogMThweDsiIGlkPSJzdmdnIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iI0UzQUZCRSIvPjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xMzNfMjYxMikiPjxwYXRoIGQ9Ik0xMi4yMjU0IDUuNzA4OTRMOC45NzU0NiA3LjU4NTU1QzguODgwNjIgNy42NDA4NiA4Ljg0OTAxIDcuNzYxMzYgOC45MDIzNiA3Ljg1NjE4TDEyLjQwNzIgMTMuOTI2NUg1LjM5NzUyQzUuMjg4ODYgMTMuOTI2NSA1LjE5OTk1IDE0LjAxNTQgNS4xOTk5NSAxNC4xMjQxVjE3Ljg3NzNDNS4xOTk5NSAxNy45ODU5IDUuMjg4ODYgMTguMDc0OCA1LjM5NzUyIDE4LjA3NDhIMTIuNDA3MkwxMy42MDQ1IDE2LjAwMDdMMTQuODAxNyAxMy45MjY1TDE1Ljk5OSAxMS44NTI0TDEyLjQ5NjEgNS43ODIwM0MxMi40NDA4IDUuNjg3MjEgMTIuMzIwMyA1LjY1NTYgMTIuMjI1NCA1LjcwODk0WiIgZmlsbD0iIzE4MTgxOCIvPjxwYXRoIGQ9Ik0xOS41OTI4IDE4LjA3NTJIMTIuNDA3M0w4LjkwMjQ1IDI0LjE0NTVDOC44NDcxMyAyNC4yNDA0IDguODgwNzIgMjQuMzYwOSA4Ljk3NTU1IDI0LjQxNjJMMTIuMjI1NSAyNi4yOTI4QzEyLjMyMDQgMjYuMzQ4MSAxMi40NDA5IDI2LjMxNDUgMTIuNDk2MiAyNi4yMTk3TDE2LjAwMSAyMC4xNDkzTDE5LjUwNTkgMjYuMjE5N0MxOS41NjEyIDI2LjMxNDUgMTkuNjgxNyAyNi4zNDYxIDE5Ljc3NjUgMjYuMjkyOEwyMy4wMjY1IDI0LjQxNjJDMjMuMTIxMyAyNC4zNjA5IDIzLjE1MyAyNC4yNDA0IDIzLjA5OTYgMjQuMTQ1NUwxOS41OTQ4IDE4LjA3NTJIMTkuNTkyOFoiIGZpbGw9IiMxODE4MTgiLz48cGF0aCBkPSJNMTkuNTkyOCAxMy45MjY5TDIzLjA5NzYgNy44NTY1N0MyMy4xNTI5IDcuNzYxNzUgMjMuMTE5MyA3LjY0MTI1IDIzLjAyNDUgNy41ODU5NEwxOS43NzQ1IDUuNzA5MzNDMTkuNjc5NyA1LjY1NDAyIDE5LjU1OTIgNS42ODc2IDE5LjUwMzkgNS43ODI0MkwxNS45OTkgMTEuODUyOEwxNy4xOTYzIDEzLjkyNjlMMTguMzkzNSAxNi4wMDExTDE5LjU5MDggMTguMDc1MkgyNi42MDA1QzI2LjcwOTEgMTguMDc1MiAyNi43OTggMTcuOTg2MyAyNi43OTggMTcuODc3N1YxNC4xMjQ0QzI2Ljc5OCAxNC4wMTU4IDI2LjcwOTEgMTMuOTI2OSAyNi42MDA1IDEzLjkyNjlIMTkuNTkwOEgxOS41OTI4WiIgZmlsbD0iIzE4MTgxOCIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImNsaXAwXzEzM18yNjEyIj48cmVjdCB3aWR0aD0iMjEuNiIgaGVpZ2h0PSIyMC42MzI4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS4xOTk5NSA1LjY4MzU5KSIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==", _2 = (t, e, r) => {
  Object.defineProperty(t, e, { get() {
    return console.warn(`"${e}" is deprecated, please use "${r}" instead.`), !0;
  } });
}, Ne = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ln(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function ta(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
const a3 = globalThis.crypto;
var Vx = a3.randomUUID.bind(a3), IP = {
  PARSE_ERROR: {
    code: -32700,
    message: "Parse error"
  },
  INVALID_REQUEST: {
    code: -32600,
    message: "Invalid request"
  },
  METHOD_NOT_FOUND: {
    code: -32601,
    message: "Method not found"
  },
  INVALID_PARAMS: {
    code: -32602,
    message: "Invalid parameters"
  },
  INTERNAL_ERROR: {
    code: -32603,
    message: "Internal error"
  }
};
const Yc = IP, TP = () => {
  let t = 0;
  return () => t++;
}, kP = (t) => Number.isInteger(t) || typeof t == "string" || t === null;
class RP {
  constructor({
    transport: e,
    requestTimeout: r = 2e4,
    generateId: n = TP,
    methods: i = /* @__PURE__ */ new Map(),
    parse: s = JSON.parse,
    stringify: a = JSON.stringify,
    getIsDevelopmentMode: o = () => !1
  } = {}) {
    if (!e)
      throw new Error("TRANSPORT_REQUIRED");
    if (this._transport = e, this._requestTimeout = r, this._pendingRequest = /* @__PURE__ */ new Map(), this._generateId = n(), this._processResponse = this._processResponse.bind(this), this._methods = i, this.parse = s, this._stringify = a, typeof o != "function")
      throw new Error("getIsDevelopmentMode must be a function");
    this._getIsDevelopmentMode = o, e.on("data", this._processResponse);
  }
  end() {
    this._transport.removeListener("data", this._processResponse);
  }
  exposeMethods(e) {
    e instanceof Map || (e = Object.entries(e).reduce(
      (n, [i, s]) => n.set(i, s),
      /* @__PURE__ */ new Map()
    ));
    const r = this._methods;
    return this._methods = e, r;
  }
  exposeFunction(e, r) {
    if (typeof e != "string")
      throw new Error("Function name must be a string");
    if (typeof r != "function")
      throw new Error("Invalid function implementation");
    this._methods.set(e, r);
  }
  async callMethod(e, r) {
    const n = this._generateId(), i = this._makeRequestObject({ method: e, params: r, id: n });
    return this._sendRequest({ request: i });
  }
  async callMethodWithRawResponse(e, r) {
    const n = this._generateId(), i = this._makeRequestObject({ method: e, params: r, id: n });
    return this._sendRequest({ request: i, getRawResponse: !0 });
  }
  async notify(e, r) {
    const n = this._makeRequestObject({ method: e, params: r });
    this._transport.write(this._stringify(n));
  }
  _sendRequest({ request: e, getRawResponse: r = !1 }) {
    const { id: n } = e, i = this._stringify(e);
    return new Promise((s, a) => {
      const o = setTimeout(() => {
        this._pendingRequest.has(n) && (this._pendingRequest.delete(n), a(new Error(`JSON-RPC: method call timeout calling ${e.method}`)));
      }, this._requestTimeout);
      this._pendingRequest.set(n, { resolve: s, reject: a, timeoutTimer: o, getRawResponse: r }), (async () => {
        try {
          await this._transport.write(i);
        } catch (c) {
          clearTimeout(o), this._pendingRequest.delete(n), a(c);
        }
      })();
    });
  }
  _processResponse(e) {
    let r;
    try {
      r = this.parse(e);
    } catch (a) {
      const o = typeof e == "string" ? JSON.parse(e).id : e.id;
      if (!kP(o))
        throw a;
      const { message: c } = a;
      this._sendError({ ...Yc.INVALID_REQUEST, message: c }, o);
      return;
    }
    if (Object.hasOwnProperty.call(r, "method"))
      return this._processCallMethod(r);
    const i = Object.hasOwnProperty.call(r, "error"), s = this._pendingRequest.get(r.id);
    if (s)
      if (this._pendingRequest.delete(r.id), clearTimeout(s.timeoutTimer), s.getRawResponse)
        s.resolve(r);
      else if (i) {
        const a = this._makeErrorObject(r.error);
        s.reject(a);
      } else
        s.resolve(r.result);
  }
  async _processCallMethod(e) {
    const { method: r, params: n = [], id: i } = e, s = this._methods.get(r);
    if (!s)
      this._sendError({
        ...Yc.METHOD_NOT_FOUND,
        methodName: r
      }, i);
    else if (typeof s != "function")
      this._sendError(Yc.INTERNAL_ERROR, i);
    else {
      const a = Array.isArray(n) ? n : [n];
      try {
        const o = await Promise.resolve(
          s.apply(this._methods, a)
        );
        this._sendSuccess({
          result: o,
          id: i
        });
      } catch (o) {
        this._sendError(o, i);
      }
    }
  }
  // https://www.jsonrpc.org/specification#error_object
  _sendError(e, r) {
    let {
      message: n = Yc.INTERNAL_ERROR.message,
      code: i = Yc.INTERNAL_ERROR.code,
      cause: s,
      stack: a,
      ...o
    } = e || {};
    typeof e != "object" && (o = e), e === null && (o = null), e instanceof Error && this._getIsDevelopmentMode() && (o.cause = {
      message: n,
      stack: a,
      cause: s
    });
    const c = this._stringify({
      jsonrpc: "2.0",
      id: r,
      error: {
        code: i,
        message: n,
        data: o
      }
    });
    this._transport.write(c);
  }
  _sendSuccess({ result: e, id: r }) {
    if (typeof r > "u")
      return;
    const i = this._stringify({
      jsonrpc: "2.0",
      id: r,
      result: e
    });
    this._transport.write(i);
  }
  _makeRequestObject({ method: e, params: r, id: n }) {
    return {
      jsonrpc: "2.0",
      method: e,
      params: r,
      id: n
    };
  }
  _createRecursiveError(e) {
    if (typeof e != "object" || e === null)
      return null;
    let r = null;
    e.cause && (r = this._createRecursiveError(e.cause));
    const n = new Error(e.message, { cause: r });
    return n.stack = e.stack, n;
  }
  _makeErrorObject(e) {
    const r = e.code, n = Yc[r], i = e.message || n && n.message, s = new Error(i);
    if (s.code = r, Object.hasOwnProperty.call(e, "data"))
      if (typeof e.data == "object" && e.data !== null) {
        const { name: a, cause: o, ...c } = e.data;
        s.name = a, o && (s.cause = this._createRecursiveError(o)), s.data = c;
      } else
        s.data = e.data;
    return s;
  }
}
var PP = RP;
const OP = /* @__PURE__ */ Ln(PP), BP = 5 * 60 * 1e3;
var Hx = { exports: {} };
(function(t) {
  var e = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function i(c, f, u) {
    this.fn = c, this.context = f, this.once = u || !1;
  }
  function s(c, f, u, d, l) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var h = new i(u, d || c, l), y = r ? r + f : f;
    return c._events[y] ? c._events[y].fn ? c._events[y] = [c._events[y], h] : c._events[y].push(h) : (c._events[y] = h, c._eventsCount++), c;
  }
  function a(c, f) {
    --c._eventsCount === 0 ? c._events = new n() : delete c._events[f];
  }
  function o() {
    this._events = new n(), this._eventsCount = 0;
  }
  o.prototype.eventNames = function() {
    var f = [], u, d;
    if (this._eventsCount === 0)
      return f;
    for (d in u = this._events)
      e.call(u, d) && f.push(r ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? f.concat(Object.getOwnPropertySymbols(u)) : f;
  }, o.prototype.listeners = function(f) {
    var u = r ? r + f : f, d = this._events[u];
    if (!d)
      return [];
    if (d.fn)
      return [d.fn];
    for (var l = 0, h = d.length, y = new Array(h); l < h; l++)
      y[l] = d[l].fn;
    return y;
  }, o.prototype.listenerCount = function(f) {
    var u = r ? r + f : f, d = this._events[u];
    return d ? d.fn ? 1 : d.length : 0;
  }, o.prototype.emit = function(f, u, d, l, h, y) {
    var p = r ? r + f : f;
    if (!this._events[p])
      return !1;
    var b = this._events[p], v = arguments.length, x, I;
    if (b.fn) {
      switch (b.once && this.removeListener(f, b.fn, void 0, !0), v) {
        case 1:
          return b.fn.call(b.context), !0;
        case 2:
          return b.fn.call(b.context, u), !0;
        case 3:
          return b.fn.call(b.context, u, d), !0;
        case 4:
          return b.fn.call(b.context, u, d, l), !0;
        case 5:
          return b.fn.call(b.context, u, d, l, h), !0;
        case 6:
          return b.fn.call(b.context, u, d, l, h, y), !0;
      }
      for (I = 1, x = new Array(v - 1); I < v; I++)
        x[I - 1] = arguments[I];
      b.fn.apply(b.context, x);
    } else {
      var L = b.length, P;
      for (I = 0; I < L; I++)
        switch (b[I].once && this.removeListener(f, b[I].fn, void 0, !0), v) {
          case 1:
            b[I].fn.call(b[I].context);
            break;
          case 2:
            b[I].fn.call(b[I].context, u);
            break;
          case 3:
            b[I].fn.call(b[I].context, u, d);
            break;
          case 4:
            b[I].fn.call(b[I].context, u, d, l);
            break;
          default:
            if (!x)
              for (P = 1, x = new Array(v - 1); P < v; P++)
                x[P - 1] = arguments[P];
            b[I].fn.apply(b[I].context, x);
        }
    }
    return !0;
  }, o.prototype.on = function(f, u, d) {
    return s(this, f, u, d, !1);
  }, o.prototype.once = function(f, u, d) {
    return s(this, f, u, d, !0);
  }, o.prototype.removeListener = function(f, u, d, l) {
    var h = r ? r + f : f;
    if (!this._events[h])
      return this;
    if (!u)
      return a(this, h), this;
    var y = this._events[h];
    if (y.fn)
      y.fn === u && (!l || y.once) && (!d || y.context === d) && a(this, h);
    else {
      for (var p = 0, b = [], v = y.length; p < v; p++)
        (y[p].fn !== u || l && !y[p].once || d && y[p].context !== d) && b.push(y[p]);
      b.length ? this._events[h] = b.length === 1 ? b[0] : b : a(this, h);
    }
    return this;
  }, o.prototype.removeAllListeners = function(f) {
    var u;
    return f ? (u = r ? r + f : f, this._events[u] && a(this, u)) : (this._events = new n(), this._eventsCount = 0), this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.addListener = o.prototype.on, o.prefixed = r, o.EventEmitter = o, t.exports = o;
})(Hx);
var MP = Hx.exports;
const tv = /* @__PURE__ */ Ln(MP), CP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EventEmitter: tv,
  default: tv
}, Symbol.toStringTag, { value: "Module" }));
var Jd;
class S2 extends tv {
  constructor({ transport: r }) {
    super();
    ct(this, Jd, null);
    ir(this, Jd, new OP({
      transport: r,
      generateId: () => Vx,
      requestTimeout: BP
    }));
  }
  _callRpcMethod(r, n) {
    return ke(this, Jd).callMethod(r, n);
  }
  defineFlag(r) {
    r in this || (this[r] = !0);
  }
  emitAndIgnoreErrors(r, ...n) {
    try {
      this.emit(r, ...n);
    } catch (i) {
      console.error(i);
    }
  }
}
Jd = new WeakMap();
var Zp, Zx;
class Gx {
  constructor(e) {
    ct(this, Zp);
    Oo(this, Zp, Zx).call(this, e);
  }
}
Zp = new WeakSet(), Zx = function({ name: e, icon: r }) {
  if (!e)
    throw new Error('"name" parameter is required');
  if (!r)
    throw new Error('"icon" parameter is required');
};
var nc, ic, Jp, Yp;
class NP extends S2 {
  constructor({ transport: r, accountsObservable: n }) {
    super({ transport: r });
    ct(this, nc, !1);
    ct(this, ic, []);
    ct(this, Jp, () => {
      ke(this, nc) || (ir(this, nc, !0), this.emitAndIgnoreErrors("connect"));
    });
    ct(this, Yp, (r) => {
      if (r.length === 0) {
        ir(this, nc, !1), this.emit("disconnect"), this.emitAndIgnoreErrors("accountsChanged", r);
        return;
      }
      const n = (o) => o.slice().sort((c, f) => c.address.localeCompare(f.address)), i = n(ke(this, ic)), s = n(r);
      (i.length !== s.length || i.some((o, c) => o.address !== s[c].address)) && (ir(this, ic, s), this.emitAndIgnoreErrors("accountsChanged", s));
    });
    this.on("connect", () => {
      const i = n.observe((s) => {
        ke(this, Yp).call(this, s);
      });
      this.on("disconnect", i);
    }), this.on("connect", () => {
      ir(this, nc, !0);
    });
  }
  get accounts() {
    return ke(this, ic);
  }
  call(r) {
    return this._callRpcMethod("bitcoin_call", [r]);
  }
  async isConnected() {
    return await this._callRpcMethod("bitcoin_isConnected", []);
  }
  async connect(r) {
    const n = await this._callRpcMethod("bitcoin_connect", [r]), i = n.map((s) => ({
      address: s.address,
      purpose: s.purpose
    }));
    return ir(this, ic, i), ke(this, Jp).call(this), {
      addresses: n
    };
  }
  sendBtcTransaction(r) {
    return this._callRpcMethod("bitcoin_sendBtcTransaction", [
      r
    ]);
  }
  signMessage(r) {
    return this._callRpcMethod("bitcoin_signMessage", [
      r
    ]);
  }
  signTransaction(r) {
    return this._callRpcMethod("bitcoin_signTransaction", [r]);
  }
}
nc = new WeakMap(), ic = new WeakMap(), Jp = new WeakMap(), Yp = new WeakMap();
const UP = "sats-connect:";
var Qp, Yd, Qd, Xd;
class LP extends Gx {
  constructor({ name: r, icon: n, provider: i }) {
    super({ name: r, icon: n });
    ct(this, Qp, "1.0.0");
    ct(this, Yd, void 0);
    ct(this, Qd, void 0);
    ct(this, Xd, void 0);
    if (!i)
      throw new Error("Bitcoin Provider parameter is required!");
    ir(this, Yd, r), ir(this, Qd, n), ir(this, Xd, i);
  }
  get version() {
    return ke(this, Qp);
  }
  get name() {
    return ke(this, Yd);
  }
  get icon() {
    return ke(this, Qd);
  }
  get chains() {
    return [];
  }
  get features() {
    return {
      [UP]: {
        provider: ke(this, Xd)
      }
    };
  }
  get accounts() {
    return [];
  }
}
Qp = new WeakMap(), Yd = new WeakMap(), Qd = new WeakMap(), Xd = new WeakMap();
var DP = function(t, e, r, n, i) {
  if (n === "m")
    throw new TypeError("Private method is not writable");
  if (n === "a" && !i)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? i.call(t, r) : i ? i.value = r : e.set(t, r), r;
}, FP = function(t, e, r, n) {
  if (r === "a" && !n)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !n : !e.has(t))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(t) : n ? n.value : e.get(t);
}, Fh;
function Jx(t) {
  const e = ({ register: r }) => r(t);
  try {
    window.dispatchEvent(new jP(e));
  } catch (r) {
    console.error(`wallet-standard:register-wallet event could not be dispatched
`, r);
  }
  try {
    window.addEventListener("wallet-standard:app-ready", ({ detail: r }) => e(r));
  } catch (r) {
    console.error(`wallet-standard:app-ready event listener could not be added
`, r);
  }
}
class jP extends Event {
  constructor(e) {
    super("wallet-standard:register-wallet", {
      bubbles: !1,
      cancelable: !1,
      composed: !1
    }), Fh.set(this, void 0), DP(this, Fh, e, "f");
  }
  get detail() {
    return FP(this, Fh, "f");
  }
  get type() {
    return "wallet-standard:register-wallet";
  }
  /** @deprecated */
  preventDefault() {
    throw new Error("preventDefault cannot be called");
  }
  /** @deprecated */
  stopImmediatePropagation() {
    throw new Error("stopImmediatePropagation cannot be called");
  }
  /** @deprecated */
  stopPropagation() {
    throw new Error("stopPropagation cannot be called");
  }
}
Fh = /* @__PURE__ */ new WeakMap();
var $P = ({ accountsObservable: t, transport: e, injectWindow: r = !1, walletStandard: n = !0 }) => {
  let i = new NP({ accountsObservable: t, transport: e });
  return i.defineFlag(qu), _2(i, m2, qu), n && Jx(new LP({ name: v2, icon: w2, provider: i })), r && (window.BitcoinProvider = i), i;
}, cu = {}, So = {}, qP = Rd;
Rd.default = Rd;
Rd.stable = Xx;
Rd.stableStringify = Xx;
var dp = "[...]", Yx = "[Circular]", _c = [], Go = [];
function Qx() {
  return {
    depthLimit: Number.MAX_SAFE_INTEGER,
    edgesLimit: Number.MAX_SAFE_INTEGER
  };
}
function Rd(t, e, r, n) {
  typeof n > "u" && (n = Qx()), rv(t, "", 0, [], void 0, 0, n);
  var i;
  try {
    Go.length === 0 ? i = JSON.stringify(t, e, r) : i = JSON.stringify(t, eA(e), r);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; _c.length !== 0; ) {
      var s = _c.pop();
      s.length === 4 ? Object.defineProperty(s[0], s[1], s[3]) : s[0][s[1]] = s[2];
    }
  }
  return i;
}
function Su(t, e, r, n) {
  var i = Object.getOwnPropertyDescriptor(n, r);
  i.get !== void 0 ? i.configurable ? (Object.defineProperty(n, r, { value: t }), _c.push([n, r, e, i])) : Go.push([e, r, t]) : (n[r] = t, _c.push([n, r, e]));
}
function rv(t, e, r, n, i, s, a) {
  s += 1;
  var o;
  if (typeof t == "object" && t !== null) {
    for (o = 0; o < n.length; o++)
      if (n[o] === t) {
        Su(Yx, t, e, i);
        return;
      }
    if (typeof a.depthLimit < "u" && s > a.depthLimit) {
      Su(dp, t, e, i);
      return;
    }
    if (typeof a.edgesLimit < "u" && r + 1 > a.edgesLimit) {
      Su(dp, t, e, i);
      return;
    }
    if (n.push(t), Array.isArray(t))
      for (o = 0; o < t.length; o++)
        rv(t[o], o, o, n, t, s, a);
    else {
      var c = Object.keys(t);
      for (o = 0; o < c.length; o++) {
        var f = c[o];
        rv(t[f], f, o, n, t, s, a);
      }
    }
    n.pop();
  }
}
function WP(t, e) {
  return t < e ? -1 : t > e ? 1 : 0;
}
function Xx(t, e, r, n) {
  typeof n > "u" && (n = Qx());
  var i = nv(t, "", 0, [], void 0, 0, n) || t, s;
  try {
    Go.length === 0 ? s = JSON.stringify(i, e, r) : s = JSON.stringify(i, eA(e), r);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; _c.length !== 0; ) {
      var a = _c.pop();
      a.length === 4 ? Object.defineProperty(a[0], a[1], a[3]) : a[0][a[1]] = a[2];
    }
  }
  return s;
}
function nv(t, e, r, n, i, s, a) {
  s += 1;
  var o;
  if (typeof t == "object" && t !== null) {
    for (o = 0; o < n.length; o++)
      if (n[o] === t) {
        Su(Yx, t, e, i);
        return;
      }
    try {
      if (typeof t.toJSON == "function")
        return;
    } catch {
      return;
    }
    if (typeof a.depthLimit < "u" && s > a.depthLimit) {
      Su(dp, t, e, i);
      return;
    }
    if (typeof a.edgesLimit < "u" && r + 1 > a.edgesLimit) {
      Su(dp, t, e, i);
      return;
    }
    if (n.push(t), Array.isArray(t))
      for (o = 0; o < t.length; o++)
        nv(t[o], o, o, n, t, s, a);
    else {
      var c = {}, f = Object.keys(t).sort(WP);
      for (o = 0; o < f.length; o++) {
        var u = f[o];
        nv(t[u], u, o, n, t, s, a), c[u] = t[u];
      }
      if (typeof i < "u")
        _c.push([i, e, t]), i[e] = c;
      else
        return c;
    }
    n.pop();
  }
}
function eA(t) {
  return t = typeof t < "u" ? t : function(e, r) {
    return r;
  }, function(e, r) {
    if (Go.length > 0)
      for (var n = 0; n < Go.length; n++) {
        var i = Go[n];
        if (i[1] === e && i[0] === r) {
          r = i[2], Go.splice(n, 1);
          break;
        }
      }
    return t.call(this, e, r);
  };
}
Object.defineProperty(So, "__esModule", { value: !0 });
So.EthereumProviderError = So.EthereumRpcError = void 0;
const zP = qP;
class tA extends Error {
  constructor(e, r, n) {
    if (!Number.isInteger(e))
      throw new Error('"code" must be an integer.');
    if (!r || typeof r != "string")
      throw new Error('"message" must be a nonempty string.');
    super(r), this.code = e, n !== void 0 && (this.data = n);
  }
  /**
   * Returns a plain object with all public class properties.
   */
  serialize() {
    const e = {
      code: this.code,
      message: this.message
    };
    return this.data !== void 0 && (e.data = this.data), this.stack && (e.stack = this.stack), e;
  }
  /**
   * Return a string representation of the serialized error, omitting
   * any circular references.
   */
  toString() {
    return zP.default(this.serialize(), HP, 2);
  }
}
So.EthereumRpcError = tA;
class KP extends tA {
  /**
   * Create an Ethereum Provider JSON-RPC error.
   * `code` must be an integer in the 1000 <= 4999 range.
   */
  constructor(e, r, n) {
    if (!VP(e))
      throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
    super(e, r, n);
  }
}
So.EthereumProviderError = KP;
function VP(t) {
  return Number.isInteger(t) && t >= 1e3 && t <= 4999;
}
function HP(t, e) {
  if (e !== "[Circular]")
    return e;
}
var E2 = {}, Eo = {};
Object.defineProperty(Eo, "__esModule", { value: !0 });
Eo.errorValues = Eo.errorCodes = void 0;
Eo.errorCodes = {
  rpc: {
    invalidInput: -32e3,
    resourceNotFound: -32001,
    resourceUnavailable: -32002,
    transactionRejected: -32003,
    methodNotSupported: -32004,
    limitExceeded: -32005,
    parse: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internal: -32603
  },
  provider: {
    userRejectedRequest: 4001,
    unauthorized: 4100,
    unsupportedMethod: 4200,
    disconnected: 4900,
    chainDisconnected: 4901
  }
};
Eo.errorValues = {
  "-32700": {
    standard: "JSON RPC 2.0",
    message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
  },
  "-32600": {
    standard: "JSON RPC 2.0",
    message: "The JSON sent is not a valid Request object."
  },
  "-32601": {
    standard: "JSON RPC 2.0",
    message: "The method does not exist / is not available."
  },
  "-32602": {
    standard: "JSON RPC 2.0",
    message: "Invalid method parameter(s)."
  },
  "-32603": {
    standard: "JSON RPC 2.0",
    message: "Internal JSON-RPC error."
  },
  "-32000": {
    standard: "EIP-1474",
    message: "Invalid input."
  },
  "-32001": {
    standard: "EIP-1474",
    message: "Resource not found."
  },
  "-32002": {
    standard: "EIP-1474",
    message: "Resource unavailable."
  },
  "-32003": {
    standard: "EIP-1474",
    message: "Transaction rejected."
  },
  "-32004": {
    standard: "EIP-1474",
    message: "Method not supported."
  },
  "-32005": {
    standard: "EIP-1474",
    message: "Request limit exceeded."
  },
  4001: {
    standard: "EIP-1193",
    message: "User rejected the request."
  },
  4100: {
    standard: "EIP-1193",
    message: "The requested account and/or method has not been authorized by the user."
  },
  4200: {
    standard: "EIP-1193",
    message: "The requested method is not supported by this Ethereum provider."
  },
  4900: {
    standard: "EIP-1193",
    message: "The provider is disconnected from all chains."
  },
  4901: {
    standard: "EIP-1193",
    message: "The provider is disconnected from the specified chain."
  }
};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.serializeError = t.isValidCode = t.getMessageFromCode = t.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
  const e = Eo, r = So, n = e.errorCodes.rpc.internal, i = "Unspecified error message. This is a bug, please report it.", s = {
    code: n,
    message: a(n)
  };
  t.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
  function a(l, h = i) {
    if (Number.isInteger(l)) {
      const y = l.toString();
      if (d(e.errorValues, y))
        return e.errorValues[y].message;
      if (f(l))
        return t.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return h;
  }
  t.getMessageFromCode = a;
  function o(l) {
    if (!Number.isInteger(l))
      return !1;
    const h = l.toString();
    return !!(e.errorValues[h] || f(l));
  }
  t.isValidCode = o;
  function c(l, { fallbackError: h = s, shouldIncludeStack: y = !1 } = {}) {
    var p, b;
    if (!h || !Number.isInteger(h.code) || typeof h.message != "string")
      throw new Error("Must provide fallback error with integer number code and string message.");
    if (l instanceof r.EthereumRpcError)
      return l.serialize();
    const v = {};
    if (l && typeof l == "object" && !Array.isArray(l) && d(l, "code") && o(l.code)) {
      const I = l;
      v.code = I.code, I.message && typeof I.message == "string" ? (v.message = I.message, d(I, "data") && (v.data = I.data)) : (v.message = a(v.code), v.data = { originalError: u(l) });
    } else {
      v.code = h.code;
      const I = (p = l) === null || p === void 0 ? void 0 : p.message;
      v.message = I && typeof I == "string" ? I : h.message, v.data = { originalError: u(l) };
    }
    const x = (b = l) === null || b === void 0 ? void 0 : b.stack;
    return y && l && x && typeof x == "string" && (v.stack = x), v;
  }
  t.serializeError = c;
  function f(l) {
    return l >= -32099 && l <= -32e3;
  }
  function u(l) {
    return l && typeof l == "object" && !Array.isArray(l) ? Object.assign({}, l) : l;
  }
  function d(l, h) {
    return Object.prototype.hasOwnProperty.call(l, h);
  }
})(E2);
var y0 = {};
Object.defineProperty(y0, "__esModule", { value: !0 });
y0.ethErrors = void 0;
const x2 = So, rA = E2, Zn = Eo;
y0.ethErrors = {
  rpc: {
    /**
     * Get a JSON RPC 2.0 Parse (-32700) error.
     */
    parse: (t) => Ki(Zn.errorCodes.rpc.parse, t),
    /**
     * Get a JSON RPC 2.0 Invalid Request (-32600) error.
     */
    invalidRequest: (t) => Ki(Zn.errorCodes.rpc.invalidRequest, t),
    /**
     * Get a JSON RPC 2.0 Invalid Params (-32602) error.
     */
    invalidParams: (t) => Ki(Zn.errorCodes.rpc.invalidParams, t),
    /**
     * Get a JSON RPC 2.0 Method Not Found (-32601) error.
     */
    methodNotFound: (t) => Ki(Zn.errorCodes.rpc.methodNotFound, t),
    /**
     * Get a JSON RPC 2.0 Internal (-32603) error.
     */
    internal: (t) => Ki(Zn.errorCodes.rpc.internal, t),
    /**
     * Get a JSON RPC 2.0 Server error.
     * Permits integer error codes in the [ -32099 <= -32005 ] range.
     * Codes -32000 through -32004 are reserved by EIP-1474.
     */
    server: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum RPC Server errors must provide single object argument.");
      const { code: e } = t;
      if (!Number.isInteger(e) || e > -32005 || e < -32099)
        throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
      return Ki(e, t);
    },
    /**
     * Get an Ethereum JSON RPC Invalid Input (-32000) error.
     */
    invalidInput: (t) => Ki(Zn.errorCodes.rpc.invalidInput, t),
    /**
     * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
     */
    resourceNotFound: (t) => Ki(Zn.errorCodes.rpc.resourceNotFound, t),
    /**
     * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
     */
    resourceUnavailable: (t) => Ki(Zn.errorCodes.rpc.resourceUnavailable, t),
    /**
     * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
     */
    transactionRejected: (t) => Ki(Zn.errorCodes.rpc.transactionRejected, t),
    /**
     * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
     */
    methodNotSupported: (t) => Ki(Zn.errorCodes.rpc.methodNotSupported, t),
    /**
     * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
     */
    limitExceeded: (t) => Ki(Zn.errorCodes.rpc.limitExceeded, t)
  },
  provider: {
    /**
     * Get an Ethereum Provider User Rejected Request (4001) error.
     */
    userRejectedRequest: (t) => Cf(Zn.errorCodes.provider.userRejectedRequest, t),
    /**
     * Get an Ethereum Provider Unauthorized (4100) error.
     */
    unauthorized: (t) => Cf(Zn.errorCodes.provider.unauthorized, t),
    /**
     * Get an Ethereum Provider Unsupported Method (4200) error.
     */
    unsupportedMethod: (t) => Cf(Zn.errorCodes.provider.unsupportedMethod, t),
    /**
     * Get an Ethereum Provider Not Connected (4900) error.
     */
    disconnected: (t) => Cf(Zn.errorCodes.provider.disconnected, t),
    /**
     * Get an Ethereum Provider Chain Not Connected (4901) error.
     */
    chainDisconnected: (t) => Cf(Zn.errorCodes.provider.chainDisconnected, t),
    /**
     * Get a custom Ethereum Provider error.
     */
    custom: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum Provider custom errors must provide single object argument.");
      const { code: e, message: r, data: n } = t;
      if (!r || typeof r != "string")
        throw new Error('"message" must be a nonempty string');
      return new x2.EthereumProviderError(e, r, n);
    }
  }
};
function Ki(t, e) {
  const [r, n] = nA(e);
  return new x2.EthereumRpcError(t, r || rA.getMessageFromCode(t), n);
}
function Cf(t, e) {
  const [r, n] = nA(e);
  return new x2.EthereumProviderError(t, r || rA.getMessageFromCode(t), n);
}
function nA(t) {
  if (t) {
    if (typeof t == "string")
      return [t];
    if (typeof t == "object" && !Array.isArray(t)) {
      const { message: e, data: r } = t;
      if (e && typeof e != "string")
        throw new Error("Must specify string message.");
      return [e || void 0, r];
    }
  }
  return [];
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getMessageFromCode = t.serializeError = t.EthereumProviderError = t.EthereumRpcError = t.ethErrors = t.errorCodes = void 0;
  const e = So;
  Object.defineProperty(t, "EthereumRpcError", { enumerable: !0, get: function() {
    return e.EthereumRpcError;
  } }), Object.defineProperty(t, "EthereumProviderError", { enumerable: !0, get: function() {
    return e.EthereumProviderError;
  } });
  const r = E2;
  Object.defineProperty(t, "serializeError", { enumerable: !0, get: function() {
    return r.serializeError;
  } }), Object.defineProperty(t, "getMessageFromCode", { enumerable: !0, get: function() {
    return r.getMessageFromCode;
  } });
  const n = y0;
  Object.defineProperty(t, "ethErrors", { enumerable: !0, get: function() {
    return n.ethErrors;
  } });
  const i = Eo;
  Object.defineProperty(t, "errorCodes", { enumerable: !0, get: function() {
    return i.errorCodes;
  } });
})(cu);
function GP(t, e) {
  const r = `${e}:ethereum:chainId`;
  async function n() {
    try {
      return await t.getItem(r);
    } catch {
      return null;
    }
  }
  async function i(a) {
    try {
      await t.setItem(r, a);
    } catch {
    }
  }
  async function s() {
    try {
      await t.removeItem(r);
    } catch {
    }
  }
  return { getChainId: n, setChainId: i, clearChainId: s };
}
const ZP = "0x1";
var Nu, Ea, el, sc, Uu, ac, xa, oc, tl, rl, Xp, e0, t0, r0, n0, cc, i0, nl, Lu, il, s0, sl;
class JP extends S2 {
  constructor({ accountsObservable: r, transport: n, storage: i, storageKeyPrefix: s, supportedChainIds: a = [ZP], getDefaultChainId: o = () => Promise.resolve(null) }) {
    super({ transport: n });
    ct(this, Nu, void 0);
    ct(this, Ea, void 0);
    ct(this, el, void 0);
    ct(this, sc, null);
    ct(this, Uu, !1);
    ct(this, ac, !1);
    ct(this, xa, null);
    ct(this, oc, []);
    ct(this, tl, null);
    ct(this, rl, () => {
      if (!this.isConnected())
        throw cu.ethErrors.provider.disconnected({
          message: "The Provider is disconnected from all chains."
        });
    });
    ct(this, Xp, (r) => {
      if (!ke(this, Ea).includes(r))
        throw cu.ethErrors.provider.custom({
          message: "The Provider does not support the requested chain.",
          code: 4902
        });
    });
    ct(this, e0, async () => {
      const r = await ke(this, Nu).getChainId();
      if (r)
        return r;
      const n = await ke(this, el).call(this);
      return n || ke(this, Ea)[0];
    });
    ct(this, t0, async () => this._callRpcMethod("eth_accounts", []));
    ct(this, r0, async () => {
      const r = await ke(this, e0).call(this);
      ke(this, i0).call(this, r), ke(this, nl).call(this, r);
      const n = await ke(this, t0).call(this);
      ir(this, Uu, !0), ir(this, sc, null), ke(this, Lu).call(this, n);
    });
    ct(this, n0, async () => {
      ke(this, sc) && await ke(this, sc);
    });
    ct(this, cc, (r) => r.toLowerCase());
    ct(this, i0, (r) => {
      ke(this, ac) || (ir(this, ac, !0), this.emitAndIgnoreErrors("connect", { chainId: r }));
    });
    ct(this, nl, (r) => {
      !r || typeof r != "string" || !r.startsWith("0x") || r !== ke(this, xa) && (ir(this, xa, r), ke(this, Uu) && this.emitAndIgnoreErrors("chainChanged", r));
    });
    ct(this, Lu, (r) => {
      ke(this, oc)[0] !== r[0] && (ir(this, oc, r), ir(this, tl, r[0] ?? null), ke(this, Uu) && this.emitAndIgnoreErrors("accountsChanged", r));
    });
    ct(this, il, async () => {
      const r = { eth_accounts: {} };
      await this._callRpcMethod("wallet_requestPermissions", [r]);
      const n = await this._callRpcMethod("eth_accounts", []);
      return ke(this, Lu).call(this, n), n;
    });
    ct(this, s0, async (r) => {
      const n = ke(this, cc).call(this, r.chainId);
      return ke(this, Ea).includes(n) || (await this._callRpcMethod("wallet_addEthereumChain", [r]), ke(this, Ea).push(n)), ke(this, sl).call(this, n);
    });
    ct(this, sl, async (r) => {
      if (r !== ke(this, xa)) {
        try {
          ke(this, Xp).call(this, r);
        } catch (n) {
          if (!await this._callRpcMethod("wallet_switchEthereumChain", [{ chainId: r }]))
            throw n;
          ke(this, Ea).push(r);
        }
        ke(this, nl).call(this, r), await ke(this, Nu).setChainId(r);
      }
      return null;
    });
    Zt(this, "request", async (r) => {
      await ke(this, n0).call(this), ke(this, rl).call(this);
      const { method: n, params: i = [] } = r;
      if (typeof n != "string" || n.length === 0)
        throw cu.ethErrors.rpc.invalidRequest({
          message: "'args.method' must be a non-empty string.",
          data: r
        });
      if (!Array.isArray(i) && (typeof i != "object" || i === null))
        throw cu.ethErrors.rpc.invalidRequest({
          message: "'args.params' must be an object or array if provided.",
          data: r
        });
      if (n === "eth_chainId")
        return ke(this, xa);
      if (n === "eth_requestAccounts")
        return ke(this, il).call(this);
      if (n === "wallet_addEthereumChain")
        return ke(this, s0).call(this, i[0]);
      if (n === "wallet_switchEthereumChain") {
        const { chainId: a } = i[0];
        return ke(this, sl).call(this, ke(this, cc).call(this, a));
      }
      let s = i;
      return n === "personal_sign" && (s = i.slice(0, 2)), this._callRpcMethod(n, s);
    });
    /**
     * Experimental API
     */
    Zt(this, "_metamask", {
      /**
       * Determines if MetaMask is unlocked by the user.
       *
       * @returns Promise resolving to true if MetaMask is currently unlocked.
       */
      // TODO: improve this, atm heurestic if we have accounts, assume unlocked
      isUnlocked: async () => Array.isArray(ke(this, oc)) && ke(this, oc).length > 0,
      /**
       * Make a batch RPC request.
       *
       * @param requests - The RPC requests to make.
       */
      requestBatch: async (r) => {
        if (!Array.isArray(r))
          throw cu.ethErrors.rpc.invalidRequest({
            message: "Batch requests must be made with an array of request objects.",
            data: r
          });
        const n = [];
        for (const i of r)
          n.push(await this.request(i));
        return n;
      }
    });
    Zt(this, "enable", async () => (console.warn(`Exodus: "ethereum.enable()" is deprecated and may be removed in the future. Please use "ethereum.request({ method: 'eth_requestAccounts' })" instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1102.`), ke(this, rl).call(this), ke(this, il).call(this)));
    Zt(this, "send", async (r, n) => {
      console.warn('Exodus: "ethereum.send()" is deprecated and may be removed in the future. Please use "ethereum.request()" instead.');
      const i = typeof r == "string", s = Array.isArray(n);
      if (i && (!n || s)) {
        const c = r, f = n;
        return new Promise((u, d) => this.request({ method: c, params: f }).then((l) => u({ id: "1", jsonrpc: "2.0", result: l })).catch((l) => d({ id: "1", jsonrpc: "2.0", error: l })));
      }
      const a = r, o = n;
      this.sendAsync(a, o);
    });
    Zt(this, "sendAsync", (r, n) => {
      console.warn('Exodus: "ethereum.sendAsync()" is deprecated and may be removed in the future. Please use "ethereum.request()" instead.');
      const { id: i, jsonrpc: s, method: a, params: o } = r, c = n && typeof n == "function";
      this.request({ method: a, params: o }).then((f) => {
        c && n(null, { id: i, jsonrpc: s, result: f });
      }).catch((f) => {
        c && n(f, { id: i, jsonrpc: s, error: f });
      });
    });
    if (!s)
      throw new Error('"storageKeyPrefix" must be provided.');
    ir(this, Nu, GP(i, s)), ir(this, Ea, a.map(ke(this, cc)).sort()), ir(this, el, async () => o().then((c) => c ? ke(this, cc).call(this, c) : null)), this.on("connect", () => {
      const c = r.observe((f) => {
        ke(this, Lu).call(this, f);
      });
      this.on("disconnect", c);
    }), this.on("connect", () => {
      ir(this, ac, !0);
    }), ir(this, sc, ke(this, r0).call(this));
  }
  _callRpcMethod(r, n) {
    const i = ke(this, xa);
    return super._callRpcMethod(`${i}_${r}`, n);
  }
  isConnected() {
    return ke(this, ac);
  }
  /*
   * Legacy API.
   */
  get chainId() {
    return console.warn(`Exodus: "ethereum.chainId" is deprecated and may be removed in the future. Please use "ethereum.request({ method: 'eth_chainId' })" instead.`), ke(this, xa);
  }
  get selectedAddress() {
    return console.warn(`Exodus: "ethereum.selectedAddress" is deprecated and may be removed in the future. Please use "ethereum.request({ method: 'eth_accounts' })" instead.`), ke(this, tl);
  }
}
Nu = new WeakMap(), Ea = new WeakMap(), el = new WeakMap(), sc = new WeakMap(), Uu = new WeakMap(), ac = new WeakMap(), xa = new WeakMap(), oc = new WeakMap(), tl = new WeakMap(), rl = new WeakMap(), Xp = new WeakMap(), e0 = new WeakMap(), t0 = new WeakMap(), r0 = new WeakMap(), n0 = new WeakMap(), cc = new WeakMap(), i0 = new WeakMap(), nl = new WeakMap(), Lu = new WeakMap(), il = new WeakMap(), s0 = new WeakMap(), sl = new WeakMap();
const YP = ({ uuid: t, name: e, icon: r, rdns: n, provider: i }) => {
  const s = {
    info: { name: e, icon: r, uuid: t || Vx(), rdns: n },
    provider: i
  };
  return Object.freeze(s);
}, QP = (t, { name: e, icon: r, uuid: n, rdns: i }) => {
  if (!e)
    throw new Error("'name' parameter is required.");
  if (!r)
    throw new Error("'icon' parameter is required.");
  if (!i)
    throw new Error("'rdns' parameter is required.");
  const s = YP({
    name: e,
    icon: r,
    rdns: i,
    uuid: n,
    provider: t
  }), a = () => {
    window.dispatchEvent(new CustomEvent("eip6963:announceProvider", {
      detail: s
    }));
  };
  window.addEventListener("eip6963:requestProvider", () => {
    a();
  }), a();
};
var XP = "network.passkeys", eO = "165de3e5-9b1b-4312-aaf8-364facf4b82d", tO = ({ transport: t, accountsObservable: e, injectWindow: r = !1, eip6963: n = !0 }) => {
  let i = new JP({ transport: t, accountsObservable: e, storage: window.localStorage, storageKeyPrefix: "passkey" });
  return i.defineFlag(qu), _2(i, m2, qu), n && QP(i, { name: v2, icon: w2, rdns: XP, uuid: eO }), r && (window.ethereum = i), i;
}, iA = {}, b0 = {};
b0.byteLength = iO;
b0.toByteArray = aO;
b0.fromByteArray = uO;
var zs = [], Yi = [], rO = typeof Uint8Array < "u" ? Uint8Array : Array, h1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Qc = 0, nO = h1.length; Qc < nO; ++Qc)
  zs[Qc] = h1[Qc], Yi[h1.charCodeAt(Qc)] = Qc;
Yi[45] = 62;
Yi[95] = 63;
function sA(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  r === -1 && (r = e);
  var n = r === e ? 0 : 4 - r % 4;
  return [r, n];
}
function iO(t) {
  var e = sA(t), r = e[0], n = e[1];
  return (r + n) * 3 / 4 - n;
}
function sO(t, e, r) {
  return (e + r) * 3 / 4 - r;
}
function aO(t) {
  var e, r = sA(t), n = r[0], i = r[1], s = new rO(sO(t, n, i)), a = 0, o = i > 0 ? n - 4 : n, c;
  for (c = 0; c < o; c += 4)
    e = Yi[t.charCodeAt(c)] << 18 | Yi[t.charCodeAt(c + 1)] << 12 | Yi[t.charCodeAt(c + 2)] << 6 | Yi[t.charCodeAt(c + 3)], s[a++] = e >> 16 & 255, s[a++] = e >> 8 & 255, s[a++] = e & 255;
  return i === 2 && (e = Yi[t.charCodeAt(c)] << 2 | Yi[t.charCodeAt(c + 1)] >> 4, s[a++] = e & 255), i === 1 && (e = Yi[t.charCodeAt(c)] << 10 | Yi[t.charCodeAt(c + 1)] << 4 | Yi[t.charCodeAt(c + 2)] >> 2, s[a++] = e >> 8 & 255, s[a++] = e & 255), s;
}
function oO(t) {
  return zs[t >> 18 & 63] + zs[t >> 12 & 63] + zs[t >> 6 & 63] + zs[t & 63];
}
function cO(t, e, r) {
  for (var n, i = [], s = e; s < r; s += 3)
    n = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (t[s + 2] & 255), i.push(oO(n));
  return i.join("");
}
function uO(t) {
  for (var e, r = t.length, n = r % 3, i = [], s = 16383, a = 0, o = r - n; a < o; a += s)
    i.push(cO(t, a, a + s > o ? o : a + s));
  return n === 1 ? (e = t[r - 1], i.push(
    zs[e >> 2] + zs[e << 4 & 63] + "=="
  )) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push(
    zs[e >> 10] + zs[e >> 4 & 63] + zs[e << 2 & 63] + "="
  )), i.join("");
}
var A2 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
A2.read = function(t, e, r, n, i) {
  var s, a, o = i * 8 - n - 1, c = (1 << o) - 1, f = c >> 1, u = -7, d = r ? i - 1 : 0, l = r ? -1 : 1, h = t[e + d];
  for (d += l, s = h & (1 << -u) - 1, h >>= -u, u += o; u > 0; s = s * 256 + t[e + d], d += l, u -= 8)
    ;
  for (a = s & (1 << -u) - 1, s >>= -u, u += n; u > 0; a = a * 256 + t[e + d], d += l, u -= 8)
    ;
  if (s === 0)
    s = 1 - f;
  else {
    if (s === c)
      return a ? NaN : (h ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, n), s = s - f;
  }
  return (h ? -1 : 1) * a * Math.pow(2, s - n);
};
A2.write = function(t, e, r, n, i, s) {
  var a, o, c, f = s * 8 - i - 1, u = (1 << f) - 1, d = u >> 1, l = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = n ? 0 : s - 1, y = n ? 1 : -1, p = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, a = u) : (a = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -a)) < 1 && (a--, c *= 2), a + d >= 1 ? e += l / c : e += l * Math.pow(2, 1 - d), e * c >= 2 && (a++, c /= 2), a + d >= u ? (o = 0, a = u) : a + d >= 1 ? (o = (e * c - 1) * Math.pow(2, i), a = a + d) : (o = e * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + h] = o & 255, h += y, o /= 256, i -= 8)
    ;
  for (a = a << i | o, f += i; f > 0; t[r + h] = a & 255, h += y, a /= 256, f -= 8)
    ;
  t[r + h - y] |= p * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  const e = b0, r = A2, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = u, t.SlowBuffer = P, t.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  t.kMaxLength = i;
  const { Uint8Array: s, ArrayBuffer: a, SharedArrayBuffer: o } = globalThis;
  u.TYPED_ARRAY_SUPPORT = c(), !u.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function c() {
    try {
      const A = new s(1), m = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(m, s.prototype), Object.setPrototypeOf(A, m), A.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(u.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(u.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.byteOffset;
    }
  });
  function f(A) {
    if (A > i)
      throw new RangeError('The value "' + A + '" is invalid for option "size"');
    const m = new s(A);
    return Object.setPrototypeOf(m, u.prototype), m;
  }
  function u(A, m, S) {
    if (typeof A == "number") {
      if (typeof m == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return y(A);
    }
    return d(A, m, S);
  }
  u.poolSize = 8192;
  function d(A, m, S) {
    if (typeof A == "string")
      return p(A, m);
    if (a.isView(A))
      return v(A);
    if (A == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof A
      );
    if (he(A, a) || A && he(A.buffer, a) || typeof o < "u" && (he(A, o) || A && he(A.buffer, o)))
      return x(A, m, S);
    if (typeof A == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const q = A.valueOf && A.valueOf();
    if (q != null && q !== A)
      return u.from(q, m, S);
    const oe = I(A);
    if (oe)
      return oe;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof A[Symbol.toPrimitive] == "function")
      return u.from(A[Symbol.toPrimitive]("string"), m, S);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof A
    );
  }
  u.from = function(A, m, S) {
    return d(A, m, S);
  }, Object.setPrototypeOf(u.prototype, s.prototype), Object.setPrototypeOf(u, s);
  function l(A) {
    if (typeof A != "number")
      throw new TypeError('"size" argument must be of type number');
    if (A < 0)
      throw new RangeError('The value "' + A + '" is invalid for option "size"');
  }
  function h(A, m, S) {
    return l(A), A <= 0 ? f(A) : m !== void 0 ? typeof S == "string" ? f(A).fill(m, S) : f(A).fill(m) : f(A);
  }
  u.alloc = function(A, m, S) {
    return h(A, m, S);
  };
  function y(A) {
    return l(A), f(A < 0 ? 0 : L(A) | 0);
  }
  u.allocUnsafe = function(A) {
    return y(A);
  }, u.allocUnsafeSlow = function(A) {
    return y(A);
  };
  function p(A, m) {
    if ((typeof m != "string" || m === "") && (m = "utf8"), !u.isEncoding(m))
      throw new TypeError("Unknown encoding: " + m);
    const S = C(A, m) | 0;
    let q = f(S);
    const oe = q.write(A, m);
    return oe !== S && (q = q.slice(0, oe)), q;
  }
  function b(A) {
    const m = A.length < 0 ? 0 : L(A.length) | 0, S = f(m);
    for (let q = 0; q < m; q += 1)
      S[q] = A[q] & 255;
    return S;
  }
  function v(A) {
    if (he(A, s)) {
      const m = new s(A);
      return x(m.buffer, m.byteOffset, m.byteLength);
    }
    return b(A);
  }
  function x(A, m, S) {
    if (m < 0 || A.byteLength < m)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (A.byteLength < m + (S || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let q;
    return m === void 0 && S === void 0 ? q = new s(A) : S === void 0 ? q = new s(A, m) : q = new s(A, m, S), Object.setPrototypeOf(q, u.prototype), q;
  }
  function I(A) {
    if (u.isBuffer(A)) {
      const m = L(A.length) | 0, S = f(m);
      return S.length === 0 || A.copy(S, 0, 0, m), S;
    }
    if (A.length !== void 0)
      return typeof A.length != "number" || Ie(A.length) ? f(0) : b(A);
    if (A.type === "Buffer" && Array.isArray(A.data))
      return b(A.data);
  }
  function L(A) {
    if (A >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return A | 0;
  }
  function P(A) {
    return +A != A && (A = 0), u.alloc(+A);
  }
  u.isBuffer = function(m) {
    return m != null && m._isBuffer === !0 && m !== u.prototype;
  }, u.compare = function(m, S) {
    if (he(m, s) && (m = u.from(m, m.offset, m.byteLength)), he(S, s) && (S = u.from(S, S.offset, S.byteLength)), !u.isBuffer(m) || !u.isBuffer(S))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (m === S)
      return 0;
    let q = m.length, oe = S.length;
    for (let fe = 0, pe = Math.min(q, oe); fe < pe; ++fe)
      if (m[fe] !== S[fe]) {
        q = m[fe], oe = S[fe];
        break;
      }
    return q < oe ? -1 : oe < q ? 1 : 0;
  }, u.isEncoding = function(m) {
    switch (String(m).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, u.concat = function(m, S) {
    if (!Array.isArray(m))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (m.length === 0)
      return u.alloc(0);
    let q;
    if (S === void 0)
      for (S = 0, q = 0; q < m.length; ++q)
        S += m[q].length;
    const oe = u.allocUnsafe(S);
    let fe = 0;
    for (q = 0; q < m.length; ++q) {
      let pe = m[q];
      if (he(pe, s))
        fe + pe.length > oe.length ? (u.isBuffer(pe) || (pe = u.from(pe)), pe.copy(oe, fe)) : s.prototype.set.call(
          oe,
          pe,
          fe
        );
      else if (u.isBuffer(pe))
        pe.copy(oe, fe);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      fe += pe.length;
    }
    return oe;
  };
  function C(A, m) {
    if (u.isBuffer(A))
      return A.length;
    if (a.isView(A) || he(A, a))
      return A.byteLength;
    if (typeof A != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof A
      );
    const S = A.length, q = arguments.length > 2 && arguments[2] === !0;
    if (!q && S === 0)
      return 0;
    let oe = !1;
    for (; ; )
      switch (m) {
        case "ascii":
        case "latin1":
        case "binary":
          return S;
        case "utf8":
        case "utf-8":
          return gt(A).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return S * 2;
        case "hex":
          return S >>> 1;
        case "base64":
          return pt(A).length;
        default:
          if (oe)
            return q ? -1 : gt(A).length;
          m = ("" + m).toLowerCase(), oe = !0;
      }
  }
  u.byteLength = C;
  function D(A, m, S) {
    let q = !1;
    if ((m === void 0 || m < 0) && (m = 0), m > this.length || ((S === void 0 || S > this.length) && (S = this.length), S <= 0) || (S >>>= 0, m >>>= 0, S <= m))
      return "";
    for (A || (A = "utf8"); ; )
      switch (A) {
        case "hex":
          return g(this, m, S);
        case "utf8":
        case "utf-8":
          return W(this, m, S);
        case "ascii":
          return N(this, m, S);
        case "latin1":
        case "binary":
          return O(this, m, S);
        case "base64":
          return U(this, m, S);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return M(this, m, S);
        default:
          if (q)
            throw new TypeError("Unknown encoding: " + A);
          A = (A + "").toLowerCase(), q = !0;
      }
  }
  u.prototype._isBuffer = !0;
  function F(A, m, S) {
    const q = A[m];
    A[m] = A[S], A[S] = q;
  }
  u.prototype.swap16 = function() {
    const m = this.length;
    if (m % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let S = 0; S < m; S += 2)
      F(this, S, S + 1);
    return this;
  }, u.prototype.swap32 = function() {
    const m = this.length;
    if (m % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let S = 0; S < m; S += 4)
      F(this, S, S + 3), F(this, S + 1, S + 2);
    return this;
  }, u.prototype.swap64 = function() {
    const m = this.length;
    if (m % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let S = 0; S < m; S += 8)
      F(this, S, S + 7), F(this, S + 1, S + 6), F(this, S + 2, S + 5), F(this, S + 3, S + 4);
    return this;
  }, u.prototype.toString = function() {
    const m = this.length;
    return m === 0 ? "" : arguments.length === 0 ? W(this, 0, m) : D.apply(this, arguments);
  }, u.prototype.toLocaleString = u.prototype.toString, u.prototype.equals = function(m) {
    if (!u.isBuffer(m))
      throw new TypeError("Argument must be a Buffer");
    return this === m ? !0 : u.compare(this, m) === 0;
  }, u.prototype.inspect = function() {
    let m = "";
    const S = t.INSPECT_MAX_BYTES;
    return m = this.toString("hex", 0, S).replace(/(.{2})/g, "$1 ").trim(), this.length > S && (m += " ... "), "<Buffer " + m + ">";
  }, n && (u.prototype[n] = u.prototype.inspect), u.prototype.compare = function(m, S, q, oe, fe) {
    if (he(m, s) && (m = u.from(m, m.offset, m.byteLength)), !u.isBuffer(m))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof m
      );
    if (S === void 0 && (S = 0), q === void 0 && (q = m ? m.length : 0), oe === void 0 && (oe = 0), fe === void 0 && (fe = this.length), S < 0 || q > m.length || oe < 0 || fe > this.length)
      throw new RangeError("out of range index");
    if (oe >= fe && S >= q)
      return 0;
    if (oe >= fe)
      return -1;
    if (S >= q)
      return 1;
    if (S >>>= 0, q >>>= 0, oe >>>= 0, fe >>>= 0, this === m)
      return 0;
    let pe = fe - oe, Ke = q - S;
    const De = Math.min(pe, Ke), ot = this.slice(oe, fe), ar = m.slice(S, q);
    for (let bt = 0; bt < De; ++bt)
      if (ot[bt] !== ar[bt]) {
        pe = ot[bt], Ke = ar[bt];
        break;
      }
    return pe < Ke ? -1 : Ke < pe ? 1 : 0;
  };
  function G(A, m, S, q, oe) {
    if (A.length === 0)
      return -1;
    if (typeof S == "string" ? (q = S, S = 0) : S > 2147483647 ? S = 2147483647 : S < -2147483648 && (S = -2147483648), S = +S, Ie(S) && (S = oe ? 0 : A.length - 1), S < 0 && (S = A.length + S), S >= A.length) {
      if (oe)
        return -1;
      S = A.length - 1;
    } else if (S < 0)
      if (oe)
        S = 0;
      else
        return -1;
    if (typeof m == "string" && (m = u.from(m, q)), u.isBuffer(m))
      return m.length === 0 ? -1 : re(A, m, S, q, oe);
    if (typeof m == "number")
      return m = m & 255, typeof s.prototype.indexOf == "function" ? oe ? s.prototype.indexOf.call(A, m, S) : s.prototype.lastIndexOf.call(A, m, S) : re(A, [m], S, q, oe);
    throw new TypeError("val must be string, number or Buffer");
  }
  function re(A, m, S, q, oe) {
    let fe = 1, pe = A.length, Ke = m.length;
    if (q !== void 0 && (q = String(q).toLowerCase(), q === "ucs2" || q === "ucs-2" || q === "utf16le" || q === "utf-16le")) {
      if (A.length < 2 || m.length < 2)
        return -1;
      fe = 2, pe /= 2, Ke /= 2, S /= 2;
    }
    function De(ar, bt) {
      return fe === 1 ? ar[bt] : ar.readUInt16BE(bt * fe);
    }
    let ot;
    if (oe) {
      let ar = -1;
      for (ot = S; ot < pe; ot++)
        if (De(A, ot) === De(m, ar === -1 ? 0 : ot - ar)) {
          if (ar === -1 && (ar = ot), ot - ar + 1 === Ke)
            return ar * fe;
        } else
          ar !== -1 && (ot -= ot - ar), ar = -1;
    } else
      for (S + Ke > pe && (S = pe - Ke), ot = S; ot >= 0; ot--) {
        let ar = !0;
        for (let bt = 0; bt < Ke; bt++)
          if (De(A, ot + bt) !== De(m, bt)) {
            ar = !1;
            break;
          }
        if (ar)
          return ot;
      }
    return -1;
  }
  u.prototype.includes = function(m, S, q) {
    return this.indexOf(m, S, q) !== -1;
  }, u.prototype.indexOf = function(m, S, q) {
    return G(this, m, S, q, !0);
  }, u.prototype.lastIndexOf = function(m, S, q) {
    return G(this, m, S, q, !1);
  };
  function ie(A, m, S, q) {
    S = Number(S) || 0;
    const oe = A.length - S;
    q ? (q = Number(q), q > oe && (q = oe)) : q = oe;
    const fe = m.length;
    q > fe / 2 && (q = fe / 2);
    let pe;
    for (pe = 0; pe < q; ++pe) {
      const Ke = parseInt(m.substr(pe * 2, 2), 16);
      if (Ie(Ke))
        return pe;
      A[S + pe] = Ke;
    }
    return pe;
  }
  function ee(A, m, S, q) {
    return de(gt(m, A.length - S), A, S, q);
  }
  function $(A, m, S, q) {
    return de(ht(m), A, S, q);
  }
  function w(A, m, S, q) {
    return de(pt(m), A, S, q);
  }
  function E(A, m, S, q) {
    return de(Bt(m, A.length - S), A, S, q);
  }
  u.prototype.write = function(m, S, q, oe) {
    if (S === void 0)
      oe = "utf8", q = this.length, S = 0;
    else if (q === void 0 && typeof S == "string")
      oe = S, q = this.length, S = 0;
    else if (isFinite(S))
      S = S >>> 0, isFinite(q) ? (q = q >>> 0, oe === void 0 && (oe = "utf8")) : (oe = q, q = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const fe = this.length - S;
    if ((q === void 0 || q > fe) && (q = fe), m.length > 0 && (q < 0 || S < 0) || S > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    oe || (oe = "utf8");
    let pe = !1;
    for (; ; )
      switch (oe) {
        case "hex":
          return ie(this, m, S, q);
        case "utf8":
        case "utf-8":
          return ee(this, m, S, q);
        case "ascii":
        case "latin1":
        case "binary":
          return $(this, m, S, q);
        case "base64":
          return w(this, m, S, q);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return E(this, m, S, q);
        default:
          if (pe)
            throw new TypeError("Unknown encoding: " + oe);
          oe = ("" + oe).toLowerCase(), pe = !0;
      }
  }, u.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function U(A, m, S) {
    return m === 0 && S === A.length ? e.fromByteArray(A) : e.fromByteArray(A.slice(m, S));
  }
  function W(A, m, S) {
    S = Math.min(A.length, S);
    const q = [];
    let oe = m;
    for (; oe < S; ) {
      const fe = A[oe];
      let pe = null, Ke = fe > 239 ? 4 : fe > 223 ? 3 : fe > 191 ? 2 : 1;
      if (oe + Ke <= S) {
        let De, ot, ar, bt;
        switch (Ke) {
          case 1:
            fe < 128 && (pe = fe);
            break;
          case 2:
            De = A[oe + 1], (De & 192) === 128 && (bt = (fe & 31) << 6 | De & 63, bt > 127 && (pe = bt));
            break;
          case 3:
            De = A[oe + 1], ot = A[oe + 2], (De & 192) === 128 && (ot & 192) === 128 && (bt = (fe & 15) << 12 | (De & 63) << 6 | ot & 63, bt > 2047 && (bt < 55296 || bt > 57343) && (pe = bt));
            break;
          case 4:
            De = A[oe + 1], ot = A[oe + 2], ar = A[oe + 3], (De & 192) === 128 && (ot & 192) === 128 && (ar & 192) === 128 && (bt = (fe & 15) << 18 | (De & 63) << 12 | (ot & 63) << 6 | ar & 63, bt > 65535 && bt < 1114112 && (pe = bt));
        }
      }
      pe === null ? (pe = 65533, Ke = 1) : pe > 65535 && (pe -= 65536, q.push(pe >>> 10 & 1023 | 55296), pe = 56320 | pe & 1023), q.push(pe), oe += Ke;
    }
    return R(q);
  }
  const _ = 4096;
  function R(A) {
    const m = A.length;
    if (m <= _)
      return String.fromCharCode.apply(String, A);
    let S = "", q = 0;
    for (; q < m; )
      S += String.fromCharCode.apply(
        String,
        A.slice(q, q += _)
      );
    return S;
  }
  function N(A, m, S) {
    let q = "";
    S = Math.min(A.length, S);
    for (let oe = m; oe < S; ++oe)
      q += String.fromCharCode(A[oe] & 127);
    return q;
  }
  function O(A, m, S) {
    let q = "";
    S = Math.min(A.length, S);
    for (let oe = m; oe < S; ++oe)
      q += String.fromCharCode(A[oe]);
    return q;
  }
  function g(A, m, S) {
    const q = A.length;
    (!m || m < 0) && (m = 0), (!S || S < 0 || S > q) && (S = q);
    let oe = "";
    for (let fe = m; fe < S; ++fe)
      oe += z[A[fe]];
    return oe;
  }
  function M(A, m, S) {
    const q = A.slice(m, S);
    let oe = "";
    for (let fe = 0; fe < q.length - 1; fe += 2)
      oe += String.fromCharCode(q[fe] + q[fe + 1] * 256);
    return oe;
  }
  u.prototype.slice = function(m, S) {
    const q = this.length;
    m = ~~m, S = S === void 0 ? q : ~~S, m < 0 ? (m += q, m < 0 && (m = 0)) : m > q && (m = q), S < 0 ? (S += q, S < 0 && (S = 0)) : S > q && (S = q), S < m && (S = m);
    const oe = this.subarray(m, S);
    return Object.setPrototypeOf(oe, u.prototype), oe;
  };
  function Y(A, m, S) {
    if (A % 1 !== 0 || A < 0)
      throw new RangeError("offset is not uint");
    if (A + m > S)
      throw new RangeError("Trying to access beyond buffer length");
  }
  u.prototype.readUintLE = u.prototype.readUIntLE = function(m, S, q) {
    m = m >>> 0, S = S >>> 0, q || Y(m, S, this.length);
    let oe = this[m], fe = 1, pe = 0;
    for (; ++pe < S && (fe *= 256); )
      oe += this[m + pe] * fe;
    return oe;
  }, u.prototype.readUintBE = u.prototype.readUIntBE = function(m, S, q) {
    m = m >>> 0, S = S >>> 0, q || Y(m, S, this.length);
    let oe = this[m + --S], fe = 1;
    for (; S > 0 && (fe *= 256); )
      oe += this[m + --S] * fe;
    return oe;
  }, u.prototype.readUint8 = u.prototype.readUInt8 = function(m, S) {
    return m = m >>> 0, S || Y(m, 1, this.length), this[m];
  }, u.prototype.readUint16LE = u.prototype.readUInt16LE = function(m, S) {
    return m = m >>> 0, S || Y(m, 2, this.length), this[m] | this[m + 1] << 8;
  }, u.prototype.readUint16BE = u.prototype.readUInt16BE = function(m, S) {
    return m = m >>> 0, S || Y(m, 2, this.length), this[m] << 8 | this[m + 1];
  }, u.prototype.readUint32LE = u.prototype.readUInt32LE = function(m, S) {
    return m = m >>> 0, S || Y(m, 4, this.length), (this[m] | this[m + 1] << 8 | this[m + 2] << 16) + this[m + 3] * 16777216;
  }, u.prototype.readUint32BE = u.prototype.readUInt32BE = function(m, S) {
    return m = m >>> 0, S || Y(m, 4, this.length), this[m] * 16777216 + (this[m + 1] << 16 | this[m + 2] << 8 | this[m + 3]);
  }, u.prototype.readBigUInt64LE = k(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const S = this[m], q = this[m + 7];
    (S === void 0 || q === void 0) && ze(m, this.length - 8);
    const oe = S + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + this[++m] * 2 ** 24, fe = this[++m] + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + q * 2 ** 24;
    return BigInt(oe) + (BigInt(fe) << BigInt(32));
  }), u.prototype.readBigUInt64BE = k(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const S = this[m], q = this[m + 7];
    (S === void 0 || q === void 0) && ze(m, this.length - 8);
    const oe = S * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + this[++m], fe = this[++m] * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + q;
    return (BigInt(oe) << BigInt(32)) + BigInt(fe);
  }), u.prototype.readIntLE = function(m, S, q) {
    m = m >>> 0, S = S >>> 0, q || Y(m, S, this.length);
    let oe = this[m], fe = 1, pe = 0;
    for (; ++pe < S && (fe *= 256); )
      oe += this[m + pe] * fe;
    return fe *= 128, oe >= fe && (oe -= Math.pow(2, 8 * S)), oe;
  }, u.prototype.readIntBE = function(m, S, q) {
    m = m >>> 0, S = S >>> 0, q || Y(m, S, this.length);
    let oe = S, fe = 1, pe = this[m + --oe];
    for (; oe > 0 && (fe *= 256); )
      pe += this[m + --oe] * fe;
    return fe *= 128, pe >= fe && (pe -= Math.pow(2, 8 * S)), pe;
  }, u.prototype.readInt8 = function(m, S) {
    return m = m >>> 0, S || Y(m, 1, this.length), this[m] & 128 ? (255 - this[m] + 1) * -1 : this[m];
  }, u.prototype.readInt16LE = function(m, S) {
    m = m >>> 0, S || Y(m, 2, this.length);
    const q = this[m] | this[m + 1] << 8;
    return q & 32768 ? q | 4294901760 : q;
  }, u.prototype.readInt16BE = function(m, S) {
    m = m >>> 0, S || Y(m, 2, this.length);
    const q = this[m + 1] | this[m] << 8;
    return q & 32768 ? q | 4294901760 : q;
  }, u.prototype.readInt32LE = function(m, S) {
    return m = m >>> 0, S || Y(m, 4, this.length), this[m] | this[m + 1] << 8 | this[m + 2] << 16 | this[m + 3] << 24;
  }, u.prototype.readInt32BE = function(m, S) {
    return m = m >>> 0, S || Y(m, 4, this.length), this[m] << 24 | this[m + 1] << 16 | this[m + 2] << 8 | this[m + 3];
  }, u.prototype.readBigInt64LE = k(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const S = this[m], q = this[m + 7];
    (S === void 0 || q === void 0) && ze(m, this.length - 8);
    const oe = this[m + 4] + this[m + 5] * 2 ** 8 + this[m + 6] * 2 ** 16 + (q << 24);
    return (BigInt(oe) << BigInt(32)) + BigInt(S + this[++m] * 2 ** 8 + this[++m] * 2 ** 16 + this[++m] * 2 ** 24);
  }), u.prototype.readBigInt64BE = k(function(m) {
    m = m >>> 0, Ve(m, "offset");
    const S = this[m], q = this[m + 7];
    (S === void 0 || q === void 0) && ze(m, this.length - 8);
    const oe = (S << 24) + // Overflow
    this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + this[++m];
    return (BigInt(oe) << BigInt(32)) + BigInt(this[++m] * 2 ** 24 + this[++m] * 2 ** 16 + this[++m] * 2 ** 8 + q);
  }), u.prototype.readFloatLE = function(m, S) {
    return m = m >>> 0, S || Y(m, 4, this.length), r.read(this, m, !0, 23, 4);
  }, u.prototype.readFloatBE = function(m, S) {
    return m = m >>> 0, S || Y(m, 4, this.length), r.read(this, m, !1, 23, 4);
  }, u.prototype.readDoubleLE = function(m, S) {
    return m = m >>> 0, S || Y(m, 8, this.length), r.read(this, m, !0, 52, 8);
  }, u.prototype.readDoubleBE = function(m, S) {
    return m = m >>> 0, S || Y(m, 8, this.length), r.read(this, m, !1, 52, 8);
  };
  function se(A, m, S, q, oe, fe) {
    if (!u.isBuffer(A))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (m > oe || m < fe)
      throw new RangeError('"value" argument is out of bounds');
    if (S + q > A.length)
      throw new RangeError("Index out of range");
  }
  u.prototype.writeUintLE = u.prototype.writeUIntLE = function(m, S, q, oe) {
    if (m = +m, S = S >>> 0, q = q >>> 0, !oe) {
      const Ke = Math.pow(2, 8 * q) - 1;
      se(this, m, S, q, Ke, 0);
    }
    let fe = 1, pe = 0;
    for (this[S] = m & 255; ++pe < q && (fe *= 256); )
      this[S + pe] = m / fe & 255;
    return S + q;
  }, u.prototype.writeUintBE = u.prototype.writeUIntBE = function(m, S, q, oe) {
    if (m = +m, S = S >>> 0, q = q >>> 0, !oe) {
      const Ke = Math.pow(2, 8 * q) - 1;
      se(this, m, S, q, Ke, 0);
    }
    let fe = q - 1, pe = 1;
    for (this[S + fe] = m & 255; --fe >= 0 && (pe *= 256); )
      this[S + fe] = m / pe & 255;
    return S + q;
  }, u.prototype.writeUint8 = u.prototype.writeUInt8 = function(m, S, q) {
    return m = +m, S = S >>> 0, q || se(this, m, S, 1, 255, 0), this[S] = m & 255, S + 1;
  }, u.prototype.writeUint16LE = u.prototype.writeUInt16LE = function(m, S, q) {
    return m = +m, S = S >>> 0, q || se(this, m, S, 2, 65535, 0), this[S] = m & 255, this[S + 1] = m >>> 8, S + 2;
  }, u.prototype.writeUint16BE = u.prototype.writeUInt16BE = function(m, S, q) {
    return m = +m, S = S >>> 0, q || se(this, m, S, 2, 65535, 0), this[S] = m >>> 8, this[S + 1] = m & 255, S + 2;
  }, u.prototype.writeUint32LE = u.prototype.writeUInt32LE = function(m, S, q) {
    return m = +m, S = S >>> 0, q || se(this, m, S, 4, 4294967295, 0), this[S + 3] = m >>> 24, this[S + 2] = m >>> 16, this[S + 1] = m >>> 8, this[S] = m & 255, S + 4;
  }, u.prototype.writeUint32BE = u.prototype.writeUInt32BE = function(m, S, q) {
    return m = +m, S = S >>> 0, q || se(this, m, S, 4, 4294967295, 0), this[S] = m >>> 24, this[S + 1] = m >>> 16, this[S + 2] = m >>> 8, this[S + 3] = m & 255, S + 4;
  };
  function V(A, m, S, q, oe) {
    Ue(m, q, oe, A, S, 7);
    let fe = Number(m & BigInt(4294967295));
    A[S++] = fe, fe = fe >> 8, A[S++] = fe, fe = fe >> 8, A[S++] = fe, fe = fe >> 8, A[S++] = fe;
    let pe = Number(m >> BigInt(32) & BigInt(4294967295));
    return A[S++] = pe, pe = pe >> 8, A[S++] = pe, pe = pe >> 8, A[S++] = pe, pe = pe >> 8, A[S++] = pe, S;
  }
  function K(A, m, S, q, oe) {
    Ue(m, q, oe, A, S, 7);
    let fe = Number(m & BigInt(4294967295));
    A[S + 7] = fe, fe = fe >> 8, A[S + 6] = fe, fe = fe >> 8, A[S + 5] = fe, fe = fe >> 8, A[S + 4] = fe;
    let pe = Number(m >> BigInt(32) & BigInt(4294967295));
    return A[S + 3] = pe, pe = pe >> 8, A[S + 2] = pe, pe = pe >> 8, A[S + 1] = pe, pe = pe >> 8, A[S] = pe, S + 8;
  }
  u.prototype.writeBigUInt64LE = k(function(m, S = 0) {
    return V(this, m, S, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeBigUInt64BE = k(function(m, S = 0) {
    return K(this, m, S, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeIntLE = function(m, S, q, oe) {
    if (m = +m, S = S >>> 0, !oe) {
      const De = Math.pow(2, 8 * q - 1);
      se(this, m, S, q, De - 1, -De);
    }
    let fe = 0, pe = 1, Ke = 0;
    for (this[S] = m & 255; ++fe < q && (pe *= 256); )
      m < 0 && Ke === 0 && this[S + fe - 1] !== 0 && (Ke = 1), this[S + fe] = (m / pe >> 0) - Ke & 255;
    return S + q;
  }, u.prototype.writeIntBE = function(m, S, q, oe) {
    if (m = +m, S = S >>> 0, !oe) {
      const De = Math.pow(2, 8 * q - 1);
      se(this, m, S, q, De - 1, -De);
    }
    let fe = q - 1, pe = 1, Ke = 0;
    for (this[S + fe] = m & 255; --fe >= 0 && (pe *= 256); )
      m < 0 && Ke === 0 && this[S + fe + 1] !== 0 && (Ke = 1), this[S + fe] = (m / pe >> 0) - Ke & 255;
    return S + q;
  }, u.prototype.writeInt8 = function(m, S, q) {
    return m = +m, S = S >>> 0, q || se(this, m, S, 1, 127, -128), m < 0 && (m = 255 + m + 1), this[S] = m & 255, S + 1;
  }, u.prototype.writeInt16LE = function(m, S, q) {
    return m = +m, S = S >>> 0, q || se(this, m, S, 2, 32767, -32768), this[S] = m & 255, this[S + 1] = m >>> 8, S + 2;
  }, u.prototype.writeInt16BE = function(m, S, q) {
    return m = +m, S = S >>> 0, q || se(this, m, S, 2, 32767, -32768), this[S] = m >>> 8, this[S + 1] = m & 255, S + 2;
  }, u.prototype.writeInt32LE = function(m, S, q) {
    return m = +m, S = S >>> 0, q || se(this, m, S, 4, 2147483647, -2147483648), this[S] = m & 255, this[S + 1] = m >>> 8, this[S + 2] = m >>> 16, this[S + 3] = m >>> 24, S + 4;
  }, u.prototype.writeInt32BE = function(m, S, q) {
    return m = +m, S = S >>> 0, q || se(this, m, S, 4, 2147483647, -2147483648), m < 0 && (m = 4294967295 + m + 1), this[S] = m >>> 24, this[S + 1] = m >>> 16, this[S + 2] = m >>> 8, this[S + 3] = m & 255, S + 4;
  }, u.prototype.writeBigInt64LE = k(function(m, S = 0) {
    return V(this, m, S, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), u.prototype.writeBigInt64BE = k(function(m, S = 0) {
    return K(this, m, S, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Z(A, m, S, q, oe, fe) {
    if (S + q > A.length)
      throw new RangeError("Index out of range");
    if (S < 0)
      throw new RangeError("Index out of range");
  }
  function ne(A, m, S, q, oe) {
    return m = +m, S = S >>> 0, oe || Z(A, m, S, 4), r.write(A, m, S, q, 23, 4), S + 4;
  }
  u.prototype.writeFloatLE = function(m, S, q) {
    return ne(this, m, S, !0, q);
  }, u.prototype.writeFloatBE = function(m, S, q) {
    return ne(this, m, S, !1, q);
  };
  function ce(A, m, S, q, oe) {
    return m = +m, S = S >>> 0, oe || Z(A, m, S, 8), r.write(A, m, S, q, 52, 8), S + 8;
  }
  u.prototype.writeDoubleLE = function(m, S, q) {
    return ce(this, m, S, !0, q);
  }, u.prototype.writeDoubleBE = function(m, S, q) {
    return ce(this, m, S, !1, q);
  }, u.prototype.copy = function(m, S, q, oe) {
    if (!u.isBuffer(m))
      throw new TypeError("argument should be a Buffer");
    if (q || (q = 0), !oe && oe !== 0 && (oe = this.length), S >= m.length && (S = m.length), S || (S = 0), oe > 0 && oe < q && (oe = q), oe === q || m.length === 0 || this.length === 0)
      return 0;
    if (S < 0)
      throw new RangeError("targetStart out of bounds");
    if (q < 0 || q >= this.length)
      throw new RangeError("Index out of range");
    if (oe < 0)
      throw new RangeError("sourceEnd out of bounds");
    oe > this.length && (oe = this.length), m.length - S < oe - q && (oe = m.length - S + q);
    const fe = oe - q;
    return this === m && typeof s.prototype.copyWithin == "function" ? this.copyWithin(S, q, oe) : s.prototype.set.call(
      m,
      this.subarray(q, oe),
      S
    ), fe;
  }, u.prototype.fill = function(m, S, q, oe) {
    if (typeof m == "string") {
      if (typeof S == "string" ? (oe = S, S = 0, q = this.length) : typeof q == "string" && (oe = q, q = this.length), oe !== void 0 && typeof oe != "string")
        throw new TypeError("encoding must be a string");
      if (typeof oe == "string" && !u.isEncoding(oe))
        throw new TypeError("Unknown encoding: " + oe);
      if (m.length === 1) {
        const pe = m.charCodeAt(0);
        (oe === "utf8" && pe < 128 || oe === "latin1") && (m = pe);
      }
    } else
      typeof m == "number" ? m = m & 255 : typeof m == "boolean" && (m = Number(m));
    if (S < 0 || this.length < S || this.length < q)
      throw new RangeError("Out of range index");
    if (q <= S)
      return this;
    S = S >>> 0, q = q === void 0 ? this.length : q >>> 0, m || (m = 0);
    let fe;
    if (typeof m == "number")
      for (fe = S; fe < q; ++fe)
        this[fe] = m;
    else {
      const pe = u.isBuffer(m) ? m : u.from(m, oe), Ke = pe.length;
      if (Ke === 0)
        throw new TypeError('The value "' + m + '" is invalid for argument "value"');
      for (fe = 0; fe < q - S; ++fe)
        this[fe + S] = pe[fe % Ke];
    }
    return this;
  };
  const H = {};
  function J(A, m, S) {
    H[A] = class extends S {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: m.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${A}]`, this.stack, delete this.name;
      }
      get code() {
        return A;
      }
      set code(oe) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: oe,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${A}]: ${this.message}`;
      }
    };
  }
  J(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(A) {
      return A ? `${A} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), J(
    "ERR_INVALID_ARG_TYPE",
    function(A, m) {
      return `The "${A}" argument must be of type number. Received type ${typeof m}`;
    },
    TypeError
  ), J(
    "ERR_OUT_OF_RANGE",
    function(A, m, S) {
      let q = `The value of "${A}" is out of range.`, oe = S;
      return Number.isInteger(S) && Math.abs(S) > 2 ** 32 ? oe = le(String(S)) : typeof S == "bigint" && (oe = String(S), (S > BigInt(2) ** BigInt(32) || S < -(BigInt(2) ** BigInt(32))) && (oe = le(oe)), oe += "n"), q += ` It must be ${m}. Received ${oe}`, q;
    },
    RangeError
  );
  function le(A) {
    let m = "", S = A.length;
    const q = A[0] === "-" ? 1 : 0;
    for (; S >= q + 4; S -= 3)
      m = `_${A.slice(S - 3, S)}${m}`;
    return `${A.slice(0, S)}${m}`;
  }
  function me(A, m, S) {
    Ve(m, "offset"), (A[m] === void 0 || A[m + S] === void 0) && ze(m, A.length - (S + 1));
  }
  function Ue(A, m, S, q, oe, fe) {
    if (A > S || A < m) {
      const pe = typeof m == "bigint" ? "n" : "";
      let Ke;
      throw fe > 3 ? m === 0 || m === BigInt(0) ? Ke = `>= 0${pe} and < 2${pe} ** ${(fe + 1) * 8}${pe}` : Ke = `>= -(2${pe} ** ${(fe + 1) * 8 - 1}${pe}) and < 2 ** ${(fe + 1) * 8 - 1}${pe}` : Ke = `>= ${m}${pe} and <= ${S}${pe}`, new H.ERR_OUT_OF_RANGE("value", Ke, A);
    }
    me(q, oe, fe);
  }
  function Ve(A, m) {
    if (typeof A != "number")
      throw new H.ERR_INVALID_ARG_TYPE(m, "number", A);
  }
  function ze(A, m, S) {
    throw Math.floor(A) !== A ? (Ve(A, S), new H.ERR_OUT_OF_RANGE(S || "offset", "an integer", A)) : m < 0 ? new H.ERR_BUFFER_OUT_OF_BOUNDS() : new H.ERR_OUT_OF_RANGE(
      S || "offset",
      `>= ${S ? 1 : 0} and <= ${m}`,
      A
    );
  }
  const at = /[^+/0-9A-Za-z-_]/g;
  function xe(A) {
    if (A = A.split("=")[0], A = A.trim().replace(at, ""), A.length < 2)
      return "";
    for (; A.length % 4 !== 0; )
      A = A + "=";
    return A;
  }
  function gt(A, m) {
    m = m || 1 / 0;
    let S;
    const q = A.length;
    let oe = null;
    const fe = [];
    for (let pe = 0; pe < q; ++pe) {
      if (S = A.charCodeAt(pe), S > 55295 && S < 57344) {
        if (!oe) {
          if (S > 56319) {
            (m -= 3) > -1 && fe.push(239, 191, 189);
            continue;
          } else if (pe + 1 === q) {
            (m -= 3) > -1 && fe.push(239, 191, 189);
            continue;
          }
          oe = S;
          continue;
        }
        if (S < 56320) {
          (m -= 3) > -1 && fe.push(239, 191, 189), oe = S;
          continue;
        }
        S = (oe - 55296 << 10 | S - 56320) + 65536;
      } else
        oe && (m -= 3) > -1 && fe.push(239, 191, 189);
      if (oe = null, S < 128) {
        if ((m -= 1) < 0)
          break;
        fe.push(S);
      } else if (S < 2048) {
        if ((m -= 2) < 0)
          break;
        fe.push(
          S >> 6 | 192,
          S & 63 | 128
        );
      } else if (S < 65536) {
        if ((m -= 3) < 0)
          break;
        fe.push(
          S >> 12 | 224,
          S >> 6 & 63 | 128,
          S & 63 | 128
        );
      } else if (S < 1114112) {
        if ((m -= 4) < 0)
          break;
        fe.push(
          S >> 18 | 240,
          S >> 12 & 63 | 128,
          S >> 6 & 63 | 128,
          S & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return fe;
  }
  function ht(A) {
    const m = [];
    for (let S = 0; S < A.length; ++S)
      m.push(A.charCodeAt(S) & 255);
    return m;
  }
  function Bt(A, m) {
    let S, q, oe;
    const fe = [];
    for (let pe = 0; pe < A.length && !((m -= 2) < 0); ++pe)
      S = A.charCodeAt(pe), q = S >> 8, oe = S % 256, fe.push(oe), fe.push(q);
    return fe;
  }
  function pt(A) {
    return e.toByteArray(xe(A));
  }
  function de(A, m, S, q) {
    let oe;
    for (oe = 0; oe < q && !(oe + S >= m.length || oe >= A.length); ++oe)
      m[oe + S] = A[oe];
    return oe;
  }
  function he(A, m) {
    return A instanceof m || A != null && A.constructor != null && A.constructor.name != null && A.constructor.name === m.name;
  }
  function Ie(A) {
    return A !== A;
  }
  const z = function() {
    const A = "0123456789abcdef", m = new Array(256);
    for (let S = 0; S < 16; ++S) {
      const q = S * 16;
      for (let oe = 0; oe < 16; ++oe)
        m[q + oe] = A[S] + A[oe];
    }
    return m;
  }();
  function k(A) {
    return typeof BigInt > "u" ? B : A;
  }
  function B() {
    throw new Error("BigInt not supported");
  }
})(iA);
const ve = iA.Buffer;
var Fe = {}, g0 = {};
g0.byteLength = lO;
g0.toByteArray = pO;
g0.fromByteArray = gO;
var Ks = [], Qi = [], fO = typeof Uint8Array < "u" ? Uint8Array : Array, p1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Xc = 0, dO = p1.length; Xc < dO; ++Xc)
  Ks[Xc] = p1[Xc], Qi[p1.charCodeAt(Xc)] = Xc;
Qi[45] = 62;
Qi[95] = 63;
function aA(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  r === -1 && (r = e);
  var n = r === e ? 0 : 4 - r % 4;
  return [r, n];
}
function lO(t) {
  var e = aA(t), r = e[0], n = e[1];
  return (r + n) * 3 / 4 - n;
}
function hO(t, e, r) {
  return (e + r) * 3 / 4 - r;
}
function pO(t) {
  var e, r = aA(t), n = r[0], i = r[1], s = new fO(hO(t, n, i)), a = 0, o = i > 0 ? n - 4 : n, c;
  for (c = 0; c < o; c += 4)
    e = Qi[t.charCodeAt(c)] << 18 | Qi[t.charCodeAt(c + 1)] << 12 | Qi[t.charCodeAt(c + 2)] << 6 | Qi[t.charCodeAt(c + 3)], s[a++] = e >> 16 & 255, s[a++] = e >> 8 & 255, s[a++] = e & 255;
  return i === 2 && (e = Qi[t.charCodeAt(c)] << 2 | Qi[t.charCodeAt(c + 1)] >> 4, s[a++] = e & 255), i === 1 && (e = Qi[t.charCodeAt(c)] << 10 | Qi[t.charCodeAt(c + 1)] << 4 | Qi[t.charCodeAt(c + 2)] >> 2, s[a++] = e >> 8 & 255, s[a++] = e & 255), s;
}
function yO(t) {
  return Ks[t >> 18 & 63] + Ks[t >> 12 & 63] + Ks[t >> 6 & 63] + Ks[t & 63];
}
function bO(t, e, r) {
  for (var n, i = [], s = e; s < r; s += 3)
    n = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (t[s + 2] & 255), i.push(yO(n));
  return i.join("");
}
function gO(t) {
  for (var e, r = t.length, n = r % 3, i = [], s = 16383, a = 0, o = r - n; a < o; a += s)
    i.push(bO(t, a, a + s > o ? o : a + s));
  return n === 1 ? (e = t[r - 1], i.push(
    Ks[e >> 2] + Ks[e << 4 & 63] + "=="
  )) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push(
    Ks[e >> 10] + Ks[e >> 4 & 63] + Ks[e << 2 & 63] + "="
  )), i.join("");
}
var I2 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
I2.read = function(t, e, r, n, i) {
  var s, a, o = i * 8 - n - 1, c = (1 << o) - 1, f = c >> 1, u = -7, d = r ? i - 1 : 0, l = r ? -1 : 1, h = t[e + d];
  for (d += l, s = h & (1 << -u) - 1, h >>= -u, u += o; u > 0; s = s * 256 + t[e + d], d += l, u -= 8)
    ;
  for (a = s & (1 << -u) - 1, s >>= -u, u += n; u > 0; a = a * 256 + t[e + d], d += l, u -= 8)
    ;
  if (s === 0)
    s = 1 - f;
  else {
    if (s === c)
      return a ? NaN : (h ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, n), s = s - f;
  }
  return (h ? -1 : 1) * a * Math.pow(2, s - n);
};
I2.write = function(t, e, r, n, i, s) {
  var a, o, c, f = s * 8 - i - 1, u = (1 << f) - 1, d = u >> 1, l = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = n ? 0 : s - 1, y = n ? 1 : -1, p = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, a = u) : (a = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -a)) < 1 && (a--, c *= 2), a + d >= 1 ? e += l / c : e += l * Math.pow(2, 1 - d), e * c >= 2 && (a++, c /= 2), a + d >= u ? (o = 0, a = u) : a + d >= 1 ? (o = (e * c - 1) * Math.pow(2, i), a = a + d) : (o = e * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + h] = o & 255, h += y, o /= 256, i -= 8)
    ;
  for (a = a << i | o, f += i; f > 0; t[r + h] = a & 255, h += y, a /= 256, f -= 8)
    ;
  t[r + h - y] |= p * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  const e = g0, r = I2, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = o, t.SlowBuffer = x, t.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  t.kMaxLength = i, o.TYPED_ARRAY_SUPPORT = s(), !o.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function s() {
    try {
      const z = new Uint8Array(1), k = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(k, Uint8Array.prototype), Object.setPrototypeOf(z, k), z.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(o.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (o.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(o.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (o.isBuffer(this))
        return this.byteOffset;
    }
  });
  function a(z) {
    if (z > i)
      throw new RangeError('The value "' + z + '" is invalid for option "size"');
    const k = new Uint8Array(z);
    return Object.setPrototypeOf(k, o.prototype), k;
  }
  function o(z, k, B) {
    if (typeof z == "number") {
      if (typeof k == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return d(z);
    }
    return c(z, k, B);
  }
  o.poolSize = 8192;
  function c(z, k, B) {
    if (typeof z == "string")
      return l(z, k);
    if (ArrayBuffer.isView(z))
      return y(z);
    if (z == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof z
      );
    if (Bt(z, ArrayBuffer) || z && Bt(z.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Bt(z, SharedArrayBuffer) || z && Bt(z.buffer, SharedArrayBuffer)))
      return p(z, k, B);
    if (typeof z == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const A = z.valueOf && z.valueOf();
    if (A != null && A !== z)
      return o.from(A, k, B);
    const m = b(z);
    if (m)
      return m;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof z[Symbol.toPrimitive] == "function")
      return o.from(z[Symbol.toPrimitive]("string"), k, B);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof z
    );
  }
  o.from = function(z, k, B) {
    return c(z, k, B);
  }, Object.setPrototypeOf(o.prototype, Uint8Array.prototype), Object.setPrototypeOf(o, Uint8Array);
  function f(z) {
    if (typeof z != "number")
      throw new TypeError('"size" argument must be of type number');
    if (z < 0)
      throw new RangeError('The value "' + z + '" is invalid for option "size"');
  }
  function u(z, k, B) {
    return f(z), z <= 0 ? a(z) : k !== void 0 ? typeof B == "string" ? a(z).fill(k, B) : a(z).fill(k) : a(z);
  }
  o.alloc = function(z, k, B) {
    return u(z, k, B);
  };
  function d(z) {
    return f(z), a(z < 0 ? 0 : v(z) | 0);
  }
  o.allocUnsafe = function(z) {
    return d(z);
  }, o.allocUnsafeSlow = function(z) {
    return d(z);
  };
  function l(z, k) {
    if ((typeof k != "string" || k === "") && (k = "utf8"), !o.isEncoding(k))
      throw new TypeError("Unknown encoding: " + k);
    const B = I(z, k) | 0;
    let A = a(B);
    const m = A.write(z, k);
    return m !== B && (A = A.slice(0, m)), A;
  }
  function h(z) {
    const k = z.length < 0 ? 0 : v(z.length) | 0, B = a(k);
    for (let A = 0; A < k; A += 1)
      B[A] = z[A] & 255;
    return B;
  }
  function y(z) {
    if (Bt(z, Uint8Array)) {
      const k = new Uint8Array(z);
      return p(k.buffer, k.byteOffset, k.byteLength);
    }
    return h(z);
  }
  function p(z, k, B) {
    if (k < 0 || z.byteLength < k)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (z.byteLength < k + (B || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let A;
    return k === void 0 && B === void 0 ? A = new Uint8Array(z) : B === void 0 ? A = new Uint8Array(z, k) : A = new Uint8Array(z, k, B), Object.setPrototypeOf(A, o.prototype), A;
  }
  function b(z) {
    if (o.isBuffer(z)) {
      const k = v(z.length) | 0, B = a(k);
      return B.length === 0 || z.copy(B, 0, 0, k), B;
    }
    if (z.length !== void 0)
      return typeof z.length != "number" || pt(z.length) ? a(0) : h(z);
    if (z.type === "Buffer" && Array.isArray(z.data))
      return h(z.data);
  }
  function v(z) {
    if (z >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return z | 0;
  }
  function x(z) {
    return +z != z && (z = 0), o.alloc(+z);
  }
  o.isBuffer = function(k) {
    return k != null && k._isBuffer === !0 && k !== o.prototype;
  }, o.compare = function(k, B) {
    if (Bt(k, Uint8Array) && (k = o.from(k, k.offset, k.byteLength)), Bt(B, Uint8Array) && (B = o.from(B, B.offset, B.byteLength)), !o.isBuffer(k) || !o.isBuffer(B))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (k === B)
      return 0;
    let A = k.length, m = B.length;
    for (let S = 0, q = Math.min(A, m); S < q; ++S)
      if (k[S] !== B[S]) {
        A = k[S], m = B[S];
        break;
      }
    return A < m ? -1 : m < A ? 1 : 0;
  }, o.isEncoding = function(k) {
    switch (String(k).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, o.concat = function(k, B) {
    if (!Array.isArray(k))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (k.length === 0)
      return o.alloc(0);
    let A;
    if (B === void 0)
      for (B = 0, A = 0; A < k.length; ++A)
        B += k[A].length;
    const m = o.allocUnsafe(B);
    let S = 0;
    for (A = 0; A < k.length; ++A) {
      let q = k[A];
      if (Bt(q, Uint8Array))
        S + q.length > m.length ? (o.isBuffer(q) || (q = o.from(q)), q.copy(m, S)) : Uint8Array.prototype.set.call(
          m,
          q,
          S
        );
      else if (o.isBuffer(q))
        q.copy(m, S);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      S += q.length;
    }
    return m;
  };
  function I(z, k) {
    if (o.isBuffer(z))
      return z.length;
    if (ArrayBuffer.isView(z) || Bt(z, ArrayBuffer))
      return z.byteLength;
    if (typeof z != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof z
      );
    const B = z.length, A = arguments.length > 2 && arguments[2] === !0;
    if (!A && B === 0)
      return 0;
    let m = !1;
    for (; ; )
      switch (k) {
        case "ascii":
        case "latin1":
        case "binary":
          return B;
        case "utf8":
        case "utf-8":
          return ze(z).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return B * 2;
        case "hex":
          return B >>> 1;
        case "base64":
          return gt(z).length;
        default:
          if (m)
            return A ? -1 : ze(z).length;
          k = ("" + k).toLowerCase(), m = !0;
      }
  }
  o.byteLength = I;
  function L(z, k, B) {
    let A = !1;
    if ((k === void 0 || k < 0) && (k = 0), k > this.length || ((B === void 0 || B > this.length) && (B = this.length), B <= 0) || (B >>>= 0, k >>>= 0, B <= k))
      return "";
    for (z || (z = "utf8"); ; )
      switch (z) {
        case "hex":
          return R(this, k, B);
        case "utf8":
        case "utf-8":
          return w(this, k, B);
        case "ascii":
          return W(this, k, B);
        case "latin1":
        case "binary":
          return _(this, k, B);
        case "base64":
          return $(this, k, B);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return N(this, k, B);
        default:
          if (A)
            throw new TypeError("Unknown encoding: " + z);
          z = (z + "").toLowerCase(), A = !0;
      }
  }
  o.prototype._isBuffer = !0;
  function P(z, k, B) {
    const A = z[k];
    z[k] = z[B], z[B] = A;
  }
  o.prototype.swap16 = function() {
    const k = this.length;
    if (k % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let B = 0; B < k; B += 2)
      P(this, B, B + 1);
    return this;
  }, o.prototype.swap32 = function() {
    const k = this.length;
    if (k % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let B = 0; B < k; B += 4)
      P(this, B, B + 3), P(this, B + 1, B + 2);
    return this;
  }, o.prototype.swap64 = function() {
    const k = this.length;
    if (k % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let B = 0; B < k; B += 8)
      P(this, B, B + 7), P(this, B + 1, B + 6), P(this, B + 2, B + 5), P(this, B + 3, B + 4);
    return this;
  }, o.prototype.toString = function() {
    const k = this.length;
    return k === 0 ? "" : arguments.length === 0 ? w(this, 0, k) : L.apply(this, arguments);
  }, o.prototype.toLocaleString = o.prototype.toString, o.prototype.equals = function(k) {
    if (!o.isBuffer(k))
      throw new TypeError("Argument must be a Buffer");
    return this === k ? !0 : o.compare(this, k) === 0;
  }, o.prototype.inspect = function() {
    let k = "";
    const B = t.INSPECT_MAX_BYTES;
    return k = this.toString("hex", 0, B).replace(/(.{2})/g, "$1 ").trim(), this.length > B && (k += " ... "), "<Buffer " + k + ">";
  }, n && (o.prototype[n] = o.prototype.inspect), o.prototype.compare = function(k, B, A, m, S) {
    if (Bt(k, Uint8Array) && (k = o.from(k, k.offset, k.byteLength)), !o.isBuffer(k))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof k
      );
    if (B === void 0 && (B = 0), A === void 0 && (A = k ? k.length : 0), m === void 0 && (m = 0), S === void 0 && (S = this.length), B < 0 || A > k.length || m < 0 || S > this.length)
      throw new RangeError("out of range index");
    if (m >= S && B >= A)
      return 0;
    if (m >= S)
      return -1;
    if (B >= A)
      return 1;
    if (B >>>= 0, A >>>= 0, m >>>= 0, S >>>= 0, this === k)
      return 0;
    let q = S - m, oe = A - B;
    const fe = Math.min(q, oe), pe = this.slice(m, S), Ke = k.slice(B, A);
    for (let De = 0; De < fe; ++De)
      if (pe[De] !== Ke[De]) {
        q = pe[De], oe = Ke[De];
        break;
      }
    return q < oe ? -1 : oe < q ? 1 : 0;
  };
  function C(z, k, B, A, m) {
    if (z.length === 0)
      return -1;
    if (typeof B == "string" ? (A = B, B = 0) : B > 2147483647 ? B = 2147483647 : B < -2147483648 && (B = -2147483648), B = +B, pt(B) && (B = m ? 0 : z.length - 1), B < 0 && (B = z.length + B), B >= z.length) {
      if (m)
        return -1;
      B = z.length - 1;
    } else if (B < 0)
      if (m)
        B = 0;
      else
        return -1;
    if (typeof k == "string" && (k = o.from(k, A)), o.isBuffer(k))
      return k.length === 0 ? -1 : D(z, k, B, A, m);
    if (typeof k == "number")
      return k = k & 255, typeof Uint8Array.prototype.indexOf == "function" ? m ? Uint8Array.prototype.indexOf.call(z, k, B) : Uint8Array.prototype.lastIndexOf.call(z, k, B) : D(z, [k], B, A, m);
    throw new TypeError("val must be string, number or Buffer");
  }
  function D(z, k, B, A, m) {
    let S = 1, q = z.length, oe = k.length;
    if (A !== void 0 && (A = String(A).toLowerCase(), A === "ucs2" || A === "ucs-2" || A === "utf16le" || A === "utf-16le")) {
      if (z.length < 2 || k.length < 2)
        return -1;
      S = 2, q /= 2, oe /= 2, B /= 2;
    }
    function fe(Ke, De) {
      return S === 1 ? Ke[De] : Ke.readUInt16BE(De * S);
    }
    let pe;
    if (m) {
      let Ke = -1;
      for (pe = B; pe < q; pe++)
        if (fe(z, pe) === fe(k, Ke === -1 ? 0 : pe - Ke)) {
          if (Ke === -1 && (Ke = pe), pe - Ke + 1 === oe)
            return Ke * S;
        } else
          Ke !== -1 && (pe -= pe - Ke), Ke = -1;
    } else
      for (B + oe > q && (B = q - oe), pe = B; pe >= 0; pe--) {
        let Ke = !0;
        for (let De = 0; De < oe; De++)
          if (fe(z, pe + De) !== fe(k, De)) {
            Ke = !1;
            break;
          }
        if (Ke)
          return pe;
      }
    return -1;
  }
  o.prototype.includes = function(k, B, A) {
    return this.indexOf(k, B, A) !== -1;
  }, o.prototype.indexOf = function(k, B, A) {
    return C(this, k, B, A, !0);
  }, o.prototype.lastIndexOf = function(k, B, A) {
    return C(this, k, B, A, !1);
  };
  function F(z, k, B, A) {
    B = Number(B) || 0;
    const m = z.length - B;
    A ? (A = Number(A), A > m && (A = m)) : A = m;
    const S = k.length;
    A > S / 2 && (A = S / 2);
    let q;
    for (q = 0; q < A; ++q) {
      const oe = parseInt(k.substr(q * 2, 2), 16);
      if (pt(oe))
        return q;
      z[B + q] = oe;
    }
    return q;
  }
  function G(z, k, B, A) {
    return ht(ze(k, z.length - B), z, B, A);
  }
  function re(z, k, B, A) {
    return ht(at(k), z, B, A);
  }
  function ie(z, k, B, A) {
    return ht(gt(k), z, B, A);
  }
  function ee(z, k, B, A) {
    return ht(xe(k, z.length - B), z, B, A);
  }
  o.prototype.write = function(k, B, A, m) {
    if (B === void 0)
      m = "utf8", A = this.length, B = 0;
    else if (A === void 0 && typeof B == "string")
      m = B, A = this.length, B = 0;
    else if (isFinite(B))
      B = B >>> 0, isFinite(A) ? (A = A >>> 0, m === void 0 && (m = "utf8")) : (m = A, A = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const S = this.length - B;
    if ((A === void 0 || A > S) && (A = S), k.length > 0 && (A < 0 || B < 0) || B > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    m || (m = "utf8");
    let q = !1;
    for (; ; )
      switch (m) {
        case "hex":
          return F(this, k, B, A);
        case "utf8":
        case "utf-8":
          return G(this, k, B, A);
        case "ascii":
        case "latin1":
        case "binary":
          return re(this, k, B, A);
        case "base64":
          return ie(this, k, B, A);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ee(this, k, B, A);
        default:
          if (q)
            throw new TypeError("Unknown encoding: " + m);
          m = ("" + m).toLowerCase(), q = !0;
      }
  }, o.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function $(z, k, B) {
    return k === 0 && B === z.length ? e.fromByteArray(z) : e.fromByteArray(z.slice(k, B));
  }
  function w(z, k, B) {
    B = Math.min(z.length, B);
    const A = [];
    let m = k;
    for (; m < B; ) {
      const S = z[m];
      let q = null, oe = S > 239 ? 4 : S > 223 ? 3 : S > 191 ? 2 : 1;
      if (m + oe <= B) {
        let fe, pe, Ke, De;
        switch (oe) {
          case 1:
            S < 128 && (q = S);
            break;
          case 2:
            fe = z[m + 1], (fe & 192) === 128 && (De = (S & 31) << 6 | fe & 63, De > 127 && (q = De));
            break;
          case 3:
            fe = z[m + 1], pe = z[m + 2], (fe & 192) === 128 && (pe & 192) === 128 && (De = (S & 15) << 12 | (fe & 63) << 6 | pe & 63, De > 2047 && (De < 55296 || De > 57343) && (q = De));
            break;
          case 4:
            fe = z[m + 1], pe = z[m + 2], Ke = z[m + 3], (fe & 192) === 128 && (pe & 192) === 128 && (Ke & 192) === 128 && (De = (S & 15) << 18 | (fe & 63) << 12 | (pe & 63) << 6 | Ke & 63, De > 65535 && De < 1114112 && (q = De));
        }
      }
      q === null ? (q = 65533, oe = 1) : q > 65535 && (q -= 65536, A.push(q >>> 10 & 1023 | 55296), q = 56320 | q & 1023), A.push(q), m += oe;
    }
    return U(A);
  }
  const E = 4096;
  function U(z) {
    const k = z.length;
    if (k <= E)
      return String.fromCharCode.apply(String, z);
    let B = "", A = 0;
    for (; A < k; )
      B += String.fromCharCode.apply(
        String,
        z.slice(A, A += E)
      );
    return B;
  }
  function W(z, k, B) {
    let A = "";
    B = Math.min(z.length, B);
    for (let m = k; m < B; ++m)
      A += String.fromCharCode(z[m] & 127);
    return A;
  }
  function _(z, k, B) {
    let A = "";
    B = Math.min(z.length, B);
    for (let m = k; m < B; ++m)
      A += String.fromCharCode(z[m]);
    return A;
  }
  function R(z, k, B) {
    const A = z.length;
    (!k || k < 0) && (k = 0), (!B || B < 0 || B > A) && (B = A);
    let m = "";
    for (let S = k; S < B; ++S)
      m += de[z[S]];
    return m;
  }
  function N(z, k, B) {
    const A = z.slice(k, B);
    let m = "";
    for (let S = 0; S < A.length - 1; S += 2)
      m += String.fromCharCode(A[S] + A[S + 1] * 256);
    return m;
  }
  o.prototype.slice = function(k, B) {
    const A = this.length;
    k = ~~k, B = B === void 0 ? A : ~~B, k < 0 ? (k += A, k < 0 && (k = 0)) : k > A && (k = A), B < 0 ? (B += A, B < 0 && (B = 0)) : B > A && (B = A), B < k && (B = k);
    const m = this.subarray(k, B);
    return Object.setPrototypeOf(m, o.prototype), m;
  };
  function O(z, k, B) {
    if (z % 1 !== 0 || z < 0)
      throw new RangeError("offset is not uint");
    if (z + k > B)
      throw new RangeError("Trying to access beyond buffer length");
  }
  o.prototype.readUintLE = o.prototype.readUIntLE = function(k, B, A) {
    k = k >>> 0, B = B >>> 0, A || O(k, B, this.length);
    let m = this[k], S = 1, q = 0;
    for (; ++q < B && (S *= 256); )
      m += this[k + q] * S;
    return m;
  }, o.prototype.readUintBE = o.prototype.readUIntBE = function(k, B, A) {
    k = k >>> 0, B = B >>> 0, A || O(k, B, this.length);
    let m = this[k + --B], S = 1;
    for (; B > 0 && (S *= 256); )
      m += this[k + --B] * S;
    return m;
  }, o.prototype.readUint8 = o.prototype.readUInt8 = function(k, B) {
    return k = k >>> 0, B || O(k, 1, this.length), this[k];
  }, o.prototype.readUint16LE = o.prototype.readUInt16LE = function(k, B) {
    return k = k >>> 0, B || O(k, 2, this.length), this[k] | this[k + 1] << 8;
  }, o.prototype.readUint16BE = o.prototype.readUInt16BE = function(k, B) {
    return k = k >>> 0, B || O(k, 2, this.length), this[k] << 8 | this[k + 1];
  }, o.prototype.readUint32LE = o.prototype.readUInt32LE = function(k, B) {
    return k = k >>> 0, B || O(k, 4, this.length), (this[k] | this[k + 1] << 8 | this[k + 2] << 16) + this[k + 3] * 16777216;
  }, o.prototype.readUint32BE = o.prototype.readUInt32BE = function(k, B) {
    return k = k >>> 0, B || O(k, 4, this.length), this[k] * 16777216 + (this[k + 1] << 16 | this[k + 2] << 8 | this[k + 3]);
  }, o.prototype.readBigUInt64LE = he(function(k) {
    k = k >>> 0, le(k, "offset");
    const B = this[k], A = this[k + 7];
    (B === void 0 || A === void 0) && me(k, this.length - 8);
    const m = B + this[++k] * 2 ** 8 + this[++k] * 2 ** 16 + this[++k] * 2 ** 24, S = this[++k] + this[++k] * 2 ** 8 + this[++k] * 2 ** 16 + A * 2 ** 24;
    return BigInt(m) + (BigInt(S) << BigInt(32));
  }), o.prototype.readBigUInt64BE = he(function(k) {
    k = k >>> 0, le(k, "offset");
    const B = this[k], A = this[k + 7];
    (B === void 0 || A === void 0) && me(k, this.length - 8);
    const m = B * 2 ** 24 + this[++k] * 2 ** 16 + this[++k] * 2 ** 8 + this[++k], S = this[++k] * 2 ** 24 + this[++k] * 2 ** 16 + this[++k] * 2 ** 8 + A;
    return (BigInt(m) << BigInt(32)) + BigInt(S);
  }), o.prototype.readIntLE = function(k, B, A) {
    k = k >>> 0, B = B >>> 0, A || O(k, B, this.length);
    let m = this[k], S = 1, q = 0;
    for (; ++q < B && (S *= 256); )
      m += this[k + q] * S;
    return S *= 128, m >= S && (m -= Math.pow(2, 8 * B)), m;
  }, o.prototype.readIntBE = function(k, B, A) {
    k = k >>> 0, B = B >>> 0, A || O(k, B, this.length);
    let m = B, S = 1, q = this[k + --m];
    for (; m > 0 && (S *= 256); )
      q += this[k + --m] * S;
    return S *= 128, q >= S && (q -= Math.pow(2, 8 * B)), q;
  }, o.prototype.readInt8 = function(k, B) {
    return k = k >>> 0, B || O(k, 1, this.length), this[k] & 128 ? (255 - this[k] + 1) * -1 : this[k];
  }, o.prototype.readInt16LE = function(k, B) {
    k = k >>> 0, B || O(k, 2, this.length);
    const A = this[k] | this[k + 1] << 8;
    return A & 32768 ? A | 4294901760 : A;
  }, o.prototype.readInt16BE = function(k, B) {
    k = k >>> 0, B || O(k, 2, this.length);
    const A = this[k + 1] | this[k] << 8;
    return A & 32768 ? A | 4294901760 : A;
  }, o.prototype.readInt32LE = function(k, B) {
    return k = k >>> 0, B || O(k, 4, this.length), this[k] | this[k + 1] << 8 | this[k + 2] << 16 | this[k + 3] << 24;
  }, o.prototype.readInt32BE = function(k, B) {
    return k = k >>> 0, B || O(k, 4, this.length), this[k] << 24 | this[k + 1] << 16 | this[k + 2] << 8 | this[k + 3];
  }, o.prototype.readBigInt64LE = he(function(k) {
    k = k >>> 0, le(k, "offset");
    const B = this[k], A = this[k + 7];
    (B === void 0 || A === void 0) && me(k, this.length - 8);
    const m = this[k + 4] + this[k + 5] * 2 ** 8 + this[k + 6] * 2 ** 16 + (A << 24);
    return (BigInt(m) << BigInt(32)) + BigInt(B + this[++k] * 2 ** 8 + this[++k] * 2 ** 16 + this[++k] * 2 ** 24);
  }), o.prototype.readBigInt64BE = he(function(k) {
    k = k >>> 0, le(k, "offset");
    const B = this[k], A = this[k + 7];
    (B === void 0 || A === void 0) && me(k, this.length - 8);
    const m = (B << 24) + // Overflow
    this[++k] * 2 ** 16 + this[++k] * 2 ** 8 + this[++k];
    return (BigInt(m) << BigInt(32)) + BigInt(this[++k] * 2 ** 24 + this[++k] * 2 ** 16 + this[++k] * 2 ** 8 + A);
  }), o.prototype.readFloatLE = function(k, B) {
    return k = k >>> 0, B || O(k, 4, this.length), r.read(this, k, !0, 23, 4);
  }, o.prototype.readFloatBE = function(k, B) {
    return k = k >>> 0, B || O(k, 4, this.length), r.read(this, k, !1, 23, 4);
  }, o.prototype.readDoubleLE = function(k, B) {
    return k = k >>> 0, B || O(k, 8, this.length), r.read(this, k, !0, 52, 8);
  }, o.prototype.readDoubleBE = function(k, B) {
    return k = k >>> 0, B || O(k, 8, this.length), r.read(this, k, !1, 52, 8);
  };
  function g(z, k, B, A, m, S) {
    if (!o.isBuffer(z))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (k > m || k < S)
      throw new RangeError('"value" argument is out of bounds');
    if (B + A > z.length)
      throw new RangeError("Index out of range");
  }
  o.prototype.writeUintLE = o.prototype.writeUIntLE = function(k, B, A, m) {
    if (k = +k, B = B >>> 0, A = A >>> 0, !m) {
      const oe = Math.pow(2, 8 * A) - 1;
      g(this, k, B, A, oe, 0);
    }
    let S = 1, q = 0;
    for (this[B] = k & 255; ++q < A && (S *= 256); )
      this[B + q] = k / S & 255;
    return B + A;
  }, o.prototype.writeUintBE = o.prototype.writeUIntBE = function(k, B, A, m) {
    if (k = +k, B = B >>> 0, A = A >>> 0, !m) {
      const oe = Math.pow(2, 8 * A) - 1;
      g(this, k, B, A, oe, 0);
    }
    let S = A - 1, q = 1;
    for (this[B + S] = k & 255; --S >= 0 && (q *= 256); )
      this[B + S] = k / q & 255;
    return B + A;
  }, o.prototype.writeUint8 = o.prototype.writeUInt8 = function(k, B, A) {
    return k = +k, B = B >>> 0, A || g(this, k, B, 1, 255, 0), this[B] = k & 255, B + 1;
  }, o.prototype.writeUint16LE = o.prototype.writeUInt16LE = function(k, B, A) {
    return k = +k, B = B >>> 0, A || g(this, k, B, 2, 65535, 0), this[B] = k & 255, this[B + 1] = k >>> 8, B + 2;
  }, o.prototype.writeUint16BE = o.prototype.writeUInt16BE = function(k, B, A) {
    return k = +k, B = B >>> 0, A || g(this, k, B, 2, 65535, 0), this[B] = k >>> 8, this[B + 1] = k & 255, B + 2;
  }, o.prototype.writeUint32LE = o.prototype.writeUInt32LE = function(k, B, A) {
    return k = +k, B = B >>> 0, A || g(this, k, B, 4, 4294967295, 0), this[B + 3] = k >>> 24, this[B + 2] = k >>> 16, this[B + 1] = k >>> 8, this[B] = k & 255, B + 4;
  }, o.prototype.writeUint32BE = o.prototype.writeUInt32BE = function(k, B, A) {
    return k = +k, B = B >>> 0, A || g(this, k, B, 4, 4294967295, 0), this[B] = k >>> 24, this[B + 1] = k >>> 16, this[B + 2] = k >>> 8, this[B + 3] = k & 255, B + 4;
  };
  function M(z, k, B, A, m) {
    J(k, A, m, z, B, 7);
    let S = Number(k & BigInt(4294967295));
    z[B++] = S, S = S >> 8, z[B++] = S, S = S >> 8, z[B++] = S, S = S >> 8, z[B++] = S;
    let q = Number(k >> BigInt(32) & BigInt(4294967295));
    return z[B++] = q, q = q >> 8, z[B++] = q, q = q >> 8, z[B++] = q, q = q >> 8, z[B++] = q, B;
  }
  function Y(z, k, B, A, m) {
    J(k, A, m, z, B, 7);
    let S = Number(k & BigInt(4294967295));
    z[B + 7] = S, S = S >> 8, z[B + 6] = S, S = S >> 8, z[B + 5] = S, S = S >> 8, z[B + 4] = S;
    let q = Number(k >> BigInt(32) & BigInt(4294967295));
    return z[B + 3] = q, q = q >> 8, z[B + 2] = q, q = q >> 8, z[B + 1] = q, q = q >> 8, z[B] = q, B + 8;
  }
  o.prototype.writeBigUInt64LE = he(function(k, B = 0) {
    return M(this, k, B, BigInt(0), BigInt("0xffffffffffffffff"));
  }), o.prototype.writeBigUInt64BE = he(function(k, B = 0) {
    return Y(this, k, B, BigInt(0), BigInt("0xffffffffffffffff"));
  }), o.prototype.writeIntLE = function(k, B, A, m) {
    if (k = +k, B = B >>> 0, !m) {
      const fe = Math.pow(2, 8 * A - 1);
      g(this, k, B, A, fe - 1, -fe);
    }
    let S = 0, q = 1, oe = 0;
    for (this[B] = k & 255; ++S < A && (q *= 256); )
      k < 0 && oe === 0 && this[B + S - 1] !== 0 && (oe = 1), this[B + S] = (k / q >> 0) - oe & 255;
    return B + A;
  }, o.prototype.writeIntBE = function(k, B, A, m) {
    if (k = +k, B = B >>> 0, !m) {
      const fe = Math.pow(2, 8 * A - 1);
      g(this, k, B, A, fe - 1, -fe);
    }
    let S = A - 1, q = 1, oe = 0;
    for (this[B + S] = k & 255; --S >= 0 && (q *= 256); )
      k < 0 && oe === 0 && this[B + S + 1] !== 0 && (oe = 1), this[B + S] = (k / q >> 0) - oe & 255;
    return B + A;
  }, o.prototype.writeInt8 = function(k, B, A) {
    return k = +k, B = B >>> 0, A || g(this, k, B, 1, 127, -128), k < 0 && (k = 255 + k + 1), this[B] = k & 255, B + 1;
  }, o.prototype.writeInt16LE = function(k, B, A) {
    return k = +k, B = B >>> 0, A || g(this, k, B, 2, 32767, -32768), this[B] = k & 255, this[B + 1] = k >>> 8, B + 2;
  }, o.prototype.writeInt16BE = function(k, B, A) {
    return k = +k, B = B >>> 0, A || g(this, k, B, 2, 32767, -32768), this[B] = k >>> 8, this[B + 1] = k & 255, B + 2;
  }, o.prototype.writeInt32LE = function(k, B, A) {
    return k = +k, B = B >>> 0, A || g(this, k, B, 4, 2147483647, -2147483648), this[B] = k & 255, this[B + 1] = k >>> 8, this[B + 2] = k >>> 16, this[B + 3] = k >>> 24, B + 4;
  }, o.prototype.writeInt32BE = function(k, B, A) {
    return k = +k, B = B >>> 0, A || g(this, k, B, 4, 2147483647, -2147483648), k < 0 && (k = 4294967295 + k + 1), this[B] = k >>> 24, this[B + 1] = k >>> 16, this[B + 2] = k >>> 8, this[B + 3] = k & 255, B + 4;
  }, o.prototype.writeBigInt64LE = he(function(k, B = 0) {
    return M(this, k, B, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), o.prototype.writeBigInt64BE = he(function(k, B = 0) {
    return Y(this, k, B, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function se(z, k, B, A, m, S) {
    if (B + A > z.length)
      throw new RangeError("Index out of range");
    if (B < 0)
      throw new RangeError("Index out of range");
  }
  function V(z, k, B, A, m) {
    return k = +k, B = B >>> 0, m || se(z, k, B, 4), r.write(z, k, B, A, 23, 4), B + 4;
  }
  o.prototype.writeFloatLE = function(k, B, A) {
    return V(this, k, B, !0, A);
  }, o.prototype.writeFloatBE = function(k, B, A) {
    return V(this, k, B, !1, A);
  };
  function K(z, k, B, A, m) {
    return k = +k, B = B >>> 0, m || se(z, k, B, 8), r.write(z, k, B, A, 52, 8), B + 8;
  }
  o.prototype.writeDoubleLE = function(k, B, A) {
    return K(this, k, B, !0, A);
  }, o.prototype.writeDoubleBE = function(k, B, A) {
    return K(this, k, B, !1, A);
  }, o.prototype.copy = function(k, B, A, m) {
    if (!o.isBuffer(k))
      throw new TypeError("argument should be a Buffer");
    if (A || (A = 0), !m && m !== 0 && (m = this.length), B >= k.length && (B = k.length), B || (B = 0), m > 0 && m < A && (m = A), m === A || k.length === 0 || this.length === 0)
      return 0;
    if (B < 0)
      throw new RangeError("targetStart out of bounds");
    if (A < 0 || A >= this.length)
      throw new RangeError("Index out of range");
    if (m < 0)
      throw new RangeError("sourceEnd out of bounds");
    m > this.length && (m = this.length), k.length - B < m - A && (m = k.length - B + A);
    const S = m - A;
    return this === k && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(B, A, m) : Uint8Array.prototype.set.call(
      k,
      this.subarray(A, m),
      B
    ), S;
  }, o.prototype.fill = function(k, B, A, m) {
    if (typeof k == "string") {
      if (typeof B == "string" ? (m = B, B = 0, A = this.length) : typeof A == "string" && (m = A, A = this.length), m !== void 0 && typeof m != "string")
        throw new TypeError("encoding must be a string");
      if (typeof m == "string" && !o.isEncoding(m))
        throw new TypeError("Unknown encoding: " + m);
      if (k.length === 1) {
        const q = k.charCodeAt(0);
        (m === "utf8" && q < 128 || m === "latin1") && (k = q);
      }
    } else
      typeof k == "number" ? k = k & 255 : typeof k == "boolean" && (k = Number(k));
    if (B < 0 || this.length < B || this.length < A)
      throw new RangeError("Out of range index");
    if (A <= B)
      return this;
    B = B >>> 0, A = A === void 0 ? this.length : A >>> 0, k || (k = 0);
    let S;
    if (typeof k == "number")
      for (S = B; S < A; ++S)
        this[S] = k;
    else {
      const q = o.isBuffer(k) ? k : o.from(k, m), oe = q.length;
      if (oe === 0)
        throw new TypeError('The value "' + k + '" is invalid for argument "value"');
      for (S = 0; S < A - B; ++S)
        this[S + B] = q[S % oe];
    }
    return this;
  };
  const Z = {};
  function ne(z, k, B) {
    Z[z] = class extends B {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: k.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${z}]`, this.stack, delete this.name;
      }
      get code() {
        return z;
      }
      set code(m) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: m,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${z}]: ${this.message}`;
      }
    };
  }
  ne(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(z) {
      return z ? `${z} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), ne(
    "ERR_INVALID_ARG_TYPE",
    function(z, k) {
      return `The "${z}" argument must be of type number. Received type ${typeof k}`;
    },
    TypeError
  ), ne(
    "ERR_OUT_OF_RANGE",
    function(z, k, B) {
      let A = `The value of "${z}" is out of range.`, m = B;
      return Number.isInteger(B) && Math.abs(B) > 2 ** 32 ? m = ce(String(B)) : typeof B == "bigint" && (m = String(B), (B > BigInt(2) ** BigInt(32) || B < -(BigInt(2) ** BigInt(32))) && (m = ce(m)), m += "n"), A += ` It must be ${k}. Received ${m}`, A;
    },
    RangeError
  );
  function ce(z) {
    let k = "", B = z.length;
    const A = z[0] === "-" ? 1 : 0;
    for (; B >= A + 4; B -= 3)
      k = `_${z.slice(B - 3, B)}${k}`;
    return `${z.slice(0, B)}${k}`;
  }
  function H(z, k, B) {
    le(k, "offset"), (z[k] === void 0 || z[k + B] === void 0) && me(k, z.length - (B + 1));
  }
  function J(z, k, B, A, m, S) {
    if (z > B || z < k) {
      const q = typeof k == "bigint" ? "n" : "";
      let oe;
      throw S > 3 ? k === 0 || k === BigInt(0) ? oe = `>= 0${q} and < 2${q} ** ${(S + 1) * 8}${q}` : oe = `>= -(2${q} ** ${(S + 1) * 8 - 1}${q}) and < 2 ** ${(S + 1) * 8 - 1}${q}` : oe = `>= ${k}${q} and <= ${B}${q}`, new Z.ERR_OUT_OF_RANGE("value", oe, z);
    }
    H(A, m, S);
  }
  function le(z, k) {
    if (typeof z != "number")
      throw new Z.ERR_INVALID_ARG_TYPE(k, "number", z);
  }
  function me(z, k, B) {
    throw Math.floor(z) !== z ? (le(z, B), new Z.ERR_OUT_OF_RANGE(B || "offset", "an integer", z)) : k < 0 ? new Z.ERR_BUFFER_OUT_OF_BOUNDS() : new Z.ERR_OUT_OF_RANGE(
      B || "offset",
      `>= ${B ? 1 : 0} and <= ${k}`,
      z
    );
  }
  const Ue = /[^+/0-9A-Za-z-_]/g;
  function Ve(z) {
    if (z = z.split("=")[0], z = z.trim().replace(Ue, ""), z.length < 2)
      return "";
    for (; z.length % 4 !== 0; )
      z = z + "=";
    return z;
  }
  function ze(z, k) {
    k = k || 1 / 0;
    let B;
    const A = z.length;
    let m = null;
    const S = [];
    for (let q = 0; q < A; ++q) {
      if (B = z.charCodeAt(q), B > 55295 && B < 57344) {
        if (!m) {
          if (B > 56319) {
            (k -= 3) > -1 && S.push(239, 191, 189);
            continue;
          } else if (q + 1 === A) {
            (k -= 3) > -1 && S.push(239, 191, 189);
            continue;
          }
          m = B;
          continue;
        }
        if (B < 56320) {
          (k -= 3) > -1 && S.push(239, 191, 189), m = B;
          continue;
        }
        B = (m - 55296 << 10 | B - 56320) + 65536;
      } else
        m && (k -= 3) > -1 && S.push(239, 191, 189);
      if (m = null, B < 128) {
        if ((k -= 1) < 0)
          break;
        S.push(B);
      } else if (B < 2048) {
        if ((k -= 2) < 0)
          break;
        S.push(
          B >> 6 | 192,
          B & 63 | 128
        );
      } else if (B < 65536) {
        if ((k -= 3) < 0)
          break;
        S.push(
          B >> 12 | 224,
          B >> 6 & 63 | 128,
          B & 63 | 128
        );
      } else if (B < 1114112) {
        if ((k -= 4) < 0)
          break;
        S.push(
          B >> 18 | 240,
          B >> 12 & 63 | 128,
          B >> 6 & 63 | 128,
          B & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return S;
  }
  function at(z) {
    const k = [];
    for (let B = 0; B < z.length; ++B)
      k.push(z.charCodeAt(B) & 255);
    return k;
  }
  function xe(z, k) {
    let B, A, m;
    const S = [];
    for (let q = 0; q < z.length && !((k -= 2) < 0); ++q)
      B = z.charCodeAt(q), A = B >> 8, m = B % 256, S.push(m), S.push(A);
    return S;
  }
  function gt(z) {
    return e.toByteArray(Ve(z));
  }
  function ht(z, k, B, A) {
    let m;
    for (m = 0; m < A && !(m + B >= k.length || m >= z.length); ++m)
      k[m + B] = z[m];
    return m;
  }
  function Bt(z, k) {
    return z instanceof k || z != null && z.constructor != null && z.constructor.name != null && z.constructor.name === k.name;
  }
  function pt(z) {
    return z !== z;
  }
  const de = function() {
    const z = "0123456789abcdef", k = new Array(256);
    for (let B = 0; B < 16; ++B) {
      const A = B * 16;
      for (let m = 0; m < 16; ++m)
        k[A + m] = z[B] + z[m];
    }
    return k;
  }();
  function he(z) {
    return typeof BigInt > "u" ? Ie : z;
  }
  function Ie() {
    throw new Error("BigInt not supported");
  }
})(Fe);
function mO(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var oA = { exports: {} }, Ft = {}, rh = { exports: {} }, iv = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(t, e) {
  var r = Fe, n = r.Buffer;
  function i(a, o) {
    for (var c in a)
      o[c] = a[c];
  }
  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? t.exports = r : (i(r, e), e.Buffer = s);
  function s(a, o, c) {
    return n(a, o, c);
  }
  s.prototype = Object.create(n.prototype), i(n, s), s.from = function(a, o, c) {
    if (typeof a == "number")
      throw new TypeError("Argument must not be a number");
    return n(a, o, c);
  }, s.alloc = function(a, o, c) {
    if (typeof a != "number")
      throw new TypeError("Argument must be a number");
    var f = n(a);
    return o !== void 0 ? typeof c == "string" ? f.fill(o, c) : f.fill(o) : f.fill(0), f;
  }, s.allocUnsafe = function(a) {
    if (typeof a != "number")
      throw new TypeError("Argument must be a number");
    return n(a);
  }, s.allocUnsafeSlow = function(a) {
    if (typeof a != "number")
      throw new TypeError("Argument must be a number");
    return r.SlowBuffer(a);
  };
})(iv, iv.exports);
var Lt = iv.exports, o3;
function hf() {
  if (o3)
    return rh.exports;
  o3 = 1;
  var t = 65536, e = 4294967295;
  function r() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var n = Lt.Buffer, i = Ne.crypto || Ne.msCrypto;
  i && i.getRandomValues ? rh.exports = s : rh.exports = r;
  function s(a, o) {
    if (a > e)
      throw new RangeError("requested too many random bytes");
    var c = n.allocUnsafe(a);
    if (a > 0)
      if (a > t)
        for (var f = 0; f < a; f += t)
          i.getRandomValues(c.slice(f, f + t));
      else
        i.getRandomValues(c);
    return typeof o == "function" ? ut.nextTick(function() {
      o(null, c);
    }) : c;
  }
  return rh.exports;
}
var sv = { exports: {} };
typeof Object.create == "function" ? sv.exports = function(e, r) {
  r && (e.super_ = r, e.prototype = Object.create(r.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : sv.exports = function(e, r) {
  if (r) {
    e.super_ = r;
    var n = function() {
    };
    n.prototype = r.prototype, e.prototype = new n(), e.prototype.constructor = e;
  }
};
var Kt = sv.exports, av = { exports: {} }, T2 = { exports: {} }, Eu = typeof Reflect == "object" ? Reflect : null, c3 = Eu && typeof Eu.apply == "function" ? Eu.apply : function(e, r, n) {
  return Function.prototype.apply.call(e, r, n);
}, jh;
Eu && typeof Eu.ownKeys == "function" ? jh = Eu.ownKeys : Object.getOwnPropertySymbols ? jh = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : jh = function(e) {
  return Object.getOwnPropertyNames(e);
};
function vO(t) {
  console && console.warn && console.warn(t);
}
var cA = Number.isNaN || function(e) {
  return e !== e;
};
function Fr() {
  Fr.init.call(this);
}
T2.exports = Fr;
T2.exports.once = EO;
Fr.EventEmitter = Fr;
Fr.prototype._events = void 0;
Fr.prototype._eventsCount = 0;
Fr.prototype._maxListeners = void 0;
var u3 = 10;
function m0(t) {
  if (typeof t != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
Object.defineProperty(Fr, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return u3;
  },
  set: function(t) {
    if (typeof t != "number" || t < 0 || cA(t))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
    u3 = t;
  }
});
Fr.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Fr.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || cA(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function uA(t) {
  return t._maxListeners === void 0 ? Fr.defaultMaxListeners : t._maxListeners;
}
Fr.prototype.getMaxListeners = function() {
  return uA(this);
};
Fr.prototype.emit = function(e) {
  for (var r = [], n = 1; n < arguments.length; n++)
    r.push(arguments[n]);
  var i = e === "error", s = this._events;
  if (s !== void 0)
    i = i && s.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var a;
    if (r.length > 0 && (a = r[0]), a instanceof Error)
      throw a;
    var o = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
    throw o.context = a, o;
  }
  var c = s[e];
  if (c === void 0)
    return !1;
  if (typeof c == "function")
    c3(c, this, r);
  else
    for (var f = c.length, u = pA(c, f), n = 0; n < f; ++n)
      c3(u[n], this, r);
  return !0;
};
function fA(t, e, r, n) {
  var i, s, a;
  if (m0(r), s = t._events, s === void 0 ? (s = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (s.newListener !== void 0 && (t.emit(
    "newListener",
    e,
    r.listener ? r.listener : r
  ), s = t._events), a = s[e]), a === void 0)
    a = s[e] = r, ++t._eventsCount;
  else if (typeof a == "function" ? a = s[e] = n ? [r, a] : [a, r] : n ? a.unshift(r) : a.push(r), i = uA(t), i > 0 && a.length > i && !a.warned) {
    a.warned = !0;
    var o = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    o.name = "MaxListenersExceededWarning", o.emitter = t, o.type = e, o.count = a.length, vO(o);
  }
  return t;
}
Fr.prototype.addListener = function(e, r) {
  return fA(this, e, r, !1);
};
Fr.prototype.on = Fr.prototype.addListener;
Fr.prototype.prependListener = function(e, r) {
  return fA(this, e, r, !0);
};
function wO() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function dA(t, e, r) {
  var n = { fired: !1, wrapFn: void 0, target: t, type: e, listener: r }, i = wO.bind(n);
  return i.listener = r, n.wrapFn = i, i;
}
Fr.prototype.once = function(e, r) {
  return m0(r), this.on(e, dA(this, e, r)), this;
};
Fr.prototype.prependOnceListener = function(e, r) {
  return m0(r), this.prependListener(e, dA(this, e, r)), this;
};
Fr.prototype.removeListener = function(e, r) {
  var n, i, s, a, o;
  if (m0(r), i = this._events, i === void 0)
    return this;
  if (n = i[e], n === void 0)
    return this;
  if (n === r || n.listener === r)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, n.listener || r));
  else if (typeof n != "function") {
    for (s = -1, a = n.length - 1; a >= 0; a--)
      if (n[a] === r || n[a].listener === r) {
        o = n[a].listener, s = a;
        break;
      }
    if (s < 0)
      return this;
    s === 0 ? n.shift() : _O(n, s), n.length === 1 && (i[e] = n[0]), i.removeListener !== void 0 && this.emit("removeListener", e, o || r);
  }
  return this;
};
Fr.prototype.off = Fr.prototype.removeListener;
Fr.prototype.removeAllListeners = function(e) {
  var r, n, i;
  if (n = this._events, n === void 0)
    return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[e]), this;
  if (arguments.length === 0) {
    var s = Object.keys(n), a;
    for (i = 0; i < s.length; ++i)
      a = s[i], a !== "removeListener" && this.removeAllListeners(a);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (r = n[e], typeof r == "function")
    this.removeListener(e, r);
  else if (r !== void 0)
    for (i = r.length - 1; i >= 0; i--)
      this.removeListener(e, r[i]);
  return this;
};
function lA(t, e, r) {
  var n = t._events;
  if (n === void 0)
    return [];
  var i = n[e];
  return i === void 0 ? [] : typeof i == "function" ? r ? [i.listener || i] : [i] : r ? SO(i) : pA(i, i.length);
}
Fr.prototype.listeners = function(e) {
  return lA(this, e, !0);
};
Fr.prototype.rawListeners = function(e) {
  return lA(this, e, !1);
};
Fr.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : hA.call(t, e);
};
Fr.prototype.listenerCount = hA;
function hA(t) {
  var e = this._events;
  if (e !== void 0) {
    var r = e[t];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
Fr.prototype.eventNames = function() {
  return this._eventsCount > 0 ? jh(this._events) : [];
};
function pA(t, e) {
  for (var r = new Array(e), n = 0; n < e; ++n)
    r[n] = t[n];
  return r;
}
function _O(t, e) {
  for (; e + 1 < t.length; e++)
    t[e] = t[e + 1];
  t.pop();
}
function SO(t) {
  for (var e = new Array(t.length), r = 0; r < e.length; ++r)
    e[r] = t[r].listener || t[r];
  return e;
}
function EO(t, e) {
  return new Promise(function(r, n) {
    function i(a) {
      t.removeListener(e, s), n(a);
    }
    function s() {
      typeof t.removeListener == "function" && t.removeListener("error", i), r([].slice.call(arguments));
    }
    yA(t, e, s, { once: !0 }), e !== "error" && xO(t, i, { once: !0 });
  });
}
function xO(t, e, r) {
  typeof t.on == "function" && yA(t, "error", e, r);
}
function yA(t, e, r, n) {
  if (typeof t.on == "function")
    n.once ? t.once(e, r) : t.on(e, r);
  else if (typeof t.addEventListener == "function")
    t.addEventListener(e, function i(s) {
      n.once && t.removeEventListener(e, i), r(s);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
}
var k2 = T2.exports, bA = k2.EventEmitter;
const AO = {}, IO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: AO
}, Symbol.toStringTag, { value: "Module" })), R2 = /* @__PURE__ */ ta(IO);
var y1, f3;
function TO() {
  if (f3)
    return y1;
  f3 = 1;
  function t(y, p) {
    var b = Object.keys(y);
    if (Object.getOwnPropertySymbols) {
      var v = Object.getOwnPropertySymbols(y);
      p && (v = v.filter(function(x) {
        return Object.getOwnPropertyDescriptor(y, x).enumerable;
      })), b.push.apply(b, v);
    }
    return b;
  }
  function e(y) {
    for (var p = 1; p < arguments.length; p++) {
      var b = arguments[p] != null ? arguments[p] : {};
      p % 2 ? t(Object(b), !0).forEach(function(v) {
        r(y, v, b[v]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(b)) : t(Object(b)).forEach(function(v) {
        Object.defineProperty(y, v, Object.getOwnPropertyDescriptor(b, v));
      });
    }
    return y;
  }
  function r(y, p, b) {
    return p = a(p), p in y ? Object.defineProperty(y, p, { value: b, enumerable: !0, configurable: !0, writable: !0 }) : y[p] = b, y;
  }
  function n(y, p) {
    if (!(y instanceof p))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(y, p) {
    for (var b = 0; b < p.length; b++) {
      var v = p[b];
      v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(y, a(v.key), v);
    }
  }
  function s(y, p, b) {
    return p && i(y.prototype, p), b && i(y, b), Object.defineProperty(y, "prototype", { writable: !1 }), y;
  }
  function a(y) {
    var p = o(y, "string");
    return typeof p == "symbol" ? p : String(p);
  }
  function o(y, p) {
    if (typeof y != "object" || y === null)
      return y;
    var b = y[Symbol.toPrimitive];
    if (b !== void 0) {
      var v = b.call(y, p || "default");
      if (typeof v != "object")
        return v;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (p === "string" ? String : Number)(y);
  }
  var c = Fe, f = c.Buffer, u = R2, d = u.inspect, l = d && d.custom || "inspect";
  function h(y, p, b) {
    f.prototype.copy.call(y, p, b);
  }
  return y1 = /* @__PURE__ */ function() {
    function y() {
      n(this, y), this.head = null, this.tail = null, this.length = 0;
    }
    return s(y, [{
      key: "push",
      value: function(b) {
        var v = {
          data: b,
          next: null
        };
        this.length > 0 ? this.tail.next = v : this.head = v, this.tail = v, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(b) {
        var v = {
          data: b,
          next: this.head
        };
        this.length === 0 && (this.tail = v), this.head = v, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var b = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, b;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(b) {
        if (this.length === 0)
          return "";
        for (var v = this.head, x = "" + v.data; v = v.next; )
          x += b + v.data;
        return x;
      }
    }, {
      key: "concat",
      value: function(b) {
        if (this.length === 0)
          return f.alloc(0);
        for (var v = f.allocUnsafe(b >>> 0), x = this.head, I = 0; x; )
          h(x.data, v, I), I += x.data.length, x = x.next;
        return v;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(b, v) {
        var x;
        return b < this.head.data.length ? (x = this.head.data.slice(0, b), this.head.data = this.head.data.slice(b)) : b === this.head.data.length ? x = this.shift() : x = v ? this._getString(b) : this._getBuffer(b), x;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(b) {
        var v = this.head, x = 1, I = v.data;
        for (b -= I.length; v = v.next; ) {
          var L = v.data, P = b > L.length ? L.length : b;
          if (P === L.length ? I += L : I += L.slice(0, b), b -= P, b === 0) {
            P === L.length ? (++x, v.next ? this.head = v.next : this.head = this.tail = null) : (this.head = v, v.data = L.slice(P));
            break;
          }
          ++x;
        }
        return this.length -= x, I;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(b) {
        var v = f.allocUnsafe(b), x = this.head, I = 1;
        for (x.data.copy(v), b -= x.data.length; x = x.next; ) {
          var L = x.data, P = b > L.length ? L.length : b;
          if (L.copy(v, v.length - b, 0, P), b -= P, b === 0) {
            P === L.length ? (++I, x.next ? this.head = x.next : this.head = this.tail = null) : (this.head = x, x.data = L.slice(P));
            break;
          }
          ++I;
        }
        return this.length -= I, v;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: l,
      value: function(b, v) {
        return d(this, e(e({}, v), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), y;
  }(), y1;
}
function kO(t, e) {
  var r = this, n = this._readableState && this._readableState.destroyed, i = this._writableState && this._writableState.destroyed;
  return n || i ? (e ? e(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, ut.nextTick(ov, this, t)) : ut.nextTick(ov, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(s) {
    !e && s ? r._writableState ? r._writableState.errorEmitted ? ut.nextTick($h, r) : (r._writableState.errorEmitted = !0, ut.nextTick(d3, r, s)) : ut.nextTick(d3, r, s) : e ? (ut.nextTick($h, r), e(s)) : ut.nextTick($h, r);
  }), this);
}
function d3(t, e) {
  ov(t, e), $h(t);
}
function $h(t) {
  t._writableState && !t._writableState.emitClose || t._readableState && !t._readableState.emitClose || t.emit("close");
}
function RO() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function ov(t, e) {
  t.emit("error", e);
}
function PO(t, e) {
  var r = t._readableState, n = t._writableState;
  r && r.autoDestroy || n && n.autoDestroy ? t.destroy(e) : t.emit("error", e);
}
var gA = {
  destroy: kO,
  undestroy: RO,
  errorOrDestroy: PO
}, Uc = {};
function OO(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
var mA = {};
function cs(t, e, r) {
  r || (r = Error);
  function n(s, a, o) {
    return typeof e == "string" ? e : e(s, a, o);
  }
  var i = /* @__PURE__ */ function(s) {
    OO(a, s);
    function a(o, c, f) {
      return s.call(this, n(o, c, f)) || this;
    }
    return a;
  }(r);
  i.prototype.name = r.name, i.prototype.code = t, mA[t] = i;
}
function l3(t, e) {
  if (Array.isArray(t)) {
    var r = t.length;
    return t = t.map(function(n) {
      return String(n);
    }), r > 2 ? "one of ".concat(e, " ").concat(t.slice(0, r - 1).join(", "), ", or ") + t[r - 1] : r === 2 ? "one of ".concat(e, " ").concat(t[0], " or ").concat(t[1]) : "of ".concat(e, " ").concat(t[0]);
  } else
    return "of ".concat(e, " ").concat(String(t));
}
function BO(t, e, r) {
  return t.substr(!r || r < 0 ? 0 : +r, e.length) === e;
}
function MO(t, e, r) {
  return (r === void 0 || r > t.length) && (r = t.length), t.substring(r - e.length, r) === e;
}
function CO(t, e, r) {
  return typeof r != "number" && (r = 0), r + e.length > t.length ? !1 : t.indexOf(e, r) !== -1;
}
cs("ERR_INVALID_OPT_VALUE", function(t, e) {
  return 'The value "' + e + '" is invalid for option "' + t + '"';
}, TypeError);
cs("ERR_INVALID_ARG_TYPE", function(t, e, r) {
  var n;
  typeof e == "string" && BO(e, "not ") ? (n = "must not be", e = e.replace(/^not /, "")) : n = "must be";
  var i;
  if (MO(t, " argument"))
    i = "The ".concat(t, " ").concat(n, " ").concat(l3(e, "type"));
  else {
    var s = CO(t, ".") ? "property" : "argument";
    i = 'The "'.concat(t, '" ').concat(s, " ").concat(n, " ").concat(l3(e, "type"));
  }
  return i += ". Received type ".concat(typeof r), i;
}, TypeError);
cs("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
cs("ERR_METHOD_NOT_IMPLEMENTED", function(t) {
  return "The " + t + " method is not implemented";
});
cs("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
cs("ERR_STREAM_DESTROYED", function(t) {
  return "Cannot call " + t + " after a stream was destroyed";
});
cs("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
cs("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
cs("ERR_STREAM_WRITE_AFTER_END", "write after end");
cs("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
cs("ERR_UNKNOWN_ENCODING", function(t) {
  return "Unknown encoding: " + t;
}, TypeError);
cs("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
Uc.codes = mA;
var NO = Uc.codes.ERR_INVALID_OPT_VALUE;
function UO(t, e, r) {
  return t.highWaterMark != null ? t.highWaterMark : e ? t[r] : null;
}
function LO(t, e, r, n) {
  var i = UO(e, n, r);
  if (i != null) {
    if (!(isFinite(i) && Math.floor(i) === i) || i < 0) {
      var s = n ? r : "highWaterMark";
      throw new NO(s, i);
    }
    return Math.floor(i);
  }
  return t.objectMode ? 16 : 16 * 1024;
}
var vA = {
  getHighWaterMark: LO
}, DO = FO;
function FO(t, e) {
  if (b1("noDeprecation"))
    return t;
  var r = !1;
  function n() {
    if (!r) {
      if (b1("throwDeprecation"))
        throw new Error(e);
      b1("traceDeprecation") ? console.trace(e) : console.warn(e), r = !0;
    }
    return t.apply(this, arguments);
  }
  return n;
}
function b1(t) {
  try {
    if (!Ne.localStorage)
      return !1;
  } catch {
    return !1;
  }
  var e = Ne.localStorage[t];
  return e == null ? !1 : String(e).toLowerCase() === "true";
}
var g1, h3;
function P2() {
  if (h3)
    return g1;
  h3 = 1, g1 = F;
  function t(V) {
    var K = this;
    this.next = null, this.entry = null, this.finish = function() {
      se(K, V);
    };
  }
  var e;
  F.WritableState = C;
  var r = {
    deprecate: DO
  }, n = bA, i = Fe.Buffer, s = (typeof Ne < "u" ? Ne : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function a(V) {
    return i.from(V);
  }
  function o(V) {
    return i.isBuffer(V) || V instanceof s;
  }
  var c = gA, f = vA, u = f.getHighWaterMark, d = Uc.codes, l = d.ERR_INVALID_ARG_TYPE, h = d.ERR_METHOD_NOT_IMPLEMENTED, y = d.ERR_MULTIPLE_CALLBACK, p = d.ERR_STREAM_CANNOT_PIPE, b = d.ERR_STREAM_DESTROYED, v = d.ERR_STREAM_NULL_VALUES, x = d.ERR_STREAM_WRITE_AFTER_END, I = d.ERR_UNKNOWN_ENCODING, L = c.errorOrDestroy;
  Kt(F, n);
  function P() {
  }
  function C(V, K, Z) {
    e = e || Sc(), V = V || {}, typeof Z != "boolean" && (Z = K instanceof e), this.objectMode = !!V.objectMode, Z && (this.objectMode = this.objectMode || !!V.writableObjectMode), this.highWaterMark = u(this, V, "writableHighWaterMark", Z), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var ne = V.decodeStrings === !1;
    this.decodeStrings = !ne, this.defaultEncoding = V.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(ce) {
      U(K, ce);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = V.emitClose !== !1, this.autoDestroy = !!V.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  C.prototype.getBuffer = function() {
    for (var K = this.bufferedRequest, Z = []; K; )
      Z.push(K), K = K.next;
    return Z;
  }, function() {
    try {
      Object.defineProperty(C.prototype, "buffer", {
        get: r.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var D;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (D = Function.prototype[Symbol.hasInstance], Object.defineProperty(F, Symbol.hasInstance, {
    value: function(K) {
      return D.call(this, K) ? !0 : this !== F ? !1 : K && K._writableState instanceof C;
    }
  })) : D = function(K) {
    return K instanceof this;
  };
  function F(V) {
    e = e || Sc();
    var K = this instanceof e;
    if (!K && !D.call(F, this))
      return new F(V);
    this._writableState = new C(V, this, K), this.writable = !0, V && (typeof V.write == "function" && (this._write = V.write), typeof V.writev == "function" && (this._writev = V.writev), typeof V.destroy == "function" && (this._destroy = V.destroy), typeof V.final == "function" && (this._final = V.final)), n.call(this);
  }
  F.prototype.pipe = function() {
    L(this, new p());
  };
  function G(V, K) {
    var Z = new x();
    L(V, Z), ut.nextTick(K, Z);
  }
  function re(V, K, Z, ne) {
    var ce;
    return Z === null ? ce = new v() : typeof Z != "string" && !K.objectMode && (ce = new l("chunk", ["string", "Buffer"], Z)), ce ? (L(V, ce), ut.nextTick(ne, ce), !1) : !0;
  }
  F.prototype.write = function(V, K, Z) {
    var ne = this._writableState, ce = !1, H = !ne.objectMode && o(V);
    return H && !i.isBuffer(V) && (V = a(V)), typeof K == "function" && (Z = K, K = null), H ? K = "buffer" : K || (K = ne.defaultEncoding), typeof Z != "function" && (Z = P), ne.ending ? G(this, Z) : (H || re(this, ne, V, Z)) && (ne.pendingcb++, ce = ee(this, ne, H, V, K, Z)), ce;
  }, F.prototype.cork = function() {
    this._writableState.corked++;
  }, F.prototype.uncork = function() {
    var V = this._writableState;
    V.corked && (V.corked--, !V.writing && !V.corked && !V.bufferProcessing && V.bufferedRequest && R(this, V));
  }, F.prototype.setDefaultEncoding = function(K) {
    if (typeof K == "string" && (K = K.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((K + "").toLowerCase()) > -1))
      throw new I(K);
    return this._writableState.defaultEncoding = K, this;
  }, Object.defineProperty(F.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function ie(V, K, Z) {
    return !V.objectMode && V.decodeStrings !== !1 && typeof K == "string" && (K = i.from(K, Z)), K;
  }
  Object.defineProperty(F.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function ee(V, K, Z, ne, ce, H) {
    if (!Z) {
      var J = ie(K, ne, ce);
      ne !== J && (Z = !0, ce = "buffer", ne = J);
    }
    var le = K.objectMode ? 1 : ne.length;
    K.length += le;
    var me = K.length < K.highWaterMark;
    if (me || (K.needDrain = !0), K.writing || K.corked) {
      var Ue = K.lastBufferedRequest;
      K.lastBufferedRequest = {
        chunk: ne,
        encoding: ce,
        isBuf: Z,
        callback: H,
        next: null
      }, Ue ? Ue.next = K.lastBufferedRequest : K.bufferedRequest = K.lastBufferedRequest, K.bufferedRequestCount += 1;
    } else
      $(V, K, !1, le, ne, ce, H);
    return me;
  }
  function $(V, K, Z, ne, ce, H, J) {
    K.writelen = ne, K.writecb = J, K.writing = !0, K.sync = !0, K.destroyed ? K.onwrite(new b("write")) : Z ? V._writev(ce, K.onwrite) : V._write(ce, H, K.onwrite), K.sync = !1;
  }
  function w(V, K, Z, ne, ce) {
    --K.pendingcb, Z ? (ut.nextTick(ce, ne), ut.nextTick(M, V, K), V._writableState.errorEmitted = !0, L(V, ne)) : (ce(ne), V._writableState.errorEmitted = !0, L(V, ne), M(V, K));
  }
  function E(V) {
    V.writing = !1, V.writecb = null, V.length -= V.writelen, V.writelen = 0;
  }
  function U(V, K) {
    var Z = V._writableState, ne = Z.sync, ce = Z.writecb;
    if (typeof ce != "function")
      throw new y();
    if (E(Z), K)
      w(V, Z, ne, K, ce);
    else {
      var H = N(Z) || V.destroyed;
      !H && !Z.corked && !Z.bufferProcessing && Z.bufferedRequest && R(V, Z), ne ? ut.nextTick(W, V, Z, H, ce) : W(V, Z, H, ce);
    }
  }
  function W(V, K, Z, ne) {
    Z || _(V, K), K.pendingcb--, ne(), M(V, K);
  }
  function _(V, K) {
    K.length === 0 && K.needDrain && (K.needDrain = !1, V.emit("drain"));
  }
  function R(V, K) {
    K.bufferProcessing = !0;
    var Z = K.bufferedRequest;
    if (V._writev && Z && Z.next) {
      var ne = K.bufferedRequestCount, ce = new Array(ne), H = K.corkedRequestsFree;
      H.entry = Z;
      for (var J = 0, le = !0; Z; )
        ce[J] = Z, Z.isBuf || (le = !1), Z = Z.next, J += 1;
      ce.allBuffers = le, $(V, K, !0, K.length, ce, "", H.finish), K.pendingcb++, K.lastBufferedRequest = null, H.next ? (K.corkedRequestsFree = H.next, H.next = null) : K.corkedRequestsFree = new t(K), K.bufferedRequestCount = 0;
    } else {
      for (; Z; ) {
        var me = Z.chunk, Ue = Z.encoding, Ve = Z.callback, ze = K.objectMode ? 1 : me.length;
        if ($(V, K, !1, ze, me, Ue, Ve), Z = Z.next, K.bufferedRequestCount--, K.writing)
          break;
      }
      Z === null && (K.lastBufferedRequest = null);
    }
    K.bufferedRequest = Z, K.bufferProcessing = !1;
  }
  F.prototype._write = function(V, K, Z) {
    Z(new h("_write()"));
  }, F.prototype._writev = null, F.prototype.end = function(V, K, Z) {
    var ne = this._writableState;
    return typeof V == "function" ? (Z = V, V = null, K = null) : typeof K == "function" && (Z = K, K = null), V != null && this.write(V, K), ne.corked && (ne.corked = 1, this.uncork()), ne.ending || Y(this, ne, Z), this;
  }, Object.defineProperty(F.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function N(V) {
    return V.ending && V.length === 0 && V.bufferedRequest === null && !V.finished && !V.writing;
  }
  function O(V, K) {
    V._final(function(Z) {
      K.pendingcb--, Z && L(V, Z), K.prefinished = !0, V.emit("prefinish"), M(V, K);
    });
  }
  function g(V, K) {
    !K.prefinished && !K.finalCalled && (typeof V._final == "function" && !K.destroyed ? (K.pendingcb++, K.finalCalled = !0, ut.nextTick(O, V, K)) : (K.prefinished = !0, V.emit("prefinish")));
  }
  function M(V, K) {
    var Z = N(K);
    if (Z && (g(V, K), K.pendingcb === 0 && (K.finished = !0, V.emit("finish"), K.autoDestroy))) {
      var ne = V._readableState;
      (!ne || ne.autoDestroy && ne.endEmitted) && V.destroy();
    }
    return Z;
  }
  function Y(V, K, Z) {
    K.ending = !0, M(V, K), Z && (K.finished ? ut.nextTick(Z) : V.once("finish", Z)), K.ended = !0, V.writable = !1;
  }
  function se(V, K, Z) {
    var ne = V.entry;
    for (V.entry = null; ne; ) {
      var ce = ne.callback;
      K.pendingcb--, ce(Z), ne = ne.next;
    }
    K.corkedRequestsFree.next = V;
  }
  return Object.defineProperty(F.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(K) {
      this._writableState && (this._writableState.destroyed = K);
    }
  }), F.prototype.destroy = c.destroy, F.prototype._undestroy = c.undestroy, F.prototype._destroy = function(V, K) {
    K(V);
  }, g1;
}
var m1, p3;
function Sc() {
  if (p3)
    return m1;
  p3 = 1;
  var t = Object.keys || function(f) {
    var u = [];
    for (var d in f)
      u.push(d);
    return u;
  };
  m1 = a;
  var e = B2(), r = P2();
  Kt(a, e);
  for (var n = t(r.prototype), i = 0; i < n.length; i++) {
    var s = n[i];
    a.prototype[s] || (a.prototype[s] = r.prototype[s]);
  }
  function a(f) {
    if (!(this instanceof a))
      return new a(f);
    e.call(this, f), r.call(this, f), this.allowHalfOpen = !0, f && (f.readable === !1 && (this.readable = !1), f.writable === !1 && (this.writable = !1), f.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", o)));
  }
  Object.defineProperty(a.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(a.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(a.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function o() {
    this._writableState.ended || ut.nextTick(c, this);
  }
  function c(f) {
    f.end();
  }
  return Object.defineProperty(a.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(u) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = u, this._writableState.destroyed = u);
    }
  }), m1;
}
var lp = {}, O2 = Lt.Buffer, y3 = O2.isEncoding || function(t) {
  switch (t = "" + t, t && t.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function jO(t) {
  if (!t)
    return "utf8";
  for (var e; ; )
    switch (t) {
      case "utf8":
      case "utf-8":
        return "utf8";
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return "utf16le";
      case "latin1":
      case "binary":
        return "latin1";
      case "base64":
      case "ascii":
      case "hex":
        return t;
      default:
        if (e)
          return;
        t = ("" + t).toLowerCase(), e = !0;
    }
}
function $O(t) {
  var e = jO(t);
  if (typeof e != "string" && (O2.isEncoding === y3 || !y3(t)))
    throw new Error("Unknown encoding: " + t);
  return e || t;
}
lp.StringDecoder = wl;
function wl(t) {
  this.encoding = $O(t);
  var e;
  switch (this.encoding) {
    case "utf16le":
      this.text = HO, this.end = GO, e = 4;
      break;
    case "utf8":
      this.fillLast = zO, e = 4;
      break;
    case "base64":
      this.text = ZO, this.end = JO, e = 3;
      break;
    default:
      this.write = YO, this.end = QO;
      return;
  }
  this.lastNeed = 0, this.lastTotal = 0, this.lastChar = O2.allocUnsafe(e);
}
wl.prototype.write = function(t) {
  if (t.length === 0)
    return "";
  var e, r;
  if (this.lastNeed) {
    if (e = this.fillLast(t), e === void 0)
      return "";
    r = this.lastNeed, this.lastNeed = 0;
  } else
    r = 0;
  return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
};
wl.prototype.end = VO;
wl.prototype.text = KO;
wl.prototype.fillLast = function(t) {
  if (this.lastNeed <= t.length)
    return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
};
function v1(t) {
  return t <= 127 ? 0 : t >> 5 === 6 ? 2 : t >> 4 === 14 ? 3 : t >> 3 === 30 ? 4 : t >> 6 === 2 ? -1 : -2;
}
function qO(t, e, r) {
  var n = e.length - 1;
  if (n < r)
    return 0;
  var i = v1(e[n]);
  return i >= 0 ? (i > 0 && (t.lastNeed = i - 1), i) : --n < r || i === -2 ? 0 : (i = v1(e[n]), i >= 0 ? (i > 0 && (t.lastNeed = i - 2), i) : --n < r || i === -2 ? 0 : (i = v1(e[n]), i >= 0 ? (i > 0 && (i === 2 ? i = 0 : t.lastNeed = i - 3), i) : 0));
}
function WO(t, e, r) {
  if ((e[0] & 192) !== 128)
    return t.lastNeed = 0, "�";
  if (t.lastNeed > 1 && e.length > 1) {
    if ((e[1] & 192) !== 128)
      return t.lastNeed = 1, "�";
    if (t.lastNeed > 2 && e.length > 2 && (e[2] & 192) !== 128)
      return t.lastNeed = 2, "�";
  }
}
function zO(t) {
  var e = this.lastTotal - this.lastNeed, r = WO(this, t);
  if (r !== void 0)
    return r;
  if (this.lastNeed <= t.length)
    return t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  t.copy(this.lastChar, e, 0, t.length), this.lastNeed -= t.length;
}
function KO(t, e) {
  var r = qO(this, t, e);
  if (!this.lastNeed)
    return t.toString("utf8", e);
  this.lastTotal = r;
  var n = t.length - (r - this.lastNeed);
  return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n);
}
function VO(t) {
  var e = t && t.length ? this.write(t) : "";
  return this.lastNeed ? e + "�" : e;
}
function HO(t, e) {
  if ((t.length - e) % 2 === 0) {
    var r = t.toString("utf16le", e);
    if (r) {
      var n = r.charCodeAt(r.length - 1);
      if (n >= 55296 && n <= 56319)
        return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
    }
    return r;
  }
  return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
}
function GO(t) {
  var e = t && t.length ? this.write(t) : "";
  if (this.lastNeed) {
    var r = this.lastTotal - this.lastNeed;
    return e + this.lastChar.toString("utf16le", 0, r);
  }
  return e;
}
function ZO(t, e) {
  var r = (t.length - e) % 3;
  return r === 0 ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, r === 1 ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
}
function JO(t) {
  var e = t && t.length ? this.write(t) : "";
  return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
}
function YO(t) {
  return t.toString(this.encoding);
}
function QO(t) {
  return t && t.length ? this.write(t) : "";
}
var b3 = Uc.codes.ERR_STREAM_PREMATURE_CLOSE;
function XO(t) {
  var e = !1;
  return function() {
    if (!e) {
      e = !0;
      for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
        n[i] = arguments[i];
      t.apply(this, n);
    }
  };
}
function eB() {
}
function tB(t) {
  return t.setHeader && typeof t.abort == "function";
}
function wA(t, e, r) {
  if (typeof e == "function")
    return wA(t, null, e);
  e || (e = {}), r = XO(r || eB);
  var n = e.readable || e.readable !== !1 && t.readable, i = e.writable || e.writable !== !1 && t.writable, s = function() {
    t.writable || o();
  }, a = t._writableState && t._writableState.finished, o = function() {
    i = !1, a = !0, n || r.call(t);
  }, c = t._readableState && t._readableState.endEmitted, f = function() {
    n = !1, c = !0, i || r.call(t);
  }, u = function(y) {
    r.call(t, y);
  }, d = function() {
    var y;
    if (n && !c)
      return (!t._readableState || !t._readableState.ended) && (y = new b3()), r.call(t, y);
    if (i && !a)
      return (!t._writableState || !t._writableState.ended) && (y = new b3()), r.call(t, y);
  }, l = function() {
    t.req.on("finish", o);
  };
  return tB(t) ? (t.on("complete", o), t.on("abort", d), t.req ? l() : t.on("request", l)) : i && !t._writableState && (t.on("end", s), t.on("close", s)), t.on("end", f), t.on("finish", o), e.error !== !1 && t.on("error", u), t.on("close", d), function() {
    t.removeListener("complete", o), t.removeListener("abort", d), t.removeListener("request", l), t.req && t.req.removeListener("finish", o), t.removeListener("end", s), t.removeListener("close", s), t.removeListener("finish", o), t.removeListener("end", f), t.removeListener("error", u), t.removeListener("close", d);
  };
}
var v0 = wA, w1, g3;
function rB() {
  if (g3)
    return w1;
  g3 = 1;
  var t;
  function e(I, L, P) {
    return L = r(L), L in I ? Object.defineProperty(I, L, { value: P, enumerable: !0, configurable: !0, writable: !0 }) : I[L] = P, I;
  }
  function r(I) {
    var L = n(I, "string");
    return typeof L == "symbol" ? L : String(L);
  }
  function n(I, L) {
    if (typeof I != "object" || I === null)
      return I;
    var P = I[Symbol.toPrimitive];
    if (P !== void 0) {
      var C = P.call(I, L || "default");
      if (typeof C != "object")
        return C;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (L === "string" ? String : Number)(I);
  }
  var i = v0, s = Symbol("lastResolve"), a = Symbol("lastReject"), o = Symbol("error"), c = Symbol("ended"), f = Symbol("lastPromise"), u = Symbol("handlePromise"), d = Symbol("stream");
  function l(I, L) {
    return {
      value: I,
      done: L
    };
  }
  function h(I) {
    var L = I[s];
    if (L !== null) {
      var P = I[d].read();
      P !== null && (I[f] = null, I[s] = null, I[a] = null, L(l(P, !1)));
    }
  }
  function y(I) {
    ut.nextTick(h, I);
  }
  function p(I, L) {
    return function(P, C) {
      I.then(function() {
        if (L[c]) {
          P(l(void 0, !0));
          return;
        }
        L[u](P, C);
      }, C);
    };
  }
  var b = Object.getPrototypeOf(function() {
  }), v = Object.setPrototypeOf((t = {
    get stream() {
      return this[d];
    },
    next: function() {
      var L = this, P = this[o];
      if (P !== null)
        return Promise.reject(P);
      if (this[c])
        return Promise.resolve(l(void 0, !0));
      if (this[d].destroyed)
        return new Promise(function(G, re) {
          ut.nextTick(function() {
            L[o] ? re(L[o]) : G(l(void 0, !0));
          });
        });
      var C = this[f], D;
      if (C)
        D = new Promise(p(C, this));
      else {
        var F = this[d].read();
        if (F !== null)
          return Promise.resolve(l(F, !1));
        D = new Promise(this[u]);
      }
      return this[f] = D, D;
    }
  }, e(t, Symbol.asyncIterator, function() {
    return this;
  }), e(t, "return", function() {
    var L = this;
    return new Promise(function(P, C) {
      L[d].destroy(null, function(D) {
        if (D) {
          C(D);
          return;
        }
        P(l(void 0, !0));
      });
    });
  }), t), b), x = function(L) {
    var P, C = Object.create(v, (P = {}, e(P, d, {
      value: L,
      writable: !0
    }), e(P, s, {
      value: null,
      writable: !0
    }), e(P, a, {
      value: null,
      writable: !0
    }), e(P, o, {
      value: null,
      writable: !0
    }), e(P, c, {
      value: L._readableState.endEmitted,
      writable: !0
    }), e(P, u, {
      value: function(F, G) {
        var re = C[d].read();
        re ? (C[f] = null, C[s] = null, C[a] = null, F(l(re, !1))) : (C[s] = F, C[a] = G);
      },
      writable: !0
    }), P));
    return C[f] = null, i(L, function(D) {
      if (D && D.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var F = C[a];
        F !== null && (C[f] = null, C[s] = null, C[a] = null, F(D)), C[o] = D;
        return;
      }
      var G = C[s];
      G !== null && (C[f] = null, C[s] = null, C[a] = null, G(l(void 0, !0))), C[c] = !0;
    }), L.on("readable", y.bind(null, C)), C;
  };
  return w1 = x, w1;
}
var _1, m3;
function nB() {
  return m3 || (m3 = 1, _1 = function() {
    throw new Error("Readable.from is not available in the browser");
  }), _1;
}
var S1, v3;
function B2() {
  if (v3)
    return S1;
  v3 = 1, S1 = G;
  var t;
  G.ReadableState = F, k2.EventEmitter;
  var e = function(J, le) {
    return J.listeners(le).length;
  }, r = bA, n = Fe.Buffer, i = (typeof Ne < "u" ? Ne : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function s(H) {
    return n.from(H);
  }
  function a(H) {
    return n.isBuffer(H) || H instanceof i;
  }
  var o = R2, c;
  o && o.debuglog ? c = o.debuglog("stream") : c = function() {
  };
  var f = TO(), u = gA, d = vA, l = d.getHighWaterMark, h = Uc.codes, y = h.ERR_INVALID_ARG_TYPE, p = h.ERR_STREAM_PUSH_AFTER_EOF, b = h.ERR_METHOD_NOT_IMPLEMENTED, v = h.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, x, I, L;
  Kt(G, r);
  var P = u.errorOrDestroy, C = ["error", "close", "destroy", "pause", "resume"];
  function D(H, J, le) {
    if (typeof H.prependListener == "function")
      return H.prependListener(J, le);
    !H._events || !H._events[J] ? H.on(J, le) : Array.isArray(H._events[J]) ? H._events[J].unshift(le) : H._events[J] = [le, H._events[J]];
  }
  function F(H, J, le) {
    t = t || Sc(), H = H || {}, typeof le != "boolean" && (le = J instanceof t), this.objectMode = !!H.objectMode, le && (this.objectMode = this.objectMode || !!H.readableObjectMode), this.highWaterMark = l(this, H, "readableHighWaterMark", le), this.buffer = new f(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = H.emitClose !== !1, this.autoDestroy = !!H.autoDestroy, this.destroyed = !1, this.defaultEncoding = H.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, H.encoding && (x || (x = lp.StringDecoder), this.decoder = new x(H.encoding), this.encoding = H.encoding);
  }
  function G(H) {
    if (t = t || Sc(), !(this instanceof G))
      return new G(H);
    var J = this instanceof t;
    this._readableState = new F(H, this, J), this.readable = !0, H && (typeof H.read == "function" && (this._read = H.read), typeof H.destroy == "function" && (this._destroy = H.destroy)), r.call(this);
  }
  Object.defineProperty(G.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(J) {
      this._readableState && (this._readableState.destroyed = J);
    }
  }), G.prototype.destroy = u.destroy, G.prototype._undestroy = u.undestroy, G.prototype._destroy = function(H, J) {
    J(H);
  }, G.prototype.push = function(H, J) {
    var le = this._readableState, me;
    return le.objectMode ? me = !0 : typeof H == "string" && (J = J || le.defaultEncoding, J !== le.encoding && (H = n.from(H, J), J = ""), me = !0), re(this, H, J, !1, me);
  }, G.prototype.unshift = function(H) {
    return re(this, H, null, !0, !1);
  };
  function re(H, J, le, me, Ue) {
    c("readableAddChunk", J);
    var Ve = H._readableState;
    if (J === null)
      Ve.reading = !1, U(H, Ve);
    else {
      var ze;
      if (Ue || (ze = ee(Ve, J)), ze)
        P(H, ze);
      else if (Ve.objectMode || J && J.length > 0)
        if (typeof J != "string" && !Ve.objectMode && Object.getPrototypeOf(J) !== n.prototype && (J = s(J)), me)
          Ve.endEmitted ? P(H, new v()) : ie(H, Ve, J, !0);
        else if (Ve.ended)
          P(H, new p());
        else {
          if (Ve.destroyed)
            return !1;
          Ve.reading = !1, Ve.decoder && !le ? (J = Ve.decoder.write(J), Ve.objectMode || J.length !== 0 ? ie(H, Ve, J, !1) : R(H, Ve)) : ie(H, Ve, J, !1);
        }
      else
        me || (Ve.reading = !1, R(H, Ve));
    }
    return !Ve.ended && (Ve.length < Ve.highWaterMark || Ve.length === 0);
  }
  function ie(H, J, le, me) {
    J.flowing && J.length === 0 && !J.sync ? (J.awaitDrain = 0, H.emit("data", le)) : (J.length += J.objectMode ? 1 : le.length, me ? J.buffer.unshift(le) : J.buffer.push(le), J.needReadable && W(H)), R(H, J);
  }
  function ee(H, J) {
    var le;
    return !a(J) && typeof J != "string" && J !== void 0 && !H.objectMode && (le = new y("chunk", ["string", "Buffer", "Uint8Array"], J)), le;
  }
  G.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, G.prototype.setEncoding = function(H) {
    x || (x = lp.StringDecoder);
    var J = new x(H);
    this._readableState.decoder = J, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var le = this._readableState.buffer.head, me = ""; le !== null; )
      me += J.write(le.data), le = le.next;
    return this._readableState.buffer.clear(), me !== "" && this._readableState.buffer.push(me), this._readableState.length = me.length, this;
  };
  var $ = 1073741824;
  function w(H) {
    return H >= $ ? H = $ : (H--, H |= H >>> 1, H |= H >>> 2, H |= H >>> 4, H |= H >>> 8, H |= H >>> 16, H++), H;
  }
  function E(H, J) {
    return H <= 0 || J.length === 0 && J.ended ? 0 : J.objectMode ? 1 : H !== H ? J.flowing && J.length ? J.buffer.head.data.length : J.length : (H > J.highWaterMark && (J.highWaterMark = w(H)), H <= J.length ? H : J.ended ? J.length : (J.needReadable = !0, 0));
  }
  G.prototype.read = function(H) {
    c("read", H), H = parseInt(H, 10);
    var J = this._readableState, le = H;
    if (H !== 0 && (J.emittedReadable = !1), H === 0 && J.needReadable && ((J.highWaterMark !== 0 ? J.length >= J.highWaterMark : J.length > 0) || J.ended))
      return c("read: emitReadable", J.length, J.ended), J.length === 0 && J.ended ? Z(this) : W(this), null;
    if (H = E(H, J), H === 0 && J.ended)
      return J.length === 0 && Z(this), null;
    var me = J.needReadable;
    c("need readable", me), (J.length === 0 || J.length - H < J.highWaterMark) && (me = !0, c("length less than watermark", me)), J.ended || J.reading ? (me = !1, c("reading or ended", me)) : me && (c("do read"), J.reading = !0, J.sync = !0, J.length === 0 && (J.needReadable = !0), this._read(J.highWaterMark), J.sync = !1, J.reading || (H = E(le, J)));
    var Ue;
    return H > 0 ? Ue = K(H, J) : Ue = null, Ue === null ? (J.needReadable = J.length <= J.highWaterMark, H = 0) : (J.length -= H, J.awaitDrain = 0), J.length === 0 && (J.ended || (J.needReadable = !0), le !== H && J.ended && Z(this)), Ue !== null && this.emit("data", Ue), Ue;
  };
  function U(H, J) {
    if (c("onEofChunk"), !J.ended) {
      if (J.decoder) {
        var le = J.decoder.end();
        le && le.length && (J.buffer.push(le), J.length += J.objectMode ? 1 : le.length);
      }
      J.ended = !0, J.sync ? W(H) : (J.needReadable = !1, J.emittedReadable || (J.emittedReadable = !0, _(H)));
    }
  }
  function W(H) {
    var J = H._readableState;
    c("emitReadable", J.needReadable, J.emittedReadable), J.needReadable = !1, J.emittedReadable || (c("emitReadable", J.flowing), J.emittedReadable = !0, ut.nextTick(_, H));
  }
  function _(H) {
    var J = H._readableState;
    c("emitReadable_", J.destroyed, J.length, J.ended), !J.destroyed && (J.length || J.ended) && (H.emit("readable"), J.emittedReadable = !1), J.needReadable = !J.flowing && !J.ended && J.length <= J.highWaterMark, V(H);
  }
  function R(H, J) {
    J.readingMore || (J.readingMore = !0, ut.nextTick(N, H, J));
  }
  function N(H, J) {
    for (; !J.reading && !J.ended && (J.length < J.highWaterMark || J.flowing && J.length === 0); ) {
      var le = J.length;
      if (c("maybeReadMore read 0"), H.read(0), le === J.length)
        break;
    }
    J.readingMore = !1;
  }
  G.prototype._read = function(H) {
    P(this, new b("_read()"));
  }, G.prototype.pipe = function(H, J) {
    var le = this, me = this._readableState;
    switch (me.pipesCount) {
      case 0:
        me.pipes = H;
        break;
      case 1:
        me.pipes = [me.pipes, H];
        break;
      default:
        me.pipes.push(H);
        break;
    }
    me.pipesCount += 1, c("pipe count=%d opts=%j", me.pipesCount, J);
    var Ue = (!J || J.end !== !1) && H !== ut.stdout && H !== ut.stderr, Ve = Ue ? at : Ie;
    me.endEmitted ? ut.nextTick(Ve) : le.once("end", Ve), H.on("unpipe", ze);
    function ze(z, k) {
      c("onunpipe"), z === le && k && k.hasUnpiped === !1 && (k.hasUnpiped = !0, ht());
    }
    function at() {
      c("onend"), H.end();
    }
    var xe = O(le);
    H.on("drain", xe);
    var gt = !1;
    function ht() {
      c("cleanup"), H.removeListener("close", de), H.removeListener("finish", he), H.removeListener("drain", xe), H.removeListener("error", pt), H.removeListener("unpipe", ze), le.removeListener("end", at), le.removeListener("end", Ie), le.removeListener("data", Bt), gt = !0, me.awaitDrain && (!H._writableState || H._writableState.needDrain) && xe();
    }
    le.on("data", Bt);
    function Bt(z) {
      c("ondata");
      var k = H.write(z);
      c("dest.write", k), k === !1 && ((me.pipesCount === 1 && me.pipes === H || me.pipesCount > 1 && ce(me.pipes, H) !== -1) && !gt && (c("false write response, pause", me.awaitDrain), me.awaitDrain++), le.pause());
    }
    function pt(z) {
      c("onerror", z), Ie(), H.removeListener("error", pt), e(H, "error") === 0 && P(H, z);
    }
    D(H, "error", pt);
    function de() {
      H.removeListener("finish", he), Ie();
    }
    H.once("close", de);
    function he() {
      c("onfinish"), H.removeListener("close", de), Ie();
    }
    H.once("finish", he);
    function Ie() {
      c("unpipe"), le.unpipe(H);
    }
    return H.emit("pipe", le), me.flowing || (c("pipe resume"), le.resume()), H;
  };
  function O(H) {
    return function() {
      var le = H._readableState;
      c("pipeOnDrain", le.awaitDrain), le.awaitDrain && le.awaitDrain--, le.awaitDrain === 0 && e(H, "data") && (le.flowing = !0, V(H));
    };
  }
  G.prototype.unpipe = function(H) {
    var J = this._readableState, le = {
      hasUnpiped: !1
    };
    if (J.pipesCount === 0)
      return this;
    if (J.pipesCount === 1)
      return H && H !== J.pipes ? this : (H || (H = J.pipes), J.pipes = null, J.pipesCount = 0, J.flowing = !1, H && H.emit("unpipe", this, le), this);
    if (!H) {
      var me = J.pipes, Ue = J.pipesCount;
      J.pipes = null, J.pipesCount = 0, J.flowing = !1;
      for (var Ve = 0; Ve < Ue; Ve++)
        me[Ve].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var ze = ce(J.pipes, H);
    return ze === -1 ? this : (J.pipes.splice(ze, 1), J.pipesCount -= 1, J.pipesCount === 1 && (J.pipes = J.pipes[0]), H.emit("unpipe", this, le), this);
  }, G.prototype.on = function(H, J) {
    var le = r.prototype.on.call(this, H, J), me = this._readableState;
    return H === "data" ? (me.readableListening = this.listenerCount("readable") > 0, me.flowing !== !1 && this.resume()) : H === "readable" && !me.endEmitted && !me.readableListening && (me.readableListening = me.needReadable = !0, me.flowing = !1, me.emittedReadable = !1, c("on readable", me.length, me.reading), me.length ? W(this) : me.reading || ut.nextTick(M, this)), le;
  }, G.prototype.addListener = G.prototype.on, G.prototype.removeListener = function(H, J) {
    var le = r.prototype.removeListener.call(this, H, J);
    return H === "readable" && ut.nextTick(g, this), le;
  }, G.prototype.removeAllListeners = function(H) {
    var J = r.prototype.removeAllListeners.apply(this, arguments);
    return (H === "readable" || H === void 0) && ut.nextTick(g, this), J;
  };
  function g(H) {
    var J = H._readableState;
    J.readableListening = H.listenerCount("readable") > 0, J.resumeScheduled && !J.paused ? J.flowing = !0 : H.listenerCount("data") > 0 && H.resume();
  }
  function M(H) {
    c("readable nexttick read 0"), H.read(0);
  }
  G.prototype.resume = function() {
    var H = this._readableState;
    return H.flowing || (c("resume"), H.flowing = !H.readableListening, Y(this, H)), H.paused = !1, this;
  };
  function Y(H, J) {
    J.resumeScheduled || (J.resumeScheduled = !0, ut.nextTick(se, H, J));
  }
  function se(H, J) {
    c("resume", J.reading), J.reading || H.read(0), J.resumeScheduled = !1, H.emit("resume"), V(H), J.flowing && !J.reading && H.read(0);
  }
  G.prototype.pause = function() {
    return c("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (c("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function V(H) {
    var J = H._readableState;
    for (c("flow", J.flowing); J.flowing && H.read() !== null; )
      ;
  }
  G.prototype.wrap = function(H) {
    var J = this, le = this._readableState, me = !1;
    H.on("end", function() {
      if (c("wrapped end"), le.decoder && !le.ended) {
        var ze = le.decoder.end();
        ze && ze.length && J.push(ze);
      }
      J.push(null);
    }), H.on("data", function(ze) {
      if (c("wrapped data"), le.decoder && (ze = le.decoder.write(ze)), !(le.objectMode && ze == null) && !(!le.objectMode && (!ze || !ze.length))) {
        var at = J.push(ze);
        at || (me = !0, H.pause());
      }
    });
    for (var Ue in H)
      this[Ue] === void 0 && typeof H[Ue] == "function" && (this[Ue] = /* @__PURE__ */ function(at) {
        return function() {
          return H[at].apply(H, arguments);
        };
      }(Ue));
    for (var Ve = 0; Ve < C.length; Ve++)
      H.on(C[Ve], this.emit.bind(this, C[Ve]));
    return this._read = function(ze) {
      c("wrapped _read", ze), me && (me = !1, H.resume());
    }, this;
  }, typeof Symbol == "function" && (G.prototype[Symbol.asyncIterator] = function() {
    return I === void 0 && (I = rB()), I(this);
  }), Object.defineProperty(G.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(G.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(G.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(J) {
      this._readableState && (this._readableState.flowing = J);
    }
  }), G._fromList = K, Object.defineProperty(G.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function K(H, J) {
    if (J.length === 0)
      return null;
    var le;
    return J.objectMode ? le = J.buffer.shift() : !H || H >= J.length ? (J.decoder ? le = J.buffer.join("") : J.buffer.length === 1 ? le = J.buffer.first() : le = J.buffer.concat(J.length), J.buffer.clear()) : le = J.buffer.consume(H, J.decoder), le;
  }
  function Z(H) {
    var J = H._readableState;
    c("endReadable", J.endEmitted), J.endEmitted || (J.ended = !0, ut.nextTick(ne, J, H));
  }
  function ne(H, J) {
    if (c("endReadableNT", H.endEmitted, H.length), !H.endEmitted && H.length === 0 && (H.endEmitted = !0, J.readable = !1, J.emit("end"), H.autoDestroy)) {
      var le = J._writableState;
      (!le || le.autoDestroy && le.finished) && J.destroy();
    }
  }
  typeof Symbol == "function" && (G.from = function(H, J) {
    return L === void 0 && (L = nB()), L(G, H, J);
  });
  function ce(H, J) {
    for (var le = 0, me = H.length; le < me; le++)
      if (H[le] === J)
        return le;
    return -1;
  }
  return S1;
}
var M2 = Ua, w0 = Uc.codes, iB = w0.ERR_METHOD_NOT_IMPLEMENTED, sB = w0.ERR_MULTIPLE_CALLBACK, aB = w0.ERR_TRANSFORM_ALREADY_TRANSFORMING, oB = w0.ERR_TRANSFORM_WITH_LENGTH_0, _0 = Sc();
Kt(Ua, _0);
function cB(t, e) {
  var r = this._transformState;
  r.transforming = !1;
  var n = r.writecb;
  if (n === null)
    return this.emit("error", new sB());
  r.writechunk = null, r.writecb = null, e != null && this.push(e), n(t);
  var i = this._readableState;
  i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
}
function Ua(t) {
  if (!(this instanceof Ua))
    return new Ua(t);
  _0.call(this, t), this._transformState = {
    afterTransform: cB.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && (typeof t.transform == "function" && (this._transform = t.transform), typeof t.flush == "function" && (this._flush = t.flush)), this.on("prefinish", uB);
}
function uB() {
  var t = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(e, r) {
    w3(t, e, r);
  }) : w3(this, null, null);
}
Ua.prototype.push = function(t, e) {
  return this._transformState.needTransform = !1, _0.prototype.push.call(this, t, e);
};
Ua.prototype._transform = function(t, e, r) {
  r(new iB("_transform()"));
};
Ua.prototype._write = function(t, e, r) {
  var n = this._transformState;
  if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
    var i = this._readableState;
    (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
  }
};
Ua.prototype._read = function(t) {
  var e = this._transformState;
  e.writechunk !== null && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
Ua.prototype._destroy = function(t, e) {
  _0.prototype._destroy.call(this, t, function(r) {
    e(r);
  });
};
function w3(t, e, r) {
  if (e)
    return t.emit("error", e);
  if (r != null && t.push(r), t._writableState.length)
    throw new oB();
  if (t._transformState.transforming)
    throw new aB();
  return t.push(null);
}
var _A = Pd, SA = M2;
Kt(Pd, SA);
function Pd(t) {
  if (!(this instanceof Pd))
    return new Pd(t);
  SA.call(this, t);
}
Pd.prototype._transform = function(t, e, r) {
  r(null, t);
};
var E1;
function fB(t) {
  var e = !1;
  return function() {
    e || (e = !0, t.apply(void 0, arguments));
  };
}
var EA = Uc.codes, dB = EA.ERR_MISSING_ARGS, lB = EA.ERR_STREAM_DESTROYED;
function _3(t) {
  if (t)
    throw t;
}
function hB(t) {
  return t.setHeader && typeof t.abort == "function";
}
function pB(t, e, r, n) {
  n = fB(n);
  var i = !1;
  t.on("close", function() {
    i = !0;
  }), E1 === void 0 && (E1 = v0), E1(t, {
    readable: e,
    writable: r
  }, function(a) {
    if (a)
      return n(a);
    i = !0, n();
  });
  var s = !1;
  return function(a) {
    if (!i && !s) {
      if (s = !0, hB(t))
        return t.abort();
      if (typeof t.destroy == "function")
        return t.destroy();
      n(a || new lB("pipe"));
    }
  };
}
function S3(t) {
  t();
}
function yB(t, e) {
  return t.pipe(e);
}
function bB(t) {
  return !t.length || typeof t[t.length - 1] != "function" ? _3 : t.pop();
}
function gB() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  var n = bB(e);
  if (Array.isArray(e[0]) && (e = e[0]), e.length < 2)
    throw new dB("streams");
  var i, s = e.map(function(a, o) {
    var c = o < e.length - 1, f = o > 0;
    return pB(a, c, f, function(u) {
      i || (i = u), u && s.forEach(S3), !c && (s.forEach(S3), n(i));
    });
  });
  return e.reduce(yB);
}
var xA = gB;
(function(t, e) {
  e = t.exports = B2(), e.Stream = e, e.Readable = e, e.Writable = P2(), e.Duplex = Sc(), e.Transform = M2, e.PassThrough = _A, e.finished = v0, e.pipeline = xA;
})(av, av.exports);
var AA = av.exports, hp = Lt.Buffer, IA = AA.Transform, mB = Kt;
function vB(t, e) {
  if (!hp.isBuffer(t) && typeof t != "string")
    throw new TypeError(e + " must be a string or a buffer");
}
function Io(t) {
  IA.call(this), this._block = hp.allocUnsafe(t), this._blockSize = t, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
}
mB(Io, IA);
Io.prototype._transform = function(t, e, r) {
  var n = null;
  try {
    this.update(t, e);
  } catch (i) {
    n = i;
  }
  r(n);
};
Io.prototype._flush = function(t) {
  var e = null;
  try {
    this.push(this.digest());
  } catch (r) {
    e = r;
  }
  t(e);
};
Io.prototype.update = function(t, e) {
  if (vB(t, "Data"), this._finalized)
    throw new Error("Digest already called");
  hp.isBuffer(t) || (t = hp.from(t, e));
  for (var r = this._block, n = 0; this._blockOffset + t.length - n >= this._blockSize; ) {
    for (var i = this._blockOffset; i < this._blockSize; )
      r[i++] = t[n++];
    this._update(), this._blockOffset = 0;
  }
  for (; n < t.length; )
    r[this._blockOffset++] = t[n++];
  for (var s = 0, a = t.length * 8; a > 0; ++s)
    this._length[s] += a, a = this._length[s] / 4294967296 | 0, a > 0 && (this._length[s] -= 4294967296 * a);
  return this;
};
Io.prototype._update = function() {
  throw new Error("_update is not implemented");
};
Io.prototype.digest = function(t) {
  if (this._finalized)
    throw new Error("Digest already called");
  this._finalized = !0;
  var e = this._digest();
  t !== void 0 && (e = e.toString(t)), this._block.fill(0), this._blockOffset = 0;
  for (var r = 0; r < 4; ++r)
    this._length[r] = 0;
  return e;
};
Io.prototype._digest = function() {
  throw new Error("_digest is not implemented");
};
var TA = Io, wB = Kt, kA = TA, _B = Lt.Buffer, SB = new Array(16);
function S0() {
  kA.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
}
wB(S0, kA);
S0.prototype._update = function() {
  for (var t = SB, e = 0; e < 16; ++e)
    t[e] = this._block.readInt32LE(e * 4);
  var r = this._a, n = this._b, i = this._c, s = this._d;
  r = Jn(r, n, i, s, t[0], 3614090360, 7), s = Jn(s, r, n, i, t[1], 3905402710, 12), i = Jn(i, s, r, n, t[2], 606105819, 17), n = Jn(n, i, s, r, t[3], 3250441966, 22), r = Jn(r, n, i, s, t[4], 4118548399, 7), s = Jn(s, r, n, i, t[5], 1200080426, 12), i = Jn(i, s, r, n, t[6], 2821735955, 17), n = Jn(n, i, s, r, t[7], 4249261313, 22), r = Jn(r, n, i, s, t[8], 1770035416, 7), s = Jn(s, r, n, i, t[9], 2336552879, 12), i = Jn(i, s, r, n, t[10], 4294925233, 17), n = Jn(n, i, s, r, t[11], 2304563134, 22), r = Jn(r, n, i, s, t[12], 1804603682, 7), s = Jn(s, r, n, i, t[13], 4254626195, 12), i = Jn(i, s, r, n, t[14], 2792965006, 17), n = Jn(n, i, s, r, t[15], 1236535329, 22), r = Yn(r, n, i, s, t[1], 4129170786, 5), s = Yn(s, r, n, i, t[6], 3225465664, 9), i = Yn(i, s, r, n, t[11], 643717713, 14), n = Yn(n, i, s, r, t[0], 3921069994, 20), r = Yn(r, n, i, s, t[5], 3593408605, 5), s = Yn(s, r, n, i, t[10], 38016083, 9), i = Yn(i, s, r, n, t[15], 3634488961, 14), n = Yn(n, i, s, r, t[4], 3889429448, 20), r = Yn(r, n, i, s, t[9], 568446438, 5), s = Yn(s, r, n, i, t[14], 3275163606, 9), i = Yn(i, s, r, n, t[3], 4107603335, 14), n = Yn(n, i, s, r, t[8], 1163531501, 20), r = Yn(r, n, i, s, t[13], 2850285829, 5), s = Yn(s, r, n, i, t[2], 4243563512, 9), i = Yn(i, s, r, n, t[7], 1735328473, 14), n = Yn(n, i, s, r, t[12], 2368359562, 20), r = Qn(r, n, i, s, t[5], 4294588738, 4), s = Qn(s, r, n, i, t[8], 2272392833, 11), i = Qn(i, s, r, n, t[11], 1839030562, 16), n = Qn(n, i, s, r, t[14], 4259657740, 23), r = Qn(r, n, i, s, t[1], 2763975236, 4), s = Qn(s, r, n, i, t[4], 1272893353, 11), i = Qn(i, s, r, n, t[7], 4139469664, 16), n = Qn(n, i, s, r, t[10], 3200236656, 23), r = Qn(r, n, i, s, t[13], 681279174, 4), s = Qn(s, r, n, i, t[0], 3936430074, 11), i = Qn(i, s, r, n, t[3], 3572445317, 16), n = Qn(n, i, s, r, t[6], 76029189, 23), r = Qn(r, n, i, s, t[9], 3654602809, 4), s = Qn(s, r, n, i, t[12], 3873151461, 11), i = Qn(i, s, r, n, t[15], 530742520, 16), n = Qn(n, i, s, r, t[2], 3299628645, 23), r = Xn(r, n, i, s, t[0], 4096336452, 6), s = Xn(s, r, n, i, t[7], 1126891415, 10), i = Xn(i, s, r, n, t[14], 2878612391, 15), n = Xn(n, i, s, r, t[5], 4237533241, 21), r = Xn(r, n, i, s, t[12], 1700485571, 6), s = Xn(s, r, n, i, t[3], 2399980690, 10), i = Xn(i, s, r, n, t[10], 4293915773, 15), n = Xn(n, i, s, r, t[1], 2240044497, 21), r = Xn(r, n, i, s, t[8], 1873313359, 6), s = Xn(s, r, n, i, t[15], 4264355552, 10), i = Xn(i, s, r, n, t[6], 2734768916, 15), n = Xn(n, i, s, r, t[13], 1309151649, 21), r = Xn(r, n, i, s, t[4], 4149444226, 6), s = Xn(s, r, n, i, t[11], 3174756917, 10), i = Xn(i, s, r, n, t[2], 718787259, 15), n = Xn(n, i, s, r, t[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + s | 0;
};
S0.prototype._digest = function() {
  this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
  var t = _B.allocUnsafe(16);
  return t.writeInt32LE(this._a, 0), t.writeInt32LE(this._b, 4), t.writeInt32LE(this._c, 8), t.writeInt32LE(this._d, 12), t;
};
function E0(t, e) {
  return t << e | t >>> 32 - e;
}
function Jn(t, e, r, n, i, s, a) {
  return E0(t + (e & r | ~e & n) + i + s | 0, a) + e | 0;
}
function Yn(t, e, r, n, i, s, a) {
  return E0(t + (e & n | r & ~n) + i + s | 0, a) + e | 0;
}
function Qn(t, e, r, n, i, s, a) {
  return E0(t + (e ^ r ^ n) + i + s | 0, a) + e | 0;
}
function Xn(t, e, r, n, i, s, a) {
  return E0(t + (r ^ (e | ~n)) + i + s | 0, a) + e | 0;
}
var C2 = S0, x1 = Fe.Buffer, EB = Kt, RA = TA, xB = new Array(16), Nf = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], Uf = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], Lf = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], Df = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], Ff = [0, 1518500249, 1859775393, 2400959708, 2840853838], jf = [1352829926, 1548603684, 1836072691, 2053994217, 0];
function x0() {
  RA.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
}
EB(x0, RA);
x0.prototype._update = function() {
  for (var t = xB, e = 0; e < 16; ++e)
    t[e] = this._block.readInt32LE(e * 4);
  for (var r = this._a | 0, n = this._b | 0, i = this._c | 0, s = this._d | 0, a = this._e | 0, o = this._a | 0, c = this._b | 0, f = this._c | 0, u = this._d | 0, d = this._e | 0, l = 0; l < 80; l += 1) {
    var h, y;
    l < 16 ? (h = E3(r, n, i, s, a, t[Nf[l]], Ff[0], Lf[l]), y = T3(o, c, f, u, d, t[Uf[l]], jf[0], Df[l])) : l < 32 ? (h = x3(r, n, i, s, a, t[Nf[l]], Ff[1], Lf[l]), y = I3(o, c, f, u, d, t[Uf[l]], jf[1], Df[l])) : l < 48 ? (h = A3(r, n, i, s, a, t[Nf[l]], Ff[2], Lf[l]), y = A3(o, c, f, u, d, t[Uf[l]], jf[2], Df[l])) : l < 64 ? (h = I3(r, n, i, s, a, t[Nf[l]], Ff[3], Lf[l]), y = x3(o, c, f, u, d, t[Uf[l]], jf[3], Df[l])) : (h = T3(r, n, i, s, a, t[Nf[l]], Ff[4], Lf[l]), y = E3(o, c, f, u, d, t[Uf[l]], jf[4], Df[l])), r = a, a = s, s = Ec(i, 10), i = n, n = h, o = d, d = u, u = Ec(f, 10), f = c, c = y;
  }
  var p = this._b + i + u | 0;
  this._b = this._c + s + d | 0, this._c = this._d + a + o | 0, this._d = this._e + r + c | 0, this._e = this._a + n + f | 0, this._a = p;
};
x0.prototype._digest = function() {
  this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
  var t = x1.alloc ? x1.alloc(20) : new x1(20);
  return t.writeInt32LE(this._a, 0), t.writeInt32LE(this._b, 4), t.writeInt32LE(this._c, 8), t.writeInt32LE(this._d, 12), t.writeInt32LE(this._e, 16), t;
};
function Ec(t, e) {
  return t << e | t >>> 32 - e;
}
function E3(t, e, r, n, i, s, a, o) {
  return Ec(t + (e ^ r ^ n) + s + a | 0, o) + i | 0;
}
function x3(t, e, r, n, i, s, a, o) {
  return Ec(t + (e & r | ~e & n) + s + a | 0, o) + i | 0;
}
function A3(t, e, r, n, i, s, a, o) {
  return Ec(t + ((e | ~r) ^ n) + s + a | 0, o) + i | 0;
}
function I3(t, e, r, n, i, s, a, o) {
  return Ec(t + (e & n | r & ~n) + s + a | 0, o) + i | 0;
}
function T3(t, e, r, n, i, s, a, o) {
  return Ec(t + (e ^ (r | ~n)) + s + a | 0, o) + i | 0;
}
var A0 = x0, PA = { exports: {} }, OA = Lt.Buffer;
function I0(t, e) {
  this._block = OA.alloc(t), this._finalSize = e, this._blockSize = t, this._len = 0;
}
I0.prototype.update = function(t, e) {
  typeof t == "string" && (e = e || "utf8", t = OA.from(t, e));
  for (var r = this._block, n = this._blockSize, i = t.length, s = this._len, a = 0; a < i; ) {
    for (var o = s % n, c = Math.min(i - a, n - o), f = 0; f < c; f++)
      r[o + f] = t[a + f];
    s += c, a += c, s % n === 0 && this._update(r);
  }
  return this._len += i, this;
};
I0.prototype.digest = function(t) {
  var e = this._len % this._blockSize;
  this._block[e] = 128, this._block.fill(0, e + 1), e >= this._finalSize && (this._update(this._block), this._block.fill(0));
  var r = this._len * 8;
  if (r <= 4294967295)
    this._block.writeUInt32BE(r, this._blockSize - 4);
  else {
    var n = (r & 4294967295) >>> 0, i = (r - n) / 4294967296;
    this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
  }
  this._update(this._block);
  var s = this._hash();
  return t ? s.toString(t) : s;
};
I0.prototype._update = function() {
  throw new Error("_update must be implemented by subclass");
};
var pf = I0, AB = Kt, BA = pf, IB = Lt.Buffer, TB = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], kB = new Array(80);
function _l() {
  this.init(), this._w = kB, BA.call(this, 64, 56);
}
AB(_l, BA);
_l.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function RB(t) {
  return t << 5 | t >>> 27;
}
function PB(t) {
  return t << 30 | t >>> 2;
}
function OB(t, e, r, n) {
  return t === 0 ? e & r | ~e & n : t === 2 ? e & r | e & n | r & n : e ^ r ^ n;
}
_l.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, n = this._b | 0, i = this._c | 0, s = this._d | 0, a = this._e | 0, o = 0; o < 16; ++o)
    e[o] = t.readInt32BE(o * 4);
  for (; o < 80; ++o)
    e[o] = e[o - 3] ^ e[o - 8] ^ e[o - 14] ^ e[o - 16];
  for (var c = 0; c < 80; ++c) {
    var f = ~~(c / 20), u = RB(r) + OB(f, n, i, s) + a + e[c] + TB[f] | 0;
    a = s, s = i, i = PB(n), n = r, r = u;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = i + this._c | 0, this._d = s + this._d | 0, this._e = a + this._e | 0;
};
_l.prototype._hash = function() {
  var t = IB.allocUnsafe(20);
  return t.writeInt32BE(this._a | 0, 0), t.writeInt32BE(this._b | 0, 4), t.writeInt32BE(this._c | 0, 8), t.writeInt32BE(this._d | 0, 12), t.writeInt32BE(this._e | 0, 16), t;
};
var BB = _l, MB = Kt, MA = pf, CB = Lt.Buffer, NB = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], UB = new Array(80);
function Sl() {
  this.init(), this._w = UB, MA.call(this, 64, 56);
}
MB(Sl, MA);
Sl.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function LB(t) {
  return t << 1 | t >>> 31;
}
function DB(t) {
  return t << 5 | t >>> 27;
}
function FB(t) {
  return t << 30 | t >>> 2;
}
function jB(t, e, r, n) {
  return t === 0 ? e & r | ~e & n : t === 2 ? e & r | e & n | r & n : e ^ r ^ n;
}
Sl.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, n = this._b | 0, i = this._c | 0, s = this._d | 0, a = this._e | 0, o = 0; o < 16; ++o)
    e[o] = t.readInt32BE(o * 4);
  for (; o < 80; ++o)
    e[o] = LB(e[o - 3] ^ e[o - 8] ^ e[o - 14] ^ e[o - 16]);
  for (var c = 0; c < 80; ++c) {
    var f = ~~(c / 20), u = DB(r) + jB(f, n, i, s) + a + e[c] + NB[f] | 0;
    a = s, s = i, i = FB(n), n = r, r = u;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = i + this._c | 0, this._d = s + this._d | 0, this._e = a + this._e | 0;
};
Sl.prototype._hash = function() {
  var t = CB.allocUnsafe(20);
  return t.writeInt32BE(this._a | 0, 0), t.writeInt32BE(this._b | 0, 4), t.writeInt32BE(this._c | 0, 8), t.writeInt32BE(this._d | 0, 12), t.writeInt32BE(this._e | 0, 16), t;
};
var $B = Sl, qB = Kt, CA = pf, WB = Lt.Buffer, zB = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
], KB = new Array(64);
function El() {
  this.init(), this._w = KB, CA.call(this, 64, 56);
}
qB(El, CA);
El.prototype.init = function() {
  return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
};
function VB(t, e, r) {
  return r ^ t & (e ^ r);
}
function HB(t, e, r) {
  return t & e | r & (t | e);
}
function GB(t) {
  return (t >>> 2 | t << 30) ^ (t >>> 13 | t << 19) ^ (t >>> 22 | t << 10);
}
function ZB(t) {
  return (t >>> 6 | t << 26) ^ (t >>> 11 | t << 21) ^ (t >>> 25 | t << 7);
}
function JB(t) {
  return (t >>> 7 | t << 25) ^ (t >>> 18 | t << 14) ^ t >>> 3;
}
function YB(t) {
  return (t >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10;
}
El.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, n = this._b | 0, i = this._c | 0, s = this._d | 0, a = this._e | 0, o = this._f | 0, c = this._g | 0, f = this._h | 0, u = 0; u < 16; ++u)
    e[u] = t.readInt32BE(u * 4);
  for (; u < 64; ++u)
    e[u] = YB(e[u - 2]) + e[u - 7] + JB(e[u - 15]) + e[u - 16] | 0;
  for (var d = 0; d < 64; ++d) {
    var l = f + ZB(a) + VB(a, o, c) + zB[d] + e[d] | 0, h = GB(r) + HB(r, n, i) | 0;
    f = c, c = o, o = a, a = s + l | 0, s = i, i = n, n = r, r = l + h | 0;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = i + this._c | 0, this._d = s + this._d | 0, this._e = a + this._e | 0, this._f = o + this._f | 0, this._g = c + this._g | 0, this._h = f + this._h | 0;
};
El.prototype._hash = function() {
  var t = WB.allocUnsafe(32);
  return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t.writeInt32BE(this._h, 28), t;
};
var NA = El, QB = Kt, XB = NA, eM = pf, tM = Lt.Buffer, rM = new Array(64);
function T0() {
  this.init(), this._w = rM, eM.call(this, 64, 56);
}
QB(T0, XB);
T0.prototype.init = function() {
  return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
};
T0.prototype._hash = function() {
  var t = tM.allocUnsafe(28);
  return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t;
};
var nM = T0, iM = Kt, UA = pf, sM = Lt.Buffer, k3 = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
], aM = new Array(160);
function xl() {
  this.init(), this._w = aM, UA.call(this, 128, 112);
}
iM(xl, UA);
xl.prototype.init = function() {
  return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
};
function R3(t, e, r) {
  return r ^ t & (e ^ r);
}
function P3(t, e, r) {
  return t & e | r & (t | e);
}
function O3(t, e) {
  return (t >>> 28 | e << 4) ^ (e >>> 2 | t << 30) ^ (e >>> 7 | t << 25);
}
function B3(t, e) {
  return (t >>> 14 | e << 18) ^ (t >>> 18 | e << 14) ^ (e >>> 9 | t << 23);
}
function oM(t, e) {
  return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ t >>> 7;
}
function cM(t, e) {
  return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ (t >>> 7 | e << 25);
}
function uM(t, e) {
  return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ t >>> 6;
}
function fM(t, e) {
  return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ (t >>> 6 | e << 26);
}
function Pn(t, e) {
  return t >>> 0 < e >>> 0 ? 1 : 0;
}
xl.prototype._update = function(t) {
  for (var e = this._w, r = this._ah | 0, n = this._bh | 0, i = this._ch | 0, s = this._dh | 0, a = this._eh | 0, o = this._fh | 0, c = this._gh | 0, f = this._hh | 0, u = this._al | 0, d = this._bl | 0, l = this._cl | 0, h = this._dl | 0, y = this._el | 0, p = this._fl | 0, b = this._gl | 0, v = this._hl | 0, x = 0; x < 32; x += 2)
    e[x] = t.readInt32BE(x * 4), e[x + 1] = t.readInt32BE(x * 4 + 4);
  for (; x < 160; x += 2) {
    var I = e[x - 30], L = e[x - 15 * 2 + 1], P = oM(I, L), C = cM(L, I);
    I = e[x - 2 * 2], L = e[x - 2 * 2 + 1];
    var D = uM(I, L), F = fM(L, I), G = e[x - 7 * 2], re = e[x - 7 * 2 + 1], ie = e[x - 16 * 2], ee = e[x - 16 * 2 + 1], $ = C + re | 0, w = P + G + Pn($, C) | 0;
    $ = $ + F | 0, w = w + D + Pn($, F) | 0, $ = $ + ee | 0, w = w + ie + Pn($, ee) | 0, e[x] = w, e[x + 1] = $;
  }
  for (var E = 0; E < 160; E += 2) {
    w = e[E], $ = e[E + 1];
    var U = P3(r, n, i), W = P3(u, d, l), _ = O3(r, u), R = O3(u, r), N = B3(a, y), O = B3(y, a), g = k3[E], M = k3[E + 1], Y = R3(a, o, c), se = R3(y, p, b), V = v + O | 0, K = f + N + Pn(V, v) | 0;
    V = V + se | 0, K = K + Y + Pn(V, se) | 0, V = V + M | 0, K = K + g + Pn(V, M) | 0, V = V + $ | 0, K = K + w + Pn(V, $) | 0;
    var Z = R + W | 0, ne = _ + U + Pn(Z, R) | 0;
    f = c, v = b, c = o, b = p, o = a, p = y, y = h + V | 0, a = s + K + Pn(y, h) | 0, s = i, h = l, i = n, l = d, n = r, d = u, u = V + Z | 0, r = K + ne + Pn(u, V) | 0;
  }
  this._al = this._al + u | 0, this._bl = this._bl + d | 0, this._cl = this._cl + l | 0, this._dl = this._dl + h | 0, this._el = this._el + y | 0, this._fl = this._fl + p | 0, this._gl = this._gl + b | 0, this._hl = this._hl + v | 0, this._ah = this._ah + r + Pn(this._al, u) | 0, this._bh = this._bh + n + Pn(this._bl, d) | 0, this._ch = this._ch + i + Pn(this._cl, l) | 0, this._dh = this._dh + s + Pn(this._dl, h) | 0, this._eh = this._eh + a + Pn(this._el, y) | 0, this._fh = this._fh + o + Pn(this._fl, p) | 0, this._gh = this._gh + c + Pn(this._gl, b) | 0, this._hh = this._hh + f + Pn(this._hl, v) | 0;
};
xl.prototype._hash = function() {
  var t = sM.allocUnsafe(64);
  function e(r, n, i) {
    t.writeInt32BE(r, i), t.writeInt32BE(n, i + 4);
  }
  return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), e(this._gh, this._gl, 48), e(this._hh, this._hl, 56), t;
};
var LA = xl, dM = Kt, lM = LA, hM = pf, pM = Lt.Buffer, yM = new Array(160);
function k0() {
  this.init(), this._w = yM, hM.call(this, 128, 112);
}
dM(k0, lM);
k0.prototype.init = function() {
  return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
};
k0.prototype._hash = function() {
  var t = pM.allocUnsafe(48);
  function e(r, n, i) {
    t.writeInt32BE(r, i), t.writeInt32BE(n, i + 4);
  }
  return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), t;
};
var bM = k0, Lc = PA.exports = function(e) {
  e = e.toLowerCase();
  var r = Lc[e];
  if (!r)
    throw new Error(e + " is not supported (we accept pull requests)");
  return new r();
};
Lc.sha = BB;
Lc.sha1 = $B;
Lc.sha224 = nM;
Lc.sha256 = NA;
Lc.sha384 = bM;
Lc.sha512 = LA;
var Od = PA.exports, gM = as, N2 = k2.EventEmitter, mM = Kt;
mM(as, N2);
as.Readable = B2();
as.Writable = P2();
as.Duplex = Sc();
as.Transform = M2;
as.PassThrough = _A;
as.finished = v0;
as.pipeline = xA;
as.Stream = as;
function as() {
  N2.call(this);
}
as.prototype.pipe = function(t, e) {
  var r = this;
  function n(u) {
    t.writable && t.write(u) === !1 && r.pause && r.pause();
  }
  r.on("data", n);
  function i() {
    r.readable && r.resume && r.resume();
  }
  t.on("drain", i), !t._isStdio && (!e || e.end !== !1) && (r.on("end", a), r.on("close", o));
  var s = !1;
  function a() {
    s || (s = !0, t.end());
  }
  function o() {
    s || (s = !0, typeof t.destroy == "function" && t.destroy());
  }
  function c(u) {
    if (f(), N2.listenerCount(this, "error") === 0)
      throw u;
  }
  r.on("error", c), t.on("error", c);
  function f() {
    r.removeListener("data", n), t.removeListener("drain", i), r.removeListener("end", a), r.removeListener("close", o), r.removeListener("error", c), t.removeListener("error", c), r.removeListener("end", f), r.removeListener("close", f), t.removeListener("close", f);
  }
  return r.on("end", f), r.on("close", f), t.on("close", f), t.emit("pipe", r), t;
};
var DA = Lt.Buffer, FA = gM.Transform, vM = lp.StringDecoder, wM = Kt;
function ks(t) {
  FA.call(this), this.hashMode = typeof t == "string", this.hashMode ? this[t] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
}
wM(ks, FA);
ks.prototype.update = function(t, e, r) {
  typeof t == "string" && (t = DA.from(t, e));
  var n = this._update(t);
  return this.hashMode ? this : (r && (n = this._toString(n, r)), n);
};
ks.prototype.setAutoPadding = function() {
};
ks.prototype.getAuthTag = function() {
  throw new Error("trying to get auth tag in unsupported state");
};
ks.prototype.setAuthTag = function() {
  throw new Error("trying to set auth tag in unsupported state");
};
ks.prototype.setAAD = function() {
  throw new Error("trying to set aad in unsupported state");
};
ks.prototype._transform = function(t, e, r) {
  var n;
  try {
    this.hashMode ? this._update(t) : this.push(this._update(t));
  } catch (i) {
    n = i;
  } finally {
    r(n);
  }
};
ks.prototype._flush = function(t) {
  var e;
  try {
    this.push(this.__final());
  } catch (r) {
    e = r;
  }
  t(e);
};
ks.prototype._finalOrDigest = function(t) {
  var e = this.__final() || DA.alloc(0);
  return t && (e = this._toString(e, t, !0)), e;
};
ks.prototype._toString = function(t, e, r) {
  if (this._decoder || (this._decoder = new vM(e), this._encoding = e), this._encoding !== e)
    throw new Error("can't switch encodings");
  var n = this._decoder.write(t);
  return r && (n += this._decoder.end()), n;
};
var To = ks, A1, M3;
function Dc() {
  if (M3)
    return A1;
  M3 = 1;
  var t = Kt, e = C2, r = A0, n = Od, i = To;
  function s(a) {
    i.call(this, "digest"), this._hash = a;
  }
  return t(s, i), s.prototype._update = function(a) {
    this._hash.update(a);
  }, s.prototype._final = function() {
    return this._hash.digest();
  }, A1 = function(o) {
    return o = o.toLowerCase(), o === "md5" ? new e() : o === "rmd160" || o === "ripemd160" ? new r() : new s(n(o));
  }, A1;
}
var _M = Kt, Zo = Lt.Buffer, jA = To, SM = Zo.alloc(128), eu = 64;
function R0(t, e) {
  jA.call(this, "digest"), typeof e == "string" && (e = Zo.from(e)), this._alg = t, this._key = e, e.length > eu ? e = t(e) : e.length < eu && (e = Zo.concat([e, SM], eu));
  for (var r = this._ipad = Zo.allocUnsafe(eu), n = this._opad = Zo.allocUnsafe(eu), i = 0; i < eu; i++)
    r[i] = e[i] ^ 54, n[i] = e[i] ^ 92;
  this._hash = [r];
}
_M(R0, jA);
R0.prototype._update = function(t) {
  this._hash.push(t);
};
R0.prototype._final = function() {
  var t = this._alg(Zo.concat(this._hash));
  return this._alg(Zo.concat([this._opad, t]));
};
var EM = R0, xM = C2, $A = function(t) {
  return new xM().update(t).digest();
}, AM = Kt, IM = EM, qA = To, Xf = Lt.Buffer, TM = $A, cv = A0, uv = Od, kM = Xf.alloc(128);
function Bd(t, e) {
  qA.call(this, "digest"), typeof e == "string" && (e = Xf.from(e));
  var r = t === "sha512" || t === "sha384" ? 128 : 64;
  if (this._alg = t, this._key = e, e.length > r) {
    var n = t === "rmd160" ? new cv() : uv(t);
    e = n.update(e).digest();
  } else
    e.length < r && (e = Xf.concat([e, kM], r));
  for (var i = this._ipad = Xf.allocUnsafe(r), s = this._opad = Xf.allocUnsafe(r), a = 0; a < r; a++)
    i[a] = e[a] ^ 54, s[a] = e[a] ^ 92;
  this._hash = t === "rmd160" ? new cv() : uv(t), this._hash.update(i);
}
AM(Bd, qA);
Bd.prototype._update = function(t) {
  this._hash.update(t);
};
Bd.prototype._final = function() {
  var t = this._hash.digest(), e = this._alg === "rmd160" ? new cv() : uv(this._alg);
  return e.update(this._opad).update(t).digest();
};
var P0 = function(e, r) {
  return e = e.toLowerCase(), e === "rmd160" || e === "ripemd160" ? new Bd("rmd160", r) : e === "md5" ? new IM(TM, r) : new Bd(e, r);
};
const RM = /* @__PURE__ */ Ln(P0), PM = /* @__PURE__ */ dR({
  __proto__: null,
  default: RM
}, [P0]), OM = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, BM = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, MM = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, CM = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, NM = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, UM = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, LM = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, DM = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, FM = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, jM = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, $M = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, WA = {
  sha224WithRSAEncryption: OM,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption: BM,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption: MM,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption: CM,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: NM,
  sha224: UM,
  sha384: LM,
  sha512: DM,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA: FM,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA: jM,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption: $M,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var I1, C3;
function qM() {
  return C3 || (C3 = 1, I1 = WA), I1;
}
var nh = {}, T1, N3;
function zA() {
  if (N3)
    return T1;
  N3 = 1;
  var t = Math.pow(2, 30) - 1;
  return T1 = function(e, r) {
    if (typeof e != "number")
      throw new TypeError("Iterations not a number");
    if (e < 0)
      throw new TypeError("Bad iterations");
    if (typeof r != "number")
      throw new TypeError("Key length not a number");
    if (r < 0 || r > t || r !== r)
      throw new TypeError("Bad key length");
  }, T1;
}
var k1, U3;
function KA() {
  if (U3)
    return k1;
  U3 = 1;
  var t;
  if (Ne.process && Ne.process.browser)
    t = "utf-8";
  else if (Ne.process && Ne.process.version) {
    var e = parseInt(ut.version.split(".")[0].slice(1), 10);
    t = e >= 6 ? "utf-8" : "binary";
  } else
    t = "utf-8";
  return k1 = t, k1;
}
var R1, L3;
function VA() {
  if (L3)
    return R1;
  L3 = 1;
  var t = Lt.Buffer;
  return R1 = function(e, r, n) {
    if (t.isBuffer(e))
      return e;
    if (typeof e == "string")
      return t.from(e, r);
    if (ArrayBuffer.isView(e))
      return t.from(e.buffer);
    throw new TypeError(n + " must be a string, a Buffer, a typed array or a DataView");
  }, R1;
}
var P1, D3;
function HA() {
  if (D3)
    return P1;
  D3 = 1;
  var t = $A, e = A0, r = Od, n = Lt.Buffer, i = zA(), s = KA(), a = VA(), o = n.alloc(128), c = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function f(l, h, y) {
    var p = u(l), b = l === "sha512" || l === "sha384" ? 128 : 64;
    h.length > b ? h = p(h) : h.length < b && (h = n.concat([h, o], b));
    for (var v = n.allocUnsafe(b + c[l]), x = n.allocUnsafe(b + c[l]), I = 0; I < b; I++)
      v[I] = h[I] ^ 54, x[I] = h[I] ^ 92;
    var L = n.allocUnsafe(b + y + 4);
    v.copy(L, 0, 0, b), this.ipad1 = L, this.ipad2 = v, this.opad = x, this.alg = l, this.blocksize = b, this.hash = p, this.size = c[l];
  }
  f.prototype.run = function(l, h) {
    l.copy(h, this.blocksize);
    var y = this.hash(h);
    return y.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function u(l) {
    function h(p) {
      return r(l).update(p).digest();
    }
    function y(p) {
      return new e().update(p).digest();
    }
    return l === "rmd160" || l === "ripemd160" ? y : l === "md5" ? t : h;
  }
  function d(l, h, y, p, b) {
    i(y, p), l = a(l, s, "Password"), h = a(h, s, "Salt"), b = b || "sha1";
    var v = new f(b, l, h.length), x = n.allocUnsafe(p), I = n.allocUnsafe(h.length + 4);
    h.copy(I, 0, 0, h.length);
    for (var L = 0, P = c[b], C = Math.ceil(p / P), D = 1; D <= C; D++) {
      I.writeUInt32BE(D, h.length);
      for (var F = v.run(I, v.ipad1), G = F, re = 1; re < y; re++) {
        G = v.run(G, v.ipad2);
        for (var ie = 0; ie < P; ie++)
          F[ie] ^= G[ie];
      }
      F.copy(x, L), L += P;
    }
    return x;
  }
  return P1 = d, P1;
}
var O1, F3;
function WM() {
  if (F3)
    return O1;
  F3 = 1;
  var t = Lt.Buffer, e = zA(), r = KA(), n = HA(), i = VA(), s, a = Ne.crypto && Ne.crypto.subtle, o = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, c = [];
  function f(y) {
    if (Ne.process && !Ne.process.browser || !a || !a.importKey || !a.deriveBits)
      return Promise.resolve(!1);
    if (c[y] !== void 0)
      return c[y];
    s = s || t.alloc(8);
    var p = l(s, s, 10, 128, y).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return c[y] = p, p;
  }
  var u;
  function d() {
    return u || (Ne.process && Ne.process.nextTick ? u = Ne.process.nextTick : Ne.queueMicrotask ? u = Ne.queueMicrotask : Ne.setImmediate ? u = Ne.setImmediate : u = Ne.setTimeout, u);
  }
  function l(y, p, b, v, x) {
    return a.importKey(
      "raw",
      y,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(I) {
      return a.deriveBits({
        name: "PBKDF2",
        salt: p,
        iterations: b,
        hash: {
          name: x
        }
      }, I, v << 3);
    }).then(function(I) {
      return t.from(I);
    });
  }
  function h(y, p) {
    y.then(function(b) {
      d()(function() {
        p(null, b);
      });
    }, function(b) {
      d()(function() {
        p(b);
      });
    });
  }
  return O1 = function(y, p, b, v, x, I) {
    typeof x == "function" && (I = x, x = void 0), x = x || "sha1";
    var L = o[x.toLowerCase()];
    if (!L || typeof Ne.Promise != "function") {
      d()(function() {
        var P;
        try {
          P = n(y, p, b, v, x);
        } catch (C) {
          return I(C);
        }
        I(null, P);
      });
      return;
    }
    if (e(b, v), y = i(y, r, "Password"), p = i(p, r, "Salt"), typeof I != "function")
      throw new Error("No callback provided to pbkdf2");
    h(f(L).then(function(P) {
      return P ? l(y, p, b, v, L) : n(y, p, b, v, x);
    }), I);
  }, O1;
}
var j3;
function GA() {
  return j3 || (j3 = 1, nh.pbkdf2 = WM(), nh.pbkdf2Sync = HA()), nh;
}
var Vi = {}, Bo = {}, Ri = {}, $3;
function ZA() {
  if ($3)
    return Ri;
  $3 = 1, Ri.readUInt32BE = function(i, s) {
    var a = i[0 + s] << 24 | i[1 + s] << 16 | i[2 + s] << 8 | i[3 + s];
    return a >>> 0;
  }, Ri.writeUInt32BE = function(i, s, a) {
    i[0 + a] = s >>> 24, i[1 + a] = s >>> 16 & 255, i[2 + a] = s >>> 8 & 255, i[3 + a] = s & 255;
  }, Ri.ip = function(i, s, a, o) {
    for (var c = 0, f = 0, u = 6; u >= 0; u -= 2) {
      for (var d = 0; d <= 24; d += 8)
        c <<= 1, c |= s >>> d + u & 1;
      for (var d = 0; d <= 24; d += 8)
        c <<= 1, c |= i >>> d + u & 1;
    }
    for (var u = 6; u >= 0; u -= 2) {
      for (var d = 1; d <= 25; d += 8)
        f <<= 1, f |= s >>> d + u & 1;
      for (var d = 1; d <= 25; d += 8)
        f <<= 1, f |= i >>> d + u & 1;
    }
    a[o + 0] = c >>> 0, a[o + 1] = f >>> 0;
  }, Ri.rip = function(i, s, a, o) {
    for (var c = 0, f = 0, u = 0; u < 4; u++)
      for (var d = 24; d >= 0; d -= 8)
        c <<= 1, c |= s >>> d + u & 1, c <<= 1, c |= i >>> d + u & 1;
    for (var u = 4; u < 8; u++)
      for (var d = 24; d >= 0; d -= 8)
        f <<= 1, f |= s >>> d + u & 1, f <<= 1, f |= i >>> d + u & 1;
    a[o + 0] = c >>> 0, a[o + 1] = f >>> 0;
  }, Ri.pc1 = function(i, s, a, o) {
    for (var c = 0, f = 0, u = 7; u >= 5; u--) {
      for (var d = 0; d <= 24; d += 8)
        c <<= 1, c |= s >> d + u & 1;
      for (var d = 0; d <= 24; d += 8)
        c <<= 1, c |= i >> d + u & 1;
    }
    for (var d = 0; d <= 24; d += 8)
      c <<= 1, c |= s >> d + u & 1;
    for (var u = 1; u <= 3; u++) {
      for (var d = 0; d <= 24; d += 8)
        f <<= 1, f |= s >> d + u & 1;
      for (var d = 0; d <= 24; d += 8)
        f <<= 1, f |= i >> d + u & 1;
    }
    for (var d = 0; d <= 24; d += 8)
      f <<= 1, f |= i >> d + u & 1;
    a[o + 0] = c >>> 0, a[o + 1] = f >>> 0;
  }, Ri.r28shl = function(i, s) {
    return i << s & 268435455 | i >>> 28 - s;
  };
  var t = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  Ri.pc2 = function(i, s, a, o) {
    for (var c = 0, f = 0, u = t.length >>> 1, d = 0; d < u; d++)
      c <<= 1, c |= i >>> t[d] & 1;
    for (var d = u; d < t.length; d++)
      f <<= 1, f |= s >>> t[d] & 1;
    a[o + 0] = c >>> 0, a[o + 1] = f >>> 0;
  }, Ri.expand = function(i, s, a) {
    var o = 0, c = 0;
    o = (i & 1) << 5 | i >>> 27;
    for (var f = 23; f >= 15; f -= 4)
      o <<= 6, o |= i >>> f & 63;
    for (var f = 11; f >= 3; f -= 4)
      c |= i >>> f & 63, c <<= 6;
    c |= (i & 31) << 1 | i >>> 31, s[a + 0] = o >>> 0, s[a + 1] = c >>> 0;
  };
  var e = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  Ri.substitute = function(i, s) {
    for (var a = 0, o = 0; o < 4; o++) {
      var c = i >>> 18 - o * 6 & 63, f = e[o * 64 + c];
      a <<= 4, a |= f;
    }
    for (var o = 0; o < 4; o++) {
      var c = s >>> 18 - o * 6 & 63, f = e[4 * 64 + o * 64 + c];
      a <<= 4, a |= f;
    }
    return a >>> 0;
  };
  var r = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return Ri.permute = function(i) {
    for (var s = 0, a = 0; a < r.length; a++)
      s <<= 1, s |= i >>> r[a] & 1;
    return s >>> 0;
  }, Ri.padSplit = function(i, s, a) {
    for (var o = i.toString(2); o.length < s; )
      o = "0" + o;
    for (var c = [], f = 0; f < s; f += a)
      c.push(o.slice(f, f + a));
    return c.join(" ");
  }, Ri;
}
var hr = JA;
function JA(t, e) {
  if (!t)
    throw new Error(e || "Assertion failed");
}
JA.equal = function(e, r, n) {
  if (e != r)
    throw new Error(n || "Assertion failed: " + e + " != " + r);
};
var B1, q3;
function U2() {
  if (q3)
    return B1;
  q3 = 1;
  var t = hr;
  function e(r) {
    this.options = r, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = r.padding !== !1;
  }
  return B1 = e, e.prototype._init = function() {
  }, e.prototype.update = function(n) {
    return n.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(n) : this._updateEncrypt(n);
  }, e.prototype._buffer = function(n, i) {
    for (var s = Math.min(this.buffer.length - this.bufferOff, n.length - i), a = 0; a < s; a++)
      this.buffer[this.bufferOff + a] = n[i + a];
    return this.bufferOff += s, s;
  }, e.prototype._flushBuffer = function(n, i) {
    return this._update(this.buffer, 0, n, i), this.bufferOff = 0, this.blockSize;
  }, e.prototype._updateEncrypt = function(n) {
    var i = 0, s = 0, a = (this.bufferOff + n.length) / this.blockSize | 0, o = new Array(a * this.blockSize);
    this.bufferOff !== 0 && (i += this._buffer(n, i), this.bufferOff === this.buffer.length && (s += this._flushBuffer(o, s)));
    for (var c = n.length - (n.length - i) % this.blockSize; i < c; i += this.blockSize)
      this._update(n, i, o, s), s += this.blockSize;
    for (; i < n.length; i++, this.bufferOff++)
      this.buffer[this.bufferOff] = n[i];
    return o;
  }, e.prototype._updateDecrypt = function(n) {
    for (var i = 0, s = 0, a = Math.ceil((this.bufferOff + n.length) / this.blockSize) - 1, o = new Array(a * this.blockSize); a > 0; a--)
      i += this._buffer(n, i), s += this._flushBuffer(o, s);
    return i += this._buffer(n, i), o;
  }, e.prototype.final = function(n) {
    var i;
    n && (i = this.update(n));
    var s;
    return this.type === "encrypt" ? s = this._finalEncrypt() : s = this._finalDecrypt(), i ? i.concat(s) : s;
  }, e.prototype._pad = function(n, i) {
    if (i === 0)
      return !1;
    for (; i < n.length; )
      n[i++] = 0;
    return !0;
  }, e.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var n = new Array(this.blockSize);
    return this._update(this.buffer, 0, n, 0), n;
  }, e.prototype._unpad = function(n) {
    return n;
  }, e.prototype._finalDecrypt = function() {
    t.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var n = new Array(this.blockSize);
    return this._flushBuffer(n, 0), this._unpad(n);
  }, B1;
}
var M1, W3;
function YA() {
  if (W3)
    return M1;
  W3 = 1;
  var t = hr, e = Kt, r = ZA(), n = U2();
  function i() {
    this.tmp = new Array(2), this.keys = null;
  }
  function s(o) {
    n.call(this, o);
    var c = new i();
    this._desState = c, this.deriveKeys(c, o.key);
  }
  e(s, n), M1 = s, s.create = function(c) {
    return new s(c);
  };
  var a = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return s.prototype.deriveKeys = function(c, f) {
    c.keys = new Array(16 * 2), t.equal(f.length, this.blockSize, "Invalid key length");
    var u = r.readUInt32BE(f, 0), d = r.readUInt32BE(f, 4);
    r.pc1(u, d, c.tmp, 0), u = c.tmp[0], d = c.tmp[1];
    for (var l = 0; l < c.keys.length; l += 2) {
      var h = a[l >>> 1];
      u = r.r28shl(u, h), d = r.r28shl(d, h), r.pc2(u, d, c.keys, l);
    }
  }, s.prototype._update = function(c, f, u, d) {
    var l = this._desState, h = r.readUInt32BE(c, f), y = r.readUInt32BE(c, f + 4);
    r.ip(h, y, l.tmp, 0), h = l.tmp[0], y = l.tmp[1], this.type === "encrypt" ? this._encrypt(l, h, y, l.tmp, 0) : this._decrypt(l, h, y, l.tmp, 0), h = l.tmp[0], y = l.tmp[1], r.writeUInt32BE(u, h, d), r.writeUInt32BE(u, y, d + 4);
  }, s.prototype._pad = function(c, f) {
    if (this.padding === !1)
      return !1;
    for (var u = c.length - f, d = f; d < c.length; d++)
      c[d] = u;
    return !0;
  }, s.prototype._unpad = function(c) {
    if (this.padding === !1)
      return c;
    for (var f = c[c.length - 1], u = c.length - f; u < c.length; u++)
      t.equal(c[u], f);
    return c.slice(0, c.length - f);
  }, s.prototype._encrypt = function(c, f, u, d, l) {
    for (var h = f, y = u, p = 0; p < c.keys.length; p += 2) {
      var b = c.keys[p], v = c.keys[p + 1];
      r.expand(y, c.tmp, 0), b ^= c.tmp[0], v ^= c.tmp[1];
      var x = r.substitute(b, v), I = r.permute(x), L = y;
      y = (h ^ I) >>> 0, h = L;
    }
    r.rip(y, h, d, l);
  }, s.prototype._decrypt = function(c, f, u, d, l) {
    for (var h = u, y = f, p = c.keys.length - 2; p >= 0; p -= 2) {
      var b = c.keys[p], v = c.keys[p + 1];
      r.expand(h, c.tmp, 0), b ^= c.tmp[0], v ^= c.tmp[1];
      var x = r.substitute(b, v), I = r.permute(x), L = h;
      h = (y ^ I) >>> 0, y = L;
    }
    r.rip(h, y, d, l);
  }, M1;
}
var C1 = {}, z3;
function zM() {
  if (z3)
    return C1;
  z3 = 1;
  var t = hr, e = Kt, r = {};
  function n(s) {
    t.equal(s.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var a = 0; a < this.iv.length; a++)
      this.iv[a] = s[a];
  }
  function i(s) {
    function a(u) {
      s.call(this, u), this._cbcInit();
    }
    e(a, s);
    for (var o = Object.keys(r), c = 0; c < o.length; c++) {
      var f = o[c];
      a.prototype[f] = r[f];
    }
    return a.create = function(d) {
      return new a(d);
    }, a;
  }
  return C1.instantiate = i, r._cbcInit = function() {
    var a = new n(this.options.iv);
    this._cbcState = a;
  }, r._update = function(a, o, c, f) {
    var u = this._cbcState, d = this.constructor.super_.prototype, l = u.iv;
    if (this.type === "encrypt") {
      for (var h = 0; h < this.blockSize; h++)
        l[h] ^= a[o + h];
      d._update.call(this, l, 0, c, f);
      for (var h = 0; h < this.blockSize; h++)
        l[h] = c[f + h];
    } else {
      d._update.call(this, a, o, c, f);
      for (var h = 0; h < this.blockSize; h++)
        c[f + h] ^= l[h];
      for (var h = 0; h < this.blockSize; h++)
        l[h] = a[o + h];
    }
  }, C1;
}
var N1, K3;
function KM() {
  if (K3)
    return N1;
  K3 = 1;
  var t = hr, e = Kt, r = U2(), n = YA();
  function i(a, o) {
    t.equal(o.length, 24, "Invalid key length");
    var c = o.slice(0, 8), f = o.slice(8, 16), u = o.slice(16, 24);
    a === "encrypt" ? this.ciphers = [
      n.create({ type: "encrypt", key: c }),
      n.create({ type: "decrypt", key: f }),
      n.create({ type: "encrypt", key: u })
    ] : this.ciphers = [
      n.create({ type: "decrypt", key: u }),
      n.create({ type: "encrypt", key: f }),
      n.create({ type: "decrypt", key: c })
    ];
  }
  function s(a) {
    r.call(this, a);
    var o = new i(this.type, this.options.key);
    this._edeState = o;
  }
  return e(s, r), N1 = s, s.create = function(o) {
    return new s(o);
  }, s.prototype._update = function(o, c, f, u) {
    var d = this._edeState;
    d.ciphers[0]._update(o, c, f, u), d.ciphers[1]._update(f, u, f, u), d.ciphers[2]._update(f, u, f, u);
  }, s.prototype._pad = n.prototype._pad, s.prototype._unpad = n.prototype._unpad, N1;
}
var V3;
function VM() {
  return V3 || (V3 = 1, Bo.utils = ZA(), Bo.Cipher = U2(), Bo.DES = YA(), Bo.CBC = zM(), Bo.EDE = KM()), Bo;
}
var U1, H3;
function HM() {
  if (H3)
    return U1;
  H3 = 1;
  var t = To, e = VM(), r = Kt, n = Lt.Buffer, i = {
    "des-ede3-cbc": e.CBC.instantiate(e.EDE),
    "des-ede3": e.EDE,
    "des-ede-cbc": e.CBC.instantiate(e.EDE),
    "des-ede": e.EDE,
    "des-cbc": e.CBC.instantiate(e.DES),
    "des-ecb": e.DES
  };
  i.des = i["des-cbc"], i.des3 = i["des-ede3-cbc"], U1 = s, r(s, t);
  function s(a) {
    t.call(this);
    var o = a.mode.toLowerCase(), c = i[o], f;
    a.decrypt ? f = "decrypt" : f = "encrypt";
    var u = a.key;
    n.isBuffer(u) || (u = n.from(u)), (o === "des-ede" || o === "des-ede-cbc") && (u = n.concat([u, u.slice(0, 8)]));
    var d = a.iv;
    n.isBuffer(d) || (d = n.from(d)), this._des = c.create({
      key: u,
      iv: d,
      type: f
    });
  }
  return s.prototype._update = function(a) {
    return n.from(this._des.update(a));
  }, s.prototype._final = function() {
    return n.from(this._des.final());
  }, U1;
}
var Hi = {}, ih = {}, sh = {}, G3;
function GM() {
  return G3 || (G3 = 1, sh.encrypt = function(t, e) {
    return t._cipher.encryptBlock(e);
  }, sh.decrypt = function(t, e) {
    return t._cipher.decryptBlock(e);
  }), sh;
}
var ah = {}, L1, Z3;
function Al() {
  return Z3 || (Z3 = 1, L1 = function(e, r) {
    for (var n = Math.min(e.length, r.length), i = new ve(n), s = 0; s < n; ++s)
      i[s] = e[s] ^ r[s];
    return i;
  }), L1;
}
var J3;
function ZM() {
  if (J3)
    return ah;
  J3 = 1;
  var t = Al();
  return ah.encrypt = function(e, r) {
    var n = t(r, e._prev);
    return e._prev = e._cipher.encryptBlock(n), e._prev;
  }, ah.decrypt = function(e, r) {
    var n = e._prev;
    e._prev = r;
    var i = e._cipher.decryptBlock(r);
    return t(i, n);
  }, ah;
}
var D1 = {}, Y3;
function JM() {
  if (Y3)
    return D1;
  Y3 = 1;
  var t = Lt.Buffer, e = Al();
  function r(n, i, s) {
    var a = i.length, o = e(i, n._cache);
    return n._cache = n._cache.slice(a), n._prev = t.concat([n._prev, s ? i : o]), o;
  }
  return D1.encrypt = function(n, i, s) {
    for (var a = t.allocUnsafe(0), o; i.length; )
      if (n._cache.length === 0 && (n._cache = n._cipher.encryptBlock(n._prev), n._prev = t.allocUnsafe(0)), n._cache.length <= i.length)
        o = n._cache.length, a = t.concat([a, r(n, i.slice(0, o), s)]), i = i.slice(o);
      else {
        a = t.concat([a, r(n, i, s)]);
        break;
      }
    return a;
  }, D1;
}
var F1 = {}, Q3;
function YM() {
  if (Q3)
    return F1;
  Q3 = 1;
  var t = Lt.Buffer;
  function e(r, n, i) {
    var s = r._cipher.encryptBlock(r._prev), a = s[0] ^ n;
    return r._prev = t.concat([
      r._prev.slice(1),
      t.from([i ? n : a])
    ]), a;
  }
  return F1.encrypt = function(r, n, i) {
    for (var s = n.length, a = t.allocUnsafe(s), o = -1; ++o < s; )
      a[o] = e(r, n[o], i);
    return a;
  }, F1;
}
var j1 = {}, X3;
function QM() {
  if (X3)
    return j1;
  X3 = 1;
  var t = Lt.Buffer;
  function e(n, i, s) {
    for (var a, o = -1, c = 8, f = 0, u, d; ++o < c; )
      a = n._cipher.encryptBlock(n._prev), u = i & 1 << 7 - o ? 128 : 0, d = a[0] ^ u, f += (d & 128) >> o % 8, n._prev = r(n._prev, s ? u : d);
    return f;
  }
  function r(n, i) {
    var s = n.length, a = -1, o = t.allocUnsafe(n.length);
    for (n = t.concat([n, t.from([i])]); ++a < s; )
      o[a] = n[a] << 1 | n[a + 1] >> 7;
    return o;
  }
  return j1.encrypt = function(n, i, s) {
    for (var a = i.length, o = t.allocUnsafe(a), c = -1; ++c < a; )
      o[c] = e(n, i[c], s);
    return o;
  }, j1;
}
var $1 = {}, eS;
function XM() {
  if (eS)
    return $1;
  eS = 1;
  var t = Al();
  function e(r) {
    return r._prev = r._cipher.encryptBlock(r._prev), r._prev;
  }
  return $1.encrypt = function(r, n) {
    for (; r._cache.length < n.length; )
      r._cache = ve.concat([r._cache, e(r)]);
    var i = r._cache.slice(0, n.length);
    return r._cache = r._cache.slice(n.length), t(n, i);
  }, $1;
}
var q1 = {}, W1, tS;
function QA() {
  if (tS)
    return W1;
  tS = 1;
  function t(e) {
    for (var r = e.length, n; r--; )
      if (n = e.readUInt8(r), n === 255)
        e.writeUInt8(0, r);
      else {
        n++, e.writeUInt8(n, r);
        break;
      }
  }
  return W1 = t, W1;
}
var rS;
function nS() {
  if (rS)
    return q1;
  rS = 1;
  var t = Al(), e = Lt.Buffer, r = QA();
  function n(s) {
    var a = s._cipher.encryptBlockRaw(s._prev);
    return r(s._prev), a;
  }
  var i = 16;
  return q1.encrypt = function(s, a) {
    var o = Math.ceil(a.length / i), c = s._cache.length;
    s._cache = e.concat([
      s._cache,
      e.allocUnsafe(o * i)
    ]);
    for (var f = 0; f < o; f++) {
      var u = n(s), d = c + f * i;
      s._cache.writeUInt32BE(u[0], d + 0), s._cache.writeUInt32BE(u[1], d + 4), s._cache.writeUInt32BE(u[2], d + 8), s._cache.writeUInt32BE(u[3], d + 12);
    }
    var l = s._cache.slice(0, a.length);
    return s._cache = s._cache.slice(a.length), t(a, l);
  }, q1;
}
const eC = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, tC = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, rC = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, XA = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128: eC,
  aes192: tC,
  aes256: rC,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var z1, iS;
function L2() {
  if (iS)
    return z1;
  iS = 1;
  var t = {
    ECB: GM(),
    CBC: ZM(),
    CFB: JM(),
    CFB8: YM(),
    CFB1: QM(),
    OFB: XM(),
    CTR: nS(),
    GCM: nS()
  }, e = XA;
  for (var r in e)
    e[r].module = t[e[r].mode];
  return z1 = e, z1;
}
var K1 = {}, sS;
function O0() {
  if (sS)
    return K1;
  sS = 1;
  var t = Lt.Buffer;
  function e(o) {
    t.isBuffer(o) || (o = t.from(o));
    for (var c = o.length / 4 | 0, f = new Array(c), u = 0; u < c; u++)
      f[u] = o.readUInt32BE(u * 4);
    return f;
  }
  function r(o) {
    for (var c = 0; c < o.length; o++)
      o[c] = 0;
  }
  function n(o, c, f, u, d) {
    for (var l = f[0], h = f[1], y = f[2], p = f[3], b = o[0] ^ c[0], v = o[1] ^ c[1], x = o[2] ^ c[2], I = o[3] ^ c[3], L, P, C, D, F = 4, G = 1; G < d; G++)
      L = l[b >>> 24] ^ h[v >>> 16 & 255] ^ y[x >>> 8 & 255] ^ p[I & 255] ^ c[F++], P = l[v >>> 24] ^ h[x >>> 16 & 255] ^ y[I >>> 8 & 255] ^ p[b & 255] ^ c[F++], C = l[x >>> 24] ^ h[I >>> 16 & 255] ^ y[b >>> 8 & 255] ^ p[v & 255] ^ c[F++], D = l[I >>> 24] ^ h[b >>> 16 & 255] ^ y[v >>> 8 & 255] ^ p[x & 255] ^ c[F++], b = L, v = P, x = C, I = D;
    return L = (u[b >>> 24] << 24 | u[v >>> 16 & 255] << 16 | u[x >>> 8 & 255] << 8 | u[I & 255]) ^ c[F++], P = (u[v >>> 24] << 24 | u[x >>> 16 & 255] << 16 | u[I >>> 8 & 255] << 8 | u[b & 255]) ^ c[F++], C = (u[x >>> 24] << 24 | u[I >>> 16 & 255] << 16 | u[b >>> 8 & 255] << 8 | u[v & 255]) ^ c[F++], D = (u[I >>> 24] << 24 | u[b >>> 16 & 255] << 16 | u[v >>> 8 & 255] << 8 | u[x & 255]) ^ c[F++], L = L >>> 0, P = P >>> 0, C = C >>> 0, D = D >>> 0, [L, P, C, D];
  }
  var i = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], s = function() {
    for (var o = new Array(256), c = 0; c < 256; c++)
      c < 128 ? o[c] = c << 1 : o[c] = c << 1 ^ 283;
    for (var f = [], u = [], d = [[], [], [], []], l = [[], [], [], []], h = 0, y = 0, p = 0; p < 256; ++p) {
      var b = y ^ y << 1 ^ y << 2 ^ y << 3 ^ y << 4;
      b = b >>> 8 ^ b & 255 ^ 99, f[h] = b, u[b] = h;
      var v = o[h], x = o[v], I = o[x], L = o[b] * 257 ^ b * 16843008;
      d[0][h] = L << 24 | L >>> 8, d[1][h] = L << 16 | L >>> 16, d[2][h] = L << 8 | L >>> 24, d[3][h] = L, L = I * 16843009 ^ x * 65537 ^ v * 257 ^ h * 16843008, l[0][b] = L << 24 | L >>> 8, l[1][b] = L << 16 | L >>> 16, l[2][b] = L << 8 | L >>> 24, l[3][b] = L, h === 0 ? h = y = 1 : (h = v ^ o[o[o[I ^ v]]], y ^= o[o[y]]);
    }
    return {
      SBOX: f,
      INV_SBOX: u,
      SUB_MIX: d,
      INV_SUB_MIX: l
    };
  }();
  function a(o) {
    this._key = e(o), this._reset();
  }
  return a.blockSize = 4 * 4, a.keySize = 256 / 8, a.prototype.blockSize = a.blockSize, a.prototype.keySize = a.keySize, a.prototype._reset = function() {
    for (var o = this._key, c = o.length, f = c + 6, u = (f + 1) * 4, d = [], l = 0; l < c; l++)
      d[l] = o[l];
    for (l = c; l < u; l++) {
      var h = d[l - 1];
      l % c === 0 ? (h = h << 8 | h >>> 24, h = s.SBOX[h >>> 24] << 24 | s.SBOX[h >>> 16 & 255] << 16 | s.SBOX[h >>> 8 & 255] << 8 | s.SBOX[h & 255], h ^= i[l / c | 0] << 24) : c > 6 && l % c === 4 && (h = s.SBOX[h >>> 24] << 24 | s.SBOX[h >>> 16 & 255] << 16 | s.SBOX[h >>> 8 & 255] << 8 | s.SBOX[h & 255]), d[l] = d[l - c] ^ h;
    }
    for (var y = [], p = 0; p < u; p++) {
      var b = u - p, v = d[b - (p % 4 ? 0 : 4)];
      p < 4 || b <= 4 ? y[p] = v : y[p] = s.INV_SUB_MIX[0][s.SBOX[v >>> 24]] ^ s.INV_SUB_MIX[1][s.SBOX[v >>> 16 & 255]] ^ s.INV_SUB_MIX[2][s.SBOX[v >>> 8 & 255]] ^ s.INV_SUB_MIX[3][s.SBOX[v & 255]];
    }
    this._nRounds = f, this._keySchedule = d, this._invKeySchedule = y;
  }, a.prototype.encryptBlockRaw = function(o) {
    return o = e(o), n(o, this._keySchedule, s.SUB_MIX, s.SBOX, this._nRounds);
  }, a.prototype.encryptBlock = function(o) {
    var c = this.encryptBlockRaw(o), f = t.allocUnsafe(16);
    return f.writeUInt32BE(c[0], 0), f.writeUInt32BE(c[1], 4), f.writeUInt32BE(c[2], 8), f.writeUInt32BE(c[3], 12), f;
  }, a.prototype.decryptBlock = function(o) {
    o = e(o);
    var c = o[1];
    o[1] = o[3], o[3] = c;
    var f = n(o, this._invKeySchedule, s.INV_SUB_MIX, s.INV_SBOX, this._nRounds), u = t.allocUnsafe(16);
    return u.writeUInt32BE(f[0], 0), u.writeUInt32BE(f[3], 4), u.writeUInt32BE(f[2], 8), u.writeUInt32BE(f[1], 12), u;
  }, a.prototype.scrub = function() {
    r(this._keySchedule), r(this._invKeySchedule), r(this._key);
  }, K1.AES = a, K1;
}
var V1, aS;
function nC() {
  if (aS)
    return V1;
  aS = 1;
  var t = Lt.Buffer, e = t.alloc(16, 0);
  function r(s) {
    return [
      s.readUInt32BE(0),
      s.readUInt32BE(4),
      s.readUInt32BE(8),
      s.readUInt32BE(12)
    ];
  }
  function n(s) {
    var a = t.allocUnsafe(16);
    return a.writeUInt32BE(s[0] >>> 0, 0), a.writeUInt32BE(s[1] >>> 0, 4), a.writeUInt32BE(s[2] >>> 0, 8), a.writeUInt32BE(s[3] >>> 0, 12), a;
  }
  function i(s) {
    this.h = s, this.state = t.alloc(16, 0), this.cache = t.allocUnsafe(0);
  }
  return i.prototype.ghash = function(s) {
    for (var a = -1; ++a < s.length; )
      this.state[a] ^= s[a];
    this._multiply();
  }, i.prototype._multiply = function() {
    for (var s = r(this.h), a = [0, 0, 0, 0], o, c, f, u = -1; ++u < 128; ) {
      for (c = (this.state[~~(u / 8)] & 1 << 7 - u % 8) !== 0, c && (a[0] ^= s[0], a[1] ^= s[1], a[2] ^= s[2], a[3] ^= s[3]), f = (s[3] & 1) !== 0, o = 3; o > 0; o--)
        s[o] = s[o] >>> 1 | (s[o - 1] & 1) << 31;
      s[0] = s[0] >>> 1, f && (s[0] = s[0] ^ 225 << 24);
    }
    this.state = n(a);
  }, i.prototype.update = function(s) {
    this.cache = t.concat([this.cache, s]);
    for (var a; this.cache.length >= 16; )
      a = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(a);
  }, i.prototype.final = function(s, a) {
    return this.cache.length && this.ghash(t.concat([this.cache, e], 16)), this.ghash(n([0, s, 0, a])), this.state;
  }, V1 = i, V1;
}
var H1, oS;
function e5() {
  if (oS)
    return H1;
  oS = 1;
  var t = O0(), e = Lt.Buffer, r = To, n = Kt, i = nC(), s = Al(), a = QA();
  function o(u, d) {
    var l = 0;
    u.length !== d.length && l++;
    for (var h = Math.min(u.length, d.length), y = 0; y < h; ++y)
      l += u[y] ^ d[y];
    return l;
  }
  function c(u, d, l) {
    if (d.length === 12)
      return u._finID = e.concat([d, e.from([0, 0, 0, 1])]), e.concat([d, e.from([0, 0, 0, 2])]);
    var h = new i(l), y = d.length, p = y % 16;
    h.update(d), p && (p = 16 - p, h.update(e.alloc(p, 0))), h.update(e.alloc(8, 0));
    var b = y * 8, v = e.alloc(8);
    v.writeUIntBE(b, 0, 8), h.update(v), u._finID = h.state;
    var x = e.from(u._finID);
    return a(x), x;
  }
  function f(u, d, l, h) {
    r.call(this);
    var y = e.alloc(4, 0);
    this._cipher = new t.AES(d);
    var p = this._cipher.encryptBlock(y);
    this._ghash = new i(p), l = c(this, l, p), this._prev = e.from(l), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = h, this._alen = 0, this._len = 0, this._mode = u, this._authTag = null, this._called = !1;
  }
  return n(f, r), f.prototype._update = function(u) {
    if (!this._called && this._alen) {
      var d = 16 - this._alen % 16;
      d < 16 && (d = e.alloc(d, 0), this._ghash.update(d));
    }
    this._called = !0;
    var l = this._mode.encrypt(this, u);
    return this._decrypt ? this._ghash.update(u) : this._ghash.update(l), this._len += u.length, l;
  }, f.prototype._final = function() {
    if (this._decrypt && !this._authTag)
      throw new Error("Unsupported state or unable to authenticate data");
    var u = s(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && o(u, this._authTag))
      throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = u, this._cipher.scrub();
  }, f.prototype.getAuthTag = function() {
    if (this._decrypt || !e.isBuffer(this._authTag))
      throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, f.prototype.setAuthTag = function(d) {
    if (!this._decrypt)
      throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = d;
  }, f.prototype.setAAD = function(d) {
    if (this._called)
      throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(d), this._alen += d.length;
  }, H1 = f, H1;
}
var G1, cS;
function t5() {
  if (cS)
    return G1;
  cS = 1;
  var t = O0(), e = Lt.Buffer, r = To, n = Kt;
  function i(s, a, o, c) {
    r.call(this), this._cipher = new t.AES(a), this._prev = e.from(o), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = c, this._mode = s;
  }
  return n(i, r), i.prototype._update = function(s) {
    return this._mode.encrypt(this, s, this._decrypt);
  }, i.prototype._final = function() {
    this._cipher.scrub();
  }, G1 = i, G1;
}
var Z1, uS;
function B0() {
  if (uS)
    return Z1;
  uS = 1;
  var t = Lt.Buffer, e = C2;
  function r(n, i, s, a) {
    if (t.isBuffer(n) || (n = t.from(n, "binary")), i && (t.isBuffer(i) || (i = t.from(i, "binary")), i.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var o = s / 8, c = t.alloc(o), f = t.alloc(a || 0), u = t.alloc(0); o > 0 || a > 0; ) {
      var d = new e();
      d.update(u), d.update(n), i && d.update(i), u = d.digest();
      var l = 0;
      if (o > 0) {
        var h = c.length - o;
        l = Math.min(o, u.length), u.copy(c, h, 0, l), o -= l;
      }
      if (l < u.length && a > 0) {
        var y = f.length - a, p = Math.min(a, u.length - l);
        u.copy(f, y, l, l + p), a -= p;
      }
    }
    return u.fill(0), { key: c, iv: f };
  }
  return Z1 = r, Z1;
}
var fS;
function iC() {
  if (fS)
    return ih;
  fS = 1;
  var t = L2(), e = e5(), r = Lt.Buffer, n = t5(), i = To, s = O0(), a = B0(), o = Kt;
  function c(h, y, p) {
    i.call(this), this._cache = new u(), this._cipher = new s.AES(y), this._prev = r.from(p), this._mode = h, this._autopadding = !0;
  }
  o(c, i), c.prototype._update = function(h) {
    this._cache.add(h);
    for (var y, p, b = []; y = this._cache.get(); )
      p = this._mode.encrypt(this, y), b.push(p);
    return r.concat(b);
  };
  var f = r.alloc(16, 16);
  c.prototype._final = function() {
    var h = this._cache.flush();
    if (this._autopadding)
      return h = this._mode.encrypt(this, h), this._cipher.scrub(), h;
    if (!h.equals(f))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, c.prototype.setAutoPadding = function(h) {
    return this._autopadding = !!h, this;
  };
  function u() {
    this.cache = r.allocUnsafe(0);
  }
  u.prototype.add = function(h) {
    this.cache = r.concat([this.cache, h]);
  }, u.prototype.get = function() {
    if (this.cache.length > 15) {
      var h = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), h;
    }
    return null;
  }, u.prototype.flush = function() {
    for (var h = 16 - this.cache.length, y = r.allocUnsafe(h), p = -1; ++p < h; )
      y.writeUInt8(h, p);
    return r.concat([this.cache, y]);
  };
  function d(h, y, p) {
    var b = t[h.toLowerCase()];
    if (!b)
      throw new TypeError("invalid suite type");
    if (typeof y == "string" && (y = r.from(y)), y.length !== b.key / 8)
      throw new TypeError("invalid key length " + y.length);
    if (typeof p == "string" && (p = r.from(p)), b.mode !== "GCM" && p.length !== b.iv)
      throw new TypeError("invalid iv length " + p.length);
    return b.type === "stream" ? new n(b.module, y, p) : b.type === "auth" ? new e(b.module, y, p) : new c(b.module, y, p);
  }
  function l(h, y) {
    var p = t[h.toLowerCase()];
    if (!p)
      throw new TypeError("invalid suite type");
    var b = a(y, !1, p.key, p.iv);
    return d(h, b.key, b.iv);
  }
  return ih.createCipheriv = d, ih.createCipher = l, ih;
}
var oh = {}, dS;
function sC() {
  if (dS)
    return oh;
  dS = 1;
  var t = e5(), e = Lt.Buffer, r = L2(), n = t5(), i = To, s = O0(), a = B0(), o = Kt;
  function c(h, y, p) {
    i.call(this), this._cache = new f(), this._last = void 0, this._cipher = new s.AES(y), this._prev = e.from(p), this._mode = h, this._autopadding = !0;
  }
  o(c, i), c.prototype._update = function(h) {
    this._cache.add(h);
    for (var y, p, b = []; y = this._cache.get(this._autopadding); )
      p = this._mode.decrypt(this, y), b.push(p);
    return e.concat(b);
  }, c.prototype._final = function() {
    var h = this._cache.flush();
    if (this._autopadding)
      return u(this._mode.decrypt(this, h));
    if (h)
      throw new Error("data not multiple of block length");
  }, c.prototype.setAutoPadding = function(h) {
    return this._autopadding = !!h, this;
  };
  function f() {
    this.cache = e.allocUnsafe(0);
  }
  f.prototype.add = function(h) {
    this.cache = e.concat([this.cache, h]);
  }, f.prototype.get = function(h) {
    var y;
    if (h) {
      if (this.cache.length > 16)
        return y = this.cache.slice(0, 16), this.cache = this.cache.slice(16), y;
    } else if (this.cache.length >= 16)
      return y = this.cache.slice(0, 16), this.cache = this.cache.slice(16), y;
    return null;
  }, f.prototype.flush = function() {
    if (this.cache.length)
      return this.cache;
  };
  function u(h) {
    var y = h[15];
    if (y < 1 || y > 16)
      throw new Error("unable to decrypt data");
    for (var p = -1; ++p < y; )
      if (h[p + (16 - y)] !== y)
        throw new Error("unable to decrypt data");
    if (y !== 16)
      return h.slice(0, 16 - y);
  }
  function d(h, y, p) {
    var b = r[h.toLowerCase()];
    if (!b)
      throw new TypeError("invalid suite type");
    if (typeof p == "string" && (p = e.from(p)), b.mode !== "GCM" && p.length !== b.iv)
      throw new TypeError("invalid iv length " + p.length);
    if (typeof y == "string" && (y = e.from(y)), y.length !== b.key / 8)
      throw new TypeError("invalid key length " + y.length);
    return b.type === "stream" ? new n(b.module, y, p, !0) : b.type === "auth" ? new t(b.module, y, p, !0) : new c(b.module, y, p);
  }
  function l(h, y) {
    var p = r[h.toLowerCase()];
    if (!p)
      throw new TypeError("invalid suite type");
    var b = a(y, !1, p.key, p.iv);
    return d(h, b.key, b.iv);
  }
  return oh.createDecipher = l, oh.createDecipheriv = d, oh;
}
var lS;
function D2() {
  if (lS)
    return Hi;
  lS = 1;
  var t = iC(), e = sC(), r = XA;
  function n() {
    return Object.keys(r);
  }
  return Hi.createCipher = Hi.Cipher = t.createCipher, Hi.createCipheriv = Hi.Cipheriv = t.createCipheriv, Hi.createDecipher = Hi.Decipher = e.createDecipher, Hi.createDecipheriv = Hi.Decipheriv = e.createDecipheriv, Hi.listCiphers = Hi.getCiphers = n, Hi;
}
var J1 = {}, hS;
function aC() {
  return hS || (hS = 1, function(t) {
    t["des-ecb"] = {
      key: 8,
      iv: 0
    }, t["des-cbc"] = t.des = {
      key: 8,
      iv: 8
    }, t["des-ede3-cbc"] = t.des3 = {
      key: 24,
      iv: 8
    }, t["des-ede3"] = {
      key: 24,
      iv: 0
    }, t["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, t["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(J1)), J1;
}
var pS;
function oC() {
  if (pS)
    return Vi;
  pS = 1;
  var t = HM(), e = D2(), r = L2(), n = aC(), i = B0();
  function s(u, d) {
    u = u.toLowerCase();
    var l, h;
    if (r[u])
      l = r[u].key, h = r[u].iv;
    else if (n[u])
      l = n[u].key * 8, h = n[u].iv;
    else
      throw new TypeError("invalid suite type");
    var y = i(d, !1, l, h);
    return o(u, y.key, y.iv);
  }
  function a(u, d) {
    u = u.toLowerCase();
    var l, h;
    if (r[u])
      l = r[u].key, h = r[u].iv;
    else if (n[u])
      l = n[u].key * 8, h = n[u].iv;
    else
      throw new TypeError("invalid suite type");
    var y = i(d, !1, l, h);
    return c(u, y.key, y.iv);
  }
  function o(u, d, l) {
    if (u = u.toLowerCase(), r[u])
      return e.createCipheriv(u, d, l);
    if (n[u])
      return new t({ key: d, iv: l, mode: u });
    throw new TypeError("invalid suite type");
  }
  function c(u, d, l) {
    if (u = u.toLowerCase(), r[u])
      return e.createDecipheriv(u, d, l);
    if (n[u])
      return new t({ key: d, iv: l, mode: u, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function f() {
    return Object.keys(n).concat(e.getCiphers());
  }
  return Vi.createCipher = Vi.Cipher = s, Vi.createCipheriv = Vi.Cipheriv = o, Vi.createDecipher = Vi.Decipher = a, Vi.createDecipheriv = Vi.Decipheriv = c, Vi.listCiphers = Vi.getCiphers = f, Vi;
}
var Mo = {}, F2 = { exports: {} };
F2.exports;
(function(t) {
  (function(e, r) {
    function n($, w) {
      if (!$)
        throw new Error(w || "Assertion failed");
    }
    function i($, w) {
      $.super_ = w;
      var E = function() {
      };
      E.prototype = w.prototype, $.prototype = new E(), $.prototype.constructor = $;
    }
    function s($, w, E) {
      if (s.isBN($))
        return $;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, $ !== null && ((w === "le" || w === "be") && (E = w, w = 10), this._init($ || 0, w || 10, E || "be"));
    }
    typeof e == "object" ? e.exports = s : r.BN = s, s.BN = s, s.wordSize = 26;
    var a;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? a = window.Buffer : a = R2.Buffer;
    } catch {
    }
    s.isBN = function(w) {
      return w instanceof s ? !0 : w !== null && typeof w == "object" && w.constructor.wordSize === s.wordSize && Array.isArray(w.words);
    }, s.max = function(w, E) {
      return w.cmp(E) > 0 ? w : E;
    }, s.min = function(w, E) {
      return w.cmp(E) < 0 ? w : E;
    }, s.prototype._init = function(w, E, U) {
      if (typeof w == "number")
        return this._initNumber(w, E, U);
      if (typeof w == "object")
        return this._initArray(w, E, U);
      E === "hex" && (E = 16), n(E === (E | 0) && E >= 2 && E <= 36), w = w.toString().replace(/\s+/g, "");
      var W = 0;
      w[0] === "-" && (W++, this.negative = 1), W < w.length && (E === 16 ? this._parseHex(w, W, U) : (this._parseBase(w, E, W), U === "le" && this._initArray(this.toArray(), E, U)));
    }, s.prototype._initNumber = function(w, E, U) {
      w < 0 && (this.negative = 1, w = -w), w < 67108864 ? (this.words = [w & 67108863], this.length = 1) : w < 4503599627370496 ? (this.words = [
        w & 67108863,
        w / 67108864 & 67108863
      ], this.length = 2) : (n(w < 9007199254740992), this.words = [
        w & 67108863,
        w / 67108864 & 67108863,
        1
      ], this.length = 3), U === "le" && this._initArray(this.toArray(), E, U);
    }, s.prototype._initArray = function(w, E, U) {
      if (n(typeof w.length == "number"), w.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(w.length / 3), this.words = new Array(this.length);
      for (var W = 0; W < this.length; W++)
        this.words[W] = 0;
      var _, R, N = 0;
      if (U === "be")
        for (W = w.length - 1, _ = 0; W >= 0; W -= 3)
          R = w[W] | w[W - 1] << 8 | w[W - 2] << 16, this.words[_] |= R << N & 67108863, this.words[_ + 1] = R >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, _++);
      else if (U === "le")
        for (W = 0, _ = 0; W < w.length; W += 3)
          R = w[W] | w[W + 1] << 8 | w[W + 2] << 16, this.words[_] |= R << N & 67108863, this.words[_ + 1] = R >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, _++);
      return this._strip();
    };
    function o($, w) {
      var E = $.charCodeAt(w);
      if (E >= 48 && E <= 57)
        return E - 48;
      if (E >= 65 && E <= 70)
        return E - 55;
      if (E >= 97 && E <= 102)
        return E - 87;
      n(!1, "Invalid character in " + $);
    }
    function c($, w, E) {
      var U = o($, E);
      return E - 1 >= w && (U |= o($, E - 1) << 4), U;
    }
    s.prototype._parseHex = function(w, E, U) {
      this.length = Math.ceil((w.length - E) / 6), this.words = new Array(this.length);
      for (var W = 0; W < this.length; W++)
        this.words[W] = 0;
      var _ = 0, R = 0, N;
      if (U === "be")
        for (W = w.length - 1; W >= E; W -= 2)
          N = c(w, E, W) << _, this.words[R] |= N & 67108863, _ >= 18 ? (_ -= 18, R += 1, this.words[R] |= N >>> 26) : _ += 8;
      else {
        var O = w.length - E;
        for (W = O % 2 === 0 ? E + 1 : E; W < w.length; W += 2)
          N = c(w, E, W) << _, this.words[R] |= N & 67108863, _ >= 18 ? (_ -= 18, R += 1, this.words[R] |= N >>> 26) : _ += 8;
      }
      this._strip();
    };
    function f($, w, E, U) {
      for (var W = 0, _ = 0, R = Math.min($.length, E), N = w; N < R; N++) {
        var O = $.charCodeAt(N) - 48;
        W *= U, O >= 49 ? _ = O - 49 + 10 : O >= 17 ? _ = O - 17 + 10 : _ = O, n(O >= 0 && _ < U, "Invalid character"), W += _;
      }
      return W;
    }
    s.prototype._parseBase = function(w, E, U) {
      this.words = [0], this.length = 1;
      for (var W = 0, _ = 1; _ <= 67108863; _ *= E)
        W++;
      W--, _ = _ / E | 0;
      for (var R = w.length - U, N = R % W, O = Math.min(R, R - N) + U, g = 0, M = U; M < O; M += W)
        g = f(w, M, M + W, E), this.imuln(_), this.words[0] + g < 67108864 ? this.words[0] += g : this._iaddn(g);
      if (N !== 0) {
        var Y = 1;
        for (g = f(w, M, w.length, E), M = 0; M < N; M++)
          Y *= E;
        this.imuln(Y), this.words[0] + g < 67108864 ? this.words[0] += g : this._iaddn(g);
      }
      this._strip();
    }, s.prototype.copy = function(w) {
      w.words = new Array(this.length);
      for (var E = 0; E < this.length; E++)
        w.words[E] = this.words[E];
      w.length = this.length, w.negative = this.negative, w.red = this.red;
    };
    function u($, w) {
      $.words = w.words, $.length = w.length, $.negative = w.negative, $.red = w.red;
    }
    if (s.prototype._move = function(w) {
      u(w, this);
    }, s.prototype.clone = function() {
      var w = new s(null);
      return this.copy(w), w;
    }, s.prototype._expand = function(w) {
      for (; this.length < w; )
        this.words[this.length++] = 0;
      return this;
    }, s.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, s.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        s.prototype[Symbol.for("nodejs.util.inspect.custom")] = d;
      } catch {
        s.prototype.inspect = d;
      }
    else
      s.prototype.inspect = d;
    function d() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var l = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], h = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], y = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    s.prototype.toString = function(w, E) {
      w = w || 10, E = E | 0 || 1;
      var U;
      if (w === 16 || w === "hex") {
        U = "";
        for (var W = 0, _ = 0, R = 0; R < this.length; R++) {
          var N = this.words[R], O = ((N << W | _) & 16777215).toString(16);
          _ = N >>> 24 - W & 16777215, W += 2, W >= 26 && (W -= 26, R--), _ !== 0 || R !== this.length - 1 ? U = l[6 - O.length] + O + U : U = O + U;
        }
        for (_ !== 0 && (U = _.toString(16) + U); U.length % E !== 0; )
          U = "0" + U;
        return this.negative !== 0 && (U = "-" + U), U;
      }
      if (w === (w | 0) && w >= 2 && w <= 36) {
        var g = h[w], M = y[w];
        U = "";
        var Y = this.clone();
        for (Y.negative = 0; !Y.isZero(); ) {
          var se = Y.modrn(M).toString(w);
          Y = Y.idivn(M), Y.isZero() ? U = se + U : U = l[g - se.length] + se + U;
        }
        for (this.isZero() && (U = "0" + U); U.length % E !== 0; )
          U = "0" + U;
        return this.negative !== 0 && (U = "-" + U), U;
      }
      n(!1, "Base should be between 2 and 36");
    }, s.prototype.toNumber = function() {
      var w = this.words[0];
      return this.length === 2 ? w += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? w += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -w : w;
    }, s.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, a && (s.prototype.toBuffer = function(w, E) {
      return this.toArrayLike(a, w, E);
    }), s.prototype.toArray = function(w, E) {
      return this.toArrayLike(Array, w, E);
    };
    var p = function(w, E) {
      return w.allocUnsafe ? w.allocUnsafe(E) : new w(E);
    };
    s.prototype.toArrayLike = function(w, E, U) {
      this._strip();
      var W = this.byteLength(), _ = U || Math.max(1, W);
      n(W <= _, "byte array longer than desired length"), n(_ > 0, "Requested array length <= 0");
      var R = p(w, _), N = E === "le" ? "LE" : "BE";
      return this["_toArrayLike" + N](R, W), R;
    }, s.prototype._toArrayLikeLE = function(w, E) {
      for (var U = 0, W = 0, _ = 0, R = 0; _ < this.length; _++) {
        var N = this.words[_] << R | W;
        w[U++] = N & 255, U < w.length && (w[U++] = N >> 8 & 255), U < w.length && (w[U++] = N >> 16 & 255), R === 6 ? (U < w.length && (w[U++] = N >> 24 & 255), W = 0, R = 0) : (W = N >>> 24, R += 2);
      }
      if (U < w.length)
        for (w[U++] = W; U < w.length; )
          w[U++] = 0;
    }, s.prototype._toArrayLikeBE = function(w, E) {
      for (var U = w.length - 1, W = 0, _ = 0, R = 0; _ < this.length; _++) {
        var N = this.words[_] << R | W;
        w[U--] = N & 255, U >= 0 && (w[U--] = N >> 8 & 255), U >= 0 && (w[U--] = N >> 16 & 255), R === 6 ? (U >= 0 && (w[U--] = N >> 24 & 255), W = 0, R = 0) : (W = N >>> 24, R += 2);
      }
      if (U >= 0)
        for (w[U--] = W; U >= 0; )
          w[U--] = 0;
    }, Math.clz32 ? s.prototype._countBits = function(w) {
      return 32 - Math.clz32(w);
    } : s.prototype._countBits = function(w) {
      var E = w, U = 0;
      return E >= 4096 && (U += 13, E >>>= 13), E >= 64 && (U += 7, E >>>= 7), E >= 8 && (U += 4, E >>>= 4), E >= 2 && (U += 2, E >>>= 2), U + E;
    }, s.prototype._zeroBits = function(w) {
      if (w === 0)
        return 26;
      var E = w, U = 0;
      return E & 8191 || (U += 13, E >>>= 13), E & 127 || (U += 7, E >>>= 7), E & 15 || (U += 4, E >>>= 4), E & 3 || (U += 2, E >>>= 2), E & 1 || U++, U;
    }, s.prototype.bitLength = function() {
      var w = this.words[this.length - 1], E = this._countBits(w);
      return (this.length - 1) * 26 + E;
    };
    function b($) {
      for (var w = new Array($.bitLength()), E = 0; E < w.length; E++) {
        var U = E / 26 | 0, W = E % 26;
        w[E] = $.words[U] >>> W & 1;
      }
      return w;
    }
    s.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var w = 0, E = 0; E < this.length; E++) {
        var U = this._zeroBits(this.words[E]);
        if (w += U, U !== 26)
          break;
      }
      return w;
    }, s.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, s.prototype.toTwos = function(w) {
      return this.negative !== 0 ? this.abs().inotn(w).iaddn(1) : this.clone();
    }, s.prototype.fromTwos = function(w) {
      return this.testn(w - 1) ? this.notn(w).iaddn(1).ineg() : this.clone();
    }, s.prototype.isNeg = function() {
      return this.negative !== 0;
    }, s.prototype.neg = function() {
      return this.clone().ineg();
    }, s.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, s.prototype.iuor = function(w) {
      for (; this.length < w.length; )
        this.words[this.length++] = 0;
      for (var E = 0; E < w.length; E++)
        this.words[E] = this.words[E] | w.words[E];
      return this._strip();
    }, s.prototype.ior = function(w) {
      return n((this.negative | w.negative) === 0), this.iuor(w);
    }, s.prototype.or = function(w) {
      return this.length > w.length ? this.clone().ior(w) : w.clone().ior(this);
    }, s.prototype.uor = function(w) {
      return this.length > w.length ? this.clone().iuor(w) : w.clone().iuor(this);
    }, s.prototype.iuand = function(w) {
      var E;
      this.length > w.length ? E = w : E = this;
      for (var U = 0; U < E.length; U++)
        this.words[U] = this.words[U] & w.words[U];
      return this.length = E.length, this._strip();
    }, s.prototype.iand = function(w) {
      return n((this.negative | w.negative) === 0), this.iuand(w);
    }, s.prototype.and = function(w) {
      return this.length > w.length ? this.clone().iand(w) : w.clone().iand(this);
    }, s.prototype.uand = function(w) {
      return this.length > w.length ? this.clone().iuand(w) : w.clone().iuand(this);
    }, s.prototype.iuxor = function(w) {
      var E, U;
      this.length > w.length ? (E = this, U = w) : (E = w, U = this);
      for (var W = 0; W < U.length; W++)
        this.words[W] = E.words[W] ^ U.words[W];
      if (this !== E)
        for (; W < E.length; W++)
          this.words[W] = E.words[W];
      return this.length = E.length, this._strip();
    }, s.prototype.ixor = function(w) {
      return n((this.negative | w.negative) === 0), this.iuxor(w);
    }, s.prototype.xor = function(w) {
      return this.length > w.length ? this.clone().ixor(w) : w.clone().ixor(this);
    }, s.prototype.uxor = function(w) {
      return this.length > w.length ? this.clone().iuxor(w) : w.clone().iuxor(this);
    }, s.prototype.inotn = function(w) {
      n(typeof w == "number" && w >= 0);
      var E = Math.ceil(w / 26) | 0, U = w % 26;
      this._expand(E), U > 0 && E--;
      for (var W = 0; W < E; W++)
        this.words[W] = ~this.words[W] & 67108863;
      return U > 0 && (this.words[W] = ~this.words[W] & 67108863 >> 26 - U), this._strip();
    }, s.prototype.notn = function(w) {
      return this.clone().inotn(w);
    }, s.prototype.setn = function(w, E) {
      n(typeof w == "number" && w >= 0);
      var U = w / 26 | 0, W = w % 26;
      return this._expand(U + 1), E ? this.words[U] = this.words[U] | 1 << W : this.words[U] = this.words[U] & ~(1 << W), this._strip();
    }, s.prototype.iadd = function(w) {
      var E;
      if (this.negative !== 0 && w.negative === 0)
        return this.negative = 0, E = this.isub(w), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && w.negative !== 0)
        return w.negative = 0, E = this.isub(w), w.negative = 1, E._normSign();
      var U, W;
      this.length > w.length ? (U = this, W = w) : (U = w, W = this);
      for (var _ = 0, R = 0; R < W.length; R++)
        E = (U.words[R] | 0) + (W.words[R] | 0) + _, this.words[R] = E & 67108863, _ = E >>> 26;
      for (; _ !== 0 && R < U.length; R++)
        E = (U.words[R] | 0) + _, this.words[R] = E & 67108863, _ = E >>> 26;
      if (this.length = U.length, _ !== 0)
        this.words[this.length] = _, this.length++;
      else if (U !== this)
        for (; R < U.length; R++)
          this.words[R] = U.words[R];
      return this;
    }, s.prototype.add = function(w) {
      var E;
      return w.negative !== 0 && this.negative === 0 ? (w.negative = 0, E = this.sub(w), w.negative ^= 1, E) : w.negative === 0 && this.negative !== 0 ? (this.negative = 0, E = w.sub(this), this.negative = 1, E) : this.length > w.length ? this.clone().iadd(w) : w.clone().iadd(this);
    }, s.prototype.isub = function(w) {
      if (w.negative !== 0) {
        w.negative = 0;
        var E = this.iadd(w);
        return w.negative = 1, E._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(w), this.negative = 1, this._normSign();
      var U = this.cmp(w);
      if (U === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var W, _;
      U > 0 ? (W = this, _ = w) : (W = w, _ = this);
      for (var R = 0, N = 0; N < _.length; N++)
        E = (W.words[N] | 0) - (_.words[N] | 0) + R, R = E >> 26, this.words[N] = E & 67108863;
      for (; R !== 0 && N < W.length; N++)
        E = (W.words[N] | 0) + R, R = E >> 26, this.words[N] = E & 67108863;
      if (R === 0 && N < W.length && W !== this)
        for (; N < W.length; N++)
          this.words[N] = W.words[N];
      return this.length = Math.max(this.length, N), W !== this && (this.negative = 1), this._strip();
    }, s.prototype.sub = function(w) {
      return this.clone().isub(w);
    };
    function v($, w, E) {
      E.negative = w.negative ^ $.negative;
      var U = $.length + w.length | 0;
      E.length = U, U = U - 1 | 0;
      var W = $.words[0] | 0, _ = w.words[0] | 0, R = W * _, N = R & 67108863, O = R / 67108864 | 0;
      E.words[0] = N;
      for (var g = 1; g < U; g++) {
        for (var M = O >>> 26, Y = O & 67108863, se = Math.min(g, w.length - 1), V = Math.max(0, g - $.length + 1); V <= se; V++) {
          var K = g - V | 0;
          W = $.words[K] | 0, _ = w.words[V] | 0, R = W * _ + Y, M += R / 67108864 | 0, Y = R & 67108863;
        }
        E.words[g] = Y | 0, O = M | 0;
      }
      return O !== 0 ? E.words[g] = O | 0 : E.length--, E._strip();
    }
    var x = function(w, E, U) {
      var W = w.words, _ = E.words, R = U.words, N = 0, O, g, M, Y = W[0] | 0, se = Y & 8191, V = Y >>> 13, K = W[1] | 0, Z = K & 8191, ne = K >>> 13, ce = W[2] | 0, H = ce & 8191, J = ce >>> 13, le = W[3] | 0, me = le & 8191, Ue = le >>> 13, Ve = W[4] | 0, ze = Ve & 8191, at = Ve >>> 13, xe = W[5] | 0, gt = xe & 8191, ht = xe >>> 13, Bt = W[6] | 0, pt = Bt & 8191, de = Bt >>> 13, he = W[7] | 0, Ie = he & 8191, z = he >>> 13, k = W[8] | 0, B = k & 8191, A = k >>> 13, m = W[9] | 0, S = m & 8191, q = m >>> 13, oe = _[0] | 0, fe = oe & 8191, pe = oe >>> 13, Ke = _[1] | 0, De = Ke & 8191, ot = Ke >>> 13, ar = _[2] | 0, bt = ar & 8191, qr = ar >>> 13, ha = _[3] | 0, nr = ha & 8191, pr = ha >>> 13, bi = _[4] | 0, Br = bi & 8191, Mr = bi >>> 13, Bs = _[5] | 0, Wr = Bs & 8191, Vt = Bs >>> 13, Ms = _[6] | 0, j = Ms & 8191, Q = Ms >>> 13, X = _[7] | 0, T = X & 8191, te = X >>> 13, ge = _[8] | 0, be = ge & 8191, Ae = ge >>> 13, Le = _[9] | 0, Ge = Le & 8191, $e = Le >>> 13;
      U.negative = w.negative ^ E.negative, U.length = 19, O = Math.imul(se, fe), g = Math.imul(se, pe), g = g + Math.imul(V, fe) | 0, M = Math.imul(V, pe);
      var Xt = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (Xt >>> 26) | 0, Xt &= 67108863, O = Math.imul(Z, fe), g = Math.imul(Z, pe), g = g + Math.imul(ne, fe) | 0, M = Math.imul(ne, pe), O = O + Math.imul(se, De) | 0, g = g + Math.imul(se, ot) | 0, g = g + Math.imul(V, De) | 0, M = M + Math.imul(V, ot) | 0;
      var et = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (et >>> 26) | 0, et &= 67108863, O = Math.imul(H, fe), g = Math.imul(H, pe), g = g + Math.imul(J, fe) | 0, M = Math.imul(J, pe), O = O + Math.imul(Z, De) | 0, g = g + Math.imul(Z, ot) | 0, g = g + Math.imul(ne, De) | 0, M = M + Math.imul(ne, ot) | 0, O = O + Math.imul(se, bt) | 0, g = g + Math.imul(se, qr) | 0, g = g + Math.imul(V, bt) | 0, M = M + Math.imul(V, qr) | 0;
      var vt = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, O = Math.imul(me, fe), g = Math.imul(me, pe), g = g + Math.imul(Ue, fe) | 0, M = Math.imul(Ue, pe), O = O + Math.imul(H, De) | 0, g = g + Math.imul(H, ot) | 0, g = g + Math.imul(J, De) | 0, M = M + Math.imul(J, ot) | 0, O = O + Math.imul(Z, bt) | 0, g = g + Math.imul(Z, qr) | 0, g = g + Math.imul(ne, bt) | 0, M = M + Math.imul(ne, qr) | 0, O = O + Math.imul(se, nr) | 0, g = g + Math.imul(se, pr) | 0, g = g + Math.imul(V, nr) | 0, M = M + Math.imul(V, pr) | 0;
      var wt = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, O = Math.imul(ze, fe), g = Math.imul(ze, pe), g = g + Math.imul(at, fe) | 0, M = Math.imul(at, pe), O = O + Math.imul(me, De) | 0, g = g + Math.imul(me, ot) | 0, g = g + Math.imul(Ue, De) | 0, M = M + Math.imul(Ue, ot) | 0, O = O + Math.imul(H, bt) | 0, g = g + Math.imul(H, qr) | 0, g = g + Math.imul(J, bt) | 0, M = M + Math.imul(J, qr) | 0, O = O + Math.imul(Z, nr) | 0, g = g + Math.imul(Z, pr) | 0, g = g + Math.imul(ne, nr) | 0, M = M + Math.imul(ne, pr) | 0, O = O + Math.imul(se, Br) | 0, g = g + Math.imul(se, Mr) | 0, g = g + Math.imul(V, Br) | 0, M = M + Math.imul(V, Mr) | 0;
      var Rt = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, O = Math.imul(gt, fe), g = Math.imul(gt, pe), g = g + Math.imul(ht, fe) | 0, M = Math.imul(ht, pe), O = O + Math.imul(ze, De) | 0, g = g + Math.imul(ze, ot) | 0, g = g + Math.imul(at, De) | 0, M = M + Math.imul(at, ot) | 0, O = O + Math.imul(me, bt) | 0, g = g + Math.imul(me, qr) | 0, g = g + Math.imul(Ue, bt) | 0, M = M + Math.imul(Ue, qr) | 0, O = O + Math.imul(H, nr) | 0, g = g + Math.imul(H, pr) | 0, g = g + Math.imul(J, nr) | 0, M = M + Math.imul(J, pr) | 0, O = O + Math.imul(Z, Br) | 0, g = g + Math.imul(Z, Mr) | 0, g = g + Math.imul(ne, Br) | 0, M = M + Math.imul(ne, Mr) | 0, O = O + Math.imul(se, Wr) | 0, g = g + Math.imul(se, Vt) | 0, g = g + Math.imul(V, Wr) | 0, M = M + Math.imul(V, Vt) | 0;
      var Tt = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, O = Math.imul(pt, fe), g = Math.imul(pt, pe), g = g + Math.imul(de, fe) | 0, M = Math.imul(de, pe), O = O + Math.imul(gt, De) | 0, g = g + Math.imul(gt, ot) | 0, g = g + Math.imul(ht, De) | 0, M = M + Math.imul(ht, ot) | 0, O = O + Math.imul(ze, bt) | 0, g = g + Math.imul(ze, qr) | 0, g = g + Math.imul(at, bt) | 0, M = M + Math.imul(at, qr) | 0, O = O + Math.imul(me, nr) | 0, g = g + Math.imul(me, pr) | 0, g = g + Math.imul(Ue, nr) | 0, M = M + Math.imul(Ue, pr) | 0, O = O + Math.imul(H, Br) | 0, g = g + Math.imul(H, Mr) | 0, g = g + Math.imul(J, Br) | 0, M = M + Math.imul(J, Mr) | 0, O = O + Math.imul(Z, Wr) | 0, g = g + Math.imul(Z, Vt) | 0, g = g + Math.imul(ne, Wr) | 0, M = M + Math.imul(ne, Vt) | 0, O = O + Math.imul(se, j) | 0, g = g + Math.imul(se, Q) | 0, g = g + Math.imul(V, j) | 0, M = M + Math.imul(V, Q) | 0;
      var _t = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863, O = Math.imul(Ie, fe), g = Math.imul(Ie, pe), g = g + Math.imul(z, fe) | 0, M = Math.imul(z, pe), O = O + Math.imul(pt, De) | 0, g = g + Math.imul(pt, ot) | 0, g = g + Math.imul(de, De) | 0, M = M + Math.imul(de, ot) | 0, O = O + Math.imul(gt, bt) | 0, g = g + Math.imul(gt, qr) | 0, g = g + Math.imul(ht, bt) | 0, M = M + Math.imul(ht, qr) | 0, O = O + Math.imul(ze, nr) | 0, g = g + Math.imul(ze, pr) | 0, g = g + Math.imul(at, nr) | 0, M = M + Math.imul(at, pr) | 0, O = O + Math.imul(me, Br) | 0, g = g + Math.imul(me, Mr) | 0, g = g + Math.imul(Ue, Br) | 0, M = M + Math.imul(Ue, Mr) | 0, O = O + Math.imul(H, Wr) | 0, g = g + Math.imul(H, Vt) | 0, g = g + Math.imul(J, Wr) | 0, M = M + Math.imul(J, Vt) | 0, O = O + Math.imul(Z, j) | 0, g = g + Math.imul(Z, Q) | 0, g = g + Math.imul(ne, j) | 0, M = M + Math.imul(ne, Q) | 0, O = O + Math.imul(se, T) | 0, g = g + Math.imul(se, te) | 0, g = g + Math.imul(V, T) | 0, M = M + Math.imul(V, te) | 0;
      var Et = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, O = Math.imul(B, fe), g = Math.imul(B, pe), g = g + Math.imul(A, fe) | 0, M = Math.imul(A, pe), O = O + Math.imul(Ie, De) | 0, g = g + Math.imul(Ie, ot) | 0, g = g + Math.imul(z, De) | 0, M = M + Math.imul(z, ot) | 0, O = O + Math.imul(pt, bt) | 0, g = g + Math.imul(pt, qr) | 0, g = g + Math.imul(de, bt) | 0, M = M + Math.imul(de, qr) | 0, O = O + Math.imul(gt, nr) | 0, g = g + Math.imul(gt, pr) | 0, g = g + Math.imul(ht, nr) | 0, M = M + Math.imul(ht, pr) | 0, O = O + Math.imul(ze, Br) | 0, g = g + Math.imul(ze, Mr) | 0, g = g + Math.imul(at, Br) | 0, M = M + Math.imul(at, Mr) | 0, O = O + Math.imul(me, Wr) | 0, g = g + Math.imul(me, Vt) | 0, g = g + Math.imul(Ue, Wr) | 0, M = M + Math.imul(Ue, Vt) | 0, O = O + Math.imul(H, j) | 0, g = g + Math.imul(H, Q) | 0, g = g + Math.imul(J, j) | 0, M = M + Math.imul(J, Q) | 0, O = O + Math.imul(Z, T) | 0, g = g + Math.imul(Z, te) | 0, g = g + Math.imul(ne, T) | 0, M = M + Math.imul(ne, te) | 0, O = O + Math.imul(se, be) | 0, g = g + Math.imul(se, Ae) | 0, g = g + Math.imul(V, be) | 0, M = M + Math.imul(V, Ae) | 0;
      var St = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, O = Math.imul(S, fe), g = Math.imul(S, pe), g = g + Math.imul(q, fe) | 0, M = Math.imul(q, pe), O = O + Math.imul(B, De) | 0, g = g + Math.imul(B, ot) | 0, g = g + Math.imul(A, De) | 0, M = M + Math.imul(A, ot) | 0, O = O + Math.imul(Ie, bt) | 0, g = g + Math.imul(Ie, qr) | 0, g = g + Math.imul(z, bt) | 0, M = M + Math.imul(z, qr) | 0, O = O + Math.imul(pt, nr) | 0, g = g + Math.imul(pt, pr) | 0, g = g + Math.imul(de, nr) | 0, M = M + Math.imul(de, pr) | 0, O = O + Math.imul(gt, Br) | 0, g = g + Math.imul(gt, Mr) | 0, g = g + Math.imul(ht, Br) | 0, M = M + Math.imul(ht, Mr) | 0, O = O + Math.imul(ze, Wr) | 0, g = g + Math.imul(ze, Vt) | 0, g = g + Math.imul(at, Wr) | 0, M = M + Math.imul(at, Vt) | 0, O = O + Math.imul(me, j) | 0, g = g + Math.imul(me, Q) | 0, g = g + Math.imul(Ue, j) | 0, M = M + Math.imul(Ue, Q) | 0, O = O + Math.imul(H, T) | 0, g = g + Math.imul(H, te) | 0, g = g + Math.imul(J, T) | 0, M = M + Math.imul(J, te) | 0, O = O + Math.imul(Z, be) | 0, g = g + Math.imul(Z, Ae) | 0, g = g + Math.imul(ne, be) | 0, M = M + Math.imul(ne, Ae) | 0, O = O + Math.imul(se, Ge) | 0, g = g + Math.imul(se, $e) | 0, g = g + Math.imul(V, Ge) | 0, M = M + Math.imul(V, $e) | 0;
      var tt = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (tt >>> 26) | 0, tt &= 67108863, O = Math.imul(S, De), g = Math.imul(S, ot), g = g + Math.imul(q, De) | 0, M = Math.imul(q, ot), O = O + Math.imul(B, bt) | 0, g = g + Math.imul(B, qr) | 0, g = g + Math.imul(A, bt) | 0, M = M + Math.imul(A, qr) | 0, O = O + Math.imul(Ie, nr) | 0, g = g + Math.imul(Ie, pr) | 0, g = g + Math.imul(z, nr) | 0, M = M + Math.imul(z, pr) | 0, O = O + Math.imul(pt, Br) | 0, g = g + Math.imul(pt, Mr) | 0, g = g + Math.imul(de, Br) | 0, M = M + Math.imul(de, Mr) | 0, O = O + Math.imul(gt, Wr) | 0, g = g + Math.imul(gt, Vt) | 0, g = g + Math.imul(ht, Wr) | 0, M = M + Math.imul(ht, Vt) | 0, O = O + Math.imul(ze, j) | 0, g = g + Math.imul(ze, Q) | 0, g = g + Math.imul(at, j) | 0, M = M + Math.imul(at, Q) | 0, O = O + Math.imul(me, T) | 0, g = g + Math.imul(me, te) | 0, g = g + Math.imul(Ue, T) | 0, M = M + Math.imul(Ue, te) | 0, O = O + Math.imul(H, be) | 0, g = g + Math.imul(H, Ae) | 0, g = g + Math.imul(J, be) | 0, M = M + Math.imul(J, Ae) | 0, O = O + Math.imul(Z, Ge) | 0, g = g + Math.imul(Z, $e) | 0, g = g + Math.imul(ne, Ge) | 0, M = M + Math.imul(ne, $e) | 0;
      var ft = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, O = Math.imul(S, bt), g = Math.imul(S, qr), g = g + Math.imul(q, bt) | 0, M = Math.imul(q, qr), O = O + Math.imul(B, nr) | 0, g = g + Math.imul(B, pr) | 0, g = g + Math.imul(A, nr) | 0, M = M + Math.imul(A, pr) | 0, O = O + Math.imul(Ie, Br) | 0, g = g + Math.imul(Ie, Mr) | 0, g = g + Math.imul(z, Br) | 0, M = M + Math.imul(z, Mr) | 0, O = O + Math.imul(pt, Wr) | 0, g = g + Math.imul(pt, Vt) | 0, g = g + Math.imul(de, Wr) | 0, M = M + Math.imul(de, Vt) | 0, O = O + Math.imul(gt, j) | 0, g = g + Math.imul(gt, Q) | 0, g = g + Math.imul(ht, j) | 0, M = M + Math.imul(ht, Q) | 0, O = O + Math.imul(ze, T) | 0, g = g + Math.imul(ze, te) | 0, g = g + Math.imul(at, T) | 0, M = M + Math.imul(at, te) | 0, O = O + Math.imul(me, be) | 0, g = g + Math.imul(me, Ae) | 0, g = g + Math.imul(Ue, be) | 0, M = M + Math.imul(Ue, Ae) | 0, O = O + Math.imul(H, Ge) | 0, g = g + Math.imul(H, $e) | 0, g = g + Math.imul(J, Ge) | 0, M = M + Math.imul(J, $e) | 0;
      var Ye = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (Ye >>> 26) | 0, Ye &= 67108863, O = Math.imul(S, nr), g = Math.imul(S, pr), g = g + Math.imul(q, nr) | 0, M = Math.imul(q, pr), O = O + Math.imul(B, Br) | 0, g = g + Math.imul(B, Mr) | 0, g = g + Math.imul(A, Br) | 0, M = M + Math.imul(A, Mr) | 0, O = O + Math.imul(Ie, Wr) | 0, g = g + Math.imul(Ie, Vt) | 0, g = g + Math.imul(z, Wr) | 0, M = M + Math.imul(z, Vt) | 0, O = O + Math.imul(pt, j) | 0, g = g + Math.imul(pt, Q) | 0, g = g + Math.imul(de, j) | 0, M = M + Math.imul(de, Q) | 0, O = O + Math.imul(gt, T) | 0, g = g + Math.imul(gt, te) | 0, g = g + Math.imul(ht, T) | 0, M = M + Math.imul(ht, te) | 0, O = O + Math.imul(ze, be) | 0, g = g + Math.imul(ze, Ae) | 0, g = g + Math.imul(at, be) | 0, M = M + Math.imul(at, Ae) | 0, O = O + Math.imul(me, Ge) | 0, g = g + Math.imul(me, $e) | 0, g = g + Math.imul(Ue, Ge) | 0, M = M + Math.imul(Ue, $e) | 0;
      var nt = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (nt >>> 26) | 0, nt &= 67108863, O = Math.imul(S, Br), g = Math.imul(S, Mr), g = g + Math.imul(q, Br) | 0, M = Math.imul(q, Mr), O = O + Math.imul(B, Wr) | 0, g = g + Math.imul(B, Vt) | 0, g = g + Math.imul(A, Wr) | 0, M = M + Math.imul(A, Vt) | 0, O = O + Math.imul(Ie, j) | 0, g = g + Math.imul(Ie, Q) | 0, g = g + Math.imul(z, j) | 0, M = M + Math.imul(z, Q) | 0, O = O + Math.imul(pt, T) | 0, g = g + Math.imul(pt, te) | 0, g = g + Math.imul(de, T) | 0, M = M + Math.imul(de, te) | 0, O = O + Math.imul(gt, be) | 0, g = g + Math.imul(gt, Ae) | 0, g = g + Math.imul(ht, be) | 0, M = M + Math.imul(ht, Ae) | 0, O = O + Math.imul(ze, Ge) | 0, g = g + Math.imul(ze, $e) | 0, g = g + Math.imul(at, Ge) | 0, M = M + Math.imul(at, $e) | 0;
      var it = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (it >>> 26) | 0, it &= 67108863, O = Math.imul(S, Wr), g = Math.imul(S, Vt), g = g + Math.imul(q, Wr) | 0, M = Math.imul(q, Vt), O = O + Math.imul(B, j) | 0, g = g + Math.imul(B, Q) | 0, g = g + Math.imul(A, j) | 0, M = M + Math.imul(A, Q) | 0, O = O + Math.imul(Ie, T) | 0, g = g + Math.imul(Ie, te) | 0, g = g + Math.imul(z, T) | 0, M = M + Math.imul(z, te) | 0, O = O + Math.imul(pt, be) | 0, g = g + Math.imul(pt, Ae) | 0, g = g + Math.imul(de, be) | 0, M = M + Math.imul(de, Ae) | 0, O = O + Math.imul(gt, Ge) | 0, g = g + Math.imul(gt, $e) | 0, g = g + Math.imul(ht, Ge) | 0, M = M + Math.imul(ht, $e) | 0;
      var Je = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (Je >>> 26) | 0, Je &= 67108863, O = Math.imul(S, j), g = Math.imul(S, Q), g = g + Math.imul(q, j) | 0, M = Math.imul(q, Q), O = O + Math.imul(B, T) | 0, g = g + Math.imul(B, te) | 0, g = g + Math.imul(A, T) | 0, M = M + Math.imul(A, te) | 0, O = O + Math.imul(Ie, be) | 0, g = g + Math.imul(Ie, Ae) | 0, g = g + Math.imul(z, be) | 0, M = M + Math.imul(z, Ae) | 0, O = O + Math.imul(pt, Ge) | 0, g = g + Math.imul(pt, $e) | 0, g = g + Math.imul(de, Ge) | 0, M = M + Math.imul(de, $e) | 0;
      var Se = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, O = Math.imul(S, T), g = Math.imul(S, te), g = g + Math.imul(q, T) | 0, M = Math.imul(q, te), O = O + Math.imul(B, be) | 0, g = g + Math.imul(B, Ae) | 0, g = g + Math.imul(A, be) | 0, M = M + Math.imul(A, Ae) | 0, O = O + Math.imul(Ie, Ge) | 0, g = g + Math.imul(Ie, $e) | 0, g = g + Math.imul(z, Ge) | 0, M = M + Math.imul(z, $e) | 0;
      var Ee = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, O = Math.imul(S, be), g = Math.imul(S, Ae), g = g + Math.imul(q, be) | 0, M = Math.imul(q, Ae), O = O + Math.imul(B, Ge) | 0, g = g + Math.imul(B, $e) | 0, g = g + Math.imul(A, Ge) | 0, M = M + Math.imul(A, $e) | 0;
      var Ce = (N + O | 0) + ((g & 8191) << 13) | 0;
      N = (M + (g >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, O = Math.imul(S, Ge), g = Math.imul(S, $e), g = g + Math.imul(q, Ge) | 0, M = Math.imul(q, $e);
      var Oe = (N + O | 0) + ((g & 8191) << 13) | 0;
      return N = (M + (g >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, R[0] = Xt, R[1] = et, R[2] = vt, R[3] = wt, R[4] = Rt, R[5] = Tt, R[6] = _t, R[7] = Et, R[8] = St, R[9] = tt, R[10] = ft, R[11] = Ye, R[12] = nt, R[13] = it, R[14] = Je, R[15] = Se, R[16] = Ee, R[17] = Ce, R[18] = Oe, N !== 0 && (R[19] = N, U.length++), U;
    };
    Math.imul || (x = v);
    function I($, w, E) {
      E.negative = w.negative ^ $.negative, E.length = $.length + w.length;
      for (var U = 0, W = 0, _ = 0; _ < E.length - 1; _++) {
        var R = W;
        W = 0;
        for (var N = U & 67108863, O = Math.min(_, w.length - 1), g = Math.max(0, _ - $.length + 1); g <= O; g++) {
          var M = _ - g, Y = $.words[M] | 0, se = w.words[g] | 0, V = Y * se, K = V & 67108863;
          R = R + (V / 67108864 | 0) | 0, K = K + N | 0, N = K & 67108863, R = R + (K >>> 26) | 0, W += R >>> 26, R &= 67108863;
        }
        E.words[_] = N, U = R, R = W;
      }
      return U !== 0 ? E.words[_] = U : E.length--, E._strip();
    }
    function L($, w, E) {
      return I($, w, E);
    }
    s.prototype.mulTo = function(w, E) {
      var U, W = this.length + w.length;
      return this.length === 10 && w.length === 10 ? U = x(this, w, E) : W < 63 ? U = v(this, w, E) : W < 1024 ? U = I(this, w, E) : U = L(this, w, E), U;
    }, s.prototype.mul = function(w) {
      var E = new s(null);
      return E.words = new Array(this.length + w.length), this.mulTo(w, E);
    }, s.prototype.mulf = function(w) {
      var E = new s(null);
      return E.words = new Array(this.length + w.length), L(this, w, E);
    }, s.prototype.imul = function(w) {
      return this.clone().mulTo(w, this);
    }, s.prototype.imuln = function(w) {
      var E = w < 0;
      E && (w = -w), n(typeof w == "number"), n(w < 67108864);
      for (var U = 0, W = 0; W < this.length; W++) {
        var _ = (this.words[W] | 0) * w, R = (_ & 67108863) + (U & 67108863);
        U >>= 26, U += _ / 67108864 | 0, U += R >>> 26, this.words[W] = R & 67108863;
      }
      return U !== 0 && (this.words[W] = U, this.length++), E ? this.ineg() : this;
    }, s.prototype.muln = function(w) {
      return this.clone().imuln(w);
    }, s.prototype.sqr = function() {
      return this.mul(this);
    }, s.prototype.isqr = function() {
      return this.imul(this.clone());
    }, s.prototype.pow = function(w) {
      var E = b(w);
      if (E.length === 0)
        return new s(1);
      for (var U = this, W = 0; W < E.length && E[W] === 0; W++, U = U.sqr())
        ;
      if (++W < E.length)
        for (var _ = U.sqr(); W < E.length; W++, _ = _.sqr())
          E[W] !== 0 && (U = U.mul(_));
      return U;
    }, s.prototype.iushln = function(w) {
      n(typeof w == "number" && w >= 0);
      var E = w % 26, U = (w - E) / 26, W = 67108863 >>> 26 - E << 26 - E, _;
      if (E !== 0) {
        var R = 0;
        for (_ = 0; _ < this.length; _++) {
          var N = this.words[_] & W, O = (this.words[_] | 0) - N << E;
          this.words[_] = O | R, R = N >>> 26 - E;
        }
        R && (this.words[_] = R, this.length++);
      }
      if (U !== 0) {
        for (_ = this.length - 1; _ >= 0; _--)
          this.words[_ + U] = this.words[_];
        for (_ = 0; _ < U; _++)
          this.words[_] = 0;
        this.length += U;
      }
      return this._strip();
    }, s.prototype.ishln = function(w) {
      return n(this.negative === 0), this.iushln(w);
    }, s.prototype.iushrn = function(w, E, U) {
      n(typeof w == "number" && w >= 0);
      var W;
      E ? W = (E - E % 26) / 26 : W = 0;
      var _ = w % 26, R = Math.min((w - _) / 26, this.length), N = 67108863 ^ 67108863 >>> _ << _, O = U;
      if (W -= R, W = Math.max(0, W), O) {
        for (var g = 0; g < R; g++)
          O.words[g] = this.words[g];
        O.length = R;
      }
      if (R !== 0)
        if (this.length > R)
          for (this.length -= R, g = 0; g < this.length; g++)
            this.words[g] = this.words[g + R];
        else
          this.words[0] = 0, this.length = 1;
      var M = 0;
      for (g = this.length - 1; g >= 0 && (M !== 0 || g >= W); g--) {
        var Y = this.words[g] | 0;
        this.words[g] = M << 26 - _ | Y >>> _, M = Y & N;
      }
      return O && M !== 0 && (O.words[O.length++] = M), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, s.prototype.ishrn = function(w, E, U) {
      return n(this.negative === 0), this.iushrn(w, E, U);
    }, s.prototype.shln = function(w) {
      return this.clone().ishln(w);
    }, s.prototype.ushln = function(w) {
      return this.clone().iushln(w);
    }, s.prototype.shrn = function(w) {
      return this.clone().ishrn(w);
    }, s.prototype.ushrn = function(w) {
      return this.clone().iushrn(w);
    }, s.prototype.testn = function(w) {
      n(typeof w == "number" && w >= 0);
      var E = w % 26, U = (w - E) / 26, W = 1 << E;
      if (this.length <= U)
        return !1;
      var _ = this.words[U];
      return !!(_ & W);
    }, s.prototype.imaskn = function(w) {
      n(typeof w == "number" && w >= 0);
      var E = w % 26, U = (w - E) / 26;
      if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= U)
        return this;
      if (E !== 0 && U++, this.length = Math.min(U, this.length), E !== 0) {
        var W = 67108863 ^ 67108863 >>> E << E;
        this.words[this.length - 1] &= W;
      }
      return this._strip();
    }, s.prototype.maskn = function(w) {
      return this.clone().imaskn(w);
    }, s.prototype.iaddn = function(w) {
      return n(typeof w == "number"), n(w < 67108864), w < 0 ? this.isubn(-w) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= w ? (this.words[0] = w - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(w), this.negative = 1, this) : this._iaddn(w);
    }, s.prototype._iaddn = function(w) {
      this.words[0] += w;
      for (var E = 0; E < this.length && this.words[E] >= 67108864; E++)
        this.words[E] -= 67108864, E === this.length - 1 ? this.words[E + 1] = 1 : this.words[E + 1]++;
      return this.length = Math.max(this.length, E + 1), this;
    }, s.prototype.isubn = function(w) {
      if (n(typeof w == "number"), n(w < 67108864), w < 0)
        return this.iaddn(-w);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(w), this.negative = 1, this;
      if (this.words[0] -= w, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var E = 0; E < this.length && this.words[E] < 0; E++)
          this.words[E] += 67108864, this.words[E + 1] -= 1;
      return this._strip();
    }, s.prototype.addn = function(w) {
      return this.clone().iaddn(w);
    }, s.prototype.subn = function(w) {
      return this.clone().isubn(w);
    }, s.prototype.iabs = function() {
      return this.negative = 0, this;
    }, s.prototype.abs = function() {
      return this.clone().iabs();
    }, s.prototype._ishlnsubmul = function(w, E, U) {
      var W = w.length + U, _;
      this._expand(W);
      var R, N = 0;
      for (_ = 0; _ < w.length; _++) {
        R = (this.words[_ + U] | 0) + N;
        var O = (w.words[_] | 0) * E;
        R -= O & 67108863, N = (R >> 26) - (O / 67108864 | 0), this.words[_ + U] = R & 67108863;
      }
      for (; _ < this.length - U; _++)
        R = (this.words[_ + U] | 0) + N, N = R >> 26, this.words[_ + U] = R & 67108863;
      if (N === 0)
        return this._strip();
      for (n(N === -1), N = 0, _ = 0; _ < this.length; _++)
        R = -(this.words[_] | 0) + N, N = R >> 26, this.words[_] = R & 67108863;
      return this.negative = 1, this._strip();
    }, s.prototype._wordDiv = function(w, E) {
      var U = this.length - w.length, W = this.clone(), _ = w, R = _.words[_.length - 1] | 0, N = this._countBits(R);
      U = 26 - N, U !== 0 && (_ = _.ushln(U), W.iushln(U), R = _.words[_.length - 1] | 0);
      var O = W.length - _.length, g;
      if (E !== "mod") {
        g = new s(null), g.length = O + 1, g.words = new Array(g.length);
        for (var M = 0; M < g.length; M++)
          g.words[M] = 0;
      }
      var Y = W.clone()._ishlnsubmul(_, 1, O);
      Y.negative === 0 && (W = Y, g && (g.words[O] = 1));
      for (var se = O - 1; se >= 0; se--) {
        var V = (W.words[_.length + se] | 0) * 67108864 + (W.words[_.length + se - 1] | 0);
        for (V = Math.min(V / R | 0, 67108863), W._ishlnsubmul(_, V, se); W.negative !== 0; )
          V--, W.negative = 0, W._ishlnsubmul(_, 1, se), W.isZero() || (W.negative ^= 1);
        g && (g.words[se] = V);
      }
      return g && g._strip(), W._strip(), E !== "div" && U !== 0 && W.iushrn(U), {
        div: g || null,
        mod: W
      };
    }, s.prototype.divmod = function(w, E, U) {
      if (n(!w.isZero()), this.isZero())
        return {
          div: new s(0),
          mod: new s(0)
        };
      var W, _, R;
      return this.negative !== 0 && w.negative === 0 ? (R = this.neg().divmod(w, E), E !== "mod" && (W = R.div.neg()), E !== "div" && (_ = R.mod.neg(), U && _.negative !== 0 && _.iadd(w)), {
        div: W,
        mod: _
      }) : this.negative === 0 && w.negative !== 0 ? (R = this.divmod(w.neg(), E), E !== "mod" && (W = R.div.neg()), {
        div: W,
        mod: R.mod
      }) : this.negative & w.negative ? (R = this.neg().divmod(w.neg(), E), E !== "div" && (_ = R.mod.neg(), U && _.negative !== 0 && _.isub(w)), {
        div: R.div,
        mod: _
      }) : w.length > this.length || this.cmp(w) < 0 ? {
        div: new s(0),
        mod: this
      } : w.length === 1 ? E === "div" ? {
        div: this.divn(w.words[0]),
        mod: null
      } : E === "mod" ? {
        div: null,
        mod: new s(this.modrn(w.words[0]))
      } : {
        div: this.divn(w.words[0]),
        mod: new s(this.modrn(w.words[0]))
      } : this._wordDiv(w, E);
    }, s.prototype.div = function(w) {
      return this.divmod(w, "div", !1).div;
    }, s.prototype.mod = function(w) {
      return this.divmod(w, "mod", !1).mod;
    }, s.prototype.umod = function(w) {
      return this.divmod(w, "mod", !0).mod;
    }, s.prototype.divRound = function(w) {
      var E = this.divmod(w);
      if (E.mod.isZero())
        return E.div;
      var U = E.div.negative !== 0 ? E.mod.isub(w) : E.mod, W = w.ushrn(1), _ = w.andln(1), R = U.cmp(W);
      return R < 0 || _ === 1 && R === 0 ? E.div : E.div.negative !== 0 ? E.div.isubn(1) : E.div.iaddn(1);
    }, s.prototype.modrn = function(w) {
      var E = w < 0;
      E && (w = -w), n(w <= 67108863);
      for (var U = (1 << 26) % w, W = 0, _ = this.length - 1; _ >= 0; _--)
        W = (U * W + (this.words[_] | 0)) % w;
      return E ? -W : W;
    }, s.prototype.modn = function(w) {
      return this.modrn(w);
    }, s.prototype.idivn = function(w) {
      var E = w < 0;
      E && (w = -w), n(w <= 67108863);
      for (var U = 0, W = this.length - 1; W >= 0; W--) {
        var _ = (this.words[W] | 0) + U * 67108864;
        this.words[W] = _ / w | 0, U = _ % w;
      }
      return this._strip(), E ? this.ineg() : this;
    }, s.prototype.divn = function(w) {
      return this.clone().idivn(w);
    }, s.prototype.egcd = function(w) {
      n(w.negative === 0), n(!w.isZero());
      var E = this, U = w.clone();
      E.negative !== 0 ? E = E.umod(w) : E = E.clone();
      for (var W = new s(1), _ = new s(0), R = new s(0), N = new s(1), O = 0; E.isEven() && U.isEven(); )
        E.iushrn(1), U.iushrn(1), ++O;
      for (var g = U.clone(), M = E.clone(); !E.isZero(); ) {
        for (var Y = 0, se = 1; !(E.words[0] & se) && Y < 26; ++Y, se <<= 1)
          ;
        if (Y > 0)
          for (E.iushrn(Y); Y-- > 0; )
            (W.isOdd() || _.isOdd()) && (W.iadd(g), _.isub(M)), W.iushrn(1), _.iushrn(1);
        for (var V = 0, K = 1; !(U.words[0] & K) && V < 26; ++V, K <<= 1)
          ;
        if (V > 0)
          for (U.iushrn(V); V-- > 0; )
            (R.isOdd() || N.isOdd()) && (R.iadd(g), N.isub(M)), R.iushrn(1), N.iushrn(1);
        E.cmp(U) >= 0 ? (E.isub(U), W.isub(R), _.isub(N)) : (U.isub(E), R.isub(W), N.isub(_));
      }
      return {
        a: R,
        b: N,
        gcd: U.iushln(O)
      };
    }, s.prototype._invmp = function(w) {
      n(w.negative === 0), n(!w.isZero());
      var E = this, U = w.clone();
      E.negative !== 0 ? E = E.umod(w) : E = E.clone();
      for (var W = new s(1), _ = new s(0), R = U.clone(); E.cmpn(1) > 0 && U.cmpn(1) > 0; ) {
        for (var N = 0, O = 1; !(E.words[0] & O) && N < 26; ++N, O <<= 1)
          ;
        if (N > 0)
          for (E.iushrn(N); N-- > 0; )
            W.isOdd() && W.iadd(R), W.iushrn(1);
        for (var g = 0, M = 1; !(U.words[0] & M) && g < 26; ++g, M <<= 1)
          ;
        if (g > 0)
          for (U.iushrn(g); g-- > 0; )
            _.isOdd() && _.iadd(R), _.iushrn(1);
        E.cmp(U) >= 0 ? (E.isub(U), W.isub(_)) : (U.isub(E), _.isub(W));
      }
      var Y;
      return E.cmpn(1) === 0 ? Y = W : Y = _, Y.cmpn(0) < 0 && Y.iadd(w), Y;
    }, s.prototype.gcd = function(w) {
      if (this.isZero())
        return w.abs();
      if (w.isZero())
        return this.abs();
      var E = this.clone(), U = w.clone();
      E.negative = 0, U.negative = 0;
      for (var W = 0; E.isEven() && U.isEven(); W++)
        E.iushrn(1), U.iushrn(1);
      do {
        for (; E.isEven(); )
          E.iushrn(1);
        for (; U.isEven(); )
          U.iushrn(1);
        var _ = E.cmp(U);
        if (_ < 0) {
          var R = E;
          E = U, U = R;
        } else if (_ === 0 || U.cmpn(1) === 0)
          break;
        E.isub(U);
      } while (!0);
      return U.iushln(W);
    }, s.prototype.invm = function(w) {
      return this.egcd(w).a.umod(w);
    }, s.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, s.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, s.prototype.andln = function(w) {
      return this.words[0] & w;
    }, s.prototype.bincn = function(w) {
      n(typeof w == "number");
      var E = w % 26, U = (w - E) / 26, W = 1 << E;
      if (this.length <= U)
        return this._expand(U + 1), this.words[U] |= W, this;
      for (var _ = W, R = U; _ !== 0 && R < this.length; R++) {
        var N = this.words[R] | 0;
        N += _, _ = N >>> 26, N &= 67108863, this.words[R] = N;
      }
      return _ !== 0 && (this.words[R] = _, this.length++), this;
    }, s.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, s.prototype.cmpn = function(w) {
      var E = w < 0;
      if (this.negative !== 0 && !E)
        return -1;
      if (this.negative === 0 && E)
        return 1;
      this._strip();
      var U;
      if (this.length > 1)
        U = 1;
      else {
        E && (w = -w), n(w <= 67108863, "Number is too big");
        var W = this.words[0] | 0;
        U = W === w ? 0 : W < w ? -1 : 1;
      }
      return this.negative !== 0 ? -U | 0 : U;
    }, s.prototype.cmp = function(w) {
      if (this.negative !== 0 && w.negative === 0)
        return -1;
      if (this.negative === 0 && w.negative !== 0)
        return 1;
      var E = this.ucmp(w);
      return this.negative !== 0 ? -E | 0 : E;
    }, s.prototype.ucmp = function(w) {
      if (this.length > w.length)
        return 1;
      if (this.length < w.length)
        return -1;
      for (var E = 0, U = this.length - 1; U >= 0; U--) {
        var W = this.words[U] | 0, _ = w.words[U] | 0;
        if (W !== _) {
          W < _ ? E = -1 : W > _ && (E = 1);
          break;
        }
      }
      return E;
    }, s.prototype.gtn = function(w) {
      return this.cmpn(w) === 1;
    }, s.prototype.gt = function(w) {
      return this.cmp(w) === 1;
    }, s.prototype.gten = function(w) {
      return this.cmpn(w) >= 0;
    }, s.prototype.gte = function(w) {
      return this.cmp(w) >= 0;
    }, s.prototype.ltn = function(w) {
      return this.cmpn(w) === -1;
    }, s.prototype.lt = function(w) {
      return this.cmp(w) === -1;
    }, s.prototype.lten = function(w) {
      return this.cmpn(w) <= 0;
    }, s.prototype.lte = function(w) {
      return this.cmp(w) <= 0;
    }, s.prototype.eqn = function(w) {
      return this.cmpn(w) === 0;
    }, s.prototype.eq = function(w) {
      return this.cmp(w) === 0;
    }, s.red = function(w) {
      return new ie(w);
    }, s.prototype.toRed = function(w) {
      return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), w.convertTo(this)._forceRed(w);
    }, s.prototype.fromRed = function() {
      return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, s.prototype._forceRed = function(w) {
      return this.red = w, this;
    }, s.prototype.forceRed = function(w) {
      return n(!this.red, "Already a number in reduction context"), this._forceRed(w);
    }, s.prototype.redAdd = function(w) {
      return n(this.red, "redAdd works only with red numbers"), this.red.add(this, w);
    }, s.prototype.redIAdd = function(w) {
      return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, w);
    }, s.prototype.redSub = function(w) {
      return n(this.red, "redSub works only with red numbers"), this.red.sub(this, w);
    }, s.prototype.redISub = function(w) {
      return n(this.red, "redISub works only with red numbers"), this.red.isub(this, w);
    }, s.prototype.redShl = function(w) {
      return n(this.red, "redShl works only with red numbers"), this.red.shl(this, w);
    }, s.prototype.redMul = function(w) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, w), this.red.mul(this, w);
    }, s.prototype.redIMul = function(w) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, w), this.red.imul(this, w);
    }, s.prototype.redSqr = function() {
      return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, s.prototype.redISqr = function() {
      return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, s.prototype.redSqrt = function() {
      return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, s.prototype.redInvm = function() {
      return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, s.prototype.redNeg = function() {
      return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, s.prototype.redPow = function(w) {
      return n(this.red && !w.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, w);
    };
    var P = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function C($, w) {
      this.name = $, this.p = new s(w, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    C.prototype._tmp = function() {
      var w = new s(null);
      return w.words = new Array(Math.ceil(this.n / 13)), w;
    }, C.prototype.ireduce = function(w) {
      var E = w, U;
      do
        this.split(E, this.tmp), E = this.imulK(E), E = E.iadd(this.tmp), U = E.bitLength();
      while (U > this.n);
      var W = U < this.n ? -1 : E.ucmp(this.p);
      return W === 0 ? (E.words[0] = 0, E.length = 1) : W > 0 ? E.isub(this.p) : E.strip !== void 0 ? E.strip() : E._strip(), E;
    }, C.prototype.split = function(w, E) {
      w.iushrn(this.n, 0, E);
    }, C.prototype.imulK = function(w) {
      return w.imul(this.k);
    };
    function D() {
      C.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    i(D, C), D.prototype.split = function(w, E) {
      for (var U = 4194303, W = Math.min(w.length, 9), _ = 0; _ < W; _++)
        E.words[_] = w.words[_];
      if (E.length = W, w.length <= 9) {
        w.words[0] = 0, w.length = 1;
        return;
      }
      var R = w.words[9];
      for (E.words[E.length++] = R & U, _ = 10; _ < w.length; _++) {
        var N = w.words[_] | 0;
        w.words[_ - 10] = (N & U) << 4 | R >>> 22, R = N;
      }
      R >>>= 22, w.words[_ - 10] = R, R === 0 && w.length > 10 ? w.length -= 10 : w.length -= 9;
    }, D.prototype.imulK = function(w) {
      w.words[w.length] = 0, w.words[w.length + 1] = 0, w.length += 2;
      for (var E = 0, U = 0; U < w.length; U++) {
        var W = w.words[U] | 0;
        E += W * 977, w.words[U] = E & 67108863, E = W * 64 + (E / 67108864 | 0);
      }
      return w.words[w.length - 1] === 0 && (w.length--, w.words[w.length - 1] === 0 && w.length--), w;
    };
    function F() {
      C.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    i(F, C);
    function G() {
      C.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    i(G, C);
    function re() {
      C.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    i(re, C), re.prototype.imulK = function(w) {
      for (var E = 0, U = 0; U < w.length; U++) {
        var W = (w.words[U] | 0) * 19 + E, _ = W & 67108863;
        W >>>= 26, w.words[U] = _, E = W;
      }
      return E !== 0 && (w.words[w.length++] = E), w;
    }, s._prime = function(w) {
      if (P[w])
        return P[w];
      var E;
      if (w === "k256")
        E = new D();
      else if (w === "p224")
        E = new F();
      else if (w === "p192")
        E = new G();
      else if (w === "p25519")
        E = new re();
      else
        throw new Error("Unknown prime " + w);
      return P[w] = E, E;
    };
    function ie($) {
      if (typeof $ == "string") {
        var w = s._prime($);
        this.m = w.p, this.prime = w;
      } else
        n($.gtn(1), "modulus must be greater than 1"), this.m = $, this.prime = null;
    }
    ie.prototype._verify1 = function(w) {
      n(w.negative === 0, "red works only with positives"), n(w.red, "red works only with red numbers");
    }, ie.prototype._verify2 = function(w, E) {
      n((w.negative | E.negative) === 0, "red works only with positives"), n(
        w.red && w.red === E.red,
        "red works only with red numbers"
      );
    }, ie.prototype.imod = function(w) {
      return this.prime ? this.prime.ireduce(w)._forceRed(this) : (u(w, w.umod(this.m)._forceRed(this)), w);
    }, ie.prototype.neg = function(w) {
      return w.isZero() ? w.clone() : this.m.sub(w)._forceRed(this);
    }, ie.prototype.add = function(w, E) {
      this._verify2(w, E);
      var U = w.add(E);
      return U.cmp(this.m) >= 0 && U.isub(this.m), U._forceRed(this);
    }, ie.prototype.iadd = function(w, E) {
      this._verify2(w, E);
      var U = w.iadd(E);
      return U.cmp(this.m) >= 0 && U.isub(this.m), U;
    }, ie.prototype.sub = function(w, E) {
      this._verify2(w, E);
      var U = w.sub(E);
      return U.cmpn(0) < 0 && U.iadd(this.m), U._forceRed(this);
    }, ie.prototype.isub = function(w, E) {
      this._verify2(w, E);
      var U = w.isub(E);
      return U.cmpn(0) < 0 && U.iadd(this.m), U;
    }, ie.prototype.shl = function(w, E) {
      return this._verify1(w), this.imod(w.ushln(E));
    }, ie.prototype.imul = function(w, E) {
      return this._verify2(w, E), this.imod(w.imul(E));
    }, ie.prototype.mul = function(w, E) {
      return this._verify2(w, E), this.imod(w.mul(E));
    }, ie.prototype.isqr = function(w) {
      return this.imul(w, w.clone());
    }, ie.prototype.sqr = function(w) {
      return this.mul(w, w);
    }, ie.prototype.sqrt = function(w) {
      if (w.isZero())
        return w.clone();
      var E = this.m.andln(3);
      if (n(E % 2 === 1), E === 3) {
        var U = this.m.add(new s(1)).iushrn(2);
        return this.pow(w, U);
      }
      for (var W = this.m.subn(1), _ = 0; !W.isZero() && W.andln(1) === 0; )
        _++, W.iushrn(1);
      n(!W.isZero());
      var R = new s(1).toRed(this), N = R.redNeg(), O = this.m.subn(1).iushrn(1), g = this.m.bitLength();
      for (g = new s(2 * g * g).toRed(this); this.pow(g, O).cmp(N) !== 0; )
        g.redIAdd(N);
      for (var M = this.pow(g, W), Y = this.pow(w, W.addn(1).iushrn(1)), se = this.pow(w, W), V = _; se.cmp(R) !== 0; ) {
        for (var K = se, Z = 0; K.cmp(R) !== 0; Z++)
          K = K.redSqr();
        n(Z < V);
        var ne = this.pow(M, new s(1).iushln(V - Z - 1));
        Y = Y.redMul(ne), M = ne.redSqr(), se = se.redMul(M), V = Z;
      }
      return Y;
    }, ie.prototype.invm = function(w) {
      var E = w._invmp(this.m);
      return E.negative !== 0 ? (E.negative = 0, this.imod(E).redNeg()) : this.imod(E);
    }, ie.prototype.pow = function(w, E) {
      if (E.isZero())
        return new s(1).toRed(this);
      if (E.cmpn(1) === 0)
        return w.clone();
      var U = 4, W = new Array(1 << U);
      W[0] = new s(1).toRed(this), W[1] = w;
      for (var _ = 2; _ < W.length; _++)
        W[_] = this.mul(W[_ - 1], w);
      var R = W[0], N = 0, O = 0, g = E.bitLength() % 26;
      for (g === 0 && (g = 26), _ = E.length - 1; _ >= 0; _--) {
        for (var M = E.words[_], Y = g - 1; Y >= 0; Y--) {
          var se = M >> Y & 1;
          if (R !== W[0] && (R = this.sqr(R)), se === 0 && N === 0) {
            O = 0;
            continue;
          }
          N <<= 1, N |= se, O++, !(O !== U && (_ !== 0 || Y !== 0)) && (R = this.mul(R, W[N]), O = 0, N = 0);
        }
        g = 26;
      }
      return R;
    }, ie.prototype.convertTo = function(w) {
      var E = w.umod(this.m);
      return E === w ? E.clone() : E;
    }, ie.prototype.convertFrom = function(w) {
      var E = w.clone();
      return E.red = null, E;
    }, s.mont = function(w) {
      return new ee(w);
    };
    function ee($) {
      ie.call(this, $), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    i(ee, ie), ee.prototype.convertTo = function(w) {
      return this.imod(w.ushln(this.shift));
    }, ee.prototype.convertFrom = function(w) {
      var E = this.imod(w.mul(this.rinv));
      return E.red = null, E;
    }, ee.prototype.imul = function(w, E) {
      if (w.isZero() || E.isZero())
        return w.words[0] = 0, w.length = 1, w;
      var U = w.imul(E), W = U.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = U.isub(W).iushrn(this.shift), R = _;
      return _.cmp(this.m) >= 0 ? R = _.isub(this.m) : _.cmpn(0) < 0 && (R = _.iadd(this.m)), R._forceRed(this);
    }, ee.prototype.mul = function(w, E) {
      if (w.isZero() || E.isZero())
        return new s(0)._forceRed(this);
      var U = w.mul(E), W = U.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = U.isub(W).iushrn(this.shift), R = _;
      return _.cmp(this.m) >= 0 ? R = _.isub(this.m) : _.cmpn(0) < 0 && (R = _.iadd(this.m)), R._forceRed(this);
    }, ee.prototype.invm = function(w) {
      var E = this.imod(w._invmp(this.m).mul(this.r2));
      return E._forceRed(this);
    };
  })(t, Ne);
})(F2);
var Tr = F2.exports;
const Ss = /* @__PURE__ */ Ln(Tr);
var ch = { exports: {} }, yS;
function j2() {
  if (yS)
    return ch.exports;
  yS = 1;
  var t;
  ch.exports = function(i) {
    return t || (t = new e(null)), t.generate(i);
  };
  function e(n) {
    this.rand = n;
  }
  if (ch.exports.Rand = e, e.prototype.generate = function(i) {
    return this._rand(i);
  }, e.prototype._rand = function(i) {
    if (this.rand.getBytes)
      return this.rand.getBytes(i);
    for (var s = new Uint8Array(i), a = 0; a < s.length; a++)
      s[a] = this.rand.getByte();
    return s;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? e.prototype._rand = function(i) {
      var s = new Uint8Array(i);
      return self.crypto.getRandomValues(s), s;
    } : self.msCrypto && self.msCrypto.getRandomValues ? e.prototype._rand = function(i) {
      var s = new Uint8Array(i);
      return self.msCrypto.getRandomValues(s), s;
    } : typeof window == "object" && (e.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var r = H2();
      if (typeof r.randomBytes != "function")
        throw new Error("Not supported");
      e.prototype._rand = function(i) {
        return r.randomBytes(i);
      };
    } catch {
    }
  return ch.exports;
}
var Y1, bS;
function r5() {
  if (bS)
    return Y1;
  bS = 1;
  var t = Tr, e = j2();
  function r(n) {
    this.rand = n || new e.Rand();
  }
  return Y1 = r, r.create = function(i) {
    return new r(i);
  }, r.prototype._randbelow = function(i) {
    var s = i.bitLength(), a = Math.ceil(s / 8);
    do
      var o = new t(this.rand.generate(a));
    while (o.cmp(i) >= 0);
    return o;
  }, r.prototype._randrange = function(i, s) {
    var a = s.sub(i);
    return i.add(this._randbelow(a));
  }, r.prototype.test = function(i, s, a) {
    var o = i.bitLength(), c = t.mont(i), f = new t(1).toRed(c);
    s || (s = Math.max(1, o / 48 | 0));
    for (var u = i.subn(1), d = 0; !u.testn(d); d++)
      ;
    for (var l = i.shrn(d), h = u.toRed(c), y = !0; s > 0; s--) {
      var p = this._randrange(new t(2), u);
      a && a(p);
      var b = p.toRed(c).redPow(l);
      if (!(b.cmp(f) === 0 || b.cmp(h) === 0)) {
        for (var v = 1; v < d; v++) {
          if (b = b.redSqr(), b.cmp(f) === 0)
            return !1;
          if (b.cmp(h) === 0)
            break;
        }
        if (v === d)
          return !1;
      }
    }
    return y;
  }, r.prototype.getDivisor = function(i, s) {
    var a = i.bitLength(), o = t.mont(i), c = new t(1).toRed(o);
    s || (s = Math.max(1, a / 48 | 0));
    for (var f = i.subn(1), u = 0; !f.testn(u); u++)
      ;
    for (var d = i.shrn(u), l = f.toRed(o); s > 0; s--) {
      var h = this._randrange(new t(2), f), y = i.gcd(h);
      if (y.cmpn(1) !== 0)
        return y;
      var p = h.toRed(o).redPow(d);
      if (!(p.cmp(c) === 0 || p.cmp(l) === 0)) {
        for (var b = 1; b < u; b++) {
          if (p = p.redSqr(), p.cmp(c) === 0)
            return p.fromRed().subn(1).gcd(i);
          if (p.cmp(l) === 0)
            break;
        }
        if (b === u)
          return p = p.redSqr(), p.fromRed().subn(1).gcd(i);
      }
    }
    return !1;
  }, Y1;
}
var Q1, gS;
function n5() {
  if (gS)
    return Q1;
  gS = 1;
  var t = hf();
  Q1 = b, b.simpleSieve = y, b.fermatTest = p;
  var e = Tr, r = new e(24), n = r5(), i = new n(), s = new e(1), a = new e(2), o = new e(5);
  new e(16), new e(8);
  var c = new e(10), f = new e(3);
  new e(7);
  var u = new e(11), d = new e(4);
  new e(12);
  var l = null;
  function h() {
    if (l !== null)
      return l;
    var v = 1048576, x = [];
    x[0] = 2;
    for (var I = 1, L = 3; L < v; L += 2) {
      for (var P = Math.ceil(Math.sqrt(L)), C = 0; C < I && x[C] <= P && L % x[C] !== 0; C++)
        ;
      I !== C && x[C] <= P || (x[I++] = L);
    }
    return l = x, x;
  }
  function y(v) {
    for (var x = h(), I = 0; I < x.length; I++)
      if (v.modn(x[I]) === 0)
        return v.cmpn(x[I]) === 0;
    return !0;
  }
  function p(v) {
    var x = e.mont(v);
    return a.toRed(x).redPow(v.subn(1)).fromRed().cmpn(1) === 0;
  }
  function b(v, x) {
    if (v < 16)
      return x === 2 || x === 5 ? new e([140, 123]) : new e([140, 39]);
    x = new e(x);
    for (var I, L; ; ) {
      for (I = new e(t(Math.ceil(v / 8))); I.bitLength() > v; )
        I.ishrn(1);
      if (I.isEven() && I.iadd(s), I.testn(1) || I.iadd(a), x.cmp(a)) {
        if (!x.cmp(o))
          for (; I.mod(c).cmp(f); )
            I.iadd(d);
      } else
        for (; I.mod(r).cmp(u); )
          I.iadd(d);
      if (L = I.shrn(1), y(L) && y(I) && p(L) && p(I) && i.test(L) && i.test(I))
        return I;
    }
  }
  return Q1;
}
const cC = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, uC = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, fC = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, dC = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, lC = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, hC = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, pC = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, yC = {
  gen: "02",
  prime: "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"
}, bC = {
  modp1: cC,
  modp2: uC,
  modp5: fC,
  modp14: dC,
  modp15: lC,
  modp16: hC,
  modp17: pC,
  modp18: yC
};
var X1, mS;
function gC() {
  if (mS)
    return X1;
  mS = 1;
  var t = Tr, e = r5(), r = new e(), n = new t(24), i = new t(11), s = new t(10), a = new t(3), o = new t(7), c = n5(), f = hf();
  X1 = y;
  function u(b, v) {
    return v = v || "utf8", ve.isBuffer(b) || (b = new ve(b, v)), this._pub = new t(b), this;
  }
  function d(b, v) {
    return v = v || "utf8", ve.isBuffer(b) || (b = new ve(b, v)), this._priv = new t(b), this;
  }
  var l = {};
  function h(b, v) {
    var x = v.toString("hex"), I = [x, b.toString(16)].join("_");
    if (I in l)
      return l[I];
    var L = 0;
    if (b.isEven() || !c.simpleSieve || !c.fermatTest(b) || !r.test(b))
      return L += 1, x === "02" || x === "05" ? L += 8 : L += 4, l[I] = L, L;
    r.test(b.shrn(1)) || (L += 2);
    var P;
    switch (x) {
      case "02":
        b.mod(n).cmp(i) && (L += 8);
        break;
      case "05":
        P = b.mod(s), P.cmp(a) && P.cmp(o) && (L += 8);
        break;
      default:
        L += 4;
    }
    return l[I] = L, L;
  }
  function y(b, v, x) {
    this.setGenerator(v), this.__prime = new t(b), this._prime = t.mont(this.__prime), this._primeLen = b.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, x ? (this.setPublicKey = u, this.setPrivateKey = d) : this._primeCode = 8;
  }
  Object.defineProperty(y.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = h(this.__prime, this.__gen)), this._primeCode;
    }
  }), y.prototype.generateKeys = function() {
    return this._priv || (this._priv = new t(f(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, y.prototype.computeSecret = function(b) {
    b = new t(b), b = b.toRed(this._prime);
    var v = b.redPow(this._priv).fromRed(), x = new ve(v.toArray()), I = this.getPrime();
    if (x.length < I.length) {
      var L = new ve(I.length - x.length);
      L.fill(0), x = ve.concat([L, x]);
    }
    return x;
  }, y.prototype.getPublicKey = function(v) {
    return p(this._pub, v);
  }, y.prototype.getPrivateKey = function(v) {
    return p(this._priv, v);
  }, y.prototype.getPrime = function(b) {
    return p(this.__prime, b);
  }, y.prototype.getGenerator = function(b) {
    return p(this._gen, b);
  }, y.prototype.setGenerator = function(b, v) {
    return v = v || "utf8", ve.isBuffer(b) || (b = new ve(b, v)), this.__gen = b, this._gen = new t(b), this;
  };
  function p(b, v) {
    var x = new ve(b.toArray());
    return v ? x.toString(v) : x;
  }
  return X1;
}
var vS;
function mC() {
  if (vS)
    return Mo;
  vS = 1;
  var t = n5(), e = bC, r = gC();
  function n(a) {
    var o = new ve(e[a].prime, "hex"), c = new ve(e[a].gen, "hex");
    return new r(o, c);
  }
  var i = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function s(a, o, c, f) {
    return ve.isBuffer(o) || i[o] === void 0 ? s(a, "binary", o, c) : (o = o || "binary", f = f || "binary", c = c || new ve([2]), ve.isBuffer(c) || (c = new ve(c, f)), typeof a == "number" ? new r(t(a, c), c, !0) : (ve.isBuffer(a) || (a = new ve(a, o)), new r(a, c, !0)));
  }
  return Mo.DiffieHellmanGroup = Mo.createDiffieHellmanGroup = Mo.getDiffieHellman = n, Mo.createDiffieHellman = Mo.DiffieHellman = s, Mo;
}
var $f = { exports: {} }, eb, wS;
function $2() {
  if (wS)
    return eb;
  wS = 1;
  var t = Tr, e = hf();
  function r(s) {
    var a = n(s), o = a.toRed(t.mont(s.modulus)).redPow(new t(s.publicExponent)).fromRed();
    return { blinder: o, unblinder: a.invm(s.modulus) };
  }
  function n(s) {
    var a = s.modulus.byteLength(), o;
    do
      o = new t(e(a));
    while (o.cmp(s.modulus) >= 0 || !o.umod(s.prime1) || !o.umod(s.prime2));
    return o;
  }
  function i(s, a) {
    var o = r(a), c = a.modulus.byteLength(), f = new t(s).mul(o.blinder).umod(a.modulus), u = f.toRed(t.mont(a.prime1)), d = f.toRed(t.mont(a.prime2)), l = a.coefficient, h = a.prime1, y = a.prime2, p = u.redPow(a.exponent1).fromRed(), b = d.redPow(a.exponent2).fromRed(), v = p.isub(b).imul(l).umod(h).imul(y);
    return b.iadd(v).imul(o.unblinder).umod(a.modulus).toArrayLike(ve, "be", c);
  }
  return i.getr = n, eb = i, eb;
}
var tb = {};
const vC = "elliptic", wC = "6.5.4", _C = "EC cryptography", SC = "lib/elliptic.js", EC = [
  "lib"
], xC = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, AC = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, IC = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], TC = "Fedor Indutny <fedor@indutny.com>", kC = "MIT", RC = {
  url: "https://github.com/indutny/elliptic/issues"
}, PC = "https://github.com/indutny/elliptic", OC = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, BC = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, MC = {
  name: vC,
  version: wC,
  description: _C,
  main: SC,
  files: EC,
  scripts: xC,
  repository: AC,
  keywords: IC,
  author: TC,
  license: kC,
  bugs: RC,
  homepage: PC,
  devDependencies: OC,
  dependencies: BC
};
var rb = {}, nb = {}, _S;
function i5() {
  return _S || (_S = 1, function(t) {
    var e = t;
    function r(s, a) {
      if (Array.isArray(s))
        return s.slice();
      if (!s)
        return [];
      var o = [];
      if (typeof s != "string") {
        for (var c = 0; c < s.length; c++)
          o[c] = s[c] | 0;
        return o;
      }
      if (a === "hex") {
        s = s.replace(/[^a-z0-9]+/ig, ""), s.length % 2 !== 0 && (s = "0" + s);
        for (var c = 0; c < s.length; c += 2)
          o.push(parseInt(s[c] + s[c + 1], 16));
      } else
        for (var c = 0; c < s.length; c++) {
          var f = s.charCodeAt(c), u = f >> 8, d = f & 255;
          u ? o.push(u, d) : o.push(d);
        }
      return o;
    }
    e.toArray = r;
    function n(s) {
      return s.length === 1 ? "0" + s : s;
    }
    e.zero2 = n;
    function i(s) {
      for (var a = "", o = 0; o < s.length; o++)
        a += n(s[o].toString(16));
      return a;
    }
    e.toHex = i, e.encode = function(a, o) {
      return o === "hex" ? i(a) : a;
    };
  }(nb)), nb;
}
var SS;
function us() {
  return SS || (SS = 1, function(t) {
    var e = t, r = Tr, n = hr, i = i5();
    e.assert = n, e.toArray = i.toArray, e.zero2 = i.zero2, e.toHex = i.toHex, e.encode = i.encode;
    function s(u, d, l) {
      var h = new Array(Math.max(u.bitLength(), l) + 1);
      h.fill(0);
      for (var y = 1 << d + 1, p = u.clone(), b = 0; b < h.length; b++) {
        var v, x = p.andln(y - 1);
        p.isOdd() ? (x > (y >> 1) - 1 ? v = (y >> 1) - x : v = x, p.isubn(v)) : v = 0, h[b] = v, p.iushrn(1);
      }
      return h;
    }
    e.getNAF = s;
    function a(u, d) {
      var l = [
        [],
        []
      ];
      u = u.clone(), d = d.clone();
      for (var h = 0, y = 0, p; u.cmpn(-h) > 0 || d.cmpn(-y) > 0; ) {
        var b = u.andln(3) + h & 3, v = d.andln(3) + y & 3;
        b === 3 && (b = -1), v === 3 && (v = -1);
        var x;
        b & 1 ? (p = u.andln(7) + h & 7, (p === 3 || p === 5) && v === 2 ? x = -b : x = b) : x = 0, l[0].push(x);
        var I;
        v & 1 ? (p = d.andln(7) + y & 7, (p === 3 || p === 5) && b === 2 ? I = -v : I = v) : I = 0, l[1].push(I), 2 * h === x + 1 && (h = 1 - h), 2 * y === I + 1 && (y = 1 - y), u.iushrn(1), d.iushrn(1);
      }
      return l;
    }
    e.getJSF = a;
    function o(u, d, l) {
      var h = "_" + d;
      u.prototype[d] = function() {
        return this[h] !== void 0 ? this[h] : this[h] = l.call(this);
      };
    }
    e.cachedProperty = o;
    function c(u) {
      return typeof u == "string" ? e.toArray(u, "hex") : u;
    }
    e.parseBytes = c;
    function f(u) {
      return new r(u, "hex", "le");
    }
    e.intFromLE = f;
  }(rb)), rb;
}
var ib = {}, sb, ES;
function M0() {
  if (ES)
    return sb;
  ES = 1;
  var t = Tr, e = us(), r = e.getNAF, n = e.getJSF, i = e.assert;
  function s(o, c) {
    this.type = o, this.p = new t(c.p, 16), this.red = c.prime ? t.red(c.prime) : t.mont(this.p), this.zero = new t(0).toRed(this.red), this.one = new t(1).toRed(this.red), this.two = new t(2).toRed(this.red), this.n = c.n && new t(c.n, 16), this.g = c.g && this.pointFromJSON(c.g, c.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var f = this.n && this.p.div(this.n);
    !f || f.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  sb = s, s.prototype.point = function() {
    throw new Error("Not implemented");
  }, s.prototype.validate = function() {
    throw new Error("Not implemented");
  }, s.prototype._fixedNafMul = function(c, f) {
    i(c.precomputed);
    var u = c._getDoubles(), d = r(f, 1, this._bitLength), l = (1 << u.step + 1) - (u.step % 2 === 0 ? 2 : 1);
    l /= 3;
    var h = [], y, p;
    for (y = 0; y < d.length; y += u.step) {
      p = 0;
      for (var b = y + u.step - 1; b >= y; b--)
        p = (p << 1) + d[b];
      h.push(p);
    }
    for (var v = this.jpoint(null, null, null), x = this.jpoint(null, null, null), I = l; I > 0; I--) {
      for (y = 0; y < h.length; y++)
        p = h[y], p === I ? x = x.mixedAdd(u.points[y]) : p === -I && (x = x.mixedAdd(u.points[y].neg()));
      v = v.add(x);
    }
    return v.toP();
  }, s.prototype._wnafMul = function(c, f) {
    var u = 4, d = c._getNAFPoints(u);
    u = d.wnd;
    for (var l = d.points, h = r(f, u, this._bitLength), y = this.jpoint(null, null, null), p = h.length - 1; p >= 0; p--) {
      for (var b = 0; p >= 0 && h[p] === 0; p--)
        b++;
      if (p >= 0 && b++, y = y.dblp(b), p < 0)
        break;
      var v = h[p];
      i(v !== 0), c.type === "affine" ? v > 0 ? y = y.mixedAdd(l[v - 1 >> 1]) : y = y.mixedAdd(l[-v - 1 >> 1].neg()) : v > 0 ? y = y.add(l[v - 1 >> 1]) : y = y.add(l[-v - 1 >> 1].neg());
    }
    return c.type === "affine" ? y.toP() : y;
  }, s.prototype._wnafMulAdd = function(c, f, u, d, l) {
    var h = this._wnafT1, y = this._wnafT2, p = this._wnafT3, b = 0, v, x, I;
    for (v = 0; v < d; v++) {
      I = f[v];
      var L = I._getNAFPoints(c);
      h[v] = L.wnd, y[v] = L.points;
    }
    for (v = d - 1; v >= 1; v -= 2) {
      var P = v - 1, C = v;
      if (h[P] !== 1 || h[C] !== 1) {
        p[P] = r(u[P], h[P], this._bitLength), p[C] = r(u[C], h[C], this._bitLength), b = Math.max(p[P].length, b), b = Math.max(p[C].length, b);
        continue;
      }
      var D = [
        f[P],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        f[C]
        /* 7 */
      ];
      f[P].y.cmp(f[C].y) === 0 ? (D[1] = f[P].add(f[C]), D[2] = f[P].toJ().mixedAdd(f[C].neg())) : f[P].y.cmp(f[C].y.redNeg()) === 0 ? (D[1] = f[P].toJ().mixedAdd(f[C]), D[2] = f[P].add(f[C].neg())) : (D[1] = f[P].toJ().mixedAdd(f[C]), D[2] = f[P].toJ().mixedAdd(f[C].neg()));
      var F = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], G = n(u[P], u[C]);
      for (b = Math.max(G[0].length, b), p[P] = new Array(b), p[C] = new Array(b), x = 0; x < b; x++) {
        var re = G[0][x] | 0, ie = G[1][x] | 0;
        p[P][x] = F[(re + 1) * 3 + (ie + 1)], p[C][x] = 0, y[P] = D;
      }
    }
    var ee = this.jpoint(null, null, null), $ = this._wnafT4;
    for (v = b; v >= 0; v--) {
      for (var w = 0; v >= 0; ) {
        var E = !0;
        for (x = 0; x < d; x++)
          $[x] = p[x][v] | 0, $[x] !== 0 && (E = !1);
        if (!E)
          break;
        w++, v--;
      }
      if (v >= 0 && w++, ee = ee.dblp(w), v < 0)
        break;
      for (x = 0; x < d; x++) {
        var U = $[x];
        U !== 0 && (U > 0 ? I = y[x][U - 1 >> 1] : U < 0 && (I = y[x][-U - 1 >> 1].neg()), I.type === "affine" ? ee = ee.mixedAdd(I) : ee = ee.add(I));
      }
    }
    for (v = 0; v < d; v++)
      y[v] = null;
    return l ? ee : ee.toP();
  };
  function a(o, c) {
    this.curve = o, this.type = c, this.precomputed = null;
  }
  return s.BasePoint = a, a.prototype.eq = function() {
    throw new Error("Not implemented");
  }, a.prototype.validate = function() {
    return this.curve.validate(this);
  }, s.prototype.decodePoint = function(c, f) {
    c = e.toArray(c, f);
    var u = this.p.byteLength();
    if ((c[0] === 4 || c[0] === 6 || c[0] === 7) && c.length - 1 === 2 * u) {
      c[0] === 6 ? i(c[c.length - 1] % 2 === 0) : c[0] === 7 && i(c[c.length - 1] % 2 === 1);
      var d = this.point(
        c.slice(1, 1 + u),
        c.slice(1 + u, 1 + 2 * u)
      );
      return d;
    } else if ((c[0] === 2 || c[0] === 3) && c.length - 1 === u)
      return this.pointFromX(c.slice(1, 1 + u), c[0] === 3);
    throw new Error("Unknown point format");
  }, a.prototype.encodeCompressed = function(c) {
    return this.encode(c, !0);
  }, a.prototype._encode = function(c) {
    var f = this.curve.p.byteLength(), u = this.getX().toArray("be", f);
    return c ? [this.getY().isEven() ? 2 : 3].concat(u) : [4].concat(u, this.getY().toArray("be", f));
  }, a.prototype.encode = function(c, f) {
    return e.encode(this._encode(f), c);
  }, a.prototype.precompute = function(c) {
    if (this.precomputed)
      return this;
    var f = {
      doubles: null,
      naf: null,
      beta: null
    };
    return f.naf = this._getNAFPoints(8), f.doubles = this._getDoubles(4, c), f.beta = this._getBeta(), this.precomputed = f, this;
  }, a.prototype._hasDoubles = function(c) {
    if (!this.precomputed)
      return !1;
    var f = this.precomputed.doubles;
    return f ? f.points.length >= Math.ceil((c.bitLength() + 1) / f.step) : !1;
  }, a.prototype._getDoubles = function(c, f) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var u = [this], d = this, l = 0; l < f; l += c) {
      for (var h = 0; h < c; h++)
        d = d.dbl();
      u.push(d);
    }
    return {
      step: c,
      points: u
    };
  }, a.prototype._getNAFPoints = function(c) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var f = [this], u = (1 << c) - 1, d = u === 1 ? null : this.dbl(), l = 1; l < u; l++)
      f[l] = f[l - 1].add(d);
    return {
      wnd: c,
      points: f
    };
  }, a.prototype._getBeta = function() {
    return null;
  }, a.prototype.dblp = function(c) {
    for (var f = this, u = 0; u < c; u++)
      f = f.dbl();
    return f;
  }, sb;
}
var ab, xS;
function CC() {
  if (xS)
    return ab;
  xS = 1;
  var t = us(), e = Tr, r = Kt, n = M0(), i = t.assert;
  function s(c) {
    n.call(this, "short", c), this.a = new e(c.a, 16).toRed(this.red), this.b = new e(c.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(c), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  r(s, n), ab = s, s.prototype._getEndomorphism = function(f) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var u, d;
      if (f.beta)
        u = new e(f.beta, 16).toRed(this.red);
      else {
        var l = this._getEndoRoots(this.p);
        u = l[0].cmp(l[1]) < 0 ? l[0] : l[1], u = u.toRed(this.red);
      }
      if (f.lambda)
        d = new e(f.lambda, 16);
      else {
        var h = this._getEndoRoots(this.n);
        this.g.mul(h[0]).x.cmp(this.g.x.redMul(u)) === 0 ? d = h[0] : (d = h[1], i(this.g.mul(d).x.cmp(this.g.x.redMul(u)) === 0));
      }
      var y;
      return f.basis ? y = f.basis.map(function(p) {
        return {
          a: new e(p.a, 16),
          b: new e(p.b, 16)
        };
      }) : y = this._getEndoBasis(d), {
        beta: u,
        lambda: d,
        basis: y
      };
    }
  }, s.prototype._getEndoRoots = function(f) {
    var u = f === this.p ? this.red : e.mont(f), d = new e(2).toRed(u).redInvm(), l = d.redNeg(), h = new e(3).toRed(u).redNeg().redSqrt().redMul(d), y = l.redAdd(h).fromRed(), p = l.redSub(h).fromRed();
    return [y, p];
  }, s.prototype._getEndoBasis = function(f) {
    for (var u = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), d = f, l = this.n.clone(), h = new e(1), y = new e(0), p = new e(0), b = new e(1), v, x, I, L, P, C, D, F = 0, G, re; d.cmpn(0) !== 0; ) {
      var ie = l.div(d);
      G = l.sub(ie.mul(d)), re = p.sub(ie.mul(h));
      var ee = b.sub(ie.mul(y));
      if (!I && G.cmp(u) < 0)
        v = D.neg(), x = h, I = G.neg(), L = re;
      else if (I && ++F === 2)
        break;
      D = G, l = d, d = G, p = h, h = re, b = y, y = ee;
    }
    P = G.neg(), C = re;
    var $ = I.sqr().add(L.sqr()), w = P.sqr().add(C.sqr());
    return w.cmp($) >= 0 && (P = v, C = x), I.negative && (I = I.neg(), L = L.neg()), P.negative && (P = P.neg(), C = C.neg()), [
      { a: I, b: L },
      { a: P, b: C }
    ];
  }, s.prototype._endoSplit = function(f) {
    var u = this.endo.basis, d = u[0], l = u[1], h = l.b.mul(f).divRound(this.n), y = d.b.neg().mul(f).divRound(this.n), p = h.mul(d.a), b = y.mul(l.a), v = h.mul(d.b), x = y.mul(l.b), I = f.sub(p).sub(b), L = v.add(x).neg();
    return { k1: I, k2: L };
  }, s.prototype.pointFromX = function(f, u) {
    f = new e(f, 16), f.red || (f = f.toRed(this.red));
    var d = f.redSqr().redMul(f).redIAdd(f.redMul(this.a)).redIAdd(this.b), l = d.redSqrt();
    if (l.redSqr().redSub(d).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var h = l.fromRed().isOdd();
    return (u && !h || !u && h) && (l = l.redNeg()), this.point(f, l);
  }, s.prototype.validate = function(f) {
    if (f.inf)
      return !0;
    var u = f.x, d = f.y, l = this.a.redMul(u), h = u.redSqr().redMul(u).redIAdd(l).redIAdd(this.b);
    return d.redSqr().redISub(h).cmpn(0) === 0;
  }, s.prototype._endoWnafMulAdd = function(f, u, d) {
    for (var l = this._endoWnafT1, h = this._endoWnafT2, y = 0; y < f.length; y++) {
      var p = this._endoSplit(u[y]), b = f[y], v = b._getBeta();
      p.k1.negative && (p.k1.ineg(), b = b.neg(!0)), p.k2.negative && (p.k2.ineg(), v = v.neg(!0)), l[y * 2] = b, l[y * 2 + 1] = v, h[y * 2] = p.k1, h[y * 2 + 1] = p.k2;
    }
    for (var x = this._wnafMulAdd(1, l, h, y * 2, d), I = 0; I < y * 2; I++)
      l[I] = null, h[I] = null;
    return x;
  };
  function a(c, f, u, d) {
    n.BasePoint.call(this, c, "affine"), f === null && u === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new e(f, 16), this.y = new e(u, 16), d && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  r(a, n.BasePoint), s.prototype.point = function(f, u, d) {
    return new a(this, f, u, d);
  }, s.prototype.pointFromJSON = function(f, u) {
    return a.fromJSON(this, f, u);
  }, a.prototype._getBeta = function() {
    if (this.curve.endo) {
      var f = this.precomputed;
      if (f && f.beta)
        return f.beta;
      var u = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (f) {
        var d = this.curve, l = function(h) {
          return d.point(h.x.redMul(d.endo.beta), h.y);
        };
        f.beta = u, u.precomputed = {
          beta: null,
          naf: f.naf && {
            wnd: f.naf.wnd,
            points: f.naf.points.map(l)
          },
          doubles: f.doubles && {
            step: f.doubles.step,
            points: f.doubles.points.map(l)
          }
        };
      }
      return u;
    }
  }, a.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, a.fromJSON = function(f, u, d) {
    typeof u == "string" && (u = JSON.parse(u));
    var l = f.point(u[0], u[1], d);
    if (!u[2])
      return l;
    function h(p) {
      return f.point(p[0], p[1], d);
    }
    var y = u[2];
    return l.precomputed = {
      beta: null,
      doubles: y.doubles && {
        step: y.doubles.step,
        points: [l].concat(y.doubles.points.map(h))
      },
      naf: y.naf && {
        wnd: y.naf.wnd,
        points: [l].concat(y.naf.points.map(h))
      }
    }, l;
  }, a.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, a.prototype.isInfinity = function() {
    return this.inf;
  }, a.prototype.add = function(f) {
    if (this.inf)
      return f;
    if (f.inf)
      return this;
    if (this.eq(f))
      return this.dbl();
    if (this.neg().eq(f))
      return this.curve.point(null, null);
    if (this.x.cmp(f.x) === 0)
      return this.curve.point(null, null);
    var u = this.y.redSub(f.y);
    u.cmpn(0) !== 0 && (u = u.redMul(this.x.redSub(f.x).redInvm()));
    var d = u.redSqr().redISub(this.x).redISub(f.x), l = u.redMul(this.x.redSub(d)).redISub(this.y);
    return this.curve.point(d, l);
  }, a.prototype.dbl = function() {
    if (this.inf)
      return this;
    var f = this.y.redAdd(this.y);
    if (f.cmpn(0) === 0)
      return this.curve.point(null, null);
    var u = this.curve.a, d = this.x.redSqr(), l = f.redInvm(), h = d.redAdd(d).redIAdd(d).redIAdd(u).redMul(l), y = h.redSqr().redISub(this.x.redAdd(this.x)), p = h.redMul(this.x.redSub(y)).redISub(this.y);
    return this.curve.point(y, p);
  }, a.prototype.getX = function() {
    return this.x.fromRed();
  }, a.prototype.getY = function() {
    return this.y.fromRed();
  }, a.prototype.mul = function(f) {
    return f = new e(f, 16), this.isInfinity() ? this : this._hasDoubles(f) ? this.curve._fixedNafMul(this, f) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [f]) : this.curve._wnafMul(this, f);
  }, a.prototype.mulAdd = function(f, u, d) {
    var l = [this, u], h = [f, d];
    return this.curve.endo ? this.curve._endoWnafMulAdd(l, h) : this.curve._wnafMulAdd(1, l, h, 2);
  }, a.prototype.jmulAdd = function(f, u, d) {
    var l = [this, u], h = [f, d];
    return this.curve.endo ? this.curve._endoWnafMulAdd(l, h, !0) : this.curve._wnafMulAdd(1, l, h, 2, !0);
  }, a.prototype.eq = function(f) {
    return this === f || this.inf === f.inf && (this.inf || this.x.cmp(f.x) === 0 && this.y.cmp(f.y) === 0);
  }, a.prototype.neg = function(f) {
    if (this.inf)
      return this;
    var u = this.curve.point(this.x, this.y.redNeg());
    if (f && this.precomputed) {
      var d = this.precomputed, l = function(h) {
        return h.neg();
      };
      u.precomputed = {
        naf: d.naf && {
          wnd: d.naf.wnd,
          points: d.naf.points.map(l)
        },
        doubles: d.doubles && {
          step: d.doubles.step,
          points: d.doubles.points.map(l)
        }
      };
    }
    return u;
  }, a.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var f = this.curve.jpoint(this.x, this.y, this.curve.one);
    return f;
  };
  function o(c, f, u, d) {
    n.BasePoint.call(this, c, "jacobian"), f === null && u === null && d === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new e(0)) : (this.x = new e(f, 16), this.y = new e(u, 16), this.z = new e(d, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return r(o, n.BasePoint), s.prototype.jpoint = function(f, u, d) {
    return new o(this, f, u, d);
  }, o.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var f = this.z.redInvm(), u = f.redSqr(), d = this.x.redMul(u), l = this.y.redMul(u).redMul(f);
    return this.curve.point(d, l);
  }, o.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, o.prototype.add = function(f) {
    if (this.isInfinity())
      return f;
    if (f.isInfinity())
      return this;
    var u = f.z.redSqr(), d = this.z.redSqr(), l = this.x.redMul(u), h = f.x.redMul(d), y = this.y.redMul(u.redMul(f.z)), p = f.y.redMul(d.redMul(this.z)), b = l.redSub(h), v = y.redSub(p);
    if (b.cmpn(0) === 0)
      return v.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var x = b.redSqr(), I = x.redMul(b), L = l.redMul(x), P = v.redSqr().redIAdd(I).redISub(L).redISub(L), C = v.redMul(L.redISub(P)).redISub(y.redMul(I)), D = this.z.redMul(f.z).redMul(b);
    return this.curve.jpoint(P, C, D);
  }, o.prototype.mixedAdd = function(f) {
    if (this.isInfinity())
      return f.toJ();
    if (f.isInfinity())
      return this;
    var u = this.z.redSqr(), d = this.x, l = f.x.redMul(u), h = this.y, y = f.y.redMul(u).redMul(this.z), p = d.redSub(l), b = h.redSub(y);
    if (p.cmpn(0) === 0)
      return b.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var v = p.redSqr(), x = v.redMul(p), I = d.redMul(v), L = b.redSqr().redIAdd(x).redISub(I).redISub(I), P = b.redMul(I.redISub(L)).redISub(h.redMul(x)), C = this.z.redMul(p);
    return this.curve.jpoint(L, P, C);
  }, o.prototype.dblp = function(f) {
    if (f === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!f)
      return this.dbl();
    var u;
    if (this.curve.zeroA || this.curve.threeA) {
      var d = this;
      for (u = 0; u < f; u++)
        d = d.dbl();
      return d;
    }
    var l = this.curve.a, h = this.curve.tinv, y = this.x, p = this.y, b = this.z, v = b.redSqr().redSqr(), x = p.redAdd(p);
    for (u = 0; u < f; u++) {
      var I = y.redSqr(), L = x.redSqr(), P = L.redSqr(), C = I.redAdd(I).redIAdd(I).redIAdd(l.redMul(v)), D = y.redMul(L), F = C.redSqr().redISub(D.redAdd(D)), G = D.redISub(F), re = C.redMul(G);
      re = re.redIAdd(re).redISub(P);
      var ie = x.redMul(b);
      u + 1 < f && (v = v.redMul(P)), y = F, b = ie, x = re;
    }
    return this.curve.jpoint(y, x.redMul(h), b);
  }, o.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, o.prototype._zeroDbl = function() {
    var f, u, d;
    if (this.zOne) {
      var l = this.x.redSqr(), h = this.y.redSqr(), y = h.redSqr(), p = this.x.redAdd(h).redSqr().redISub(l).redISub(y);
      p = p.redIAdd(p);
      var b = l.redAdd(l).redIAdd(l), v = b.redSqr().redISub(p).redISub(p), x = y.redIAdd(y);
      x = x.redIAdd(x), x = x.redIAdd(x), f = v, u = b.redMul(p.redISub(v)).redISub(x), d = this.y.redAdd(this.y);
    } else {
      var I = this.x.redSqr(), L = this.y.redSqr(), P = L.redSqr(), C = this.x.redAdd(L).redSqr().redISub(I).redISub(P);
      C = C.redIAdd(C);
      var D = I.redAdd(I).redIAdd(I), F = D.redSqr(), G = P.redIAdd(P);
      G = G.redIAdd(G), G = G.redIAdd(G), f = F.redISub(C).redISub(C), u = D.redMul(C.redISub(f)).redISub(G), d = this.y.redMul(this.z), d = d.redIAdd(d);
    }
    return this.curve.jpoint(f, u, d);
  }, o.prototype._threeDbl = function() {
    var f, u, d;
    if (this.zOne) {
      var l = this.x.redSqr(), h = this.y.redSqr(), y = h.redSqr(), p = this.x.redAdd(h).redSqr().redISub(l).redISub(y);
      p = p.redIAdd(p);
      var b = l.redAdd(l).redIAdd(l).redIAdd(this.curve.a), v = b.redSqr().redISub(p).redISub(p);
      f = v;
      var x = y.redIAdd(y);
      x = x.redIAdd(x), x = x.redIAdd(x), u = b.redMul(p.redISub(v)).redISub(x), d = this.y.redAdd(this.y);
    } else {
      var I = this.z.redSqr(), L = this.y.redSqr(), P = this.x.redMul(L), C = this.x.redSub(I).redMul(this.x.redAdd(I));
      C = C.redAdd(C).redIAdd(C);
      var D = P.redIAdd(P);
      D = D.redIAdd(D);
      var F = D.redAdd(D);
      f = C.redSqr().redISub(F), d = this.y.redAdd(this.z).redSqr().redISub(L).redISub(I);
      var G = L.redSqr();
      G = G.redIAdd(G), G = G.redIAdd(G), G = G.redIAdd(G), u = C.redMul(D.redISub(f)).redISub(G);
    }
    return this.curve.jpoint(f, u, d);
  }, o.prototype._dbl = function() {
    var f = this.curve.a, u = this.x, d = this.y, l = this.z, h = l.redSqr().redSqr(), y = u.redSqr(), p = d.redSqr(), b = y.redAdd(y).redIAdd(y).redIAdd(f.redMul(h)), v = u.redAdd(u);
    v = v.redIAdd(v);
    var x = v.redMul(p), I = b.redSqr().redISub(x.redAdd(x)), L = x.redISub(I), P = p.redSqr();
    P = P.redIAdd(P), P = P.redIAdd(P), P = P.redIAdd(P);
    var C = b.redMul(L).redISub(P), D = d.redAdd(d).redMul(l);
    return this.curve.jpoint(I, C, D);
  }, o.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var f = this.x.redSqr(), u = this.y.redSqr(), d = this.z.redSqr(), l = u.redSqr(), h = f.redAdd(f).redIAdd(f), y = h.redSqr(), p = this.x.redAdd(u).redSqr().redISub(f).redISub(l);
    p = p.redIAdd(p), p = p.redAdd(p).redIAdd(p), p = p.redISub(y);
    var b = p.redSqr(), v = l.redIAdd(l);
    v = v.redIAdd(v), v = v.redIAdd(v), v = v.redIAdd(v);
    var x = h.redIAdd(p).redSqr().redISub(y).redISub(b).redISub(v), I = u.redMul(x);
    I = I.redIAdd(I), I = I.redIAdd(I);
    var L = this.x.redMul(b).redISub(I);
    L = L.redIAdd(L), L = L.redIAdd(L);
    var P = this.y.redMul(x.redMul(v.redISub(x)).redISub(p.redMul(b)));
    P = P.redIAdd(P), P = P.redIAdd(P), P = P.redIAdd(P);
    var C = this.z.redAdd(p).redSqr().redISub(d).redISub(b);
    return this.curve.jpoint(L, P, C);
  }, o.prototype.mul = function(f, u) {
    return f = new e(f, u), this.curve._wnafMul(this, f);
  }, o.prototype.eq = function(f) {
    if (f.type === "affine")
      return this.eq(f.toJ());
    if (this === f)
      return !0;
    var u = this.z.redSqr(), d = f.z.redSqr();
    if (this.x.redMul(d).redISub(f.x.redMul(u)).cmpn(0) !== 0)
      return !1;
    var l = u.redMul(this.z), h = d.redMul(f.z);
    return this.y.redMul(h).redISub(f.y.redMul(l)).cmpn(0) === 0;
  }, o.prototype.eqXToP = function(f) {
    var u = this.z.redSqr(), d = f.toRed(this.curve.red).redMul(u);
    if (this.x.cmp(d) === 0)
      return !0;
    for (var l = f.clone(), h = this.curve.redN.redMul(u); ; ) {
      if (l.iadd(this.curve.n), l.cmp(this.curve.p) >= 0)
        return !1;
      if (d.redIAdd(h), this.x.cmp(d) === 0)
        return !0;
    }
  }, o.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, o.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, ab;
}
var ob, AS;
function NC() {
  if (AS)
    return ob;
  AS = 1;
  var t = Tr, e = Kt, r = M0(), n = us();
  function i(a) {
    r.call(this, "mont", a), this.a = new t(a.a, 16).toRed(this.red), this.b = new t(a.b, 16).toRed(this.red), this.i4 = new t(4).toRed(this.red).redInvm(), this.two = new t(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  e(i, r), ob = i, i.prototype.validate = function(o) {
    var c = o.normalize().x, f = c.redSqr(), u = f.redMul(c).redAdd(f.redMul(this.a)).redAdd(c), d = u.redSqrt();
    return d.redSqr().cmp(u) === 0;
  };
  function s(a, o, c) {
    r.BasePoint.call(this, a, "projective"), o === null && c === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new t(o, 16), this.z = new t(c, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return e(s, r.BasePoint), i.prototype.decodePoint = function(o, c) {
    return this.point(n.toArray(o, c), 1);
  }, i.prototype.point = function(o, c) {
    return new s(this, o, c);
  }, i.prototype.pointFromJSON = function(o) {
    return s.fromJSON(this, o);
  }, s.prototype.precompute = function() {
  }, s.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, s.fromJSON = function(o, c) {
    return new s(o, c[0], c[1] || o.one);
  }, s.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, s.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, s.prototype.dbl = function() {
    var o = this.x.redAdd(this.z), c = o.redSqr(), f = this.x.redSub(this.z), u = f.redSqr(), d = c.redSub(u), l = c.redMul(u), h = d.redMul(u.redAdd(this.curve.a24.redMul(d)));
    return this.curve.point(l, h);
  }, s.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, s.prototype.diffAdd = function(o, c) {
    var f = this.x.redAdd(this.z), u = this.x.redSub(this.z), d = o.x.redAdd(o.z), l = o.x.redSub(o.z), h = l.redMul(f), y = d.redMul(u), p = c.z.redMul(h.redAdd(y).redSqr()), b = c.x.redMul(h.redISub(y).redSqr());
    return this.curve.point(p, b);
  }, s.prototype.mul = function(o) {
    for (var c = o.clone(), f = this, u = this.curve.point(null, null), d = this, l = []; c.cmpn(0) !== 0; c.iushrn(1))
      l.push(c.andln(1));
    for (var h = l.length - 1; h >= 0; h--)
      l[h] === 0 ? (f = f.diffAdd(u, d), u = u.dbl()) : (u = f.diffAdd(u, d), f = f.dbl());
    return u;
  }, s.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, s.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, s.prototype.eq = function(o) {
    return this.getX().cmp(o.getX()) === 0;
  }, s.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, s.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, ob;
}
var cb, IS;
function UC() {
  if (IS)
    return cb;
  IS = 1;
  var t = us(), e = Tr, r = Kt, n = M0(), i = t.assert;
  function s(o) {
    this.twisted = (o.a | 0) !== 1, this.mOneA = this.twisted && (o.a | 0) === -1, this.extended = this.mOneA, n.call(this, "edwards", o), this.a = new e(o.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new e(o.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new e(o.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), i(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (o.c | 0) === 1;
  }
  r(s, n), cb = s, s.prototype._mulA = function(c) {
    return this.mOneA ? c.redNeg() : this.a.redMul(c);
  }, s.prototype._mulC = function(c) {
    return this.oneC ? c : this.c.redMul(c);
  }, s.prototype.jpoint = function(c, f, u, d) {
    return this.point(c, f, u, d);
  }, s.prototype.pointFromX = function(c, f) {
    c = new e(c, 16), c.red || (c = c.toRed(this.red));
    var u = c.redSqr(), d = this.c2.redSub(this.a.redMul(u)), l = this.one.redSub(this.c2.redMul(this.d).redMul(u)), h = d.redMul(l.redInvm()), y = h.redSqrt();
    if (y.redSqr().redSub(h).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var p = y.fromRed().isOdd();
    return (f && !p || !f && p) && (y = y.redNeg()), this.point(c, y);
  }, s.prototype.pointFromY = function(c, f) {
    c = new e(c, 16), c.red || (c = c.toRed(this.red));
    var u = c.redSqr(), d = u.redSub(this.c2), l = u.redMul(this.d).redMul(this.c2).redSub(this.a), h = d.redMul(l.redInvm());
    if (h.cmp(this.zero) === 0) {
      if (f)
        throw new Error("invalid point");
      return this.point(this.zero, c);
    }
    var y = h.redSqrt();
    if (y.redSqr().redSub(h).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return y.fromRed().isOdd() !== f && (y = y.redNeg()), this.point(y, c);
  }, s.prototype.validate = function(c) {
    if (c.isInfinity())
      return !0;
    c.normalize();
    var f = c.x.redSqr(), u = c.y.redSqr(), d = f.redMul(this.a).redAdd(u), l = this.c2.redMul(this.one.redAdd(this.d.redMul(f).redMul(u)));
    return d.cmp(l) === 0;
  };
  function a(o, c, f, u, d) {
    n.BasePoint.call(this, o, "projective"), c === null && f === null && u === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new e(c, 16), this.y = new e(f, 16), this.z = u ? new e(u, 16) : this.curve.one, this.t = d && new e(d, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return r(a, n.BasePoint), s.prototype.pointFromJSON = function(c) {
    return a.fromJSON(this, c);
  }, s.prototype.point = function(c, f, u, d) {
    return new a(this, c, f, u, d);
  }, a.fromJSON = function(c, f) {
    return new a(c, f[0], f[1], f[2]);
  }, a.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, a.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, a.prototype._extDbl = function() {
    var c = this.x.redSqr(), f = this.y.redSqr(), u = this.z.redSqr();
    u = u.redIAdd(u);
    var d = this.curve._mulA(c), l = this.x.redAdd(this.y).redSqr().redISub(c).redISub(f), h = d.redAdd(f), y = h.redSub(u), p = d.redSub(f), b = l.redMul(y), v = h.redMul(p), x = l.redMul(p), I = y.redMul(h);
    return this.curve.point(b, v, I, x);
  }, a.prototype._projDbl = function() {
    var c = this.x.redAdd(this.y).redSqr(), f = this.x.redSqr(), u = this.y.redSqr(), d, l, h, y, p, b;
    if (this.curve.twisted) {
      y = this.curve._mulA(f);
      var v = y.redAdd(u);
      this.zOne ? (d = c.redSub(f).redSub(u).redMul(v.redSub(this.curve.two)), l = v.redMul(y.redSub(u)), h = v.redSqr().redSub(v).redSub(v)) : (p = this.z.redSqr(), b = v.redSub(p).redISub(p), d = c.redSub(f).redISub(u).redMul(b), l = v.redMul(y.redSub(u)), h = v.redMul(b));
    } else
      y = f.redAdd(u), p = this.curve._mulC(this.z).redSqr(), b = y.redSub(p).redSub(p), d = this.curve._mulC(c.redISub(y)).redMul(b), l = this.curve._mulC(y).redMul(f.redISub(u)), h = y.redMul(b);
    return this.curve.point(d, l, h);
  }, a.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, a.prototype._extAdd = function(c) {
    var f = this.y.redSub(this.x).redMul(c.y.redSub(c.x)), u = this.y.redAdd(this.x).redMul(c.y.redAdd(c.x)), d = this.t.redMul(this.curve.dd).redMul(c.t), l = this.z.redMul(c.z.redAdd(c.z)), h = u.redSub(f), y = l.redSub(d), p = l.redAdd(d), b = u.redAdd(f), v = h.redMul(y), x = p.redMul(b), I = h.redMul(b), L = y.redMul(p);
    return this.curve.point(v, x, L, I);
  }, a.prototype._projAdd = function(c) {
    var f = this.z.redMul(c.z), u = f.redSqr(), d = this.x.redMul(c.x), l = this.y.redMul(c.y), h = this.curve.d.redMul(d).redMul(l), y = u.redSub(h), p = u.redAdd(h), b = this.x.redAdd(this.y).redMul(c.x.redAdd(c.y)).redISub(d).redISub(l), v = f.redMul(y).redMul(b), x, I;
    return this.curve.twisted ? (x = f.redMul(p).redMul(l.redSub(this.curve._mulA(d))), I = y.redMul(p)) : (x = f.redMul(p).redMul(l.redSub(d)), I = this.curve._mulC(y).redMul(p)), this.curve.point(v, x, I);
  }, a.prototype.add = function(c) {
    return this.isInfinity() ? c : c.isInfinity() ? this : this.curve.extended ? this._extAdd(c) : this._projAdd(c);
  }, a.prototype.mul = function(c) {
    return this._hasDoubles(c) ? this.curve._fixedNafMul(this, c) : this.curve._wnafMul(this, c);
  }, a.prototype.mulAdd = function(c, f, u) {
    return this.curve._wnafMulAdd(1, [this, f], [c, u], 2, !1);
  }, a.prototype.jmulAdd = function(c, f, u) {
    return this.curve._wnafMulAdd(1, [this, f], [c, u], 2, !0);
  }, a.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var c = this.z.redInvm();
    return this.x = this.x.redMul(c), this.y = this.y.redMul(c), this.t && (this.t = this.t.redMul(c)), this.z = this.curve.one, this.zOne = !0, this;
  }, a.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, a.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, a.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, a.prototype.eq = function(c) {
    return this === c || this.getX().cmp(c.getX()) === 0 && this.getY().cmp(c.getY()) === 0;
  }, a.prototype.eqXToP = function(c) {
    var f = c.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(f) === 0)
      return !0;
    for (var u = c.clone(), d = this.curve.redN.redMul(this.z); ; ) {
      if (u.iadd(this.curve.n), u.cmp(this.curve.p) >= 0)
        return !1;
      if (f.redIAdd(d), this.x.cmp(f) === 0)
        return !0;
    }
  }, a.prototype.toP = a.prototype.normalize, a.prototype.mixedAdd = a.prototype.add, cb;
}
var TS;
function s5() {
  return TS || (TS = 1, function(t) {
    var e = t;
    e.base = M0(), e.short = CC(), e.mont = NC(), e.edwards = UC();
  }(ib)), ib;
}
var ub = {}, fb = {}, Dr = {}, kS;
function ra() {
  if (kS)
    return Dr;
  kS = 1;
  var t = hr, e = Kt;
  Dr.inherits = e;
  function r(ee, $) {
    return (ee.charCodeAt($) & 64512) !== 55296 || $ < 0 || $ + 1 >= ee.length ? !1 : (ee.charCodeAt($ + 1) & 64512) === 56320;
  }
  function n(ee, $) {
    if (Array.isArray(ee))
      return ee.slice();
    if (!ee)
      return [];
    var w = [];
    if (typeof ee == "string")
      if ($) {
        if ($ === "hex")
          for (ee = ee.replace(/[^a-z0-9]+/ig, ""), ee.length % 2 !== 0 && (ee = "0" + ee), U = 0; U < ee.length; U += 2)
            w.push(parseInt(ee[U] + ee[U + 1], 16));
      } else
        for (var E = 0, U = 0; U < ee.length; U++) {
          var W = ee.charCodeAt(U);
          W < 128 ? w[E++] = W : W < 2048 ? (w[E++] = W >> 6 | 192, w[E++] = W & 63 | 128) : r(ee, U) ? (W = 65536 + ((W & 1023) << 10) + (ee.charCodeAt(++U) & 1023), w[E++] = W >> 18 | 240, w[E++] = W >> 12 & 63 | 128, w[E++] = W >> 6 & 63 | 128, w[E++] = W & 63 | 128) : (w[E++] = W >> 12 | 224, w[E++] = W >> 6 & 63 | 128, w[E++] = W & 63 | 128);
        }
    else
      for (U = 0; U < ee.length; U++)
        w[U] = ee[U] | 0;
    return w;
  }
  Dr.toArray = n;
  function i(ee) {
    for (var $ = "", w = 0; w < ee.length; w++)
      $ += o(ee[w].toString(16));
    return $;
  }
  Dr.toHex = i;
  function s(ee) {
    var $ = ee >>> 24 | ee >>> 8 & 65280 | ee << 8 & 16711680 | (ee & 255) << 24;
    return $ >>> 0;
  }
  Dr.htonl = s;
  function a(ee, $) {
    for (var w = "", E = 0; E < ee.length; E++) {
      var U = ee[E];
      $ === "little" && (U = s(U)), w += c(U.toString(16));
    }
    return w;
  }
  Dr.toHex32 = a;
  function o(ee) {
    return ee.length === 1 ? "0" + ee : ee;
  }
  Dr.zero2 = o;
  function c(ee) {
    return ee.length === 7 ? "0" + ee : ee.length === 6 ? "00" + ee : ee.length === 5 ? "000" + ee : ee.length === 4 ? "0000" + ee : ee.length === 3 ? "00000" + ee : ee.length === 2 ? "000000" + ee : ee.length === 1 ? "0000000" + ee : ee;
  }
  Dr.zero8 = c;
  function f(ee, $, w, E) {
    var U = w - $;
    t(U % 4 === 0);
    for (var W = new Array(U / 4), _ = 0, R = $; _ < W.length; _++, R += 4) {
      var N;
      E === "big" ? N = ee[R] << 24 | ee[R + 1] << 16 | ee[R + 2] << 8 | ee[R + 3] : N = ee[R + 3] << 24 | ee[R + 2] << 16 | ee[R + 1] << 8 | ee[R], W[_] = N >>> 0;
    }
    return W;
  }
  Dr.join32 = f;
  function u(ee, $) {
    for (var w = new Array(ee.length * 4), E = 0, U = 0; E < ee.length; E++, U += 4) {
      var W = ee[E];
      $ === "big" ? (w[U] = W >>> 24, w[U + 1] = W >>> 16 & 255, w[U + 2] = W >>> 8 & 255, w[U + 3] = W & 255) : (w[U + 3] = W >>> 24, w[U + 2] = W >>> 16 & 255, w[U + 1] = W >>> 8 & 255, w[U] = W & 255);
    }
    return w;
  }
  Dr.split32 = u;
  function d(ee, $) {
    return ee >>> $ | ee << 32 - $;
  }
  Dr.rotr32 = d;
  function l(ee, $) {
    return ee << $ | ee >>> 32 - $;
  }
  Dr.rotl32 = l;
  function h(ee, $) {
    return ee + $ >>> 0;
  }
  Dr.sum32 = h;
  function y(ee, $, w) {
    return ee + $ + w >>> 0;
  }
  Dr.sum32_3 = y;
  function p(ee, $, w, E) {
    return ee + $ + w + E >>> 0;
  }
  Dr.sum32_4 = p;
  function b(ee, $, w, E, U) {
    return ee + $ + w + E + U >>> 0;
  }
  Dr.sum32_5 = b;
  function v(ee, $, w, E) {
    var U = ee[$], W = ee[$ + 1], _ = E + W >>> 0, R = (_ < E ? 1 : 0) + w + U;
    ee[$] = R >>> 0, ee[$ + 1] = _;
  }
  Dr.sum64 = v;
  function x(ee, $, w, E) {
    var U = $ + E >>> 0, W = (U < $ ? 1 : 0) + ee + w;
    return W >>> 0;
  }
  Dr.sum64_hi = x;
  function I(ee, $, w, E) {
    var U = $ + E;
    return U >>> 0;
  }
  Dr.sum64_lo = I;
  function L(ee, $, w, E, U, W, _, R) {
    var N = 0, O = $;
    O = O + E >>> 0, N += O < $ ? 1 : 0, O = O + W >>> 0, N += O < W ? 1 : 0, O = O + R >>> 0, N += O < R ? 1 : 0;
    var g = ee + w + U + _ + N;
    return g >>> 0;
  }
  Dr.sum64_4_hi = L;
  function P(ee, $, w, E, U, W, _, R) {
    var N = $ + E + W + R;
    return N >>> 0;
  }
  Dr.sum64_4_lo = P;
  function C(ee, $, w, E, U, W, _, R, N, O) {
    var g = 0, M = $;
    M = M + E >>> 0, g += M < $ ? 1 : 0, M = M + W >>> 0, g += M < W ? 1 : 0, M = M + R >>> 0, g += M < R ? 1 : 0, M = M + O >>> 0, g += M < O ? 1 : 0;
    var Y = ee + w + U + _ + N + g;
    return Y >>> 0;
  }
  Dr.sum64_5_hi = C;
  function D(ee, $, w, E, U, W, _, R, N, O) {
    var g = $ + E + W + R + O;
    return g >>> 0;
  }
  Dr.sum64_5_lo = D;
  function F(ee, $, w) {
    var E = $ << 32 - w | ee >>> w;
    return E >>> 0;
  }
  Dr.rotr64_hi = F;
  function G(ee, $, w) {
    var E = ee << 32 - w | $ >>> w;
    return E >>> 0;
  }
  Dr.rotr64_lo = G;
  function re(ee, $, w) {
    return ee >>> w;
  }
  Dr.shr64_hi = re;
  function ie(ee, $, w) {
    var E = ee << 32 - w | $ >>> w;
    return E >>> 0;
  }
  return Dr.shr64_lo = ie, Dr;
}
var db = {}, RS;
function Il() {
  if (RS)
    return db;
  RS = 1;
  var t = ra(), e = hr;
  function r() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  return db.BlockHash = r, r.prototype.update = function(i, s) {
    if (i = t.toArray(i, s), this.pending ? this.pending = this.pending.concat(i) : this.pending = i, this.pendingTotal += i.length, this.pending.length >= this._delta8) {
      i = this.pending;
      var a = i.length % this._delta8;
      this.pending = i.slice(i.length - a, i.length), this.pending.length === 0 && (this.pending = null), i = t.join32(i, 0, i.length - a, this.endian);
      for (var o = 0; o < i.length; o += this._delta32)
        this._update(i, o, o + this._delta32);
    }
    return this;
  }, r.prototype.digest = function(i) {
    return this.update(this._pad()), e(this.pending === null), this._digest(i);
  }, r.prototype._pad = function() {
    var i = this.pendingTotal, s = this._delta8, a = s - (i + this.padLength) % s, o = new Array(a + this.padLength);
    o[0] = 128;
    for (var c = 1; c < a; c++)
      o[c] = 0;
    if (i <<= 3, this.endian === "big") {
      for (var f = 8; f < this.padLength; f++)
        o[c++] = 0;
      o[c++] = 0, o[c++] = 0, o[c++] = 0, o[c++] = 0, o[c++] = i >>> 24 & 255, o[c++] = i >>> 16 & 255, o[c++] = i >>> 8 & 255, o[c++] = i & 255;
    } else
      for (o[c++] = i & 255, o[c++] = i >>> 8 & 255, o[c++] = i >>> 16 & 255, o[c++] = i >>> 24 & 255, o[c++] = 0, o[c++] = 0, o[c++] = 0, o[c++] = 0, f = 8; f < this.padLength; f++)
        o[c++] = 0;
    return o;
  }, db;
}
var Co = {}, Cs = {}, PS;
function a5() {
  if (PS)
    return Cs;
  PS = 1;
  var t = ra(), e = t.rotr32;
  function r(u, d, l, h) {
    if (u === 0)
      return n(d, l, h);
    if (u === 1 || u === 3)
      return s(d, l, h);
    if (u === 2)
      return i(d, l, h);
  }
  Cs.ft_1 = r;
  function n(u, d, l) {
    return u & d ^ ~u & l;
  }
  Cs.ch32 = n;
  function i(u, d, l) {
    return u & d ^ u & l ^ d & l;
  }
  Cs.maj32 = i;
  function s(u, d, l) {
    return u ^ d ^ l;
  }
  Cs.p32 = s;
  function a(u) {
    return e(u, 2) ^ e(u, 13) ^ e(u, 22);
  }
  Cs.s0_256 = a;
  function o(u) {
    return e(u, 6) ^ e(u, 11) ^ e(u, 25);
  }
  Cs.s1_256 = o;
  function c(u) {
    return e(u, 7) ^ e(u, 18) ^ u >>> 3;
  }
  Cs.g0_256 = c;
  function f(u) {
    return e(u, 17) ^ e(u, 19) ^ u >>> 10;
  }
  return Cs.g1_256 = f, Cs;
}
var lb, OS;
function LC() {
  if (OS)
    return lb;
  OS = 1;
  var t = ra(), e = Il(), r = a5(), n = t.rotl32, i = t.sum32, s = t.sum32_5, a = r.ft_1, o = e.BlockHash, c = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
  ];
  function f() {
    if (!(this instanceof f))
      return new f();
    o.call(this), this.h = [
      1732584193,
      4023233417,
      2562383102,
      271733878,
      3285377520
    ], this.W = new Array(80);
  }
  return t.inherits(f, o), lb = f, f.blockSize = 512, f.outSize = 160, f.hmacStrength = 80, f.padLength = 64, f.prototype._update = function(d, l) {
    for (var h = this.W, y = 0; y < 16; y++)
      h[y] = d[l + y];
    for (; y < h.length; y++)
      h[y] = n(h[y - 3] ^ h[y - 8] ^ h[y - 14] ^ h[y - 16], 1);
    var p = this.h[0], b = this.h[1], v = this.h[2], x = this.h[3], I = this.h[4];
    for (y = 0; y < h.length; y++) {
      var L = ~~(y / 20), P = s(n(p, 5), a(L, b, v, x), I, h[y], c[L]);
      I = x, x = v, v = n(b, 30), b = p, p = P;
    }
    this.h[0] = i(this.h[0], p), this.h[1] = i(this.h[1], b), this.h[2] = i(this.h[2], v), this.h[3] = i(this.h[3], x), this.h[4] = i(this.h[4], I);
  }, f.prototype._digest = function(d) {
    return d === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
  }, lb;
}
var hb, BS;
function o5() {
  if (BS)
    return hb;
  BS = 1;
  var t = ra(), e = Il(), r = a5(), n = hr, i = t.sum32, s = t.sum32_4, a = t.sum32_5, o = r.ch32, c = r.maj32, f = r.s0_256, u = r.s1_256, d = r.g0_256, l = r.g1_256, h = e.BlockHash, y = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  function p() {
    if (!(this instanceof p))
      return new p();
    h.call(this), this.h = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ], this.k = y, this.W = new Array(64);
  }
  return t.inherits(p, h), hb = p, p.blockSize = 512, p.outSize = 256, p.hmacStrength = 192, p.padLength = 64, p.prototype._update = function(v, x) {
    for (var I = this.W, L = 0; L < 16; L++)
      I[L] = v[x + L];
    for (; L < I.length; L++)
      I[L] = s(l(I[L - 2]), I[L - 7], d(I[L - 15]), I[L - 16]);
    var P = this.h[0], C = this.h[1], D = this.h[2], F = this.h[3], G = this.h[4], re = this.h[5], ie = this.h[6], ee = this.h[7];
    for (n(this.k.length === I.length), L = 0; L < I.length; L++) {
      var $ = a(ee, u(G), o(G, re, ie), this.k[L], I[L]), w = i(f(P), c(P, C, D));
      ee = ie, ie = re, re = G, G = i(F, $), F = D, D = C, C = P, P = i($, w);
    }
    this.h[0] = i(this.h[0], P), this.h[1] = i(this.h[1], C), this.h[2] = i(this.h[2], D), this.h[3] = i(this.h[3], F), this.h[4] = i(this.h[4], G), this.h[5] = i(this.h[5], re), this.h[6] = i(this.h[6], ie), this.h[7] = i(this.h[7], ee);
  }, p.prototype._digest = function(v) {
    return v === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
  }, hb;
}
var pb, MS;
function DC() {
  if (MS)
    return pb;
  MS = 1;
  var t = ra(), e = o5();
  function r() {
    if (!(this instanceof r))
      return new r();
    e.call(this), this.h = [
      3238371032,
      914150663,
      812702999,
      4144912697,
      4290775857,
      1750603025,
      1694076839,
      3204075428
    ];
  }
  return t.inherits(r, e), pb = r, r.blockSize = 512, r.outSize = 224, r.hmacStrength = 192, r.padLength = 64, r.prototype._digest = function(i) {
    return i === "hex" ? t.toHex32(this.h.slice(0, 7), "big") : t.split32(this.h.slice(0, 7), "big");
  }, pb;
}
var yb, CS;
function c5() {
  if (CS)
    return yb;
  CS = 1;
  var t = ra(), e = Il(), r = hr, n = t.rotr64_hi, i = t.rotr64_lo, s = t.shr64_hi, a = t.shr64_lo, o = t.sum64, c = t.sum64_hi, f = t.sum64_lo, u = t.sum64_4_hi, d = t.sum64_4_lo, l = t.sum64_5_hi, h = t.sum64_5_lo, y = e.BlockHash, p = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ];
  function b() {
    if (!(this instanceof b))
      return new b();
    y.call(this), this.h = [
      1779033703,
      4089235720,
      3144134277,
      2227873595,
      1013904242,
      4271175723,
      2773480762,
      1595750129,
      1359893119,
      2917565137,
      2600822924,
      725511199,
      528734635,
      4215389547,
      1541459225,
      327033209
    ], this.k = p, this.W = new Array(160);
  }
  t.inherits(b, y), yb = b, b.blockSize = 1024, b.outSize = 512, b.hmacStrength = 192, b.padLength = 128, b.prototype._prepareBlock = function(w, E) {
    for (var U = this.W, W = 0; W < 32; W++)
      U[W] = w[E + W];
    for (; W < U.length; W += 2) {
      var _ = ie(U[W - 4], U[W - 3]), R = ee(U[W - 4], U[W - 3]), N = U[W - 14], O = U[W - 13], g = G(U[W - 30], U[W - 29]), M = re(U[W - 30], U[W - 29]), Y = U[W - 32], se = U[W - 31];
      U[W] = u(
        _,
        R,
        N,
        O,
        g,
        M,
        Y,
        se
      ), U[W + 1] = d(
        _,
        R,
        N,
        O,
        g,
        M,
        Y,
        se
      );
    }
  }, b.prototype._update = function(w, E) {
    this._prepareBlock(w, E);
    var U = this.W, W = this.h[0], _ = this.h[1], R = this.h[2], N = this.h[3], O = this.h[4], g = this.h[5], M = this.h[6], Y = this.h[7], se = this.h[8], V = this.h[9], K = this.h[10], Z = this.h[11], ne = this.h[12], ce = this.h[13], H = this.h[14], J = this.h[15];
    r(this.k.length === U.length);
    for (var le = 0; le < U.length; le += 2) {
      var me = H, Ue = J, Ve = D(se, V), ze = F(se, V), at = v(se, V, K, Z, ne), xe = x(se, V, K, Z, ne, ce), gt = this.k[le], ht = this.k[le + 1], Bt = U[le], pt = U[le + 1], de = l(
        me,
        Ue,
        Ve,
        ze,
        at,
        xe,
        gt,
        ht,
        Bt,
        pt
      ), he = h(
        me,
        Ue,
        Ve,
        ze,
        at,
        xe,
        gt,
        ht,
        Bt,
        pt
      );
      me = P(W, _), Ue = C(W, _), Ve = I(W, _, R, N, O), ze = L(W, _, R, N, O, g);
      var Ie = c(me, Ue, Ve, ze), z = f(me, Ue, Ve, ze);
      H = ne, J = ce, ne = K, ce = Z, K = se, Z = V, se = c(M, Y, de, he), V = f(Y, Y, de, he), M = O, Y = g, O = R, g = N, R = W, N = _, W = c(de, he, Ie, z), _ = f(de, he, Ie, z);
    }
    o(this.h, 0, W, _), o(this.h, 2, R, N), o(this.h, 4, O, g), o(this.h, 6, M, Y), o(this.h, 8, se, V), o(this.h, 10, K, Z), o(this.h, 12, ne, ce), o(this.h, 14, H, J);
  }, b.prototype._digest = function(w) {
    return w === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
  };
  function v($, w, E, U, W) {
    var _ = $ & E ^ ~$ & W;
    return _ < 0 && (_ += 4294967296), _;
  }
  function x($, w, E, U, W, _) {
    var R = w & U ^ ~w & _;
    return R < 0 && (R += 4294967296), R;
  }
  function I($, w, E, U, W) {
    var _ = $ & E ^ $ & W ^ E & W;
    return _ < 0 && (_ += 4294967296), _;
  }
  function L($, w, E, U, W, _) {
    var R = w & U ^ w & _ ^ U & _;
    return R < 0 && (R += 4294967296), R;
  }
  function P($, w) {
    var E = n($, w, 28), U = n(w, $, 2), W = n(w, $, 7), _ = E ^ U ^ W;
    return _ < 0 && (_ += 4294967296), _;
  }
  function C($, w) {
    var E = i($, w, 28), U = i(w, $, 2), W = i(w, $, 7), _ = E ^ U ^ W;
    return _ < 0 && (_ += 4294967296), _;
  }
  function D($, w) {
    var E = n($, w, 14), U = n($, w, 18), W = n(w, $, 9), _ = E ^ U ^ W;
    return _ < 0 && (_ += 4294967296), _;
  }
  function F($, w) {
    var E = i($, w, 14), U = i($, w, 18), W = i(w, $, 9), _ = E ^ U ^ W;
    return _ < 0 && (_ += 4294967296), _;
  }
  function G($, w) {
    var E = n($, w, 1), U = n($, w, 8), W = s($, w, 7), _ = E ^ U ^ W;
    return _ < 0 && (_ += 4294967296), _;
  }
  function re($, w) {
    var E = i($, w, 1), U = i($, w, 8), W = a($, w, 7), _ = E ^ U ^ W;
    return _ < 0 && (_ += 4294967296), _;
  }
  function ie($, w) {
    var E = n($, w, 19), U = n(w, $, 29), W = s($, w, 6), _ = E ^ U ^ W;
    return _ < 0 && (_ += 4294967296), _;
  }
  function ee($, w) {
    var E = i($, w, 19), U = i(w, $, 29), W = a($, w, 6), _ = E ^ U ^ W;
    return _ < 0 && (_ += 4294967296), _;
  }
  return yb;
}
var bb, NS;
function FC() {
  if (NS)
    return bb;
  NS = 1;
  var t = ra(), e = c5();
  function r() {
    if (!(this instanceof r))
      return new r();
    e.call(this), this.h = [
      3418070365,
      3238371032,
      1654270250,
      914150663,
      2438529370,
      812702999,
      355462360,
      4144912697,
      1731405415,
      4290775857,
      2394180231,
      1750603025,
      3675008525,
      1694076839,
      1203062813,
      3204075428
    ];
  }
  return t.inherits(r, e), bb = r, r.blockSize = 1024, r.outSize = 384, r.hmacStrength = 192, r.padLength = 128, r.prototype._digest = function(i) {
    return i === "hex" ? t.toHex32(this.h.slice(0, 12), "big") : t.split32(this.h.slice(0, 12), "big");
  }, bb;
}
var US;
function jC() {
  return US || (US = 1, Co.sha1 = LC(), Co.sha224 = DC(), Co.sha256 = o5(), Co.sha384 = FC(), Co.sha512 = c5()), Co;
}
var gb = {}, LS;
function $C() {
  if (LS)
    return gb;
  LS = 1;
  var t = ra(), e = Il(), r = t.rotl32, n = t.sum32, i = t.sum32_3, s = t.sum32_4, a = e.BlockHash;
  function o() {
    if (!(this instanceof o))
      return new o();
    a.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  t.inherits(o, a), gb.ripemd160 = o, o.blockSize = 512, o.outSize = 160, o.hmacStrength = 192, o.padLength = 64, o.prototype._update = function(b, v) {
    for (var x = this.h[0], I = this.h[1], L = this.h[2], P = this.h[3], C = this.h[4], D = x, F = I, G = L, re = P, ie = C, ee = 0; ee < 80; ee++) {
      var $ = n(
        r(
          s(x, c(ee, I, L, P), b[d[ee] + v], f(ee)),
          h[ee]
        ),
        C
      );
      x = C, C = P, P = r(L, 10), L = I, I = $, $ = n(
        r(
          s(D, c(79 - ee, F, G, re), b[l[ee] + v], u(ee)),
          y[ee]
        ),
        ie
      ), D = ie, ie = re, re = r(G, 10), G = F, F = $;
    }
    $ = i(this.h[1], L, re), this.h[1] = i(this.h[2], P, ie), this.h[2] = i(this.h[3], C, D), this.h[3] = i(this.h[4], x, F), this.h[4] = i(this.h[0], I, G), this.h[0] = $;
  }, o.prototype._digest = function(b) {
    return b === "hex" ? t.toHex32(this.h, "little") : t.split32(this.h, "little");
  };
  function c(p, b, v, x) {
    return p <= 15 ? b ^ v ^ x : p <= 31 ? b & v | ~b & x : p <= 47 ? (b | ~v) ^ x : p <= 63 ? b & x | v & ~x : b ^ (v | ~x);
  }
  function f(p) {
    return p <= 15 ? 0 : p <= 31 ? 1518500249 : p <= 47 ? 1859775393 : p <= 63 ? 2400959708 : 2840853838;
  }
  function u(p) {
    return p <= 15 ? 1352829926 : p <= 31 ? 1548603684 : p <= 47 ? 1836072691 : p <= 63 ? 2053994217 : 0;
  }
  var d = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], l = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], h = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], y = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ];
  return gb;
}
var mb, DS;
function qC() {
  if (DS)
    return mb;
  DS = 1;
  var t = ra(), e = hr;
  function r(n, i, s) {
    if (!(this instanceof r))
      return new r(n, i, s);
    this.Hash = n, this.blockSize = n.blockSize / 8, this.outSize = n.outSize / 8, this.inner = null, this.outer = null, this._init(t.toArray(i, s));
  }
  return mb = r, r.prototype._init = function(i) {
    i.length > this.blockSize && (i = new this.Hash().update(i).digest()), e(i.length <= this.blockSize);
    for (var s = i.length; s < this.blockSize; s++)
      i.push(0);
    for (s = 0; s < i.length; s++)
      i[s] ^= 54;
    for (this.inner = new this.Hash().update(i), s = 0; s < i.length; s++)
      i[s] ^= 106;
    this.outer = new this.Hash().update(i);
  }, r.prototype.update = function(i, s) {
    return this.inner.update(i, s), this;
  }, r.prototype.digest = function(i) {
    return this.outer.update(this.inner.digest()), this.outer.digest(i);
  }, mb;
}
var FS;
function C0() {
  return FS || (FS = 1, function(t) {
    var e = t;
    e.utils = ra(), e.common = Il(), e.sha = jC(), e.ripemd = $C(), e.hmac = qC(), e.sha1 = e.sha.sha1, e.sha256 = e.sha.sha256, e.sha224 = e.sha.sha224, e.sha384 = e.sha.sha384, e.sha512 = e.sha.sha512, e.ripemd160 = e.ripemd.ripemd160;
  }(fb)), fb;
}
var vb, jS;
function WC() {
  return jS || (jS = 1, vb = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), vb;
}
var $S;
function q2() {
  return $S || ($S = 1, function(t) {
    var e = t, r = C0(), n = s5(), i = us(), s = i.assert;
    function a(f) {
      f.type === "short" ? this.curve = new n.short(f) : f.type === "edwards" ? this.curve = new n.edwards(f) : this.curve = new n.mont(f), this.g = this.curve.g, this.n = this.curve.n, this.hash = f.hash, s(this.g.validate(), "Invalid curve"), s(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    e.PresetCurve = a;
    function o(f, u) {
      Object.defineProperty(e, f, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var d = new a(u);
          return Object.defineProperty(e, f, {
            configurable: !0,
            enumerable: !0,
            value: d
          }), d;
        }
      });
    }
    o("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: r.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), o("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: r.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), o("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: r.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), o("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: r.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), o("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: r.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), o("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), o("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var c;
    try {
      c = WC();
    } catch {
      c = void 0;
    }
    o("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: r.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        c
      ]
    });
  }(ub)), ub;
}
var wb, qS;
function zC() {
  if (qS)
    return wb;
  qS = 1;
  var t = C0(), e = i5(), r = hr;
  function n(i) {
    if (!(this instanceof n))
      return new n(i);
    this.hash = i.hash, this.predResist = !!i.predResist, this.outLen = this.hash.outSize, this.minEntropy = i.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var s = e.toArray(i.entropy, i.entropyEnc || "hex"), a = e.toArray(i.nonce, i.nonceEnc || "hex"), o = e.toArray(i.pers, i.persEnc || "hex");
    r(
      s.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._init(s, a, o);
  }
  return wb = n, n.prototype._init = function(s, a, o) {
    var c = s.concat(a).concat(o);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var f = 0; f < this.V.length; f++)
      this.K[f] = 0, this.V[f] = 1;
    this._update(c), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, n.prototype._hmac = function() {
    return new t.hmac(this.hash, this.K);
  }, n.prototype._update = function(s) {
    var a = this._hmac().update(this.V).update([0]);
    s && (a = a.update(s)), this.K = a.digest(), this.V = this._hmac().update(this.V).digest(), s && (this.K = this._hmac().update(this.V).update([1]).update(s).digest(), this.V = this._hmac().update(this.V).digest());
  }, n.prototype.reseed = function(s, a, o, c) {
    typeof a != "string" && (c = o, o = a, a = null), s = e.toArray(s, a), o = e.toArray(o, c), r(
      s.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._update(s.concat(o || [])), this._reseed = 1;
  }, n.prototype.generate = function(s, a, o, c) {
    if (this._reseed > this.reseedInterval)
      throw new Error("Reseed is required");
    typeof a != "string" && (c = o, o = a, a = null), o && (o = e.toArray(o, c || "hex"), this._update(o));
    for (var f = []; f.length < s; )
      this.V = this._hmac().update(this.V).digest(), f = f.concat(this.V);
    var u = f.slice(0, s);
    return this._update(o), this._reseed++, e.encode(u, a);
  }, wb;
}
var _b, WS;
function KC() {
  if (WS)
    return _b;
  WS = 1;
  var t = Tr, e = us(), r = e.assert;
  function n(i, s) {
    this.ec = i, this.priv = null, this.pub = null, s.priv && this._importPrivate(s.priv, s.privEnc), s.pub && this._importPublic(s.pub, s.pubEnc);
  }
  return _b = n, n.fromPublic = function(s, a, o) {
    return a instanceof n ? a : new n(s, {
      pub: a,
      pubEnc: o
    });
  }, n.fromPrivate = function(s, a, o) {
    return a instanceof n ? a : new n(s, {
      priv: a,
      privEnc: o
    });
  }, n.prototype.validate = function() {
    var s = this.getPublic();
    return s.isInfinity() ? { result: !1, reason: "Invalid public key" } : s.validate() ? s.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, n.prototype.getPublic = function(s, a) {
    return typeof s == "string" && (a = s, s = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), a ? this.pub.encode(a, s) : this.pub;
  }, n.prototype.getPrivate = function(s) {
    return s === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, n.prototype._importPrivate = function(s, a) {
    this.priv = new t(s, a || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, n.prototype._importPublic = function(s, a) {
    if (s.x || s.y) {
      this.ec.curve.type === "mont" ? r(s.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && r(s.x && s.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(s.x, s.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(s, a);
  }, n.prototype.derive = function(s) {
    return s.validate() || r(s.validate(), "public point not validated"), s.mul(this.priv).getX();
  }, n.prototype.sign = function(s, a, o) {
    return this.ec.sign(s, this, a, o);
  }, n.prototype.verify = function(s, a) {
    return this.ec.verify(s, a, this);
  }, n.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, _b;
}
var Sb, zS;
function VC() {
  if (zS)
    return Sb;
  zS = 1;
  var t = Tr, e = us(), r = e.assert;
  function n(c, f) {
    if (c instanceof n)
      return c;
    this._importDER(c, f) || (r(c.r && c.s, "Signature without r or s"), this.r = new t(c.r, 16), this.s = new t(c.s, 16), c.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = c.recoveryParam);
  }
  Sb = n;
  function i() {
    this.place = 0;
  }
  function s(c, f) {
    var u = c[f.place++];
    if (!(u & 128))
      return u;
    var d = u & 15;
    if (d === 0 || d > 4)
      return !1;
    for (var l = 0, h = 0, y = f.place; h < d; h++, y++)
      l <<= 8, l |= c[y], l >>>= 0;
    return l <= 127 ? !1 : (f.place = y, l);
  }
  function a(c) {
    for (var f = 0, u = c.length - 1; !c[f] && !(c[f + 1] & 128) && f < u; )
      f++;
    return f === 0 ? c : c.slice(f);
  }
  n.prototype._importDER = function(f, u) {
    f = e.toArray(f, u);
    var d = new i();
    if (f[d.place++] !== 48)
      return !1;
    var l = s(f, d);
    if (l === !1 || l + d.place !== f.length || f[d.place++] !== 2)
      return !1;
    var h = s(f, d);
    if (h === !1)
      return !1;
    var y = f.slice(d.place, h + d.place);
    if (d.place += h, f[d.place++] !== 2)
      return !1;
    var p = s(f, d);
    if (p === !1 || f.length !== p + d.place)
      return !1;
    var b = f.slice(d.place, p + d.place);
    if (y[0] === 0)
      if (y[1] & 128)
        y = y.slice(1);
      else
        return !1;
    if (b[0] === 0)
      if (b[1] & 128)
        b = b.slice(1);
      else
        return !1;
    return this.r = new t(y), this.s = new t(b), this.recoveryParam = null, !0;
  };
  function o(c, f) {
    if (f < 128) {
      c.push(f);
      return;
    }
    var u = 1 + (Math.log(f) / Math.LN2 >>> 3);
    for (c.push(u | 128); --u; )
      c.push(f >>> (u << 3) & 255);
    c.push(f);
  }
  return n.prototype.toDER = function(f) {
    var u = this.r.toArray(), d = this.s.toArray();
    for (u[0] & 128 && (u = [0].concat(u)), d[0] & 128 && (d = [0].concat(d)), u = a(u), d = a(d); !d[0] && !(d[1] & 128); )
      d = d.slice(1);
    var l = [2];
    o(l, u.length), l = l.concat(u), l.push(2), o(l, d.length);
    var h = l.concat(d), y = [48];
    return o(y, h.length), y = y.concat(h), e.encode(y, f);
  }, Sb;
}
var Eb, KS;
function HC() {
  if (KS)
    return Eb;
  KS = 1;
  var t = Tr, e = zC(), r = us(), n = q2(), i = j2(), s = r.assert, a = KC(), o = VC();
  function c(f) {
    if (!(this instanceof c))
      return new c(f);
    typeof f == "string" && (s(
      Object.prototype.hasOwnProperty.call(n, f),
      "Unknown curve " + f
    ), f = n[f]), f instanceof n.PresetCurve && (f = { curve: f }), this.curve = f.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = f.curve.g, this.g.precompute(f.curve.n.bitLength() + 1), this.hash = f.hash || f.curve.hash;
  }
  return Eb = c, c.prototype.keyPair = function(u) {
    return new a(this, u);
  }, c.prototype.keyFromPrivate = function(u, d) {
    return a.fromPrivate(this, u, d);
  }, c.prototype.keyFromPublic = function(u, d) {
    return a.fromPublic(this, u, d);
  }, c.prototype.genKeyPair = function(u) {
    u || (u = {});
    for (var d = new e({
      hash: this.hash,
      pers: u.pers,
      persEnc: u.persEnc || "utf8",
      entropy: u.entropy || i(this.hash.hmacStrength),
      entropyEnc: u.entropy && u.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), l = this.n.byteLength(), h = this.n.sub(new t(2)); ; ) {
      var y = new t(d.generate(l));
      if (!(y.cmp(h) > 0))
        return y.iaddn(1), this.keyFromPrivate(y);
    }
  }, c.prototype._truncateToN = function(u, d) {
    var l = u.byteLength() * 8 - this.n.bitLength();
    return l > 0 && (u = u.ushrn(l)), !d && u.cmp(this.n) >= 0 ? u.sub(this.n) : u;
  }, c.prototype.sign = function(u, d, l, h) {
    typeof l == "object" && (h = l, l = null), h || (h = {}), d = this.keyFromPrivate(d, l), u = this._truncateToN(new t(u, 16));
    for (var y = this.n.byteLength(), p = d.getPrivate().toArray("be", y), b = u.toArray("be", y), v = new e({
      hash: this.hash,
      entropy: p,
      nonce: b,
      pers: h.pers,
      persEnc: h.persEnc || "utf8"
    }), x = this.n.sub(new t(1)), I = 0; ; I++) {
      var L = h.k ? h.k(I) : new t(v.generate(this.n.byteLength()));
      if (L = this._truncateToN(L, !0), !(L.cmpn(1) <= 0 || L.cmp(x) >= 0)) {
        var P = this.g.mul(L);
        if (!P.isInfinity()) {
          var C = P.getX(), D = C.umod(this.n);
          if (D.cmpn(0) !== 0) {
            var F = L.invm(this.n).mul(D.mul(d.getPrivate()).iadd(u));
            if (F = F.umod(this.n), F.cmpn(0) !== 0) {
              var G = (P.getY().isOdd() ? 1 : 0) | (C.cmp(D) !== 0 ? 2 : 0);
              return h.canonical && F.cmp(this.nh) > 0 && (F = this.n.sub(F), G ^= 1), new o({ r: D, s: F, recoveryParam: G });
            }
          }
        }
      }
    }
  }, c.prototype.verify = function(u, d, l, h) {
    u = this._truncateToN(new t(u, 16)), l = this.keyFromPublic(l, h), d = new o(d, "hex");
    var y = d.r, p = d.s;
    if (y.cmpn(1) < 0 || y.cmp(this.n) >= 0 || p.cmpn(1) < 0 || p.cmp(this.n) >= 0)
      return !1;
    var b = p.invm(this.n), v = b.mul(u).umod(this.n), x = b.mul(y).umod(this.n), I;
    return this.curve._maxwellTrick ? (I = this.g.jmulAdd(v, l.getPublic(), x), I.isInfinity() ? !1 : I.eqXToP(y)) : (I = this.g.mulAdd(v, l.getPublic(), x), I.isInfinity() ? !1 : I.getX().umod(this.n).cmp(y) === 0);
  }, c.prototype.recoverPubKey = function(f, u, d, l) {
    s((3 & d) === d, "The recovery param is more than two bits"), u = new o(u, l);
    var h = this.n, y = new t(f), p = u.r, b = u.s, v = d & 1, x = d >> 1;
    if (p.cmp(this.curve.p.umod(this.curve.n)) >= 0 && x)
      throw new Error("Unable to find sencond key candinate");
    x ? p = this.curve.pointFromX(p.add(this.curve.n), v) : p = this.curve.pointFromX(p, v);
    var I = u.r.invm(h), L = h.sub(y).mul(I).umod(h), P = b.mul(I).umod(h);
    return this.g.mulAdd(L, p, P);
  }, c.prototype.getKeyRecoveryParam = function(f, u, d, l) {
    if (u = new o(u, l), u.recoveryParam !== null)
      return u.recoveryParam;
    for (var h = 0; h < 4; h++) {
      var y;
      try {
        y = this.recoverPubKey(f, u, h);
      } catch {
        continue;
      }
      if (y.eq(d))
        return h;
    }
    throw new Error("Unable to find valid recovery factor");
  }, Eb;
}
var xb, VS;
function GC() {
  if (VS)
    return xb;
  VS = 1;
  var t = us(), e = t.assert, r = t.parseBytes, n = t.cachedProperty;
  function i(s, a) {
    this.eddsa = s, this._secret = r(a.secret), s.isPoint(a.pub) ? this._pub = a.pub : this._pubBytes = r(a.pub);
  }
  return i.fromPublic = function(a, o) {
    return o instanceof i ? o : new i(a, { pub: o });
  }, i.fromSecret = function(a, o) {
    return o instanceof i ? o : new i(a, { secret: o });
  }, i.prototype.secret = function() {
    return this._secret;
  }, n(i, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), n(i, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), n(i, "privBytes", function() {
    var a = this.eddsa, o = this.hash(), c = a.encodingLength - 1, f = o.slice(0, a.encodingLength);
    return f[0] &= 248, f[c] &= 127, f[c] |= 64, f;
  }), n(i, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), n(i, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), n(i, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), i.prototype.sign = function(a) {
    return e(this._secret, "KeyPair can only verify"), this.eddsa.sign(a, this);
  }, i.prototype.verify = function(a, o) {
    return this.eddsa.verify(a, o, this);
  }, i.prototype.getSecret = function(a) {
    return e(this._secret, "KeyPair is public only"), t.encode(this.secret(), a);
  }, i.prototype.getPublic = function(a) {
    return t.encode(this.pubBytes(), a);
  }, xb = i, xb;
}
var Ab, HS;
function ZC() {
  if (HS)
    return Ab;
  HS = 1;
  var t = Tr, e = us(), r = e.assert, n = e.cachedProperty, i = e.parseBytes;
  function s(a, o) {
    this.eddsa = a, typeof o != "object" && (o = i(o)), Array.isArray(o) && (o = {
      R: o.slice(0, a.encodingLength),
      S: o.slice(a.encodingLength)
    }), r(o.R && o.S, "Signature without R or S"), a.isPoint(o.R) && (this._R = o.R), o.S instanceof t && (this._S = o.S), this._Rencoded = Array.isArray(o.R) ? o.R : o.Rencoded, this._Sencoded = Array.isArray(o.S) ? o.S : o.Sencoded;
  }
  return n(s, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), n(s, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), n(s, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), n(s, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), s.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, s.prototype.toHex = function() {
    return e.encode(this.toBytes(), "hex").toUpperCase();
  }, Ab = s, Ab;
}
var Ib, GS;
function JC() {
  if (GS)
    return Ib;
  GS = 1;
  var t = C0(), e = q2(), r = us(), n = r.assert, i = r.parseBytes, s = GC(), a = ZC();
  function o(c) {
    if (n(c === "ed25519", "only tested with ed25519 so far"), !(this instanceof o))
      return new o(c);
    c = e[c].curve, this.curve = c, this.g = c.g, this.g.precompute(c.n.bitLength() + 1), this.pointClass = c.point().constructor, this.encodingLength = Math.ceil(c.n.bitLength() / 8), this.hash = t.sha512;
  }
  return Ib = o, o.prototype.sign = function(f, u) {
    f = i(f);
    var d = this.keyFromSecret(u), l = this.hashInt(d.messagePrefix(), f), h = this.g.mul(l), y = this.encodePoint(h), p = this.hashInt(y, d.pubBytes(), f).mul(d.priv()), b = l.add(p).umod(this.curve.n);
    return this.makeSignature({ R: h, S: b, Rencoded: y });
  }, o.prototype.verify = function(f, u, d) {
    f = i(f), u = this.makeSignature(u);
    var l = this.keyFromPublic(d), h = this.hashInt(u.Rencoded(), l.pubBytes(), f), y = this.g.mul(u.S()), p = u.R().add(l.pub().mul(h));
    return p.eq(y);
  }, o.prototype.hashInt = function() {
    for (var f = this.hash(), u = 0; u < arguments.length; u++)
      f.update(arguments[u]);
    return r.intFromLE(f.digest()).umod(this.curve.n);
  }, o.prototype.keyFromPublic = function(f) {
    return s.fromPublic(this, f);
  }, o.prototype.keyFromSecret = function(f) {
    return s.fromSecret(this, f);
  }, o.prototype.makeSignature = function(f) {
    return f instanceof a ? f : new a(this, f);
  }, o.prototype.encodePoint = function(f) {
    var u = f.getY().toArray("le", this.encodingLength);
    return u[this.encodingLength - 1] |= f.getX().isOdd() ? 128 : 0, u;
  }, o.prototype.decodePoint = function(f) {
    f = r.parseBytes(f);
    var u = f.length - 1, d = f.slice(0, u).concat(f[u] & -129), l = (f[u] & 128) !== 0, h = r.intFromLE(d);
    return this.curve.pointFromY(h, l);
  }, o.prototype.encodeInt = function(f) {
    return f.toArray("le", this.encodingLength);
  }, o.prototype.decodeInt = function(f) {
    return r.intFromLE(f);
  }, o.prototype.isPoint = function(f) {
    return f instanceof this.pointClass;
  }, Ib;
}
var ZS;
function N0() {
  return ZS || (ZS = 1, function(t) {
    var e = t;
    e.version = MC.version, e.utils = us(), e.rand = j2(), e.curve = s5(), e.curves = q2(), e.ec = HC(), e.eddsa = JC();
  }(tb)), tb;
}
var Gi = {}, Tb = {}, kb = {}, Rb = {}, Pb, JS;
function W2() {
  if (JS)
    return Pb;
  JS = 1;
  var t = Fe, e = t.Buffer, r = {}, n;
  for (n in t)
    t.hasOwnProperty(n) && (n === "SlowBuffer" || n === "Buffer" || (r[n] = t[n]));
  var i = r.Buffer = {};
  for (n in e)
    e.hasOwnProperty(n) && (n === "allocUnsafe" || n === "allocUnsafeSlow" || (i[n] = e[n]));
  if (r.Buffer.prototype = e.prototype, (!i.from || i.from === Uint8Array.from) && (i.from = function(s, a, o) {
    if (typeof s == "number")
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof s);
    if (s && typeof s.length > "u")
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof s);
    return e(s, a, o);
  }), i.alloc || (i.alloc = function(s, a, o) {
    if (typeof s != "number")
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof s);
    if (s < 0 || s >= 2 * (1 << 30))
      throw new RangeError('The value "' + s + '" is invalid for option "size"');
    var c = e(s);
    return !a || a.length === 0 ? c.fill(0) : typeof o == "string" ? c.fill(a, o) : c.fill(a), c;
  }), !r.kStringMaxLength)
    try {
      r.kStringMaxLength = ut.binding("buffer").kStringMaxLength;
    } catch {
    }
  return r.constants || (r.constants = {
    MAX_LENGTH: r.kMaxLength
  }, r.kStringMaxLength && (r.constants.MAX_STRING_LENGTH = r.kStringMaxLength)), Pb = r, Pb;
}
var Ob = {}, YS;
function z2() {
  if (YS)
    return Ob;
  YS = 1;
  const t = Kt;
  function e(n) {
    this._reporterState = {
      obj: null,
      path: [],
      options: n || {},
      errors: []
    };
  }
  Ob.Reporter = e, e.prototype.isError = function(i) {
    return i instanceof r;
  }, e.prototype.save = function() {
    const i = this._reporterState;
    return { obj: i.obj, pathLen: i.path.length };
  }, e.prototype.restore = function(i) {
    const s = this._reporterState;
    s.obj = i.obj, s.path = s.path.slice(0, i.pathLen);
  }, e.prototype.enterKey = function(i) {
    return this._reporterState.path.push(i);
  }, e.prototype.exitKey = function(i) {
    const s = this._reporterState;
    s.path = s.path.slice(0, i - 1);
  }, e.prototype.leaveKey = function(i, s, a) {
    const o = this._reporterState;
    this.exitKey(i), o.obj !== null && (o.obj[s] = a);
  }, e.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, e.prototype.enterObject = function() {
    const i = this._reporterState, s = i.obj;
    return i.obj = {}, s;
  }, e.prototype.leaveObject = function(i) {
    const s = this._reporterState, a = s.obj;
    return s.obj = i, a;
  }, e.prototype.error = function(i) {
    let s;
    const a = this._reporterState, o = i instanceof r;
    if (o ? s = i : s = new r(a.path.map(function(c) {
      return "[" + JSON.stringify(c) + "]";
    }).join(""), i.message || i, i.stack), !a.options.partial)
      throw s;
    return o || a.errors.push(s), s;
  }, e.prototype.wrapResult = function(i) {
    const s = this._reporterState;
    return s.options.partial ? {
      result: this.isError(i) ? null : i,
      errors: s.errors
    } : i;
  };
  function r(n, i) {
    this.path = n, this.rethrow(i);
  }
  return t(r, Error), r.prototype.rethrow = function(i) {
    if (this.message = i + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, r), !this.stack)
      try {
        throw new Error(this.message);
      } catch (s) {
        this.stack = s.stack;
      }
    return this;
  }, Ob;
}
var uh = {}, QS;
function Md() {
  if (QS)
    return uh;
  QS = 1;
  const t = Kt, e = z2().Reporter, r = W2().Buffer;
  function n(s, a) {
    if (e.call(this, a), !r.isBuffer(s)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = s, this.offset = 0, this.length = s.length;
  }
  t(n, e), uh.DecoderBuffer = n, n.isDecoderBuffer = function(a) {
    return a instanceof n ? !0 : typeof a == "object" && r.isBuffer(a.base) && a.constructor.name === "DecoderBuffer" && typeof a.offset == "number" && typeof a.length == "number" && typeof a.save == "function" && typeof a.restore == "function" && typeof a.isEmpty == "function" && typeof a.readUInt8 == "function" && typeof a.skip == "function" && typeof a.raw == "function";
  }, n.prototype.save = function() {
    return { offset: this.offset, reporter: e.prototype.save.call(this) };
  }, n.prototype.restore = function(a) {
    const o = new n(this.base);
    return o.offset = a.offset, o.length = this.offset, this.offset = a.offset, e.prototype.restore.call(this, a.reporter), o;
  }, n.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, n.prototype.readUInt8 = function(a) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(a || "DecoderBuffer overrun");
  }, n.prototype.skip = function(a, o) {
    if (!(this.offset + a <= this.length))
      return this.error(o || "DecoderBuffer overrun");
    const c = new n(this.base);
    return c._reporterState = this._reporterState, c.offset = this.offset, c.length = this.offset + a, this.offset += a, c;
  }, n.prototype.raw = function(a) {
    return this.base.slice(a ? a.offset : this.offset, this.length);
  };
  function i(s, a) {
    if (Array.isArray(s))
      this.length = 0, this.value = s.map(function(o) {
        return i.isEncoderBuffer(o) || (o = new i(o, a)), this.length += o.length, o;
      }, this);
    else if (typeof s == "number") {
      if (!(0 <= s && s <= 255))
        return a.error("non-byte EncoderBuffer value");
      this.value = s, this.length = 1;
    } else if (typeof s == "string")
      this.value = s, this.length = r.byteLength(s);
    else if (r.isBuffer(s))
      this.value = s, this.length = s.length;
    else
      return a.error("Unsupported type: " + typeof s);
  }
  return uh.EncoderBuffer = i, i.isEncoderBuffer = function(a) {
    return a instanceof i ? !0 : typeof a == "object" && a.constructor.name === "EncoderBuffer" && typeof a.length == "number" && typeof a.join == "function";
  }, i.prototype.join = function(a, o) {
    return a || (a = r.alloc(this.length)), o || (o = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(c) {
      c.join(a, o), o += c.length;
    }) : (typeof this.value == "number" ? a[o] = this.value : typeof this.value == "string" ? a.write(this.value, o) : r.isBuffer(this.value) && this.value.copy(a, o), o += this.length)), a;
  }, uh;
}
var Bb, XS;
function K2() {
  if (XS)
    return Bb;
  XS = 1;
  const t = z2().Reporter, e = Md().EncoderBuffer, r = Md().DecoderBuffer, n = hr, i = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], s = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(i), a = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function o(f, u, d) {
    const l = {};
    this._baseState = l, l.name = d, l.enc = f, l.parent = u || null, l.children = null, l.tag = null, l.args = null, l.reverseArgs = null, l.choice = null, l.optional = !1, l.any = !1, l.obj = !1, l.use = null, l.useDecoder = null, l.key = null, l.default = null, l.explicit = null, l.implicit = null, l.contains = null, l.parent || (l.children = [], this._wrap());
  }
  Bb = o;
  const c = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return o.prototype.clone = function() {
    const u = this._baseState, d = {};
    c.forEach(function(h) {
      d[h] = u[h];
    });
    const l = new this.constructor(d.parent);
    return l._baseState = d, l;
  }, o.prototype._wrap = function() {
    const u = this._baseState;
    s.forEach(function(d) {
      this[d] = function() {
        const h = new this.constructor(this);
        return u.children.push(h), h[d].apply(h, arguments);
      };
    }, this);
  }, o.prototype._init = function(u) {
    const d = this._baseState;
    n(d.parent === null), u.call(this), d.children = d.children.filter(function(l) {
      return l._baseState.parent === this;
    }, this), n.equal(d.children.length, 1, "Root node can have only one child");
  }, o.prototype._useArgs = function(u) {
    const d = this._baseState, l = u.filter(function(h) {
      return h instanceof this.constructor;
    }, this);
    u = u.filter(function(h) {
      return !(h instanceof this.constructor);
    }, this), l.length !== 0 && (n(d.children === null), d.children = l, l.forEach(function(h) {
      h._baseState.parent = this;
    }, this)), u.length !== 0 && (n(d.args === null), d.args = u, d.reverseArgs = u.map(function(h) {
      if (typeof h != "object" || h.constructor !== Object)
        return h;
      const y = {};
      return Object.keys(h).forEach(function(p) {
        p == (p | 0) && (p |= 0);
        const b = h[p];
        y[b] = p;
      }), y;
    }));
  }, a.forEach(function(f) {
    o.prototype[f] = function() {
      const d = this._baseState;
      throw new Error(f + " not implemented for encoding: " + d.enc);
    };
  }), i.forEach(function(f) {
    o.prototype[f] = function() {
      const d = this._baseState, l = Array.prototype.slice.call(arguments);
      return n(d.tag === null), d.tag = f, this._useArgs(l), this;
    };
  }), o.prototype.use = function(u) {
    n(u);
    const d = this._baseState;
    return n(d.use === null), d.use = u, this;
  }, o.prototype.optional = function() {
    const u = this._baseState;
    return u.optional = !0, this;
  }, o.prototype.def = function(u) {
    const d = this._baseState;
    return n(d.default === null), d.default = u, d.optional = !0, this;
  }, o.prototype.explicit = function(u) {
    const d = this._baseState;
    return n(d.explicit === null && d.implicit === null), d.explicit = u, this;
  }, o.prototype.implicit = function(u) {
    const d = this._baseState;
    return n(d.explicit === null && d.implicit === null), d.implicit = u, this;
  }, o.prototype.obj = function() {
    const u = this._baseState, d = Array.prototype.slice.call(arguments);
    return u.obj = !0, d.length !== 0 && this._useArgs(d), this;
  }, o.prototype.key = function(u) {
    const d = this._baseState;
    return n(d.key === null), d.key = u, this;
  }, o.prototype.any = function() {
    const u = this._baseState;
    return u.any = !0, this;
  }, o.prototype.choice = function(u) {
    const d = this._baseState;
    return n(d.choice === null), d.choice = u, this._useArgs(Object.keys(u).map(function(l) {
      return u[l];
    })), this;
  }, o.prototype.contains = function(u) {
    const d = this._baseState;
    return n(d.use === null), d.contains = u, this;
  }, o.prototype._decode = function(u, d) {
    const l = this._baseState;
    if (l.parent === null)
      return u.wrapResult(l.children[0]._decode(u, d));
    let h = l.default, y = !0, p = null;
    if (l.key !== null && (p = u.enterKey(l.key)), l.optional) {
      let v = null;
      if (l.explicit !== null ? v = l.explicit : l.implicit !== null ? v = l.implicit : l.tag !== null && (v = l.tag), v === null && !l.any) {
        const x = u.save();
        try {
          l.choice === null ? this._decodeGeneric(l.tag, u, d) : this._decodeChoice(u, d), y = !0;
        } catch {
          y = !1;
        }
        u.restore(x);
      } else if (y = this._peekTag(u, v, l.any), u.isError(y))
        return y;
    }
    let b;
    if (l.obj && y && (b = u.enterObject()), y) {
      if (l.explicit !== null) {
        const x = this._decodeTag(u, l.explicit);
        if (u.isError(x))
          return x;
        u = x;
      }
      const v = u.offset;
      if (l.use === null && l.choice === null) {
        let x;
        l.any && (x = u.save());
        const I = this._decodeTag(
          u,
          l.implicit !== null ? l.implicit : l.tag,
          l.any
        );
        if (u.isError(I))
          return I;
        l.any ? h = u.raw(x) : u = I;
      }
      if (d && d.track && l.tag !== null && d.track(u.path(), v, u.length, "tagged"), d && d.track && l.tag !== null && d.track(u.path(), u.offset, u.length, "content"), l.any || (l.choice === null ? h = this._decodeGeneric(l.tag, u, d) : h = this._decodeChoice(u, d)), u.isError(h))
        return h;
      if (!l.any && l.choice === null && l.children !== null && l.children.forEach(function(I) {
        I._decode(u, d);
      }), l.contains && (l.tag === "octstr" || l.tag === "bitstr")) {
        const x = new r(h);
        h = this._getUse(l.contains, u._reporterState.obj)._decode(x, d);
      }
    }
    return l.obj && y && (h = u.leaveObject(b)), l.key !== null && (h !== null || y === !0) ? u.leaveKey(p, l.key, h) : p !== null && u.exitKey(p), h;
  }, o.prototype._decodeGeneric = function(u, d, l) {
    const h = this._baseState;
    return u === "seq" || u === "set" ? null : u === "seqof" || u === "setof" ? this._decodeList(d, u, h.args[0], l) : /str$/.test(u) ? this._decodeStr(d, u, l) : u === "objid" && h.args ? this._decodeObjid(d, h.args[0], h.args[1], l) : u === "objid" ? this._decodeObjid(d, null, null, l) : u === "gentime" || u === "utctime" ? this._decodeTime(d, u, l) : u === "null_" ? this._decodeNull(d, l) : u === "bool" ? this._decodeBool(d, l) : u === "objDesc" ? this._decodeStr(d, u, l) : u === "int" || u === "enum" ? this._decodeInt(d, h.args && h.args[0], l) : h.use !== null ? this._getUse(h.use, d._reporterState.obj)._decode(d, l) : d.error("unknown tag: " + u);
  }, o.prototype._getUse = function(u, d) {
    const l = this._baseState;
    return l.useDecoder = this._use(u, d), n(l.useDecoder._baseState.parent === null), l.useDecoder = l.useDecoder._baseState.children[0], l.implicit !== l.useDecoder._baseState.implicit && (l.useDecoder = l.useDecoder.clone(), l.useDecoder._baseState.implicit = l.implicit), l.useDecoder;
  }, o.prototype._decodeChoice = function(u, d) {
    const l = this._baseState;
    let h = null, y = !1;
    return Object.keys(l.choice).some(function(p) {
      const b = u.save(), v = l.choice[p];
      try {
        const x = v._decode(u, d);
        if (u.isError(x))
          return !1;
        h = { type: p, value: x }, y = !0;
      } catch {
        return u.restore(b), !1;
      }
      return !0;
    }, this), y ? h : u.error("Choice not matched");
  }, o.prototype._createEncoderBuffer = function(u) {
    return new e(u, this.reporter);
  }, o.prototype._encode = function(u, d, l) {
    const h = this._baseState;
    if (h.default !== null && h.default === u)
      return;
    const y = this._encodeValue(u, d, l);
    if (y !== void 0 && !this._skipDefault(y, d, l))
      return y;
  }, o.prototype._encodeValue = function(u, d, l) {
    const h = this._baseState;
    if (h.parent === null)
      return h.children[0]._encode(u, d || new t());
    let y = null;
    if (this.reporter = d, h.optional && u === void 0)
      if (h.default !== null)
        u = h.default;
      else
        return;
    let p = null, b = !1;
    if (h.any)
      y = this._createEncoderBuffer(u);
    else if (h.choice)
      y = this._encodeChoice(u, d);
    else if (h.contains)
      p = this._getUse(h.contains, l)._encode(u, d), b = !0;
    else if (h.children)
      p = h.children.map(function(v) {
        if (v._baseState.tag === "null_")
          return v._encode(null, d, u);
        if (v._baseState.key === null)
          return d.error("Child should have a key");
        const x = d.enterKey(v._baseState.key);
        if (typeof u != "object")
          return d.error("Child expected, but input is not object");
        const I = v._encode(u[v._baseState.key], d, u);
        return d.leaveKey(x), I;
      }, this).filter(function(v) {
        return v;
      }), p = this._createEncoderBuffer(p);
    else if (h.tag === "seqof" || h.tag === "setof") {
      if (!(h.args && h.args.length === 1))
        return d.error("Too many args for : " + h.tag);
      if (!Array.isArray(u))
        return d.error("seqof/setof, but data is not Array");
      const v = this.clone();
      v._baseState.implicit = null, p = this._createEncoderBuffer(u.map(function(x) {
        const I = this._baseState;
        return this._getUse(I.args[0], u)._encode(x, d);
      }, v));
    } else
      h.use !== null ? y = this._getUse(h.use, l)._encode(u, d) : (p = this._encodePrimitive(h.tag, u), b = !0);
    if (!h.any && h.choice === null) {
      const v = h.implicit !== null ? h.implicit : h.tag, x = h.implicit === null ? "universal" : "context";
      v === null ? h.use === null && d.error("Tag could be omitted only for .use()") : h.use === null && (y = this._encodeComposite(v, b, x, p));
    }
    return h.explicit !== null && (y = this._encodeComposite(h.explicit, !1, "context", y)), y;
  }, o.prototype._encodeChoice = function(u, d) {
    const l = this._baseState, h = l.choice[u.type];
    return h || n(
      !1,
      u.type + " not found in " + JSON.stringify(Object.keys(l.choice))
    ), h._encode(u.value, d);
  }, o.prototype._encodePrimitive = function(u, d) {
    const l = this._baseState;
    if (/str$/.test(u))
      return this._encodeStr(d, u);
    if (u === "objid" && l.args)
      return this._encodeObjid(d, l.reverseArgs[0], l.args[1]);
    if (u === "objid")
      return this._encodeObjid(d, null, null);
    if (u === "gentime" || u === "utctime")
      return this._encodeTime(d, u);
    if (u === "null_")
      return this._encodeNull();
    if (u === "int" || u === "enum")
      return this._encodeInt(d, l.args && l.reverseArgs[0]);
    if (u === "bool")
      return this._encodeBool(d);
    if (u === "objDesc")
      return this._encodeStr(d, u);
    throw new Error("Unsupported tag: " + u);
  }, o.prototype._isNumstr = function(u) {
    return /^[0-9 ]*$/.test(u);
  }, o.prototype._isPrintstr = function(u) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(u);
  }, Bb;
}
var Mb = {}, e6;
function V2() {
  return e6 || (e6 = 1, function(t) {
    function e(r) {
      const n = {};
      return Object.keys(r).forEach(function(i) {
        (i | 0) == i && (i = i | 0);
        const s = r[i];
        n[s] = i;
      }), n;
    }
    t.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, t.tagClassByName = e(t.tagClass), t.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, t.tagByName = e(t.tag);
  }(Mb)), Mb;
}
var Cb, t6;
function u5() {
  if (t6)
    return Cb;
  t6 = 1;
  const t = Kt, e = W2().Buffer, r = K2(), n = V2();
  function i(c) {
    this.enc = "der", this.name = c.name, this.entity = c, this.tree = new s(), this.tree._init(c.body);
  }
  Cb = i, i.prototype.encode = function(f, u) {
    return this.tree._encode(f, u).join();
  };
  function s(c) {
    r.call(this, "der", c);
  }
  t(s, r), s.prototype._encodeComposite = function(f, u, d, l) {
    const h = o(f, u, d, this.reporter);
    if (l.length < 128) {
      const b = e.alloc(2);
      return b[0] = h, b[1] = l.length, this._createEncoderBuffer([b, l]);
    }
    let y = 1;
    for (let b = l.length; b >= 256; b >>= 8)
      y++;
    const p = e.alloc(2 + y);
    p[0] = h, p[1] = 128 | y;
    for (let b = 1 + y, v = l.length; v > 0; b--, v >>= 8)
      p[b] = v & 255;
    return this._createEncoderBuffer([p, l]);
  }, s.prototype._encodeStr = function(f, u) {
    if (u === "bitstr")
      return this._createEncoderBuffer([f.unused | 0, f.data]);
    if (u === "bmpstr") {
      const d = e.alloc(f.length * 2);
      for (let l = 0; l < f.length; l++)
        d.writeUInt16BE(f.charCodeAt(l), l * 2);
      return this._createEncoderBuffer(d);
    } else
      return u === "numstr" ? this._isNumstr(f) ? this._createEncoderBuffer(f) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : u === "printstr" ? this._isPrintstr(f) ? this._createEncoderBuffer(f) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(u) ? this._createEncoderBuffer(f) : u === "objDesc" ? this._createEncoderBuffer(f) : this.reporter.error("Encoding of string type: " + u + " unsupported");
  }, s.prototype._encodeObjid = function(f, u, d) {
    if (typeof f == "string") {
      if (!u)
        return this.reporter.error("string objid given, but no values map found");
      if (!u.hasOwnProperty(f))
        return this.reporter.error("objid not found in values map");
      f = u[f].split(/[\s.]+/g);
      for (let p = 0; p < f.length; p++)
        f[p] |= 0;
    } else if (Array.isArray(f)) {
      f = f.slice();
      for (let p = 0; p < f.length; p++)
        f[p] |= 0;
    }
    if (!Array.isArray(f))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(f));
    if (!d) {
      if (f[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      f.splice(0, 2, f[0] * 40 + f[1]);
    }
    let l = 0;
    for (let p = 0; p < f.length; p++) {
      let b = f[p];
      for (l++; b >= 128; b >>= 7)
        l++;
    }
    const h = e.alloc(l);
    let y = h.length - 1;
    for (let p = f.length - 1; p >= 0; p--) {
      let b = f[p];
      for (h[y--] = b & 127; (b >>= 7) > 0; )
        h[y--] = 128 | b & 127;
    }
    return this._createEncoderBuffer(h);
  };
  function a(c) {
    return c < 10 ? "0" + c : c;
  }
  s.prototype._encodeTime = function(f, u) {
    let d;
    const l = new Date(f);
    return u === "gentime" ? d = [
      a(l.getUTCFullYear()),
      a(l.getUTCMonth() + 1),
      a(l.getUTCDate()),
      a(l.getUTCHours()),
      a(l.getUTCMinutes()),
      a(l.getUTCSeconds()),
      "Z"
    ].join("") : u === "utctime" ? d = [
      a(l.getUTCFullYear() % 100),
      a(l.getUTCMonth() + 1),
      a(l.getUTCDate()),
      a(l.getUTCHours()),
      a(l.getUTCMinutes()),
      a(l.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + u + " time is not supported yet"), this._encodeStr(d, "octstr");
  }, s.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, s.prototype._encodeInt = function(f, u) {
    if (typeof f == "string") {
      if (!u)
        return this.reporter.error("String int or enum given, but no values map");
      if (!u.hasOwnProperty(f))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(f));
      f = u[f];
    }
    if (typeof f != "number" && !e.isBuffer(f)) {
      const h = f.toArray();
      !f.sign && h[0] & 128 && h.unshift(0), f = e.from(h);
    }
    if (e.isBuffer(f)) {
      let h = f.length;
      f.length === 0 && h++;
      const y = e.alloc(h);
      return f.copy(y), f.length === 0 && (y[0] = 0), this._createEncoderBuffer(y);
    }
    if (f < 128)
      return this._createEncoderBuffer(f);
    if (f < 256)
      return this._createEncoderBuffer([0, f]);
    let d = 1;
    for (let h = f; h >= 256; h >>= 8)
      d++;
    const l = new Array(d);
    for (let h = l.length - 1; h >= 0; h--)
      l[h] = f & 255, f >>= 8;
    return l[0] & 128 && l.unshift(0), this._createEncoderBuffer(e.from(l));
  }, s.prototype._encodeBool = function(f) {
    return this._createEncoderBuffer(f ? 255 : 0);
  }, s.prototype._use = function(f, u) {
    return typeof f == "function" && (f = f(u)), f._getEncoder("der").tree;
  }, s.prototype._skipDefault = function(f, u, d) {
    const l = this._baseState;
    let h;
    if (l.default === null)
      return !1;
    const y = f.join();
    if (l.defaultBuffer === void 0 && (l.defaultBuffer = this._encodeValue(l.default, u, d).join()), y.length !== l.defaultBuffer.length)
      return !1;
    for (h = 0; h < y.length; h++)
      if (y[h] !== l.defaultBuffer[h])
        return !1;
    return !0;
  };
  function o(c, f, u, d) {
    let l;
    if (c === "seqof" ? c = "seq" : c === "setof" && (c = "set"), n.tagByName.hasOwnProperty(c))
      l = n.tagByName[c];
    else if (typeof c == "number" && (c | 0) === c)
      l = c;
    else
      return d.error("Unknown tag: " + c);
    return l >= 31 ? d.error("Multi-octet tag encoding unsupported") : (f || (l |= 32), l |= n.tagClassByName[u || "universal"] << 6, l);
  }
  return Cb;
}
var Nb, r6;
function YC() {
  if (r6)
    return Nb;
  r6 = 1;
  const t = Kt, e = u5();
  function r(n) {
    e.call(this, n), this.enc = "pem";
  }
  return t(r, e), Nb = r, r.prototype.encode = function(i, s) {
    const o = e.prototype.encode.call(this, i).toString("base64"), c = ["-----BEGIN " + s.label + "-----"];
    for (let f = 0; f < o.length; f += 64)
      c.push(o.slice(f, f + 64));
    return c.push("-----END " + s.label + "-----"), c.join(`
`);
  }, Nb;
}
var n6;
function f5() {
  return n6 || (n6 = 1, function(t) {
    const e = t;
    e.der = u5(), e.pem = YC();
  }(Rb)), Rb;
}
var Ub = {}, Lb, i6;
function d5() {
  if (i6)
    return Lb;
  i6 = 1;
  const t = Kt, e = Tr, r = Md().DecoderBuffer, n = K2(), i = V2();
  function s(f) {
    this.enc = "der", this.name = f.name, this.entity = f, this.tree = new a(), this.tree._init(f.body);
  }
  Lb = s, s.prototype.decode = function(u, d) {
    return r.isDecoderBuffer(u) || (u = new r(u, d)), this.tree._decode(u, d);
  };
  function a(f) {
    n.call(this, "der", f);
  }
  t(a, n), a.prototype._peekTag = function(u, d, l) {
    if (u.isEmpty())
      return !1;
    const h = u.save(), y = o(u, 'Failed to peek tag: "' + d + '"');
    return u.isError(y) ? y : (u.restore(h), y.tag === d || y.tagStr === d || y.tagStr + "of" === d || l);
  }, a.prototype._decodeTag = function(u, d, l) {
    const h = o(
      u,
      'Failed to decode tag of "' + d + '"'
    );
    if (u.isError(h))
      return h;
    let y = c(
      u,
      h.primitive,
      'Failed to get length of "' + d + '"'
    );
    if (u.isError(y))
      return y;
    if (!l && h.tag !== d && h.tagStr !== d && h.tagStr + "of" !== d)
      return u.error('Failed to match tag: "' + d + '"');
    if (h.primitive || y !== null)
      return u.skip(y, 'Failed to match body of: "' + d + '"');
    const p = u.save(), b = this._skipUntilEnd(
      u,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return u.isError(b) ? b : (y = u.offset - p.offset, u.restore(p), u.skip(y, 'Failed to match body of: "' + d + '"'));
  }, a.prototype._skipUntilEnd = function(u, d) {
    for (; ; ) {
      const l = o(u, d);
      if (u.isError(l))
        return l;
      const h = c(u, l.primitive, d);
      if (u.isError(h))
        return h;
      let y;
      if (l.primitive || h !== null ? y = u.skip(h) : y = this._skipUntilEnd(u, d), u.isError(y))
        return y;
      if (l.tagStr === "end")
        break;
    }
  }, a.prototype._decodeList = function(u, d, l, h) {
    const y = [];
    for (; !u.isEmpty(); ) {
      const p = this._peekTag(u, "end");
      if (u.isError(p))
        return p;
      const b = l.decode(u, "der", h);
      if (u.isError(b) && p)
        break;
      y.push(b);
    }
    return y;
  }, a.prototype._decodeStr = function(u, d) {
    if (d === "bitstr") {
      const l = u.readUInt8();
      return u.isError(l) ? l : { unused: l, data: u.raw() };
    } else if (d === "bmpstr") {
      const l = u.raw();
      if (l.length % 2 === 1)
        return u.error("Decoding of string type: bmpstr length mismatch");
      let h = "";
      for (let y = 0; y < l.length / 2; y++)
        h += String.fromCharCode(l.readUInt16BE(y * 2));
      return h;
    } else if (d === "numstr") {
      const l = u.raw().toString("ascii");
      return this._isNumstr(l) ? l : u.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (d === "octstr")
        return u.raw();
      if (d === "objDesc")
        return u.raw();
      if (d === "printstr") {
        const l = u.raw().toString("ascii");
        return this._isPrintstr(l) ? l : u.error("Decoding of string type: printstr unsupported characters");
      } else
        return /str$/.test(d) ? u.raw().toString() : u.error("Decoding of string type: " + d + " unsupported");
    }
  }, a.prototype._decodeObjid = function(u, d, l) {
    let h;
    const y = [];
    let p = 0, b = 0;
    for (; !u.isEmpty(); )
      b = u.readUInt8(), p <<= 7, p |= b & 127, b & 128 || (y.push(p), p = 0);
    b & 128 && y.push(p);
    const v = y[0] / 40 | 0, x = y[0] % 40;
    if (l ? h = y : h = [v, x].concat(y.slice(1)), d) {
      let I = d[h.join(" ")];
      I === void 0 && (I = d[h.join(".")]), I !== void 0 && (h = I);
    }
    return h;
  }, a.prototype._decodeTime = function(u, d) {
    const l = u.raw().toString();
    let h, y, p, b, v, x;
    if (d === "gentime")
      h = l.slice(0, 4) | 0, y = l.slice(4, 6) | 0, p = l.slice(6, 8) | 0, b = l.slice(8, 10) | 0, v = l.slice(10, 12) | 0, x = l.slice(12, 14) | 0;
    else if (d === "utctime")
      h = l.slice(0, 2) | 0, y = l.slice(2, 4) | 0, p = l.slice(4, 6) | 0, b = l.slice(6, 8) | 0, v = l.slice(8, 10) | 0, x = l.slice(10, 12) | 0, h < 70 ? h = 2e3 + h : h = 1900 + h;
    else
      return u.error("Decoding " + d + " time is not supported yet");
    return Date.UTC(h, y - 1, p, b, v, x, 0);
  }, a.prototype._decodeNull = function() {
    return null;
  }, a.prototype._decodeBool = function(u) {
    const d = u.readUInt8();
    return u.isError(d) ? d : d !== 0;
  }, a.prototype._decodeInt = function(u, d) {
    const l = u.raw();
    let h = new e(l);
    return d && (h = d[h.toString(10)] || h), h;
  }, a.prototype._use = function(u, d) {
    return typeof u == "function" && (u = u(d)), u._getDecoder("der").tree;
  };
  function o(f, u) {
    let d = f.readUInt8(u);
    if (f.isError(d))
      return d;
    const l = i.tagClass[d >> 6], h = (d & 32) === 0;
    if ((d & 31) === 31) {
      let p = d;
      for (d = 0; (p & 128) === 128; ) {
        if (p = f.readUInt8(u), f.isError(p))
          return p;
        d <<= 7, d |= p & 127;
      }
    } else
      d &= 31;
    const y = i.tag[d];
    return {
      cls: l,
      primitive: h,
      tag: d,
      tagStr: y
    };
  }
  function c(f, u, d) {
    let l = f.readUInt8(d);
    if (f.isError(l))
      return l;
    if (!u && l === 128)
      return null;
    if (!(l & 128))
      return l;
    const h = l & 127;
    if (h > 4)
      return f.error("length octect is too long");
    l = 0;
    for (let y = 0; y < h; y++) {
      l <<= 8;
      const p = f.readUInt8(d);
      if (f.isError(p))
        return p;
      l |= p;
    }
    return l;
  }
  return Lb;
}
var Db, s6;
function QC() {
  if (s6)
    return Db;
  s6 = 1;
  const t = Kt, e = W2().Buffer, r = d5();
  function n(i) {
    r.call(this, i), this.enc = "pem";
  }
  return t(n, r), Db = n, n.prototype.decode = function(s, a) {
    const o = s.toString().split(/[\r\n]+/g), c = a.label.toUpperCase(), f = /^-----(BEGIN|END) ([^-]+)-----$/;
    let u = -1, d = -1;
    for (let y = 0; y < o.length; y++) {
      const p = o[y].match(f);
      if (p !== null && p[2] === c)
        if (u === -1) {
          if (p[1] !== "BEGIN")
            break;
          u = y;
        } else {
          if (p[1] !== "END")
            break;
          d = y;
          break;
        }
    }
    if (u === -1 || d === -1)
      throw new Error("PEM section not found for: " + c);
    const l = o.slice(u + 1, d).join("");
    l.replace(/[^a-z0-9+/=]+/gi, "");
    const h = e.from(l, "base64");
    return r.prototype.decode.call(this, h, a);
  }, Db;
}
var a6;
function l5() {
  return a6 || (a6 = 1, function(t) {
    const e = t;
    e.der = d5(), e.pem = QC();
  }(Ub)), Ub;
}
var o6;
function XC() {
  return o6 || (o6 = 1, function(t) {
    const e = f5(), r = l5(), n = Kt, i = t;
    i.define = function(o, c) {
      return new s(o, c);
    };
    function s(a, o) {
      this.name = a, this.body = o, this.decoders = {}, this.encoders = {};
    }
    s.prototype._createNamed = function(o) {
      const c = this.name;
      function f(u) {
        this._initNamed(u, c);
      }
      return n(f, o), f.prototype._initNamed = function(d, l) {
        o.call(this, d, l);
      }, new f(this);
    }, s.prototype._getDecoder = function(o) {
      return o = o || "der", this.decoders.hasOwnProperty(o) || (this.decoders[o] = this._createNamed(r[o])), this.decoders[o];
    }, s.prototype.decode = function(o, c, f) {
      return this._getDecoder(c).decode(o, f);
    }, s.prototype._getEncoder = function(o) {
      return o = o || "der", this.encoders.hasOwnProperty(o) || (this.encoders[o] = this._createNamed(e[o])), this.encoders[o];
    }, s.prototype.encode = function(o, c, f) {
      return this._getEncoder(c).encode(o, f);
    };
  }(kb)), kb;
}
var Fb = {}, c6;
function eN() {
  return c6 || (c6 = 1, function(t) {
    const e = t;
    e.Reporter = z2().Reporter, e.DecoderBuffer = Md().DecoderBuffer, e.EncoderBuffer = Md().EncoderBuffer, e.Node = K2();
  }(Fb)), Fb;
}
var jb = {}, u6;
function tN() {
  return u6 || (u6 = 1, function(t) {
    const e = t;
    e._reverse = function(n) {
      const i = {};
      return Object.keys(n).forEach(function(s) {
        (s | 0) == s && (s = s | 0);
        const a = n[s];
        i[a] = s;
      }), i;
    }, e.der = V2();
  }(jb)), jb;
}
var f6;
function h5() {
  return f6 || (f6 = 1, function(t) {
    const e = t;
    e.bignum = Tr, e.define = XC().define, e.base = eN(), e.constants = tN(), e.decoders = l5(), e.encoders = f5();
  }(Tb)), Tb;
}
var $b, d6;
function rN() {
  if (d6)
    return $b;
  d6 = 1;
  var t = h5(), e = t.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), r = t.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), n = t.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), i = t.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(n),
      this.key("subjectPublicKey").bitstr()
    );
  }), s = t.define("RelativeDistinguishedName", function() {
    this.setof(r);
  }), a = t.define("RDNSequence", function() {
    this.seqof(s);
  }), o = t.define("Name", function() {
    this.choice({
      rdnSequence: this.use(a)
    });
  }), c = t.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(e),
      this.key("notAfter").use(e)
    );
  }), f = t.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), u = t.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(n),
      this.key("issuer").use(o),
      this.key("validity").use(c),
      this.key("subject").use(o),
      this.key("subjectPublicKeyInfo").use(i),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(f).optional()
    );
  }), d = t.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(u),
      this.key("signatureAlgorithm").use(n),
      this.key("signatureValue").bitstr()
    );
  });
  return $b = d, $b;
}
var l6;
function nN() {
  if (l6)
    return Gi;
  l6 = 1;
  var t = h5();
  Gi.certificate = rN();
  var e = t.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  Gi.RSAPrivateKey = e;
  var r = t.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  Gi.RSAPublicKey = r;
  var n = t.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(i),
      this.key("subjectPublicKey").bitstr()
    );
  });
  Gi.PublicKey = n;
  var i = t.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), s = t.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(i),
      this.key("subjectPrivateKey").octstr()
    );
  });
  Gi.PrivateKey = s;
  var a = t.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  Gi.EncryptedPrivateKey = a;
  var o = t.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  Gi.DSAPrivateKey = o, Gi.DSAparam = t.define("DSAparam", function() {
    this.int();
  });
  var c = t.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(f),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  Gi.ECPrivateKey = c;
  var f = t.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  });
  return Gi.signature = t.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), Gi;
}
const iN = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var qb, h6;
function sN() {
  if (h6)
    return qb;
  h6 = 1;
  var t = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, e = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, r = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, n = B0(), i = D2(), s = Lt.Buffer;
  return qb = function(a, o) {
    var c = a.toString(), f = c.match(t), u;
    if (f) {
      var l = "aes" + f[1], h = s.from(f[2], "hex"), y = s.from(f[3].replace(/[\r\n]/g, ""), "base64"), p = n(o, h.slice(0, 8), parseInt(f[1], 10)).key, b = [], v = i.createDecipheriv(l, p, h);
      b.push(v.update(y)), b.push(v.final()), u = s.concat(b);
    } else {
      var d = c.match(r);
      u = s.from(d[2].replace(/[\r\n]/g, ""), "base64");
    }
    var x = c.match(e)[1];
    return {
      tag: x,
      data: u
    };
  }, qb;
}
var Wb, p6;
function U0() {
  if (p6)
    return Wb;
  p6 = 1;
  var t = nN(), e = iN, r = sN(), n = D2(), i = GA(), s = Lt.Buffer;
  Wb = a;
  function a(c) {
    var f;
    typeof c == "object" && !s.isBuffer(c) && (f = c.passphrase, c = c.key), typeof c == "string" && (c = s.from(c));
    var u = r(c, f), d = u.tag, l = u.data, h, y;
    switch (d) {
      case "CERTIFICATE":
        y = t.certificate.decode(l, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (y || (y = t.PublicKey.decode(l, "der")), h = y.algorithm.algorithm.join("."), h) {
          case "1.2.840.113549.1.1.1":
            return t.RSAPublicKey.decode(y.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return y.subjectPrivateKey = y.subjectPublicKey, {
              type: "ec",
              data: y
            };
          case "1.2.840.10040.4.1":
            return y.algorithm.params.pub_key = t.DSAparam.decode(y.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: y.algorithm.params
            };
          default:
            throw new Error("unknown key id " + h);
        }
      case "ENCRYPTED PRIVATE KEY":
        l = t.EncryptedPrivateKey.decode(l, "der"), l = o(l, f);
      case "PRIVATE KEY":
        switch (y = t.PrivateKey.decode(l, "der"), h = y.algorithm.algorithm.join("."), h) {
          case "1.2.840.113549.1.1.1":
            return t.RSAPrivateKey.decode(y.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: y.algorithm.curve,
              privateKey: t.ECPrivateKey.decode(y.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return y.algorithm.params.priv_key = t.DSAparam.decode(y.subjectPrivateKey, "der"), {
              type: "dsa",
              params: y.algorithm.params
            };
          default:
            throw new Error("unknown key id " + h);
        }
      case "RSA PUBLIC KEY":
        return t.RSAPublicKey.decode(l, "der");
      case "RSA PRIVATE KEY":
        return t.RSAPrivateKey.decode(l, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: t.DSAPrivateKey.decode(l, "der")
        };
      case "EC PRIVATE KEY":
        return l = t.ECPrivateKey.decode(l, "der"), {
          curve: l.parameters.value,
          privateKey: l.privateKey
        };
      default:
        throw new Error("unknown key type " + d);
    }
  }
  a.signature = t.signature;
  function o(c, f) {
    var u = c.algorithm.decrypt.kde.kdeparams.salt, d = parseInt(c.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), l = e[c.algorithm.decrypt.cipher.algo.join(".")], h = c.algorithm.decrypt.cipher.iv, y = c.subjectPrivateKey, p = parseInt(l.split("-")[1], 10) / 8, b = i.pbkdf2Sync(f, u, d, p, "sha1"), v = n.createDecipheriv(l, b, h), x = [];
    return x.push(v.update(y)), x.push(v.final()), s.concat(x);
  }
  return Wb;
}
const p5 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var y6;
function aN() {
  if (y6)
    return $f.exports;
  y6 = 1;
  var t = Lt.Buffer, e = P0, r = $2(), n = N0().ec, i = Tr, s = U0(), a = p5, o = 1;
  function c(v, x, I, L, P) {
    var C = s(x);
    if (C.curve) {
      if (L !== "ecdsa" && L !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return f(v, C);
    } else if (C.type === "dsa") {
      if (L !== "dsa")
        throw new Error("wrong private key type");
      return u(v, C, I);
    }
    if (L !== "rsa" && L !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (x.padding !== void 0 && x.padding !== o)
      throw new Error("illegal or unsupported padding mode");
    v = t.concat([P, v]);
    for (var D = C.modulus.byteLength(), F = [0, 1]; v.length + F.length + 1 < D; )
      F.push(255);
    F.push(0);
    for (var G = -1; ++G < v.length; )
      F.push(v[G]);
    var re = r(F, C);
    return re;
  }
  function f(v, x) {
    var I = a[x.curve.join(".")];
    if (!I)
      throw new Error("unknown curve " + x.curve.join("."));
    var L = new n(I), P = L.keyFromPrivate(x.privateKey), C = P.sign(v);
    return t.from(C.toDER());
  }
  function u(v, x, I) {
    for (var L = x.params.priv_key, P = x.params.p, C = x.params.q, D = x.params.g, F = new i(0), G, re = h(v, C).mod(C), ie = !1, ee = l(L, C, v, I); ie === !1; )
      G = p(C, ee, I), F = b(D, G, P, C), ie = G.invm(C).imul(re.add(L.mul(F))).mod(C), ie.cmpn(0) === 0 && (ie = !1, F = new i(0));
    return d(F, ie);
  }
  function d(v, x) {
    v = v.toArray(), x = x.toArray(), v[0] & 128 && (v = [0].concat(v)), x[0] & 128 && (x = [0].concat(x));
    var I = v.length + x.length + 4, L = [
      48,
      I,
      2,
      v.length
    ];
    return L = L.concat(v, [2, x.length], x), t.from(L);
  }
  function l(v, x, I, L) {
    if (v = t.from(v.toArray()), v.length < x.byteLength()) {
      var P = t.alloc(x.byteLength() - v.length);
      v = t.concat([P, v]);
    }
    var C = I.length, D = y(I, x), F = t.alloc(C);
    F.fill(1);
    var G = t.alloc(C);
    return G = e(L, G).update(F).update(t.from([0])).update(v).update(D).digest(), F = e(L, G).update(F).digest(), G = e(L, G).update(F).update(t.from([1])).update(v).update(D).digest(), F = e(L, G).update(F).digest(), { k: G, v: F };
  }
  function h(v, x) {
    var I = new i(v), L = (v.length << 3) - x.bitLength();
    return L > 0 && I.ishrn(L), I;
  }
  function y(v, x) {
    v = h(v, x), v = v.mod(x);
    var I = t.from(v.toArray());
    if (I.length < x.byteLength()) {
      var L = t.alloc(x.byteLength() - I.length);
      I = t.concat([L, I]);
    }
    return I;
  }
  function p(v, x, I) {
    var L, P;
    do {
      for (L = t.alloc(0); L.length * 8 < v.bitLength(); )
        x.v = e(I, x.k).update(x.v).digest(), L = t.concat([L, x.v]);
      P = h(L, v), x.k = e(I, x.k).update(x.v).update(t.from([0])).digest(), x.v = e(I, x.k).update(x.v).digest();
    } while (P.cmp(v) !== -1);
    return P;
  }
  function b(v, x, I, L) {
    return v.toRed(i.mont(I)).redPow(x).fromRed().mod(L);
  }
  return $f.exports = c, $f.exports.getKey = l, $f.exports.makeKey = p, $f.exports;
}
var zb, b6;
function oN() {
  if (b6)
    return zb;
  b6 = 1;
  var t = Lt.Buffer, e = Tr, r = N0().ec, n = U0(), i = p5;
  function s(f, u, d, l, h) {
    var y = n(d);
    if (y.type === "ec") {
      if (l !== "ecdsa" && l !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return a(f, u, y);
    } else if (y.type === "dsa") {
      if (l !== "dsa")
        throw new Error("wrong public key type");
      return o(f, u, y);
    }
    if (l !== "rsa" && l !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    u = t.concat([h, u]);
    for (var p = y.modulus.byteLength(), b = [1], v = 0; u.length + b.length + 2 < p; )
      b.push(255), v += 1;
    b.push(0);
    for (var x = -1; ++x < u.length; )
      b.push(u[x]);
    b = t.from(b);
    var I = e.mont(y.modulus);
    f = new e(f).toRed(I), f = f.redPow(new e(y.publicExponent)), f = t.from(f.fromRed().toArray());
    var L = v < 8 ? 1 : 0;
    for (p = Math.min(f.length, b.length), f.length !== b.length && (L = 1), x = -1; ++x < p; )
      L |= f[x] ^ b[x];
    return L === 0;
  }
  function a(f, u, d) {
    var l = i[d.data.algorithm.curve.join(".")];
    if (!l)
      throw new Error("unknown curve " + d.data.algorithm.curve.join("."));
    var h = new r(l), y = d.data.subjectPrivateKey.data;
    return h.verify(u, f, y);
  }
  function o(f, u, d) {
    var l = d.data.p, h = d.data.q, y = d.data.g, p = d.data.pub_key, b = n.signature.decode(f, "der"), v = b.s, x = b.r;
    c(v, h), c(x, h);
    var I = e.mont(l), L = v.invm(h), P = y.toRed(I).redPow(new e(u).mul(L).mod(h)).fromRed().mul(p.toRed(I).redPow(x.mul(L).mod(h)).fromRed()).mod(l).mod(h);
    return P.cmp(x) === 0;
  }
  function c(f, u) {
    if (f.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (f.cmp(u) >= 0)
      throw new Error("invalid sig");
  }
  return zb = s, zb;
}
var Kb, g6;
function cN() {
  if (g6)
    return Kb;
  g6 = 1;
  var t = Lt.Buffer, e = Dc(), r = AA, n = Kt, i = aN(), s = oN(), a = WA;
  Object.keys(a).forEach(function(d) {
    a[d].id = t.from(a[d].id, "hex"), a[d.toLowerCase()] = a[d];
  });
  function o(d) {
    r.Writable.call(this);
    var l = a[d];
    if (!l)
      throw new Error("Unknown message digest");
    this._hashType = l.hash, this._hash = e(l.hash), this._tag = l.id, this._signType = l.sign;
  }
  n(o, r.Writable), o.prototype._write = function(l, h, y) {
    this._hash.update(l), y();
  }, o.prototype.update = function(l, h) {
    return this._hash.update(typeof l == "string" ? t.from(l, h) : l), this;
  }, o.prototype.sign = function(l, h) {
    this.end();
    var y = this._hash.digest(), p = i(y, l, this._hashType, this._signType, this._tag);
    return h ? p.toString(h) : p;
  };
  function c(d) {
    r.Writable.call(this);
    var l = a[d];
    if (!l)
      throw new Error("Unknown message digest");
    this._hash = e(l.hash), this._tag = l.id, this._signType = l.sign;
  }
  n(c, r.Writable), c.prototype._write = function(l, h, y) {
    this._hash.update(l), y();
  }, c.prototype.update = function(l, h) {
    return this._hash.update(typeof l == "string" ? t.from(l, h) : l), this;
  }, c.prototype.verify = function(l, h, y) {
    var p = typeof h == "string" ? t.from(h, y) : h;
    this.end();
    var b = this._hash.digest();
    return s(p, b, l, this._signType, this._tag);
  };
  function f(d) {
    return new o(d);
  }
  function u(d) {
    return new c(d);
  }
  return Kb = {
    Sign: f,
    Verify: u,
    createSign: f,
    createVerify: u
  }, Kb;
}
var Vb, m6;
function uN() {
  if (m6)
    return Vb;
  m6 = 1;
  var t = N0(), e = Tr;
  Vb = function(a) {
    return new n(a);
  };
  var r = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  r.p224 = r.secp224r1, r.p256 = r.secp256r1 = r.prime256v1, r.p192 = r.secp192r1 = r.prime192v1, r.p384 = r.secp384r1, r.p521 = r.secp521r1;
  function n(s) {
    this.curveType = r[s], this.curveType || (this.curveType = {
      name: s
    }), this.curve = new t.ec(this.curveType.name), this.keys = void 0;
  }
  n.prototype.generateKeys = function(s, a) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(s, a);
  }, n.prototype.computeSecret = function(s, a, o) {
    a = a || "utf8", ve.isBuffer(s) || (s = new ve(s, a));
    var c = this.curve.keyFromPublic(s).getPublic(), f = c.mul(this.keys.getPrivate()).getX();
    return i(f, o, this.curveType.byteLength);
  }, n.prototype.getPublicKey = function(s, a) {
    var o = this.keys.getPublic(a === "compressed", !0);
    return a === "hybrid" && (o[o.length - 1] % 2 ? o[0] = 7 : o[0] = 6), i(o, s);
  }, n.prototype.getPrivateKey = function(s) {
    return i(this.keys.getPrivate(), s);
  }, n.prototype.setPublicKey = function(s, a) {
    return a = a || "utf8", ve.isBuffer(s) || (s = new ve(s, a)), this.keys._importPublic(s), this;
  }, n.prototype.setPrivateKey = function(s, a) {
    a = a || "utf8", ve.isBuffer(s) || (s = new ve(s, a));
    var o = new e(s);
    return o = o.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(o), this;
  };
  function i(s, a, o) {
    Array.isArray(s) || (s = s.toArray());
    var c = new ve(s);
    if (o && c.length < o) {
      var f = new ve(o - c.length);
      f.fill(0), c = ve.concat([f, c]);
    }
    return a ? c.toString(a) : c;
  }
  return Vb;
}
var Hb = {}, Gb, v6;
function y5() {
  if (v6)
    return Gb;
  v6 = 1;
  var t = Dc(), e = Lt.Buffer;
  Gb = function(n, i) {
    for (var s = e.alloc(0), a = 0, o; s.length < i; )
      o = r(a++), s = e.concat([s, t("sha1").update(n).update(o).digest()]);
    return s.slice(0, i);
  };
  function r(n) {
    var i = e.allocUnsafe(4);
    return i.writeUInt32BE(n, 0), i;
  }
  return Gb;
}
var Zb, w6;
function b5() {
  return w6 || (w6 = 1, Zb = function(e, r) {
    for (var n = e.length, i = -1; ++i < n; )
      e[i] ^= r[i];
    return e;
  }), Zb;
}
var Jb, _6;
function g5() {
  if (_6)
    return Jb;
  _6 = 1;
  var t = Tr, e = Lt.Buffer;
  function r(n, i) {
    return e.from(n.toRed(t.mont(i.modulus)).redPow(new t(i.publicExponent)).fromRed().toArray());
  }
  return Jb = r, Jb;
}
var Yb, S6;
function fN() {
  if (S6)
    return Yb;
  S6 = 1;
  var t = U0(), e = hf(), r = Dc(), n = y5(), i = b5(), s = Tr, a = g5(), o = $2(), c = Lt.Buffer;
  Yb = function(h, y, p) {
    var b;
    h.padding ? b = h.padding : p ? b = 1 : b = 4;
    var v = t(h), x;
    if (b === 4)
      x = f(v, y);
    else if (b === 1)
      x = u(v, y, p);
    else if (b === 3) {
      if (x = new s(y), x.cmp(v.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return p ? o(x, v) : a(x, v);
  };
  function f(l, h) {
    var y = l.modulus.byteLength(), p = h.length, b = r("sha1").update(c.alloc(0)).digest(), v = b.length, x = 2 * v;
    if (p > y - x - 2)
      throw new Error("message too long");
    var I = c.alloc(y - p - x - 2), L = y - v - 1, P = e(v), C = i(c.concat([b, I, c.alloc(1, 1), h], L), n(P, L)), D = i(P, n(C, v));
    return new s(c.concat([c.alloc(1), D, C], y));
  }
  function u(l, h, y) {
    var p = h.length, b = l.modulus.byteLength();
    if (p > b - 11)
      throw new Error("message too long");
    var v;
    return y ? v = c.alloc(b - p - 3, 255) : v = d(b - p - 3), new s(c.concat([c.from([0, y ? 1 : 2]), v, c.alloc(1), h], b));
  }
  function d(l) {
    for (var h = c.allocUnsafe(l), y = 0, p = e(l * 2), b = 0, v; y < l; )
      b === p.length && (p = e(l * 2), b = 0), v = p[b++], v && (h[y++] = v);
    return h;
  }
  return Yb;
}
var Qb, E6;
function dN() {
  if (E6)
    return Qb;
  E6 = 1;
  var t = U0(), e = y5(), r = b5(), n = Tr, i = $2(), s = Dc(), a = g5(), o = Lt.Buffer;
  Qb = function(l, h, y) {
    var p;
    l.padding ? p = l.padding : y ? p = 1 : p = 4;
    var b = t(l), v = b.modulus.byteLength();
    if (h.length > v || new n(h).cmp(b.modulus) >= 0)
      throw new Error("decryption error");
    var x;
    y ? x = a(new n(h), b) : x = i(h, b);
    var I = o.alloc(v - x.length);
    if (x = o.concat([I, x], v), p === 4)
      return c(b, x);
    if (p === 1)
      return f(b, x, y);
    if (p === 3)
      return x;
    throw new Error("unknown padding");
  };
  function c(d, l) {
    var h = d.modulus.byteLength(), y = s("sha1").update(o.alloc(0)).digest(), p = y.length;
    if (l[0] !== 0)
      throw new Error("decryption error");
    var b = l.slice(1, p + 1), v = l.slice(p + 1), x = r(b, e(v, p)), I = r(v, e(x, h - p - 1));
    if (u(y, I.slice(0, p)))
      throw new Error("decryption error");
    for (var L = p; I[L] === 0; )
      L++;
    if (I[L++] !== 1)
      throw new Error("decryption error");
    return I.slice(L);
  }
  function f(d, l, h) {
    for (var y = l.slice(0, 2), p = 2, b = 0; l[p++] !== 0; )
      if (p >= l.length) {
        b++;
        break;
      }
    var v = l.slice(2, p - 1);
    if ((y.toString("hex") !== "0002" && !h || y.toString("hex") !== "0001" && h) && b++, v.length < 8 && b++, b)
      throw new Error("decryption error");
    return l.slice(p);
  }
  function u(d, l) {
    d = o.from(d), l = o.from(l);
    var h = 0, y = d.length;
    d.length !== l.length && (h++, y = Math.min(d.length, l.length));
    for (var p = -1; ++p < y; )
      h += d[p] ^ l[p];
    return h;
  }
  return Qb;
}
var x6;
function lN() {
  return x6 || (x6 = 1, function(t) {
    t.publicEncrypt = fN(), t.privateDecrypt = dN(), t.privateEncrypt = function(r, n) {
      return t.publicEncrypt(r, n, !0);
    }, t.publicDecrypt = function(r, n) {
      return t.privateDecrypt(r, n, !0);
    };
  }(Hb)), Hb;
}
var tu = {}, A6;
function hN() {
  if (A6)
    return tu;
  A6 = 1;
  function t() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var e = Lt, r = hf(), n = e.Buffer, i = e.kMaxLength, s = Ne.crypto || Ne.msCrypto, a = Math.pow(2, 32) - 1;
  function o(l, h) {
    if (typeof l != "number" || l !== l)
      throw new TypeError("offset must be a number");
    if (l > a || l < 0)
      throw new TypeError("offset must be a uint32");
    if (l > i || l > h)
      throw new RangeError("offset out of range");
  }
  function c(l, h, y) {
    if (typeof l != "number" || l !== l)
      throw new TypeError("size must be a number");
    if (l > a || l < 0)
      throw new TypeError("size must be a uint32");
    if (l + h > y || l > i)
      throw new RangeError("buffer too small");
  }
  s && s.getRandomValues || !ut.browser ? (tu.randomFill = f, tu.randomFillSync = d) : (tu.randomFill = t, tu.randomFillSync = t);
  function f(l, h, y, p) {
    if (!n.isBuffer(l) && !(l instanceof Ne.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof h == "function")
      p = h, h = 0, y = l.length;
    else if (typeof y == "function")
      p = y, y = l.length - h;
    else if (typeof p != "function")
      throw new TypeError('"cb" argument must be a function');
    return o(h, l.length), c(y, h, l.length), u(l, h, y, p);
  }
  function u(l, h, y, p) {
    if (ut.browser) {
      var b = l.buffer, v = new Uint8Array(b, h, y);
      if (s.getRandomValues(v), p) {
        ut.nextTick(function() {
          p(null, l);
        });
        return;
      }
      return l;
    }
    if (p) {
      r(y, function(I, L) {
        if (I)
          return p(I);
        L.copy(l, h), p(null, l);
      });
      return;
    }
    var x = r(y);
    return x.copy(l, h), l;
  }
  function d(l, h, y) {
    if (typeof h > "u" && (h = 0), !n.isBuffer(l) && !(l instanceof Ne.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return o(h, l.length), y === void 0 && (y = l.length - h), c(y, h, l.length), u(l, h, y);
  }
  return tu;
}
var I6;
function H2() {
  if (I6)
    return Ft;
  I6 = 1, Ft.randomBytes = Ft.rng = Ft.pseudoRandomBytes = Ft.prng = hf(), Ft.createHash = Ft.Hash = Dc(), Ft.createHmac = Ft.Hmac = P0;
  var t = qM(), e = Object.keys(t), r = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(e);
  Ft.getHashes = function() {
    return r;
  };
  var n = GA();
  Ft.pbkdf2 = n.pbkdf2, Ft.pbkdf2Sync = n.pbkdf2Sync;
  var i = oC();
  Ft.Cipher = i.Cipher, Ft.createCipher = i.createCipher, Ft.Cipheriv = i.Cipheriv, Ft.createCipheriv = i.createCipheriv, Ft.Decipher = i.Decipher, Ft.createDecipher = i.createDecipher, Ft.Decipheriv = i.Decipheriv, Ft.createDecipheriv = i.createDecipheriv, Ft.getCiphers = i.getCiphers, Ft.listCiphers = i.listCiphers;
  var s = mC();
  Ft.DiffieHellmanGroup = s.DiffieHellmanGroup, Ft.createDiffieHellmanGroup = s.createDiffieHellmanGroup, Ft.getDiffieHellman = s.getDiffieHellman, Ft.createDiffieHellman = s.createDiffieHellman, Ft.DiffieHellman = s.DiffieHellman;
  var a = cN();
  Ft.createSign = a.createSign, Ft.Sign = a.Sign, Ft.createVerify = a.createVerify, Ft.Verify = a.Verify, Ft.createECDH = uN();
  var o = lN();
  Ft.publicEncrypt = o.publicEncrypt, Ft.privateEncrypt = o.privateEncrypt, Ft.publicDecrypt = o.publicDecrypt, Ft.privateDecrypt = o.privateDecrypt;
  var c = hN();
  return Ft.randomFill = c.randomFill, Ft.randomFillSync = c.randomFillSync, Ft.createCredentials = function() {
    throw new Error([
      "sorry, createCredentials is not implemented yet",
      "we accept pull requests",
      "https://github.com/crypto-browserify/crypto-browserify"
    ].join(`
`));
  }, Ft.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, Ft;
}
(function(t) {
  (function(e) {
    var r = function(j) {
      var Q, X = new Float64Array(16);
      if (j)
        for (Q = 0; Q < j.length; Q++)
          X[Q] = j[Q];
      return X;
    }, n = function() {
      throw new Error("no PRNG");
    }, i = new Uint8Array(16), s = new Uint8Array(32);
    s[0] = 9;
    var a = r(), o = r([1]), c = r([56129, 1]), f = r([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), u = r([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), d = r([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), l = r([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), h = r([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function y(j, Q, X, T) {
      j[Q] = X >> 24 & 255, j[Q + 1] = X >> 16 & 255, j[Q + 2] = X >> 8 & 255, j[Q + 3] = X & 255, j[Q + 4] = T >> 24 & 255, j[Q + 5] = T >> 16 & 255, j[Q + 6] = T >> 8 & 255, j[Q + 7] = T & 255;
    }
    function p(j, Q, X, T, te) {
      var ge, be = 0;
      for (ge = 0; ge < te; ge++)
        be |= j[Q + ge] ^ X[T + ge];
      return (1 & be - 1 >>> 8) - 1;
    }
    function b(j, Q, X, T) {
      return p(j, Q, X, T, 16);
    }
    function v(j, Q, X, T) {
      return p(j, Q, X, T, 32);
    }
    function x(j, Q, X, T) {
      for (var te = T[0] & 255 | (T[1] & 255) << 8 | (T[2] & 255) << 16 | (T[3] & 255) << 24, ge = X[0] & 255 | (X[1] & 255) << 8 | (X[2] & 255) << 16 | (X[3] & 255) << 24, be = X[4] & 255 | (X[5] & 255) << 8 | (X[6] & 255) << 16 | (X[7] & 255) << 24, Ae = X[8] & 255 | (X[9] & 255) << 8 | (X[10] & 255) << 16 | (X[11] & 255) << 24, Le = X[12] & 255 | (X[13] & 255) << 8 | (X[14] & 255) << 16 | (X[15] & 255) << 24, Ge = T[4] & 255 | (T[5] & 255) << 8 | (T[6] & 255) << 16 | (T[7] & 255) << 24, $e = Q[0] & 255 | (Q[1] & 255) << 8 | (Q[2] & 255) << 16 | (Q[3] & 255) << 24, Xt = Q[4] & 255 | (Q[5] & 255) << 8 | (Q[6] & 255) << 16 | (Q[7] & 255) << 24, et = Q[8] & 255 | (Q[9] & 255) << 8 | (Q[10] & 255) << 16 | (Q[11] & 255) << 24, vt = Q[12] & 255 | (Q[13] & 255) << 8 | (Q[14] & 255) << 16 | (Q[15] & 255) << 24, wt = T[8] & 255 | (T[9] & 255) << 8 | (T[10] & 255) << 16 | (T[11] & 255) << 24, Rt = X[16] & 255 | (X[17] & 255) << 8 | (X[18] & 255) << 16 | (X[19] & 255) << 24, Tt = X[20] & 255 | (X[21] & 255) << 8 | (X[22] & 255) << 16 | (X[23] & 255) << 24, _t = X[24] & 255 | (X[25] & 255) << 8 | (X[26] & 255) << 16 | (X[27] & 255) << 24, Et = X[28] & 255 | (X[29] & 255) << 8 | (X[30] & 255) << 16 | (X[31] & 255) << 24, St = T[12] & 255 | (T[13] & 255) << 8 | (T[14] & 255) << 16 | (T[15] & 255) << 24, tt = te, ft = ge, Ye = be, nt = Ae, it = Le, Je = Ge, Se = $e, Ee = Xt, Ce = et, Oe = vt, Me = wt, je = Rt, mt = Tt, Mt = _t, Dt = Et, Ct = St, ue, Ht = 0; Ht < 20; Ht += 2)
        ue = tt + mt | 0, it ^= ue << 7 | ue >>> 25, ue = it + tt | 0, Ce ^= ue << 9 | ue >>> 23, ue = Ce + it | 0, mt ^= ue << 13 | ue >>> 19, ue = mt + Ce | 0, tt ^= ue << 18 | ue >>> 14, ue = Je + ft | 0, Oe ^= ue << 7 | ue >>> 25, ue = Oe + Je | 0, Mt ^= ue << 9 | ue >>> 23, ue = Mt + Oe | 0, ft ^= ue << 13 | ue >>> 19, ue = ft + Mt | 0, Je ^= ue << 18 | ue >>> 14, ue = Me + Se | 0, Dt ^= ue << 7 | ue >>> 25, ue = Dt + Me | 0, Ye ^= ue << 9 | ue >>> 23, ue = Ye + Dt | 0, Se ^= ue << 13 | ue >>> 19, ue = Se + Ye | 0, Me ^= ue << 18 | ue >>> 14, ue = Ct + je | 0, nt ^= ue << 7 | ue >>> 25, ue = nt + Ct | 0, Ee ^= ue << 9 | ue >>> 23, ue = Ee + nt | 0, je ^= ue << 13 | ue >>> 19, ue = je + Ee | 0, Ct ^= ue << 18 | ue >>> 14, ue = tt + nt | 0, ft ^= ue << 7 | ue >>> 25, ue = ft + tt | 0, Ye ^= ue << 9 | ue >>> 23, ue = Ye + ft | 0, nt ^= ue << 13 | ue >>> 19, ue = nt + Ye | 0, tt ^= ue << 18 | ue >>> 14, ue = Je + it | 0, Se ^= ue << 7 | ue >>> 25, ue = Se + Je | 0, Ee ^= ue << 9 | ue >>> 23, ue = Ee + Se | 0, it ^= ue << 13 | ue >>> 19, ue = it + Ee | 0, Je ^= ue << 18 | ue >>> 14, ue = Me + Oe | 0, je ^= ue << 7 | ue >>> 25, ue = je + Me | 0, Ce ^= ue << 9 | ue >>> 23, ue = Ce + je | 0, Oe ^= ue << 13 | ue >>> 19, ue = Oe + Ce | 0, Me ^= ue << 18 | ue >>> 14, ue = Ct + Dt | 0, mt ^= ue << 7 | ue >>> 25, ue = mt + Ct | 0, Mt ^= ue << 9 | ue >>> 23, ue = Mt + mt | 0, Dt ^= ue << 13 | ue >>> 19, ue = Dt + Mt | 0, Ct ^= ue << 18 | ue >>> 14;
      tt = tt + te | 0, ft = ft + ge | 0, Ye = Ye + be | 0, nt = nt + Ae | 0, it = it + Le | 0, Je = Je + Ge | 0, Se = Se + $e | 0, Ee = Ee + Xt | 0, Ce = Ce + et | 0, Oe = Oe + vt | 0, Me = Me + wt | 0, je = je + Rt | 0, mt = mt + Tt | 0, Mt = Mt + _t | 0, Dt = Dt + Et | 0, Ct = Ct + St | 0, j[0] = tt >>> 0 & 255, j[1] = tt >>> 8 & 255, j[2] = tt >>> 16 & 255, j[3] = tt >>> 24 & 255, j[4] = ft >>> 0 & 255, j[5] = ft >>> 8 & 255, j[6] = ft >>> 16 & 255, j[7] = ft >>> 24 & 255, j[8] = Ye >>> 0 & 255, j[9] = Ye >>> 8 & 255, j[10] = Ye >>> 16 & 255, j[11] = Ye >>> 24 & 255, j[12] = nt >>> 0 & 255, j[13] = nt >>> 8 & 255, j[14] = nt >>> 16 & 255, j[15] = nt >>> 24 & 255, j[16] = it >>> 0 & 255, j[17] = it >>> 8 & 255, j[18] = it >>> 16 & 255, j[19] = it >>> 24 & 255, j[20] = Je >>> 0 & 255, j[21] = Je >>> 8 & 255, j[22] = Je >>> 16 & 255, j[23] = Je >>> 24 & 255, j[24] = Se >>> 0 & 255, j[25] = Se >>> 8 & 255, j[26] = Se >>> 16 & 255, j[27] = Se >>> 24 & 255, j[28] = Ee >>> 0 & 255, j[29] = Ee >>> 8 & 255, j[30] = Ee >>> 16 & 255, j[31] = Ee >>> 24 & 255, j[32] = Ce >>> 0 & 255, j[33] = Ce >>> 8 & 255, j[34] = Ce >>> 16 & 255, j[35] = Ce >>> 24 & 255, j[36] = Oe >>> 0 & 255, j[37] = Oe >>> 8 & 255, j[38] = Oe >>> 16 & 255, j[39] = Oe >>> 24 & 255, j[40] = Me >>> 0 & 255, j[41] = Me >>> 8 & 255, j[42] = Me >>> 16 & 255, j[43] = Me >>> 24 & 255, j[44] = je >>> 0 & 255, j[45] = je >>> 8 & 255, j[46] = je >>> 16 & 255, j[47] = je >>> 24 & 255, j[48] = mt >>> 0 & 255, j[49] = mt >>> 8 & 255, j[50] = mt >>> 16 & 255, j[51] = mt >>> 24 & 255, j[52] = Mt >>> 0 & 255, j[53] = Mt >>> 8 & 255, j[54] = Mt >>> 16 & 255, j[55] = Mt >>> 24 & 255, j[56] = Dt >>> 0 & 255, j[57] = Dt >>> 8 & 255, j[58] = Dt >>> 16 & 255, j[59] = Dt >>> 24 & 255, j[60] = Ct >>> 0 & 255, j[61] = Ct >>> 8 & 255, j[62] = Ct >>> 16 & 255, j[63] = Ct >>> 24 & 255;
    }
    function I(j, Q, X, T) {
      for (var te = T[0] & 255 | (T[1] & 255) << 8 | (T[2] & 255) << 16 | (T[3] & 255) << 24, ge = X[0] & 255 | (X[1] & 255) << 8 | (X[2] & 255) << 16 | (X[3] & 255) << 24, be = X[4] & 255 | (X[5] & 255) << 8 | (X[6] & 255) << 16 | (X[7] & 255) << 24, Ae = X[8] & 255 | (X[9] & 255) << 8 | (X[10] & 255) << 16 | (X[11] & 255) << 24, Le = X[12] & 255 | (X[13] & 255) << 8 | (X[14] & 255) << 16 | (X[15] & 255) << 24, Ge = T[4] & 255 | (T[5] & 255) << 8 | (T[6] & 255) << 16 | (T[7] & 255) << 24, $e = Q[0] & 255 | (Q[1] & 255) << 8 | (Q[2] & 255) << 16 | (Q[3] & 255) << 24, Xt = Q[4] & 255 | (Q[5] & 255) << 8 | (Q[6] & 255) << 16 | (Q[7] & 255) << 24, et = Q[8] & 255 | (Q[9] & 255) << 8 | (Q[10] & 255) << 16 | (Q[11] & 255) << 24, vt = Q[12] & 255 | (Q[13] & 255) << 8 | (Q[14] & 255) << 16 | (Q[15] & 255) << 24, wt = T[8] & 255 | (T[9] & 255) << 8 | (T[10] & 255) << 16 | (T[11] & 255) << 24, Rt = X[16] & 255 | (X[17] & 255) << 8 | (X[18] & 255) << 16 | (X[19] & 255) << 24, Tt = X[20] & 255 | (X[21] & 255) << 8 | (X[22] & 255) << 16 | (X[23] & 255) << 24, _t = X[24] & 255 | (X[25] & 255) << 8 | (X[26] & 255) << 16 | (X[27] & 255) << 24, Et = X[28] & 255 | (X[29] & 255) << 8 | (X[30] & 255) << 16 | (X[31] & 255) << 24, St = T[12] & 255 | (T[13] & 255) << 8 | (T[14] & 255) << 16 | (T[15] & 255) << 24, tt = te, ft = ge, Ye = be, nt = Ae, it = Le, Je = Ge, Se = $e, Ee = Xt, Ce = et, Oe = vt, Me = wt, je = Rt, mt = Tt, Mt = _t, Dt = Et, Ct = St, ue, Ht = 0; Ht < 20; Ht += 2)
        ue = tt + mt | 0, it ^= ue << 7 | ue >>> 25, ue = it + tt | 0, Ce ^= ue << 9 | ue >>> 23, ue = Ce + it | 0, mt ^= ue << 13 | ue >>> 19, ue = mt + Ce | 0, tt ^= ue << 18 | ue >>> 14, ue = Je + ft | 0, Oe ^= ue << 7 | ue >>> 25, ue = Oe + Je | 0, Mt ^= ue << 9 | ue >>> 23, ue = Mt + Oe | 0, ft ^= ue << 13 | ue >>> 19, ue = ft + Mt | 0, Je ^= ue << 18 | ue >>> 14, ue = Me + Se | 0, Dt ^= ue << 7 | ue >>> 25, ue = Dt + Me | 0, Ye ^= ue << 9 | ue >>> 23, ue = Ye + Dt | 0, Se ^= ue << 13 | ue >>> 19, ue = Se + Ye | 0, Me ^= ue << 18 | ue >>> 14, ue = Ct + je | 0, nt ^= ue << 7 | ue >>> 25, ue = nt + Ct | 0, Ee ^= ue << 9 | ue >>> 23, ue = Ee + nt | 0, je ^= ue << 13 | ue >>> 19, ue = je + Ee | 0, Ct ^= ue << 18 | ue >>> 14, ue = tt + nt | 0, ft ^= ue << 7 | ue >>> 25, ue = ft + tt | 0, Ye ^= ue << 9 | ue >>> 23, ue = Ye + ft | 0, nt ^= ue << 13 | ue >>> 19, ue = nt + Ye | 0, tt ^= ue << 18 | ue >>> 14, ue = Je + it | 0, Se ^= ue << 7 | ue >>> 25, ue = Se + Je | 0, Ee ^= ue << 9 | ue >>> 23, ue = Ee + Se | 0, it ^= ue << 13 | ue >>> 19, ue = it + Ee | 0, Je ^= ue << 18 | ue >>> 14, ue = Me + Oe | 0, je ^= ue << 7 | ue >>> 25, ue = je + Me | 0, Ce ^= ue << 9 | ue >>> 23, ue = Ce + je | 0, Oe ^= ue << 13 | ue >>> 19, ue = Oe + Ce | 0, Me ^= ue << 18 | ue >>> 14, ue = Ct + Dt | 0, mt ^= ue << 7 | ue >>> 25, ue = mt + Ct | 0, Mt ^= ue << 9 | ue >>> 23, ue = Mt + mt | 0, Dt ^= ue << 13 | ue >>> 19, ue = Dt + Mt | 0, Ct ^= ue << 18 | ue >>> 14;
      j[0] = tt >>> 0 & 255, j[1] = tt >>> 8 & 255, j[2] = tt >>> 16 & 255, j[3] = tt >>> 24 & 255, j[4] = Je >>> 0 & 255, j[5] = Je >>> 8 & 255, j[6] = Je >>> 16 & 255, j[7] = Je >>> 24 & 255, j[8] = Me >>> 0 & 255, j[9] = Me >>> 8 & 255, j[10] = Me >>> 16 & 255, j[11] = Me >>> 24 & 255, j[12] = Ct >>> 0 & 255, j[13] = Ct >>> 8 & 255, j[14] = Ct >>> 16 & 255, j[15] = Ct >>> 24 & 255, j[16] = Se >>> 0 & 255, j[17] = Se >>> 8 & 255, j[18] = Se >>> 16 & 255, j[19] = Se >>> 24 & 255, j[20] = Ee >>> 0 & 255, j[21] = Ee >>> 8 & 255, j[22] = Ee >>> 16 & 255, j[23] = Ee >>> 24 & 255, j[24] = Ce >>> 0 & 255, j[25] = Ce >>> 8 & 255, j[26] = Ce >>> 16 & 255, j[27] = Ce >>> 24 & 255, j[28] = Oe >>> 0 & 255, j[29] = Oe >>> 8 & 255, j[30] = Oe >>> 16 & 255, j[31] = Oe >>> 24 & 255;
    }
    function L(j, Q, X, T) {
      x(j, Q, X, T);
    }
    function P(j, Q, X, T) {
      I(j, Q, X, T);
    }
    var C = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function D(j, Q, X, T, te, ge, be) {
      var Ae = new Uint8Array(16), Le = new Uint8Array(64), Ge, $e;
      for ($e = 0; $e < 16; $e++)
        Ae[$e] = 0;
      for ($e = 0; $e < 8; $e++)
        Ae[$e] = ge[$e];
      for (; te >= 64; ) {
        for (L(Le, Ae, be, C), $e = 0; $e < 64; $e++)
          j[Q + $e] = X[T + $e] ^ Le[$e];
        for (Ge = 1, $e = 8; $e < 16; $e++)
          Ge = Ge + (Ae[$e] & 255) | 0, Ae[$e] = Ge & 255, Ge >>>= 8;
        te -= 64, Q += 64, T += 64;
      }
      if (te > 0)
        for (L(Le, Ae, be, C), $e = 0; $e < te; $e++)
          j[Q + $e] = X[T + $e] ^ Le[$e];
      return 0;
    }
    function F(j, Q, X, T, te) {
      var ge = new Uint8Array(16), be = new Uint8Array(64), Ae, Le;
      for (Le = 0; Le < 16; Le++)
        ge[Le] = 0;
      for (Le = 0; Le < 8; Le++)
        ge[Le] = T[Le];
      for (; X >= 64; ) {
        for (L(be, ge, te, C), Le = 0; Le < 64; Le++)
          j[Q + Le] = be[Le];
        for (Ae = 1, Le = 8; Le < 16; Le++)
          Ae = Ae + (ge[Le] & 255) | 0, ge[Le] = Ae & 255, Ae >>>= 8;
        X -= 64, Q += 64;
      }
      if (X > 0)
        for (L(be, ge, te, C), Le = 0; Le < X; Le++)
          j[Q + Le] = be[Le];
      return 0;
    }
    function G(j, Q, X, T, te) {
      var ge = new Uint8Array(32);
      P(ge, T, te, C);
      for (var be = new Uint8Array(8), Ae = 0; Ae < 8; Ae++)
        be[Ae] = T[Ae + 16];
      return F(j, Q, X, be, ge);
    }
    function re(j, Q, X, T, te, ge, be) {
      var Ae = new Uint8Array(32);
      P(Ae, ge, be, C);
      for (var Le = new Uint8Array(8), Ge = 0; Ge < 8; Ge++)
        Le[Ge] = ge[Ge + 16];
      return D(j, Q, X, T, te, Le, Ae);
    }
    var ie = function(j) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var Q, X, T, te, ge, be, Ae, Le;
      Q = j[0] & 255 | (j[1] & 255) << 8, this.r[0] = Q & 8191, X = j[2] & 255 | (j[3] & 255) << 8, this.r[1] = (Q >>> 13 | X << 3) & 8191, T = j[4] & 255 | (j[5] & 255) << 8, this.r[2] = (X >>> 10 | T << 6) & 7939, te = j[6] & 255 | (j[7] & 255) << 8, this.r[3] = (T >>> 7 | te << 9) & 8191, ge = j[8] & 255 | (j[9] & 255) << 8, this.r[4] = (te >>> 4 | ge << 12) & 255, this.r[5] = ge >>> 1 & 8190, be = j[10] & 255 | (j[11] & 255) << 8, this.r[6] = (ge >>> 14 | be << 2) & 8191, Ae = j[12] & 255 | (j[13] & 255) << 8, this.r[7] = (be >>> 11 | Ae << 5) & 8065, Le = j[14] & 255 | (j[15] & 255) << 8, this.r[8] = (Ae >>> 8 | Le << 8) & 8191, this.r[9] = Le >>> 5 & 127, this.pad[0] = j[16] & 255 | (j[17] & 255) << 8, this.pad[1] = j[18] & 255 | (j[19] & 255) << 8, this.pad[2] = j[20] & 255 | (j[21] & 255) << 8, this.pad[3] = j[22] & 255 | (j[23] & 255) << 8, this.pad[4] = j[24] & 255 | (j[25] & 255) << 8, this.pad[5] = j[26] & 255 | (j[27] & 255) << 8, this.pad[6] = j[28] & 255 | (j[29] & 255) << 8, this.pad[7] = j[30] & 255 | (j[31] & 255) << 8;
    };
    ie.prototype.blocks = function(j, Q, X) {
      for (var T = this.fin ? 0 : 2048, te, ge, be, Ae, Le, Ge, $e, Xt, et, vt, wt, Rt, Tt, _t, Et, St, tt, ft, Ye, nt = this.h[0], it = this.h[1], Je = this.h[2], Se = this.h[3], Ee = this.h[4], Ce = this.h[5], Oe = this.h[6], Me = this.h[7], je = this.h[8], mt = this.h[9], Mt = this.r[0], Dt = this.r[1], Ct = this.r[2], ue = this.r[3], Ht = this.r[4], yr = this.r[5], br = this.r[6], jt = this.r[7], or = this.r[8], cr = this.r[9]; X >= 16; )
        te = j[Q + 0] & 255 | (j[Q + 1] & 255) << 8, nt += te & 8191, ge = j[Q + 2] & 255 | (j[Q + 3] & 255) << 8, it += (te >>> 13 | ge << 3) & 8191, be = j[Q + 4] & 255 | (j[Q + 5] & 255) << 8, Je += (ge >>> 10 | be << 6) & 8191, Ae = j[Q + 6] & 255 | (j[Q + 7] & 255) << 8, Se += (be >>> 7 | Ae << 9) & 8191, Le = j[Q + 8] & 255 | (j[Q + 9] & 255) << 8, Ee += (Ae >>> 4 | Le << 12) & 8191, Ce += Le >>> 1 & 8191, Ge = j[Q + 10] & 255 | (j[Q + 11] & 255) << 8, Oe += (Le >>> 14 | Ge << 2) & 8191, $e = j[Q + 12] & 255 | (j[Q + 13] & 255) << 8, Me += (Ge >>> 11 | $e << 5) & 8191, Xt = j[Q + 14] & 255 | (j[Q + 15] & 255) << 8, je += ($e >>> 8 | Xt << 8) & 8191, mt += Xt >>> 5 | T, et = 0, vt = et, vt += nt * Mt, vt += it * (5 * cr), vt += Je * (5 * or), vt += Se * (5 * jt), vt += Ee * (5 * br), et = vt >>> 13, vt &= 8191, vt += Ce * (5 * yr), vt += Oe * (5 * Ht), vt += Me * (5 * ue), vt += je * (5 * Ct), vt += mt * (5 * Dt), et += vt >>> 13, vt &= 8191, wt = et, wt += nt * Dt, wt += it * Mt, wt += Je * (5 * cr), wt += Se * (5 * or), wt += Ee * (5 * jt), et = wt >>> 13, wt &= 8191, wt += Ce * (5 * br), wt += Oe * (5 * yr), wt += Me * (5 * Ht), wt += je * (5 * ue), wt += mt * (5 * Ct), et += wt >>> 13, wt &= 8191, Rt = et, Rt += nt * Ct, Rt += it * Dt, Rt += Je * Mt, Rt += Se * (5 * cr), Rt += Ee * (5 * or), et = Rt >>> 13, Rt &= 8191, Rt += Ce * (5 * jt), Rt += Oe * (5 * br), Rt += Me * (5 * yr), Rt += je * (5 * Ht), Rt += mt * (5 * ue), et += Rt >>> 13, Rt &= 8191, Tt = et, Tt += nt * ue, Tt += it * Ct, Tt += Je * Dt, Tt += Se * Mt, Tt += Ee * (5 * cr), et = Tt >>> 13, Tt &= 8191, Tt += Ce * (5 * or), Tt += Oe * (5 * jt), Tt += Me * (5 * br), Tt += je * (5 * yr), Tt += mt * (5 * Ht), et += Tt >>> 13, Tt &= 8191, _t = et, _t += nt * Ht, _t += it * ue, _t += Je * Ct, _t += Se * Dt, _t += Ee * Mt, et = _t >>> 13, _t &= 8191, _t += Ce * (5 * cr), _t += Oe * (5 * or), _t += Me * (5 * jt), _t += je * (5 * br), _t += mt * (5 * yr), et += _t >>> 13, _t &= 8191, Et = et, Et += nt * yr, Et += it * Ht, Et += Je * ue, Et += Se * Ct, Et += Ee * Dt, et = Et >>> 13, Et &= 8191, Et += Ce * Mt, Et += Oe * (5 * cr), Et += Me * (5 * or), Et += je * (5 * jt), Et += mt * (5 * br), et += Et >>> 13, Et &= 8191, St = et, St += nt * br, St += it * yr, St += Je * Ht, St += Se * ue, St += Ee * Ct, et = St >>> 13, St &= 8191, St += Ce * Dt, St += Oe * Mt, St += Me * (5 * cr), St += je * (5 * or), St += mt * (5 * jt), et += St >>> 13, St &= 8191, tt = et, tt += nt * jt, tt += it * br, tt += Je * yr, tt += Se * Ht, tt += Ee * ue, et = tt >>> 13, tt &= 8191, tt += Ce * Ct, tt += Oe * Dt, tt += Me * Mt, tt += je * (5 * cr), tt += mt * (5 * or), et += tt >>> 13, tt &= 8191, ft = et, ft += nt * or, ft += it * jt, ft += Je * br, ft += Se * yr, ft += Ee * Ht, et = ft >>> 13, ft &= 8191, ft += Ce * ue, ft += Oe * Ct, ft += Me * Dt, ft += je * Mt, ft += mt * (5 * cr), et += ft >>> 13, ft &= 8191, Ye = et, Ye += nt * cr, Ye += it * or, Ye += Je * jt, Ye += Se * br, Ye += Ee * yr, et = Ye >>> 13, Ye &= 8191, Ye += Ce * Ht, Ye += Oe * ue, Ye += Me * Ct, Ye += je * Dt, Ye += mt * Mt, et += Ye >>> 13, Ye &= 8191, et = (et << 2) + et | 0, et = et + vt | 0, vt = et & 8191, et = et >>> 13, wt += et, nt = vt, it = wt, Je = Rt, Se = Tt, Ee = _t, Ce = Et, Oe = St, Me = tt, je = ft, mt = Ye, Q += 16, X -= 16;
      this.h[0] = nt, this.h[1] = it, this.h[2] = Je, this.h[3] = Se, this.h[4] = Ee, this.h[5] = Ce, this.h[6] = Oe, this.h[7] = Me, this.h[8] = je, this.h[9] = mt;
    }, ie.prototype.finish = function(j, Q) {
      var X = new Uint16Array(10), T, te, ge, be;
      if (this.leftover) {
        for (be = this.leftover, this.buffer[be++] = 1; be < 16; be++)
          this.buffer[be] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (T = this.h[1] >>> 13, this.h[1] &= 8191, be = 2; be < 10; be++)
        this.h[be] += T, T = this.h[be] >>> 13, this.h[be] &= 8191;
      for (this.h[0] += T * 5, T = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += T, T = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += T, X[0] = this.h[0] + 5, T = X[0] >>> 13, X[0] &= 8191, be = 1; be < 10; be++)
        X[be] = this.h[be] + T, T = X[be] >>> 13, X[be] &= 8191;
      for (X[9] -= 8192, te = (T ^ 1) - 1, be = 0; be < 10; be++)
        X[be] &= te;
      for (te = ~te, be = 0; be < 10; be++)
        this.h[be] = this.h[be] & te | X[be];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, ge = this.h[0] + this.pad[0], this.h[0] = ge & 65535, be = 1; be < 8; be++)
        ge = (this.h[be] + this.pad[be] | 0) + (ge >>> 16) | 0, this.h[be] = ge & 65535;
      j[Q + 0] = this.h[0] >>> 0 & 255, j[Q + 1] = this.h[0] >>> 8 & 255, j[Q + 2] = this.h[1] >>> 0 & 255, j[Q + 3] = this.h[1] >>> 8 & 255, j[Q + 4] = this.h[2] >>> 0 & 255, j[Q + 5] = this.h[2] >>> 8 & 255, j[Q + 6] = this.h[3] >>> 0 & 255, j[Q + 7] = this.h[3] >>> 8 & 255, j[Q + 8] = this.h[4] >>> 0 & 255, j[Q + 9] = this.h[4] >>> 8 & 255, j[Q + 10] = this.h[5] >>> 0 & 255, j[Q + 11] = this.h[5] >>> 8 & 255, j[Q + 12] = this.h[6] >>> 0 & 255, j[Q + 13] = this.h[6] >>> 8 & 255, j[Q + 14] = this.h[7] >>> 0 & 255, j[Q + 15] = this.h[7] >>> 8 & 255;
    }, ie.prototype.update = function(j, Q, X) {
      var T, te;
      if (this.leftover) {
        for (te = 16 - this.leftover, te > X && (te = X), T = 0; T < te; T++)
          this.buffer[this.leftover + T] = j[Q + T];
        if (X -= te, Q += te, this.leftover += te, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (X >= 16 && (te = X - X % 16, this.blocks(j, Q, te), Q += te, X -= te), X) {
        for (T = 0; T < X; T++)
          this.buffer[this.leftover + T] = j[Q + T];
        this.leftover += X;
      }
    };
    function ee(j, Q, X, T, te, ge) {
      var be = new ie(ge);
      return be.update(X, T, te), be.finish(j, Q), 0;
    }
    function $(j, Q, X, T, te, ge) {
      var be = new Uint8Array(16);
      return ee(be, 0, X, T, te, ge), b(j, Q, be, 0);
    }
    function w(j, Q, X, T, te) {
      var ge;
      if (X < 32)
        return -1;
      for (re(j, 0, Q, 0, X, T, te), ee(j, 16, j, 32, X - 32, j), ge = 0; ge < 16; ge++)
        j[ge] = 0;
      return 0;
    }
    function E(j, Q, X, T, te) {
      var ge, be = new Uint8Array(32);
      if (X < 32 || (G(be, 0, 32, T, te), $(Q, 16, Q, 32, X - 32, be) !== 0))
        return -1;
      for (re(j, 0, Q, 0, X, T, te), ge = 0; ge < 32; ge++)
        j[ge] = 0;
      return 0;
    }
    function U(j, Q) {
      var X;
      for (X = 0; X < 16; X++)
        j[X] = Q[X] | 0;
    }
    function W(j) {
      var Q, X, T = 1;
      for (Q = 0; Q < 16; Q++)
        X = j[Q] + T + 65535, T = Math.floor(X / 65536), j[Q] = X - T * 65536;
      j[0] += T - 1 + 37 * (T - 1);
    }
    function _(j, Q, X) {
      for (var T, te = ~(X - 1), ge = 0; ge < 16; ge++)
        T = te & (j[ge] ^ Q[ge]), j[ge] ^= T, Q[ge] ^= T;
    }
    function R(j, Q) {
      var X, T, te, ge = r(), be = r();
      for (X = 0; X < 16; X++)
        be[X] = Q[X];
      for (W(be), W(be), W(be), T = 0; T < 2; T++) {
        for (ge[0] = be[0] - 65517, X = 1; X < 15; X++)
          ge[X] = be[X] - 65535 - (ge[X - 1] >> 16 & 1), ge[X - 1] &= 65535;
        ge[15] = be[15] - 32767 - (ge[14] >> 16 & 1), te = ge[15] >> 16 & 1, ge[14] &= 65535, _(be, ge, 1 - te);
      }
      for (X = 0; X < 16; X++)
        j[2 * X] = be[X] & 255, j[2 * X + 1] = be[X] >> 8;
    }
    function N(j, Q) {
      var X = new Uint8Array(32), T = new Uint8Array(32);
      return R(X, j), R(T, Q), v(X, 0, T, 0);
    }
    function O(j) {
      var Q = new Uint8Array(32);
      return R(Q, j), Q[0] & 1;
    }
    function g(j, Q) {
      var X;
      for (X = 0; X < 16; X++)
        j[X] = Q[2 * X] + (Q[2 * X + 1] << 8);
      j[15] &= 32767;
    }
    function M(j, Q, X) {
      for (var T = 0; T < 16; T++)
        j[T] = Q[T] + X[T];
    }
    function Y(j, Q, X) {
      for (var T = 0; T < 16; T++)
        j[T] = Q[T] - X[T];
    }
    function se(j, Q, X) {
      var T, te, ge = 0, be = 0, Ae = 0, Le = 0, Ge = 0, $e = 0, Xt = 0, et = 0, vt = 0, wt = 0, Rt = 0, Tt = 0, _t = 0, Et = 0, St = 0, tt = 0, ft = 0, Ye = 0, nt = 0, it = 0, Je = 0, Se = 0, Ee = 0, Ce = 0, Oe = 0, Me = 0, je = 0, mt = 0, Mt = 0, Dt = 0, Ct = 0, ue = X[0], Ht = X[1], yr = X[2], br = X[3], jt = X[4], or = X[5], cr = X[6], hn = X[7], Cr = X[8], sn = X[9], an = X[10], on = X[11], vn = X[12], Vn = X[13], Hn = X[14], Gn = X[15];
      T = Q[0], ge += T * ue, be += T * Ht, Ae += T * yr, Le += T * br, Ge += T * jt, $e += T * or, Xt += T * cr, et += T * hn, vt += T * Cr, wt += T * sn, Rt += T * an, Tt += T * on, _t += T * vn, Et += T * Vn, St += T * Hn, tt += T * Gn, T = Q[1], be += T * ue, Ae += T * Ht, Le += T * yr, Ge += T * br, $e += T * jt, Xt += T * or, et += T * cr, vt += T * hn, wt += T * Cr, Rt += T * sn, Tt += T * an, _t += T * on, Et += T * vn, St += T * Vn, tt += T * Hn, ft += T * Gn, T = Q[2], Ae += T * ue, Le += T * Ht, Ge += T * yr, $e += T * br, Xt += T * jt, et += T * or, vt += T * cr, wt += T * hn, Rt += T * Cr, Tt += T * sn, _t += T * an, Et += T * on, St += T * vn, tt += T * Vn, ft += T * Hn, Ye += T * Gn, T = Q[3], Le += T * ue, Ge += T * Ht, $e += T * yr, Xt += T * br, et += T * jt, vt += T * or, wt += T * cr, Rt += T * hn, Tt += T * Cr, _t += T * sn, Et += T * an, St += T * on, tt += T * vn, ft += T * Vn, Ye += T * Hn, nt += T * Gn, T = Q[4], Ge += T * ue, $e += T * Ht, Xt += T * yr, et += T * br, vt += T * jt, wt += T * or, Rt += T * cr, Tt += T * hn, _t += T * Cr, Et += T * sn, St += T * an, tt += T * on, ft += T * vn, Ye += T * Vn, nt += T * Hn, it += T * Gn, T = Q[5], $e += T * ue, Xt += T * Ht, et += T * yr, vt += T * br, wt += T * jt, Rt += T * or, Tt += T * cr, _t += T * hn, Et += T * Cr, St += T * sn, tt += T * an, ft += T * on, Ye += T * vn, nt += T * Vn, it += T * Hn, Je += T * Gn, T = Q[6], Xt += T * ue, et += T * Ht, vt += T * yr, wt += T * br, Rt += T * jt, Tt += T * or, _t += T * cr, Et += T * hn, St += T * Cr, tt += T * sn, ft += T * an, Ye += T * on, nt += T * vn, it += T * Vn, Je += T * Hn, Se += T * Gn, T = Q[7], et += T * ue, vt += T * Ht, wt += T * yr, Rt += T * br, Tt += T * jt, _t += T * or, Et += T * cr, St += T * hn, tt += T * Cr, ft += T * sn, Ye += T * an, nt += T * on, it += T * vn, Je += T * Vn, Se += T * Hn, Ee += T * Gn, T = Q[8], vt += T * ue, wt += T * Ht, Rt += T * yr, Tt += T * br, _t += T * jt, Et += T * or, St += T * cr, tt += T * hn, ft += T * Cr, Ye += T * sn, nt += T * an, it += T * on, Je += T * vn, Se += T * Vn, Ee += T * Hn, Ce += T * Gn, T = Q[9], wt += T * ue, Rt += T * Ht, Tt += T * yr, _t += T * br, Et += T * jt, St += T * or, tt += T * cr, ft += T * hn, Ye += T * Cr, nt += T * sn, it += T * an, Je += T * on, Se += T * vn, Ee += T * Vn, Ce += T * Hn, Oe += T * Gn, T = Q[10], Rt += T * ue, Tt += T * Ht, _t += T * yr, Et += T * br, St += T * jt, tt += T * or, ft += T * cr, Ye += T * hn, nt += T * Cr, it += T * sn, Je += T * an, Se += T * on, Ee += T * vn, Ce += T * Vn, Oe += T * Hn, Me += T * Gn, T = Q[11], Tt += T * ue, _t += T * Ht, Et += T * yr, St += T * br, tt += T * jt, ft += T * or, Ye += T * cr, nt += T * hn, it += T * Cr, Je += T * sn, Se += T * an, Ee += T * on, Ce += T * vn, Oe += T * Vn, Me += T * Hn, je += T * Gn, T = Q[12], _t += T * ue, Et += T * Ht, St += T * yr, tt += T * br, ft += T * jt, Ye += T * or, nt += T * cr, it += T * hn, Je += T * Cr, Se += T * sn, Ee += T * an, Ce += T * on, Oe += T * vn, Me += T * Vn, je += T * Hn, mt += T * Gn, T = Q[13], Et += T * ue, St += T * Ht, tt += T * yr, ft += T * br, Ye += T * jt, nt += T * or, it += T * cr, Je += T * hn, Se += T * Cr, Ee += T * sn, Ce += T * an, Oe += T * on, Me += T * vn, je += T * Vn, mt += T * Hn, Mt += T * Gn, T = Q[14], St += T * ue, tt += T * Ht, ft += T * yr, Ye += T * br, nt += T * jt, it += T * or, Je += T * cr, Se += T * hn, Ee += T * Cr, Ce += T * sn, Oe += T * an, Me += T * on, je += T * vn, mt += T * Vn, Mt += T * Hn, Dt += T * Gn, T = Q[15], tt += T * ue, ft += T * Ht, Ye += T * yr, nt += T * br, it += T * jt, Je += T * or, Se += T * cr, Ee += T * hn, Ce += T * Cr, Oe += T * sn, Me += T * an, je += T * on, mt += T * vn, Mt += T * Vn, Dt += T * Hn, Ct += T * Gn, ge += 38 * ft, be += 38 * Ye, Ae += 38 * nt, Le += 38 * it, Ge += 38 * Je, $e += 38 * Se, Xt += 38 * Ee, et += 38 * Ce, vt += 38 * Oe, wt += 38 * Me, Rt += 38 * je, Tt += 38 * mt, _t += 38 * Mt, Et += 38 * Dt, St += 38 * Ct, te = 1, T = ge + te + 65535, te = Math.floor(T / 65536), ge = T - te * 65536, T = be + te + 65535, te = Math.floor(T / 65536), be = T - te * 65536, T = Ae + te + 65535, te = Math.floor(T / 65536), Ae = T - te * 65536, T = Le + te + 65535, te = Math.floor(T / 65536), Le = T - te * 65536, T = Ge + te + 65535, te = Math.floor(T / 65536), Ge = T - te * 65536, T = $e + te + 65535, te = Math.floor(T / 65536), $e = T - te * 65536, T = Xt + te + 65535, te = Math.floor(T / 65536), Xt = T - te * 65536, T = et + te + 65535, te = Math.floor(T / 65536), et = T - te * 65536, T = vt + te + 65535, te = Math.floor(T / 65536), vt = T - te * 65536, T = wt + te + 65535, te = Math.floor(T / 65536), wt = T - te * 65536, T = Rt + te + 65535, te = Math.floor(T / 65536), Rt = T - te * 65536, T = Tt + te + 65535, te = Math.floor(T / 65536), Tt = T - te * 65536, T = _t + te + 65535, te = Math.floor(T / 65536), _t = T - te * 65536, T = Et + te + 65535, te = Math.floor(T / 65536), Et = T - te * 65536, T = St + te + 65535, te = Math.floor(T / 65536), St = T - te * 65536, T = tt + te + 65535, te = Math.floor(T / 65536), tt = T - te * 65536, ge += te - 1 + 37 * (te - 1), te = 1, T = ge + te + 65535, te = Math.floor(T / 65536), ge = T - te * 65536, T = be + te + 65535, te = Math.floor(T / 65536), be = T - te * 65536, T = Ae + te + 65535, te = Math.floor(T / 65536), Ae = T - te * 65536, T = Le + te + 65535, te = Math.floor(T / 65536), Le = T - te * 65536, T = Ge + te + 65535, te = Math.floor(T / 65536), Ge = T - te * 65536, T = $e + te + 65535, te = Math.floor(T / 65536), $e = T - te * 65536, T = Xt + te + 65535, te = Math.floor(T / 65536), Xt = T - te * 65536, T = et + te + 65535, te = Math.floor(T / 65536), et = T - te * 65536, T = vt + te + 65535, te = Math.floor(T / 65536), vt = T - te * 65536, T = wt + te + 65535, te = Math.floor(T / 65536), wt = T - te * 65536, T = Rt + te + 65535, te = Math.floor(T / 65536), Rt = T - te * 65536, T = Tt + te + 65535, te = Math.floor(T / 65536), Tt = T - te * 65536, T = _t + te + 65535, te = Math.floor(T / 65536), _t = T - te * 65536, T = Et + te + 65535, te = Math.floor(T / 65536), Et = T - te * 65536, T = St + te + 65535, te = Math.floor(T / 65536), St = T - te * 65536, T = tt + te + 65535, te = Math.floor(T / 65536), tt = T - te * 65536, ge += te - 1 + 37 * (te - 1), j[0] = ge, j[1] = be, j[2] = Ae, j[3] = Le, j[4] = Ge, j[5] = $e, j[6] = Xt, j[7] = et, j[8] = vt, j[9] = wt, j[10] = Rt, j[11] = Tt, j[12] = _t, j[13] = Et, j[14] = St, j[15] = tt;
    }
    function V(j, Q) {
      se(j, Q, Q);
    }
    function K(j, Q) {
      var X = r(), T;
      for (T = 0; T < 16; T++)
        X[T] = Q[T];
      for (T = 253; T >= 0; T--)
        V(X, X), T !== 2 && T !== 4 && se(X, X, Q);
      for (T = 0; T < 16; T++)
        j[T] = X[T];
    }
    function Z(j, Q) {
      var X = r(), T;
      for (T = 0; T < 16; T++)
        X[T] = Q[T];
      for (T = 250; T >= 0; T--)
        V(X, X), T !== 1 && se(X, X, Q);
      for (T = 0; T < 16; T++)
        j[T] = X[T];
    }
    function ne(j, Q, X) {
      var T = new Uint8Array(32), te = new Float64Array(80), ge, be, Ae = r(), Le = r(), Ge = r(), $e = r(), Xt = r(), et = r();
      for (be = 0; be < 31; be++)
        T[be] = Q[be];
      for (T[31] = Q[31] & 127 | 64, T[0] &= 248, g(te, X), be = 0; be < 16; be++)
        Le[be] = te[be], $e[be] = Ae[be] = Ge[be] = 0;
      for (Ae[0] = $e[0] = 1, be = 254; be >= 0; --be)
        ge = T[be >>> 3] >>> (be & 7) & 1, _(Ae, Le, ge), _(Ge, $e, ge), M(Xt, Ae, Ge), Y(Ae, Ae, Ge), M(Ge, Le, $e), Y(Le, Le, $e), V($e, Xt), V(et, Ae), se(Ae, Ge, Ae), se(Ge, Le, Xt), M(Xt, Ae, Ge), Y(Ae, Ae, Ge), V(Le, Ae), Y(Ge, $e, et), se(Ae, Ge, c), M(Ae, Ae, $e), se(Ge, Ge, Ae), se(Ae, $e, et), se($e, Le, te), V(Le, Xt), _(Ae, Le, ge), _(Ge, $e, ge);
      for (be = 0; be < 16; be++)
        te[be + 16] = Ae[be], te[be + 32] = Ge[be], te[be + 48] = Le[be], te[be + 64] = $e[be];
      var vt = te.subarray(32), wt = te.subarray(16);
      return K(vt, vt), se(wt, wt, vt), R(j, wt), 0;
    }
    function ce(j, Q) {
      return ne(j, Q, s);
    }
    function H(j, Q) {
      return n(Q, 32), ce(j, Q);
    }
    function J(j, Q, X) {
      var T = new Uint8Array(32);
      return ne(T, X, Q), P(j, i, T, C);
    }
    var le = w, me = E;
    function Ue(j, Q, X, T, te, ge) {
      var be = new Uint8Array(32);
      return J(be, te, ge), le(j, Q, X, T, be);
    }
    function Ve(j, Q, X, T, te, ge) {
      var be = new Uint8Array(32);
      return J(be, te, ge), me(j, Q, X, T, be);
    }
    var ze = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function at(j, Q, X, T) {
      for (var te = new Int32Array(16), ge = new Int32Array(16), be, Ae, Le, Ge, $e, Xt, et, vt, wt, Rt, Tt, _t, Et, St, tt, ft, Ye, nt, it, Je, Se, Ee, Ce, Oe, Me, je, mt = j[0], Mt = j[1], Dt = j[2], Ct = j[3], ue = j[4], Ht = j[5], yr = j[6], br = j[7], jt = Q[0], or = Q[1], cr = Q[2], hn = Q[3], Cr = Q[4], sn = Q[5], an = Q[6], on = Q[7], vn = 0; T >= 128; ) {
        for (it = 0; it < 16; it++)
          Je = 8 * it + vn, te[it] = X[Je + 0] << 24 | X[Je + 1] << 16 | X[Je + 2] << 8 | X[Je + 3], ge[it] = X[Je + 4] << 24 | X[Je + 5] << 16 | X[Je + 6] << 8 | X[Je + 7];
        for (it = 0; it < 80; it++)
          if (be = mt, Ae = Mt, Le = Dt, Ge = Ct, $e = ue, Xt = Ht, et = yr, vt = br, wt = jt, Rt = or, Tt = cr, _t = hn, Et = Cr, St = sn, tt = an, ft = on, Se = br, Ee = on, Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = (ue >>> 14 | Cr << 18) ^ (ue >>> 18 | Cr << 14) ^ (Cr >>> 9 | ue << 23), Ee = (Cr >>> 14 | ue << 18) ^ (Cr >>> 18 | ue << 14) ^ (ue >>> 9 | Cr << 23), Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Se = ue & Ht ^ ~ue & yr, Ee = Cr & sn ^ ~Cr & an, Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Se = ze[it * 2], Ee = ze[it * 2 + 1], Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Se = te[it % 16], Ee = ge[it % 16], Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, Ye = Me & 65535 | je << 16, nt = Ce & 65535 | Oe << 16, Se = Ye, Ee = nt, Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = (mt >>> 28 | jt << 4) ^ (jt >>> 2 | mt << 30) ^ (jt >>> 7 | mt << 25), Ee = (jt >>> 28 | mt << 4) ^ (mt >>> 2 | jt << 30) ^ (mt >>> 7 | jt << 25), Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Se = mt & Mt ^ mt & Dt ^ Mt & Dt, Ee = jt & or ^ jt & cr ^ or & cr, Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, vt = Me & 65535 | je << 16, ft = Ce & 65535 | Oe << 16, Se = Ge, Ee = _t, Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = Ye, Ee = nt, Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, Ge = Me & 65535 | je << 16, _t = Ce & 65535 | Oe << 16, Mt = be, Dt = Ae, Ct = Le, ue = Ge, Ht = $e, yr = Xt, br = et, mt = vt, or = wt, cr = Rt, hn = Tt, Cr = _t, sn = Et, an = St, on = tt, jt = ft, it % 16 === 15)
            for (Je = 0; Je < 16; Je++)
              Se = te[Je], Ee = ge[Je], Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = te[(Je + 9) % 16], Ee = ge[(Je + 9) % 16], Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Ye = te[(Je + 1) % 16], nt = ge[(Je + 1) % 16], Se = (Ye >>> 1 | nt << 31) ^ (Ye >>> 8 | nt << 24) ^ Ye >>> 7, Ee = (nt >>> 1 | Ye << 31) ^ (nt >>> 8 | Ye << 24) ^ (nt >>> 7 | Ye << 25), Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Ye = te[(Je + 14) % 16], nt = ge[(Je + 14) % 16], Se = (Ye >>> 19 | nt << 13) ^ (nt >>> 29 | Ye << 3) ^ Ye >>> 6, Ee = (nt >>> 19 | Ye << 13) ^ (Ye >>> 29 | nt << 3) ^ (nt >>> 6 | Ye << 26), Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, te[Je] = Me & 65535 | je << 16, ge[Je] = Ce & 65535 | Oe << 16;
        Se = mt, Ee = jt, Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = j[0], Ee = Q[0], Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, j[0] = mt = Me & 65535 | je << 16, Q[0] = jt = Ce & 65535 | Oe << 16, Se = Mt, Ee = or, Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = j[1], Ee = Q[1], Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, j[1] = Mt = Me & 65535 | je << 16, Q[1] = or = Ce & 65535 | Oe << 16, Se = Dt, Ee = cr, Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = j[2], Ee = Q[2], Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, j[2] = Dt = Me & 65535 | je << 16, Q[2] = cr = Ce & 65535 | Oe << 16, Se = Ct, Ee = hn, Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = j[3], Ee = Q[3], Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, j[3] = Ct = Me & 65535 | je << 16, Q[3] = hn = Ce & 65535 | Oe << 16, Se = ue, Ee = Cr, Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = j[4], Ee = Q[4], Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, j[4] = ue = Me & 65535 | je << 16, Q[4] = Cr = Ce & 65535 | Oe << 16, Se = Ht, Ee = sn, Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = j[5], Ee = Q[5], Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, j[5] = Ht = Me & 65535 | je << 16, Q[5] = sn = Ce & 65535 | Oe << 16, Se = yr, Ee = an, Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = j[6], Ee = Q[6], Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, j[6] = yr = Me & 65535 | je << 16, Q[6] = an = Ce & 65535 | Oe << 16, Se = br, Ee = on, Ce = Ee & 65535, Oe = Ee >>> 16, Me = Se & 65535, je = Se >>> 16, Se = j[7], Ee = Q[7], Ce += Ee & 65535, Oe += Ee >>> 16, Me += Se & 65535, je += Se >>> 16, Oe += Ce >>> 16, Me += Oe >>> 16, je += Me >>> 16, j[7] = br = Me & 65535 | je << 16, Q[7] = on = Ce & 65535 | Oe << 16, vn += 128, T -= 128;
      }
      return T;
    }
    function xe(j, Q, X) {
      var T = new Int32Array(8), te = new Int32Array(8), ge = new Uint8Array(256), be, Ae = X;
      for (T[0] = 1779033703, T[1] = 3144134277, T[2] = 1013904242, T[3] = 2773480762, T[4] = 1359893119, T[5] = 2600822924, T[6] = 528734635, T[7] = 1541459225, te[0] = 4089235720, te[1] = 2227873595, te[2] = 4271175723, te[3] = 1595750129, te[4] = 2917565137, te[5] = 725511199, te[6] = 4215389547, te[7] = 327033209, at(T, te, Q, X), X %= 128, be = 0; be < X; be++)
        ge[be] = Q[Ae - X + be];
      for (ge[X] = 128, X = 256 - 128 * (X < 112 ? 1 : 0), ge[X - 9] = 0, y(ge, X - 8, Ae / 536870912 | 0, Ae << 3), at(T, te, ge, X), be = 0; be < 8; be++)
        y(j, 8 * be, T[be], te[be]);
      return 0;
    }
    function gt(j, Q) {
      var X = r(), T = r(), te = r(), ge = r(), be = r(), Ae = r(), Le = r(), Ge = r(), $e = r();
      Y(X, j[1], j[0]), Y($e, Q[1], Q[0]), se(X, X, $e), M(T, j[0], j[1]), M($e, Q[0], Q[1]), se(T, T, $e), se(te, j[3], Q[3]), se(te, te, u), se(ge, j[2], Q[2]), M(ge, ge, ge), Y(be, T, X), Y(Ae, ge, te), M(Le, ge, te), M(Ge, T, X), se(j[0], be, Ae), se(j[1], Ge, Le), se(j[2], Le, Ae), se(j[3], be, Ge);
    }
    function ht(j, Q, X) {
      var T;
      for (T = 0; T < 4; T++)
        _(j[T], Q[T], X);
    }
    function Bt(j, Q) {
      var X = r(), T = r(), te = r();
      K(te, Q[2]), se(X, Q[0], te), se(T, Q[1], te), R(j, T), j[31] ^= O(X) << 7;
    }
    function pt(j, Q, X) {
      var T, te;
      for (U(j[0], a), U(j[1], o), U(j[2], o), U(j[3], a), te = 255; te >= 0; --te)
        T = X[te / 8 | 0] >> (te & 7) & 1, ht(j, Q, T), gt(Q, j), gt(j, j), ht(j, Q, T);
    }
    function de(j, Q) {
      var X = [r(), r(), r(), r()];
      U(X[0], d), U(X[1], l), U(X[2], o), se(X[3], d, l), pt(j, X, Q);
    }
    function he(j, Q, X) {
      var T = new Uint8Array(64), te = [r(), r(), r(), r()], ge;
      for (X || n(Q, 32), xe(T, Q, 32), T[0] &= 248, T[31] &= 127, T[31] |= 64, de(te, T), Bt(j, te), ge = 0; ge < 32; ge++)
        Q[ge + 32] = j[ge];
      return 0;
    }
    var Ie = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function z(j, Q) {
      var X, T, te, ge;
      for (T = 63; T >= 32; --T) {
        for (X = 0, te = T - 32, ge = T - 12; te < ge; ++te)
          Q[te] += X - 16 * Q[T] * Ie[te - (T - 32)], X = Math.floor((Q[te] + 128) / 256), Q[te] -= X * 256;
        Q[te] += X, Q[T] = 0;
      }
      for (X = 0, te = 0; te < 32; te++)
        Q[te] += X - (Q[31] >> 4) * Ie[te], X = Q[te] >> 8, Q[te] &= 255;
      for (te = 0; te < 32; te++)
        Q[te] -= X * Ie[te];
      for (T = 0; T < 32; T++)
        Q[T + 1] += Q[T] >> 8, j[T] = Q[T] & 255;
    }
    function k(j) {
      var Q = new Float64Array(64), X;
      for (X = 0; X < 64; X++)
        Q[X] = j[X];
      for (X = 0; X < 64; X++)
        j[X] = 0;
      z(j, Q);
    }
    function B(j, Q, X, T) {
      var te = new Uint8Array(64), ge = new Uint8Array(64), be = new Uint8Array(64), Ae, Le, Ge = new Float64Array(64), $e = [r(), r(), r(), r()];
      xe(te, T, 32), te[0] &= 248, te[31] &= 127, te[31] |= 64;
      var Xt = X + 64;
      for (Ae = 0; Ae < X; Ae++)
        j[64 + Ae] = Q[Ae];
      for (Ae = 0; Ae < 32; Ae++)
        j[32 + Ae] = te[32 + Ae];
      for (xe(be, j.subarray(32), X + 32), k(be), de($e, be), Bt(j, $e), Ae = 32; Ae < 64; Ae++)
        j[Ae] = T[Ae];
      for (xe(ge, j, X + 64), k(ge), Ae = 0; Ae < 64; Ae++)
        Ge[Ae] = 0;
      for (Ae = 0; Ae < 32; Ae++)
        Ge[Ae] = be[Ae];
      for (Ae = 0; Ae < 32; Ae++)
        for (Le = 0; Le < 32; Le++)
          Ge[Ae + Le] += ge[Ae] * te[Le];
      return z(j.subarray(32), Ge), Xt;
    }
    function A(j, Q) {
      var X = r(), T = r(), te = r(), ge = r(), be = r(), Ae = r(), Le = r();
      return U(j[2], o), g(j[1], Q), V(te, j[1]), se(ge, te, f), Y(te, te, j[2]), M(ge, j[2], ge), V(be, ge), V(Ae, be), se(Le, Ae, be), se(X, Le, te), se(X, X, ge), Z(X, X), se(X, X, te), se(X, X, ge), se(X, X, ge), se(j[0], X, ge), V(T, j[0]), se(T, T, ge), N(T, te) && se(j[0], j[0], h), V(T, j[0]), se(T, T, ge), N(T, te) ? -1 : (O(j[0]) === Q[31] >> 7 && Y(j[0], a, j[0]), se(j[3], j[0], j[1]), 0);
    }
    function m(j, Q, X, T) {
      var te, ge = new Uint8Array(32), be = new Uint8Array(64), Ae = [r(), r(), r(), r()], Le = [r(), r(), r(), r()];
      if (X < 64 || A(Le, T))
        return -1;
      for (te = 0; te < X; te++)
        j[te] = Q[te];
      for (te = 0; te < 32; te++)
        j[te + 32] = T[te];
      if (xe(be, j, X), k(be), pt(Ae, Le, be), de(Le, Q.subarray(32)), gt(Ae, Le), Bt(ge, Ae), X -= 64, v(Q, 0, ge, 0)) {
        for (te = 0; te < X; te++)
          j[te] = 0;
        return -1;
      }
      for (te = 0; te < X; te++)
        j[te] = Q[te + 64];
      return X;
    }
    var S = 32, q = 24, oe = 32, fe = 16, pe = 32, Ke = 32, De = 32, ot = 32, ar = 32, bt = q, qr = oe, ha = fe, nr = 64, pr = 32, bi = 64, Br = 32, Mr = 64;
    e.lowlevel = {
      crypto_core_hsalsa20: P,
      crypto_stream_xor: re,
      crypto_stream: G,
      crypto_stream_salsa20_xor: D,
      crypto_stream_salsa20: F,
      crypto_onetimeauth: ee,
      crypto_onetimeauth_verify: $,
      crypto_verify_16: b,
      crypto_verify_32: v,
      crypto_secretbox: w,
      crypto_secretbox_open: E,
      crypto_scalarmult: ne,
      crypto_scalarmult_base: ce,
      crypto_box_beforenm: J,
      crypto_box_afternm: le,
      crypto_box: Ue,
      crypto_box_open: Ve,
      crypto_box_keypair: H,
      crypto_hash: xe,
      crypto_sign: B,
      crypto_sign_keypair: he,
      crypto_sign_open: m,
      crypto_secretbox_KEYBYTES: S,
      crypto_secretbox_NONCEBYTES: q,
      crypto_secretbox_ZEROBYTES: oe,
      crypto_secretbox_BOXZEROBYTES: fe,
      crypto_scalarmult_BYTES: pe,
      crypto_scalarmult_SCALARBYTES: Ke,
      crypto_box_PUBLICKEYBYTES: De,
      crypto_box_SECRETKEYBYTES: ot,
      crypto_box_BEFORENMBYTES: ar,
      crypto_box_NONCEBYTES: bt,
      crypto_box_ZEROBYTES: qr,
      crypto_box_BOXZEROBYTES: ha,
      crypto_sign_BYTES: nr,
      crypto_sign_PUBLICKEYBYTES: pr,
      crypto_sign_SECRETKEYBYTES: bi,
      crypto_sign_SEEDBYTES: Br,
      crypto_hash_BYTES: Mr,
      gf: r,
      D: f,
      L: Ie,
      pack25519: R,
      unpack25519: g,
      M: se,
      A: M,
      S: V,
      Z: Y,
      pow2523: Z,
      add: gt,
      set25519: U,
      modL: z,
      scalarmult: pt,
      scalarbase: de
    };
    function Bs(j, Q) {
      if (j.length !== S)
        throw new Error("bad key size");
      if (Q.length !== q)
        throw new Error("bad nonce size");
    }
    function Wr(j, Q) {
      if (j.length !== De)
        throw new Error("bad public key size");
      if (Q.length !== ot)
        throw new Error("bad secret key size");
    }
    function Vt() {
      for (var j = 0; j < arguments.length; j++)
        if (!(arguments[j] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function Ms(j) {
      for (var Q = 0; Q < j.length; Q++)
        j[Q] = 0;
    }
    e.randomBytes = function(j) {
      var Q = new Uint8Array(j);
      return n(Q, j), Q;
    }, e.secretbox = function(j, Q, X) {
      Vt(j, Q, X), Bs(X, Q);
      for (var T = new Uint8Array(oe + j.length), te = new Uint8Array(T.length), ge = 0; ge < j.length; ge++)
        T[ge + oe] = j[ge];
      return w(te, T, T.length, Q, X), te.subarray(fe);
    }, e.secretbox.open = function(j, Q, X) {
      Vt(j, Q, X), Bs(X, Q);
      for (var T = new Uint8Array(fe + j.length), te = new Uint8Array(T.length), ge = 0; ge < j.length; ge++)
        T[ge + fe] = j[ge];
      return T.length < 32 || E(te, T, T.length, Q, X) !== 0 ? null : te.subarray(oe);
    }, e.secretbox.keyLength = S, e.secretbox.nonceLength = q, e.secretbox.overheadLength = fe, e.scalarMult = function(j, Q) {
      if (Vt(j, Q), j.length !== Ke)
        throw new Error("bad n size");
      if (Q.length !== pe)
        throw new Error("bad p size");
      var X = new Uint8Array(pe);
      return ne(X, j, Q), X;
    }, e.scalarMult.base = function(j) {
      if (Vt(j), j.length !== Ke)
        throw new Error("bad n size");
      var Q = new Uint8Array(pe);
      return ce(Q, j), Q;
    }, e.scalarMult.scalarLength = Ke, e.scalarMult.groupElementLength = pe, e.box = function(j, Q, X, T) {
      var te = e.box.before(X, T);
      return e.secretbox(j, Q, te);
    }, e.box.before = function(j, Q) {
      Vt(j, Q), Wr(j, Q);
      var X = new Uint8Array(ar);
      return J(X, j, Q), X;
    }, e.box.after = e.secretbox, e.box.open = function(j, Q, X, T) {
      var te = e.box.before(X, T);
      return e.secretbox.open(j, Q, te);
    }, e.box.open.after = e.secretbox.open, e.box.keyPair = function() {
      var j = new Uint8Array(De), Q = new Uint8Array(ot);
      return H(j, Q), { publicKey: j, secretKey: Q };
    }, e.box.keyPair.fromSecretKey = function(j) {
      if (Vt(j), j.length !== ot)
        throw new Error("bad secret key size");
      var Q = new Uint8Array(De);
      return ce(Q, j), { publicKey: Q, secretKey: new Uint8Array(j) };
    }, e.box.publicKeyLength = De, e.box.secretKeyLength = ot, e.box.sharedKeyLength = ar, e.box.nonceLength = bt, e.box.overheadLength = e.secretbox.overheadLength, e.sign = function(j, Q) {
      if (Vt(j, Q), Q.length !== bi)
        throw new Error("bad secret key size");
      var X = new Uint8Array(nr + j.length);
      return B(X, j, j.length, Q), X;
    }, e.sign.open = function(j, Q) {
      if (Vt(j, Q), Q.length !== pr)
        throw new Error("bad public key size");
      var X = new Uint8Array(j.length), T = m(X, j, j.length, Q);
      if (T < 0)
        return null;
      for (var te = new Uint8Array(T), ge = 0; ge < te.length; ge++)
        te[ge] = X[ge];
      return te;
    }, e.sign.detached = function(j, Q) {
      for (var X = e.sign(j, Q), T = new Uint8Array(nr), te = 0; te < T.length; te++)
        T[te] = X[te];
      return T;
    }, e.sign.detached.verify = function(j, Q, X) {
      if (Vt(j, Q, X), Q.length !== nr)
        throw new Error("bad signature size");
      if (X.length !== pr)
        throw new Error("bad public key size");
      var T = new Uint8Array(nr + j.length), te = new Uint8Array(nr + j.length), ge;
      for (ge = 0; ge < nr; ge++)
        T[ge] = Q[ge];
      for (ge = 0; ge < j.length; ge++)
        T[ge + nr] = j[ge];
      return m(te, T, T.length, X) >= 0;
    }, e.sign.keyPair = function() {
      var j = new Uint8Array(pr), Q = new Uint8Array(bi);
      return he(j, Q), { publicKey: j, secretKey: Q };
    }, e.sign.keyPair.fromSecretKey = function(j) {
      if (Vt(j), j.length !== bi)
        throw new Error("bad secret key size");
      for (var Q = new Uint8Array(pr), X = 0; X < Q.length; X++)
        Q[X] = j[32 + X];
      return { publicKey: Q, secretKey: new Uint8Array(j) };
    }, e.sign.keyPair.fromSeed = function(j) {
      if (Vt(j), j.length !== Br)
        throw new Error("bad seed size");
      for (var Q = new Uint8Array(pr), X = new Uint8Array(bi), T = 0; T < 32; T++)
        X[T] = j[T];
      return he(Q, X, !0), { publicKey: Q, secretKey: X };
    }, e.sign.publicKeyLength = pr, e.sign.secretKeyLength = bi, e.sign.seedLength = Br, e.sign.signatureLength = nr, e.hash = function(j) {
      Vt(j);
      var Q = new Uint8Array(Mr);
      return xe(Q, j, j.length), Q;
    }, e.hash.hashLength = Mr, e.verify = function(j, Q) {
      return Vt(j, Q), j.length === 0 || Q.length === 0 || j.length !== Q.length ? !1 : p(j, 0, Q, 0, j.length) === 0;
    }, e.setPRNG = function(j) {
      n = j;
    }, function() {
      var j = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (j && j.getRandomValues) {
        var Q = 65536;
        e.setPRNG(function(X, T) {
          var te, ge = new Uint8Array(T);
          for (te = 0; te < T; te += Q)
            j.getRandomValues(ge.subarray(te, te + Math.min(T - te, Q)));
          for (te = 0; te < T; te++)
            X[te] = ge[te];
          Ms(ge);
        });
      } else
        typeof mO < "u" && (j = H2(), j && j.randomBytes && e.setPRNG(function(X, T) {
          var te, ge = j.randomBytes(T);
          for (te = 0; te < T; te++)
            X[te] = ge[te];
          Ms(ge);
        }));
    }();
  })(t.exports ? t.exports : self.nacl = self.nacl || {});
})(oA);
var L0 = oA.exports;
const Wu = /* @__PURE__ */ Ln(L0);
var fh = Lt.Buffer;
function pN(t) {
  if (t.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var e = new Uint8Array(256), r = 0; r < e.length; r++)
    e[r] = 255;
  for (var n = 0; n < t.length; n++) {
    var i = t.charAt(n), s = i.charCodeAt(0);
    if (e[s] !== 255)
      throw new TypeError(i + " is ambiguous");
    e[s] = n;
  }
  var a = t.length, o = t.charAt(0), c = Math.log(a) / Math.log(256), f = Math.log(256) / Math.log(a);
  function u(h) {
    if ((Array.isArray(h) || h instanceof Uint8Array) && (h = fh.from(h)), !fh.isBuffer(h))
      throw new TypeError("Expected Buffer");
    if (h.length === 0)
      return "";
    for (var y = 0, p = 0, b = 0, v = h.length; b !== v && h[b] === 0; )
      b++, y++;
    for (var x = (v - b) * f + 1 >>> 0, I = new Uint8Array(x); b !== v; ) {
      for (var L = h[b], P = 0, C = x - 1; (L !== 0 || P < p) && C !== -1; C--, P++)
        L += 256 * I[C] >>> 0, I[C] = L % a >>> 0, L = L / a >>> 0;
      if (L !== 0)
        throw new Error("Non-zero carry");
      p = P, b++;
    }
    for (var D = x - p; D !== x && I[D] === 0; )
      D++;
    for (var F = o.repeat(y); D < x; ++D)
      F += t.charAt(I[D]);
    return F;
  }
  function d(h) {
    if (typeof h != "string")
      throw new TypeError("Expected String");
    if (h.length === 0)
      return fh.alloc(0);
    for (var y = 0, p = 0, b = 0; h[y] === o; )
      p++, y++;
    for (var v = (h.length - y) * c + 1 >>> 0, x = new Uint8Array(v); h[y]; ) {
      var I = e[h.charCodeAt(y)];
      if (I === 255)
        return;
      for (var L = 0, P = v - 1; (I !== 0 || L < b) && P !== -1; P--, L++)
        I += a * x[P] >>> 0, x[P] = I % 256 >>> 0, I = I / 256 >>> 0;
      if (I !== 0)
        throw new Error("Non-zero carry");
      b = L, y++;
    }
    for (var C = v - b; C !== v && x[C] === 0; )
      C++;
    var D = fh.allocUnsafe(p + (v - C));
    D.fill(0, 0, p);
    for (var F = p; C !== v; )
      D[F++] = x[C++];
    return D;
  }
  function l(h) {
    var y = d(h);
    if (y)
      return y;
    throw new Error("Non-base" + a + " character");
  }
  return {
    encode: u,
    decodeUnsafe: d,
    decode: l
  };
}
var yN = pN, bN = yN, gN = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", ko = bN(gN);
const Ot = /* @__PURE__ */ Ln(ko);
var Wn = {};
function Aa(t, e, r) {
  return e <= t && t <= r;
}
function D0(t) {
  if (t === void 0)
    return {};
  if (t === Object(t))
    return t;
  throw TypeError("Could not convert argument to dictionary");
}
function mN(t) {
  for (var e = String(t), r = e.length, n = 0, i = []; n < r; ) {
    var s = e.charCodeAt(n);
    if (s < 55296 || s > 57343)
      i.push(s);
    else if (56320 <= s && s <= 57343)
      i.push(65533);
    else if (55296 <= s && s <= 56319)
      if (n === r - 1)
        i.push(65533);
      else {
        var a = t.charCodeAt(n + 1);
        if (56320 <= a && a <= 57343) {
          var o = s & 1023, c = a & 1023;
          i.push(65536 + (o << 10) + c), n += 1;
        } else
          i.push(65533);
      }
    n += 1;
  }
  return i;
}
function vN(t) {
  for (var e = "", r = 0; r < t.length; ++r) {
    var n = t[r];
    n <= 65535 ? e += String.fromCharCode(n) : (n -= 65536, e += String.fromCharCode(
      (n >> 10) + 55296,
      (n & 1023) + 56320
    ));
  }
  return e;
}
var pp = -1;
function G2(t) {
  this.tokens = [].slice.call(t);
}
G2.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },
  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
  read: function() {
    return this.tokens.length ? this.tokens.shift() : pp;
  },
  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(t) {
    if (Array.isArray(t))
      for (var e = (
        /**@type {!Array.<number>}*/
        t
      ); e.length; )
        this.tokens.unshift(e.pop());
    else
      this.tokens.unshift(t);
  },
  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(t) {
    if (Array.isArray(t))
      for (var e = (
        /**@type {!Array.<number>}*/
        t
      ); e.length; )
        this.tokens.push(e.shift());
    else
      this.tokens.push(t);
  }
};
var zu = -1;
function Xb(t, e) {
  if (t)
    throw TypeError("Decoder error");
  return e || 65533;
}
var yp = "utf-8";
function bp(t, e) {
  if (!(this instanceof bp))
    return new bp(t, e);
  if (t = t !== void 0 ? String(t).toLowerCase() : yp, t !== yp)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  e = D0(e), this._streaming = !1, this._BOMseen = !1, this._decoder = null, this._fatal = !!e.fatal, this._ignoreBOM = !!e.ignoreBOM, Object.defineProperty(this, "encoding", { value: "utf-8" }), Object.defineProperty(this, "fatal", { value: this._fatal }), Object.defineProperty(this, "ignoreBOM", { value: this._ignoreBOM });
}
bp.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function(e, r) {
    var n;
    typeof e == "object" && e instanceof ArrayBuffer ? n = new Uint8Array(e) : typeof e == "object" && "buffer" in e && e.buffer instanceof ArrayBuffer ? n = new Uint8Array(
      e.buffer,
      e.byteOffset,
      e.byteLength
    ) : n = new Uint8Array(0), r = D0(r), this._streaming || (this._decoder = new wN({ fatal: this._fatal }), this._BOMseen = !1), this._streaming = !!r.stream;
    for (var i = new G2(n), s = [], a; !i.endOfStream() && (a = this._decoder.handler(i, i.read()), a !== zu); )
      a !== null && (Array.isArray(a) ? s.push.apply(
        s,
        /**@type {!Array.<number>}*/
        a
      ) : s.push(a));
    if (!this._streaming) {
      do {
        if (a = this._decoder.handler(i, i.read()), a === zu)
          break;
        a !== null && (Array.isArray(a) ? s.push.apply(
          s,
          /**@type {!Array.<number>}*/
          a
        ) : s.push(a));
      } while (!i.endOfStream());
      this._decoder = null;
    }
    return s.length && ["utf-8"].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen && (s[0] === 65279 ? (this._BOMseen = !0, s.shift()) : this._BOMseen = !0), vN(s);
  }
};
function gp(t, e) {
  if (!(this instanceof gp))
    return new gp(t, e);
  if (t = t !== void 0 ? String(t).toLowerCase() : yp, t !== yp)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  e = D0(e), this._streaming = !1, this._encoder = null, this._options = { fatal: !!e.fatal }, Object.defineProperty(this, "encoding", { value: "utf-8" });
}
gp.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function(e, r) {
    e = e ? String(e) : "", r = D0(r), this._streaming || (this._encoder = new _N(this._options)), this._streaming = !!r.stream;
    for (var n = [], i = new G2(mN(e)), s; !i.endOfStream() && (s = this._encoder.handler(i, i.read()), s !== zu); )
      Array.isArray(s) ? n.push.apply(
        n,
        /**@type {!Array.<number>}*/
        s
      ) : n.push(s);
    if (!this._streaming) {
      for (; s = this._encoder.handler(i, i.read()), s !== zu; )
        Array.isArray(s) ? n.push.apply(
          n,
          /**@type {!Array.<number>}*/
          s
        ) : n.push(s);
      this._encoder = null;
    }
    return new Uint8Array(n);
  }
};
function wN(t) {
  var e = t.fatal, r = 0, n = 0, i = 0, s = 128, a = 191;
  this.handler = function(o, c) {
    if (c === pp && i !== 0)
      return i = 0, Xb(e);
    if (c === pp)
      return zu;
    if (i === 0) {
      if (Aa(c, 0, 127))
        return c;
      if (Aa(c, 194, 223))
        i = 1, r = c - 192;
      else if (Aa(c, 224, 239))
        c === 224 && (s = 160), c === 237 && (a = 159), i = 2, r = c - 224;
      else if (Aa(c, 240, 244))
        c === 240 && (s = 144), c === 244 && (a = 143), i = 3, r = c - 240;
      else
        return Xb(e);
      return r = r << 6 * i, null;
    }
    if (!Aa(c, s, a))
      return r = i = n = 0, s = 128, a = 191, o.prepend(c), Xb(e);
    if (s = 128, a = 191, n += 1, r += c - 128 << 6 * (i - n), n !== i)
      return null;
    var f = r;
    return r = i = n = 0, f;
  };
}
function _N(t) {
  t.fatal, this.handler = function(e, r) {
    if (r === pp)
      return zu;
    if (Aa(r, 0, 127))
      return r;
    var n, i;
    Aa(r, 128, 2047) ? (n = 1, i = 192) : Aa(r, 2048, 65535) ? (n = 2, i = 224) : Aa(r, 65536, 1114111) && (n = 3, i = 240);
    for (var s = [(r >> 6 * n) + i]; n > 0; ) {
      var a = r >> 6 * (n - 1);
      s.push(128 | a & 63), n -= 1;
    }
    return s;
  };
}
const SN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextDecoder: bp,
  TextEncoder: gp
}, Symbol.toStringTag, { value: "Module" })), m5 = /* @__PURE__ */ ta(SN);
var EN = Ne && Ne.__createBinding || (Object.create ? function(t, e, r, n) {
  n === void 0 && (n = r), Object.defineProperty(t, n, { enumerable: !0, get: function() {
    return e[r];
  } });
} : function(t, e, r, n) {
  n === void 0 && (n = r), t[n] = e[r];
}), xN = Ne && Ne.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), na = Ne && Ne.__decorate || function(t, e, r, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, r) : n, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(t, e, r, n);
  else
    for (var o = t.length - 1; o >= 0; o--)
      (a = t[o]) && (s = (i < 3 ? a(s) : i > 3 ? a(e, r, s) : a(e, r)) || s);
  return i > 3 && s && Object.defineProperty(e, r, s), s;
}, AN = Ne && Ne.__importStar || function(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var r in t)
      r !== "default" && Object.hasOwnProperty.call(t, r) && EN(e, t, r);
  return xN(e, t), e;
}, v5 = Ne && Ne.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Wn, "__esModule", { value: !0 });
var F0 = Wn.deserializeUnchecked = Y2 = Wn.deserialize = Z2 = Wn.serialize = E5 = Wn.BinaryReader = S5 = Wn.BinaryWriter = Wn.BorshError = Wn.baseDecode = Wn.baseEncode = void 0;
const io = v5(Tr), w5 = v5(ko), IN = AN(m5), TN = typeof TextDecoder != "function" ? IN.TextDecoder : TextDecoder, kN = new TN("utf-8", { fatal: !0 });
function RN(t) {
  return typeof t == "string" && (t = ve.from(t, "utf8")), w5.default.encode(ve.from(t));
}
Wn.baseEncode = RN;
function PN(t) {
  return ve.from(w5.default.decode(t));
}
Wn.baseDecode = PN;
const eg = 1024;
let di = class extends Error {
  constructor(e) {
    super(e), this.fieldPath = [], this.originalMessage = e;
  }
  addToFieldPath(e) {
    this.fieldPath.splice(0, 0, e), this.message = this.originalMessage + ": " + this.fieldPath.join(".");
  }
};
Wn.BorshError = di;
let _5 = class {
  constructor() {
    this.buf = ve.alloc(eg), this.length = 0;
  }
  maybeResize() {
    this.buf.length < 16 + this.length && (this.buf = ve.concat([this.buf, ve.alloc(eg)]));
  }
  writeU8(e) {
    this.maybeResize(), this.buf.writeUInt8(e, this.length), this.length += 1;
  }
  writeU16(e) {
    this.maybeResize(), this.buf.writeUInt16LE(e, this.length), this.length += 2;
  }
  writeU32(e) {
    this.maybeResize(), this.buf.writeUInt32LE(e, this.length), this.length += 4;
  }
  writeU64(e) {
    this.maybeResize(), this.writeBuffer(ve.from(new io.default(e).toArray("le", 8)));
  }
  writeU128(e) {
    this.maybeResize(), this.writeBuffer(ve.from(new io.default(e).toArray("le", 16)));
  }
  writeU256(e) {
    this.maybeResize(), this.writeBuffer(ve.from(new io.default(e).toArray("le", 32)));
  }
  writeU512(e) {
    this.maybeResize(), this.writeBuffer(ve.from(new io.default(e).toArray("le", 64)));
  }
  writeBuffer(e) {
    this.buf = ve.concat([
      ve.from(this.buf.subarray(0, this.length)),
      e,
      ve.alloc(eg)
    ]), this.length += e.length;
  }
  writeString(e) {
    this.maybeResize();
    const r = ve.from(e, "utf8");
    this.writeU32(r.length), this.writeBuffer(r);
  }
  writeFixedArray(e) {
    this.writeBuffer(ve.from(e));
  }
  writeArray(e, r) {
    this.maybeResize(), this.writeU32(e.length);
    for (const n of e)
      this.maybeResize(), r(n);
  }
  toArray() {
    return this.buf.subarray(0, this.length);
  }
};
var S5 = Wn.BinaryWriter = _5;
function ia(t, e, r) {
  const n = r.value;
  r.value = function(...i) {
    try {
      return n.apply(this, i);
    } catch (s) {
      if (s instanceof RangeError) {
        const a = s.code;
        if (["ERR_BUFFER_OUT_OF_BOUNDS", "ERR_OUT_OF_RANGE"].indexOf(a) >= 0)
          throw new di("Reached the end of buffer when deserializing");
      }
      throw s;
    }
  };
}
let Wi = class {
  constructor(e) {
    this.buf = e, this.offset = 0;
  }
  readU8() {
    const e = this.buf.readUInt8(this.offset);
    return this.offset += 1, e;
  }
  readU16() {
    const e = this.buf.readUInt16LE(this.offset);
    return this.offset += 2, e;
  }
  readU32() {
    const e = this.buf.readUInt32LE(this.offset);
    return this.offset += 4, e;
  }
  readU64() {
    const e = this.readBuffer(8);
    return new io.default(e, "le");
  }
  readU128() {
    const e = this.readBuffer(16);
    return new io.default(e, "le");
  }
  readU256() {
    const e = this.readBuffer(32);
    return new io.default(e, "le");
  }
  readU512() {
    const e = this.readBuffer(64);
    return new io.default(e, "le");
  }
  readBuffer(e) {
    if (this.offset + e > this.buf.length)
      throw new di(`Expected buffer length ${e} isn't within bounds`);
    const r = this.buf.slice(this.offset, this.offset + e);
    return this.offset += e, r;
  }
  readString() {
    const e = this.readU32(), r = this.readBuffer(e);
    try {
      return kN.decode(r);
    } catch (n) {
      throw new di(`Error decoding UTF-8 string: ${n}`);
    }
  }
  readFixedArray(e) {
    return new Uint8Array(this.readBuffer(e));
  }
  readArray(e) {
    const r = this.readU32(), n = Array();
    for (let i = 0; i < r; ++i)
      n.push(e());
    return n;
  }
};
na([
  ia
], Wi.prototype, "readU8", null);
na([
  ia
], Wi.prototype, "readU16", null);
na([
  ia
], Wi.prototype, "readU32", null);
na([
  ia
], Wi.prototype, "readU64", null);
na([
  ia
], Wi.prototype, "readU128", null);
na([
  ia
], Wi.prototype, "readU256", null);
na([
  ia
], Wi.prototype, "readU512", null);
na([
  ia
], Wi.prototype, "readString", null);
na([
  ia
], Wi.prototype, "readFixedArray", null);
na([
  ia
], Wi.prototype, "readArray", null);
var E5 = Wn.BinaryReader = Wi;
function x5(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function $o(t, e, r, n, i) {
  try {
    if (typeof n == "string")
      i[`write${x5(n)}`](r);
    else if (n instanceof Array)
      if (typeof n[0] == "number") {
        if (r.length !== n[0])
          throw new di(`Expecting byte array of length ${n[0]}, but got ${r.length} bytes`);
        i.writeFixedArray(r);
      } else if (n.length === 2 && typeof n[1] == "number") {
        if (r.length !== n[1])
          throw new di(`Expecting byte array of length ${n[1]}, but got ${r.length} bytes`);
        for (let s = 0; s < n[1]; s++)
          $o(t, null, r[s], n[0], i);
      } else
        i.writeArray(r, (s) => {
          $o(t, e, s, n[0], i);
        });
    else if (n.kind !== void 0)
      switch (n.kind) {
        case "option": {
          r == null ? i.writeU8(0) : (i.writeU8(1), $o(t, e, r, n.type, i));
          break;
        }
        case "map": {
          i.writeU32(r.size), r.forEach((s, a) => {
            $o(t, e, a, n.key, i), $o(t, e, s, n.value, i);
          });
          break;
        }
        default:
          throw new di(`FieldType ${n} unrecognized`);
      }
    else
      A5(t, r, i);
  } catch (s) {
    throw s instanceof di && s.addToFieldPath(e), s;
  }
}
function A5(t, e, r) {
  if (typeof e.borshSerialize == "function") {
    e.borshSerialize(r);
    return;
  }
  const n = t.get(e.constructor);
  if (!n)
    throw new di(`Class ${e.constructor.name} is missing in schema`);
  if (n.kind === "struct")
    n.fields.map(([i, s]) => {
      $o(t, i, e[i], s, r);
    });
  else if (n.kind === "enum") {
    const i = e[n.field];
    for (let s = 0; s < n.values.length; ++s) {
      const [a, o] = n.values[s];
      if (a === i) {
        r.writeU8(s), $o(t, a, e[a], o, r);
        break;
      }
    }
  } else
    throw new di(`Unexpected schema kind: ${n.kind} for ${e.constructor.name}`);
}
function ON(t, e, r = _5) {
  const n = new r();
  return A5(t, e, n), n.toArray();
}
var Z2 = Wn.serialize = ON;
function qo(t, e, r, n) {
  try {
    if (typeof r == "string")
      return n[`read${x5(r)}`]();
    if (r instanceof Array) {
      if (typeof r[0] == "number")
        return n.readFixedArray(r[0]);
      if (typeof r[1] == "number") {
        const i = [];
        for (let s = 0; s < r[1]; s++)
          i.push(qo(t, null, r[0], n));
        return i;
      } else
        return n.readArray(() => qo(t, e, r[0], n));
    }
    if (r.kind === "option")
      return n.readU8() ? qo(t, e, r.type, n) : void 0;
    if (r.kind === "map") {
      let i = /* @__PURE__ */ new Map();
      const s = n.readU32();
      for (let a = 0; a < s; a++) {
        const o = qo(t, e, r.key, n), c = qo(t, e, r.value, n);
        i.set(o, c);
      }
      return i;
    }
    return J2(t, r, n);
  } catch (i) {
    throw i instanceof di && i.addToFieldPath(e), i;
  }
}
function J2(t, e, r) {
  if (typeof e.borshDeserialize == "function")
    return e.borshDeserialize(r);
  const n = t.get(e);
  if (!n)
    throw new di(`Class ${e.name} is missing in schema`);
  if (n.kind === "struct") {
    const i = {};
    for (const [s, a] of t.get(e).fields)
      i[s] = qo(t, s, a, r);
    return new e(i);
  }
  if (n.kind === "enum") {
    const i = r.readU8();
    if (i >= n.values.length)
      throw new di(`Enum index: ${i} is out of range`);
    const [s, a] = n.values[i], o = qo(t, s, a, r);
    return new e({ [s]: o });
  }
  throw new di(`Unexpected schema kind: ${n.kind} for ${e.constructor.name}`);
}
function BN(t, e, r, n = Wi) {
  const i = new n(r), s = J2(t, e, i);
  if (i.offset < r.length)
    throw new di(`Unexpected ${r.length - i.offset} bytes after deserialized data`);
  return s;
}
var Y2 = Wn.deserialize = BN;
function MN(t, e, r, n = Wi) {
  const i = new n(r);
  return J2(t, e, i);
}
F0 = Wn.deserializeUnchecked = MN;
var _e = {};
Object.defineProperty(_e, "__esModule", { value: !0 });
_e.s16 = _e.s8 = _e.nu64be = _e.u48be = _e.u40be = _e.u32be = _e.u24be = _e.u16be = gr = _e.nu64 = _e.u48 = _e.u40 = Be = _e.u32 = _e.u24 = rn = _e.u16 = st = _e.u8 = Ii = _e.offset = _e.greedy = _e.Constant = _e.UTF8 = _e.CString = _e.Blob = _e.Boolean = _e.BitField = _e.BitStructure = _e.VariantLayout = _e.Union = _e.UnionLayoutDiscriminator = _e.UnionDiscriminator = _e.Structure = _e.Sequence = _e.DoubleBE = _e.Double = _e.FloatBE = _e.Float = _e.NearInt64BE = _e.NearInt64 = _e.NearUInt64BE = _e.NearUInt64 = _e.IntBE = _e.Int = _e.UIntBE = _e.UInt = _e.OffsetLayout = _e.GreedyCount = _e.ExternalLayout = _e.bindConstructorLayout = _e.nameWithProperty = _e.Layout = _e.uint8ArrayToBuffer = _e.checkUint8Array = void 0;
_e.constant = _e.utf8 = _e.cstr = xt = _e.blob = _e.unionLayoutDiscriminator = _e.union = Ir = _e.seq = _e.bits = Re = _e.struct = _e.f64be = _e.f64 = _e.f32be = _e.f32 = _e.ns64be = _e.s48be = _e.s40be = _e.s32be = _e.s24be = _e.s16be = Gr = _e.ns64 = _e.s48 = _e.s40 = _e.s32 = _e.s24 = void 0;
const Q2 = Fe;
function yf(t) {
  if (!(t instanceof Uint8Array))
    throw new TypeError("b must be a Uint8Array");
}
_e.checkUint8Array = yf;
function Sr(t) {
  return yf(t), Q2.Buffer.from(t.buffer, t.byteOffset, t.length);
}
_e.uint8ArrayToBuffer = Sr;
let Ur = class {
  constructor(e, r) {
    if (!Number.isInteger(e))
      throw new TypeError("span must be an integer");
    this.span = e, this.property = r;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Uint8Array} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(e, r) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(e) {
    const r = Object.create(this.constructor.prototype);
    return Object.assign(r, this), r.property = e, r;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(e) {
  }
};
_e.Layout = Ur;
function X2(t, e) {
  return e.property ? t + "[" + e.property + "]" : t;
}
_e.nameWithProperty = X2;
function CN(t, e) {
  if (typeof t != "function")
    throw new TypeError("Class must be constructor");
  if (Object.prototype.hasOwnProperty.call(t, "layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(e && e instanceof Ur))
    throw new TypeError("layout must be a Layout");
  if (Object.prototype.hasOwnProperty.call(e, "boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  t.layout_ = e, e.boundConstructor_ = t, e.makeDestinationObject = () => new t(), Object.defineProperty(t.prototype, "encode", {
    value(r, n) {
      return e.encode(this, r, n);
    },
    writable: !0
  }), Object.defineProperty(t, "decode", {
    value(r, n) {
      return e.decode(r, n);
    },
    writable: !0
  });
}
_e.bindConstructorLayout = CN;
let Si = class extends Ur {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
};
_e.ExternalLayout = Si;
let I5 = class extends Si {
  constructor(e = 1, r) {
    if (!Number.isInteger(e) || 0 >= e)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, r), this.elementSpan = e;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(e, r = 0) {
    yf(e);
    const n = e.length - r;
    return Math.floor(n / this.elementSpan);
  }
  /** @override */
  encode(e, r, n) {
    return 0;
  }
};
_e.GreedyCount = I5;
let ew = class extends Si {
  constructor(e, r = 0, n) {
    if (!(e instanceof Ur))
      throw new TypeError("layout must be a Layout");
    if (!Number.isInteger(r))
      throw new TypeError("offset must be integer or undefined");
    super(e.span, n || e.property), this.layout = e, this.offset = r;
  }
  /** @override */
  isCount() {
    return this.layout instanceof ss || this.layout instanceof Es;
  }
  /** @override */
  decode(e, r = 0) {
    return this.layout.decode(e, r + this.offset);
  }
  /** @override */
  encode(e, r, n = 0) {
    return this.layout.encode(e, r, n + this.offset);
  }
};
_e.OffsetLayout = ew;
let ss = class extends Ur {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r = 0) {
    return Sr(e).readUIntLE(r, this.span);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Sr(r).writeUIntLE(e, n, this.span), this.span;
  }
};
_e.UInt = ss;
let Es = class extends Ur {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r = 0) {
    return Sr(e).readUIntBE(r, this.span);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Sr(r).writeUIntBE(e, n, this.span), this.span;
  }
};
_e.UIntBE = Es;
let Fc = class extends Ur {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r = 0) {
    return Sr(e).readIntLE(r, this.span);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Sr(r).writeIntLE(e, n, this.span), this.span;
  }
};
_e.Int = Fc;
let bf = class extends Ur {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r = 0) {
    return Sr(e).readIntBE(r, this.span);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Sr(r).writeIntBE(e, n, this.span), this.span;
  }
};
_e.IntBE = bf;
const fv = Math.pow(2, 32);
function j0(t) {
  const e = Math.floor(t / fv), r = t - e * fv;
  return { hi32: e, lo32: r };
}
function $0(t, e) {
  return t * fv + e;
}
let T5 = class extends Ur {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    const n = Sr(e), i = n.readUInt32LE(r), s = n.readUInt32LE(r + 4);
    return $0(s, i);
  }
  /** @override */
  encode(e, r, n = 0) {
    const i = j0(e), s = Sr(r);
    return s.writeUInt32LE(i.lo32, n), s.writeUInt32LE(i.hi32, n + 4), 8;
  }
};
_e.NearUInt64 = T5;
let k5 = class extends Ur {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    const n = Sr(e), i = n.readUInt32BE(r), s = n.readUInt32BE(r + 4);
    return $0(i, s);
  }
  /** @override */
  encode(e, r, n = 0) {
    const i = j0(e), s = Sr(r);
    return s.writeUInt32BE(i.hi32, n), s.writeUInt32BE(i.lo32, n + 4), 8;
  }
};
_e.NearUInt64BE = k5;
let R5 = class extends Ur {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    const n = Sr(e), i = n.readUInt32LE(r), s = n.readInt32LE(r + 4);
    return $0(s, i);
  }
  /** @override */
  encode(e, r, n = 0) {
    const i = j0(e), s = Sr(r);
    return s.writeUInt32LE(i.lo32, n), s.writeInt32LE(i.hi32, n + 4), 8;
  }
};
_e.NearInt64 = R5;
let P5 = class extends Ur {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    const n = Sr(e), i = n.readInt32BE(r), s = n.readUInt32BE(r + 4);
    return $0(i, s);
  }
  /** @override */
  encode(e, r, n = 0) {
    const i = j0(e), s = Sr(r);
    return s.writeInt32BE(i.hi32, n), s.writeUInt32BE(i.lo32, n + 4), 8;
  }
};
_e.NearInt64BE = P5;
let O5 = class extends Ur {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, r = 0) {
    return Sr(e).readFloatLE(r);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Sr(r).writeFloatLE(e, n), 4;
  }
};
_e.Float = O5;
let B5 = class extends Ur {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, r = 0) {
    return Sr(e).readFloatBE(r);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Sr(r).writeFloatBE(e, n), 4;
  }
};
_e.FloatBE = B5;
let M5 = class extends Ur {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    return Sr(e).readDoubleLE(r);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Sr(r).writeDoubleLE(e, n), 8;
  }
};
_e.Double = M5;
let C5 = class extends Ur {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    return Sr(e).readDoubleBE(r);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Sr(r).writeDoubleBE(e, n), 8;
  }
};
_e.DoubleBE = C5;
let N5 = class extends Ur {
  constructor(e, r, n) {
    if (!(e instanceof Ur))
      throw new TypeError("elementLayout must be a Layout");
    if (!(r instanceof Si && r.isCount() || Number.isInteger(r) && 0 <= r))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let i = -1;
    !(r instanceof Si) && 0 < e.span && (i = r * e.span), super(i, n), this.elementLayout = e, this.count = r;
  }
  /** @override */
  getSpan(e, r = 0) {
    if (0 <= this.span)
      return this.span;
    let n = 0, i = this.count;
    if (i instanceof Si && (i = i.decode(e, r)), 0 < this.elementLayout.span)
      n = i * this.elementLayout.span;
    else {
      let s = 0;
      for (; s < i; )
        n += this.elementLayout.getSpan(e, r + n), ++s;
    }
    return n;
  }
  /** @override */
  decode(e, r = 0) {
    const n = [];
    let i = 0, s = this.count;
    for (s instanceof Si && (s = s.decode(e, r)); i < s; )
      n.push(this.elementLayout.decode(e, r)), r += this.elementLayout.getSpan(e, r), i += 1;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, r, n = 0) {
    const i = this.elementLayout, s = e.reduce((a, o) => a + i.encode(o, r, n + a), 0);
    return this.count instanceof Si && this.count.encode(e.length, r, n), s;
  }
};
_e.Sequence = N5;
let U5 = class extends Ur {
  constructor(e, r, n) {
    if (!(Array.isArray(e) && e.reduce((s, a) => s && a instanceof Ur, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof r == "boolean" && n === void 0 && (n = r, r = void 0);
    for (const s of e)
      if (0 > s.span && s.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let i = -1;
    try {
      i = e.reduce((s, a) => s + a.getSpan(), 0);
    } catch {
    }
    super(i, r), this.fields = e, this.decodePrefixes = !!n;
  }
  /** @override */
  getSpan(e, r = 0) {
    if (0 <= this.span)
      return this.span;
    let n = 0;
    try {
      n = this.fields.reduce((i, s) => {
        const a = s.getSpan(e, r);
        return r += a, i + a;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return n;
  }
  /** @override */
  decode(e, r = 0) {
    yf(e);
    const n = this.makeDestinationObject();
    for (const i of this.fields)
      if (i.property !== void 0 && (n[i.property] = i.decode(e, r)), r += i.getSpan(e, r), this.decodePrefixes && e.length === r)
        break;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(e, r, n = 0) {
    const i = n;
    let s = 0, a = 0;
    for (const o of this.fields) {
      let c = o.span;
      if (a = 0 < c ? c : 0, o.property !== void 0) {
        const f = e[o.property];
        f !== void 0 && (a = o.encode(f, r, n), 0 > c && (c = o.getSpan(r, n)));
      }
      s = n, n += c;
    }
    return s + a - i;
  }
  /** @override */
  fromArray(e) {
    const r = this.makeDestinationObject();
    for (const n of this.fields)
      n.property !== void 0 && 0 < e.length && (r[n.property] = e.shift());
    return r;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const r of this.fields)
      if (r.property === e)
        return r;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    let r = 0;
    for (const n of this.fields) {
      if (n.property === e)
        return r;
      0 > n.span ? r = -1 : 0 <= r && (r += n.span);
    }
  }
};
_e.Structure = U5;
let tw = class {
  constructor(e) {
    this.property = e;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode(e, r) {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode(e, r, n) {
    throw new Error("UnionDiscriminator is abstract");
  }
};
_e.UnionDiscriminator = tw;
let mp = class extends tw {
  constructor(e, r) {
    if (!(e instanceof Si && e.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(r || e.property || "variant"), this.layout = e;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(e, r) {
    return this.layout.decode(e, r);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(e, r, n) {
    return this.layout.encode(e, r, n);
  }
};
_e.UnionLayoutDiscriminator = mp;
let rw = class extends Ur {
  constructor(e, r, n) {
    let i;
    if (e instanceof ss || e instanceof Es)
      i = new mp(new ew(e));
    else if (e instanceof Si && e.isCount())
      i = new mp(e);
    else if (e instanceof tw)
      i = e;
    else
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (r === void 0 && (r = null), !(r === null || r instanceof Ur))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (r !== null) {
      if (0 > r.span)
        throw new Error("defaultLayout must have constant span");
      r.property === void 0 && (r = r.replicate("content"));
    }
    let s = -1;
    r && (s = r.span, 0 <= s && (e instanceof ss || e instanceof Es) && (s += i.layout.span)), super(s, n), this.discriminator = i, this.usesPrefixDiscriminator = e instanceof ss || e instanceof Es, this.defaultLayout = r, this.registry = {};
    let a = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(o) {
      return a(o);
    }, this.configGetSourceVariant = function(o) {
      a = o.bind(this);
    };
  }
  /** @override */
  getSpan(e, r = 0) {
    if (0 <= this.span)
      return this.span;
    const n = this.getVariant(e, r);
    if (!n)
      throw new Error("unable to determine span for unrecognized variant");
    return n.getSpan(e, r);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisfied rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(e) {
    if (Object.prototype.hasOwnProperty.call(e, this.discriminator.property)) {
      if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(e, this.defaultLayout.property))
        return;
      const r = this.registry[e[this.discriminator.property]];
      if (r && (!r.layout || r.property && Object.prototype.hasOwnProperty.call(e, r.property)))
        return r;
    } else
      for (const r in this.registry) {
        const n = this.registry[r];
        if (n.property && Object.prototype.hasOwnProperty.call(e, n.property))
          return n;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(e, r = 0) {
    let n;
    const i = this.discriminator, s = i.decode(e, r), a = this.registry[s];
    if (a === void 0) {
      const o = this.defaultLayout;
      let c = 0;
      this.usesPrefixDiscriminator && (c = i.layout.span), n = this.makeDestinationObject(), n[i.property] = s, n[o.property] = o.decode(e, r + c);
    } else
      n = a.decode(e, r);
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(e, r, n = 0) {
    const i = this.getSourceVariant(e);
    if (i === void 0) {
      const s = this.discriminator, a = this.defaultLayout;
      let o = 0;
      return this.usesPrefixDiscriminator && (o = s.layout.span), s.encode(e[s.property], r, n), o + a.encode(e[a.property], r, n + o);
    }
    return i.encode(e, r, n);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(e, r, n) {
    const i = new L5(this, e, r, n);
    return this.registry[e] = i, i;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Uint8Array)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Uint8Array}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(e, r = 0) {
    let n;
    return e instanceof Uint8Array ? n = this.discriminator.decode(e, r) : n = e, this.registry[n];
  }
};
_e.Union = rw;
let L5 = class extends Ur {
  constructor(e, r, n, i) {
    if (!(e instanceof rw))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(r) || 0 > r)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof n == "string" && i === void 0 && (i = n, n = null), n) {
      if (!(n instanceof Ur))
        throw new TypeError("layout must be a Layout");
      if (e.defaultLayout !== null && 0 <= n.span && n.span > e.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof i != "string")
        throw new TypeError("variant must have a String property");
    }
    let s = e.span;
    0 > e.span && (s = n ? n.span : 0, 0 <= s && e.usesPrefixDiscriminator && (s += e.discriminator.layout.span)), super(s, i), this.union = e, this.variant = r, this.layout = n || null;
  }
  /** @override */
  getSpan(e, r = 0) {
    if (0 <= this.span)
      return this.span;
    let n = 0;
    this.union.usesPrefixDiscriminator && (n = this.union.discriminator.layout.span);
    let i = 0;
    return this.layout && (i = this.layout.getSpan(e, r + n)), n + i;
  }
  /** @override */
  decode(e, r = 0) {
    const n = this.makeDestinationObject();
    if (this !== this.union.getVariant(e, r))
      throw new Error("variant mismatch");
    let i = 0;
    return this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout ? n[this.property] = this.layout.decode(e, r + i) : this.property ? n[this.property] = !0 : this.union.usesPrefixDiscriminator && (n[this.union.discriminator.property] = this.variant), n;
  }
  /** @override */
  encode(e, r, n = 0) {
    let i = 0;
    if (this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout && !Object.prototype.hasOwnProperty.call(e, this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, r, n);
    let s = i;
    if (this.layout && (this.layout.encode(e[this.property], r, n + i), s += this.layout.getSpan(r, n + i), 0 <= this.union.span && s > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return s;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(e) {
    if (this.layout)
      return this.layout.fromArray(e);
  }
};
_e.VariantLayout = L5;
function uu(t) {
  return 0 > t && (t += 4294967296), t;
}
let nw = class extends Ur {
  constructor(e, r, n) {
    if (!(e instanceof ss || e instanceof Es))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof r == "string" && n === void 0 && (n = r, r = !1), 4 < e.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(e.span, n), this.word = e, this.msb = !!r, this.fields = [];
    let i = 0;
    this._packedSetValue = function(s) {
      return i = uu(s), this;
    }, this._packedGetValue = function() {
      return i;
    };
  }
  /** @override */
  decode(e, r = 0) {
    const n = this.makeDestinationObject(), i = this.word.decode(e, r);
    this._packedSetValue(i);
    for (const s of this.fields)
      s.property !== void 0 && (n[s.property] = s.decode(e));
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(e, r, n = 0) {
    const i = this.word.decode(r, n);
    this._packedSetValue(i);
    for (const s of this.fields)
      if (s.property !== void 0) {
        const a = e[s.property];
        a !== void 0 && s.encode(a);
      }
    return this.word.encode(this._packedGetValue(), r, n);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(e, r) {
    const n = new iw(this, e, r);
    return this.fields.push(n), n;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  // `Boolean` conflicts with the native primitive type
  // eslint-disable-next-line @typescript-eslint/ban-types
  addBoolean(e) {
    const r = new D5(this, e);
    return this.fields.push(r), r;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const r of this.fields)
      if (r.property === e)
        return r;
  }
};
_e.BitStructure = nw;
let iw = class {
  constructor(e, r, n) {
    if (!(e instanceof nw))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(r) || 0 >= r)
      throw new TypeError("bits must be positive integer");
    const i = 8 * e.span, s = e.fields.reduce((a, o) => a + o.bits, 0);
    if (r + s > i)
      throw new Error("bits too long for span remainder (" + (i - s) + " of " + i + " remain)");
    this.container = e, this.bits = r, this.valueMask = (1 << r) - 1, r === 32 && (this.valueMask = 4294967295), this.start = s, this.container.msb && (this.start = i - s - r), this.wordMask = uu(this.valueMask << this.start), this.property = n;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode(e, r) {
    const n = this.container._packedGetValue();
    return uu(n & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(e) {
    if (typeof e != "number" || !Number.isInteger(e) || e !== uu(e & this.valueMask))
      throw new TypeError(X2("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const r = this.container._packedGetValue(), n = uu(e << this.start);
    this.container._packedSetValue(uu(r & ~this.wordMask) | n);
  }
};
_e.BitField = iw;
let D5 = class extends iw {
  constructor(e, r) {
    super(e, 1, r);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(e, r) {
    return !!super.decode(e, r);
  }
  /** @override */
  encode(e) {
    typeof e == "boolean" && (e = +e), super.encode(e);
  }
};
_e.Boolean = D5;
let F5 = class extends Ur {
  constructor(e, r) {
    if (!(e instanceof Si && e.isCount() || Number.isInteger(e) && 0 <= e))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let n = -1;
    e instanceof Si || (n = e), super(n, r), this.length = e;
  }
  /** @override */
  getSpan(e, r) {
    let n = this.span;
    return 0 > n && (n = this.length.decode(e, r)), n;
  }
  /** @override */
  decode(e, r = 0) {
    let n = this.span;
    return 0 > n && (n = this.length.decode(e, r)), Sr(e).slice(r, r + n);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, r, n) {
    let i = this.length;
    if (this.length instanceof Si && (i = e.length), !(e instanceof Uint8Array && i === e.length))
      throw new TypeError(X2("Blob.encode", this) + " requires (length " + i + ") Uint8Array as src");
    if (n + i > r.length)
      throw new RangeError("encoding overruns Uint8Array");
    const s = Sr(e);
    return Sr(r).write(s.toString("hex"), n, i, "hex"), this.length instanceof Si && this.length.encode(i, r, n), i;
  }
};
_e.Blob = F5;
let j5 = class extends Ur {
  constructor(e) {
    super(-1, e);
  }
  /** @override */
  getSpan(e, r = 0) {
    yf(e);
    let n = r;
    for (; n < e.length && e[n] !== 0; )
      n += 1;
    return 1 + n - r;
  }
  /** @override */
  decode(e, r = 0) {
    const n = this.getSpan(e, r);
    return Sr(e).slice(r, r + n - 1).toString("utf-8");
  }
  /** @override */
  encode(e, r, n = 0) {
    typeof e != "string" && (e = String(e));
    const i = Q2.Buffer.from(e, "utf8"), s = i.length;
    if (n + s > r.length)
      throw new RangeError("encoding overruns Buffer");
    const a = Sr(r);
    return i.copy(a, n), a[n + s] = 0, s + 1;
  }
};
_e.CString = j5;
let $5 = class extends Ur {
  constructor(e, r) {
    if (typeof e == "string" && r === void 0 && (r = e, e = void 0), e === void 0)
      e = -1;
    else if (!Number.isInteger(e))
      throw new TypeError("maxSpan must be an integer");
    super(-1, r), this.maxSpan = e;
  }
  /** @override */
  getSpan(e, r = 0) {
    return yf(e), e.length - r;
  }
  /** @override */
  decode(e, r = 0) {
    const n = this.getSpan(e, r);
    if (0 <= this.maxSpan && this.maxSpan < n)
      throw new RangeError("text length exceeds maxSpan");
    return Sr(e).slice(r, r + n).toString("utf-8");
  }
  /** @override */
  encode(e, r, n = 0) {
    typeof e != "string" && (e = String(e));
    const i = Q2.Buffer.from(e, "utf8"), s = i.length;
    if (0 <= this.maxSpan && this.maxSpan < s)
      throw new RangeError("text length exceeds maxSpan");
    if (n + s > r.length)
      throw new RangeError("encoding overruns Buffer");
    return i.copy(Sr(r), n), s;
  }
};
_e.UTF8 = $5;
let q5 = class extends Ur {
  constructor(e, r) {
    super(0, r), this.value = e;
  }
  /** @override */
  decode(e, r) {
    return this.value;
  }
  /** @override */
  encode(e, r, n) {
    return 0;
  }
};
_e.Constant = q5;
_e.greedy = (t, e) => new I5(t, e);
var Ii = _e.offset = (t, e, r) => new ew(t, e, r), st = _e.u8 = (t) => new ss(1, t), rn = _e.u16 = (t) => new ss(2, t);
_e.u24 = (t) => new ss(3, t);
var Be = _e.u32 = (t) => new ss(4, t);
_e.u40 = (t) => new ss(5, t);
_e.u48 = (t) => new ss(6, t);
var gr = _e.nu64 = (t) => new T5(t);
_e.u16be = (t) => new Es(2, t);
_e.u24be = (t) => new Es(3, t);
_e.u32be = (t) => new Es(4, t);
_e.u40be = (t) => new Es(5, t);
_e.u48be = (t) => new Es(6, t);
_e.nu64be = (t) => new k5(t);
_e.s8 = (t) => new Fc(1, t);
_e.s16 = (t) => new Fc(2, t);
_e.s24 = (t) => new Fc(3, t);
_e.s32 = (t) => new Fc(4, t);
_e.s40 = (t) => new Fc(5, t);
_e.s48 = (t) => new Fc(6, t);
var Gr = _e.ns64 = (t) => new R5(t);
_e.s16be = (t) => new bf(2, t);
_e.s24be = (t) => new bf(3, t);
_e.s32be = (t) => new bf(4, t);
_e.s40be = (t) => new bf(5, t);
_e.s48be = (t) => new bf(6, t);
_e.ns64be = (t) => new P5(t);
_e.f32 = (t) => new O5(t);
_e.f32be = (t) => new B5(t);
_e.f64 = (t) => new M5(t);
_e.f64be = (t) => new C5(t);
var Re = _e.struct = (t, e, r) => new U5(t, e, r);
_e.bits = (t, e, r) => new nw(t, e, r);
var Ir = _e.seq = (t, e, r) => new N5(t, e, r);
_e.union = (t, e, r) => new rw(t, e, r);
_e.unionLayoutDiscriminator = (t, e) => new mp(t, e);
var xt = _e.blob = (t, e) => new F5(t, e);
_e.cstr = (t) => new j5(t);
_e.utf8 = (t, e) => new $5(t, e);
_e.constant = (t, e) => new q5(t, e);
var dh = {}, tg, T6;
function NN() {
  if (T6)
    return tg;
  T6 = 1;
  var t, e, r = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, n;
  function i(h) {
    throw {
      name: "SyntaxError",
      message: h,
      at: t,
      text: n
    };
  }
  function s(h) {
    return h && h !== e && i("Expected '" + h + "' instead of '" + e + "'"), e = n.charAt(t), t += 1, e;
  }
  function a() {
    var h, y = "";
    for (e === "-" && (y = "-", s("-")); e >= "0" && e <= "9"; )
      y += e, s();
    if (e === ".")
      for (y += "."; s() && e >= "0" && e <= "9"; )
        y += e;
    if (e === "e" || e === "E")
      for (y += e, s(), (e === "-" || e === "+") && (y += e, s()); e >= "0" && e <= "9"; )
        y += e, s();
    return h = Number(y), isFinite(h) || i("Bad number"), h;
  }
  function o() {
    var h, y, p = "", b;
    if (e === '"')
      for (; s(); ) {
        if (e === '"')
          return s(), p;
        if (e === "\\")
          if (s(), e === "u") {
            for (b = 0, y = 0; y < 4 && (h = parseInt(s(), 16), !!isFinite(h)); y += 1)
              b = b * 16 + h;
            p += String.fromCharCode(b);
          } else if (typeof r[e] == "string")
            p += r[e];
          else
            break;
        else
          p += e;
      }
    i("Bad string");
  }
  function c() {
    for (; e && e <= " "; )
      s();
  }
  function f() {
    switch (e) {
      case "t":
        return s("t"), s("r"), s("u"), s("e"), !0;
      case "f":
        return s("f"), s("a"), s("l"), s("s"), s("e"), !1;
      case "n":
        return s("n"), s("u"), s("l"), s("l"), null;
      default:
        i("Unexpected '" + e + "'");
    }
  }
  function u() {
    var h = [];
    if (e === "[") {
      if (s("["), c(), e === "]")
        return s("]"), h;
      for (; e; ) {
        if (h.push(l()), c(), e === "]")
          return s("]"), h;
        s(","), c();
      }
    }
    i("Bad array");
  }
  function d() {
    var h, y = {};
    if (e === "{") {
      if (s("{"), c(), e === "}")
        return s("}"), y;
      for (; e; ) {
        if (h = o(), c(), s(":"), Object.prototype.hasOwnProperty.call(y, h) && i('Duplicate key "' + h + '"'), y[h] = l(), c(), e === "}")
          return s("}"), y;
        s(","), c();
      }
    }
    i("Bad object");
  }
  function l() {
    switch (c(), e) {
      case "{":
        return d();
      case "[":
        return u();
      case '"':
        return o();
      case "-":
        return a();
      default:
        return e >= "0" && e <= "9" ? a() : f();
    }
  }
  return tg = function(h, y) {
    var p;
    return n = h, t = 0, e = " ", p = l(), c(), e && i("Syntax error"), typeof y == "function" ? function b(v, x) {
      var I, L, P = v[x];
      if (P && typeof P == "object")
        for (I in l)
          Object.prototype.hasOwnProperty.call(P, I) && (L = b(P, I), typeof L > "u" ? delete P[I] : P[I] = L);
      return y.call(v, x, P);
    }({ "": p }, "") : p;
  }, tg;
}
var rg, k6;
function UN() {
  if (k6)
    return rg;
  k6 = 1;
  var t = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, e, r, n = {
    // table of character substitutions
    "\b": "\\b",
    "	": "\\t",
    "\n": "\\n",
    "\f": "\\f",
    "\r": "\\r",
    '"': '\\"',
    "\\": "\\\\"
  }, i;
  function s(o) {
    return t.lastIndex = 0, t.test(o) ? '"' + o.replace(t, function(c) {
      var f = n[c];
      return typeof f == "string" ? f : "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4);
    }) + '"' : '"' + o + '"';
  }
  function a(o, c) {
    var f, u, d, l, h = e, y, p = c[o];
    switch (p && typeof p == "object" && typeof p.toJSON == "function" && (p = p.toJSON(o)), typeof i == "function" && (p = i.call(c, o, p)), typeof p) {
      case "string":
        return s(p);
      case "number":
        return isFinite(p) ? String(p) : "null";
      case "boolean":
      case "null":
        return String(p);
      case "object":
        if (!p)
          return "null";
        if (e += r, y = [], Object.prototype.toString.apply(p) === "[object Array]") {
          for (l = p.length, f = 0; f < l; f += 1)
            y[f] = a(f, p) || "null";
          return d = y.length === 0 ? "[]" : e ? `[
` + e + y.join(`,
` + e) + `
` + h + "]" : "[" + y.join(",") + "]", e = h, d;
        }
        if (i && typeof i == "object")
          for (l = i.length, f = 0; f < l; f += 1)
            u = i[f], typeof u == "string" && (d = a(u, p), d && y.push(s(u) + (e ? ": " : ":") + d));
        else
          for (u in p)
            Object.prototype.hasOwnProperty.call(p, u) && (d = a(u, p), d && y.push(s(u) + (e ? ": " : ":") + d));
        return d = y.length === 0 ? "{}" : e ? `{
` + e + y.join(`,
` + e) + `
` + h + "}" : "{" + y.join(",") + "}", e = h, d;
    }
  }
  return rg = function(o, c, f) {
    var u;
    if (e = "", r = "", typeof f == "number")
      for (u = 0; u < f; u += 1)
        r += " ";
    else
      typeof f == "string" && (r = f);
    if (i = c, c && typeof c != "function" && (typeof c != "object" || typeof c.length != "number"))
      throw new Error("JSON.stringify");
    return a("", { "": o });
  }, rg;
}
var R6;
function LN() {
  return R6 || (R6 = 1, dh.parse = NN(), dh.stringify = UN()), dh;
}
typeof JSON < "u" || LN();
class DN extends TypeError {
  constructor(e, r) {
    let n;
    const {
      message: i,
      ...s
    } = e, {
      path: a
    } = e, o = a.length === 0 ? i : "At path: " + a.join(".") + " -- " + i;
    super(o), Object.assign(this, s), this.name = this.constructor.name, this.failures = () => {
      var c;
      return (c = n) != null ? c : n = [e, ...r()];
    };
  }
}
function FN(t) {
  return fo(t) && typeof t[Symbol.iterator] == "function";
}
function fo(t) {
  return typeof t == "object" && t != null;
}
function As(t) {
  return typeof t == "string" ? JSON.stringify(t) : "" + t;
}
function jN(t) {
  const {
    done: e,
    value: r
  } = t.next();
  return e ? void 0 : r;
}
function $N(t, e, r, n) {
  if (t === !0)
    return;
  t === !1 ? t = {} : typeof t == "string" && (t = {
    message: t
  });
  const {
    path: i,
    branch: s
  } = e, {
    type: a
  } = r, {
    refinement: o,
    message: c = "Expected a value of type `" + a + "`" + (o ? " with refinement `" + o + "`" : "") + ", but received: `" + As(n) + "`"
  } = t;
  return {
    value: n,
    type: a,
    refinement: o,
    key: i[i.length - 1],
    path: i,
    branch: s,
    ...t,
    message: c
  };
}
function* P6(t, e, r, n) {
  FN(t) || (t = [t]);
  for (const i of t) {
    const s = $N(i, e, r, n);
    s && (yield s);
  }
}
function* sw(t, e, r = {}) {
  const {
    path: n = [],
    branch: i = [t],
    coerce: s = !1,
    mask: a = !1
  } = r, o = {
    path: n,
    branch: i
  };
  if (s && (t = e.coercer(t, o), a && e.type !== "type" && fo(e.schema) && fo(t) && !Array.isArray(t)))
    for (const f in t)
      e.schema[f] === void 0 && delete t[f];
  let c = !0;
  for (const f of e.validator(t, o))
    c = !1, yield [f, void 0];
  for (let [f, u, d] of e.entries(t, o)) {
    const l = sw(u, d, {
      path: f === void 0 ? n : [...n, f],
      branch: f === void 0 ? i : [...i, u],
      coerce: s,
      mask: a
    });
    for (const h of l)
      h[0] ? (c = !1, yield [h[0], void 0]) : s && (u = h[1], f === void 0 ? t = u : t instanceof Map ? t.set(f, u) : t instanceof Set ? t.add(u) : fo(t) && (t[f] = u));
  }
  if (c)
    for (const f of e.refiner(t, o))
      c = !1, yield [f, void 0];
  c && (yield [void 0, t]);
}
let sa = class {
  constructor(e) {
    const {
      type: r,
      schema: n,
      validator: i,
      refiner: s,
      coercer: a = (c) => c,
      entries: o = function* () {
      }
    } = e;
    this.type = r, this.schema = n, this.entries = o, this.coercer = a, i ? this.validator = (c, f) => {
      const u = i(c, f);
      return P6(u, f, this, c);
    } : this.validator = () => [], s ? this.refiner = (c, f) => {
      const u = s(c, f);
      return P6(u, f, this, c);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(e) {
    return W5(e, this);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(e) {
    return He(e, this);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(e) {
    return z5(e, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(e) {
    return qN(e, this);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(e, r = {}) {
    return Tl(e, this, r);
  }
};
function W5(t, e) {
  const r = Tl(t, e);
  if (r[0])
    throw r[0];
}
function He(t, e) {
  const r = Tl(t, e, {
    coerce: !0
  });
  if (r[0])
    throw r[0];
  return r[1];
}
function qN(t, e) {
  const r = Tl(t, e, {
    coerce: !0,
    mask: !0
  });
  if (r[0])
    throw r[0];
  return r[1];
}
function z5(t, e) {
  return !Tl(t, e)[0];
}
function Tl(t, e, r = {}) {
  const n = sw(t, e, r), i = jN(n);
  return i[0] ? [new DN(i[0], function* () {
    for (const a of n)
      a[0] && (yield a[0]);
  }), void 0] : [void 0, i[1]];
}
function jc(t, e) {
  return new sa({
    type: t,
    schema: null,
    validator: e
  });
}
function K5() {
  return jc("any", () => !0);
}
function Te(t) {
  return new sa({
    type: "array",
    schema: t,
    *entries(e) {
      if (t && Array.isArray(e))
        for (const [r, n] of e.entries())
          yield [r, n, t];
    },
    coercer(e) {
      return Array.isArray(e) ? e.slice() : e;
    },
    validator(e) {
      return Array.isArray(e) || "Expected an array value, but received: " + As(e);
    }
  });
}
function Tn() {
  return jc("boolean", (t) => typeof t == "boolean");
}
function gf(t) {
  return jc("instance", (e) => e instanceof t || "Expected a `" + t.name + "` instance, but received: " + As(e));
}
function Pt(t) {
  const e = As(t), r = typeof t;
  return new sa({
    type: "literal",
    schema: r === "string" || r === "number" || r === "boolean" ? t : null,
    validator(n) {
      return n === t || "Expected the literal `" + e + "`, but received: " + As(n);
    }
  });
}
function WN() {
  return jc("never", () => !1);
}
function Pe(t) {
  return new sa({
    ...t,
    validator: (e, r) => e === null || t.validator(e, r),
    refiner: (e, r) => e === null || t.refiner(e, r)
  });
}
function ae() {
  return jc("number", (t) => typeof t == "number" && !isNaN(t) || "Expected a number, but received: " + As(t));
}
function We(t) {
  return new sa({
    ...t,
    validator: (e, r) => e === void 0 || t.validator(e, r),
    refiner: (e, r) => e === void 0 || t.refiner(e, r)
  });
}
function q0(t, e) {
  return new sa({
    type: "record",
    schema: null,
    *entries(r) {
      if (fo(r))
        for (const n in r) {
          const i = r[n];
          yield [n, n, t], yield [n, i, e];
        }
    },
    validator(r) {
      return fo(r) || "Expected an object, but received: " + As(r);
    }
  });
}
function we() {
  return jc("string", (t) => typeof t == "string" || "Expected a string, but received: " + As(t));
}
function mf(t) {
  const e = WN();
  return new sa({
    type: "tuple",
    schema: null,
    *entries(r) {
      if (Array.isArray(r)) {
        const n = Math.max(t.length, r.length);
        for (let i = 0; i < n; i++)
          yield [i, r[i], t[i] || e];
      }
    },
    validator(r) {
      return Array.isArray(r) || "Expected an array, but received: " + As(r);
    }
  });
}
function ye(t) {
  const e = Object.keys(t);
  return new sa({
    type: "type",
    schema: t,
    *entries(r) {
      if (fo(r))
        for (const n of e)
          yield [n, r[n], t[n]];
    },
    validator(r) {
      return fo(r) || "Expected an object, but received: " + As(r);
    }
  });
}
function jr(t) {
  const e = t.map((r) => r.type).join(" | ");
  return new sa({
    type: "union",
    schema: null,
    validator(r, n) {
      const i = [];
      for (const s of t) {
        const [...a] = sw(r, s, n), [o] = a;
        if (o[0])
          for (const [c] of a)
            c && i.push(c);
        else
          return [];
      }
      return ["Expected the value to satisfy a union of `" + e + "`, but received: " + As(r), ...i];
    }
  });
}
function aa() {
  return jc("unknown", () => !0);
}
function oa(t, e, r) {
  return new sa({
    ...t,
    coercer: (n, i) => z5(n, e) ? t.coercer(r(n, i), i) : t.coercer(n, i)
  });
}
var aw = {}, ow = {};
const W0 = /* @__PURE__ */ ta(CP);
Object.defineProperty(ow, "__esModule", {
  value: !0
});
ow.default = VN;
var zN = W0;
class KN extends zN.EventEmitter {
  /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */
  constructor(e, r, n) {
    super(), this.socket = new window.WebSocket(e, n), this.socket.onopen = () => this.emit("open"), this.socket.onmessage = (i) => this.emit("message", i.data), this.socket.onerror = (i) => this.emit("error", i), this.socket.onclose = (i) => {
      this.emit("close", i.code, i.reason);
    };
  }
  /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */
  send(e, r, n) {
    const i = n || r;
    try {
      this.socket.send(e), i();
    } catch (s) {
      i(s);
    }
  }
  /**
   * Closes an underlying socket
   * @method
   * @param {Number} code - status code explaining why the connection is being closed
   * @param {String} reason - a description why the connection is closing
   * @return {Undefined}
   * @throws {Error}
   */
  close(e, r) {
    this.socket.close(e, r);
  }
  addEventListener(e, r, n) {
    this.socket.addEventListener(e, r, n);
  }
}
function VN(t, e) {
  return new KN(t, e);
}
var z0 = {};
Object.defineProperty(z0, "__esModule", {
  value: !0
});
z0.default = void 0;
var HN = W0;
class GN extends HN.EventEmitter {
  /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @return {CommonClient}
   */
  constructor(e, r = "ws://localhost:8080", {
    autoconnect: n = !0,
    reconnect: i = !0,
    reconnect_interval: s = 1e3,
    max_reconnects: a = 5,
    ...o
  } = {}, c) {
    super(), this.webSocketFactory = e, this.queue = /* @__PURE__ */ new Map(), this.rpc_id = 0, this.address = r, this.autoconnect = n, this.ready = !1, this.reconnect = i, this.reconnect_interval = s, this.max_reconnects = a, this.rest_options = o, this.current_reconnects = 0, this.generate_request_id = c || (() => ++this.rpc_id), this.autoconnect && this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */
  connect() {
    this.socket || this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Calls a registered RPC method on server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object|Array} params - optional method parameters
   * @param {Number} timeout - RPC reply timeout value
   * @param {Object} ws_opts - options passed to ws
   * @return {Promise}
   */
  call(e, r, n, i) {
    return !i && typeof n == "object" && (i = n, n = null), new Promise((s, a) => {
      if (!this.ready)
        return a(new Error("socket not ready"));
      const o = this.generate_request_id(e, r), c = {
        jsonrpc: "2.0",
        method: e,
        params: r || null,
        id: o
      };
      this.socket.send(JSON.stringify(c), i, (f) => {
        if (f)
          return a(f);
        this.queue.set(o, {
          promise: [s, a]
        }), n && (this.queue.get(o).timeout = setTimeout(() => {
          this.queue.delete(o), a(new Error("reply timeout"));
        }, n));
      });
    });
  }
  /**
   * Logins with the other side of the connection.
   * @method
   * @param {Object} params - Login credentials object
   * @return {Promise}
   */
  async login(e) {
    const r = await this.call("rpc.login", e);
    if (!r)
      throw new Error("authentication failed");
    return r;
  }
  /**
   * Fetches a list of client's methods registered on server.
   * @method
   * @return {Array}
   */
  async listMethods() {
    return await this.call("__listMethods");
  }
  /**
   * Sends a JSON-RPC 2.0 notification to server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object} params - optional method parameters
   * @return {Promise}
   */
  notify(e, r) {
    return new Promise((n, i) => {
      if (!this.ready)
        return i(new Error("socket not ready"));
      const s = {
        jsonrpc: "2.0",
        method: e,
        params: r || null
      };
      this.socket.send(JSON.stringify(s), (a) => {
        if (a)
          return i(a);
        n();
      });
    });
  }
  /**
   * Subscribes for a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async subscribe(e) {
    typeof e == "string" && (e = [e]);
    const r = await this.call("rpc.on", e);
    if (typeof e == "string" && r[e] !== "ok")
      throw new Error("Failed subscribing to an event '" + e + "' with: " + r[e]);
    return r;
  }
  /**
   * Unsubscribes from a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async unsubscribe(e) {
    typeof e == "string" && (e = [e]);
    const r = await this.call("rpc.off", e);
    if (typeof e == "string" && r[e] !== "ok")
      throw new Error("Failed unsubscribing from an event with: " + r);
    return r;
  }
  /**
   * Closes a WebSocket connection gracefully.
   * @method
   * @param {Number} code - socket close code
   * @param {String} data - optional data to be sent before closing
   * @return {Undefined}
   */
  close(e, r) {
    this.socket.close(e || 1e3, r);
  }
  /**
   * Connection/Message handler.
   * @method
   * @private
   * @param {String} address - WebSocket API address
   * @param {Object} options - ws options object
   * @return {Undefined}
   */
  _connect(e, r) {
    this.socket = this.webSocketFactory(e, r), this.socket.addEventListener("open", () => {
      this.ready = !0, this.emit("open"), this.current_reconnects = 0;
    }), this.socket.addEventListener("message", ({
      data: n
    }) => {
      n instanceof ArrayBuffer && (n = ve.from(n).toString());
      try {
        n = JSON.parse(n);
      } catch {
        return;
      }
      if (n.notification && this.listeners(n.notification).length) {
        if (!Object.keys(n.params).length)
          return this.emit(n.notification);
        const i = [n.notification];
        if (n.params.constructor === Object)
          i.push(n.params);
        else
          for (let s = 0; s < n.params.length; s++)
            i.push(n.params[s]);
        return Promise.resolve().then(() => {
          this.emit.apply(this, i);
        });
      }
      if (!this.queue.has(n.id))
        return n.method && n.params ? Promise.resolve().then(() => {
          this.emit(n.method, n.params);
        }) : void 0;
      "error" in n == "result" in n && this.queue.get(n.id).promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.')), this.queue.get(n.id).timeout && clearTimeout(this.queue.get(n.id).timeout), n.error ? this.queue.get(n.id).promise[1](n.error) : this.queue.get(n.id).promise[0](n.result), this.queue.delete(n.id);
    }), this.socket.addEventListener("error", (n) => this.emit("error", n)), this.socket.addEventListener("close", ({
      code: n,
      reason: i
    }) => {
      this.ready && setTimeout(() => this.emit("close", n, i), 0), this.ready = !1, this.socket = void 0, n !== 1e3 && (this.current_reconnects++, this.reconnect && (this.max_reconnects > this.current_reconnects || this.max_reconnects === 0) && setTimeout(() => this._connect(e, r), this.reconnect_interval));
    });
  }
}
z0.default = GN;
Object.defineProperty(aw, "__esModule", {
  value: !0
});
aw.Client = void 0;
var ZN = V5(ow), JN = V5(z0);
function V5(t) {
  return t && t.__esModule ? t : { default: t };
}
class YN extends JN.default {
  constructor(e = "ws://localhost:8080", {
    autoconnect: r = !0,
    reconnect: n = !0,
    reconnect_interval: i = 1e3,
    max_reconnects: s = 5
  } = {}, a) {
    super(ZN.default, e, {
      autoconnect: r,
      reconnect: n,
      reconnect_interval: i,
      max_reconnects: s
    }, a);
  }
}
aw.Client = YN;
var lh, QN = new Uint8Array(16);
function H5() {
  if (!lh && (lh = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !lh))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return lh(QN);
}
const XN = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function K0(t) {
  return typeof t == "string" && XN.test(t);
}
var Fn = [];
for (var ng = 0; ng < 256; ++ng)
  Fn.push((ng + 256).toString(16).substr(1));
function V0(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Fn[t[e + 0]] + Fn[t[e + 1]] + Fn[t[e + 2]] + Fn[t[e + 3]] + "-" + Fn[t[e + 4]] + Fn[t[e + 5]] + "-" + Fn[t[e + 6]] + Fn[t[e + 7]] + "-" + Fn[t[e + 8]] + Fn[t[e + 9]] + "-" + Fn[t[e + 10]] + Fn[t[e + 11]] + Fn[t[e + 12]] + Fn[t[e + 13]] + Fn[t[e + 14]] + Fn[t[e + 15]]).toLowerCase();
  if (!K0(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
var O6, ig, sg = 0, ag = 0;
function eU(t, e, r) {
  var n = e && r || 0, i = e || new Array(16);
  t = t || {};
  var s = t.node || O6, a = t.clockseq !== void 0 ? t.clockseq : ig;
  if (s == null || a == null) {
    var o = t.random || (t.rng || H5)();
    s == null && (s = O6 = [o[0] | 1, o[1], o[2], o[3], o[4], o[5]]), a == null && (a = ig = (o[6] << 8 | o[7]) & 16383);
  }
  var c = t.msecs !== void 0 ? t.msecs : Date.now(), f = t.nsecs !== void 0 ? t.nsecs : ag + 1, u = c - sg + (f - ag) / 1e4;
  if (u < 0 && t.clockseq === void 0 && (a = a + 1 & 16383), (u < 0 || c > sg) && t.nsecs === void 0 && (f = 0), f >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  sg = c, ag = f, ig = a, c += 122192928e5;
  var d = ((c & 268435455) * 1e4 + f) % 4294967296;
  i[n++] = d >>> 24 & 255, i[n++] = d >>> 16 & 255, i[n++] = d >>> 8 & 255, i[n++] = d & 255;
  var l = c / 4294967296 * 1e4 & 268435455;
  i[n++] = l >>> 8 & 255, i[n++] = l & 255, i[n++] = l >>> 24 & 15 | 16, i[n++] = l >>> 16 & 255, i[n++] = a >>> 8 | 128, i[n++] = a & 255;
  for (var h = 0; h < 6; ++h)
    i[n + h] = s[h];
  return e || V0(i);
}
function G5(t) {
  if (!K0(t))
    throw TypeError("Invalid UUID");
  var e, r = new Uint8Array(16);
  return r[0] = (e = parseInt(t.slice(0, 8), 16)) >>> 24, r[1] = e >>> 16 & 255, r[2] = e >>> 8 & 255, r[3] = e & 255, r[4] = (e = parseInt(t.slice(9, 13), 16)) >>> 8, r[5] = e & 255, r[6] = (e = parseInt(t.slice(14, 18), 16)) >>> 8, r[7] = e & 255, r[8] = (e = parseInt(t.slice(19, 23), 16)) >>> 8, r[9] = e & 255, r[10] = (e = parseInt(t.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = e / 4294967296 & 255, r[12] = e >>> 24 & 255, r[13] = e >>> 16 & 255, r[14] = e >>> 8 & 255, r[15] = e & 255, r;
}
function tU(t) {
  t = unescape(encodeURIComponent(t));
  for (var e = [], r = 0; r < t.length; ++r)
    e.push(t.charCodeAt(r));
  return e;
}
var rU = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", nU = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function Z5(t, e, r) {
  function n(i, s, a, o) {
    if (typeof i == "string" && (i = tU(i)), typeof s == "string" && (s = G5(s)), s.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var c = new Uint8Array(16 + i.length);
    if (c.set(s), c.set(i, s.length), c = r(c), c[6] = c[6] & 15 | e, c[8] = c[8] & 63 | 128, a) {
      o = o || 0;
      for (var f = 0; f < 16; ++f)
        a[o + f] = c[f];
      return a;
    }
    return V0(c);
  }
  try {
    n.name = t;
  } catch {
  }
  return n.DNS = rU, n.URL = nU, n;
}
function iU(t) {
  if (typeof t == "string") {
    var e = unescape(encodeURIComponent(t));
    t = new Uint8Array(e.length);
    for (var r = 0; r < e.length; ++r)
      t[r] = e.charCodeAt(r);
  }
  return sU(aU(oU(t), t.length * 8));
}
function sU(t) {
  for (var e = [], r = t.length * 32, n = "0123456789abcdef", i = 0; i < r; i += 8) {
    var s = t[i >> 5] >>> i % 32 & 255, a = parseInt(n.charAt(s >>> 4 & 15) + n.charAt(s & 15), 16);
    e.push(a);
  }
  return e;
}
function J5(t) {
  return (t + 64 >>> 9 << 4) + 14 + 1;
}
function aU(t, e) {
  t[e >> 5] |= 128 << e % 32, t[J5(e) - 1] = e;
  for (var r = 1732584193, n = -271733879, i = -1732584194, s = 271733878, a = 0; a < t.length; a += 16) {
    var o = r, c = n, f = i, u = s;
    r = ei(r, n, i, s, t[a], 7, -680876936), s = ei(s, r, n, i, t[a + 1], 12, -389564586), i = ei(i, s, r, n, t[a + 2], 17, 606105819), n = ei(n, i, s, r, t[a + 3], 22, -1044525330), r = ei(r, n, i, s, t[a + 4], 7, -176418897), s = ei(s, r, n, i, t[a + 5], 12, 1200080426), i = ei(i, s, r, n, t[a + 6], 17, -1473231341), n = ei(n, i, s, r, t[a + 7], 22, -45705983), r = ei(r, n, i, s, t[a + 8], 7, 1770035416), s = ei(s, r, n, i, t[a + 9], 12, -1958414417), i = ei(i, s, r, n, t[a + 10], 17, -42063), n = ei(n, i, s, r, t[a + 11], 22, -1990404162), r = ei(r, n, i, s, t[a + 12], 7, 1804603682), s = ei(s, r, n, i, t[a + 13], 12, -40341101), i = ei(i, s, r, n, t[a + 14], 17, -1502002290), n = ei(n, i, s, r, t[a + 15], 22, 1236535329), r = ti(r, n, i, s, t[a + 1], 5, -165796510), s = ti(s, r, n, i, t[a + 6], 9, -1069501632), i = ti(i, s, r, n, t[a + 11], 14, 643717713), n = ti(n, i, s, r, t[a], 20, -373897302), r = ti(r, n, i, s, t[a + 5], 5, -701558691), s = ti(s, r, n, i, t[a + 10], 9, 38016083), i = ti(i, s, r, n, t[a + 15], 14, -660478335), n = ti(n, i, s, r, t[a + 4], 20, -405537848), r = ti(r, n, i, s, t[a + 9], 5, 568446438), s = ti(s, r, n, i, t[a + 14], 9, -1019803690), i = ti(i, s, r, n, t[a + 3], 14, -187363961), n = ti(n, i, s, r, t[a + 8], 20, 1163531501), r = ti(r, n, i, s, t[a + 13], 5, -1444681467), s = ti(s, r, n, i, t[a + 2], 9, -51403784), i = ti(i, s, r, n, t[a + 7], 14, 1735328473), n = ti(n, i, s, r, t[a + 12], 20, -1926607734), r = ri(r, n, i, s, t[a + 5], 4, -378558), s = ri(s, r, n, i, t[a + 8], 11, -2022574463), i = ri(i, s, r, n, t[a + 11], 16, 1839030562), n = ri(n, i, s, r, t[a + 14], 23, -35309556), r = ri(r, n, i, s, t[a + 1], 4, -1530992060), s = ri(s, r, n, i, t[a + 4], 11, 1272893353), i = ri(i, s, r, n, t[a + 7], 16, -155497632), n = ri(n, i, s, r, t[a + 10], 23, -1094730640), r = ri(r, n, i, s, t[a + 13], 4, 681279174), s = ri(s, r, n, i, t[a], 11, -358537222), i = ri(i, s, r, n, t[a + 3], 16, -722521979), n = ri(n, i, s, r, t[a + 6], 23, 76029189), r = ri(r, n, i, s, t[a + 9], 4, -640364487), s = ri(s, r, n, i, t[a + 12], 11, -421815835), i = ri(i, s, r, n, t[a + 15], 16, 530742520), n = ri(n, i, s, r, t[a + 2], 23, -995338651), r = ni(r, n, i, s, t[a], 6, -198630844), s = ni(s, r, n, i, t[a + 7], 10, 1126891415), i = ni(i, s, r, n, t[a + 14], 15, -1416354905), n = ni(n, i, s, r, t[a + 5], 21, -57434055), r = ni(r, n, i, s, t[a + 12], 6, 1700485571), s = ni(s, r, n, i, t[a + 3], 10, -1894986606), i = ni(i, s, r, n, t[a + 10], 15, -1051523), n = ni(n, i, s, r, t[a + 1], 21, -2054922799), r = ni(r, n, i, s, t[a + 8], 6, 1873313359), s = ni(s, r, n, i, t[a + 15], 10, -30611744), i = ni(i, s, r, n, t[a + 6], 15, -1560198380), n = ni(n, i, s, r, t[a + 13], 21, 1309151649), r = ni(r, n, i, s, t[a + 4], 6, -145523070), s = ni(s, r, n, i, t[a + 11], 10, -1120210379), i = ni(i, s, r, n, t[a + 2], 15, 718787259), n = ni(n, i, s, r, t[a + 9], 21, -343485551), r = so(r, o), n = so(n, c), i = so(i, f), s = so(s, u);
  }
  return [r, n, i, s];
}
function oU(t) {
  if (t.length === 0)
    return [];
  for (var e = t.length * 8, r = new Uint32Array(J5(e)), n = 0; n < e; n += 8)
    r[n >> 5] |= (t[n / 8] & 255) << n % 32;
  return r;
}
function so(t, e) {
  var r = (t & 65535) + (e & 65535), n = (t >> 16) + (e >> 16) + (r >> 16);
  return n << 16 | r & 65535;
}
function cU(t, e) {
  return t << e | t >>> 32 - e;
}
function H0(t, e, r, n, i, s) {
  return so(cU(so(so(e, t), so(n, s)), i), r);
}
function ei(t, e, r, n, i, s, a) {
  return H0(e & r | ~e & n, t, e, i, s, a);
}
function ti(t, e, r, n, i, s, a) {
  return H0(e & n | r & ~n, t, e, i, s, a);
}
function ri(t, e, r, n, i, s, a) {
  return H0(e ^ r ^ n, t, e, i, s, a);
}
function ni(t, e, r, n, i, s, a) {
  return H0(r ^ (e | ~n), t, e, i, s, a);
}
var uU = Z5("v3", 48, iU);
const fU = uU;
function dU(t, e, r) {
  t = t || {};
  var n = t.random || (t.rng || H5)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    r = r || 0;
    for (var i = 0; i < 16; ++i)
      e[r + i] = n[i];
    return e;
  }
  return V0(n);
}
function lU(t, e, r, n) {
  switch (t) {
    case 0:
      return e & r ^ ~e & n;
    case 1:
      return e ^ r ^ n;
    case 2:
      return e & r ^ e & n ^ r & n;
    case 3:
      return e ^ r ^ n;
  }
}
function og(t, e) {
  return t << e | t >>> 32 - e;
}
function hU(t) {
  var e = [1518500249, 1859775393, 2400959708, 3395469782], r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof t == "string") {
    var n = unescape(encodeURIComponent(t));
    t = [];
    for (var i = 0; i < n.length; ++i)
      t.push(n.charCodeAt(i));
  } else
    Array.isArray(t) || (t = Array.prototype.slice.call(t));
  t.push(128);
  for (var s = t.length / 4 + 2, a = Math.ceil(s / 16), o = new Array(a), c = 0; c < a; ++c) {
    for (var f = new Uint32Array(16), u = 0; u < 16; ++u)
      f[u] = t[c * 64 + u * 4] << 24 | t[c * 64 + u * 4 + 1] << 16 | t[c * 64 + u * 4 + 2] << 8 | t[c * 64 + u * 4 + 3];
    o[c] = f;
  }
  o[a - 1][14] = (t.length - 1) * 8 / Math.pow(2, 32), o[a - 1][14] = Math.floor(o[a - 1][14]), o[a - 1][15] = (t.length - 1) * 8 & 4294967295;
  for (var d = 0; d < a; ++d) {
    for (var l = new Uint32Array(80), h = 0; h < 16; ++h)
      l[h] = o[d][h];
    for (var y = 16; y < 80; ++y)
      l[y] = og(l[y - 3] ^ l[y - 8] ^ l[y - 14] ^ l[y - 16], 1);
    for (var p = r[0], b = r[1], v = r[2], x = r[3], I = r[4], L = 0; L < 80; ++L) {
      var P = Math.floor(L / 20), C = og(p, 5) + lU(P, b, v, x) + I + e[P] + l[L] >>> 0;
      I = x, x = v, v = og(b, 30) >>> 0, b = p, p = C;
    }
    r[0] = r[0] + p >>> 0, r[1] = r[1] + b >>> 0, r[2] = r[2] + v >>> 0, r[3] = r[3] + x >>> 0, r[4] = r[4] + I >>> 0;
  }
  return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, r[0] & 255, r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, r[1] & 255, r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, r[2] & 255, r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, r[3] & 255, r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, r[4] & 255];
}
var pU = Z5("v5", 80, hU);
const yU = pU, bU = "00000000-0000-0000-0000-000000000000";
function gU(t) {
  if (!K0(t))
    throw TypeError("Invalid UUID");
  return parseInt(t.substr(14, 1), 16);
}
const mU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: bU,
  parse: G5,
  stringify: V0,
  v1: eU,
  v3: fU,
  v4: dU,
  v5: yU,
  validate: K0,
  version: gU
}, Symbol.toStringTag, { value: "Module" })), Y5 = /* @__PURE__ */ ta(mU), vU = Y5.v4, wU = function(t, e, r, n) {
  if (typeof t != "string")
    throw new TypeError(t + " must be a string");
  n = n || {};
  const i = typeof n.version == "number" ? n.version : 2;
  if (i !== 1 && i !== 2)
    throw new TypeError(i + " must be 1 or 2");
  const s = {
    method: t
  };
  if (i === 2 && (s.jsonrpc = "2.0"), e) {
    if (typeof e != "object" && !Array.isArray(e))
      throw new TypeError(e + " must be an object, array or omitted");
    s.params = e;
  }
  if (typeof r > "u") {
    const a = typeof n.generator == "function" ? n.generator : function() {
      return vU();
    };
    s.id = a(s, n);
  } else
    i === 2 && r === null ? n.notificationIdNull && (s.id = null) : s.id = r;
  return s;
};
var _U = wU;
const SU = Y5.v4, EU = _U, vp = function(t, e) {
  if (!(this instanceof vp))
    return new vp(t, e);
  e || (e = {}), this.options = {
    reviver: typeof e.reviver < "u" ? e.reviver : null,
    replacer: typeof e.replacer < "u" ? e.replacer : null,
    generator: typeof e.generator < "u" ? e.generator : function() {
      return SU();
    },
    version: typeof e.version < "u" ? e.version : 2,
    notificationIdNull: typeof e.notificationIdNull == "boolean" ? e.notificationIdNull : !1
  }, this.callServer = t;
};
vp.prototype.request = function(t, e, r, n) {
  const i = this;
  let s = null;
  const a = Array.isArray(t) && typeof e == "function";
  if (this.options.version === 1 && a)
    throw new TypeError("JSON-RPC 1.0 does not support batching");
  if (a || !a && t && typeof t == "object" && typeof e == "function")
    n = e, s = t;
  else {
    typeof r == "function" && (n = r, r = void 0);
    const f = typeof n == "function";
    try {
      s = EU(t, e, r, {
        generator: this.options.generator,
        version: this.options.version,
        notificationIdNull: this.options.notificationIdNull
      });
    } catch (u) {
      if (f)
        return n(u);
      throw u;
    }
    if (!f)
      return s;
  }
  let c;
  try {
    c = JSON.stringify(s, this.options.replacer);
  } catch (f) {
    return n(f);
  }
  return this.callServer(c, function(f, u) {
    i._parseResponse(f, u, n);
  }), s;
};
vp.prototype._parseResponse = function(t, e, r) {
  if (t) {
    r(t);
    return;
  }
  if (!e)
    return r();
  let n;
  try {
    n = JSON.parse(e, this.options.reviver);
  } catch (i) {
    return r(i);
  }
  if (r.length === 3)
    if (Array.isArray(n)) {
      const i = function(a) {
        return typeof a.error < "u";
      }, s = function(a) {
        return !i(a);
      };
      return r(null, n.filter(i), n.filter(s));
    } else
      return r(null, n.error, n.result);
  r(null, n);
};
(function() {
  var t = typeof window == "object" ? window : {}, e = !t.JS_SHA3_NO_NODE_JS && typeof ut == "object" && ut.versions && ut.versions.node;
  e && (t = Ne);
  var r = !t.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", n = "0123456789abcdef".split(""), i = [31, 7936, 2031616, 520093696], s = [4, 1024, 262144, 67108864], a = [1, 256, 65536, 16777216], o = [6, 1536, 393216, 100663296], c = [0, 8, 16, 24], f = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
  ], u = [224, 256, 384, 512], d = [128, 256], l = ["hex", "buffer", "arrayBuffer", "array"], h = {
    128: 168,
    256: 136
  };
  (t.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(_) {
    return Object.prototype.toString.call(_) === "[object Array]";
  });
  for (var y = function(_, R, N) {
    return function(O) {
      return new E(_, R, _).update(O)[N]();
    };
  }, p = function(_, R, N) {
    return function(O, g) {
      return new E(_, R, g).update(O)[N]();
    };
  }, b = function(_, R, N) {
    return function(O, g, M, Y) {
      return F["cshake" + _].update(O, g, M, Y)[N]();
    };
  }, v = function(_, R, N) {
    return function(O, g, M, Y) {
      return F["kmac" + _].update(O, g, M, Y)[N]();
    };
  }, x = function(_, R, N, O) {
    for (var g = 0; g < l.length; ++g) {
      var M = l[g];
      _[M] = R(N, O, M);
    }
    return _;
  }, I = function(_, R) {
    var N = y(_, R, "hex");
    return N.create = function() {
      return new E(_, R, _);
    }, N.update = function(O) {
      return N.create().update(O);
    }, x(N, y, _, R);
  }, L = function(_, R) {
    var N = p(_, R, "hex");
    return N.create = function(O) {
      return new E(_, R, O);
    }, N.update = function(O, g) {
      return N.create(g).update(O);
    }, x(N, p, _, R);
  }, P = function(_, R) {
    var N = h[_], O = b(_, R, "hex");
    return O.create = function(g, M, Y) {
      return !M && !Y ? F["shake" + _].create(g) : new E(_, R, g).bytepad([M, Y], N);
    }, O.update = function(g, M, Y, se) {
      return O.create(M, Y, se).update(g);
    }, x(O, b, _, R);
  }, C = function(_, R) {
    var N = h[_], O = v(_, R, "hex");
    return O.create = function(g, M, Y) {
      return new U(_, R, M).bytepad(["KMAC", Y], N).bytepad([g], N);
    }, O.update = function(g, M, Y, se) {
      return O.create(g, Y, se).update(M);
    }, x(O, v, _, R);
  }, D = [
    { name: "keccak", padding: a, bits: u, createMethod: I },
    { name: "sha3", padding: o, bits: u, createMethod: I },
    { name: "shake", padding: i, bits: d, createMethod: L },
    { name: "cshake", padding: s, bits: d, createMethod: P },
    { name: "kmac", padding: s, bits: d, createMethod: C }
  ], F = {}, G = 0; G < D.length; ++G)
    for (var re = D[G], ie = re.bits, ee = 0; ee < ie.length; ++ee) {
      var $ = re.name + "_" + ie[ee];
      if (F[$] = re.createMethod(ie[ee], re.padding), re.name !== "sha3") {
        var w = re.name + ie[ee];
        F[w] = F[$];
      }
    }
  function E(_, R, N) {
    this.blocks = [], this.s = [], this.padding = R, this.outputBits = N, this.reset = !0, this.block = 0, this.start = 0, this.blockCount = 1600 - (_ << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = N >> 5, this.extraBytes = (N & 31) >> 3;
    for (var O = 0; O < 50; ++O)
      this.s[O] = 0;
  }
  E.prototype.update = function(_) {
    var R = typeof _ != "string";
    R && _.constructor === t.ArrayBuffer && (_ = new Uint8Array(_));
    var N = _.length;
    if (R && (typeof N != "number" || !Array.isArray(_) && !(r && ArrayBuffer.isView(_))))
      throw "input is invalid type";
    for (var O = this.blocks, g = this.byteCount, M = this.blockCount, Y = 0, se = this.s, V, K; Y < N; ) {
      if (this.reset)
        for (this.reset = !1, O[0] = this.block, V = 1; V < M + 1; ++V)
          O[V] = 0;
      if (R)
        for (V = this.start; Y < N && V < g; ++Y)
          O[V >> 2] |= _[Y] << c[V++ & 3];
      else
        for (V = this.start; Y < N && V < g; ++Y)
          K = _.charCodeAt(Y), K < 128 ? O[V >> 2] |= K << c[V++ & 3] : K < 2048 ? (O[V >> 2] |= (192 | K >> 6) << c[V++ & 3], O[V >> 2] |= (128 | K & 63) << c[V++ & 3]) : K < 55296 || K >= 57344 ? (O[V >> 2] |= (224 | K >> 12) << c[V++ & 3], O[V >> 2] |= (128 | K >> 6 & 63) << c[V++ & 3], O[V >> 2] |= (128 | K & 63) << c[V++ & 3]) : (K = 65536 + ((K & 1023) << 10 | _.charCodeAt(++Y) & 1023), O[V >> 2] |= (240 | K >> 18) << c[V++ & 3], O[V >> 2] |= (128 | K >> 12 & 63) << c[V++ & 3], O[V >> 2] |= (128 | K >> 6 & 63) << c[V++ & 3], O[V >> 2] |= (128 | K & 63) << c[V++ & 3]);
      if (this.lastByteIndex = V, V >= g) {
        for (this.start = V - g, this.block = O[M], V = 0; V < M; ++V)
          se[V] ^= O[V];
        W(se), this.reset = !0;
      } else
        this.start = V;
    }
    return this;
  }, E.prototype.encode = function(_, R) {
    var N = _ & 255, O = 1, g = [N];
    for (_ = _ >> 8, N = _ & 255; N > 0; )
      g.unshift(N), _ = _ >> 8, N = _ & 255, ++O;
    return R ? g.push(O) : g.unshift(O), this.update(g), g.length;
  }, E.prototype.encodeString = function(_) {
    _ = _ || "";
    var R = typeof _ != "string";
    R && _.constructor === t.ArrayBuffer && (_ = new Uint8Array(_));
    var N = _.length;
    if (R && (typeof N != "number" || !Array.isArray(_) && !(r && ArrayBuffer.isView(_))))
      throw "input is invalid type";
    var O = 0;
    if (R)
      O = N;
    else
      for (var g = 0; g < _.length; ++g) {
        var M = _.charCodeAt(g);
        M < 128 ? O += 1 : M < 2048 ? O += 2 : M < 55296 || M >= 57344 ? O += 3 : (M = 65536 + ((M & 1023) << 10 | _.charCodeAt(++g) & 1023), O += 4);
      }
    return O += this.encode(O * 8), this.update(_), O;
  }, E.prototype.bytepad = function(_, R) {
    for (var N = this.encode(R), O = 0; O < _.length; ++O)
      N += this.encodeString(_[O]);
    var g = R - N % R, M = [];
    return M.length = g, this.update(M), this;
  }, E.prototype.finalize = function() {
    var _ = this.blocks, R = this.lastByteIndex, N = this.blockCount, O = this.s;
    if (_[R >> 2] |= this.padding[R & 3], this.lastByteIndex === this.byteCount)
      for (_[0] = _[N], R = 1; R < N + 1; ++R)
        _[R] = 0;
    for (_[N - 1] |= 2147483648, R = 0; R < N; ++R)
      O[R] ^= _[R];
    W(O);
  }, E.prototype.toString = E.prototype.hex = function() {
    this.finalize();
    for (var _ = this.blockCount, R = this.s, N = this.outputBlocks, O = this.extraBytes, g = 0, M = 0, Y = "", se; M < N; ) {
      for (g = 0; g < _ && M < N; ++g, ++M)
        se = R[g], Y += n[se >> 4 & 15] + n[se & 15] + n[se >> 12 & 15] + n[se >> 8 & 15] + n[se >> 20 & 15] + n[se >> 16 & 15] + n[se >> 28 & 15] + n[se >> 24 & 15];
      M % _ === 0 && (W(R), g = 0);
    }
    return O && (se = R[g], O > 0 && (Y += n[se >> 4 & 15] + n[se & 15]), O > 1 && (Y += n[se >> 12 & 15] + n[se >> 8 & 15]), O > 2 && (Y += n[se >> 20 & 15] + n[se >> 16 & 15])), Y;
  }, E.prototype.arrayBuffer = function() {
    this.finalize();
    var _ = this.blockCount, R = this.s, N = this.outputBlocks, O = this.extraBytes, g = 0, M = 0, Y = this.outputBits >> 3, se;
    O ? se = new ArrayBuffer(N + 1 << 2) : se = new ArrayBuffer(Y);
    for (var V = new Uint32Array(se); M < N; ) {
      for (g = 0; g < _ && M < N; ++g, ++M)
        V[M] = R[g];
      M % _ === 0 && W(R);
    }
    return O && (V[g] = R[g], se = se.slice(0, Y)), se;
  }, E.prototype.buffer = E.prototype.arrayBuffer, E.prototype.digest = E.prototype.array = function() {
    this.finalize();
    for (var _ = this.blockCount, R = this.s, N = this.outputBlocks, O = this.extraBytes, g = 0, M = 0, Y = [], se, V; M < N; ) {
      for (g = 0; g < _ && M < N; ++g, ++M)
        se = M << 2, V = R[g], Y[se] = V & 255, Y[se + 1] = V >> 8 & 255, Y[se + 2] = V >> 16 & 255, Y[se + 3] = V >> 24 & 255;
      M % _ === 0 && W(R);
    }
    return O && (se = M << 2, V = R[g], O > 0 && (Y[se] = V & 255), O > 1 && (Y[se + 1] = V >> 8 & 255), O > 2 && (Y[se + 2] = V >> 16 & 255)), Y;
  };
  function U(_, R, N) {
    E.call(this, _, R, N);
  }
  U.prototype = new E(), U.prototype.finalize = function() {
    return this.encode(this.outputBits, !0), E.prototype.finalize.call(this);
  };
  var W = function(_) {
    var R, N, O, g, M, Y, se, V, K, Z, ne, ce, H, J, le, me, Ue, Ve, ze, at, xe, gt, ht, Bt, pt, de, he, Ie, z, k, B, A, m, S, q, oe, fe, pe, Ke, De, ot, ar, bt, qr, ha, nr, pr, bi, Br, Mr, Bs, Wr, Vt, Ms, j, Q, X, T, te, ge, be, Ae, Le;
    for (O = 0; O < 48; O += 2)
      g = _[0] ^ _[10] ^ _[20] ^ _[30] ^ _[40], M = _[1] ^ _[11] ^ _[21] ^ _[31] ^ _[41], Y = _[2] ^ _[12] ^ _[22] ^ _[32] ^ _[42], se = _[3] ^ _[13] ^ _[23] ^ _[33] ^ _[43], V = _[4] ^ _[14] ^ _[24] ^ _[34] ^ _[44], K = _[5] ^ _[15] ^ _[25] ^ _[35] ^ _[45], Z = _[6] ^ _[16] ^ _[26] ^ _[36] ^ _[46], ne = _[7] ^ _[17] ^ _[27] ^ _[37] ^ _[47], ce = _[8] ^ _[18] ^ _[28] ^ _[38] ^ _[48], H = _[9] ^ _[19] ^ _[29] ^ _[39] ^ _[49], R = ce ^ (Y << 1 | se >>> 31), N = H ^ (se << 1 | Y >>> 31), _[0] ^= R, _[1] ^= N, _[10] ^= R, _[11] ^= N, _[20] ^= R, _[21] ^= N, _[30] ^= R, _[31] ^= N, _[40] ^= R, _[41] ^= N, R = g ^ (V << 1 | K >>> 31), N = M ^ (K << 1 | V >>> 31), _[2] ^= R, _[3] ^= N, _[12] ^= R, _[13] ^= N, _[22] ^= R, _[23] ^= N, _[32] ^= R, _[33] ^= N, _[42] ^= R, _[43] ^= N, R = Y ^ (Z << 1 | ne >>> 31), N = se ^ (ne << 1 | Z >>> 31), _[4] ^= R, _[5] ^= N, _[14] ^= R, _[15] ^= N, _[24] ^= R, _[25] ^= N, _[34] ^= R, _[35] ^= N, _[44] ^= R, _[45] ^= N, R = V ^ (ce << 1 | H >>> 31), N = K ^ (H << 1 | ce >>> 31), _[6] ^= R, _[7] ^= N, _[16] ^= R, _[17] ^= N, _[26] ^= R, _[27] ^= N, _[36] ^= R, _[37] ^= N, _[46] ^= R, _[47] ^= N, R = Z ^ (g << 1 | M >>> 31), N = ne ^ (M << 1 | g >>> 31), _[8] ^= R, _[9] ^= N, _[18] ^= R, _[19] ^= N, _[28] ^= R, _[29] ^= N, _[38] ^= R, _[39] ^= N, _[48] ^= R, _[49] ^= N, J = _[0], le = _[1], nr = _[11] << 4 | _[10] >>> 28, pr = _[10] << 4 | _[11] >>> 28, Ie = _[20] << 3 | _[21] >>> 29, z = _[21] << 3 | _[20] >>> 29, ge = _[31] << 9 | _[30] >>> 23, be = _[30] << 9 | _[31] >>> 23, ar = _[40] << 18 | _[41] >>> 14, bt = _[41] << 18 | _[40] >>> 14, S = _[2] << 1 | _[3] >>> 31, q = _[3] << 1 | _[2] >>> 31, me = _[13] << 12 | _[12] >>> 20, Ue = _[12] << 12 | _[13] >>> 20, bi = _[22] << 10 | _[23] >>> 22, Br = _[23] << 10 | _[22] >>> 22, k = _[33] << 13 | _[32] >>> 19, B = _[32] << 13 | _[33] >>> 19, Ae = _[42] << 2 | _[43] >>> 30, Le = _[43] << 2 | _[42] >>> 30, Ms = _[5] << 30 | _[4] >>> 2, j = _[4] << 30 | _[5] >>> 2, oe = _[14] << 6 | _[15] >>> 26, fe = _[15] << 6 | _[14] >>> 26, Ve = _[25] << 11 | _[24] >>> 21, ze = _[24] << 11 | _[25] >>> 21, Mr = _[34] << 15 | _[35] >>> 17, Bs = _[35] << 15 | _[34] >>> 17, A = _[45] << 29 | _[44] >>> 3, m = _[44] << 29 | _[45] >>> 3, Bt = _[6] << 28 | _[7] >>> 4, pt = _[7] << 28 | _[6] >>> 4, Q = _[17] << 23 | _[16] >>> 9, X = _[16] << 23 | _[17] >>> 9, pe = _[26] << 25 | _[27] >>> 7, Ke = _[27] << 25 | _[26] >>> 7, at = _[36] << 21 | _[37] >>> 11, xe = _[37] << 21 | _[36] >>> 11, Wr = _[47] << 24 | _[46] >>> 8, Vt = _[46] << 24 | _[47] >>> 8, qr = _[8] << 27 | _[9] >>> 5, ha = _[9] << 27 | _[8] >>> 5, de = _[18] << 20 | _[19] >>> 12, he = _[19] << 20 | _[18] >>> 12, T = _[29] << 7 | _[28] >>> 25, te = _[28] << 7 | _[29] >>> 25, De = _[38] << 8 | _[39] >>> 24, ot = _[39] << 8 | _[38] >>> 24, gt = _[48] << 14 | _[49] >>> 18, ht = _[49] << 14 | _[48] >>> 18, _[0] = J ^ ~me & Ve, _[1] = le ^ ~Ue & ze, _[10] = Bt ^ ~de & Ie, _[11] = pt ^ ~he & z, _[20] = S ^ ~oe & pe, _[21] = q ^ ~fe & Ke, _[30] = qr ^ ~nr & bi, _[31] = ha ^ ~pr & Br, _[40] = Ms ^ ~Q & T, _[41] = j ^ ~X & te, _[2] = me ^ ~Ve & at, _[3] = Ue ^ ~ze & xe, _[12] = de ^ ~Ie & k, _[13] = he ^ ~z & B, _[22] = oe ^ ~pe & De, _[23] = fe ^ ~Ke & ot, _[32] = nr ^ ~bi & Mr, _[33] = pr ^ ~Br & Bs, _[42] = Q ^ ~T & ge, _[43] = X ^ ~te & be, _[4] = Ve ^ ~at & gt, _[5] = ze ^ ~xe & ht, _[14] = Ie ^ ~k & A, _[15] = z ^ ~B & m, _[24] = pe ^ ~De & ar, _[25] = Ke ^ ~ot & bt, _[34] = bi ^ ~Mr & Wr, _[35] = Br ^ ~Bs & Vt, _[44] = T ^ ~ge & Ae, _[45] = te ^ ~be & Le, _[6] = at ^ ~gt & J, _[7] = xe ^ ~ht & le, _[16] = k ^ ~A & Bt, _[17] = B ^ ~m & pt, _[26] = De ^ ~ar & S, _[27] = ot ^ ~bt & q, _[36] = Mr ^ ~Wr & qr, _[37] = Bs ^ ~Vt & ha, _[46] = ge ^ ~Ae & Ms, _[47] = be ^ ~Le & j, _[8] = gt ^ ~J & me, _[9] = ht ^ ~le & Ue, _[18] = A ^ ~Bt & de, _[19] = m ^ ~pt & he, _[28] = ar ^ ~S & oe, _[29] = bt ^ ~q & fe, _[38] = Wr ^ ~qr & nr, _[39] = Vt ^ ~ha & pr, _[48] = Ae ^ ~Ms & Q, _[49] = Le ^ ~j & X, _[0] ^= f[O], _[1] ^= f[O + 1];
  };
})();
const Q5 = (t, e) => Wu.sign.detached(t, e);
function xU(t, e, r) {
  return Wu.sign.detached.verify(e, t, r);
}
let Jt = Wu.lowlevel;
function B6(t) {
  var e = [Jt.gf(), Jt.gf(), Jt.gf(), Jt.gf()], r = Jt.gf(), n = Jt.gf(), i = Jt.gf(), s = Jt.gf(), a = Jt.gf(), o = Jt.gf(), c = Jt.gf();
  return Jt.set25519(e[2], AU), Jt.unpack25519(e[1], t), Jt.S(i, e[1]), Jt.M(s, i, Jt.D), Jt.Z(i, i, e[2]), Jt.A(s, e[2], s), Jt.S(a, s), Jt.S(o, a), Jt.M(c, o, a), Jt.M(r, c, i), Jt.M(r, r, s), Jt.pow2523(r, r), Jt.M(r, r, i), Jt.M(r, r, s), Jt.M(r, r, s), Jt.M(e[0], r, s), Jt.S(n, e[0]), Jt.M(n, n, s), M6(n, i) && Jt.M(e[0], e[0], IU), Jt.S(n, e[0]), Jt.M(n, n, s), !M6(n, i);
}
let AU = Jt.gf([1]), IU = Jt.gf([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
function M6(t, e) {
  var r = new Uint8Array(32), n = new Uint8Array(32);
  return Jt.pack25519(r, t), Jt.pack25519(n, e), Jt.crypto_verify_32(r, 0, n, 0);
}
const cw = (t) => Fe.Buffer.isBuffer(t) ? t : t instanceof Uint8Array ? Fe.Buffer.from(t.buffer, t.byteOffset, t.byteLength) : Fe.Buffer.from(t);
let TU = class {
  constructor(e) {
    Object.assign(this, e);
  }
  encode() {
    return Fe.Buffer.from(Z2(qh, this));
  }
  static decode(e) {
    return Y2(qh, this, e);
  }
  static decodeUnchecked(e) {
    return F0(qh, this, e);
  }
};
const qh = /* @__PURE__ */ new Map(), kU = 32, Oa = 32;
function RU(t) {
  return t._bn !== void 0;
}
let C6 = 1, Gt = class fu extends TU {
  /** @internal */
  /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */
  constructor(e) {
    if (super({}), this._bn = void 0, RU(e))
      this._bn = e._bn;
    else {
      if (typeof e == "string") {
        const r = Ot.decode(e);
        if (r.length != Oa)
          throw new Error("Invalid public key input");
        this._bn = new Ss(r);
      } else
        this._bn = new Ss(e);
      if (this._bn.byteLength() > 32)
        throw new Error("Invalid public key input");
    }
  }
  /**
   * Returns a unique PublicKey for tests and benchmarks using acounter
   */
  static unique() {
    const e = new fu(C6);
    return C6 += 1, new fu(e.toBuffer());
  }
  /**
   * Default public key value. (All zeros)
   */
  /**
   * Checks if two publicKeys are equal
   */
  equals(e) {
    return this._bn.eq(e._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return Ot.encode(this.toBytes());
  }
  toJSON() {
    return this.toBase58();
  }
  /**
   * Return the byte array representation of the public key
   */
  toBytes() {
    return this.toBuffer();
  }
  /**
   * Return the Buffer representation of the public key
   */
  toBuffer() {
    const e = this._bn.toArrayLike(Fe.Buffer);
    if (e.length === Oa)
      return e;
    const r = Fe.Buffer.alloc(32);
    return e.copy(r, 32 - e.length), r;
  }
  /**
   * Return the base-58 representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */
  /* eslint-disable require-await */
  static async createWithSeed(e, r, n) {
    const i = Fe.Buffer.concat([e.toBuffer(), Fe.Buffer.from(r), n.toBuffer()]), s = new Uint8Array(new Od.sha256().update(i).digest());
    return new fu(s);
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  /* eslint-disable require-await */
  static createProgramAddressSync(e, r) {
    let n = Fe.Buffer.alloc(0);
    e.forEach(function(s) {
      if (s.length > kU)
        throw new TypeError("Max seed length exceeded");
      n = Fe.Buffer.concat([n, cw(s)]);
    }), n = Fe.Buffer.concat([n, r.toBuffer(), Fe.Buffer.from("ProgramDerivedAddress")]);
    const i = new Uint8Array(new Od.sha256().update(n).digest());
    if (B6(i))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new fu(i);
  }
  /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   */
  /* eslint-disable require-await */
  static async createProgramAddress(e, r) {
    return this.createProgramAddressSync(e, r);
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */
  static findProgramAddressSync(e, r) {
    let n = 255, i;
    for (; n != 0; ) {
      try {
        const s = e.concat(Fe.Buffer.from([n]));
        i = this.createProgramAddressSync(s, r);
      } catch (s) {
        if (s instanceof TypeError)
          throw s;
        n--;
        continue;
      }
      return [i, n];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   */
  static async findProgramAddress(e, r) {
    return this.findProgramAddressSync(e, r);
  }
  /**
   * Check that a pubkey is on the ed25519 curve.
   */
  static isOnCurve(e) {
    const r = new fu(e);
    return B6(r.toBytes());
  }
};
Gt.default = new Gt("11111111111111111111111111111111");
qh.set(Gt, {
  kind: "struct",
  fields: [["_bn", "u256"]]
});
new Gt("BPFLoader1111111111111111111111111111111111");
const xu = 1232, uw = 127, Cd = 64;
let wp = class {
  constructor(e, r) {
    this.staticAccountKeys = void 0, this.accountKeysFromLookups = void 0, this.staticAccountKeys = e, this.accountKeysFromLookups = r;
  }
  keySegments() {
    const e = [this.staticAccountKeys];
    return this.accountKeysFromLookups && (e.push(this.accountKeysFromLookups.writable), e.push(this.accountKeysFromLookups.readonly)), e;
  }
  get(e) {
    for (const r of this.keySegments()) {
      if (e < r.length)
        return r[e];
      e -= r.length;
    }
  }
  get length() {
    return this.keySegments().flat().length;
  }
  compileInstructions(e) {
    if (this.length > 255)
      throw new Error("Account index overflow encountered during compilation");
    const n = /* @__PURE__ */ new Map();
    this.keySegments().flat().forEach((s, a) => {
      n.set(s.toBase58(), a);
    });
    const i = (s) => {
      const a = n.get(s.toBase58());
      if (a === void 0)
        throw new Error("Encountered an unknown instruction account key during compilation");
      return a;
    };
    return e.map((s) => ({
      programIdIndex: i(s.programId),
      accountKeyIndexes: s.keys.map((a) => i(a.pubkey)),
      data: s.data
    }));
  }
};
const rr = (t = "publicKey") => xt(32, t), PU = (t = "signature") => xt(64, t), gu = (t = "string") => {
  const e = Re([Be("length"), Be("lengthPadding"), xt(Ii(Be(), -8), "chars")], t), r = e.decode.bind(e), n = e.encode.bind(e), i = e;
  return i.decode = (s, a) => r(s, a).chars.toString(), i.encode = (s, a, o) => {
    const c = {
      chars: Fe.Buffer.from(s, "utf8")
    };
    return n(c, a, o);
  }, i.alloc = (s) => Be().span + Be().span + Fe.Buffer.from(s, "utf8").length, i;
}, OU = (t = "authorized") => Re([rr("staker"), rr("withdrawer")], t), BU = (t = "lockup") => Re([Gr("unixTimestamp"), Gr("epoch"), rr("custodian")], t), MU = (t = "voteInit") => Re([rr("nodePubkey"), rr("authorizedVoter"), rr("authorizedWithdrawer"), st("commission")], t), CU = (t = "voteAuthorizeWithSeedArgs") => Re([Be("voteAuthorizationType"), rr("currentAuthorityDerivedKeyOwnerPubkey"), gu("currentAuthorityDerivedKeySeed"), rr("newAuthorized")], t);
function Mi(t) {
  let e = 0, r = 0;
  for (; ; ) {
    let n = t.shift();
    if (e |= (n & 127) << r * 7, r += 1, !(n & 128))
      break;
  }
  return e;
}
function Ci(t, e) {
  let r = e;
  for (; ; ) {
    let n = r & 127;
    if (r >>= 7, r == 0) {
      t.push(n);
      break;
    } else
      n |= 128, t.push(n);
  }
}
function Sn(t, e) {
  if (!t)
    throw new Error(e || "Assertion failed");
}
let X5 = class e9 {
  constructor(e, r) {
    this.payer = void 0, this.keyMetaMap = void 0, this.payer = e, this.keyMetaMap = r;
  }
  static compile(e, r) {
    const n = /* @__PURE__ */ new Map(), i = (a) => {
      const o = a.toBase58();
      let c = n.get(o);
      return c === void 0 && (c = {
        isSigner: !1,
        isWritable: !1,
        isInvoked: !1
      }, n.set(o, c)), c;
    }, s = i(r);
    s.isSigner = !0, s.isWritable = !0;
    for (const a of e) {
      i(a.programId).isInvoked = !0;
      for (const o of a.keys) {
        const c = i(o.pubkey);
        c.isSigner || (c.isSigner = o.isSigner), c.isWritable || (c.isWritable = o.isWritable);
      }
    }
    return new e9(r, n);
  }
  getMessageComponents() {
    const e = [...this.keyMetaMap.entries()];
    Sn(e.length < 256, "Max static account keys length exceeded");
    const r = e.filter(([, c]) => c.isSigner && c.isWritable), n = e.filter(([, c]) => c.isSigner && !c.isWritable), i = e.filter(([, c]) => !c.isSigner && c.isWritable), s = e.filter(([, c]) => !c.isSigner && !c.isWritable), a = {
      numRequiredSignatures: r.length + n.length,
      numReadonlySignedAccounts: n.length,
      numReadonlyUnsignedAccounts: s.length
    };
    {
      Sn(r.length > 0, "Expected at least one writable signer key");
      const [c] = r[0];
      Sn(c === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
    }
    const o = [...r.map(([c]) => new Gt(c)), ...n.map(([c]) => new Gt(c)), ...i.map(([c]) => new Gt(c)), ...s.map(([c]) => new Gt(c))];
    return [a, o];
  }
  extractTableLookup(e) {
    const [r, n] = this.drainKeysFoundInLookupTable(e.state.addresses, (a) => !a.isSigner && !a.isInvoked && a.isWritable), [i, s] = this.drainKeysFoundInLookupTable(e.state.addresses, (a) => !a.isSigner && !a.isInvoked && !a.isWritable);
    if (!(r.length === 0 && i.length === 0))
      return [{
        accountKey: e.key,
        writableIndexes: r,
        readonlyIndexes: i
      }, {
        writable: n,
        readonly: s
      }];
  }
  /** @internal */
  drainKeysFoundInLookupTable(e, r) {
    const n = new Array(), i = new Array();
    for (const [s, a] of this.keyMetaMap.entries())
      if (r(a)) {
        const o = new Gt(s), c = e.findIndex((f) => f.equals(o));
        c >= 0 && (Sn(c < 256, "Max lookup table index exceeded"), n.push(c), i.push(o), this.keyMetaMap.delete(s));
      }
    return [n, i];
  }
}, dv = class lv {
  constructor(e) {
    this.header = void 0, this.accountKeys = void 0, this.recentBlockhash = void 0, this.instructions = void 0, this.indexToProgramIds = /* @__PURE__ */ new Map(), this.header = e.header, this.accountKeys = e.accountKeys.map((r) => new Gt(r)), this.recentBlockhash = e.recentBlockhash, this.instructions = e.instructions, this.instructions.forEach((r) => this.indexToProgramIds.set(r.programIdIndex, this.accountKeys[r.programIdIndex]));
  }
  get version() {
    return "legacy";
  }
  get staticAccountKeys() {
    return this.accountKeys;
  }
  get compiledInstructions() {
    return this.instructions.map((e) => ({
      programIdIndex: e.programIdIndex,
      accountKeyIndexes: e.accounts,
      data: Ot.decode(e.data)
    }));
  }
  get addressTableLookups() {
    return [];
  }
  getAccountKeys() {
    return new wp(this.staticAccountKeys);
  }
  static compile(e) {
    const r = X5.compile(e.instructions, e.payerKey), [n, i] = r.getMessageComponents(), a = new wp(i).compileInstructions(e.instructions).map((o) => ({
      programIdIndex: o.programIdIndex,
      accounts: o.accountKeyIndexes,
      data: Ot.encode(o.data)
    }));
    return new lv({
      header: n,
      accountKeys: i,
      recentBlockhash: e.recentBlockhash,
      instructions: a
    });
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    const r = this.header.numRequiredSignatures;
    if (e >= this.header.numRequiredSignatures) {
      const n = e - r, s = this.accountKeys.length - r - this.header.numReadonlyUnsignedAccounts;
      return n < s;
    } else {
      const n = r - this.header.numReadonlySignedAccounts;
      return e < n;
    }
  }
  isProgramId(e) {
    return this.indexToProgramIds.has(e);
  }
  programIds() {
    return [...this.indexToProgramIds.values()];
  }
  nonProgramIds() {
    return this.accountKeys.filter((e, r) => !this.isProgramId(r));
  }
  serialize() {
    const e = this.accountKeys.length;
    let r = [];
    Ci(r, e);
    const n = this.instructions.map((d) => {
      const {
        accounts: l,
        programIdIndex: h
      } = d, y = Array.from(Ot.decode(d.data));
      let p = [];
      Ci(p, l.length);
      let b = [];
      return Ci(b, y.length), {
        programIdIndex: h,
        keyIndicesCount: Fe.Buffer.from(p),
        keyIndices: l,
        dataLength: Fe.Buffer.from(b),
        data: y
      };
    });
    let i = [];
    Ci(i, n.length);
    let s = Fe.Buffer.alloc(xu);
    Fe.Buffer.from(i).copy(s);
    let a = i.length;
    n.forEach((d) => {
      const h = Re([st("programIdIndex"), xt(d.keyIndicesCount.length, "keyIndicesCount"), Ir(st("keyIndex"), d.keyIndices.length, "keyIndices"), xt(d.dataLength.length, "dataLength"), Ir(st("userdatum"), d.data.length, "data")]).encode(d, s, a);
      a += h;
    }), s = s.slice(0, a);
    const o = Re([xt(1, "numRequiredSignatures"), xt(1, "numReadonlySignedAccounts"), xt(1, "numReadonlyUnsignedAccounts"), xt(r.length, "keyCount"), Ir(rr("key"), e, "keys"), rr("recentBlockhash")]), c = {
      numRequiredSignatures: Fe.Buffer.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: Fe.Buffer.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: Fe.Buffer.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: Fe.Buffer.from(r),
      keys: this.accountKeys.map((d) => cw(d.toBytes())),
      recentBlockhash: Ot.decode(this.recentBlockhash)
    };
    let f = Fe.Buffer.alloc(2048);
    const u = o.encode(c, f);
    return s.copy(f, u), f.slice(0, u + s.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(e) {
    let r = [...e];
    const n = r.shift();
    if (n !== (n & uw))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const i = r.shift(), s = r.shift(), a = Mi(r);
    let o = [];
    for (let l = 0; l < a; l++) {
      const h = r.slice(0, Oa);
      r = r.slice(Oa), o.push(new Gt(Fe.Buffer.from(h)));
    }
    const c = r.slice(0, Oa);
    r = r.slice(Oa);
    const f = Mi(r);
    let u = [];
    for (let l = 0; l < f; l++) {
      const h = r.shift(), y = Mi(r), p = r.slice(0, y);
      r = r.slice(y);
      const b = Mi(r), v = r.slice(0, b), x = Ot.encode(Fe.Buffer.from(v));
      r = r.slice(b), u.push({
        programIdIndex: h,
        accounts: p,
        data: x
      });
    }
    const d = {
      header: {
        numRequiredSignatures: n,
        numReadonlySignedAccounts: i,
        numReadonlyUnsignedAccounts: s
      },
      recentBlockhash: Ot.encode(Fe.Buffer.from(c)),
      accountKeys: o,
      instructions: u
    };
    return new lv(d);
  }
}, NU = class hv {
  constructor(e) {
    this.header = void 0, this.staticAccountKeys = void 0, this.recentBlockhash = void 0, this.compiledInstructions = void 0, this.addressTableLookups = void 0, this.header = e.header, this.staticAccountKeys = e.staticAccountKeys, this.recentBlockhash = e.recentBlockhash, this.compiledInstructions = e.compiledInstructions, this.addressTableLookups = e.addressTableLookups;
  }
  get version() {
    return 0;
  }
  get numAccountKeysFromLookups() {
    let e = 0;
    for (const r of this.addressTableLookups)
      e += r.readonlyIndexes.length + r.writableIndexes.length;
    return e;
  }
  getAccountKeys(e) {
    let r;
    if (e && "accountKeysFromLookups" in e && e.accountKeysFromLookups) {
      if (this.numAccountKeysFromLookups != e.accountKeysFromLookups.writable.length + e.accountKeysFromLookups.readonly.length)
        throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
      r = e.accountKeysFromLookups;
    } else if (e && "addressLookupTableAccounts" in e && e.addressLookupTableAccounts)
      r = this.resolveAddressTableLookups(e.addressLookupTableAccounts);
    else if (this.addressTableLookups.length > 0)
      throw new Error("Failed to get account keys because address table lookups were not resolved");
    return new wp(this.staticAccountKeys, r);
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    const r = this.header.numRequiredSignatures, n = this.staticAccountKeys.length;
    if (e >= n) {
      const i = e - n, s = this.addressTableLookups.reduce((a, o) => a + o.writableIndexes.length, 0);
      return i < s;
    } else if (e >= this.header.numRequiredSignatures) {
      const i = e - r, a = n - r - this.header.numReadonlyUnsignedAccounts;
      return i < a;
    } else {
      const i = r - this.header.numReadonlySignedAccounts;
      return e < i;
    }
  }
  resolveAddressTableLookups(e) {
    const r = {
      writable: [],
      readonly: []
    };
    for (const n of this.addressTableLookups) {
      const i = e.find((s) => s.key.equals(n.accountKey));
      if (!i)
        throw new Error(`Failed to find address lookup table account for table key ${n.accountKey.toBase58()}`);
      for (const s of n.writableIndexes)
        if (s < i.state.addresses.length)
          r.writable.push(i.state.addresses[s]);
        else
          throw new Error(`Failed to find address for index ${s} in address lookup table ${n.accountKey.toBase58()}`);
      for (const s of n.readonlyIndexes)
        if (s < i.state.addresses.length)
          r.readonly.push(i.state.addresses[s]);
        else
          throw new Error(`Failed to find address for index ${s} in address lookup table ${n.accountKey.toBase58()}`);
    }
    return r;
  }
  static compile(e) {
    const r = X5.compile(e.instructions, e.payerKey), n = new Array(), i = {
      writable: new Array(),
      readonly: new Array()
    }, s = e.addressLookupTableAccounts || [];
    for (const u of s) {
      const d = r.extractTableLookup(u);
      if (d !== void 0) {
        const [l, {
          writable: h,
          readonly: y
        }] = d;
        n.push(l), i.writable.push(...h), i.readonly.push(...y);
      }
    }
    const [a, o] = r.getMessageComponents(), f = new wp(o, i).compileInstructions(e.instructions);
    return new hv({
      header: a,
      staticAccountKeys: o,
      recentBlockhash: e.recentBlockhash,
      compiledInstructions: f,
      addressTableLookups: n
    });
  }
  serialize() {
    const e = Array();
    Ci(e, this.staticAccountKeys.length);
    const r = this.serializeInstructions(), n = Array();
    Ci(n, this.compiledInstructions.length);
    const i = this.serializeAddressTableLookups(), s = Array();
    Ci(s, this.addressTableLookups.length);
    const a = Re([st("prefix"), Re([st("numRequiredSignatures"), st("numReadonlySignedAccounts"), st("numReadonlyUnsignedAccounts")], "header"), xt(e.length, "staticAccountKeysLength"), Ir(rr(), this.staticAccountKeys.length, "staticAccountKeys"), rr("recentBlockhash"), xt(n.length, "instructionsLength"), xt(r.length, "serializedInstructions"), xt(s.length, "addressTableLookupsLength"), xt(i.length, "serializedAddressTableLookups")]), o = new Uint8Array(xu), f = a.encode({
      prefix: 128,
      header: this.header,
      staticAccountKeysLength: new Uint8Array(e),
      staticAccountKeys: this.staticAccountKeys.map((u) => u.toBytes()),
      recentBlockhash: Ot.decode(this.recentBlockhash),
      instructionsLength: new Uint8Array(n),
      serializedInstructions: r,
      addressTableLookupsLength: new Uint8Array(s),
      serializedAddressTableLookups: i
    }, o);
    return o.slice(0, f);
  }
  serializeInstructions() {
    let e = 0;
    const r = new Uint8Array(xu);
    for (const n of this.compiledInstructions) {
      const i = Array();
      Ci(i, n.accountKeyIndexes.length);
      const s = Array();
      Ci(s, n.data.length);
      const a = Re([st("programIdIndex"), xt(i.length, "encodedAccountKeyIndexesLength"), Ir(st(), n.accountKeyIndexes.length, "accountKeyIndexes"), xt(s.length, "encodedDataLength"), xt(n.data.length, "data")]);
      e += a.encode({
        programIdIndex: n.programIdIndex,
        encodedAccountKeyIndexesLength: new Uint8Array(i),
        accountKeyIndexes: n.accountKeyIndexes,
        encodedDataLength: new Uint8Array(s),
        data: n.data
      }, r, e);
    }
    return r.slice(0, e);
  }
  serializeAddressTableLookups() {
    let e = 0;
    const r = new Uint8Array(xu);
    for (const n of this.addressTableLookups) {
      const i = Array();
      Ci(i, n.writableIndexes.length);
      const s = Array();
      Ci(s, n.readonlyIndexes.length);
      const a = Re([rr("accountKey"), xt(i.length, "encodedWritableIndexesLength"), Ir(st(), n.writableIndexes.length, "writableIndexes"), xt(s.length, "encodedReadonlyIndexesLength"), Ir(st(), n.readonlyIndexes.length, "readonlyIndexes")]);
      e += a.encode({
        accountKey: n.accountKey.toBytes(),
        encodedWritableIndexesLength: new Uint8Array(i),
        writableIndexes: n.writableIndexes,
        encodedReadonlyIndexesLength: new Uint8Array(s),
        readonlyIndexes: n.readonlyIndexes
      }, r, e);
    }
    return r.slice(0, e);
  }
  static deserialize(e) {
    let r = [...e];
    const n = r.shift(), i = n & uw;
    Sn(n !== i, "Expected versioned message but received legacy message");
    const s = i;
    Sn(s === 0, `Expected versioned message with version 0 but found version ${s}`);
    const a = {
      numRequiredSignatures: r.shift(),
      numReadonlySignedAccounts: r.shift(),
      numReadonlyUnsignedAccounts: r.shift()
    }, o = [], c = Mi(r);
    for (let y = 0; y < c; y++)
      o.push(new Gt(r.splice(0, Oa)));
    const f = Ot.encode(r.splice(0, Oa)), u = Mi(r), d = [];
    for (let y = 0; y < u; y++) {
      const p = r.shift(), b = Mi(r), v = r.splice(0, b), x = Mi(r), I = new Uint8Array(r.splice(0, x));
      d.push({
        programIdIndex: p,
        accountKeyIndexes: v,
        data: I
      });
    }
    const l = Mi(r), h = [];
    for (let y = 0; y < l; y++) {
      const p = new Gt(r.splice(0, Oa)), b = Mi(r), v = r.splice(0, b), x = Mi(r), I = r.splice(0, x);
      h.push({
        accountKey: p,
        writableIndexes: v,
        readonlyIndexes: I
      });
    }
    return new hv({
      header: a,
      staticAccountKeys: o,
      recentBlockhash: f,
      compiledInstructions: d,
      addressTableLookups: h
    });
  }
};
const t9 = {
  deserializeMessageVersion(t) {
    const e = t[0], r = e & uw;
    return r === e ? "legacy" : r;
  },
  deserialize: (t) => {
    const e = t9.deserializeMessageVersion(t);
    if (e === "legacy")
      return dv.from(t);
    if (e === 0)
      return NU.deserialize(t);
    throw new Error(`Transaction message version ${e} deserialization is not supported`);
  }
};
let N6;
(function(t) {
  t[t.BLOCKHEIGHT_EXCEEDED = 0] = "BLOCKHEIGHT_EXCEEDED", t[t.PROCESSED = 1] = "PROCESSED", t[t.TIMED_OUT = 2] = "TIMED_OUT";
})(N6 || (N6 = {}));
const UU = Fe.Buffer.alloc(Cd).fill(0);
let U6 = class {
  /**
   * Public keys to include in this transaction
   * Boolean represents whether this pubkey needs to sign the transaction
   */
  /**
   * Program Id to execute
   */
  /**
   * Program input
   */
  constructor(e) {
    this.keys = void 0, this.programId = void 0, this.data = Fe.Buffer.alloc(0), this.programId = e.programId, this.keys = e.keys, e.data && (this.data = e.data);
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      keys: this.keys.map(({
        pubkey: e,
        isSigner: r,
        isWritable: n
      }) => ({
        pubkey: e.toJSON(),
        isSigner: r,
        isWritable: n
      })),
      programId: this.programId.toJSON(),
      data: [...this.data]
    };
  }
}, LU = class pv {
  /**
   * Signatures for the transaction.  Typically created by invoking the
   * `sign()` method
   */
  /**
   * The first (payer) Transaction signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer
   */
  /**
   * Construct an empty Transaction
   */
  constructor(e) {
    if (this.signatures = [], this.feePayer = void 0, this.instructions = [], this.recentBlockhash = void 0, this.lastValidBlockHeight = void 0, this.nonceInfo = void 0, this._message = void 0, this._json = void 0, !!e)
      if (e.feePayer && (this.feePayer = e.feePayer), e.signatures && (this.signatures = e.signatures), Object.prototype.hasOwnProperty.call(e, "lastValidBlockHeight")) {
        const {
          blockhash: r,
          lastValidBlockHeight: n
        } = e;
        this.recentBlockhash = r, this.lastValidBlockHeight = n;
      } else {
        const {
          recentBlockhash: r,
          nonceInfo: n
        } = e;
        n && (this.nonceInfo = n), this.recentBlockhash = r;
      }
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      recentBlockhash: this.recentBlockhash || null,
      feePayer: this.feePayer ? this.feePayer.toJSON() : null,
      nonceInfo: this.nonceInfo ? {
        nonce: this.nonceInfo.nonce,
        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
      } : null,
      instructions: this.instructions.map((e) => e.toJSON()),
      signers: this.signatures.map(({
        publicKey: e
      }) => e.toJSON())
    };
  }
  /**
   * Add one or more instructions to this Transaction
   */
  add(...e) {
    if (e.length === 0)
      throw new Error("No instructions");
    return e.forEach((r) => {
      "instructions" in r ? this.instructions = this.instructions.concat(r.instructions) : "data" in r && "programId" in r && "keys" in r ? this.instructions.push(r) : this.instructions.push(new U6(r));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json))
      return this._message;
    let e, r;
    if (this.nonceInfo ? (e = this.nonceInfo.nonce, this.instructions[0] != this.nonceInfo.nonceInstruction ? r = [this.nonceInfo.nonceInstruction, ...this.instructions] : r = this.instructions) : (e = this.recentBlockhash, r = this.instructions), !e)
      throw new Error("Transaction recentBlockhash required");
    r.length < 1 && console.warn("No instructions provided");
    let n;
    if (this.feePayer)
      n = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      n = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    for (let p = 0; p < r.length; p++)
      if (r[p].programId === void 0)
        throw new Error(`Transaction instruction index ${p} has undefined program id`);
    const i = [], s = [];
    r.forEach((p) => {
      p.keys.forEach((v) => {
        s.push({
          ...v
        });
      });
      const b = p.programId.toString();
      i.includes(b) || i.push(b);
    }), i.forEach((p) => {
      s.push({
        pubkey: new Gt(p),
        isSigner: !1,
        isWritable: !1
      });
    });
    const a = [];
    s.forEach((p) => {
      const b = p.pubkey.toString(), v = a.findIndex((x) => x.pubkey.toString() === b);
      v > -1 ? (a[v].isWritable = a[v].isWritable || p.isWritable, a[v].isSigner = a[v].isSigner || p.isSigner) : a.push(p);
    }), a.sort(function(p, b) {
      return p.isSigner !== b.isSigner ? p.isSigner ? -1 : 1 : p.isWritable !== b.isWritable ? p.isWritable ? -1 : 1 : p.pubkey.toBase58().localeCompare(b.pubkey.toBase58());
    });
    const o = a.findIndex((p) => p.pubkey.equals(n));
    if (o > -1) {
      const [p] = a.splice(o, 1);
      p.isSigner = !0, p.isWritable = !0, a.unshift(p);
    } else
      a.unshift({
        pubkey: n,
        isSigner: !0,
        isWritable: !0
      });
    for (const p of this.signatures) {
      const b = a.findIndex((v) => v.pubkey.equals(p.publicKey));
      if (b > -1)
        a[b].isSigner || (a[b].isSigner = !0, console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release."));
      else
        throw new Error(`unknown signer: ${p.publicKey.toString()}`);
    }
    let c = 0, f = 0, u = 0;
    const d = [], l = [];
    a.forEach(({
      pubkey: p,
      isSigner: b,
      isWritable: v
    }) => {
      b ? (d.push(p.toString()), c += 1, v || (f += 1)) : (l.push(p.toString()), v || (u += 1));
    });
    const h = d.concat(l), y = r.map((p) => {
      const {
        data: b,
        programId: v
      } = p;
      return {
        programIdIndex: h.indexOf(v.toString()),
        accounts: p.keys.map((x) => h.indexOf(x.pubkey.toString())),
        data: Ot.encode(b)
      };
    });
    return y.forEach((p) => {
      Sn(p.programIdIndex >= 0), p.accounts.forEach((b) => Sn(b >= 0));
    }), new dv({
      header: {
        numRequiredSignatures: c,
        numReadonlySignedAccounts: f,
        numReadonlyUnsignedAccounts: u
      },
      accountKeys: h,
      recentBlockhash: e,
      instructions: y
    });
  }
  /**
   * @internal
   */
  _compile() {
    const e = this.compileMessage(), r = e.accountKeys.slice(0, e.header.numRequiredSignatures);
    return this.signatures.length === r.length && this.signatures.every((i, s) => r[s].equals(i.publicKey)) || (this.signatures = r.map((n) => ({
      signature: null,
      publicKey: n
    }))), e;
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this._compile().serialize();
  }
  /**
   * Get the estimated fee associated with a transaction
   */
  async getEstimatedFee(e) {
    return (await e.getFeeForMessage(this.compileMessage())).value;
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */
  setSigners(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set();
    this.signatures = e.filter((n) => {
      const i = n.toString();
      return r.has(i) ? !1 : (r.add(i), !0);
    }).map((n) => ({
      signature: null,
      publicKey: n
    }));
  }
  /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   */
  sign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set(), n = [];
    for (const s of e) {
      const a = s.publicKey.toString();
      r.has(a) || (r.add(a), n.push(s));
    }
    this.signatures = n.map((s) => ({
      signature: null,
      publicKey: s.publicKey
    }));
    const i = this._compile();
    this._partialSign(i, ...n);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   */
  partialSign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set(), n = [];
    for (const s of e) {
      const a = s.publicKey.toString();
      r.has(a) || (r.add(a), n.push(s));
    }
    const i = this._compile();
    this._partialSign(i, ...n);
  }
  /**
   * @internal
   */
  _partialSign(e, ...r) {
    const n = e.serialize();
    r.forEach((i) => {
      const s = Q5(n, i.secretKey);
      this._addSignature(i.publicKey, cw(s));
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   */
  addSignature(e, r) {
    this._compile(), this._addSignature(e, r);
  }
  /**
   * @internal
   */
  _addSignature(e, r) {
    Sn(r.length === 64);
    const n = this.signatures.findIndex((i) => e.equals(i.publicKey));
    if (n < 0)
      throw new Error(`unknown signer: ${e.toString()}`);
    this.signatures[n].signature = Fe.Buffer.from(r);
  }
  /**
   * Verify signatures of a complete, signed Transaction
   */
  verifySignatures() {
    return this._verifySignatures(this.serializeMessage(), !0);
  }
  /**
   * @internal
   */
  _verifySignatures(e, r) {
    for (const {
      signature: n,
      publicKey: i
    } of this.signatures)
      if (n === null) {
        if (r)
          return !1;
      } else if (!xU(n, e, i.toBuffer()))
        return !1;
    return !0;
  }
  /**
   * Serialize the Transaction in the wire format.
   */
  serialize(e) {
    const {
      requireAllSignatures: r,
      verifySignatures: n
    } = Object.assign({
      requireAllSignatures: !0,
      verifySignatures: !0
    }, e), i = this.serializeMessage();
    if (n && !this._verifySignatures(i, r))
      throw new Error("Signature verification failed");
    return this._serialize(i);
  }
  /**
   * @internal
   */
  _serialize(e) {
    const {
      signatures: r
    } = this, n = [];
    Ci(n, r.length);
    const i = n.length + r.length * 64 + e.length, s = Fe.Buffer.alloc(i);
    return Sn(r.length < 256), Fe.Buffer.from(n).copy(s, 0), r.forEach(({
      signature: a
    }, o) => {
      a !== null && (Sn(a.length === 64, "signature has invalid length"), Fe.Buffer.from(a).copy(s, n.length + o * 64));
    }), e.copy(s, n.length + r.length * 64), Sn(s.length <= xu, `Transaction too large: ${s.length} > ${xu}`), s;
  }
  /**
   * Deprecated method
   * @internal
   */
  get keys() {
    return Sn(this.instructions.length === 1), this.instructions[0].keys.map((e) => e.pubkey);
  }
  /**
   * Deprecated method
   * @internal
   */
  get programId() {
    return Sn(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @internal
   */
  get data() {
    return Sn(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   */
  static from(e) {
    let r = [...e];
    const n = Mi(r);
    let i = [];
    for (let s = 0; s < n; s++) {
      const a = r.slice(0, Cd);
      r = r.slice(Cd), i.push(Ot.encode(Fe.Buffer.from(a)));
    }
    return pv.populate(dv.from(r), i);
  }
  /**
   * Populate Transaction object from message and signatures
   */
  static populate(e, r = []) {
    const n = new pv();
    return n.recentBlockhash = e.recentBlockhash, e.header.numRequiredSignatures > 0 && (n.feePayer = e.accountKeys[0]), r.forEach((i, s) => {
      const a = {
        signature: i == Ot.encode(UU) ? null : Ot.decode(i),
        publicKey: e.accountKeys[s]
      };
      n.signatures.push(a);
    }), e.instructions.forEach((i) => {
      const s = i.accounts.map((a) => {
        const o = e.accountKeys[a];
        return {
          pubkey: o,
          isSigner: n.signatures.some((c) => c.publicKey.toString() === o.toString()) || e.isAccountSigner(a),
          isWritable: e.isAccountWritable(a)
        };
      });
      n.instructions.push(new U6({
        keys: s,
        programId: e.accountKeys[i.programIdIndex],
        data: Ot.decode(i.data)
      }));
    }), n._message = e, n._json = n.toJSON(), n;
  }
}, L6 = class r9 {
  get version() {
    return this.message.version;
  }
  constructor(e, r) {
    if (this.signatures = void 0, this.message = void 0, r !== void 0)
      Sn(r.length === e.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures"), this.signatures = r;
    else {
      const n = [];
      for (let i = 0; i < e.header.numRequiredSignatures; i++)
        n.push(new Uint8Array(Cd));
      this.signatures = n;
    }
    this.message = e;
  }
  serialize() {
    const e = this.message.serialize(), r = Array();
    Ci(r, this.signatures.length);
    const n = Re([xt(r.length, "encodedSignaturesLength"), Ir(PU(), this.signatures.length, "signatures"), xt(e.length, "serializedMessage")]), i = new Uint8Array(2048), s = n.encode({
      encodedSignaturesLength: new Uint8Array(r),
      signatures: this.signatures,
      serializedMessage: e
    }, i);
    return i.slice(0, s);
  }
  static deserialize(e) {
    let r = [...e];
    const n = [], i = Mi(r);
    for (let a = 0; a < i; a++)
      n.push(new Uint8Array(r.splice(0, Cd)));
    const s = t9.deserialize(new Uint8Array(r));
    return new r9(s, n);
  }
  sign(e) {
    const r = this.message.serialize(), n = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
    for (const i of e) {
      const s = n.findIndex((a) => a.equals(i.publicKey));
      Sn(s >= 0, `Cannot sign with non signer key ${i.publicKey.toBase58()}`), this.signatures[s] = Q5(r, i.secretKey);
    }
  }
  addSignature(e, r) {
    Sn(r.byteLength === 64, "Signature must be 64 bytes long");
    const i = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures).findIndex((s) => s.equals(e));
    Sn(i >= 0, `Can not add signature; \`${e.toBase58()}\` is not required to sign this transaction`), this.signatures[i] = r;
  }
};
new Gt("SysvarC1ock11111111111111111111111111111111");
new Gt("SysvarEpochSchedu1e111111111111111111111111");
new Gt("Sysvar1nstructions1111111111111111111111111");
new Gt("SysvarRecentB1ockHashes11111111111111111111");
new Gt("SysvarRent111111111111111111111111111111111");
new Gt("SysvarRewards111111111111111111111111111111");
new Gt("SysvarS1otHashes111111111111111111111111111");
new Gt("SysvarS1otHistory11111111111111111111111111");
new Gt("SysvarStakeHistory1111111111111111111111111");
const DU = gr("lamportsPerSignature"), FU = Re([Be("version"), Be("state"), rr("authorizedPubkey"), rr("nonce"), Re([DU], "feeCalculator")]);
FU.span;
var kl = {};
Object.defineProperty(kl, "__esModule", { value: !0 });
function jU(t) {
  {
    const e = ve.from(t);
    e.reverse();
    const r = e.toString("hex");
    return r.length === 0 ? BigInt(0) : BigInt(`0x${r}`);
  }
}
var $U = kl.toBigIntLE = jU;
function qU(t) {
  {
    const e = t.toString("hex");
    return e.length === 0 ? BigInt(0) : BigInt(`0x${e}`);
  }
}
kl.toBigIntBE = qU;
function WU(t, e) {
  {
    const r = t.toString(16), n = ve.from(r.padStart(e * 2, "0").slice(0, e * 2), "hex");
    return n.reverse(), n;
  }
}
var zU = kl.toBufferLE = WU;
function KU(t, e) {
  {
    const r = t.toString(16);
    return ve.from(r.padStart(e * 2, "0").slice(0, e * 2), "hex");
  }
}
kl.toBufferBE = KU;
const VU = (t) => {
  const e = t.decode.bind(t), r = t.encode.bind(t);
  return {
    decode: e,
    encode: r
  };
}, HU = (t) => (e) => {
  const r = xt(t, e), {
    encode: n,
    decode: i
  } = VU(r), s = r;
  return s.decode = (a, o) => {
    const c = i(a, o);
    return $U(Fe.Buffer.from(c));
  }, s.encode = (a, o, c) => {
    const f = zU(a, t);
    return n(f, o, c);
  }, s;
}, Ku = HU(8);
Object.freeze({
  Create: {
    index: 0,
    layout: Re([Be("instruction"), Gr("lamports"), Gr("space"), rr("programId")])
  },
  Assign: {
    index: 1,
    layout: Re([Be("instruction"), rr("programId")])
  },
  Transfer: {
    index: 2,
    layout: Re([Be("instruction"), Ku("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: Re([Be("instruction"), rr("base"), gu("seed"), Gr("lamports"), Gr("space"), rr("programId")])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: Re([Be("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: Re([Be("instruction"), Gr("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: Re([Be("instruction"), rr("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: Re([Be("instruction"), rr("authorized")])
  },
  Allocate: {
    index: 8,
    layout: Re([Be("instruction"), Gr("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: Re([Be("instruction"), rr("base"), gu("seed"), Gr("space"), rr("programId")])
  },
  AssignWithSeed: {
    index: 10,
    layout: Re([Be("instruction"), rr("base"), gu("seed"), rr("programId")])
  },
  TransferWithSeed: {
    index: 11,
    layout: Re([Be("instruction"), Ku("lamports"), gu("seed"), rr("programId")])
  },
  UpgradeNonceAccount: {
    index: 12,
    layout: Re([Be("instruction")])
  }
});
new Gt("11111111111111111111111111111111");
new Gt("BPFLoader2111111111111111111111111111111111");
Re([
  Be("typeIndex"),
  Ku("deactivationSlot"),
  gr("lastExtendedSlot"),
  st("lastExtendedStartIndex"),
  st(),
  // option
  Ir(rr(), Ii(st(), -1), "authority")
]);
const kn = oa(gf(Gt), we(), (t) => new Gt(t)), n9 = mf([we(), Pt("base64")]), fw = oa(gf(Fe.Buffer), n9, (t) => Fe.Buffer.from(t[0], "base64"));
function i9(t) {
  return jr([ye({
    jsonrpc: Pt("2.0"),
    id: we(),
    result: t
  }), ye({
    jsonrpc: Pt("2.0"),
    id: we(),
    error: ye({
      code: aa(),
      message: we(),
      data: We(K5())
    })
  })]);
}
const GU = i9(aa());
function Rn(t) {
  return oa(i9(t), GU, (e) => "error" in e ? e : {
    ...e,
    result: He(e.result, t)
  });
}
function Rs(t) {
  return Rn(ye({
    context: ye({
      slot: ae()
    }),
    value: t
  }));
}
function G0(t) {
  return ye({
    context: ye({
      slot: ae()
    }),
    value: t
  });
}
const ZU = ye({
  foundation: ae(),
  foundationTerm: ae(),
  initial: ae(),
  taper: ae(),
  terminal: ae()
});
Rn(Te(Pe(ye({
  epoch: ae(),
  effectiveSlot: ae(),
  amount: ae(),
  postBalance: ae()
}))));
const JU = ye({
  epoch: ae(),
  slotIndex: ae(),
  slotsInEpoch: ae(),
  absoluteSlot: ae(),
  blockHeight: We(ae()),
  transactionCount: We(ae())
}), YU = ye({
  slotsPerEpoch: ae(),
  leaderScheduleSlotOffset: ae(),
  warmup: Tn(),
  firstNormalEpoch: ae(),
  firstNormalSlot: ae()
}), QU = q0(we(), Te(ae())), $c = Pe(jr([ye({}), we()])), XU = ye({
  err: $c
}), eL = Pt("receivedSignature");
ye({
  "solana-core": we(),
  "feature-set": We(ae())
});
Rs(ye({
  err: Pe(jr([ye({}), we()])),
  logs: Pe(Te(we())),
  accounts: We(Pe(Te(Pe(ye({
    executable: Tn(),
    owner: we(),
    lamports: ae(),
    data: Te(we()),
    rentEpoch: We(ae())
  }))))),
  unitsConsumed: We(ae()),
  returnData: We(Pe(ye({
    programId: we(),
    data: mf([we(), Pt("base64")])
  })))
}));
Rs(ye({
  byIdentity: q0(we(), Te(ae())),
  range: ye({
    firstSlot: ae(),
    lastSlot: ae()
  })
}));
Rn(ZU);
Rn(JU);
Rn(YU);
Rn(QU);
Rn(ae());
Rs(ye({
  total: ae(),
  circulating: ae(),
  nonCirculating: ae(),
  nonCirculatingAccounts: Te(kn)
}));
const tL = ye({
  amount: we(),
  uiAmount: Pe(ae()),
  decimals: ae(),
  uiAmountString: We(we())
});
Rs(Te(ye({
  address: kn,
  amount: we(),
  uiAmount: Pe(ae()),
  decimals: ae(),
  uiAmountString: We(we())
})));
Rs(Te(ye({
  pubkey: kn,
  account: ye({
    executable: Tn(),
    owner: kn,
    lamports: ae(),
    data: fw,
    rentEpoch: ae()
  })
})));
const yv = ye({
  program: we(),
  parsed: aa(),
  space: ae()
});
Rs(Te(ye({
  pubkey: kn,
  account: ye({
    executable: Tn(),
    owner: kn,
    lamports: ae(),
    data: yv,
    rentEpoch: ae()
  })
})));
Rs(Te(ye({
  lamports: ae(),
  address: kn
})));
const dw = ye({
  executable: Tn(),
  owner: kn,
  lamports: ae(),
  data: fw,
  rentEpoch: ae()
});
ye({
  pubkey: kn,
  account: dw
});
const rL = oa(jr([gf(Fe.Buffer), yv]), jr([n9, yv]), (t) => Array.isArray(t) ? He(t, fw) : t), nL = ye({
  executable: Tn(),
  owner: kn,
  lamports: ae(),
  data: rL,
  rentEpoch: ae()
});
ye({
  pubkey: kn,
  account: nL
});
ye({
  state: jr([Pt("active"), Pt("inactive"), Pt("activating"), Pt("deactivating")]),
  active: ae(),
  inactive: ae()
});
Rn(Te(ye({
  signature: we(),
  slot: ae(),
  err: $c,
  memo: Pe(we()),
  blockTime: We(Pe(ae()))
})));
Rn(Te(ye({
  signature: we(),
  slot: ae(),
  err: $c,
  memo: Pe(we()),
  blockTime: We(Pe(ae()))
})));
ye({
  subscription: ae(),
  result: G0(dw)
});
const iL = ye({
  pubkey: kn,
  account: dw
});
ye({
  subscription: ae(),
  result: G0(iL)
});
const sL = ye({
  parent: ae(),
  slot: ae(),
  root: ae()
});
ye({
  subscription: ae(),
  result: sL
});
const aL = jr([ye({
  type: jr([Pt("firstShredReceived"), Pt("completed"), Pt("optimisticConfirmation"), Pt("root")]),
  slot: ae(),
  timestamp: ae()
}), ye({
  type: Pt("createdBank"),
  parent: ae(),
  slot: ae(),
  timestamp: ae()
}), ye({
  type: Pt("frozen"),
  slot: ae(),
  timestamp: ae(),
  stats: ye({
    numTransactionEntries: ae(),
    numSuccessfulTransactions: ae(),
    numFailedTransactions: ae(),
    maxTransactionsPerEntry: ae()
  })
}), ye({
  type: Pt("dead"),
  slot: ae(),
  timestamp: ae(),
  err: we()
})]);
ye({
  subscription: ae(),
  result: aL
});
ye({
  subscription: ae(),
  result: G0(jr([XU, eL]))
});
ye({
  subscription: ae(),
  result: ae()
});
ye({
  pubkey: we(),
  gossip: Pe(we()),
  tpu: Pe(we()),
  rpc: Pe(we()),
  version: Pe(we())
});
const D6 = ye({
  votePubkey: we(),
  nodePubkey: we(),
  activatedStake: ae(),
  epochVoteAccount: Tn(),
  epochCredits: Te(mf([ae(), ae(), ae()])),
  commission: ae(),
  lastVote: ae(),
  rootSlot: Pe(ae())
});
Rn(ye({
  current: Te(D6),
  delinquent: Te(D6)
}));
const oL = jr([Pt("processed"), Pt("confirmed"), Pt("finalized")]), cL = ye({
  slot: ae(),
  confirmations: Pe(ae()),
  err: $c,
  confirmationStatus: We(oL)
});
Rs(Te(Pe(cL)));
Rn(ae());
const s9 = ye({
  accountKey: kn,
  writableIndexes: Te(ae()),
  readonlyIndexes: Te(ae())
}), lw = ye({
  signatures: Te(we()),
  message: ye({
    accountKeys: Te(we()),
    header: ye({
      numRequiredSignatures: ae(),
      numReadonlySignedAccounts: ae(),
      numReadonlyUnsignedAccounts: ae()
    }),
    instructions: Te(ye({
      accounts: Te(ae()),
      data: we(),
      programIdIndex: ae()
    })),
    recentBlockhash: we(),
    addressTableLookups: We(Te(s9))
  })
}), a9 = ye({
  parsed: aa(),
  program: we(),
  programId: kn
}), o9 = ye({
  accounts: Te(kn),
  data: we(),
  programId: kn
}), uL = jr([o9, a9]), fL = jr([ye({
  parsed: aa(),
  program: we(),
  programId: we()
}), ye({
  accounts: Te(we()),
  data: we(),
  programId: we()
})]), c9 = oa(uL, fL, (t) => "accounts" in t ? He(t, o9) : He(t, a9)), dL = ye({
  signatures: Te(we()),
  message: ye({
    accountKeys: Te(ye({
      pubkey: kn,
      signer: Tn(),
      writable: Tn(),
      source: We(jr([Pt("transaction"), Pt("lookupTable")]))
    })),
    instructions: Te(c9),
    recentBlockhash: we(),
    addressTableLookups: We(Pe(Te(s9)))
  })
}), _p = ye({
  accountIndex: ae(),
  mint: we(),
  owner: We(we()),
  uiTokenAmount: tL
}), u9 = ye({
  writable: Te(kn),
  readonly: Te(kn)
}), hw = ye({
  err: $c,
  fee: ae(),
  innerInstructions: We(Pe(Te(ye({
    index: ae(),
    instructions: Te(ye({
      accounts: Te(ae()),
      data: we(),
      programIdIndex: ae()
    }))
  })))),
  preBalances: Te(ae()),
  postBalances: Te(ae()),
  logMessages: We(Pe(Te(we()))),
  preTokenBalances: We(Pe(Te(_p))),
  postTokenBalances: We(Pe(Te(_p))),
  loadedAddresses: We(u9),
  computeUnitsConsumed: We(ae())
}), lL = ye({
  err: $c,
  fee: ae(),
  innerInstructions: We(Pe(Te(ye({
    index: ae(),
    instructions: Te(c9)
  })))),
  preBalances: Te(ae()),
  postBalances: Te(ae()),
  logMessages: We(Pe(Te(we()))),
  preTokenBalances: We(Pe(Te(_p))),
  postTokenBalances: We(Pe(Te(_p))),
  loadedAddresses: We(u9),
  computeUnitsConsumed: We(ae())
}), pw = jr([Pt(0), Pt("legacy")]);
Rn(Pe(ye({
  blockhash: we(),
  previousBlockhash: we(),
  parentSlot: ae(),
  transactions: Te(ye({
    transaction: lw,
    meta: Pe(hw),
    version: We(pw)
  })),
  rewards: We(Te(ye({
    pubkey: we(),
    lamports: ae(),
    postBalance: Pe(ae()),
    rewardType: Pe(we())
  }))),
  blockTime: Pe(ae()),
  blockHeight: Pe(ae())
})));
Rn(Pe(ye({
  blockhash: we(),
  previousBlockhash: we(),
  parentSlot: ae(),
  transactions: Te(ye({
    transaction: lw,
    meta: Pe(hw)
  })),
  rewards: We(Te(ye({
    pubkey: we(),
    lamports: ae(),
    postBalance: Pe(ae()),
    rewardType: Pe(we())
  }))),
  blockTime: Pe(ae())
})));
Rn(Pe(ye({
  blockhash: we(),
  previousBlockhash: we(),
  parentSlot: ae(),
  signatures: Te(we()),
  blockTime: Pe(ae())
})));
Rn(Pe(ye({
  slot: ae(),
  meta: hw,
  blockTime: We(Pe(ae())),
  transaction: lw,
  version: We(pw)
})));
Rn(Pe(ye({
  slot: ae(),
  transaction: dL,
  meta: Pe(lL),
  blockTime: We(Pe(ae())),
  version: We(pw)
})));
Rs(ye({
  blockhash: we(),
  feeCalculator: ye({
    lamportsPerSignature: ae()
  })
}));
Rs(ye({
  blockhash: we(),
  lastValidBlockHeight: ae()
}));
const hL = ye({
  slot: ae(),
  numTransactions: ae(),
  numSlots: ae(),
  samplePeriodSecs: ae()
});
Rn(Te(hL));
Rs(Pe(ye({
  feeCalculator: ye({
    lamportsPerSignature: ae()
  })
})));
Rn(we());
Rn(we());
const pL = ye({
  err: $c,
  logs: Te(we()),
  signature: we()
});
ye({
  result: G0(pL),
  subscription: ae()
});
Object.freeze({
  CreateLookupTable: {
    index: 0,
    layout: Re([Be("instruction"), Ku("recentSlot"), st("bumpSeed")])
  },
  FreezeLookupTable: {
    index: 1,
    layout: Re([Be("instruction")])
  },
  ExtendLookupTable: {
    index: 2,
    layout: Re([Be("instruction"), Ku(), Ir(rr(), Ii(Be(), -8), "addresses")])
  },
  DeactivateLookupTable: {
    index: 3,
    layout: Re([Be("instruction")])
  },
  CloseLookupTable: {
    index: 4,
    layout: Re([Be("instruction")])
  }
});
new Gt("AddressLookupTab1e1111111111111111111111111");
Object.freeze({
  RequestUnits: {
    index: 0,
    layout: Re([st("instruction"), Be("units"), Be("additionalFee")])
  },
  RequestHeapFrame: {
    index: 1,
    layout: Re([st("instruction"), Be("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: Re([st("instruction"), Be("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: Re([st("instruction"), Ku("microLamports")])
  }
});
new Gt("ComputeBudget111111111111111111111111111111");
Re([st("numSignatures"), st("padding"), rn("signatureOffset"), rn("signatureInstructionIndex"), rn("publicKeyOffset"), rn("publicKeyInstructionIndex"), rn("messageDataOffset"), rn("messageDataSize"), rn("messageInstructionIndex")]);
new Gt("Ed25519SigVerify111111111111111111111111111");
var yL = {}, bL = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yL
});
/*! noble-secp256k1 - MIT License (c) 2019 Paul Miller (paulmillr.com) */
const Pr = BigInt(0), en = BigInt(1), ao = BigInt(2), id = BigInt(3), gL = BigInt(8), bn = Object.freeze({
  a: Pr,
  b: BigInt(7),
  P: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
  n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
  h: en,
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee")
});
function F6(t) {
  const { a: e, b: r } = bn, n = dt(t * t), i = dt(n * t);
  return dt(i + e * t + r);
}
const hh = bn.a === Pr;
class mL extends Error {
  constructor(e) {
    super(e);
  }
}
class Nr {
  constructor(e, r, n) {
    this.x = e, this.y = r, this.z = n;
  }
  static fromAffine(e) {
    if (!(e instanceof An))
      throw new TypeError("JacobianPoint#fromAffine: expected Point");
    return new Nr(e.x, e.y, en);
  }
  static toAffineBatch(e) {
    const r = EL(e.map((n) => n.z));
    return e.map((n, i) => n.toAffine(r[i]));
  }
  static normalizeZ(e) {
    return Nr.toAffineBatch(e).map(Nr.fromAffine);
  }
  equals(e) {
    if (!(e instanceof Nr))
      throw new TypeError("JacobianPoint expected");
    const { x: r, y: n, z: i } = this, { x: s, y: a, z: o } = e, c = dt(i * i), f = dt(o * o), u = dt(r * f), d = dt(s * c), l = dt(dt(n * o) * f), h = dt(dt(a * i) * c);
    return u === d && l === h;
  }
  negate() {
    return new Nr(this.x, dt(-this.y), this.z);
  }
  double() {
    const { x: e, y: r, z: n } = this, i = dt(e * e), s = dt(r * r), a = dt(s * s), o = e + s, c = dt(ao * (dt(o * o) - i - a)), f = dt(id * i), u = dt(f * f), d = dt(u - ao * c), l = dt(f * (c - d) - gL * a), h = dt(ao * r * n);
    return new Nr(d, l, h);
  }
  add(e) {
    if (!(e instanceof Nr))
      throw new TypeError("JacobianPoint expected");
    const { x: r, y: n, z: i } = this, { x: s, y: a, z: o } = e;
    if (s === Pr || a === Pr)
      return this;
    if (r === Pr || n === Pr)
      return e;
    const c = dt(i * i), f = dt(o * o), u = dt(r * f), d = dt(s * c), l = dt(dt(n * o) * f), h = dt(dt(a * i) * c), y = dt(d - u), p = dt(h - l);
    if (y === Pr)
      return p === Pr ? this.double() : Nr.ZERO;
    const b = dt(y * y), v = dt(y * b), x = dt(u * b), I = dt(p * p - v - ao * x), L = dt(p * (x - I) - l * v), P = dt(i * o * y);
    return new Nr(I, L, P);
  }
  subtract(e) {
    return this.add(e.negate());
  }
  multiplyUnsafe(e) {
    const r = Nr.ZERO;
    if (typeof e == "bigint" && e === Pr)
      return r;
    let n = W6(e);
    if (n === en)
      return this;
    if (!hh) {
      let d = r, l = this;
      for (; n > Pr; )
        n & en && (d = d.add(l)), l = l.double(), n >>= en;
      return d;
    }
    let { k1neg: i, k1: s, k2neg: a, k2: o } = K6(n), c = r, f = r, u = this;
    for (; s > Pr || o > Pr; )
      s & en && (c = c.add(u)), o & en && (f = f.add(u)), u = u.double(), s >>= en, o >>= en;
    return i && (c = c.negate()), a && (f = f.negate()), f = new Nr(dt(f.x * bn.beta), f.y, f.z), c.add(f);
  }
  precomputeWindow(e) {
    const r = hh ? 128 / e + 1 : 256 / e + 1, n = [];
    let i = this, s = i;
    for (let a = 0; a < r; a++) {
      s = i, n.push(s);
      for (let o = 1; o < 2 ** (e - 1); o++)
        s = s.add(i), n.push(s);
      i = s.double();
    }
    return n;
  }
  wNAF(e, r) {
    !r && this.equals(Nr.BASE) && (r = An.BASE);
    const n = r && r._WINDOW_SIZE || 1;
    if (256 % n)
      throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
    let i = r && bv.get(r);
    i || (i = this.precomputeWindow(n), r && n !== 1 && (i = Nr.normalizeZ(i), bv.set(r, i)));
    let s = Nr.ZERO, a = Nr.ZERO;
    const o = 1 + (hh ? 128 / n : 256 / n), c = 2 ** (n - 1), f = BigInt(2 ** n - 1), u = 2 ** n, d = BigInt(n);
    for (let l = 0; l < o; l++) {
      const h = l * c;
      let y = Number(e & f);
      if (e >>= d, y > c && (y -= u, e += en), y === 0) {
        let p = i[h];
        l % 2 && (p = p.negate()), a = a.add(p);
      } else {
        let p = i[h + Math.abs(y) - 1];
        y < 0 && (p = p.negate()), s = s.add(p);
      }
    }
    return { p: s, f: a };
  }
  multiply(e, r) {
    let n = W6(e), i, s;
    if (hh) {
      const { k1neg: a, k1: o, k2neg: c, k2: f } = K6(n);
      let { p: u, f: d } = this.wNAF(o, r), { p: l, f: h } = this.wNAF(f, r);
      a && (u = u.negate()), c && (l = l.negate()), l = new Nr(dt(l.x * bn.beta), l.y, l.z), i = u.add(l), s = d.add(h);
    } else {
      const { p: a, f: o } = this.wNAF(n, r);
      i = a, s = o;
    }
    return Nr.normalizeZ([i, s])[0];
  }
  toAffine(e = Z0(this.z)) {
    const { x: r, y: n, z: i } = this, s = e, a = dt(s * s), o = dt(a * s), c = dt(r * a), f = dt(n * o);
    if (dt(i * s) !== en)
      throw new Error("invZ was invalid");
    return new An(c, f);
  }
}
Nr.BASE = new Nr(bn.Gx, bn.Gy, en);
Nr.ZERO = new Nr(Pr, en, Pr);
const bv = /* @__PURE__ */ new WeakMap();
class An {
  constructor(e, r) {
    this.x = e, this.y = r;
  }
  _setWindowSize(e) {
    this._WINDOW_SIZE = e, bv.delete(this);
  }
  hasEvenY() {
    return this.y % ao === Pr;
  }
  static fromCompressedHex(e) {
    const r = e.length === 32, n = hc(r ? e : e.subarray(1));
    if (!ug(n))
      throw new Error("Point is not on curve");
    const i = F6(n);
    let s = SL(i);
    const a = (s & en) === en;
    r ? a && (s = dt(-s)) : (e[0] & 1) === 1 !== a && (s = dt(-s));
    const o = new An(n, s);
    return o.assertValidity(), o;
  }
  static fromUncompressedHex(e) {
    const r = hc(e.subarray(1, 33)), n = hc(e.subarray(33, 65)), i = new An(r, n);
    return i.assertValidity(), i;
  }
  static fromHex(e) {
    const r = gv(e), n = r.length, i = r[0];
    if (n === 32 || n === 33 && (i === 2 || i === 3))
      return this.fromCompressedHex(r);
    if (n === 65 && i === 4)
      return this.fromUncompressedHex(r);
    throw new Error(`Point.fromHex: received invalid point. Expected 32-33 compressed bytes or 65 uncompressed bytes, not ${n}`);
  }
  static fromPrivateKey(e) {
    return An.BASE.multiply(mv(e));
  }
  static fromSignature(e, r, n) {
    e = gv(e);
    const i = AL(e), { r: s, s: a } = IL(r);
    if (n !== 0 && n !== 1)
      throw new Error("Cannot recover signature: invalid recovery bit");
    const o = n & 1 ? "03" : "02", c = An.fromHex(o + Au(s)), { n: f } = bn, u = Z0(s, f), d = dt(-i * u, f), l = dt(a * u, f), h = An.BASE.multiplyAndAddUnsafe(c, d, l);
    if (!h)
      throw new Error("Cannot recover signature: point at infinify");
    return h.assertValidity(), h;
  }
  toRawBytes(e = !1) {
    return lc(this.toHex(e));
  }
  toHex(e = !1) {
    const r = Au(this.x);
    return e ? `${this.hasEvenY() ? "02" : "03"}${r}` : `04${r}${Au(this.y)}`;
  }
  toHexX() {
    return this.toHex(!0).slice(2);
  }
  toRawX() {
    return this.toRawBytes(!0).slice(1);
  }
  assertValidity() {
    const e = "Point is not on elliptic curve", { x: r, y: n } = this;
    if (!ug(r) || !ug(n))
      throw new Error(e);
    const i = dt(n * n), s = F6(r);
    if (dt(i - s) !== Pr)
      throw new Error(e);
  }
  equals(e) {
    return this.x === e.x && this.y === e.y;
  }
  negate() {
    return new An(this.x, dt(-this.y));
  }
  double() {
    return Nr.fromAffine(this).double().toAffine();
  }
  add(e) {
    return Nr.fromAffine(this).add(Nr.fromAffine(e)).toAffine();
  }
  subtract(e) {
    return this.add(e.negate());
  }
  multiply(e) {
    return Nr.fromAffine(this).multiply(e, this).toAffine();
  }
  multiplyAndAddUnsafe(e, r, n) {
    const i = Nr.fromAffine(this), s = r === Pr || r === en || this !== An.BASE ? i.multiplyUnsafe(r) : i.multiply(r), a = Nr.fromAffine(e).multiplyUnsafe(n), o = s.add(a);
    return o.equals(Nr.ZERO) ? void 0 : o.toAffine();
  }
}
An.BASE = new An(bn.Gx, bn.Gy);
An.ZERO = new An(Pr, Pr);
function j6(t) {
  return Number.parseInt(t[0], 16) >= 8 ? "00" + t : t;
}
function $6(t) {
  if (t.length < 2 || t[0] !== 2)
    throw new Error(`Invalid signature integer tag: ${Vu(t)}`);
  const e = t[1], r = t.subarray(2, e + 2);
  if (!e || r.length !== e)
    throw new Error("Invalid signature integer: wrong length");
  if (r[0] === 0 && r[1] <= 127)
    throw new Error("Invalid signature integer: trailing length");
  return { data: hc(r), left: t.subarray(e + 2) };
}
function vL(t) {
  if (t.length < 2 || t[0] != 48)
    throw new Error(`Invalid signature tag: ${Vu(t)}`);
  if (t[1] !== t.length - 2)
    throw new Error("Invalid signature: incorrect length");
  const { data: e, left: r } = $6(t.subarray(2)), { data: n, left: i } = $6(r);
  if (i.length)
    throw new Error(`Invalid signature: left bytes after parsing: ${Vu(i)}`);
  return { r: e, s: n };
}
class dc {
  constructor(e, r) {
    this.r = e, this.s = r, this.assertValidity();
  }
  static fromCompact(e) {
    const r = e instanceof Uint8Array, n = "Signature.fromCompact";
    if (typeof e != "string" && !r)
      throw new TypeError(`${n}: Expected string or Uint8Array`);
    const i = r ? Vu(e) : e;
    if (i.length !== 128)
      throw new Error(`${n}: Expected 64-byte hex`);
    return new dc(Sp(i.slice(0, 64)), Sp(i.slice(64, 128)));
  }
  static fromDER(e) {
    const r = e instanceof Uint8Array;
    if (typeof e != "string" && !r)
      throw new TypeError("Signature.fromDER: Expected string or Uint8Array");
    const { r: n, s: i } = vL(r ? e : lc(e));
    return new dc(n, i);
  }
  static fromHex(e) {
    return this.fromDER(e);
  }
  assertValidity() {
    const { r: e, s: r } = this;
    if (!Ep(e))
      throw new Error("Invalid Signature: r must be 0 < r < n");
    if (!Ep(r))
      throw new Error("Invalid Signature: s must be 0 < s < n");
  }
  hasHighS() {
    const e = bn.n >> en;
    return this.s > e;
  }
  normalizeS() {
    return this.hasHighS() ? new dc(this.r, bn.n - this.s) : this;
  }
  toDERRawBytes(e = !1) {
    return lc(this.toDERHex(e));
  }
  toDERHex(e = !1) {
    const r = j6(Wf(this.s));
    if (e)
      return r;
    const n = j6(Wf(this.r)), i = Wf(n.length / 2), s = Wf(r.length / 2);
    return `30${Wf(n.length / 2 + r.length / 2 + 4)}02${i}${n}02${s}${r}`;
  }
  toRawBytes() {
    return this.toDERRawBytes();
  }
  toHex() {
    return this.toDERHex();
  }
  toCompactRawBytes() {
    return lc(this.toCompactHex());
  }
  toCompactHex() {
    return Au(this.r) + Au(this.s);
  }
}
function qf(...t) {
  if (!t.every((n) => n instanceof Uint8Array))
    throw new Error("Uint8Array list expected");
  if (t.length === 1)
    return t[0];
  const e = t.reduce((n, i) => n + i.length, 0), r = new Uint8Array(e);
  for (let n = 0, i = 0; n < t.length; n++) {
    const s = t[n];
    r.set(s, i), i += s.length;
  }
  return r;
}
const wL = Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function Vu(t) {
  if (!(t instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  let e = "";
  for (let r = 0; r < t.length; r++)
    e += wL[t[r]];
  return e;
}
const _L = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
function Au(t) {
  if (typeof t != "bigint")
    throw new Error("Expected bigint");
  if (!(Pr <= t && t < _L))
    throw new Error("Expected number < 2^256");
  return t.toString(16).padStart(64, "0");
}
function q6(t) {
  const e = lc(Au(t));
  if (e.length !== 32)
    throw new Error("Error: expected 32 bytes");
  return e;
}
function Wf(t) {
  const e = t.toString(16);
  return e.length & 1 ? `0${e}` : e;
}
function Sp(t) {
  if (typeof t != "string")
    throw new TypeError("hexToNumber: expected string, got " + typeof t);
  return BigInt(`0x${t}`);
}
function lc(t) {
  if (typeof t != "string")
    throw new TypeError("hexToBytes: expected string, got " + typeof t);
  if (t.length % 2)
    throw new Error("hexToBytes: received invalid unpadded hex" + t.length);
  const e = new Uint8Array(t.length / 2);
  for (let r = 0; r < e.length; r++) {
    const n = r * 2, i = t.slice(n, n + 2), s = Number.parseInt(i, 16);
    if (Number.isNaN(s) || s < 0)
      throw new Error("Invalid byte sequence");
    e[r] = s;
  }
  return e;
}
function hc(t) {
  return Sp(Vu(t));
}
function gv(t) {
  return t instanceof Uint8Array ? Uint8Array.from(t) : lc(t);
}
function W6(t) {
  if (typeof t == "number" && Number.isSafeInteger(t) && t > 0)
    return BigInt(t);
  if (typeof t == "bigint" && Ep(t))
    return t;
  throw new TypeError("Expected valid private scalar: 0 < scalar < curve.n");
}
function dt(t, e = bn.P) {
  const r = t % e;
  return r >= Pr ? r : e + r;
}
function Zi(t, e) {
  const { P: r } = bn;
  let n = t;
  for (; e-- > Pr; )
    n *= n, n %= r;
  return n;
}
function SL(t) {
  const { P: e } = bn, r = BigInt(6), n = BigInt(11), i = BigInt(22), s = BigInt(23), a = BigInt(44), o = BigInt(88), c = t * t * t % e, f = c * c * t % e, u = Zi(f, id) * f % e, d = Zi(u, id) * f % e, l = Zi(d, ao) * c % e, h = Zi(l, n) * l % e, y = Zi(h, i) * h % e, p = Zi(y, a) * y % e, b = Zi(p, o) * p % e, v = Zi(b, a) * y % e, x = Zi(v, id) * f % e, I = Zi(x, s) * h % e, L = Zi(I, r) * c % e;
  return Zi(L, ao);
}
function Z0(t, e = bn.P) {
  if (t === Pr || e <= Pr)
    throw new Error(`invert: expected positive integers, got n=${t} mod=${e}`);
  let r = dt(t, e), n = e, i = Pr, s = en;
  for (; r !== Pr; ) {
    const o = n / r, c = n % r, f = i - s * o;
    n = r, r = c, i = s, s = f;
  }
  if (n !== en)
    throw new Error("invert: does not exist");
  return dt(i, e);
}
function EL(t, e = bn.P) {
  const r = new Array(t.length), n = t.reduce((s, a, o) => a === Pr ? s : (r[o] = s, dt(s * a, e)), en), i = Z0(n, e);
  return t.reduceRight((s, a, o) => a === Pr ? s : (r[o] = dt(s * r[o], e), dt(s * a, e)), i), r;
}
const z6 = (t, e) => (t + e / ao) / e, xL = {
  a1: BigInt("0x3086d221a7d46bcde86c90e49284eb15"),
  b1: -en * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"),
  a2: BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"),
  b2: BigInt("0x3086d221a7d46bcde86c90e49284eb15"),
  POW_2_128: BigInt("0x100000000000000000000000000000000")
};
function K6(t) {
  const { n: e } = bn, { a1: r, b1: n, a2: i, b2: s, POW_2_128: a } = xL, o = z6(s * t, e), c = z6(-n * t, e);
  let f = dt(t - o * r - c * i, e), u = dt(-o * n - c * s, e);
  const d = f > a, l = u > a;
  if (d && (f = e - f), l && (u = e - u), f > a || u > a)
    throw new Error("splitScalarEndo: Endomorphism failed, k=" + t);
  return { k1neg: d, k1: f, k2neg: l, k2: u };
}
function AL(t) {
  const { n: e } = bn, n = t.length * 8 - 256;
  let i = hc(t);
  return n > 0 && (i = i >> BigInt(n)), i >= e && (i -= e), i;
}
let Iu, cg;
function Ep(t) {
  return Pr < t && t < bn.n;
}
function ug(t) {
  return Pr < t && t < bn.P;
}
function mv(t) {
  let e;
  if (typeof t == "bigint")
    e = t;
  else if (typeof t == "number" && Number.isSafeInteger(t) && t > 0)
    e = BigInt(t);
  else if (typeof t == "string") {
    if (t.length !== 64)
      throw new Error("Expected 32 bytes of private key");
    e = Sp(t);
  } else if (t instanceof Uint8Array) {
    if (t.length !== 32)
      throw new Error("Expected 32 bytes of private key");
    e = hc(t);
  } else
    throw new TypeError("Expected valid private key");
  if (!Ep(e))
    throw new Error("Expected private key: 0 < key < n");
  return e;
}
function IL(t) {
  if (t instanceof dc)
    return t.assertValidity(), t;
  try {
    return dc.fromDER(t);
  } catch {
    return dc.fromCompact(t);
  }
}
An.BASE._setWindowSize(8);
const Pi = {
  node: bL,
  web: typeof self == "object" && "crypto" in self ? self.crypto : void 0
}, ph = {}, Jo = {
  bytesToHex: Vu,
  hexToBytes: lc,
  concatBytes: qf,
  mod: dt,
  invert: Z0,
  isValidPrivateKey(t) {
    try {
      return mv(t), !0;
    } catch {
      return !1;
    }
  },
  _bigintTo32Bytes: q6,
  _normalizePrivateKey: mv,
  hashToPrivateKey: (t) => {
    if (t = gv(t), t.length < 40 || t.length > 1024)
      throw new Error("Expected 40-1024 bytes of private key as per FIPS 186");
    const e = dt(hc(t), bn.n - en) + en;
    return q6(e);
  },
  randomBytes: (t = 32) => {
    if (Pi.web)
      return Pi.web.getRandomValues(new Uint8Array(t));
    if (Pi.node) {
      const { randomBytes: e } = Pi.node;
      return Uint8Array.from(e(t));
    } else
      throw new Error("The environment doesn't have randomBytes function");
  },
  randomPrivateKey: () => Jo.hashToPrivateKey(Jo.randomBytes(40)),
  sha256: async (...t) => {
    if (Pi.web) {
      const e = await Pi.web.subtle.digest("SHA-256", qf(...t));
      return new Uint8Array(e);
    } else if (Pi.node) {
      const { createHash: e } = Pi.node, r = e("sha256");
      return t.forEach((n) => r.update(n)), Uint8Array.from(r.digest());
    } else
      throw new Error("The environment doesn't have sha256 function");
  },
  hmacSha256: async (t, ...e) => {
    if (Pi.web) {
      const r = await Pi.web.subtle.importKey("raw", t, { name: "HMAC", hash: { name: "SHA-256" } }, !1, ["sign"]), n = qf(...e), i = await Pi.web.subtle.sign("HMAC", r, n);
      return new Uint8Array(i);
    } else if (Pi.node) {
      const { createHmac: r } = Pi.node, n = r("sha256", t);
      return e.forEach((i) => n.update(i)), Uint8Array.from(n.digest());
    } else
      throw new Error("The environment doesn't have hmac-sha256 function");
  },
  sha256Sync: void 0,
  hmacSha256Sync: void 0,
  taggedHash: async (t, ...e) => {
    let r = ph[t];
    if (r === void 0) {
      const n = await Jo.sha256(Uint8Array.from(t, (i) => i.charCodeAt(0)));
      r = qf(n, n), ph[t] = r;
    }
    return Jo.sha256(r, ...e);
  },
  taggedHashSync: (t, ...e) => {
    if (typeof Iu != "function")
      throw new mL("sha256Sync is undefined, you need to set it");
    let r = ph[t];
    if (r === void 0) {
      const n = Iu(Uint8Array.from(t, (i) => i.charCodeAt(0)));
      r = qf(n, n), ph[t] = r;
    }
    return Iu(r, ...e);
  },
  precompute(t = 8, e = An.BASE) {
    const r = e === An.BASE ? e : new An(e.x, e.y);
    return r._setWindowSize(t), r.multiply(id), r;
  }
};
Object.defineProperties(Jo, {
  sha256Sync: {
    configurable: !1,
    get() {
      return Iu;
    },
    set(t) {
      Iu || (Iu = t);
    }
  },
  hmacSha256Sync: {
    configurable: !1,
    get() {
      return cg;
    },
    set(t) {
      cg || (cg = t);
    }
  }
});
Jo.hmacSha256Sync = (t, ...e) => {
  const r = PM("sha256", t);
  return e.forEach((n) => r.update(n)), new Uint8Array(r.digest());
};
Jo.isValidPrivateKey;
Re([st("numSignatures"), rn("signatureOffset"), st("signatureInstructionIndex"), rn("ethAddressOffset"), st("ethAddressInstructionIndex"), rn("messageDataOffset"), rn("messageDataSize"), st("messageInstructionIndex"), xt(20, "ethAddress"), xt(64, "signature"), st("recoveryId")]);
new Gt("KeccakSecp256k11111111111111111111111111111");
new Gt("StakeConfig11111111111111111111111111111111");
let V6 = class {
  /** Unix timestamp of lockup expiration */
  /** Epoch of lockup expiration */
  /** Lockup custodian authority */
  /**
   * Create a new Lockup object
   */
  constructor(e, r, n) {
    this.unixTimestamp = void 0, this.epoch = void 0, this.custodian = void 0, this.unixTimestamp = e, this.epoch = r, this.custodian = n;
  }
  /**
   * Default, inactive Lockup value
   */
};
V6.default = new V6(0, 0, Gt.default);
Object.freeze({
  Initialize: {
    index: 0,
    layout: Re([Be("instruction"), OU(), BU()])
  },
  Authorize: {
    index: 1,
    layout: Re([Be("instruction"), rr("newAuthorized"), Be("stakeAuthorizationType")])
  },
  Delegate: {
    index: 2,
    layout: Re([Be("instruction")])
  },
  Split: {
    index: 3,
    layout: Re([Be("instruction"), Gr("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: Re([Be("instruction"), Gr("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: Re([Be("instruction")])
  },
  Merge: {
    index: 7,
    layout: Re([Be("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: Re([Be("instruction"), rr("newAuthorized"), Be("stakeAuthorizationType"), gu("authoritySeed"), rr("authorityOwner")])
  }
});
new Gt("Stake11111111111111111111111111111111111111");
Object.freeze({
  InitializeAccount: {
    index: 0,
    layout: Re([Be("instruction"), MU()])
  },
  Authorize: {
    index: 1,
    layout: Re([Be("instruction"), rr("newAuthorized"), Be("voteAuthorizationType")])
  },
  Withdraw: {
    index: 3,
    layout: Re([Be("instruction"), Gr("lamports")])
  },
  AuthorizeWithSeed: {
    index: 10,
    layout: Re([Be("instruction"), CU()])
  }
});
new Gt("Vote111111111111111111111111111111111111111");
new Gt("Va1idator1nfo111111111111111111111111111111");
ye({
  name: we(),
  website: We(we()),
  details: We(we()),
  keybaseUsername: We(we())
});
new Gt("Vote111111111111111111111111111111111111111");
Re([
  rr("nodePubkey"),
  rr("authorizedWithdrawer"),
  st("commission"),
  gr(),
  // votes.length
  Ir(Re([gr("slot"), Be("confirmationCount")]), Ii(Be(), -8), "votes"),
  st("rootSlotValid"),
  gr("rootSlot"),
  gr(),
  // authorizedVoters.length
  Ir(Re([gr("epoch"), rr("authorizedVoter")]), Ii(Be(), -8), "authorizedVoters"),
  Re([Ir(Re([rr("authorizedPubkey"), gr("epochOfLastAuthorizedSwitch"), gr("targetEpoch")]), 32, "buf"), gr("idx"), st("isEmpty")], "priorVoters"),
  gr(),
  // epochCredits.length
  Ir(Re([gr("epoch"), gr("credits"), gr("prevCredits")]), Ii(Be(), -8), "epochCredits"),
  Re([gr("slot"), gr("timestamp")], "lastTimestamp")
]);
let pc;
if (typeof Error.captureStackTrace < "u")
  pc = Error.captureStackTrace.bind(Error);
else
  try {
    const t = (i) => {
      try {
        throw new Error(i);
      } catch (s) {
        return s;
      }
    }, e = (i) => i.stack || i.stacktrace, r = e(t("Marker"));
    if (!r)
      throw new Error("No Error.prototype.stack");
    const n = /Marker/.test(r.split(`
`)[0]);
    pc = function(i) {
      const s = e(t());
      if (s === void 0)
        return;
      const a = s.trim().split(`
`).slice(n ? 4 : 3);
      let o;
      Object.defineProperties(i, {
        stack: {
          configurable: !0,
          get: function() {
            return o !== void 0 || (o = [
              `${i.name || "Error"}: ${i.message || ""}`,
              ...a
            ].join(`
`)), o;
          }
        }
      });
    };
  } catch {
    pc = function(e) {
      let r;
      Object.defineProperties(e, {
        stack: {
          configurable: !0,
          get: function() {
            return r !== void 0 || (r = `${e.name || "Error"}: ${e.message || ""}`), r;
          }
        }
      });
    };
  }
class TL extends Error {
  constructor() {
    super("The Provider does not support the requested method.");
    Zt(this, "code");
    this.name = "UnsupportedMethodError", this.code = 4200, pc(this, this.constructor);
  }
}
class kL extends Error {
  constructor() {
    super("The Provider is disconnected from all chains.");
    Zt(this, "code");
    this.name = "DisconnectedError", this.code = 4900, pc(this, this.constructor);
  }
}
class RL extends Error {
  constructor(r) {
    super("Missing or invalid parameters.");
    Zt(this, "code");
    this.name = "InvalidInputError", this.code = -32e3, r && (this.message = r), pc(this, this.constructor);
  }
}
class PL extends Error {
  constructor() {
    super("The requested method is not recognized by the wallet.");
    Zt(this, "code");
    this.name = "MethodNotFoundError", this.code = -32601, pc(this, this.constructor);
  }
}
function OL(t) {
  return new Gt(t);
}
function BL(t) {
  return ve.from(t).toString("base64");
}
function ML(t) {
  if (t.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var e = new Uint8Array(256), r = 0; r < e.length; r++)
    e[r] = 255;
  for (var n = 0; n < t.length; n++) {
    var i = t.charAt(n), s = i.charCodeAt(0);
    if (e[s] !== 255)
      throw new TypeError(i + " is ambiguous");
    e[s] = n;
  }
  var a = t.length, o = t.charAt(0), c = Math.log(a) / Math.log(256), f = Math.log(256) / Math.log(a);
  function u(h) {
    if (h instanceof Uint8Array || (ArrayBuffer.isView(h) ? h = new Uint8Array(h.buffer, h.byteOffset, h.byteLength) : Array.isArray(h) && (h = Uint8Array.from(h))), !(h instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (h.length === 0)
      return "";
    for (var y = 0, p = 0, b = 0, v = h.length; b !== v && h[b] === 0; )
      b++, y++;
    for (var x = (v - b) * f + 1 >>> 0, I = new Uint8Array(x); b !== v; ) {
      for (var L = h[b], P = 0, C = x - 1; (L !== 0 || P < p) && C !== -1; C--, P++)
        L += 256 * I[C] >>> 0, I[C] = L % a >>> 0, L = L / a >>> 0;
      if (L !== 0)
        throw new Error("Non-zero carry");
      p = P, b++;
    }
    for (var D = x - p; D !== x && I[D] === 0; )
      D++;
    for (var F = o.repeat(y); D < x; ++D)
      F += t.charAt(I[D]);
    return F;
  }
  function d(h) {
    if (typeof h != "string")
      throw new TypeError("Expected String");
    if (h.length === 0)
      return new Uint8Array();
    for (var y = 0, p = 0, b = 0; h[y] === o; )
      p++, y++;
    for (var v = (h.length - y) * c + 1 >>> 0, x = new Uint8Array(v); h[y]; ) {
      var I = e[h.charCodeAt(y)];
      if (I === 255)
        return;
      for (var L = 0, P = v - 1; (I !== 0 || L < b) && P !== -1; P--, L++)
        I += a * x[P] >>> 0, x[P] = I % 256 >>> 0, I = I / 256 >>> 0;
      if (I !== 0)
        throw new Error("Non-zero carry");
      b = L, y++;
    }
    for (var C = v - b; C !== v && x[C] === 0; )
      C++;
    for (var D = new Uint8Array(p + (v - C)), F = p; C !== v; )
      D[F++] = x[C++];
    return D;
  }
  function l(h) {
    var y = d(h);
    if (y)
      return y;
    throw new Error("Non-base" + a + " character");
  }
  return {
    encode: u,
    decodeUnsafe: d,
    decode: l
  };
}
var CL = ML;
const NL = CL, UL = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var LL = NL(UL);
L0.sign.signatureLength;
function DL(t) {
  return LL.decode(t);
}
function FL(t) {
  return ve.from(t, "base64");
}
var J0 = {}, Y0 = {};
Object.defineProperty(Y0, "__esModule", {
  value: !0
});
Y0.default = void 0;
function f9(t, e, r) {
  return e = jL(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function jL(t) {
  var e = $L(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function $L(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
class oo {
  static update({
    preTime: e,
    postTime: r,
    serverTime: n
  }) {
    const i = n - (e + r) / 2;
    oo.clockOffset += i, oo.debug(`Synchronized time offset: ${oo.clockOffset} ms`);
  }
  static now() {
    return Math.floor(Date.now() + oo.clockOffset);
  }
}
Y0.default = oo;
f9(oo, "debug", () => {
});
f9(oo, "clockOffset", 0);
function qL(t, e = null) {
  if (t = t.trim(), t = t.includes(",") && t.includes(".") ? t.replace(/[^\d.]/g, "") : t.replace(/[^\d,.]/g, ""), t = t.replace(/,+/g, "."), t === "00" && (t = "0"), t === "." && (t = "0."), t = t.split(".").slice(0, 2).join("."), e !== null && t.includes(".")) {
    let [r, n] = t.split(".");
    if (e === 0)
      return r;
    n = n.slice(0, e), t = [r, n].join(".");
  }
  return t;
}
var WL = qL, yw = {}, fr = {};
Object.defineProperty(fr, "__esModule", {
  value: !0
});
fr.set = fr.pickBy = fr.pick = fr.partition = fr.orderBy = fr.omitBy = fr.omit = fr.mapValues = fr.mapKeys = fr.keyBy = fr.isPlainObject = fr.isObjectLike = fr.isNil = fr.intersection = fr.difference = void 0;
var La = zL(hr);
function zL(t) {
  return t && t.__esModule ? t : { default: t };
}
const d9 = (t) => (0, La.default)(Array.isArray(t), `expected Array, got ${typeof t}`), Q0 = (t) => (0, La.default)(typeof t == "function", `expected Function, got ${typeof t}`), KL = (t, e) => {
  d9(e);
  const r = new Set(e);
  return t == null ? /* @__PURE__ */ Object.create(null) : Object.fromEntries(Object.entries(t).filter(([n]) => r.has(n)));
};
fr.pick = KL;
const VL = (t, e) => (Q0(e), t == null ? /* @__PURE__ */ Object.create(null) : Object.fromEntries(Object.entries(t).filter(([, r]) => e(r))));
fr.pickBy = VL;
const HL = (t, e) => (d9(e), t == null ? /* @__PURE__ */ Object.create(null) : Object.fromEntries(Object.entries(t).filter(([r]) => !e.includes(r))));
fr.omit = HL;
const GL = (t, e) => (Q0(e), t ? Object.fromEntries(Object.entries(t).filter(([r, n]) => !e(n, r))) : /* @__PURE__ */ Object.create(null));
fr.omitBy = GL;
const ZL = (t, e) => (Q0(e), t == null ? /* @__PURE__ */ Object.create(null) : Object.fromEntries(Object.entries(t).map(([r, n]) => [e(n, r), n])));
fr.mapKeys = ZL;
const JL = (t, e) => (Q0(e), t == null ? /* @__PURE__ */ Object.create(null) : Object.fromEntries(Object.entries(t).map(([r, n]) => [r, e(n, r)])));
fr.mapValues = JL;
const YL = (t) => t == null;
fr.isNil = YL;
function QL(t, e) {
  return e || (e = () => 0), (r, n) => {
    const i = typeof t == "function" ? t(r) : r[t], s = typeof t == "function" ? t(n) : n[t];
    return i > s ? 1 : s > i ? -1 : e(r, n);
  };
}
function XL(t, e) {
  return e || (e = () => 0), (r, n) => {
    const i = typeof t == "function" ? t(n) : n[t], s = typeof t == "function" ? t(r) : r[t];
    return i > s ? 1 : s > i ? -1 : e(r, n);
  };
}
const eD = (t, e = [], r = []) => {
  const n = [...Array.isArray(e) ? e : [e]].reverse(), i = [...Array.isArray(r) ? r : [r]].reverse(), s = [...t];
  let a = () => 0;
  for (const [o, c] of n.entries()) {
    const f = i[o];
    if (f === "asc" || !f)
      a = QL(c, a);
    else if (f === "desc")
      a = XL(c, a);
    else
      throw new Error(`Unsupported order "${f}"`);
  }
  return s.sort(a);
};
fr.orderBy = eD;
const tD = (t, e) => {
  if (typeof e == "string") {
    const n = e;
    if (n in {})
      throw new Error("prototype key");
    e = (i) => i[n];
  }
  (0, La.default)(typeof e == "function", "expected key string or keying function");
  const r = (n) => {
    const i = e(n);
    if (typeof i == "string" && i in {})
      throw new Error("prototype key");
    return i;
  };
  return Object.fromEntries(t.map((n) => [r(n), n]));
};
fr.keyBy = tD;
const rD = (t) => t == null ? t === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(t), l9 = (t) => typeof t == "object" && t !== null;
fr.isObjectLike = l9;
const nD = (t) => {
  if (!l9(t) || rD(t) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(t) === null)
    return !0;
  let e = t;
  for (; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e;
};
fr.isPlainObject = nD;
const iD = (t, e) => {
  (0, La.default)(Array.isArray(t), "expected 1st argument to be an Array"), (0, La.default)(Array.isArray(e), "expected 2nd argument to be an Array");
  const r = new Set(e);
  return t.filter((n) => !r.has(n));
};
fr.difference = iD;
const sD = (t, e) => {
  (0, La.default)(Array.isArray(t), "expected 1st argument to be an Array"), (0, La.default)(Array.isArray(e), "expected 2nd argument to be an Array");
  const r = new Set(e);
  return t.filter((n) => r.has(n));
};
fr.intersection = sD;
const aD = (t, e) => {
  (0, La.default)(Array.isArray(t), "expected 1st argument to be an Array"), (0, La.default)(typeof e == "function", "expected 2nd argument to be a Function");
  const r = [], n = [];
  for (const i of t)
    e(i) ? r.push(i) : n.push(i);
  return [r, n];
};
fr.partition = aD;
const oD = (t, e, r) => {
  const n = Array.isArray(e) ? e : e.match(/([^.[\]])+/g);
  n.reduce((i, s, a) => {
    if (s in {})
      throw new Error("prototype pollution");
    return i[s] === void 0 && (i[s] = /* @__PURE__ */ Object.create(null)), a === n.length - 1 && (i[s] = r), i[s];
  }, t);
};
fr.set = oD;
Object.defineProperty(yw, "__esModule", {
  value: !0
});
yw.default = uD;
var cD = fr;
function uD(t) {
  const e = [];
  if (!t)
    return e;
  const r = (n, i = []) => {
    if ((0, cD.isPlainObject)(n)) {
      Object.entries(n).forEach(([s, a]) => r(a, [...i, s]));
      return;
    }
    e.push([...i, n]);
  };
  return r(t), e;
}
var lo = {};
Object.defineProperty(lo, "__esModule", {
  value: !0
});
lo.partitionAsync = lo.mapValuesAsync = lo.filterAsync = void 0;
var fD = fr;
const dD = async (t, e) => Object.fromEntries(await Promise.all(Object.entries(t).map(async ([r, n]) => [r, await e(n, r, t)])));
lo.mapValuesAsync = dD;
const lD = async (t, e) => {
  const r = await Promise.all(t.map((n, i, s) => e(n, i, s)));
  return t.filter((n, i) => r[i]);
};
lo.filterAsync = lD;
const hD = async (t, e) => {
  const r = await Promise.all(t.map((i, s, a) => e(i, s, a)));
  let n = 0;
  return (0, fD.partition)(t, () => r[n++]);
};
lo.partitionAsync = hD;
var X0 = {};
Object.defineProperty(X0, "__esModule", {
  value: !0
});
X0.default = void 0;
const h9 = (t, e, r = {}) => {
  if (!Number.isFinite(e))
    throw new TypeError("Expected `wait` to be a finite number");
  let n, i, s = [];
  return function(...a) {
    return new Promise((o) => {
      const c = r.before && !i;
      clearTimeout(i), i = setTimeout(() => {
        i = null;
        const f = r.before ? n : t.apply(this, a);
        for (o of s)
          o(f);
        s = [];
      }, e), c ? (n = t.apply(this, a), o(n)) : s.push(o);
    });
  };
};
h9.promise = (t) => {
  let e;
  return async function(...r) {
    if (e)
      return e;
    try {
      return e = t.apply(this, r), await e;
    } finally {
      e = void 0;
    }
  };
};
var pD = h9;
X0.default = pD;
var ey = {};
Object.defineProperty(ey, "__esModule", {
  value: !0
});
ey.default = void 0;
const yD = (t, e, r, n = {}) => {
  const i = {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0,
    ...n,
    __proto__: null
  };
  return Object.defineProperty(t, e, i), t;
};
var bD = yD;
ey.default = bD;
var ty = {};
Object.defineProperty(ty, "__esModule", {
  value: !0
});
ty.getOwnProperty = void 0;
const gD = (t, e, r) => {
  const n = t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, e) ? t[e] : void 0;
  if (n !== void 0 && r !== void 0 && typeof n !== r)
    throw new TypeError(`Unexpected type for key ${e}, expected ${r} but got ${typeof n}`);
  return n;
};
ty.getOwnProperty = gD;
var bw = {};
Object.defineProperty(bw, "__esModule", {
  value: !0
});
bw.default = mD;
function mD(t, e, r) {
  const n = /* @__PURE__ */ new Map();
  function i(...s) {
    var a;
    const o = e ? e(...s) : s[0], c = !r || ((a = n.get(o)) === null || a === void 0 ? void 0 : a.expiry) > Date.now();
    if (n.has(o) && c)
      return n.get(o).value;
    const f = t.apply(this, s);
    return n.set(o, {
      value: f,
      expiry: Date.now() + r
    }), f;
  }
  return i;
}
var ry = {};
Object.defineProperty(ry, "__esModule", {
  value: !0
});
ry.areSetsEqual = void 0;
const vD = (t, e) => {
  if (t.size !== e.size)
    return !1;
  for (const r of t)
    if (!e.has(r))
      return !1;
  return !0;
};
ry.areSetsEqual = vD;
var ny = {};
Object.defineProperty(ny, "__esModule", {
  value: !0
});
ny.ReadonlySet = void 0;
var wD = _D(hr);
let p9, y9;
function _D(t) {
  return t && t.__esModule ? t : { default: t };
}
function SD(t, e, r) {
  ED(t, e), e.set(t, r);
}
function ED(t, e) {
  if (e.has(t))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function No(t, e) {
  var r = b9(t, e, "get");
  return xD(t, r);
}
function xD(t, e) {
  return e.get ? e.get.call(t) : e.value;
}
function AD(t, e, r) {
  var n = b9(t, e, "set");
  return ID(t, n, r), r;
}
function b9(t, e, r) {
  if (!e.has(t))
    throw new TypeError("attempted to " + r + " private field on non-instance");
  return e.get(t);
}
function ID(t, e, r) {
  if (e.set)
    e.set.call(t, r);
  else {
    if (!e.writable)
      throw new TypeError("attempted to set read only private field");
    e.value = r;
  }
}
const fg = () => {
  throw new Error("this Set is read-only!");
};
var pa = /* @__PURE__ */ new WeakMap();
p9 = Symbol.iterator;
y9 = Symbol.toStringTag;
class TD {
  constructor(e) {
    SD(this, pa, {
      writable: !0,
      value: void 0
    }), (0, wD.default)(e instanceof Set, "expected Set"), AD(this, pa, e);
  }
  get size() {
    return No(this, pa).size;
  }
  has(e) {
    return No(this, pa).has(e);
  }
  entries() {
    return No(this, pa).entries();
  }
  forEach(...e) {
    return No(this, pa).forEach(...e);
  }
  keys() {
    return No(this, pa).keys();
  }
  values() {
    return No(this, pa).values();
  }
  add() {
    fg();
  }
  delete() {
    fg();
  }
  clear() {
    fg();
  }
  [p9]() {
    return No(this, pa)[Symbol.iterator]();
  }
  get [y9]() {
    return "ReadonlySet";
  }
}
ny.ReadonlySet = TD;
var iy = {};
Object.defineProperty(iy, "__esModule", {
  value: !0
});
iy.ReadonlyMap = void 0;
var kD = RD(hr);
let g9, m9;
function RD(t) {
  return t && t.__esModule ? t : { default: t };
}
function PD(t, e, r) {
  OD(t, e), e.set(t, r);
}
function OD(t, e) {
  if (e.has(t))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Ka(t, e) {
  var r = v9(t, e, "get");
  return BD(t, r);
}
function BD(t, e) {
  return e.get ? e.get.call(t) : e.value;
}
function MD(t, e, r) {
  var n = v9(t, e, "set");
  return CD(t, n, r), r;
}
function v9(t, e, r) {
  if (!e.has(t))
    throw new TypeError("attempted to " + r + " private field on non-instance");
  return e.get(t);
}
function CD(t, e, r) {
  if (e.set)
    e.set.call(t, r);
  else {
    if (!e.writable)
      throw new TypeError("attempted to set read only private field");
    e.value = r;
  }
}
const dg = () => {
  throw new Error("this Map is read-only!");
};
var Ns = /* @__PURE__ */ new WeakMap();
g9 = Symbol.iterator;
m9 = Symbol.toStringTag;
class ND {
  constructor(e) {
    PD(this, Ns, {
      writable: !0,
      value: void 0
    }), (0, kD.default)(e instanceof Map, "expected Map"), MD(this, Ns, e);
  }
  get size() {
    return Ka(this, Ns).size;
  }
  get(e) {
    return Ka(this, Ns).get(e);
  }
  has(e) {
    return Ka(this, Ns).has(e);
  }
  entries() {
    return Ka(this, Ns).entries();
  }
  forEach(...e) {
    return Ka(this, Ns).forEach(...e);
  }
  keys() {
    return Ka(this, Ns).keys();
  }
  values() {
    return Ka(this, Ns).values();
  }
  set() {
    dg();
  }
  clear() {
    dg();
  }
  delete() {
    dg();
  }
  [g9]() {
    return Ka(this, Ns)[Symbol.iterator]();
  }
  get [m9]() {
    return "ReadonlyMap";
  }
}
iy.ReadonlyMap = ND;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var e = {
    SynchronizedTime: !0,
    cleanInput: !0,
    flattenToPaths: !0,
    pDebounce: !0,
    defineProperty: !0,
    memoize: !0,
    ReadonlySet: !0,
    ReadonlyMap: !0
  };
  Object.defineProperty(t, "ReadonlyMap", {
    enumerable: !0,
    get: function() {
      return h.ReadonlyMap;
    }
  }), Object.defineProperty(t, "ReadonlySet", {
    enumerable: !0,
    get: function() {
      return l.ReadonlySet;
    }
  }), Object.defineProperty(t, "SynchronizedTime", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(t, "cleanInput", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(t, "defineProperty", {
    enumerable: !0,
    get: function() {
      return c.default;
    }
  }), Object.defineProperty(t, "flattenToPaths", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  }), Object.defineProperty(t, "memoize", {
    enumerable: !0,
    get: function() {
      return u.default;
    }
  }), Object.defineProperty(t, "pDebounce", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  });
  var r = y(Y0), n = y(WL), i = y(yw), s = fr;
  Object.keys(s).forEach(function(p) {
    p === "default" || p === "__esModule" || Object.prototype.hasOwnProperty.call(e, p) || p in t && t[p] === s[p] || Object.defineProperty(t, p, {
      enumerable: !0,
      get: function() {
        return s[p];
      }
    });
  });
  var a = lo;
  Object.keys(a).forEach(function(p) {
    p === "default" || p === "__esModule" || Object.prototype.hasOwnProperty.call(e, p) || p in t && t[p] === a[p] || Object.defineProperty(t, p, {
      enumerable: !0,
      get: function() {
        return a[p];
      }
    });
  });
  var o = y(X0), c = y(ey), f = ty;
  Object.keys(f).forEach(function(p) {
    p === "default" || p === "__esModule" || Object.prototype.hasOwnProperty.call(e, p) || p in t && t[p] === f[p] || Object.defineProperty(t, p, {
      enumerable: !0,
      get: function() {
        return f[p];
      }
    });
  });
  var u = y(bw), d = ry;
  Object.keys(d).forEach(function(p) {
    p === "default" || p === "__esModule" || Object.prototype.hasOwnProperty.call(e, p) || p in t && t[p] === d[p] || Object.defineProperty(t, p, {
      enumerable: !0,
      get: function() {
        return d[p];
      }
    });
  });
  var l = ny, h = iy;
  function y(p) {
    return p && p.__esModule ? p : { default: p };
  }
})(J0);
var Ps = {}, sy = {}, Rl = {}, ns = {}, vf = {}, ca = {}, Dn = {}, Kn = {}, w9 = typeof Ne == "object" && Ne && Ne.Object === Object && Ne, UD = typeof self == "object" && self && self.Object === Object && self, _9 = w9 || UD || Function("return this")(), Nd = _9.Symbol, S9 = Object.prototype, LD = S9.hasOwnProperty, DD = S9.toString, zf = Nd ? Nd.toStringTag : void 0;
function FD(t) {
  var e = LD.call(t, zf), r = t[zf];
  try {
    t[zf] = void 0;
    var n = !0;
  } catch {
  }
  var i = DD.call(t);
  return n && (e ? t[zf] = r : delete t[zf]), i;
}
var jD = Object.prototype, $D = jD.toString;
function qD(t) {
  return $D.call(t);
}
var WD = "[object Null]", zD = "[object Undefined]", H6 = Nd ? Nd.toStringTag : void 0;
function KD(t) {
  return t == null ? t === void 0 ? zD : WD : H6 && H6 in Object(t) ? FD(t) : qD(t);
}
Kn.Symbol = Nd;
Kn.baseGetTag = KD;
Kn.freeGlobal = w9;
Kn.root = _9;
const gw = Kn;
function mw(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var VD = "[object AsyncFunction]", HD = "[object Function]", GD = "[object GeneratorFunction]", ZD = "[object Proxy]";
function E9(t) {
  if (!mw(t))
    return !1;
  var e = gw.baseGetTag(t);
  return e == HD || e == GD || e == VD || e == ZD;
}
var lg = gw.root["__core-js_shared__"], G6 = function() {
  var t = /[^.]+$/.exec(lg && lg.keys && lg.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function JD(t) {
  return !!G6 && G6 in t;
}
var YD = Function.prototype, QD = YD.toString;
function x9(t) {
  if (t != null) {
    try {
      return QD.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var XD = /[\\^$.*+?()[\]{}|]/g, eF = /^\[object .+?Constructor\]$/, tF = Function.prototype, rF = Object.prototype, nF = tF.toString, iF = rF.hasOwnProperty, sF = RegExp("^" + nF.call(iF).replace(XD, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function aF(t) {
  if (!mw(t) || JD(t))
    return !1;
  var e = E9(t) ? sF : eF;
  return e.test(x9(t));
}
function oF(t, e) {
  return t == null ? void 0 : t[e];
}
function A9(t, e) {
  var r = oF(t, e);
  return aF(r) ? r : void 0;
}
var cF = A9(gw.root, "Map");
Dn.Map = cF;
Dn.getNative = A9;
Dn.isFunction = E9;
Dn.isObject = mw;
Dn.toSource = x9;
const I9 = Dn;
function T9(t, e) {
  return t === e || t !== t && e !== e;
}
var Ud = I9.getNative(Object, "create");
function uF() {
  this.__data__ = Ud ? Ud(null) : {}, this.size = 0;
}
function fF(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var dF = "__lodash_hash_undefined__", lF = Object.prototype, hF = lF.hasOwnProperty;
function pF(t) {
  var e = this.__data__;
  if (Ud) {
    var r = e[t];
    return r === dF ? void 0 : r;
  }
  return hF.call(e, t) ? e[t] : void 0;
}
var yF = Object.prototype, bF = yF.hasOwnProperty;
function gF(t) {
  var e = this.__data__;
  return Ud ? e[t] !== void 0 : bF.call(e, t);
}
var mF = "__lodash_hash_undefined__";
function vF(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = Ud && e === void 0 ? mF : e, this;
}
function xc(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
xc.prototype.clear = uF;
xc.prototype.delete = fF;
xc.prototype.get = pF;
xc.prototype.has = gF;
xc.prototype.set = vF;
function wF() {
  this.__data__ = [], this.size = 0;
}
function ay(t, e) {
  for (var r = t.length; r--; )
    if (T9(t[r][0], e))
      return r;
  return -1;
}
var _F = Array.prototype, SF = _F.splice;
function EF(t) {
  var e = this.__data__, r = ay(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : SF.call(e, r, 1), --this.size, !0;
}
function xF(t) {
  var e = this.__data__, r = ay(e, t);
  return r < 0 ? void 0 : e[r][1];
}
function AF(t) {
  return ay(this.__data__, t) > -1;
}
function IF(t, e) {
  var r = this.__data__, n = ay(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
function qc(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
qc.prototype.clear = wF;
qc.prototype.delete = EF;
qc.prototype.get = xF;
qc.prototype.has = AF;
qc.prototype.set = IF;
function TF() {
  this.size = 0, this.__data__ = { hash: new xc(), map: new (I9.Map || qc)(), string: new xc() };
}
function kF(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function oy(t, e) {
  var r = t.__data__;
  return kF(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
function RF(t) {
  var e = oy(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function PF(t) {
  return oy(this, t).get(t);
}
function OF(t) {
  return oy(this, t).has(t);
}
function BF(t, e) {
  var r = oy(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
function wf(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
wf.prototype.clear = TF;
wf.prototype.delete = RF;
wf.prototype.get = PF;
wf.prototype.has = OF;
wf.prototype.set = BF;
ca.ListCache = qc;
ca.MapCache = wf;
ca.eq = T9;
const MF = ca;
var CF = "__lodash_hash_undefined__";
function NF(t) {
  return this.__data__.set(t, CF), this;
}
function UF(t) {
  return this.__data__.has(t);
}
function xp(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new MF.MapCache(); ++e < r; )
    this.add(t[e]);
}
xp.prototype.add = xp.prototype.push = NF;
xp.prototype.has = UF;
function LF(t, e) {
  return t.has(e);
}
function DF(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
vf.SetCache = xp;
vf.cacheHas = LF;
vf.setToArray = DF;
var Pl = {};
function k9(t, e, r, n) {
  for (var i = t.length, s = r + -1; ++s < i; )
    if (e(t[s], s, t))
      return s;
  return -1;
}
function FF(t) {
  return t !== t;
}
function jF(t, e, r) {
  for (var n = r - 1, i = t.length; ++n < i; )
    if (t[n] === e)
      return n;
  return -1;
}
function $F(t, e, r) {
  return e === e ? jF(t, e, r) : k9(t, FF, r);
}
function qF(t, e) {
  var r = t == null ? 0 : t.length;
  return !!r && $F(t, e, 0) > -1;
}
Pl.arrayIncludes = qF;
Pl.baseFindIndex = k9;
var Ti = {}, WF = Array.isArray, yi = WF;
const R9 = ca;
var zF = "Expected a function";
function vw(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(zF);
  var r = function() {
    var n = arguments, i = e ? e.apply(this, n) : n[0], s = r.cache;
    if (s.has(i))
      return s.get(i);
    var a = t.apply(this, n);
    return r.cache = s.set(i, a) || s, a;
  };
  return r.cache = new (vw.Cache || R9.MapCache)(), r;
}
vw.Cache = R9.MapCache;
var ww = vw, ja = {};
function KF(t) {
  return t != null && typeof t == "object";
}
ja.isObjectLike = KF;
const _w = yi, VF = ww, vv = Kn, HF = ja;
var GF = "[object Symbol]";
function cy(t) {
  return typeof t == "symbol" || HF.isObjectLike(t) && vv.baseGetTag(t) == GF;
}
function P9(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, i = Array(n); ++r < n; )
    i[r] = e(t[r], r, t);
  return i;
}
var ZF = 1 / 0, Z6 = vv.Symbol ? vv.Symbol.prototype : void 0, J6 = Z6 ? Z6.toString : void 0;
function O9(t) {
  if (typeof t == "string")
    return t;
  if (_w(t))
    return P9(t, O9) + "";
  if (cy(t))
    return J6 ? J6.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -ZF ? "-0" : e;
}
var JF = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, YF = /^\w*$/;
function B9(t, e) {
  if (_w(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || cy(t) ? !0 : YF.test(t) || !JF.test(t) || e != null && t in Object(e);
}
var QF = 500;
function XF(t) {
  var e = VF(t, function(n) {
    return r.size === QF && r.clear(), n;
  }), r = e.cache;
  return e;
}
var ej = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, tj = /\\(\\)?/g, rj = XF(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(ej, function(r, n, i, s) {
    e.push(i ? s.replace(tj, "$1") : n || r);
  }), e;
});
function nj(t) {
  return t == null ? "" : O9(t);
}
function ij(t, e) {
  return _w(t) ? t : B9(t, e) ? [t] : rj(nj(t));
}
var sj = 1 / 0;
function aj(t) {
  if (typeof t == "string" || cy(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -sj ? "-0" : e;
}
Ti.arrayMap = P9;
Ti.castPath = ij;
Ti.isKey = B9;
Ti.isSymbol = cy;
Ti.toKey = aj;
var Ap = { exports: {} }, Ro = {};
const oj = Kn, M9 = ja;
var cj = 9007199254740991;
function uj(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= cj;
}
var fj = "[object Arguments]";
function Y6(t) {
  return M9.isObjectLike(t) && oj.baseGetTag(t) == fj;
}
var C9 = Object.prototype, dj = C9.hasOwnProperty, lj = C9.propertyIsEnumerable, hj = Y6(/* @__PURE__ */ function() {
  return arguments;
}()) ? Y6 : function(t) {
  return M9.isObjectLike(t) && dj.call(t, "callee") && !lj.call(t, "callee");
};
Ro.isArguments = hj;
Ro.isLength = uj;
Ap.exports;
(function(t, e) {
  const r = Dn, n = Ro, i = Kn, s = ja;
  function a(me) {
    return me != null && n.isLength(me.length) && !r.isFunction(me);
  }
  var o = Object.prototype;
  function c(me) {
    var Ue = me && me.constructor, Ve = typeof Ue == "function" && Ue.prototype || o;
    return me === Ve;
  }
  function f() {
    return !1;
  }
  var u = e && !e.nodeType && e, d = u && !0 && t && !t.nodeType && t, l = d && d.exports === u, h = l ? i.root.Buffer : void 0, y = h ? h.isBuffer : void 0, p = y || f, b = "[object Arguments]", v = "[object Array]", x = "[object Boolean]", I = "[object Date]", L = "[object Error]", P = "[object Function]", C = "[object Map]", D = "[object Number]", F = "[object Object]", G = "[object RegExp]", re = "[object Set]", ie = "[object String]", ee = "[object WeakMap]", $ = "[object ArrayBuffer]", w = "[object DataView]", E = "[object Float32Array]", U = "[object Float64Array]", W = "[object Int8Array]", _ = "[object Int16Array]", R = "[object Int32Array]", N = "[object Uint8Array]", O = "[object Uint8ClampedArray]", g = "[object Uint16Array]", M = "[object Uint32Array]", Y = {};
  Y[E] = Y[U] = Y[W] = Y[_] = Y[R] = Y[N] = Y[O] = Y[g] = Y[M] = !0, Y[b] = Y[v] = Y[$] = Y[x] = Y[w] = Y[I] = Y[L] = Y[P] = Y[C] = Y[D] = Y[F] = Y[G] = Y[re] = Y[ie] = Y[ee] = !1;
  function se(me) {
    return s.isObjectLike(me) && n.isLength(me.length) && !!Y[i.baseGetTag(me)];
  }
  function V(me) {
    return function(Ue) {
      return me(Ue);
    };
  }
  var K = e && !e.nodeType && e, Z = K && !0 && t && !t.nodeType && t, ne = Z && Z.exports === K, ce = ne && i.freeGlobal.process, H = function() {
    try {
      var me = Z && Z.require && Z.require("util").types;
      return me || ce && ce.binding && ce.binding("util");
    } catch {
    }
  }(), J = H && H.isTypedArray, le = J ? V(J) : se;
  e.baseUnary = V, e.isArrayLike = a, e.isBuffer = p, e.isPrototype = c, e.isTypedArray = le, e.nodeUtil = H;
})(Ap, Ap.exports);
var ki = Ap.exports, Ol = {}, uy = {};
function pj(t, e) {
  for (var r = -1, n = e.length, i = t.length; ++r < n; )
    t[i + r] = e[r];
  return t;
}
uy.arrayPush = pj;
const yj = uy, Q6 = Kn, bj = Ro, gj = yi;
var X6 = Q6.Symbol ? Q6.Symbol.isConcatSpreadable : void 0;
function mj(t) {
  return gj(t) || bj.isArguments(t) || !!(X6 && t && t[X6]);
}
function vj(t, e, r, n, i) {
  var s = -1, a = t.length;
  for (r || (r = mj), i || (i = []); ++s < a; ) {
    var o = t[s];
    r(o) ? yj.arrayPush(i, o) : n || (i[i.length] = o);
  }
  return i;
}
Ol.baseFlatten = vj;
var Wc = {}, $a = {}, Bl = {}, wj = 9007199254740991, _j = /^(?:0|[1-9]\d*)$/;
function Sj(t, e) {
  var r = typeof t;
  return e = e ?? wj, !!e && (r == "number" || r != "symbol" && _j.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
Bl.isIndex = Sj;
const Ej = Ro, xj = yi, eE = ki, Aj = Bl, Ip = ca, Ij = Dn, Tj = Kn;
function kj(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var Rj = Object.prototype, Pj = Rj.hasOwnProperty;
function Oj(t, e) {
  var r = xj(t), n = !r && Ej.isArguments(t), i = !r && !n && eE.isBuffer(t), s = !r && !n && !i && eE.isTypedArray(t), a = r || n || i || s, o = a ? kj(t.length, String) : [], c = o.length;
  for (var f in t)
    (e || Pj.call(t, f)) && !(a && (f == "length" || i && (f == "offset" || f == "parent") || s && (f == "buffer" || f == "byteLength" || f == "byteOffset") || Aj.isIndex(f, c))) && o.push(f);
  return o;
}
function Bj() {
  this.__data__ = new Ip.ListCache(), this.size = 0;
}
function Mj(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
function Cj(t) {
  return this.__data__.get(t);
}
function Nj(t) {
  return this.__data__.has(t);
}
var Uj = 200;
function Lj(t, e) {
  var r = this.__data__;
  if (r instanceof Ip.ListCache) {
    var n = r.__data__;
    if (!Ij.Map || n.length < Uj - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new Ip.MapCache(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
function _f(t) {
  var e = this.__data__ = new Ip.ListCache(t);
  this.size = e.size;
}
_f.prototype.clear = Bj;
_f.prototype.delete = Mj;
_f.prototype.get = Cj;
_f.prototype.has = Nj;
_f.prototype.set = Lj;
var Dj = Tj.root.Uint8Array;
$a.Stack = _f;
$a.Uint8Array = Dj;
$a.arrayLikeKeys = Oj;
var Sw = {}, Os = {}, Ml = {}, Ew = {};
function Fj(t, e) {
  return function(r) {
    return t(e(r));
  };
}
Ew.overArg = Fj;
var xw = {};
const jj = Dn, $j = Kn;
var qj = jj.getNative($j.root, "Set");
xw.Set = qj;
(function(t) {
  const e = ki, r = Ew, n = Dn, i = Kn, s = xw;
  var a = n.getNative(i.root, "WeakMap"), o = r.overArg(Object.keys, Object), c = Object.prototype, f = c.hasOwnProperty;
  function u(F) {
    if (!e.isPrototype(F))
      return o(F);
    var G = [];
    for (var re in Object(F))
      f.call(F, re) && re != "constructor" && G.push(re);
    return G;
  }
  var d = n.getNative(i.root, "DataView"), l = n.getNative(i.root, "Promise"), h = "[object Map]", y = "[object Object]", p = "[object Promise]", b = "[object Set]", v = "[object WeakMap]", x = "[object DataView]", I = n.toSource(d), L = n.toSource(n.Map), P = n.toSource(l), C = n.toSource(s.Set), D = n.toSource(a);
  t.getTag = i.baseGetTag, (d && t.getTag(new d(new ArrayBuffer(1))) != x || n.Map && t.getTag(new n.Map()) != h || l && t.getTag(l.resolve()) != p || s.Set && t.getTag(new s.Set()) != b || a && t.getTag(new a()) != v) && (t.getTag = function(F) {
    var G = i.baseGetTag(F), re = G == y ? F.constructor : void 0, ie = re ? n.toSource(re) : "";
    if (ie)
      switch (ie) {
        case I:
          return x;
        case L:
          return h;
        case P:
          return p;
        case C:
          return b;
        case D:
          return v;
      }
    return G;
  }), t.baseKeys = u;
})(Ml);
const Wj = uy, zj = yi, Kj = $a, Vj = Ml, Hj = ki;
function N9(t) {
  return Hj.isArrayLike(t) ? Kj.arrayLikeKeys(t) : Vj.baseKeys(t);
}
function U9(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, i = 0, s = []; ++r < n; ) {
    var a = t[r];
    e(a, r, t) && (s[i++] = a);
  }
  return s;
}
function L9() {
  return [];
}
var Gj = Object.prototype, Zj = Gj.propertyIsEnumerable, tE = Object.getOwnPropertySymbols, D9 = tE ? function(t) {
  return t == null ? [] : (t = Object(t), U9(tE(t), function(e) {
    return Zj.call(t, e);
  }));
} : L9;
function F9(t, e, r) {
  var n = e(t);
  return zj(t) ? n : Wj.arrayPush(n, r(t));
}
function Jj(t) {
  return F9(t, N9, D9);
}
Os.arrayFilter = U9;
Os.baseGetAllKeys = F9;
Os.getAllKeys = Jj;
Os.getSymbols = D9;
Os.keys = N9;
Os.stubArray = L9;
const sd = $a, wv = vf, rE = Kn, Yj = ca, nE = Os, iE = Ml, sE = yi, hg = ki, aE = ja;
function Qj(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
var Xj = 1, e$ = 2;
function j9(t, e, r, n, i, s) {
  var a = r & Xj, o = t.length, c = e.length;
  if (o != c && !(a && c > o))
    return !1;
  var f = s.get(t), u = s.get(e);
  if (f && u)
    return f == e && u == t;
  var d = -1, l = !0, h = r & e$ ? new wv.SetCache() : void 0;
  for (s.set(t, e), s.set(e, t); ++d < o; ) {
    var y = t[d], p = e[d];
    if (n)
      var b = a ? n(p, y, d, e, t, s) : n(y, p, d, t, e, s);
    if (b !== void 0) {
      if (b)
        continue;
      l = !1;
      break;
    }
    if (h) {
      if (!Qj(e, function(v, x) {
        if (!wv.cacheHas(h, x) && (y === v || i(y, v, r, n, s)))
          return h.push(x);
      })) {
        l = !1;
        break;
      }
    } else if (!(y === p || i(y, p, r, n, s))) {
      l = !1;
      break;
    }
  }
  return s.delete(t), s.delete(e), l;
}
function t$(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n, i) {
    r[++e] = [i, n];
  }), r;
}
var r$ = 1, n$ = 2, i$ = "[object Boolean]", s$ = "[object Date]", a$ = "[object Error]", o$ = "[object Map]", c$ = "[object Number]", u$ = "[object RegExp]", f$ = "[object Set]", d$ = "[object String]", l$ = "[object Symbol]", h$ = "[object ArrayBuffer]", p$ = "[object DataView]", oE = rE.Symbol ? rE.Symbol.prototype : void 0, pg = oE ? oE.valueOf : void 0;
function y$(t, e, r, n, i, s, a) {
  switch (r) {
    case p$:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case h$:
      return !(t.byteLength != e.byteLength || !s(new sd.Uint8Array(t), new sd.Uint8Array(e)));
    case i$:
    case s$:
    case c$:
      return Yj.eq(+t, +e);
    case a$:
      return t.name == e.name && t.message == e.message;
    case u$:
    case d$:
      return t == e + "";
    case o$:
      var o = t$;
    case f$:
      var c = n & r$;
      if (o || (o = wv.setToArray), t.size != e.size && !c)
        return !1;
      var f = a.get(t);
      if (f)
        return f == e;
      n |= n$, a.set(t, e);
      var u = j9(o(t), o(e), n, i, s, a);
      return a.delete(t), u;
    case l$:
      if (pg)
        return pg.call(t) == pg.call(e);
  }
  return !1;
}
var b$ = 1, g$ = Object.prototype, m$ = g$.hasOwnProperty;
function v$(t, e, r, n, i, s) {
  var a = r & b$, o = nE.getAllKeys(t), c = o.length, f = nE.getAllKeys(e), u = f.length;
  if (c != u && !a)
    return !1;
  for (var d = c; d--; ) {
    var l = o[d];
    if (!(a ? l in e : m$.call(e, l)))
      return !1;
  }
  var h = s.get(t), y = s.get(e);
  if (h && y)
    return h == e && y == t;
  var p = !0;
  s.set(t, e), s.set(e, t);
  for (var b = a; ++d < c; ) {
    l = o[d];
    var v = t[l], x = e[l];
    if (n)
      var I = a ? n(x, v, l, e, t, s) : n(v, x, l, t, e, s);
    if (!(I === void 0 ? v === x || i(v, x, r, n, s) : I)) {
      p = !1;
      break;
    }
    b || (b = l == "constructor");
  }
  if (p && !b) {
    var L = t.constructor, P = e.constructor;
    L != P && "constructor" in t && "constructor" in e && !(typeof L == "function" && L instanceof L && typeof P == "function" && P instanceof P) && (p = !1);
  }
  return s.delete(t), s.delete(e), p;
}
var w$ = 1, cE = "[object Arguments]", uE = "[object Array]", yh = "[object Object]", _$ = Object.prototype, fE = _$.hasOwnProperty;
function S$(t, e, r, n, i, s) {
  var a = sE(t), o = sE(e), c = a ? uE : iE.getTag(t), f = o ? uE : iE.getTag(e);
  c = c == cE ? yh : c, f = f == cE ? yh : f;
  var u = c == yh, d = f == yh, l = c == f;
  if (l && hg.isBuffer(t)) {
    if (!hg.isBuffer(e))
      return !1;
    a = !0, u = !1;
  }
  if (l && !u)
    return s || (s = new sd.Stack()), a || hg.isTypedArray(t) ? j9(t, e, r, n, i, s) : y$(t, e, c, r, n, i, s);
  if (!(r & w$)) {
    var h = u && fE.call(t, "__wrapped__"), y = d && fE.call(e, "__wrapped__");
    if (h || y) {
      var p = h ? t.value() : t, b = y ? e.value() : e;
      return s || (s = new sd.Stack()), i(p, b, r, n, s);
    }
  }
  return l ? (s || (s = new sd.Stack()), v$(t, e, r, n, i, s)) : !1;
}
function $9(t, e, r, n, i) {
  return t === e ? !0 : t == null || e == null || !aE.isObjectLike(t) && !aE.isObjectLike(e) ? t !== t && e !== e : S$(t, e, r, n, $9, i);
}
Sw.baseIsEqual = $9;
var Sf = {};
const dE = Ti;
function E$(t, e) {
  e = dE.castPath(e, t);
  for (var r = 0, n = e.length; t != null && r < n; )
    t = t[dE.toKey(e[r++])];
  return r && r == n ? t : void 0;
}
Sf.baseGet = E$;
const x$ = Sf;
function A$(t, e, r) {
  var n = t == null ? void 0 : x$.baseGet(t, e);
  return n === void 0 ? r : n;
}
var Aw = A$, Iw = {};
const lE = Ti, hE = Ro, I$ = yi, T$ = Bl;
function k$(t, e) {
  return t != null && e in Object(t);
}
function R$(t, e, r) {
  e = lE.castPath(e, t);
  for (var n = -1, i = e.length, s = !1; ++n < i; ) {
    var a = lE.toKey(e[n]);
    if (!(s = t != null && r(t, a)))
      break;
    t = t[a];
  }
  return s || ++n != i ? s : (i = t == null ? 0 : t.length, !!i && hE.isLength(i) && T$.isIndex(a, i) && (I$(t) || hE.isArguments(t)));
}
function P$(t, e) {
  return t != null && R$(t, e, k$);
}
Iw.hasIn = P$;
var Cl = {};
function O$(t) {
  return t;
}
Cl.identity = O$;
const B$ = $a, q9 = Sw, M$ = Dn, C$ = Os, N$ = Aw, U$ = Iw, Tp = Ti, L$ = Cl, D$ = yi, F$ = Sf;
var j$ = 1, $$ = 2;
function q$(t, e, r, n) {
  var i = r.length, s = i;
  if (t == null)
    return !s;
  for (t = Object(t); i--; ) {
    var a = r[i];
    if (a[2] ? a[1] !== t[a[0]] : !(a[0] in t))
      return !1;
  }
  for (; ++i < s; ) {
    a = r[i];
    var o = a[0], c = t[o], f = a[1];
    if (a[2]) {
      if (c === void 0 && !(o in t))
        return !1;
    } else {
      var u = new B$.Stack(), d;
      if (!(d === void 0 ? q9.baseIsEqual(f, c, j$ | $$, n, u) : d))
        return !1;
    }
  }
  return !0;
}
function W9(t) {
  return t === t && !M$.isObject(t);
}
function W$(t) {
  for (var e = C$.keys(t), r = e.length; r--; ) {
    var n = e[r], i = t[n];
    e[r] = [n, i, W9(i)];
  }
  return e;
}
function z9(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
function z$(t) {
  var e = W$(t);
  return e.length == 1 && e[0][2] ? z9(e[0][0], e[0][1]) : function(r) {
    return r === t || q$(r, t, e);
  };
}
var K$ = 1, V$ = 2;
function H$(t, e) {
  return Tp.isKey(t) && W9(e) ? z9(Tp.toKey(t), e) : function(r) {
    var n = N$(r, t);
    return n === void 0 && n === e ? U$.hasIn(r, t) : q9.baseIsEqual(e, n, K$ | V$);
  };
}
function G$(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
function Z$(t) {
  return function(e) {
    return F$.baseGet(e, t);
  };
}
function J$(t) {
  return Tp.isKey(t) ? G$(Tp.toKey(t)) : Z$(t);
}
function Y$(t) {
  return typeof t == "function" ? t : t == null ? L$.identity : typeof t == "object" ? D$(t) ? H$(t[0], t[1]) : z$(t) : J$(t);
}
Wc.baseIteratee = Y$;
var Nl = {}, fy = {}, Tw = {};
const Q$ = Dn;
var X$ = function() {
  try {
    var t = Q$.getNative(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
Tw.defineProperty = X$;
const pE = Tw, eq = Cl;
function tq(t, e, r) {
  switch (r.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, r[0]);
    case 2:
      return t.call(e, r[0], r[1]);
    case 3:
      return t.call(e, r[0], r[1], r[2]);
  }
  return t.apply(e, r);
}
var rq = 800, nq = 16, iq = Date.now;
function sq(t) {
  var e = 0, r = 0;
  return function() {
    var n = iq(), i = nq - (n - r);
    if (r = n, i > 0) {
      if (++e >= rq)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
function aq(t) {
  return function() {
    return t;
  };
}
var oq = pE.defineProperty ? function(t, e) {
  return pE.defineProperty(t, "toString", { configurable: !0, enumerable: !1, value: aq(e), writable: !0 });
} : eq.identity, cq = sq(oq), yE = Math.max;
function uq(t, e, r) {
  return e = yE(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var n = arguments, i = -1, s = yE(n.length - e, 0), a = Array(s); ++i < s; )
      a[i] = n[e + i];
    i = -1;
    for (var o = Array(e + 1); ++i < e; )
      o[i] = n[i];
    return o[e] = r(a), tq(t, this, o);
  };
}
fy.overRest = uq;
fy.setToString = cq;
const fq = Cl, bE = fy;
function dq(t, e) {
  return bE.setToString(bE.overRest(t, e, fq.identity), t + "");
}
Nl.baseRest = dq;
var dy = {};
const lq = ki, hq = ja;
function pq(t) {
  return hq.isObjectLike(t) && lq.isArrayLike(t);
}
dy.isArrayLikeObject = pq;
var ly = {};
function yq(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
ly.last = yq;
const gE = vf, bq = Pl, gq = Ti, mq = ki, vq = Ol, wq = Wc, _q = Nl, yg = dy, Sq = ly;
var Eq = 200;
function xq(t, e, r, n) {
  var i = -1, s = bq.arrayIncludes, a = !0, o = t.length, c = [], f = e.length;
  if (!o)
    return c;
  r && (e = gq.arrayMap(e, mq.baseUnary(r))), e.length >= Eq && (s = gE.cacheHas, a = !1, e = new gE.SetCache(e));
  e:
    for (; ++i < o; ) {
      var u = t[i], d = r == null ? u : r(u);
      if (u = u !== 0 ? u : 0, a && d === d) {
        for (var l = f; l--; )
          if (e[l] === d)
            continue e;
        c.push(u);
      } else
        s(e, d, n) || c.push(u);
    }
  return c;
}
var Aq = _q.baseRest(function(t, e) {
  var r = Sq.last(e);
  return yg.isArrayLikeObject(r) && (r = void 0), yg.isArrayLikeObject(t) ? xq(t, vq.baseFlatten(e, 1, yg.isArrayLikeObject, !0), wq.baseIteratee(r)) : [];
}), K9 = Aq, hy = {}, kw = {}, Rw = {};
function Iq(t) {
  return function(e, r, n) {
    for (var i = -1, s = Object(e), a = n(e), o = a.length; o--; ) {
      var c = a[++i];
      if (r(s[c], c, s) === !1)
        break;
    }
    return e;
  };
}
var Tq = Iq();
Rw.baseFor = Tq;
const kq = Rw, Rq = Os;
function Pq(t, e) {
  return t && kq.baseFor(t, e, Rq.keys);
}
kw.baseForOwn = Pq;
const Oq = kw, Bq = ki;
function Mq(t, e) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!Bq.isArrayLike(r))
      return t(r, n);
    for (var i = r.length, s = -1, a = Object(r); ++s < i && n(a[s], s, a) !== !1; )
      ;
    return r;
  };
}
var Cq = Mq(Oq.baseForOwn);
hy.baseEach = Cq;
var Ef = {};
const mE = Tw;
function Nq(t, e, r) {
  e == "__proto__" && mE.defineProperty ? mE.defineProperty(t, e, { configurable: !0, enumerable: !0, value: r, writable: !0 }) : t[e] = r;
}
Ef.baseAssignValue = Nq;
const Uq = Ef, Lq = hy, Dq = Wc, Fq = yi;
function jq(t, e, r, n) {
  for (var i = -1, s = t == null ? 0 : t.length; ++i < s; ) {
    var a = t[i];
    e(n, a, r(a), t);
  }
  return n;
}
function $q(t, e, r, n) {
  return Lq.baseEach(t, function(i, s, a) {
    e(n, i, r(i), a);
  }), n;
}
function qq(t, e) {
  return function(r, n) {
    var i = Fq(r) ? jq : $q, s = {};
    return i(r, t, Dq.baseIteratee(n), s);
  };
}
var Wq = Object.prototype, zq = Wq.hasOwnProperty, Kq = qq(function(t, e, r) {
  zq.call(t, r) ? t[r].push(e) : Uq.baseAssignValue(t, r, [e]);
}), V9 = Kq;
const vE = Ml, Vq = Ro, Hq = yi, bh = ki;
var Gq = "[object Map]", Zq = "[object Set]", Jq = Object.prototype, Yq = Jq.hasOwnProperty;
function Qq(t) {
  if (t == null)
    return !0;
  if (bh.isArrayLike(t) && (Hq(t) || typeof t == "string" || typeof t.splice == "function" || bh.isBuffer(t) || bh.isTypedArray(t) || Vq.isArguments(t)))
    return !t.length;
  var e = vE.getTag(t);
  if (e == Gq || e == Zq)
    return !t.size;
  if (bh.isPrototype(t))
    return !vE.baseKeys(t).length;
  for (var r in t)
    if (Yq.call(t, r))
      return !1;
  return !0;
}
var Pw = Qq;
const Xq = Sw;
function eW(t, e) {
  return Xq.baseIsEqual(t, e);
}
var zc = eW;
function tW(t) {
  return t == null;
}
var H9 = tW, Kc = {};
const rW = Kn, nW = Ew, iW = ja;
var G9 = nW.overArg(Object.getPrototypeOf, Object), sW = "[object Object]", aW = Function.prototype, oW = Object.prototype, Z9 = aW.toString, cW = oW.hasOwnProperty, uW = Z9.call(Object);
function fW(t) {
  if (!iW.isObjectLike(t) || rW.baseGetTag(t) != sW)
    return !1;
  var e = G9(t);
  if (e === null)
    return !0;
  var r = cW.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && Z9.call(r) == uW;
}
Kc.getPrototype = G9;
Kc.isPlainObject = fW;
const dW = Kn, lW = yi, hW = ja;
var pW = "[object String]";
function yW(t) {
  return typeof t == "string" || !lW(t) && hW.isObjectLike(t) && dW.baseGetTag(t) == pW;
}
var Ul = yW, py = {}, Ow = {};
const bW = ca, gW = ki, mW = Bl, vW = Dn;
function wW(t, e, r) {
  if (!vW.isObject(r))
    return !1;
  var n = typeof e;
  return (n == "number" ? gW.isArrayLike(r) && mW.isIndex(e, r.length) : n == "string" && e in r) ? bW.eq(r[e], t) : !1;
}
Ow.isIterateeCall = wW;
const _W = Ol, ad = Ti, SW = Sf, EW = Wc, xW = hy, J9 = ki, AW = Cl, IW = yi, TW = Nl, wE = Ow;
function Y9(t, e) {
  var r = -1, n = J9.isArrayLike(t) ? Array(t.length) : [];
  return xW.baseEach(t, function(i, s, a) {
    n[++r] = e(i, s, a);
  }), n;
}
function kW(t, e) {
  var r = t.length;
  for (t.sort(e); r--; )
    t[r] = t[r].value;
  return t;
}
function RW(t, e) {
  if (t !== e) {
    var r = t !== void 0, n = t === null, i = t === t, s = ad.isSymbol(t), a = e !== void 0, o = e === null, c = e === e, f = ad.isSymbol(e);
    if (!o && !f && !s && t > e || s && a && c && !o && !f || n && a && c || !r && c || !i)
      return 1;
    if (!n && !s && !f && t < e || f && r && i && !n && !s || o && r && i || !a && i || !c)
      return -1;
  }
  return 0;
}
function PW(t, e, r) {
  for (var n = -1, i = t.criteria, s = e.criteria, a = i.length, o = r.length; ++n < a; ) {
    var c = RW(i[n], s[n]);
    if (c) {
      if (n >= o)
        return c;
      var f = r[n];
      return c * (f == "desc" ? -1 : 1);
    }
  }
  return t.index - e.index;
}
function OW(t, e, r) {
  e.length ? e = ad.arrayMap(e, function(s) {
    return IW(s) ? function(a) {
      return SW.baseGet(a, s.length === 1 ? s[0] : s);
    } : s;
  }) : e = [AW.identity];
  var n = -1;
  e = ad.arrayMap(e, J9.baseUnary(EW.baseIteratee));
  var i = Y9(t, function(s, a, o) {
    var c = ad.arrayMap(e, function(f) {
      return f(s);
    });
    return { criteria: c, index: ++n, value: s };
  });
  return kW(i, function(s, a) {
    return PW(s, a, r);
  });
}
var BW = TW.baseRest(function(t, e) {
  if (t == null)
    return [];
  var r = e.length;
  return r > 1 && wE.isIterateeCall(t, e[0], e[1]) ? e = [] : r > 2 && wE.isIterateeCall(e[0], e[1], e[2]) && (e = [e[0]]), OW(t, _W.baseFlatten(e), []);
});
py.baseMap = Y9;
py.sortBy = BW;
const MW = Ef, CW = kw, NW = Wc;
function UW(t, e) {
  var r = {};
  return e = NW.baseIteratee(e), CW.baseForOwn(t, function(n, i, s) {
    MW.baseAssignValue(r, i, e(n, i, s));
  }), r;
}
var xf = UW, yy = {}, kp = { exports: {} }, by = {};
const LW = Ef, DW = ca;
var FW = Object.prototype, jW = FW.hasOwnProperty;
function $W(t, e, r) {
  var n = t[e];
  (!(jW.call(t, e) && DW.eq(n, r)) || r === void 0 && !(e in t)) && LW.baseAssignValue(t, e, r);
}
by.assignValue = $W;
kp.exports;
(function(t, e) {
  const r = by, n = Ef, i = $a, s = Dn, a = ki, o = Kn, c = Kc;
  var f = Object.create, u = /* @__PURE__ */ function() {
    function ie() {
    }
    return function(ee) {
      if (!s.isObject(ee))
        return {};
      if (f)
        return f(ee);
      ie.prototype = ee;
      var $ = new ie();
      return ie.prototype = void 0, $;
    };
  }();
  function d(ie, ee) {
    var $ = -1, w = ie.length;
    for (ee || (ee = Array(w)); ++$ < w; )
      ee[$] = ie[$];
    return ee;
  }
  function l(ie, ee, $, w) {
    var E = !$;
    $ || ($ = {});
    for (var U = -1, W = ee.length; ++U < W; ) {
      var _ = ee[U], R = void 0;
      R === void 0 && (R = ie[_]), E ? n.baseAssignValue($, _, R) : r.assignValue($, _, R);
    }
    return $;
  }
  function h(ie) {
    var ee = [];
    if (ie != null)
      for (var $ in Object(ie))
        ee.push($);
    return ee;
  }
  var y = Object.prototype, p = y.hasOwnProperty;
  function b(ie) {
    if (!s.isObject(ie))
      return h(ie);
    var ee = a.isPrototype(ie), $ = [];
    for (var w in ie)
      w == "constructor" && (ee || !p.call(ie, w)) || $.push(w);
    return $;
  }
  function v(ie) {
    return a.isArrayLike(ie) ? i.arrayLikeKeys(ie, !0) : b(ie);
  }
  var x = e && !e.nodeType && e, I = x && !0 && t && !t.nodeType && t, L = I && I.exports === x, P = L ? o.root.Buffer : void 0, C = P ? P.allocUnsafe : void 0;
  function D(ie, ee) {
    if (ee)
      return ie.slice();
    var $ = ie.length, w = C ? C($) : new ie.constructor($);
    return ie.copy(w), w;
  }
  function F(ie) {
    var ee = new ie.constructor(ie.byteLength);
    return new i.Uint8Array(ee).set(new i.Uint8Array(ie)), ee;
  }
  function G(ie, ee) {
    var $ = ee ? F(ie.buffer) : ie.buffer;
    return new ie.constructor($, ie.byteOffset, ie.length);
  }
  function re(ie) {
    return typeof ie.constructor == "function" && !a.isPrototype(ie) ? u(c.getPrototype(ie)) : {};
  }
  e.cloneArrayBuffer = F, e.cloneBuffer = D, e.cloneTypedArray = G, e.copyArray = d, e.copyObject = l, e.initCloneObject = re, e.keysIn = v;
})(kp, kp.exports);
var Q9 = kp.exports;
const qW = Nl, WW = Ow, zW = $a, KW = Ef, VW = ca, HW = Rw, Yo = Q9, _E = Ro, SE = yi, GW = dy, EE = ki, _v = Dn, ZW = Kc;
function JW(t) {
  return qW.baseRest(function(e, r) {
    var n = -1, i = r.length, s = i > 1 ? r[i - 1] : void 0, a = i > 2 ? r[2] : void 0;
    for (s = t.length > 3 && typeof s == "function" ? (i--, s) : void 0, a && WW.isIterateeCall(r[0], r[1], a) && (s = i < 3 ? void 0 : s, i = 1), e = Object(e); ++n < i; ) {
      var o = r[n];
      o && t(e, o, n, s);
    }
    return e;
  });
}
function Sv(t, e, r) {
  (r !== void 0 && !VW.eq(t[e], r) || r === void 0 && !(e in t)) && KW.baseAssignValue(t, e, r);
}
function Ev(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
function YW(t) {
  return Yo.copyObject(t, Yo.keysIn(t));
}
function QW(t, e, r, n, i, s, a) {
  var o = Ev(t, r), c = Ev(e, r), f = a.get(c);
  if (f) {
    Sv(t, r, f);
    return;
  }
  var u = s ? s(o, c, r + "", t, e, a) : void 0, d = u === void 0;
  if (d) {
    var l = SE(c), h = !l && EE.isBuffer(c), y = !l && !h && EE.isTypedArray(c);
    u = c, l || h || y ? SE(o) ? u = o : GW.isArrayLikeObject(o) ? u = Yo.copyArray(o) : h ? (d = !1, u = Yo.cloneBuffer(c, !0)) : y ? (d = !1, u = Yo.cloneTypedArray(c, !0)) : u = [] : ZW.isPlainObject(c) || _E.isArguments(c) ? (u = o, _E.isArguments(o) ? u = YW(o) : (!_v.isObject(o) || _v.isFunction(o)) && (u = Yo.initCloneObject(c))) : d = !1;
  }
  d && (a.set(c, u), i(u, c, n, s, a), a.delete(c)), Sv(t, r, u);
}
function X9(t, e, r, n, i) {
  t !== e && HW.baseFor(e, function(s, a) {
    if (i || (i = new zW.Stack()), _v.isObject(s))
      QW(t, e, a, r, X9, n, i);
    else {
      var o = n ? n(Ev(t, a), s, a + "", t, e, i) : void 0;
      o === void 0 && (o = s), Sv(t, a, o);
    }
  }, Yo.keysIn);
}
yy.baseMerge = X9;
yy.createAssigner = JW;
const xE = yy;
var XW = xE.createAssigner(function(t, e, r) {
  xE.baseMerge(t, e, r);
}), Bw = XW;
const AE = yy;
var ez = AE.createAssigner(function(t, e, r, n) {
  AE.baseMerge(t, e, r, n);
}), eI = ez, gy = {}, Mw = {};
const tz = Ol, IE = fy;
function rz(t) {
  var e = t == null ? 0 : t.length;
  return e ? tz.baseFlatten(t) : [];
}
function nz(t) {
  return IE.setToString(IE.overRest(t, void 0, rz), t + "");
}
Mw.flatRest = nz;
const Rp = Ti, iz = $a, sz = by, Ai = Q9, Ac = Os, az = uy, tI = Kc, Cw = Ml, TE = Kn, oz = yi, Ic = ki, rI = ja, cz = Dn, uz = ly, fz = Sf, dz = Mw;
function lz(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n && e(t[r], r, t) !== !1; )
    ;
  return t;
}
function hz(t, e, r) {
  var n = -1, i = t.length;
  e < 0 && (e = -e > i ? 0 : i + e), r = r > i ? i : r, r < 0 && (r += i), i = e > r ? 0 : r - e >>> 0, e >>>= 0;
  for (var s = Array(i); ++n < i; )
    s[n] = t[n + e];
  return s;
}
function pz(t, e) {
  return t && Ai.copyObject(e, Ac.keys(e), t);
}
function yz(t, e) {
  return t && Ai.copyObject(e, Ai.keysIn(e), t);
}
function bz(t, e) {
  return Ai.copyObject(t, Ac.getSymbols(t), e);
}
var gz = Object.getOwnPropertySymbols, nI = gz ? function(t) {
  for (var e = []; t; )
    az.arrayPush(e, Ac.getSymbols(t)), t = tI.getPrototype(t);
  return e;
} : Ac.stubArray;
function mz(t, e) {
  return Ai.copyObject(t, nI(t), e);
}
function Nw(t) {
  return Ac.baseGetAllKeys(t, Ai.keysIn, nI);
}
var vz = Object.prototype, wz = vz.hasOwnProperty;
function _z(t) {
  var e = t.length, r = new t.constructor(e);
  return e && typeof t[0] == "string" && wz.call(t, "index") && (r.index = t.index, r.input = t.input), r;
}
function Sz(t, e) {
  var r = e ? Ai.cloneArrayBuffer(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.byteLength);
}
var Ez = /\w*$/;
function xz(t) {
  var e = new t.constructor(t.source, Ez.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var kE = TE.Symbol ? TE.Symbol.prototype : void 0, RE = kE ? kE.valueOf : void 0;
function Az(t) {
  return RE ? Object(RE.call(t)) : {};
}
var Iz = "[object Boolean]", Tz = "[object Date]", kz = "[object Map]", Rz = "[object Number]", Pz = "[object RegExp]", Oz = "[object Set]", Bz = "[object String]", Mz = "[object Symbol]", Cz = "[object ArrayBuffer]", Nz = "[object DataView]", Uz = "[object Float32Array]", Lz = "[object Float64Array]", Dz = "[object Int8Array]", Fz = "[object Int16Array]", jz = "[object Int32Array]", $z = "[object Uint8Array]", qz = "[object Uint8ClampedArray]", Wz = "[object Uint16Array]", zz = "[object Uint32Array]";
function Kz(t, e, r) {
  var n = t.constructor;
  switch (e) {
    case Cz:
      return Ai.cloneArrayBuffer(t);
    case Iz:
    case Tz:
      return new n(+t);
    case Nz:
      return Sz(t, r);
    case Uz:
    case Lz:
    case Dz:
    case Fz:
    case jz:
    case $z:
    case qz:
    case Wz:
    case zz:
      return Ai.cloneTypedArray(t, r);
    case kz:
      return new n();
    case Rz:
    case Bz:
      return new n(t);
    case Pz:
      return xz(t);
    case Oz:
      return new n();
    case Mz:
      return Az(t);
  }
}
var Vz = "[object Map]";
function Hz(t) {
  return rI.isObjectLike(t) && Cw.getTag(t) == Vz;
}
var PE = Ic.nodeUtil && Ic.nodeUtil.isMap, Gz = PE ? Ic.baseUnary(PE) : Hz, Zz = "[object Set]";
function Jz(t) {
  return rI.isObjectLike(t) && Cw.getTag(t) == Zz;
}
var OE = Ic.nodeUtil && Ic.nodeUtil.isSet, Yz = OE ? Ic.baseUnary(OE) : Jz, Qz = 1, Xz = 2, eK = 4, iI = "[object Arguments]", tK = "[object Array]", rK = "[object Boolean]", nK = "[object Date]", iK = "[object Error]", sI = "[object Function]", sK = "[object GeneratorFunction]", aK = "[object Map]", oK = "[object Number]", aI = "[object Object]", cK = "[object RegExp]", uK = "[object Set]", fK = "[object String]", dK = "[object Symbol]", lK = "[object WeakMap]", hK = "[object ArrayBuffer]", pK = "[object DataView]", yK = "[object Float32Array]", bK = "[object Float64Array]", gK = "[object Int8Array]", mK = "[object Int16Array]", vK = "[object Int32Array]", wK = "[object Uint8Array]", _K = "[object Uint8ClampedArray]", SK = "[object Uint16Array]", EK = "[object Uint32Array]", Vr = {};
Vr[iI] = Vr[tK] = Vr[hK] = Vr[pK] = Vr[rK] = Vr[nK] = Vr[yK] = Vr[bK] = Vr[gK] = Vr[mK] = Vr[vK] = Vr[aK] = Vr[oK] = Vr[aI] = Vr[cK] = Vr[uK] = Vr[fK] = Vr[dK] = Vr[wK] = Vr[_K] = Vr[SK] = Vr[EK] = !0;
Vr[iK] = Vr[sI] = Vr[lK] = !1;
function Wh(t, e, r, n, i, s) {
  var a, o = e & Qz, c = e & Xz, f = e & eK;
  if (r && (a = i ? r(t, n, i, s) : r(t)), a !== void 0)
    return a;
  if (!cz.isObject(t))
    return t;
  var u = oz(t);
  if (u) {
    if (a = _z(t), !o)
      return Ai.copyArray(t, a);
  } else {
    var d = Cw.getTag(t), l = d == sI || d == sK;
    if (Ic.isBuffer(t))
      return Ai.cloneBuffer(t, o);
    if (d == aI || d == iI || l && !i) {
      if (a = c || l ? {} : Ai.initCloneObject(t), !o)
        return c ? mz(t, yz(a, t)) : bz(t, pz(a, t));
    } else {
      if (!Vr[d])
        return i ? t : {};
      a = Kz(t, d, o);
    }
  }
  s || (s = new iz.Stack());
  var h = s.get(t);
  if (h)
    return h;
  s.set(t, a), Yz(t) ? t.forEach(function(b) {
    a.add(Wh(b, e, r, b, t, s));
  }) : Gz(t) && t.forEach(function(b, v) {
    a.set(v, Wh(b, e, r, v, t, s));
  });
  var y = f ? c ? Nw : Ac.getAllKeys : c ? Ai.keysIn : Ac.keys, p = u ? void 0 : y(t);
  return lz(p || t, function(b, v) {
    p && (v = b, b = t[v]), sz.assignValue(a, v, Wh(b, e, r, v, t, s));
  }), a;
}
function xK(t, e) {
  return e.length < 2 ? t : fz.baseGet(t, hz(e, 0, -1));
}
function AK(t, e) {
  return e = Rp.castPath(e, t), t = xK(t, e), t == null || delete t[Rp.toKey(uz.last(e))];
}
function IK(t) {
  return tI.isPlainObject(t) ? void 0 : t;
}
var TK = 1, kK = 2, RK = 4, PK = dz.flatRest(function(t, e) {
  var r = {};
  if (t == null)
    return r;
  var n = !1;
  e = Rp.arrayMap(e, function(s) {
    return s = Rp.castPath(s, t), n || (n = s.length > 1), s;
  }), Ai.copyObject(t, Nw(t), r), n && (r = Wh(r, TK | kK | RK, IK));
  for (var i = e.length; i--; )
    AK(r, e[i]);
  return r;
});
gy.getAllKeysIn = Nw;
gy.omit = PK;
var my = {}, Uw = {};
const OK = by, BE = Ti, BK = Bl, ME = Dn;
function MK(t, e, r, n) {
  if (!ME.isObject(t))
    return t;
  e = BE.castPath(e, t);
  for (var i = -1, s = e.length, a = s - 1, o = t; o != null && ++i < s; ) {
    var c = BE.toKey(e[i]), f = r;
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return t;
    if (i != a) {
      var u = o[c];
      f = void 0, f === void 0 && (f = ME.isObject(u) ? u : BK.isIndex(e[i + 1]) ? [] : {});
    }
    OK.assignValue(o, c, f), o = o[c];
  }
  return t;
}
Uw.baseSet = MK;
const CK = Sf, NK = Uw, UK = Ti, LK = Iw, DK = Mw;
function oI(t, e, r) {
  for (var n = -1, i = e.length, s = {}; ++n < i; ) {
    var a = e[n], o = CK.baseGet(t, a);
    r(o, a) && NK.baseSet(s, UK.castPath(a, t), o);
  }
  return s;
}
function FK(t, e) {
  return oI(t, e, function(r, n) {
    return LK.hasIn(t, n);
  });
}
var jK = DK.flatRest(function(t, e) {
  return t == null ? {} : FK(t, e);
});
my.basePickBy = oI;
my.pick = jK;
const $K = Uw;
function qK(t, e, r) {
  return t == null ? t : $K.baseSet(t, e, r);
}
var cI = qK, vy = {};
const zh = vf, WK = Pl, bg = xw;
function zK() {
}
var KK = 1 / 0, VK = bg.Set && 1 / zh.setToArray(new bg.Set([, -0]))[1] == KK ? function(t) {
  return new bg.Set(t);
} : zK, HK = 200;
function GK(t, e, r) {
  var n = -1, i = WK.arrayIncludes, s = t.length, a = !0, o = [], c = o;
  if (s >= HK) {
    var f = e ? null : VK(t);
    if (f)
      return zh.setToArray(f);
    a = !1, i = zh.cacheHas, c = new zh.SetCache();
  } else
    c = e ? [] : o;
  e:
    for (; ++n < s; ) {
      var u = t[n], d = e ? e(u) : u;
      if (u = u !== 0 ? u : 0, a && d === d) {
        for (var l = c.length; l--; )
          if (c[l] === d)
            continue e;
        e && c.push(d), o.push(u);
      } else
        i(c, d, r) || (c !== o && c.push(d), o.push(u));
    }
  return o;
}
vy.baseUniq = GK;
const ZK = vy;
function JK(t) {
  return t && t.length ? ZK.baseUniq(t) : [];
}
var uI = JK;
const YK = Wc, QK = vy;
function XK(t, e) {
  return t && t.length ? QK.baseUniq(t, YK.baseIteratee(e)) : [];
}
var Lw = XK;
(function(t) {
  Object.defineProperties(t, { __esModule: { value: !0 }, [Symbol.toStringTag]: { value: "Module" } });
  const e = K9, r = Os, n = hy, i = Wc, s = yi, a = ki, o = Pl, c = Dn, f = Ti, u = Aw, d = V9, l = Pw, h = zc, y = H9, p = Kc, b = Ul, v = py, x = xf, I = ww, L = Bw, P = eI, C = gy, D = my, F = cI, G = Ol, re = Nl, ie = vy, ee = dy, $ = ly, w = uI, E = Lw;
  var U = /\s/;
  function W(m) {
    for (var S = m.length; S-- && U.test(m.charAt(S)); )
      ;
    return S;
  }
  var _ = /^\s+/;
  function R(m) {
    return m && m.slice(0, W(m) + 1).replace(_, "");
  }
  var N = NaN, O = /^[-+]0x[0-9a-f]+$/i, g = /^0b[01]+$/i, M = /^0o[0-7]+$/i, Y = parseInt;
  function se(m) {
    if (typeof m == "number")
      return m;
    if (f.isSymbol(m))
      return N;
    if (c.isObject(m)) {
      var S = typeof m.valueOf == "function" ? m.valueOf() : m;
      m = c.isObject(S) ? S + "" : S;
    }
    if (typeof m != "string")
      return m === 0 ? m : +m;
    m = R(m);
    var q = g.test(m);
    return q || M.test(m) ? Y(m.slice(2), q ? 2 : 8) : O.test(m) ? N : +m;
  }
  var V = 1 / 0, K = 17976931348623157e292;
  function Z(m) {
    if (!m)
      return m === 0 ? m : 0;
    if (m = se(m), m === V || m === -V) {
      var S = m < 0 ? -1 : 1;
      return S * K;
    }
    return m === m ? m : 0;
  }
  function ne(m) {
    var S = Z(m), q = S % 1;
    return S === S ? q ? S - q : S : 0;
  }
  function ce(m, S, q, oe) {
    var fe = -1, pe = m == null ? 0 : m.length;
    for (oe && pe && (q = m[++fe]); ++fe < pe; )
      q = S(q, m[fe], fe, m);
    return q;
  }
  function H(m, S) {
    var q = [];
    return n.baseEach(m, function(oe, fe, pe) {
      S(oe, fe, pe) && q.push(oe);
    }), q;
  }
  function J(m, S) {
    var q = s(m) ? r.arrayFilter : H;
    return q(m, i.baseIteratee(S));
  }
  function le(m) {
    return function(S, q, oe) {
      var fe = Object(S);
      if (!a.isArrayLike(S)) {
        var pe = i.baseIteratee(q);
        S = r.keys(S), q = function(De) {
          return pe(fe[De], De, fe);
        };
      }
      var Ke = m(S, q, oe);
      return Ke > -1 ? fe[pe ? S[Ke] : Ke] : void 0;
    };
  }
  var me = Math.max;
  function Ue(m, S, q) {
    var oe = m == null ? 0 : m.length;
    if (!oe)
      return -1;
    var fe = q == null ? 0 : ne(q);
    return fe < 0 && (fe = me(oe + fe, 0)), o.baseFindIndex(m, i.baseIteratee(S), fe);
  }
  var Ve = le(Ue);
  function ze(m, S) {
    var q = s(m) ? f.arrayMap : v.baseMap;
    return q(m, i.baseIteratee(S));
  }
  function at(m, S) {
    return f.arrayMap(S, function(q) {
      return m[q];
    });
  }
  function xe(m) {
    return m == null ? [] : at(m, r.keys(m));
  }
  function gt(m, S) {
    if (m == null)
      return {};
    var q = f.arrayMap(C.getAllKeysIn(m), function(oe) {
      return [oe];
    });
    return S = i.baseIteratee(S), D.basePickBy(m, q, function(oe, fe) {
      return S(oe, fe[0]);
    });
  }
  var ht = Math.floor, Bt = Math.random;
  function pt(m, S) {
    return m + ht(Bt() * (S - m + 1));
  }
  function de(m, S, q, oe, fe) {
    return fe(m, function(pe, Ke, De) {
      q = oe ? (oe = !1, pe) : S(q, pe, Ke, De);
    }), q;
  }
  function he(m, S, q) {
    var oe = s(m) ? ce : de, fe = arguments.length < 3;
    return oe(m, i.baseIteratee(S), q, fe, n.baseEach);
  }
  function Ie(m) {
    var S = m.length;
    return S ? m[pt(0, S - 1)] : void 0;
  }
  function z(m) {
    return Ie(xe(m));
  }
  function k(m) {
    var S = s(m) ? Ie : z;
    return S(m);
  }
  var B = re.baseRest(function(m) {
    var S = $.last(m);
    return ee.isArrayLikeObject(S) && (S = void 0), ie.baseUniq(G.baseFlatten(m, 1, ee.isArrayLikeObject, !0), i.baseIteratee(S));
  });
  const A = { differenceBy: e, filter: J, find: Ve, get: u, groupBy: d, isArray: s, isEmpty: l, isEqual: h, isNil: y, isObject: c.isObject, isPlainObject: p.isPlainObject, isString: b, map: ze, mapValues: x, memoize: I, merge: L, mergeWith: P, omit: C.omit, pick: D.pick, pickBy: gt, reduce: he, sample: k, set: F, sortBy: v.sortBy, unionBy: B, uniq: w, uniqBy: E };
  t.differenceBy = e, t.isArray = s, t.isObject = c.isObject, t.get = u, t.groupBy = d, t.isEmpty = l, t.isEqual = h, t.isNil = y, t.isPlainObject = p.isPlainObject, t.isString = b, t.sortBy = v.sortBy, t.mapValues = x, t.memoize = I, t.merge = L, t.mergeWith = P, t.omit = C.omit, t.pick = D.pick, t.set = F, t.uniq = w, t.uniqBy = E, t.default = A, t.filter = J, t.find = Ve, t.map = ze, t.pickBy = gt, t.reduce = he, t.sample = k, t.unionBy = B;
})(ns);
const kt = /* @__PURE__ */ Ln(ns);
var Dw = {}, Af = {}, Ll = {};
Object.defineProperty(Ll, "__esModule", {
  value: !0
});
Ll.default = eV;
function eV(t) {
  return t == null || typeof t != "object" ? !1 : "_number" in t && "unit" in t && "unitType" in t && "baseUnit" in t;
}
var wy = {}, Dl = {};
Object.defineProperty(Dl, "__esModule", {
  value: !0
});
Dl.default = nV;
const tV = ["parse", "equals", "toJSON"], rV = ["units", "baseUnit", "defaultUnit", "ZERO"];
function nV(t) {
  return t == null || typeof t != "object" ? !1 : rV.every((e) => e in t) && tV.every((e) => typeof t[e] == "function");
}
Object.defineProperty(wy, "__esModule", {
  value: !0
});
wy.default = sV;
var CE = iV(Dl);
function iV(t) {
  return t && t.__esModule ? t : { default: t };
}
function sV(t, e, r, n = {}) {
  if (!(0, CE.default)(t) || !(0, CE.default)(e))
    throw new Error("Must pass in an instance of UnitType for ut1 and ut2.");
  const {
    unit1: i,
    unit2: s
  } = {
    unit1: t.defaultUnit,
    unit2: e.defaultUnit,
    ...n
  };
  if (!t[i])
    throw new Error(`unit1 (${i}) is not from ut1`);
  if (!e[s])
    throw new Error(`unit2 (${s}) is not from ut2`);
  return function(o) {
    const c = o.unitType;
    if (c.equals(t)) {
      const f = e.baseUnit(o._number).mul(e[s].multiplier).mul(r);
      return f._number = f._number.div(t[i].multiplier), f.to(s);
    } else if (c.equals(e)) {
      let f = t.baseUnit(o._number).mul(t[i].multiplier);
      try {
        f = f.div(r);
      } catch (u) {
        if (String(u.message) !== "Invalid division by 0")
          throw u;
        f = t.baseUnit(0);
      }
      return f._number = f._number.div(e[s].multiplier), f.to(i);
    } else
      throw new Error("Conversion error");
  };
}
var Tc = {};
Object.defineProperty(Tc, "__esModule", {
  value: !0
});
Tc.maybeReportDifferentTypesDeprecated = Tc.default = void 0;
const fI = (t) => {
  try {
    console.warn("***************************************************************"), console.warn(t), console.warn("***************************************************************"), console.trace();
  } catch {
  }
}, aV = (t, e, r) => {
  t.unitType.equals(e.unitType) || fI(`DEPRECATION WARNING: number-unit.${r} on different NumberUnit types (${t}, ${e}) is not correct and will be removed soon`);
};
Tc.maybeReportDifferentTypesDeprecated = aV;
var oV = fI;
Tc.default = oV;
Object.defineProperty(Af, "__esModule", {
  value: !0
});
Af.default = void 0;
var wn = _y(Tr), cV = _y(Ll), uV = _y(wy), gi = dV(Tc), fV = _y(Dl);
function dI(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (dI = function(n) {
    return n ? r : e;
  })(t);
}
function dV(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var r = dI(e);
  if (r && r.has(t))
    return r.get(t);
  var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in t)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(t, s)) {
      var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
      a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
    }
  return n.default = t, r && r.set(t, n), n;
}
function _y(t) {
  return t && t.__esModule ? t : { default: t };
}
function Do(t, e, r) {
  return e = lV(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function lV(t) {
  var e = hV(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function hV(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
class xr {
  static create(e, r) {
    return new xr(e, r);
  }
  constructor(e, r) {
    Do(this, "_number", void 0), Do(this, "unit", void 0), Do(this, "unitType", void 0), Do(this, "baseUnit", void 0), Do(this, "defaultUnit", void 0), Do(this, "unitName", void 0), this.unit = r, this.unitType = r.unitType, this.baseUnit = r.unitType.baseUnit, this.defaultUnit = r.unitType.defaultUnit, this.unitName = this.unit.unitName, this._number = this._createNumber(e), Object.defineProperty(this, "_numberStringMap", {
      enumerable: !1,
      value: /* @__PURE__ */ new Map(),
      writable: !0
    });
  }
  _createNumber(e) {
    if (wn.default.isBN(e))
      return e;
    const r = this._stringToNumberFraction(e, this.unit.power, {
      numberOnly: !0
    });
    return new wn.default(r, 10);
  }
  _stringToNumberFraction(e, r, {
    numberOnly: n = !1
  } = {}) {
    if (typeof e == "number") {
      if (e === Number.POSITIVE_INFINITY || e === Number.NEGATIVE_INFINITY)
        throw new Error("Infinity is not supported");
      e = e.toString();
    } else
      e = e.toLowerCase();
    if (e.length > 2 && e[0] === "0" && e[1] === "x") {
      if (e = e.slice(2), !/^[\d.a-f]*$/.test(e))
        throw new Error(`Invalid hex number: 0x${e}`);
      e = new wn.default(e, 16).toString(10);
    }
    const i = e[0] === "-";
    i && (e = e.slice(1));
    const s = i ? "-" : "";
    e[0] === "+" && !i && (e = e.slice(1));
    const a = e.indexOf("e");
    if (a !== -1) {
      if (r += Number.parseInt(e.slice(a + 1), 10), Number.isNaN(r))
        throw new TypeError(`Invalid exponential in number: ${e}`);
      e = e.slice(0, a);
    }
    if (!/^\d*\.?\d*$/.test(e))
      throw new Error(`Not allowed symbol in number: ${e}`);
    switch (e.indexOf(".")) {
      case -1: {
        e += ".0";
        break;
      }
      case 0: {
        e = "0" + e;
        break;
      }
      case e.length - 1: {
        e += "0";
        break;
      }
    }
    if (r === 0) {
      const l = e.indexOf("."), h = s + e.slice(0, l);
      if (n)
        return h;
      const y = e.slice(l + 1);
      return {
        number: h,
        fraction: s + y,
        fractionLength: y.length
      };
    }
    r > 0 ? e = e.padEnd(e.length + r, "0") : e = e.padStart(e.length - r, "0");
    const c = e.indexOf(".");
    e = e.slice(0, c) + e.slice(c + 1);
    const f = s + e.slice(0, c + r);
    if (n)
      return f;
    let u = e.slice(c + r), d = u.length - 1;
    for (; u[d] === "0" && d > 0; )
      d -= 1;
    return d !== u.length - 1 && (u = u.slice(0, d + 1)), {
      number: f,
      fraction: s + u,
      fractionLength: u.length
    };
  }
  abs() {
    return new xr(this._number.abs(), this.unit);
  }
  add(e) {
    return e = this._coerceToNumberUnit(e), (0, gi.maybeReportDifferentTypesDeprecated)(this, e, "add"), e.isZero ? this : this.isZero ? new xr(e._number, this.unit) : new xr(this._number.add(e._number), this.unit);
  }
  clampLowerZero() {
    const e = new xr(0, this.unit);
    return this.gte(e) ? this : e;
  }
  clone() {
    return new xr(this._number, this.unit);
  }
  equals(e) {
    return (0, gi.maybeReportDifferentTypesDeprecated)(this, e, "equals"), this._number.eq(e._number);
  }
  gt(e) {
    return (0, gi.maybeReportDifferentTypesDeprecated)(this, e, "gt"), this._number.gt(e._number);
  }
  gte(e) {
    return (0, gi.maybeReportDifferentTypesDeprecated)(this, e, "gte"), this._number.gte(e._number);
  }
  lt(e) {
    return (0, gi.maybeReportDifferentTypesDeprecated)(this, e, "lt"), this._number.lt(e._number);
  }
  lte(e) {
    return (0, gi.maybeReportDifferentTypesDeprecated)(this, e, "lte"), this._number.lte(e._number);
  }
  mul(e) {
    if (wn.default.isBN(e))
      return new xr(this._number.mul(e), this.unit);
    xr.isNumberUnit(e) && (0, gi.maybeReportDifferentTypesDeprecated)(this, e, "mul");
    const {
      number: r,
      fraction: n,
      fractionLength: i
    } = this._stringToNumberFraction(e, 0), s = new wn.default(0, 10);
    if (r !== "0" && r !== "-0" && this._number.mulTo(new wn.default(r, 10), s), n !== "0" && n !== "-0") {
      const a = new wn.default(n, 10).imul(this._number).div(new wn.default(10, 10).pow(new wn.default(i, 10)));
      s.iadd(a);
    }
    return new xr(s, this.unit);
  }
  div(e) {
    if (wn.default.isBN(e))
      return new xr(this._number.div(e), this.unit);
    xr.isNumberUnit(e) && (0, gi.maybeReportDifferentTypesDeprecated)(this, e, "div");
    const {
      number: r,
      fraction: n,
      fractionLength: i
    } = this._stringToNumberFraction(e, 0), s = new wn.default(10, 10).pow(new wn.default(i, 10)), a = new wn.default(r, 10).imul(s).iadd(new wn.default(n, 10));
    if (a.isZero())
      throw new Error("Invalid division by 0");
    const o = this._number.mul(s).div(a);
    return new xr(o, this.unit);
  }
  floor() {
    if (this.unit.power === 0)
      return this;
    {
      const e = this._toNumberString(), [r] = e.split(".");
      return new xr(r, this.unit);
    }
  }
  round() {
    if (this.unit.power === 0)
      return this;
    {
      const e = this._toNumberString(), [r, n] = e.split(".");
      let i = new xr(r, this.unit);
      return n && Math.round(Number.parseFloat(`0.${n}`)) > 0 && (i = i.add(new xr(1, this.unit))), i;
    }
  }
  ceil() {
    if (this.unit.power === 0)
      return this;
    {
      const e = this._toNumberString(), [r, n] = e.split(".");
      let i = new xr(r, this.unit);
      return n && Math.ceil(Number.parseFloat(`0.${n}`)) > 0 && (i = i.add(new xr(1, this.unit))), i;
    }
  }
  toFixed(e, r) {
    const n = new wn.default(10, 10).pow(new wn.default(e, 10));
    let i = new xr(this._number.mul(n), this.unit);
    switch (r) {
      case "floor":
        i = i.floor();
        break;
      case "ceil":
        i = i.ceil();
        break;
      default:
        i = i.round();
    }
    return i = new xr(i._number.div(n), this.unit), i;
  }
  negate() {
    return new xr(this._number.neg(), this.unit);
  }
  sub(e) {
    return e = this._coerceToNumberUnit(e), (0, gi.maybeReportDifferentTypesDeprecated)(this, e, "sub"), e.isZero ? this : this.isZero ? new xr(e._number.neg(), this.unit) : new xr(this._number.sub(e._number), this.unit);
  }
  cast(e) {
    if (!(0, fV.default)(e))
      throw new Error("unitType needs to be a UnitType instance");
    if (this.unitType.equals(e))
      return this.toBase();
    const r = e.baseUnit;
    let n = this._number;
    const i = this.unitType.defaultUnit.power, s = e.defaultUnit.power;
    if (n.isZero() || i === s)
      return new xr(n, r);
    const a = new wn.default(10, 10).pow(new wn.default(Math.abs(s - i), 10));
    return i < s ? n = n.mul(a) : i > s && (n = n.div(a)), new xr(n, r);
  }
  toBase() {
    return this.unit.power === 0 ? this : new xr(this._number, this.baseUnit);
  }
  toDefault() {
    return this.defaultUnit === this.unit ? this : this.to(this.defaultUnit);
  }
  to(e, r) {
    if (e === this.unit)
      return this;
    if (typeof e == "string" && (e = this.unitType.units[e]), this.unit.unitType.equals(e.unitType))
      return new xr(this._number, e);
    if (!r)
      throw new Error("Incompatible unit types. Must specify a conversion.");
    if (typeof r == "function")
      return r(this);
    {
      if (!this.unitType.equals(r.from.unitType))
        throw new Error("Conversion unit from is of different type.");
      const n = Number.parseFloat(r.toValue) / Number.parseFloat(r.fromValue);
      return (0, uV.default)(r.from.unitType, r.to.unitType, n, {
        unit1: r.fromUnit,
        unit2: r.toUnit
      })(this);
    }
  }
  toJSON() {
    return {
      value: this._toNumberString(),
      unit: this.unitName,
      unitType: this.unitType.toString(),
      type: "NumberUnit"
    };
  }
  toNumber(e) {
    return Number.parseFloat(this._toNumberString(e));
  }
  toDefaultNumber() {
    return this.toNumber(this.defaultUnit);
  }
  toBaseNumber() {
    return this.toNumber(this.baseUnit);
  }
  toBaseBufferLE(e) {
    return this._number.toBuffer("le", e);
  }
  toBaseBufferBE(e) {
    return this._number.toBuffer("be", e);
  }
  toNumberString(e) {
    return (0, gi.default)("DEPRECATION WARNING: number-unit.toNumberString usage will be removed soon. Use number-unit.toString({unit: false}) instead"), this._toNumberString(e);
  }
  _toNumberString(e = this.unit) {
    const r = "WARNING: number-unit was cloned improperly and is no longer a NumberUnit instance", n = e.toString();
    if (this._numberStringMap && this._numberStringMap.get(n))
      return this._numberStringMap.get(n);
    this._numberStringMap || (0, gi.default)(r);
    let i;
    e === this.unit ? i = this : i = this.to(e);
    let s = i._number.toString(10);
    if (i.unit.power === 0)
      return this._numberStringMap ? this._numberStringMap.set(n, s) : (0, gi.default)(r), s;
    const a = s[0] === "-";
    a && (s = s.slice(1)), s.length < i.unit.power + 1 && (s = s.padStart(i.unit.power + 1, "0")), s = s.slice(0, -i.unit.power) + "." + s.slice(-i.unit.power);
    const o = s.indexOf(".");
    if (o !== -1) {
      let c = s.length - 1;
      for (; s[c] === "0" && c > o; )
        c -= 1;
      c !== s.length - 1 && (s[c] === "." && c--, s = s.slice(0, c + 1));
    }
    return a && (s = "-" + s), this._numberStringMap ? this._numberStringMap.set(n, s) : (0, gi.default)(r), s;
  }
  toString({
    unit: e = !0,
    format: r,
    unitInstance: n = this.unit
  } = {}) {
    return r ? r(this._toNumberString(n), n) : this._toNumberString(n) + (e ? " " + n.unitName : "");
  }
  toDefaultString({
    unit: e = !1
  } = {}) {
    return this.toString({
      unitInstance: this.defaultUnit,
      unit: e
    });
  }
  toBaseString({
    unit: e = !1
  } = {}) {
    return this.toString({
      unitInstance: this.baseUnit,
      unit: e
    });
  }
  valueOf() {
    return this.toDefaultNumber();
  }
  get value() {
    return this.toString();
  }
  get isNegative() {
    return this._number.isNeg();
  }
  get isPositive() {
    return this._number.gt(new wn.default(0));
  }
  get isZero() {
    return this._number.isZero();
  }
  _coerceToNumberUnit(e) {
    return xr.isNumberUnit(e) ? e : ((0, gi.default)("DEPRECATION WARNING: number-unit.add/sub usage with int or string param will be removed soon"), new xr(e, this.unit));
  }
}
Af.default = xr;
Do(xr, "isNumberUnit", cV.default);
Object.defineProperty(Dw, "__esModule", {
  value: !0
});
Dw.create = gV;
var NE = Fw(Tr), pV = Fw(Af), yV = Fw(Ll), bV = Tc;
function Fw(t) {
  return t && t.__esModule ? t : { default: t };
}
function gV(t, e, r) {
  if (r < 0)
    throw new Error("power cannot be less than 0");
  const n = function(i) {
    if (Number.isNaN(i))
      throw new Error("Value NaN not supported for number unit conversion.");
    return (0, yV.default)(i) ? ((0, bV.maybeReportDifferentTypesDeprecated)(i, n, "create"), i.to(n)) : pV.default.create(i, n);
  };
  return n.unitName = e, n.power = r, n.multiplier = new NE.default(10, 10).pow(new NE.default(r)), n.unitType = t, n.toJSON = function() {
    return {
      unitName: n.unitName,
      power: n.power
    };
  }, n[Symbol.toStringTag] = () => String(n), n.toString = function() {
    return n.unitName;
  }, n;
}
Object.defineProperty(Rl, "__esModule", {
  value: !0
});
Rl.default = void 0;
var Kh = lI(hr), xv = ns, mV = Dw, vV = lI(Dl);
function lI(t) {
  return t && t.__esModule ? t : { default: t };
}
function wV(t, e, r) {
  _V(t, e), e.set(t, r);
}
function _V(t, e) {
  if (e.has(t))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Vh(t, e, r) {
  return e = SV(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function SV(t) {
  var e = EV(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function EV(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function xV(t, e) {
  var r = hI(t, e, "get");
  return AV(t, r);
}
function AV(t, e) {
  return e.get ? e.get.call(t) : e.value;
}
function IV(t, e, r) {
  var n = hI(t, e, "set");
  return TV(t, n, r), r;
}
function hI(t, e, r) {
  if (!e.has(t))
    throw new TypeError("attempted to " + r + " private field on non-instance");
  return e.get(t);
}
function TV(t, e, r) {
  if (e.set)
    e.set.call(t, r);
  else {
    if (!e.writable)
      throw new TypeError("attempted to set read only private field");
    e.value = r;
  }
}
const pI = Symbol("UnitType"), UE = (t) => t;
var gg = /* @__PURE__ */ new WeakMap();
class Ld {
  static equals(e, r) {
    return (0, Kh.default)(e instanceof Ld, "argument must be a UnitType"), e === r || e.equals(r);
  }
  constructor(e, r) {
    Vh(this, "units", void 0), Vh(this, "baseUnit", void 0), Vh(this, "defaultUnit", void 0), wV(this, gg, {
      writable: !0,
      value: void 0
    }), (0, Kh.default)(r === pI, "please use UnitType.create()"), this.units = {}, Object.keys(e).forEach((i) => {
      this.units[i] = (0, mV.create)(this, i, e[i]), this[i] = this.units[i];
    });
    const n = Object.keys(this.units).filter((i) => this.units[i].power === 0);
    if (n.length === 0)
      throw new Error("Must specify at least one unit with a power of 0.");
    this.baseUnit = this.units[n[0]], this.defaultUnit = Object.values(this.units).reduce((i, s) => Math.trunc(i.power) > s.power ? i : s, {}), IV(this, gg, this.defaultUnit(0));
  }
  equals(e) {
    return (0, Kh.default)((0, vV.default)(e), "argument must be a UnitType"), this === e || this.toString() === e.toString();
  }
  parse(e) {
    const [r, n] = e.split(" ");
    if (this.units[n] === void 0)
      throw new Error(`Unit "${n}" not found from parsing "${e}"`);
    return this.units[n](r);
  }
  toString() {
    return String(this.defaultUnit);
  }
  toJSON() {
    return (0, xv.mapValues)(this.units, (e) => e.power);
  }
  get ZERO() {
    return xV(this, gg);
  }
}
Rl.default = Ld;
Vh(Ld, "create", (0, xv.memoize)((t) => ((0, Kh.default)(!(0, xv.isEmpty)(t), "definitions must have at least one item"), new Ld(UE(t), pI)), (t) => JSON.stringify(UE(t))));
Object.defineProperty(sy, "__esModule", {
  value: !0
});
sy.createFromBaseValue = void 0;
var kV = RV(Rl);
function RV(t) {
  return t && t.__esModule ? t : { default: t };
}
const PV = ({
  value: t,
  symbol: e,
  power: r
}) => kV.default.create({
  base: 0,
  [e]: r
}).baseUnit(t);
sy.createFromBaseValue = PV;
var jw = {};
Object.defineProperty(jw, "__esModule", {
  value: !0
});
jw.default = BV;
OV(Af);
function OV(t) {
  return t && t.__esModule ? t : { default: t };
}
function BV(t, e) {
  const r = t.unitType, n = e.unitType;
  return function(s) {
    const a = s.unitType;
    if (a.equals(r)) {
      const o = s.to(t.unitName), c = t.isZero ? t.unitType.ZERO._number : o._number.mul(e._number).div(t._number);
      return n[e.unitName](c).to(e.unitName);
    } else if (a.equals(n)) {
      const o = s.to(e.unitName), c = e.isZero ? e.unitType.ZERO._number : o._number.mul(t._number).div(e._number);
      return r[t.unitName](c).to(t.unitName);
    } else
      throw new Error("Conversion error");
  };
}
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var e = {
    isNumberUnit: !0,
    conversionByRate: !0,
    conversion: !0,
    UnitType: !0
  };
  Object.defineProperty(t, "UnitType", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(t, "conversion", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(t, "conversionByRate", {
    enumerable: !0,
    get: function() {
      return s.default;
    }
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(t, "isNumberUnit", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  });
  var r = sy;
  Object.keys(r).forEach(function(f) {
    f === "default" || f === "__esModule" || Object.prototype.hasOwnProperty.call(e, f) || f in t && t[f] === r[f] || Object.defineProperty(t, f, {
      enumerable: !0,
      get: function() {
        return r[f];
      }
    });
  });
  var n = c(Af), i = c(Ll), s = c(wy), a = c(jw), o = c(Rl);
  function c(f) {
    return f && f.__esModule ? f : { default: f };
  }
})(Ps);
const Us = (t, e, r) => {
  t[e] === void 0 && r !== void 0 && (t[e] = r);
}, MV = ({ assets: t, asset: e }) => {
  if (Object.defineProperties(e, {
    baseAsset: {
      get() {
        return t[e.baseAssetName || e.name];
      },
      enumerable: !0
    },
    feeAsset: {
      get() {
        return t[e.feeAssetName || e.baseAssetName || e.name];
      },
      enumerable: !0
    }
  }), e.isCombined) {
    const r = e.combinedAssetNames.filter((n) => t[n]);
    Object.defineProperties(e, {
      combinedAssetNames: {
        get() {
          return r;
        },
        enumerable: !0
      }
    }), Object.defineProperties(e, {
      combinedAssets: {
        get() {
          return r.map((n) => t[n]);
        },
        enumerable: !0
      }
    });
  }
  e.isBuiltIn = !e.isCustomToken, e.isCustomToken && CV(e, e.baseAsset);
};
function CV(t, e) {
  const { units: r, properName: n, properTicker: i, ticker: s, color: a } = t;
  Us(t, "currency", Ps.UnitType.create(r)), Us(t, "displayName", n), Us(t, "displayTicker", i || s), Us(t, "primaryColor", a || "#FFFFFF"), Us(t, "chainBadgeColors", e.chainBadgeColors), Us(t, "displayNetworkName", e.displayNetworkName || e.displayName), Us(
    t,
    "displayNetworkTicker",
    e.displayNetworkTicker || e.displayTicker
  ), Us(t, "blockExplorer", e.blockExplorer), Us(t, "gradientCoords", { x1: "0%", y1: "0%", x2: "100%", y2: "100%" }), Us(t, "gradientColors", ["#EAEAEA", "#FFF"]);
  const { displayName: o, displayTicker: c } = t;
  return t.properName = o, t.properTicker = c, t;
}
const NV = (t) => Object.values(t).sort(
  (e, r) => +(r.baseAssetName === r.name) - +(e.baseAssetName === e.name)
);
function UV(t) {
  const e = J0.mapValues(t, (r) => ({ ...r }));
  return NV(e).forEach((r) => MV({ assets: e, asset: r })), e;
}
var yc = {}, Sy = {};
Object.defineProperty(Sy, "__esModule", {
  value: !0
});
Sy.default = void 0;
var LV = [{
  name: "7dhb_solana_c9e04412",
  displayName: "Lido Staked SOL",
  decimals: 9,
  ticker: "7DHBsolanaC9E04412",
  displayTicker: "stSOL",
  mintAddress: "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
  info: {
    description: "When someone stakes their SOL with Lido, they instantly receive stSOL tokens in return. The stSOL tokens increase in value over time and can be used in other DeFi products while the SOL is staked.",
    telegram: "https://t.me/lidofinance",
    reddit: "https://reddit.com/r/lidofinance",
    twitter: "https://twitter.com/lidofinance",
    website: "https://www.lido.fi"
  },
  primaryColor: "#00A3FF",
  gradientColors: ["#00A3FF", "#3ADCFF"],
  gradientCoords: {
    x1: "29.931%",
    y1: "11.994%",
    x2: "10.494%",
    y2: "28.187%"
  }
}, {
  name: "7i5k_solana_c9e04412",
  displayName: "STEPN",
  decimals: 9,
  ticker: "7I5KsolanaC9E04412",
  displayTicker: "GMT",
  mintAddress: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
  primaryColor: "#E6BC7B",
  gradientColors: ["#FFE5C0", "#E6BC7B"],
  gradientCoords: {
    x1: "3%",
    y1: "8.5%",
    x2: "41.043%",
    y2: "26.738%"
  }
}, {
  name: "8hgy_solana_43b58185",
  displayName: "COPE",
  decimals: 6,
  ticker: "8HGYsolana43B58185",
  displayTicker: "COPE",
  mintAddress: "8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh",
  info: {
    description: "Cope ranks and indexes online call makers (such as trader influencers on social media), and filters out the ones who make low quality calls. This creates a powerful leaderboard that can be used to follow the top call makers.",
    twitter: "https://twitter.com/unlimitedcope",
    website: "https://www.unlimitedcope.com"
  },
  primaryColor: "#77B0DD",
  gradientColors: ["#44b6BB", "#77B0DD"],
  gradientCoords: {
    x1: "19.031%",
    y1: "-66.682%",
    x2: "123.324%",
    y2: "91.487%"
  }
}, {
  name: "audius_solana",
  displayName: "Audius",
  decimals: 8,
  ticker: "AUDIOSOL",
  displayTicker: "AUDIO",
  mintAddress: "9LzCMqDgTKYz9Drzqnpgee3SGa89up3a247ypMj2xrqM",
  primaryColor: "#ED43FF",
  gradientColors: ["#EAEAEA", "#FFF"],
  gradientCoords: {
    x1: "19.031%",
    y1: "-66.682%",
    x2: "123.324%",
    y2: "91.487%"
  }
}, {
  name: "aury_solana_c9e04412",
  displayName: "Aurory",
  decimals: 9,
  ticker: "AURYsolanaC9E04412",
  displayTicker: "AURY",
  mintAddress: "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
  info: {
    description: "Aurory is a Solana-based role-playing game that rewards players with NFTs and tokens. Its universe has a blend of Japanese, retro, and futuristic styles, including hand-drawn art.",
    twitter: "https://twitter.com/auroryproject",
    website: "https://aurory.io/",
    telegram: "https://t.me/aurory_project"
  },
  primaryColor: "#B53BE1",
  gradientColors: ["#8312AC", "#B53BE1"],
  gradientCoords: {
    x1: "22.6%",
    y1: "7.867%",
    x2: "22.426%",
    y2: "30.81%"
  }
}, {
  name: "eche_solana_c5cba5c4",
  displayName: "Bonfida",
  decimals: 6,
  ticker: "ECHEsolanaC5CBA5C4",
  displayTicker: "FIDA",
  mintAddress: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
  info: {
    description: "FIDA is a Solana-based governance token that offers multiple services such as a graphical user interface for the Serum DEX and Solana data analytics.",
    website: "https://bonfida.org/#/",
    telegram: "https://t.me/bonfidatg"
  },
  primaryColor: "#6868FC",
  gradientColors: ["#A0A0FF", "#6868FC"],
  gradientCoords: {
    x1: "-4.68%",
    y1: "1.381%",
    x2: "48.573%",
    y2: "30.414%"
  }
}, {
  name: "dezx_solana_3b523050",
  displayName: "Bonk",
  decimals: 5,
  ticker: "DEZXsolana3B523050",
  displayTicker: "BONK",
  mintAddress: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263",
  info: {
    description: "BONK is a memecoin that gave users airdrops of BONK on the Solana network.",
    website: "https://www.bonkcoin.com/"
  },
  primaryColor: "#6868FC",
  gradientColors: ["#A0A0FF", "#6868FC"],
  gradientCoords: {
    x1: "-4.68%",
    y1: "1.381%",
    x2: "48.573%",
    y2: "30.414%"
  }
}, {
  name: "gene_solana_c9e04412",
  displayName: "Genopets",
  decimals: 9,
  ticker: "GENEsolanaC9E04412",
  displayTicker: "GENE",
  mintAddress: "GENEtH5amGSi8kHAtQoezp1XEXwZJ8vcuePYnXdKrMYz",
  info: {
    description: "Genopets is a game that rewards users for being active while raising their in-game Genopet. The GENE token offers staking, NFT-creation, exclusive features, and governance of the Genopets platform.",
    reddit: "https://reddit.com/r/genopets",
    twitter: "https://twitter.com/genopets",
    website: "https://www.genopets.me/"
  },
  primaryColor: "#00FFC8",
  gradientColors: ["#00AE89", "#00FFC8"],
  gradientCoords: {
    x1: "19.031%",
    y1: "-66.682%",
    x2: "123.324%",
    y2: "91.487%"
  }
}, {
  name: "jupy_solana_ed7ebe51",
  displayName: "Jupiter",
  decimals: 6,
  ticker: "JUPYsolanaED7EBE51",
  displayTicker: "JUP",
  mintAddress: "JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN",
  info: {
    description: "JUP is the governance token of the Jupiter platform, originally split 50% to the community and 50% to the Jupiter ecosystem team.  Holders are expecting to vote on token mints and initiatives within the Jupiter platform.",
    twitter: "https://twitter.com/JupiterExchange",
    website: "https://jup.ag/"
  },
  primaryColor: "#00FFC8",
  gradientColors: ["#98C158", "#C7F284"],
  gradientCoords: {
    x1: "19.031%",
    y1: "-66.682%",
    x2: "123.324%",
    y2: "91.487%"
  }
}, {
  name: "kinx_solana_bf1442d2",
  displayName: "KIN",
  decimals: 5,
  ticker: "KINXsolanaBF1442D2",
  displayTicker: "KIN",
  mintAddress: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
  info: {
    description: "Kin is used as money in consumer apps and services in the spaces of gaming, finance, communication, and more. By implementing Kin, apps can offer their users the ability to earn, pay, or transfer cryptocurrency.",
    telegram: "https://t.me/TheKinChannel",
    reddit: "https://reddit.com/r/KinFoundation",
    twitter: "https://twitter.com/kin_ecosystem",
    website: "https://kin.org"
  },
  primaryColor: "#946DFC",
  gradientColors: ["#EAEAEA", "#FFF"],
  gradientCoords: {
    x1: "19.031%",
    y1: "-66.682%",
    x2: "123.324%",
    y2: "91.487%"
  }
}, {
  name: "mang_solana_c5cba5c4",
  displayName: "Mango",
  decimals: 6,
  ticker: "MANGsolanaC5CBA5C4",
  displayTicker: "MNGO",
  mintAddress: "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
  info: {
    description: "MNGO is a governance token for Mango, a DAO offering margin trading, lending, and perpetual futures. Powered by Solana, Mango’s transactions are nearly instant, with fees close to zero. ",
    twitter: "https://twitter.com/mangomarkets",
    website: "https://mango.markets/"
  },
  primaryColor: "#EEB91B",
  gradientColors: ["#E54033", "#EEB91B"],
  gradientCoords: {
    x1: "61.5%",
    y1: "7.3%",
    x2: "47.7%",
    y2: "-6.5%"
  }
}, {
  name: "mean_solana_c5cba5c4",
  displayName: "Meanfi",
  decimals: 6,
  ticker: "MEANsolanaC5CBA5C4",
  displayTicker: "MEAN",
  mintAddress: "MEANeD3XDdUmNMsRGjASkSWdC8prLYsoRJ61pPeHctD",
  info: {
    description: "MeanFi is a self-custody, trustless bank that connects traditional finance and DeFi. It can save users time and money with services such as money streaming, dollar cost averaging, and searches that find the best prices for Solana-based exchanges.",
    twitter: "https://twitter.com/meanfinance",
    website: "https://meanfi.com/"
  },
  primaryColor: "#FF4F4F",
  gradientColors: ["#B7011C", "#FF4F4F"],
  gradientCoords: {
    x1: "10.5%",
    y1: "3.5%",
    x2: "38.5%",
    y2: "53.5%"
  }
}, {
  name: "msol_solana_c9e04412",
  displayName: "Marinade Staked SOL",
  decimals: 9,
  ticker: "MSOLsolanaC9E04412",
  displayTicker: "mSOL",
  mintAddress: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
  info: {
    description: "Marinade Staked SOL is a token users receive for staking their SOL with Marinade, the first liquid staking protocol built on Solana. While earning staking rewards with Marinade, users can earn even more by using their mSOL for borrowing, lending, and other DeFi use cases.",
    twitter: "https://twitter.com/MarinadeFinance",
    website: "https://marinade.finance/"
  },
  primaryColor: "#C8ECE1",
  gradientColors: ["#308DBA", "#C8ECE1"],
  gradientCoords: {
    x1: "-3.5%",
    y1: "3.5%",
    x2: "48.05%",
    y2: "30.724%"
  }
}, {
  name: "orca_solana",
  displayName: "Orca",
  decimals: 6,
  ticker: "ORCASOL",
  displayTicker: "ORCA",
  mintAddress: "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
  info: {
    description: "Orca is an AMM on Solana where users can exchange assets with low fees and get rewarded for providing liquidity to trading pools.",
    reddit: "https://www.reddit.com/r/orca_so",
    twitter: "https://twitter.com/orca_so",
    website: "https://orca.so",
    telegram: "https://t.me/orca_so"
  },
  primaryColor: "#5969DB",
  gradientColors: ["#1D257A", "#5969DB"],
  gradientCoords: {
    x1: "44.5%",
    y1: "40%",
    x2: "-4.548%",
    y2: "4.017%"
  }
}, {
  name: "poli_solana_0cc3745c",
  displayName: "Star Atlas DAO",
  decimals: 8,
  ticker: "POLIsolana0CC3745C",
  displayTicker: "POLIS",
  mintAddress: "poLisWXnNRwC6oBu1vHiuKQzFjGL4XDSu4g9qjz9qVk",
  info: {
    description: "Star Atlas DAO (POLIS) is the governance token for Star Atlas, an expansive, breathtaking gaming metaverse. POLIS holders can participate in decisions that affect how Star Atlas is operated.",
    reddit: "https://reddit.com/r/staratlas",
    twitter: "https://twitter.com/staratlas",
    website: "https://staratlas.com"
  },
  primaryColor: "#32FFFF",
  gradientColors: ["#32FFFF", "#EDFEFF"],
  gradientCoords: {
    x1: "19.031%",
    y1: "-66.682%",
    x2: "123.324%",
    y2: "91.487%"
  }
}, {
  name: "raydium",
  displayName: "Raydium",
  decimals: 6,
  ticker: "RAY",
  mintAddress: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
  info: {
    description: "Raydium, an AMM (Automated Market Market), powers DeFi on the Solana blockchain, providing on-chain liquidity for the Serum Decentralized Exchange. This means lightning fast token swaps and a whole lot more!",
    twitter: "https://twitter.com/RaydiumProtocol",
    website: "https://raydium.io/",
    telegram: "https://t.me/raydiumprotocol"
  },
  primaryColor: "#3772FF",
  gradientColors: ["#3772FF", "#C200FB"],
  gradientCoords: {
    x1: "99.911%",
    y1: "25.033%",
    x2: "-6.116%",
    y2: "61.756%"
  }
}, {
  name: "rndr_solana_4b3ba195",
  displayName: "Render",
  decimals: 8,
  ticker: "RNDRsolana4B3BA195",
  displayTicker: "RENDER",
  mintAddress: "rndrizKT3MK1iimdxRdWabcF7Zg7AR5T4nud4EkHBof",
  info: {
    description: "Render is a token that creators can pay to node operators to get GPU rendering power for their work on images, animation, and special effects. This saves creators money as it’s cheaper than in-house rendering, and it allows node operators to earn RNDR with their idle GPUs.",
    reddit: "https://www.reddit.com/r/RenderToken/",
    twitter: "https://twitter.com/rendertoken",
    website: "https://rendertoken.com/",
    telegram: "https://t.me/RenderTokenOfficial"
  },
  primaryColor: "#FF5A5A",
  gradientColors: ["#E62249", "#FF5A5A"],
  gradientCoords: {
    x1: "38%",
    y1: "37.5%",
    x2: "0.537%",
    y2: "6.714%"
  }
}, {
  name: "serum",
  displayName: "Serum",
  decimals: 6,
  ticker: "SRM",
  mintAddress: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
  info: {
    description: "SRM tokens power Serum, a centralized exchange software system built on the Solana blockchain. It allows for trading of cryptocurrencies and has the advantage of a cross-chain support, meaning that it enables a trustless exchange of crypto between various blockchains.",
    reddit: "https://www.reddit.com/r/ProjectSerum/",
    twitter: "https://twitter.com/ProjectSerum",
    website: "https://projectserum.com/"
  },
  primaryColor: "#71E0EC",
  gradientColors: ["#71E0EC", "#05AAC5"],
  gradientCoords: {
    x1: "0%",
    y1: "-.006%",
    x2: "99.694%",
    y2: "99.694%"
  }
}, {
  name: "smoothlovepotion_solana",
  displayName: "Smooth Love Potion",
  decimals: 8,
  ticker: "SLPSOL",
  displayTicker: "SLP",
  mintAddress: "4hpngEp1v3CXpeKB81Gw4sv7YvwUVRKvY3SGag9ND8Q4",
  primaryColor: "#77BAA1",
  gradientColors: ["#EAEAEA", "#FFF"],
  gradientCoords: {
    x1: "19.031%",
    y1: "-66.682%",
    x2: "123.324%",
    y2: "91.487%"
  }
}, {
  name: "staratlas_solana",
  displayName: "Star Atlas",
  decimals: 8,
  ticker: "ATLASSOL",
  displayTicker: "ATLAS",
  mintAddress: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
  info: {
    description: "Star Atlas is a massive multiplayer online game in a breathtaking metaverse run on Solana. Players can travel in space, build space stations, form alliances, and battle for virtual assets.",
    reddit: "https://reddit.com/r/staratlas",
    twitter: "https://twitter.com/staratlas",
    website: "https://staratlas.com",
    telegram: "https://t.me/staratlasgame"
  },
  primaryColor: "#32FFFF",
  gradientColors: ["#32FFFF", "#EDFEFF"],
  gradientCoords: {
    x1: "44.5%",
    y1: "40%",
    x2: "-4.548%",
    y2: "4.017%"
  }
}, {
  name: "tetherusd_solana",
  displayName: "Tether USD",
  decimals: 6,
  ticker: "USDTSOL",
  displayTicker: "USDT",
  mintAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
  primaryColor: "#53AE94",
  gradientColors: ["#EAEAEA", "#FFF"],
  gradientCoords: {
    x1: "19.031%",
    y1: "-66.682%",
    x2: "123.324%",
    y2: "91.487%"
  }
}, {
  name: "thegraph_solana",
  displayName: "The Graph",
  decimals: 8,
  ticker: "GRTSOL",
  displayTicker: "GRT",
  mintAddress: "HGsLG4PnZ28L8A4R5nPqKgZd86zUUdmfnkTRnuFJ5dAX",
  primaryColor: "#33A0FF",
  gradientColors: ["#EAEAEA", "#FFF"],
  gradientCoords: {
    x1: "19.031%",
    y1: "-66.682%",
    x2: "123.324%",
    y2: "91.487%"
  }
}, {
  name: "tulip_solana",
  displayName: "Tulip Protocol",
  decimals: 6,
  ticker: "TULIPSOL",
  displayTicker: "TULIP",
  mintAddress: "TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs",
  info: {
    description: "Tulip is the first Solana-powered platform to offer decentralized yield aggregation and auto-compounding vault strategies.",
    twitter: "https://twitter.com/tulipprotocol",
    website: "https://tulip.garden",
    telegram: "https://t.me/tulipprotocol"
  },
  primaryColor: "#1C88B4",
  gradientColors: ["#2BD9B9", "#D141E9"],
  gradientCoords: {
    x1: "44.5%",
    y1: "40%",
    x2: "-4.548%",
    y2: "4.017%"
  }
}, {
  name: "usdcoin_solana",
  displayName: "USD Coin",
  decimals: 6,
  ticker: "USDCSOL",
  displayTicker: "USDC",
  mintAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
  primaryColor: "#3E90E8",
  gradientColors: ["#EAEAEA", "#FFF"],
  gradientCoords: {
    x1: "19.031%",
    y1: "-66.682%",
    x2: "123.324%",
    y2: "91.487%"
  }
}];
Sy.default = LV;
var $w = {};
Object.defineProperty($w, "__esModule", {
  value: !0
});
$w.extractUnits = DV;
function DV(t) {
  return t.units || {
    base: 0,
    [t.ticker]: t.decimals
  };
}
Object.defineProperty(yc, "__esModule", {
  value: !0
});
yc.tokens = EI = yc.default = yc.asset = void 0;
var FV = $V(Sy), jV = $w, yI = Ps;
function $V(t) {
  return t && t.__esModule ? t : { default: t };
}
const Av = "solana", Iv = "Solana", qV = "SOL", Tv = "SOL", bI = Tv, gI = Iv, mI = Av, WV = "#14F195", zV = ["#14F195", "#9BFFD7"], KV = {
  x1: "12.519%",
  y1: "28.482%",
  x2: "27.289%",
  y2: "11.831%"
}, VV = ["#0CF3A8", "#D823FE"], vI = {
  Lamports: 0,
  SOL: 9
}, HV = yI.UnitType.create(vI), GV = "SOLANA_LIKE", wI = {
  addressUrl: (t) => `https://solscan.io/account/${encodeURIComponent(t)}`,
  txUrl: (t) => `https://solscan.io/tx/${encodeURIComponent(t)}`
}, ZV = {
  description: "Solana is a high-performance blockchain, taking on one of tech's biggest challenges: scaling blockchain for global adoption.",
  reddit: "https://www.reddit.com/r/solana/",
  twitter: "https://twitter.com/solana",
  website: "https://solana.com/",
  telegram: "https://t.me/solana"
}, _I = {
  assetType: GV,
  baseAssetName: mI,
  blockExplorer: wI,
  chainBadgeColors: VV,
  currency: HV,
  displayName: Iv,
  displayNetworkName: gI,
  displayNetworkTicker: bI,
  displayTicker: Tv,
  gradientColors: zV,
  gradientCoords: KV,
  info: ZV,
  name: Av,
  primaryColor: WV,
  properName: Iv,
  // deprecated
  properTicker: Tv,
  // deprecated
  ticker: qV,
  toString: () => Av,
  units: vI
};
yc.asset = _I;
const SI = FV.default.map((t) => {
  const e = (0, jV.extractUnits)(t);
  return {
    ...t,
    // name,
    // displayName,
    // decimals,
    // ticker,
    // info,
    // primaryColor,
    // gradientColors
    // gradientCoords
    assetType: "SOLANA_TOKEN",
    baseAssetName: mI,
    blockExplorer: wI,
    chainBadgeColors: t.chainBadgeColors || t.gradientColors,
    currency: yI.UnitType.create(e),
    displayNetworkName: gI,
    displayNetworkTicker: bI,
    displayTicker: t.displayTicker || t.ticker,
    mintAddress: t.mintAddress,
    info: t.info || {},
    properName: t.displayName,
    // deprecated
    properTicker: t.displayTicker || t.ticker,
    // deprecated
    toString: () => t.name,
    units: e
  };
});
yc.tokens = SI;
var JV = [_I, ...SI], EI = yc.default = JV, xI = {}, kv = function() {
  return kv = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, kv.apply(this, arguments);
}, LE = function(t, e, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = e.length, s; n < i; n++)
      (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return t.concat(s || Array.prototype.slice.call(e));
}, od = function(t, e, r) {
  if (r === void 0 && (r = !1), !t || !e || typeof t != "object" || typeof e != "object")
    return t;
  var n = kv({}, t);
  for (var i in e)
    e.hasOwnProperty(i) && (e[i] instanceof Array && t[i] instanceof Array ? n[i] = r ? LE(LE([], t[i], !0), e[i], !0) : e[i] : typeof e[i] == "object" && typeof t[i] == "object" ? n[i] = od(t[i], e[i], r) : n[i] = e[i]);
  return n;
};
const DE = globalThis || void 0 || self;
var YV = function(t, e, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = e.length, s; n < i; n++)
      (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return t.concat(s || Array.prototype.slice.call(e));
}, Ei = {
  // Default options
  defaults: {},
  // Error type
  errorType: null,
  // Polyfills
  polyfills: {
    fetch: null,
    FormData: null,
    URLSearchParams: null,
    performance: null,
    PerformanceObserver: null,
    AbortController: null
  },
  polyfill: function(t, e) {
    for (var r = e === void 0 ? {} : e, n = r.doThrow, i = n === void 0 ? !0 : n, s = r.instance, a = s === void 0 ? !1 : s, o = [], c = 2; c < arguments.length; c++)
      o[c - 2] = arguments[c];
    var f = this.polyfills[t] || (typeof self < "u" ? self[t] : null) || (typeof DE < "u" ? DE[t] : null);
    if (i && !f)
      throw new Error(t + " is not defined");
    return a && f ? new (f.bind.apply(f, YV([void 0], o, !1)))() : f;
  }
}, AI = function(t, e, r, n) {
  if (!t.getEntriesByName)
    return !1;
  var i = t.getEntriesByName(e);
  return i && i.length > 0 ? (r(i.reverse()[0]), n.clearMeasures && n.clearMeasures(e), ws.callbacks.delete(e), ws.callbacks.size < 1 && (ws.observer.disconnect(), n.clearResourceTimings && n.clearResourceTimings()), !0) : !1;
}, QV = function(t, e) {
  return !ws.observer && t && e && (ws.observer = new e(function(r) {
    ws.callbacks.forEach(function(n, i) {
      AI(r, i, n, t);
    });
  }), t.clearResourceTimings && t.clearResourceTimings()), ws.observer;
}, ws = {
  callbacks: /* @__PURE__ */ new Map(),
  observer: null,
  observe: function(t, e) {
    if (!(!t || !e)) {
      var r = Ei.polyfill("performance", { doThrow: !1 }), n = Ei.polyfill("PerformanceObserver", { doThrow: !1 });
      QV(r, n) && (AI(r, t, e, r) || (ws.callbacks.size < 1 && ws.observer.observe({ entryTypes: ["resource", "measure"] }), ws.callbacks.set(t, e)));
    }
  }
}, XV = function(t) {
  return function(e) {
    return t.length === 0 ? e : t.length === 1 ? t[0](e) : t.reduceRight(function(r, n, i) {
      return i === t.length - 2 ? n(r(e)) : n(r);
    });
  };
}, mg = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.error = e;
    }
    return t;
  }()
), eH = function(t) {
  var e = t._url, r = t._catchers, n = t._resolvers, i = t._middlewares, s = t._options, a = new Map(r), o = od(Ei.defaults, s), c = Ei.polyfill("AbortController", { doThrow: !1, instance: !0 });
  !o.signal && c && (o.signal = c.signal);
  var f = {
    ref: null,
    clear: function() {
      f.ref && (clearTimeout(f.ref), f.ref = null);
    }
  }, u = XV(i)(Ei.polyfill("fetch"))(e, o), d = u.catch(function(p) {
    throw new mg(p);
  }).then(function(p) {
    if (f.clear(), !p.ok) {
      if (p.type === "opaque") {
        var b = new Error("Opaque response");
        throw b.status = p.status, b.response = p, b;
      }
      return p[Ei.errorType || "text"]().then(function(v) {
        var x = new Error(v);
        throw x[Ei.errorType || "text"] = v, x.status = p.status, x.response = p, x;
      });
    }
    return p;
  }), l = function(p) {
    return p.catch(function(b) {
      f.clear();
      var v = b instanceof mg ? b.error : b;
      if (b instanceof mg && a.has("__fromFetch"))
        return a.get("__fromFetch")(v, t);
      if (a.has(v.status))
        return a.get(v.status)(v, t);
      if (a.has(v.name))
        return a.get(v.name)(v, t);
      throw v;
    });
  }, h = function(p) {
    return function(b) {
      return /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ l(p ? d.then(function(v) {
        return v && v[p]();
      }).then(function(v) {
        return b ? b(v) : v;
      }) : d.then(function(v) {
        return b ? b(v) : v;
      }));
    };
  }, y = {
    /**
     * Retrieves the raw result as a promise.
     */
    res: h(null),
    /**
     * Retrieves the result as a parsed JSON object.
     */
    json: h("json"),
    /**
     * Retrieves the result as a Blob object.
     */
    blob: h("blob"),
    /**
     * Retrieves the result as a FormData object.
     */
    formData: h("formData"),
    /**
     * Retrieves the result as an ArrayBuffer object.
     */
    arrayBuffer: h("arrayBuffer"),
    /**
     * Retrieves the result as a string.
     */
    text: h("text"),
    /**
     * Performs a callback on the API performance timings of the request.
     *
     * Warning: Still experimental on browsers and node.js
     */
    perfs: function(p) {
      return u.then(function(b) {
        return ws.observe(b.url, p);
      }).catch(function() {
      }), y;
    },
    /**
     * Aborts the request after a fixed time.
     *
     * @param time Time in milliseconds
     * @param controller A custom controller
     */
    setTimeout: function(p, b) {
      return b === void 0 && (b = c), f.clear(), f.ref = setTimeout(function() {
        return b.abort();
      }, p), y;
    },
    /**
     * Returns the automatically generated AbortController alongside the current wretch response as a pair.
     */
    controller: function() {
      return [c, y];
    },
    /**
     * Catches an http response with a specific error code or name and performs a callback.
     */
    error: function(p, b) {
      return a.set(p, b), y;
    },
    /**
     * Catches a bad request (http code 400) and performs a callback.
     */
    badRequest: function(p) {
      return y.error(400, p);
    },
    /**
     * Catches an unauthorized request (http code 401) and performs a callback.
     */
    unauthorized: function(p) {
      return y.error(401, p);
    },
    /**
     * Catches a forbidden request (http code 403) and performs a callback.
     */
    forbidden: function(p) {
      return y.error(403, p);
    },
    /**
     * Catches a "not found" request (http code 404) and performs a callback.
     */
    notFound: function(p) {
      return y.error(404, p);
    },
    /**
     * Catches a timeout (http code 408) and performs a callback.
     */
    timeout: function(p) {
      return y.error(408, p);
    },
    /**
     * Catches an internal server error (http code 500) and performs a callback.
     */
    internalError: function(p) {
      return y.error(500, p);
    },
    /**
     * Catches errors thrown when calling the fetch function and performs a callback.
     */
    fetchError: function(p) {
      return y.error("__fromFetch", p);
    },
    /**
     * Catches an AbortError and performs a callback.
     */
    onAbort: function(p) {
      return y.error("AbortError", p);
    }
  };
  return n.reduce(function(p, b) {
    return b(p, t);
  }, y);
}, ps = function() {
  return ps = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, ps.apply(this, arguments);
}, ys = function(t, e, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = e.length, s; n < i; n++)
      (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return t.concat(s || Array.prototype.slice.call(e));
}, tH = "application/json", II = "Content-Type";
function FE(t) {
  var e;
  return t === void 0 && (t = {}), (e = Object.entries(t).find(function(r) {
    var n = r[0];
    return n.toLowerCase() === II.toLowerCase();
  })) === null || e === void 0 ? void 0 : e[1];
}
function jE(t) {
  return /^application\/.*json.*/.test(t);
}
var qw = (
  /** @class */
  function() {
    function t(e, r, n, i, s, a) {
      n === void 0 && (n = /* @__PURE__ */ new Map()), i === void 0 && (i = []), s === void 0 && (s = []), a === void 0 && (a = []), this._url = e, this._options = r, this._catchers = n, this._resolvers = i, this._middlewares = s, this._deferredChain = a;
    }
    return t.factory = function(e, r) {
      return e === void 0 && (e = ""), r === void 0 && (r = {}), new t(e, r);
    }, t.prototype.selfFactory = function(e) {
      var r = e === void 0 ? {} : e, n = r.url, i = n === void 0 ? this._url : n, s = r.options, a = s === void 0 ? this._options : s, o = r.catchers, c = o === void 0 ? this._catchers : o, f = r.resolvers, u = f === void 0 ? this._resolvers : f, d = r.middlewares, l = d === void 0 ? this._middlewares : d, h = r.deferredChain, y = h === void 0 ? this._deferredChain : h;
      return new t(i, ps({}, a), new Map(c), ys([], u, !0), ys([], l, !0), ys([], y, !0));
    }, t.prototype.defaults = function(e, r) {
      return r === void 0 && (r = !1), Ei.defaults = r ? od(Ei.defaults, e) : e, this;
    }, t.prototype.errorType = function(e) {
      return Ei.errorType = e, this;
    }, t.prototype.polyfills = function(e) {
      return Ei.polyfills = ps(ps({}, Ei.polyfills), e), this;
    }, t.prototype.url = function(e, r) {
      if (r === void 0 && (r = !1), r)
        return this.selfFactory({ url: e });
      var n = this._url.split("?");
      return this.selfFactory({
        url: n.length > 1 ? n[0] + e + "?" + n[1] : this._url + e
      });
    }, t.prototype.options = function(e, r) {
      return r === void 0 && (r = !0), this.selfFactory({ options: r ? od(this._options, e) : e });
    }, t.prototype.query = function(e, r) {
      return r === void 0 && (r = !1), this.selfFactory({ url: rH(this._url, e, r) });
    }, t.prototype.headers = function(e) {
      return this.selfFactory({ options: od(this._options, { headers: e || {} }) });
    }, t.prototype.accept = function(e) {
      return this.headers({ Accept: e });
    }, t.prototype.content = function(e) {
      var r;
      return this.headers((r = {}, r[II] = e, r));
    }, t.prototype.auth = function(e) {
      return this.headers({ Authorization: e });
    }, t.prototype.catcher = function(e, r) {
      var n = new Map(this._catchers);
      return n.set(e, r), this.selfFactory({ catchers: n });
    }, t.prototype.signal = function(e) {
      return this.selfFactory({ options: ps(ps({}, this._options), { signal: e.signal }) });
    }, t.prototype.resolve = function(e, r) {
      return r === void 0 && (r = !1), this.selfFactory({ resolvers: r ? [e] : ys(ys([], this._resolvers, !0), [e], !1) });
    }, t.prototype.defer = function(e, r) {
      return r === void 0 && (r = !1), this.selfFactory({
        deferredChain: r ? [e] : ys(ys([], this._deferredChain, !0), [e], !1)
      });
    }, t.prototype.middlewares = function(e, r) {
      return r === void 0 && (r = !1), this.selfFactory({
        middlewares: r ? e : ys(ys([], this._middlewares, !0), e, !0)
      });
    }, t.prototype.method = function(e, r, n) {
      r === void 0 && (r = {}), n === void 0 && (n = null);
      var i = this.options(ps(ps({}, r), { method: e })), s = FE(i._options.headers), a = typeof n == "object" && (!i._options.headers || !s || jE(s));
      return i = n ? a ? i.json(n, s) : i.body(n) : i, eH(i._deferredChain.reduce(function(o, c) {
        return c(o, o._url, o._options);
      }, i));
    }, t.prototype.get = function(e) {
      return this.method("GET", e);
    }, t.prototype.delete = function(e) {
      return this.method("DELETE", e);
    }, t.prototype.put = function(e, r) {
      return this.method("PUT", r, e);
    }, t.prototype.post = function(e, r) {
      return this.method("POST", r, e);
    }, t.prototype.patch = function(e, r) {
      return this.method("PATCH", r, e);
    }, t.prototype.head = function(e) {
      return this.method("HEAD", e);
    }, t.prototype.opts = function(e) {
      return this.method("OPTIONS", e);
    }, t.prototype.replay = function(e) {
      return this.method(this._options.method, e);
    }, t.prototype.body = function(e) {
      return this.selfFactory({ options: ps(ps({}, this._options), { body: e }) });
    }, t.prototype.json = function(e, r) {
      var n = FE(this._options.headers);
      return this.content(r || jE(n) && n || tH).body(JSON.stringify(e));
    }, t.prototype.formData = function(e, r) {
      return r === void 0 && (r = !1), this.body(TI(e, r));
    }, t.prototype.formUrl = function(e) {
      return this.body(typeof e == "string" ? e : nH(e)).content("application/x-www-form-urlencoded");
    }, t;
  }()
), rH = function(t, e, r) {
  var n;
  if (typeof e == "string")
    n = e;
  else {
    var i = Ei.polyfill("URLSearchParams", { instance: !0 });
    for (var s in e)
      if (e[s] instanceof Array)
        for (var a = 0, o = e[s]; a < o.length; a++) {
          var c = o[a];
          i.append(s, c);
        }
      else
        i.append(s, e[s]);
    n = i.toString();
  }
  var f = t.split("?");
  return n ? r || f.length < 2 ? f[0] + "?" + n : t + "&" + n : r ? f[0] : t;
};
function TI(t, e, r, n) {
  return e === void 0 && (e = !1), r === void 0 && (r = Ei.polyfill("FormData", { instance: !0 })), n === void 0 && (n = []), Object.entries(t).forEach(function(i) {
    var s = i[0], a = i[1], o = n.reduce(function(d, l) {
      return d ? "".concat(d, "[").concat(l, "]") : l;
    }, null);
    if (o = o ? "".concat(o, "[").concat(s, "]") : s, a instanceof Array)
      for (var c = 0, f = a; c < f.length; c++) {
        var u = f[c];
        r.append(o + "[]", u);
      }
    else
      e && typeof a == "object" && (!(e instanceof Array) || !e.includes(s)) ? a !== null && TI(a, e, r, ys(ys([], n, !0), [s], !1)) : r.append(o, a);
  }), r;
}
function $E(t, e) {
  return encodeURIComponent(t) + "=" + encodeURIComponent(typeof e == "object" ? JSON.stringify(e) : "" + e);
}
function nH(t) {
  return Object.keys(t).map(function(e) {
    var r = t[e];
    return r instanceof Array ? r.map(function(n) {
      return $E(e, n);
    }).join("&") : $E(e, r);
  }).join("&");
}
var Ww = qw.factory;
Ww.default = qw.factory;
const iH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Wretcher: qw,
  default: Ww
}, Symbol.toStringTag, { value: "Module" })), sH = /* @__PURE__ */ ta(iH);
Object.defineProperty(xI, "__esModule", {
  value: !0
});
var aH = xI.default = fH, oH = cH(sH);
function cH(t) {
  return t && t.__esModule ? t : { default: t };
}
function qE(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function WE(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qE(Object(r), !0).forEach(function(n) {
      uH(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qE(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function uH(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function fH(t, e = {}) {
  return (0, oH.default)(t).middlewares([(r) => async (n, i) => {
    const s = JSON.stringify(WE({
      jsonrpc: "2.0",
      id: 1,
      params: []
    }, JSON.parse(i.body)));
    return r(n, WE({}, i, {
      body: s
    }));
  }]).resolve(async (r) => {
    const {
      result: n,
      error: i
    } = await r.json();
    if (i)
      throw new Error(JSON.stringify(i));
    return n;
  });
}
var Dd = {}, kI = {}, kc = {}, dH = C0();
const Fd = /* @__PURE__ */ Ln(dH), lH = "logger/5.7.0";
let zE = !1, KE = !1;
const Hh = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let VE = Hh.default, vg = null;
function hH() {
  try {
    const t = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((e) => {
      try {
        if ("test".normalize(e) !== "test")
          throw new Error("bad normalize");
      } catch {
        t.push(e);
      }
    }), t.length)
      throw new Error("missing " + t.join(", "));
    if ("é".normalize("NFD") !== "é")
      throw new Error("broken implementation");
  } catch (t) {
    return t.message;
  }
  return null;
}
const HE = hH();
var Rv;
(function(t) {
  t.DEBUG = "DEBUG", t.INFO = "INFO", t.WARNING = "WARNING", t.ERROR = "ERROR", t.OFF = "OFF";
})(Rv || (Rv = {}));
var gs;
(function(t) {
  t.UNKNOWN_ERROR = "UNKNOWN_ERROR", t.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", t.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", t.NETWORK_ERROR = "NETWORK_ERROR", t.SERVER_ERROR = "SERVER_ERROR", t.TIMEOUT = "TIMEOUT", t.BUFFER_OVERRUN = "BUFFER_OVERRUN", t.NUMERIC_FAULT = "NUMERIC_FAULT", t.MISSING_NEW = "MISSING_NEW", t.INVALID_ARGUMENT = "INVALID_ARGUMENT", t.MISSING_ARGUMENT = "MISSING_ARGUMENT", t.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", t.CALL_EXCEPTION = "CALL_EXCEPTION", t.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", t.NONCE_EXPIRED = "NONCE_EXPIRED", t.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", t.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", t.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", t.ACTION_REJECTED = "ACTION_REJECTED";
})(gs || (gs = {}));
const GE = "0123456789abcdef";
class Jr {
  constructor(e) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: e,
      writable: !1
    });
  }
  _log(e, r) {
    const n = e.toLowerCase();
    Hh[n] == null && this.throwArgumentError("invalid log level name", "logLevel", e), !(VE > Hh[n]) && console.log.apply(console, r);
  }
  debug(...e) {
    this._log(Jr.levels.DEBUG, e);
  }
  info(...e) {
    this._log(Jr.levels.INFO, e);
  }
  warn(...e) {
    this._log(Jr.levels.WARNING, e);
  }
  makeError(e, r, n) {
    if (KE)
      return this.makeError("censored error", r, {});
    r || (r = Jr.errors.UNKNOWN_ERROR), n || (n = {});
    const i = [];
    Object.keys(n).forEach((c) => {
      const f = n[c];
      try {
        if (f instanceof Uint8Array) {
          let u = "";
          for (let d = 0; d < f.length; d++)
            u += GE[f[d] >> 4], u += GE[f[d] & 15];
          i.push(c + "=Uint8Array(0x" + u + ")");
        } else
          i.push(c + "=" + JSON.stringify(f));
      } catch {
        i.push(c + "=" + JSON.stringify(n[c].toString()));
      }
    }), i.push(`code=${r}`), i.push(`version=${this.version}`);
    const s = e;
    let a = "";
    switch (r) {
      case gs.NUMERIC_FAULT: {
        a = "NUMERIC_FAULT";
        const c = e;
        switch (c) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            a += "-" + c;
            break;
          case "negative-power":
          case "negative-width":
            a += "-unsupported";
            break;
          case "unbound-bitwise-result":
            a += "-unbound-result";
            break;
        }
        break;
      }
      case gs.CALL_EXCEPTION:
      case gs.INSUFFICIENT_FUNDS:
      case gs.MISSING_NEW:
      case gs.NONCE_EXPIRED:
      case gs.REPLACEMENT_UNDERPRICED:
      case gs.TRANSACTION_REPLACED:
      case gs.UNPREDICTABLE_GAS_LIMIT:
        a = r;
        break;
    }
    a && (e += " [ See: https://links.ethers.org/v5-errors-" + a + " ]"), i.length && (e += " (" + i.join(", ") + ")");
    const o = new Error(e);
    return o.reason = s, o.code = r, Object.keys(n).forEach(function(c) {
      o[c] = n[c];
    }), o;
  }
  throwError(e, r, n) {
    throw this.makeError(e, r, n);
  }
  throwArgumentError(e, r, n) {
    return this.throwError(e, Jr.errors.INVALID_ARGUMENT, {
      argument: r,
      value: n
    });
  }
  assert(e, r, n, i) {
    e || this.throwError(r, n, i);
  }
  assertArgument(e, r, n, i) {
    e || this.throwArgumentError(r, n, i);
  }
  checkNormalize(e) {
    HE && this.throwError("platform missing String.prototype.normalize", Jr.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: HE
    });
  }
  checkSafeUint53(e, r) {
    typeof e == "number" && (r == null && (r = "value not safe"), (e < 0 || e >= 9007199254740991) && this.throwError(r, Jr.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: e
    }), e % 1 && this.throwError(r, Jr.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: e
    }));
  }
  checkArgumentCount(e, r, n) {
    n ? n = ": " + n : n = "", e < r && this.throwError("missing argument" + n, Jr.errors.MISSING_ARGUMENT, {
      count: e,
      expectedCount: r
    }), e > r && this.throwError("too many arguments" + n, Jr.errors.UNEXPECTED_ARGUMENT, {
      count: e,
      expectedCount: r
    });
  }
  checkNew(e, r) {
    (e === Object || e == null) && this.throwError("missing new", Jr.errors.MISSING_NEW, { name: r.name });
  }
  checkAbstract(e, r) {
    e === r ? this.throwError("cannot instantiate abstract class " + JSON.stringify(r.name) + " directly; use a sub-class", Jr.errors.UNSUPPORTED_OPERATION, { name: e.name, operation: "new" }) : (e === Object || e == null) && this.throwError("missing new", Jr.errors.MISSING_NEW, { name: r.name });
  }
  static globalLogger() {
    return vg || (vg = new Jr(lH)), vg;
  }
  static setCensorship(e, r) {
    if (!e && r && this.globalLogger().throwError("cannot permanently disable censorship", Jr.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), zE) {
      if (!e)
        return;
      this.globalLogger().throwError("error censorship permanent", Jr.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    KE = !!e, zE = !!r;
  }
  static setLogLevel(e) {
    const r = Hh[e.toLowerCase()];
    if (r == null) {
      Jr.globalLogger().warn("invalid log level - " + e);
      return;
    }
    VE = r;
  }
  static from(e) {
    return new Jr(e);
  }
}
Jr.errors = gs;
Jr.levels = Rv;
const pH = "bytes/5.7.0", wg = new Jr(pH);
function yH(t) {
  return !!t.toHexString;
}
function Gh(t) {
  return t.slice || (t.slice = function() {
    const e = Array.prototype.slice.call(arguments);
    return Gh(new Uint8Array(Array.prototype.slice.apply(t, e)));
  }), t;
}
function ZE(t) {
  return typeof t == "number" && t == t && t % 1 === 0;
}
function bH(t) {
  if (t == null)
    return !1;
  if (t.constructor === Uint8Array)
    return !0;
  if (typeof t == "string" || !ZE(t.length) || t.length < 0)
    return !1;
  for (let e = 0; e < t.length; e++) {
    const r = t[e];
    if (!ZE(r) || r < 0 || r >= 256)
      return !1;
  }
  return !0;
}
function jd(t, e) {
  if (e || (e = {}), typeof t == "number") {
    wg.checkSafeUint53(t, "invalid arrayify value");
    const r = [];
    for (; t; )
      r.unshift(t & 255), t = parseInt(String(t / 256));
    return r.length === 0 && r.push(0), Gh(new Uint8Array(r));
  }
  if (e.allowMissingPrefix && typeof t == "string" && t.substring(0, 2) !== "0x" && (t = "0x" + t), yH(t) && (t = t.toHexString()), gH(t)) {
    let r = t.substring(2);
    r.length % 2 && (e.hexPad === "left" ? r = "0" + r : e.hexPad === "right" ? r += "0" : wg.throwArgumentError("hex data is odd-length", "value", t));
    const n = [];
    for (let i = 0; i < r.length; i += 2)
      n.push(parseInt(r.substring(i, i + 2), 16));
    return Gh(new Uint8Array(n));
  }
  return bH(t) ? Gh(new Uint8Array(t)) : wg.throwArgumentError("invalid arrayify value", "value", t);
}
function gH(t, e) {
  return !(typeof t != "string" || !t.match(/^0x[0-9A-Fa-f]*$/) || e && t.length !== 2 + 2 * e);
}
var Pp;
(function(t) {
  t.sha256 = "sha256", t.sha512 = "sha512";
})(Pp || (Pp = {}));
const mH = "sha2/5.7.0", vH = new Jr(mH);
function wH(t) {
  return "0x" + Fd.ripemd160().update(jd(t)).digest("hex");
}
function _H(t) {
  return "0x" + Fd.sha256().update(jd(t)).digest("hex");
}
function SH(t) {
  return "0x" + Fd.sha512().update(jd(t)).digest("hex");
}
function EH(t, e, r) {
  return Pp[t] || vH.throwError("unsupported algorithm " + t, Jr.errors.UNSUPPORTED_OPERATION, {
    operation: "hmac",
    algorithm: t
  }), "0x" + Fd.hmac(Fd[t], jd(e)).update(jd(r)).digest("hex");
}
const xH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get SupportedAlgorithm() {
    return Pp;
  },
  computeHmac: EH,
  ripemd160: wH,
  sha256: _H,
  sha512: SH
}, Symbol.toStringTag, { value: "Module" })), AH = /* @__PURE__ */ ta(xH);
var Ey = {}, IH = Ne && Ne.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Ey, "__esModule", { value: !0 });
Ey.isOnCurve = void 0;
const TH = IH(L0), Yt = TH.default.lowlevel;
function kH(t) {
  const e = [Yt.gf(), Yt.gf(), Yt.gf(), Yt.gf()], r = Yt.gf(), n = Yt.gf(), i = Yt.gf(), s = Yt.gf(), a = Yt.gf(), o = Yt.gf(), c = Yt.gf();
  return Yt.set25519(e[2], RH), Yt.unpack25519(e[1], t), Yt.S(i, e[1]), Yt.M(s, i, Yt.D), Yt.Z(i, i, e[2]), Yt.A(s, e[2], s), Yt.S(a, s), Yt.S(o, a), Yt.M(c, o, a), Yt.M(r, c, i), Yt.M(r, r, s), Yt.pow2523(r, r), Yt.M(r, r, i), Yt.M(r, r, s), Yt.M(r, r, s), Yt.M(e[0], r, s), Yt.S(n, e[0]), Yt.M(n, n, s), JE(n, i) && Yt.M(e[0], e[0], PH), Yt.S(n, e[0]), Yt.M(n, n, s), !JE(n, i);
}
Ey.isOnCurve = kH;
const RH = Yt.gf([1]), PH = Yt.gf([
  41136,
  18958,
  6951,
  50414,
  58488,
  44335,
  6150,
  12099,
  55207,
  15867,
  153,
  11085,
  57099,
  20417,
  9344,
  11139
]);
function JE(t, e) {
  const r = new Uint8Array(32), n = new Uint8Array(32);
  return Yt.pack25519(r, t), Yt.pack25519(n, e), Yt.crypto_verify_32(r, 0, n, 0);
}
var RI = Ne && Ne.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(kc, "__esModule", { value: !0 });
kc.findProgramAddress = kc.createProgramAddress = void 0;
const YE = RI(ko), OH = RI(Tr), BH = AH, MH = Ey, CH = 32;
function NH(t) {
  const e = t.toArrayLike(ve);
  if (e.length === 32)
    return e;
  const r = ve.alloc(32);
  return e.copy(r, 32 - e.length), r;
}
async function PI(t, e) {
  let r = ve.alloc(0);
  t.forEach(function(a) {
    if (a.length > CH)
      throw new TypeError("Max seed length exceeded");
    r = ve.concat([r, a]);
  }), r = ve.concat([r, YE.default.decode(e), ve.from("ProgramDerivedAddress")]);
  const n = await (0, BH.sha256)(new Uint8Array(r)), i = new OH.default(n.slice(2), 16), s = i.toArray(void 0, 32);
  if ((0, MH.isOnCurve)(s))
    throw new Error("Invalid seeds, address must fall off the curve");
  return YE.default.encode(NH(i));
}
kc.createProgramAddress = PI;
async function UH(t, e) {
  let r = 255, n;
  for (; r !== 0; ) {
    try {
      const i = t.concat(ve.from([r]));
      n = await PI(i, e);
    } catch {
      r--;
      continue;
    }
    return [n, r];
  }
  throw new Error("Unable to find a viable program address nonce");
}
kc.findProgramAddress = UH;
var Js = {};
Object.defineProperty(Js, "__esModule", { value: !0 });
Js.PROGRAM_IDS = Js.AUCTION_PREFIX = Js.METADATA_PREFIX = void 0;
Js.METADATA_PREFIX = "metadata";
Js.AUCTION_PREFIX = "auction";
Js.PROGRAM_IDS = {
  token: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
  associatedToken: "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL",
  bpf_upgrade_loader: "BPFLoaderUpgradeab1e11111111111111111111111",
  system: "11111111111111111111111111111111",
  metadata: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
  memo: "MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr",
  vault: "vau1zxA2LbssAUEF7Gpw91zMM1LvXrvpzJtmZ58rPsn",
  auction: "auctxRXPeJoc4817jDhf4HbjnhEcr1cCXenosMhK5R8",
  metaplex: "p1exdMJcjVao65QdewkaZRUnU6VPSXhus9n2GzWfh98"
};
var zw = {};
function LH(t) {
  return t ? `?${Object.entries(t).map(([e, r]) => `${encodeURIComponent(e)}=${encodeURIComponent(r)}`).join("&")}` : "";
}
function DH({ fetch: t }) {
  async function e(n, i, s, a) {
    if (s.body)
      throw new Error("unexpected pre-set body option");
    const o = await r.fetch(i, {
      ...s,
      method: n,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...s.headers
      },
      ...a ? { body: JSON.stringify(a) } : {}
    });
    if (o.status >= 200 && o.status < 300)
      return s.responseAs === "response" ? o : o.status === 204 ? null : s.responseAs === "text" ? o.text() : o.json();
    const c = new Error(o.statusText);
    throw c.response = o, c;
  }
  function r(n, i = {}) {
    const s = (a, o = {}) => {
      const f = `${n}`.endsWith("/") ? `${n}${a}` : `${n}/${a}`;
      return r(f, { ...i, ...o });
    };
    return s.get = (a) => e("GET", n + LH(a), i), s.post = (a) => e("POST", n, i, a), s.put = (a) => e("PUT", n, i, a), s.patch = (a) => e("PATCH", n, i, a), s.delete = () => e("DELETE", n, i), s;
  }
  return r.fetch = t, r;
}
var FH = DH;
const jH = FH;
var $H = jH({
  fetch: typeof fetch > "u" ? null : fetch.bind(globalThis)
}), qH = fetch.bind(globalThis);
const WH = $H, zH = qH;
var Wo = { fetch: zH, WebSocket, fetchival: WH };
Object.defineProperty(zw, "__esModule", { value: !0 });
const KH = Wo, VH = Js;
class HH {
  constructor() {
    this.setServer();
  }
  setServer(e) {
    this.url = e || "https://solana.a.exodus.io";
  }
  async request(e, r) {
    return (await (0, KH.fetchival)(this.url).post({
      jsonrpc: "2.0",
      id: 1,
      method: e,
      params: r
    })).result.value;
  }
  async getTokenAccountsByOwner(e) {
    return this.request("getTokenAccountsByOwner", [
      e,
      { programId: VH.PROGRAM_IDS.token },
      { encoding: "jsonParsed" }
    ]);
  }
  async getMultipleAccounts(e) {
    return this.request("getMultipleAccounts", [e]);
  }
}
zw.default = new HH();
var OI = {}, En = {}, GH = Ne && Ne.__createBinding || (Object.create ? function(t, e, r, n) {
  n === void 0 && (n = r), Object.defineProperty(t, n, { enumerable: !0, get: function() {
    return e[r];
  } });
} : function(t, e, r, n) {
  n === void 0 && (n = r), t[n] = e[r];
}), ZH = Ne && Ne.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), ua = Ne && Ne.__decorate || function(t, e, r, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, r) : n, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(t, e, r, n);
  else
    for (var o = t.length - 1; o >= 0; o--)
      (a = t[o]) && (s = (i < 3 ? a(s) : i > 3 ? a(e, r, s) : a(e, r)) || s);
  return i > 3 && s && Object.defineProperty(e, r, s), s;
}, JH = Ne && Ne.__importStar || function(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var r in t)
      r !== "default" && Object.hasOwnProperty.call(t, r) && GH(e, t, r);
  return ZH(e, t), e;
}, BI = Ne && Ne.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(En, "__esModule", { value: !0 });
En.deserializeUnchecked = En.deserialize = En.serialize = En.BinaryReader = En.BinaryWriter = En.BorshError = En.baseDecode = En.baseEncode = void 0;
const co = BI(Tr), MI = BI(ko), YH = JH(m5), QH = typeof Ne.TextDecoder != "function" ? YH.TextDecoder : Ne.TextDecoder, XH = new QH("utf-8", { fatal: !0 });
function eG(t) {
  return typeof t == "string" && (t = ve.from(t, "utf8")), MI.default.encode(ve.from(t));
}
En.baseEncode = eG;
function tG(t) {
  return ve.from(MI.default.decode(t));
}
En.baseDecode = tG;
const _g = 1024;
class li extends Error {
  constructor(e) {
    super(e), this.fieldPath = [], this.originalMessage = e;
  }
  addToFieldPath(e) {
    this.fieldPath.splice(0, 0, e), this.message = this.originalMessage + ": " + this.fieldPath.join(".");
  }
}
En.BorshError = li;
class CI {
  constructor() {
    this.buf = ve.alloc(_g), this.length = 0;
  }
  maybeResize() {
    this.buf.length < 16 + this.length && (this.buf = ve.concat([this.buf, ve.alloc(_g)]));
  }
  writeU8(e) {
    this.maybeResize(), this.buf.writeUInt8(e, this.length), this.length += 1;
  }
  writeU16(e) {
    this.maybeResize(), this.buf.writeUInt16LE(e, this.length), this.length += 2;
  }
  writeU32(e) {
    this.maybeResize(), this.buf.writeUInt32LE(e, this.length), this.length += 4;
  }
  writeU64(e) {
    this.maybeResize(), this.writeBuffer(ve.from(new co.default(e).toArray("le", 8)));
  }
  writeU128(e) {
    this.maybeResize(), this.writeBuffer(ve.from(new co.default(e).toArray("le", 16)));
  }
  writeU256(e) {
    this.maybeResize(), this.writeBuffer(ve.from(new co.default(e).toArray("le", 32)));
  }
  writeU512(e) {
    this.maybeResize(), this.writeBuffer(ve.from(new co.default(e).toArray("le", 64)));
  }
  writeBuffer(e) {
    this.buf = ve.concat([
      ve.from(this.buf.subarray(0, this.length)),
      e,
      ve.alloc(_g)
    ]), this.length += e.length;
  }
  writeString(e) {
    this.maybeResize();
    const r = ve.from(e, "utf8");
    this.writeU32(r.length), this.writeBuffer(r);
  }
  writeFixedArray(e) {
    this.writeBuffer(ve.from(e));
  }
  writeArray(e, r) {
    this.maybeResize(), this.writeU32(e.length);
    for (const n of e)
      this.maybeResize(), r(n);
  }
  toArray() {
    return this.buf.subarray(0, this.length);
  }
}
En.BinaryWriter = CI;
function fa(t, e, r) {
  const n = r.value;
  r.value = function(...i) {
    try {
      return n.apply(this, i);
    } catch (s) {
      if (s instanceof RangeError) {
        const a = s.code;
        if (["ERR_BUFFER_OUT_OF_BOUNDS", "ERR_OUT_OF_RANGE"].indexOf(a) >= 0)
          throw new li("Reached the end of buffer when deserializing");
      }
      throw s;
    }
  };
}
class zi {
  constructor(e) {
    this.buf = e, this.offset = 0;
  }
  readU8() {
    const e = this.buf.readUInt8(this.offset);
    return this.offset += 1, e;
  }
  readU16() {
    const e = this.buf.readUInt16LE(this.offset);
    return this.offset += 2, e;
  }
  readU32() {
    const e = this.buf.readUInt32LE(this.offset);
    return this.offset += 4, e;
  }
  readU64() {
    const e = this.readBuffer(8);
    return new co.default(e, "le");
  }
  readU128() {
    const e = this.readBuffer(16);
    return new co.default(e, "le");
  }
  readU256() {
    const e = this.readBuffer(32);
    return new co.default(e, "le");
  }
  readU512() {
    const e = this.readBuffer(64);
    return new co.default(e, "le");
  }
  readBuffer(e) {
    if (this.offset + e > this.buf.length)
      throw new li(`Expected buffer length ${e} isn't within bounds`);
    const r = this.buf.slice(this.offset, this.offset + e);
    return this.offset += e, r;
  }
  readString() {
    const e = this.readU32(), r = this.readBuffer(e);
    try {
      return XH.decode(r);
    } catch (n) {
      throw new li(`Error decoding UTF-8 string: ${n}`);
    }
  }
  readFixedArray(e) {
    return new Uint8Array(this.readBuffer(e));
  }
  readArray(e) {
    const r = this.readU32(), n = Array();
    for (let i = 0; i < r; ++i)
      n.push(e());
    return n;
  }
}
ua([
  fa
], zi.prototype, "readU8", null);
ua([
  fa
], zi.prototype, "readU16", null);
ua([
  fa
], zi.prototype, "readU32", null);
ua([
  fa
], zi.prototype, "readU64", null);
ua([
  fa
], zi.prototype, "readU128", null);
ua([
  fa
], zi.prototype, "readU256", null);
ua([
  fa
], zi.prototype, "readU512", null);
ua([
  fa
], zi.prototype, "readString", null);
ua([
  fa
], zi.prototype, "readFixedArray", null);
ua([
  fa
], zi.prototype, "readArray", null);
En.BinaryReader = zi;
function NI(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function cd(t, e, r, n, i) {
  try {
    if (typeof n == "string")
      i[`write${NI(n)}`](r);
    else if (n instanceof Array)
      if (typeof n[0] == "number") {
        if (r.length !== n[0])
          throw new li(`Expecting byte array of length ${n[0]}, but got ${r.length} bytes`);
        i.writeFixedArray(r);
      } else if (n.length === 2 && typeof n[1] == "number") {
        if (r.length !== n[1])
          throw new li(`Expecting byte array of length ${n[1]}, but got ${r.length} bytes`);
        for (let s = 0; s < n[1]; s++)
          cd(t, null, r[s], n[0], i);
      } else
        i.writeArray(r, (s) => {
          cd(t, e, s, n[0], i);
        });
    else if (n.kind !== void 0)
      switch (n.kind) {
        case "option": {
          r == null ? i.writeU8(0) : (i.writeU8(1), cd(t, e, r, n.type, i));
          break;
        }
        default:
          throw new li(`FieldType ${n} unrecognized`);
      }
    else
      UI(t, r, i);
  } catch (s) {
    throw s instanceof li && s.addToFieldPath(e), s;
  }
}
function UI(t, e, r) {
  if (typeof e.borshSerialize == "function") {
    e.borshSerialize(r);
    return;
  }
  const n = t.get(e.constructor);
  if (!n)
    throw new li(`Class ${e.constructor.name} is missing in schema`);
  if (n.kind === "struct")
    n.fields.map(([i, s]) => {
      cd(t, i, e[i], s, r);
    });
  else if (n.kind === "enum") {
    const i = e[n.field];
    for (let s = 0; s < n.values.length; ++s) {
      const [a, o] = n.values[s];
      if (a === i) {
        r.writeU8(s), cd(t, a, e[a], o, r);
        break;
      }
    }
  } else
    throw new li(`Unexpected schema kind: ${n.kind} for ${e.constructor.name}`);
}
function rG(t, e, r = CI) {
  const n = new r();
  return UI(t, e, n), n.toArray();
}
En.serialize = rG;
function ud(t, e, r, n) {
  try {
    if (typeof r == "string")
      return n[`read${NI(r)}`]();
    if (r instanceof Array) {
      if (typeof r[0] == "number")
        return n.readFixedArray(r[0]);
      if (typeof r[1] == "number") {
        const i = [];
        for (let s = 0; s < r[1]; s++)
          i.push(ud(t, null, r[0], n));
        return i;
      } else
        return n.readArray(() => ud(t, e, r[0], n));
    }
    return r.kind === "option" ? n.readU8() ? ud(t, e, r.type, n) : void 0 : Kw(t, r, n);
  } catch (i) {
    throw i instanceof li && i.addToFieldPath(e), i;
  }
}
function Kw(t, e, r) {
  if (typeof e.borshDeserialize == "function")
    return e.borshDeserialize(r);
  const n = t.get(e);
  if (!n)
    throw new li(`Class ${e.name} is missing in schema`);
  if (n.kind === "struct") {
    const i = {};
    for (const [s, a] of t.get(e).fields)
      i[s] = ud(t, s, a, r);
    return new e(i);
  }
  if (n.kind === "enum") {
    const i = r.readU8();
    if (i >= n.values.length)
      throw new li(`Enum index: ${i} is out of range`);
    const [s, a] = n.values[i], o = ud(t, s, a, r);
    return new e({ [s]: o });
  }
  throw new li(`Unexpected schema kind: ${n.kind} for ${e.constructor.name}`);
}
function nG(t, e, r, n = zi) {
  const i = new n(r), s = Kw(t, e, i);
  if (i.offset < r.length)
    throw new li(`Unexpected ${r.length - i.offset} bytes after deserialized data`);
  return s;
}
En.deserialize = nG;
function iG(t, e, r, n = zi) {
  const i = new n(r);
  return Kw(t, e, i);
}
En.deserializeUnchecked = iG;
var sG = {};
(function(t) {
  var e = Ne && Ne.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.extendBorsh = void 0;
  const r = En, n = e(ko), i = () => {
    r.BinaryReader.prototype.readPubkeyAsString = function() {
      const a = this.readFixedArray(32);
      return n.default.encode(a);
    }, r.BinaryWriter.prototype.writePubkeyAsString = function(s) {
      this.writeFixedArray(n.default.decode(s));
    };
  };
  t.extendBorsh = i, (0, t.extendBorsh)();
})(sG);
(function(t) {
  var e = Ne && Ne.__importDefault || function(P) {
    return P && P.__esModule ? P : { default: P };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getEdition = t.decodeMetadata = t.METADATA_SCHEMA = t.Metadata = t.Data = t.Edition = t.EditionMarker = t.MasterEditionV2 = t.MasterEditionV1 = t.Creator = t.MetadataCategory = t.MetadataKey = t.EDITION_MARKER_BIT_SIZE = t.MAX_EDITION_LEN = t.MAX_METADATA_LEN = t.MAX_CREATOR_LEN = t.MAX_CREATOR_LIMIT = t.MAX_URI_LENGTH = t.MAX_SYMBOL_LENGTH = t.MAX_NAME_LENGTH = t.RESERVATION = t.EDITION = void 0;
  const r = e(ko), n = En, i = kc, s = Js, a = new RegExp("\0", "g");
  t.EDITION = "edition", t.RESERVATION = "reservation", t.MAX_NAME_LENGTH = 32, t.MAX_SYMBOL_LENGTH = 10, t.MAX_URI_LENGTH = 200, t.MAX_CREATOR_LIMIT = 5, t.MAX_CREATOR_LEN = 34, t.MAX_METADATA_LEN = 65 + t.MAX_NAME_LENGTH + t.MAX_SYMBOL_LENGTH + t.MAX_URI_LENGTH + t.MAX_CREATOR_LIMIT * t.MAX_CREATOR_LEN + 2 + 1 + 1 + 198, t.MAX_EDITION_LEN = 241, t.EDITION_MARKER_BIT_SIZE = 248;
  var o;
  (function(P) {
    P[P.Uninitialized = 0] = "Uninitialized", P[P.MetadataV1 = 4] = "MetadataV1", P[P.EditionV1 = 1] = "EditionV1", P[P.MasterEditionV1 = 2] = "MasterEditionV1", P[P.MasterEditionV2 = 6] = "MasterEditionV2", P[P.EditionMarker = 7] = "EditionMarker";
  })(o = t.MetadataKey || (t.MetadataKey = {})), function(P) {
    P.Audio = "audio", P.Video = "video", P.Image = "image", P.VR = "vr", P.HTML = "html";
  }(t.MetadataCategory || (t.MetadataCategory = {}));
  class c {
    constructor(C) {
      this.address = C.address, this.verified = C.verified, this.share = C.share;
    }
  }
  t.Creator = c;
  class f {
    constructor(C) {
      this.key = o.MasterEditionV1, this.supply = C.supply, this.maxSupply = C.maxSupply, this.printingMint = C.printingMint, this.oneTimePrintingAuthorizationMint = C.oneTimePrintingAuthorizationMint;
    }
  }
  t.MasterEditionV1 = f;
  class u {
    constructor(C) {
      this.key = o.MasterEditionV2, this.supply = C.supply, this.maxSupply = C.maxSupply;
    }
  }
  t.MasterEditionV2 = u;
  class d {
    constructor(C) {
      this.key = o.EditionMarker, this.ledger = C.ledger;
    }
    editionTaken(C) {
      const D = C % t.EDITION_MARKER_BIT_SIZE, F = Math.floor(D / 8);
      if (F > 30)
        throw Error("bad index for edition");
      const G = 7 - D % 8, re = Math.pow(2, G);
      return (this.ledger[F] & re) !== 0;
    }
  }
  t.EditionMarker = d;
  class l {
    constructor(C) {
      this.key = o.EditionV1, this.parent = C.parent, this.edition = C.edition;
    }
  }
  t.Edition = l;
  class h {
    constructor(C) {
      this.name = C.name, this.symbol = C.symbol, this.uri = C.uri, this.sellerFeeBasisPoints = C.sellerFeeBasisPoints, this.creators = C.creators;
    }
  }
  t.Data = h;
  class y {
    constructor(C) {
      var D;
      this.key = o.MetadataV1, this.updateAuthority = C.updateAuthority, this.mint = C.mint, this.data = C.data, this.primarySaleHappened = C.primarySaleHappened, this.isMutable = C.isMutable, this.editionNonce = (D = C.editionNonce) !== null && D !== void 0 ? D : null;
    }
    async init() {
      this.editionNonce !== null ? this.edition = await (0, i.createProgramAddress)([
        ve.from(s.METADATA_PREFIX),
        r.default.decode(s.PROGRAM_IDS.metadata),
        r.default.decode(this.mint),
        ve.from([this.editionNonce || 0])
      ], s.PROGRAM_IDS.metadata) : this.edition = await L(this.mint), this.masterEdition = this.edition;
    }
  }
  t.Metadata = y;
  class p {
    constructor(C) {
      this.instruction = 0, this.data = C.data, this.isMutable = C.isMutable;
    }
  }
  class b {
    constructor(C) {
      this.instruction = 1, this.data = C.data ? C.data : null, this.updateAuthority = C.updateAuthority ? C.updateAuthority : null, this.primarySaleHappened = C.primarySaleHappened;
    }
  }
  class v {
    constructor(C) {
      this.instruction = 10, this.maxSupply = C.maxSupply;
    }
  }
  class x {
    constructor(C) {
      this.instruction = 9, this.supply = C.supply;
    }
  }
  t.METADATA_SCHEMA = /* @__PURE__ */ new Map([
    [
      p,
      {
        kind: "struct",
        fields: [
          ["instruction", "u8"],
          ["data", h],
          ["isMutable", "u8"]
          // bool
        ]
      }
    ],
    [
      b,
      {
        kind: "struct",
        fields: [
          ["instruction", "u8"],
          ["data", { kind: "option", type: h }],
          ["updateAuthority", { kind: "option", type: "pubkeyAsString" }],
          ["primarySaleHappened", { kind: "option", type: "u8" }]
        ]
      }
    ],
    [
      v,
      {
        kind: "struct",
        fields: [
          ["instruction", "u8"],
          ["maxSupply", { kind: "option", type: "u64" }]
        ]
      }
    ],
    [
      x,
      {
        kind: "struct",
        fields: [
          ["instruction", "u8"],
          ["supply", "u64"]
        ]
      }
    ],
    [
      f,
      {
        kind: "struct",
        fields: [
          ["key", "u8"],
          ["supply", "u64"],
          ["maxSupply", { kind: "option", type: "u64" }],
          ["printingMint", "pubkeyAsString"],
          ["oneTimePrintingAuthorizationMint", "pubkeyAsString"]
        ]
      }
    ],
    [
      u,
      {
        kind: "struct",
        fields: [
          ["key", "u8"],
          ["supply", "u64"],
          ["maxSupply", { kind: "option", type: "u64" }]
        ]
      }
    ],
    [
      l,
      {
        kind: "struct",
        fields: [
          ["key", "u8"],
          ["parent", "pubkeyAsString"],
          ["edition", "u64"]
        ]
      }
    ],
    [
      h,
      {
        kind: "struct",
        fields: [
          ["name", "string"],
          ["symbol", "string"],
          ["uri", "string"],
          ["sellerFeeBasisPoints", "u16"],
          ["creators", { kind: "option", type: [c] }]
        ]
      }
    ],
    [
      c,
      {
        kind: "struct",
        fields: [
          ["address", "pubkeyAsString"],
          ["verified", "u8"],
          ["share", "u8"]
        ]
      }
    ],
    [
      y,
      {
        kind: "struct",
        fields: [
          ["key", "u8"],
          ["updateAuthority", "pubkeyAsString"],
          ["mint", "pubkeyAsString"],
          ["data", h],
          ["primarySaleHappened", "u8"],
          ["isMutable", "u8"]
          // bool
        ]
      }
    ],
    [
      d,
      {
        kind: "struct",
        fields: [
          ["key", "u8"],
          ["ledger", [31]]
        ]
      }
    ]
  ]);
  function I(P) {
    const C = (0, n.deserializeUnchecked)(t.METADATA_SCHEMA, y, P);
    return C.data.name = C.data.name.replace(a, ""), C.data.uri = C.data.uri.replace(a, ""), C.data.symbol = C.data.symbol.replace(a, ""), C;
  }
  t.decodeMetadata = I;
  async function L(P) {
    return (await (0, i.findProgramAddress)([
      ve.from(s.METADATA_PREFIX),
      r.default.decode(s.PROGRAM_IDS.metadata),
      r.default.decode(P),
      ve.from(t.EDITION)
    ], s.PROGRAM_IDS.metadata))[0];
  }
  t.getEdition = L;
})(OI);
(function(t) {
  var e = Ne && Ne.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getMetadataAddress = t.decodeMetadata = t.api = void 0;
  const r = e(ko), n = kc, i = Js;
  var s = zw;
  Object.defineProperty(t, "api", { enumerable: !0, get: function() {
    return e(s).default;
  } });
  var a = OI;
  Object.defineProperty(t, "decodeMetadata", { enumerable: !0, get: function() {
    return a.decodeMetadata;
  } });
  async function o(c) {
    return (await (0, n.findProgramAddress)([ve.from("metadata"), r.default.decode(i.PROGRAM_IDS.metadata), r.default.decode(c)], i.PROGRAM_IDS.metadata))[0];
  }
  t.getMetadataAddress = o;
})(kI);
var LI = {}, Vw = {}, ho = {};
Object.defineProperty(ho, "__esModule", { value: !0 });
ho.SELLER_REFERRAL = ho.AUCTION_HOUSE_KEY = ho.ROOT_URL = void 0;
ho.ROOT_URL = "https://api-mainnet.magiceden.dev";
ho.AUCTION_HOUSE_KEY = "E8cU1WiRWjanGxmn96ewBgk9vPTcL6AEZ1t6F6fkgUWe";
ho.SELLER_REFERRAL = "autMW8SgBkVYeBgqYiTuJZnkvDZMVU2MHJh9Jh7CSQ2";
var xy = {};
Object.defineProperty(xy, "__esModule", { value: !0 });
xy.objectToQueryString = void 0;
function aG(t) {
  return encodeURIComponent(JSON.stringify(t));
}
xy.objectToQueryString = aG;
Object.defineProperty(Vw, "__esModule", { value: !0 });
const mi = Wo, Sg = ho, Eg = xy;
class oG {
  constructor(e, r) {
    this.setServer(e), this.setApiKey(r);
  }
  setServer(e) {
    this.url = e || Sg.ROOT_URL;
  }
  setApiKey(e) {
    this.apiKey = e;
  }
  async getNFTsByOwner(e) {
    return (await (0, mi.fetchival)(`${this.url}/rpc/getNFTsByOwner/${e}`).get()).results;
  }
  async getNFTsByEscrowOwner(e) {
    return (await (0, mi.fetchival)(`${this.url}/rpc/getNFTsByEscrowOwner/${e}`).get()).results;
  }
  async getNFTByMintAddress(e) {
    return (await (0, mi.fetchival)(`${this.url}/rpc/getNFTByMintAddress/${e}`).get()).results;
  }
  async getNFTStatsByMintAddress(e) {
    return (await (0, mi.fetchival)(`${this.url}/rpc/getNFTStatsByMintAddress/${e}`).get()).results;
  }
  async getListedNFTsByQuery(e) {
    return (await (0, mi.fetchival)(`${this.url}/rpc/getListedNFTsByQuery?q=${(0, Eg.objectToQueryString)(e)}`).get()).results;
  }
  async getBiddingsByQuery(e) {
    return (await (0, mi.fetchival)(`${this.url}/rpc/getBiddingsByQuery?q=${(0, Eg.objectToQueryString)(e)}`).get()).results;
  }
  async getActivitiesByQuery(e) {
    return (await (0, mi.fetchival)(`${this.url}/rpc/getActivitiesByQuery?q=${(0, Eg.objectToQueryString)(e)}`).get()).results;
  }
  async getUpcomingCollections() {
    return await (0, mi.fetchival)(`${this.url}/launchpad_collections`).get();
  }
  async getAllCollections() {
    return await (0, mi.fetchival)(`${this.url}/all_collections`).get();
  }
  async getNewCollections() {
    return await (0, mi.fetchival)(`${this.url}/new_collections`).get();
  }
  async getPopularCollections() {
    return await (0, mi.fetchival)(`${this.url}/popular_collections`).get();
  }
  async getCollection(e) {
    return await (0, mi.fetchival)(`${this.url}/collections/${e}`).get();
  }
  async getCollectionStats(e) {
    return (await (0, mi.fetchival)(`${this.url}/rpc/getCollectionEscrowStats/${e}`).get()).results;
  }
  //
  // MAGIC EDEN v2
  // =============
  ensureApiKey() {
    if (this.apiKey)
      return !0;
    throw new Error("The `apiKey` is necessary for this function");
  }
  fetchV2(e) {
    return this.ensureApiKey(), (0, mi.fetchival)(`${this.url}/v2/${e}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.apiKey}`
      }
    });
  }
  async getNFTActivity(e) {
    return await this.fetchV2(`tokens/${e}/activities`).get();
  }
  async getNFTBuyNowInstructions(e, r) {
    const n = await this.getNFTByMintAddress(r);
    return await this.fetchV2("instructions/buy_now").get({
      auctionHouseAddress: n.v2.auctionHouseKey,
      buyer: e,
      price: `${n.price}`,
      seller: n.owner,
      sellerExpiry: `${n.v2.expiry}`,
      sellerReferral: n.v2.sellerReferral,
      tokenATA: n.id,
      tokenMint: n.mintAddress
    });
  }
  async getNFTListForSaleInstructions(e, r, n, i) {
    return await this.fetchV2("instructions/sell").get({
      auctionHouseAddress: Sg.AUCTION_HOUSE_KEY,
      expiry: -1,
      price: i,
      seller: e,
      sellerReferral: Sg.SELLER_REFERRAL,
      tokenAccount: n,
      tokenMint: r
    });
  }
  async getNFTDelistForSaleInstructions(e, r) {
    const n = await this.getNFTByMintAddress(r);
    return await this.fetchV2("instructions/sell_cancel").get({
      auctionHouseAddress: n.v2.auctionHouseKey,
      expiry: n.v2.expiry || -1,
      price: n.price,
      seller: e,
      sellerReferral: n.v2.sellerReferral,
      tokenAccount: n.id,
      tokenMint: r
    });
  }
}
Vw.default = new oG();
(function(t) {
  var e = Ne && Ne.__importDefault || function(n) {
    return n && n.__esModule ? n : { default: n };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.api = void 0;
  var r = Vw;
  Object.defineProperty(t, "api", { enumerable: !0, get: function() {
    return e(r).default;
  } });
})(LI);
var cG = Ne && Ne.__createBinding || (Object.create ? function(t, e, r, n) {
  n === void 0 && (n = r);
  var i = Object.getOwnPropertyDescriptor(e, r);
  (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return e[r];
  } }), Object.defineProperty(t, n, i);
} : function(t, e, r, n) {
  n === void 0 && (n = r), t[n] = e[r];
}), uG = Ne && Ne.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), DI = Ne && Ne.__importStar || function(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var r in t)
      r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && cG(e, t, r);
  return uG(e, t), e;
};
Object.defineProperty(Dd, "__esModule", { value: !0 });
var FI = Dd.magicEden = Dd.solana = void 0;
Dd.solana = DI(kI);
FI = Dd.magicEden = DI(LI);
var jI = {}, Hw = { exports: {} };
const fG = (t, e) => Math.floor(Math.random() * (e - t + 1) + t), QE = () => {
  const t = new Error("Delay aborted");
  return t.name = "AbortError", t;
}, Op = ({ clearTimeout: t, setTimeout: e, willResolve: r }) => (n, { value: i, signal: s } = {}) => {
  if (s && s.aborted)
    return Promise.reject(QE());
  let a, o, c;
  const f = t || clearTimeout, u = () => {
    f(a), c(QE());
  }, d = () => {
    s && s.removeEventListener("abort", u);
  }, l = new Promise((h, y) => {
    o = () => {
      d(), r ? h(i) : y(i);
    }, c = y, a = (e || setTimeout)(o, n);
  });
  return s && s.addEventListener("abort", u, { once: !0 }), l.clear = () => {
    f(a), a = null, o();
  }, l;
}, Hu = Op({ willResolve: !0 });
Hu.reject = Op({ willResolve: !1 });
Hu.range = (t, e, r) => Hu(fG(t, e), r);
Hu.createWithTimers = ({ clearTimeout: t, setTimeout: e }) => {
  const r = Op({ clearTimeout: t, setTimeout: e, willResolve: !0 });
  return r.reject = Op({ clearTimeout: t, setTimeout: e, willResolve: !1 }), r;
};
Hw.exports = Hu;
Hw.exports.default = Hu;
var dG = Hw.exports, Gu = 1e3, Zu = Gu * 60, Ju = Zu * 60, Rc = Ju * 24, lG = Rc * 7, hG = Rc * 365.25, Gw = function(t, e) {
  e = e || {};
  var r = typeof t;
  if (r === "string" && t.length > 0)
    return pG(t);
  if (r === "number" && isFinite(t))
    return e.long ? bG(t) : yG(t);
  throw new Error(
    "val is not a non-empty string or a valid number. val=" + JSON.stringify(t)
  );
};
function pG(t) {
  if (t = String(t), !(t.length > 100)) {
    var e = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
      t
    );
    if (e) {
      var r = parseFloat(e[1]), n = (e[2] || "ms").toLowerCase();
      switch (n) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return r * hG;
        case "weeks":
        case "week":
        case "w":
          return r * lG;
        case "days":
        case "day":
        case "d":
          return r * Rc;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return r * Ju;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return r * Zu;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return r * Gu;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return r;
        default:
          return;
      }
    }
  }
}
function yG(t) {
  var e = Math.abs(t);
  return e >= Rc ? Math.round(t / Rc) + "d" : e >= Ju ? Math.round(t / Ju) + "h" : e >= Zu ? Math.round(t / Zu) + "m" : e >= Gu ? Math.round(t / Gu) + "s" : t + "ms";
}
function bG(t) {
  var e = Math.abs(t);
  return e >= Rc ? gh(t, e, Rc, "day") : e >= Ju ? gh(t, e, Ju, "hour") : e >= Zu ? gh(t, e, Zu, "minute") : e >= Gu ? gh(t, e, Gu, "second") : t + " ms";
}
function gh(t, e, r, n) {
  var i = e >= r * 1.5;
  return Math.round(t / r) + " " + n + (i ? "s" : "");
}
const xo = /* @__PURE__ */ Ln(Gw);
Object.defineProperty(jI, "__esModule", {
  value: !0
});
var gG = jI.retry = wG, mG = $I(dG), XE = $I(Gw);
function $I(t) {
  return t && t.__esModule ? t : { default: t };
}
function vG(t) {
  return t instanceof Error ? Object.assign({
    name: t.name,
    message: t.message,
    stack: t.stack
  }, t) : t;
}
function wG(t, {
  delayTimesMs: e = [(0, XE.default)("10s")]
}) {
  return async function(...r) {
    const n = e.map((a) => typeof a == "number" ? a : (0, XE.default)(a)), i = [];
    let s = 0;
    for (; ; )
      try {
        return await t(...r);
      } catch (a) {
        const o = a || new Error("Null error");
        if (o.finalError || s === n.length)
          throw o.errorChain = i, o;
        i.push(vG(o)), await (0, mG.default)(n[s]), s++;
      }
  };
}
var _G = Dc();
const e8 = /* @__PURE__ */ Ln(_G), Qt = Wu.lowlevel, SG = 32;
let $r = class Pv {
  /**
   * Create a new PublicKey object
   */
  constructor(e) {
    Zt(this, "_bn");
    if (typeof e == "string") {
      const r = Ot.decode(e);
      if (r.length !== 32)
        throw new Error("Invalid public key input");
      this._bn = new Ss(r);
    } else
      this._bn = new Ss(e);
    if (this._bn.byteLength() > 32)
      throw new Error("Invalid public key input");
  }
  /**
   * Checks if two publicKeys are equal
   */
  equals(e) {
    return this._bn.eq(e._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return Ot.encode(this.toBuffer());
  }
  /**
   * Return the byte array representation of the public key in big endian
   */
  toBytes() {
    const e = this.toBuffer();
    return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  }
  /**
   * Return the Buffer representation of the public key
   */
  toBuffer() {
    const e = this._bn.toArrayLike(ve);
    if (e.length === 32)
      return e;
    const r = ve.alloc(32);
    return e.copy(r, 32 - e.length), r;
  }
  /**
   * Returns a string representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Returns a JSON representation of the public key
   */
  toJSON() {
    return this.toBase58();
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   * HACK: transformed in sync function
   */
  static findProgramAddress(e, r) {
    let n = 255, i;
    for (; n !== 0; ) {
      try {
        const s = [...e, ve.from([n])];
        i = this.createProgramAddress(s, r);
      } catch {
        n--;
        continue;
      }
      return [i, n];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * HACK: transformed in sync function
   */
  static createWithSeed(e, r, n) {
    const i = ve.concat([
      e.toBuffer(),
      ve.from(r),
      n.toBuffer()
    ]), s = e8("sha256").update(i).digest("hex");
    return new Pv(ve.from(s, "hex"));
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  static createProgramAddress(e, r) {
    let n = ve.alloc(0);
    e.forEach(function(a) {
      if (a.length > SG)
        throw new Error("Max seed length exceeded");
      n = ve.concat([n, ve.from(a)]);
    }), n = ve.concat([n, r.toBuffer(), ve.from("ProgramDerivedAddress")]);
    const i = e8("sha256").update(n).digest("hex"), s = new Ss(i, 16).toArray(null, 32);
    if (EG(s))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new Pv(s);
  }
};
function EG(t) {
  const e = [Qt.gf(), Qt.gf(), Qt.gf(), Qt.gf()], r = Qt.gf(), n = Qt.gf(), i = Qt.gf(), s = Qt.gf(), a = Qt.gf(), o = Qt.gf(), c = Qt.gf();
  return Qt.set25519(e[2], xG), Qt.unpack25519(e[1], t), Qt.S(i, e[1]), Qt.M(s, i, Qt.D), Qt.Z(i, i, e[2]), Qt.A(s, e[2], s), Qt.S(a, s), Qt.S(o, a), Qt.M(c, o, a), Qt.M(r, c, i), Qt.M(r, r, s), Qt.pow2523(r, r), Qt.M(r, r, i), Qt.M(r, r, s), Qt.M(r, r, s), Qt.M(e[0], r, s), Qt.S(n, e[0]), Qt.M(n, n, s), t8(n, i) && Qt.M(e[0], e[0], AG), Qt.S(n, e[0]), Qt.M(n, n, s), t8(n, i) ? 0 : 1;
}
const xG = Qt.gf([1]), AG = Qt.gf([
  41136,
  18958,
  6951,
  50414,
  58488,
  44335,
  6150,
  12099,
  55207,
  15867,
  153,
  11085,
  57099,
  20417,
  9344,
  11139
]);
function t8(t, e) {
  var r = new Uint8Array(32), n = new Uint8Array(32);
  return Qt.pack25519(r, t), Qt.pack25519(n, e), Qt.crypto_verify_32(r, 0, n, 0);
}
var xg = { exports: {} }, Ag = {}, Yu = {}, qI = {}, Zw = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, r = Symbol("test"), n = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var i = 42;
  e[r] = i;
  for (r in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var s = Object.getOwnPropertySymbols(e);
  if (s.length !== 1 || s[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var a = Object.getOwnPropertyDescriptor(e, r);
    if (a.value !== i || a.enumerable !== !0)
      return !1;
  }
  return !0;
}, IG = Zw, Jw = function() {
  return IG() && !!Symbol.toStringTag;
}, TG = Error, kG = EvalError, RG = RangeError, PG = ReferenceError, WI = SyntaxError, Ay = TypeError, OG = URIError, r8 = typeof Symbol < "u" && Symbol, BG = Zw, MG = function() {
  return typeof r8 != "function" || typeof Symbol != "function" || typeof r8("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : BG();
}, Ig = {
  __proto__: null,
  foo: {}
}, CG = Object, NG = function() {
  return { __proto__: Ig }.foo === Ig.foo && !(Ig instanceof CG);
}, UG = "Function.prototype.bind called on incompatible ", LG = Object.prototype.toString, DG = Math.max, FG = "[object Function]", n8 = function(e, r) {
  for (var n = [], i = 0; i < e.length; i += 1)
    n[i] = e[i];
  for (var s = 0; s < r.length; s += 1)
    n[s + e.length] = r[s];
  return n;
}, jG = function(e, r) {
  for (var n = [], i = r || 0, s = 0; i < e.length; i += 1, s += 1)
    n[s] = e[i];
  return n;
}, $G = function(t, e) {
  for (var r = "", n = 0; n < t.length; n += 1)
    r += t[n], n + 1 < t.length && (r += e);
  return r;
}, qG = function(e) {
  var r = this;
  if (typeof r != "function" || LG.apply(r) !== FG)
    throw new TypeError(UG + r);
  for (var n = jG(arguments, 1), i, s = function() {
    if (this instanceof i) {
      var u = r.apply(
        this,
        n8(n, arguments)
      );
      return Object(u) === u ? u : this;
    }
    return r.apply(
      e,
      n8(n, arguments)
    );
  }, a = DG(0, r.length - n.length), o = [], c = 0; c < a; c++)
    o[c] = "$" + c;
  if (i = Function("binder", "return function (" + $G(o, ",") + "){ return binder.apply(this,arguments); }")(s), r.prototype) {
    var f = function() {
    };
    f.prototype = r.prototype, i.prototype = new f(), f.prototype = null;
  }
  return i;
}, WG = qG, Yw = Function.prototype.bind || WG, zG = Function.prototype.call, KG = Object.prototype.hasOwnProperty, VG = Yw, HG = VG.call(zG, KG), tr, GG = TG, ZG = kG, JG = RG, YG = PG, Qu = WI, Tu = Ay, QG = OG, zI = Function, Tg = function(t) {
  try {
    return zI('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, bc = Object.getOwnPropertyDescriptor;
if (bc)
  try {
    bc({}, "");
  } catch {
    bc = null;
  }
var kg = function() {
  throw new Tu();
}, XG = bc ? function() {
  try {
    return arguments.callee, kg;
  } catch {
    try {
      return bc(arguments, "callee").get;
    } catch {
      return kg;
    }
  }
}() : kg, ru = MG(), eZ = NG(), Bn = Object.getPrototypeOf || (eZ ? function(t) {
  return t.__proto__;
} : null), du = {}, tZ = typeof Uint8Array > "u" || !Bn ? tr : Bn(Uint8Array), gc = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? tr : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? tr : ArrayBuffer,
  "%ArrayIteratorPrototype%": ru && Bn ? Bn([][Symbol.iterator]()) : tr,
  "%AsyncFromSyncIteratorPrototype%": tr,
  "%AsyncFunction%": du,
  "%AsyncGenerator%": du,
  "%AsyncGeneratorFunction%": du,
  "%AsyncIteratorPrototype%": du,
  "%Atomics%": typeof Atomics > "u" ? tr : Atomics,
  "%BigInt%": typeof BigInt > "u" ? tr : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? tr : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? tr : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? tr : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": GG,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": ZG,
  "%Float32Array%": typeof Float32Array > "u" ? tr : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? tr : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? tr : FinalizationRegistry,
  "%Function%": zI,
  "%GeneratorFunction%": du,
  "%Int8Array%": typeof Int8Array > "u" ? tr : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? tr : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? tr : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": ru && Bn ? Bn(Bn([][Symbol.iterator]())) : tr,
  "%JSON%": typeof JSON == "object" ? JSON : tr,
  "%Map%": typeof Map > "u" ? tr : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !ru || !Bn ? tr : Bn((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? tr : Promise,
  "%Proxy%": typeof Proxy > "u" ? tr : Proxy,
  "%RangeError%": JG,
  "%ReferenceError%": YG,
  "%Reflect%": typeof Reflect > "u" ? tr : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? tr : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !ru || !Bn ? tr : Bn((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? tr : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": ru && Bn ? Bn(""[Symbol.iterator]()) : tr,
  "%Symbol%": ru ? Symbol : tr,
  "%SyntaxError%": Qu,
  "%ThrowTypeError%": XG,
  "%TypedArray%": tZ,
  "%TypeError%": Tu,
  "%Uint8Array%": typeof Uint8Array > "u" ? tr : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? tr : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? tr : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? tr : Uint32Array,
  "%URIError%": QG,
  "%WeakMap%": typeof WeakMap > "u" ? tr : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? tr : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? tr : WeakSet
};
if (Bn)
  try {
    null.error;
  } catch (t) {
    var rZ = Bn(Bn(t));
    gc["%Error.prototype%"] = rZ;
  }
var nZ = function t(e) {
  var r;
  if (e === "%AsyncFunction%")
    r = Tg("async function () {}");
  else if (e === "%GeneratorFunction%")
    r = Tg("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    r = Tg("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var n = t("%AsyncGeneratorFunction%");
    n && (r = n.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var i = t("%AsyncGenerator%");
    i && Bn && (r = Bn(i.prototype));
  }
  return gc[e] = r, r;
}, i8 = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Fl = Yw, Bp = HG, iZ = Fl.call(Function.call, Array.prototype.concat), sZ = Fl.call(Function.apply, Array.prototype.splice), s8 = Fl.call(Function.call, String.prototype.replace), Mp = Fl.call(Function.call, String.prototype.slice), aZ = Fl.call(Function.call, RegExp.prototype.exec), oZ = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, cZ = /\\(\\)?/g, uZ = function(e) {
  var r = Mp(e, 0, 1), n = Mp(e, -1);
  if (r === "%" && n !== "%")
    throw new Qu("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && r !== "%")
    throw new Qu("invalid intrinsic syntax, expected opening `%`");
  var i = [];
  return s8(e, oZ, function(s, a, o, c) {
    i[i.length] = o ? s8(c, cZ, "$1") : a || s;
  }), i;
}, fZ = function(e, r) {
  var n = e, i;
  if (Bp(i8, n) && (i = i8[n], n = "%" + i[0] + "%"), Bp(gc, n)) {
    var s = gc[n];
    if (s === du && (s = nZ(n)), typeof s > "u" && !r)
      throw new Tu("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: i,
      name: n,
      value: s
    };
  }
  throw new Qu("intrinsic " + e + " does not exist!");
}, jl = function(e, r) {
  if (typeof e != "string" || e.length === 0)
    throw new Tu("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new Tu('"allowMissing" argument must be a boolean');
  if (aZ(/^%?[^%]*%?$/, e) === null)
    throw new Qu("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = uZ(e), i = n.length > 0 ? n[0] : "", s = fZ("%" + i + "%", r), a = s.name, o = s.value, c = !1, f = s.alias;
  f && (i = f[0], sZ(n, iZ([0, 1], f)));
  for (var u = 1, d = !0; u < n.length; u += 1) {
    var l = n[u], h = Mp(l, 0, 1), y = Mp(l, -1);
    if ((h === '"' || h === "'" || h === "`" || y === '"' || y === "'" || y === "`") && h !== y)
      throw new Qu("property names with quotes must have matching quotes");
    if ((l === "constructor" || !d) && (c = !0), i += "." + l, a = "%" + i + "%", Bp(gc, a))
      o = gc[a];
    else if (o != null) {
      if (!(l in o)) {
        if (!r)
          throw new Tu("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (bc && u + 1 >= n.length) {
        var p = bc(o, l);
        d = !!p, d && "get" in p && !("originalValue" in p.get) ? o = p.get : o = o[l];
      } else
        d = Bp(o, l), o = o[l];
      d && !c && (gc[a] = o);
    }
  }
  return o;
}, KI = { exports: {} }, Rg, a8;
function Qw() {
  if (a8)
    return Rg;
  a8 = 1;
  var t = jl, e = t("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Rg = e, Rg;
}
var dZ = jl, Zh = dZ("%Object.getOwnPropertyDescriptor%", !0);
if (Zh)
  try {
    Zh([], "length");
  } catch {
    Zh = null;
  }
var Xw = Zh, o8 = Qw(), lZ = WI, nu = Ay, c8 = Xw, VI = function(e, r, n) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new nu("`obj` must be an object or a function`");
  if (typeof r != "string" && typeof r != "symbol")
    throw new nu("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new nu("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new nu("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new nu("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new nu("`loose`, if provided, must be a boolean");
  var i = arguments.length > 3 ? arguments[3] : null, s = arguments.length > 4 ? arguments[4] : null, a = arguments.length > 5 ? arguments[5] : null, o = arguments.length > 6 ? arguments[6] : !1, c = !!c8 && c8(e, r);
  if (o8)
    o8(e, r, {
      configurable: a === null && c ? c.configurable : !a,
      enumerable: i === null && c ? c.enumerable : !i,
      value: n,
      writable: s === null && c ? c.writable : !s
    });
  else if (o || !i && !s && !a)
    e[r] = n;
  else
    throw new lZ("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Ov = Qw(), HI = function() {
  return !!Ov;
};
HI.hasArrayLengthDefineBug = function() {
  if (!Ov)
    return null;
  try {
    return Ov([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var GI = HI, hZ = jl, u8 = VI, pZ = GI(), f8 = Xw, d8 = Ay, yZ = hZ("%Math.floor%"), bZ = function(e, r) {
  if (typeof e != "function")
    throw new d8("`fn` is not a function");
  if (typeof r != "number" || r < 0 || r > 4294967295 || yZ(r) !== r)
    throw new d8("`length` must be a positive 32-bit integer");
  var n = arguments.length > 2 && !!arguments[2], i = !0, s = !0;
  if ("length" in e && f8) {
    var a = f8(e, "length");
    a && !a.configurable && (i = !1), a && !a.writable && (s = !1);
  }
  return (i || s || !n) && (pZ ? u8(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    r,
    !0,
    !0
  ) : u8(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    r
  )), e;
};
(function(t) {
  var e = Yw, r = jl, n = bZ, i = Ay, s = r("%Function.prototype.apply%"), a = r("%Function.prototype.call%"), o = r("%Reflect.apply%", !0) || e.call(a, s), c = Qw(), f = r("%Math.max%");
  t.exports = function(l) {
    if (typeof l != "function")
      throw new i("a function is required");
    var h = o(e, a, arguments);
    return n(
      h,
      1 + f(0, l.length - (arguments.length - 1)),
      !0
    );
  };
  var u = function() {
    return o(e, s, arguments);
  };
  c ? c(t.exports, "apply", { value: u }) : t.exports.apply = u;
})(KI);
var Iy = KI.exports, ZI = jl, JI = Iy, gZ = JI(ZI("String.prototype.indexOf")), Ty = function(e, r) {
  var n = ZI(e, !!r);
  return typeof n == "function" && gZ(e, ".prototype.") > -1 ? JI(n) : n;
}, mZ = Jw(), vZ = Ty, Bv = vZ("Object.prototype.toString"), ky = function(e) {
  return mZ && e && typeof e == "object" && Symbol.toStringTag in e ? !1 : Bv(e) === "[object Arguments]";
}, YI = function(e) {
  return ky(e) ? !0 : e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && Bv(e) !== "[object Array]" && Bv(e.callee) === "[object Function]";
}, wZ = function() {
  return ky(arguments);
}();
ky.isLegacyArguments = YI;
var _Z = wZ ? ky : YI, SZ = Object.prototype.toString, EZ = Function.prototype.toString, xZ = /^\s*(?:function)?\*/, QI = Jw(), Pg = Object.getPrototypeOf, AZ = function() {
  if (!QI)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, Og, IZ = function(e) {
  if (typeof e != "function")
    return !1;
  if (xZ.test(EZ.call(e)))
    return !0;
  if (!QI) {
    var r = SZ.call(e);
    return r === "[object GeneratorFunction]";
  }
  if (!Pg)
    return !1;
  if (typeof Og > "u") {
    var n = AZ();
    Og = n ? Pg(n) : !1;
  }
  return Pg(e) === Og;
}, XI = Function.prototype.toString, mu = typeof Reflect == "object" && Reflect !== null && Reflect.apply, Mv, Jh;
if (typeof mu == "function" && typeof Object.defineProperty == "function")
  try {
    Mv = Object.defineProperty({}, "length", {
      get: function() {
        throw Jh;
      }
    }), Jh = {}, mu(function() {
      throw 42;
    }, null, Mv);
  } catch (t) {
    t !== Jh && (mu = null);
  }
else
  mu = null;
var TZ = /^\s*class\b/, Cv = function(e) {
  try {
    var r = XI.call(e);
    return TZ.test(r);
  } catch {
    return !1;
  }
}, Bg = function(e) {
  try {
    return Cv(e) ? !1 : (XI.call(e), !0);
  } catch {
    return !1;
  }
}, Yh = Object.prototype.toString, kZ = "[object Object]", RZ = "[object Function]", PZ = "[object GeneratorFunction]", OZ = "[object HTMLAllCollection]", BZ = "[object HTML document.all class]", MZ = "[object HTMLCollection]", CZ = typeof Symbol == "function" && !!Symbol.toStringTag, NZ = !(0 in [,]), Nv = function() {
  return !1;
};
if (typeof document == "object") {
  var UZ = document.all;
  Yh.call(UZ) === Yh.call(document.all) && (Nv = function(e) {
    if ((NZ || !e) && (typeof e > "u" || typeof e == "object"))
      try {
        var r = Yh.call(e);
        return (r === OZ || r === BZ || r === MZ || r === kZ) && e("") == null;
      } catch {
      }
    return !1;
  });
}
var LZ = mu ? function(e) {
  if (Nv(e))
    return !0;
  if (!e || typeof e != "function" && typeof e != "object")
    return !1;
  try {
    mu(e, null, Mv);
  } catch (r) {
    if (r !== Jh)
      return !1;
  }
  return !Cv(e) && Bg(e);
} : function(e) {
  if (Nv(e))
    return !0;
  if (!e || typeof e != "function" && typeof e != "object")
    return !1;
  if (CZ)
    return Bg(e);
  if (Cv(e))
    return !1;
  var r = Yh.call(e);
  return r !== RZ && r !== PZ && !/^\[object HTML/.test(r) ? !1 : Bg(e);
}, DZ = LZ, FZ = Object.prototype.toString, eT = Object.prototype.hasOwnProperty, jZ = function(e, r, n) {
  for (var i = 0, s = e.length; i < s; i++)
    eT.call(e, i) && (n == null ? r(e[i], i, e) : r.call(n, e[i], i, e));
}, $Z = function(e, r, n) {
  for (var i = 0, s = e.length; i < s; i++)
    n == null ? r(e.charAt(i), i, e) : r.call(n, e.charAt(i), i, e);
}, qZ = function(e, r, n) {
  for (var i in e)
    eT.call(e, i) && (n == null ? r(e[i], i, e) : r.call(n, e[i], i, e));
}, WZ = function(e, r, n) {
  if (!DZ(r))
    throw new TypeError("iterator must be a function");
  var i;
  arguments.length >= 3 && (i = n), FZ.call(e) === "[object Array]" ? jZ(e, r, i) : typeof e == "string" ? $Z(e, r, i) : qZ(e, r, i);
}, zZ = WZ, KZ = [
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
], Mg = KZ, VZ = typeof globalThis > "u" ? Ne : globalThis, HZ = function() {
  for (var e = [], r = 0; r < Mg.length; r++)
    typeof VZ[Mg[r]] == "function" && (e[e.length] = Mg[r]);
  return e;
}, Cp = zZ, GZ = HZ, l8 = Iy, e_ = Ty, Qh = Xw, ZZ = e_("Object.prototype.toString"), tT = Jw(), h8 = typeof globalThis > "u" ? Ne : globalThis, Uv = GZ(), t_ = e_("String.prototype.slice"), Cg = Object.getPrototypeOf, JZ = e_("Array.prototype.indexOf", !0) || function(e, r) {
  for (var n = 0; n < e.length; n += 1)
    if (e[n] === r)
      return n;
  return -1;
}, Np = { __proto__: null };
tT && Qh && Cg ? Cp(Uv, function(t) {
  var e = new h8[t]();
  if (Symbol.toStringTag in e) {
    var r = Cg(e), n = Qh(r, Symbol.toStringTag);
    if (!n) {
      var i = Cg(r);
      n = Qh(i, Symbol.toStringTag);
    }
    Np["$" + t] = l8(n.get);
  }
}) : Cp(Uv, function(t) {
  var e = new h8[t](), r = e.slice || e.set;
  r && (Np["$" + t] = l8(r));
});
var YZ = function(e) {
  var r = !1;
  return Cp(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    Np,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(n, i) {
      if (!r)
        try {
          "$" + n(e) === i && (r = t_(i, 1));
        } catch {
        }
    }
  ), r;
}, QZ = function(e) {
  var r = !1;
  return Cp(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    Np,
    /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
    function(n, i) {
      if (!r)
        try {
          n(e), r = t_(i, 1);
        } catch {
        }
    }
  ), r;
}, rT = function(e) {
  if (!e || typeof e != "object")
    return !1;
  if (!tT) {
    var r = t_(ZZ(e), 8, -1);
    return JZ(Uv, r) > -1 ? r : r !== "Object" ? !1 : QZ(e);
  }
  return Qh ? YZ(e) : null;
}, XZ = rT, eJ = function(e) {
  return !!XZ(e);
};
(function(t) {
  var e = _Z, r = IZ, n = rT, i = eJ;
  function s(xe) {
    return xe.call.bind(xe);
  }
  var a = typeof BigInt < "u", o = typeof Symbol < "u", c = s(Object.prototype.toString), f = s(Number.prototype.valueOf), u = s(String.prototype.valueOf), d = s(Boolean.prototype.valueOf);
  if (a)
    var l = s(BigInt.prototype.valueOf);
  if (o)
    var h = s(Symbol.prototype.valueOf);
  function y(xe, gt) {
    if (typeof xe != "object")
      return !1;
    try {
      return gt(xe), !0;
    } catch {
      return !1;
    }
  }
  t.isArgumentsObject = e, t.isGeneratorFunction = r, t.isTypedArray = i;
  function p(xe) {
    return typeof Promise < "u" && xe instanceof Promise || xe !== null && typeof xe == "object" && typeof xe.then == "function" && typeof xe.catch == "function";
  }
  t.isPromise = p;
  function b(xe) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(xe) : i(xe) || M(xe);
  }
  t.isArrayBufferView = b;
  function v(xe) {
    return n(xe) === "Uint8Array";
  }
  t.isUint8Array = v;
  function x(xe) {
    return n(xe) === "Uint8ClampedArray";
  }
  t.isUint8ClampedArray = x;
  function I(xe) {
    return n(xe) === "Uint16Array";
  }
  t.isUint16Array = I;
  function L(xe) {
    return n(xe) === "Uint32Array";
  }
  t.isUint32Array = L;
  function P(xe) {
    return n(xe) === "Int8Array";
  }
  t.isInt8Array = P;
  function C(xe) {
    return n(xe) === "Int16Array";
  }
  t.isInt16Array = C;
  function D(xe) {
    return n(xe) === "Int32Array";
  }
  t.isInt32Array = D;
  function F(xe) {
    return n(xe) === "Float32Array";
  }
  t.isFloat32Array = F;
  function G(xe) {
    return n(xe) === "Float64Array";
  }
  t.isFloat64Array = G;
  function re(xe) {
    return n(xe) === "BigInt64Array";
  }
  t.isBigInt64Array = re;
  function ie(xe) {
    return n(xe) === "BigUint64Array";
  }
  t.isBigUint64Array = ie;
  function ee(xe) {
    return c(xe) === "[object Map]";
  }
  ee.working = typeof Map < "u" && ee(/* @__PURE__ */ new Map());
  function $(xe) {
    return typeof Map > "u" ? !1 : ee.working ? ee(xe) : xe instanceof Map;
  }
  t.isMap = $;
  function w(xe) {
    return c(xe) === "[object Set]";
  }
  w.working = typeof Set < "u" && w(/* @__PURE__ */ new Set());
  function E(xe) {
    return typeof Set > "u" ? !1 : w.working ? w(xe) : xe instanceof Set;
  }
  t.isSet = E;
  function U(xe) {
    return c(xe) === "[object WeakMap]";
  }
  U.working = typeof WeakMap < "u" && U(/* @__PURE__ */ new WeakMap());
  function W(xe) {
    return typeof WeakMap > "u" ? !1 : U.working ? U(xe) : xe instanceof WeakMap;
  }
  t.isWeakMap = W;
  function _(xe) {
    return c(xe) === "[object WeakSet]";
  }
  _.working = typeof WeakSet < "u" && _(/* @__PURE__ */ new WeakSet());
  function R(xe) {
    return _(xe);
  }
  t.isWeakSet = R;
  function N(xe) {
    return c(xe) === "[object ArrayBuffer]";
  }
  N.working = typeof ArrayBuffer < "u" && N(new ArrayBuffer());
  function O(xe) {
    return typeof ArrayBuffer > "u" ? !1 : N.working ? N(xe) : xe instanceof ArrayBuffer;
  }
  t.isArrayBuffer = O;
  function g(xe) {
    return c(xe) === "[object DataView]";
  }
  g.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && g(new DataView(new ArrayBuffer(1), 0, 1));
  function M(xe) {
    return typeof DataView > "u" ? !1 : g.working ? g(xe) : xe instanceof DataView;
  }
  t.isDataView = M;
  var Y = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function se(xe) {
    return c(xe) === "[object SharedArrayBuffer]";
  }
  function V(xe) {
    return typeof Y > "u" ? !1 : (typeof se.working > "u" && (se.working = se(new Y())), se.working ? se(xe) : xe instanceof Y);
  }
  t.isSharedArrayBuffer = V;
  function K(xe) {
    return c(xe) === "[object AsyncFunction]";
  }
  t.isAsyncFunction = K;
  function Z(xe) {
    return c(xe) === "[object Map Iterator]";
  }
  t.isMapIterator = Z;
  function ne(xe) {
    return c(xe) === "[object Set Iterator]";
  }
  t.isSetIterator = ne;
  function ce(xe) {
    return c(xe) === "[object Generator]";
  }
  t.isGeneratorObject = ce;
  function H(xe) {
    return c(xe) === "[object WebAssembly.Module]";
  }
  t.isWebAssemblyCompiledModule = H;
  function J(xe) {
    return y(xe, f);
  }
  t.isNumberObject = J;
  function le(xe) {
    return y(xe, u);
  }
  t.isStringObject = le;
  function me(xe) {
    return y(xe, d);
  }
  t.isBooleanObject = me;
  function Ue(xe) {
    return a && y(xe, l);
  }
  t.isBigIntObject = Ue;
  function Ve(xe) {
    return o && y(xe, h);
  }
  t.isSymbolObject = Ve;
  function ze(xe) {
    return J(xe) || le(xe) || me(xe) || Ue(xe) || Ve(xe);
  }
  t.isBoxedPrimitive = ze;
  function at(xe) {
    return typeof Uint8Array < "u" && (O(xe) || V(xe));
  }
  t.isAnyArrayBuffer = at, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(xe) {
    Object.defineProperty(t, xe, {
      enumerable: !1,
      value: function() {
        throw new Error(xe + " is not supported in userland");
      }
    });
  });
})(qI);
var tJ = function(e) {
  return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
};
(function(t) {
  var e = Object.getOwnPropertyDescriptors || function(M) {
    for (var Y = Object.keys(M), se = {}, V = 0; V < Y.length; V++)
      se[Y[V]] = Object.getOwnPropertyDescriptor(M, Y[V]);
    return se;
  }, r = /%[sdj%]/g;
  t.format = function(g) {
    if (!P(g)) {
      for (var M = [], Y = 0; Y < arguments.length; Y++)
        M.push(a(arguments[Y]));
      return M.join(" ");
    }
    for (var Y = 1, se = arguments, V = se.length, K = String(g).replace(r, function(ne) {
      if (ne === "%%")
        return "%";
      if (Y >= V)
        return ne;
      switch (ne) {
        case "%s":
          return String(se[Y++]);
        case "%d":
          return Number(se[Y++]);
        case "%j":
          try {
            return JSON.stringify(se[Y++]);
          } catch {
            return "[Circular]";
          }
        default:
          return ne;
      }
    }), Z = se[Y]; Y < V; Z = se[++Y])
      x(Z) || !G(Z) ? K += " " + Z : K += " " + a(Z);
    return K;
  }, t.deprecate = function(g, M) {
    if (typeof ut < "u" && ut.noDeprecation === !0)
      return g;
    if (typeof ut > "u")
      return function() {
        return t.deprecate(g, M).apply(this, arguments);
      };
    var Y = !1;
    function se() {
      if (!Y) {
        if (ut.throwDeprecation)
          throw new Error(M);
        ut.traceDeprecation ? console.trace(M) : console.error(M), Y = !0;
      }
      return g.apply(this, arguments);
    }
    return se;
  };
  var n = {}, i = /^$/;
  if (ut.env.NODE_DEBUG) {
    var s = ut.env.NODE_DEBUG;
    s = s.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), i = new RegExp("^" + s + "$", "i");
  }
  t.debuglog = function(g) {
    if (g = g.toUpperCase(), !n[g])
      if (i.test(g)) {
        var M = ut.pid;
        n[g] = function() {
          var Y = t.format.apply(t, arguments);
          console.error("%s %d: %s", g, M, Y);
        };
      } else
        n[g] = function() {
        };
    return n[g];
  };
  function a(g, M) {
    var Y = {
      seen: [],
      stylize: c
    };
    return arguments.length >= 3 && (Y.depth = arguments[2]), arguments.length >= 4 && (Y.colors = arguments[3]), v(M) ? Y.showHidden = M : M && t._extend(Y, M), D(Y.showHidden) && (Y.showHidden = !1), D(Y.depth) && (Y.depth = 2), D(Y.colors) && (Y.colors = !1), D(Y.customInspect) && (Y.customInspect = !0), Y.colors && (Y.stylize = o), u(Y, g, Y.depth);
  }
  t.inspect = a, a.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, a.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function o(g, M) {
    var Y = a.styles[M];
    return Y ? "\x1B[" + a.colors[Y][0] + "m" + g + "\x1B[" + a.colors[Y][1] + "m" : g;
  }
  function c(g, M) {
    return g;
  }
  function f(g) {
    var M = {};
    return g.forEach(function(Y, se) {
      M[Y] = !0;
    }), M;
  }
  function u(g, M, Y) {
    if (g.customInspect && M && ee(M.inspect) && // Filter out the util module, it's inspect function is special
    M.inspect !== t.inspect && // Also filter out any prototype objects using the circular check.
    !(M.constructor && M.constructor.prototype === M)) {
      var se = M.inspect(Y, g);
      return P(se) || (se = u(g, se, Y)), se;
    }
    var V = d(g, M);
    if (V)
      return V;
    var K = Object.keys(M), Z = f(K);
    if (g.showHidden && (K = Object.getOwnPropertyNames(M)), ie(M) && (K.indexOf("message") >= 0 || K.indexOf("description") >= 0))
      return l(M);
    if (K.length === 0) {
      if (ee(M)) {
        var ne = M.name ? ": " + M.name : "";
        return g.stylize("[Function" + ne + "]", "special");
      }
      if (F(M))
        return g.stylize(RegExp.prototype.toString.call(M), "regexp");
      if (re(M))
        return g.stylize(Date.prototype.toString.call(M), "date");
      if (ie(M))
        return l(M);
    }
    var ce = "", H = !1, J = ["{", "}"];
    if (b(M) && (H = !0, J = ["[", "]"]), ee(M)) {
      var le = M.name ? ": " + M.name : "";
      ce = " [Function" + le + "]";
    }
    if (F(M) && (ce = " " + RegExp.prototype.toString.call(M)), re(M) && (ce = " " + Date.prototype.toUTCString.call(M)), ie(M) && (ce = " " + l(M)), K.length === 0 && (!H || M.length == 0))
      return J[0] + ce + J[1];
    if (Y < 0)
      return F(M) ? g.stylize(RegExp.prototype.toString.call(M), "regexp") : g.stylize("[Object]", "special");
    g.seen.push(M);
    var me;
    return H ? me = h(g, M, Y, Z, K) : me = K.map(function(Ue) {
      return y(g, M, Y, Z, Ue, H);
    }), g.seen.pop(), p(me, ce, J);
  }
  function d(g, M) {
    if (D(M))
      return g.stylize("undefined", "undefined");
    if (P(M)) {
      var Y = "'" + JSON.stringify(M).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return g.stylize(Y, "string");
    }
    if (L(M))
      return g.stylize("" + M, "number");
    if (v(M))
      return g.stylize("" + M, "boolean");
    if (x(M))
      return g.stylize("null", "null");
  }
  function l(g) {
    return "[" + Error.prototype.toString.call(g) + "]";
  }
  function h(g, M, Y, se, V) {
    for (var K = [], Z = 0, ne = M.length; Z < ne; ++Z)
      _(M, String(Z)) ? K.push(y(
        g,
        M,
        Y,
        se,
        String(Z),
        !0
      )) : K.push("");
    return V.forEach(function(ce) {
      ce.match(/^\d+$/) || K.push(y(
        g,
        M,
        Y,
        se,
        ce,
        !0
      ));
    }), K;
  }
  function y(g, M, Y, se, V, K) {
    var Z, ne, ce;
    if (ce = Object.getOwnPropertyDescriptor(M, V) || { value: M[V] }, ce.get ? ce.set ? ne = g.stylize("[Getter/Setter]", "special") : ne = g.stylize("[Getter]", "special") : ce.set && (ne = g.stylize("[Setter]", "special")), _(se, V) || (Z = "[" + V + "]"), ne || (g.seen.indexOf(ce.value) < 0 ? (x(Y) ? ne = u(g, ce.value, null) : ne = u(g, ce.value, Y - 1), ne.indexOf(`
`) > -1 && (K ? ne = ne.split(`
`).map(function(H) {
      return "  " + H;
    }).join(`
`).slice(2) : ne = `
` + ne.split(`
`).map(function(H) {
      return "   " + H;
    }).join(`
`))) : ne = g.stylize("[Circular]", "special")), D(Z)) {
      if (K && V.match(/^\d+$/))
        return ne;
      Z = JSON.stringify("" + V), Z.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Z = Z.slice(1, -1), Z = g.stylize(Z, "name")) : (Z = Z.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Z = g.stylize(Z, "string"));
    }
    return Z + ": " + ne;
  }
  function p(g, M, Y) {
    var se = g.reduce(function(V, K) {
      return K.indexOf(`
`) >= 0, V + K.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return se > 60 ? Y[0] + (M === "" ? "" : M + `
 `) + " " + g.join(`,
  `) + " " + Y[1] : Y[0] + M + " " + g.join(", ") + " " + Y[1];
  }
  t.types = qI;
  function b(g) {
    return Array.isArray(g);
  }
  t.isArray = b;
  function v(g) {
    return typeof g == "boolean";
  }
  t.isBoolean = v;
  function x(g) {
    return g === null;
  }
  t.isNull = x;
  function I(g) {
    return g == null;
  }
  t.isNullOrUndefined = I;
  function L(g) {
    return typeof g == "number";
  }
  t.isNumber = L;
  function P(g) {
    return typeof g == "string";
  }
  t.isString = P;
  function C(g) {
    return typeof g == "symbol";
  }
  t.isSymbol = C;
  function D(g) {
    return g === void 0;
  }
  t.isUndefined = D;
  function F(g) {
    return G(g) && w(g) === "[object RegExp]";
  }
  t.isRegExp = F, t.types.isRegExp = F;
  function G(g) {
    return typeof g == "object" && g !== null;
  }
  t.isObject = G;
  function re(g) {
    return G(g) && w(g) === "[object Date]";
  }
  t.isDate = re, t.types.isDate = re;
  function ie(g) {
    return G(g) && (w(g) === "[object Error]" || g instanceof Error);
  }
  t.isError = ie, t.types.isNativeError = ie;
  function ee(g) {
    return typeof g == "function";
  }
  t.isFunction = ee;
  function $(g) {
    return g === null || typeof g == "boolean" || typeof g == "number" || typeof g == "string" || typeof g == "symbol" || // ES6 symbol
    typeof g > "u";
  }
  t.isPrimitive = $, t.isBuffer = tJ;
  function w(g) {
    return Object.prototype.toString.call(g);
  }
  function E(g) {
    return g < 10 ? "0" + g.toString(10) : g.toString(10);
  }
  var U = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function W() {
    var g = /* @__PURE__ */ new Date(), M = [
      E(g.getHours()),
      E(g.getMinutes()),
      E(g.getSeconds())
    ].join(":");
    return [g.getDate(), U[g.getMonth()], M].join(" ");
  }
  t.log = function() {
    console.log("%s - %s", W(), t.format.apply(t, arguments));
  }, t.inherits = Kt, t._extend = function(g, M) {
    if (!M || !G(M))
      return g;
    for (var Y = Object.keys(M), se = Y.length; se--; )
      g[Y[se]] = M[Y[se]];
    return g;
  };
  function _(g, M) {
    return Object.prototype.hasOwnProperty.call(g, M);
  }
  var R = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  t.promisify = function(M) {
    if (typeof M != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (R && M[R]) {
      var Y = M[R];
      if (typeof Y != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(Y, R, {
        value: Y,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Y;
    }
    function Y() {
      for (var se, V, K = new Promise(function(ce, H) {
        se = ce, V = H;
      }), Z = [], ne = 0; ne < arguments.length; ne++)
        Z.push(arguments[ne]);
      Z.push(function(ce, H) {
        ce ? V(ce) : se(H);
      });
      try {
        M.apply(this, Z);
      } catch (ce) {
        V(ce);
      }
      return K;
    }
    return Object.setPrototypeOf(Y, Object.getPrototypeOf(M)), R && Object.defineProperty(Y, R, {
      value: Y,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      Y,
      e(M)
    );
  }, t.promisify.custom = R;
  function N(g, M) {
    if (!g) {
      var Y = new Error("Promise was rejected with a falsy value");
      Y.reason = g, g = Y;
    }
    return M(g);
  }
  function O(g) {
    if (typeof g != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function M() {
      for (var Y = [], se = 0; se < arguments.length; se++)
        Y.push(arguments[se]);
      var V = Y.pop();
      if (typeof V != "function")
        throw new TypeError("The last argument must be of type Function");
      var K = this, Z = function() {
        return V.apply(K, arguments);
      };
      g.apply(this, Y).then(
        function(ne) {
          ut.nextTick(Z.bind(null, null, ne));
        },
        function(ne) {
          ut.nextTick(N.bind(null, ne, Z));
        }
      );
    }
    return Object.setPrototypeOf(M, Object.getPrototypeOf(g)), Object.defineProperties(
      M,
      e(g)
    ), M;
  }
  t.callbackify = O;
})(Yu);
var p8;
function nT() {
  if (p8)
    return Ag;
  p8 = 1;
  function t(P) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(C) {
      return typeof C;
    } : function(C) {
      return C && typeof Symbol == "function" && C.constructor === Symbol && C !== Symbol.prototype ? "symbol" : typeof C;
    }, t(P);
  }
  function e(P, C) {
    for (var D = 0; D < C.length; D++) {
      var F = C[D];
      F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(P, n(F.key), F);
    }
  }
  function r(P, C, D) {
    return C && e(P.prototype, C), D && e(P, D), Object.defineProperty(P, "prototype", { writable: !1 }), P;
  }
  function n(P) {
    var C = i(P, "string");
    return t(C) === "symbol" ? C : String(C);
  }
  function i(P, C) {
    if (t(P) !== "object" || P === null)
      return P;
    var D = P[Symbol.toPrimitive];
    if (D !== void 0) {
      var F = D.call(P, C || "default");
      if (t(F) !== "object")
        return F;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (C === "string" ? String : Number)(P);
  }
  function s(P, C) {
    if (!(P instanceof C))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(P, C) {
    if (typeof C != "function" && C !== null)
      throw new TypeError("Super expression must either be null or a function");
    P.prototype = Object.create(C && C.prototype, { constructor: { value: P, writable: !0, configurable: !0 } }), Object.defineProperty(P, "prototype", { writable: !1 }), C && o(P, C);
  }
  function o(P, C) {
    return o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(F, G) {
      return F.__proto__ = G, F;
    }, o(P, C);
  }
  function c(P) {
    var C = d();
    return function() {
      var F = l(P), G;
      if (C) {
        var re = l(this).constructor;
        G = Reflect.construct(F, arguments, re);
      } else
        G = F.apply(this, arguments);
      return f(this, G);
    };
  }
  function f(P, C) {
    if (C && (t(C) === "object" || typeof C == "function"))
      return C;
    if (C !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return u(P);
  }
  function u(P) {
    if (P === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return P;
  }
  function d() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function l(P) {
    return l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(D) {
      return D.__proto__ || Object.getPrototypeOf(D);
    }, l(P);
  }
  var h = {}, y, p;
  function b(P, C, D) {
    D || (D = Error);
    function F(re, ie, ee) {
      return typeof C == "string" ? C : C(re, ie, ee);
    }
    var G = /* @__PURE__ */ function(re) {
      a(ee, re);
      var ie = c(ee);
      function ee($, w, E) {
        var U;
        return s(this, ee), U = ie.call(this, F($, w, E)), U.code = P, U;
      }
      return r(ee);
    }(D);
    h[P] = G;
  }
  function v(P, C) {
    if (Array.isArray(P)) {
      var D = P.length;
      return P = P.map(function(F) {
        return String(F);
      }), D > 2 ? "one of ".concat(C, " ").concat(P.slice(0, D - 1).join(", "), ", or ") + P[D - 1] : D === 2 ? "one of ".concat(C, " ").concat(P[0], " or ").concat(P[1]) : "of ".concat(C, " ").concat(P[0]);
    } else
      return "of ".concat(C, " ").concat(String(P));
  }
  function x(P, C, D) {
    return P.substr(!D || D < 0 ? 0 : +D, C.length) === C;
  }
  function I(P, C, D) {
    return (D === void 0 || D > P.length) && (D = P.length), P.substring(D - C.length, D) === C;
  }
  function L(P, C, D) {
    return typeof D != "number" && (D = 0), D + C.length > P.length ? !1 : P.indexOf(C, D) !== -1;
  }
  return b("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), b("ERR_INVALID_ARG_TYPE", function(P, C, D) {
    y === void 0 && (y = $d()), y(typeof P == "string", "'name' must be a string");
    var F;
    typeof C == "string" && x(C, "not ") ? (F = "must not be", C = C.replace(/^not /, "")) : F = "must be";
    var G;
    if (I(P, " argument"))
      G = "The ".concat(P, " ").concat(F, " ").concat(v(C, "type"));
    else {
      var re = L(P, ".") ? "property" : "argument";
      G = 'The "'.concat(P, '" ').concat(re, " ").concat(F, " ").concat(v(C, "type"));
    }
    return G += ". Received type ".concat(t(D)), G;
  }, TypeError), b("ERR_INVALID_ARG_VALUE", function(P, C) {
    var D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
    p === void 0 && (p = Yu);
    var F = p.inspect(C);
    return F.length > 128 && (F = "".concat(F.slice(0, 128), "...")), "The argument '".concat(P, "' ").concat(D, ". Received ").concat(F);
  }, TypeError), b("ERR_INVALID_RETURN_VALUE", function(P, C, D) {
    var F;
    return D && D.constructor && D.constructor.name ? F = "instance of ".concat(D.constructor.name) : F = "type ".concat(t(D)), "Expected ".concat(P, ' to be returned from the "').concat(C, '"') + " function but got ".concat(F, ".");
  }, TypeError), b("ERR_MISSING_ARGS", function() {
    for (var P = arguments.length, C = new Array(P), D = 0; D < P; D++)
      C[D] = arguments[D];
    y === void 0 && (y = $d()), y(C.length > 0, "At least one arg needs to be specified");
    var F = "The ", G = C.length;
    switch (C = C.map(function(re) {
      return '"'.concat(re, '"');
    }), G) {
      case 1:
        F += "".concat(C[0], " argument");
        break;
      case 2:
        F += "".concat(C[0], " and ").concat(C[1], " arguments");
        break;
      default:
        F += C.slice(0, G - 1).join(", "), F += ", and ".concat(C[G - 1], " arguments");
        break;
    }
    return "".concat(F, " must be specified");
  }, TypeError), Ag.codes = h, Ag;
}
var Ng, y8;
function rJ() {
  if (y8)
    return Ng;
  y8 = 1;
  function t(R, N) {
    var O = Object.keys(R);
    if (Object.getOwnPropertySymbols) {
      var g = Object.getOwnPropertySymbols(R);
      N && (g = g.filter(function(M) {
        return Object.getOwnPropertyDescriptor(R, M).enumerable;
      })), O.push.apply(O, g);
    }
    return O;
  }
  function e(R) {
    for (var N = 1; N < arguments.length; N++) {
      var O = arguments[N] != null ? arguments[N] : {};
      N % 2 ? t(Object(O), !0).forEach(function(g) {
        r(R, g, O[g]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(R, Object.getOwnPropertyDescriptors(O)) : t(Object(O)).forEach(function(g) {
        Object.defineProperty(R, g, Object.getOwnPropertyDescriptor(O, g));
      });
    }
    return R;
  }
  function r(R, N, O) {
    return N = a(N), N in R ? Object.defineProperty(R, N, { value: O, enumerable: !0, configurable: !0, writable: !0 }) : R[N] = O, R;
  }
  function n(R, N) {
    if (!(R instanceof N))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(R, N) {
    for (var O = 0; O < N.length; O++) {
      var g = N[O];
      g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(R, a(g.key), g);
    }
  }
  function s(R, N, O) {
    return N && i(R.prototype, N), O && i(R, O), Object.defineProperty(R, "prototype", { writable: !1 }), R;
  }
  function a(R) {
    var N = o(R, "string");
    return x(N) === "symbol" ? N : String(N);
  }
  function o(R, N) {
    if (x(R) !== "object" || R === null)
      return R;
    var O = R[Symbol.toPrimitive];
    if (O !== void 0) {
      var g = O.call(R, N || "default");
      if (x(g) !== "object")
        return g;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (N === "string" ? String : Number)(R);
  }
  function c(R, N) {
    if (typeof N != "function" && N !== null)
      throw new TypeError("Super expression must either be null or a function");
    R.prototype = Object.create(N && N.prototype, { constructor: { value: R, writable: !0, configurable: !0 } }), Object.defineProperty(R, "prototype", { writable: !1 }), N && b(R, N);
  }
  function f(R) {
    var N = y();
    return function() {
      var g = v(R), M;
      if (N) {
        var Y = v(this).constructor;
        M = Reflect.construct(g, arguments, Y);
      } else
        M = g.apply(this, arguments);
      return u(this, M);
    };
  }
  function u(R, N) {
    if (N && (x(N) === "object" || typeof N == "function"))
      return N;
    if (N !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return d(R);
  }
  function d(R) {
    if (R === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return R;
  }
  function l(R) {
    var N = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return l = function(g) {
      if (g === null || !p(g))
        return g;
      if (typeof g != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof N < "u") {
        if (N.has(g))
          return N.get(g);
        N.set(g, M);
      }
      function M() {
        return h(g, arguments, v(this).constructor);
      }
      return M.prototype = Object.create(g.prototype, { constructor: { value: M, enumerable: !1, writable: !0, configurable: !0 } }), b(M, g);
    }, l(R);
  }
  function h(R, N, O) {
    return y() ? h = Reflect.construct.bind() : h = function(M, Y, se) {
      var V = [null];
      V.push.apply(V, Y);
      var K = Function.bind.apply(M, V), Z = new K();
      return se && b(Z, se.prototype), Z;
    }, h.apply(null, arguments);
  }
  function y() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function p(R) {
    return Function.toString.call(R).indexOf("[native code]") !== -1;
  }
  function b(R, N) {
    return b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, M) {
      return g.__proto__ = M, g;
    }, b(R, N);
  }
  function v(R) {
    return v = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(O) {
      return O.__proto__ || Object.getPrototypeOf(O);
    }, v(R);
  }
  function x(R) {
    "@babel/helpers - typeof";
    return x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(N) {
      return typeof N;
    } : function(N) {
      return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
    }, x(R);
  }
  var I = Yu, L = I.inspect, P = nT(), C = P.codes.ERR_INVALID_ARG_TYPE;
  function D(R, N, O) {
    return (O === void 0 || O > R.length) && (O = R.length), R.substring(O - N.length, O) === N;
  }
  function F(R, N) {
    if (N = Math.floor(N), R.length == 0 || N == 0)
      return "";
    var O = R.length * N;
    for (N = Math.floor(Math.log(N) / Math.log(2)); N; )
      R += R, N--;
    return R += R.substring(0, O - R.length), R;
  }
  var G = "", re = "", ie = "", ee = "", $ = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
  }, w = 10;
  function E(R) {
    var N = Object.keys(R), O = Object.create(Object.getPrototypeOf(R));
    return N.forEach(function(g) {
      O[g] = R[g];
    }), Object.defineProperty(O, "message", {
      value: R.message
    }), O;
  }
  function U(R) {
    return L(R, {
      compact: !1,
      customInspect: !1,
      depth: 1e3,
      maxArrayLength: 1 / 0,
      // Assert compares only enumerable properties (with a few exceptions).
      showHidden: !1,
      // Having a long line as error is better than wrapping the line for
      // comparison for now.
      // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
      // have meta information about the inspected properties (i.e., know where
      // in what line the property starts and ends).
      breakLength: 1 / 0,
      // Assert does not detect proxies currently.
      showProxy: !1,
      sorted: !0,
      // Inspect getters as we also check them when comparing entries.
      getters: !0
    });
  }
  function W(R, N, O) {
    var g = "", M = "", Y = 0, se = "", V = !1, K = U(R), Z = K.split(`
`), ne = U(N).split(`
`), ce = 0, H = "";
    if (O === "strictEqual" && x(R) === "object" && x(N) === "object" && R !== null && N !== null && (O = "strictEqualObject"), Z.length === 1 && ne.length === 1 && Z[0] !== ne[0]) {
      var J = Z[0].length + ne[0].length;
      if (J <= w) {
        if ((x(R) !== "object" || R === null) && (x(N) !== "object" || N === null) && (R !== 0 || N !== 0))
          return "".concat($[O], `

`) + "".concat(Z[0], " !== ").concat(ne[0], `
`);
      } else if (O !== "strictEqualObject") {
        var le = ut.stderr && ut.stderr.isTTY ? ut.stderr.columns : 80;
        if (J < le) {
          for (; Z[0][ce] === ne[0][ce]; )
            ce++;
          ce > 2 && (H = `
  `.concat(F(" ", ce), "^"), ce = 0);
        }
      }
    }
    for (var me = Z[Z.length - 1], Ue = ne[ne.length - 1]; me === Ue && (ce++ < 2 ? se = `
  `.concat(me).concat(se) : g = me, Z.pop(), ne.pop(), !(Z.length === 0 || ne.length === 0)); )
      me = Z[Z.length - 1], Ue = ne[ne.length - 1];
    var Ve = Math.max(Z.length, ne.length);
    if (Ve === 0) {
      var ze = K.split(`
`);
      if (ze.length > 30)
        for (ze[26] = "".concat(G, "...").concat(ee); ze.length > 27; )
          ze.pop();
      return "".concat($.notIdentical, `

`).concat(ze.join(`
`), `
`);
    }
    ce > 3 && (se = `
`.concat(G, "...").concat(ee).concat(se), V = !0), g !== "" && (se = `
  `.concat(g).concat(se), g = "");
    var at = 0, xe = $[O] + `
`.concat(re, "+ actual").concat(ee, " ").concat(ie, "- expected").concat(ee), gt = " ".concat(G, "...").concat(ee, " Lines skipped");
    for (ce = 0; ce < Ve; ce++) {
      var ht = ce - Y;
      if (Z.length < ce + 1)
        ht > 1 && ce > 2 && (ht > 4 ? (M += `
`.concat(G, "...").concat(ee), V = !0) : ht > 3 && (M += `
  `.concat(ne[ce - 2]), at++), M += `
  `.concat(ne[ce - 1]), at++), Y = ce, g += `
`.concat(ie, "-").concat(ee, " ").concat(ne[ce]), at++;
      else if (ne.length < ce + 1)
        ht > 1 && ce > 2 && (ht > 4 ? (M += `
`.concat(G, "...").concat(ee), V = !0) : ht > 3 && (M += `
  `.concat(Z[ce - 2]), at++), M += `
  `.concat(Z[ce - 1]), at++), Y = ce, M += `
`.concat(re, "+").concat(ee, " ").concat(Z[ce]), at++;
      else {
        var Bt = ne[ce], pt = Z[ce], de = pt !== Bt && (!D(pt, ",") || pt.slice(0, -1) !== Bt);
        de && D(Bt, ",") && Bt.slice(0, -1) === pt && (de = !1, pt += ","), de ? (ht > 1 && ce > 2 && (ht > 4 ? (M += `
`.concat(G, "...").concat(ee), V = !0) : ht > 3 && (M += `
  `.concat(Z[ce - 2]), at++), M += `
  `.concat(Z[ce - 1]), at++), Y = ce, M += `
`.concat(re, "+").concat(ee, " ").concat(pt), g += `
`.concat(ie, "-").concat(ee, " ").concat(Bt), at += 2) : (M += g, g = "", (ht === 1 || ce === 0) && (M += `
  `.concat(pt), at++));
      }
      if (at > 20 && ce < Ve - 2)
        return "".concat(xe).concat(gt, `
`).concat(M, `
`).concat(G, "...").concat(ee).concat(g, `
`) + "".concat(G, "...").concat(ee);
    }
    return "".concat(xe).concat(V ? gt : "", `
`).concat(M).concat(g).concat(se).concat(H);
  }
  var _ = /* @__PURE__ */ function(R, N) {
    c(g, R);
    var O = f(g);
    function g(M) {
      var Y;
      if (n(this, g), x(M) !== "object" || M === null)
        throw new C("options", "Object", M);
      var se = M.message, V = M.operator, K = M.stackStartFn, Z = M.actual, ne = M.expected, ce = Error.stackTraceLimit;
      if (Error.stackTraceLimit = 0, se != null)
        Y = O.call(this, String(se));
      else if (ut.stderr && ut.stderr.isTTY && (ut.stderr && ut.stderr.getColorDepth && ut.stderr.getColorDepth() !== 1 ? (G = "\x1B[34m", re = "\x1B[32m", ee = "\x1B[39m", ie = "\x1B[31m") : (G = "", re = "", ee = "", ie = "")), x(Z) === "object" && Z !== null && x(ne) === "object" && ne !== null && "stack" in Z && Z instanceof Error && "stack" in ne && ne instanceof Error && (Z = E(Z), ne = E(ne)), V === "deepStrictEqual" || V === "strictEqual")
        Y = O.call(this, W(Z, ne, V));
      else if (V === "notDeepStrictEqual" || V === "notStrictEqual") {
        var H = $[V], J = U(Z).split(`
`);
        if (V === "notStrictEqual" && x(Z) === "object" && Z !== null && (H = $.notStrictEqualObject), J.length > 30)
          for (J[26] = "".concat(G, "...").concat(ee); J.length > 27; )
            J.pop();
        J.length === 1 ? Y = O.call(this, "".concat(H, " ").concat(J[0])) : Y = O.call(this, "".concat(H, `

`).concat(J.join(`
`), `
`));
      } else {
        var le = U(Z), me = "", Ue = $[V];
        V === "notDeepEqual" || V === "notEqual" ? (le = "".concat($[V], `

`).concat(le), le.length > 1024 && (le = "".concat(le.slice(0, 1021), "..."))) : (me = "".concat(U(ne)), le.length > 512 && (le = "".concat(le.slice(0, 509), "...")), me.length > 512 && (me = "".concat(me.slice(0, 509), "...")), V === "deepEqual" || V === "equal" ? le = "".concat(Ue, `

`).concat(le, `

should equal

`) : me = " ".concat(V, " ").concat(me)), Y = O.call(this, "".concat(le).concat(me));
      }
      return Error.stackTraceLimit = ce, Y.generatedMessage = !se, Object.defineProperty(d(Y), "name", {
        value: "AssertionError [ERR_ASSERTION]",
        enumerable: !1,
        writable: !0,
        configurable: !0
      }), Y.code = "ERR_ASSERTION", Y.actual = Z, Y.expected = ne, Y.operator = V, Error.captureStackTrace && Error.captureStackTrace(d(Y), K), Y.stack, Y.name = "AssertionError", u(Y);
    }
    return s(g, [{
      key: "toString",
      value: function() {
        return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
      }
    }, {
      key: N,
      value: function(Y, se) {
        return L(this, e(e({}, se), {}, {
          customInspect: !1,
          depth: 0
        }));
      }
    }]), g;
  }(/* @__PURE__ */ l(Error), L.custom);
  return Ng = _, Ng;
}
var b8 = Object.prototype.toString, iT = function(e) {
  var r = b8.call(e), n = r === "[object Arguments]";
  return n || (n = r !== "[object Array]" && e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && b8.call(e.callee) === "[object Function]"), n;
}, Ug, g8;
function nJ() {
  if (g8)
    return Ug;
  g8 = 1;
  var t;
  if (!Object.keys) {
    var e = Object.prototype.hasOwnProperty, r = Object.prototype.toString, n = iT, i = Object.prototype.propertyIsEnumerable, s = !i.call({ toString: null }, "toString"), a = i.call(function() {
    }, "prototype"), o = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], c = function(l) {
      var h = l.constructor;
      return h && h.prototype === l;
    }, f = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, u = function() {
      if (typeof window > "u")
        return !1;
      for (var l in window)
        try {
          if (!f["$" + l] && e.call(window, l) && window[l] !== null && typeof window[l] == "object")
            try {
              c(window[l]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), d = function(l) {
      if (typeof window > "u" || !u)
        return c(l);
      try {
        return c(l);
      } catch {
        return !1;
      }
    };
    t = function(h) {
      var y = h !== null && typeof h == "object", p = r.call(h) === "[object Function]", b = n(h), v = y && r.call(h) === "[object String]", x = [];
      if (!y && !p && !b)
        throw new TypeError("Object.keys called on a non-object");
      var I = a && p;
      if (v && h.length > 0 && !e.call(h, 0))
        for (var L = 0; L < h.length; ++L)
          x.push(String(L));
      if (b && h.length > 0)
        for (var P = 0; P < h.length; ++P)
          x.push(String(P));
      else
        for (var C in h)
          !(I && C === "prototype") && e.call(h, C) && x.push(String(C));
      if (s)
        for (var D = d(h), F = 0; F < o.length; ++F)
          !(D && o[F] === "constructor") && e.call(h, o[F]) && x.push(o[F]);
      return x;
    };
  }
  return Ug = t, Ug;
}
var iJ = Array.prototype.slice, sJ = iT, m8 = Object.keys, Xh = m8 ? function(e) {
  return m8(e);
} : nJ(), v8 = Object.keys;
Xh.shim = function() {
  if (Object.keys) {
    var e = function() {
      var r = Object.keys(arguments);
      return r && r.length === arguments.length;
    }(1, 2);
    e || (Object.keys = function(n) {
      return sJ(n) ? v8(iJ.call(n)) : v8(n);
    });
  } else
    Object.keys = Xh;
  return Object.keys || Xh;
};
var sT = Xh, aJ = sT, aT = Zw(), oT = Ty, w8 = Object, oJ = oT("Array.prototype.push"), _8 = oT("Object.prototype.propertyIsEnumerable"), cJ = aT ? Object.getOwnPropertySymbols : null, uJ = function(e, r) {
  if (e == null)
    throw new TypeError("target must be an object");
  var n = w8(e);
  if (arguments.length === 1)
    return n;
  for (var i = 1; i < arguments.length; ++i) {
    var s = w8(arguments[i]), a = aJ(s), o = aT && (Object.getOwnPropertySymbols || cJ);
    if (o)
      for (var c = o(s), f = 0; f < c.length; ++f) {
        var u = c[f];
        _8(s, u) && oJ(a, u);
      }
    for (var d = 0; d < a.length; ++d) {
      var l = a[d];
      if (_8(s, l)) {
        var h = s[l];
        n[l] = h;
      }
    }
  }
  return n;
}, Lg = uJ, fJ = function() {
  if (!Object.assign)
    return !1;
  for (var t = "abcdefghijklmnopqrst", e = t.split(""), r = {}, n = 0; n < e.length; ++n)
    r[e[n]] = e[n];
  var i = Object.assign({}, r), s = "";
  for (var a in i)
    s += a;
  return t !== s;
}, dJ = function() {
  if (!Object.assign || !Object.preventExtensions)
    return !1;
  var t = Object.preventExtensions({ 1: 2 });
  try {
    Object.assign(t, "xy");
  } catch {
    return t[1] === "y";
  }
  return !1;
}, lJ = function() {
  return !Object.assign || fJ() || dJ() ? Lg : Object.assign;
}, S8 = function(t) {
  return t !== t;
}, cT = function(e, r) {
  return e === 0 && r === 0 ? 1 / e === 1 / r : !!(e === r || S8(e) && S8(r));
}, hJ = cT, r_ = function() {
  return typeof Object.is == "function" ? Object.is : hJ;
}, Dg, E8;
function Ry() {
  if (E8)
    return Dg;
  E8 = 1;
  var t = sT, e = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", r = Object.prototype.toString, n = Array.prototype.concat, i = VI, s = function(f) {
    return typeof f == "function" && r.call(f) === "[object Function]";
  }, a = GI(), o = function(f, u, d, l) {
    if (u in f) {
      if (l === !0) {
        if (f[u] === d)
          return;
      } else if (!s(l) || !l())
        return;
    }
    a ? i(f, u, d, !0) : i(f, u, d);
  }, c = function(f, u) {
    var d = arguments.length > 2 ? arguments[2] : {}, l = t(u);
    e && (l = n.call(l, Object.getOwnPropertySymbols(u)));
    for (var h = 0; h < l.length; h += 1)
      o(f, l[h], u[l[h]], d[l[h]]);
  };
  return c.supportsDescriptors = !!a, Dg = c, Dg;
}
var Fg, x8;
function pJ() {
  if (x8)
    return Fg;
  x8 = 1;
  var t = r_, e = Ry();
  return Fg = function() {
    var n = t();
    return e(Object, { is: n }, {
      is: function() {
        return Object.is !== n;
      }
    }), n;
  }, Fg;
}
var jg, A8;
function yJ() {
  if (A8)
    return jg;
  A8 = 1;
  var t = Ry(), e = Iy, r = cT, n = r_, i = pJ(), s = e(n(), Object);
  return t(s, {
    getPolyfill: n,
    implementation: r,
    shim: i
  }), jg = s, jg;
}
var $g, I8;
function uT() {
  return I8 || (I8 = 1, $g = function(e) {
    return e !== e;
  }), $g;
}
var qg, T8;
function fT() {
  if (T8)
    return qg;
  T8 = 1;
  var t = uT();
  return qg = function() {
    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : t;
  }, qg;
}
var Wg, k8;
function bJ() {
  if (k8)
    return Wg;
  k8 = 1;
  var t = Ry(), e = fT();
  return Wg = function() {
    var n = e();
    return t(Number, { isNaN: n }, {
      isNaN: function() {
        return Number.isNaN !== n;
      }
    }), n;
  }, Wg;
}
var zg, R8;
function gJ() {
  if (R8)
    return zg;
  R8 = 1;
  var t = Iy, e = Ry(), r = uT(), n = fT(), i = bJ(), s = t(n(), Number);
  return e(s, {
    getPolyfill: n,
    implementation: r,
    shim: i
  }), zg = s, zg;
}
var Kg, P8;
function mJ() {
  if (P8)
    return Kg;
  P8 = 1;
  function t(de, he) {
    return s(de) || i(de, he) || r(de, he) || e();
  }
  function e() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(de, he) {
    if (de) {
      if (typeof de == "string")
        return n(de, he);
      var Ie = Object.prototype.toString.call(de).slice(8, -1);
      if (Ie === "Object" && de.constructor && (Ie = de.constructor.name), Ie === "Map" || Ie === "Set")
        return Array.from(de);
      if (Ie === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ie))
        return n(de, he);
    }
  }
  function n(de, he) {
    (he == null || he > de.length) && (he = de.length);
    for (var Ie = 0, z = new Array(he); Ie < he; Ie++)
      z[Ie] = de[Ie];
    return z;
  }
  function i(de, he) {
    var Ie = de == null ? null : typeof Symbol < "u" && de[Symbol.iterator] || de["@@iterator"];
    if (Ie != null) {
      var z, k, B, A, m = [], S = !0, q = !1;
      try {
        if (B = (Ie = Ie.call(de)).next, he === 0) {
          if (Object(Ie) !== Ie)
            return;
          S = !1;
        } else
          for (; !(S = (z = B.call(Ie)).done) && (m.push(z.value), m.length !== he); S = !0)
            ;
      } catch (oe) {
        q = !0, k = oe;
      } finally {
        try {
          if (!S && Ie.return != null && (A = Ie.return(), Object(A) !== A))
            return;
        } finally {
          if (q)
            throw k;
        }
      }
      return m;
    }
  }
  function s(de) {
    if (Array.isArray(de))
      return de;
  }
  function a(de) {
    "@babel/helpers - typeof";
    return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(he) {
      return typeof he;
    } : function(he) {
      return he && typeof Symbol == "function" && he.constructor === Symbol && he !== Symbol.prototype ? "symbol" : typeof he;
    }, a(de);
  }
  var o = /a/g.flags !== void 0, c = function(he) {
    var Ie = [];
    return he.forEach(function(z) {
      return Ie.push(z);
    }), Ie;
  }, f = function(he) {
    var Ie = [];
    return he.forEach(function(z, k) {
      return Ie.push([k, z]);
    }), Ie;
  }, u = Object.is ? Object.is : yJ(), d = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
  }, l = Number.isNaN ? Number.isNaN : gJ();
  function h(de) {
    return de.call.bind(de);
  }
  var y = h(Object.prototype.hasOwnProperty), p = h(Object.prototype.propertyIsEnumerable), b = h(Object.prototype.toString), v = Yu.types, x = v.isAnyArrayBuffer, I = v.isArrayBufferView, L = v.isDate, P = v.isMap, C = v.isRegExp, D = v.isSet, F = v.isNativeError, G = v.isBoxedPrimitive, re = v.isNumberObject, ie = v.isStringObject, ee = v.isBooleanObject, $ = v.isBigIntObject, w = v.isSymbolObject, E = v.isFloat32Array, U = v.isFloat64Array;
  function W(de) {
    if (de.length === 0 || de.length > 10)
      return !0;
    for (var he = 0; he < de.length; he++) {
      var Ie = de.charCodeAt(he);
      if (Ie < 48 || Ie > 57)
        return !0;
    }
    return de.length === 10 && de >= Math.pow(2, 32);
  }
  function _(de) {
    return Object.keys(de).filter(W).concat(d(de).filter(Object.prototype.propertyIsEnumerable.bind(de)));
  }
  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
   * @license  MIT
   */
  function R(de, he) {
    if (de === he)
      return 0;
    for (var Ie = de.length, z = he.length, k = 0, B = Math.min(Ie, z); k < B; ++k)
      if (de[k] !== he[k]) {
        Ie = de[k], z = he[k];
        break;
      }
    return Ie < z ? -1 : z < Ie ? 1 : 0;
  }
  var N = !0, O = !1, g = 0, M = 1, Y = 2, se = 3;
  function V(de, he) {
    return o ? de.source === he.source && de.flags === he.flags : RegExp.prototype.toString.call(de) === RegExp.prototype.toString.call(he);
  }
  function K(de, he) {
    if (de.byteLength !== he.byteLength)
      return !1;
    for (var Ie = 0; Ie < de.byteLength; Ie++)
      if (de[Ie] !== he[Ie])
        return !1;
    return !0;
  }
  function Z(de, he) {
    return de.byteLength !== he.byteLength ? !1 : R(new Uint8Array(de.buffer, de.byteOffset, de.byteLength), new Uint8Array(he.buffer, he.byteOffset, he.byteLength)) === 0;
  }
  function ne(de, he) {
    return de.byteLength === he.byteLength && R(new Uint8Array(de), new Uint8Array(he)) === 0;
  }
  function ce(de, he) {
    return re(de) ? re(he) && u(Number.prototype.valueOf.call(de), Number.prototype.valueOf.call(he)) : ie(de) ? ie(he) && String.prototype.valueOf.call(de) === String.prototype.valueOf.call(he) : ee(de) ? ee(he) && Boolean.prototype.valueOf.call(de) === Boolean.prototype.valueOf.call(he) : $(de) ? $(he) && BigInt.prototype.valueOf.call(de) === BigInt.prototype.valueOf.call(he) : w(he) && Symbol.prototype.valueOf.call(de) === Symbol.prototype.valueOf.call(he);
  }
  function H(de, he, Ie, z) {
    if (de === he)
      return de !== 0 ? !0 : Ie ? u(de, he) : !0;
    if (Ie) {
      if (a(de) !== "object")
        return typeof de == "number" && l(de) && l(he);
      if (a(he) !== "object" || de === null || he === null || Object.getPrototypeOf(de) !== Object.getPrototypeOf(he))
        return !1;
    } else {
      if (de === null || a(de) !== "object")
        return he === null || a(he) !== "object" ? de == he : !1;
      if (he === null || a(he) !== "object")
        return !1;
    }
    var k = b(de), B = b(he);
    if (k !== B)
      return !1;
    if (Array.isArray(de)) {
      if (de.length !== he.length)
        return !1;
      var A = _(de), m = _(he);
      return A.length !== m.length ? !1 : le(de, he, Ie, z, M, A);
    }
    if (k === "[object Object]" && (!P(de) && P(he) || !D(de) && D(he)))
      return !1;
    if (L(de)) {
      if (!L(he) || Date.prototype.getTime.call(de) !== Date.prototype.getTime.call(he))
        return !1;
    } else if (C(de)) {
      if (!C(he) || !V(de, he))
        return !1;
    } else if (F(de) || de instanceof Error) {
      if (de.message !== he.message || de.name !== he.name)
        return !1;
    } else if (I(de)) {
      if (!Ie && (E(de) || U(de))) {
        if (!K(de, he))
          return !1;
      } else if (!Z(de, he))
        return !1;
      var S = _(de), q = _(he);
      return S.length !== q.length ? !1 : le(de, he, Ie, z, g, S);
    } else {
      if (D(de))
        return !D(he) || de.size !== he.size ? !1 : le(de, he, Ie, z, Y);
      if (P(de))
        return !P(he) || de.size !== he.size ? !1 : le(de, he, Ie, z, se);
      if (x(de)) {
        if (!ne(de, he))
          return !1;
      } else if (G(de) && !ce(de, he))
        return !1;
    }
    return le(de, he, Ie, z, g);
  }
  function J(de, he) {
    return he.filter(function(Ie) {
      return p(de, Ie);
    });
  }
  function le(de, he, Ie, z, k, B) {
    if (arguments.length === 5) {
      B = Object.keys(de);
      var A = Object.keys(he);
      if (B.length !== A.length)
        return !1;
    }
    for (var m = 0; m < B.length; m++)
      if (!y(he, B[m]))
        return !1;
    if (Ie && arguments.length === 5) {
      var S = d(de);
      if (S.length !== 0) {
        var q = 0;
        for (m = 0; m < S.length; m++) {
          var oe = S[m];
          if (p(de, oe)) {
            if (!p(he, oe))
              return !1;
            B.push(oe), q++;
          } else if (p(he, oe))
            return !1;
        }
        var fe = d(he);
        if (S.length !== fe.length && J(he, fe).length !== q)
          return !1;
      } else {
        var pe = d(he);
        if (pe.length !== 0 && J(he, pe).length !== 0)
          return !1;
      }
    }
    if (B.length === 0 && (k === g || k === M && de.length === 0 || de.size === 0))
      return !0;
    if (z === void 0)
      z = {
        val1: /* @__PURE__ */ new Map(),
        val2: /* @__PURE__ */ new Map(),
        position: 0
      };
    else {
      var Ke = z.val1.get(de);
      if (Ke !== void 0) {
        var De = z.val2.get(he);
        if (De !== void 0)
          return Ke === De;
      }
      z.position++;
    }
    z.val1.set(de, z.position), z.val2.set(he, z.position);
    var ot = ht(de, he, Ie, B, z, k);
    return z.val1.delete(de), z.val2.delete(he), ot;
  }
  function me(de, he, Ie, z) {
    for (var k = c(de), B = 0; B < k.length; B++) {
      var A = k[B];
      if (H(he, A, Ie, z))
        return de.delete(A), !0;
    }
    return !1;
  }
  function Ue(de) {
    switch (a(de)) {
      case "undefined":
        return null;
      case "object":
        return;
      case "symbol":
        return !1;
      case "string":
        de = +de;
      case "number":
        if (l(de))
          return !1;
    }
    return !0;
  }
  function Ve(de, he, Ie) {
    var z = Ue(Ie);
    return z ?? (he.has(z) && !de.has(z));
  }
  function ze(de, he, Ie, z, k) {
    var B = Ue(Ie);
    if (B != null)
      return B;
    var A = he.get(B);
    return A === void 0 && !he.has(B) || !H(z, A, !1, k) ? !1 : !de.has(B) && H(z, A, !1, k);
  }
  function at(de, he, Ie, z) {
    for (var k = null, B = c(de), A = 0; A < B.length; A++) {
      var m = B[A];
      if (a(m) === "object" && m !== null)
        k === null && (k = /* @__PURE__ */ new Set()), k.add(m);
      else if (!he.has(m)) {
        if (Ie || !Ve(de, he, m))
          return !1;
        k === null && (k = /* @__PURE__ */ new Set()), k.add(m);
      }
    }
    if (k !== null) {
      for (var S = c(he), q = 0; q < S.length; q++) {
        var oe = S[q];
        if (a(oe) === "object" && oe !== null) {
          if (!me(k, oe, Ie, z))
            return !1;
        } else if (!Ie && !de.has(oe) && !me(k, oe, Ie, z))
          return !1;
      }
      return k.size === 0;
    }
    return !0;
  }
  function xe(de, he, Ie, z, k, B) {
    for (var A = c(de), m = 0; m < A.length; m++) {
      var S = A[m];
      if (H(Ie, S, k, B) && H(z, he.get(S), k, B))
        return de.delete(S), !0;
    }
    return !1;
  }
  function gt(de, he, Ie, z) {
    for (var k = null, B = f(de), A = 0; A < B.length; A++) {
      var m = t(B[A], 2), S = m[0], q = m[1];
      if (a(S) === "object" && S !== null)
        k === null && (k = /* @__PURE__ */ new Set()), k.add(S);
      else {
        var oe = he.get(S);
        if (oe === void 0 && !he.has(S) || !H(q, oe, Ie, z)) {
          if (Ie || !ze(de, he, S, q, z))
            return !1;
          k === null && (k = /* @__PURE__ */ new Set()), k.add(S);
        }
      }
    }
    if (k !== null) {
      for (var fe = f(he), pe = 0; pe < fe.length; pe++) {
        var Ke = t(fe[pe], 2), De = Ke[0], ot = Ke[1];
        if (a(De) === "object" && De !== null) {
          if (!xe(k, de, De, ot, Ie, z))
            return !1;
        } else if (!Ie && (!de.has(De) || !H(de.get(De), ot, !1, z)) && !xe(k, de, De, ot, !1, z))
          return !1;
      }
      return k.size === 0;
    }
    return !0;
  }
  function ht(de, he, Ie, z, k, B) {
    var A = 0;
    if (B === Y) {
      if (!at(de, he, Ie, k))
        return !1;
    } else if (B === se) {
      if (!gt(de, he, Ie, k))
        return !1;
    } else if (B === M)
      for (; A < de.length; A++)
        if (y(de, A)) {
          if (!y(he, A) || !H(de[A], he[A], Ie, k))
            return !1;
        } else {
          if (y(he, A))
            return !1;
          for (var m = Object.keys(de); A < m.length; A++) {
            var S = m[A];
            if (!y(he, S) || !H(de[S], he[S], Ie, k))
              return !1;
          }
          return m.length === Object.keys(he).length;
        }
    for (A = 0; A < z.length; A++) {
      var q = z[A];
      if (!H(de[q], he[q], Ie, k))
        return !1;
    }
    return !0;
  }
  function Bt(de, he) {
    return H(de, he, O);
  }
  function pt(de, he) {
    return H(de, he, N);
  }
  return Kg = {
    isDeepEqual: Bt,
    isDeepStrictEqual: pt
  }, Kg;
}
var O8;
function $d() {
  if (O8)
    return xg.exports;
  O8 = 1;
  function t(K) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Z) {
      return typeof Z;
    } : function(Z) {
      return Z && typeof Symbol == "function" && Z.constructor === Symbol && Z !== Symbol.prototype ? "symbol" : typeof Z;
    }, t(K);
  }
  function e(K, Z) {
    for (var ne = 0; ne < Z.length; ne++) {
      var ce = Z[ne];
      ce.enumerable = ce.enumerable || !1, ce.configurable = !0, "value" in ce && (ce.writable = !0), Object.defineProperty(K, n(ce.key), ce);
    }
  }
  function r(K, Z, ne) {
    return Z && e(K.prototype, Z), ne && e(K, ne), Object.defineProperty(K, "prototype", { writable: !1 }), K;
  }
  function n(K) {
    var Z = i(K, "string");
    return t(Z) === "symbol" ? Z : String(Z);
  }
  function i(K, Z) {
    if (t(K) !== "object" || K === null)
      return K;
    var ne = K[Symbol.toPrimitive];
    if (ne !== void 0) {
      var ce = ne.call(K, Z || "default");
      if (t(ce) !== "object")
        return ce;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Z === "string" ? String : Number)(K);
  }
  function s(K, Z) {
    if (!(K instanceof Z))
      throw new TypeError("Cannot call a class as a function");
  }
  var a = nT(), o = a.codes, c = o.ERR_AMBIGUOUS_ARGUMENT, f = o.ERR_INVALID_ARG_TYPE, u = o.ERR_INVALID_ARG_VALUE, d = o.ERR_INVALID_RETURN_VALUE, l = o.ERR_MISSING_ARGS, h = rJ(), y = Yu, p = y.inspect, b = Yu.types, v = b.isPromise, x = b.isRegExp, I = lJ(), L = r_(), P = Ty("RegExp.prototype.test"), C, D;
  function F() {
    var K = mJ();
    C = K.isDeepEqual, D = K.isDeepStrictEqual;
  }
  var G = !1, re = xg.exports = E, ie = {};
  function ee(K) {
    throw K.message instanceof Error ? K.message : new h(K);
  }
  function $(K, Z, ne, ce, H) {
    var J = arguments.length, le;
    if (J === 0)
      le = "Failed";
    else if (J === 1)
      ne = K, K = void 0;
    else {
      if (G === !1) {
        G = !0;
        var me = ut.emitWarning ? ut.emitWarning : console.warn.bind(console);
        me("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
      }
      J === 2 && (ce = "!=");
    }
    if (ne instanceof Error)
      throw ne;
    var Ue = {
      actual: K,
      expected: Z,
      operator: ce === void 0 ? "fail" : ce,
      stackStartFn: H || $
    };
    ne !== void 0 && (Ue.message = ne);
    var Ve = new h(Ue);
    throw le && (Ve.message = le, Ve.generatedMessage = !0), Ve;
  }
  re.fail = $, re.AssertionError = h;
  function w(K, Z, ne, ce) {
    if (!ne) {
      var H = !1;
      if (Z === 0)
        H = !0, ce = "No value argument passed to `assert.ok()`";
      else if (ce instanceof Error)
        throw ce;
      var J = new h({
        actual: ne,
        expected: !0,
        message: ce,
        operator: "==",
        stackStartFn: K
      });
      throw J.generatedMessage = H, J;
    }
  }
  function E() {
    for (var K = arguments.length, Z = new Array(K), ne = 0; ne < K; ne++)
      Z[ne] = arguments[ne];
    w.apply(void 0, [E, Z.length].concat(Z));
  }
  re.ok = E, re.equal = function K(Z, ne, ce) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    Z != ne && ee({
      actual: Z,
      expected: ne,
      message: ce,
      operator: "==",
      stackStartFn: K
    });
  }, re.notEqual = function K(Z, ne, ce) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    Z == ne && ee({
      actual: Z,
      expected: ne,
      message: ce,
      operator: "!=",
      stackStartFn: K
    });
  }, re.deepEqual = function K(Z, ne, ce) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    C === void 0 && F(), C(Z, ne) || ee({
      actual: Z,
      expected: ne,
      message: ce,
      operator: "deepEqual",
      stackStartFn: K
    });
  }, re.notDeepEqual = function K(Z, ne, ce) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    C === void 0 && F(), C(Z, ne) && ee({
      actual: Z,
      expected: ne,
      message: ce,
      operator: "notDeepEqual",
      stackStartFn: K
    });
  }, re.deepStrictEqual = function K(Z, ne, ce) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    C === void 0 && F(), D(Z, ne) || ee({
      actual: Z,
      expected: ne,
      message: ce,
      operator: "deepStrictEqual",
      stackStartFn: K
    });
  }, re.notDeepStrictEqual = U;
  function U(K, Z, ne) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    C === void 0 && F(), D(K, Z) && ee({
      actual: K,
      expected: Z,
      message: ne,
      operator: "notDeepStrictEqual",
      stackStartFn: U
    });
  }
  re.strictEqual = function K(Z, ne, ce) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    L(Z, ne) || ee({
      actual: Z,
      expected: ne,
      message: ce,
      operator: "strictEqual",
      stackStartFn: K
    });
  }, re.notStrictEqual = function K(Z, ne, ce) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    L(Z, ne) && ee({
      actual: Z,
      expected: ne,
      message: ce,
      operator: "notStrictEqual",
      stackStartFn: K
    });
  };
  var W = /* @__PURE__ */ r(function K(Z, ne, ce) {
    var H = this;
    s(this, K), ne.forEach(function(J) {
      J in Z && (ce !== void 0 && typeof ce[J] == "string" && x(Z[J]) && P(Z[J], ce[J]) ? H[J] = ce[J] : H[J] = Z[J]);
    });
  });
  function _(K, Z, ne, ce, H, J) {
    if (!(ne in K) || !D(K[ne], Z[ne])) {
      if (!ce) {
        var le = new W(K, H), me = new W(Z, H, K), Ue = new h({
          actual: le,
          expected: me,
          operator: "deepStrictEqual",
          stackStartFn: J
        });
        throw Ue.actual = K, Ue.expected = Z, Ue.operator = J.name, Ue;
      }
      ee({
        actual: K,
        expected: Z,
        message: ce,
        operator: J.name,
        stackStartFn: J
      });
    }
  }
  function R(K, Z, ne, ce) {
    if (typeof Z != "function") {
      if (x(Z))
        return P(Z, K);
      if (arguments.length === 2)
        throw new f("expected", ["Function", "RegExp"], Z);
      if (t(K) !== "object" || K === null) {
        var H = new h({
          actual: K,
          expected: Z,
          message: ne,
          operator: "deepStrictEqual",
          stackStartFn: ce
        });
        throw H.operator = ce.name, H;
      }
      var J = Object.keys(Z);
      if (Z instanceof Error)
        J.push("name", "message");
      else if (J.length === 0)
        throw new u("error", Z, "may not be an empty object");
      return C === void 0 && F(), J.forEach(function(le) {
        typeof K[le] == "string" && x(Z[le]) && P(Z[le], K[le]) || _(K, Z, le, ne, J, ce);
      }), !0;
    }
    return Z.prototype !== void 0 && K instanceof Z ? !0 : Error.isPrototypeOf(Z) ? !1 : Z.call({}, K) === !0;
  }
  function N(K) {
    if (typeof K != "function")
      throw new f("fn", "Function", K);
    try {
      K();
    } catch (Z) {
      return Z;
    }
    return ie;
  }
  function O(K) {
    return v(K) || K !== null && t(K) === "object" && typeof K.then == "function" && typeof K.catch == "function";
  }
  function g(K) {
    return Promise.resolve().then(function() {
      var Z;
      if (typeof K == "function") {
        if (Z = K(), !O(Z))
          throw new d("instance of Promise", "promiseFn", Z);
      } else if (O(K))
        Z = K;
      else
        throw new f("promiseFn", ["Function", "Promise"], K);
      return Promise.resolve().then(function() {
        return Z;
      }).then(function() {
        return ie;
      }).catch(function(ne) {
        return ne;
      });
    });
  }
  function M(K, Z, ne, ce) {
    if (typeof ne == "string") {
      if (arguments.length === 4)
        throw new f("error", ["Object", "Error", "Function", "RegExp"], ne);
      if (t(Z) === "object" && Z !== null) {
        if (Z.message === ne)
          throw new c("error/message", 'The error message "'.concat(Z.message, '" is identical to the message.'));
      } else if (Z === ne)
        throw new c("error/message", 'The error "'.concat(Z, '" is identical to the message.'));
      ce = ne, ne = void 0;
    } else if (ne != null && t(ne) !== "object" && typeof ne != "function")
      throw new f("error", ["Object", "Error", "Function", "RegExp"], ne);
    if (Z === ie) {
      var H = "";
      ne && ne.name && (H += " (".concat(ne.name, ")")), H += ce ? ": ".concat(ce) : ".";
      var J = K.name === "rejects" ? "rejection" : "exception";
      ee({
        actual: void 0,
        expected: ne,
        operator: K.name,
        message: "Missing expected ".concat(J).concat(H),
        stackStartFn: K
      });
    }
    if (ne && !R(Z, ne, ce, K))
      throw Z;
  }
  function Y(K, Z, ne, ce) {
    if (Z !== ie) {
      if (typeof ne == "string" && (ce = ne, ne = void 0), !ne || R(Z, ne)) {
        var H = ce ? ": ".concat(ce) : ".", J = K.name === "doesNotReject" ? "rejection" : "exception";
        ee({
          actual: Z,
          expected: ne,
          operator: K.name,
          message: "Got unwanted ".concat(J).concat(H, `
`) + 'Actual message: "'.concat(Z && Z.message, '"'),
          stackStartFn: K
        });
      }
      throw Z;
    }
  }
  re.throws = function K(Z) {
    for (var ne = arguments.length, ce = new Array(ne > 1 ? ne - 1 : 0), H = 1; H < ne; H++)
      ce[H - 1] = arguments[H];
    M.apply(void 0, [K, N(Z)].concat(ce));
  }, re.rejects = function K(Z) {
    for (var ne = arguments.length, ce = new Array(ne > 1 ? ne - 1 : 0), H = 1; H < ne; H++)
      ce[H - 1] = arguments[H];
    return g(Z).then(function(J) {
      return M.apply(void 0, [K, J].concat(ce));
    });
  }, re.doesNotThrow = function K(Z) {
    for (var ne = arguments.length, ce = new Array(ne > 1 ? ne - 1 : 0), H = 1; H < ne; H++)
      ce[H - 1] = arguments[H];
    Y.apply(void 0, [K, N(Z)].concat(ce));
  }, re.doesNotReject = function K(Z) {
    for (var ne = arguments.length, ce = new Array(ne > 1 ? ne - 1 : 0), H = 1; H < ne; H++)
      ce[H - 1] = arguments[H];
    return g(Z).then(function(J) {
      return Y.apply(void 0, [K, J].concat(ce));
    });
  }, re.ifError = function K(Z) {
    if (Z != null) {
      var ne = "ifError got unwanted exception: ";
      t(Z) === "object" && typeof Z.message == "string" ? Z.message.length === 0 && Z.constructor ? ne += Z.constructor.name : ne += Z.message : ne += p(Z);
      var ce = new h({
        actual: Z,
        expected: null,
        operator: "ifError",
        message: ne,
        stackStartFn: K
      }), H = Z.stack;
      if (typeof H == "string") {
        var J = H.split(`
`);
        J.shift();
        for (var le = ce.stack.split(`
`), me = 0; me < J.length; me++) {
          var Ue = le.indexOf(J[me]);
          if (Ue !== -1) {
            le = le.slice(0, Ue);
            break;
          }
        }
        ce.stack = "".concat(le.join(`
`), `
`).concat(J.join(`
`));
      }
      throw ce;
    }
  };
  function se(K, Z, ne, ce, H) {
    if (!x(Z))
      throw new f("regexp", "RegExp", Z);
    var J = H === "match";
    if (typeof K != "string" || P(Z, K) !== J) {
      if (ne instanceof Error)
        throw ne;
      var le = !ne;
      ne = ne || (typeof K != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(t(K), " (").concat(p(K), ")") : (J ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(p(Z), `. Input:

`).concat(p(K), `
`));
      var me = new h({
        actual: K,
        expected: Z,
        message: ne,
        operator: H,
        stackStartFn: ce
      });
      throw me.generatedMessage = le, me;
    }
  }
  re.match = function K(Z, ne, ce) {
    se(Z, ne, ce, K, "match");
  }, re.doesNotMatch = function K(Z, ne, ce) {
    se(Z, ne, ce, K, "doesNotMatch");
  };
  function V() {
    for (var K = arguments.length, Z = new Array(K), ne = 0; ne < K; ne++)
      Z[ne] = arguments[ne];
    w.apply(void 0, [V, Z.length].concat(Z));
  }
  return re.strict = I(V, re, {
    equal: re.strictEqual,
    deepEqual: re.deepStrictEqual,
    notEqual: re.notStrictEqual,
    notDeepEqual: re.notDeepStrictEqual
  }), re.strict.strict = re.strict, xg.exports;
}
const vJ = $d();
let pi = class {
  constructor(e, r) {
    if (!Number.isInteger(e))
      throw new TypeError("span must be an integer");
    this.span = e, this.property = r;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */
  decode(e, r) {
    throw new Error("Layout is abstract");
  }
  /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */
  encode(e, r, n) {
    throw new Error("Layout is abstract");
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(e, r) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(e) {
    const r = Object.create(this.constructor.prototype);
    return Object.assign(r, this), r.property = e, r;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(e) {
  }
};
function wJ(t, e) {
  return e.property ? t + "[" + e.property + "]" : t;
}
let is = class extends pi {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
}, dT = class extends is {
  constructor(e, r, n) {
    if (!(e instanceof pi))
      throw new TypeError("layout must be a Layout");
    if (r === void 0)
      r = 0;
    else if (!Number.isInteger(r))
      throw new TypeError("offset must be integer or undefined");
    super(e.span, n || e.property), this.layout = e, this.offset = r;
  }
  /** @override */
  isCount() {
    return this.layout instanceof Py || this.layout instanceof lT;
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), this.layout.decode(e, r + this.offset);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), this.layout.encode(e, r, n + this.offset);
  }
}, Py = class extends pi {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readUIntLE(r, this.span);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeUIntLE(e, n, this.span), this.span;
  }
}, lT = class extends pi {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readUIntBE(r, this.span);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeUIntBE(e, n, this.span), this.span;
  }
};
const Lv = Math.pow(2, 32);
function hT(t) {
  const e = Math.floor(t / Lv), r = t - e * Lv;
  return { hi32: e, lo32: r };
}
function pT(t, e) {
  return t * Lv + e;
}
let _J = class extends pi {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = e.readUInt32LE(r), i = e.readUInt32LE(r + 4);
    return pT(i, n);
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = hT(e);
    return r.writeUInt32LE(i.lo32, n), r.writeUInt32LE(i.hi32, n + 4), 8;
  }
}, SJ = class extends pi {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = e.readUInt32LE(r), i = e.readInt32LE(r + 4);
    return pT(i, n);
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = hT(e);
    return r.writeUInt32LE(i.lo32, n), r.writeInt32LE(i.hi32, n + 4), 8;
  }
}, EJ = class extends pi {
  constructor(e, r, n) {
    if (!(e instanceof pi))
      throw new TypeError("elementLayout must be a Layout");
    if (!(r instanceof is && r.isCount() || Number.isInteger(r) && 0 <= r))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let i = -1;
    !(r instanceof is) && 0 < e.span && (i = r * e.span), super(i, n), this.elementLayout = e, this.count = r;
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    let n = 0, i = this.count;
    if (i instanceof is && (i = i.decode(e, r)), 0 < this.elementLayout.span)
      n = i * this.elementLayout.span;
    else {
      let s = 0;
      for (; s < i; )
        n += this.elementLayout.getSpan(e, r + n), ++s;
    }
    return n;
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = [];
    let i = 0, s = this.count;
    for (s instanceof is && (s = s.decode(e, r)); i < s; )
      n.push(this.elementLayout.decode(e, r)), r += this.elementLayout.getSpan(e, r), i += 1;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = this.elementLayout, s = e.reduce((a, o) => a + i.encode(o, r, n + a), 0);
    return this.count instanceof is && this.count.encode(e.length, r, n), s;
  }
}, xJ = class extends pi {
  constructor(e, r, n) {
    if (!(Array.isArray(e) && e.reduce((s, a) => s && a instanceof pi, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof r == "boolean" && n === void 0 && (n = r, r = void 0);
    for (const s of e)
      if (0 > s.span && s.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let i = -1;
    try {
      i = e.reduce((s, a) => s + a.getSpan(), 0);
    } catch {
    }
    super(i, r), this.fields = e, this.decodePrefixes = !!n;
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    let n = 0;
    try {
      n = this.fields.reduce((i, s) => {
        const a = s.getSpan(e, r);
        return r += a, i + a;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return n;
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = this.makeDestinationObject();
    for (const i of this.fields)
      if (i.property !== void 0 && (n[i.property] = i.decode(e, r)), r += i.getSpan(e, r), this.decodePrefixes && e.length === r)
        break;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = n;
    let s = 0, a = 0;
    for (const o of this.fields) {
      let c = o.span;
      if (a = 0 < c ? c : 0, o.property === void 0)
        vJ(0 < c);
      else {
        const f = e[o.property];
        f !== void 0 && (a = o.encode(f, r, n), 0 > c && (c = o.getSpan(r, n)));
      }
      s = n, n += c;
    }
    return s + a - i;
  }
  /** @override */
  fromArray(e) {
    const r = this.makeDestinationObject();
    for (const n of this.fields)
      n.property !== void 0 && 0 < e.length && (r[n.property] = e.shift());
    return r;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const r of this.fields)
      if (r.property === e)
        return r;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    let r = 0;
    for (const n of this.fields) {
      if (n.property === e)
        return r;
      0 > n.span ? r = -1 : 0 <= r && (r += n.span);
    }
  }
}, yT = class {
  constructor(e) {
    this.property = e;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode() {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode() {
    throw new Error("UnionDiscriminator is abstract");
  }
}, B8 = class extends yT {
  constructor(e, r) {
    if (!(e instanceof is && e.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(r || e.property || "variant"), this.layout = e;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(e, r) {
    return this.layout.decode(e, r);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(e, r, n) {
    return this.layout.encode(e, r, n);
  }
}, bT = class extends pi {
  constructor(e, r, n) {
    const i = e instanceof Py || e instanceof lT;
    if (i)
      e = new B8(new dT(e));
    else if (e instanceof is && e.isCount())
      e = new B8(e);
    else if (!(e instanceof yT))
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (r === void 0 && (r = null), !(r === null || r instanceof pi))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (r !== null) {
      if (0 > r.span)
        throw new Error("defaultLayout must have constant span");
      r.property === void 0 && (r = r.replicate("content"));
    }
    let s = -1;
    r && (s = r.span, 0 <= s && i && (s += e.layout.span)), super(s, n), this.discriminator = e, this.usesPrefixDiscriminator = i, this.defaultLayout = r, this.registry = {};
    let a = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(o) {
      return a(o);
    }, this.configGetSourceVariant = function(o) {
      a = o.bind(this);
    };
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    const n = this.getVariant(e, r);
    if (!n)
      throw new Error("unable to determine span for unrecognized variant");
    return n.getSpan(e, r);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(e) {
    if (e.hasOwnProperty(this.discriminator.property)) {
      if (this.defaultLayout && e.hasOwnProperty(this.defaultLayout.property))
        return;
      const r = this.registry[e[this.discriminator.property]];
      if (r && (!r.layout || e.hasOwnProperty(r.property)))
        return r;
    } else
      for (const r in this.registry) {
        const n = this.registry[r];
        if (e.hasOwnProperty(n.property))
          return n;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(e, r) {
    r === void 0 && (r = 0);
    let n;
    const i = this.discriminator, s = i.decode(e, r);
    let a = this.registry[s];
    if (a === void 0) {
      let o = 0;
      a = this.defaultLayout, this.usesPrefixDiscriminator && (o = i.layout.span), n = this.makeDestinationObject(), n[i.property] = s, n[a.property] = this.defaultLayout.decode(e, r + o);
    } else
      n = a.decode(e, r);
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = this.getSourceVariant(e);
    if (i === void 0) {
      const s = this.discriminator, a = this.defaultLayout;
      let o = 0;
      return this.usesPrefixDiscriminator && (o = s.layout.span), s.encode(e[s.property], r, n), o + a.encode(
        e[a.property],
        r,
        n + o
      );
    }
    return i.encode(e, r, n);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(e, r, n) {
    const i = new AJ(this, e, r, n);
    return this.registry[e] = i, i;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(e, r) {
    let n = e;
    return e instanceof ve && (r === void 0 && (r = 0), n = this.discriminator.decode(e, r)), this.registry[n];
  }
}, AJ = class extends pi {
  constructor(e, r, n, i) {
    if (!(e instanceof bT))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(r) || 0 > r)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof n == "string" && i === void 0 && (i = n, n = null), n) {
      if (!(n instanceof pi))
        throw new TypeError("layout must be a Layout");
      if (e.defaultLayout !== null && 0 <= n.span && n.span > e.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof i != "string")
        throw new TypeError("variant must have a String property");
    }
    let s = e.span;
    0 > e.span && (s = n ? n.span : 0, 0 <= s && e.usesPrefixDiscriminator && (s += e.discriminator.layout.span)), super(s, i), this.union = e, this.variant = r, this.layout = n || null;
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    let n = 0;
    return this.union.usesPrefixDiscriminator && (n = this.union.discriminator.layout.span), n + this.layout.getSpan(e, r + n);
  }
  /** @override */
  decode(e, r) {
    const n = this.makeDestinationObject();
    if (r === void 0 && (r = 0), this !== this.union.getVariant(e, r))
      throw new Error("variant mismatch");
    let i = 0;
    return this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout ? n[this.property] = this.layout.decode(e, r + i) : this.property ? n[this.property] = !0 : this.union.usesPrefixDiscriminator && (n[this.union.discriminator.property] = this.variant), n;
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    let i = 0;
    if (this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout && !e.hasOwnProperty(this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, r, n);
    let s = i;
    if (this.layout && (this.layout.encode(e[this.property], r, n + i), s += this.layout.getSpan(r, n + i), 0 <= this.union.span && s > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return s;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(e) {
    if (this.layout)
      return this.layout.fromArray(e);
  }
}, IJ = class extends pi {
  constructor(e, r) {
    if (!(e instanceof is && e.isCount() || Number.isInteger(e) && 0 <= e))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let n = -1;
    e instanceof is || (n = e), super(n, r), this.length = e;
  }
  /** @override */
  getSpan(e, r) {
    let n = this.span;
    return 0 > n && (n = this.length.decode(e, r)), n;
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    let n = this.span;
    return 0 > n && (n = this.length.decode(e, r)), e.slice(r, r + n);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, r, n) {
    let i = this.length;
    if (this.length instanceof is && (i = e.length), !(e instanceof ve && i === e.length))
      throw new TypeError(wJ("Blob.encode", this) + " requires (length " + i + ") Buffer as src");
    if (n + i > r.length)
      throw new RangeError("encoding overruns Buffer");
    return r.write(e.toString("hex"), n, i, "hex"), this.length instanceof is && this.length.encode(i, r, n), i;
  }
};
var TJ = (t, e, r) => new dT(t, e, r), tn = (t) => new Py(1, t), dr = (t) => new Py(4, t), gT = (t) => new _J(t), Bi = (t) => new SJ(t), Nt = (t, e, r) => new xJ(t, e, r), Vg = (t, e, r) => new EJ(t, e, r), kJ = (t, e, r) => new bT(t, e, r), Ui = (t, e) => new IJ(t, e);
const yn = (t = "publicKey") => Ui(32, t), RJ = (t = "uint64") => Ui(8, t), ep = (t = "string") => {
  const e = Nt(
    [
      dr("length"),
      dr("lengthPadding"),
      Ui(TJ(dr(), -8), "chars")
    ],
    t
  ), r = e.decode.bind(e), n = e.encode.bind(e);
  return e.decode = (i, s) => r(i, s).chars.toString("utf8"), e.encode = (i, s, a) => {
    const o = {
      chars: ve.from(i, "utf8")
    };
    return n(o, s, a);
  }, e.alloc = (i) => dr().span + dr().span + ve.from(i, "utf8").length, e;
}, PJ = (t = "authorized") => Nt([yn("staker"), yn("withdrawer")], t), OJ = (t = "lockup") => Nt(
  [Bi("unixTimestamp"), Bi("epoch"), yn("custodian")],
  t
), M8 = (t) => {
  const e = Ui(8, t), r = e.decode.bind(e), n = e.encode.bind(e);
  return e.decode = (i, s = 0) => new Ss(r(i, s), 10, "le"), e.encode = (i, s, a = 0) => n(i.toArrayLike(ve, "le", 8), s, a), e;
};
function BJ(t, e) {
  let r = 0;
  return t.layout.fields.forEach((n) => {
    n.span >= 0 ? r += n.span : typeof n.alloc == "function" && (r += n.alloc(e[n.property]));
  }), r;
}
function _n(t, e) {
  const r = t.layout.span >= 0 ? t.layout.span : BJ(t, e), n = ve.alloc(r), i = Object.assign({ instruction: t.index }, e);
  return t.layout.encode(i, n), n;
}
const qd = 1232;
function ed(t) {
  let e = 0, r = 0;
  for (; ; ) {
    const n = t.shift();
    if (e |= (n & 127) << r * 7, r += 1, !(n & 128))
      break;
  }
  return e;
}
function td(t, e) {
  let r = e;
  for (; ; ) {
    let n = r & 127;
    if (r >>= 7, r === 0) {
      t.push(n);
      break;
    } else
      n |= 128, t.push(n);
  }
}
const mT = "Reached end of buffer unexpectedly";
function mh(t) {
  if (t.length === 0)
    throw new Error(mT);
  return t.shift();
}
function rd(t, ...e) {
  const [r] = e;
  if (e.length === 2 ? r + (e[1] ?? 0) > t.length : r >= t.length)
    throw new Error(mT);
  return t.splice(...e);
}
const C8 = 32, MJ = 127;
let N8 = class vT {
  constructor(e) {
    Zt(this, "header");
    Zt(this, "accountKeys");
    Zt(this, "recentBlockhash");
    Zt(this, "instructions");
    this.header = e.header, this.accountKeys = e.accountKeys.map((r) => new $r(r)), this.recentBlockhash = e.recentBlockhash, this.instructions = e.instructions;
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    return e < this.header.numRequiredSignatures - this.header.numReadonlySignedAccounts || e >= this.header.numRequiredSignatures && e < this.accountKeys.length - this.header.numReadonlyUnsignedAccounts;
  }
  findSignerIndex(e) {
    const r = this.accountKeys.findIndex((n) => n.equals(e));
    if (r < 0)
      throw new Error(`unknown signer: ${e.toString()}`);
    return r;
  }
  serialize() {
    const e = this.accountKeys.length, r = [];
    td(r, e);
    const n = this.instructions.map((d) => {
      const { accounts: l, programIdIndex: h } = d, y = Ot.decode(d.data), p = [];
      td(p, l.length);
      const b = [];
      return td(b, y.length), {
        programIdIndex: h,
        keyIndicesCount: ve.from(p),
        keyIndices: ve.from(l),
        dataLength: ve.from(b),
        data: y
      };
    }), i = [];
    td(i, n.length);
    let s = ve.alloc(qd);
    ve.from(i).copy(s);
    let a = i.length;
    n.forEach((d) => {
      const h = Nt([
        tn("programIdIndex"),
        Ui(d.keyIndicesCount.length, "keyIndicesCount"),
        Vg(tn("keyIndex"), d.keyIndices.length, "keyIndices"),
        Ui(d.dataLength.length, "dataLength"),
        Vg(tn("userdatum"), d.data.length, "data")
      ]).encode(
        d,
        s,
        a
      );
      a += h;
    }), s = s.slice(0, a);
    const o = Nt([
      Ui(1, "numRequiredSignatures"),
      Ui(1, "numReadonlySignedAccounts"),
      Ui(1, "numReadonlyUnsignedAccounts"),
      Ui(r.length, "keyCount"),
      Vg(yn("key"), e, "keys"),
      yn("recentBlockhash")
    ]), c = {
      numRequiredSignatures: ve.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: ve.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: ve.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: ve.from(r),
      keys: this.accountKeys.map((d) => d.toBuffer()),
      recentBlockhash: Ot.decode(this.recentBlockhash)
    }, f = ve.alloc(2048), u = o.encode(c, f);
    return s.copy(f, u), f.slice(0, u + s.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(e) {
    const r = [...e], n = mh(r);
    if (n !== (n & MJ))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const i = mh(r), s = mh(r), a = ed(r), o = [];
    for (let l = 0; l < a; l++) {
      const h = rd(r, 0, C8);
      o.push(ve.from(h));
    }
    const c = rd(r, 0, C8), f = ed(r), u = [];
    for (let l = 0; l < f; l++) {
      const h = mh(r), y = ed(r), p = rd(r, 0, y), b = ed(r), v = rd(r, 0, b), x = Ot.encode(ve.from(v));
      u.push({
        programIdIndex: h,
        accounts: p,
        data: x
      });
    }
    const d = {
      header: {
        numRequiredSignatures: n,
        numReadonlySignedAccounts: i,
        numReadonlyUnsignedAccounts: s
      },
      recentBlockhash: Ot.encode(ve.from(c)),
      accountKeys: o,
      instructions: u
    };
    return new vT(d);
  }
};
const CJ = gT("lamportsPerSignature"), NJ = Nt([
  dr("version"),
  dr("state"),
  yn("authorizedPubkey"),
  yn("nonce"),
  Nt([CJ], "feeCalculator")
]), U8 = NJ.span, Hg = new $r("SysvarC1ock11111111111111111111111111111111"), Gg = new $r(
  "SysvarRecentB1ockHashes11111111111111111111"
), ku = new $r("SysvarRent111111111111111111111111111111111");
new $r("SysvarRewards111111111111111111111111111111");
const L8 = new $r(
  "SysvarStakeHistory1111111111111111111111111"
);
var UJ = $d();
const Xi = /* @__PURE__ */ Ln(UJ), LJ = ve.alloc(64).fill(0), DJ = 64;
let Yr = class {
  constructor(e) {
    /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */
    Zt(this, "keys", []);
    /**
     * Program Id to execute
     */
    Zt(this, "programId");
    /**
     * Program input
     */
    Zt(this, "data", ve.alloc(0));
    e && Object.assign(this, e);
  }
}, lu = class Dv {
  /**
   * Construct an empty Transaction
   */
  constructor(e) {
    /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */
    Zt(this, "signatures", []);
    /**
     * The transaction fee payer
     */
    Zt(this, "feePayer");
    /**
     * The instructions to atomically execute
     */
    Zt(this, "instructions", []);
    /**
     * A recent transaction id.  Must be populated by the caller
     */
    Zt(this, "recentBlockhash");
    /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */
    Zt(this, "nonceInfo");
    e && Object.assign(this, e);
  }
  /**
   * The first (payer) Transaction signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer (first signer)
   */
  getFeePayer() {
    return this.signatures.length > 0 ? this.signatures[0].publicKey : null;
  }
  /**
   * Add one or more instructions to this Transaction
   */
  add(...e) {
    if (e.length === 0)
      throw new Error("No instructions");
    return e.forEach((r) => {
      "instructions" in r ? this.instructions = [...this.instructions, ...r.instructions] : "data" in r && "programId" in r && "keys" in r ? this.instructions.push(r) : this.instructions.push(new Yr(r));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    const { nonceInfo: e } = this;
    e && this.instructions[0] !== e.nonceInstruction && (this.recentBlockhash = e.nonce, this.instructions.unshift(e.nonceInstruction));
    const { recentBlockhash: r } = this;
    if (!r)
      throw new Error("Transaction recentBlockhash required");
    if (this.instructions.length === 0)
      throw new Error("No instructions provided");
    let n;
    if (this.feePayer)
      n = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      n = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    const i = [], s = [];
    this.instructions.forEach((p) => {
      p.keys.forEach((v) => {
        s.push({ ...v });
      });
      const b = p.programId.toString();
      i.includes(b) || i.push(b);
    }), i.forEach((p) => {
      s.push({
        pubkey: new $r(p),
        isSigner: !1,
        isWritable: !1
      });
    }), s.sort(function(p, b) {
      if (p.isSigner !== b.isSigner)
        return p.isSigner ? -1 : 1;
      if (p.isWritable !== b.isWritable)
        return p.isWritable ? -1 : 1;
      const v = p.pubkey.toBase58().toLowerCase(), x = b.pubkey.toBase58().toLowerCase();
      return v < x ? -1 : v > x ? 1 : 0;
    });
    const a = [];
    s.forEach((p) => {
      const b = p.pubkey.toString(), v = a.findIndex((x) => x.pubkey.toString() === b);
      v > -1 ? a[v].isWritable = a[v].isWritable || p.isWritable : a.push(p);
    });
    const o = a.findIndex((p) => p.pubkey.equals(n));
    if (o > -1) {
      const [p] = a.splice(o, 1);
      p.isSigner = !0, p.isWritable = !0, a.unshift(p);
    } else
      a.unshift({
        pubkey: n,
        isSigner: !0,
        isWritable: !0
      });
    this.signatures.forEach((p, b) => {
      const v = b === 0, x = a.findIndex((I) => I.pubkey.equals(p.publicKey));
      if (x > -1)
        if (v) {
          const [I] = a.splice(x, 1);
          I.isSigner = !0, I.isWritable = !0, a.unshift(I);
        } else
          a[x].isSigner = !0;
      else if (v)
        a.unshift({
          pubkey: p.publicKey,
          isSigner: !0,
          isWritable: !0
        });
      else
        throw new Error(`unknown signer: ${p.publicKey.toString()}`);
    });
    let c = 0, f = 0, u = 0;
    const d = [], l = [];
    a.forEach(({ pubkey: p, isSigner: b, isWritable: v }) => {
      b ? (d.push(p.toString()), c += 1, v || (f += 1)) : (l.push(p.toString()), v || (u += 1));
    });
    const h = [...d, ...l], y = this.instructions.map((p) => {
      const { data: b, programId: v } = p;
      return {
        programIdIndex: h.indexOf(v.toString()),
        accounts: p.keys.map((x) => h.indexOf(x.pubkey.toString())),
        data: Ot.encode(b)
      };
    });
    return y.forEach((p) => {
      Xi(p.programIdIndex >= 0), p.accounts.forEach((b) => Xi(b >= 0));
    }), new N8({
      header: {
        numRequiredSignatures: c,
        numReadonlySignedAccounts: f,
        numReadonlyUnsignedAccounts: u
      },
      accountKeys: h,
      recentBlockhash: r,
      instructions: y
    });
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this.compileMessage().serialize();
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   */
  setSigners(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set();
    this.signatures = e.filter((n) => {
      const i = n.toString();
      return r.has(i) ? !1 : (r.add(i), !0);
    }).map((n) => ({ signature: null, publicKey: n }));
  }
  /**
   * Sign the Transaction with the specified accounts. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used when testing for Transaction confirmation. The first signer
   * will be used as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   */
  sign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set();
    return this.signatures = e.filter((n) => {
      const i = n.publicKey.toString();
      return r.has(i) ? !1 : (r.add(i), !0);
    }).map((n) => ({
      signature: null,
      publicKey: n.publicKey
    })), this.partialSign(...e);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to a public key that was previously provided to `setSigners`.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   */
  partialSign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = this.compileMessage();
    this.signatures.sort(function(i, s) {
      const a = r.findSignerIndex(i.publicKey), o = r.findSignerIndex(s.publicKey);
      return a < o ? -1 : 1;
    });
    const n = r.serialize();
    e.forEach((i) => {
      const s = Wu.sign.detached(n, i.secretKey);
      this.addSignature(i.publicKey, s);
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to a public key that was previously provided to `setSigners`.
   */
  addSignature(e, r) {
    Xi(r.length === 64);
    const n = this.signatures.findIndex((i) => e.equals(i.publicKey));
    if (n < 0)
      throw new Error(`unknown signer: ${e.toString()}`);
    this.signatures[n].signature = ve.from(r);
  }
  /**
   * Verify signatures of a complete, signed Transaction
   */
  verifySignatures() {
    return this._verifySignatures(this.serializeMessage(), !0);
  }
  /**
   * @private
   */
  _verifySignatures(e, r) {
    for (const { signature: n, publicKey: i } of this.signatures)
      if (n === null) {
        if (r)
          return !1;
      } else if (!Wu.sign.detached.verify(e, n, i.toBuffer()))
        return !1;
    return !0;
  }
  /**
   * Serialize the Transaction in the wire format.
   */
  serialize(e) {
    const { requireAllSignatures: r, verifySignatures: n } = Object.assign(
      { requireAllSignatures: !0, verifySignatures: !0 },
      e
    ), i = this.serializeMessage();
    if (n && !this._verifySignatures(i, r))
      throw new Error("Signature verification failed");
    return this._serialize(i);
  }
  /**
   * @private
   */
  _serialize(e) {
    const { signatures: r } = this, n = [];
    td(n, r.length);
    const i = n.length + r.length * 64 + e.length, s = ve.alloc(i);
    return Xi(r.length < 256), ve.from(n).copy(s, 0), r.forEach(({ signature: a }, o) => {
      a !== null && (Xi(a.length === 64, "signature has invalid length"), ve.from(a).copy(s, n.length + o * 64));
    }), e.copy(s, n.length + r.length * 64), Xi(
      s.length <= qd,
      `Transaction too large: ${s.length} > ${qd}`
    ), s;
  }
  /**
   * Deprecated method
   * @private
   */
  get keys() {
    return Xi(this.instructions.length === 1), this.instructions[0].keys.map((e) => e.pubkey);
  }
  /**
   * Deprecated method
   * @private
   */
  get programId() {
    return Xi(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @private
   */
  get data() {
    return Xi(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   */
  static from(e) {
    const r = [...e], n = ed(r), i = [];
    for (let s = 0; s < n; s++) {
      const a = rd(r, 0, DJ);
      i.push(Ot.encode(ve.from(a)));
    }
    return Dv.populate(N8.from(r), i);
  }
  /**
   * Populate Transaction object from message and signatures
   */
  static populate(e, r) {
    const n = new Dv();
    return n.recentBlockhash = e.recentBlockhash, r.forEach((i, s) => {
      const a = {
        signature: i === Ot.encode(LJ) ? null : Ot.decode(i),
        publicKey: e.accountKeys[s]
      };
      n.signatures.push(a);
    }), e.instructions.forEach((i) => {
      const s = i.accounts.map((a) => {
        const o = e.accountKeys[a];
        return {
          pubkey: o,
          isSigner: n.signatures.some(
            (c) => c.publicKey.toString() === o.toString()
          ),
          isWritable: e.isAccountWritable(a)
        };
      });
      n.instructions.push(
        new Yr({
          keys: s,
          programId: e.accountKeys[i.programIdIndex],
          data: Ot.decode(i.data)
        })
      );
    }), n;
  }
};
const fs = Object.freeze({
  Create: {
    index: 0,
    layout: Nt([
      dr("instruction"),
      Bi("lamports"),
      Bi("space"),
      yn("programId")
    ])
  },
  Assign: {
    index: 1,
    layout: Nt([dr("instruction"), yn("programId")])
  },
  Transfer: {
    index: 2,
    layout: Nt([dr("instruction"), Bi("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: Nt([
      dr("instruction"),
      yn("base"),
      ep("seed"),
      Bi("lamports"),
      Bi("space"),
      yn("programId")
    ])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: Nt([dr("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: Nt([dr("instruction"), Bi("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: Nt([dr("instruction"), yn("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: Nt([dr("instruction"), yn("authorized")])
  },
  Allocate: {
    index: 8,
    layout: Nt([dr("instruction"), Bi("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: Nt([
      dr("instruction"),
      yn("base"),
      ep("seed"),
      Bi("space"),
      yn("programId")
    ])
  },
  AssignWithSeed: {
    index: 10,
    layout: Nt([
      dr("instruction"),
      yn("base"),
      ep("seed"),
      yn("programId")
    ])
  }
}), Xu = {
  /**
   * Public key that identifies the System program
   */
  get programId() {
    return new $r("11111111111111111111111111111111");
  },
  /**
   * Generate a transaction instruction that creates a new account
   */
  createAccount(t) {
    const e = fs.Create, r = _n(e, {
      lamports: t.lamports,
      space: t.space,
      programId: t.programId.toBuffer()
    });
    return new Yr({
      keys: [
        { pubkey: t.fromPubkey, isSigner: !0, isWritable: !0 },
        { pubkey: t.newAccountPubkey, isSigner: !0, isWritable: !0 }
      ],
      programId: this.programId,
      data: r
    });
  },
  /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */
  transfer(t) {
    const e = fs.Transfer, r = _n(e, { lamports: t.lamports });
    return new Yr({
      keys: [
        { pubkey: t.fromPubkey, isSigner: !0, isWritable: !0 },
        { pubkey: t.toPubkey, isSigner: !1, isWritable: !0 }
      ],
      programId: this.programId,
      data: r
    });
  },
  /**
   * Generate a transaction instruction that assigns an account to a program
   */
  assign(t) {
    let e;
    if (t.basePubkey) {
      const r = fs.AssignWithSeed;
      e = _n(r, {
        base: t.basePubkey.toBuffer(),
        seed: t.seed,
        programId: t.programId.toBuffer()
      });
    } else {
      const r = fs.Assign;
      e = _n(r, { programId: t.programId.toBuffer() });
    }
    return new Yr({
      keys: [{ pubkey: t.accountPubkey, isSigner: !0, isWritable: !0 }],
      programId: this.programId,
      data: e
    });
  },
  /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */
  createAccountWithSeed(t) {
    const e = fs.CreateWithSeed, r = _n(e, {
      base: t.basePubkey.toBuffer(),
      seed: t.seed,
      lamports: t.lamports,
      space: t.space,
      programId: t.programId.toBuffer()
    });
    return new Yr({
      keys: [
        { pubkey: t.fromPubkey, isSigner: !0, isWritable: !0 },
        { pubkey: t.newAccountPubkey, isSigner: !1, isWritable: !0 }
      ],
      programId: this.programId,
      data: r
    });
  },
  /**
   * Generate a transaction that creates a new Nonce account
   */
  createNonceAccount(t) {
    const e = new lu();
    t.basePubkey && t.seed ? e.add(
      Xu.createAccountWithSeed({
        fromPubkey: t.fromPubkey,
        newAccountPubkey: t.noncePubkey,
        basePubkey: t.basePubkey,
        seed: t.seed,
        lamports: t.lamports,
        space: U8,
        programId: this.programId
      })
    ) : e.add(
      Xu.createAccount({
        fromPubkey: t.fromPubkey,
        newAccountPubkey: t.noncePubkey,
        lamports: t.lamports,
        space: U8,
        programId: this.programId
      })
    );
    const r = {
      noncePubkey: t.noncePubkey,
      authorizedPubkey: t.authorizedPubkey
    };
    return e.add(this.nonceInitialize(r)), e;
  },
  /**
   * Generate an instruction to initialize a Nonce account
   */
  nonceInitialize(t) {
    const e = fs.InitializeNonceAccount, r = _n(e, {
      authorized: t.authorizedPubkey.toBuffer()
    }), n = {
      keys: [
        { pubkey: t.noncePubkey, isSigner: !1, isWritable: !0 },
        {
          pubkey: Gg,
          isSigner: !1,
          isWritable: !1
        },
        { pubkey: ku, isSigner: !1, isWritable: !1 }
      ],
      programId: this.programId,
      data: r
    };
    return new Yr(n);
  },
  /**
   * Generate an instruction to advance the nonce in a Nonce account
   */
  nonceAdvance(t) {
    const e = fs.AdvanceNonceAccount, r = _n(e), n = {
      keys: [
        { pubkey: t.noncePubkey, isSigner: !1, isWritable: !0 },
        {
          pubkey: Gg,
          isSigner: !1,
          isWritable: !1
        },
        { pubkey: t.authorizedPubkey, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: r
    };
    return new Yr(n);
  },
  /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */
  nonceWithdraw(t) {
    const e = fs.WithdrawNonceAccount, r = _n(e, { lamports: t.lamports });
    return new Yr({
      keys: [
        { pubkey: t.noncePubkey, isSigner: !1, isWritable: !0 },
        { pubkey: t.toPubkey, isSigner: !1, isWritable: !0 },
        {
          pubkey: Gg,
          isSigner: !1,
          isWritable: !1
        },
        {
          pubkey: ku,
          isSigner: !1,
          isWritable: !1
        },
        { pubkey: t.authorizedPubkey, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: r
    });
  },
  /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */
  nonceAuthorize(t) {
    const e = fs.AuthorizeNonceAccount, r = _n(e, {
      authorized: t.newAuthorizedPubkey.toBuffer()
    });
    return new Yr({
      keys: [
        { pubkey: t.noncePubkey, isSigner: !1, isWritable: !0 },
        { pubkey: t.authorizedPubkey, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: r
    });
  },
  /**
   * Generate a transaction instruction that allocates space in an account without funding
   */
  allocate(t) {
    let e;
    if (t.basePubkey) {
      const r = fs.AllocateWithSeed;
      e = _n(r, {
        base: t.basePubkey.toBuffer(),
        seed: t.seed,
        space: t.space,
        programId: t.programId.toBuffer()
      });
    } else {
      const r = fs.Allocate;
      e = _n(r, {
        space: t.space
      });
    }
    return new Yr({
      keys: [{ pubkey: t.accountPubkey, isSigner: !0, isWritable: !0 }],
      programId: this.programId,
      data: e
    });
  }
}, vh = Object.freeze({
  RequestUnits: {
    index: 0,
    layout: Nt([
      tn("instruction"),
      dr("units"),
      dr("additionalFee")
    ])
  },
  RequestHeapFrame: {
    index: 1,
    layout: Nt([tn("instruction"), dr("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: Nt([tn("instruction"), dr("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: Nt([
      tn("instruction"),
      Bi("microLamports")
    ])
  }
});
var Vm;
let Zoe = (Vm = class {
  /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */
  static requestUnits(e) {
    const r = vh.RequestUnits, n = _n(r, e);
    return new Yr({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
  static requestHeapFrame(e) {
    const r = vh.RequestHeapFrame, n = _n(r, e);
    return new Yr({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
  static setComputeUnitLimit(e) {
    const r = vh.SetComputeUnitLimit, n = _n(r, e);
    return new Yr({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
  static setComputeUnitPrice(e) {
    const r = vh.SetComputeUnitPrice, n = _n(r, {
      microLamports: Number(e.microLamports)
      // replaced from BigInt
    });
    return new Yr({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
}, /**
 * Public key that identifies the Compute Budget program
 */
Zt(Vm, "programId", new $r("ComputeBudget111111111111111111111111111111")), Vm);
const FJ = new $r("StakeConfig11111111111111111111111111111111"), wh = Object.freeze({
  Initialize: {
    index: 0,
    layout: Nt([
      dr("instruction"),
      PJ(),
      OJ()
    ])
  },
  Authorize: {
    index: 1,
    layout: Nt([
      dr("instruction"),
      yn("newAuthorized"),
      dr("stakeAuthorizationType")
    ])
  },
  Delegate: {
    index: 2,
    layout: Nt([dr("instruction")])
  },
  Split: {
    index: 3,
    layout: Nt([dr("instruction"), Bi("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: Nt([dr("instruction"), Bi("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: Nt([dr("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: Nt([
      dr("instruction"),
      yn("newAuthorized"),
      dr("stakeAuthorizationType"),
      ep("authoritySeed"),
      yn("authorityOwner")
    ])
  }
}), jJ = {
  /**
   * Public key that identifies the Stake program
   */
  get programId() {
    return new $r("Stake11111111111111111111111111111111111111");
  },
  /**
   * Max space of a Stake account
   *
   * This is generated from the solana-stake-program StakeState struct as
   * `std::mem::size_of::<StakeState>()`:
   * https://docs.rs/solana-stake-program/1.4.4/solana_stake_program/stake_state/enum.StakeState.html
   */
  get space() {
    return 200;
  },
  /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */
  initialize(t) {
    const { stakePubkey: e, authorized: r, lockup: n } = t, i = wh.Initialize, s = _n(i, {
      authorized: {
        staker: r.staker.toBuffer(),
        withdrawer: r.withdrawer.toBuffer()
      },
      lockup: {
        unixTimestamp: n.unixTimestamp,
        epoch: n.epoch,
        custodian: n.custodian.toBuffer()
      }
    }), a = {
      keys: [
        { pubkey: e, isSigner: !1, isWritable: !0 },
        { pubkey: ku, isSigner: !1, isWritable: !1 }
      ],
      programId: this.programId,
      data: s
    };
    return new Yr(a);
  },
  /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */
  createAccountWithSeed(t) {
    const e = new lu();
    e.add(
      Xu.createAccountWithSeed({
        fromPubkey: t.fromPubkey,
        newAccountPubkey: t.stakePubkey,
        basePubkey: t.basePubkey,
        seed: t.seed,
        lamports: t.lamports,
        space: this.space,
        programId: this.programId
      })
    );
    const { stakePubkey: r, authorized: n, lockup: i } = t;
    return e.add(this.initialize({ stakePubkey: r, authorized: n, lockup: i }));
  },
  /**
   * Generate a Transaction that creates a new Stake account
   */
  createAccount(t) {
    const e = new lu();
    e.add(
      Xu.createAccount({
        fromPubkey: t.fromPubkey,
        newAccountPubkey: t.stakePubkey,
        lamports: t.lamports,
        space: this.space,
        programId: this.programId
      })
    );
    const { stakePubkey: r, authorized: n, lockup: i } = t;
    return e.add(this.initialize({ stakePubkey: r, authorized: n, lockup: i }));
  },
  /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */
  delegate(t) {
    const { stakePubkey: e, authorizedPubkey: r, votePubkey: n } = t, i = wh.Delegate, s = _n(i);
    return new lu().add({
      keys: [
        { pubkey: e, isSigner: !1, isWritable: !0 },
        { pubkey: n, isSigner: !1, isWritable: !1 },
        { pubkey: Hg, isSigner: !1, isWritable: !1 },
        {
          pubkey: L8,
          isSigner: !1,
          isWritable: !1
        },
        { pubkey: FJ, isSigner: !1, isWritable: !1 },
        { pubkey: r, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: s
    });
  },
  /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */
  withdraw(t) {
    const { stakePubkey: e, authorizedPubkey: r, toPubkey: n, lamports: i } = t, s = wh.Withdraw, a = _n(s, { lamports: i });
    return new lu().add({
      keys: [
        { pubkey: e, isSigner: !1, isWritable: !0 },
        { pubkey: n, isSigner: !1, isWritable: !0 },
        { pubkey: Hg, isSigner: !1, isWritable: !1 },
        {
          pubkey: L8,
          isSigner: !1,
          isWritable: !1
        },
        { pubkey: r, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: a
    });
  },
  /**
   * Generate a Transaction that deactivates Stake tokens.
   */
  deactivate(t) {
    const { stakePubkey: e, authorizedPubkey: r } = t, n = wh.Deactivate, i = _n(n);
    return new lu().add({
      keys: [
        { pubkey: e, isSigner: !1, isWritable: !0 },
        { pubkey: Hg, isSigner: !1, isWritable: !1 },
        { pubkey: r, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: i
    });
  }
};
new $r(
  "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
);
const $J = Xu.programId, qJ = jJ.programId, Zg = new $r("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), _h = new $r("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
new $r("MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr");
new $r(
  "MEisE1HzehtrDpAAT8PnLHjpSSkRYakotTuJRPjTpo8"
);
const D8 = new $r(
  "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
);
new $r(
  "Sysvar1nstructions1111111111111111111111111"
);
const WJ = 1e9, zJ = Math.log10(WJ);
E5.prototype.readPubkeyAsString = function() {
  const t = this.readFixedArray(32);
  return Ot.encode(t);
};
S5.prototype.writePubkeyAsString = function(t) {
  this.writeFixedArray(Ot.decode(t));
};
class F8 {
  constructor(e) {
    this.name = e.name, this.symbol = e.symbol, this.uri = e.uri, this.sellerFeeBasisPoints = e.sellerFeeBasisPoints, this.creators = e.creators;
  }
}
class j8 {
  constructor(e) {
    this.address = e.address, this.verified = e.verified, this.share = e.share;
  }
}
class wT {
  constructor(e) {
    this.key = "", this.updateAuthority = e.updateAuthority, this.mint = e.mint, this.data = e.data, this.primarySaleHappened = e.primarySaleHappened, this.isMutable = e.isMutable, this.editionNonce = e.editionNonce || null;
  }
}
const KJ = /* @__PURE__ */ new Map([
  [
    F8,
    {
      kind: "struct",
      fields: [
        ["name", "string"],
        ["symbol", "string"],
        ["uri", "string"],
        ["sellerFeeBasisPoints", "u16"],
        ["creators", { kind: "option", type: [j8] }]
      ]
    }
  ],
  [
    j8,
    {
      kind: "struct",
      fields: [
        ["address", "pubkeyAsString"],
        ["verified", "u8"],
        ["share", "u8"]
      ]
    }
  ],
  [
    wT,
    {
      kind: "struct",
      fields: [
        ["key", "u8"],
        ["updateAuthority", "pubkeyAsString"],
        ["mint", "pubkeyAsString"],
        ["data", F8],
        ["primarySaleHappened", "u8"],
        // bool
        ["isMutable", "u8"],
        // bool
        ["editionNonce", { kind: "option", type: "u8" }]
      ]
    }
  ]
]);
function VJ(t) {
  return $r.findProgramAddress(
    [
      ve.from("metadata"),
      D8.toBuffer(),
      new $r(t).toBuffer()
    ],
    D8
  )[0].toBase58();
}
function HJ(t) {
  const e = F0(KJ, wT, t), r = new RegExp("\0", "g");
  return e.data.name = e.data.name.replace(r, ""), e.data.uri = e.data.uri.replace(r, ""), e.data.symbol = e.data.symbol.replace(r, ""), e.data;
}
new $r(
  "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
);
new $r("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
class po extends Ss {
  /**
   * Convert to Buffer representation
   */
  toBuffer() {
    const e = super.toArray().reverse(), r = ve.from(e);
    if (r.length === 8)
      return r;
    Xi(r.length < 8, "u64 too large");
    const n = ve.alloc(8);
    return r.copy(n), n;
  }
  /**
   * Construct a u64 from Buffer representation
   */
  static fromBuffer(e) {
    return Xi(e.length === 8, `Invalid buffer length: ${e.length}`), new po(
      [...e].reverse().map((r) => `00${r.toString(16)}`.slice(-2)).join(""),
      16
    );
  }
}
const iu = (t = "publicKey") => Ui(32, t), Kf = (t = "uint64") => Ui(8, t), $8 = (t) => ve.from(t.toBuffer()), GJ = {
  /**
   * Construct an Approve instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param delegate Account authorized to perform a transfer of tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   */
  createApproveInstruction(t, e, r, n, i, s) {
    const a = Nt([tn("instruction"), Kf("amount")]), o = ve.alloc(a.span);
    a.encode(
      {
        instruction: 4,
        // Approve instruction
        amount: new po(s).toBuffer()
      },
      o
    );
    const c = [
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: r,
        isSigner: !1,
        isWritable: !1
      }
    ];
    return i.length === 0 ? c.push({
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }) : (c.push({
      pubkey: n,
      isSigner: !1,
      isWritable: !1
    }), i.forEach(
      (f) => c.push({
        pubkey: f.publicKey,
        isSigner: !0,
        isWritable: !1
      })
    )), new Yr({
      keys: c,
      programId: t,
      data: o
    });
  },
  /**
   * Construct the AssociatedTokenProgram instruction to create the associated
   * token account
   *
   * @param associatedProgramId SPL Associated Token program account
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param associatedAccount New associated account
   * @param owner Owner of the new account
   * @param payer Payer of fees
   */
  createAssociatedTokenAccountInstruction(t, e, r, n, i, s) {
    const a = ve.alloc(0), o = [
      {
        pubkey: s,
        isSigner: !0,
        isWritable: !0
      },
      {
        pubkey: n,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: i,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: r,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: Xu.programId,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: ku,
        isSigner: !1,
        isWritable: !1
      }
    ];
    return new Yr({
      keys: o,
      programId: t,
      data: a
    });
  },
  /**
   * Construct a Close instruction
   *
   * @param programId SPL Token program account
   * @param account Account to close
   * @param dest Account to receive the remaining balance of the closed account
   * @param authority Account Close authority
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */
  createCloseAccountInstruction(t, e, r, n, i) {
    const s = Nt([tn("instruction")]), a = ve.alloc(s.span);
    s.encode(
      {
        instruction: 9
        // CloseAccount instruction
      },
      a
    );
    const o = [
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      }
    ];
    return i.length === 0 ? o.push({
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }) : (o.push({
      pubkey: n,
      isSigner: !1,
      isWritable: !1
    }), i.forEach(
      (c) => o.push({
        pubkey: c.publicKey,
        isSigner: !0,
        isWritable: !1
      })
    )), new Yr({
      keys: o,
      programId: t,
      data: a
    });
  },
  /**
   * Construct an InitializeAccount instruction
   *
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param account New account
   * @param owner Owner of the new account
   */
  createInitAccountInstruction(t, e, r, n) {
    const i = Nt([tn("instruction")]), s = ve.alloc(i.span);
    i.encode(
      {
        instruction: 1
        // InitializeAccount instruction
      },
      s
    );
    const a = [
      {
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: n,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: ku,
        isSigner: !1,
        isWritable: !1
      }
    ];
    return new Yr({
      keys: a,
      programId: t,
      data: s
    });
  },
  /**
   * Construct an InitializeMint instruction
   *
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param decimals Number of decimals in token account amounts
   * @param mintAuthority Minting authority
   * @param freezeAuthority Optional authority that can freeze token accounts
   */
  createInitMintInstruction(t, e, r, n, i) {
    const s = Nt([
      tn("instruction"),
      tn("decimals"),
      iu("mintAuthority"),
      tn("option"),
      iu("freezeAuthority")
    ]);
    let a = ve.alloc(1024);
    const o = s.encode(
      {
        instruction: 0,
        // InitializeMint instruction
        decimals: r,
        mintAuthority: $8(n),
        option: i === null ? 0 : 1,
        freezeAuthority: $8(i || new $r(0))
      },
      a
    );
    a = a.slice(0, o);
    const c = [
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: ku,
        isSigner: !1,
        isWritable: !1
      }
    ];
    return new Yr({
      keys: c,
      programId: t,
      data: a
    });
  },
  /**
   * Construct a MintTo instruction
   *
   * @param programId SPL Token program account
   * @param mint Public key of the mint
   * @param dest Public key of the account to mint to
   * @param authority The mint authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   */
  createMintToInstruction(t, e, r, n, i, s) {
    const a = Nt([tn("instruction"), Kf("amount")]), o = ve.alloc(a.span);
    a.encode(
      {
        instruction: 7,
        // MintTo instruction
        amount: new po(s).toBuffer()
      },
      o
    );
    const c = [
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      }
    ];
    return i.length === 0 ? c.push({
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }) : (c.push({
      pubkey: n,
      isSigner: !1,
      isWritable: !1
    }), i.forEach(
      (f) => c.push({
        pubkey: f.publicKey,
        isSigner: !0,
        isWritable: !1
      })
    )), new Yr({
      keys: c,
      programId: t,
      data: o
    });
  },
  /**
   * Construct a SyncNative instruction
   *
   * @param programId SPL Token program account
   * @param nativeAccount Account to sync lamports from
   */
  createSyncNativeInstruction(t, e) {
    const r = Nt([tn("instruction")]), n = ve.alloc(r.span);
    r.encode(
      {
        instruction: 17
        // SyncNative instruction
      },
      n
    );
    const i = [
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !0
      }
    ];
    return new Yr({
      keys: i,
      programId: t,
      data: n
    });
  },
  /**
   * Construct a Transfer instruction
   *
   * @param programId SPL Token program account
   * @param source Source account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Number of tokens to transfer
   */
  createTransferInstruction(t, e, r, n, i, s) {
    const a = Nt([
      tn("instruction"),
      RJ("amount")
    ]), o = ve.alloc(a.span);
    a.encode(
      {
        instruction: 3,
        // Transfer instruction
        amount: new po(s).toBuffer()
      },
      o
    );
    const c = [
      { pubkey: e, isSigner: !1, isWritable: !0 },
      { pubkey: r, isSigner: !1, isWritable: !0 }
    ];
    return i.length === 0 ? c.push({
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }) : (c.push({ pubkey: n, isSigner: !1, isWritable: !1 }), i.forEach(
      (f) => c.push({
        pubkey: f.publicKey,
        isSigner: !0,
        isWritable: !1
      })
    )), new Yr({
      keys: c,
      programId: t,
      data: o
    });
  },
  decode(t) {
    return Nt([
      iu("mint"),
      iu("owner"),
      Kf("amount"),
      dr("delegateOption"),
      iu("delegate"),
      tn("state"),
      dr("isNativeOption"),
      Kf("isNative"),
      Kf("delegatedAmount"),
      dr("closeAuthorityOption"),
      iu("closeAuthority")
    ]).decode(t);
  }
}, q8 = (t = "uint64") => Ui(8, t);
new $r("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
Nt([
  tn("instruction"),
  tn("transferFeeInstruction"),
  q8("amount"),
  tn("decimals"),
  q8("fee")
]);
Nt([M8("takerAmount"), tn("escrowBump")]), Nt([]), Nt([M8("expectedTakerAmount"), yn("expectedMint")]);
new $r("2NZukH2TXpcuZP4htiuT8CFxcaQSWzkkR6kepSWnZ24Q");
new $r("auth9SigNpDKz4sJJ1DfCTuZrZNSAgh9sFD3rboVmgg");
function W8(t, e) {
  return new po(t).sub(new po(e));
}
function ZJ(t) {
  let e = t.indexToProgramIds;
  const r = {
    encoding: "base64",
    commitment: "confirmed"
  }, n = /* @__PURE__ */ new Set();
  if (t.staticAccountKeys)
    t.staticAccountKeys.forEach(
      (i) => n.add(i.toString())
    );
  else if (t.accountKeys)
    e || (e = /* @__PURE__ */ new Map(), t.instructions.forEach(
      (i) => e.set(
        i.programIdIndex,
        t.accountKeys[i.programIdIndex]
      )
    )), t.accountKeys.filter((i, s) => !e.has(s)).forEach((i) => n.add(i.toString()));
  else {
    const i = new Set(
      t.instructions.map((s) => s.programId.toString())
    );
    t.instructions.forEach((s) => {
      s.keys.forEach((a) => {
        i.has(a.pubkey.toString()) || n.add(a.pubkey.toString());
      });
    });
  }
  return r.accounts = {
    encoding: "base64",
    addresses: [...n]
  }, {
    config: r,
    accountAddresses: [...n]
  };
}
const JJ = (t) => t === "11111111111111111111111111111111";
function YJ(t, e, r) {
  const n = [], i = [];
  if (t.length !== e.length)
    throw new Error("Simulation returning wrong account length");
  return t.forEach((s, a) => {
    try {
      const o = e[a];
      if (JJ(s.owner.toString())) {
        o.toString() === r.toString() && n.push({
          amount: s.lamports,
          address: r
        });
        return;
      }
      const c = ve.from(s.data[0], "base64"), f = GJ.decode(c), u = new $r(f.owner).toString(), d = po.fromBuffer(f.amount);
      u === r.toString() && i.push({
        amount: d,
        mint: new $r(f.mint).toString(),
        owner: u,
        address: o.toString()
      });
    } catch (o) {
      console.warn(o);
    }
  }), {
    solAccounts: n,
    tokenAccounts: i
  };
}
var QJ = {}, _T = {}, Qe = {};
class Lr {
  constructor(e, r) {
    if (!Number.isInteger(e))
      throw new TypeError("span must be an integer");
    this.span = e, this.property = r;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */
  decode(e, r) {
    throw new Error("Layout is abstract");
  }
  /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */
  encode(e, r, n) {
    throw new Error("Layout is abstract");
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(e, r) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(e) {
    const r = Object.create(this.constructor.prototype);
    return Object.assign(r, this), r.property = e, r;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(e) {
  }
}
Qe.Layout = Lr;
function n_(t, e) {
  return e.property ? t + "[" + e.property + "]" : t;
}
Qe.nameWithProperty = n_;
function XJ(t, e) {
  if (typeof t != "function")
    throw new TypeError("Class must be constructor");
  if (t.hasOwnProperty("layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(e && e instanceof Lr))
    throw new TypeError("layout must be a Layout");
  if (e.hasOwnProperty("boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  t.layout_ = e, e.boundConstructor_ = t, e.makeDestinationObject = () => new t(), Object.defineProperty(t.prototype, "encode", {
    value: function(r, n) {
      return e.encode(this, r, n);
    },
    writable: !0
  }), Object.defineProperty(t, "decode", {
    value: function(r, n) {
      return e.decode(r, n);
    },
    writable: !0
  });
}
Qe.bindConstructorLayout = XJ;
class xi extends Lr {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
}
class ST extends xi {
  constructor(e, r) {
    if (e === void 0 && (e = 1), !Number.isInteger(e) || 0 >= e)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, r), this.elementSpan = e;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = e.length - r;
    return Math.floor(n / this.elementSpan);
  }
  /** @override */
  encode(e, r, n) {
    return 0;
  }
}
class i_ extends xi {
  constructor(e, r, n) {
    if (!(e instanceof Lr))
      throw new TypeError("layout must be a Layout");
    if (r === void 0)
      r = 0;
    else if (!Number.isInteger(r))
      throw new TypeError("offset must be integer or undefined");
    super(e.span, n || e.property), this.layout = e, this.offset = r;
  }
  /** @override */
  isCount() {
    return this.layout instanceof da || this.layout instanceof qa;
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), this.layout.decode(e, r + this.offset);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), this.layout.encode(e, r, n + this.offset);
  }
}
class da extends Lr {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readUIntLE(r, this.span);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeUIntLE(e, n, this.span), this.span;
  }
}
class qa extends Lr {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readUIntBE(r, this.span);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeUIntBE(e, n, this.span), this.span;
  }
}
class Vc extends Lr {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readIntLE(r, this.span);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeIntLE(e, n, this.span), this.span;
  }
}
class If extends Lr {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readIntBE(r, this.span);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeIntBE(e, n, this.span), this.span;
  }
}
const Fv = Math.pow(2, 32);
function Oy(t) {
  const e = Math.floor(t / Fv), r = t - e * Fv;
  return { hi32: e, lo32: r };
}
function By(t, e) {
  return t * Fv + e;
}
class eY extends Lr {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = e.readUInt32LE(r), i = e.readUInt32LE(r + 4);
    return By(i, n);
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = Oy(e);
    return r.writeUInt32LE(i.lo32, n), r.writeUInt32LE(i.hi32, n + 4), 8;
  }
}
class tY extends Lr {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = e.readUInt32BE(r), i = e.readUInt32BE(r + 4);
    return By(n, i);
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = Oy(e);
    return r.writeUInt32BE(i.hi32, n), r.writeUInt32BE(i.lo32, n + 4), 8;
  }
}
class rY extends Lr {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = e.readUInt32LE(r), i = e.readInt32LE(r + 4);
    return By(i, n);
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = Oy(e);
    return r.writeUInt32LE(i.lo32, n), r.writeInt32LE(i.hi32, n + 4), 8;
  }
}
class nY extends Lr {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = e.readInt32BE(r), i = e.readUInt32BE(r + 4);
    return By(n, i);
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = Oy(e);
    return r.writeInt32BE(i.hi32, n), r.writeUInt32BE(i.lo32, n + 4), 8;
  }
}
class ET extends Lr {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readFloatLE(r);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeFloatLE(e, n), 4;
  }
}
class xT extends Lr {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readFloatBE(r);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeFloatBE(e, n), 4;
  }
}
class AT extends Lr {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readDoubleLE(r);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeDoubleLE(e, n), 8;
  }
}
class IT extends Lr {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readDoubleBE(r);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeDoubleBE(e, n), 8;
  }
}
class TT extends Lr {
  constructor(e, r, n) {
    if (!(e instanceof Lr))
      throw new TypeError("elementLayout must be a Layout");
    if (!(r instanceof xi && r.isCount() || Number.isInteger(r) && 0 <= r))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let i = -1;
    !(r instanceof xi) && 0 < e.span && (i = r * e.span), super(i, n), this.elementLayout = e, this.count = r;
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    let n = 0, i = this.count;
    if (i instanceof xi && (i = i.decode(e, r)), 0 < this.elementLayout.span)
      n = i * this.elementLayout.span;
    else {
      let s = 0;
      for (; s < i; )
        n += this.elementLayout.getSpan(e, r + n), ++s;
    }
    return n;
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = [];
    let i = 0, s = this.count;
    for (s instanceof xi && (s = s.decode(e, r)); i < s; )
      n.push(this.elementLayout.decode(e, r)), r += this.elementLayout.getSpan(e, r), i += 1;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = this.elementLayout, s = e.reduce((a, o) => a + i.encode(o, r, n + a), 0);
    return this.count instanceof xi && this.count.encode(e.length, r, n), s;
  }
}
class kT extends Lr {
  constructor(e, r, n) {
    if (!(Array.isArray(e) && e.reduce((s, a) => s && a instanceof Lr, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof r == "boolean" && n === void 0 && (n = r, r = void 0);
    for (const s of e)
      if (0 > s.span && s.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let i = -1;
    try {
      i = e.reduce((s, a) => s + a.getSpan(), 0);
    } catch {
    }
    super(i, r), this.fields = e, this.decodePrefixes = !!n;
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    let n = 0;
    try {
      n = this.fields.reduce((i, s) => {
        const a = s.getSpan(e, r);
        return r += a, i + a;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return n;
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = this.makeDestinationObject();
    for (const i of this.fields)
      if (i.property !== void 0 && (n[i.property] = i.decode(e, r)), r += i.getSpan(e, r), this.decodePrefixes && e.length === r)
        break;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = n;
    let s = 0, a = 0;
    for (const o of this.fields) {
      let c = o.span;
      if (a = 0 < c ? c : 0, o.property !== void 0) {
        const f = e[o.property];
        f !== void 0 && (a = o.encode(f, r, n), 0 > c && (c = o.getSpan(r, n)));
      }
      s = n, n += c;
    }
    return s + a - i;
  }
  /** @override */
  fromArray(e) {
    const r = this.makeDestinationObject();
    for (const n of this.fields)
      n.property !== void 0 && 0 < e.length && (r[n.property] = e.shift());
    return r;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const r of this.fields)
      if (r.property === e)
        return r;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    let r = 0;
    for (const n of this.fields) {
      if (n.property === e)
        return r;
      0 > n.span ? r = -1 : 0 <= r && (r += n.span);
    }
  }
}
class s_ {
  constructor(e) {
    this.property = e;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode() {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode() {
    throw new Error("UnionDiscriminator is abstract");
  }
}
class Up extends s_ {
  constructor(e, r) {
    if (!(e instanceof xi && e.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(r || e.property || "variant"), this.layout = e;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(e, r) {
    return this.layout.decode(e, r);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(e, r, n) {
    return this.layout.encode(e, r, n);
  }
}
class a_ extends Lr {
  constructor(e, r, n) {
    const i = e instanceof da || e instanceof qa;
    if (i)
      e = new Up(new i_(e));
    else if (e instanceof xi && e.isCount())
      e = new Up(e);
    else if (!(e instanceof s_))
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (r === void 0 && (r = null), !(r === null || r instanceof Lr))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (r !== null) {
      if (0 > r.span)
        throw new Error("defaultLayout must have constant span");
      r.property === void 0 && (r = r.replicate("content"));
    }
    let s = -1;
    r && (s = r.span, 0 <= s && i && (s += e.layout.span)), super(s, n), this.discriminator = e, this.usesPrefixDiscriminator = i, this.defaultLayout = r, this.registry = {};
    let a = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(o) {
      return a(o);
    }, this.configGetSourceVariant = function(o) {
      a = o.bind(this);
    };
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    const n = this.getVariant(e, r);
    if (!n)
      throw new Error("unable to determine span for unrecognized variant");
    return n.getSpan(e, r);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(e) {
    if (e.hasOwnProperty(this.discriminator.property)) {
      if (this.defaultLayout && e.hasOwnProperty(this.defaultLayout.property))
        return;
      const r = this.registry[e[this.discriminator.property]];
      if (r && (!r.layout || e.hasOwnProperty(r.property)))
        return r;
    } else
      for (const r in this.registry) {
        const n = this.registry[r];
        if (e.hasOwnProperty(n.property))
          return n;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(e, r) {
    r === void 0 && (r = 0);
    let n;
    const i = this.discriminator, s = i.decode(e, r);
    let a = this.registry[s];
    if (a === void 0) {
      let o = 0;
      a = this.defaultLayout, this.usesPrefixDiscriminator && (o = i.layout.span), n = this.makeDestinationObject(), n[i.property] = s, n[a.property] = this.defaultLayout.decode(e, r + o);
    } else
      n = a.decode(e, r);
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = this.getSourceVariant(e);
    if (i === void 0) {
      const s = this.discriminator, a = this.defaultLayout;
      let o = 0;
      return this.usesPrefixDiscriminator && (o = s.layout.span), s.encode(e[s.property], r, n), o + a.encode(
        e[a.property],
        r,
        n + o
      );
    }
    return i.encode(e, r, n);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(e, r, n) {
    const i = new RT(this, e, r, n);
    return this.registry[e] = i, i;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(e, r) {
    let n = e;
    return ve.isBuffer(e) && (r === void 0 && (r = 0), n = this.discriminator.decode(e, r)), this.registry[n];
  }
}
class RT extends Lr {
  constructor(e, r, n, i) {
    if (!(e instanceof a_))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(r) || 0 > r)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof n == "string" && i === void 0 && (i = n, n = null), n) {
      if (!(n instanceof Lr))
        throw new TypeError("layout must be a Layout");
      if (e.defaultLayout !== null && 0 <= n.span && n.span > e.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof i != "string")
        throw new TypeError("variant must have a String property");
    }
    let s = e.span;
    0 > e.span && (s = n ? n.span : 0, 0 <= s && e.usesPrefixDiscriminator && (s += e.discriminator.layout.span)), super(s, i), this.union = e, this.variant = r, this.layout = n || null;
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    let n = 0;
    return this.union.usesPrefixDiscriminator && (n = this.union.discriminator.layout.span), n + this.layout.getSpan(e, r + n);
  }
  /** @override */
  decode(e, r) {
    const n = this.makeDestinationObject();
    if (r === void 0 && (r = 0), this !== this.union.getVariant(e, r))
      throw new Error("variant mismatch");
    let i = 0;
    return this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout ? n[this.property] = this.layout.decode(e, r + i) : this.property ? n[this.property] = !0 : this.union.usesPrefixDiscriminator && (n[this.union.discriminator.property] = this.variant), n;
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    let i = 0;
    if (this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout && !e.hasOwnProperty(this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, r, n);
    let s = i;
    if (this.layout && (this.layout.encode(e[this.property], r, n + i), s += this.layout.getSpan(r, n + i), 0 <= this.union.span && s > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return s;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(e) {
    if (this.layout)
      return this.layout.fromArray(e);
  }
}
function hu(t) {
  return 0 > t && (t += 4294967296), t;
}
class o_ extends Lr {
  constructor(e, r, n) {
    if (!(e instanceof da || e instanceof qa))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof r == "string" && n === void 0 && (n = r, r = void 0), 4 < e.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(e.span, n), this.word = e, this.msb = !!r, this.fields = [];
    let i = 0;
    this._packedSetValue = function(s) {
      return i = hu(s), this;
    }, this._packedGetValue = function() {
      return i;
    };
  }
  /** @override */
  decode(e, r) {
    const n = this.makeDestinationObject();
    r === void 0 && (r = 0);
    const i = this.word.decode(e, r);
    this._packedSetValue(i);
    for (const s of this.fields)
      s.property !== void 0 && (n[s.property] = s.decode(i));
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = this.word.decode(r, n);
    this._packedSetValue(i);
    for (const s of this.fields)
      if (s.property !== void 0) {
        const a = e[s.property];
        a !== void 0 && s.encode(a);
      }
    return this.word.encode(this._packedGetValue(), r, n);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(e, r) {
    const n = new fd(this, e, r);
    return this.fields.push(n), n;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  addBoolean(e) {
    const r = new PT(this, e);
    return this.fields.push(r), r;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const r of this.fields)
      if (r.property === e)
        return r;
  }
}
class fd {
  constructor(e, r, n) {
    if (!(e instanceof o_))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(r) || 0 >= r)
      throw new TypeError("bits must be positive integer");
    const i = 8 * e.span, s = e.fields.reduce((a, o) => a + o.bits, 0);
    if (r + s > i)
      throw new Error("bits too long for span remainder (" + (i - s) + " of " + i + " remain)");
    this.container = e, this.bits = r, this.valueMask = (1 << r) - 1, r === 32 && (this.valueMask = 4294967295), this.start = s, this.container.msb && (this.start = i - s - r), this.wordMask = hu(this.valueMask << this.start), this.property = n;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode() {
    const e = this.container._packedGetValue();
    return hu(e & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(e) {
    if (!Number.isInteger(e) || e !== hu(e & this.valueMask))
      throw new TypeError(n_("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const r = this.container._packedGetValue(), n = hu(e << this.start);
    this.container._packedSetValue(hu(r & ~this.wordMask) | n);
  }
}
let PT = class extends fd {
  constructor(e, r) {
    super(e, 1, r);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(e, r) {
    return !!fd.prototype.decode.call(this, e, r);
  }
  /** @override */
  encode(e) {
    return typeof e == "boolean" && (e = +e), fd.prototype.encode.call(this, e);
  }
};
class OT extends Lr {
  constructor(e, r) {
    if (!(e instanceof xi && e.isCount() || Number.isInteger(e) && 0 <= e))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let n = -1;
    e instanceof xi || (n = e), super(n, r), this.length = e;
  }
  /** @override */
  getSpan(e, r) {
    let n = this.span;
    return 0 > n && (n = this.length.decode(e, r)), n;
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    let n = this.span;
    return 0 > n && (n = this.length.decode(e, r)), e.slice(r, r + n);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, r, n) {
    let i = this.length;
    if (this.length instanceof xi && (i = e.length), !(ve.isBuffer(e) && i === e.length))
      throw new TypeError(n_("Blob.encode", this) + " requires (length " + i + ") Buffer as src");
    if (n + i > r.length)
      throw new RangeError("encoding overruns Buffer");
    return r.write(e.toString("hex"), n, i, "hex"), this.length instanceof xi && this.length.encode(i, r, n), i;
  }
}
class BT extends Lr {
  constructor(e) {
    super(-1, e);
  }
  /** @override */
  getSpan(e, r) {
    if (!ve.isBuffer(e))
      throw new TypeError("b must be a Buffer");
    r === void 0 && (r = 0);
    let n = r;
    for (; n < e.length && e[n] !== 0; )
      n += 1;
    return 1 + n - r;
  }
  /** @override */
  decode(e, r, n) {
    r === void 0 && (r = 0);
    let i = this.getSpan(e, r);
    return e.slice(r, r + i - 1).toString("utf-8");
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0), typeof e != "string" && (e = e.toString());
    const i = new ve(e, "utf8"), s = i.length;
    if (n + s > r.length)
      throw new RangeError("encoding overruns Buffer");
    return i.copy(r, n), r[n + s] = 0, s + 1;
  }
}
class MT extends Lr {
  constructor(e, r) {
    if (typeof e == "string" && r === void 0 && (r = e, e = void 0), e === void 0)
      e = -1;
    else if (!Number.isInteger(e))
      throw new TypeError("maxSpan must be an integer");
    super(-1, r), this.maxSpan = e;
  }
  /** @override */
  getSpan(e, r) {
    if (!ve.isBuffer(e))
      throw new TypeError("b must be a Buffer");
    return r === void 0 && (r = 0), e.length - r;
  }
  /** @override */
  decode(e, r, n) {
    r === void 0 && (r = 0);
    let i = this.getSpan(e, r);
    if (0 <= this.maxSpan && this.maxSpan < i)
      throw new RangeError("text length exceeds maxSpan");
    return e.slice(r, r + i).toString("utf-8");
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0), typeof e != "string" && (e = e.toString());
    const i = new ve(e, "utf8"), s = i.length;
    if (0 <= this.maxSpan && this.maxSpan < s)
      throw new RangeError("text length exceeds maxSpan");
    if (n + s > r.length)
      throw new RangeError("encoding overruns Buffer");
    return i.copy(r, n), s;
  }
}
class CT extends Lr {
  constructor(e, r) {
    super(0, r), this.value = e;
  }
  /** @override */
  decode(e, r, n) {
    return this.value;
  }
  /** @override */
  encode(e, r, n) {
    return 0;
  }
}
Qe.ExternalLayout = xi;
Qe.GreedyCount = ST;
Qe.OffsetLayout = i_;
Qe.UInt = da;
Qe.UIntBE = qa;
Qe.Int = Vc;
Qe.IntBE = If;
Qe.Float = ET;
Qe.FloatBE = xT;
Qe.Double = AT;
Qe.DoubleBE = IT;
Qe.Sequence = TT;
Qe.Structure = kT;
Qe.UnionDiscriminator = s_;
Qe.UnionLayoutDiscriminator = Up;
Qe.Union = a_;
Qe.VariantLayout = RT;
Qe.BitStructure = o_;
Qe.BitField = fd;
Qe.Boolean = PT;
Qe.Blob = OT;
Qe.CString = BT;
Qe.UTF8 = MT;
Qe.Constant = CT;
Qe.greedy = (t, e) => new ST(t, e);
Qe.offset = (t, e, r) => new i_(t, e, r);
Qe.u8 = (t) => new da(1, t);
Qe.u16 = (t) => new da(2, t);
Qe.u24 = (t) => new da(3, t);
Qe.u32 = (t) => new da(4, t);
Qe.u40 = (t) => new da(5, t);
Qe.u48 = (t) => new da(6, t);
Qe.nu64 = (t) => new eY(t);
Qe.u16be = (t) => new qa(2, t);
Qe.u24be = (t) => new qa(3, t);
Qe.u32be = (t) => new qa(4, t);
Qe.u40be = (t) => new qa(5, t);
Qe.u48be = (t) => new qa(6, t);
Qe.nu64be = (t) => new tY(t);
Qe.s8 = (t) => new Vc(1, t);
Qe.s16 = (t) => new Vc(2, t);
Qe.s24 = (t) => new Vc(3, t);
Qe.s32 = (t) => new Vc(4, t);
Qe.s40 = (t) => new Vc(5, t);
Qe.s48 = (t) => new Vc(6, t);
Qe.ns64 = (t) => new rY(t);
Qe.s16be = (t) => new If(2, t);
Qe.s24be = (t) => new If(3, t);
Qe.s32be = (t) => new If(4, t);
Qe.s40be = (t) => new If(5, t);
Qe.s48be = (t) => new If(6, t);
Qe.ns64be = (t) => new nY(t);
Qe.f32 = (t) => new ET(t);
Qe.f32be = (t) => new xT(t);
Qe.f64 = (t) => new AT(t);
Qe.f64be = (t) => new IT(t);
Qe.struct = (t, e, r) => new kT(t, e, r);
Qe.bits = (t, e, r) => new o_(t, e, r);
Qe.seq = (t, e, r) => new TT(t, e, r);
Qe.union = (t, e, r) => new a_(t, e, r);
Qe.unionLayoutDiscriminator = (t, e) => new Up(t, e);
Qe.blob = (t, e) => new OT(t, e);
Qe.cstr = (t) => new BT(t);
Qe.utf8 = (t, e) => new MT(t, e);
Qe.const = (t, e) => new CT(t, e);
var wr = {};
function Lp(t) {
  if (!Number.isSafeInteger(t) || t < 0)
    throw new Error(`Wrong positive integer: ${t}`);
}
function iY(t) {
  return t instanceof Uint8Array || t != null && typeof t == "object" && t.constructor.name === "Uint8Array";
}
function c_(t, ...e) {
  if (!iY(t))
    throw new Error("Expected Uint8Array");
  if (e.length > 0 && !e.includes(t.length))
    throw new Error(`Expected Uint8Array of length ${e}, not of length=${t.length}`);
}
function sY(t) {
  if (typeof t != "function" || typeof t.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  Lp(t.outputLen), Lp(t.blockLen);
}
function ef(t, e = !0) {
  if (t.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && t.finished)
    throw new Error("Hash#digest() has already been called");
}
function NT(t, e) {
  c_(t);
  const r = e.outputLen;
  if (t.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const Jg = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const aY = (t) => new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4));
function UT(t) {
  return t instanceof Uint8Array || t != null && typeof t == "object" && t.constructor.name === "Uint8Array";
}
const Yg = (t) => new DataView(t.buffer, t.byteOffset, t.byteLength), Ls = (t, e) => t << 32 - e | t >>> e, oY = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!oY)
  throw new Error("Non little-endian hardware is not supported");
function LT(t) {
  if (typeof t != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof t}`);
  return new Uint8Array(new TextEncoder().encode(t));
}
function My(t) {
  if (typeof t == "string" && (t = LT(t)), !UT(t))
    throw new Error(`expected Uint8Array, got ${typeof t}`);
  return t;
}
function DT(...t) {
  let e = 0;
  for (let n = 0; n < t.length; n++) {
    const i = t[n];
    if (!UT(i))
      throw new Error("Uint8Array expected");
    e += i.length;
  }
  const r = new Uint8Array(e);
  for (let n = 0, i = 0; n < t.length; n++) {
    const s = t[n];
    r.set(s, i), i += s.length;
  }
  return r;
}
class u_ {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function f_(t) {
  const e = (n) => t().update(My(n)).digest(), r = t();
  return e.outputLen = r.outputLen, e.blockLen = r.blockLen, e.create = () => t(), e;
}
function FT(t = 32) {
  if (Jg && typeof Jg.getRandomValues == "function")
    return Jg.getRandomValues(new Uint8Array(t));
  throw new Error("crypto.getRandomValues must be defined");
}
function cY(t, e, r, n) {
  if (typeof t.setBigUint64 == "function")
    return t.setBigUint64(e, r, n);
  const i = BigInt(32), s = BigInt(4294967295), a = Number(r >> i & s), o = Number(r & s), c = n ? 4 : 0, f = n ? 0 : 4;
  t.setUint32(e + c, a, n), t.setUint32(e + f, o, n);
}
class jT extends u_ {
  constructor(e, r, n, i) {
    super(), this.blockLen = e, this.outputLen = r, this.padOffset = n, this.isLE = i, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = Yg(this.buffer);
  }
  update(e) {
    ef(this);
    const { view: r, buffer: n, blockLen: i } = this;
    e = My(e);
    const s = e.length;
    for (let a = 0; a < s; ) {
      const o = Math.min(i - this.pos, s - a);
      if (o === i) {
        const c = Yg(e);
        for (; i <= s - a; a += i)
          this.process(c, a);
        continue;
      }
      n.set(e.subarray(a, a + o), this.pos), this.pos += o, a += o, this.pos === i && (this.process(r, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    ef(this), NT(e, this), this.finished = !0;
    const { buffer: r, view: n, blockLen: i, isLE: s } = this;
    let { pos: a } = this;
    r[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > i - a && (this.process(n, 0), a = 0);
    for (let d = a; d < i; d++)
      r[d] = 0;
    cY(n, i - 8, BigInt(this.length * 8), s), this.process(n, 0);
    const o = Yg(e), c = this.outputLen;
    if (c % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const f = c / 4, u = this.get();
    if (f > u.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let d = 0; d < f; d++)
      o.setUint32(4 * d, u[d], s);
  }
  digest() {
    const { buffer: e, outputLen: r } = this;
    this.digestInto(e);
    const n = e.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: r, buffer: n, length: i, finished: s, destroyed: a, pos: o } = this;
    return e.length = i, e.pos = o, e.finished = s, e.destroyed = a, i % r && e.buffer.set(n), e;
  }
}
const Sh = /* @__PURE__ */ BigInt(2 ** 32 - 1), jv = /* @__PURE__ */ BigInt(32);
function $T(t, e = !1) {
  return e ? { h: Number(t & Sh), l: Number(t >> jv & Sh) } : { h: Number(t >> jv & Sh) | 0, l: Number(t & Sh) | 0 };
}
function qT(t, e = !1) {
  let r = new Uint32Array(t.length), n = new Uint32Array(t.length);
  for (let i = 0; i < t.length; i++) {
    const { h: s, l: a } = $T(t[i], e);
    [r[i], n[i]] = [s, a];
  }
  return [r, n];
}
const uY = (t, e) => BigInt(t >>> 0) << jv | BigInt(e >>> 0), fY = (t, e, r) => t >>> r, dY = (t, e, r) => t << 32 - r | e >>> r, lY = (t, e, r) => t >>> r | e << 32 - r, hY = (t, e, r) => t << 32 - r | e >>> r, pY = (t, e, r) => t << 64 - r | e >>> r - 32, yY = (t, e, r) => t >>> r - 32 | e << 64 - r, bY = (t, e) => e, gY = (t, e) => t, WT = (t, e, r) => t << r | e >>> 32 - r, zT = (t, e, r) => e << r | t >>> 32 - r, KT = (t, e, r) => e << r - 32 | t >>> 64 - r, VT = (t, e, r) => t << r - 32 | e >>> 64 - r;
function mY(t, e, r, n) {
  const i = (e >>> 0) + (n >>> 0);
  return { h: t + r + (i / 2 ** 32 | 0) | 0, l: i | 0 };
}
const vY = (t, e, r) => (t >>> 0) + (e >>> 0) + (r >>> 0), wY = (t, e, r, n) => e + r + n + (t / 2 ** 32 | 0) | 0, _Y = (t, e, r, n) => (t >>> 0) + (e >>> 0) + (r >>> 0) + (n >>> 0), SY = (t, e, r, n, i) => e + r + n + i + (t / 2 ** 32 | 0) | 0, EY = (t, e, r, n, i) => (t >>> 0) + (e >>> 0) + (r >>> 0) + (n >>> 0) + (i >>> 0), xY = (t, e, r, n, i, s) => e + r + n + i + s + (t / 2 ** 32 | 0) | 0, $t = {
  fromBig: $T,
  split: qT,
  toBig: uY,
  shrSH: fY,
  shrSL: dY,
  rotrSH: lY,
  rotrSL: hY,
  rotrBH: pY,
  rotrBL: yY,
  rotr32H: bY,
  rotr32L: gY,
  rotlSH: WT,
  rotlSL: zT,
  rotlBH: KT,
  rotlBL: VT,
  add: mY,
  add3L: vY,
  add3H: wY,
  add4L: _Y,
  add4H: SY,
  add5H: xY,
  add5L: EY
}, [AY, IY] = $t.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((t) => BigInt(t))), Va = /* @__PURE__ */ new Uint32Array(80), Ha = /* @__PURE__ */ new Uint32Array(80);
class TY extends jT {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: e, Al: r, Bh: n, Bl: i, Ch: s, Cl: a, Dh: o, Dl: c, Eh: f, El: u, Fh: d, Fl: l, Gh: h, Gl: y, Hh: p, Hl: b } = this;
    return [e, r, n, i, s, a, o, c, f, u, d, l, h, y, p, b];
  }
  // prettier-ignore
  set(e, r, n, i, s, a, o, c, f, u, d, l, h, y, p, b) {
    this.Ah = e | 0, this.Al = r | 0, this.Bh = n | 0, this.Bl = i | 0, this.Ch = s | 0, this.Cl = a | 0, this.Dh = o | 0, this.Dl = c | 0, this.Eh = f | 0, this.El = u | 0, this.Fh = d | 0, this.Fl = l | 0, this.Gh = h | 0, this.Gl = y | 0, this.Hh = p | 0, this.Hl = b | 0;
  }
  process(e, r) {
    for (let I = 0; I < 16; I++, r += 4)
      Va[I] = e.getUint32(r), Ha[I] = e.getUint32(r += 4);
    for (let I = 16; I < 80; I++) {
      const L = Va[I - 15] | 0, P = Ha[I - 15] | 0, C = $t.rotrSH(L, P, 1) ^ $t.rotrSH(L, P, 8) ^ $t.shrSH(L, P, 7), D = $t.rotrSL(L, P, 1) ^ $t.rotrSL(L, P, 8) ^ $t.shrSL(L, P, 7), F = Va[I - 2] | 0, G = Ha[I - 2] | 0, re = $t.rotrSH(F, G, 19) ^ $t.rotrBH(F, G, 61) ^ $t.shrSH(F, G, 6), ie = $t.rotrSL(F, G, 19) ^ $t.rotrBL(F, G, 61) ^ $t.shrSL(F, G, 6), ee = $t.add4L(D, ie, Ha[I - 7], Ha[I - 16]), $ = $t.add4H(ee, C, re, Va[I - 7], Va[I - 16]);
      Va[I] = $ | 0, Ha[I] = ee | 0;
    }
    let { Ah: n, Al: i, Bh: s, Bl: a, Ch: o, Cl: c, Dh: f, Dl: u, Eh: d, El: l, Fh: h, Fl: y, Gh: p, Gl: b, Hh: v, Hl: x } = this;
    for (let I = 0; I < 80; I++) {
      const L = $t.rotrSH(d, l, 14) ^ $t.rotrSH(d, l, 18) ^ $t.rotrBH(d, l, 41), P = $t.rotrSL(d, l, 14) ^ $t.rotrSL(d, l, 18) ^ $t.rotrBL(d, l, 41), C = d & h ^ ~d & p, D = l & y ^ ~l & b, F = $t.add5L(x, P, D, IY[I], Ha[I]), G = $t.add5H(F, v, L, C, AY[I], Va[I]), re = F | 0, ie = $t.rotrSH(n, i, 28) ^ $t.rotrBH(n, i, 34) ^ $t.rotrBH(n, i, 39), ee = $t.rotrSL(n, i, 28) ^ $t.rotrBL(n, i, 34) ^ $t.rotrBL(n, i, 39), $ = n & s ^ n & o ^ s & o, w = i & a ^ i & c ^ a & c;
      v = p | 0, x = b | 0, p = h | 0, b = y | 0, h = d | 0, y = l | 0, { h: d, l } = $t.add(f | 0, u | 0, G | 0, re | 0), f = o | 0, u = c | 0, o = s | 0, c = a | 0, s = n | 0, a = i | 0;
      const E = $t.add3L(re, ee, w);
      n = $t.add3H(E, G, ie, $), i = E | 0;
    }
    ({ h: n, l: i } = $t.add(this.Ah | 0, this.Al | 0, n | 0, i | 0)), { h: s, l: a } = $t.add(this.Bh | 0, this.Bl | 0, s | 0, a | 0), { h: o, l: c } = $t.add(this.Ch | 0, this.Cl | 0, o | 0, c | 0), { h: f, l: u } = $t.add(this.Dh | 0, this.Dl | 0, f | 0, u | 0), { h: d, l } = $t.add(this.Eh | 0, this.El | 0, d | 0, l | 0), { h, l: y } = $t.add(this.Fh | 0, this.Fl | 0, h | 0, y | 0), { h: p, l: b } = $t.add(this.Gh | 0, this.Gl | 0, p | 0, b | 0), { h: v, l: x } = $t.add(this.Hh | 0, this.Hl | 0, v | 0, x | 0), this.set(n, i, s, a, o, c, f, u, d, l, h, y, p, b, v, x);
  }
  roundClean() {
    Va.fill(0), Ha.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const HT = /* @__PURE__ */ f_(() => new TY());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const GT = BigInt(0), Cy = BigInt(1), kY = BigInt(2);
function ea(t) {
  return t instanceof Uint8Array || t != null && typeof t == "object" && t.constructor.name === "Uint8Array";
}
const RY = /* @__PURE__ */ Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function Pc(t) {
  if (!ea(t))
    throw new Error("Uint8Array expected");
  let e = "";
  for (let r = 0; r < t.length; r++)
    e += RY[t[r]];
  return e;
}
function ZT(t) {
  const e = t.toString(16);
  return e.length & 1 ? `0${e}` : e;
}
function d_(t) {
  if (typeof t != "string")
    throw new Error("hex string expected, got " + typeof t);
  return BigInt(t === "" ? "0" : `0x${t}`);
}
const ya = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function z8(t) {
  if (t >= ya._0 && t <= ya._9)
    return t - ya._0;
  if (t >= ya._A && t <= ya._F)
    return t - (ya._A - 10);
  if (t >= ya._a && t <= ya._f)
    return t - (ya._a - 10);
}
function tf(t) {
  if (typeof t != "string")
    throw new Error("hex string expected, got " + typeof t);
  const e = t.length, r = e / 2;
  if (e % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + e);
  const n = new Uint8Array(r);
  for (let i = 0, s = 0; i < r; i++, s += 2) {
    const a = z8(t.charCodeAt(s)), o = z8(t.charCodeAt(s + 1));
    if (a === void 0 || o === void 0) {
      const c = t[s] + t[s + 1];
      throw new Error('hex string expected, got non-hex character "' + c + '" at index ' + s);
    }
    n[i] = a * 16 + o;
  }
  return n;
}
function mc(t) {
  return d_(Pc(t));
}
function Ru(t) {
  if (!ea(t))
    throw new Error("Uint8Array expected");
  return d_(Pc(Uint8Array.from(t).reverse()));
}
function rf(t, e) {
  return tf(t.toString(16).padStart(e * 2, "0"));
}
function Wd(t, e) {
  return rf(t, e).reverse();
}
function PY(t) {
  return tf(ZT(t));
}
function xn(t, e, r) {
  let n;
  if (typeof e == "string")
    try {
      n = tf(e);
    } catch (s) {
      throw new Error(`${t} must be valid hex string, got "${e}". Cause: ${s}`);
    }
  else if (ea(e))
    n = Uint8Array.from(e);
  else
    throw new Error(`${t} must be hex string or Uint8Array`);
  const i = n.length;
  if (typeof r == "number" && i !== r)
    throw new Error(`${t} expected ${r} bytes, got ${i}`);
  return n;
}
function Oc(...t) {
  let e = 0;
  for (let i = 0; i < t.length; i++) {
    const s = t[i];
    if (!ea(s))
      throw new Error("Uint8Array expected");
    e += s.length;
  }
  let r = new Uint8Array(e), n = 0;
  for (let i = 0; i < t.length; i++) {
    const s = t[i];
    r.set(s, n), n += s.length;
  }
  return r;
}
function OY(t, e) {
  if (t.length !== e.length)
    return !1;
  let r = 0;
  for (let n = 0; n < t.length; n++)
    r |= t[n] ^ e[n];
  return r === 0;
}
function BY(t) {
  if (typeof t != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof t}`);
  return new Uint8Array(new TextEncoder().encode(t));
}
function MY(t) {
  let e;
  for (e = 0; t > GT; t >>= Cy, e += 1)
    ;
  return e;
}
function CY(t, e) {
  return t >> BigInt(e) & Cy;
}
const NY = (t, e, r) => t | (r ? Cy : GT) << BigInt(e), l_ = (t) => (kY << BigInt(t - 1)) - Cy, Qg = (t) => new Uint8Array(t), K8 = (t) => Uint8Array.from(t);
function JT(t, e, r) {
  if (typeof t != "number" || t < 2)
    throw new Error("hashLen must be a number");
  if (typeof e != "number" || e < 2)
    throw new Error("qByteLen must be a number");
  if (typeof r != "function")
    throw new Error("hmacFn must be a function");
  let n = Qg(t), i = Qg(t), s = 0;
  const a = () => {
    n.fill(1), i.fill(0), s = 0;
  }, o = (...d) => r(i, n, ...d), c = (d = Qg()) => {
    i = o(K8([0]), d), n = o(), d.length !== 0 && (i = o(K8([1]), d), n = o());
  }, f = () => {
    if (s++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let d = 0;
    const l = [];
    for (; d < e; ) {
      n = o();
      const h = n.slice();
      l.push(h), d += n.length;
    }
    return Oc(...l);
  };
  return (d, l) => {
    a(), c(d);
    let h;
    for (; !(h = l(f())); )
      c();
    return a(), h;
  };
}
const UY = {
  bigint: (t) => typeof t == "bigint",
  function: (t) => typeof t == "function",
  boolean: (t) => typeof t == "boolean",
  string: (t) => typeof t == "string",
  stringOrUint8Array: (t) => typeof t == "string" || ea(t),
  isSafeInteger: (t) => Number.isSafeInteger(t),
  array: (t) => Array.isArray(t),
  field: (t, e) => e.Fp.isValid(t),
  hash: (t) => typeof t == "function" && Number.isSafeInteger(t.outputLen)
};
function Tf(t, e, r = {}) {
  const n = (i, s, a) => {
    const o = UY[s];
    if (typeof o != "function")
      throw new Error(`Invalid validator "${s}", expected function`);
    const c = t[i];
    if (!(a && c === void 0) && !o(c, t))
      throw new Error(`Invalid param ${String(i)}=${c} (${typeof c}), expected ${s}`);
  };
  for (const [i, s] of Object.entries(e))
    n(i, s, !1);
  for (const [i, s] of Object.entries(r))
    n(i, s, !0);
  return t;
}
const LY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bitGet: CY,
  bitLen: MY,
  bitMask: l_,
  bitSet: NY,
  bytesToHex: Pc,
  bytesToNumberBE: mc,
  bytesToNumberLE: Ru,
  concatBytes: Oc,
  createHmacDrbg: JT,
  ensureBytes: xn,
  equalBytes: OY,
  hexToBytes: tf,
  hexToNumber: d_,
  isBytes: ea,
  numberToBytesBE: rf,
  numberToBytesLE: Wd,
  numberToHexUnpadded: ZT,
  numberToVarBytesBE: PY,
  utf8ToBytes: BY,
  validateObject: Tf
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Nn = BigInt(0), nn = BigInt(1), zo = BigInt(2), DY = BigInt(3), $v = BigInt(4), V8 = BigInt(5), H8 = BigInt(8);
BigInt(9);
BigInt(16);
function Qr(t, e) {
  const r = t % e;
  return r >= Nn ? r : e + r;
}
function FY(t, e, r) {
  if (r <= Nn || e < Nn)
    throw new Error("Expected power/modulo > 0");
  if (r === nn)
    return Nn;
  let n = nn;
  for (; e > Nn; )
    e & nn && (n = n * t % r), t = t * t % r, e >>= nn;
  return n;
}
function un(t, e, r) {
  let n = t;
  for (; e-- > Nn; )
    n *= n, n %= r;
  return n;
}
function qv(t, e) {
  if (t === Nn || e <= Nn)
    throw new Error(`invert: expected positive integers, got n=${t} mod=${e}`);
  let r = Qr(t, e), n = e, i = Nn, s = nn;
  for (; r !== Nn; ) {
    const o = n / r, c = n % r, f = i - s * o;
    n = r, r = c, i = s, s = f;
  }
  if (n !== nn)
    throw new Error("invert: does not exist");
  return Qr(i, e);
}
function jY(t) {
  const e = (t - nn) / zo;
  let r, n, i;
  for (r = t - nn, n = 0; r % zo === Nn; r /= zo, n++)
    ;
  for (i = zo; i < t && FY(i, e, t) !== t - nn; i++)
    ;
  if (n === 1) {
    const a = (t + nn) / $v;
    return function(c, f) {
      const u = c.pow(f, a);
      if (!c.eql(c.sqr(u), f))
        throw new Error("Cannot find square root");
      return u;
    };
  }
  const s = (r + nn) / zo;
  return function(o, c) {
    if (o.pow(c, e) === o.neg(o.ONE))
      throw new Error("Cannot find square root");
    let f = n, u = o.pow(o.mul(o.ONE, i), r), d = o.pow(c, s), l = o.pow(c, r);
    for (; !o.eql(l, o.ONE); ) {
      if (o.eql(l, o.ZERO))
        return o.ZERO;
      let h = 1;
      for (let p = o.sqr(l); h < f && !o.eql(p, o.ONE); h++)
        p = o.sqr(p);
      const y = o.pow(u, nn << BigInt(f - h - 1));
      u = o.sqr(y), d = o.mul(d, y), l = o.mul(l, u), f = h;
    }
    return d;
  };
}
function $Y(t) {
  if (t % $v === DY) {
    const e = (t + nn) / $v;
    return function(n, i) {
      const s = n.pow(i, e);
      if (!n.eql(n.sqr(s), i))
        throw new Error("Cannot find square root");
      return s;
    };
  }
  if (t % H8 === V8) {
    const e = (t - V8) / H8;
    return function(n, i) {
      const s = n.mul(i, zo), a = n.pow(s, e), o = n.mul(i, a), c = n.mul(n.mul(o, zo), a), f = n.mul(o, n.sub(c, n.ONE));
      if (!n.eql(n.sqr(f), i))
        throw new Error("Cannot find square root");
      return f;
    };
  }
  return jY(t);
}
const qY = (t, e) => (Qr(t, e) & nn) === nn, WY = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function zY(t) {
  const e = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, r = WY.reduce((n, i) => (n[i] = "function", n), e);
  return Tf(t, r);
}
function KY(t, e, r) {
  if (r < Nn)
    throw new Error("Expected power > 0");
  if (r === Nn)
    return t.ONE;
  if (r === nn)
    return e;
  let n = t.ONE, i = e;
  for (; r > Nn; )
    r & nn && (n = t.mul(n, i)), i = t.sqr(i), r >>= nn;
  return n;
}
function VY(t, e) {
  const r = new Array(e.length), n = e.reduce((s, a, o) => t.is0(a) ? s : (r[o] = s, t.mul(s, a)), t.ONE), i = t.inv(n);
  return e.reduceRight((s, a, o) => t.is0(a) ? s : (r[o] = t.mul(s, r[o]), t.mul(s, a)), i), r;
}
function YT(t, e) {
  const r = e !== void 0 ? e : t.toString(2).length, n = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: n };
}
function QT(t, e, r = !1, n = {}) {
  if (t <= Nn)
    throw new Error(`Expected Field ORDER > 0, got ${t}`);
  const { nBitLength: i, nByteLength: s } = YT(t, e);
  if (s > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const a = $Y(t), o = Object.freeze({
    ORDER: t,
    BITS: i,
    BYTES: s,
    MASK: l_(i),
    ZERO: Nn,
    ONE: nn,
    create: (c) => Qr(c, t),
    isValid: (c) => {
      if (typeof c != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof c}`);
      return Nn <= c && c < t;
    },
    is0: (c) => c === Nn,
    isOdd: (c) => (c & nn) === nn,
    neg: (c) => Qr(-c, t),
    eql: (c, f) => c === f,
    sqr: (c) => Qr(c * c, t),
    add: (c, f) => Qr(c + f, t),
    sub: (c, f) => Qr(c - f, t),
    mul: (c, f) => Qr(c * f, t),
    pow: (c, f) => KY(o, c, f),
    div: (c, f) => Qr(c * qv(f, t), t),
    // Same as above, but doesn't normalize
    sqrN: (c) => c * c,
    addN: (c, f) => c + f,
    subN: (c, f) => c - f,
    mulN: (c, f) => c * f,
    inv: (c) => qv(c, t),
    sqrt: n.sqrt || ((c) => a(o, c)),
    invertBatch: (c) => VY(o, c),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (c, f, u) => u ? f : c,
    toBytes: (c) => r ? Wd(c, s) : rf(c, s),
    fromBytes: (c) => {
      if (c.length !== s)
        throw new Error(`Fp.fromBytes: expected ${s}, got ${c.length}`);
      return r ? Ru(c) : mc(c);
    }
  });
  return Object.freeze(o);
}
function HY(t, e) {
  if (!t.isOdd)
    throw new Error("Field doesn't have isOdd");
  const r = t.sqrt(e);
  return t.isOdd(r) ? t.neg(r) : r;
}
function XT(t) {
  if (typeof t != "bigint")
    throw new Error("field order must be bigint");
  const e = t.toString(2).length;
  return Math.ceil(e / 8);
}
function ek(t) {
  const e = XT(t);
  return e + Math.ceil(e / 2);
}
function GY(t, e, r = !1) {
  const n = t.length, i = XT(e), s = ek(e);
  if (n < 16 || n < s || n > 1024)
    throw new Error(`expected ${s}-1024 bytes of input, got ${n}`);
  const a = r ? mc(t) : Ru(t), o = Qr(a, e - nn) + nn;
  return r ? Wd(o, i) : rf(o, i);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ZY = BigInt(0), Xg = BigInt(1);
function tk(t, e) {
  const r = (i, s) => {
    const a = s.negate();
    return i ? a : s;
  }, n = (i) => {
    const s = Math.ceil(e / i) + 1, a = 2 ** (i - 1);
    return { windows: s, windowSize: a };
  };
  return {
    constTimeNegate: r,
    // non-const time multiplication ladder
    unsafeLadder(i, s) {
      let a = t.ZERO, o = i;
      for (; s > ZY; )
        s & Xg && (a = a.add(o)), o = o.double(), s >>= Xg;
      return a;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(i, s) {
      const { windows: a, windowSize: o } = n(s), c = [];
      let f = i, u = f;
      for (let d = 0; d < a; d++) {
        u = f, c.push(u);
        for (let l = 1; l < o; l++)
          u = u.add(f), c.push(u);
        f = u.double();
      }
      return c;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(i, s, a) {
      const { windows: o, windowSize: c } = n(i);
      let f = t.ZERO, u = t.BASE;
      const d = BigInt(2 ** i - 1), l = 2 ** i, h = BigInt(i);
      for (let y = 0; y < o; y++) {
        const p = y * c;
        let b = Number(a & d);
        a >>= h, b > c && (b -= l, a += Xg);
        const v = p, x = p + Math.abs(b) - 1, I = y % 2 !== 0, L = b < 0;
        b === 0 ? u = u.add(r(I, s[v])) : f = f.add(r(L, s[x]));
      }
      return { p: f, f: u };
    },
    wNAFCached(i, s, a, o) {
      const c = i._WINDOW_SIZE || 1;
      let f = s.get(i);
      return f || (f = this.precomputeWindow(i, c), c !== 1 && s.set(i, o(f))), this.wNAF(c, f, a);
    }
  };
}
function h_(t) {
  return zY(t.Fp), Tf(t, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...YT(t.n, t.nBitLength),
    ...t,
    p: t.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const ds = BigInt(0), Oi = BigInt(1), Eh = BigInt(2), JY = BigInt(8), YY = { zip215: !0 };
function QY(t) {
  const e = h_(t);
  return Tf(t, {
    hash: "function",
    a: "bigint",
    d: "bigint",
    randomBytes: "function"
  }, {
    adjustScalarBytes: "function",
    domain: "function",
    uvRatio: "function",
    mapToCurve: "function"
  }), Object.freeze({ ...e });
}
function p_(t) {
  const e = QY(t), { Fp: r, n, prehash: i, hash: s, randomBytes: a, nByteLength: o, h: c } = e, f = Eh << BigInt(o * 8) - Oi, u = r.create, d = e.uvRatio || ((_, R) => {
    try {
      return { isValid: !0, value: r.sqrt(_ * r.inv(R)) };
    } catch {
      return { isValid: !1, value: ds };
    }
  }), l = e.adjustScalarBytes || ((_) => _), h = e.domain || ((_, R, N) => {
    if (R.length || N)
      throw new Error("Contexts/pre-hash are not supported");
    return _;
  }), y = (_) => typeof _ == "bigint" && ds < _, p = (_, R) => y(_) && y(R) && _ < R, b = (_) => _ === ds || p(_, f);
  function v(_, R) {
    if (p(_, R))
      return _;
    throw new Error(`Expected valid scalar < ${R}, got ${typeof _} ${_}`);
  }
  function x(_) {
    return _ === ds ? _ : v(_, n);
  }
  const I = /* @__PURE__ */ new Map();
  function L(_) {
    if (!(_ instanceof P))
      throw new Error("ExtendedPoint expected");
  }
  class P {
    constructor(R, N, O, g) {
      if (this.ex = R, this.ey = N, this.ez = O, this.et = g, !b(R))
        throw new Error("x required");
      if (!b(N))
        throw new Error("y required");
      if (!b(O))
        throw new Error("z required");
      if (!b(g))
        throw new Error("t required");
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(R) {
      if (R instanceof P)
        throw new Error("extended point not allowed");
      const { x: N, y: O } = R || {};
      if (!b(N) || !b(O))
        throw new Error("invalid affine point");
      return new P(N, O, Oi, u(N * O));
    }
    static normalizeZ(R) {
      const N = r.invertBatch(R.map((O) => O.ez));
      return R.map((O, g) => O.toAffine(N[g])).map(P.fromAffine);
    }
    // "Private method", don't use it directly
    _setWindowSize(R) {
      this._WINDOW_SIZE = R, I.delete(this);
    }
    // Not required for fromHex(), which always creates valid points.
    // Could be useful for fromAffine().
    assertValidity() {
      const { a: R, d: N } = e;
      if (this.is0())
        throw new Error("bad point: ZERO");
      const { ex: O, ey: g, ez: M, et: Y } = this, se = u(O * O), V = u(g * g), K = u(M * M), Z = u(K * K), ne = u(se * R), ce = u(K * u(ne + V)), H = u(Z + u(N * u(se * V)));
      if (ce !== H)
        throw new Error("bad point: equation left != right (1)");
      const J = u(O * g), le = u(M * Y);
      if (J !== le)
        throw new Error("bad point: equation left != right (2)");
    }
    // Compare one point to another.
    equals(R) {
      L(R);
      const { ex: N, ey: O, ez: g } = this, { ex: M, ey: Y, ez: se } = R, V = u(N * se), K = u(M * g), Z = u(O * se), ne = u(Y * g);
      return V === K && Z === ne;
    }
    is0() {
      return this.equals(P.ZERO);
    }
    negate() {
      return new P(u(-this.ex), this.ey, this.ez, u(-this.et));
    }
    // Fast algo for doubling Extended Point.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
    // Cost: 4M + 4S + 1*a + 6add + 1*2.
    double() {
      const { a: R } = e, { ex: N, ey: O, ez: g } = this, M = u(N * N), Y = u(O * O), se = u(Eh * u(g * g)), V = u(R * M), K = N + O, Z = u(u(K * K) - M - Y), ne = V + Y, ce = ne - se, H = V - Y, J = u(Z * ce), le = u(ne * H), me = u(Z * H), Ue = u(ce * ne);
      return new P(J, le, Ue, me);
    }
    // Fast algo for adding 2 Extended Points.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
    // Cost: 9M + 1*a + 1*d + 7add.
    add(R) {
      L(R);
      const { a: N, d: O } = e, { ex: g, ey: M, ez: Y, et: se } = this, { ex: V, ey: K, ez: Z, et: ne } = R;
      if (N === BigInt(-1)) {
        const Bt = u((M - g) * (K + V)), pt = u((M + g) * (K - V)), de = u(pt - Bt);
        if (de === ds)
          return this.double();
        const he = u(Y * Eh * ne), Ie = u(se * Eh * Z), z = Ie + he, k = pt + Bt, B = Ie - he, A = u(z * de), m = u(k * B), S = u(z * B), q = u(de * k);
        return new P(A, m, q, S);
      }
      const ce = u(g * V), H = u(M * K), J = u(se * O * ne), le = u(Y * Z), me = u((g + M) * (V + K) - ce - H), Ue = le - J, Ve = le + J, ze = u(H - N * ce), at = u(me * Ue), xe = u(Ve * ze), gt = u(me * ze), ht = u(Ue * Ve);
      return new P(at, xe, ht, gt);
    }
    subtract(R) {
      return this.add(R.negate());
    }
    wNAF(R) {
      return F.wNAFCached(this, I, R, P.normalizeZ);
    }
    // Constant-time multiplication.
    multiply(R) {
      const { p: N, f: O } = this.wNAF(v(R, n));
      return P.normalizeZ([N, O])[0];
    }
    // Non-constant-time multiplication. Uses double-and-add algorithm.
    // It's faster, but should only be used when you don't care about
    // an exposed private key e.g. sig verification.
    // Does NOT allow scalars higher than CURVE.n.
    multiplyUnsafe(R) {
      let N = x(R);
      return N === ds ? D : this.equals(D) || N === Oi ? this : this.equals(C) ? this.wNAF(N).p : F.unsafeLadder(this, N);
    }
    // Checks if point is of small order.
    // If you add something to small order point, you will have "dirty"
    // point with torsion component.
    // Multiplies point by cofactor and checks if the result is 0.
    isSmallOrder() {
      return this.multiplyUnsafe(c).is0();
    }
    // Multiplies point by curve order and checks if the result is 0.
    // Returns `false` is the point is dirty.
    isTorsionFree() {
      return F.unsafeLadder(this, n).is0();
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    toAffine(R) {
      const { ex: N, ey: O, ez: g } = this, M = this.is0();
      R == null && (R = M ? JY : r.inv(g));
      const Y = u(N * R), se = u(O * R), V = u(g * R);
      if (M)
        return { x: ds, y: Oi };
      if (V !== Oi)
        throw new Error("invZ was invalid");
      return { x: Y, y: se };
    }
    clearCofactor() {
      const { h: R } = e;
      return R === Oi ? this : this.multiplyUnsafe(R);
    }
    // Converts hash string or Uint8Array to Point.
    // Uses algo from RFC8032 5.1.3.
    static fromHex(R, N = !1) {
      const { d: O, a: g } = e, M = r.BYTES;
      R = xn("pointHex", R, M);
      const Y = R.slice(), se = R[M - 1];
      Y[M - 1] = se & -129;
      const V = Ru(Y);
      V === ds || (N ? v(V, f) : v(V, r.ORDER));
      const K = u(V * V), Z = u(K - Oi), ne = u(O * K - g);
      let { isValid: ce, value: H } = d(Z, ne);
      if (!ce)
        throw new Error("Point.fromHex: invalid y coordinate");
      const J = (H & Oi) === Oi, le = (se & 128) !== 0;
      if (!N && H === ds && le)
        throw new Error("Point.fromHex: x=0 and x_0=1");
      return le !== J && (H = u(-H)), P.fromAffine({ x: H, y: V });
    }
    static fromPrivateKey(R) {
      return ie(R).point;
    }
    toRawBytes() {
      const { x: R, y: N } = this.toAffine(), O = Wd(N, r.BYTES);
      return O[O.length - 1] |= R & Oi ? 128 : 0, O;
    }
    toHex() {
      return Pc(this.toRawBytes());
    }
  }
  P.BASE = new P(e.Gx, e.Gy, Oi, u(e.Gx * e.Gy)), P.ZERO = new P(ds, Oi, Oi, ds);
  const { BASE: C, ZERO: D } = P, F = tk(P, o * 8);
  function G(_) {
    return Qr(_, n);
  }
  function re(_) {
    return G(Ru(_));
  }
  function ie(_) {
    const R = o;
    _ = xn("private key", _, R);
    const N = xn("hashed private key", s(_), 2 * R), O = l(N.slice(0, R)), g = N.slice(R, 2 * R), M = re(O), Y = C.multiply(M), se = Y.toRawBytes();
    return { head: O, prefix: g, scalar: M, point: Y, pointBytes: se };
  }
  function ee(_) {
    return ie(_).pointBytes;
  }
  function $(_ = new Uint8Array(), ...R) {
    const N = Oc(...R);
    return re(s(h(N, xn("context", _), !!i)));
  }
  function w(_, R, N = {}) {
    _ = xn("message", _), i && (_ = i(_));
    const { prefix: O, scalar: g, pointBytes: M } = ie(R), Y = $(N.context, O, _), se = C.multiply(Y).toRawBytes(), V = $(N.context, se, M, _), K = G(Y + V * g);
    x(K);
    const Z = Oc(se, Wd(K, r.BYTES));
    return xn("result", Z, o * 2);
  }
  const E = YY;
  function U(_, R, N, O = E) {
    const { context: g, zip215: M } = O, Y = r.BYTES;
    _ = xn("signature", _, 2 * Y), R = xn("message", R), i && (R = i(R));
    const se = Ru(_.slice(Y, 2 * Y));
    let V, K, Z;
    try {
      V = P.fromHex(N, M), K = P.fromHex(_.slice(0, Y), M), Z = C.multiplyUnsafe(se);
    } catch {
      return !1;
    }
    if (!M && V.isSmallOrder())
      return !1;
    const ne = $(g, K.toRawBytes(), V.toRawBytes(), R);
    return K.add(V.multiplyUnsafe(ne)).subtract(Z).clearCofactor().equals(P.ZERO);
  }
  return C._setWindowSize(8), {
    CURVE: e,
    getPublicKey: ee,
    sign: w,
    verify: U,
    ExtendedPoint: P,
    utils: {
      getExtendedPublicKey: ie,
      // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
      randomPrivateKey: () => a(r.BYTES),
      /**
       * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
       * values. This slows down first getPublicKey() by milliseconds (see Speed section),
       * but allows to speed-up subsequent getPublicKey() calls up to 20x.
       * @param windowSize 2, 4, 8, 16
       */
      precompute(_ = 8, R = P.BASE) {
        return R._setWindowSize(_), R.multiply(BigInt(3)), R;
      }
    }
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const y_ = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), G8 = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const XY = BigInt(1), Wv = BigInt(2), eQ = BigInt(5), Z8 = BigInt(10), tQ = BigInt(20), rQ = BigInt(40), J8 = BigInt(80);
function nQ(t) {
  const e = y_, n = t * t % e * t % e, i = un(n, Wv, e) * n % e, s = un(i, XY, e) * t % e, a = un(s, eQ, e) * s % e, o = un(a, Z8, e) * a % e, c = un(o, tQ, e) * o % e, f = un(c, rQ, e) * c % e, u = un(f, J8, e) * f % e, d = un(u, J8, e) * f % e, l = un(d, Z8, e) * a % e;
  return { pow_p_5_8: un(l, Wv, e) * t % e, b2: n };
}
function iQ(t) {
  return t[0] &= 248, t[31] &= 127, t[31] |= 64, t;
}
function sQ(t, e) {
  const r = y_, n = Qr(e * e * e, r), i = Qr(n * n * e, r), s = nQ(t * i).pow_p_5_8;
  let a = Qr(t * n * s, r);
  const o = Qr(e * a * a, r), c = a, f = Qr(a * G8, r), u = o === t, d = o === Qr(-t, r), l = o === Qr(-t * G8, r);
  return u && (a = c), (d || l) && (a = f), qY(a, r) && (a = Qr(-a, r)), { isValid: u || d, value: a };
}
const Ba = QT(y_, void 0, !0), b_ = {
  // Param: a
  a: BigInt(-1),
  // Fp.create(-1) is proper; our way still works and is faster
  // d is equal to -121665/121666 over finite field.
  // Negative number is P - number, and division is invert(number, P)
  d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
  // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
  Fp: Ba,
  // Subgroup order: how many points curve has
  // 2n**252n + 27742317777372353535851937790883648493n;
  n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
  // Cofactor
  h: BigInt(8),
  // Base point (x, y) aka generator point
  Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
  Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
  hash: HT,
  randomBytes: FT,
  adjustScalarBytes: iQ,
  // dom2
  // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
  // Constant-time, u/√v
  uvRatio: sQ
}, kf = /* @__PURE__ */ p_(b_);
function rk(t, e, r) {
  if (e.length > 255)
    throw new Error("Context is too big");
  return DT(LT("SigEd25519 no Ed25519 collisions"), new Uint8Array([r ? 1 : 0, e.length]), e, t);
}
({
  ...b_
});
({
  ...b_
});
const aQ = (Ba.ORDER + BigInt(3)) / BigInt(8);
Ba.pow(Wv, aQ);
Ba.sqrt(Ba.neg(Ba.ONE));
(Ba.ORDER - BigInt(5)) / BigInt(8);
BigInt(486662);
HY(Ba, Ba.neg(BigInt(486664)));
BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const oQ = (t, e, r) => t & e ^ ~t & r, cQ = (t, e, r) => t & e ^ t & r ^ e & r, uQ = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Ga = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Za = /* @__PURE__ */ new Uint32Array(64);
class fQ extends jT {
  constructor() {
    super(64, 32, 8, !1), this.A = Ga[0] | 0, this.B = Ga[1] | 0, this.C = Ga[2] | 0, this.D = Ga[3] | 0, this.E = Ga[4] | 0, this.F = Ga[5] | 0, this.G = Ga[6] | 0, this.H = Ga[7] | 0;
  }
  get() {
    const { A: e, B: r, C: n, D: i, E: s, F: a, G: o, H: c } = this;
    return [e, r, n, i, s, a, o, c];
  }
  // prettier-ignore
  set(e, r, n, i, s, a, o, c) {
    this.A = e | 0, this.B = r | 0, this.C = n | 0, this.D = i | 0, this.E = s | 0, this.F = a | 0, this.G = o | 0, this.H = c | 0;
  }
  process(e, r) {
    for (let d = 0; d < 16; d++, r += 4)
      Za[d] = e.getUint32(r, !1);
    for (let d = 16; d < 64; d++) {
      const l = Za[d - 15], h = Za[d - 2], y = Ls(l, 7) ^ Ls(l, 18) ^ l >>> 3, p = Ls(h, 17) ^ Ls(h, 19) ^ h >>> 10;
      Za[d] = p + Za[d - 7] + y + Za[d - 16] | 0;
    }
    let { A: n, B: i, C: s, D: a, E: o, F: c, G: f, H: u } = this;
    for (let d = 0; d < 64; d++) {
      const l = Ls(o, 6) ^ Ls(o, 11) ^ Ls(o, 25), h = u + l + oQ(o, c, f) + uQ[d] + Za[d] | 0, p = (Ls(n, 2) ^ Ls(n, 13) ^ Ls(n, 22)) + cQ(n, i, s) | 0;
      u = f, f = c, c = o, o = a + h | 0, a = s, s = i, i = n, n = h + p | 0;
    }
    n = n + this.A | 0, i = i + this.B | 0, s = s + this.C | 0, a = a + this.D | 0, o = o + this.E | 0, c = c + this.F | 0, f = f + this.G | 0, u = u + this.H | 0, this.set(n, i, s, a, o, c, f, u);
  }
  roundClean() {
    Za.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const zv = /* @__PURE__ */ f_(() => new fQ());
var $l = {};
Object.defineProperty($l, "__esModule", { value: !0 });
function dQ(t) {
  {
    const e = ve.from(t);
    e.reverse();
    const r = e.toString("hex");
    return r.length === 0 ? BigInt(0) : BigInt(`0x${r}`);
  }
}
var lQ = $l.toBigIntLE = dQ;
function hQ(t) {
  {
    const e = t.toString("hex");
    return e.length === 0 ? BigInt(0) : BigInt(`0x${e}`);
  }
}
$l.toBigIntBE = hQ;
function pQ(t, e) {
  {
    const r = t.toString(16), n = ve.from(r.padStart(e * 2, "0").slice(0, e * 2), "hex");
    return n.reverse(), n;
  }
}
var nk = $l.toBufferLE = pQ;
function yQ(t, e) {
  {
    const r = t.toString(16);
    return ve.from(r.padStart(e * 2, "0").slice(0, e * 2), "hex");
  }
}
$l.toBufferBE = yQ;
var xh, bQ = new Uint8Array(16);
function ik() {
  if (!xh && (xh = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !xh))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return xh(bQ);
}
const gQ = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Ny(t) {
  return typeof t == "string" && gQ.test(t);
}
var jn = [];
for (var em = 0; em < 256; ++em)
  jn.push((em + 256).toString(16).substr(1));
function Uy(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (jn[t[e + 0]] + jn[t[e + 1]] + jn[t[e + 2]] + jn[t[e + 3]] + "-" + jn[t[e + 4]] + jn[t[e + 5]] + "-" + jn[t[e + 6]] + jn[t[e + 7]] + "-" + jn[t[e + 8]] + jn[t[e + 9]] + "-" + jn[t[e + 10]] + jn[t[e + 11]] + jn[t[e + 12]] + jn[t[e + 13]] + jn[t[e + 14]] + jn[t[e + 15]]).toLowerCase();
  if (!Ny(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
var Y8, tm, rm = 0, nm = 0;
function mQ(t, e, r) {
  var n = e && r || 0, i = e || new Array(16);
  t = t || {};
  var s = t.node || Y8, a = t.clockseq !== void 0 ? t.clockseq : tm;
  if (s == null || a == null) {
    var o = t.random || (t.rng || ik)();
    s == null && (s = Y8 = [o[0] | 1, o[1], o[2], o[3], o[4], o[5]]), a == null && (a = tm = (o[6] << 8 | o[7]) & 16383);
  }
  var c = t.msecs !== void 0 ? t.msecs : Date.now(), f = t.nsecs !== void 0 ? t.nsecs : nm + 1, u = c - rm + (f - nm) / 1e4;
  if (u < 0 && t.clockseq === void 0 && (a = a + 1 & 16383), (u < 0 || c > rm) && t.nsecs === void 0 && (f = 0), f >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  rm = c, nm = f, tm = a, c += 122192928e5;
  var d = ((c & 268435455) * 1e4 + f) % 4294967296;
  i[n++] = d >>> 24 & 255, i[n++] = d >>> 16 & 255, i[n++] = d >>> 8 & 255, i[n++] = d & 255;
  var l = c / 4294967296 * 1e4 & 268435455;
  i[n++] = l >>> 8 & 255, i[n++] = l & 255, i[n++] = l >>> 24 & 15 | 16, i[n++] = l >>> 16 & 255, i[n++] = a >>> 8 | 128, i[n++] = a & 255;
  for (var h = 0; h < 6; ++h)
    i[n + h] = s[h];
  return e || Uy(i);
}
function sk(t) {
  if (!Ny(t))
    throw TypeError("Invalid UUID");
  var e, r = new Uint8Array(16);
  return r[0] = (e = parseInt(t.slice(0, 8), 16)) >>> 24, r[1] = e >>> 16 & 255, r[2] = e >>> 8 & 255, r[3] = e & 255, r[4] = (e = parseInt(t.slice(9, 13), 16)) >>> 8, r[5] = e & 255, r[6] = (e = parseInt(t.slice(14, 18), 16)) >>> 8, r[7] = e & 255, r[8] = (e = parseInt(t.slice(19, 23), 16)) >>> 8, r[9] = e & 255, r[10] = (e = parseInt(t.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = e / 4294967296 & 255, r[12] = e >>> 24 & 255, r[13] = e >>> 16 & 255, r[14] = e >>> 8 & 255, r[15] = e & 255, r;
}
function vQ(t) {
  t = unescape(encodeURIComponent(t));
  for (var e = [], r = 0; r < t.length; ++r)
    e.push(t.charCodeAt(r));
  return e;
}
var wQ = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", _Q = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function ak(t, e, r) {
  function n(i, s, a, o) {
    if (typeof i == "string" && (i = vQ(i)), typeof s == "string" && (s = sk(s)), s.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var c = new Uint8Array(16 + i.length);
    if (c.set(s), c.set(i, s.length), c = r(c), c[6] = c[6] & 15 | e, c[8] = c[8] & 63 | 128, a) {
      o = o || 0;
      for (var f = 0; f < 16; ++f)
        a[o + f] = c[f];
      return a;
    }
    return Uy(c);
  }
  try {
    n.name = t;
  } catch {
  }
  return n.DNS = wQ, n.URL = _Q, n;
}
function SQ(t) {
  if (typeof t == "string") {
    var e = unescape(encodeURIComponent(t));
    t = new Uint8Array(e.length);
    for (var r = 0; r < e.length; ++r)
      t[r] = e.charCodeAt(r);
  }
  return EQ(xQ(AQ(t), t.length * 8));
}
function EQ(t) {
  for (var e = [], r = t.length * 32, n = "0123456789abcdef", i = 0; i < r; i += 8) {
    var s = t[i >> 5] >>> i % 32 & 255, a = parseInt(n.charAt(s >>> 4 & 15) + n.charAt(s & 15), 16);
    e.push(a);
  }
  return e;
}
function ok(t) {
  return (t + 64 >>> 9 << 4) + 14 + 1;
}
function xQ(t, e) {
  t[e >> 5] |= 128 << e % 32, t[ok(e) - 1] = e;
  for (var r = 1732584193, n = -271733879, i = -1732584194, s = 271733878, a = 0; a < t.length; a += 16) {
    var o = r, c = n, f = i, u = s;
    r = ii(r, n, i, s, t[a], 7, -680876936), s = ii(s, r, n, i, t[a + 1], 12, -389564586), i = ii(i, s, r, n, t[a + 2], 17, 606105819), n = ii(n, i, s, r, t[a + 3], 22, -1044525330), r = ii(r, n, i, s, t[a + 4], 7, -176418897), s = ii(s, r, n, i, t[a + 5], 12, 1200080426), i = ii(i, s, r, n, t[a + 6], 17, -1473231341), n = ii(n, i, s, r, t[a + 7], 22, -45705983), r = ii(r, n, i, s, t[a + 8], 7, 1770035416), s = ii(s, r, n, i, t[a + 9], 12, -1958414417), i = ii(i, s, r, n, t[a + 10], 17, -42063), n = ii(n, i, s, r, t[a + 11], 22, -1990404162), r = ii(r, n, i, s, t[a + 12], 7, 1804603682), s = ii(s, r, n, i, t[a + 13], 12, -40341101), i = ii(i, s, r, n, t[a + 14], 17, -1502002290), n = ii(n, i, s, r, t[a + 15], 22, 1236535329), r = si(r, n, i, s, t[a + 1], 5, -165796510), s = si(s, r, n, i, t[a + 6], 9, -1069501632), i = si(i, s, r, n, t[a + 11], 14, 643717713), n = si(n, i, s, r, t[a], 20, -373897302), r = si(r, n, i, s, t[a + 5], 5, -701558691), s = si(s, r, n, i, t[a + 10], 9, 38016083), i = si(i, s, r, n, t[a + 15], 14, -660478335), n = si(n, i, s, r, t[a + 4], 20, -405537848), r = si(r, n, i, s, t[a + 9], 5, 568446438), s = si(s, r, n, i, t[a + 14], 9, -1019803690), i = si(i, s, r, n, t[a + 3], 14, -187363961), n = si(n, i, s, r, t[a + 8], 20, 1163531501), r = si(r, n, i, s, t[a + 13], 5, -1444681467), s = si(s, r, n, i, t[a + 2], 9, -51403784), i = si(i, s, r, n, t[a + 7], 14, 1735328473), n = si(n, i, s, r, t[a + 12], 20, -1926607734), r = ai(r, n, i, s, t[a + 5], 4, -378558), s = ai(s, r, n, i, t[a + 8], 11, -2022574463), i = ai(i, s, r, n, t[a + 11], 16, 1839030562), n = ai(n, i, s, r, t[a + 14], 23, -35309556), r = ai(r, n, i, s, t[a + 1], 4, -1530992060), s = ai(s, r, n, i, t[a + 4], 11, 1272893353), i = ai(i, s, r, n, t[a + 7], 16, -155497632), n = ai(n, i, s, r, t[a + 10], 23, -1094730640), r = ai(r, n, i, s, t[a + 13], 4, 681279174), s = ai(s, r, n, i, t[a], 11, -358537222), i = ai(i, s, r, n, t[a + 3], 16, -722521979), n = ai(n, i, s, r, t[a + 6], 23, 76029189), r = ai(r, n, i, s, t[a + 9], 4, -640364487), s = ai(s, r, n, i, t[a + 12], 11, -421815835), i = ai(i, s, r, n, t[a + 15], 16, 530742520), n = ai(n, i, s, r, t[a + 2], 23, -995338651), r = oi(r, n, i, s, t[a], 6, -198630844), s = oi(s, r, n, i, t[a + 7], 10, 1126891415), i = oi(i, s, r, n, t[a + 14], 15, -1416354905), n = oi(n, i, s, r, t[a + 5], 21, -57434055), r = oi(r, n, i, s, t[a + 12], 6, 1700485571), s = oi(s, r, n, i, t[a + 3], 10, -1894986606), i = oi(i, s, r, n, t[a + 10], 15, -1051523), n = oi(n, i, s, r, t[a + 1], 21, -2054922799), r = oi(r, n, i, s, t[a + 8], 6, 1873313359), s = oi(s, r, n, i, t[a + 15], 10, -30611744), i = oi(i, s, r, n, t[a + 6], 15, -1560198380), n = oi(n, i, s, r, t[a + 13], 21, 1309151649), r = oi(r, n, i, s, t[a + 4], 6, -145523070), s = oi(s, r, n, i, t[a + 11], 10, -1120210379), i = oi(i, s, r, n, t[a + 2], 15, 718787259), n = oi(n, i, s, r, t[a + 9], 21, -343485551), r = uo(r, o), n = uo(n, c), i = uo(i, f), s = uo(s, u);
  }
  return [r, n, i, s];
}
function AQ(t) {
  if (t.length === 0)
    return [];
  for (var e = t.length * 8, r = new Uint32Array(ok(e)), n = 0; n < e; n += 8)
    r[n >> 5] |= (t[n / 8] & 255) << n % 32;
  return r;
}
function uo(t, e) {
  var r = (t & 65535) + (e & 65535), n = (t >> 16) + (e >> 16) + (r >> 16);
  return n << 16 | r & 65535;
}
function IQ(t, e) {
  return t << e | t >>> 32 - e;
}
function Ly(t, e, r, n, i, s) {
  return uo(IQ(uo(uo(e, t), uo(n, s)), i), r);
}
function ii(t, e, r, n, i, s, a) {
  return Ly(e & r | ~e & n, t, e, i, s, a);
}
function si(t, e, r, n, i, s, a) {
  return Ly(e & n | r & ~n, t, e, i, s, a);
}
function ai(t, e, r, n, i, s, a) {
  return Ly(e ^ r ^ n, t, e, i, s, a);
}
function oi(t, e, r, n, i, s, a) {
  return Ly(r ^ (e | ~n), t, e, i, s, a);
}
var TQ = ak("v3", 48, SQ);
const kQ = TQ;
function RQ(t, e, r) {
  t = t || {};
  var n = t.random || (t.rng || ik)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    r = r || 0;
    for (var i = 0; i < 16; ++i)
      e[r + i] = n[i];
    return e;
  }
  return Uy(n);
}
function PQ(t, e, r, n) {
  switch (t) {
    case 0:
      return e & r ^ ~e & n;
    case 1:
      return e ^ r ^ n;
    case 2:
      return e & r ^ e & n ^ r & n;
    case 3:
      return e ^ r ^ n;
  }
}
function im(t, e) {
  return t << e | t >>> 32 - e;
}
function OQ(t) {
  var e = [1518500249, 1859775393, 2400959708, 3395469782], r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof t == "string") {
    var n = unescape(encodeURIComponent(t));
    t = [];
    for (var i = 0; i < n.length; ++i)
      t.push(n.charCodeAt(i));
  } else
    Array.isArray(t) || (t = Array.prototype.slice.call(t));
  t.push(128);
  for (var s = t.length / 4 + 2, a = Math.ceil(s / 16), o = new Array(a), c = 0; c < a; ++c) {
    for (var f = new Uint32Array(16), u = 0; u < 16; ++u)
      f[u] = t[c * 64 + u * 4] << 24 | t[c * 64 + u * 4 + 1] << 16 | t[c * 64 + u * 4 + 2] << 8 | t[c * 64 + u * 4 + 3];
    o[c] = f;
  }
  o[a - 1][14] = (t.length - 1) * 8 / Math.pow(2, 32), o[a - 1][14] = Math.floor(o[a - 1][14]), o[a - 1][15] = (t.length - 1) * 8 & 4294967295;
  for (var d = 0; d < a; ++d) {
    for (var l = new Uint32Array(80), h = 0; h < 16; ++h)
      l[h] = o[d][h];
    for (var y = 16; y < 80; ++y)
      l[y] = im(l[y - 3] ^ l[y - 8] ^ l[y - 14] ^ l[y - 16], 1);
    for (var p = r[0], b = r[1], v = r[2], x = r[3], I = r[4], L = 0; L < 80; ++L) {
      var P = Math.floor(L / 20), C = im(p, 5) + PQ(P, b, v, x) + I + e[P] + l[L] >>> 0;
      I = x, x = v, v = im(b, 30) >>> 0, b = p, p = C;
    }
    r[0] = r[0] + p >>> 0, r[1] = r[1] + b >>> 0, r[2] = r[2] + v >>> 0, r[3] = r[3] + x >>> 0, r[4] = r[4] + I >>> 0;
  }
  return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, r[0] & 255, r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, r[1] & 255, r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, r[2] & 255, r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, r[3] & 255, r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, r[4] & 255];
}
var BQ = ak("v5", 80, OQ);
const MQ = BQ, CQ = "00000000-0000-0000-0000-000000000000";
function NQ(t) {
  if (!Ny(t))
    throw TypeError("Invalid UUID");
  return parseInt(t.substr(14, 1), 16);
}
const UQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: CQ,
  parse: sk,
  stringify: Uy,
  v1: mQ,
  v3: kQ,
  v4: RQ,
  v5: MQ,
  validate: Ny,
  version: NQ
}, Symbol.toStringTag, { value: "Module" })), ck = /* @__PURE__ */ ta(UQ), LQ = ck.v4, DQ = function(t, e, r, n) {
  if (typeof t != "string")
    throw new TypeError(t + " must be a string");
  n = n || {};
  const i = typeof n.version == "number" ? n.version : 2;
  if (i !== 1 && i !== 2)
    throw new TypeError(i + " must be 1 or 2");
  const s = {
    method: t
  };
  if (i === 2 && (s.jsonrpc = "2.0"), e) {
    if (typeof e != "object" && !Array.isArray(e))
      throw new TypeError(e + " must be an object, array or omitted");
    s.params = e;
  }
  if (typeof r > "u") {
    const a = typeof n.generator == "function" ? n.generator : function() {
      return LQ();
    };
    s.id = a(s, n);
  } else
    i === 2 && r === null ? n.notificationIdNull && (s.id = null) : s.id = r;
  return s;
};
var FQ = DQ;
const jQ = ck.v4, $Q = FQ, zd = function(t, e) {
  if (!(this instanceof zd))
    return new zd(t, e);
  e || (e = {}), this.options = {
    reviver: typeof e.reviver < "u" ? e.reviver : null,
    replacer: typeof e.replacer < "u" ? e.replacer : null,
    generator: typeof e.generator < "u" ? e.generator : function() {
      return jQ();
    },
    version: typeof e.version < "u" ? e.version : 2,
    notificationIdNull: typeof e.notificationIdNull == "boolean" ? e.notificationIdNull : !1
  }, this.callServer = t;
};
var qQ = zd;
zd.prototype.request = function(t, e, r, n) {
  const i = this;
  let s = null;
  const a = Array.isArray(t) && typeof e == "function";
  if (this.options.version === 1 && a)
    throw new TypeError("JSON-RPC 1.0 does not support batching");
  if (a || !a && t && typeof t == "object" && typeof e == "function")
    n = e, s = t;
  else {
    typeof r == "function" && (n = r, r = void 0);
    const f = typeof n == "function";
    try {
      s = $Q(t, e, r, {
        generator: this.options.generator,
        version: this.options.version,
        notificationIdNull: this.options.notificationIdNull
      });
    } catch (u) {
      if (f)
        return n(u);
      throw u;
    }
    if (!f)
      return s;
  }
  let c;
  try {
    c = JSON.stringify(s, this.options.replacer);
  } catch (f) {
    return n(f);
  }
  return this.callServer(c, function(f, u) {
    i._parseResponse(f, u, n);
  }), s;
};
zd.prototype._parseResponse = function(t, e, r) {
  if (t) {
    r(t);
    return;
  }
  if (!e)
    return r();
  let n;
  try {
    n = JSON.parse(e, this.options.reviver);
  } catch (i) {
    return r(i);
  }
  if (r.length === 3)
    if (Array.isArray(n)) {
      const i = function(a) {
        return typeof a.error < "u";
      }, s = function(a) {
        return !i(a);
      };
      return r(null, n.filter(i), n.filter(s));
    } else
      return r(null, n.error, n.result);
  r(null, n);
};
const WQ = /* @__PURE__ */ Ln(qQ);
var uk = {}, fk = { exports: {} };
(function(t) {
  function e(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(fk);
var dk = fk.exports, sm = { exports: {} }, am = { exports: {} }, Q8;
function ql() {
  return Q8 || (Q8 = 1, function(t) {
    function e(r) {
      "@babel/helpers - typeof";
      return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(am)), am.exports;
}
var X8;
function zQ() {
  return X8 || (X8 = 1, function(t) {
    var e = ql().default;
    function r() {
      t.exports = r = function() {
        return i;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
      var n, i = {}, s = Object.prototype, a = s.hasOwnProperty, o = Object.defineProperty || function(R, N, O) {
        R[N] = O.value;
      }, c = typeof Symbol == "function" ? Symbol : {}, f = c.iterator || "@@iterator", u = c.asyncIterator || "@@asyncIterator", d = c.toStringTag || "@@toStringTag";
      function l(R, N, O) {
        return Object.defineProperty(R, N, {
          value: O,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), R[N];
      }
      try {
        l({}, "");
      } catch {
        l = function(O, g, M) {
          return O[g] = M;
        };
      }
      function h(R, N, O, g) {
        var M = N && N.prototype instanceof L ? N : L, Y = Object.create(M.prototype), se = new W(g || []);
        return o(Y, "_invoke", {
          value: $(R, O, se)
        }), Y;
      }
      function y(R, N, O) {
        try {
          return {
            type: "normal",
            arg: R.call(N, O)
          };
        } catch (g) {
          return {
            type: "throw",
            arg: g
          };
        }
      }
      i.wrap = h;
      var p = "suspendedStart", b = "suspendedYield", v = "executing", x = "completed", I = {};
      function L() {
      }
      function P() {
      }
      function C() {
      }
      var D = {};
      l(D, f, function() {
        return this;
      });
      var F = Object.getPrototypeOf, G = F && F(F(_([])));
      G && G !== s && a.call(G, f) && (D = G);
      var re = C.prototype = L.prototype = Object.create(D);
      function ie(R) {
        ["next", "throw", "return"].forEach(function(N) {
          l(R, N, function(O) {
            return this._invoke(N, O);
          });
        });
      }
      function ee(R, N) {
        function O(M, Y, se, V) {
          var K = y(R[M], R, Y);
          if (K.type !== "throw") {
            var Z = K.arg, ne = Z.value;
            return ne && e(ne) == "object" && a.call(ne, "__await") ? N.resolve(ne.__await).then(function(ce) {
              O("next", ce, se, V);
            }, function(ce) {
              O("throw", ce, se, V);
            }) : N.resolve(ne).then(function(ce) {
              Z.value = ce, se(Z);
            }, function(ce) {
              return O("throw", ce, se, V);
            });
          }
          V(K.arg);
        }
        var g;
        o(this, "_invoke", {
          value: function(Y, se) {
            function V() {
              return new N(function(K, Z) {
                O(Y, se, K, Z);
              });
            }
            return g = g ? g.then(V, V) : V();
          }
        });
      }
      function $(R, N, O) {
        var g = p;
        return function(M, Y) {
          if (g === v)
            throw new Error("Generator is already running");
          if (g === x) {
            if (M === "throw")
              throw Y;
            return {
              value: n,
              done: !0
            };
          }
          for (O.method = M, O.arg = Y; ; ) {
            var se = O.delegate;
            if (se) {
              var V = w(se, O);
              if (V) {
                if (V === I)
                  continue;
                return V;
              }
            }
            if (O.method === "next")
              O.sent = O._sent = O.arg;
            else if (O.method === "throw") {
              if (g === p)
                throw g = x, O.arg;
              O.dispatchException(O.arg);
            } else
              O.method === "return" && O.abrupt("return", O.arg);
            g = v;
            var K = y(R, N, O);
            if (K.type === "normal") {
              if (g = O.done ? x : b, K.arg === I)
                continue;
              return {
                value: K.arg,
                done: O.done
              };
            }
            K.type === "throw" && (g = x, O.method = "throw", O.arg = K.arg);
          }
        };
      }
      function w(R, N) {
        var O = N.method, g = R.iterator[O];
        if (g === n)
          return N.delegate = null, O === "throw" && R.iterator.return && (N.method = "return", N.arg = n, w(R, N), N.method === "throw") || O !== "return" && (N.method = "throw", N.arg = new TypeError("The iterator does not provide a '" + O + "' method")), I;
        var M = y(g, R.iterator, N.arg);
        if (M.type === "throw")
          return N.method = "throw", N.arg = M.arg, N.delegate = null, I;
        var Y = M.arg;
        return Y ? Y.done ? (N[R.resultName] = Y.value, N.next = R.nextLoc, N.method !== "return" && (N.method = "next", N.arg = n), N.delegate = null, I) : Y : (N.method = "throw", N.arg = new TypeError("iterator result is not an object"), N.delegate = null, I);
      }
      function E(R) {
        var N = {
          tryLoc: R[0]
        };
        1 in R && (N.catchLoc = R[1]), 2 in R && (N.finallyLoc = R[2], N.afterLoc = R[3]), this.tryEntries.push(N);
      }
      function U(R) {
        var N = R.completion || {};
        N.type = "normal", delete N.arg, R.completion = N;
      }
      function W(R) {
        this.tryEntries = [{
          tryLoc: "root"
        }], R.forEach(E, this), this.reset(!0);
      }
      function _(R) {
        if (R || R === "") {
          var N = R[f];
          if (N)
            return N.call(R);
          if (typeof R.next == "function")
            return R;
          if (!isNaN(R.length)) {
            var O = -1, g = function M() {
              for (; ++O < R.length; )
                if (a.call(R, O))
                  return M.value = R[O], M.done = !1, M;
              return M.value = n, M.done = !0, M;
            };
            return g.next = g;
          }
        }
        throw new TypeError(e(R) + " is not iterable");
      }
      return P.prototype = C, o(re, "constructor", {
        value: C,
        configurable: !0
      }), o(C, "constructor", {
        value: P,
        configurable: !0
      }), P.displayName = l(C, d, "GeneratorFunction"), i.isGeneratorFunction = function(R) {
        var N = typeof R == "function" && R.constructor;
        return !!N && (N === P || (N.displayName || N.name) === "GeneratorFunction");
      }, i.mark = function(R) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(R, C) : (R.__proto__ = C, l(R, d, "GeneratorFunction")), R.prototype = Object.create(re), R;
      }, i.awrap = function(R) {
        return {
          __await: R
        };
      }, ie(ee.prototype), l(ee.prototype, u, function() {
        return this;
      }), i.AsyncIterator = ee, i.async = function(R, N, O, g, M) {
        M === void 0 && (M = Promise);
        var Y = new ee(h(R, N, O, g), M);
        return i.isGeneratorFunction(N) ? Y : Y.next().then(function(se) {
          return se.done ? se.value : Y.next();
        });
      }, ie(re), l(re, d, "Generator"), l(re, f, function() {
        return this;
      }), l(re, "toString", function() {
        return "[object Generator]";
      }), i.keys = function(R) {
        var N = Object(R), O = [];
        for (var g in N)
          O.push(g);
        return O.reverse(), function M() {
          for (; O.length; ) {
            var Y = O.pop();
            if (Y in N)
              return M.value = Y, M.done = !1, M;
          }
          return M.done = !0, M;
        };
      }, i.values = _, W.prototype = {
        constructor: W,
        reset: function(N) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = n, this.done = !1, this.delegate = null, this.method = "next", this.arg = n, this.tryEntries.forEach(U), !N)
            for (var O in this)
              O.charAt(0) === "t" && a.call(this, O) && !isNaN(+O.slice(1)) && (this[O] = n);
        },
        stop: function() {
          this.done = !0;
          var N = this.tryEntries[0].completion;
          if (N.type === "throw")
            throw N.arg;
          return this.rval;
        },
        dispatchException: function(N) {
          if (this.done)
            throw N;
          var O = this;
          function g(Z, ne) {
            return se.type = "throw", se.arg = N, O.next = Z, ne && (O.method = "next", O.arg = n), !!ne;
          }
          for (var M = this.tryEntries.length - 1; M >= 0; --M) {
            var Y = this.tryEntries[M], se = Y.completion;
            if (Y.tryLoc === "root")
              return g("end");
            if (Y.tryLoc <= this.prev) {
              var V = a.call(Y, "catchLoc"), K = a.call(Y, "finallyLoc");
              if (V && K) {
                if (this.prev < Y.catchLoc)
                  return g(Y.catchLoc, !0);
                if (this.prev < Y.finallyLoc)
                  return g(Y.finallyLoc);
              } else if (V) {
                if (this.prev < Y.catchLoc)
                  return g(Y.catchLoc, !0);
              } else {
                if (!K)
                  throw new Error("try statement without catch or finally");
                if (this.prev < Y.finallyLoc)
                  return g(Y.finallyLoc);
              }
            }
          }
        },
        abrupt: function(N, O) {
          for (var g = this.tryEntries.length - 1; g >= 0; --g) {
            var M = this.tryEntries[g];
            if (M.tryLoc <= this.prev && a.call(M, "finallyLoc") && this.prev < M.finallyLoc) {
              var Y = M;
              break;
            }
          }
          Y && (N === "break" || N === "continue") && Y.tryLoc <= O && O <= Y.finallyLoc && (Y = null);
          var se = Y ? Y.completion : {};
          return se.type = N, se.arg = O, Y ? (this.method = "next", this.next = Y.finallyLoc, I) : this.complete(se);
        },
        complete: function(N, O) {
          if (N.type === "throw")
            throw N.arg;
          return N.type === "break" || N.type === "continue" ? this.next = N.arg : N.type === "return" ? (this.rval = this.arg = N.arg, this.method = "return", this.next = "end") : N.type === "normal" && O && (this.next = O), I;
        },
        finish: function(N) {
          for (var O = this.tryEntries.length - 1; O >= 0; --O) {
            var g = this.tryEntries[O];
            if (g.finallyLoc === N)
              return this.complete(g.completion, g.afterLoc), U(g), I;
          }
        },
        catch: function(N) {
          for (var O = this.tryEntries.length - 1; O >= 0; --O) {
            var g = this.tryEntries[O];
            if (g.tryLoc === N) {
              var M = g.completion;
              if (M.type === "throw") {
                var Y = M.arg;
                U(g);
              }
              return Y;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function(N, O, g) {
          return this.delegate = {
            iterator: _(N),
            resultName: O,
            nextLoc: g
          }, this.method === "next" && (this.arg = n), I;
        }
      }, i;
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(sm)), sm.exports;
}
var om, e4;
function KQ() {
  if (e4)
    return om;
  e4 = 1;
  var t = zQ()();
  om = t;
  try {
    regeneratorRuntime = t;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
  }
  return om;
}
var cm = { exports: {} }, t4;
function VQ() {
  return t4 || (t4 = 1, function(t) {
    function e(n, i, s, a, o, c, f) {
      try {
        var u = n[c](f), d = u.value;
      } catch (l) {
        s(l);
        return;
      }
      u.done ? i(d) : Promise.resolve(d).then(a, o);
    }
    function r(n) {
      return function() {
        var i = this, s = arguments;
        return new Promise(function(a, o) {
          var c = n.apply(i, s);
          function f(d) {
            e(c, a, o, f, u, "next", d);
          }
          function u(d) {
            e(c, a, o, f, u, "throw", d);
          }
          f(void 0);
        });
      };
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(cm)), cm.exports;
}
var um = { exports: {} }, r4;
function lk() {
  return r4 || (r4 = 1, function(t) {
    function e(r, n) {
      if (!(r instanceof n))
        throw new TypeError("Cannot call a class as a function");
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(um)), um.exports;
}
var fm = { exports: {} }, dm = { exports: {} }, lm = { exports: {} }, n4;
function HQ() {
  return n4 || (n4 = 1, function(t) {
    var e = ql().default;
    function r(n, i) {
      if (e(n) !== "object" || n === null)
        return n;
      var s = n[Symbol.toPrimitive];
      if (s !== void 0) {
        var a = s.call(n, i || "default");
        if (e(a) !== "object")
          return a;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (i === "string" ? String : Number)(n);
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(lm)), lm.exports;
}
var i4;
function GQ() {
  return i4 || (i4 = 1, function(t) {
    var e = ql().default, r = HQ();
    function n(i) {
      var s = r(i, "string");
      return e(s) === "symbol" ? s : String(s);
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(dm)), dm.exports;
}
var s4;
function hk() {
  return s4 || (s4 = 1, function(t) {
    var e = GQ();
    function r(i, s) {
      for (var a = 0; a < s.length; a++) {
        var o = s[a];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(i, e(o.key), o);
      }
    }
    function n(i, s, a) {
      return s && r(i.prototype, s), a && r(i, a), Object.defineProperty(i, "prototype", {
        writable: !1
      }), i;
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(fm)), fm.exports;
}
var hm = { exports: {} }, pm = { exports: {} }, a4;
function ZQ() {
  return a4 || (a4 = 1, function(t) {
    function e(r, n) {
      return t.exports = e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(s, a) {
        return s.__proto__ = a, s;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r, n);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(pm)), pm.exports;
}
var o4;
function pk() {
  return o4 || (o4 = 1, function(t) {
    var e = ZQ();
    function r(n, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Super expression must either be null or a function");
      n.prototype = Object.create(i && i.prototype, {
        constructor: {
          value: n,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(n, "prototype", {
        writable: !1
      }), i && e(n, i);
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(hm)), hm.exports;
}
var ym = { exports: {} }, bm = { exports: {} }, c4;
function JQ() {
  return c4 || (c4 = 1, function(t) {
    function e(r) {
      if (r === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return r;
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(bm)), bm.exports;
}
var u4;
function yk() {
  return u4 || (u4 = 1, function(t) {
    var e = ql().default, r = JQ();
    function n(i, s) {
      if (s && (e(s) === "object" || typeof s == "function"))
        return s;
      if (s !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return r(i);
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(ym)), ym.exports;
}
var gm = { exports: {} }, f4;
function bk() {
  return f4 || (f4 = 1, function(t) {
    function e(r) {
      return t.exports = e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
        return i.__proto__ || Object.getPrototypeOf(i);
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(gm)), gm.exports;
}
(function(t) {
  var e = dk;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = e(KQ()), n = e(VQ()), i = e(ql()), s = e(lk()), a = e(hk()), o = e(pk()), c = e(yk()), f = e(bk()), u = W0;
  function d(p) {
    var b = l();
    return function() {
      var x = (0, f.default)(p), I;
      if (b) {
        var L = (0, f.default)(this).constructor;
        I = Reflect.construct(x, arguments, L);
      } else
        I = x.apply(this, arguments);
      return (0, c.default)(this, I);
    };
  }
  function l() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var h = function(p, b) {
    var v = {};
    for (var x in p)
      Object.prototype.hasOwnProperty.call(p, x) && b.indexOf(x) < 0 && (v[x] = p[x]);
    if (p != null && typeof Object.getOwnPropertySymbols == "function")
      for (var I = 0, x = Object.getOwnPropertySymbols(p); I < x.length; I++)
        b.indexOf(x[I]) < 0 && Object.prototype.propertyIsEnumerable.call(p, x[I]) && (v[x[I]] = p[x[I]]);
    return v;
  }, y = /* @__PURE__ */ function(p) {
    (0, o.default)(v, p);
    var b = d(v);
    function v(x) {
      var I, L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "ws://localhost:8080", P = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, C = arguments.length > 3 ? arguments[3] : void 0;
      (0, s.default)(this, v);
      var D = P.autoconnect, F = D === void 0 ? !0 : D, G = P.reconnect, re = G === void 0 ? !0 : G, ie = P.reconnect_interval, ee = ie === void 0 ? 1e3 : ie, $ = P.max_reconnects, w = $ === void 0 ? 5 : $, E = h(P, ["autoconnect", "reconnect", "reconnect_interval", "max_reconnects"]);
      return I = b.call(this), I.webSocketFactory = x, I.queue = {}, I.rpc_id = 0, I.address = L, I.autoconnect = F, I.ready = !1, I.reconnect = re, I.reconnect_timer_id = void 0, I.reconnect_interval = ee, I.max_reconnects = w, I.rest_options = E, I.current_reconnects = 0, I.generate_request_id = C || function() {
        return ++I.rpc_id;
      }, I.autoconnect && I._connect(I.address, Object.assign({
        autoconnect: I.autoconnect,
        reconnect: I.reconnect,
        reconnect_interval: I.reconnect_interval,
        max_reconnects: I.max_reconnects
      }, I.rest_options)), I;
    }
    return (0, a.default)(v, [{
      key: "connect",
      value: function() {
        this.socket || this._connect(this.address, Object.assign({
          autoconnect: this.autoconnect,
          reconnect: this.reconnect,
          reconnect_interval: this.reconnect_interval,
          max_reconnects: this.max_reconnects
        }, this.rest_options));
      }
      /**
       * Calls a registered RPC method on server.
       * @method
       * @param {String} method - RPC method name
       * @param {Object|Array} params - optional method parameters
       * @param {Number} timeout - RPC reply timeout value
       * @param {Object} ws_opts - options passed to ws
       * @return {Promise}
       */
    }, {
      key: "call",
      value: function(I, L, P, C) {
        var D = this;
        return !C && (0, i.default)(P) === "object" && (C = P, P = null), new Promise(function(F, G) {
          if (!D.ready)
            return G(new Error("socket not ready"));
          var re = D.generate_request_id(I, L), ie = {
            jsonrpc: "2.0",
            method: I,
            params: L || null,
            id: re
          };
          D.socket.send(JSON.stringify(ie), C, function(ee) {
            if (ee)
              return G(ee);
            D.queue[re] = {
              promise: [F, G]
            }, P && (D.queue[re].timeout = setTimeout(function() {
              delete D.queue[re], G(new Error("reply timeout"));
            }, P));
          });
        });
      }
      /**
       * Logins with the other side of the connection.
       * @method
       * @param {Object} params - Login credentials object
       * @return {Promise}
       */
    }, {
      key: "login",
      value: function() {
        var x = (0, n.default)(/* @__PURE__ */ r.default.mark(function L(P) {
          var C;
          return r.default.wrap(function(F) {
            for (; ; )
              switch (F.prev = F.next) {
                case 0:
                  return F.next = 2, this.call("rpc.login", P);
                case 2:
                  if (C = F.sent, C) {
                    F.next = 5;
                    break;
                  }
                  throw new Error("authentication failed");
                case 5:
                  return F.abrupt("return", C);
                case 6:
                case "end":
                  return F.stop();
              }
          }, L, this);
        }));
        function I(L) {
          return x.apply(this, arguments);
        }
        return I;
      }()
      /**
       * Fetches a list of client's methods registered on server.
       * @method
       * @return {Array}
       */
    }, {
      key: "listMethods",
      value: function() {
        var x = (0, n.default)(/* @__PURE__ */ r.default.mark(function L() {
          return r.default.wrap(function(C) {
            for (; ; )
              switch (C.prev = C.next) {
                case 0:
                  return C.next = 2, this.call("__listMethods");
                case 2:
                  return C.abrupt("return", C.sent);
                case 3:
                case "end":
                  return C.stop();
              }
          }, L, this);
        }));
        function I() {
          return x.apply(this, arguments);
        }
        return I;
      }()
      /**
       * Sends a JSON-RPC 2.0 notification to server.
       * @method
       * @param {String} method - RPC method name
       * @param {Object} params - optional method parameters
       * @return {Promise}
       */
    }, {
      key: "notify",
      value: function(I, L) {
        var P = this;
        return new Promise(function(C, D) {
          if (!P.ready)
            return D(new Error("socket not ready"));
          var F = {
            jsonrpc: "2.0",
            method: I,
            params: L || null
          };
          P.socket.send(JSON.stringify(F), function(G) {
            if (G)
              return D(G);
            C();
          });
        });
      }
      /**
       * Subscribes for a defined event.
       * @method
       * @param {String|Array} event - event name
       * @return {Undefined}
       * @throws {Error}
       */
    }, {
      key: "subscribe",
      value: function() {
        var x = (0, n.default)(/* @__PURE__ */ r.default.mark(function L(P) {
          var C;
          return r.default.wrap(function(F) {
            for (; ; )
              switch (F.prev = F.next) {
                case 0:
                  return typeof P == "string" && (P = [P]), F.next = 3, this.call("rpc.on", P);
                case 3:
                  if (C = F.sent, !(typeof P == "string" && C[P] !== "ok")) {
                    F.next = 6;
                    break;
                  }
                  throw new Error("Failed subscribing to an event '" + P + "' with: " + C[P]);
                case 6:
                  return F.abrupt("return", C);
                case 7:
                case "end":
                  return F.stop();
              }
          }, L, this);
        }));
        function I(L) {
          return x.apply(this, arguments);
        }
        return I;
      }()
      /**
       * Unsubscribes from a defined event.
       * @method
       * @param {String|Array} event - event name
       * @return {Undefined}
       * @throws {Error}
       */
    }, {
      key: "unsubscribe",
      value: function() {
        var x = (0, n.default)(/* @__PURE__ */ r.default.mark(function L(P) {
          var C;
          return r.default.wrap(function(F) {
            for (; ; )
              switch (F.prev = F.next) {
                case 0:
                  return typeof P == "string" && (P = [P]), F.next = 3, this.call("rpc.off", P);
                case 3:
                  if (C = F.sent, !(typeof P == "string" && C[P] !== "ok")) {
                    F.next = 6;
                    break;
                  }
                  throw new Error("Failed unsubscribing from an event with: " + C);
                case 6:
                  return F.abrupt("return", C);
                case 7:
                case "end":
                  return F.stop();
              }
          }, L, this);
        }));
        function I(L) {
          return x.apply(this, arguments);
        }
        return I;
      }()
      /**
       * Closes a WebSocket connection gracefully.
       * @method
       * @param {Number} code - socket close code
       * @param {String} data - optional data to be sent before closing
       * @return {Undefined}
       */
    }, {
      key: "close",
      value: function(I, L) {
        this.socket.close(I || 1e3, L);
      }
      /**
       * Connection/Message handler.
       * @method
       * @private
       * @param {String} address - WebSocket API address
       * @param {Object} options - ws options object
       * @return {Undefined}
       */
    }, {
      key: "_connect",
      value: function(I, L) {
        var P = this;
        clearTimeout(this.reconnect_timer_id), this.socket = this.webSocketFactory(I, L), this.socket.addEventListener("open", function() {
          P.ready = !0, P.emit("open"), P.current_reconnects = 0;
        }), this.socket.addEventListener("message", function(C) {
          var D = C.data;
          D instanceof ArrayBuffer && (D = ve.from(D).toString());
          try {
            D = JSON.parse(D);
          } catch {
            return;
          }
          if (D.notification && P.listeners(D.notification).length) {
            if (!Object.keys(D.params).length)
              return P.emit(D.notification);
            var F = [D.notification];
            if (D.params.constructor === Object)
              F.push(D.params);
            else
              for (var G = 0; G < D.params.length; G++)
                F.push(D.params[G]);
            return Promise.resolve().then(function() {
              P.emit.apply(P, F);
            });
          }
          if (!P.queue[D.id])
            return D.method && D.params ? Promise.resolve().then(function() {
              P.emit(D.method, D.params);
            }) : void 0;
          "error" in D == "result" in D && P.queue[D.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.')), P.queue[D.id].timeout && clearTimeout(P.queue[D.id].timeout), D.error ? P.queue[D.id].promise[1](D.error) : P.queue[D.id].promise[0](D.result), delete P.queue[D.id];
        }), this.socket.addEventListener("error", function(C) {
          return P.emit("error", C);
        }), this.socket.addEventListener("close", function(C) {
          var D = C.code, F = C.reason;
          P.ready && setTimeout(function() {
            return P.emit("close", D, F);
          }, 0), P.ready = !1, P.socket = void 0, D !== 1e3 && (P.current_reconnects++, P.reconnect && (P.max_reconnects > P.current_reconnects || P.max_reconnects === 0) && (P.reconnect_timer_id = setTimeout(function() {
            return P._connect(I, L);
          }, P.reconnect_interval)));
        });
      }
    }]), v;
  }(u.EventEmitter);
  t.default = y;
})(uk);
const YQ = /* @__PURE__ */ Ln(uk);
var gk = {};
(function(t) {
  var e = dk;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = d;
  var r = e(lk()), n = e(hk()), i = e(pk()), s = e(yk()), a = e(bk()), o = W0;
  function c(l) {
    var h = f();
    return function() {
      var p = (0, a.default)(l), b;
      if (h) {
        var v = (0, a.default)(this).constructor;
        b = Reflect.construct(p, arguments, v);
      } else
        b = p.apply(this, arguments);
      return (0, s.default)(this, b);
    };
  }
  function f() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var u = /* @__PURE__ */ function(l) {
    (0, i.default)(y, l);
    var h = c(y);
    function y(p, b, v) {
      var x;
      return (0, r.default)(this, y), x = h.call(this), x.socket = new window.WebSocket(p, v), x.socket.onopen = function() {
        return x.emit("open");
      }, x.socket.onmessage = function(I) {
        return x.emit("message", I.data);
      }, x.socket.onerror = function(I) {
        return x.emit("error", I);
      }, x.socket.onclose = function(I) {
        x.emit("close", I.code, I.reason);
      }, x;
    }
    return (0, n.default)(y, [{
      key: "send",
      value: function(b, v, x) {
        var I = x || v;
        try {
          this.socket.send(b), I();
        } catch (L) {
          I(L);
        }
      }
      /**
       * Closes an underlying socket
       * @method
       * @param {Number} code - status code explaining why the connection is being closed
       * @param {String} reason - a description why the connection is closing
       * @return {Undefined}
       * @throws {Error}
       */
    }, {
      key: "close",
      value: function(b, v) {
        this.socket.close(b, v);
      }
    }, {
      key: "addEventListener",
      value: function(b, v, x) {
        this.socket.addEventListener(b, v, x);
      }
    }]), y;
  }(o.EventEmitter);
  function d(l, h) {
    return new u(l, h);
  }
})(gk);
const QQ = /* @__PURE__ */ Ln(gk), [mk, vk, wk] = [[], [], []], XQ = /* @__PURE__ */ BigInt(0), Vf = /* @__PURE__ */ BigInt(1), eX = /* @__PURE__ */ BigInt(2), tX = /* @__PURE__ */ BigInt(7), rX = /* @__PURE__ */ BigInt(256), nX = /* @__PURE__ */ BigInt(113);
for (let t = 0, e = Vf, r = 1, n = 0; t < 24; t++) {
  [r, n] = [n, (2 * r + 3 * n) % 5], mk.push(2 * (5 * n + r)), vk.push((t + 1) * (t + 2) / 2 % 64);
  let i = XQ;
  for (let s = 0; s < 7; s++)
    e = (e << Vf ^ (e >> tX) * nX) % rX, e & eX && (i ^= Vf << (Vf << /* @__PURE__ */ BigInt(s)) - Vf);
  wk.push(i);
}
const [iX, sX] = /* @__PURE__ */ qT(wk, !0), d4 = (t, e, r) => r > 32 ? KT(t, e, r) : WT(t, e, r), l4 = (t, e, r) => r > 32 ? VT(t, e, r) : zT(t, e, r);
function aX(t, e = 24) {
  const r = new Uint32Array(10);
  for (let n = 24 - e; n < 24; n++) {
    for (let a = 0; a < 10; a++)
      r[a] = t[a] ^ t[a + 10] ^ t[a + 20] ^ t[a + 30] ^ t[a + 40];
    for (let a = 0; a < 10; a += 2) {
      const o = (a + 8) % 10, c = (a + 2) % 10, f = r[c], u = r[c + 1], d = d4(f, u, 1) ^ r[o], l = l4(f, u, 1) ^ r[o + 1];
      for (let h = 0; h < 50; h += 10)
        t[a + h] ^= d, t[a + h + 1] ^= l;
    }
    let i = t[2], s = t[3];
    for (let a = 0; a < 24; a++) {
      const o = vk[a], c = d4(i, s, o), f = l4(i, s, o), u = mk[a];
      i = t[u], s = t[u + 1], t[u] = c, t[u + 1] = f;
    }
    for (let a = 0; a < 50; a += 10) {
      for (let o = 0; o < 10; o++)
        r[o] = t[a + o];
      for (let o = 0; o < 10; o++)
        t[a + o] ^= ~r[(o + 2) % 10] & r[(o + 4) % 10];
    }
    t[0] ^= iX[n], t[1] ^= sX[n];
  }
  r.fill(0);
}
class g_ extends u_ {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, r, n, i = !1, s = 24) {
    if (super(), this.blockLen = e, this.suffix = r, this.outputLen = n, this.enableXOF = i, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, Lp(n), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = aY(this.state);
  }
  keccak() {
    aX(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    ef(this);
    const { blockLen: r, state: n } = this;
    e = My(e);
    const i = e.length;
    for (let s = 0; s < i; ) {
      const a = Math.min(r - this.pos, i - s);
      for (let o = 0; o < a; o++)
        n[this.pos++] ^= e[s++];
      this.pos === r && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: r, pos: n, blockLen: i } = this;
    e[n] ^= r, r & 128 && n === i - 1 && this.keccak(), e[i - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    ef(this, !1), c_(e), this.finish();
    const r = this.state, { blockLen: n } = this;
    for (let i = 0, s = e.length; i < s; ) {
      this.posOut >= n && this.keccak();
      const a = Math.min(n - this.posOut, s - i);
      e.set(r.subarray(this.posOut, this.posOut + a), i), this.posOut += a, i += a;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return Lp(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (NT(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: r, suffix: n, outputLen: i, rounds: s, enableXOF: a } = this;
    return e || (e = new g_(r, n, i, a, s)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = s, e.suffix = n, e.outputLen = i, e.enableXOF = a, e.destroyed = this.destroyed, e;
  }
}
const oX = (t, e, r) => f_(() => new g_(e, t, r)), h4 = /* @__PURE__ */ oX(1, 136, 256 / 8);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function cX(t) {
  const e = h_(t);
  Tf(e, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: r, Fp: n, a: i } = e;
  if (r) {
    if (!n.eql(i, n.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof r != "object" || typeof r.beta != "bigint" || typeof r.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...e });
}
const { bytesToNumberBE: uX, hexToBytes: fX } = LY, Qo = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(e = "") {
      super(e);
    }
  },
  _parseInt(t) {
    const { Err: e } = Qo;
    if (t.length < 2 || t[0] !== 2)
      throw new e("Invalid signature integer tag");
    const r = t[1], n = t.subarray(2, r + 2);
    if (!r || n.length !== r)
      throw new e("Invalid signature integer: wrong length");
    if (n[0] & 128)
      throw new e("Invalid signature integer: negative");
    if (n[0] === 0 && !(n[1] & 128))
      throw new e("Invalid signature integer: unnecessary leading zero");
    return { d: uX(n), l: t.subarray(r + 2) };
  },
  toSig(t) {
    const { Err: e } = Qo, r = typeof t == "string" ? fX(t) : t;
    if (!ea(r))
      throw new Error("ui8a expected");
    let n = r.length;
    if (n < 2 || r[0] != 48)
      throw new e("Invalid signature tag");
    if (r[1] !== n - 2)
      throw new e("Invalid signature: incorrect length");
    const { d: i, l: s } = Qo._parseInt(r.subarray(2)), { d: a, l: o } = Qo._parseInt(s);
    if (o.length)
      throw new e("Invalid signature: left bytes after parsing");
    return { r: i, s: a };
  },
  hexFromSig(t) {
    const e = (f) => Number.parseInt(f[0], 16) & 8 ? "00" + f : f, r = (f) => {
      const u = f.toString(16);
      return u.length & 1 ? `0${u}` : u;
    }, n = e(r(t.s)), i = e(r(t.r)), s = n.length / 2, a = i.length / 2, o = r(s), c = r(a);
    return `30${r(a + s + 4)}02${c}${i}02${o}${n}`;
  }
}, Ia = BigInt(0), es = BigInt(1);
BigInt(2);
const p4 = BigInt(3);
BigInt(4);
function dX(t) {
  const e = cX(t), { Fp: r } = e, n = e.toBytes || ((y, p, b) => {
    const v = p.toAffine();
    return Oc(Uint8Array.from([4]), r.toBytes(v.x), r.toBytes(v.y));
  }), i = e.fromBytes || ((y) => {
    const p = y.subarray(1), b = r.fromBytes(p.subarray(0, r.BYTES)), v = r.fromBytes(p.subarray(r.BYTES, 2 * r.BYTES));
    return { x: b, y: v };
  });
  function s(y) {
    const { a: p, b } = e, v = r.sqr(y), x = r.mul(v, y);
    return r.add(r.add(x, r.mul(y, p)), b);
  }
  if (!r.eql(r.sqr(e.Gy), s(e.Gx)))
    throw new Error("bad generator point: equation left != right");
  function a(y) {
    return typeof y == "bigint" && Ia < y && y < e.n;
  }
  function o(y) {
    if (!a(y))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function c(y) {
    const { allowedPrivateKeyLengths: p, nByteLength: b, wrapPrivateKey: v, n: x } = e;
    if (p && typeof y != "bigint") {
      if (ea(y) && (y = Pc(y)), typeof y != "string" || !p.includes(y.length))
        throw new Error("Invalid key");
      y = y.padStart(b * 2, "0");
    }
    let I;
    try {
      I = typeof y == "bigint" ? y : mc(xn("private key", y, b));
    } catch {
      throw new Error(`private key must be ${b} bytes, hex or bigint, not ${typeof y}`);
    }
    return v && (I = Qr(I, x)), o(I), I;
  }
  const f = /* @__PURE__ */ new Map();
  function u(y) {
    if (!(y instanceof d))
      throw new Error("ProjectivePoint expected");
  }
  class d {
    constructor(p, b, v) {
      if (this.px = p, this.py = b, this.pz = v, p == null || !r.isValid(p))
        throw new Error("x required");
      if (b == null || !r.isValid(b))
        throw new Error("y required");
      if (v == null || !r.isValid(v))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(p) {
      const { x: b, y: v } = p || {};
      if (!p || !r.isValid(b) || !r.isValid(v))
        throw new Error("invalid affine point");
      if (p instanceof d)
        throw new Error("projective point not allowed");
      const x = (I) => r.eql(I, r.ZERO);
      return x(b) && x(v) ? d.ZERO : new d(b, v, r.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(p) {
      const b = r.invertBatch(p.map((v) => v.pz));
      return p.map((v, x) => v.toAffine(b[x])).map(d.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(p) {
      const b = d.fromAffine(i(xn("pointHex", p)));
      return b.assertValidity(), b;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(p) {
      return d.BASE.multiply(c(p));
    }
    // "Private method", don't use it directly
    _setWindowSize(p) {
      this._WINDOW_SIZE = p, f.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (e.allowInfinityPoint && !r.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: p, y: b } = this.toAffine();
      if (!r.isValid(p) || !r.isValid(b))
        throw new Error("bad point: x or y not FE");
      const v = r.sqr(b), x = s(p);
      if (!r.eql(v, x))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: p } = this.toAffine();
      if (r.isOdd)
        return !r.isOdd(p);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(p) {
      u(p);
      const { px: b, py: v, pz: x } = this, { px: I, py: L, pz: P } = p, C = r.eql(r.mul(b, P), r.mul(I, x)), D = r.eql(r.mul(v, P), r.mul(L, x));
      return C && D;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new d(this.px, r.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: p, b } = e, v = r.mul(b, p4), { px: x, py: I, pz: L } = this;
      let P = r.ZERO, C = r.ZERO, D = r.ZERO, F = r.mul(x, x), G = r.mul(I, I), re = r.mul(L, L), ie = r.mul(x, I);
      return ie = r.add(ie, ie), D = r.mul(x, L), D = r.add(D, D), P = r.mul(p, D), C = r.mul(v, re), C = r.add(P, C), P = r.sub(G, C), C = r.add(G, C), C = r.mul(P, C), P = r.mul(ie, P), D = r.mul(v, D), re = r.mul(p, re), ie = r.sub(F, re), ie = r.mul(p, ie), ie = r.add(ie, D), D = r.add(F, F), F = r.add(D, F), F = r.add(F, re), F = r.mul(F, ie), C = r.add(C, F), re = r.mul(I, L), re = r.add(re, re), F = r.mul(re, ie), P = r.sub(P, F), D = r.mul(re, G), D = r.add(D, D), D = r.add(D, D), new d(P, C, D);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(p) {
      u(p);
      const { px: b, py: v, pz: x } = this, { px: I, py: L, pz: P } = p;
      let C = r.ZERO, D = r.ZERO, F = r.ZERO;
      const G = e.a, re = r.mul(e.b, p4);
      let ie = r.mul(b, I), ee = r.mul(v, L), $ = r.mul(x, P), w = r.add(b, v), E = r.add(I, L);
      w = r.mul(w, E), E = r.add(ie, ee), w = r.sub(w, E), E = r.add(b, x);
      let U = r.add(I, P);
      return E = r.mul(E, U), U = r.add(ie, $), E = r.sub(E, U), U = r.add(v, x), C = r.add(L, P), U = r.mul(U, C), C = r.add(ee, $), U = r.sub(U, C), F = r.mul(G, E), C = r.mul(re, $), F = r.add(C, F), C = r.sub(ee, F), F = r.add(ee, F), D = r.mul(C, F), ee = r.add(ie, ie), ee = r.add(ee, ie), $ = r.mul(G, $), E = r.mul(re, E), ee = r.add(ee, $), $ = r.sub(ie, $), $ = r.mul(G, $), E = r.add(E, $), ie = r.mul(ee, E), D = r.add(D, ie), ie = r.mul(U, E), C = r.mul(w, C), C = r.sub(C, ie), ie = r.mul(w, ee), F = r.mul(U, F), F = r.add(F, ie), new d(C, D, F);
    }
    subtract(p) {
      return this.add(p.negate());
    }
    is0() {
      return this.equals(d.ZERO);
    }
    wNAF(p) {
      return h.wNAFCached(this, f, p, (b) => {
        const v = r.invertBatch(b.map((x) => x.pz));
        return b.map((x, I) => x.toAffine(v[I])).map(d.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(p) {
      const b = d.ZERO;
      if (p === Ia)
        return b;
      if (o(p), p === es)
        return this;
      const { endo: v } = e;
      if (!v)
        return h.unsafeLadder(this, p);
      let { k1neg: x, k1: I, k2neg: L, k2: P } = v.splitScalar(p), C = b, D = b, F = this;
      for (; I > Ia || P > Ia; )
        I & es && (C = C.add(F)), P & es && (D = D.add(F)), F = F.double(), I >>= es, P >>= es;
      return x && (C = C.negate()), L && (D = D.negate()), D = new d(r.mul(D.px, v.beta), D.py, D.pz), C.add(D);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(p) {
      o(p);
      let b = p, v, x;
      const { endo: I } = e;
      if (I) {
        const { k1neg: L, k1: P, k2neg: C, k2: D } = I.splitScalar(b);
        let { p: F, f: G } = this.wNAF(P), { p: re, f: ie } = this.wNAF(D);
        F = h.constTimeNegate(L, F), re = h.constTimeNegate(C, re), re = new d(r.mul(re.px, I.beta), re.py, re.pz), v = F.add(re), x = G.add(ie);
      } else {
        const { p: L, f: P } = this.wNAF(b);
        v = L, x = P;
      }
      return d.normalizeZ([v, x])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(p, b, v) {
      const x = d.BASE, I = (P, C) => C === Ia || C === es || !P.equals(x) ? P.multiplyUnsafe(C) : P.multiply(C), L = I(this, b).add(I(p, v));
      return L.is0() ? void 0 : L;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(p) {
      const { px: b, py: v, pz: x } = this, I = this.is0();
      p == null && (p = I ? r.ONE : r.inv(x));
      const L = r.mul(b, p), P = r.mul(v, p), C = r.mul(x, p);
      if (I)
        return { x: r.ZERO, y: r.ZERO };
      if (!r.eql(C, r.ONE))
        throw new Error("invZ was invalid");
      return { x: L, y: P };
    }
    isTorsionFree() {
      const { h: p, isTorsionFree: b } = e;
      if (p === es)
        return !0;
      if (b)
        return b(d, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: p, clearCofactor: b } = e;
      return p === es ? this : b ? b(d, this) : this.multiplyUnsafe(e.h);
    }
    toRawBytes(p = !0) {
      return this.assertValidity(), n(d, this, p);
    }
    toHex(p = !0) {
      return Pc(this.toRawBytes(p));
    }
  }
  d.BASE = new d(e.Gx, e.Gy, r.ONE), d.ZERO = new d(r.ZERO, r.ONE, r.ZERO);
  const l = e.nBitLength, h = tk(d, e.endo ? Math.ceil(l / 2) : l);
  return {
    CURVE: e,
    ProjectivePoint: d,
    normPrivateKeyToScalar: c,
    weierstrassEquation: s,
    isWithinCurveOrder: a
  };
}
function lX(t) {
  const e = h_(t);
  return Tf(e, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...e });
}
function hX(t) {
  const e = lX(t), { Fp: r, n } = e, i = r.BYTES + 1, s = 2 * r.BYTES + 1;
  function a(E) {
    return Ia < E && E < r.ORDER;
  }
  function o(E) {
    return Qr(E, n);
  }
  function c(E) {
    return qv(E, n);
  }
  const { ProjectivePoint: f, normPrivateKeyToScalar: u, weierstrassEquation: d, isWithinCurveOrder: l } = dX({
    ...e,
    toBytes(E, U, W) {
      const _ = U.toAffine(), R = r.toBytes(_.x), N = Oc;
      return W ? N(Uint8Array.from([U.hasEvenY() ? 2 : 3]), R) : N(Uint8Array.from([4]), R, r.toBytes(_.y));
    },
    fromBytes(E) {
      const U = E.length, W = E[0], _ = E.subarray(1);
      if (U === i && (W === 2 || W === 3)) {
        const R = mc(_);
        if (!a(R))
          throw new Error("Point is not on curve");
        const N = d(R);
        let O = r.sqrt(N);
        const g = (O & es) === es;
        return (W & 1) === 1 !== g && (O = r.neg(O)), { x: R, y: O };
      } else if (U === s && W === 4) {
        const R = r.fromBytes(_.subarray(0, r.BYTES)), N = r.fromBytes(_.subarray(r.BYTES, 2 * r.BYTES));
        return { x: R, y: N };
      } else
        throw new Error(`Point of length ${U} was invalid. Expected ${i} compressed bytes or ${s} uncompressed bytes`);
    }
  }), h = (E) => Pc(rf(E, e.nByteLength));
  function y(E) {
    const U = n >> es;
    return E > U;
  }
  function p(E) {
    return y(E) ? o(-E) : E;
  }
  const b = (E, U, W) => mc(E.slice(U, W));
  class v {
    constructor(U, W, _) {
      this.r = U, this.s = W, this.recovery = _, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(U) {
      const W = e.nByteLength;
      return U = xn("compactSignature", U, W * 2), new v(b(U, 0, W), b(U, W, 2 * W));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(U) {
      const { r: W, s: _ } = Qo.toSig(xn("DER", U));
      return new v(W, _);
    }
    assertValidity() {
      if (!l(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!l(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(U) {
      return new v(this.r, this.s, U);
    }
    recoverPublicKey(U) {
      const { r: W, s: _, recovery: R } = this, N = D(xn("msgHash", U));
      if (R == null || ![0, 1, 2, 3].includes(R))
        throw new Error("recovery id invalid");
      const O = R === 2 || R === 3 ? W + e.n : W;
      if (O >= r.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const g = R & 1 ? "03" : "02", M = f.fromHex(g + h(O)), Y = c(O), se = o(-N * Y), V = o(_ * Y), K = f.BASE.multiplyAndAddUnsafe(M, se, V);
      if (!K)
        throw new Error("point at infinify");
      return K.assertValidity(), K;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return y(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new v(this.r, o(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return tf(this.toDERHex());
    }
    toDERHex() {
      return Qo.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return tf(this.toCompactHex());
    }
    toCompactHex() {
      return h(this.r) + h(this.s);
    }
  }
  const x = {
    isValidPrivateKey(E) {
      try {
        return u(E), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: u,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const E = ek(e.n);
      return GY(e.randomBytes(E), e.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(E = 8, U = f.BASE) {
      return U._setWindowSize(E), U.multiply(BigInt(3)), U;
    }
  };
  function I(E, U = !0) {
    return f.fromPrivateKey(E).toRawBytes(U);
  }
  function L(E) {
    const U = ea(E), W = typeof E == "string", _ = (U || W) && E.length;
    return U ? _ === i || _ === s : W ? _ === 2 * i || _ === 2 * s : E instanceof f;
  }
  function P(E, U, W = !0) {
    if (L(E))
      throw new Error("first arg must be private key");
    if (!L(U))
      throw new Error("second arg must be public key");
    return f.fromHex(U).multiply(u(E)).toRawBytes(W);
  }
  const C = e.bits2int || function(E) {
    const U = mc(E), W = E.length * 8 - e.nBitLength;
    return W > 0 ? U >> BigInt(W) : U;
  }, D = e.bits2int_modN || function(E) {
    return o(C(E));
  }, F = l_(e.nBitLength);
  function G(E) {
    if (typeof E != "bigint")
      throw new Error("bigint expected");
    if (!(Ia <= E && E < F))
      throw new Error(`bigint expected < 2^${e.nBitLength}`);
    return rf(E, e.nByteLength);
  }
  function re(E, U, W = ie) {
    if (["recovered", "canonical"].some((ne) => ne in W))
      throw new Error("sign() legacy options not supported");
    const { hash: _, randomBytes: R } = e;
    let { lowS: N, prehash: O, extraEntropy: g } = W;
    N == null && (N = !0), E = xn("msgHash", E), O && (E = xn("prehashed msgHash", _(E)));
    const M = D(E), Y = u(U), se = [G(Y), G(M)];
    if (g != null) {
      const ne = g === !0 ? R(r.BYTES) : g;
      se.push(xn("extraEntropy", ne));
    }
    const V = Oc(...se), K = M;
    function Z(ne) {
      const ce = C(ne);
      if (!l(ce))
        return;
      const H = c(ce), J = f.BASE.multiply(ce).toAffine(), le = o(J.x);
      if (le === Ia)
        return;
      const me = o(H * o(K + le * Y));
      if (me === Ia)
        return;
      let Ue = (J.x === le ? 0 : 2) | Number(J.y & es), Ve = me;
      return N && y(me) && (Ve = p(me), Ue ^= 1), new v(le, Ve, Ue);
    }
    return { seed: V, k2sig: Z };
  }
  const ie = { lowS: e.lowS, prehash: !1 }, ee = { lowS: e.lowS, prehash: !1 };
  function $(E, U, W = ie) {
    const { seed: _, k2sig: R } = re(E, U, W), N = e;
    return JT(N.hash.outputLen, N.nByteLength, N.hmac)(_, R);
  }
  f.BASE._setWindowSize(8);
  function w(E, U, W, _ = ee) {
    var J;
    const R = E;
    if (U = xn("msgHash", U), W = xn("publicKey", W), "strict" in _)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: N, prehash: O } = _;
    let g, M;
    try {
      if (typeof R == "string" || ea(R))
        try {
          g = v.fromDER(R);
        } catch (le) {
          if (!(le instanceof Qo.Err))
            throw le;
          g = v.fromCompact(R);
        }
      else if (typeof R == "object" && typeof R.r == "bigint" && typeof R.s == "bigint") {
        const { r: le, s: me } = R;
        g = new v(le, me);
      } else
        throw new Error("PARSE");
      M = f.fromHex(W);
    } catch (le) {
      if (le.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (N && g.hasHighS())
      return !1;
    O && (U = e.hash(U));
    const { r: Y, s: se } = g, V = D(U), K = c(se), Z = o(V * K), ne = o(Y * K), ce = (J = f.BASE.multiplyAndAddUnsafe(M, Z, ne)) == null ? void 0 : J.toAffine();
    return ce ? o(ce.x) === Y : !1;
  }
  return {
    CURVE: e,
    getPublicKey: I,
    getSharedSecret: P,
    sign: $,
    verify: w,
    ProjectivePoint: f,
    Signature: v,
    utils: x
  };
}
class _k extends u_ {
  constructor(e, r) {
    super(), this.finished = !1, this.destroyed = !1, sY(e);
    const n = My(r);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const i = this.blockLen, s = new Uint8Array(i);
    s.set(n.length > i ? e.create().update(n).digest() : n);
    for (let a = 0; a < s.length; a++)
      s[a] ^= 54;
    this.iHash.update(s), this.oHash = e.create();
    for (let a = 0; a < s.length; a++)
      s[a] ^= 106;
    this.oHash.update(s), s.fill(0);
  }
  update(e) {
    return ef(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    ef(this), c_(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: r, iHash: n, finished: i, destroyed: s, blockLen: a, outputLen: o } = this;
    return e = e, e.finished = i, e.destroyed = s, e.blockLen = a, e.outputLen = o, e.oHash = r._cloneInto(e.oHash), e.iHash = n._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const Sk = (t, e, r) => new _k(t, e).update(r).digest();
Sk.create = (t, e) => new _k(t, e);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function pX(t) {
  return {
    hash: t,
    hmac: (e, ...r) => Sk(t, e, DT(...r)),
    randomBytes: FT
  };
}
function yX(t, e) {
  const r = (n) => hX({ ...t, ...pX(n) });
  return Object.freeze({ ...r(e), create: r });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Ek = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), y4 = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), bX = BigInt(1), Kv = BigInt(2), b4 = (t, e) => (t + e / Kv) / e;
function gX(t) {
  const e = Ek, r = BigInt(3), n = BigInt(6), i = BigInt(11), s = BigInt(22), a = BigInt(23), o = BigInt(44), c = BigInt(88), f = t * t * t % e, u = f * f * t % e, d = un(u, r, e) * u % e, l = un(d, r, e) * u % e, h = un(l, Kv, e) * f % e, y = un(h, i, e) * h % e, p = un(y, s, e) * y % e, b = un(p, o, e) * p % e, v = un(b, c, e) * b % e, x = un(v, o, e) * p % e, I = un(x, r, e) * u % e, L = un(I, a, e) * y % e, P = un(L, n, e) * f % e, C = un(P, Kv, e);
  if (!Vv.eql(Vv.sqr(C), t))
    throw new Error("Cannot find square root");
  return C;
}
const Vv = QT(Ek, void 0, void 0, { sqrt: gX }), Dy = yX({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
  Fp: Vv,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: y4,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (t) => {
      const e = y4, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -bX * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), i = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), s = r, a = BigInt("0x100000000000000000000000000000000"), o = b4(s * t, e), c = b4(-n * t, e);
      let f = Qr(t - o * r - c * i, e), u = Qr(-o * n - c * s, e);
      const d = f > a, l = u > a;
      if (d && (f = e - f), l && (u = e - u), f > a || u > a)
        throw new Error("splitScalar: Endomorphism failed, k=" + t);
      return { k1neg: d, k1: f, k2neg: l, k2: u };
    }
  }
}, zv);
BigInt(0);
Dy.ProjectivePoint;
const mX = kf.utils.randomPrivateKey, g4 = () => {
  const t = kf.utils.randomPrivateKey(), e = Dp(t), r = new Uint8Array(64);
  return r.set(t), r.set(e, 32), {
    publicKey: e,
    secretKey: r
  };
}, Dp = kf.getPublicKey;
function m4(t) {
  try {
    return kf.ExtendedPoint.fromHex(t), !0;
  } catch {
    return !1;
  }
}
const m_ = (t, e) => kf.sign(t, e.slice(0, 32)), vX = kf.verify, Wt = (t) => Fe.Buffer.isBuffer(t) ? t : t instanceof Uint8Array ? Fe.Buffer.from(t.buffer, t.byteOffset, t.byteLength) : Fe.Buffer.from(t);
class v_ {
  constructor(e) {
    Object.assign(this, e);
  }
  encode() {
    return Fe.Buffer.from(Z2(dd, this));
  }
  static decode(e) {
    return Y2(dd, this, e);
  }
  static decodeUnchecked(e) {
    return F0(dd, this, e);
  }
}
class wX extends v_ {
  constructor(e) {
    if (super(e), this.enum = "", Object.keys(e).length !== 1)
      throw new Error("Enum can only take single value");
    Object.keys(e).map((r) => {
      this.enum = r;
    });
  }
}
const dd = /* @__PURE__ */ new Map();
var xk;
let Ak;
const Ik = 32, Di = 32;
function _X(t) {
  return t._bn !== void 0;
}
let v4 = 1;
Ak = Symbol.toStringTag;
class Ze extends v_ {
  /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */
  constructor(e) {
    if (super({}), this._bn = void 0, _X(e))
      this._bn = e._bn;
    else {
      if (typeof e == "string") {
        const r = Ot.decode(e);
        if (r.length != Di)
          throw new Error("Invalid public key input");
        this._bn = new Ss(r);
      } else
        this._bn = new Ss(e);
      if (this._bn.byteLength() > Di)
        throw new Error("Invalid public key input");
    }
  }
  /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */
  static unique() {
    const e = new Ze(v4);
    return v4 += 1, new Ze(e.toBuffer());
  }
  /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */
  /**
   * Checks if two publicKeys are equal
   */
  equals(e) {
    return this._bn.eq(e._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return Ot.encode(this.toBytes());
  }
  toJSON() {
    return this.toBase58();
  }
  /**
   * Return the byte array representation of the public key in big endian
   */
  toBytes() {
    const e = this.toBuffer();
    return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  }
  /**
   * Return the Buffer representation of the public key in big endian
   */
  toBuffer() {
    const e = this._bn.toArrayLike(Fe.Buffer);
    if (e.length === Di)
      return e;
    const r = Fe.Buffer.alloc(32);
    return e.copy(r, 32 - e.length), r;
  }
  get [Ak]() {
    return `PublicKey(${this.toString()})`;
  }
  /**
   * Return the base-58 representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */
  /* eslint-disable require-await */
  static async createWithSeed(e, r, n) {
    const i = Fe.Buffer.concat([e.toBuffer(), Fe.Buffer.from(r), n.toBuffer()]), s = zv(i);
    return new Ze(s);
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  /* eslint-disable require-await */
  static createProgramAddressSync(e, r) {
    let n = Fe.Buffer.alloc(0);
    e.forEach(function(s) {
      if (s.length > Ik)
        throw new TypeError("Max seed length exceeded");
      n = Fe.Buffer.concat([n, Wt(s)]);
    }), n = Fe.Buffer.concat([n, r.toBuffer(), Fe.Buffer.from("ProgramDerivedAddress")]);
    const i = zv(n);
    if (m4(i))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new Ze(i);
  }
  /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */
  /* eslint-disable require-await */
  static async createProgramAddress(e, r) {
    return this.createProgramAddressSync(e, r);
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */
  static findProgramAddressSync(e, r) {
    let n = 255, i;
    for (; n != 0; ) {
      try {
        const s = e.concat(Fe.Buffer.from([n]));
        i = this.createProgramAddressSync(s, r);
      } catch (s) {
        if (s instanceof TypeError)
          throw s;
        n--;
        continue;
      }
      return [i, n];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */
  static async findProgramAddress(e, r) {
    return this.findProgramAddressSync(e, r);
  }
  /**
   * Check that a pubkey is on the ed25519 curve.
   */
  static isOnCurve(e) {
    const r = new Ze(e);
    return m4(r.toBytes());
  }
}
xk = Ze;
Ze.default = new xk("11111111111111111111111111111111");
dd.set(Ze, {
  kind: "struct",
  fields: [["_bn", "u256"]]
});
class SX {
  /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */
  constructor(e) {
    if (this._publicKey = void 0, this._secretKey = void 0, e) {
      const r = Wt(e);
      if (e.length !== 64)
        throw new Error("bad secret key size");
      this._publicKey = r.slice(32, 64), this._secretKey = r.slice(0, 32);
    } else
      this._secretKey = Wt(mX()), this._publicKey = Wt(Dp(this._secretKey));
  }
  /**
   * The public key for this account
   */
  get publicKey() {
    return new Ze(this._publicKey);
  }
  /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  get secretKey() {
    return Fe.Buffer.concat([this._secretKey, this._publicKey], 64);
  }
}
const EX = new Ze("BPFLoader1111111111111111111111111111111111"), yo = 1232, Fy = 127, nf = 64;
class w_ extends Error {
  constructor(e) {
    super(`Signature ${e} has expired: block height exceeded.`), this.signature = void 0, this.signature = e;
  }
}
Object.defineProperty(w_.prototype, "name", {
  value: "TransactionExpiredBlockheightExceededError"
});
class __ extends Error {
  constructor(e, r) {
    super(`Transaction was not confirmed in ${r.toFixed(2)} seconds. It is unknown if it succeeded or failed. Check signature ${e} using the Solana Explorer or CLI tools.`), this.signature = void 0, this.signature = e;
  }
}
Object.defineProperty(__.prototype, "name", {
  value: "TransactionExpiredTimeoutError"
});
class vu extends Error {
  constructor(e) {
    super(`Signature ${e} has expired: the nonce is no longer valid.`), this.signature = void 0, this.signature = e;
  }
}
Object.defineProperty(vu.prototype, "name", {
  value: "TransactionExpiredNonceInvalidError"
});
class Kd {
  constructor(e, r) {
    this.staticAccountKeys = void 0, this.accountKeysFromLookups = void 0, this.staticAccountKeys = e, this.accountKeysFromLookups = r;
  }
  keySegments() {
    const e = [this.staticAccountKeys];
    return this.accountKeysFromLookups && (e.push(this.accountKeysFromLookups.writable), e.push(this.accountKeysFromLookups.readonly)), e;
  }
  get(e) {
    for (const r of this.keySegments()) {
      if (e < r.length)
        return r[e];
      e -= r.length;
    }
  }
  get length() {
    return this.keySegments().flat().length;
  }
  compileInstructions(e) {
    if (this.length > 256)
      throw new Error("Account index overflow encountered during compilation");
    const n = /* @__PURE__ */ new Map();
    this.keySegments().flat().forEach((s, a) => {
      n.set(s.toBase58(), a);
    });
    const i = (s) => {
      const a = n.get(s.toBase58());
      if (a === void 0)
        throw new Error("Encountered an unknown instruction account key during compilation");
      return a;
    };
    return e.map((s) => ({
      programIdIndex: i(s.programId),
      accountKeyIndexes: s.keys.map((a) => i(a.pubkey)),
      data: s.data
    }));
  }
}
const er = (t = "publicKey") => xt(32, t), xX = (t = "signature") => xt(64, t), Xo = (t = "string") => {
  const e = Re([Be("length"), Be("lengthPadding"), xt(Ii(Be(), -8), "chars")], t), r = e.decode.bind(e), n = e.encode.bind(e), i = e;
  return i.decode = (s, a) => r(s, a).chars.toString(), i.encode = (s, a, o) => {
    const c = {
      chars: Fe.Buffer.from(s, "utf8")
    };
    return n(c, a, o);
  }, i.alloc = (s) => Be().span + Be().span + Fe.Buffer.from(s, "utf8").length, i;
}, AX = (t = "authorized") => Re([er("staker"), er("withdrawer")], t), IX = (t = "lockup") => Re([Gr("unixTimestamp"), Gr("epoch"), er("custodian")], t), TX = (t = "voteInit") => Re([er("nodePubkey"), er("authorizedVoter"), er("authorizedWithdrawer"), st("commission")], t), kX = (t = "voteAuthorizeWithSeedArgs") => Re([Be("voteAuthorizationType"), er("currentAuthorityDerivedKeyOwnerPubkey"), Xo("currentAuthorityDerivedKeySeed"), er("newAuthorized")], t);
function Tk(t, e) {
  const r = (i) => {
    if (i.span >= 0)
      return i.span;
    if (typeof i.alloc == "function")
      return i.alloc(e[i.property]);
    if ("count" in i && "elementLayout" in i) {
      const s = e[i.property];
      if (Array.isArray(s))
        return s.length * r(i.elementLayout);
    } else if ("fields" in i)
      return Tk({
        layout: i
      }, e[i.property]);
    return 0;
  };
  let n = 0;
  return t.layout.fields.forEach((i) => {
    n += r(i);
  }), n;
}
function wi(t) {
  let e = 0, r = 0;
  for (; ; ) {
    let n = t.shift();
    if (e |= (n & 127) << r * 7, r += 1, !(n & 128))
      break;
  }
  return e;
}
function Ni(t, e) {
  let r = e;
  for (; ; ) {
    let n = r & 127;
    if (r >>= 7, r == 0) {
      t.push(n);
      break;
    } else
      n |= 128, t.push(n);
  }
}
function _r(t, e) {
  if (!t)
    throw new Error(e || "Assertion failed");
}
class jy {
  constructor(e, r) {
    this.payer = void 0, this.keyMetaMap = void 0, this.payer = e, this.keyMetaMap = r;
  }
  static compile(e, r) {
    const n = /* @__PURE__ */ new Map(), i = (a) => {
      const o = a.toBase58();
      let c = n.get(o);
      return c === void 0 && (c = {
        isSigner: !1,
        isWritable: !1,
        isInvoked: !1
      }, n.set(o, c)), c;
    }, s = i(r);
    s.isSigner = !0, s.isWritable = !0;
    for (const a of e) {
      i(a.programId).isInvoked = !0;
      for (const o of a.keys) {
        const c = i(o.pubkey);
        c.isSigner || (c.isSigner = o.isSigner), c.isWritable || (c.isWritable = o.isWritable);
      }
    }
    return new jy(r, n);
  }
  getMessageComponents() {
    const e = [...this.keyMetaMap.entries()];
    _r(e.length <= 256, "Max static account keys length exceeded");
    const r = e.filter(([, c]) => c.isSigner && c.isWritable), n = e.filter(([, c]) => c.isSigner && !c.isWritable), i = e.filter(([, c]) => !c.isSigner && c.isWritable), s = e.filter(([, c]) => !c.isSigner && !c.isWritable), a = {
      numRequiredSignatures: r.length + n.length,
      numReadonlySignedAccounts: n.length,
      numReadonlyUnsignedAccounts: s.length
    };
    {
      _r(r.length > 0, "Expected at least one writable signer key");
      const [c] = r[0];
      _r(c === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
    }
    const o = [...r.map(([c]) => new Ze(c)), ...n.map(([c]) => new Ze(c)), ...i.map(([c]) => new Ze(c)), ...s.map(([c]) => new Ze(c))];
    return [a, o];
  }
  extractTableLookup(e) {
    const [r, n] = this.drainKeysFoundInLookupTable(e.state.addresses, (a) => !a.isSigner && !a.isInvoked && a.isWritable), [i, s] = this.drainKeysFoundInLookupTable(e.state.addresses, (a) => !a.isSigner && !a.isInvoked && !a.isWritable);
    if (!(r.length === 0 && i.length === 0))
      return [{
        accountKey: e.key,
        writableIndexes: r,
        readonlyIndexes: i
      }, {
        writable: n,
        readonly: s
      }];
  }
  /** @internal */
  drainKeysFoundInLookupTable(e, r) {
    const n = new Array(), i = new Array();
    for (const [s, a] of this.keyMetaMap.entries())
      if (r(a)) {
        const o = new Ze(s), c = e.findIndex((f) => f.equals(o));
        c >= 0 && (_r(c < 256, "Max lookup table index exceeded"), n.push(c), i.push(o), this.keyMetaMap.delete(s));
      }
    return [n, i];
  }
}
class Is {
  constructor(e) {
    this.header = void 0, this.accountKeys = void 0, this.recentBlockhash = void 0, this.instructions = void 0, this.indexToProgramIds = /* @__PURE__ */ new Map(), this.header = e.header, this.accountKeys = e.accountKeys.map((r) => new Ze(r)), this.recentBlockhash = e.recentBlockhash, this.instructions = e.instructions, this.instructions.forEach((r) => this.indexToProgramIds.set(r.programIdIndex, this.accountKeys[r.programIdIndex]));
  }
  get version() {
    return "legacy";
  }
  get staticAccountKeys() {
    return this.accountKeys;
  }
  get compiledInstructions() {
    return this.instructions.map((e) => ({
      programIdIndex: e.programIdIndex,
      accountKeyIndexes: e.accounts,
      data: Ot.decode(e.data)
    }));
  }
  get addressTableLookups() {
    return [];
  }
  getAccountKeys() {
    return new Kd(this.staticAccountKeys);
  }
  static compile(e) {
    const r = jy.compile(e.instructions, e.payerKey), [n, i] = r.getMessageComponents(), a = new Kd(i).compileInstructions(e.instructions).map((o) => ({
      programIdIndex: o.programIdIndex,
      accounts: o.accountKeyIndexes,
      data: Ot.encode(o.data)
    }));
    return new Is({
      header: n,
      accountKeys: i,
      recentBlockhash: e.recentBlockhash,
      instructions: a
    });
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    const r = this.header.numRequiredSignatures;
    if (e >= this.header.numRequiredSignatures) {
      const n = e - r, s = this.accountKeys.length - r - this.header.numReadonlyUnsignedAccounts;
      return n < s;
    } else {
      const n = r - this.header.numReadonlySignedAccounts;
      return e < n;
    }
  }
  isProgramId(e) {
    return this.indexToProgramIds.has(e);
  }
  programIds() {
    return [...this.indexToProgramIds.values()];
  }
  nonProgramIds() {
    return this.accountKeys.filter((e, r) => !this.isProgramId(r));
  }
  serialize() {
    const e = this.accountKeys.length;
    let r = [];
    Ni(r, e);
    const n = this.instructions.map((d) => {
      const {
        accounts: l,
        programIdIndex: h
      } = d, y = Array.from(Ot.decode(d.data));
      let p = [];
      Ni(p, l.length);
      let b = [];
      return Ni(b, y.length), {
        programIdIndex: h,
        keyIndicesCount: Fe.Buffer.from(p),
        keyIndices: l,
        dataLength: Fe.Buffer.from(b),
        data: y
      };
    });
    let i = [];
    Ni(i, n.length);
    let s = Fe.Buffer.alloc(yo);
    Fe.Buffer.from(i).copy(s);
    let a = i.length;
    n.forEach((d) => {
      const h = Re([st("programIdIndex"), xt(d.keyIndicesCount.length, "keyIndicesCount"), Ir(st("keyIndex"), d.keyIndices.length, "keyIndices"), xt(d.dataLength.length, "dataLength"), Ir(st("userdatum"), d.data.length, "data")]).encode(d, s, a);
      a += h;
    }), s = s.slice(0, a);
    const o = Re([xt(1, "numRequiredSignatures"), xt(1, "numReadonlySignedAccounts"), xt(1, "numReadonlyUnsignedAccounts"), xt(r.length, "keyCount"), Ir(er("key"), e, "keys"), er("recentBlockhash")]), c = {
      numRequiredSignatures: Fe.Buffer.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: Fe.Buffer.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: Fe.Buffer.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: Fe.Buffer.from(r),
      keys: this.accountKeys.map((d) => Wt(d.toBytes())),
      recentBlockhash: Ot.decode(this.recentBlockhash)
    };
    let f = Fe.Buffer.alloc(2048);
    const u = o.encode(c, f);
    return s.copy(f, u), f.slice(0, u + s.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(e) {
    let r = [...e];
    const n = r.shift();
    if (n !== (n & Fy))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const i = r.shift(), s = r.shift(), a = wi(r);
    let o = [];
    for (let l = 0; l < a; l++) {
      const h = r.slice(0, Di);
      r = r.slice(Di), o.push(new Ze(Fe.Buffer.from(h)));
    }
    const c = r.slice(0, Di);
    r = r.slice(Di);
    const f = wi(r);
    let u = [];
    for (let l = 0; l < f; l++) {
      const h = r.shift(), y = wi(r), p = r.slice(0, y);
      r = r.slice(y);
      const b = wi(r), v = r.slice(0, b), x = Ot.encode(Fe.Buffer.from(v));
      r = r.slice(b), u.push({
        programIdIndex: h,
        accounts: p,
        data: x
      });
    }
    const d = {
      header: {
        numRequiredSignatures: n,
        numReadonlySignedAccounts: i,
        numReadonlyUnsignedAccounts: s
      },
      recentBlockhash: Ot.encode(Fe.Buffer.from(c)),
      accountKeys: o,
      instructions: u
    };
    return new Is(d);
  }
}
class Bc {
  constructor(e) {
    this.header = void 0, this.staticAccountKeys = void 0, this.recentBlockhash = void 0, this.compiledInstructions = void 0, this.addressTableLookups = void 0, this.header = e.header, this.staticAccountKeys = e.staticAccountKeys, this.recentBlockhash = e.recentBlockhash, this.compiledInstructions = e.compiledInstructions, this.addressTableLookups = e.addressTableLookups;
  }
  get version() {
    return 0;
  }
  get numAccountKeysFromLookups() {
    let e = 0;
    for (const r of this.addressTableLookups)
      e += r.readonlyIndexes.length + r.writableIndexes.length;
    return e;
  }
  getAccountKeys(e) {
    let r;
    if (e && "accountKeysFromLookups" in e && e.accountKeysFromLookups) {
      if (this.numAccountKeysFromLookups != e.accountKeysFromLookups.writable.length + e.accountKeysFromLookups.readonly.length)
        throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
      r = e.accountKeysFromLookups;
    } else if (e && "addressLookupTableAccounts" in e && e.addressLookupTableAccounts)
      r = this.resolveAddressTableLookups(e.addressLookupTableAccounts);
    else if (this.addressTableLookups.length > 0)
      throw new Error("Failed to get account keys because address table lookups were not resolved");
    return new Kd(this.staticAccountKeys, r);
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    const r = this.header.numRequiredSignatures, n = this.staticAccountKeys.length;
    if (e >= n) {
      const i = e - n, s = this.addressTableLookups.reduce((a, o) => a + o.writableIndexes.length, 0);
      return i < s;
    } else if (e >= this.header.numRequiredSignatures) {
      const i = e - r, a = n - r - this.header.numReadonlyUnsignedAccounts;
      return i < a;
    } else {
      const i = r - this.header.numReadonlySignedAccounts;
      return e < i;
    }
  }
  resolveAddressTableLookups(e) {
    const r = {
      writable: [],
      readonly: []
    };
    for (const n of this.addressTableLookups) {
      const i = e.find((s) => s.key.equals(n.accountKey));
      if (!i)
        throw new Error(`Failed to find address lookup table account for table key ${n.accountKey.toBase58()}`);
      for (const s of n.writableIndexes)
        if (s < i.state.addresses.length)
          r.writable.push(i.state.addresses[s]);
        else
          throw new Error(`Failed to find address for index ${s} in address lookup table ${n.accountKey.toBase58()}`);
      for (const s of n.readonlyIndexes)
        if (s < i.state.addresses.length)
          r.readonly.push(i.state.addresses[s]);
        else
          throw new Error(`Failed to find address for index ${s} in address lookup table ${n.accountKey.toBase58()}`);
    }
    return r;
  }
  static compile(e) {
    const r = jy.compile(e.instructions, e.payerKey), n = new Array(), i = {
      writable: new Array(),
      readonly: new Array()
    }, s = e.addressLookupTableAccounts || [];
    for (const u of s) {
      const d = r.extractTableLookup(u);
      if (d !== void 0) {
        const [l, {
          writable: h,
          readonly: y
        }] = d;
        n.push(l), i.writable.push(...h), i.readonly.push(...y);
      }
    }
    const [a, o] = r.getMessageComponents(), f = new Kd(o, i).compileInstructions(e.instructions);
    return new Bc({
      header: a,
      staticAccountKeys: o,
      recentBlockhash: e.recentBlockhash,
      compiledInstructions: f,
      addressTableLookups: n
    });
  }
  serialize() {
    const e = Array();
    Ni(e, this.staticAccountKeys.length);
    const r = this.serializeInstructions(), n = Array();
    Ni(n, this.compiledInstructions.length);
    const i = this.serializeAddressTableLookups(), s = Array();
    Ni(s, this.addressTableLookups.length);
    const a = Re([st("prefix"), Re([st("numRequiredSignatures"), st("numReadonlySignedAccounts"), st("numReadonlyUnsignedAccounts")], "header"), xt(e.length, "staticAccountKeysLength"), Ir(er(), this.staticAccountKeys.length, "staticAccountKeys"), er("recentBlockhash"), xt(n.length, "instructionsLength"), xt(r.length, "serializedInstructions"), xt(s.length, "addressTableLookupsLength"), xt(i.length, "serializedAddressTableLookups")]), o = new Uint8Array(yo), f = a.encode({
      prefix: 128,
      header: this.header,
      staticAccountKeysLength: new Uint8Array(e),
      staticAccountKeys: this.staticAccountKeys.map((u) => u.toBytes()),
      recentBlockhash: Ot.decode(this.recentBlockhash),
      instructionsLength: new Uint8Array(n),
      serializedInstructions: r,
      addressTableLookupsLength: new Uint8Array(s),
      serializedAddressTableLookups: i
    }, o);
    return o.slice(0, f);
  }
  serializeInstructions() {
    let e = 0;
    const r = new Uint8Array(yo);
    for (const n of this.compiledInstructions) {
      const i = Array();
      Ni(i, n.accountKeyIndexes.length);
      const s = Array();
      Ni(s, n.data.length);
      const a = Re([st("programIdIndex"), xt(i.length, "encodedAccountKeyIndexesLength"), Ir(st(), n.accountKeyIndexes.length, "accountKeyIndexes"), xt(s.length, "encodedDataLength"), xt(n.data.length, "data")]);
      e += a.encode({
        programIdIndex: n.programIdIndex,
        encodedAccountKeyIndexesLength: new Uint8Array(i),
        accountKeyIndexes: n.accountKeyIndexes,
        encodedDataLength: new Uint8Array(s),
        data: n.data
      }, r, e);
    }
    return r.slice(0, e);
  }
  serializeAddressTableLookups() {
    let e = 0;
    const r = new Uint8Array(yo);
    for (const n of this.addressTableLookups) {
      const i = Array();
      Ni(i, n.writableIndexes.length);
      const s = Array();
      Ni(s, n.readonlyIndexes.length);
      const a = Re([er("accountKey"), xt(i.length, "encodedWritableIndexesLength"), Ir(st(), n.writableIndexes.length, "writableIndexes"), xt(s.length, "encodedReadonlyIndexesLength"), Ir(st(), n.readonlyIndexes.length, "readonlyIndexes")]);
      e += a.encode({
        accountKey: n.accountKey.toBytes(),
        encodedWritableIndexesLength: new Uint8Array(i),
        writableIndexes: n.writableIndexes,
        encodedReadonlyIndexesLength: new Uint8Array(s),
        readonlyIndexes: n.readonlyIndexes
      }, r, e);
    }
    return r.slice(0, e);
  }
  static deserialize(e) {
    let r = [...e];
    const n = r.shift(), i = n & Fy;
    _r(n !== i, "Expected versioned message but received legacy message");
    const s = i;
    _r(s === 0, `Expected versioned message with version 0 but found version ${s}`);
    const a = {
      numRequiredSignatures: r.shift(),
      numReadonlySignedAccounts: r.shift(),
      numReadonlyUnsignedAccounts: r.shift()
    }, o = [], c = wi(r);
    for (let y = 0; y < c; y++)
      o.push(new Ze(r.splice(0, Di)));
    const f = Ot.encode(r.splice(0, Di)), u = wi(r), d = [];
    for (let y = 0; y < u; y++) {
      const p = r.shift(), b = wi(r), v = r.splice(0, b), x = wi(r), I = new Uint8Array(r.splice(0, x));
      d.push({
        programIdIndex: p,
        accountKeyIndexes: v,
        data: I
      });
    }
    const l = wi(r), h = [];
    for (let y = 0; y < l; y++) {
      const p = new Ze(r.splice(0, Di)), b = wi(r), v = r.splice(0, b), x = wi(r), I = r.splice(0, x);
      h.push({
        accountKey: p,
        writableIndexes: v,
        readonlyIndexes: I
      });
    }
    return new Bc({
      header: a,
      staticAccountKeys: o,
      recentBlockhash: f,
      compiledInstructions: d,
      addressTableLookups: h
    });
  }
}
const S_ = {
  deserializeMessageVersion(t) {
    const e = t[0], r = e & Fy;
    return r === e ? "legacy" : r;
  },
  deserialize: (t) => {
    const e = S_.deserializeMessageVersion(t);
    if (e === "legacy")
      return Is.from(t);
    if (e === 0)
      return Bc.deserialize(t);
    throw new Error(`Transaction message version ${e} deserialization is not supported`);
  }
};
let ga = /* @__PURE__ */ function(t) {
  return t[t.BLOCKHEIGHT_EXCEEDED = 0] = "BLOCKHEIGHT_EXCEEDED", t[t.PROCESSED = 1] = "PROCESSED", t[t.TIMED_OUT = 2] = "TIMED_OUT", t[t.NONCE_INVALID = 3] = "NONCE_INVALID", t;
}({});
const RX = Fe.Buffer.alloc(nf).fill(0);
class Kr {
  constructor(e) {
    this.keys = void 0, this.programId = void 0, this.data = Fe.Buffer.alloc(0), this.programId = e.programId, this.keys = e.keys, e.data && (this.data = e.data);
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      keys: this.keys.map(({
        pubkey: e,
        isSigner: r,
        isWritable: n
      }) => ({
        pubkey: e.toJSON(),
        isSigner: r,
        isWritable: n
      })),
      programId: this.programId.toJSON(),
      data: [...this.data]
    };
  }
}
class Or {
  /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer
   */
  // Construct a transaction with a blockhash and lastValidBlockHeight
  // Construct a transaction using a durable nonce
  /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */
  /**
   * Construct an empty Transaction
   */
  constructor(e) {
    if (this.signatures = [], this.feePayer = void 0, this.instructions = [], this.recentBlockhash = void 0, this.lastValidBlockHeight = void 0, this.nonceInfo = void 0, this.minNonceContextSlot = void 0, this._message = void 0, this._json = void 0, !!e)
      if (e.feePayer && (this.feePayer = e.feePayer), e.signatures && (this.signatures = e.signatures), Object.prototype.hasOwnProperty.call(e, "nonceInfo")) {
        const {
          minContextSlot: r,
          nonceInfo: n
        } = e;
        this.minNonceContextSlot = r, this.nonceInfo = n;
      } else if (Object.prototype.hasOwnProperty.call(e, "lastValidBlockHeight")) {
        const {
          blockhash: r,
          lastValidBlockHeight: n
        } = e;
        this.recentBlockhash = r, this.lastValidBlockHeight = n;
      } else {
        const {
          recentBlockhash: r,
          nonceInfo: n
        } = e;
        n && (this.nonceInfo = n), this.recentBlockhash = r;
      }
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      recentBlockhash: this.recentBlockhash || null,
      feePayer: this.feePayer ? this.feePayer.toJSON() : null,
      nonceInfo: this.nonceInfo ? {
        nonce: this.nonceInfo.nonce,
        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
      } : null,
      instructions: this.instructions.map((e) => e.toJSON()),
      signers: this.signatures.map(({
        publicKey: e
      }) => e.toJSON())
    };
  }
  /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */
  add(...e) {
    if (e.length === 0)
      throw new Error("No instructions");
    return e.forEach((r) => {
      "instructions" in r ? this.instructions = this.instructions.concat(r.instructions) : "data" in r && "programId" in r && "keys" in r ? this.instructions.push(r) : this.instructions.push(new Kr(r));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json))
      return this._message;
    let e, r;
    if (this.nonceInfo ? (e = this.nonceInfo.nonce, this.instructions[0] != this.nonceInfo.nonceInstruction ? r = [this.nonceInfo.nonceInstruction, ...this.instructions] : r = this.instructions) : (e = this.recentBlockhash, r = this.instructions), !e)
      throw new Error("Transaction recentBlockhash required");
    r.length < 1 && console.warn("No instructions provided");
    let n;
    if (this.feePayer)
      n = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      n = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    for (let p = 0; p < r.length; p++)
      if (r[p].programId === void 0)
        throw new Error(`Transaction instruction index ${p} has undefined program id`);
    const i = [], s = [];
    r.forEach((p) => {
      p.keys.forEach((v) => {
        s.push({
          ...v
        });
      });
      const b = p.programId.toString();
      i.includes(b) || i.push(b);
    }), i.forEach((p) => {
      s.push({
        pubkey: new Ze(p),
        isSigner: !1,
        isWritable: !1
      });
    });
    const a = [];
    s.forEach((p) => {
      const b = p.pubkey.toString(), v = a.findIndex((x) => x.pubkey.toString() === b);
      v > -1 ? (a[v].isWritable = a[v].isWritable || p.isWritable, a[v].isSigner = a[v].isSigner || p.isSigner) : a.push(p);
    }), a.sort(function(p, b) {
      if (p.isSigner !== b.isSigner)
        return p.isSigner ? -1 : 1;
      if (p.isWritable !== b.isWritable)
        return p.isWritable ? -1 : 1;
      const v = {
        localeMatcher: "best fit",
        usage: "sort",
        sensitivity: "variant",
        ignorePunctuation: !1,
        numeric: !1,
        caseFirst: "lower"
      };
      return p.pubkey.toBase58().localeCompare(b.pubkey.toBase58(), "en", v);
    });
    const o = a.findIndex((p) => p.pubkey.equals(n));
    if (o > -1) {
      const [p] = a.splice(o, 1);
      p.isSigner = !0, p.isWritable = !0, a.unshift(p);
    } else
      a.unshift({
        pubkey: n,
        isSigner: !0,
        isWritable: !0
      });
    for (const p of this.signatures) {
      const b = a.findIndex((v) => v.pubkey.equals(p.publicKey));
      if (b > -1)
        a[b].isSigner || (a[b].isSigner = !0, console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release."));
      else
        throw new Error(`unknown signer: ${p.publicKey.toString()}`);
    }
    let c = 0, f = 0, u = 0;
    const d = [], l = [];
    a.forEach(({
      pubkey: p,
      isSigner: b,
      isWritable: v
    }) => {
      b ? (d.push(p.toString()), c += 1, v || (f += 1)) : (l.push(p.toString()), v || (u += 1));
    });
    const h = d.concat(l), y = r.map((p) => {
      const {
        data: b,
        programId: v
      } = p;
      return {
        programIdIndex: h.indexOf(v.toString()),
        accounts: p.keys.map((x) => h.indexOf(x.pubkey.toString())),
        data: Ot.encode(b)
      };
    });
    return y.forEach((p) => {
      _r(p.programIdIndex >= 0), p.accounts.forEach((b) => _r(b >= 0));
    }), new Is({
      header: {
        numRequiredSignatures: c,
        numReadonlySignedAccounts: f,
        numReadonlyUnsignedAccounts: u
      },
      accountKeys: h,
      recentBlockhash: e,
      instructions: y
    });
  }
  /**
   * @internal
   */
  _compile() {
    const e = this.compileMessage(), r = e.accountKeys.slice(0, e.header.numRequiredSignatures);
    return this.signatures.length === r.length && this.signatures.every((i, s) => r[s].equals(i.publicKey)) || (this.signatures = r.map((n) => ({
      signature: null,
      publicKey: n
    }))), e;
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this._compile().serialize();
  }
  /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */
  async getEstimatedFee(e) {
    return (await e.getFeeForMessage(this.compileMessage())).value;
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */
  setSigners(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set();
    this.signatures = e.filter((n) => {
      const i = n.toString();
      return r.has(i) ? !1 : (r.add(i), !0);
    }).map((n) => ({
      signature: null,
      publicKey: n
    }));
  }
  /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  sign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set(), n = [];
    for (const s of e) {
      const a = s.publicKey.toString();
      r.has(a) || (r.add(a), n.push(s));
    }
    this.signatures = n.map((s) => ({
      signature: null,
      publicKey: s.publicKey
    }));
    const i = this._compile();
    this._partialSign(i, ...n);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  partialSign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set(), n = [];
    for (const s of e) {
      const a = s.publicKey.toString();
      r.has(a) || (r.add(a), n.push(s));
    }
    const i = this._compile();
    this._partialSign(i, ...n);
  }
  /**
   * @internal
   */
  _partialSign(e, ...r) {
    const n = e.serialize();
    r.forEach((i) => {
      const s = m_(n, i.secretKey);
      this._addSignature(i.publicKey, Wt(s));
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */
  addSignature(e, r) {
    this._compile(), this._addSignature(e, r);
  }
  /**
   * @internal
   */
  _addSignature(e, r) {
    _r(r.length === 64);
    const n = this.signatures.findIndex((i) => e.equals(i.publicKey));
    if (n < 0)
      throw new Error(`unknown signer: ${e.toString()}`);
    this.signatures[n].signature = Fe.Buffer.from(r);
  }
  /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */
  verifySignatures(e) {
    return this._verifySignatures(this.serializeMessage(), e === void 0 ? !0 : e);
  }
  /**
   * @internal
   */
  _verifySignatures(e, r) {
    for (const {
      signature: n,
      publicKey: i
    } of this.signatures)
      if (n === null) {
        if (r)
          return !1;
      } else if (!vX(n, e, i.toBytes()))
        return !1;
    return !0;
  }
  /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */
  serialize(e) {
    const {
      requireAllSignatures: r,
      verifySignatures: n
    } = Object.assign({
      requireAllSignatures: !0,
      verifySignatures: !0
    }, e), i = this.serializeMessage();
    if (n && !this._verifySignatures(i, r))
      throw new Error("Signature verification failed");
    return this._serialize(i);
  }
  /**
   * @internal
   */
  _serialize(e) {
    const {
      signatures: r
    } = this, n = [];
    Ni(n, r.length);
    const i = n.length + r.length * 64 + e.length, s = Fe.Buffer.alloc(i);
    return _r(r.length < 256), Fe.Buffer.from(n).copy(s, 0), r.forEach(({
      signature: a
    }, o) => {
      a !== null && (_r(a.length === 64, "signature has invalid length"), Fe.Buffer.from(a).copy(s, n.length + o * 64));
    }), e.copy(s, n.length + r.length * 64), _r(s.length <= yo, `Transaction too large: ${s.length} > ${yo}`), s;
  }
  /**
   * Deprecated method
   * @internal
   */
  get keys() {
    return _r(this.instructions.length === 1), this.instructions[0].keys.map((e) => e.pubkey);
  }
  /**
   * Deprecated method
   * @internal
   */
  get programId() {
    return _r(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @internal
   */
  get data() {
    return _r(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */
  static from(e) {
    let r = [...e];
    const n = wi(r);
    let i = [];
    for (let s = 0; s < n; s++) {
      const a = r.slice(0, nf);
      r = r.slice(nf), i.push(Ot.encode(Fe.Buffer.from(a)));
    }
    return Or.populate(Is.from(r), i);
  }
  /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */
  static populate(e, r = []) {
    const n = new Or();
    return n.recentBlockhash = e.recentBlockhash, e.header.numRequiredSignatures > 0 && (n.feePayer = e.accountKeys[0]), r.forEach((i, s) => {
      const a = {
        signature: i == Ot.encode(RX) ? null : Ot.decode(i),
        publicKey: e.accountKeys[s]
      };
      n.signatures.push(a);
    }), e.instructions.forEach((i) => {
      const s = i.accounts.map((a) => {
        const o = e.accountKeys[a];
        return {
          pubkey: o,
          isSigner: n.signatures.some((c) => c.publicKey.toString() === o.toString()) || e.isAccountSigner(a),
          isWritable: e.isAccountWritable(a)
        };
      });
      n.instructions.push(new Kr({
        keys: s,
        programId: e.accountKeys[i.programIdIndex],
        data: Ot.decode(i.data)
      }));
    }), n._message = e, n._json = n.toJSON(), n;
  }
}
class E_ {
  constructor(e) {
    this.payerKey = void 0, this.instructions = void 0, this.recentBlockhash = void 0, this.payerKey = e.payerKey, this.instructions = e.instructions, this.recentBlockhash = e.recentBlockhash;
  }
  static decompile(e, r) {
    const {
      header: n,
      compiledInstructions: i,
      recentBlockhash: s
    } = e, {
      numRequiredSignatures: a,
      numReadonlySignedAccounts: o,
      numReadonlyUnsignedAccounts: c
    } = n, f = a - o;
    _r(f > 0, "Message header is invalid");
    const u = e.staticAccountKeys.length - a - c;
    _r(u >= 0, "Message header is invalid");
    const d = e.getAccountKeys(r), l = d.get(0);
    if (l === void 0)
      throw new Error("Failed to decompile message because no account keys were found");
    const h = [];
    for (const y of i) {
      const p = [];
      for (const v of y.accountKeyIndexes) {
        const x = d.get(v);
        if (x === void 0)
          throw new Error(`Failed to find key for account key index ${v}`);
        const I = v < a;
        let L;
        I ? L = v < f : v < d.staticAccountKeys.length ? L = v - a < u : L = v - d.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
        d.accountKeysFromLookups.writable.length, p.push({
          pubkey: x,
          isSigner: v < n.numRequiredSignatures,
          isWritable: L
        });
      }
      const b = d.get(y.programIdIndex);
      if (b === void 0)
        throw new Error(`Failed to find program id for program id index ${y.programIdIndex}`);
      h.push(new Kr({
        programId: b,
        data: Wt(y.data),
        keys: p
      }));
    }
    return new E_({
      payerKey: l,
      instructions: h,
      recentBlockhash: s
    });
  }
  compileToLegacyMessage() {
    return Is.compile({
      payerKey: this.payerKey,
      recentBlockhash: this.recentBlockhash,
      instructions: this.instructions
    });
  }
  compileToV0Message(e) {
    return Bc.compile({
      payerKey: this.payerKey,
      recentBlockhash: this.recentBlockhash,
      instructions: this.instructions,
      addressLookupTableAccounts: e
    });
  }
}
class x_ {
  get version() {
    return this.message.version;
  }
  constructor(e, r) {
    if (this.signatures = void 0, this.message = void 0, r !== void 0)
      _r(r.length === e.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures"), this.signatures = r;
    else {
      const n = [];
      for (let i = 0; i < e.header.numRequiredSignatures; i++)
        n.push(new Uint8Array(nf));
      this.signatures = n;
    }
    this.message = e;
  }
  serialize() {
    const e = this.message.serialize(), r = Array();
    Ni(r, this.signatures.length);
    const n = Re([xt(r.length, "encodedSignaturesLength"), Ir(xX(), this.signatures.length, "signatures"), xt(e.length, "serializedMessage")]), i = new Uint8Array(2048), s = n.encode({
      encodedSignaturesLength: new Uint8Array(r),
      signatures: this.signatures,
      serializedMessage: e
    }, i);
    return i.slice(0, s);
  }
  static deserialize(e) {
    let r = [...e];
    const n = [], i = wi(r);
    for (let a = 0; a < i; a++)
      n.push(new Uint8Array(r.splice(0, nf)));
    const s = S_.deserialize(new Uint8Array(r));
    return new x_(s, n);
  }
  sign(e) {
    const r = this.message.serialize(), n = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
    for (const i of e) {
      const s = n.findIndex((a) => a.equals(i.publicKey));
      _r(s >= 0, `Cannot sign with non signer key ${i.publicKey.toBase58()}`), this.signatures[s] = m_(r, i.secretKey);
    }
  }
  addSignature(e, r) {
    _r(r.byteLength === 64, "Signature must be 64 bytes long");
    const i = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures).findIndex((s) => s.equals(e));
    _r(i >= 0, `Can not add signature; \`${e.toBase58()}\` is not required to sign this transaction`), this.signatures[i] = r;
  }
}
const PX = 160, OX = 64, BX = PX / OX, kk = 1e3 / BX, Ws = new Ze("SysvarC1ock11111111111111111111111111111111"), MX = new Ze("SysvarEpochSchedu1e111111111111111111111111"), CX = new Ze("Sysvar1nstructions1111111111111111111111111"), tp = new Ze("SysvarRecentB1ockHashes11111111111111111111"), sf = new Ze("SysvarRent111111111111111111111111111111111"), NX = new Ze("SysvarRewards111111111111111111111111111111"), UX = new Ze("SysvarS1otHashes111111111111111111111111111"), LX = new Ze("SysvarS1otHistory11111111111111111111111111"), rp = new Ze("SysvarStakeHistory1111111111111111111111111");
async function Hv(t, e, r, n) {
  const i = n && {
    skipPreflight: n.skipPreflight,
    preflightCommitment: n.preflightCommitment || n.commitment,
    maxRetries: n.maxRetries,
    minContextSlot: n.minContextSlot
  }, s = await t.sendTransaction(e, r, i);
  let a;
  if (e.recentBlockhash != null && e.lastValidBlockHeight != null)
    a = (await t.confirmTransaction({
      abortSignal: n == null ? void 0 : n.abortSignal,
      signature: s,
      blockhash: e.recentBlockhash,
      lastValidBlockHeight: e.lastValidBlockHeight
    }, n && n.commitment)).value;
  else if (e.minNonceContextSlot != null && e.nonceInfo != null) {
    const {
      nonceInstruction: o
    } = e.nonceInfo, c = o.keys[0].pubkey;
    a = (await t.confirmTransaction({
      abortSignal: n == null ? void 0 : n.abortSignal,
      minContextSlot: e.minNonceContextSlot,
      nonceAccountPubkey: c,
      nonceValue: e.nonceInfo.nonce,
      signature: s
    }, n && n.commitment)).value;
  } else
    (n == null ? void 0 : n.abortSignal) != null && console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable."), a = (await t.confirmTransaction(s, n && n.commitment)).value;
  if (a.err)
    throw new Error(`Transaction ${s} failed (${JSON.stringify(a)})`);
  return s;
}
function Ko(t) {
  return new Promise((e) => setTimeout(e, t));
}
function mr(t, e) {
  const r = t.layout.span >= 0 ? t.layout.span : Tk(t, e), n = Fe.Buffer.alloc(r), i = Object.assign({
    instruction: t.index
  }, e);
  return t.layout.encode(i, n), n;
}
function Rr(t, e) {
  let r;
  try {
    r = t.layout.decode(e);
  } catch (n) {
    throw new Error("invalid instruction; " + n);
  }
  if (r.instruction !== t.index)
    throw new Error(`invalid instruction; instruction index mismatch ${r.instruction} != ${t.index}`);
  return r;
}
const Rk = gr("lamportsPerSignature"), Pk = Re([Be("version"), Be("state"), er("authorizedPubkey"), er("nonce"), Re([Rk], "feeCalculator")]), Gv = Pk.span;
class $y {
  /**
   * @internal
   */
  constructor(e) {
    this.authorizedPubkey = void 0, this.nonce = void 0, this.feeCalculator = void 0, this.authorizedPubkey = e.authorizedPubkey, this.nonce = e.nonce, this.feeCalculator = e.feeCalculator;
  }
  /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */
  static fromAccountData(e) {
    const r = Pk.decode(Wt(e), 0);
    return new $y({
      authorizedPubkey: new Ze(r.authorizedPubkey),
      nonce: new Ze(r.nonce).toString(),
      feeCalculator: r.feeCalculator
    });
  }
}
const DX = (t) => {
  const e = t.decode.bind(t), r = t.encode.bind(t);
  return {
    decode: e,
    encode: r
  };
}, FX = (t) => (e) => {
  const r = xt(t, e), {
    encode: n,
    decode: i
  } = DX(r), s = r;
  return s.decode = (a, o) => {
    const c = i(a, o);
    return lQ(Fe.Buffer.from(c));
  }, s.encode = (a, o, c) => {
    const f = nk(a, t);
    return n(f, o, c);
  }, s;
}, af = FX(8);
class jX {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a system instruction and retrieve the instruction type.
   */
  static decodeInstructionType(e) {
    this.checkProgramId(e.programId);
    const n = Be("instruction").decode(e.data);
    let i;
    for (const [s, a] of Object.entries(Hr))
      if (a.index == n) {
        i = s;
        break;
      }
    if (!i)
      throw new Error("Instruction type incorrect; not a SystemInstruction");
    return i;
  }
  /**
   * Decode a create account system instruction and retrieve the instruction params.
   */
  static decodeCreateAccount(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      lamports: r,
      space: n,
      programId: i
    } = Rr(Hr.Create, e.data);
    return {
      fromPubkey: e.keys[0].pubkey,
      newAccountPubkey: e.keys[1].pubkey,
      lamports: r,
      space: n,
      programId: new Ze(i)
    };
  }
  /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */
  static decodeTransfer(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      lamports: r
    } = Rr(Hr.Transfer, e.data);
    return {
      fromPubkey: e.keys[0].pubkey,
      toPubkey: e.keys[1].pubkey,
      lamports: r
    };
  }
  /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */
  static decodeTransferWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      lamports: r,
      seed: n,
      programId: i
    } = Rr(Hr.TransferWithSeed, e.data);
    return {
      fromPubkey: e.keys[0].pubkey,
      basePubkey: e.keys[1].pubkey,
      toPubkey: e.keys[2].pubkey,
      lamports: r,
      seed: n,
      programId: new Ze(i)
    };
  }
  /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */
  static decodeAllocate(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 1);
    const {
      space: r
    } = Rr(Hr.Allocate, e.data);
    return {
      accountPubkey: e.keys[0].pubkey,
      space: r
    };
  }
  /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */
  static decodeAllocateWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 1);
    const {
      base: r,
      seed: n,
      space: i,
      programId: s
    } = Rr(Hr.AllocateWithSeed, e.data);
    return {
      accountPubkey: e.keys[0].pubkey,
      basePubkey: new Ze(r),
      seed: n,
      space: i,
      programId: new Ze(s)
    };
  }
  /**
   * Decode an assign system instruction and retrieve the instruction params.
   */
  static decodeAssign(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 1);
    const {
      programId: r
    } = Rr(Hr.Assign, e.data);
    return {
      accountPubkey: e.keys[0].pubkey,
      programId: new Ze(r)
    };
  }
  /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */
  static decodeAssignWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 1);
    const {
      base: r,
      seed: n,
      programId: i
    } = Rr(Hr.AssignWithSeed, e.data);
    return {
      accountPubkey: e.keys[0].pubkey,
      basePubkey: new Ze(r),
      seed: n,
      programId: new Ze(i)
    };
  }
  /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */
  static decodeCreateWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      base: r,
      seed: n,
      lamports: i,
      space: s,
      programId: a
    } = Rr(Hr.CreateWithSeed, e.data);
    return {
      fromPubkey: e.keys[0].pubkey,
      newAccountPubkey: e.keys[1].pubkey,
      basePubkey: new Ze(r),
      seed: n,
      lamports: i,
      space: s,
      programId: new Ze(a)
    };
  }
  /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */
  static decodeNonceInitialize(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      authorized: r
    } = Rr(Hr.InitializeNonceAccount, e.data);
    return {
      noncePubkey: e.keys[0].pubkey,
      authorizedPubkey: new Ze(r)
    };
  }
  /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */
  static decodeNonceAdvance(e) {
    return this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3), Rr(Hr.AdvanceNonceAccount, e.data), {
      noncePubkey: e.keys[0].pubkey,
      authorizedPubkey: e.keys[2].pubkey
    };
  }
  /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */
  static decodeNonceWithdraw(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 5);
    const {
      lamports: r
    } = Rr(Hr.WithdrawNonceAccount, e.data);
    return {
      noncePubkey: e.keys[0].pubkey,
      toPubkey: e.keys[1].pubkey,
      authorizedPubkey: e.keys[4].pubkey,
      lamports: r
    };
  }
  /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */
  static decodeNonceAuthorize(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      authorized: r
    } = Rr(Hr.AuthorizeNonceAccount, e.data);
    return {
      noncePubkey: e.keys[0].pubkey,
      authorizedPubkey: e.keys[1].pubkey,
      newAuthorizedPubkey: new Ze(r)
    };
  }
  /**
   * @internal
   */
  static checkProgramId(e) {
    if (!e.equals(zn.programId))
      throw new Error("invalid instruction; programId is not SystemProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(e, r) {
    if (e.length < r)
      throw new Error(`invalid instruction; found ${e.length} keys, expected at least ${r}`);
  }
}
const Hr = Object.freeze({
  Create: {
    index: 0,
    layout: Re([Be("instruction"), Gr("lamports"), Gr("space"), er("programId")])
  },
  Assign: {
    index: 1,
    layout: Re([Be("instruction"), er("programId")])
  },
  Transfer: {
    index: 2,
    layout: Re([Be("instruction"), af("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: Re([Be("instruction"), er("base"), Xo("seed"), Gr("lamports"), Gr("space"), er("programId")])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: Re([Be("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: Re([Be("instruction"), Gr("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: Re([Be("instruction"), er("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: Re([Be("instruction"), er("authorized")])
  },
  Allocate: {
    index: 8,
    layout: Re([Be("instruction"), Gr("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: Re([Be("instruction"), er("base"), Xo("seed"), Gr("space"), er("programId")])
  },
  AssignWithSeed: {
    index: 10,
    layout: Re([Be("instruction"), er("base"), Xo("seed"), er("programId")])
  },
  TransferWithSeed: {
    index: 11,
    layout: Re([Be("instruction"), af("lamports"), Xo("seed"), er("programId")])
  },
  UpgradeNonceAccount: {
    index: 12,
    layout: Re([Be("instruction")])
  }
});
class zn {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the System program
   */
  /**
   * Generate a transaction instruction that creates a new account
   */
  static createAccount(e) {
    const r = Hr.Create, n = mr(r, {
      lamports: e.lamports,
      space: e.space,
      programId: Wt(e.programId.toBuffer())
    });
    return new Kr({
      keys: [{
        pubkey: e.fromPubkey,
        isSigner: !0,
        isWritable: !0
      }, {
        pubkey: e.newAccountPubkey,
        isSigner: !0,
        isWritable: !0
      }],
      programId: this.programId,
      data: n
    });
  }
  /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */
  static transfer(e) {
    let r, n;
    if ("basePubkey" in e) {
      const i = Hr.TransferWithSeed;
      r = mr(i, {
        lamports: BigInt(e.lamports),
        seed: e.seed,
        programId: Wt(e.programId.toBuffer())
      }), n = [{
        pubkey: e.fromPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: e.basePubkey,
        isSigner: !0,
        isWritable: !1
      }, {
        pubkey: e.toPubkey,
        isSigner: !1,
        isWritable: !0
      }];
    } else {
      const i = Hr.Transfer;
      r = mr(i, {
        lamports: BigInt(e.lamports)
      }), n = [{
        pubkey: e.fromPubkey,
        isSigner: !0,
        isWritable: !0
      }, {
        pubkey: e.toPubkey,
        isSigner: !1,
        isWritable: !0
      }];
    }
    return new Kr({
      keys: n,
      programId: this.programId,
      data: r
    });
  }
  /**
   * Generate a transaction instruction that assigns an account to a program
   */
  static assign(e) {
    let r, n;
    if ("basePubkey" in e) {
      const i = Hr.AssignWithSeed;
      r = mr(i, {
        base: Wt(e.basePubkey.toBuffer()),
        seed: e.seed,
        programId: Wt(e.programId.toBuffer())
      }), n = [{
        pubkey: e.accountPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: e.basePubkey,
        isSigner: !0,
        isWritable: !1
      }];
    } else {
      const i = Hr.Assign;
      r = mr(i, {
        programId: Wt(e.programId.toBuffer())
      }), n = [{
        pubkey: e.accountPubkey,
        isSigner: !0,
        isWritable: !0
      }];
    }
    return new Kr({
      keys: n,
      programId: this.programId,
      data: r
    });
  }
  /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */
  static createAccountWithSeed(e) {
    const r = Hr.CreateWithSeed, n = mr(r, {
      base: Wt(e.basePubkey.toBuffer()),
      seed: e.seed,
      lamports: e.lamports,
      space: e.space,
      programId: Wt(e.programId.toBuffer())
    });
    let i = [{
      pubkey: e.fromPubkey,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: e.newAccountPubkey,
      isSigner: !1,
      isWritable: !0
    }];
    return e.basePubkey != e.fromPubkey && i.push({
      pubkey: e.basePubkey,
      isSigner: !0,
      isWritable: !1
    }), new Kr({
      keys: i,
      programId: this.programId,
      data: n
    });
  }
  /**
   * Generate a transaction that creates a new Nonce account
   */
  static createNonceAccount(e) {
    const r = new Or();
    "basePubkey" in e && "seed" in e ? r.add(zn.createAccountWithSeed({
      fromPubkey: e.fromPubkey,
      newAccountPubkey: e.noncePubkey,
      basePubkey: e.basePubkey,
      seed: e.seed,
      lamports: e.lamports,
      space: Gv,
      programId: this.programId
    })) : r.add(zn.createAccount({
      fromPubkey: e.fromPubkey,
      newAccountPubkey: e.noncePubkey,
      lamports: e.lamports,
      space: Gv,
      programId: this.programId
    }));
    const n = {
      noncePubkey: e.noncePubkey,
      authorizedPubkey: e.authorizedPubkey
    };
    return r.add(this.nonceInitialize(n)), r;
  }
  /**
   * Generate an instruction to initialize a Nonce account
   */
  static nonceInitialize(e) {
    const r = Hr.InitializeNonceAccount, n = mr(r, {
      authorized: Wt(e.authorizedPubkey.toBuffer())
    }), i = {
      keys: [{
        pubkey: e.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: tp,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: sf,
        isSigner: !1,
        isWritable: !1
      }],
      programId: this.programId,
      data: n
    };
    return new Kr(i);
  }
  /**
   * Generate an instruction to advance the nonce in a Nonce account
   */
  static nonceAdvance(e) {
    const r = Hr.AdvanceNonceAccount, n = mr(r), i = {
      keys: [{
        pubkey: e.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: tp,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: e.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: n
    };
    return new Kr(i);
  }
  /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */
  static nonceWithdraw(e) {
    const r = Hr.WithdrawNonceAccount, n = mr(r, {
      lamports: e.lamports
    });
    return new Kr({
      keys: [{
        pubkey: e.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: e.toPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: tp,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: sf,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: e.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: n
    });
  }
  /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */
  static nonceAuthorize(e) {
    const r = Hr.AuthorizeNonceAccount, n = mr(r, {
      authorized: Wt(e.newAuthorizedPubkey.toBuffer())
    });
    return new Kr({
      keys: [{
        pubkey: e.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: e.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: n
    });
  }
  /**
   * Generate a transaction instruction that allocates space in an account without funding
   */
  static allocate(e) {
    let r, n;
    if ("basePubkey" in e) {
      const i = Hr.AllocateWithSeed;
      r = mr(i, {
        base: Wt(e.basePubkey.toBuffer()),
        seed: e.seed,
        space: e.space,
        programId: Wt(e.programId.toBuffer())
      }), n = [{
        pubkey: e.accountPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: e.basePubkey,
        isSigner: !0,
        isWritable: !1
      }];
    } else {
      const i = Hr.Allocate;
      r = mr(i, {
        space: e.space
      }), n = [{
        pubkey: e.accountPubkey,
        isSigner: !0,
        isWritable: !0
      }];
    }
    return new Kr({
      keys: n,
      programId: this.programId,
      data: r
    });
  }
}
zn.programId = new Ze("11111111111111111111111111111111");
const $X = yo - 300;
class Mc {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Amount of program data placed in each load Transaction
   */
  /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */
  static getMinNumSignatures(e) {
    return 2 * // Every transaction requires two signatures (payer + program)
    (Math.ceil(e / Mc.chunkSize) + 1 + // Add one for Create transaction
    1);
  }
  /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */
  static async load(e, r, n, i, s) {
    {
      const d = await e.getMinimumBalanceForRentExemption(s.length), l = await e.getAccountInfo(n.publicKey, "confirmed");
      let h = null;
      if (l !== null) {
        if (l.executable)
          return console.error("Program load failed, account is already executable"), !1;
        l.data.length !== s.length && (h = h || new Or(), h.add(zn.allocate({
          accountPubkey: n.publicKey,
          space: s.length
        }))), l.owner.equals(i) || (h = h || new Or(), h.add(zn.assign({
          accountPubkey: n.publicKey,
          programId: i
        }))), l.lamports < d && (h = h || new Or(), h.add(zn.transfer({
          fromPubkey: r.publicKey,
          toPubkey: n.publicKey,
          lamports: d - l.lamports
        })));
      } else
        h = new Or().add(zn.createAccount({
          fromPubkey: r.publicKey,
          newAccountPubkey: n.publicKey,
          lamports: d > 0 ? d : 1,
          space: s.length,
          programId: i
        }));
      h !== null && await Hv(e, h, [r, n], {
        commitment: "confirmed"
      });
    }
    const a = Re([Be("instruction"), Be("offset"), Be("bytesLength"), Be("bytesLengthPadding"), Ir(st("byte"), Ii(Be(), -8), "bytes")]), o = Mc.chunkSize;
    let c = 0, f = s, u = [];
    for (; f.length > 0; ) {
      const d = f.slice(0, o), l = Fe.Buffer.alloc(o + 16);
      a.encode({
        instruction: 0,
        // Load instruction
        offset: c,
        bytes: d,
        bytesLength: 0,
        bytesLengthPadding: 0
      }, l);
      const h = new Or().add({
        keys: [{
          pubkey: n.publicKey,
          isSigner: !0,
          isWritable: !0
        }],
        programId: i,
        data: l
      });
      u.push(Hv(e, h, [r, n], {
        commitment: "confirmed"
      })), e._rpcEndpoint.includes("solana.com") && await Ko(1e3 / 4), c += o, f = f.slice(o);
    }
    await Promise.all(u);
    {
      const d = Re([Be("instruction")]), l = Fe.Buffer.alloc(d.span);
      d.encode({
        instruction: 1
        // Finalize instruction
      }, l);
      const h = new Or().add({
        keys: [{
          pubkey: n.publicKey,
          isSigner: !0,
          isWritable: !0
        }, {
          pubkey: sf,
          isSigner: !1,
          isWritable: !1
        }],
        programId: i,
        data: l
      }), y = "processed", p = await e.sendTransaction(h, [r, n], {
        preflightCommitment: y
      }), {
        context: b,
        value: v
      } = await e.confirmTransaction({
        signature: p,
        lastValidBlockHeight: h.lastValidBlockHeight,
        blockhash: h.recentBlockhash
      }, y);
      if (v.err)
        throw new Error(`Transaction ${p} failed (${JSON.stringify(v)})`);
      for (; ; ) {
        try {
          if (await e.getSlot({
            commitment: y
          }) > b.slot)
            break;
        } catch {
        }
        await new Promise((x) => setTimeout(x, Math.round(kk / 2)));
      }
    }
    return !0;
  }
}
Mc.chunkSize = $X;
const qX = new Ze("BPFLoader2111111111111111111111111111111111");
class WX {
  /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */
  static getMinNumSignatures(e) {
    return Mc.getMinNumSignatures(e);
  }
  /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */
  static load(e, r, n, i, s) {
    return Mc.load(e, r, n, s, i);
  }
}
function zX(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var KX = Object.prototype.toString, VX = Object.keys || function(t) {
  var e = [];
  for (var r in t)
    e.push(r);
  return e;
};
function nd(t, e) {
  var r, n, i, s, a, o, c;
  if (t === !0)
    return "true";
  if (t === !1)
    return "false";
  switch (typeof t) {
    case "object":
      if (t === null)
        return null;
      if (t.toJSON && typeof t.toJSON == "function")
        return nd(t.toJSON(), e);
      if (c = KX.call(t), c === "[object Array]") {
        for (i = "[", n = t.length - 1, r = 0; r < n; r++)
          i += nd(t[r], !0) + ",";
        return n > -1 && (i += nd(t[r], !0)), i + "]";
      } else if (c === "[object Object]") {
        for (s = VX(t).sort(), n = s.length, i = "", r = 0; r < n; )
          a = s[r], o = nd(t[a], !1), o !== void 0 && (i && (i += ","), i += JSON.stringify(a) + ":" + o), r++;
        return "{" + i + "}";
      } else
        return JSON.stringify(t);
    case "function":
    case "undefined":
      return e ? null : void 0;
    case "string":
      return JSON.stringify(t);
    default:
      return isFinite(t) ? t : null;
  }
}
var HX = function(t) {
  var e = nd(t, !1);
  if (e !== void 0)
    return "" + e;
}, w4 = /* @__PURE__ */ zX(HX);
const Hf = 32;
function mm(t) {
  let e = 0;
  for (; t > 1; )
    t /= 2, e++;
  return e;
}
function GX(t) {
  return t === 0 ? 1 : (t--, t |= t >> 1, t |= t >> 2, t |= t >> 4, t |= t >> 8, t |= t >> 16, t |= t >> 32, t + 1);
}
class Ok {
  constructor(e, r, n, i, s) {
    this.slotsPerEpoch = void 0, this.leaderScheduleSlotOffset = void 0, this.warmup = void 0, this.firstNormalEpoch = void 0, this.firstNormalSlot = void 0, this.slotsPerEpoch = e, this.leaderScheduleSlotOffset = r, this.warmup = n, this.firstNormalEpoch = i, this.firstNormalSlot = s;
  }
  getEpoch(e) {
    return this.getEpochAndSlotIndex(e)[0];
  }
  getEpochAndSlotIndex(e) {
    if (e < this.firstNormalSlot) {
      const r = mm(GX(e + Hf + 1)) - mm(Hf) - 1, n = this.getSlotsInEpoch(r), i = e - (n - Hf);
      return [r, i];
    } else {
      const r = e - this.firstNormalSlot, n = Math.floor(r / this.slotsPerEpoch), i = this.firstNormalEpoch + n, s = r % this.slotsPerEpoch;
      return [i, s];
    }
  }
  getFirstSlotInEpoch(e) {
    return e <= this.firstNormalEpoch ? (Math.pow(2, e) - 1) * Hf : (e - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
  }
  getLastSlotInEpoch(e) {
    return this.getFirstSlotInEpoch(e) + this.getSlotsInEpoch(e) - 1;
  }
  getSlotsInEpoch(e) {
    return e < this.firstNormalEpoch ? Math.pow(2, e + mm(Hf)) : this.slotsPerEpoch;
  }
}
class Zv extends Error {
  constructor(e, r) {
    super(e), this.logs = void 0, this.logs = r;
  }
}
const ZX = {
  JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
  JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
  JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
  JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
  JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
  JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
  JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
  JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
  JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
  JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
  JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
  JSON_RPC_SCAN_ERROR: -32012,
  JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
  JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
  JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
  JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class lt extends Error {
  constructor({
    code: e,
    message: r,
    data: n
  }, i) {
    super(i != null ? `${i}: ${r}` : r), this.code = void 0, this.data = void 0, this.code = e, this.data = n, this.name = "SolanaJSONRPCError";
  }
}
var JX = globalThis.fetch;
class YX extends YQ {
  constructor(e, r, n) {
    const i = (s) => {
      const a = QQ(s, {
        autoconnect: !0,
        max_reconnects: 5,
        reconnect: !0,
        reconnect_interval: 1e3,
        ...r
      });
      return "socket" in a ? this.underlyingSocket = a.socket : this.underlyingSocket = a, a;
    };
    super(i, e, r, n), this.underlyingSocket = void 0;
  }
  call(...e) {
    var n;
    const r = (n = this.underlyingSocket) == null ? void 0 : n.readyState;
    return r === 1 ? super.call(...e) : Promise.reject(new Error("Tried to call a JSON-RPC method `" + e[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + r + ")"));
  }
  notify(...e) {
    var n;
    const r = (n = this.underlyingSocket) == null ? void 0 : n.readyState;
    return r === 1 ? super.notify(...e) : Promise.reject(new Error("Tried to send a JSON-RPC notification `" + e[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + r + ")"));
  }
}
function QX(t, e) {
  let r;
  try {
    r = t.layout.decode(e);
  } catch (n) {
    throw new Error("invalid instruction; " + n);
  }
  if (r.typeIndex !== t.index)
    throw new Error(`invalid account data; account type mismatch ${r.typeIndex} != ${t.index}`);
  return r;
}
const _4 = 56;
class Jv {
  constructor(e) {
    this.key = void 0, this.state = void 0, this.key = e.key, this.state = e.state;
  }
  isActive() {
    const e = BigInt("0xffffffffffffffff");
    return this.state.deactivationSlot === e;
  }
  static deserialize(e) {
    const r = QX(XX, e), n = e.length - _4;
    _r(n >= 0, "lookup table is invalid"), _r(n % 32 === 0, "lookup table is invalid");
    const i = n / 32, {
      addresses: s
    } = Re([Ir(er(), i, "addresses")]).decode(e.slice(_4));
    return {
      deactivationSlot: r.deactivationSlot,
      lastExtendedSlot: r.lastExtendedSlot,
      lastExtendedSlotStartIndex: r.lastExtendedStartIndex,
      authority: r.authority.length !== 0 ? new Ze(r.authority[0]) : void 0,
      addresses: s.map((a) => new Ze(a))
    };
  }
}
const XX = {
  index: 1,
  layout: Re([
    Be("typeIndex"),
    af("deactivationSlot"),
    gr("lastExtendedSlot"),
    st("lastExtendedStartIndex"),
    st(),
    // option
    Ir(er(), Ii(st(), -1), "authority")
  ])
}, eee = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function tee(t) {
  const e = t.match(eee);
  if (e == null)
    throw TypeError(`Failed to validate endpoint URL \`${t}\``);
  const [
    r,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    n,
    i,
    s
  ] = e, a = t.startsWith("https:") ? "wss:" : "ws:", o = i == null ? null : parseInt(i.slice(1), 10), c = (
    // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explictly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    o == null ? "" : `:${o + 1}`
  );
  return `${a}//${n}${c}${s}`;
}
const mn = oa(gf(Ze), we(), (t) => new Ze(t)), Bk = mf([we(), Pt("base64")]), A_ = oa(gf(Fe.Buffer), Bk, (t) => Fe.Buffer.from(t[0], "base64")), Mk = 30 * 1e3;
function ree(t) {
  if (/^https?:/.test(t) === !1)
    throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
  return t;
}
function Zr(t) {
  let e, r;
  if (typeof t == "string")
    e = t;
  else if (t) {
    const {
      commitment: n,
      ...i
    } = t;
    e = n, r = i;
  }
  return {
    commitment: e,
    config: r
  };
}
function Ck(t) {
  return jr([ye({
    jsonrpc: Pt("2.0"),
    id: we(),
    result: t
  }), ye({
    jsonrpc: Pt("2.0"),
    id: we(),
    error: ye({
      code: aa(),
      message: we(),
      data: We(K5())
    })
  })]);
}
const nee = Ck(aa());
function qt(t) {
  return oa(Ck(t), nee, (e) => "error" in e ? e : {
    ...e,
    result: He(e.result, t)
  });
}
function fn(t) {
  return qt(ye({
    context: ye({
      slot: ae()
    }),
    value: t
  }));
}
function qy(t) {
  return ye({
    context: ye({
      slot: ae()
    }),
    value: t
  });
}
function vm(t, e) {
  return t === 0 ? new Bc({
    header: e.header,
    staticAccountKeys: e.accountKeys.map((r) => new Ze(r)),
    recentBlockhash: e.recentBlockhash,
    compiledInstructions: e.instructions.map((r) => ({
      programIdIndex: r.programIdIndex,
      accountKeyIndexes: r.accounts,
      data: Ot.decode(r.data)
    })),
    addressTableLookups: e.addressTableLookups
  }) : new Is(e);
}
const iee = ye({
  foundation: ae(),
  foundationTerm: ae(),
  initial: ae(),
  taper: ae(),
  terminal: ae()
}), see = qt(Te(Pe(ye({
  epoch: ae(),
  effectiveSlot: ae(),
  amount: ae(),
  postBalance: ae(),
  commission: We(Pe(ae()))
})))), aee = Te(ye({
  slot: ae(),
  prioritizationFee: ae()
})), oee = ye({
  total: ae(),
  validator: ae(),
  foundation: ae(),
  epoch: ae()
}), cee = ye({
  epoch: ae(),
  slotIndex: ae(),
  slotsInEpoch: ae(),
  absoluteSlot: ae(),
  blockHeight: We(ae()),
  transactionCount: We(ae())
}), uee = ye({
  slotsPerEpoch: ae(),
  leaderScheduleSlotOffset: ae(),
  warmup: Tn(),
  firstNormalEpoch: ae(),
  firstNormalSlot: ae()
}), fee = q0(we(), Te(ae())), Hc = Pe(jr([ye({}), we()])), dee = ye({
  err: Hc
}), lee = Pt("receivedSignature"), hee = ye({
  "solana-core": we(),
  "feature-set": We(ae())
}), S4 = fn(ye({
  err: Pe(jr([ye({}), we()])),
  logs: Pe(Te(we())),
  accounts: We(Pe(Te(Pe(ye({
    executable: Tn(),
    owner: we(),
    lamports: ae(),
    data: Te(we()),
    rentEpoch: We(ae())
  }))))),
  unitsConsumed: We(ae()),
  returnData: We(Pe(ye({
    programId: we(),
    data: mf([we(), Pt("base64")])
  })))
})), pee = fn(ye({
  byIdentity: q0(we(), Te(ae())),
  range: ye({
    firstSlot: ae(),
    lastSlot: ae()
  })
}));
function yee(t, e, r, n, i, s) {
  const a = r || JX;
  let o;
  s != null && console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
  let c;
  return n && (c = async (u, d) => {
    const l = await new Promise((h, y) => {
      try {
        n(u, d, (p, b) => h([p, b]));
      } catch (p) {
        y(p);
      }
    });
    return await a(...l);
  }), new WQ(async (u, d) => {
    const l = {
      method: "POST",
      body: u,
      agent: o,
      headers: Object.assign({
        "Content-Type": "application/json"
      }, e || {}, bte)
    };
    try {
      let h = 5, y, p = 500;
      for (; c ? y = await c(t, l) : y = await a(t, l), !(y.status !== 429 || i === !0 || (h -= 1, h === 0)); )
        console.log(`Server responded with ${y.status} ${y.statusText}.  Retrying after ${p}ms delay...`), await Ko(p), p *= 2;
      const b = await y.text();
      y.ok ? d(null, b) : d(new Error(`${y.status} ${y.statusText}: ${b}`));
    } catch (h) {
      h instanceof Error && d(h);
    }
  }, {});
}
function bee(t) {
  return (e, r) => new Promise((n, i) => {
    t.request(e, r, (s, a) => {
      if (s) {
        i(s);
        return;
      }
      n(a);
    });
  });
}
function gee(t) {
  return (e) => new Promise((r, n) => {
    e.length === 0 && r([]);
    const i = e.map((s) => t.request(s.methodName, s.args));
    t.request(i, (s, a) => {
      if (s) {
        n(s);
        return;
      }
      r(a);
    });
  });
}
const mee = qt(iee), vee = qt(oee), wee = qt(aee), _ee = qt(cee), See = qt(uee), Eee = qt(fee), xee = qt(ae()), Aee = fn(ye({
  total: ae(),
  circulating: ae(),
  nonCirculating: ae(),
  nonCirculatingAccounts: Te(mn)
})), Yv = ye({
  amount: we(),
  uiAmount: Pe(ae()),
  decimals: ae(),
  uiAmountString: We(we())
}), Iee = fn(Te(ye({
  address: mn,
  amount: we(),
  uiAmount: Pe(ae()),
  decimals: ae(),
  uiAmountString: We(we())
}))), Tee = fn(Te(ye({
  pubkey: mn,
  account: ye({
    executable: Tn(),
    owner: mn,
    lamports: ae(),
    data: A_,
    rentEpoch: ae()
  })
}))), Qv = ye({
  program: we(),
  parsed: aa(),
  space: ae()
}), kee = fn(Te(ye({
  pubkey: mn,
  account: ye({
    executable: Tn(),
    owner: mn,
    lamports: ae(),
    data: Qv,
    rentEpoch: ae()
  })
}))), Ree = fn(Te(ye({
  lamports: ae(),
  address: mn
}))), Vd = ye({
  executable: Tn(),
  owner: mn,
  lamports: ae(),
  data: A_,
  rentEpoch: ae()
}), Pee = ye({
  pubkey: mn,
  account: Vd
}), Oee = oa(jr([gf(Fe.Buffer), Qv]), jr([Bk, Qv]), (t) => Array.isArray(t) ? He(t, A_) : t), Xv = ye({
  executable: Tn(),
  owner: mn,
  lamports: ae(),
  data: Oee,
  rentEpoch: ae()
}), Bee = ye({
  pubkey: mn,
  account: Xv
}), Mee = ye({
  state: jr([Pt("active"), Pt("inactive"), Pt("activating"), Pt("deactivating")]),
  active: ae(),
  inactive: ae()
}), Cee = qt(Te(ye({
  signature: we(),
  slot: ae(),
  err: Hc,
  memo: Pe(we()),
  blockTime: We(Pe(ae()))
}))), Nee = qt(Te(ye({
  signature: we(),
  slot: ae(),
  err: Hc,
  memo: Pe(we()),
  blockTime: We(Pe(ae()))
}))), Uee = ye({
  subscription: ae(),
  result: qy(Vd)
}), Lee = ye({
  pubkey: mn,
  account: Vd
}), Dee = ye({
  subscription: ae(),
  result: qy(Lee)
}), Fee = ye({
  parent: ae(),
  slot: ae(),
  root: ae()
}), jee = ye({
  subscription: ae(),
  result: Fee
}), $ee = jr([ye({
  type: jr([Pt("firstShredReceived"), Pt("completed"), Pt("optimisticConfirmation"), Pt("root")]),
  slot: ae(),
  timestamp: ae()
}), ye({
  type: Pt("createdBank"),
  parent: ae(),
  slot: ae(),
  timestamp: ae()
}), ye({
  type: Pt("frozen"),
  slot: ae(),
  timestamp: ae(),
  stats: ye({
    numTransactionEntries: ae(),
    numSuccessfulTransactions: ae(),
    numFailedTransactions: ae(),
    maxTransactionsPerEntry: ae()
  })
}), ye({
  type: Pt("dead"),
  slot: ae(),
  timestamp: ae(),
  err: we()
})]), qee = ye({
  subscription: ae(),
  result: $ee
}), Wee = ye({
  subscription: ae(),
  result: qy(jr([dee, lee]))
}), zee = ye({
  subscription: ae(),
  result: ae()
}), Kee = ye({
  pubkey: we(),
  gossip: Pe(we()),
  tpu: Pe(we()),
  rpc: Pe(we()),
  version: Pe(we())
}), E4 = ye({
  votePubkey: we(),
  nodePubkey: we(),
  activatedStake: ae(),
  epochVoteAccount: Tn(),
  epochCredits: Te(mf([ae(), ae(), ae()])),
  commission: ae(),
  lastVote: ae(),
  rootSlot: Pe(ae())
}), Vee = qt(ye({
  current: Te(E4),
  delinquent: Te(E4)
})), Hee = jr([Pt("processed"), Pt("confirmed"), Pt("finalized")]), Gee = ye({
  slot: ae(),
  confirmations: Pe(ae()),
  err: Hc,
  confirmationStatus: We(Hee)
}), Zee = fn(Te(Pe(Gee))), Jee = qt(ae()), Nk = ye({
  accountKey: mn,
  writableIndexes: Te(ae()),
  readonlyIndexes: Te(ae())
}), I_ = ye({
  signatures: Te(we()),
  message: ye({
    accountKeys: Te(we()),
    header: ye({
      numRequiredSignatures: ae(),
      numReadonlySignedAccounts: ae(),
      numReadonlyUnsignedAccounts: ae()
    }),
    instructions: Te(ye({
      accounts: Te(ae()),
      data: we(),
      programIdIndex: ae()
    })),
    recentBlockhash: we(),
    addressTableLookups: We(Te(Nk))
  })
}), Uk = ye({
  pubkey: mn,
  signer: Tn(),
  writable: Tn(),
  source: We(jr([Pt("transaction"), Pt("lookupTable")]))
}), Lk = ye({
  accountKeys: Te(Uk),
  signatures: Te(we())
}), Dk = ye({
  parsed: aa(),
  program: we(),
  programId: mn
}), Fk = ye({
  accounts: Te(mn),
  data: we(),
  programId: mn
}), Yee = jr([Fk, Dk]), Qee = jr([ye({
  parsed: aa(),
  program: we(),
  programId: we()
}), ye({
  accounts: Te(we()),
  data: we(),
  programId: we()
})]), jk = oa(Yee, Qee, (t) => "accounts" in t ? He(t, Fk) : He(t, Dk)), $k = ye({
  signatures: Te(we()),
  message: ye({
    accountKeys: Te(Uk),
    instructions: Te(jk),
    recentBlockhash: we(),
    addressTableLookups: We(Pe(Te(Nk)))
  })
}), Fp = ye({
  accountIndex: ae(),
  mint: we(),
  owner: We(we()),
  uiTokenAmount: Yv
}), qk = ye({
  writable: Te(mn),
  readonly: Te(mn)
}), Wy = ye({
  err: Hc,
  fee: ae(),
  innerInstructions: We(Pe(Te(ye({
    index: ae(),
    instructions: Te(ye({
      accounts: Te(ae()),
      data: we(),
      programIdIndex: ae()
    }))
  })))),
  preBalances: Te(ae()),
  postBalances: Te(ae()),
  logMessages: We(Pe(Te(we()))),
  preTokenBalances: We(Pe(Te(Fp))),
  postTokenBalances: We(Pe(Te(Fp))),
  loadedAddresses: We(qk),
  computeUnitsConsumed: We(ae())
}), T_ = ye({
  err: Hc,
  fee: ae(),
  innerInstructions: We(Pe(Te(ye({
    index: ae(),
    instructions: Te(jk)
  })))),
  preBalances: Te(ae()),
  postBalances: Te(ae()),
  logMessages: We(Pe(Te(we()))),
  preTokenBalances: We(Pe(Te(Fp))),
  postTokenBalances: We(Pe(Te(Fp))),
  loadedAddresses: We(qk),
  computeUnitsConsumed: We(ae())
}), Rf = jr([Pt(0), Pt("legacy")]), Gc = ye({
  pubkey: we(),
  lamports: ae(),
  postBalance: Pe(ae()),
  rewardType: Pe(we()),
  commission: We(Pe(ae()))
}), Xee = qt(Pe(ye({
  blockhash: we(),
  previousBlockhash: we(),
  parentSlot: ae(),
  transactions: Te(ye({
    transaction: I_,
    meta: Pe(Wy),
    version: We(Rf)
  })),
  rewards: We(Te(Gc)),
  blockTime: Pe(ae()),
  blockHeight: Pe(ae())
}))), ete = qt(Pe(ye({
  blockhash: we(),
  previousBlockhash: we(),
  parentSlot: ae(),
  rewards: We(Te(Gc)),
  blockTime: Pe(ae()),
  blockHeight: Pe(ae())
}))), tte = qt(Pe(ye({
  blockhash: we(),
  previousBlockhash: we(),
  parentSlot: ae(),
  transactions: Te(ye({
    transaction: Lk,
    meta: Pe(Wy),
    version: We(Rf)
  })),
  rewards: We(Te(Gc)),
  blockTime: Pe(ae()),
  blockHeight: Pe(ae())
}))), rte = qt(Pe(ye({
  blockhash: we(),
  previousBlockhash: we(),
  parentSlot: ae(),
  transactions: Te(ye({
    transaction: $k,
    meta: Pe(T_),
    version: We(Rf)
  })),
  rewards: We(Te(Gc)),
  blockTime: Pe(ae()),
  blockHeight: Pe(ae())
}))), nte = qt(Pe(ye({
  blockhash: we(),
  previousBlockhash: we(),
  parentSlot: ae(),
  transactions: Te(ye({
    transaction: Lk,
    meta: Pe(T_),
    version: We(Rf)
  })),
  rewards: We(Te(Gc)),
  blockTime: Pe(ae()),
  blockHeight: Pe(ae())
}))), ite = qt(Pe(ye({
  blockhash: we(),
  previousBlockhash: we(),
  parentSlot: ae(),
  rewards: We(Te(Gc)),
  blockTime: Pe(ae()),
  blockHeight: Pe(ae())
}))), ste = qt(Pe(ye({
  blockhash: we(),
  previousBlockhash: we(),
  parentSlot: ae(),
  transactions: Te(ye({
    transaction: I_,
    meta: Pe(Wy)
  })),
  rewards: We(Te(Gc)),
  blockTime: Pe(ae())
}))), x4 = qt(Pe(ye({
  blockhash: we(),
  previousBlockhash: we(),
  parentSlot: ae(),
  signatures: Te(we()),
  blockTime: Pe(ae())
}))), wm = qt(Pe(ye({
  slot: ae(),
  meta: Wy,
  blockTime: We(Pe(ae())),
  transaction: I_,
  version: We(Rf)
}))), Ah = qt(Pe(ye({
  slot: ae(),
  transaction: $k,
  meta: Pe(T_),
  blockTime: We(Pe(ae())),
  version: We(Rf)
}))), ate = fn(ye({
  blockhash: we(),
  feeCalculator: ye({
    lamportsPerSignature: ae()
  })
})), ote = fn(ye({
  blockhash: we(),
  lastValidBlockHeight: ae()
})), cte = fn(Tn()), ute = ye({
  slot: ae(),
  numTransactions: ae(),
  numSlots: ae(),
  samplePeriodSecs: ae()
}), fte = qt(Te(ute)), dte = fn(Pe(ye({
  feeCalculator: ye({
    lamportsPerSignature: ae()
  })
}))), lte = qt(we()), hte = qt(we()), pte = ye({
  err: Hc,
  logs: Te(we()),
  signature: we()
}), yte = ye({
  result: qy(pte),
  subscription: ae()
}), bte = {
  "solana-client": "js/0.0.0-development"
};
let gte = class {
  /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */
  constructor(e, r) {
    this._commitment = void 0, this._confirmTransactionInitialTimeout = void 0, this._rpcEndpoint = void 0, this._rpcWsEndpoint = void 0, this._rpcClient = void 0, this._rpcRequest = void 0, this._rpcBatchRequest = void 0, this._rpcWebSocket = void 0, this._rpcWebSocketConnected = !1, this._rpcWebSocketHeartbeat = null, this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketGeneration = 0, this._disableBlockhashCaching = !1, this._pollingBlockhash = !1, this._blockhashInfo = {
      latestBlockhash: null,
      lastFetch: 0,
      transactionSignatures: [],
      simulatedSignatures: []
    }, this._nextClientSubscriptionId = 0, this._subscriptionDisposeFunctionsByClientSubscriptionId = {}, this._subscriptionHashByClientSubscriptionId = {}, this._subscriptionStateChangeCallbacksByHash = {}, this._subscriptionCallbacksByServerSubscriptionId = {}, this._subscriptionsByHash = {}, this._subscriptionsAutoDisposedByRpc = /* @__PURE__ */ new Set(), this.getBlockHeight = /* @__PURE__ */ (() => {
      const f = {};
      return async (u) => {
        const {
          commitment: d,
          config: l
        } = Zr(u), h = this._buildArgs([], d, void 0, l), y = w4(h);
        return f[y] = f[y] ?? (async () => {
          try {
            const p = await this._rpcRequest("getBlockHeight", h), b = He(p, qt(ae()));
            if ("error" in b)
              throw new lt(b.error, "failed to get block height information");
            return b.result;
          } finally {
            delete f[y];
          }
        })(), await f[y];
      };
    })();
    let n, i, s, a, o, c;
    r && typeof r == "string" ? this._commitment = r : r && (this._commitment = r.commitment, this._confirmTransactionInitialTimeout = r.confirmTransactionInitialTimeout, n = r.wsEndpoint, i = r.httpHeaders, s = r.fetch, a = r.fetchMiddleware, o = r.disableRetryOnRateLimit, c = r.httpAgent), this._rpcEndpoint = ree(e), this._rpcWsEndpoint = n || tee(e), this._rpcClient = yee(e, i, s, a, o, c), this._rpcRequest = bee(this._rpcClient), this._rpcBatchRequest = gee(this._rpcClient), this._rpcWebSocket = new YX(this._rpcWsEndpoint, {
      autoconnect: !1,
      max_reconnects: 1 / 0
    }), this._rpcWebSocket.on("open", this._wsOnOpen.bind(this)), this._rpcWebSocket.on("error", this._wsOnError.bind(this)), this._rpcWebSocket.on("close", this._wsOnClose.bind(this)), this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this)), this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this)), this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this)), this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this)), this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this)), this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this)), this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
  }
  /**
   * The default commitment used for requests
   */
  get commitment() {
    return this._commitment;
  }
  /**
   * The RPC endpoint
   */
  get rpcEndpoint() {
    return this._rpcEndpoint;
  }
  /**
   * Fetch the balance for the specified public key, return with context
   */
  async getBalanceAndContext(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = this._buildArgs([e.toBase58()], n, void 0, i), a = await this._rpcRequest("getBalance", s), o = He(a, fn(ae()));
    if ("error" in o)
      throw new lt(o.error, `failed to get balance for ${e.toBase58()}`);
    return o.result;
  }
  /**
   * Fetch the balance for the specified public key
   */
  async getBalance(e, r) {
    return await this.getBalanceAndContext(e, r).then((n) => n.value).catch((n) => {
      throw new Error("failed to get balance of account " + e.toBase58() + ": " + n);
    });
  }
  /**
   * Fetch the estimated production time of a block
   */
  async getBlockTime(e) {
    const r = await this._rpcRequest("getBlockTime", [e]), n = He(r, qt(Pe(ae())));
    if ("error" in n)
      throw new lt(n.error, `failed to get block time for slot ${e}`);
    return n.result;
  }
  /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */
  async getMinimumLedgerSlot() {
    const e = await this._rpcRequest("minimumLedgerSlot", []), r = He(e, qt(ae()));
    if ("error" in r)
      throw new lt(r.error, "failed to get minimum ledger slot");
    return r.result;
  }
  /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */
  async getFirstAvailableBlock() {
    const e = await this._rpcRequest("getFirstAvailableBlock", []), r = He(e, xee);
    if ("error" in r)
      throw new lt(r.error, "failed to get first available block");
    return r.result;
  }
  /**
   * Fetch information about the current supply
   */
  async getSupply(e) {
    let r = {};
    typeof e == "string" ? r = {
      commitment: e
    } : e ? r = {
      ...e,
      commitment: e && e.commitment || this.commitment
    } : r = {
      commitment: this.commitment
    };
    const n = await this._rpcRequest("getSupply", [r]), i = He(n, Aee);
    if ("error" in i)
      throw new lt(i.error, "failed to get supply");
    return i.result;
  }
  /**
   * Fetch the current supply of a token mint
   */
  async getTokenSupply(e, r) {
    const n = this._buildArgs([e.toBase58()], r), i = await this._rpcRequest("getTokenSupply", n), s = He(i, fn(Yv));
    if ("error" in s)
      throw new lt(s.error, "failed to get token supply");
    return s.result;
  }
  /**
   * Fetch the current balance of a token account
   */
  async getTokenAccountBalance(e, r) {
    const n = this._buildArgs([e.toBase58()], r), i = await this._rpcRequest("getTokenAccountBalance", n), s = He(i, fn(Yv));
    if ("error" in s)
      throw new lt(s.error, "failed to get token account balance");
    return s.result;
  }
  /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */
  async getTokenAccountsByOwner(e, r, n) {
    const {
      commitment: i,
      config: s
    } = Zr(n);
    let a = [e.toBase58()];
    "mint" in r ? a.push({
      mint: r.mint.toBase58()
    }) : a.push({
      programId: r.programId.toBase58()
    });
    const o = this._buildArgs(a, i, "base64", s), c = await this._rpcRequest("getTokenAccountsByOwner", o), f = He(c, Tee);
    if ("error" in f)
      throw new lt(f.error, `failed to get token accounts owned by account ${e.toBase58()}`);
    return f.result;
  }
  /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */
  async getParsedTokenAccountsByOwner(e, r, n) {
    let i = [e.toBase58()];
    "mint" in r ? i.push({
      mint: r.mint.toBase58()
    }) : i.push({
      programId: r.programId.toBase58()
    });
    const s = this._buildArgs(i, n, "jsonParsed"), a = await this._rpcRequest("getTokenAccountsByOwner", s), o = He(a, kee);
    if ("error" in o)
      throw new lt(o.error, `failed to get token accounts owned by account ${e.toBase58()}`);
    return o.result;
  }
  /**
   * Fetch the 20 largest accounts with their current balances
   */
  async getLargestAccounts(e) {
    const r = {
      ...e,
      commitment: e && e.commitment || this.commitment
    }, n = r.filter || r.commitment ? [r] : [], i = await this._rpcRequest("getLargestAccounts", n), s = He(i, Ree);
    if ("error" in s)
      throw new lt(s.error, "failed to get largest accounts");
    return s.result;
  }
  /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */
  async getTokenLargestAccounts(e, r) {
    const n = this._buildArgs([e.toBase58()], r), i = await this._rpcRequest("getTokenLargestAccounts", n), s = He(i, Iee);
    if ("error" in s)
      throw new lt(s.error, "failed to get token largest accounts");
    return s.result;
  }
  /**
   * Fetch all the account info for the specified public key, return with context
   */
  async getAccountInfoAndContext(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = this._buildArgs([e.toBase58()], n, "base64", i), a = await this._rpcRequest("getAccountInfo", s), o = He(a, fn(Pe(Vd)));
    if ("error" in o)
      throw new lt(o.error, `failed to get info about account ${e.toBase58()}`);
    return o.result;
  }
  /**
   * Fetch parsed account info for the specified public key
   */
  async getParsedAccountInfo(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = this._buildArgs([e.toBase58()], n, "jsonParsed", i), a = await this._rpcRequest("getAccountInfo", s), o = He(a, fn(Pe(Xv)));
    if ("error" in o)
      throw new lt(o.error, `failed to get info about account ${e.toBase58()}`);
    return o.result;
  }
  /**
   * Fetch all the account info for the specified public key
   */
  async getAccountInfo(e, r) {
    try {
      return (await this.getAccountInfoAndContext(e, r)).value;
    } catch (n) {
      throw new Error("failed to get info about account " + e.toBase58() + ": " + n);
    }
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleParsedAccounts(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = e.map((f) => f.toBase58()), a = this._buildArgs([s], n, "jsonParsed", i), o = await this._rpcRequest("getMultipleAccounts", a), c = He(o, fn(Te(Pe(Xv))));
    if ("error" in c)
      throw new lt(c.error, `failed to get info for accounts ${s}`);
    return c.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleAccountsInfoAndContext(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = e.map((f) => f.toBase58()), a = this._buildArgs([s], n, "base64", i), o = await this._rpcRequest("getMultipleAccounts", a), c = He(o, fn(Te(Pe(Vd))));
    if ("error" in c)
      throw new lt(c.error, `failed to get info for accounts ${s}`);
    return c.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */
  async getMultipleAccountsInfo(e, r) {
    return (await this.getMultipleAccountsInfoAndContext(e, r)).value;
  }
  /**
   * Returns epoch activation information for a stake account that has been delegated
   */
  async getStakeActivation(e, r, n) {
    const {
      commitment: i,
      config: s
    } = Zr(r), a = this._buildArgs([e.toBase58()], i, void 0, {
      ...s,
      epoch: n ?? (s == null ? void 0 : s.epoch)
    }), o = await this._rpcRequest("getStakeActivation", a), c = He(o, qt(Mee));
    if ("error" in c)
      throw new lt(c.error, `failed to get Stake Activation ${e.toBase58()}`);
    return c.result;
  }
  /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async getProgramAccounts(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), {
      encoding: s,
      ...a
    } = i || {}, o = this._buildArgs([e.toBase58()], n, s || "base64", a), c = await this._rpcRequest("getProgramAccounts", o), f = Te(Pee), u = a.withContext === !0 ? He(c, fn(f)) : He(c, qt(f));
    if ("error" in u)
      throw new lt(u.error, `failed to get accounts owned by program ${e.toBase58()}`);
    return u.result;
  }
  /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */
  async getParsedProgramAccounts(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = this._buildArgs([e.toBase58()], n, "jsonParsed", i), a = await this._rpcRequest("getProgramAccounts", s), o = He(a, qt(Te(Bee)));
    if ("error" in o)
      throw new lt(o.error, `failed to get accounts owned by program ${e.toBase58()}`);
    return o.result;
  }
  /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async confirmTransaction(e, r) {
    var s;
    let n;
    if (typeof e == "string")
      n = e;
    else {
      const a = e;
      if ((s = a.abortSignal) != null && s.aborted)
        return Promise.reject(a.abortSignal.reason);
      n = a.signature;
    }
    let i;
    try {
      i = Ot.decode(n);
    } catch {
      throw new Error("signature must be base58 encoded: " + n);
    }
    return _r(i.length === 64, "signature has invalid length"), typeof e == "string" ? await this.confirmTransactionUsingLegacyTimeoutStrategy({
      commitment: r || this.commitment,
      signature: n
    }) : "lastValidBlockHeight" in e ? await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
      commitment: r || this.commitment,
      strategy: e
    }) : await this.confirmTransactionUsingDurableNonceStrategy({
      commitment: r || this.commitment,
      strategy: e
    });
  }
  getCancellationPromise(e) {
    return new Promise((r, n) => {
      e != null && (e.aborted ? n(e.reason) : e.addEventListener("abort", () => {
        n(e.reason);
      }));
    });
  }
  getTransactionConfirmationPromise({
    commitment: e,
    signature: r
  }) {
    let n, i, s = !1;
    const a = new Promise((c, f) => {
      try {
        n = this.onSignature(r, (d, l) => {
          n = void 0;
          const h = {
            context: l,
            value: d
          };
          c({
            __type: ga.PROCESSED,
            response: h
          });
        }, e);
        const u = new Promise((d) => {
          n == null ? d() : i = this._onSubscriptionStateChange(n, (l) => {
            l === "subscribed" && d();
          });
        });
        (async () => {
          if (await u, s)
            return;
          const d = await this.getSignatureStatus(r);
          if (s || d == null)
            return;
          const {
            context: l,
            value: h
          } = d;
          if (h != null)
            if (h != null && h.err)
              f(h.err);
            else {
              switch (e) {
                case "confirmed":
                case "single":
                case "singleGossip": {
                  if (h.confirmationStatus === "processed")
                    return;
                  break;
                }
                case "finalized":
                case "max":
                case "root": {
                  if (h.confirmationStatus === "processed" || h.confirmationStatus === "confirmed")
                    return;
                  break;
                }
                case "processed":
                case "recent":
              }
              s = !0, c({
                __type: ga.PROCESSED,
                response: {
                  context: l,
                  value: h
                }
              });
            }
        })();
      } catch (u) {
        f(u);
      }
    });
    return {
      abortConfirmation: () => {
        i && (i(), i = void 0), n != null && (this.removeSignatureListener(n), n = void 0);
      },
      confirmationPromise: a
    };
  }
  async confirmTransactionUsingBlockHeightExceedanceStrategy({
    commitment: e,
    strategy: {
      abortSignal: r,
      lastValidBlockHeight: n,
      signature: i
    }
  }) {
    let s = !1;
    const a = new Promise((d) => {
      const l = async () => {
        try {
          return await this.getBlockHeight(e);
        } catch {
          return -1;
        }
      };
      (async () => {
        let h = await l();
        if (!s) {
          for (; h <= n; )
            if (await Ko(1e3), s || (h = await l(), s))
              return;
          d({
            __type: ga.BLOCKHEIGHT_EXCEEDED
          });
        }
      })();
    }), {
      abortConfirmation: o,
      confirmationPromise: c
    } = this.getTransactionConfirmationPromise({
      commitment: e,
      signature: i
    }), f = this.getCancellationPromise(r);
    let u;
    try {
      const d = await Promise.race([f, c, a]);
      if (d.__type === ga.PROCESSED)
        u = d.response;
      else
        throw new w_(i);
    } finally {
      s = !0, o();
    }
    return u;
  }
  async confirmTransactionUsingDurableNonceStrategy({
    commitment: e,
    strategy: {
      abortSignal: r,
      minContextSlot: n,
      nonceAccountPubkey: i,
      nonceValue: s,
      signature: a
    }
  }) {
    let o = !1;
    const c = new Promise((h) => {
      let y = s, p = null;
      const b = async () => {
        try {
          const {
            context: v,
            value: x
          } = await this.getNonceAndContext(i, {
            commitment: e,
            minContextSlot: n
          });
          return p = v.slot, x == null ? void 0 : x.nonce;
        } catch {
          return y;
        }
      };
      (async () => {
        if (y = await b(), !o)
          for (; ; ) {
            if (s !== y) {
              h({
                __type: ga.NONCE_INVALID,
                slotInWhichNonceDidAdvance: p
              });
              return;
            }
            if (await Ko(2e3), o || (y = await b(), o))
              return;
          }
      })();
    }), {
      abortConfirmation: f,
      confirmationPromise: u
    } = this.getTransactionConfirmationPromise({
      commitment: e,
      signature: a
    }), d = this.getCancellationPromise(r);
    let l;
    try {
      const h = await Promise.race([d, u, c]);
      if (h.__type === ga.PROCESSED)
        l = h.response;
      else {
        let y;
        for (; ; ) {
          const p = await this.getSignatureStatus(a);
          if (p == null)
            break;
          if (p.context.slot < (h.slotInWhichNonceDidAdvance ?? n)) {
            await Ko(400);
            continue;
          }
          y = p;
          break;
        }
        if (y != null && y.value) {
          const p = e || "finalized", {
            confirmationStatus: b
          } = y.value;
          switch (p) {
            case "processed":
            case "recent":
              if (b !== "processed" && b !== "confirmed" && b !== "finalized")
                throw new vu(a);
              break;
            case "confirmed":
            case "single":
            case "singleGossip":
              if (b !== "confirmed" && b !== "finalized")
                throw new vu(a);
              break;
            case "finalized":
            case "max":
            case "root":
              if (b !== "finalized")
                throw new vu(a);
              break;
            default:
          }
          l = {
            context: y.context,
            value: {
              err: y.value.err
            }
          };
        } else
          throw new vu(a);
      }
    } finally {
      o = !0, f();
    }
    return l;
  }
  async confirmTransactionUsingLegacyTimeoutStrategy({
    commitment: e,
    signature: r
  }) {
    let n;
    const i = new Promise((c) => {
      let f = this._confirmTransactionInitialTimeout || 6e4;
      switch (e) {
        case "processed":
        case "recent":
        case "single":
        case "confirmed":
        case "singleGossip": {
          f = this._confirmTransactionInitialTimeout || 3e4;
          break;
        }
      }
      n = setTimeout(() => c({
        __type: ga.TIMED_OUT,
        timeoutMs: f
      }), f);
    }), {
      abortConfirmation: s,
      confirmationPromise: a
    } = this.getTransactionConfirmationPromise({
      commitment: e,
      signature: r
    });
    let o;
    try {
      const c = await Promise.race([a, i]);
      if (c.__type === ga.PROCESSED)
        o = c.response;
      else
        throw new __(r, c.timeoutMs / 1e3);
    } finally {
      clearTimeout(n), s();
    }
    return o;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getClusterNodes() {
    const e = await this._rpcRequest("getClusterNodes", []), r = He(e, qt(Te(Kee)));
    if ("error" in r)
      throw new lt(r.error, "failed to get cluster nodes");
    return r.result;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getVoteAccounts(e) {
    const r = this._buildArgs([], e), n = await this._rpcRequest("getVoteAccounts", r), i = He(n, Vee);
    if ("error" in i)
      throw new lt(i.error, "failed to get vote accounts");
    return i.result;
  }
  /**
   * Fetch the current slot that the node is processing
   */
  async getSlot(e) {
    const {
      commitment: r,
      config: n
    } = Zr(e), i = this._buildArgs([], r, void 0, n), s = await this._rpcRequest("getSlot", i), a = He(s, qt(ae()));
    if ("error" in a)
      throw new lt(a.error, "failed to get slot");
    return a.result;
  }
  /**
   * Fetch the current slot leader of the cluster
   */
  async getSlotLeader(e) {
    const {
      commitment: r,
      config: n
    } = Zr(e), i = this._buildArgs([], r, void 0, n), s = await this._rpcRequest("getSlotLeader", i), a = He(s, qt(we()));
    if ("error" in a)
      throw new lt(a.error, "failed to get slot leader");
    return a.result;
  }
  /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */
  async getSlotLeaders(e, r) {
    const n = [e, r], i = await this._rpcRequest("getSlotLeaders", n), s = He(i, qt(Te(mn)));
    if ("error" in s)
      throw new lt(s.error, "failed to get slot leaders");
    return s.result;
  }
  /**
   * Fetch the current status of a signature
   */
  async getSignatureStatus(e, r) {
    const {
      context: n,
      value: i
    } = await this.getSignatureStatuses([e], r);
    _r(i.length === 1);
    const s = i[0];
    return {
      context: n,
      value: s
    };
  }
  /**
   * Fetch the current statuses of a batch of signatures
   */
  async getSignatureStatuses(e, r) {
    const n = [e];
    r && n.push(r);
    const i = await this._rpcRequest("getSignatureStatuses", n), s = He(i, Zee);
    if ("error" in s)
      throw new lt(s.error, "failed to get signature status");
    return s.result;
  }
  /**
   * Fetch the current transaction count of the cluster
   */
  async getTransactionCount(e) {
    const {
      commitment: r,
      config: n
    } = Zr(e), i = this._buildArgs([], r, void 0, n), s = await this._rpcRequest("getTransactionCount", i), a = He(s, qt(ae()));
    if ("error" in a)
      throw new lt(a.error, "failed to get transaction count");
    return a.result;
  }
  /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */
  async getTotalSupply(e) {
    return (await this.getSupply({
      commitment: e,
      excludeNonCirculatingAccountsList: !0
    })).value.total;
  }
  /**
   * Fetch the cluster InflationGovernor parameters
   */
  async getInflationGovernor(e) {
    const r = this._buildArgs([], e), n = await this._rpcRequest("getInflationGovernor", r), i = He(n, mee);
    if ("error" in i)
      throw new lt(i.error, "failed to get inflation");
    return i.result;
  }
  /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */
  async getInflationReward(e, r, n) {
    const {
      commitment: i,
      config: s
    } = Zr(n), a = this._buildArgs([e.map((f) => f.toBase58())], i, void 0, {
      ...s,
      epoch: r ?? (s == null ? void 0 : s.epoch)
    }), o = await this._rpcRequest("getInflationReward", a), c = He(o, see);
    if ("error" in c)
      throw new lt(c.error, "failed to get inflation reward");
    return c.result;
  }
  /**
   * Fetch the specific inflation values for the current epoch
   */
  async getInflationRate() {
    const e = await this._rpcRequest("getInflationRate", []), r = He(e, vee);
    if ("error" in r)
      throw new lt(r.error, "failed to get inflation rate");
    return r.result;
  }
  /**
   * Fetch the Epoch Info parameters
   */
  async getEpochInfo(e) {
    const {
      commitment: r,
      config: n
    } = Zr(e), i = this._buildArgs([], r, void 0, n), s = await this._rpcRequest("getEpochInfo", i), a = He(s, _ee);
    if ("error" in a)
      throw new lt(a.error, "failed to get epoch info");
    return a.result;
  }
  /**
   * Fetch the Epoch Schedule parameters
   */
  async getEpochSchedule() {
    const e = await this._rpcRequest("getEpochSchedule", []), r = He(e, See);
    if ("error" in r)
      throw new lt(r.error, "failed to get epoch schedule");
    const n = r.result;
    return new Ok(n.slotsPerEpoch, n.leaderScheduleSlotOffset, n.warmup, n.firstNormalEpoch, n.firstNormalSlot);
  }
  /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */
  async getLeaderSchedule() {
    const e = await this._rpcRequest("getLeaderSchedule", []), r = He(e, Eee);
    if ("error" in r)
      throw new lt(r.error, "failed to get leader schedule");
    return r.result;
  }
  /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */
  async getMinimumBalanceForRentExemption(e, r) {
    const n = this._buildArgs([e], r), i = await this._rpcRequest("getMinimumBalanceForRentExemption", n), s = He(i, Jee);
    return "error" in s ? (console.warn("Unable to fetch minimum balance for rent exemption"), 0) : s.result;
  }
  /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhashAndContext(e) {
    const r = this._buildArgs([], e), n = await this._rpcRequest("getRecentBlockhash", r), i = He(n, ate);
    if ("error" in i)
      throw new lt(i.error, "failed to get recent blockhash");
    return i.result;
  }
  /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */
  async getRecentPerformanceSamples(e) {
    const r = await this._rpcRequest("getRecentPerformanceSamples", e ? [e] : []), n = He(r, fte);
    if ("error" in n)
      throw new lt(n.error, "failed to get recent performance samples");
    return n.result;
  }
  /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */
  async getFeeCalculatorForBlockhash(e, r) {
    const n = this._buildArgs([e], r), i = await this._rpcRequest("getFeeCalculatorForBlockhash", n), s = He(i, dte);
    if ("error" in s)
      throw new lt(s.error, "failed to get fee calculator");
    const {
      context: a,
      value: o
    } = s.result;
    return {
      context: a,
      value: o !== null ? o.feeCalculator : null
    };
  }
  /**
   * Fetch the fee for a message from the cluster, return with context
   */
  async getFeeForMessage(e, r) {
    const n = Wt(e.serialize()).toString("base64"), i = this._buildArgs([n], r), s = await this._rpcRequest("getFeeForMessage", i), a = He(s, fn(Pe(ae())));
    if ("error" in a)
      throw new lt(a.error, "failed to get fee for message");
    if (a.result === null)
      throw new Error("invalid blockhash");
    return a.result;
  }
  /**
   * Fetch a list of prioritization fees from recent blocks.
   */
  async getRecentPrioritizationFees(e) {
    var a;
    const r = (a = e == null ? void 0 : e.lockedWritableAccounts) == null ? void 0 : a.map((o) => o.toBase58()), n = r != null && r.length ? [r] : [], i = await this._rpcRequest("getRecentPrioritizationFees", n), s = He(i, wee);
    if ("error" in s)
      throw new lt(s.error, "failed to get recent prioritization fees");
    return s.result;
  }
  /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhash(e) {
    try {
      return (await this.getRecentBlockhashAndContext(e)).value;
    } catch (r) {
      throw new Error("failed to get recent blockhash: " + r);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhash(e) {
    try {
      return (await this.getLatestBlockhashAndContext(e)).value;
    } catch (r) {
      throw new Error("failed to get recent blockhash: " + r);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhashAndContext(e) {
    const {
      commitment: r,
      config: n
    } = Zr(e), i = this._buildArgs([], r, void 0, n), s = await this._rpcRequest("getLatestBlockhash", i), a = He(s, ote);
    if ("error" in a)
      throw new lt(a.error, "failed to get latest blockhash");
    return a.result;
  }
  /**
   * Returns whether a blockhash is still valid or not
   */
  async isBlockhashValid(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = this._buildArgs([e], n, void 0, i), a = await this._rpcRequest("isBlockhashValid", s), o = He(a, cte);
    if ("error" in o)
      throw new lt(o.error, "failed to determine if the blockhash `" + e + "`is valid");
    return o.result;
  }
  /**
   * Fetch the node version
   */
  async getVersion() {
    const e = await this._rpcRequest("getVersion", []), r = He(e, qt(hee));
    if ("error" in r)
      throw new lt(r.error, "failed to get version");
    return r.result;
  }
  /**
   * Fetch the genesis hash
   */
  async getGenesisHash() {
    const e = await this._rpcRequest("getGenesisHash", []), r = He(e, qt(we()));
    if ("error" in r)
      throw new lt(r.error, "failed to get genesis hash");
    return r.result;
  }
  /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a processed block from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a processed block from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getBlock(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = this._buildArgsAtLeastConfirmed([e], n, void 0, i), a = await this._rpcRequest("getBlock", s);
    try {
      switch (i == null ? void 0 : i.transactionDetails) {
        case "accounts": {
          const o = He(a, tte);
          if ("error" in o)
            throw o.error;
          return o.result;
        }
        case "none": {
          const o = He(a, ete);
          if ("error" in o)
            throw o.error;
          return o.result;
        }
        default: {
          const o = He(a, Xee);
          if ("error" in o)
            throw o.error;
          const {
            result: c
          } = o;
          return c ? {
            ...c,
            transactions: c.transactions.map(({
              transaction: f,
              meta: u,
              version: d
            }) => ({
              meta: u,
              transaction: {
                ...f,
                message: vm(d, f.message)
              },
              version: d
            }))
          } : null;
        }
      }
    } catch (o) {
      throw new lt(o, "failed to get confirmed block");
    }
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  // eslint-disable-next-line no-dupe-class-members
  async getParsedBlock(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = this._buildArgsAtLeastConfirmed([e], n, "jsonParsed", i), a = await this._rpcRequest("getBlock", s);
    try {
      switch (i == null ? void 0 : i.transactionDetails) {
        case "accounts": {
          const o = He(a, nte);
          if ("error" in o)
            throw o.error;
          return o.result;
        }
        case "none": {
          const o = He(a, ite);
          if ("error" in o)
            throw o.error;
          return o.result;
        }
        default: {
          const o = He(a, rte);
          if ("error" in o)
            throw o.error;
          return o.result;
        }
      }
    } catch (o) {
      throw new lt(o, "failed to get block");
    }
  }
  /*
   * Returns recent block production information from the current or previous epoch
   */
  async getBlockProduction(e) {
    let r, n;
    if (typeof e == "string")
      n = e;
    else if (e) {
      const {
        commitment: o,
        ...c
      } = e;
      n = o, r = c;
    }
    const i = this._buildArgs([], n, "base64", r), s = await this._rpcRequest("getBlockProduction", i), a = He(s, pee);
    if ("error" in a)
      throw new lt(a.error, "failed to get block production information");
    return a.result;
  }
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransaction(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = this._buildArgsAtLeastConfirmed([e], n, void 0, i), a = await this._rpcRequest("getTransaction", s), o = He(a, wm);
    if ("error" in o)
      throw new lt(o.error, "failed to get transaction");
    const c = o.result;
    return c && {
      ...c,
      transaction: {
        ...c.transaction,
        message: vm(c.version, c.transaction.message)
      }
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */
  async getParsedTransaction(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = this._buildArgsAtLeastConfirmed([e], n, "jsonParsed", i), a = await this._rpcRequest("getTransaction", s), o = He(a, Ah);
    if ("error" in o)
      throw new lt(o.error, "failed to get transaction");
    return o.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */
  async getParsedTransactions(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = e.map((c) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([c], n, "jsonParsed", i)
    }));
    return (await this._rpcBatchRequest(s)).map((c) => {
      const f = He(c, Ah);
      if ("error" in f)
        throw new lt(f.error, "failed to get transactions");
      return f.result;
    });
  }
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransactions(e, r) {
    const {
      commitment: n,
      config: i
    } = Zr(r), s = e.map((c) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([c], n, void 0, i)
    }));
    return (await this._rpcBatchRequest(s)).map((c) => {
      const f = He(c, wm);
      if ("error" in f)
        throw new lt(f.error, "failed to get transactions");
      const u = f.result;
      return u && {
        ...u,
        transaction: {
          ...u.transaction,
          message: vm(u.version, u.transaction.message)
        }
      };
    });
  }
  /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */
  async getConfirmedBlock(e, r) {
    const n = this._buildArgsAtLeastConfirmed([e], r), i = await this._rpcRequest("getConfirmedBlock", n), s = He(i, ste);
    if ("error" in s)
      throw new lt(s.error, "failed to get confirmed block");
    const a = s.result;
    if (!a)
      throw new Error("Confirmed block " + e + " not found");
    const o = {
      ...a,
      transactions: a.transactions.map(({
        transaction: c,
        meta: f
      }) => {
        const u = new Is(c.message);
        return {
          meta: f,
          transaction: {
            ...c,
            message: u
          }
        };
      })
    };
    return {
      ...o,
      transactions: o.transactions.map(({
        transaction: c,
        meta: f
      }) => ({
        meta: f,
        transaction: Or.populate(c.message, c.signatures)
      }))
    };
  }
  /**
   * Fetch confirmed blocks between two slots
   */
  async getBlocks(e, r, n) {
    const i = this._buildArgsAtLeastConfirmed(r !== void 0 ? [e, r] : [e], n), s = await this._rpcRequest("getBlocks", i), a = He(s, qt(Te(ae())));
    if ("error" in a)
      throw new lt(a.error, "failed to get blocks");
    return a.result;
  }
  /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */
  async getBlockSignatures(e, r) {
    const n = this._buildArgsAtLeastConfirmed([e], r, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), i = await this._rpcRequest("getBlock", n), s = He(i, x4);
    if ("error" in s)
      throw new lt(s.error, "failed to get block");
    const a = s.result;
    if (!a)
      throw new Error("Block " + e + " not found");
    return a;
  }
  /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */
  async getConfirmedBlockSignatures(e, r) {
    const n = this._buildArgsAtLeastConfirmed([e], r, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), i = await this._rpcRequest("getConfirmedBlock", n), s = He(i, x4);
    if ("error" in s)
      throw new lt(s.error, "failed to get confirmed block");
    const a = s.result;
    if (!a)
      throw new Error("Confirmed block " + e + " not found");
    return a;
  }
  /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */
  async getConfirmedTransaction(e, r) {
    const n = this._buildArgsAtLeastConfirmed([e], r), i = await this._rpcRequest("getConfirmedTransaction", n), s = He(i, wm);
    if ("error" in s)
      throw new lt(s.error, "failed to get transaction");
    const a = s.result;
    if (!a)
      return a;
    const o = new Is(a.transaction.message), c = a.transaction.signatures;
    return {
      ...a,
      transaction: Or.populate(o, c)
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */
  async getParsedConfirmedTransaction(e, r) {
    const n = this._buildArgsAtLeastConfirmed([e], r, "jsonParsed"), i = await this._rpcRequest("getConfirmedTransaction", n), s = He(i, Ah);
    if ("error" in s)
      throw new lt(s.error, "failed to get confirmed transaction");
    return s.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */
  async getParsedConfirmedTransactions(e, r) {
    const n = e.map((a) => ({
      methodName: "getConfirmedTransaction",
      args: this._buildArgsAtLeastConfirmed([a], r, "jsonParsed")
    }));
    return (await this._rpcBatchRequest(n)).map((a) => {
      const o = He(a, Ah);
      if ("error" in o)
        throw new lt(o.error, "failed to get confirmed transactions");
      return o.result;
    });
  }
  /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */
  async getConfirmedSignaturesForAddress(e, r, n) {
    let i = {}, s = await this.getFirstAvailableBlock();
    for (; !("until" in i) && (r--, !(r <= 0 || r < s)); )
      try {
        const c = await this.getConfirmedBlockSignatures(r, "finalized");
        c.signatures.length > 0 && (i.until = c.signatures[c.signatures.length - 1].toString());
      } catch (c) {
        if (c instanceof Error && c.message.includes("skipped"))
          continue;
        throw c;
      }
    let a = await this.getSlot("finalized");
    for (; !("before" in i) && (n++, !(n > a)); )
      try {
        const c = await this.getConfirmedBlockSignatures(n);
        c.signatures.length > 0 && (i.before = c.signatures[c.signatures.length - 1].toString());
      } catch (c) {
        if (c instanceof Error && c.message.includes("skipped"))
          continue;
        throw c;
      }
    return (await this.getConfirmedSignaturesForAddress2(e, i)).map((c) => c.signature);
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */
  async getConfirmedSignaturesForAddress2(e, r, n) {
    const i = this._buildArgsAtLeastConfirmed([e.toBase58()], n, void 0, r), s = await this._rpcRequest("getConfirmedSignaturesForAddress2", i), a = He(s, Cee);
    if ("error" in a)
      throw new lt(a.error, "failed to get confirmed signatures for address");
    return a.result;
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */
  async getSignaturesForAddress(e, r, n) {
    const i = this._buildArgsAtLeastConfirmed([e.toBase58()], n, void 0, r), s = await this._rpcRequest("getSignaturesForAddress", i), a = He(s, Nee);
    if ("error" in a)
      throw new lt(a.error, "failed to get signatures for address");
    return a.result;
  }
  async getAddressLookupTable(e, r) {
    const {
      context: n,
      value: i
    } = await this.getAccountInfoAndContext(e, r);
    let s = null;
    return i !== null && (s = new Jv({
      key: e,
      state: Jv.deserialize(i.data)
    })), {
      context: n,
      value: s
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */
  async getNonceAndContext(e, r) {
    const {
      context: n,
      value: i
    } = await this.getAccountInfoAndContext(e, r);
    let s = null;
    return i !== null && (s = $y.fromAccountData(i.data)), {
      context: n,
      value: s
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster
   */
  async getNonce(e, r) {
    return await this.getNonceAndContext(e, r).then((n) => n.value).catch((n) => {
      throw new Error("failed to get nonce for account " + e.toBase58() + ": " + n);
    });
  }
  /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */
  async requestAirdrop(e, r) {
    const n = await this._rpcRequest("requestAirdrop", [e.toBase58(), r]), i = He(n, lte);
    if ("error" in i)
      throw new lt(i.error, `airdrop to ${e.toBase58()} failed`);
    return i.result;
  }
  /**
   * @internal
   */
  async _blockhashWithExpiryBlockHeight(e) {
    if (!e) {
      for (; this._pollingBlockhash; )
        await Ko(100);
      const n = Date.now() - this._blockhashInfo.lastFetch >= Mk;
      if (this._blockhashInfo.latestBlockhash !== null && !n)
        return this._blockhashInfo.latestBlockhash;
    }
    return await this._pollNewBlockhash();
  }
  /**
   * @internal
   */
  async _pollNewBlockhash() {
    this._pollingBlockhash = !0;
    try {
      const e = Date.now(), r = this._blockhashInfo.latestBlockhash, n = r ? r.blockhash : null;
      for (let i = 0; i < 50; i++) {
        const s = await this.getLatestBlockhash("finalized");
        if (n !== s.blockhash)
          return this._blockhashInfo = {
            latestBlockhash: s,
            lastFetch: Date.now(),
            transactionSignatures: [],
            simulatedSignatures: []
          }, s;
        await Ko(kk / 2);
      }
      throw new Error(`Unable to obtain a new blockhash after ${Date.now() - e}ms`);
    } finally {
      this._pollingBlockhash = !1;
    }
  }
  /**
   * get the stake minimum delegation
   */
  async getStakeMinimumDelegation(e) {
    const {
      commitment: r,
      config: n
    } = Zr(e), i = this._buildArgs([], r, "base64", n), s = await this._rpcRequest("getStakeMinimumDelegation", i), a = He(s, fn(ae()));
    if ("error" in a)
      throw new lt(a.error, "failed to get stake minimum delegation");
    return a.result;
  }
  /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */
  /**
   * Simulate a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Simulate a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async simulateTransaction(e, r, n) {
    if ("message" in e) {
      const p = e.serialize(), b = Fe.Buffer.from(p).toString("base64");
      if (Array.isArray(r) || n !== void 0)
        throw new Error("Invalid arguments");
      const v = r || {};
      v.encoding = "base64", "commitment" in v || (v.commitment = this.commitment);
      const x = [b, v], I = await this._rpcRequest("simulateTransaction", x), L = He(I, S4);
      if ("error" in L)
        throw new Error("failed to simulate transaction: " + L.error.message);
      return L.result;
    }
    let i;
    if (e instanceof Or) {
      let y = e;
      i = new Or(), i.feePayer = y.feePayer, i.instructions = e.instructions, i.nonceInfo = y.nonceInfo, i.signatures = y.signatures;
    } else
      i = Or.populate(e), i._message = i._json = void 0;
    if (r !== void 0 && !Array.isArray(r))
      throw new Error("Invalid arguments");
    const s = r;
    if (i.nonceInfo && s)
      i.sign(...s);
    else {
      let y = this._disableBlockhashCaching;
      for (; ; ) {
        const p = await this._blockhashWithExpiryBlockHeight(y);
        if (i.lastValidBlockHeight = p.lastValidBlockHeight, i.recentBlockhash = p.blockhash, !s)
          break;
        if (i.sign(...s), !i.signature)
          throw new Error("!signature");
        const b = i.signature.toString("base64");
        if (!this._blockhashInfo.simulatedSignatures.includes(b) && !this._blockhashInfo.transactionSignatures.includes(b)) {
          this._blockhashInfo.simulatedSignatures.push(b);
          break;
        } else
          y = !0;
      }
    }
    const a = i._compile(), o = a.serialize(), f = i._serialize(o).toString("base64"), u = {
      encoding: "base64",
      commitment: this.commitment
    };
    if (n) {
      const y = (Array.isArray(n) ? n : a.nonProgramIds()).map((p) => p.toBase58());
      u.accounts = {
        encoding: "base64",
        addresses: y
      };
    }
    s && (u.sigVerify = !0);
    const d = [f, u], l = await this._rpcRequest("simulateTransaction", d), h = He(l, S4);
    if ("error" in h) {
      let y;
      if ("data" in h.error && (y = h.error.data.logs, y && Array.isArray(y))) {
        const p = `
    `, b = p + y.join(p);
        console.error(h.error.message, b);
      }
      throw new Zv("failed to simulate transaction: " + h.error.message, y);
    }
    return h.result;
  }
  /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */
  /**
   * Send a signed transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  /**
   * Sign and send a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async sendTransaction(e, r, n) {
    if ("version" in e) {
      if (r && Array.isArray(r))
        throw new Error("Invalid arguments");
      const a = e.serialize();
      return await this.sendRawTransaction(a, r);
    }
    if (r === void 0 || !Array.isArray(r))
      throw new Error("Invalid arguments");
    const i = r;
    if (e.nonceInfo)
      e.sign(...i);
    else {
      let a = this._disableBlockhashCaching;
      for (; ; ) {
        const o = await this._blockhashWithExpiryBlockHeight(a);
        if (e.lastValidBlockHeight = o.lastValidBlockHeight, e.recentBlockhash = o.blockhash, e.sign(...i), !e.signature)
          throw new Error("!signature");
        const c = e.signature.toString("base64");
        if (this._blockhashInfo.transactionSignatures.includes(c))
          a = !0;
        else {
          this._blockhashInfo.transactionSignatures.push(c);
          break;
        }
      }
    }
    const s = e.serialize();
    return await this.sendRawTransaction(s, n);
  }
  /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */
  async sendRawTransaction(e, r) {
    const n = Wt(e).toString("base64");
    return await this.sendEncodedTransaction(n, r);
  }
  /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */
  async sendEncodedTransaction(e, r) {
    const n = {
      encoding: "base64"
    }, i = r && r.skipPreflight, s = r && r.preflightCommitment || this.commitment;
    r && r.maxRetries != null && (n.maxRetries = r.maxRetries), r && r.minContextSlot != null && (n.minContextSlot = r.minContextSlot), i && (n.skipPreflight = i), s && (n.preflightCommitment = s);
    const a = [e, n], o = await this._rpcRequest("sendTransaction", a), c = He(o, hte);
    if ("error" in c) {
      let f;
      throw "data" in c.error && (f = c.error.data.logs), new Zv("failed to send transaction: " + c.error.message, f);
    }
    return c.result;
  }
  /**
   * @internal
   */
  _wsOnOpen() {
    this._rpcWebSocketConnected = !0, this._rpcWebSocketHeartbeat = setInterval(() => {
      (async () => {
        try {
          await this._rpcWebSocket.notify("ping");
        } catch {
        }
      })();
    }, 5e3), this._updateSubscriptions();
  }
  /**
   * @internal
   */
  _wsOnError(e) {
    this._rpcWebSocketConnected = !1, console.error("ws error:", e.message);
  }
  /**
   * @internal
   */
  _wsOnClose(e) {
    if (this._rpcWebSocketConnected = !1, this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER, this._rpcWebSocketIdleTimeout && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null), this._rpcWebSocketHeartbeat && (clearInterval(this._rpcWebSocketHeartbeat), this._rpcWebSocketHeartbeat = null), e === 1e3) {
      this._updateSubscriptions();
      return;
    }
    this._subscriptionCallbacksByServerSubscriptionId = {}, Object.entries(this._subscriptionsByHash).forEach(([r, n]) => {
      this._setSubscription(r, {
        ...n,
        state: "pending"
      });
    });
  }
  /**
   * @internal
   */
  _setSubscription(e, r) {
    var i;
    const n = (i = this._subscriptionsByHash[e]) == null ? void 0 : i.state;
    if (this._subscriptionsByHash[e] = r, n !== r.state) {
      const s = this._subscriptionStateChangeCallbacksByHash[e];
      s && s.forEach((a) => {
        try {
          a(r.state);
        } catch {
        }
      });
    }
  }
  /**
   * @internal
   */
  _onSubscriptionStateChange(e, r) {
    var s;
    const n = this._subscriptionHashByClientSubscriptionId[e];
    if (n == null)
      return () => {
      };
    const i = (s = this._subscriptionStateChangeCallbacksByHash)[n] || (s[n] = /* @__PURE__ */ new Set());
    return i.add(r), () => {
      i.delete(r), i.size === 0 && delete this._subscriptionStateChangeCallbacksByHash[n];
    };
  }
  /**
   * @internal
   */
  async _updateSubscriptions() {
    if (Object.keys(this._subscriptionsByHash).length === 0) {
      this._rpcWebSocketConnected && (this._rpcWebSocketConnected = !1, this._rpcWebSocketIdleTimeout = setTimeout(() => {
        this._rpcWebSocketIdleTimeout = null;
        try {
          this._rpcWebSocket.close();
        } catch (n) {
          n instanceof Error && console.log(`Error when closing socket connection: ${n.message}`);
        }
      }, 500));
      return;
    }
    if (this._rpcWebSocketIdleTimeout !== null && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketConnected = !0), !this._rpcWebSocketConnected) {
      this._rpcWebSocket.connect();
      return;
    }
    const e = this._rpcWebSocketGeneration, r = () => e === this._rpcWebSocketGeneration;
    await Promise.all(
      // Don't be tempted to change this to `Object.entries`. We call
      // `_updateSubscriptions` recursively when processing the state,
      // so it's important that we look up the *current* version of
      // each subscription, every time we process a hash.
      Object.keys(this._subscriptionsByHash).map(async (n) => {
        const i = this._subscriptionsByHash[n];
        if (i !== void 0)
          switch (i.state) {
            case "pending":
            case "unsubscribed":
              if (i.callbacks.size === 0) {
                delete this._subscriptionsByHash[n], i.state === "unsubscribed" && delete this._subscriptionCallbacksByServerSubscriptionId[i.serverSubscriptionId], await this._updateSubscriptions();
                return;
              }
              await (async () => {
                const {
                  args: s,
                  method: a
                } = i;
                try {
                  this._setSubscription(n, {
                    ...i,
                    state: "subscribing"
                  });
                  const o = await this._rpcWebSocket.call(a, s);
                  this._setSubscription(n, {
                    ...i,
                    serverSubscriptionId: o,
                    state: "subscribed"
                  }), this._subscriptionCallbacksByServerSubscriptionId[o] = i.callbacks, await this._updateSubscriptions();
                } catch (o) {
                  if (o instanceof Error && console.error(`${a} error for argument`, s, o.message), !r())
                    return;
                  this._setSubscription(n, {
                    ...i,
                    state: "pending"
                  }), await this._updateSubscriptions();
                }
              })();
              break;
            case "subscribed":
              i.callbacks.size === 0 && await (async () => {
                const {
                  serverSubscriptionId: s,
                  unsubscribeMethod: a
                } = i;
                if (this._subscriptionsAutoDisposedByRpc.has(s))
                  this._subscriptionsAutoDisposedByRpc.delete(s);
                else {
                  this._setSubscription(n, {
                    ...i,
                    state: "unsubscribing"
                  }), this._setSubscription(n, {
                    ...i,
                    state: "unsubscribing"
                  });
                  try {
                    await this._rpcWebSocket.call(a, [s]);
                  } catch (o) {
                    if (o instanceof Error && console.error(`${a} error:`, o.message), !r())
                      return;
                    this._setSubscription(n, {
                      ...i,
                      state: "subscribed"
                    }), await this._updateSubscriptions();
                    return;
                  }
                }
                this._setSubscription(n, {
                  ...i,
                  state: "unsubscribed"
                }), await this._updateSubscriptions();
              })();
              break;
          }
      })
    );
  }
  /**
   * @internal
   */
  _handleServerNotification(e, r) {
    const n = this._subscriptionCallbacksByServerSubscriptionId[e];
    n !== void 0 && n.forEach((i) => {
      try {
        i(
          ...r
        );
      } catch (s) {
        console.error(s);
      }
    });
  }
  /**
   * @internal
   */
  _wsOnAccountNotification(e) {
    const {
      result: r,
      subscription: n
    } = He(e, Uee);
    this._handleServerNotification(n, [r.value, r.context]);
  }
  /**
   * @internal
   */
  _makeSubscription(e, r) {
    const n = this._nextClientSubscriptionId++, i = w4(
      [e.method, r],
      !0
      /* isArrayProp */
    ), s = this._subscriptionsByHash[i];
    return s === void 0 ? this._subscriptionsByHash[i] = {
      ...e,
      args: r,
      callbacks: /* @__PURE__ */ new Set([e.callback]),
      state: "pending"
    } : s.callbacks.add(e.callback), this._subscriptionHashByClientSubscriptionId[n] = i, this._subscriptionDisposeFunctionsByClientSubscriptionId[n] = async () => {
      delete this._subscriptionDisposeFunctionsByClientSubscriptionId[n], delete this._subscriptionHashByClientSubscriptionId[n];
      const a = this._subscriptionsByHash[i];
      _r(a !== void 0, `Could not find a \`Subscription\` when tearing down client subscription #${n}`), a.callbacks.delete(e.callback), await this._updateSubscriptions();
    }, this._updateSubscriptions(), n;
  }
  /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */
  onAccountChange(e, r, n) {
    const i = this._buildArgs(
      [e.toBase58()],
      n || this._commitment || "finalized",
      // Apply connection/server default.
      "base64"
    );
    return this._makeSubscription({
      callback: r,
      method: "accountSubscribe",
      unsubscribeMethod: "accountUnsubscribe"
    }, i);
  }
  /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeAccountChangeListener(e) {
    await this._unsubscribeClientSubscription(e, "account change");
  }
  /**
   * @internal
   */
  _wsOnProgramAccountNotification(e) {
    const {
      result: r,
      subscription: n
    } = He(e, Dee);
    this._handleServerNotification(n, [{
      accountId: r.value.pubkey,
      accountInfo: r.value.account
    }, r.context]);
  }
  /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */
  onProgramAccountChange(e, r, n, i) {
    const s = this._buildArgs(
      [e.toBase58()],
      n || this._commitment || "finalized",
      // Apply connection/server default.
      "base64",
      i ? {
        filters: i
      } : void 0
      /* extra */
    );
    return this._makeSubscription({
      callback: r,
      method: "programSubscribe",
      unsubscribeMethod: "programUnsubscribe"
    }, s);
  }
  /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeProgramAccountChangeListener(e) {
    await this._unsubscribeClientSubscription(e, "program account change");
  }
  /**
   * Registers a callback to be invoked whenever logs are emitted.
   */
  onLogs(e, r, n) {
    const i = this._buildArgs(
      [typeof e == "object" ? {
        mentions: [e.toString()]
      } : e],
      n || this._commitment || "finalized"
      // Apply connection/server default.
    );
    return this._makeSubscription({
      callback: r,
      method: "logsSubscribe",
      unsubscribeMethod: "logsUnsubscribe"
    }, i);
  }
  /**
   * Deregister a logs callback.
   *
   * @param id client subscription id to deregister.
   */
  async removeOnLogsListener(e) {
    await this._unsubscribeClientSubscription(e, "logs");
  }
  /**
   * @internal
   */
  _wsOnLogsNotification(e) {
    const {
      result: r,
      subscription: n
    } = He(e, yte);
    this._handleServerNotification(n, [r.value, r.context]);
  }
  /**
   * @internal
   */
  _wsOnSlotNotification(e) {
    const {
      result: r,
      subscription: n
    } = He(e, jee);
    this._handleServerNotification(n, [r]);
  }
  /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */
  onSlotChange(e) {
    return this._makeSubscription(
      {
        callback: e,
        method: "slotSubscribe",
        unsubscribeMethod: "slotUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSlotChangeListener(e) {
    await this._unsubscribeClientSubscription(e, "slot change");
  }
  /**
   * @internal
   */
  _wsOnSlotUpdatesNotification(e) {
    const {
      result: r,
      subscription: n
    } = He(e, qee);
    this._handleServerNotification(n, [r]);
  }
  /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */
  onSlotUpdate(e) {
    return this._makeSubscription(
      {
        callback: e,
        method: "slotsUpdatesSubscribe",
        unsubscribeMethod: "slotsUpdatesUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot update notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSlotUpdateListener(e) {
    await this._unsubscribeClientSubscription(e, "slot update");
  }
  /**
   * @internal
   */
  async _unsubscribeClientSubscription(e, r) {
    const n = this._subscriptionDisposeFunctionsByClientSubscriptionId[e];
    n ? await n() : console.warn(`Ignored unsubscribe request because an active subscription with id \`${e}\` for '${r}' events could not be found.`);
  }
  _buildArgs(e, r, n, i) {
    const s = r || this._commitment;
    if (s || n || i) {
      let a = {};
      n && (a.encoding = n), s && (a.commitment = s), i && (a = Object.assign(a, i)), e.push(a);
    }
    return e;
  }
  /**
   * @internal
   */
  _buildArgsAtLeastConfirmed(e, r, n, i) {
    const s = r || this._commitment;
    if (s && !["confirmed", "finalized"].includes(s))
      throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
    return this._buildArgs(e, r, n, i);
  }
  /**
   * @internal
   */
  _wsOnSignatureNotification(e) {
    const {
      result: r,
      subscription: n
    } = He(e, Wee);
    r.value !== "receivedSignature" && this._subscriptionsAutoDisposedByRpc.add(n), this._handleServerNotification(n, r.value === "receivedSignature" ? [{
      type: "received"
    }, r.context] : [{
      type: "status",
      result: r.value
    }, r.context]);
  }
  /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */
  onSignature(e, r, n) {
    const i = this._buildArgs(
      [e],
      n || this._commitment || "finalized"
      // Apply connection/server default.
    ), s = this._makeSubscription({
      callback: (a, o) => {
        if (a.type === "status") {
          r(a.result, o);
          try {
            this.removeSignatureListener(s);
          } catch {
          }
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, i);
    return s;
  }
  /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */
  onSignatureWithOptions(e, r, n) {
    const {
      commitment: i,
      ...s
    } = {
      ...n,
      commitment: n && n.commitment || this._commitment || "finalized"
      // Apply connection/server default.
    }, a = this._buildArgs([e], i, void 0, s), o = this._makeSubscription({
      callback: (c, f) => {
        r(c, f);
        try {
          this.removeSignatureListener(o);
        } catch {
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, a);
    return o;
  }
  /**
   * Deregister a signature notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSignatureListener(e) {
    await this._unsubscribeClientSubscription(e, "signature result");
  }
  /**
   * @internal
   */
  _wsOnRootNotification(e) {
    const {
      result: r,
      subscription: n
    } = He(e, zee);
    this._handleServerNotification(n, [r]);
  }
  /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */
  onRootChange(e) {
    return this._makeSubscription(
      {
        callback: e,
        method: "rootSubscribe",
        unsubscribeMethod: "rootUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a root notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeRootChangeListener(e) {
    await this._unsubscribeClientSubscription(e, "root change");
  }
};
class Pu {
  /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */
  constructor(e) {
    this._keypair = void 0, this._keypair = e ?? g4();
  }
  /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */
  static generate() {
    return new Pu(g4());
  }
  /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */
  static fromSecretKey(e, r) {
    if (e.byteLength !== 64)
      throw new Error("bad secret key size");
    const n = e.slice(32, 64);
    if (!r || !r.skipValidation) {
      const i = e.slice(0, 32), s = Dp(i);
      for (let a = 0; a < 32; a++)
        if (n[a] !== s[a])
          throw new Error("provided secretKey is invalid");
    }
    return new Pu({
      publicKey: n,
      secretKey: e
    });
  }
  /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */
  static fromSeed(e) {
    const r = Dp(e), n = new Uint8Array(64);
    return n.set(e), n.set(r, 32), new Pu({
      publicKey: r,
      secretKey: n
    });
  }
  /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */
  get publicKey() {
    return new Ze(this._keypair.publicKey);
  }
  /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */
  get secretKey() {
    return new Uint8Array(this._keypair.secretKey);
  }
}
const Ta = Object.freeze({
  CreateLookupTable: {
    index: 0,
    layout: Re([Be("instruction"), af("recentSlot"), st("bumpSeed")])
  },
  FreezeLookupTable: {
    index: 1,
    layout: Re([Be("instruction")])
  },
  ExtendLookupTable: {
    index: 2,
    layout: Re([Be("instruction"), af(), Ir(er(), Ii(Be(), -8), "addresses")])
  },
  DeactivateLookupTable: {
    index: 3,
    layout: Re([Be("instruction")])
  },
  CloseLookupTable: {
    index: 4,
    layout: Re([Be("instruction")])
  }
});
class mte {
  /**
   * @internal
   */
  constructor() {
  }
  static decodeInstructionType(e) {
    this.checkProgramId(e.programId);
    const n = Be("instruction").decode(e.data);
    let i;
    for (const [s, a] of Object.entries(Ta))
      if (a.index == n) {
        i = s;
        break;
      }
    if (!i)
      throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
    return i;
  }
  static decodeCreateLookupTable(e) {
    this.checkProgramId(e.programId), this.checkKeysLength(e.keys, 4);
    const {
      recentSlot: r
    } = Rr(Ta.CreateLookupTable, e.data);
    return {
      authority: e.keys[1].pubkey,
      payer: e.keys[2].pubkey,
      recentSlot: Number(r)
    };
  }
  static decodeExtendLookupTable(e) {
    if (this.checkProgramId(e.programId), e.keys.length < 2)
      throw new Error(`invalid instruction; found ${e.keys.length} keys, expected at least 2`);
    const {
      addresses: r
    } = Rr(Ta.ExtendLookupTable, e.data);
    return {
      lookupTable: e.keys[0].pubkey,
      authority: e.keys[1].pubkey,
      payer: e.keys.length > 2 ? e.keys[2].pubkey : void 0,
      addresses: r.map((n) => new Ze(n))
    };
  }
  static decodeCloseLookupTable(e) {
    return this.checkProgramId(e.programId), this.checkKeysLength(e.keys, 3), {
      lookupTable: e.keys[0].pubkey,
      authority: e.keys[1].pubkey,
      recipient: e.keys[2].pubkey
    };
  }
  static decodeFreezeLookupTable(e) {
    return this.checkProgramId(e.programId), this.checkKeysLength(e.keys, 2), {
      lookupTable: e.keys[0].pubkey,
      authority: e.keys[1].pubkey
    };
  }
  static decodeDeactivateLookupTable(e) {
    return this.checkProgramId(e.programId), this.checkKeysLength(e.keys, 2), {
      lookupTable: e.keys[0].pubkey,
      authority: e.keys[1].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(e) {
    if (!e.equals(k_.programId))
      throw new Error("invalid instruction; programId is not AddressLookupTable Program");
  }
  /**
   * @internal
   */
  static checkKeysLength(e, r) {
    if (e.length < r)
      throw new Error(`invalid instruction; found ${e.length} keys, expected at least ${r}`);
  }
}
class k_ {
  /**
   * @internal
   */
  constructor() {
  }
  static createLookupTable(e) {
    const [r, n] = Ze.findProgramAddressSync([e.authority.toBuffer(), nk(BigInt(e.recentSlot), 8)], this.programId), i = Ta.CreateLookupTable, s = mr(i, {
      recentSlot: BigInt(e.recentSlot),
      bumpSeed: n
    }), a = [{
      pubkey: r,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: e.authority,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: e.payer,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: zn.programId,
      isSigner: !1,
      isWritable: !1
    }];
    return [new Kr({
      programId: this.programId,
      keys: a,
      data: s
    }), r];
  }
  static freezeLookupTable(e) {
    const r = Ta.FreezeLookupTable, n = mr(r), i = [{
      pubkey: e.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: e.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return new Kr({
      programId: this.programId,
      keys: i,
      data: n
    });
  }
  static extendLookupTable(e) {
    const r = Ta.ExtendLookupTable, n = mr(r, {
      addresses: e.addresses.map((s) => s.toBytes())
    }), i = [{
      pubkey: e.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: e.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return e.payer && i.push({
      pubkey: e.payer,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: zn.programId,
      isSigner: !1,
      isWritable: !1
    }), new Kr({
      programId: this.programId,
      keys: i,
      data: n
    });
  }
  static deactivateLookupTable(e) {
    const r = Ta.DeactivateLookupTable, n = mr(r), i = [{
      pubkey: e.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: e.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return new Kr({
      programId: this.programId,
      keys: i,
      data: n
    });
  }
  static closeLookupTable(e) {
    const r = Ta.CloseLookupTable, n = mr(r), i = [{
      pubkey: e.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: e.authority,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: e.recipient,
      isSigner: !1,
      isWritable: !0
    }];
    return new Kr({
      programId: this.programId,
      keys: i,
      data: n
    });
  }
}
k_.programId = new Ze("AddressLookupTab1e1111111111111111111111111");
class vte {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */
  static decodeInstructionType(e) {
    this.checkProgramId(e.programId);
    const n = st("instruction").decode(e.data);
    let i;
    for (const [s, a] of Object.entries(Vs))
      if (a.index == n) {
        i = s;
        break;
      }
    if (!i)
      throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
    return i;
  }
  /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */
  static decodeRequestUnits(e) {
    this.checkProgramId(e.programId);
    const {
      units: r,
      additionalFee: n
    } = Rr(Vs.RequestUnits, e.data);
    return {
      units: r,
      additionalFee: n
    };
  }
  /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */
  static decodeRequestHeapFrame(e) {
    this.checkProgramId(e.programId);
    const {
      bytes: r
    } = Rr(Vs.RequestHeapFrame, e.data);
    return {
      bytes: r
    };
  }
  /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */
  static decodeSetComputeUnitLimit(e) {
    this.checkProgramId(e.programId);
    const {
      units: r
    } = Rr(Vs.SetComputeUnitLimit, e.data);
    return {
      units: r
    };
  }
  /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */
  static decodeSetComputeUnitPrice(e) {
    this.checkProgramId(e.programId);
    const {
      microLamports: r
    } = Rr(Vs.SetComputeUnitPrice, e.data);
    return {
      microLamports: r
    };
  }
  /**
   * @internal
   */
  static checkProgramId(e) {
    if (!e.equals(R_.programId))
      throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
  }
}
const Vs = Object.freeze({
  RequestUnits: {
    index: 0,
    layout: Re([st("instruction"), Be("units"), Be("additionalFee")])
  },
  RequestHeapFrame: {
    index: 1,
    layout: Re([st("instruction"), Be("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: Re([st("instruction"), Be("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: Re([st("instruction"), af("microLamports")])
  }
});
class R_ {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Compute Budget program
   */
  /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */
  static requestUnits(e) {
    const r = Vs.RequestUnits, n = mr(r, e);
    return new Kr({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
  static requestHeapFrame(e) {
    const r = Vs.RequestHeapFrame, n = mr(r, e);
    return new Kr({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
  static setComputeUnitLimit(e) {
    const r = Vs.SetComputeUnitLimit, n = mr(r, e);
    return new Kr({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
  static setComputeUnitPrice(e) {
    const r = Vs.SetComputeUnitPrice, n = mr(r, {
      microLamports: BigInt(e.microLamports)
    });
    return new Kr({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
}
R_.programId = new Ze("ComputeBudget111111111111111111111111111111");
const A4 = 64, I4 = 32, T4 = 64, k4 = Re([st("numSignatures"), st("padding"), rn("signatureOffset"), rn("signatureInstructionIndex"), rn("publicKeyOffset"), rn("publicKeyInstructionIndex"), rn("messageDataOffset"), rn("messageDataSize"), rn("messageInstructionIndex")]);
class zy {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the ed25519 program
   */
  /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */
  static createInstructionWithPublicKey(e) {
    const {
      publicKey: r,
      message: n,
      signature: i,
      instructionIndex: s
    } = e;
    _r(r.length === I4, `Public Key must be ${I4} bytes but received ${r.length} bytes`), _r(i.length === T4, `Signature must be ${T4} bytes but received ${i.length} bytes`);
    const a = k4.span, o = a + r.length, c = o + i.length, f = 1, u = Fe.Buffer.alloc(c + n.length), d = s ?? 65535;
    return k4.encode({
      numSignatures: f,
      padding: 0,
      signatureOffset: o,
      signatureInstructionIndex: d,
      publicKeyOffset: a,
      publicKeyInstructionIndex: d,
      messageDataOffset: c,
      messageDataSize: n.length,
      messageInstructionIndex: d
    }, u), u.fill(r, a), u.fill(i, o), u.fill(n, c), new Kr({
      keys: [],
      programId: zy.programId,
      data: u
    });
  }
  /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */
  static createInstructionWithPrivateKey(e) {
    const {
      privateKey: r,
      message: n,
      instructionIndex: i
    } = e;
    _r(r.length === A4, `Private key must be ${A4} bytes but received ${r.length} bytes`);
    try {
      const s = Pu.fromSecretKey(r), a = s.publicKey.toBytes(), o = m_(n, s.secretKey);
      return this.createInstructionWithPublicKey({
        publicKey: a,
        message: n,
        signature: o,
        instructionIndex: i
      });
    } catch (s) {
      throw new Error(`Error creating instruction; ${s}`);
    }
  }
}
zy.programId = new Ze("Ed25519SigVerify111111111111111111111111111");
const wte = (t, e) => {
  const r = Dy.sign(t, e);
  return [r.toCompactRawBytes(), r.recovery];
};
Dy.utils.isValidPrivateKey;
const _te = Dy.getPublicKey, R4 = 32, _m = 20, P4 = 64, Ste = 11, Sm = Re([st("numSignatures"), rn("signatureOffset"), st("signatureInstructionIndex"), rn("ethAddressOffset"), st("ethAddressInstructionIndex"), rn("messageDataOffset"), rn("messageDataSize"), st("messageInstructionIndex"), xt(20, "ethAddress"), xt(64, "signature"), st("recoveryId")]);
class Ou {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the secp256k1 program
   */
  /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */
  static publicKeyToEthAddress(e) {
    _r(e.length === P4, `Public key must be ${P4} bytes but received ${e.length} bytes`);
    try {
      return Fe.Buffer.from(h4(Wt(e))).slice(-_m);
    } catch (r) {
      throw new Error(`Error constructing Ethereum address: ${r}`);
    }
  }
  /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */
  static createInstructionWithPublicKey(e) {
    const {
      publicKey: r,
      message: n,
      signature: i,
      recoveryId: s,
      instructionIndex: a
    } = e;
    return Ou.createInstructionWithEthAddress({
      ethAddress: Ou.publicKeyToEthAddress(r),
      message: n,
      signature: i,
      recoveryId: s,
      instructionIndex: a
    });
  }
  /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */
  static createInstructionWithEthAddress(e) {
    const {
      ethAddress: r,
      message: n,
      signature: i,
      recoveryId: s,
      instructionIndex: a = 0
    } = e;
    let o;
    typeof r == "string" ? r.startsWith("0x") ? o = Fe.Buffer.from(r.substr(2), "hex") : o = Fe.Buffer.from(r, "hex") : o = r, _r(o.length === _m, `Address must be ${_m} bytes but received ${o.length} bytes`);
    const c = 1 + Ste, f = c, u = c + o.length, d = u + i.length + 1, l = 1, h = Fe.Buffer.alloc(Sm.span + n.length);
    return Sm.encode({
      numSignatures: l,
      signatureOffset: u,
      signatureInstructionIndex: a,
      ethAddressOffset: f,
      ethAddressInstructionIndex: a,
      messageDataOffset: d,
      messageDataSize: n.length,
      messageInstructionIndex: a,
      signature: Wt(i),
      ethAddress: Wt(o),
      recoveryId: s
    }, h), h.fill(Wt(n), Sm.span), new Kr({
      keys: [],
      programId: Ou.programId,
      data: h
    });
  }
  /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */
  static createInstructionWithPrivateKey(e) {
    const {
      privateKey: r,
      message: n,
      instructionIndex: i
    } = e;
    _r(r.length === R4, `Private key must be ${R4} bytes but received ${r.length} bytes`);
    try {
      const s = Wt(r), a = _te(
        s,
        !1
        /* isCompressed */
      ).slice(1), o = Fe.Buffer.from(h4(Wt(n))), [c, f] = wte(o, s);
      return this.createInstructionWithPublicKey({
        publicKey: a,
        message: n,
        signature: c,
        recoveryId: f,
        instructionIndex: i
      });
    } catch (s) {
      throw new Error(`Error creating instruction; ${s}`);
    }
  }
}
Ou.programId = new Ze("KeccakSecp256k11111111111111111111111111111");
var Wk;
const zk = new Ze("StakeConfig11111111111111111111111111111111");
class Kk {
  /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */
  constructor(e, r) {
    this.staker = void 0, this.withdrawer = void 0, this.staker = e, this.withdrawer = r;
  }
}
class Wl {
  /**
   * Create a new Lockup object
   */
  constructor(e, r, n) {
    this.unixTimestamp = void 0, this.epoch = void 0, this.custodian = void 0, this.unixTimestamp = e, this.epoch = r, this.custodian = n;
  }
  /**
   * Default, inactive Lockup value
   */
}
Wk = Wl;
Wl.default = new Wk(0, 0, Ze.default);
class Ete {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a stake instruction and retrieve the instruction type.
   */
  static decodeInstructionType(e) {
    this.checkProgramId(e.programId);
    const n = Be("instruction").decode(e.data);
    let i;
    for (const [s, a] of Object.entries(Mn))
      if (a.index == n) {
        i = s;
        break;
      }
    if (!i)
      throw new Error("Instruction type incorrect; not a StakeInstruction");
    return i;
  }
  /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */
  static decodeInitialize(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      authorized: r,
      lockup: n
    } = Rr(Mn.Initialize, e.data);
    return {
      stakePubkey: e.keys[0].pubkey,
      authorized: new Kk(new Ze(r.staker), new Ze(r.withdrawer)),
      lockup: new Wl(n.unixTimestamp, n.epoch, new Ze(n.custodian))
    };
  }
  /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */
  static decodeDelegate(e) {
    return this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 6), Rr(Mn.Delegate, e.data), {
      stakePubkey: e.keys[0].pubkey,
      votePubkey: e.keys[1].pubkey,
      authorizedPubkey: e.keys[5].pubkey
    };
  }
  /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */
  static decodeAuthorize(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      newAuthorized: r,
      stakeAuthorizationType: n
    } = Rr(Mn.Authorize, e.data), i = {
      stakePubkey: e.keys[0].pubkey,
      authorizedPubkey: e.keys[2].pubkey,
      newAuthorizedPubkey: new Ze(r),
      stakeAuthorizationType: {
        index: n
      }
    };
    return e.keys.length > 3 && (i.custodianPubkey = e.keys[3].pubkey), i;
  }
  /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */
  static decodeAuthorizeWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 2);
    const {
      newAuthorized: r,
      stakeAuthorizationType: n,
      authoritySeed: i,
      authorityOwner: s
    } = Rr(Mn.AuthorizeWithSeed, e.data), a = {
      stakePubkey: e.keys[0].pubkey,
      authorityBase: e.keys[1].pubkey,
      authoritySeed: i,
      authorityOwner: new Ze(s),
      newAuthorizedPubkey: new Ze(r),
      stakeAuthorizationType: {
        index: n
      }
    };
    return e.keys.length > 3 && (a.custodianPubkey = e.keys[3].pubkey), a;
  }
  /**
   * Decode a split stake instruction and retrieve the instruction params.
   */
  static decodeSplit(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      lamports: r
    } = Rr(Mn.Split, e.data);
    return {
      stakePubkey: e.keys[0].pubkey,
      splitStakePubkey: e.keys[1].pubkey,
      authorizedPubkey: e.keys[2].pubkey,
      lamports: r
    };
  }
  /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */
  static decodeMerge(e) {
    return this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3), Rr(Mn.Merge, e.data), {
      stakePubkey: e.keys[0].pubkey,
      sourceStakePubKey: e.keys[1].pubkey,
      authorizedPubkey: e.keys[4].pubkey
    };
  }
  /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */
  static decodeWithdraw(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 5);
    const {
      lamports: r
    } = Rr(Mn.Withdraw, e.data), n = {
      stakePubkey: e.keys[0].pubkey,
      toPubkey: e.keys[1].pubkey,
      authorizedPubkey: e.keys[4].pubkey,
      lamports: r
    };
    return e.keys.length > 5 && (n.custodianPubkey = e.keys[5].pubkey), n;
  }
  /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */
  static decodeDeactivate(e) {
    return this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3), Rr(Mn.Deactivate, e.data), {
      stakePubkey: e.keys[0].pubkey,
      authorizedPubkey: e.keys[2].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(e) {
    if (!e.equals(Ky.programId))
      throw new Error("invalid instruction; programId is not StakeProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(e, r) {
    if (e.length < r)
      throw new Error(`invalid instruction; found ${e.length} keys, expected at least ${r}`);
  }
}
const Mn = Object.freeze({
  Initialize: {
    index: 0,
    layout: Re([Be("instruction"), AX(), IX()])
  },
  Authorize: {
    index: 1,
    layout: Re([Be("instruction"), er("newAuthorized"), Be("stakeAuthorizationType")])
  },
  Delegate: {
    index: 2,
    layout: Re([Be("instruction")])
  },
  Split: {
    index: 3,
    layout: Re([Be("instruction"), Gr("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: Re([Be("instruction"), Gr("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: Re([Be("instruction")])
  },
  Merge: {
    index: 7,
    layout: Re([Be("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: Re([Be("instruction"), er("newAuthorized"), Be("stakeAuthorizationType"), Xo("authoritySeed"), er("authorityOwner")])
  }
}), xte = Object.freeze({
  Staker: {
    index: 0
  },
  Withdrawer: {
    index: 1
  }
});
class Ky {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Stake program
   */
  /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */
  static initialize(e) {
    const {
      stakePubkey: r,
      authorized: n,
      lockup: i
    } = e, s = i || Wl.default, a = Mn.Initialize, o = mr(a, {
      authorized: {
        staker: Wt(n.staker.toBuffer()),
        withdrawer: Wt(n.withdrawer.toBuffer())
      },
      lockup: {
        unixTimestamp: s.unixTimestamp,
        epoch: s.epoch,
        custodian: Wt(s.custodian.toBuffer())
      }
    }), c = {
      keys: [{
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: sf,
        isSigner: !1,
        isWritable: !1
      }],
      programId: this.programId,
      data: o
    };
    return new Kr(c);
  }
  /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */
  static createAccountWithSeed(e) {
    const r = new Or();
    r.add(zn.createAccountWithSeed({
      fromPubkey: e.fromPubkey,
      newAccountPubkey: e.stakePubkey,
      basePubkey: e.basePubkey,
      seed: e.seed,
      lamports: e.lamports,
      space: this.space,
      programId: this.programId
    }));
    const {
      stakePubkey: n,
      authorized: i,
      lockup: s
    } = e;
    return r.add(this.initialize({
      stakePubkey: n,
      authorized: i,
      lockup: s
    }));
  }
  /**
   * Generate a Transaction that creates a new Stake account
   */
  static createAccount(e) {
    const r = new Or();
    r.add(zn.createAccount({
      fromPubkey: e.fromPubkey,
      newAccountPubkey: e.stakePubkey,
      lamports: e.lamports,
      space: this.space,
      programId: this.programId
    }));
    const {
      stakePubkey: n,
      authorized: i,
      lockup: s
    } = e;
    return r.add(this.initialize({
      stakePubkey: n,
      authorized: i,
      lockup: s
    }));
  }
  /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */
  static delegate(e) {
    const {
      stakePubkey: r,
      authorizedPubkey: n,
      votePubkey: i
    } = e, s = Mn.Delegate, a = mr(s);
    return new Or().add({
      keys: [{
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: i,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Ws,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: rp,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: zk,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: n,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: a
    });
  }
  /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */
  static authorize(e) {
    const {
      stakePubkey: r,
      authorizedPubkey: n,
      newAuthorizedPubkey: i,
      stakeAuthorizationType: s,
      custodianPubkey: a
    } = e, o = Mn.Authorize, c = mr(o, {
      newAuthorized: Wt(i.toBuffer()),
      stakeAuthorizationType: s.index
    }), f = [{
      pubkey: r,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Ws,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }];
    return a && f.push({
      pubkey: a,
      isSigner: !1,
      isWritable: !1
    }), new Or().add({
      keys: f,
      programId: this.programId,
      data: c
    });
  }
  /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */
  static authorizeWithSeed(e) {
    const {
      stakePubkey: r,
      authorityBase: n,
      authoritySeed: i,
      authorityOwner: s,
      newAuthorizedPubkey: a,
      stakeAuthorizationType: o,
      custodianPubkey: c
    } = e, f = Mn.AuthorizeWithSeed, u = mr(f, {
      newAuthorized: Wt(a.toBuffer()),
      stakeAuthorizationType: o.index,
      authoritySeed: i,
      authorityOwner: Wt(s.toBuffer())
    }), d = [{
      pubkey: r,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: Ws,
      isSigner: !1,
      isWritable: !1
    }];
    return c && d.push({
      pubkey: c,
      isSigner: !1,
      isWritable: !1
    }), new Or().add({
      keys: d,
      programId: this.programId,
      data: u
    });
  }
  /**
   * @internal
   */
  static splitInstruction(e) {
    const {
      stakePubkey: r,
      authorizedPubkey: n,
      splitStakePubkey: i,
      lamports: s
    } = e, a = Mn.Split, o = mr(a, {
      lamports: s
    });
    return new Kr({
      keys: [{
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: i,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: n,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: o
    });
  }
  /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */
  static split(e) {
    const r = new Or();
    return r.add(zn.createAccount({
      fromPubkey: e.authorizedPubkey,
      newAccountPubkey: e.splitStakePubkey,
      lamports: 0,
      space: this.space,
      programId: this.programId
    })), r.add(this.splitInstruction(e));
  }
  /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */
  static splitWithSeed(e) {
    const {
      stakePubkey: r,
      authorizedPubkey: n,
      splitStakePubkey: i,
      basePubkey: s,
      seed: a,
      lamports: o
    } = e, c = new Or();
    return c.add(zn.allocate({
      accountPubkey: i,
      basePubkey: s,
      seed: a,
      space: this.space,
      programId: this.programId
    })), c.add(this.splitInstruction({
      stakePubkey: r,
      authorizedPubkey: n,
      splitStakePubkey: i,
      lamports: o
    }));
  }
  /**
   * Generate a Transaction that merges Stake accounts.
   */
  static merge(e) {
    const {
      stakePubkey: r,
      sourceStakePubKey: n,
      authorizedPubkey: i
    } = e, s = Mn.Merge, a = mr(s);
    return new Or().add({
      keys: [{
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: n,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Ws,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: rp,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: i,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: a
    });
  }
  /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */
  static withdraw(e) {
    const {
      stakePubkey: r,
      authorizedPubkey: n,
      toPubkey: i,
      lamports: s,
      custodianPubkey: a
    } = e, o = Mn.Withdraw, c = mr(o, {
      lamports: s
    }), f = [{
      pubkey: r,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: i,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Ws,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: rp,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }];
    return a && f.push({
      pubkey: a,
      isSigner: !1,
      isWritable: !1
    }), new Or().add({
      keys: f,
      programId: this.programId,
      data: c
    });
  }
  /**
   * Generate a Transaction that deactivates Stake tokens.
   */
  static deactivate(e) {
    const {
      stakePubkey: r,
      authorizedPubkey: n
    } = e, i = Mn.Deactivate, s = mr(i);
    return new Or().add({
      keys: [{
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Ws,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: n,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: s
    });
  }
}
Ky.programId = new Ze("Stake11111111111111111111111111111111111111");
Ky.space = 200;
class Vk {
  /** [0, 100] */
  constructor(e, r, n, i) {
    this.nodePubkey = void 0, this.authorizedVoter = void 0, this.authorizedWithdrawer = void 0, this.commission = void 0, this.nodePubkey = e, this.authorizedVoter = r, this.authorizedWithdrawer = n, this.commission = i;
  }
}
class Ate {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a vote instruction and retrieve the instruction type.
   */
  static decodeInstructionType(e) {
    this.checkProgramId(e.programId);
    const n = Be("instruction").decode(e.data);
    let i;
    for (const [s, a] of Object.entries(ka))
      if (a.index == n) {
        i = s;
        break;
      }
    if (!i)
      throw new Error("Instruction type incorrect; not a VoteInstruction");
    return i;
  }
  /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */
  static decodeInitializeAccount(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 4);
    const {
      voteInit: r
    } = Rr(ka.InitializeAccount, e.data);
    return {
      votePubkey: e.keys[0].pubkey,
      nodePubkey: e.keys[3].pubkey,
      voteInit: new Vk(new Ze(r.nodePubkey), new Ze(r.authorizedVoter), new Ze(r.authorizedWithdrawer), r.commission)
    };
  }
  /**
   * Decode an authorize instruction and retrieve the instruction params.
   */
  static decodeAuthorize(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      newAuthorized: r,
      voteAuthorizationType: n
    } = Rr(ka.Authorize, e.data);
    return {
      votePubkey: e.keys[0].pubkey,
      authorizedPubkey: e.keys[2].pubkey,
      newAuthorizedPubkey: new Ze(r),
      voteAuthorizationType: {
        index: n
      }
    };
  }
  /**
   * Decode an authorize instruction and retrieve the instruction params.
   */
  static decodeAuthorizeWithSeed(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      voteAuthorizeWithSeedArgs: {
        currentAuthorityDerivedKeyOwnerPubkey: r,
        currentAuthorityDerivedKeySeed: n,
        newAuthorized: i,
        voteAuthorizationType: s
      }
    } = Rr(ka.AuthorizeWithSeed, e.data);
    return {
      currentAuthorityDerivedKeyBasePubkey: e.keys[2].pubkey,
      currentAuthorityDerivedKeyOwnerPubkey: new Ze(r),
      currentAuthorityDerivedKeySeed: n,
      newAuthorizedPubkey: new Ze(i),
      voteAuthorizationType: {
        index: s
      },
      votePubkey: e.keys[0].pubkey
    };
  }
  /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */
  static decodeWithdraw(e) {
    this.checkProgramId(e.programId), this.checkKeyLength(e.keys, 3);
    const {
      lamports: r
    } = Rr(ka.Withdraw, e.data);
    return {
      votePubkey: e.keys[0].pubkey,
      authorizedWithdrawerPubkey: e.keys[2].pubkey,
      lamports: r,
      toPubkey: e.keys[1].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(e) {
    if (!e.equals(Pf.programId))
      throw new Error("invalid instruction; programId is not VoteProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(e, r) {
    if (e.length < r)
      throw new Error(`invalid instruction; found ${e.length} keys, expected at least ${r}`);
  }
}
const ka = Object.freeze({
  InitializeAccount: {
    index: 0,
    layout: Re([Be("instruction"), TX()])
  },
  Authorize: {
    index: 1,
    layout: Re([Be("instruction"), er("newAuthorized"), Be("voteAuthorizationType")])
  },
  Withdraw: {
    index: 3,
    layout: Re([Be("instruction"), Gr("lamports")])
  },
  AuthorizeWithSeed: {
    index: 10,
    layout: Re([Be("instruction"), kX()])
  }
}), Ite = Object.freeze({
  Voter: {
    index: 0
  },
  Withdrawer: {
    index: 1
  }
});
class Pf {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Vote program
   */
  /**
   * Generate an Initialize instruction.
   */
  static initializeAccount(e) {
    const {
      votePubkey: r,
      nodePubkey: n,
      voteInit: i
    } = e, s = ka.InitializeAccount, a = mr(s, {
      voteInit: {
        nodePubkey: Wt(i.nodePubkey.toBuffer()),
        authorizedVoter: Wt(i.authorizedVoter.toBuffer()),
        authorizedWithdrawer: Wt(i.authorizedWithdrawer.toBuffer()),
        commission: i.commission
      }
    }), o = {
      keys: [{
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: sf,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Ws,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: n,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: a
    };
    return new Kr(o);
  }
  /**
   * Generate a transaction that creates a new Vote account.
   */
  static createAccount(e) {
    const r = new Or();
    return r.add(zn.createAccount({
      fromPubkey: e.fromPubkey,
      newAccountPubkey: e.votePubkey,
      lamports: e.lamports,
      space: this.space,
      programId: this.programId
    })), r.add(this.initializeAccount({
      votePubkey: e.votePubkey,
      nodePubkey: e.voteInit.nodePubkey,
      voteInit: e.voteInit
    }));
  }
  /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */
  static authorize(e) {
    const {
      votePubkey: r,
      authorizedPubkey: n,
      newAuthorizedPubkey: i,
      voteAuthorizationType: s
    } = e, a = ka.Authorize, o = mr(a, {
      newAuthorized: Wt(i.toBuffer()),
      voteAuthorizationType: s.index
    }), c = [{
      pubkey: r,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Ws,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }];
    return new Or().add({
      keys: c,
      programId: this.programId,
      data: o
    });
  }
  /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */
  static authorizeWithSeed(e) {
    const {
      currentAuthorityDerivedKeyBasePubkey: r,
      currentAuthorityDerivedKeyOwnerPubkey: n,
      currentAuthorityDerivedKeySeed: i,
      newAuthorizedPubkey: s,
      voteAuthorizationType: a,
      votePubkey: o
    } = e, c = ka.AuthorizeWithSeed, f = mr(c, {
      voteAuthorizeWithSeedArgs: {
        currentAuthorityDerivedKeyOwnerPubkey: Wt(n.toBuffer()),
        currentAuthorityDerivedKeySeed: i,
        newAuthorized: Wt(s.toBuffer()),
        voteAuthorizationType: a.index
      }
    }), u = [{
      pubkey: o,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Ws,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: r,
      isSigner: !0,
      isWritable: !1
    }];
    return new Or().add({
      keys: u,
      programId: this.programId,
      data: f
    });
  }
  /**
   * Generate a transaction to withdraw from a Vote account.
   */
  static withdraw(e) {
    const {
      votePubkey: r,
      authorizedWithdrawerPubkey: n,
      lamports: i,
      toPubkey: s
    } = e, a = ka.Withdraw, o = mr(a, {
      lamports: i
    }), c = [{
      pubkey: r,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: s,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }];
    return new Or().add({
      keys: c,
      programId: this.programId,
      data: o
    });
  }
  /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */
  static safeWithdraw(e, r, n) {
    if (e.lamports > r - n)
      throw new Error("Withdraw will leave vote account with insuffcient funds.");
    return Pf.withdraw(e);
  }
}
Pf.programId = new Ze("Vote111111111111111111111111111111111111111");
Pf.space = 3731;
const Hk = new Ze("Va1idator1nfo111111111111111111111111111111"), Tte = ye({
  name: we(),
  website: We(we()),
  details: We(we()),
  keybaseUsername: We(we())
});
class P_ {
  /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */
  constructor(e, r) {
    this.key = void 0, this.info = void 0, this.key = e, this.info = r;
  }
  /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */
  static fromConfigData(e) {
    let r = [...e];
    if (wi(r) !== 2)
      return null;
    const i = [];
    for (let s = 0; s < 2; s++) {
      const a = new Ze(r.slice(0, Di));
      r = r.slice(Di);
      const o = r.slice(0, 1)[0] === 1;
      r = r.slice(1), i.push({
        publicKey: a,
        isSigner: o
      });
    }
    if (i[0].publicKey.equals(Hk) && i[1].isSigner) {
      const s = Xo().decode(Fe.Buffer.from(r)), a = JSON.parse(s);
      return W5(a, Tte), new P_(i[1].publicKey, a);
    }
    return null;
  }
}
const kte = new Ze("Vote111111111111111111111111111111111111111"), Rte = Re([
  er("nodePubkey"),
  er("authorizedWithdrawer"),
  st("commission"),
  gr(),
  // votes.length
  Ir(Re([gr("slot"), Be("confirmationCount")]), Ii(Be(), -8), "votes"),
  st("rootSlotValid"),
  gr("rootSlot"),
  gr(),
  // authorizedVoters.length
  Ir(Re([gr("epoch"), er("authorizedVoter")]), Ii(Be(), -8), "authorizedVoters"),
  Re([Ir(Re([er("authorizedPubkey"), gr("epochOfLastAuthorizedSwitch"), gr("targetEpoch")]), 32, "buf"), gr("idx"), st("isEmpty")], "priorVoters"),
  gr(),
  // epochCredits.length
  Ir(Re([gr("epoch"), gr("credits"), gr("prevCredits")]), Ii(Be(), -8), "epochCredits"),
  Re([gr("slot"), gr("timestamp")], "lastTimestamp")
]);
class O_ {
  /**
   * @internal
   */
  constructor(e) {
    this.nodePubkey = void 0, this.authorizedWithdrawer = void 0, this.commission = void 0, this.rootSlot = void 0, this.votes = void 0, this.authorizedVoters = void 0, this.priorVoters = void 0, this.epochCredits = void 0, this.lastTimestamp = void 0, this.nodePubkey = e.nodePubkey, this.authorizedWithdrawer = e.authorizedWithdrawer, this.commission = e.commission, this.rootSlot = e.rootSlot, this.votes = e.votes, this.authorizedVoters = e.authorizedVoters, this.priorVoters = e.priorVoters, this.epochCredits = e.epochCredits, this.lastTimestamp = e.lastTimestamp;
  }
  /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */
  static fromAccountData(e) {
    const n = Rte.decode(Wt(e), 4);
    let i = n.rootSlot;
    return n.rootSlotValid || (i = null), new O_({
      nodePubkey: new Ze(n.nodePubkey),
      authorizedWithdrawer: new Ze(n.authorizedWithdrawer),
      commission: n.commission,
      votes: n.votes,
      rootSlot: i,
      authorizedVoters: n.authorizedVoters.map(Pte),
      priorVoters: Ote(n.priorVoters),
      epochCredits: n.epochCredits,
      lastTimestamp: n.lastTimestamp
    });
  }
}
function Pte({
  authorizedVoter: t,
  epoch: e
}) {
  return {
    epoch: e,
    authorizedVoter: new Ze(t)
  };
}
function O4({
  authorizedPubkey: t,
  epochOfLastAuthorizedSwitch: e,
  targetEpoch: r
}) {
  return {
    authorizedPubkey: new Ze(t),
    epochOfLastAuthorizedSwitch: e,
    targetEpoch: r
  };
}
function Ote({
  buf: t,
  idx: e,
  isEmpty: r
}) {
  return r ? [] : [...t.slice(e + 1).map(O4), ...t.slice(0, e).map(O4)];
}
const B4 = {
  http: {
    devnet: "http://api.devnet.solana.com",
    testnet: "http://api.testnet.solana.com",
    "mainnet-beta": "http://api.mainnet-beta.solana.com/"
  },
  https: {
    devnet: "https://api.devnet.solana.com",
    testnet: "https://api.testnet.solana.com",
    "mainnet-beta": "https://api.mainnet-beta.solana.com/"
  }
};
function Bte(t, e) {
  const r = e === !1 ? "http" : "https";
  if (!t)
    return B4[r].devnet;
  const n = B4[r][t];
  if (!n)
    throw new Error(`Unknown ${r} cluster: ${t}`);
  return n;
}
async function Mte(t, e, r, n) {
  let i, s;
  r && Object.prototype.hasOwnProperty.call(r, "lastValidBlockHeight") || r && Object.prototype.hasOwnProperty.call(r, "nonceValue") ? (i = r, s = n) : s = r;
  const a = s && {
    skipPreflight: s.skipPreflight,
    preflightCommitment: s.preflightCommitment || s.commitment,
    minContextSlot: s.minContextSlot
  }, o = await t.sendRawTransaction(e, a), c = s && s.commitment, u = (await (i ? t.confirmTransaction(i, c) : t.confirmTransaction(o, c))).value;
  if (u.err)
    throw new Error(`Raw transaction ${o} failed (${JSON.stringify(u)})`);
  return o;
}
const Cte = 1e9, Nte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Account: SX,
  AddressLookupTableAccount: Jv,
  AddressLookupTableInstruction: mte,
  AddressLookupTableProgram: k_,
  Authorized: Kk,
  BLOCKHASH_CACHE_TIMEOUT_MS: Mk,
  BPF_LOADER_DEPRECATED_PROGRAM_ID: EX,
  BPF_LOADER_PROGRAM_ID: qX,
  BpfLoader: WX,
  COMPUTE_BUDGET_INSTRUCTION_LAYOUTS: Vs,
  ComputeBudgetInstruction: vte,
  ComputeBudgetProgram: R_,
  Connection: gte,
  Ed25519Program: zy,
  Enum: wX,
  EpochSchedule: Ok,
  FeeCalculatorLayout: Rk,
  Keypair: Pu,
  LAMPORTS_PER_SOL: Cte,
  LOOKUP_TABLE_INSTRUCTION_LAYOUTS: Ta,
  Loader: Mc,
  Lockup: Wl,
  MAX_SEED_LENGTH: Ik,
  Message: Is,
  MessageAccountKeys: Kd,
  MessageV0: Bc,
  NONCE_ACCOUNT_LENGTH: Gv,
  NonceAccount: $y,
  PACKET_DATA_SIZE: yo,
  PUBLIC_KEY_LENGTH: Di,
  PublicKey: Ze,
  SIGNATURE_LENGTH_IN_BYTES: nf,
  SOLANA_SCHEMA: dd,
  STAKE_CONFIG_ID: zk,
  STAKE_INSTRUCTION_LAYOUTS: Mn,
  SYSTEM_INSTRUCTION_LAYOUTS: Hr,
  SYSVAR_CLOCK_PUBKEY: Ws,
  SYSVAR_EPOCH_SCHEDULE_PUBKEY: MX,
  SYSVAR_INSTRUCTIONS_PUBKEY: CX,
  SYSVAR_RECENT_BLOCKHASHES_PUBKEY: tp,
  SYSVAR_RENT_PUBKEY: sf,
  SYSVAR_REWARDS_PUBKEY: NX,
  SYSVAR_SLOT_HASHES_PUBKEY: UX,
  SYSVAR_SLOT_HISTORY_PUBKEY: LX,
  SYSVAR_STAKE_HISTORY_PUBKEY: rp,
  Secp256k1Program: Ou,
  SendTransactionError: Zv,
  SolanaJSONRPCError: lt,
  SolanaJSONRPCErrorCode: ZX,
  StakeAuthorizationLayout: xte,
  StakeInstruction: Ete,
  StakeProgram: Ky,
  Struct: v_,
  SystemInstruction: jX,
  SystemProgram: zn,
  Transaction: Or,
  TransactionExpiredBlockheightExceededError: w_,
  TransactionExpiredNonceInvalidError: vu,
  TransactionExpiredTimeoutError: __,
  TransactionInstruction: Kr,
  TransactionMessage: E_,
  TransactionStatus: ga,
  VALIDATOR_INFO_KEY: Hk,
  VERSION_PREFIX_MASK: Fy,
  VOTE_PROGRAM_ID: kte,
  ValidatorInfo: P_,
  VersionedMessage: S_,
  VersionedTransaction: x_,
  VoteAccount: O_,
  VoteAuthorizationLayout: Ite,
  VoteInit: Vk,
  VoteInstruction: Ate,
  VoteProgram: Pf,
  clusterApiUrl: Bte,
  sendAndConfirmRawTransaction: Mte,
  sendAndConfirmTransaction: Hv
}, Symbol.toStringTag, { value: "Module" })), Of = /* @__PURE__ */ ta(Nte);
var Ute = Ne && Ne.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(wr, "__esModule", { value: !0 });
wr.setLayoutEncoder = wr.setLayoutDecoder = wr.accountFlagsLayout = wr.selfTradeBehaviorLayout = wr.orderTypeLayout = wr.sideLayout = wr.VersionedLayout = wr.WideBits = wr.u128 = wr.i64 = wr.u64 = wr.publicKeyLayout = wr.zeros = void 0;
const Hs = Qe, Lte = Of, Dte = Ute(Tr);
class Fte extends Hs.Blob {
  decode(e, r) {
    const n = super.decode(e, r);
    if (!n.every((i) => i === 0))
      throw new Error("nonzero padding bytes");
    return n;
  }
}
function jte(t) {
  return new Fte(t);
}
wr.zeros = jte;
class $te extends Hs.Blob {
  constructor(e) {
    super(32, e);
  }
  decode(e, r) {
    return new Lte.PublicKey(super.decode(e, r));
  }
  encode(e, r, n) {
    return super.encode(e.toBuffer(), r, n);
  }
}
function qte(t) {
  return new $te(t);
}
wr.publicKeyLayout = qte;
class B_ extends Hs.Blob {
  decode(e, r) {
    return new Dte.default(super.decode(e, r), 10, "le");
  }
  encode(e, r, n) {
    return super.encode(e.toArrayLike(ve, "le", this.span), r, n);
  }
}
function Wte(t) {
  return new B_(8, t);
}
wr.u64 = Wte;
function zte(t) {
  return new B_(8, t);
}
wr.i64 = zte;
function Kte(t) {
  return new B_(16, t);
}
wr.u128 = Kte;
class Gk extends Hs.Layout {
  constructor(e) {
    super(8, e), this._lower = Hs.bits(Hs.u32(), !1), this._upper = Hs.bits(Hs.u32(), !1);
  }
  addBoolean(e) {
    this._lower.fields.length < 32 ? this._lower.addBoolean(e) : this._upper.addBoolean(e);
  }
  decode(e, r = 0) {
    const n = this._lower.decode(e, r), i = this._upper.decode(e, r + this._lower.span);
    return { ...n, ...i };
  }
  encode(e, r, n = 0) {
    return this._lower.encode(e, r, n) + this._upper.encode(e, r, n + this._lower.span);
  }
}
wr.WideBits = Gk;
class Vte extends Hs.Layout {
  constructor(e, r, n) {
    super(r.span > 0 ? r.span + 1 : r.span, n), this.version = e, this.inner = r;
  }
  decode(e, r = 0) {
    return this.inner.decode(e, r + 1);
  }
  encode(e, r, n = 0) {
    return r.writeUInt8(this.version, n), 1 + this.inner.encode(e, r, n + 1);
  }
  getSpan(e, r = 0) {
    return 1 + this.inner.getSpan(e, r + 1);
  }
}
wr.VersionedLayout = Vte;
class M_ extends Hs.UInt {
  constructor(e, r, n) {
    super(r, n), this.values = e;
  }
  encode(e, r, n) {
    if (this.values[e] !== void 0)
      return super.encode(this.values[e], r, n);
    throw new Error("Invalid " + this.property);
  }
  decode(e, r) {
    const n = super.decode(e, r), i = Object.entries(this.values).find(([, s]) => s === n);
    if (i)
      return i[0];
    throw new Error("Invalid " + this.property);
  }
}
function Hte(t) {
  return new M_({ buy: 0, sell: 1 }, 4, t);
}
wr.sideLayout = Hte;
function Gte(t) {
  return new M_({ limit: 0, ioc: 1, postOnly: 2 }, 4, t);
}
wr.orderTypeLayout = Gte;
function Zte(t) {
  return new M_({ decrementTake: 0, cancelProvide: 1, abortTransaction: 2 }, 4, t);
}
wr.selfTradeBehaviorLayout = Zte;
const Po = new Gk();
Po.addBoolean("initialized");
Po.addBoolean("market");
Po.addBoolean("openOrders");
Po.addBoolean("requestQueue");
Po.addBoolean("eventQueue");
Po.addBoolean("bids");
Po.addBoolean("asks");
function Jte(t = "accountFlags") {
  return Po.replicate(t);
}
wr.accountFlagsLayout = Jte;
function Yte(t, e) {
  const r = t.decode;
  t.decode = function(i, s = 0) {
    return e(r.call(this, i, s));
  };
}
wr.setLayoutDecoder = Yte;
function Qte(t, e) {
  const r = t.encode;
  return t.encode = function(i, s, a) {
    return r.call(this, e(i), s, a);
  }, t;
}
wr.setLayoutEncoder = Qte;
var Zk = {};
(function(t) {
  var e = Ne && Ne.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.Slab = t.SLAB_LAYOUT = void 0;
  const r = e(Tr), n = Qe, i = wr, s = n.struct([
    // Number of modified slab nodes
    n.u32("bumpIndex"),
    i.zeros(4),
    // Linked list of unused nodes
    n.u32("freeListLen"),
    i.zeros(4),
    n.u32("freeListHead"),
    n.u32("root"),
    n.u32("leafCount"),
    i.zeros(4)
  ], "header"), a = n.union(n.u32("tag"), n.blob(68), "node");
  a.addVariant(0, n.struct([]), "uninitialized"), a.addVariant(1, n.struct([
    // Only the first prefixLen high-order bits of key are meaningful
    n.u32("prefixLen"),
    i.u128("key"),
    n.seq(n.u32(), 2, "children")
  ]), "innerNode"), a.addVariant(2, n.struct([
    n.u8("ownerSlot"),
    n.u8("feeTier"),
    n.blob(2),
    i.u128("key"),
    i.publicKeyLayout("owner"),
    i.u64("quantity"),
    i.u64("clientOrderId")
  ]), "leafNode"), a.addVariant(3, n.struct([n.u32("next")]), "freeNode"), a.addVariant(4, n.struct([]), "lastFreeNode"), t.SLAB_LAYOUT = n.struct([
    s,
    n.seq(a, n.offset(s.layoutFor("bumpIndex"), s.offsetOf("bumpIndex") - s.span), "nodes")
  ]);
  class o {
    constructor(f, u) {
      this.header = f, this.nodes = u;
    }
    static decode(f) {
      return t.SLAB_LAYOUT.decode(f);
    }
    get(f) {
      if (this.header.leafCount === 0)
        return null;
      f instanceof r.default || (f = new r.default(f));
      let u = this.header.root;
      for (; ; ) {
        const { leafNode: d, innerNode: l } = this.nodes[u];
        if (d)
          return d.key.eq(f) ? d : null;
        if (l) {
          if (!l.key.xor(f).iushrn(128 - l.prefixLen).isZero())
            return null;
          u = l.children[f.testn(128 - l.prefixLen - 1) ? 1 : 0];
        } else
          throw new Error("Invalid slab");
      }
    }
    [Symbol.iterator]() {
      return this.items(!1);
    }
    *items(f = !1) {
      if (this.header.leafCount === 0)
        return;
      const u = [this.header.root];
      for (; u.length > 0; ) {
        const d = u.pop(), { leafNode: l, innerNode: h } = this.nodes[d];
        l ? yield l : h && (f ? u.push(h.children[0], h.children[1]) : u.push(h.children[1], h.children[0]));
      }
    }
  }
  t.Slab = o, i.setLayoutDecoder(t.SLAB_LAYOUT, ({ header: c, nodes: f }) => new o(c, f));
})(Zk);
var C_ = {}, zl = {};
(function(t) {
  var e = Ne && Ne.__createBinding || (Object.create ? function(I, L, P, C) {
    C === void 0 && (C = P), Object.defineProperty(I, C, { enumerable: !0, get: function() {
      return L[P];
    } });
  } : function(I, L, P, C) {
    C === void 0 && (C = P), I[C] = L[P];
  }), r = Ne && Ne.__setModuleDefault || (Object.create ? function(I, L) {
    Object.defineProperty(I, "default", { enumerable: !0, value: L });
  } : function(I, L) {
    I.default = L;
  }), n = Ne && Ne.__importStar || function(I) {
    if (I && I.__esModule)
      return I;
    var L = {};
    if (I != null)
      for (var P in I)
        P !== "default" && Object.prototype.hasOwnProperty.call(I, P) && e(L, I, P);
    return r(L, I), L;
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.closeAccount = t.mintTo = t.setAuthority = t.revoke = t.approve = t.transfer = t.initializeAccount = t.initializeMint = t.decodeTokenInstructionData = t.SRM_DECIMALS = t.SRM_MINT = t.MSRM_DECIMALS = t.MSRM_MINT = t.WRAPPED_SOL_MINT = t.TOKEN_PROGRAM_ID = t.CLOSE_ACCOUNT_OWNER_INDEX = t.CLOSE_ACCOUNT_DESTINATION_INDEX = t.CLOSE_ACCOUNT_SOURCE_INDEX = t.TRANSFER_OWNER_INDEX = t.TRANSFER_DESTINATION_INDEX = t.TRANSFER_SOURCE_INDEX = t.INITIALIZE_ACCOUNT_OWNER_INDEX = t.INITIALIZE_ACCOUNT_MINT_INDEX = t.INITIALIZE_ACCOUNT_ACCOUNT_INDEX = void 0;
  const i = n(Qe), s = Of, a = wr;
  t.INITIALIZE_ACCOUNT_ACCOUNT_INDEX = 0, t.INITIALIZE_ACCOUNT_MINT_INDEX = 1, t.INITIALIZE_ACCOUNT_OWNER_INDEX = 2, t.TRANSFER_SOURCE_INDEX = 0, t.TRANSFER_DESTINATION_INDEX = 1, t.TRANSFER_OWNER_INDEX = 2, t.CLOSE_ACCOUNT_SOURCE_INDEX = 0, t.CLOSE_ACCOUNT_DESTINATION_INDEX = 1, t.CLOSE_ACCOUNT_OWNER_INDEX = 2, t.TOKEN_PROGRAM_ID = new s.PublicKey("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), t.WRAPPED_SOL_MINT = new s.PublicKey("So11111111111111111111111111111111111111112"), t.MSRM_MINT = new s.PublicKey("MSRMcoVyrFxnSgo5uXwone5SKcGhT1KEJMFEkMEWf9L"), t.MSRM_DECIMALS = 0, t.SRM_MINT = new s.PublicKey("SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt"), t.SRM_DECIMALS = 6;
  const o = i.union(i.u8("instruction"));
  o.addVariant(0, i.struct([
    i.u8("decimals"),
    a.publicKeyLayout("mintAuthority"),
    i.u8("freezeAuthorityOption"),
    a.publicKeyLayout("freezeAuthority")
  ]), "initializeMint"), o.addVariant(1, i.struct([]), "initializeAccount"), o.addVariant(3, i.struct([i.nu64("amount")]), "transfer"), o.addVariant(4, i.struct([i.nu64("amount")]), "approve"), o.addVariant(5, i.struct([]), "revoke"), o.addVariant(6, i.struct([
    i.u8("authorityType"),
    i.u8("newAuthorityOption"),
    a.publicKeyLayout("newAuthority")
  ]), "setAuthority"), o.addVariant(7, i.struct([i.nu64("amount")]), "mintTo"), o.addVariant(8, i.struct([i.nu64("amount")]), "burn"), o.addVariant(9, i.struct([]), "closeAccount");
  const c = Math.max(...Object.values(o.registry).map((I) => I.span));
  function f(I) {
    const L = ve.alloc(c), P = o.encode(I, L);
    return L.slice(0, P);
  }
  function u(I) {
    return o.decode(I);
  }
  t.decodeTokenInstructionData = u;
  function d({ mint: I, decimals: L, mintAuthority: P, freezeAuthority: C = null }) {
    const D = [
      { pubkey: I, isSigner: !1, isWritable: !0 },
      { pubkey: s.SYSVAR_RENT_PUBKEY, isSigner: !1, isWritable: !1 }
    ];
    return new s.TransactionInstruction({
      keys: D,
      data: f({
        initializeMint: {
          decimals: L,
          mintAuthority: P,
          freezeAuthorityOption: !!C,
          freezeAuthority: C || new s.PublicKey(0)
        }
      }),
      programId: t.TOKEN_PROGRAM_ID
    });
  }
  t.initializeMint = d;
  function l({ account: I, mint: L, owner: P }) {
    const C = [
      { pubkey: I, isSigner: !1, isWritable: !0 },
      { pubkey: L, isSigner: !1, isWritable: !1 },
      { pubkey: P, isSigner: !1, isWritable: !1 },
      { pubkey: s.SYSVAR_RENT_PUBKEY, isSigner: !1, isWritable: !1 }
    ];
    return new s.TransactionInstruction({
      keys: C,
      data: f({
        initializeAccount: {}
      }),
      programId: t.TOKEN_PROGRAM_ID
    });
  }
  t.initializeAccount = l;
  function h({ source: I, destination: L, amount: P, owner: C }) {
    const D = [
      { pubkey: I, isSigner: !1, isWritable: !0 },
      { pubkey: L, isSigner: !1, isWritable: !0 },
      { pubkey: C, isSigner: !0, isWritable: !1 }
    ];
    return new s.TransactionInstruction({
      keys: D,
      data: f({
        transfer: { amount: P }
      }),
      programId: t.TOKEN_PROGRAM_ID
    });
  }
  t.transfer = h;
  function y({ source: I, delegate: L, amount: P, owner: C }) {
    const D = [
      { pubkey: I, isSigner: !1, isWritable: !0 },
      { pubkey: L, isSigner: !1, isWritable: !1 },
      { pubkey: C, isSigner: !0, isWritable: !1 }
    ];
    return new s.TransactionInstruction({
      keys: D,
      data: f({
        approve: { amount: P }
      }),
      programId: t.TOKEN_PROGRAM_ID
    });
  }
  t.approve = y;
  function p({ source: I, owner: L }) {
    const P = [
      { pubkey: I, isSigner: !1, isWritable: !0 },
      { pubkey: L, isSigner: !0, isWritable: !1 }
    ];
    return new s.TransactionInstruction({
      keys: P,
      data: f({
        revoke: {}
      }),
      programId: t.TOKEN_PROGRAM_ID
    });
  }
  t.revoke = p;
  function b({ target: I, currentAuthority: L, newAuthority: P, authorityType: C }) {
    const D = [
      { pubkey: I, isSigner: !1, isWritable: !0 },
      { pubkey: L, isSigner: !0, isWritable: !1 }
    ];
    return new s.TransactionInstruction({
      keys: D,
      data: f({
        setAuthority: {
          authorityType: C,
          newAuthorityOption: !!P,
          newAuthority: P
        }
      }),
      programId: t.TOKEN_PROGRAM_ID
    });
  }
  t.setAuthority = b;
  function v({ mint: I, destination: L, amount: P, mintAuthority: C }) {
    const D = [
      { pubkey: I, isSigner: !1, isWritable: !0 },
      { pubkey: L, isSigner: !1, isWritable: !0 },
      { pubkey: C, isSigner: !0, isWritable: !1 }
    ];
    return new s.TransactionInstruction({
      keys: D,
      data: f({
        mintTo: { amount: P }
      }),
      programId: t.TOKEN_PROGRAM_ID
    });
  }
  t.mintTo = v;
  function x({ source: I, destination: L, owner: P }) {
    const C = [
      { pubkey: I, isSigner: !1, isWritable: !0 },
      { pubkey: L, isSigner: !1, isWritable: !0 },
      { pubkey: P, isSigner: !0, isWritable: !1 }
    ];
    return new s.TransactionInstruction({
      keys: C,
      data: f({
        closeAccount: {}
      }),
      programId: t.TOKEN_PROGRAM_ID
    });
  }
  t.closeAccount = x;
})(zl);
(function(t) {
  var e = Ne && Ne.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.DexInstructions = t.decodeInstructionV2 = t.decodeInstruction = t.encodeInstructionV2 = t.encodeInstruction = t.INSTRUCTION_LAYOUT_V2 = t.INSTRUCTION_LAYOUT = t.NEW_ORDER_V3_OWNER_INDEX = t.NEW_ORDER_V3_OPEN_ORDERS_INDEX = t.NEW_ORDER_OWNER_INDEX = t.NEW_ORDER_OPEN_ORDERS_INDEX = t.SETTLE_FUNDS_QUOTE_WALLET_INDEX = t.SETTLE_FUNDS_BASE_WALLET_INDEX = void 0;
  const r = Qe, n = wr, i = Of, s = zl, a = e(Tr);
  t.SETTLE_FUNDS_BASE_WALLET_INDEX = 5, t.SETTLE_FUNDS_QUOTE_WALLET_INDEX = 6, t.NEW_ORDER_OPEN_ORDERS_INDEX = 1, t.NEW_ORDER_OWNER_INDEX = 4, t.NEW_ORDER_V3_OPEN_ORDERS_INDEX = 1, t.NEW_ORDER_V3_OWNER_INDEX = 7, t.INSTRUCTION_LAYOUT = new n.VersionedLayout(0, r.union(r.u32("instruction"))), t.INSTRUCTION_LAYOUT.inner.addVariant(0, r.struct([
    n.u64("baseLotSize"),
    n.u64("quoteLotSize"),
    r.u16("feeRateBps"),
    n.u64("vaultSignerNonce"),
    n.u64("quoteDustThreshold")
  ]), "initializeMarket"), t.INSTRUCTION_LAYOUT.inner.addVariant(1, r.struct([
    n.sideLayout("side"),
    n.u64("limitPrice"),
    n.u64("maxQuantity"),
    n.orderTypeLayout("orderType"),
    n.u64("clientId")
  ]), "newOrder"), t.INSTRUCTION_LAYOUT.inner.addVariant(2, r.struct([r.u16("limit")]), "matchOrders"), t.INSTRUCTION_LAYOUT.inner.addVariant(3, r.struct([r.u16("limit")]), "consumeEvents"), t.INSTRUCTION_LAYOUT.inner.addVariant(4, r.struct([
    n.sideLayout("side"),
    n.u128("orderId"),
    n.publicKeyLayout("openOrders"),
    r.u8("openOrdersSlot")
  ]), "cancelOrder"), t.INSTRUCTION_LAYOUT.inner.addVariant(5, r.struct([]), "settleFunds"), t.INSTRUCTION_LAYOUT.inner.addVariant(6, r.struct([n.u64("clientId")]), "cancelOrderByClientId"), t.INSTRUCTION_LAYOUT.inner.addVariant(10, r.struct([
    n.sideLayout("side"),
    n.u64("limitPrice"),
    n.u64("maxBaseQuantity"),
    n.u64("maxQuoteQuantity"),
    n.selfTradeBehaviorLayout("selfTradeBehavior"),
    n.orderTypeLayout("orderType"),
    n.u64("clientId"),
    r.u16("limit")
  ]), "newOrderV3"), t.INSTRUCTION_LAYOUT.inner.addVariant(11, r.struct([n.sideLayout("side"), n.u128("orderId")]), "cancelOrderV2"), t.INSTRUCTION_LAYOUT.inner.addVariant(12, r.struct([n.u64("clientId")]), "cancelOrderByClientIdV2"), t.INSTRUCTION_LAYOUT.inner.addVariant(14, r.struct([]), "closeOpenOrders"), t.INSTRUCTION_LAYOUT.inner.addVariant(15, r.struct([]), "initOpenOrders"), t.INSTRUCTION_LAYOUT.inner.addVariant(16, r.struct([r.u16("limit")]), "prune"), t.INSTRUCTION_LAYOUT.inner.addVariant(17, r.struct([r.u16("limit")]), "consumeEventsPermissioned"), t.INSTRUCTION_LAYOUT.inner.addVariant(18, r.struct([
    n.u64("clientId0"),
    n.u64("clientId1"),
    n.u64("clientId2"),
    n.u64("clientId3"),
    n.u64("clientId4"),
    n.u64("clientId5"),
    n.u64("clientId6"),
    n.u64("clientId7")
  ]), "cancelOrdersByClientIds"), t.INSTRUCTION_LAYOUT_V2 = new n.VersionedLayout(0, r.union(r.u32("instruction"))), t.INSTRUCTION_LAYOUT_V2.inner.addVariant(10, r.struct([
    n.sideLayout("side"),
    n.u64("limitPrice"),
    n.u64("maxBaseQuantity"),
    n.u64("maxQuoteQuantity"),
    n.selfTradeBehaviorLayout("selfTradeBehavior"),
    n.orderTypeLayout("orderType"),
    n.u64("clientId"),
    r.u16("limit"),
    n.i64("maxTs")
  ]), "newOrderV3");
  function o(l) {
    const h = ve.alloc(100);
    return h.slice(0, t.INSTRUCTION_LAYOUT.encode(l, h));
  }
  t.encodeInstruction = o;
  function c(l) {
    const h = ve.alloc(100);
    return h.slice(0, t.INSTRUCTION_LAYOUT_V2.encode(l, h));
  }
  t.encodeInstructionV2 = c;
  function f(l) {
    return t.INSTRUCTION_LAYOUT.decode(l);
  }
  t.decodeInstruction = f;
  function u(l) {
    return t.INSTRUCTION_LAYOUT_V2.decode(l);
  }
  t.decodeInstructionV2 = u;
  class d {
    static initializeMarket({ market: h, requestQueue: y, eventQueue: p, bids: b, asks: v, baseVault: x, quoteVault: I, baseMint: L, quoteMint: P, baseLotSize: C, quoteLotSize: D, feeRateBps: F, vaultSignerNonce: G, quoteDustThreshold: re, programId: ie, authority: ee = void 0, pruneAuthority: $ = void 0, crankAuthority: w = void 0 }) {
      return new i.PublicKey("SysvarRent111111111111111111111111111111111"), new i.TransactionInstruction({
        keys: [
          { pubkey: h, isSigner: !1, isWritable: !0 },
          { pubkey: y, isSigner: !1, isWritable: !0 },
          { pubkey: p, isSigner: !1, isWritable: !0 },
          { pubkey: b, isSigner: !1, isWritable: !0 },
          { pubkey: v, isSigner: !1, isWritable: !0 },
          { pubkey: x, isSigner: !1, isWritable: !0 },
          { pubkey: I, isSigner: !1, isWritable: !0 },
          { pubkey: L, isSigner: !1, isWritable: !1 },
          { pubkey: P, isSigner: !1, isWritable: !1 },
          // Use a dummy address if using the new dex upgrade to save tx space.
          {
            pubkey: ee ? P : i.SYSVAR_RENT_PUBKEY,
            isSigner: !1,
            isWritable: !1
          }
        ].concat(ee ? { pubkey: ee, isSigner: !1, isWritable: !1 } : []).concat(ee && $ ? { pubkey: $, isSigner: !1, isWritable: !1 } : []).concat(ee && $ && w ? { pubkey: w, isSigner: !1, isWritable: !1 } : []),
        programId: ie,
        data: o({
          initializeMarket: {
            baseLotSize: C,
            quoteLotSize: D,
            feeRateBps: F,
            vaultSignerNonce: G,
            quoteDustThreshold: re
          }
        })
      });
    }
    static newOrder({ market: h, openOrders: y, payer: p, owner: b, requestQueue: v, baseVault: x, quoteVault: I, side: L, limitPrice: P, maxQuantity: C, orderType: D, clientId: F, programId: G, feeDiscountPubkey: re = null }) {
      const ie = [
        { pubkey: h, isSigner: !1, isWritable: !0 },
        { pubkey: y, isSigner: !1, isWritable: !0 },
        { pubkey: v, isSigner: !1, isWritable: !0 },
        { pubkey: p, isSigner: !1, isWritable: !0 },
        { pubkey: b, isSigner: !0, isWritable: !1 },
        { pubkey: x, isSigner: !1, isWritable: !0 },
        { pubkey: I, isSigner: !1, isWritable: !0 },
        { pubkey: s.TOKEN_PROGRAM_ID, isSigner: !1, isWritable: !1 },
        { pubkey: i.SYSVAR_RENT_PUBKEY, isSigner: !1, isWritable: !1 }
      ];
      return re && ie.push({
        pubkey: re,
        isSigner: !1,
        isWritable: !1
      }), new i.TransactionInstruction({
        keys: ie,
        programId: G,
        data: o({
          newOrder: F ? { side: L, limitPrice: P, maxQuantity: C, orderType: D, clientId: F } : { side: L, limitPrice: P, maxQuantity: C, orderType: D }
        })
      });
    }
    static newOrderV3({ market: h, openOrders: y, payer: p, owner: b, requestQueue: v, eventQueue: x, bids: I, asks: L, baseVault: P, quoteVault: C, side: D, limitPrice: F, maxBaseQuantity: G, maxQuoteQuantity: re, orderType: ie, clientId: ee, programId: $, selfTradeBehavior: w, feeDiscountPubkey: E = null, maxTs: U = null }) {
      const W = [
        { pubkey: h, isSigner: !1, isWritable: !0 },
        { pubkey: y, isSigner: !1, isWritable: !0 },
        { pubkey: v, isSigner: !1, isWritable: !0 },
        { pubkey: x, isSigner: !1, isWritable: !0 },
        { pubkey: I, isSigner: !1, isWritable: !0 },
        { pubkey: L, isSigner: !1, isWritable: !0 },
        { pubkey: p, isSigner: !1, isWritable: !0 },
        { pubkey: b, isSigner: !0, isWritable: !1 },
        { pubkey: P, isSigner: !1, isWritable: !0 },
        { pubkey: C, isSigner: !1, isWritable: !0 },
        { pubkey: s.TOKEN_PROGRAM_ID, isSigner: !1, isWritable: !1 },
        { pubkey: i.SYSVAR_RENT_PUBKEY, isSigner: !1, isWritable: !1 }
      ];
      E && W.push({
        pubkey: E,
        isSigner: !1,
        isWritable: !1
      });
      const _ = U ? c : o;
      return new i.TransactionInstruction({
        keys: W,
        programId: $,
        data: _({
          newOrderV3: {
            side: D,
            limitPrice: F,
            maxBaseQuantity: G,
            maxQuoteQuantity: re,
            selfTradeBehavior: w,
            orderType: ie,
            clientId: ee,
            limit: 65535,
            maxTs: new a.default(U ?? "9223372036854775807")
          }
        })
      });
    }
    static matchOrders({ market: h, requestQueue: y, eventQueue: p, bids: b, asks: v, baseVault: x, quoteVault: I, limit: L, programId: P }) {
      return new i.TransactionInstruction({
        keys: [
          { pubkey: h, isSigner: !1, isWritable: !0 },
          { pubkey: y, isSigner: !1, isWritable: !0 },
          { pubkey: p, isSigner: !1, isWritable: !0 },
          { pubkey: b, isSigner: !1, isWritable: !0 },
          { pubkey: v, isSigner: !1, isWritable: !0 },
          { pubkey: x, isSigner: !1, isWritable: !0 },
          { pubkey: I, isSigner: !1, isWritable: !0 }
        ],
        programId: P,
        data: o({ matchOrders: { limit: L } })
      });
    }
    static consumeEvents({ market: h, eventQueue: y, coinFee: p, pcFee: b, openOrdersAccounts: v, limit: x, programId: I }) {
      return new i.TransactionInstruction({
        keys: [
          ...v.map((L) => ({
            pubkey: L,
            isSigner: !1,
            isWritable: !0
          })),
          { pubkey: h, isSigner: !1, isWritable: !0 },
          { pubkey: y, isSigner: !1, isWritable: !0 },
          { pubkey: p, isSigner: !1, isWriteable: !0 },
          { pubkey: b, isSigner: !1, isWritable: !0 }
        ],
        programId: I,
        data: o({ consumeEvents: { limit: x } })
      });
    }
    static consumeEventsPermissioned({ market: h, eventQueue: y, crankAuthority: p, openOrdersAccounts: b, limit: v, programId: x }) {
      return new i.TransactionInstruction({
        keys: [
          ...b.map((I) => ({
            pubkey: I,
            isSigner: !1,
            isWritable: !0
          })),
          { pubkey: h, isSigner: !1, isWritable: !0 },
          { pubkey: y, isSigner: !1, isWritable: !0 },
          { pubkey: p, isSigner: !0, isWritable: !1 }
        ],
        programId: x,
        data: o({ consumeEventsPermissioned: { limit: v } })
      });
    }
    static cancelOrder({ market: h, openOrders: y, owner: p, requestQueue: b, side: v, orderId: x, openOrdersSlot: I, programId: L }) {
      return new i.TransactionInstruction({
        keys: [
          { pubkey: h, isSigner: !1, isWritable: !1 },
          { pubkey: y, isSigner: !1, isWritable: !0 },
          { pubkey: b, isSigner: !1, isWritable: !0 },
          { pubkey: p, isSigner: !0, isWritable: !1 }
        ],
        programId: L,
        data: o({
          cancelOrder: { side: v, orderId: x, openOrders: y, openOrdersSlot: I }
        })
      });
    }
    static cancelOrderV2(h) {
      const { market: y, bids: p, asks: b, eventQueue: v, openOrders: x, owner: I, side: L, orderId: P, programId: C } = h;
      return new i.TransactionInstruction({
        keys: [
          { pubkey: y, isSigner: !1, isWritable: !1 },
          { pubkey: p, isSigner: !1, isWritable: !0 },
          { pubkey: b, isSigner: !1, isWritable: !0 },
          { pubkey: x, isSigner: !1, isWritable: !0 },
          { pubkey: I, isSigner: !0, isWritable: !1 },
          { pubkey: v, isSigner: !1, isWritable: !0 }
        ],
        programId: C,
        data: o({
          cancelOrderV2: { side: L, orderId: P }
        })
      });
    }
    static cancelOrderByClientId({ market: h, openOrders: y, owner: p, requestQueue: b, clientId: v, programId: x }) {
      return new i.TransactionInstruction({
        keys: [
          { pubkey: h, isSigner: !1, isWritable: !1 },
          { pubkey: y, isSigner: !1, isWritable: !0 },
          { pubkey: b, isSigner: !1, isWritable: !0 },
          { pubkey: p, isSigner: !0, isWritable: !1 }
        ],
        programId: x,
        data: o({
          cancelOrderByClientId: { clientId: v }
        })
      });
    }
    static cancelOrderByClientIdV2({ market: h, openOrders: y, owner: p, bids: b, asks: v, eventQueue: x, clientId: I, programId: L }) {
      return new i.TransactionInstruction({
        keys: [
          { pubkey: h, isSigner: !1, isWritable: !1 },
          { pubkey: b, isSigner: !1, isWritable: !0 },
          { pubkey: v, isSigner: !1, isWritable: !0 },
          { pubkey: y, isSigner: !1, isWritable: !0 },
          { pubkey: p, isSigner: !0, isWritable: !1 },
          { pubkey: x, isSigner: !1, isWritable: !0 }
        ],
        programId: L,
        data: o({
          cancelOrderByClientIdV2: { clientId: I }
        })
      });
    }
    static cancelOrdersByClientIds({ market: h, openOrders: y, owner: p, bids: b, asks: v, eventQueue: x, clientIds: I, programId: L }) {
      if (I.length > 8)
        throw new Error("Number of client ids cannot exceed 8!");
      for (; I.length < 8; )
        I.push(new a.default(0));
      return new i.TransactionInstruction({
        keys: [
          { pubkey: h, isSigner: !1, isWritable: !1 },
          { pubkey: b, isSigner: !1, isWritable: !0 },
          { pubkey: v, isSigner: !1, isWritable: !0 },
          { pubkey: y, isSigner: !1, isWritable: !0 },
          { pubkey: p, isSigner: !0, isWritable: !1 },
          { pubkey: x, isSigner: !1, isWritable: !0 }
        ],
        programId: L,
        data: o({
          cancelOrdersByClientIds: Object.fromEntries(I.map((P, C) => [`clientId${C}`, P]))
        })
      });
    }
    static settleFunds({ market: h, openOrders: y, owner: p, baseVault: b, quoteVault: v, baseWallet: x, quoteWallet: I, vaultSigner: L, programId: P, referrerQuoteWallet: C = null }) {
      const D = [
        { pubkey: h, isSigner: !1, isWritable: !0 },
        { pubkey: y, isSigner: !1, isWritable: !0 },
        { pubkey: p, isSigner: !0, isWritable: !1 },
        { pubkey: b, isSigner: !1, isWritable: !0 },
        { pubkey: v, isSigner: !1, isWritable: !0 },
        { pubkey: x, isSigner: !1, isWritable: !0 },
        { pubkey: I, isSigner: !1, isWritable: !0 },
        { pubkey: L, isSigner: !1, isWritable: !1 },
        { pubkey: s.TOKEN_PROGRAM_ID, isSigner: !1, isWritable: !1 }
      ];
      return C && D.push({
        pubkey: C,
        isSigner: !1,
        isWritable: !0
      }), new i.TransactionInstruction({
        keys: D,
        programId: P,
        data: o({
          settleFunds: {}
        })
      });
    }
    static closeOpenOrders({ market: h, openOrders: y, owner: p, solWallet: b, programId: v }) {
      const x = [
        { pubkey: y, isSigner: !1, isWritable: !0 },
        { pubkey: p, isSigner: !0, isWritable: !1 },
        { pubkey: b, isSigner: !1, isWritable: !0 },
        { pubkey: h, isSigner: !1, isWritable: !1 }
      ];
      return new i.TransactionInstruction({
        keys: x,
        programId: v,
        data: o({
          closeOpenOrders: {}
        })
      });
    }
    static initOpenOrders({ market: h, openOrders: y, owner: p, programId: b, marketAuthority: v }) {
      const x = [
        { pubkey: y, isSigner: !1, isWritable: !0 },
        { pubkey: p, isSigner: !0, isWritable: !1 },
        { pubkey: h, isSigner: !1, isWritable: !1 },
        { pubkey: i.SYSVAR_RENT_PUBKEY, isSigner: !1, isWritable: !1 }
      ].concat(v ? { pubkey: v, isSigner: !1, isWritable: !1 } : []);
      return new i.TransactionInstruction({
        keys: x,
        programId: b,
        data: o({
          initOpenOrders: {}
        })
      });
    }
    static prune({ market: h, bids: y, asks: p, eventQueue: b, pruneAuthority: v, openOrders: x, openOrdersOwner: I, programId: L, limit: P }) {
      const C = [
        { pubkey: h, isSigner: !1, isWritable: !0 },
        { pubkey: y, isSigner: !1, isWritable: !0 },
        { pubkey: p, isSigner: !1, isWritable: !0 },
        // Keep signer false so that one can use a PDA.
        { pubkey: v, isSigner: !1, isWritable: !1 },
        { pubkey: x, isSigner: !1, isWritable: !0 },
        { pubkey: I, isSigner: !1, isWritable: !1 },
        { pubkey: b, isSigner: !1, isWritable: !0 }
      ];
      return new i.TransactionInstruction({
        keys: C,
        programId: L,
        data: o({
          prune: { limit: P }
        })
      });
    }
  }
  t.DexInstructions = d;
})(C_);
var Li = {};
Object.defineProperty(Li, "__esModule", { value: !0 });
Li.EVENT_QUEUE_LAYOUT = Li.REQUEST_QUEUE_LAYOUT = Li.decodeEventQueue = Li.decodeRequestQueue = Li.decodeEventsSince = void 0;
const dn = Qe, In = wr, Jk = dn.struct([
  dn.blob(5),
  In.accountFlagsLayout("accountFlags"),
  dn.u32("head"),
  In.zeros(4),
  dn.u32("count"),
  In.zeros(4),
  dn.u32("nextSeqNum"),
  In.zeros(4)
]), Bf = dn.bits(dn.u8(), !1, "requestFlags");
Bf.addBoolean("newOrder");
Bf.addBoolean("cancelOrder");
Bf.addBoolean("bid");
Bf.addBoolean("postOnly");
Bf.addBoolean("ioc");
const Yk = dn.struct([
  Bf,
  dn.u8("openOrdersSlot"),
  dn.u8("feeTier"),
  dn.blob(5),
  In.u64("maxBaseSizeOrCancelId"),
  In.u64("nativeQuoteQuantityLocked"),
  In.u128("orderId"),
  In.publicKeyLayout("openOrders"),
  In.u64("clientOrderId")
]), ld = dn.struct([
  dn.blob(5),
  In.accountFlagsLayout("accountFlags"),
  dn.u32("head"),
  In.zeros(4),
  dn.u32("count"),
  In.zeros(4),
  dn.u32("seqNum"),
  In.zeros(4)
]), Kl = dn.bits(dn.u8(), !1, "eventFlags");
Kl.addBoolean("fill");
Kl.addBoolean("out");
Kl.addBoolean("bid");
Kl.addBoolean("maker");
const jp = dn.struct([
  Kl,
  dn.u8("openOrdersSlot"),
  dn.u8("feeTier"),
  dn.blob(5),
  In.u64("nativeQuantityReleased"),
  In.u64("nativeQuantityPaid"),
  In.u64("nativeFeeOrRebate"),
  In.u128("orderId"),
  In.publicKeyLayout("openOrders"),
  In.u64("clientOrderId")
]);
function e2(t, e, r, n) {
  return e.decode(r, t.span + n * e.span);
}
function Qk(t, e, r, n) {
  const i = t.decode(r), s = Math.floor((r.length - t.span) / e.span), a = [];
  if (n)
    for (let o = 0; o < Math.min(n, s); ++o) {
      const c = (i.head + i.count + s - 1 - o) % s;
      a.push(e2(t, e, r, c));
    }
  else
    for (let o = 0; o < i.count; ++o) {
      const c = (i.head + o) % s;
      a.push(e2(t, e, r, c));
    }
  return { header: i, nodes: a };
}
function Xte(t, e) {
  const r = ld.decode(t), n = Math.floor((t.length - ld.span) / jp.span), i = 4294967296;
  let s = (r.seqNum - e + i) % i;
  s > n && (s = n - 1);
  const a = (r.seqNum - s + i) % i, c = ((r.head + r.count) % n - s + n) % n, f = [];
  for (let u = 0; u < s; ++u) {
    const d = (c + u) % n, l = e2(ld, jp, t, d);
    l.seqNum = (a + u) % i, f.push(l);
  }
  return f;
}
Li.decodeEventsSince = Xte;
function ere(t, e) {
  const { header: r, nodes: n } = Qk(Jk, Yk, t, e);
  if (!r.accountFlags.initialized || !r.accountFlags.requestQueue)
    throw new Error("Invalid requests queue");
  return n;
}
Li.decodeRequestQueue = ere;
function tre(t, e) {
  const { header: r, nodes: n } = Qk(ld, jp, t, e);
  if (!r.accountFlags.initialized || !r.accountFlags.eventQueue)
    throw new Error("Invalid events queue");
  return n;
}
Li.decodeEventQueue = tre;
Li.REQUEST_QUEUE_LAYOUT = {
  HEADER: Jk,
  NODE: Yk
};
Li.EVENT_QUEUE_LAYOUT = {
  HEADER: ld,
  NODE: jp
};
var Ma = {}, Vl = {};
const rre = [
  {
    address: "B37pZmwrwXHjpgvd9hHDAx1yeDsNevTnbbrN9W12BoGK",
    deprecated: !0,
    name: "soALEPH/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "CAgAeMD7quTdnr6RPa7JySQpjf3irAmefYNdTb6anemq",
    deprecated: !0,
    name: "BTC/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "ASKiV944nKg1W9vsf7hf3fTsjawK6DwLwrnB2LH9n61c",
    deprecated: !0,
    name: "soETH/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "Cdp72gDcYMCLLk3aDkPxjeiirKoFqK38ECm8Ywvk94Wi",
    deprecated: !0,
    name: "SOL/soUSDC",
    programId: "BJ3jrUzddfuSrZHXSCxMUUQsjKEyLmuuyZebkcaFp2fg"
  },
  {
    address: "68J6nkWToik6oM9rTatKSR5ibVSykAtzftBUEAvpRsys",
    deprecated: !0,
    name: "SRM/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "8Jzed8Fafu1RU1CQDWdiETSrqAJy1ukZ5JL6Pma3p3a2",
    deprecated: !0,
    name: "SRM/SOL",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "9wDmxsfwaDb2ysmZpBLzxKzoWrF1zHzBN7PV5EmJe19R",
    deprecated: !0,
    name: "soSUSHI/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "GbQSffne1NcJbS4jsewZEpRGYVR4RNnuVUN8Ht6vAGb6",
    deprecated: !0,
    name: "soSXP/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "7kgkDyW7dmyMeP8KFXzbcUZz1R2WHsovDZ7n3ihZuNDS",
    deprecated: !0,
    name: "MSRM/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "FZqrBXz7ADGsmDf1TM9YgysPUfvtG8rJiNUrqDpHc9Au",
    deprecated: !0,
    name: "soFTT/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "FJg9FUtbN3fg3YFbMCFiZKjGh5Bn4gtzxZmtxFzmz9kT",
    deprecated: !0,
    name: "soYFI/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "7GZ59DMgJ7D6dfoJTpszPayTRyua9jwcaGJXaRMMF1my",
    deprecated: !0,
    name: "soLINK/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "uPNcBgFhrLW3FtvyYYbBUi53BBEQf9e4NPgwxaLu5Hn",
    deprecated: !0,
    name: "soHGET/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "3puWJFZyCso14EdxhywjD7xqyTarpsULx483mzvqxQRW",
    deprecated: !0,
    name: "soCREAM/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "8Ae7Uhigx8k4fKdJG7irdPCVDZLvWsJfeTH2t5fr3TVD",
    deprecated: !0,
    name: "soUBXT/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "Hze5AUX4Qp1cTujiJ4CsAMRGn4g6ZpgXsmptFn3xxhWg",
    deprecated: !0,
    name: "soHNT/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "FJq4HX3bUSgF3yQZ8ADALtJYfAyr9fz36SNG18hc3dgF",
    deprecated: !0,
    name: "soFRONT/soUSDC",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "BZMuoQ2i2noNUXMdrRDivc7MwjGspNJTCfZkdHMwK18T",
    deprecated: !0,
    name: "soALEPH/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "5LgJphS6D5zXwUVPU7eCryDBkyta3AidrJ5vjNU6BcGW",
    deprecated: !0,
    name: "BTC/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "DmEDKZPXXkWgaYiKgWws2ZXWWKCh41eryDPRVD4zKnD9",
    deprecated: !0,
    name: "soETH/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "EBFTQNg2QjyxV7WDDenoLbfLLXLcbSz6w1YrdTCGPWT5",
    deprecated: !0,
    name: "SOL/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "8YmQZRXGizZXYPCDmxgjwB8X8XN4PZG7MMwNg76iAmPZ",
    deprecated: !0,
    name: "SRM/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "9vFuX2BizwinWjkZLQTmThDcNMFEcY3wVXYuqnRQtcD",
    deprecated: !0,
    name: "soSUSHI/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "C5NReXAeQhfjiDCGPFj1UUmDxDqF8v2CUVKoYuQqb4eW",
    deprecated: !0,
    name: "soSXP/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "58H7ZRmiyWtsrz2sQGz1qQCMW6n7447xhNNehUSQGPj5",
    deprecated: !0,
    name: "MSRM/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "ES8skmkEeyH1BYFThd2FtyaFKhkqtwH7XWp8mXptv3vg",
    deprecated: !0,
    name: "soFTT/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "Gw78CYLLFbgmmn4rps9KoPAnNtBQ2S1foL2Mn6Z5ZHYB",
    deprecated: !0,
    name: "soYFI/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "WjfsTPyrvUUrhGJ9hVQFubMnKDcnQS8VxSXU7L2gLcA",
    deprecated: !0,
    name: "soLINK/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "2ZmB255T4FVUugpeXTFxD6Yz5GE47yTByYvqSTDUbk3G",
    deprecated: !0,
    name: "soHGET/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "FGJtCDXoHLHjagP5Ht6xcUFt2rW3z8MJPe87rFKP2ZW6",
    deprecated: !0,
    name: "soCREAM/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "7K6MPog6LskZmyaYwqtLvRUuedoiE68nirbQ9tK3LasE",
    deprecated: !0,
    name: "soUBXT/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "9RyozJe3bkAFfH3jmoiKHjkWCoLTxn7aBQSi6YfaV6ab",
    deprecated: !0,
    name: "soHNT/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "AGtBbGuJZiv3Ko3dfT4v6g4kCqnNc9DXfoGLe5HpjmWx",
    deprecated: !0,
    name: "soFRONT/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "AA1HSrsMcRNzjaQfRMTNarHR9B7e4U79LJ2319UtiqPF",
    deprecated: !0,
    name: "soAKRO/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "AUAobJdffexcoJBMeyLorpShu3ZtG9VvPEPjoeTN4u5Z",
    deprecated: !0,
    name: "soHXRO/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "GpdYLFbKHeSeDGqsnQ4jnP7D1294iBpQcsN1VPwhoaFS",
    deprecated: !0,
    name: "soUNI/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "sxS9EdTx1UPe4j2c6Au9f1GKZXrFj5pTgNKgjGGtGdY",
    deprecated: !0,
    name: "soKEEP/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "CfnnU38ACScF6pcurxSB3FLXeZmfFYunVKExeUyosu5P",
    deprecated: !0,
    name: "soMATH/soUSDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "7NR5GDouQYkkfppVkNhpa4HfJ2LwqUQymE3b4CYQiYHa",
    deprecated: !0,
    name: "soALEPH/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "CVfYa8RGXnuDBeGmniCcdkBwoLqVxh92xB1JqgRQx3F",
    deprecated: !0,
    name: "BTC/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "H5uzEytiByuXt964KampmuNCurNDwkVVypkym75J2DQW",
    deprecated: !0,
    name: "soETH/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "7xMDbYTCqQEcK2aM9LbetGtNFJpzKdfXzLL5juaLh4GJ",
    deprecated: !0,
    name: "SOL/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "CDdR97S8y96v3To93aKvi3nCnjUrbuVSuumw8FLvbVeg",
    deprecated: !0,
    name: "SRM/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "7LVJtqSrF6RudMaz5rKGTmR3F3V5TKoDcN6bnk68biYZ",
    deprecated: !0,
    name: "soSUSHI/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "13vjJ8pxDMmzen26bQ5UrouX8dkXYPW1p3VLVDjxXrKR",
    deprecated: !0,
    name: "soSXP/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "AwvPwwSprfDZ86beBJDNH5vocFvuw4ZbVQ6upJDbSCXZ",
    deprecated: !0,
    name: "MSRM/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "FfDb3QZUdMW2R2aqJQgzeieys4ETb3rPrFFfPSemzq7R",
    deprecated: !0,
    name: "soFTT/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "4QL5AQvXdMSCVZmnKXiuMMU83Kq3LCwVfU8CyznqZELG",
    deprecated: !0,
    name: "soYFI/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "7JCG9TsCx3AErSV3pvhxiW4AbkKRcJ6ZAveRmJwrgQ16",
    deprecated: !0,
    name: "soLINK/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "3otQFkeQ7GNUKT3i2p3aGTQKS2SAw6NLYPE5qxh3PoqZ",
    deprecated: !0,
    name: "soHGET/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "2M8EBxFbLANnCoHydypL1jupnRHG782RofnvkatuKyLL",
    deprecated: !0,
    name: "soCREAM/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "3UqXdFtNBZsFrFtRGAWGvy9R8H6GJR2hAyGRdYT9BgG3",
    deprecated: !0,
    name: "soUBXT/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "9jiasgdYGGh34fAbBQSwkKe1dYSapXbjy2sLsYpetqFp",
    deprecated: !0,
    name: "soHNT/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "7oKqJhnz9b8af8Mw47dieTiuxeaHnRYYGBiqCrRpzTRD",
    deprecated: !0,
    name: "soFRONT/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "F1rxD8Ns5w4WzVcTRdaJ96LG7YKaA5a25BBmM32yFP4b",
    deprecated: !0,
    name: "soAKRO/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "6ToedDwjRCvrcKX7fnHSTA9uABQe1dcLK6YgS5B9M3wo",
    deprecated: !0,
    name: "soHXRO/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "FURvCsDUiuUaxZ13pZqQbbfktFGWmQVTHz7tL992LQVZ",
    deprecated: !0,
    name: "soUNI/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "EcfDRMrEJ3yW4SgrRyyxTPoKqAZDNSBV8EerigT7BNSS",
    deprecated: !0,
    name: "soKEEP/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "2bPsJ6bZ9KDLfJ8QgSN1Eb4mRsbAiaGyHN6cJkoVLpwd",
    deprecated: !0,
    name: "soMATH/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "B1GypajMh7S8zJVp6M1xMfu6zGsMgvYrt3cSn9wG7Dd6",
    deprecated: !0,
    name: "soTOMO/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "rPTGvVrNFYzBeTEcYnHiaWGNnkSXsWNNjUgk771LkwJ",
    deprecated: !0,
    name: "soLUA/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "FrDavxi4QawYnQY259PVfYUjUvuyPNfqSXbLBqMnbfWJ",
    deprecated: !0,
    name: "FIDA/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "CVn1nJ5Utuseyy2qqwrpYoJz9Y7jjYonVL4UYvcCepDH",
    deprecated: !0,
    name: "KIN/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "BqjGW7ousAizgs8VrHo5SR1LxTksAQPtb8cKZZiNvX5D",
    deprecated: !0,
    name: "MAPS/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "GcoKtAmTy5QyuijXSmJKBtFdt99e6Buza18Js7j9AJ6e",
    deprecated: !1,
    name: "soALEPH/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "A8YFbxQYFVqKZaoYJLLUVcQiWP7G2MeEgW5wsAQgMvFw",
    deprecated: !1,
    name: "BTC/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "4tSvZvnbyzHXLMTiFonMyxZoHmFqau1XArcRCVHLZ5gX",
    deprecated: !1,
    name: "soETH/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "ByRys5tuUWDgL73G8JBAEfkdFf8JWBzPBDHsBVQ5vbQA",
    deprecated: !1,
    name: "SRM/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "A1Q9iJDVVS8Wsswr9ajeZugmj64bQVCYLZQLra2TMBMo",
    deprecated: !1,
    name: "soSUSHI/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "4LUro5jaPaTurXK737QAxgJywdhABnFAMQkXX4ZyqqaZ",
    deprecated: !1,
    name: "soSXP/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "4VKLSYdvrQ5ngQrt1d2VS8o4ewvb2MMUZLiejbnGPV33",
    deprecated: !1,
    name: "MSRM/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "2Pbh1CvRVku1TgewMfycemghf6sU9EyuFDcNXqvRmSxc",
    deprecated: !1,
    name: "soFTT/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "7qcCo8jqepnjjvB5swP4Afsr3keVBs6gNpBTNubd1Kr2",
    deprecated: !1,
    name: "soYFI/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "3hwH1txjJVS8qv588tWrjHfRxdqNjBykM1kMcit484up",
    deprecated: !1,
    name: "soLINK/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "88vztw7RTN6yJQchVvxrs6oXUDryvpv9iJaFa1EEmg87",
    deprecated: !1,
    name: "soHGET/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "7nZP6feE94eAz9jmfakNJWPwEKaeezuKKC5D1vrnqyo2",
    deprecated: !1,
    name: "soCREAM/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "2wr3Ab29KNwGhtzr5HaPCyfU1qGJzTUAN4amCLZWaD1H",
    deprecated: !1,
    name: "soUBXT/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "CnUV42ZykoKUnMDdyefv5kP6nDSJf7jFd7WXAecC6LYr",
    deprecated: !1,
    name: "soHNT/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "9Zx1CvxSVdroKMMWf2z8RwrnrLiQZ9VkQ7Ex3syQqdSH",
    deprecated: !1,
    name: "soFRONT/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "5CZXTTgVZKSzgSA3AFMN5a2f3hmwmmJ6hU8BHTEJ3PX8",
    deprecated: !1,
    name: "soAKRO/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "6Pn1cSiRos3qhBf54uBP9ZQg8x3JTardm1dL3n4p29tA",
    deprecated: !1,
    name: "soHXRO/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "6JYHjaQBx6AtKSSsizDMwozAEDEZ5KBsSUzH7kRjGJon",
    deprecated: !1,
    name: "soUNI/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "J7cPYBrXVy8Qeki2crZkZavcojf2sMRyQU7nx438Mf8t",
    deprecated: !1,
    name: "soMATH/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "8BdpjpSD5n3nk8DQLqPUyTZvVqFu6kcff5bzUX5dqDpy",
    deprecated: !1,
    name: "soTOMO/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "4xyWjQ74Eifq17vbue5Ut9xfFNfuVB116tZLEpiZuAn8",
    deprecated: !1,
    name: "soLUA/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "jyei9Fpj2GtHLDDGgcuhDacxYLLiSyxU4TY7KxB2xai",
    deprecated: !1,
    name: "SRM/SOL",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "9wFFyRfZBsuAha4YcuxcXLKwMxJR43S7fPfQLusDBzvT",
    deprecated: !1,
    name: "SOL/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "E14BKBhDWD4EuTkWj1ooZezesGxMW8LPCps4W5PuzZJo",
    deprecated: !1,
    name: "FIDA/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "Bn6NPyr6UzrFAwC4WmvPvDr2Vm8XSUnFykM2aQroedgn",
    deprecated: !1,
    name: "KIN/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "3A8XQRWXC7BjLpgLDDBhQJLT5yPCzS16cGYRKHkKxvYo",
    deprecated: !1,
    name: "MAPS/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "3rgacody9SvM88QR83GHaNdEEx4Fe2V2ed5GJp2oeKDr",
    deprecated: !1,
    name: "soKEEP/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "EmCzMQfXMgNHcnRoFwAdPe1i2SuiSzMj1mx6wu3KN2uA",
    deprecated: !0,
    name: "soALEPH/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "8AcVjMG2LTbpkjNoyq8RwysokqZunkjy3d5JDzxC6BJa",
    deprecated: !0,
    name: "BTC/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "HfCZdJ1wfsWKfYP2qyWdXTT5PWAGWFctzFjLH48U1Hsd",
    deprecated: !0,
    name: "soETH/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "8mDuvJJSgoodovMRYArtVVYBbixWYdGzR47GPrRT65YJ",
    deprecated: !0,
    name: "SOL/soUSDT",
    programId: "BJ3jrUzddfuSrZHXSCxMUUQsjKEyLmuuyZebkcaFp2fg"
  },
  {
    address: "HARFLhSq8nECZk4DVFKvzqXMNMA9a3hjvridGMFizeLa",
    deprecated: !0,
    name: "SRM/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "DzFjazak6EKHnaB2w6qSsArnj28CV1TKd2Smcj9fqtHW",
    deprecated: !0,
    name: "soSUSHI/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "GuvWMATdEV6DExWnXncPYEzn4ePWYkvGdC8pu8gsn7m7",
    deprecated: !0,
    name: "soSXP/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "H4snTKK9adiU15gP22ErfZYtro3aqR9BTMXiH3AwiUTQ",
    deprecated: !0,
    name: "MSRM/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "DHDdghmkBhEpReno3tbzBPtsxCt6P3KrMzZvxavTktJt",
    deprecated: !0,
    name: "soFTT/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "5zu5bTZZvqESAAgFsr12CUMxdQvMrvU9CgvC1GW8vJdf",
    deprecated: !0,
    name: "soYFI/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "F5xschQBMpu1gD2q1babYEAVJHR1buj1YazLiXyQNqSW",
    deprecated: !0,
    name: "soLINK/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "BAbc9baz4hV1hnYjWSJ6cZDRjfvziWbYGQu9UFkcdUmx",
    deprecated: !0,
    name: "soHGET/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "EBxJWA2nLV57ZntbjizxH527ZjPNLT5cpUHMnY5k3oq",
    deprecated: !0,
    name: "soCREAM/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "46VdEkj4MJwZinwVb3Y7DUDpVXLNb9YW7P2waKU3vCqr",
    deprecated: !0,
    name: "soUBXT/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "Hc22rHKrhbrZBaQMmhJvPTkp1yDr31PDusU8wKoqFSZV",
    deprecated: !0,
    name: "soHNT/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "HFoca5HKwiTPpw9iUY5iXWqzkXdu88dS7YrpSvt2uhyF",
    deprecated: !0,
    name: "soFRONT/soUSDT",
    programId: "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn"
  },
  {
    address: "5xnYnWca2bFwC6cPufpdsCbDJhMjYCC59YgwoZHEfiee",
    deprecated: !0,
    name: "soALEPH/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "EXnGBBSamqzd3uxEdRLUiYzjJkTwQyorAaFXdfteuGXe",
    deprecated: !0,
    name: "BTC/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "5abZGhrELnUnfM9ZUnvK6XJPoBU5eShZwfFPkdhAC7o",
    deprecated: !0,
    name: "soETH/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "7xLk17EQQ5KLDLDe44wCmupJKJjTGd8hs3eSVVhCx932",
    deprecated: !0,
    name: "SOL/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "H3APNWA8bZW2gLMSq5sRL41JSMmEJ648AqoEdDgLcdvB",
    deprecated: !0,
    name: "SRM/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "4uZTPc72sCDcVRfKKii67dTPm2Xe4ri3TYnGcUQrtnU9",
    deprecated: !0,
    name: "soSUSHI/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "33GHmwG9woY95JuWNi74Aa8uKvysSXxif9P1EwwkrCRz",
    deprecated: !0,
    name: "soSXP/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "FUaF58sDrgbqakHTR8RUwRLauSofRTjqyCsqThFPh6YM",
    deprecated: !0,
    name: "MSRM/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "5NqjQVXLuLSDnsnQMfWp3rF9gbWDusWG4B1Xwtk3rZ5S",
    deprecated: !0,
    name: "soFTT/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "97NiXHUNkpYd1eb2HthSDGhaPfepuqMAV3QsZhAgb1wm",
    deprecated: !0,
    name: "soYFI/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "hBswhpNyz4m5nt4KwtCA7jYXvh7VmyZ4TuuPmpaKQb1",
    deprecated: !0,
    name: "soLINK/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "GaeUpY7CT8rjoeVGjY1t3mJJDd1bdXxYWtrGSpsVFors",
    deprecated: !0,
    name: "soHGET/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "7qq9BABQvTWKZuJ5fX2PeTKX6XVtduEs9zW9WS21fSzN",
    deprecated: !0,
    name: "soCREAM/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "DCHvVahuLTNWBGUtEzF5GrTdx5FRpxqEJiS6Ru1hrDfD",
    deprecated: !0,
    name: "soUBXT/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "DWjJ8VHdGYBxDQYdrRBVDWkHswrgjuBFEv5pBhiRoPBz",
    deprecated: !0,
    name: "soHNT/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "56eqxJYzPigm4FkigiBdsfebjMgAbKNh24E7oiKLBtye",
    deprecated: !0,
    name: "soFRONT/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "FQbCNSVH3RgosCPB4CJRstkLh5hXkvuXzAjQzT11oMYo",
    deprecated: !0,
    name: "soAKRO/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "Fs5xtGUmJTYo8Ao75M3R3m3mVX53KMUhzfXCmyRLnp2P",
    deprecated: !0,
    name: "soHXRO/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "ChKV7mxecPqFPGYJjhzowPHDiLKFWXXVujUiE3EWxFcg",
    deprecated: !0,
    name: "soUNI/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "6N3oU7ALvn2RPwdpYVzPBgQJ8njT29inBbS2tSrwx8fh",
    deprecated: !0,
    name: "soKEEP/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "5P6dJbyKySFXMYNWiEcNQu8xPRYsehYzCeVpae9Ueqrg",
    deprecated: !0,
    name: "soMATH/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "H7c8FcQPJ2E5tJmpWBPSi7xCAbk8immdtUxKFRUyE4Ro",
    deprecated: !0,
    name: "soTOMO/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "7PSeX1AEtBY9KvgegF5rUh452VemMh7oDzFtJgH7sxMG",
    deprecated: !0,
    name: "soLUA/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "AF2oQQaLtcrTnQyVs3EPTdyw57TPaK6njKYDq2Qw7LqP",
    deprecated: !0,
    name: "soSWAG/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "9TE15E5h61zJ5VmQAAHkGrAuQdFTth33aBbKdcrppZBp",
    deprecated: !0,
    name: "FIDA/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "8HEaA1vSA5mGQoHcvRPNibnuZvnUpSjJJru9HJNH3SqM",
    deprecated: !0,
    name: "KIN/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "8EuuEwULFM7n7zthPjC7kA64LPRzYkpAyuLFiLuVg7D4",
    deprecated: !0,
    name: "soUSDT/USDC",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "8grUs4WZoTs4KJ8LfRNUBs6SNkMTp5BnVRzJgQ2ranDT",
    deprecated: !0,
    name: "MAPS/soUSDT",
    programId: "EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o"
  },
  {
    address: "FoCuWt4KboucUg2PwmQ3dbkvLqYPLnAo1Rsm8p7QPyf",
    deprecated: !0,
    name: "soALEPH/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "5r8FfnbNYcQbS1m4CYmoHYGjBtu6bxfo6UJHNRfzPiYH",
    deprecated: !0,
    name: "BTC/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "71CtEComq2XdhGNbXBuYPmosAjMCPSedcgbNi5jDaGbR",
    deprecated: !0,
    name: "soETH/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "EZyQ9zyqQsw3QcsLksoWyd1UFVjHZkzRx8N4ZMnZQrS2",
    deprecated: !0,
    name: "SRM/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "6ERBjj692XHLWwWSRAUpiKenXshcwmPqhMy7RMapeoKa",
    deprecated: !0,
    name: "soSUSHI/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "CQ3kAGxPmpBbak2RSHWyMeRhyLYbH6oVZHJxgjzDLpLW",
    deprecated: !0,
    name: "soSXP/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "2Hqn46jhwaQMQ3zEnHtxrWxQZom6qwLXAgdsFJM1Srwh",
    deprecated: !0,
    name: "MSRM/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "G5jqZNo2UVCTnJxgEhKCYvqFRs3MxsnH8Bervq3rfLoL",
    deprecated: !0,
    name: "soFTT/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "CbwtTHEpfTnCyLw4GoTbKk7WyrXkuATLfLadY2odBSsY",
    deprecated: !0,
    name: "soYFI/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "5GjhBAYx8pYeCeUQt7rt93KQZnoQFuDq9Jx4iqq97Mip",
    deprecated: !0,
    name: "soLINK/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "9jMPV9E23pTirMjC7vz5suRNkd25311G3Httg7jTib8R",
    deprecated: !0,
    name: "soCREAM/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "DsSz9KWT97T4RewRTqTNDpNFQyxMPcuYNAJw2xHAzSiZ",
    deprecated: !0,
    name: "soUBXT/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "3k1sURztjxhjYczjyioQ7y2UkMB6K5Ksi3SWvLeLx6Ex",
    deprecated: !0,
    name: "soHNT/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "B791G8UCahfmABVcR2wPAMK6LJnuqxSAqiG6wX3mmVVM",
    deprecated: !0,
    name: "soFRONT/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "95f7fxfUh8WqUTrdjorHRXm6rTfkWqr23ioGMmKMjedP",
    deprecated: !0,
    name: "soAKRO/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "H4RxtmQ4P3TYPt78G3DuHgaGzyFct6MfaeYneLB5PyeG",
    deprecated: !0,
    name: "soHXRO/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "7myaZEGZf9m72T1Mqm8GTx5MnmSFS5NCXSwRP18W4EA3",
    deprecated: !0,
    name: "soUNI/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "7cRKzNoqjF9VtzvdnP129VYP3izivk9iY3jMJBMzREVT",
    deprecated: !0,
    name: "soHGET/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "GV9fYzdwipoaagXFxe5tzDMPcmSVQati5CUvBPsEZThH",
    deprecated: !0,
    name: "soMATH/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "AaMLXcwYYi5fA41JNCB2ukAmQyKHitYx5NnpsiWWev6R",
    deprecated: !0,
    name: "soTOMO/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "5ZeNLrduGi3WkH9CPwv2Zpbkh38MH8v63aSi2aBUW23g",
    deprecated: !0,
    name: "soLUA/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "Ec1aq54XKH9o5fe169cU2sCcxxTP54eeQCe77SpizKuc",
    deprecated: !0,
    name: "soUSDT/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "G3uhFg2rBFunHUXtCera13vyQ5KCS8Hx3d4HohLoZbT5",
    deprecated: !0,
    name: "SOL/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "2NMTG7tFZidRpQk9Sf4dgQyJb9HxKCyXjQdiuXww3sKm",
    deprecated: !0,
    name: "soSWAG/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "7QpJAiwGmqY1SiucjfPXvgeWwCobyV6hZSgzMysZX6Ww",
    deprecated: !0,
    name: "FIDA/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "CmLhvXARncLncE1949XBfQWeJh6Zvw3FE5A3Z5ecPYQH",
    deprecated: !0,
    name: "KIN/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "FhP3X2ptdi7L1RtWK9Vfow5dyzD92gfXiA57e8eqxvka",
    deprecated: !0,
    name: "MAPS/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "DE7xJE2EkaV81wLabDMuhBzUwFhhwfURLdz1aXBBQZQ1",
    deprecated: !0,
    name: "soKEEP/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "5nLJ22h1DUfeCfwbFxPYK8zbfbri7nA9bXoDcR8AcJjs",
    deprecated: !1,
    name: "MSRM/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "7dLVkUfBVfCGkFhSXDCq1ukM9usathSgS716t643iFGF",
    deprecated: !1,
    name: "soETH/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "8afKwzHR3wJE7W7Y5hvQkngXh6iTepSZuutRMMy96MjR",
    deprecated: !1,
    name: "soSXP/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "cgani53cMZgYfRMgSrNekJTMaLmccRfspsfTbXWRg7u",
    deprecated: !1,
    name: "soCEL/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "Gyp1UGRgbrb6z8t7fpssxEKQgEmcJ4pVnWW3ds2p6ZPY",
    deprecated: !1,
    name: "soALEPH/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "4ztJEvQyryoYagj2uieep3dyPwG2pyEwb2dKXTwmXe82",
    deprecated: !1,
    name: "soCREAM/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "HEGnaVL5i48ubPBqWAhodnZo8VsSLzEM3Gfc451DnFj9",
    deprecated: !1,
    name: "soKEEP/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "8FpuMGLtMZ7Wt9ZvyTGuTVwTwwzLYfS5NZWcHxbP1Wuh",
    deprecated: !1,
    name: "soHNT/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "5GAPymgnnWieGcRrcghZdA3aanefqa4cZx1ZSE8UTyMV",
    deprecated: !1,
    name: "soMAPS/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "AADohBGxvf7bvixs2HKC3dG2RuU3xpZDwaTzYFJThM8U",
    deprecated: !1,
    name: "TRYB/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "EbV7pPpEvheLizuYX3gUCvWM8iySbSRAhu2mQ5Vz2Mxf",
    deprecated: !1,
    name: "FIDA/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "FcPet5fz9NLdbXwVM6kw2WTHzRAD7mT78UjwTpawd7hJ",
    deprecated: !1,
    name: "soRSR/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "AtNnsY1AyRERWJ8xCskfz38YdvruWVJQUVXgScC1iPb",
    deprecated: !1,
    name: "SRM/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "teE55QrL4a4QSfydR9dnHF97jgCfptpuigbb53Lo95g",
    deprecated: !1,
    name: "RAY/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "C1EuT9VokAKLiW7i2ASnZUvxDoKuKkCpDDeNxAptuNe4",
    deprecated: !1,
    name: "BTC/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "Hr3wzG8mZXNHV7TuL6YqtgfVUesCqMxGYCEyP3otywZE",
    deprecated: !1,
    name: "soFTT/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "HLvRdctRB48F9yLnu9E24LUTRt89D48Z35yi1HcxayDf",
    deprecated: !1,
    name: "soAKRO/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "2SSnWNrc83otLpfRo792P6P3PESZpdr8cu2r8zCE6bMD",
    deprecated: !1,
    name: "soUNI/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "F1T7b6pnR8Pge3qmfNUfW6ZipRDiGpMww6TKTrRU4NiL",
    deprecated: !1,
    name: "soUBXT/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "HWHvQhFmJB3NUcu1aihKmrKegfVxBEHzwVX6yZCKEsi1",
    deprecated: !1,
    name: "SOL/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "35tV8UsHH8FnSAi3YFRrgCu4K9tb883wKnAXpnihot5r",
    deprecated: !1,
    name: "soLUA/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "6DgQRTpJTnAYBSShngAVZZDq7j9ogRN1GfSQ3cq9tubW",
    deprecated: !1,
    name: "soSUSHI/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "2WghiBkDL2yRhHdvm8CpprrkmfguuQGJTCDfPSudKBAZ",
    deprecated: !1,
    name: "soMATH/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "ErQXxiNfJgd4fqQ58PuEw5xY35TZG84tHT6FXf5s4UxY",
    deprecated: !1,
    name: "soHGET/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "CGC4UgWwqA9PET6Tfx6o6dLv94EK2coVkPtxgNHuBtxj",
    deprecated: !1,
    name: "soFRONT/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "GnKPri4thaGipzTbp8hhSGSrHgG4F8MFiZVrbRn16iG2",
    deprecated: !1,
    name: "soTOMO/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "6bxuB5N3bt3qW8UnPNLgMMzDq5sEH8pFmYJYGgzvE11V",
    deprecated: !1,
    name: "soAAVE/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "7cknqHAuGpfVXPtFoJpFvUjJ8wkmyEfbFusmwMfNy3FE",
    deprecated: !1,
    name: "MAPS/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "4absuMsgemvdjfkgdLQq1zKEjw3dHBoCWkzKoctndyqd",
    deprecated: !1,
    name: "soHXRO/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "4nCFQr8sahhhL4XJ7kngGFBmpkmyf3xLzemuMhn6mWTm",
    deprecated: !1,
    name: "KIN/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "3Xg9Q4VtZhD4bVYJbTfgGWFV5zjE3U7ztSHa938zizte",
    deprecated: !1,
    name: "soYFI/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "3yEZ9ZpXSQapmKjLAGKZEzUNA1rcupJtsDp5mPBWmGZR",
    deprecated: !1,
    name: "soLINK/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "J2XSt77XWim5HwtUM8RUwQvmRXNZsbMKpp5GTKpHafvf",
    deprecated: !1,
    name: "soSWAG/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "77quYg4MGneUdjgXCunt9GgM1usmrxKY31twEy3WHwcS",
    deprecated: !1,
    name: "USDT/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "GKLev6UHeX1KSDCyo2bzyG6wqhByEzDBkmYTxEdmYJgB",
    deprecated: !1,
    name: "OXY/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    address: "HdBhZrnrxpje39ggXnTb6WuTWVvj5YKcSHwYGQCRsVj",
    deprecated: !1,
    name: "OXY/soUSDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    name: "OXY/USDC",
    address: "GZ3WBFsqntmERPwumFEYgrX2B7J7G11MzNZAy7Hje27X",
    deprecated: !1,
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    name: "xCOPE/USDC",
    address: "7MpMwArporUHEGW7quUpkPZp5L5cHPs9eKUfKCdaPHq2",
    deprecated: !1,
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    name: "COPE/USDC",
    address: "6fc7v3PmjZG9Lk2XTot6BywGyYLkBQuzuFKd4FpCsPxk",
    deprecated: !1,
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    name: "MER/USDC",
    address: "HhvDWug3ftYNx5148ZmrQxzvEmohN2pKVNiRT4TVoekF",
    deprecated: !0,
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    name: "MER/USDT",
    address: "6HwcY27nbeb933UkEcxqJejtjWLfNQFWkGCjAVNes6g7",
    deprecated: !1,
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    name: "MER/USDC",
    address: "G4LcexdCzzJUKZfqyVDQFzpkjhB1JoCNL8Kooxi9nJz5",
    deprecated: !1,
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    name: "SNY/USDC",
    address: "DPfj2jYwPaezkCmUNm5SSYfkrkz8WFqwGLcxDDUsN3gA",
    deprecated: !1,
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    name: "SLRS/USDC",
    address: "2Gx3UfV831BAh8uQv1FKSPKS9yajfeeD8GJ4ZNb2o2YP",
    deprecated: !1,
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin"
  },
  {
    name: "ETHV/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "HrgkuJryyKRserkoz7LBFYkASzhXHWp9XA6fRYCA6PHb"
  },
  {
    name: "IETHV/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "5aoLj1bySDhhWjo7cLfT3pF2gqNGd63uEJ9HMSfASESL"
  },
  {
    name: "SBR/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "HXBi8YBwbh4TXF6PjVw81m8Z3Cc4WBofvauj5SBFdgUs"
  },
  {
    name: "renBTC/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "74Ciu5yRzhe8TFTHvQuEVbFZJrbnCMRoohBK33NNiPtv"
  },
  {
    name: "renDOGE/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "5FpKCWYXgHWZ9CdDMHjwxAfqxJLdw2PRXuAmtECkzADk"
  },
  {
    name: "DXL/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "DYfigimKWc5VhavR4moPBibx9sMcWYVSjVdWvPztBPTa"
  },
  {
    name: "MNGO/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "3d4rzwpy9iGdCZvgxcu7B1YocYffVLsQXPXkBZKt2zLc"
  },
  {
    name: "CYS/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "6V6y6QFi17QZC9qNRpVp7SaPiHpCTp2skbRQkUyZZXPW"
  },
  {
    name: "POLIS/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "HxFLKUAmAMLz1jtT3hbvCMELwH5H9tpM2QugP8sKyfhW"
  },
  {
    name: "ATLAS/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "Di66GTLsV64JgCCYGVcY21RZ173BHkjJVgPyezNN7P1K"
  },
  {
    name: "LIKE/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "3WptgZZu34aiDrLMUiPntTYZGNZ72yT1yxHYxSdbTArX"
  },
  {
    name: "MSOL/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "6oGsL2puUgySccKzn9XA9afqF217LfxP5ocq4B3LWsjy"
  },
  {
    name: "MSOL/SOL",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "5cLrMai1DsLRYc1Nio9qMTicsWtvzjzZfJPXyAoF4t1Z"
  },
  {
    name: "AAVE/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "8WZrmdpLckptiVKd2fPHPjewRVYQGQkjxi9vzRYG1sfs"
  },
  {
    name: "AAVE/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "LghsMERQWQFK3zWMTrUkoyAJARQw2wSmcYZjexeN3zy"
  },
  {
    name: "AKRO/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "G3h8NZgJozk9crme2me6sKDJuSQ12mNCtvC9NbSWqGuk"
  },
  {
    name: "AKRO/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "DvbiPxKzuXZPcmUcYDqBz1tvUrXYPsNrRAjSeuwHtmEA"
  },
  {
    name: "ALEPH/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "Fw4mvuE7KZmTjQPxP2sRpHwPDfRMWnKBupFZGyW9CAQH"
  },
  {
    name: "ALEPH/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "GZeHR8uCTVoHVDZFRVXTgm386DK1EKehy9yMS3BFChcL"
  },
  {
    name: "CEL/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "79ESpYSb2hM14KTRXPZUwDkxUGC5irE2esd1vxdXfnZz"
  },
  {
    name: "CEL/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "J9ww1yufRNDDbUbDXmew2mW2ozkx7cme7dMvKjMQVHrL"
  },
  {
    name: "CREAM/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "4pdQ2D4gehMhGu4z9jeQbEPUFbTxB5qcPr3zCynjJGyp"
  },
  {
    name: "CREAM/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "6fspxMfBmYFTGFBDN5MU33A55i2MkGr7eSjBLPCAU6y9"
  },
  {
    name: "ETH/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "8Gmi2HhZmwQPVdCwzS7CM66MGstMXPcTVHA7jF19cLZz"
  },
  {
    name: "ETH/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "ch7kmPrtoQUSEPBggcNAvLGiMQkJagVwd3gDYfd8m7Q"
  },
  {
    name: "FRONT/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "B95oZN5HCLGmFAhbzReWBA9cuSGPFQAXeuhm2FfpdrML"
  },
  {
    name: "FRONT/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "DZTYyy1L5Pr6DmTtYY5bEuU9g3LQ4XGvuYiN3zS25yG7"
  },
  {
    name: "FTT/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "2wteg25ch227n4Rh1CN4WNrDZXBpRBpWJ48mEC2K7f4r"
  },
  {
    name: "FTT/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "BoHojHESAv4McZx9gXd1bWTZMq25JYyGz4qL1m5C3nvk"
  },
  {
    name: "HGET/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "27e1mB6UoPohbc3MmwMXu5QM7b2E3k5Mbhwv6JguwyXg"
  },
  {
    name: "HGET/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "BdRzTEKb7Qdu4tWts5zXjwcpQErZxEzvShKZ5QcthMag"
  },
  {
    name: "HXRO/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "CBb5zXwNRB73WVjs2m21P5prcEZa6SWmej74Vzxh8dRm"
  },
  {
    name: "HXRO/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "3BScwNxtMrEcQ5VTHyXHYQR98dTaxfyXGaLkuSjBY1dW"
  },
  {
    name: "LINK/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "FJMjxMCiDKn16TLhXUdEbVDH5wC6k9EHYJTcrH6NcbDE"
  },
  {
    name: "LINK/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "Gr2KmhK7Upr4uW56B1QQrJuhhgmot6zAHJeZALTMStiX"
  },
  {
    name: "LUA/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "J9imTcEeahZqKuaoQaPcCeSGCMWL8qSACpK4B7bC8NN4"
  },
  {
    name: "LUA/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "BMJ3CvQZ57cNnuc3Lz5Pb6cW6Sr9kZGz3qz2bJQTE24A"
  },
  {
    name: "MATH/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "G8L1YLrktaG1t8YBMJs3CwV96nExvJJCSpw3DARPDjE2"
  },
  {
    name: "MATH/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "CkvNfATB7nky8zPLuwS9bgcFbVRkQdkd5zuKEovyo9rs"
  },
  {
    name: "RAY/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "2xiv8A5xrJ7RnGdxXB42uFEkYHJjszEhaJyKKt4WaLep"
  },
  {
    name: "RSR/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "GqgkxEswUwHBntmzb5GpUhKrVpJhzreSruZycuJwdNwB"
  },
  {
    name: "RSR/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "2j2or38X2FUbpkK4gkgvjDtqN3ibkKw3v5yn7o2gHqPc"
  },
  {
    name: "SUSHI/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "3uWVMWu7cwMnYMAAdtsZNwaaqeeeZHARGZwcExnQiFay"
  },
  {
    name: "SUSHI/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "T3aC6qcPAJtX1gqkckfSxBPdPWziz5fLYRt5Dz3Nafq"
  },
  {
    name: "SWAG/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "wSkeLMv3ktJyLm51bvQWxY2saGKqGxbnUFimPxbgEvQ"
  },
  {
    name: "SWAG/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "6URQ4zFWvPm1fhJCKKWorrh8X3mmTFiDDyXEUmSf8Rb2"
  },
  {
    name: "SXP/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "G5F84rfqmWqzZv5GBpSn8mMwW8zJ2B4Y1GpGupiwjHNM"
  },
  {
    name: "SXP/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "2FQbPW1ticJz2SMMbEXxbKWJKmw1wLc6ggSP2HyzdMen"
  },
  {
    name: "UBXT/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "Hh4p7tJpqkGW6xsHM2LiPPMpJg43fwn5TbmVmfrURdLY"
  },
  {
    name: "UBXT/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "5xhjc3ZtAwnBK3qsaro28VChL7WrxY9N4SG6UZpYxpGc"
  },
  {
    name: "UNI/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "B7b5rjQuqQCuGqmUBWmcCTqaL3Z1462mo4NArqty6QFR"
  },
  {
    name: "UNI/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "FrKM6kJtAjXknHPEpkrQtJSXZwUxV5dq26wDpc4YjQST"
  },
  {
    name: "YFI/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "BiJXGFc1c4gyPpv9HLRJoKbZewWQrTCHGuxYKjYMQJpC"
  },
  {
    name: "YFI/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "9sue9TZAeUhNtNAPPGb9dke7rkJeXktGD3u8ZC37GWnQ"
  },
  {
    name: "AVAX/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "E8JQstcwjuqN5kdMyUJLNuaectymnhffkvfg1j286UCr"
  },
  {
    name: "AXSet/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "HZCheduA4nsSuQpVww1TiyKZpXSAitqaXxjBD2ymg22X"
  },
  {
    name: "BNB/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "4UPUurKveNEJgBqJzqHPyi8DhedvpYsMXi7d43CjAg2f"
  },
  {
    name: "BNB/USDT",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "FjbKNZME5yVSC1R3HJM99kB3yir3q3frS5MteMFD72sV"
  },
  {
    name: "GALA/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "F7WJsoxTWQRmAwAyFe9APmuVv4HqmhchFtdbR9dvAUDm"
  },
  {
    name: "MATICpo/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "5WRoQxE59966N2XfD2wYy1uhuyKeoVJ9NBMH6r6RNYEF"
  },
  {
    name: "ROSE/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "EybAYkmRKCyD4w8AErTG1bqmnvT85LFuPQPMCc8J3yD"
  },
  {
    name: "SAND/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "3FE2g3cadTJjN3C7gNRavwnv7Yh9Midq7h9KgTVUE7tR"
  },
  {
    name: "LUNA/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "HBTu8hNaoT3VyiSSzJYa8jwt9sDGKtJviSwFa11iXdmE"
  },
  {
    name: "SHIB/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "Er7Jp4PADPVHifykFwbVoHdkL1RtZSsx9zGJrPJTrCgW"
  },
  {
    name: "UST/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "8WmckvEoVGZvtN8knjdzFGbWJ3Sr4BcWdyzSYuCrD4YK"
  },
  {
    name: "FAB/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "Cud48DK2qoxsWNzQeTL5D8sAiHsGwG8Ev1VMNcYLayxt"
  },
  {
    name: "JET/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "6pQMoHDC2o8eeFxyTKtfnsr8d48hKFWsRpLHAqVHH2ZP"
  },
  {
    name: "scnSOL/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "D52sefGCWho2nd5UGxWd7wCftAzeNEMNYZkdEPGEdQTb"
  },
  {
    name: "stSOL/USDC",
    programId: "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin",
    deprecated: !1,
    address: "5F7LGsP1LPtaRV7vVKgxwNYX4Vf22xvuzyXjyar7jJqp"
  }
], nre = [
  {
    address: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
    name: "BTC"
  },
  {
    address: "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk",
    name: "ETH"
  },
  {
    address: "AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3",
    name: "FTT"
  },
  {
    address: "3JSf5tPeuscJGtaCp5giEiDhv51gQ4v3zWg8DGgyLfAB",
    name: "YFI"
  },
  {
    address: "CWE8jPTUYhdCTZYWPTe1o5DFqfdjzWKc9WKz6rSjQUdG",
    name: "LINK"
  },
  {
    address: "Ga2AXHpfAF6mv2ekZwcsJFqu7wB4NV331qNH7fW9Nst8",
    name: "XRP"
  },
  {
    address: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    name: "USDT"
  },
  {
    address: "BQcdHdAQW1hczDbBi9hiegXAR7A98Q9jx3X3iBBBDiq4",
    name: "WUSDT"
  },
  {
    address: "BXXkv6z8ykpG1yuvUDPgh732wzVHB69RnB9YgSYh3itW",
    name: "WUSDC"
  },
  {
    address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    name: "USDC"
  },
  {
    address: "MSRMcoVyrFxnSgo5uXwone5SKcGhT1KEJMFEkMEWf9L",
    name: "MSRM"
  },
  {
    address: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    name: "SRM"
  },
  {
    address: "AR1Mtgh7zAtxuxGd2XPovXPVjcSdY3i4rQYisNadjfKy",
    name: "SUSHI"
  },
  {
    address: "SF3oTvfWzEP3DTwGSvUXRrGTvr75pdZNnBLAH9bzMuX",
    name: "SXP"
  },
  {
    address: "CsZ5LZkDS7h9TDKjrbL7VAwQZ9nsRu8vJLhRYfmGaN8K",
    name: "ALEPH"
  },
  {
    address: "BtZQfWqDGbk9Wf2rXEiWyQBdBY1etnUUn6zEphvVS7yN",
    name: "HGET"
  },
  {
    address: "5Fu5UUgbjpUvdBveb3a1JTNirL8rXtiYeSMWvKjtUNQv",
    name: "CREAM"
  },
  {
    address: "873KLxCbz7s9Kc4ZzgYRtNmhfkQrhfyWGZJBmyCbC3ei",
    name: "UBXT"
  },
  {
    address: "HqB7uswoVg4suaQiDP3wjxob1G5WdZ144zhdStwMCq7e",
    name: "HNT"
  },
  {
    address: "9S4t2NEAiJVMvPdRYKVrfJpBafPBLtvbvyS3DecojQHw",
    name: "FRONT"
  },
  {
    address: "6WNVCuxCGJzNjmMZoKyhZJwvJ5tYpsLyAtagzYASqBoF",
    name: "AKRO"
  },
  {
    address: "DJafV9qemGp7mLMEn5wrfqaFwxsbLgUsGVS16zKRk9kc",
    name: "HXRO"
  },
  {
    address: "DEhAasscXF4kEGxFgJ3bq4PpVGp5wyUxMRvn6TzGVHaw",
    name: "UNI"
  },
  {
    address: "GUohe4DJUA5FKPWo3joiPgsB7yzer7LpDmt1Vhzy3Zht",
    name: "KEEP"
  },
  {
    address: "GeDS162t9yGJuLEHPWXXGrb1zwkzinCgRwnT8vHYjKza",
    name: "MATH"
  },
  {
    address: "So11111111111111111111111111111111111111112",
    name: "SOL"
  },
  {
    address: "GXMvfY2jpQctDqZ9RoU3oWPhufKiCcFEfchvYumtX7jd",
    name: "TOMO"
  },
  {
    address: "EqWCKXfs3x47uVosDpTRgFniThL9Y8iCztJaapxbEaVX",
    name: "LUA"
  },
  {
    address: "9F9fNTT6qwjsu4X4yWYKZpsbw5qT7o6yR2i57JF2jagy",
    name: "SWAG"
  },
  {
    address: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
    name: "FIDA"
  },
  {
    address: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    name: "KIN"
  },
  {
    address: "MAPS41MDahZ9QdKXhVa4dWB9RuyfV4XqhyAZ8XcYepb",
    name: "MAPS"
  },
  {
    address: "z3dn17yLaGMKffVogeFHQ9zWVcXgqgf3PQnDsNs2g6M",
    name: "OXY"
  },
  {
    address: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    name: "RAY"
  },
  {
    address: "3K6rftdAaQYMPunrtNRHgnK2UAtjm2JwyT2oCiTDouYE",
    name: "xCOPE"
  },
  {
    address: "dK83wTVypEpa1pqiBbHY3MNuUnT3ADUZM4wk9VZXZEc",
    name: "AAVE"
  },
  {
    address: "DgHK9mfhMtUwwv54GChRrU54T2Em5cuszq2uMuen1ZVE",
    name: "CEL"
  },
  {
    address: "7ncCLJpP3MNww17LW8bRvx8odQQnubNtfNZBL5BgAEHW",
    name: "RSR"
  },
  {
    address: "6ry4WBDvAwAnrYJVv6MCog4J8zx6S3cPgSqnTsDZ73AR",
    name: "TRYB"
  },
  {
    address: "8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh",
    name: "COPE"
  },
  {
    address: "MERt85fc5boKw3BW1eYdxonEuJNvXbiMbs6hvheau5K",
    name: "MER"
  },
  {
    address: "4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y",
    name: "SNY"
  },
  {
    address: "SLRSSpSLUTP7okbCUBYStWCo1vUgyt775faPqz8HUMr",
    name: "SLRS"
  },
  {
    address: "CDJWUqTcYTVAKXAVXoQZFes5JUFc7owSeq7eMQcDSbo5",
    name: "renBTC"
  },
  {
    address: "ArUkYE2XDKzqy77PRRGjo4wREWwqk6RXTfM9NeqzPvjU",
    name: "renDOGE"
  },
  {
    address: "GsNzxJfFn6zQdJGeYsupJWzUAm57Ba7335mfhWvFiE9Z",
    name: "DXL"
  }
];
(function(t) {
  var e = Ne && Ne.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.MARKETS = t.TOKEN_MINTS = t.getLayoutVersion = t.PROGRAM_LAYOUT_VERSIONS = void 0;
  const r = Of, n = e(rre), i = e(nre);
  t.PROGRAM_LAYOUT_VERSIONS = {
    "4ckmDgGdxQoPDLUkDT3vHgSAkzA3QRdNq5ywwY4sUSJn": 1,
    BJ3jrUzddfuSrZHXSCxMUUQsjKEyLmuuyZebkcaFp2fg: 1,
    EUqojwWA2rd19FZrzeBncJsm38Jm1hEhE3zsmX3bRc2o: 2,
    "9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin": 3
  };
  function s(a) {
    return t.PROGRAM_LAYOUT_VERSIONS[a.toString()] || 3;
  }
  t.getLayoutVersion = s, t.TOKEN_MINTS = i.default.map((a) => ({
    address: new r.PublicKey(a.address),
    name: a.name
  })), t.MARKETS = n.default.map((a) => ({
    address: new r.PublicKey(a.address),
    name: a.name,
    programId: new r.PublicKey(a.programId),
    deprecated: a.deprecated
  }));
})(Vl);
Object.defineProperty(Ma, "__esModule", { value: !0 });
Ma.getFeeTier = Ma.getFeeRates = Ma.supportsSrmFeeDiscounts = void 0;
const ire = Vl;
function sre(t) {
  return ire.getLayoutVersion(t) > 1;
}
Ma.supportsSrmFeeDiscounts = sre;
function are(t) {
  return t === 1 ? { taker: 2e-3, maker: -3e-4 } : t === 2 ? { taker: 18e-4, maker: -3e-4 } : t === 3 ? { taker: 16e-4, maker: -3e-4 } : t === 4 ? { taker: 14e-4, maker: -3e-4 } : t === 5 ? { taker: 12e-4, maker: -3e-4 } : t === 6 ? { taker: 1e-3, maker: -5e-4 } : { taker: 22e-4, maker: -3e-4 };
}
Ma.getFeeRates = are;
function ore(t, e) {
  return t >= 1 ? 6 : e >= 1e6 ? 5 : e >= 1e5 ? 4 : e >= 1e4 ? 3 : e >= 1e3 ? 2 : e >= 100 ? 1 : 0;
}
Ma.getFeeTier = ore;
(function(t) {
  var e = Ne && Ne.__importDefault || function(C) {
    return C && C.__esModule ? C : { default: C };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getMintDecimals = t.Orderbook = t.ORDERBOOK_LAYOUT = t.OpenOrders = t._OPEN_ORDERS_LAYOUT_V2 = t._OPEN_ORDERS_LAYOUT_V1 = t.Market = t.MARKET_STATE_LAYOUT_V3 = t.MARKET_STATE_LAYOUT_V2 = t._MARKET_STAT_LAYOUT_V1 = void 0;
  const r = Qe, n = wr, i = Zk, s = C_, a = e(Tr), o = Of, c = Li, f = Fe, u = Ma, d = zl, l = Vl;
  t._MARKET_STAT_LAYOUT_V1 = r.struct([
    r.blob(5),
    n.accountFlagsLayout("accountFlags"),
    n.publicKeyLayout("ownAddress"),
    n.u64("vaultSignerNonce"),
    n.publicKeyLayout("baseMint"),
    n.publicKeyLayout("quoteMint"),
    n.publicKeyLayout("baseVault"),
    n.u64("baseDepositsTotal"),
    n.u64("baseFeesAccrued"),
    n.publicKeyLayout("quoteVault"),
    n.u64("quoteDepositsTotal"),
    n.u64("quoteFeesAccrued"),
    n.u64("quoteDustThreshold"),
    n.publicKeyLayout("requestQueue"),
    n.publicKeyLayout("eventQueue"),
    n.publicKeyLayout("bids"),
    n.publicKeyLayout("asks"),
    n.u64("baseLotSize"),
    n.u64("quoteLotSize"),
    n.u64("feeRateBps"),
    r.blob(7)
  ]), t.MARKET_STATE_LAYOUT_V2 = r.struct([
    r.blob(5),
    n.accountFlagsLayout("accountFlags"),
    n.publicKeyLayout("ownAddress"),
    n.u64("vaultSignerNonce"),
    n.publicKeyLayout("baseMint"),
    n.publicKeyLayout("quoteMint"),
    n.publicKeyLayout("baseVault"),
    n.u64("baseDepositsTotal"),
    n.u64("baseFeesAccrued"),
    n.publicKeyLayout("quoteVault"),
    n.u64("quoteDepositsTotal"),
    n.u64("quoteFeesAccrued"),
    n.u64("quoteDustThreshold"),
    n.publicKeyLayout("requestQueue"),
    n.publicKeyLayout("eventQueue"),
    n.publicKeyLayout("bids"),
    n.publicKeyLayout("asks"),
    n.u64("baseLotSize"),
    n.u64("quoteLotSize"),
    n.u64("feeRateBps"),
    n.u64("referrerRebatesAccrued"),
    r.blob(7)
  ]), t.MARKET_STATE_LAYOUT_V3 = r.struct([
    r.blob(5),
    n.accountFlagsLayout("accountFlags"),
    n.publicKeyLayout("ownAddress"),
    n.u64("vaultSignerNonce"),
    n.publicKeyLayout("baseMint"),
    n.publicKeyLayout("quoteMint"),
    n.publicKeyLayout("baseVault"),
    n.u64("baseDepositsTotal"),
    n.u64("baseFeesAccrued"),
    n.publicKeyLayout("quoteVault"),
    n.u64("quoteDepositsTotal"),
    n.u64("quoteFeesAccrued"),
    n.u64("quoteDustThreshold"),
    n.publicKeyLayout("requestQueue"),
    n.publicKeyLayout("eventQueue"),
    n.publicKeyLayout("bids"),
    n.publicKeyLayout("asks"),
    n.u64("baseLotSize"),
    n.u64("quoteLotSize"),
    n.u64("feeRateBps"),
    n.u64("referrerRebatesAccrued"),
    n.publicKeyLayout("authority"),
    n.publicKeyLayout("pruneAuthority"),
    n.publicKeyLayout("consumeEventsAuthority"),
    r.blob(992),
    r.blob(7)
  ]);
  class h {
    constructor(D, F, G, re = {}, ie, ee) {
      const { skipPreflight: $ = !1, commitment: w = "recent" } = re;
      if (!D.accountFlags.initialized || !D.accountFlags.market)
        throw new Error("Invalid market state");
      this._decoded = D, this._baseSplTokenDecimals = F, this._quoteSplTokenDecimals = G, this._skipPreflight = $, this._commitment = w, this._programId = ie, this._openOrdersAccountsCache = {}, this._feeDiscountKeysCache = {}, this._layoutOverride = ee;
    }
    static getLayout(D) {
      return l.getLayoutVersion(D) === 1 ? t._MARKET_STAT_LAYOUT_V1 : t.MARKET_STATE_LAYOUT_V2;
    }
    static async findAccountsByMints(D, F, G, re) {
      const ie = [
        {
          memcmp: {
            offset: this.getLayout(re).offsetOf("baseMint"),
            bytes: F.toBase58()
          }
        },
        {
          memcmp: {
            offset: h.getLayout(re).offsetOf("quoteMint"),
            bytes: G.toBase58()
          }
        }
      ];
      return L(D, re, ie);
    }
    static async load(D, F, G = {}, re, ie) {
      const { owner: ee, data: $ } = P(await D.getAccountInfo(F), "Market not found");
      if (!ee.equals(re))
        throw new Error("Address not owned by program: " + ee.toBase58());
      const w = (ie ?? this.getLayout(re)).decode($);
      if (!w.accountFlags.initialized || !w.accountFlags.market || !w.ownAddress.equals(F))
        throw new Error("Invalid market");
      const [E, U] = await Promise.all([
        I(D, w.baseMint),
        I(D, w.quoteMint)
      ]);
      return new h(w, E, U, G, re, ie);
    }
    get programId() {
      return this._programId;
    }
    get address() {
      return this._decoded.ownAddress;
    }
    get publicKey() {
      return this.address;
    }
    get baseMintAddress() {
      return this._decoded.baseMint;
    }
    get quoteMintAddress() {
      return this._decoded.quoteMint;
    }
    get bidsAddress() {
      return this._decoded.bids;
    }
    get asksAddress() {
      return this._decoded.asks;
    }
    get decoded() {
      return this._decoded;
    }
    async loadBids(D) {
      const { data: F } = P(await D.getAccountInfo(this._decoded.bids));
      return p.decode(this, F);
    }
    async loadAsks(D) {
      const { data: F } = P(await D.getAccountInfo(this._decoded.asks));
      return p.decode(this, F);
    }
    async loadOrdersForOwner(D, F, G = 0) {
      const [re, ie, ee] = await Promise.all([
        this.loadBids(D),
        this.loadAsks(D),
        this.findOpenOrdersAccountsForOwner(D, F, G)
      ]);
      return this.filterForOpenOrders(re, ie, ee);
    }
    filterForOpenOrders(D, F, G) {
      return [...D, ...F].filter((re) => G.some((ie) => re.openOrdersAddress.equals(ie.address)));
    }
    async findBaseTokenAccountsForOwner(D, F, G = !1) {
      if (this.baseMintAddress.equals(d.WRAPPED_SOL_MINT) && G) {
        const [re, ie] = await Promise.all([
          this.findBaseTokenAccountsForOwner(D, F, !1),
          D.getAccountInfo(F)
        ]);
        return ie !== null ? [{ pubkey: F, account: ie }, ...re] : re;
      }
      return await this.getTokenAccountsByOwnerForMint(D, F, this.baseMintAddress);
    }
    async getTokenAccountsByOwnerForMint(D, F, G) {
      return (await D.getTokenAccountsByOwner(F, {
        mint: G
      })).value;
    }
    async findQuoteTokenAccountsForOwner(D, F, G = !1) {
      if (this.quoteMintAddress.equals(d.WRAPPED_SOL_MINT) && G) {
        const [re, ie] = await Promise.all([
          this.findQuoteTokenAccountsForOwner(D, F, !1),
          D.getAccountInfo(F)
        ]);
        return ie !== null ? [{ pubkey: F, account: ie }, ...re] : re;
      }
      return await this.getTokenAccountsByOwnerForMint(D, F, this.quoteMintAddress);
    }
    async findOpenOrdersAccountsForOwner(D, F, G = 0) {
      const re = F.toBase58(), ie = (/* @__PURE__ */ new Date()).getTime();
      if (re in this._openOrdersAccountsCache && ie - this._openOrdersAccountsCache[re].ts < G)
        return this._openOrdersAccountsCache[re].accounts;
      const ee = await y.findForMarketAndOwner(D, this.address, F, this._programId);
      return this._openOrdersAccountsCache[re] = {
        accounts: ee,
        ts: ie
      }, ee;
    }
    async placeOrder(D, { owner: F, payer: G, side: re, price: ie, size: ee, orderType: $ = "limit", clientId: w, openOrdersAddressKey: E, openOrdersAccount: U, feeDiscountPubkey: W, maxTs: _ }) {
      const { transaction: R, signers: N } = await this.makePlaceOrderTransaction(D, {
        owner: F,
        payer: G,
        side: re,
        price: ie,
        size: ee,
        orderType: $,
        clientId: w,
        openOrdersAddressKey: E,
        openOrdersAccount: U,
        feeDiscountPubkey: W,
        maxTs: _
      });
      return await this._sendTransaction(D, R, [
        F,
        ...N
      ]);
    }
    getSplTokenBalanceFromAccountInfo(D, F) {
      return v(new a.default(D.data.slice(64, 72), 10, "le"), new a.default(10).pow(new a.default(F)));
    }
    get supportsSrmFeeDiscounts() {
      return u.supportsSrmFeeDiscounts(this._programId);
    }
    get supportsReferralFees() {
      return l.getLayoutVersion(this._programId) > 1;
    }
    get usesRequestQueue() {
      return l.getLayoutVersion(this._programId) <= 2;
    }
    async findFeeDiscountKeys(D, F, G = 0) {
      let re = [];
      const ie = (/* @__PURE__ */ new Date()).getTime(), ee = F.toBase58();
      if (ee in this._feeDiscountKeysCache && ie - this._feeDiscountKeysCache[ee].ts < G)
        return this._feeDiscountKeysCache[ee].accounts;
      if (this.supportsSrmFeeDiscounts) {
        const $ = (await this.getTokenAccountsByOwnerForMint(D, F, d.MSRM_MINT)).map(({ pubkey: E, account: U }) => {
          const W = this.getSplTokenBalanceFromAccountInfo(U, d.MSRM_DECIMALS);
          return {
            pubkey: E,
            mint: d.MSRM_MINT,
            balance: W,
            feeTier: u.getFeeTier(W, 0)
          };
        }), w = (await this.getTokenAccountsByOwnerForMint(D, F, d.SRM_MINT)).map(({ pubkey: E, account: U }) => {
          const W = this.getSplTokenBalanceFromAccountInfo(U, d.SRM_DECIMALS);
          return {
            pubkey: E,
            mint: d.SRM_MINT,
            balance: W,
            feeTier: u.getFeeTier(0, W)
          };
        });
        re = $.concat(w).sort((E, U) => E.feeTier > U.feeTier ? -1 : E.feeTier < U.feeTier ? 1 : E.balance > U.balance ? -1 : E.balance < U.balance ? 1 : 0);
      }
      return this._feeDiscountKeysCache[ee] = {
        accounts: re,
        ts: ie
      }, re;
    }
    async findBestFeeDiscountKey(D, F, G = 3e4) {
      const re = await this.findFeeDiscountKeys(D, F, G);
      return re.length > 0 ? {
        pubkey: re[0].pubkey,
        feeTier: re[0].feeTier
      } : {
        pubkey: null,
        feeTier: 0
      };
    }
    async makePlaceOrderTransaction(D, { owner: F, payer: G, side: re, price: ie, size: ee, orderType: $ = "limit", clientId: w, openOrdersAddressKey: E, openOrdersAccount: U, feeDiscountPubkey: W = void 0, selfTradeBehavior: _ = "decrementTake", maxTs: R }, N = 0, O = 0) {
      var g, M;
      const Y = (g = F.publicKey) !== null && g !== void 0 ? g : F, se = await this.findOpenOrdersAccountsForOwner(D, Y, N), V = new o.Transaction(), K = [];
      let Z;
      W ? Z = W : W === void 0 && this.supportsSrmFeeDiscounts ? Z = (await this.findBestFeeDiscountKey(D, Y, O)).pubkey : Z = null;
      let ne;
      if (se.length === 0) {
        let J;
        U ? J = U : J = new o.Account(), V.add(await y.makeCreateAccountTransaction(D, this.address, Y, J.publicKey, this._programId)), ne = J.publicKey, K.push(J), this._openOrdersAccountsCache[Y.toBase58()].ts = 0;
      } else
        U ? ne = U.publicKey : E ? ne = E : ne = se[0].address;
      let ce = null;
      if (G.equals(Y))
        if (re === "buy" && this.quoteMintAddress.equals(d.WRAPPED_SOL_MINT) || re === "sell" && this.baseMintAddress.equals(d.WRAPPED_SOL_MINT)) {
          ce = new o.Account();
          let J;
          re === "buy" ? (J = Math.round(ie * ee * 1.01 * o.LAMPORTS_PER_SOL), se.length > 0 && (J -= se[0].quoteTokenFree.toNumber())) : (J = Math.round(ee * o.LAMPORTS_PER_SOL), se.length > 0 && (J -= se[0].baseTokenFree.toNumber())), J = Math.max(J, 0) + 1e7, V.add(o.SystemProgram.createAccount({
            fromPubkey: Y,
            newAccountPubkey: ce.publicKey,
            lamports: J,
            space: 165,
            programId: d.TOKEN_PROGRAM_ID
          })), V.add(d.initializeAccount({
            account: ce.publicKey,
            mint: d.WRAPPED_SOL_MINT,
            owner: Y
          })), K.push(ce);
        } else
          throw new Error("Invalid payer account");
      const H = this.makePlaceOrderInstruction(D, {
        owner: F,
        payer: (M = ce == null ? void 0 : ce.publicKey) !== null && M !== void 0 ? M : G,
        side: re,
        price: ie,
        size: ee,
        orderType: $,
        clientId: w,
        openOrdersAddressKey: ne,
        feeDiscountPubkey: Z,
        selfTradeBehavior: _,
        maxTs: R
      });
      return V.add(H), ce && V.add(d.closeAccount({
        source: ce.publicKey,
        destination: Y,
        owner: Y
      })), { transaction: V, signers: K, payer: F };
    }
    makePlaceOrderInstruction(D, F) {
      var G;
      const { owner: re, payer: ie, side: ee, price: $, size: w, orderType: E = "limit", clientId: U, openOrdersAddressKey: W, openOrdersAccount: _, feeDiscountPubkey: R = null, maxTs: N } = F, O = (G = re.publicKey) !== null && G !== void 0 ? G : re;
      if (this.baseSizeNumberToLots(w).lte(new a.default(0)))
        throw new Error("size too small");
      if (this.priceNumberToLots($).lte(new a.default(0)))
        throw new Error("invalid price");
      return this.usesRequestQueue ? s.DexInstructions.newOrder({
        market: this.address,
        requestQueue: this._decoded.requestQueue,
        baseVault: this._decoded.baseVault,
        quoteVault: this._decoded.quoteVault,
        openOrders: _ ? _.publicKey : W,
        owner: O,
        payer: ie,
        side: ee,
        limitPrice: this.priceNumberToLots($),
        maxQuantity: this.baseSizeNumberToLots(w),
        orderType: E,
        clientId: U,
        programId: this._programId,
        feeDiscountPubkey: this.supportsSrmFeeDiscounts ? R : null
      }) : this.makeNewOrderV3Instruction(F);
    }
    makeNewOrderV3Instruction(D) {
      var F;
      const { owner: G, payer: re, side: ie, price: ee, size: $, orderType: w = "limit", clientId: E, openOrdersAddressKey: U, openOrdersAccount: W, feeDiscountPubkey: _ = null, selfTradeBehavior: R = "decrementTake", programId: N, maxTs: O } = D, g = (F = G.publicKey) !== null && F !== void 0 ? F : G;
      return s.DexInstructions.newOrderV3({
        market: this.address,
        bids: this._decoded.bids,
        asks: this._decoded.asks,
        requestQueue: this._decoded.requestQueue,
        eventQueue: this._decoded.eventQueue,
        baseVault: this._decoded.baseVault,
        quoteVault: this._decoded.quoteVault,
        openOrders: W ? W.publicKey : U,
        owner: g,
        payer: re,
        side: ie,
        limitPrice: this.priceNumberToLots(ee),
        maxBaseQuantity: this.baseSizeNumberToLots($),
        maxQuoteQuantity: new a.default(this._decoded.quoteLotSize.toNumber()).mul(this.baseSizeNumberToLots($).mul(this.priceNumberToLots(ee))),
        orderType: w,
        clientId: E,
        programId: N ?? this._programId,
        selfTradeBehavior: R,
        // @ts-ignore
        feeDiscountPubkey: this.supportsSrmFeeDiscounts ? _ : null,
        // @ts-ignore
        maxTs: O
      });
    }
    async _sendTransaction(D, F, G) {
      const re = await D.sendTransaction(F, G, {
        skipPreflight: this._skipPreflight
      }), { value: ie } = await D.confirmTransaction(re, this._commitment);
      if (ie != null && ie.err)
        throw new Error(JSON.stringify(ie.err));
      return re;
    }
    async cancelOrderByClientId(D, F, G, re) {
      const ie = await this.makeCancelOrderByClientIdTransaction(D, F.publicKey, G, re);
      return await this._sendTransaction(D, ie, [F]);
    }
    async cancelOrdersByClientIds(D, F, G, re) {
      const ie = await this.makeCancelOrdersByClientIdsTransaction(D, F.publicKey, G, re);
      return await this._sendTransaction(D, ie, [F]);
    }
    async makeCancelOrderByClientIdTransaction(D, F, G, re) {
      const ie = new o.Transaction();
      return this.usesRequestQueue ? ie.add(s.DexInstructions.cancelOrderByClientId({
        market: this.address,
        owner: F,
        openOrders: G,
        requestQueue: this._decoded.requestQueue,
        clientId: re,
        programId: this._programId
      })) : ie.add(s.DexInstructions.cancelOrderByClientIdV2({
        market: this.address,
        openOrders: G,
        owner: F,
        bids: this._decoded.bids,
        asks: this._decoded.asks,
        eventQueue: this._decoded.eventQueue,
        clientId: re,
        programId: this._programId
      })), ie;
    }
    async makeCancelOrdersByClientIdsTransaction(D, F, G, re) {
      const ie = new o.Transaction();
      return ie.add(s.DexInstructions.cancelOrdersByClientIds({
        market: this.address,
        openOrders: G,
        owner: F,
        bids: this._decoded.bids,
        asks: this._decoded.asks,
        eventQueue: this._decoded.eventQueue,
        clientIds: re,
        programId: this._programId
      })), ie;
    }
    async cancelOrder(D, F, G) {
      const re = await this.makeCancelOrderTransaction(D, F.publicKey, G);
      return await this._sendTransaction(D, re, [F]);
    }
    async makeCancelOrderTransaction(D, F, G) {
      const re = new o.Transaction();
      return re.add(this.makeCancelOrderInstruction(D, F, G)), re;
    }
    makeCancelOrderInstruction(D, F, G) {
      return this.usesRequestQueue ? s.DexInstructions.cancelOrder({
        market: this.address,
        owner: F,
        openOrders: G.openOrdersAddress,
        requestQueue: this._decoded.requestQueue,
        side: G.side,
        orderId: G.orderId,
        openOrdersSlot: G.openOrdersSlot,
        programId: this._programId
      }) : s.DexInstructions.cancelOrderV2({
        market: this.address,
        owner: F,
        openOrders: G.openOrdersAddress,
        bids: this._decoded.bids,
        asks: this._decoded.asks,
        eventQueue: this._decoded.eventQueue,
        side: G.side,
        orderId: G.orderId,
        openOrdersSlot: G.openOrdersSlot,
        programId: this._programId
      });
    }
    makeConsumeEventsInstruction(D, F) {
      return s.DexInstructions.consumeEvents({
        market: this.address,
        eventQueue: this._decoded.eventQueue,
        coinFee: this._decoded.eventQueue,
        pcFee: this._decoded.eventQueue,
        openOrdersAccounts: D,
        limit: F,
        programId: this._programId
      });
    }
    makeConsumeEventsPermissionedInstruction(D, F) {
      return s.DexInstructions.consumeEventsPermissioned({
        market: this.address,
        eventQueue: this._decoded.eventQueue,
        crankAuthority: this._decoded.consumeEventsAuthority,
        openOrdersAccounts: D,
        limit: F,
        programId: this._programId
      });
    }
    async settleFunds(D, F, G, re, ie, ee = null) {
      if (!G.owner.equals(F.publicKey))
        throw new Error("Invalid open orders account");
      if (ee && !this.supportsReferralFees)
        throw new Error("This program ID does not support referrerQuoteWallet");
      const { transaction: $, signers: w } = await this.makeSettleFundsTransaction(D, G, re, ie, ee);
      return await this._sendTransaction(D, $, [
        F,
        ...w
      ]);
    }
    async makeSettleFundsTransaction(D, F, G, re, ie = null) {
      const ee = await o.PublicKey.createProgramAddress([
        this.address.toBuffer(),
        this._decoded.vaultSignerNonce.toArrayLike(f.Buffer, "le", 8)
      ], this._programId), $ = new o.Transaction(), w = [];
      let E = null;
      return (this.baseMintAddress.equals(d.WRAPPED_SOL_MINT) && G.equals(F.owner) || this.quoteMintAddress.equals(d.WRAPPED_SOL_MINT) && re.equals(F.owner)) && (E = new o.Account(), $.add(o.SystemProgram.createAccount({
        fromPubkey: F.owner,
        newAccountPubkey: E.publicKey,
        lamports: await D.getMinimumBalanceForRentExemption(165),
        space: 165,
        programId: d.TOKEN_PROGRAM_ID
      })), $.add(d.initializeAccount({
        account: E.publicKey,
        mint: d.WRAPPED_SOL_MINT,
        owner: F.owner
      })), w.push(E)), $.add(s.DexInstructions.settleFunds({
        market: this.address,
        openOrders: F.address,
        owner: F.owner,
        baseVault: this._decoded.baseVault,
        quoteVault: this._decoded.quoteVault,
        baseWallet: G.equals(F.owner) && E ? E.publicKey : G,
        quoteWallet: re.equals(F.owner) && E ? E.publicKey : re,
        vaultSigner: ee,
        programId: this._programId,
        referrerQuoteWallet: ie
      })), E && $.add(d.closeAccount({
        source: E.publicKey,
        destination: F.owner,
        owner: F.owner
      })), { transaction: $, signers: w, payer: F.owner };
    }
    async matchOrders(D, F, G) {
      const re = this.makeMatchOrdersTransaction(G);
      return await this._sendTransaction(D, re, [F]);
    }
    makeMatchOrdersTransaction(D) {
      const F = new o.Transaction();
      return F.add(s.DexInstructions.matchOrders({
        market: this.address,
        requestQueue: this._decoded.requestQueue,
        eventQueue: this._decoded.eventQueue,
        bids: this._decoded.bids,
        asks: this._decoded.asks,
        baseVault: this._decoded.baseVault,
        quoteVault: this._decoded.quoteVault,
        limit: D,
        programId: this._programId
      })), F;
    }
    async loadRequestQueue(D) {
      const { data: F } = P(await D.getAccountInfo(this._decoded.requestQueue));
      return c.decodeRequestQueue(F);
    }
    async loadEventQueue(D) {
      const { data: F } = P(await D.getAccountInfo(this._decoded.eventQueue));
      return c.decodeEventQueue(F);
    }
    async loadFills(D, F = 100) {
      const { data: G } = P(await D.getAccountInfo(this._decoded.eventQueue));
      return c.decodeEventQueue(G, F).filter((ie) => ie.eventFlags.fill && ie.nativeQuantityPaid.gtn(0)).map(this.parseFillEvent.bind(this));
    }
    parseFillEvent(D) {
      let F, G, re, ie;
      return D.eventFlags.bid ? (re = "buy", ie = D.eventFlags.maker ? D.nativeQuantityPaid.add(D.nativeFeeOrRebate) : D.nativeQuantityPaid.sub(D.nativeFeeOrRebate), G = v(ie.mul(this._baseSplTokenMultiplier), this._quoteSplTokenMultiplier.mul(D.nativeQuantityReleased)), F = v(D.nativeQuantityReleased, this._baseSplTokenMultiplier)) : (re = "sell", ie = D.eventFlags.maker ? D.nativeQuantityReleased.sub(D.nativeFeeOrRebate) : D.nativeQuantityReleased.add(D.nativeFeeOrRebate), G = v(ie.mul(this._baseSplTokenMultiplier), this._quoteSplTokenMultiplier.mul(D.nativeQuantityPaid)), F = v(D.nativeQuantityPaid, this._baseSplTokenMultiplier)), {
        ...D,
        side: re,
        price: G,
        feeCost: this.quoteSplSizeToNumber(D.nativeFeeOrRebate) * (D.eventFlags.maker ? -1 : 1),
        size: F
      };
    }
    get _baseSplTokenMultiplier() {
      return new a.default(10).pow(new a.default(this._baseSplTokenDecimals));
    }
    get _quoteSplTokenMultiplier() {
      return new a.default(10).pow(new a.default(this._quoteSplTokenDecimals));
    }
    priceLotsToNumber(D) {
      return v(D.mul(this._decoded.quoteLotSize).mul(this._baseSplTokenMultiplier), this._decoded.baseLotSize.mul(this._quoteSplTokenMultiplier));
    }
    priceNumberToLots(D) {
      return new a.default(Math.round(D * Math.pow(10, this._quoteSplTokenDecimals) * this._decoded.baseLotSize.toNumber() / (Math.pow(10, this._baseSplTokenDecimals) * this._decoded.quoteLotSize.toNumber())));
    }
    baseSplSizeToNumber(D) {
      return v(D, this._baseSplTokenMultiplier);
    }
    quoteSplSizeToNumber(D) {
      return v(D, this._quoteSplTokenMultiplier);
    }
    baseSizeLotsToNumber(D) {
      return v(D.mul(this._decoded.baseLotSize), this._baseSplTokenMultiplier);
    }
    baseSizeNumberToLots(D) {
      return new a.default(Math.round(D * Math.pow(10, this._baseSplTokenDecimals))).div(this._decoded.baseLotSize);
    }
    quoteSizeLotsToNumber(D) {
      return v(D.mul(this._decoded.quoteLotSize), this._quoteSplTokenMultiplier);
    }
    quoteSizeNumberToLots(D) {
      return new a.default(Math.round(D * Math.pow(10, this._quoteSplTokenDecimals))).div(this._decoded.quoteLotSize);
    }
    get minOrderSize() {
      return this.baseSizeLotsToNumber(new a.default(1));
    }
    get tickSize() {
      return this.priceLotsToNumber(new a.default(1));
    }
  }
  t.Market = h, t._OPEN_ORDERS_LAYOUT_V1 = r.struct([
    r.blob(5),
    n.accountFlagsLayout("accountFlags"),
    n.publicKeyLayout("market"),
    n.publicKeyLayout("owner"),
    // These are in spl-token (i.e. not lot) units
    n.u64("baseTokenFree"),
    n.u64("baseTokenTotal"),
    n.u64("quoteTokenFree"),
    n.u64("quoteTokenTotal"),
    n.u128("freeSlotBits"),
    n.u128("isBidBits"),
    r.seq(n.u128(), 128, "orders"),
    r.seq(n.u64(), 128, "clientIds"),
    r.blob(7)
  ]), t._OPEN_ORDERS_LAYOUT_V2 = r.struct([
    r.blob(5),
    n.accountFlagsLayout("accountFlags"),
    n.publicKeyLayout("market"),
    n.publicKeyLayout("owner"),
    // These are in spl-token (i.e. not lot) units
    n.u64("baseTokenFree"),
    n.u64("baseTokenTotal"),
    n.u64("quoteTokenFree"),
    n.u64("quoteTokenTotal"),
    n.u128("freeSlotBits"),
    n.u128("isBidBits"),
    r.seq(n.u128(), 128, "orders"),
    r.seq(n.u64(), 128, "clientIds"),
    n.u64("referrerRebatesAccrued"),
    r.blob(7)
  ]);
  class y {
    constructor(D, F, G) {
      this.address = D, this._programId = G, Object.assign(this, F);
    }
    static getLayout(D) {
      return l.getLayoutVersion(D) === 1 ? t._OPEN_ORDERS_LAYOUT_V1 : t._OPEN_ORDERS_LAYOUT_V2;
    }
    static async findForOwner(D, F, G) {
      const re = [
        {
          memcmp: {
            offset: this.getLayout(G).offsetOf("owner"),
            bytes: F.toBase58()
          }
        },
        {
          dataSize: this.getLayout(G).span
        }
      ];
      return (await L(D, G, re)).map(({ publicKey: ee, accountInfo: $ }) => y.fromAccountInfo(ee, $, G));
    }
    static async findForMarketAndOwner(D, F, G, re) {
      const ie = [
        {
          memcmp: {
            offset: this.getLayout(re).offsetOf("market"),
            bytes: F.toBase58()
          }
        },
        {
          memcmp: {
            offset: this.getLayout(re).offsetOf("owner"),
            bytes: G.toBase58()
          }
        },
        {
          dataSize: this.getLayout(re).span
        }
      ];
      return (await L(D, re, ie)).map(({ publicKey: $, accountInfo: w }) => y.fromAccountInfo($, w, re));
    }
    static async load(D, F, G) {
      const re = await D.getAccountInfo(F);
      if (re === null)
        throw new Error("Open orders account not found");
      return y.fromAccountInfo(F, re, G);
    }
    static fromAccountInfo(D, F, G) {
      const { owner: re, data: ie } = F;
      if (!re.equals(G))
        throw new Error("Address not owned by program");
      const ee = this.getLayout(G).decode(ie);
      if (!ee.accountFlags.initialized || !ee.accountFlags.openOrders)
        throw new Error("Invalid open orders account");
      return new y(D, ee, G);
    }
    static async makeCreateAccountTransaction(D, F, G, re, ie) {
      return o.SystemProgram.createAccount({
        fromPubkey: G,
        newAccountPubkey: re,
        lamports: await D.getMinimumBalanceForRentExemption(this.getLayout(ie).span),
        space: this.getLayout(ie).span,
        programId: ie
      });
    }
    get publicKey() {
      return this.address;
    }
  }
  t.OpenOrders = y, t.ORDERBOOK_LAYOUT = r.struct([
    r.blob(5),
    n.accountFlagsLayout("accountFlags"),
    i.SLAB_LAYOUT.replicate("slab"),
    r.blob(7)
  ]);
  class p {
    constructor(D, F, G) {
      if (!F.initialized || !(F.bids ^ F.asks))
        throw new Error("Invalid orderbook");
      this.market = D, this.isBids = F.bids, this.slab = G;
    }
    static get LAYOUT() {
      return t.ORDERBOOK_LAYOUT;
    }
    static decode(D, F) {
      const { accountFlags: G, slab: re } = t.ORDERBOOK_LAYOUT.decode(F);
      return new p(D, G, re);
    }
    getL2(D) {
      const F = this.isBids, G = [];
      for (const { key: re, quantity: ie } of this.slab.items(F)) {
        const ee = b(re);
        if (G.length > 0 && G[G.length - 1][0].eq(ee))
          G[G.length - 1][1] = G[G.length - 1][1].add(ie);
        else {
          if (G.length === D)
            break;
          G.push([ee, ie]);
        }
      }
      return G.map(([re, ie]) => [
        this.market.priceLotsToNumber(re),
        this.market.baseSizeLotsToNumber(ie),
        re,
        ie
      ]);
    }
    [Symbol.iterator]() {
      return this.items(!1);
    }
    *items(D = !1) {
      for (const { key: F, ownerSlot: G, owner: re, quantity: ie, feeTier: ee, clientOrderId: $ } of this.slab.items(D)) {
        const w = b(F);
        yield {
          orderId: F,
          clientId: $,
          openOrdersAddress: re,
          openOrdersSlot: G,
          feeTier: ee,
          price: this.market.priceLotsToNumber(w),
          priceLots: w,
          size: this.market.baseSizeLotsToNumber(ie),
          sizeLots: ie,
          side: this.isBids ? "buy" : "sell"
        };
      }
    }
  }
  t.Orderbook = p;
  function b(C) {
    return C.ushrn(64);
  }
  function v(C, D) {
    const F = C.div(D).toNumber(), G = C.umod(D), re = G.gcd(D);
    return F + G.div(re).toNumber() / D.div(re).toNumber();
  }
  const x = r.struct([r.blob(44), r.u8("decimals"), r.blob(37)]);
  async function I(C, D) {
    if (D.equals(d.WRAPPED_SOL_MINT))
      return 9;
    const { data: F } = P(await C.getAccountInfo(D), "mint not found"), { decimals: G } = x.decode(F);
    return G;
  }
  t.getMintDecimals = I;
  async function L(C, D, F) {
    const G = await C._rpcRequest("getProgramAccounts", [
      D.toBase58(),
      {
        commitment: C.commitment,
        filters: F,
        encoding: "base64"
      }
    ]);
    if (G.error)
      throw new Error(G.error.message);
    return G.result.map(({ pubkey: re, account: { data: ie, executable: ee, owner: $, lamports: w } }) => ({
      publicKey: new o.PublicKey(re),
      accountInfo: {
        data: f.Buffer.from(ie[0], "base64"),
        executable: ee,
        owner: new o.PublicKey($),
        lamports: w
      }
    }));
  }
  function P(C, D = "account not found") {
    if (C === null)
      throw new Error(D);
    return C;
  }
})(_T);
var Xk = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.parseInstructionErrorResponse = t.KNOWN_PROGRAMS = t.DexError = void 0;
  const e = Of, r = Vl, n = zl;
  var i;
  (function(a) {
    a[a.InvalidMarketFlags = 0] = "InvalidMarketFlags", a[a.InvalidAskFlags = 1] = "InvalidAskFlags", a[a.InvalidBidFlags = 2] = "InvalidBidFlags", a[a.InvalidQueueLength = 3] = "InvalidQueueLength", a[a.OwnerAccountNotProvided = 4] = "OwnerAccountNotProvided", a[a.ConsumeEventsQueueFailure = 5] = "ConsumeEventsQueueFailure", a[a.WrongCoinVault = 6] = "WrongCoinVault", a[a.WrongPcVault = 7] = "WrongPcVault", a[a.WrongCoinMint = 8] = "WrongCoinMint", a[a.WrongPcMint = 9] = "WrongPcMint", a[a.CoinVaultProgramId = 10] = "CoinVaultProgramId", a[a.PcVaultProgramId = 11] = "PcVaultProgramId", a[a.CoinMintProgramId = 12] = "CoinMintProgramId", a[a.PcMintProgramId = 13] = "PcMintProgramId", a[a.WrongCoinMintSize = 14] = "WrongCoinMintSize", a[a.WrongPcMintSize = 15] = "WrongPcMintSize", a[a.WrongCoinVaultSize = 16] = "WrongCoinVaultSize", a[a.WrongPcVaultSize = 17] = "WrongPcVaultSize", a[a.UninitializedVault = 18] = "UninitializedVault", a[a.UninitializedMint = 19] = "UninitializedMint", a[a.CoinMintUninitialized = 20] = "CoinMintUninitialized", a[a.PcMintUninitialized = 21] = "PcMintUninitialized", a[a.WrongMint = 22] = "WrongMint", a[a.WrongVaultOwner = 23] = "WrongVaultOwner", a[a.VaultHasDelegate = 24] = "VaultHasDelegate", a[a.AlreadyInitialized = 25] = "AlreadyInitialized", a[a.WrongAccountDataAlignment = 26] = "WrongAccountDataAlignment", a[a.WrongAccountDataPaddingLength = 27] = "WrongAccountDataPaddingLength", a[a.WrongAccountHeadPadding = 28] = "WrongAccountHeadPadding", a[a.WrongAccountTailPadding = 29] = "WrongAccountTailPadding", a[a.RequestQueueEmpty = 30] = "RequestQueueEmpty", a[a.EventQueueTooSmall = 31] = "EventQueueTooSmall", a[a.SlabTooSmall = 32] = "SlabTooSmall", a[a.BadVaultSignerNonce = 33] = "BadVaultSignerNonce", a[a.InsufficientFunds = 34] = "InsufficientFunds", a[a.SplAccountProgramId = 35] = "SplAccountProgramId", a[a.SplAccountLen = 36] = "SplAccountLen", a[a.WrongFeeDiscountAccountOwner = 37] = "WrongFeeDiscountAccountOwner", a[a.WrongFeeDiscountMint = 38] = "WrongFeeDiscountMint", a[a.CoinPayerProgramId = 39] = "CoinPayerProgramId", a[a.PcPayerProgramId = 40] = "PcPayerProgramId", a[a.ClientIdNotFound = 41] = "ClientIdNotFound", a[a.TooManyOpenOrders = 42] = "TooManyOpenOrders", a[a.FakeErrorSoWeDontChangeNumbers = 43] = "FakeErrorSoWeDontChangeNumbers", a[a.BorrowError = 44] = "BorrowError", a[a.WrongOrdersAccount = 45] = "WrongOrdersAccount", a[a.WrongBidsAccount = 46] = "WrongBidsAccount", a[a.WrongAsksAccount = 47] = "WrongAsksAccount", a[a.WrongRequestQueueAccount = 48] = "WrongRequestQueueAccount", a[a.WrongEventQueueAccount = 49] = "WrongEventQueueAccount", a[a.RequestQueueFull = 50] = "RequestQueueFull", a[a.EventQueueFull = 51] = "EventQueueFull", a[a.MarketIsDisabled = 52] = "MarketIsDisabled", a[a.WrongSigner = 53] = "WrongSigner", a[a.TransferFailed = 54] = "TransferFailed", a[a.ClientOrderIdIsZero = 55] = "ClientOrderIdIsZero", a[a.WrongRentSysvarAccount = 56] = "WrongRentSysvarAccount", a[a.RentNotProvided = 57] = "RentNotProvided", a[a.OrdersNotRentExempt = 58] = "OrdersNotRentExempt", a[a.OrderNotFound = 59] = "OrderNotFound", a[a.OrderNotYours = 60] = "OrderNotYours", a[a.WouldSelfTrade = 61] = "WouldSelfTrade", a[a.Unknown = 1e3] = "Unknown";
  })(i = t.DexError || (t.DexError = {})), t.KNOWN_PROGRAMS = {
    [n.TOKEN_PROGRAM_ID.toString()]: "Token program",
    [e.SystemProgram.programId.toString()]: "System program"
  };
  function s(a, o) {
    const [c, f] = o, u = a.instructions[c];
    let d;
    return u.programId.toString() in r.PROGRAM_LAYOUT_VERSIONS ? d = i[f.Custom] : u.programId.toString() in t.KNOWN_PROGRAMS ? d = `${t.KNOWN_PROGRAMS[u.programId.toString()]} error ${f.Custom}` : d = `Unknown program ${u.programId.toString()} custom error: ${f.Custom}`, {
      failedInstructionIndex: c,
      error: d,
      failedProgram: u.programId.toString()
    };
  }
  t.parseInstructionErrorResponse = s;
})(Xk);
(function(t) {
  var e = Ne && Ne.__createBinding || (Object.create ? function(u, d, l, h) {
    h === void 0 && (h = l), Object.defineProperty(u, h, { enumerable: !0, get: function() {
      return d[l];
    } });
  } : function(u, d, l, h) {
    h === void 0 && (h = l), u[h] = d[l];
  }), r = Ne && Ne.__setModuleDefault || (Object.create ? function(u, d) {
    Object.defineProperty(u, "default", { enumerable: !0, value: d });
  } : function(u, d) {
    u.default = d;
  }), n = Ne && Ne.__importStar || function(u) {
    if (u && u.__esModule)
      return u;
    var d = {};
    if (u != null)
      for (var l in u)
        l !== "default" && Object.prototype.hasOwnProperty.call(u, l) && e(d, u, l);
    return r(d, u), d;
  }, i = Ne && Ne.__exportStar || function(u, d) {
    for (var l in u)
      l !== "default" && !Object.prototype.hasOwnProperty.call(d, l) && e(d, u, l);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.TokenInstructions = t.EVENT_QUEUE_LAYOUT = t.REQUEST_QUEUE_LAYOUT = t.decodeRequestQueue = t.decodeEventQueue = t.getLayoutVersion = t.MARKETS = t.TOKEN_MINTS = t.supportsSrmFeeDiscounts = t.getFeeRates = t.getFeeTier = t.NEW_ORDER_V3_OWNER_INDEX = t.NEW_ORDER_V3_OPEN_ORDERS_INDEX = t.NEW_ORDER_OWNER_INDEX = t.NEW_ORDER_OPEN_ORDERS_INDEX = t.SETTLE_FUNDS_QUOTE_WALLET_INDEX = t.SETTLE_FUNDS_BASE_WALLET_INDEX = t.decodeInstructionV2 = t.decodeInstruction = t.DexInstructions = t.MARKET_STATE_LAYOUT_V2 = t.MARKET_STATE_LAYOUT_V3 = t.OpenOrders = t.Orderbook = t.Market = void 0;
  var s = _T;
  Object.defineProperty(t, "Market", { enumerable: !0, get: function() {
    return s.Market;
  } }), Object.defineProperty(t, "Orderbook", { enumerable: !0, get: function() {
    return s.Orderbook;
  } }), Object.defineProperty(t, "OpenOrders", { enumerable: !0, get: function() {
    return s.OpenOrders;
  } }), Object.defineProperty(t, "MARKET_STATE_LAYOUT_V3", { enumerable: !0, get: function() {
    return s.MARKET_STATE_LAYOUT_V3;
  } }), Object.defineProperty(t, "MARKET_STATE_LAYOUT_V2", { enumerable: !0, get: function() {
    return s.MARKET_STATE_LAYOUT_V2;
  } });
  var a = C_;
  Object.defineProperty(t, "DexInstructions", { enumerable: !0, get: function() {
    return a.DexInstructions;
  } }), Object.defineProperty(t, "decodeInstruction", { enumerable: !0, get: function() {
    return a.decodeInstruction;
  } }), Object.defineProperty(t, "decodeInstructionV2", { enumerable: !0, get: function() {
    return a.decodeInstructionV2;
  } }), Object.defineProperty(t, "SETTLE_FUNDS_BASE_WALLET_INDEX", { enumerable: !0, get: function() {
    return a.SETTLE_FUNDS_BASE_WALLET_INDEX;
  } }), Object.defineProperty(t, "SETTLE_FUNDS_QUOTE_WALLET_INDEX", { enumerable: !0, get: function() {
    return a.SETTLE_FUNDS_QUOTE_WALLET_INDEX;
  } }), Object.defineProperty(t, "NEW_ORDER_OPEN_ORDERS_INDEX", { enumerable: !0, get: function() {
    return a.NEW_ORDER_OPEN_ORDERS_INDEX;
  } }), Object.defineProperty(t, "NEW_ORDER_OWNER_INDEX", { enumerable: !0, get: function() {
    return a.NEW_ORDER_OWNER_INDEX;
  } }), Object.defineProperty(t, "NEW_ORDER_V3_OPEN_ORDERS_INDEX", { enumerable: !0, get: function() {
    return a.NEW_ORDER_V3_OPEN_ORDERS_INDEX;
  } }), Object.defineProperty(t, "NEW_ORDER_V3_OWNER_INDEX", { enumerable: !0, get: function() {
    return a.NEW_ORDER_V3_OWNER_INDEX;
  } });
  var o = Ma;
  Object.defineProperty(t, "getFeeTier", { enumerable: !0, get: function() {
    return o.getFeeTier;
  } }), Object.defineProperty(t, "getFeeRates", { enumerable: !0, get: function() {
    return o.getFeeRates;
  } }), Object.defineProperty(t, "supportsSrmFeeDiscounts", { enumerable: !0, get: function() {
    return o.supportsSrmFeeDiscounts;
  } });
  var c = Vl;
  Object.defineProperty(t, "TOKEN_MINTS", { enumerable: !0, get: function() {
    return c.TOKEN_MINTS;
  } }), Object.defineProperty(t, "MARKETS", { enumerable: !0, get: function() {
    return c.MARKETS;
  } }), Object.defineProperty(t, "getLayoutVersion", { enumerable: !0, get: function() {
    return c.getLayoutVersion;
  } });
  var f = Li;
  Object.defineProperty(t, "decodeEventQueue", { enumerable: !0, get: function() {
    return f.decodeEventQueue;
  } }), Object.defineProperty(t, "decodeRequestQueue", { enumerable: !0, get: function() {
    return f.decodeRequestQueue;
  } }), Object.defineProperty(t, "REQUEST_QUEUE_LAYOUT", { enumerable: !0, get: function() {
    return f.REQUEST_QUEUE_LAYOUT;
  } }), Object.defineProperty(t, "EVENT_QUEUE_LAYOUT", { enumerable: !0, get: function() {
    return f.EVENT_QUEUE_LAYOUT;
  } }), t.TokenInstructions = n(zl), i(Xk, t);
})(QJ);
const cre = kJ(tn("instruction"));
cre.addVariant(
  12,
  Nt([gT("amount"), tn("decimals")]),
  "transferChecked"
);
function ure(t, e) {
  let r = e;
  for (; ; ) {
    let n = r & 127;
    if (r >>= 7, r === 0) {
      t.push(n);
      break;
    }
    n |= 128, t.push(n);
  }
}
const M4 = 255, Em = L0.sign.signatureLength;
function fre(t, e) {
  const r = [];
  ure(r, e.length);
  const n = r.length + e.length * Em, i = t.length + n;
  if (e.length > M4)
    throw new Error(`Too many signatures: ${e.length} > ${M4}`);
  if (i > qd)
    throw new Error(`Transaction too large: ${i} > ${qd}`);
  const s = ve.alloc(i);
  return ve.from(r).copy(s), e.forEach((a, o) => {
    if (a !== null) {
      if (a.length !== Em)
        throw new Error("Invalid signature length");
      ve.from(a).copy(s, r.length + o * Em);
    }
  }), t.copy(s, n), s;
}
var dre = {}, e7 = {}, Hl = {};
Object.defineProperty(Hl, "__esModule", {
  value: !0
});
Hl.default = void 0;
class lre {
  update(e = {}) {
    throw new Error("Not Implemented");
  }
  toJSON() {
    throw new Error("Not Implemented");
  }
}
Hl.default = lre;
var Vy = {}, t7 = {}, N_ = {};
Object.defineProperty(N_, "__esModule", {
  value: !0
});
N_.default = pre;
var hre = Ps, C4 = ns;
function pre(t, e, r = []) {
  return (0, C4.mapValues)(t, (n, i) => {
    for (const s of e)
      if ((0, C4.isString)(n))
        try {
          const a = n.trim();
          return s.parse(a);
        } catch {
        }
    if (r.includes(i) && !(0, hre.isNumberUnit)(n))
      throw new Error(`mapCurrency invalid value ${JSON.stringify({
        [i]: n
      })}`);
    return n;
  });
}
var Hy = {};
Object.defineProperty(Hy, "__esModule", {
  value: !0
});
Hy.default = t2;
var xm = ns;
function t2(t, e) {
  return (0, xm.isPlainObject)(t) ? (0, xm.mapValues)(t, (r) => t2(r, e)) : (0, xm.isArray)(t) ? t.map((r) => t2(r, e)) : e(t);
}
var U_ = {};
Object.defineProperty(U_, "__esModule", {
  value: !0
});
U_.default = mre;
var yre = Ps, bre = gre(Hy);
function gre(t) {
  return t && t.__esModule ? t : { default: t };
}
function mre(t) {
  return (0, bre.default)(t, (e, r) => (0, yre.isNumberUnit)(e) ? e.toString() : e);
}
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "mapCurrency", {
    enumerable: !0,
    get: function() {
      return e.default;
    }
  }), Object.defineProperty(t, "mapValuesDeep", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(t, "modelToJSON", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  });
  var e = i(N_), r = i(Hy), n = i(U_);
  function i(s) {
    return s && s.__esModule ? s : { default: s };
  }
})(t7);
Object.defineProperty(Vy, "__esModule", {
  value: !0
});
Vy.default = void 0;
var N4 = ns, U4 = r7(hr), Ih = t7, vre = r7(Hl);
function r7(t) {
  return t && t.__esModule ? t : { default: t };
}
function L4(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Th(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? L4(Object(r), !0).forEach(function(n) {
      wre(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : L4(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function wre(t, e, r) {
  return e = _re(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function _re(t) {
  var e = Sre(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Sre(t, e) {
  if (typeof t != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
class Ere extends vre.default {
  // legacy arguments is to avoid breaking change while assets are being updated.
  constructor({
    currency: e,
    config: r,
    mainKey: n
  }) {
    super(), (0, U4.default)(r, "config has not been resolved"), (0, U4.default)(e, "currency has not been resolved");
    const i = (0, Ih.mapCurrency)(r, [e], [n]);
    Object.assign(this, i), this.origin = i.origin || i[n], Object.defineProperty(this, "currency", {
      value: e,
      enumerable: !1
    }), Object.defineProperty(this, "mainKey", {
      value: n,
      enumerable: !1
    });
  }
  update(e = {}) {
    if ((0, N4.isEmpty)(e))
      return this;
    e = (0, Ih.mapCurrency)(e, [this.currency], [this.mainKey]);
    const r = Th(Th({}, this), e);
    e[this.mainKey] && (r.origin = e[this.mainKey]);
    const {
      multiplier: n,
      max: i,
      min: s
    } = r;
    if (this.mainKey) {
      let a = r.origin;
      n && (a = a.mul(n)), i && (a = a.lte(i) ? a : i), s && (a = a.gte(s) ? a : s), r[this.mainKey] = a;
    }
    return (0, N4.isEqual)(this.toJSON(), (0, Ih.modelToJSON)(Th({}, r))) ? this : new this.constructor({
      config: r,
      mainKey: this.mainKey,
      currency: this.currency
    });
  }
  toJSON() {
    return (0, Ih.modelToJSON)(Th({}, this));
  }
}
Vy.default = Ere;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "BaseFeeData", {
    enumerable: !0,
    get: function() {
      return e.default;
    }
  }), Object.defineProperty(t, "FeeData", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  });
  var e = n(Hl), r = n(Vy);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
})(e7);
var n7 = {}, Gy = {}, qs, al, n2;
const Ji = class Ji {
  /**
   * The timer constructor.
   * @param {number} interval - the interval in ms when the timer will tick and run the callback.
   * @param {number} maxFuzziness - the maximum allowed time (in ms) for the timer to tick
   after being paused for an extended period and subsequently resumed. Used to limit resource contention
   through randomization, when multiple timers are resumed at the same time. Defaults to interval.
   */
  constructor(e, { maxFuzziness: r } = {}) {
    ct(this, al);
    Ji.validateInterval(e), this.timerId = void 0, this.interval = e, this.maxFuzziness = typeof r == "number" ? r : e, this.isCallbacking = !1, this.isRestarting = !1, this.pending = [], this.callback = void 0, this.pauseCheckpointTime = void 0, this.timeLeftAfterResume = void 0;
  }
  /**
   * Starts the timer, user must provide the callback if the timer wasn't started already.
   *
   * Start method will call the callback the first time if the initial is not provided or 0.
   * If initial delay > 0, callback will be executed after the initial delay, then every interval.
   * @param {Function=} callback - the function that's called when the timer ticks.
   * @param {boolean=} delayedStart - If the callback should be executed now or after the interval. Default is false, execute now.
   * @returns {Promise<void>} a promise that resolves now if the timer has started already or delayedStart:true,
   * otherwise it resolves after callback is executed for the first time.
   */
  start(e, { delayedStart: r } = {}) {
    if (this.callback = e || this.callback, !this.callback)
      throw new Error("Callback must be provided");
    return this.timerId ? Promise.resolve() : (this.timeLeftAfterResume = void 0, ke(Ji, qs).add(this), this.pauseCheckpointTime = Date.now(), r ? (this.timerId = setTimeout(() => this.tick(), this.interval), Promise.resolve()) : (this.timerId = !0, this.tick()));
  }
  /**
   * Stops the timer finishing up a running callback.
   * @returns {Promise<void>} that resolves when the last callback has finished.
   */
  stop() {
    return this.isRestarting = !1, Oo(this, al, n2).call(this);
  }
  /**
   * Pauses the timer flagging when the next callback should run after resume.
   *
   * E.g, Ticker runs every 10 seconds. It's pause after 3 seconds passed from the last execution. Resume will run the job in 7 seconds
   *
   */
  pause() {
    if (this.timerId === void 0)
      throw new Error("You cannot pause a timer that hasn't started or it has been stopped!");
    if (this.timeLeftAfterResume !== void 0)
      return;
    const e = Date.now();
    this.timeLeftAfterResume = this.pauseCheckpointTime ? Math.max(0, this.interval - (e - this.pauseCheckpointTime)) : 0, this.pauseCheckpointTime = e, clearTimeout(this.timerId);
  }
  /**
   * Resumes the timer. The callback is called after the "left-over" ms seconds from pause's interval have completed.
   */
  resume() {
    if (this.timerId === void 0)
      throw new Error("You cannot resume a timer that hasn't started or it has been stopped!");
    if (this.timeLeftAfterResume === void 0)
      return;
    const e = Date.now(), r = Math.max(
      this.timeLeftAfterResume - (e - this.pauseCheckpointTime),
      Math.round(this.maxFuzziness * this.timeLeftAfterResume / this.interval)
    );
    this.timerId = setTimeout(() => this.tick(), Math.min(this.timeLeftAfterResume, r)), this.pauseCheckpointTime = e - (this.interval - this.timeLeftAfterResume), this.timeLeftAfterResume = void 0;
  }
  /**
   * Performs one tick executing the callback. Once the callback has finished, it schedules the next tick in the configured interval.
   * @returns {Promise<void>} that resolves when the callback has finished.
   */
  async tick() {
    try {
      this.isCallbacking = !0, this.pauseCheckpointTime = Date.now(), await this.callback();
    } finally {
      for (const n of this.pending)
        n();
      this.pending.length = 0, this.isCallbacking = !1;
      const e = this.timerId === void 0, r = this.timeLeftAfterResume !== void 0;
      !e && !r && (this.timerId = setTimeout(() => this.tick(), this.interval));
    }
  }
  /**
   * @returns {boolean} if the timer is running, if it has started and not stopped. Note that pause is still 'running'
   */
  get isRunning() {
    return !!this.timerId || this.isRestarting;
  }
  /**
   * Changes the timer interval and restarts it if it is already started
   * @param {number}  newInterval the new interval
   * @returns {Promise<void>} that resolves when the
   */
  async setNewInterval(e) {
    if (Ji.validateInterval(e), this.interval = e, !!this.isRunning && (this.isRestarting = !0, await Oo(this, al, n2).call(this), this.isRestarting)) {
      const r = this.start();
      return this.isRestarting = !1, r;
    }
  }
  /**
   * Validates that the provided interval is a positive finite number. It raises an error if it's not valid.
   * @param {number} interval the interval to ve validated.
   */
  static validateInterval(e) {
    if (typeof e != "number" || e <= 0 || !Number.isFinite(e))
      throw new Error("Interval should be a positive number");
  }
  /**
   * Starts all the known timers. Note that stopped timers are removed from the registry.
   * @returns {Promise<Awaited<void>[]>} that resolves when all the timers have started.
   */
  static async startAll() {
    return Promise.all([...ke(Ji, qs)].map((e) => e.start()));
  }
  /**
   * Stops all the known registered timers. This method will clean up all the timers from the registry.
   * @returns {Promise<Awaited<void>[]>} a promise that resolves once all timers have stopped.
   */
  static stopAll() {
    return Promise.all([...ke(Ji, qs)].map((e) => e.stop()));
  }
  /**
   * Pauses all the registered timers. You can resume them later on.
   */
  static pauseAll() {
    [...ke(Ji, qs)].forEach((e) => e.pause());
  }
  /**
   * Resumes all the registered timers that have been paused.
   */
  static resumeAll() {
    [...ke(Ji, qs)].forEach((e) => e.resume());
  }
  /**
   * @returns {number} the number of registered timers.
   */
  static count() {
    return ke(Ji, qs).size;
  }
};
qs = new WeakMap(), al = new WeakSet(), n2 = function() {
  return this.timerId === void 0 ? Promise.resolve() : (clearTimeout(this.timerId), this.timeLeftAfterResume = void 0, ke(Ji, qs).delete(this), this.timerId = void 0, this.isCallbacking ? new Promise((e) => this.pending.push(e)) : Promise.resolve());
}, /**
 * The registry of known timers that have started and not cleared.
 * @type {Set<Timer>}
 */
ct(Ji, qs, /* @__PURE__ */ new Set());
let r2 = Ji;
const xre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Timer: r2
}, Symbol.toStringTag, { value: "Module" })), i7 = /* @__PURE__ */ ta(xre);
Object.defineProperty(Gy, "__esModule", {
  value: !0
});
Gy.default = void 0;
var Are = i7, Am = s7(hr), Ire = s7(Gw);
function s7(t) {
  return t && t.__esModule ? t : { default: t };
}
function kh(t, e, r) {
  return e = Tre(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Tre(t) {
  var e = kre(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function kre(t, e) {
  if (typeof t != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
class Rre {
  constructor({
    updateFee: e,
    interval: r,
    assetName: n
  }) {
    kh(this, "start", () => async () => {
      this.isStarted || (this.isStarted = !0, this.timer.start(() => {
        this.tick();
      }));
    }), kh(this, "update", () => async () => {
      if (this.isStarted)
        return this.tick();
    }), kh(this, "tick", async () => {
      try {
        const i = await this.fetchFee();
        await this.updateFee(this.assetName, i);
      } catch (i) {
        console.warn(`Fee monitor tick error for ${this.assetName}`, i.message, i);
      }
    }), kh(this, "stop", async () => {
      this.isStarted && (this.isStarted = !1, await this.timer.stop());
    }), (0, Am.default)(e, "updateFee is required"), (0, Am.default)(r, "interval is required"), (0, Am.default)(n, "assetName is required"), this.updateFee = e, this.timer = new Are.Timer((0, Ire.default)(r)), this.assetName = n, this.isStarted = !1;
  }
  async fetchFee() {
    throw new Error("Not Implemented");
  }
}
Gy.default = Rre;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "FeeMonitor", {
    enumerable: !0,
    get: function() {
      return e.default;
    }
  });
  var e = r(Gy);
  function r(n) {
    return n && n.__esModule ? n : { default: n };
  }
})(n7);
var Zy = {};
function Un() {
  this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
}
var Pre = Un;
Un.EventEmitter = Un;
Un.prototype._events = void 0;
Un.prototype._maxListeners = void 0;
Un.defaultMaxListeners = 10;
Un.prototype.setMaxListeners = function(t) {
  if (!Ore(t) || t < 0 || isNaN(t))
    throw TypeError("n must be a positive number");
  return this._maxListeners = t, this;
};
Un.prototype.emit = function(t) {
  var e, r, n, i, s, a;
  if (this._events || (this._events = {}), t === "error" && (!this._events.error || Hd(this._events.error) && !this._events.error.length)) {
    if (e = arguments[1], e instanceof Error)
      throw e;
    var o = new Error('Uncaught, unspecified "error" event. (' + e + ")");
    throw o.context = e, o;
  }
  if (r = this._events[t], a7(r))
    return !1;
  if (Da(r))
    switch (arguments.length) {
      case 1:
        r.call(this);
        break;
      case 2:
        r.call(this, arguments[1]);
        break;
      case 3:
        r.call(this, arguments[1], arguments[2]);
        break;
      default:
        i = Array.prototype.slice.call(arguments, 1), r.apply(this, i);
    }
  else if (Hd(r))
    for (i = Array.prototype.slice.call(arguments, 1), a = r.slice(), n = a.length, s = 0; s < n; s++)
      a[s].apply(this, i);
  return !0;
};
Un.prototype.addListener = function(t, e) {
  var r;
  if (!Da(e))
    throw TypeError("listener must be a function");
  return this._events || (this._events = {}), this._events.newListener && this.emit(
    "newListener",
    t,
    Da(e.listener) ? e.listener : e
  ), this._events[t] ? Hd(this._events[t]) ? this._events[t].push(e) : this._events[t] = [this._events[t], e] : this._events[t] = e, Hd(this._events[t]) && !this._events[t].warned && (a7(this._maxListeners) ? r = Un.defaultMaxListeners : r = this._maxListeners, r && r > 0 && this._events[t].length > r && (this._events[t].warned = !0, console.error(
    "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
    this._events[t].length
  ), typeof console.trace == "function" && console.trace())), this;
};
Un.prototype.on = Un.prototype.addListener;
Un.prototype.once = function(t, e) {
  if (!Da(e))
    throw TypeError("listener must be a function");
  var r = !1;
  function n() {
    this.removeListener(t, n), r || (r = !0, e.apply(this, arguments));
  }
  return n.listener = e, this.on(t, n), this;
};
Un.prototype.removeListener = function(t, e) {
  var r, n, i, s;
  if (!Da(e))
    throw TypeError("listener must be a function");
  if (!this._events || !this._events[t])
    return this;
  if (r = this._events[t], i = r.length, n = -1, r === e || Da(r.listener) && r.listener === e)
    delete this._events[t], this._events.removeListener && this.emit("removeListener", t, e);
  else if (Hd(r)) {
    for (s = i; s-- > 0; )
      if (r[s] === e || r[s].listener && r[s].listener === e) {
        n = s;
        break;
      }
    if (n < 0)
      return this;
    r.length === 1 ? (r.length = 0, delete this._events[t]) : r.splice(n, 1), this._events.removeListener && this.emit("removeListener", t, e);
  }
  return this;
};
Un.prototype.removeAllListeners = function(t) {
  var e, r;
  if (!this._events)
    return this;
  if (!this._events.removeListener)
    return arguments.length === 0 ? this._events = {} : this._events[t] && delete this._events[t], this;
  if (arguments.length === 0) {
    for (e in this._events)
      e !== "removeListener" && this.removeAllListeners(e);
    return this.removeAllListeners("removeListener"), this._events = {}, this;
  }
  if (r = this._events[t], Da(r))
    this.removeListener(t, r);
  else if (r)
    for (; r.length; )
      this.removeListener(t, r[r.length - 1]);
  return delete this._events[t], this;
};
Un.prototype.listeners = function(t) {
  var e;
  return !this._events || !this._events[t] ? e = [] : Da(this._events[t]) ? e = [this._events[t]] : e = this._events[t].slice(), e;
};
Un.prototype.listenerCount = function(t) {
  if (this._events) {
    var e = this._events[t];
    if (Da(e))
      return 1;
    if (e)
      return e.length;
  }
  return 0;
};
Un.listenerCount = function(t, e) {
  return t.listenerCount(e);
};
function Da(t) {
  return typeof t == "function";
}
function Ore(t) {
  return typeof t == "number";
}
function Hd(t) {
  return typeof t == "object" && t !== null;
}
function a7(t) {
  return t === void 0;
}
var Gl = {};
Object.defineProperty(Gl, "__esModule", {
  value: !0
});
Gl.createConsoleLogger = void 0;
const Bre = (t) => ({
  trace: (...e) => console.trace(`[${t}:trace]`, ...e),
  debug: (...e) => console.debug(`[${t}:debug]`, ...e),
  log: (...e) => console.log(`[${t}]`, ...e),
  info: (...e) => console.info(`[${t}:info]`, ...e),
  warn: (...e) => console.warn(`[${t}:warn]`, ...e),
  error: (...e) => console.error(`[${t}:error]`, ...e)
});
Gl.createConsoleLogger = Bre;
Object.defineProperty(Zy, "__esModule", {
  value: !0
});
Zy.BaseMonitor = void 0;
var Mre = J0, Cre = i7, Nre = o7(Pre), Ure = ns, Ja = o7(hr), Lre = Gl;
function o7(t) {
  return t && t.__esModule ? t : { default: t };
}
function D4(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ya(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? D4(Object(r), !0).forEach(function(n) {
      Xa(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : D4(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Xa(t, e, r) {
  return e = Dre(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Dre(t) {
  var e = Fre(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Fre(t, e) {
  if (typeof t != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
const jre = ["start", "stop", "update", "tick", "tick-multiple-wallet-accounts"];
class $re extends Nre.default {
  constructor({
    asset: e,
    interval: r,
    assetClientInterface: n,
    runner: i = (a) => a(),
    logger: s
  }) {
    super(), Xa(this, "start", async (a) => {
      if (this.timer.isRunning)
        return;
      let o = a;
      await this._runHooks("before-start", a), await this.timer.start(async () => {
        try {
          return await this.tickWalletAccounts(o);
        } finally {
          o = {};
        }
      }), await this._runHooks("after-start", a);
    }), Xa(this, "stop", async () => {
      this.timer.isRunning && (await this._runHooks("before-stop"), await this.timer.stop(), await this._runHooks("after-stop"));
    }), Xa(this, "update", async ({
      walletAccount: a,
      refresh: o,
      highPriority: c,
      assetName: f
    } = {}) => {
      let u = null;
      try {
        await this._runHooks("before-update", {
          walletAccount: a,
          refresh: o,
          highPriority: c,
          assetName: f
        }), await this.timer.stop(), await this.tickWalletAccounts({
          walletAccount: a,
          refresh: o,
          highPriority: c,
          assetName: f
        });
      } catch (d) {
        throw u = d, Object.assign(u, {
          walletAccount: a,
          refresh: o,
          highPriority: c,
          assetName: f
        });
      } finally {
        await this._runHooks("after-update", {
          error: u,
          walletAccount: a,
          refresh: o,
          highPriority: c,
          assetName: f
        }), await this.timer.start(() => this.tickWalletAccounts(), {
          delayedStart: !0
        });
      }
    }), Xa(this, "refresh", async () => (this.logDeprecation("refresh", "update"), this.update({
      refresh: !0
    }))), Xa(this, "refreshOneWallet", async (a, o) => (this.logDeprecation("refreshOneWallet", "update"), this.update({
      walletAccount: a,
      assetName: o,
      refresh: !0
    }))), Xa(this, "tickWithExtra", async (a) => {
      let o = null;
      const {
        walletAccount: c
      } = a;
      this.tickCount[c] = this.tickCount[c] || 0;
      try {
        await this._runHooks("before-tick", a);
        const f = () => this.tick(a);
        a.highPriority ? await f() : await this.runner(f);
      } catch (f) {
        o = f, this.logger.error(`${this.constructor.name} ${o.name}: ${o.message}
`, o, Ya({}, o));
      } finally {
        await this._runHooks("after-tick", Ya(Ya({}, a), {}, {
          error: o
        })), this.tickCount[c]++;
      }
    }), Xa(this, "logDeprecation", (a, o) => {
      const c = `monitor.${a}() is deprecated. Please use monitor.${o}(). Asset name ${this.asset.name}`;
      this.logger.log(c, new Error().stack);
    }), (0, Ja.default)(e, "asset is required"), (0, Ja.default)(r, "interval is required"), (0, Ja.default)(n, "assetClientInterface is required"), (0, Ja.default)(i, "runner is required"), this.logger = s || (0, Lre.createConsoleLogger)(`@exodus/${this.constructor.name}`), this.runner = i, this.asset = e, this.interval = r, this.timer = new Cre.Timer(r), this.isStarted = !1, this.aci = n, this.params = {}, this.hooks = jre.reduce((a, o) => (a[`before-${o}`] = [], a[`after-${o}`] = [], a), {}), this.tickCount = {};
  }
  /**
   * @deprecated use object fields rather than generic params.
   * @param params
   */
  setParams(e = {}) {
    Object.entries(e).forEach(([r, n]) => {
      (0, Ja.default)(n, `required parameter ${r} missing in ${this.constructor.name}`);
    }), this.params = Ya(Ya({}, this.params), e);
  }
  // name: string
  // fn: async ({monitor})=>{}
  addHook(e, r) {
    (0, Ja.default)(typeof r == "function", "hook must be a function"), this.hooks[e].push(r);
  }
  async _runHooks(e, r) {
    const n = Ya({
      monitor: this
    }, r);
    await Promise.all(this.hooks[e].map(async (i) => {
      try {
        await i(n);
      } catch (s) {
        this.logger.warn(`Error running hook ${e} for ${this.asset.name}. Error ${s.message || s}`, s);
      }
    })), this.emit(e, n);
  }
  /**
   * It ticks the monitor without stopping it.
   *
   * NOTE: Atm, Monero monitor overrides it on mobile. It cannot be a function field
   *
   * @param walletAccount tick a particular wallet account, leave empty to tick all accounts.
   * @param refresh perform a full refresh
   * @param highPriority don't wait for the runner, run now.
   * @param assetName tick a particular asset, leave empty to tick all assets.
   * @returns {Promise<void>}
   */
  async tickWalletAccounts({
    walletAccount: e,
    refresh: r,
    highPriority: n,
    assetName: i
  } = {}) {
    const s = await this.aci.getWalletAccounts({
      assetName: this.asset.name
    });
    await this._runHooks("before-tick-multiple-wallet-accounts", {
      refresh: r,
      highPriority: n,
      assetName: i,
      walletAccounts: s
    });
    let a = null;
    try {
      await Promise.all(s.filter((o) => !e || e === o).map((o) => this.tickWithExtra({
        walletAccount: o,
        refresh: r,
        highPriority: n,
        assetName: i
      })));
    } catch (o) {
      throw a = o, o;
    } finally {
      await this._runHooks("after-tick-multiple-wallet-accounts", {
        error: a,
        refresh: r,
        highPriority: n,
        assetName: i,
        walletAccounts: s
      });
    }
  }
  setServer(e) {
    throw new Error("Unimplemented");
  }
  /**
   * It ticks the monitor for all the accounts without stopping it.
   *
   * @deprecated use tickWalletAccounts
   *
   * @param refresh perform a full refresh
   * @param highPriority don't wait for the runner, run now.
   * @param assetName tick a particular asset, leave empty to tick all assets.
   * @returns {Promise<void>}
   */
  async tickAllWalletAccounts({
    refresh: e,
    highPriority: r,
    assetName: n
  } = {}) {
    return this.logDeprecation("tickAllWalletAccounts", "tickWalletAccounts"), this.tickWalletAccounts({
      refresh: e,
      highPriority: r,
      assetName: n
    });
  }
  async tick({
    refresh: e,
    walletAccount: r,
    highPriority: n
  }) {
    throw new Error("Unimplemented");
  }
  async updateAccountState({
    assetName: e = this.asset.name,
    accountState: r,
    newData: n,
    walletAccount: i
  }) {
    return this.aci.updateAccountState({
      assetName: e,
      walletAccount: i,
      accountState: r,
      newData: n
    });
  }
  async updateTxLog({
    assetName: e = this.asset.name,
    logItems: r,
    walletAccount: n,
    refresh: i,
    notifyCondition: s
  }) {
    return this.aci.updateTxLogAndNotify({
      assetName: e,
      walletAccount: n,
      txs: r,
      refresh: i,
      notifyCondition: s
    });
  }
  async removeFromTxLog(e) {
    for (const {
      tx: r,
      assetSource: n
    } of e) {
      const {
        asset: i,
        walletAccount: s
      } = n;
      await this.aci.removeTxLog({
        assetName: i,
        walletAccount: s,
        txs: [r]
      });
    }
  }
  getUnconfirmed({
    txSet: e,
    staleTxAge: r
  }) {
    (0, Ja.default)(e, "txSet is required"), (0, Ja.default)(r >= 0, "staleTxAge must be a 0 or positive number");
    const n = [...e].filter((a) => !a.confirmed && !a.dropped), [i, s] = (0, Ure.partition)(n, (a) => Mre.SynchronizedTime.now() - a.date.valueOf() < r);
    return {
      stale: s.map((a) => Ya(Ya({}, a), {}, {
        dropped: !0
      })),
      unconfirmed: i.map((a) => a.txId)
    };
  }
  async updateTxLogByAsset({
    logItemsByAsset: e,
    walletAccount: r,
    refresh: n,
    notifyCondition: i
  }) {
    if (n) {
      const s = this.aci.createOperationsBatch();
      for (const [a, o] of Object.entries(e))
        this.aci.updateTxLogAndNotifyBatch({
          assetName: a,
          walletAccount: r,
          txs: o,
          refresh: n,
          batch: s
        });
      await this.aci.executeOperationsBatch(s);
    } else
      for (const [s, a] of Object.entries(e))
        await this.updateTxLog({
          assetName: s,
          logItems: a,
          walletAccount: r,
          refresh: n,
          notifyCondition: i
        });
  }
}
Zy.BaseMonitor = $re;
var Jy = {};
Object.defineProperty(Jy, "__esModule", {
  value: !0
});
Jy.AssetError = void 0;
class c7 extends Error {
  constructor(e, r) {
    super(e), Object.defineProperty(this, "name", {
      value: "AssetError",
      enumerable: !1
    }), this.code = e, this.properties = r;
  }
}
Jy.AssetError = c7;
Object.defineProperty(c7, "name", {
  value: "AssetError"
});
var _i = {};
Object.defineProperty(_i, "__esModule", {
  value: !0
});
_i.getUnconfirmedSentBalance = _i.getUnconfirmedReceivedBalance = _i.getBalancesFromAccountStateFactory = _i.getBalanceFromTxLog = _i.getBalanceFromAccountState = _i.fixBalance = void 0;
var Ts = qre(hr);
function qre(t) {
  return t && t.__esModule ? t : { default: t };
}
function F4(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Im(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? F4(Object(r), !0).forEach(function(n) {
      Wre(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : F4(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Wre(t, e, r) {
  return e = zre(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function zre(t) {
  var e = Kre(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Kre(t, e) {
  if (typeof t != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
const Vre = ({
  asset: t,
  txLog: e
}) => ((0, Ts.default)(t, "asset is required"), (0, Ts.default)(e, "txLog is required"), e.size > 0 ? e.getMutations().slice(-1)[0].balance : t.currency.ZERO);
_i.getBalanceFromTxLog = Vre;
const u7 = ({
  asset: t,
  accountState: e
}) => {
  var r;
  return (0, Ts.default)(e, "accountState is required"), (0, Ts.default)(t, "asset is required"), t.name === t.baseAsset.name ? (e == null ? void 0 : e.balance) || t.currency.ZERO : (e == null || (r = e.tokenBalances) === null || r === void 0 ? void 0 : r[t.name]) || t.currency.ZERO;
};
_i.getBalanceFromAccountState = u7;
const f7 = ({
  asset: t,
  txLog: e,
  sent: r,
  received: n
}) => {
  (0, Ts.default)(r || n, "At least sent: true or received: true must be provided");
  let i = t.currency.ZERO;
  for (const s of e) {
    const a = s.sent;
    !s.failed && s.pending && (a && r || !a && n) && (i = i.add(s.coinAmount.abs()), s.feeAmount && a && r && s.coinAmount.unitType.equals(s.feeAmount.unitType) && (i = i.add(s.feeAmount.abs())));
  }
  return i;
}, d7 = ({
  asset: t,
  txLog: e
}) => ((0, Ts.default)(t, "asset is required"), (0, Ts.default)(e, "txLog is required"), f7({
  asset: t,
  txLog: e,
  received: !0
}));
_i.getUnconfirmedReceivedBalance = d7;
const l7 = ({
  asset: t,
  txLog: e
}) => ((0, Ts.default)(t, "asset is required"), (0, Ts.default)(e, "txLog is required"), f7({
  asset: t,
  txLog: e,
  sent: !0
}));
_i.getUnconfirmedSentBalance = l7;
const h7 = ({
  txLog: t,
  balance: e
}) => {
  (0, Ts.default)(t, "txLog is required"), (0, Ts.default)(e, "balance is required");
  for (const r of t)
    r.sent && r.pending && !r.error && (e = e.sub(r.coinAmount.abs()), r.coinAmount.unitType.equals(r.feeAmount.unitType) && (e = e.sub(r.feeAmount)));
  return e;
};
_i.fixBalance = h7;
const Hre = ({
  shouldFixBalance: t = !1,
  getFrozenBalances: e = () => ({}),
  getOtherBalances: r = () => ({})
} = {}) => ({
  accountState: n,
  asset: i,
  txLog: s
}) => {
  const a = d7({
    asset: i,
    txLog: s
  }), o = l7({
    asset: i,
    txLog: s
  }), c = u7({
    accountState: n,
    asset: i
  }), f = t ? h7({
    txLog: s,
    balance: c
  }) : c, u = r({
    asset: i,
    accountState: n,
    txLog: s
  }) || {}, d = e({
    asset: i,
    accountState: n,
    txLog: s
  }) || {}, l = Object.values(d).reduce((y, p) => y.add(p), i.currency.ZERO), h = f.sub(a).sub(l).clampLowerZero();
  return Im(Im(Im({
    total: f,
    spendable: h,
    unconfirmedReceived: a,
    unconfirmedSent: o
  }, u), d), {}, {
    frozen: l
  });
};
_i.getBalancesFromAccountStateFactory = Hre;
var Yy = {}, Gre = function(t, e) {
  const r = Object.assign({ concurrency: 1 }, e).concurrency;
  if (typeof r != "number" || isNaN(r) || r <= 0)
    throw new TypeError(`Invalid concurrency value: ${r}`);
  let n = 0;
  const i = [];
  function s() {
    i.length > 0 ? i.shift().resolve() : n -= 1;
  }
  return function() {
    let a;
    return n >= r ? a = new Promise((o) => i.push({ resolve: o })) : (a = Promise.resolve(), n += 1), a.then(() => t.apply(this, arguments)).then((o) => (s(), o), (o) => {
      throw s(), o;
    });
  };
};
Object.defineProperty(Yy, "__esModule", {
  value: !0
});
Yy.createLimiter = void 0;
var Zre = p7(Gre), Tm = p7(hr);
function p7(t) {
  return t && t.__esModule ? t : { default: t };
}
const Jre = ({
  name: t,
  concurrency: e,
  logger: r
}) => {
  (0, Tm.default)(t, "name is required"), (0, Tm.default)(e !== void 0, "concurrency is required"), (0, Tm.default)(r, "logger is required");
  let n = 0;
  const i = e < 1, s = i ? "unlimited concurrency" : "max concurrency: " + e, a = async (o) => {
    r.debug(`running ${t}, in progress: ${++n} ${s}`);
    try {
      return await o();
    } finally {
      r.debug(`finished ${t}, in progress: ${--n} ${s}`);
    }
  };
  return i ? a : (0, Zre.default)(a, {
    concurrency: e
  });
};
Yy.createLimiter = Jre;
var Qy = {}, km, j4;
function Yre() {
  return j4 || (j4 = 1, km = function(t) {
    t.prototype[Symbol.iterator] = function* () {
      for (let e = this.head; e; e = e.next)
        yield e.value;
    };
  }), km;
}
var Qre = Er;
Er.Node = Cc;
Er.create = Er;
function Er(t) {
  var e = this;
  if (e instanceof Er || (e = new Er()), e.tail = null, e.head = null, e.length = 0, t && typeof t.forEach == "function")
    t.forEach(function(i) {
      e.push(i);
    });
  else if (arguments.length > 0)
    for (var r = 0, n = arguments.length; r < n; r++)
      e.push(arguments[r]);
  return e;
}
Er.prototype.removeNode = function(t) {
  if (t.list !== this)
    throw new Error("removing node which does not belong to this list");
  var e = t.next, r = t.prev;
  return e && (e.prev = r), r && (r.next = e), t === this.head && (this.head = e), t === this.tail && (this.tail = r), t.list.length--, t.next = null, t.prev = null, t.list = null, e;
};
Er.prototype.unshiftNode = function(t) {
  if (t !== this.head) {
    t.list && t.list.removeNode(t);
    var e = this.head;
    t.list = this, t.next = e, e && (e.prev = t), this.head = t, this.tail || (this.tail = t), this.length++;
  }
};
Er.prototype.pushNode = function(t) {
  if (t !== this.tail) {
    t.list && t.list.removeNode(t);
    var e = this.tail;
    t.list = this, t.prev = e, e && (e.next = t), this.tail = t, this.head || (this.head = t), this.length++;
  }
};
Er.prototype.push = function() {
  for (var t = 0, e = arguments.length; t < e; t++)
    ene(this, arguments[t]);
  return this.length;
};
Er.prototype.unshift = function() {
  for (var t = 0, e = arguments.length; t < e; t++)
    tne(this, arguments[t]);
  return this.length;
};
Er.prototype.pop = function() {
  if (this.tail) {
    var t = this.tail.value;
    return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, t;
  }
};
Er.prototype.shift = function() {
  if (this.head) {
    var t = this.head.value;
    return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, t;
  }
};
Er.prototype.forEach = function(t, e) {
  e = e || this;
  for (var r = this.head, n = 0; r !== null; n++)
    t.call(e, r.value, n, this), r = r.next;
};
Er.prototype.forEachReverse = function(t, e) {
  e = e || this;
  for (var r = this.tail, n = this.length - 1; r !== null; n--)
    t.call(e, r.value, n, this), r = r.prev;
};
Er.prototype.get = function(t) {
  for (var e = 0, r = this.head; r !== null && e < t; e++)
    r = r.next;
  if (e === t && r !== null)
    return r.value;
};
Er.prototype.getReverse = function(t) {
  for (var e = 0, r = this.tail; r !== null && e < t; e++)
    r = r.prev;
  if (e === t && r !== null)
    return r.value;
};
Er.prototype.map = function(t, e) {
  e = e || this;
  for (var r = new Er(), n = this.head; n !== null; )
    r.push(t.call(e, n.value, this)), n = n.next;
  return r;
};
Er.prototype.mapReverse = function(t, e) {
  e = e || this;
  for (var r = new Er(), n = this.tail; n !== null; )
    r.push(t.call(e, n.value, this)), n = n.prev;
  return r;
};
Er.prototype.reduce = function(t, e) {
  var r, n = this.head;
  if (arguments.length > 1)
    r = e;
  else if (this.head)
    n = this.head.next, r = this.head.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var i = 0; n !== null; i++)
    r = t(r, n.value, i), n = n.next;
  return r;
};
Er.prototype.reduceReverse = function(t, e) {
  var r, n = this.tail;
  if (arguments.length > 1)
    r = e;
  else if (this.tail)
    n = this.tail.prev, r = this.tail.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var i = this.length - 1; n !== null; i--)
    r = t(r, n.value, i), n = n.prev;
  return r;
};
Er.prototype.toArray = function() {
  for (var t = new Array(this.length), e = 0, r = this.head; r !== null; e++)
    t[e] = r.value, r = r.next;
  return t;
};
Er.prototype.toArrayReverse = function() {
  for (var t = new Array(this.length), e = 0, r = this.tail; r !== null; e++)
    t[e] = r.value, r = r.prev;
  return t;
};
Er.prototype.slice = function(t, e) {
  e = e || this.length, e < 0 && (e += this.length), t = t || 0, t < 0 && (t += this.length);
  var r = new Er();
  if (e < t || e < 0)
    return r;
  t < 0 && (t = 0), e > this.length && (e = this.length);
  for (var n = 0, i = this.head; i !== null && n < t; n++)
    i = i.next;
  for (; i !== null && n < e; n++, i = i.next)
    r.push(i.value);
  return r;
};
Er.prototype.sliceReverse = function(t, e) {
  e = e || this.length, e < 0 && (e += this.length), t = t || 0, t < 0 && (t += this.length);
  var r = new Er();
  if (e < t || e < 0)
    return r;
  t < 0 && (t = 0), e > this.length && (e = this.length);
  for (var n = this.length, i = this.tail; i !== null && n > e; n--)
    i = i.prev;
  for (; i !== null && n > t; n--, i = i.prev)
    r.push(i.value);
  return r;
};
Er.prototype.splice = function(t, e, ...r) {
  t > this.length && (t = this.length - 1), t < 0 && (t = this.length + t);
  for (var n = 0, i = this.head; i !== null && n < t; n++)
    i = i.next;
  for (var s = [], n = 0; i && n < e; n++)
    s.push(i.value), i = this.removeNode(i);
  i === null && (i = this.tail), i !== this.head && i !== this.tail && (i = i.prev);
  for (var n = 0; n < r.length; n++)
    i = Xre(this, i, r[n]);
  return s;
};
Er.prototype.reverse = function() {
  for (var t = this.head, e = this.tail, r = t; r !== null; r = r.prev) {
    var n = r.prev;
    r.prev = r.next, r.next = n;
  }
  return this.head = e, this.tail = t, this;
};
function Xre(t, e, r) {
  var n = e === t.head ? new Cc(r, null, e, t) : new Cc(r, e, e.next, t);
  return n.next === null && (t.tail = n), n.prev === null && (t.head = n), t.length++, n;
}
function ene(t, e) {
  t.tail = new Cc(e, t.tail, null, t), t.head || (t.head = t.tail), t.length++;
}
function tne(t, e) {
  t.head = new Cc(e, null, t.head, t), t.tail || (t.tail = t.head), t.length++;
}
function Cc(t, e, r, n) {
  if (!(this instanceof Cc))
    return new Cc(t, e, r, n);
  this.list = n, this.value = t, e ? (e.next = this, this.prev = e) : this.prev = null, r ? (r.prev = this, this.next = r) : this.next = null;
}
try {
  Yre()(Er);
} catch {
}
const rne = Qre, Vo = Symbol("max"), va = Symbol("length"), su = Symbol("lengthCalculator"), hd = Symbol("allowStale"), ec = Symbol("maxAge"), ma = Symbol("dispose"), $4 = Symbol("noDisposeOnSet"), On = Symbol("lruList"), bs = Symbol("cache"), y7 = Symbol("updateAgeOnGet"), Rm = () => 1;
class nne {
  constructor(e) {
    if (typeof e == "number" && (e = { max: e }), e || (e = {}), e.max && (typeof e.max != "number" || e.max < 0))
      throw new TypeError("max must be a non-negative number");
    this[Vo] = e.max || 1 / 0;
    const r = e.length || Rm;
    if (this[su] = typeof r != "function" ? Rm : r, this[hd] = e.stale || !1, e.maxAge && typeof e.maxAge != "number")
      throw new TypeError("maxAge must be a number");
    this[ec] = e.maxAge || 0, this[ma] = e.dispose, this[$4] = e.noDisposeOnSet || !1, this[y7] = e.updateAgeOnGet || !1, this.reset();
  }
  // resize the cache when the max changes.
  set max(e) {
    if (typeof e != "number" || e < 0)
      throw new TypeError("max must be a non-negative number");
    this[Vo] = e || 1 / 0, Gf(this);
  }
  get max() {
    return this[Vo];
  }
  set allowStale(e) {
    this[hd] = !!e;
  }
  get allowStale() {
    return this[hd];
  }
  set maxAge(e) {
    if (typeof e != "number")
      throw new TypeError("maxAge must be a non-negative number");
    this[ec] = e, Gf(this);
  }
  get maxAge() {
    return this[ec];
  }
  // resize the cache when the lengthCalculator changes.
  set lengthCalculator(e) {
    typeof e != "function" && (e = Rm), e !== this[su] && (this[su] = e, this[va] = 0, this[On].forEach((r) => {
      r.length = this[su](r.value, r.key), this[va] += r.length;
    })), Gf(this);
  }
  get lengthCalculator() {
    return this[su];
  }
  get length() {
    return this[va];
  }
  get itemCount() {
    return this[On].length;
  }
  rforEach(e, r) {
    r = r || this;
    for (let n = this[On].tail; n !== null; ) {
      const i = n.prev;
      q4(this, e, n, r), n = i;
    }
  }
  forEach(e, r) {
    r = r || this;
    for (let n = this[On].head; n !== null; ) {
      const i = n.next;
      q4(this, e, n, r), n = i;
    }
  }
  keys() {
    return this[On].toArray().map((e) => e.key);
  }
  values() {
    return this[On].toArray().map((e) => e.value);
  }
  reset() {
    this[ma] && this[On] && this[On].length && this[On].forEach((e) => this[ma](e.key, e.value)), this[bs] = /* @__PURE__ */ new Map(), this[On] = new rne(), this[va] = 0;
  }
  dump() {
    return this[On].map((e) => $p(this, e) ? !1 : {
      k: e.key,
      v: e.value,
      e: e.now + (e.maxAge || 0)
    }).toArray().filter((e) => e);
  }
  dumpLru() {
    return this[On];
  }
  set(e, r, n) {
    if (n = n || this[ec], n && typeof n != "number")
      throw new TypeError("maxAge must be a number");
    const i = n ? Date.now() : 0, s = this[su](r, e);
    if (this[bs].has(e)) {
      if (s > this[Vo])
        return Bu(this, this[bs].get(e)), !1;
      const c = this[bs].get(e).value;
      return this[ma] && (this[$4] || this[ma](e, c.value)), c.now = i, c.maxAge = n, c.value = r, this[va] += s - c.length, c.length = s, this.get(e), Gf(this), !0;
    }
    const a = new ine(e, r, s, i, n);
    return a.length > this[Vo] ? (this[ma] && this[ma](e, r), !1) : (this[va] += a.length, this[On].unshift(a), this[bs].set(e, this[On].head), Gf(this), !0);
  }
  has(e) {
    if (!this[bs].has(e))
      return !1;
    const r = this[bs].get(e).value;
    return !$p(this, r);
  }
  get(e) {
    return Pm(this, e, !0);
  }
  peek(e) {
    return Pm(this, e, !1);
  }
  pop() {
    const e = this[On].tail;
    return e ? (Bu(this, e), e.value) : null;
  }
  del(e) {
    Bu(this, this[bs].get(e));
  }
  load(e) {
    this.reset();
    const r = Date.now();
    for (let n = e.length - 1; n >= 0; n--) {
      const i = e[n], s = i.e || 0;
      if (s === 0)
        this.set(i.k, i.v);
      else {
        const a = s - r;
        a > 0 && this.set(i.k, i.v, a);
      }
    }
  }
  prune() {
    this[bs].forEach((e, r) => Pm(this, r, !1));
  }
}
const Pm = (t, e, r) => {
  const n = t[bs].get(e);
  if (n) {
    const i = n.value;
    if ($p(t, i)) {
      if (Bu(t, n), !t[hd])
        return;
    } else
      r && (t[y7] && (n.value.now = Date.now()), t[On].unshiftNode(n));
    return i.value;
  }
}, $p = (t, e) => {
  if (!e || !e.maxAge && !t[ec])
    return !1;
  const r = Date.now() - e.now;
  return e.maxAge ? r > e.maxAge : t[ec] && r > t[ec];
}, Gf = (t) => {
  if (t[va] > t[Vo])
    for (let e = t[On].tail; t[va] > t[Vo] && e !== null; ) {
      const r = e.prev;
      Bu(t, e), e = r;
    }
}, Bu = (t, e) => {
  if (e) {
    const r = e.value;
    t[ma] && t[ma](r.key, r.value), t[va] -= r.length, t[bs].delete(r.key), t[On].removeNode(e);
  }
};
class ine {
  constructor(e, r, n, i, s) {
    this.key = e, this.value = r, this.length = n, this.now = i, this.maxAge = s || 0;
  }
}
const q4 = (t, e, r, n) => {
  let i = r.value;
  $p(t, i) && (Bu(t, r), t[hd] || (i = void 0)), i && e.call(n, i.value, i.key, t);
};
var sne = nne;
Object.defineProperty(Qy, "__esModule", {
  value: !0
});
Qy.memoizeLruCache = void 0;
var ane = one(sne);
function one(t) {
  return t && t.__esModule ? t : { default: t };
}
const cne = (t, e, r) => {
  const n = new ane.default(r);
  return (...i) => {
    const s = e(...i);
    if (!n.has(s)) {
      const a = t(...i);
      n.set(s, a), Promise.resolve(a).catch(() => n.del(s));
    }
    return n.get(s);
  };
};
Qy.memoizeLruCache = cne;
var Xy = {};
Object.defineProperty(Xy, "__esModule", {
  value: !0
});
Xy.getDefaultPathIndexes = void 0;
var W4 = une(hr);
function une(t) {
  return t && t.__esModule ? t : { default: t };
}
const z4 = (t) => t === void 0 ? void 0 : Number.parseInt(t), fne = ({
  asset: t,
  compatibilityMode: e
}) => {
  (0, W4.default)(t && t.baseAsset && t.baseAsset.api, "expected asset.baseAsset.api"), (0, W4.default)(!e || typeof e == "string", 'expected string "compatibilityMode"');
  const {
    baseAsset: r
  } = t, i = (r.api.getDefaultAddressPath || function() {
    return r.api.defaultAddressPath;
  })({
    asset: t,
    compatibilityMode: e
  }), [, s, a] = i.split("/");
  return {
    chainIndex: z4(s),
    addressIndex: z4(a)
  };
};
Xy.getDefaultPathIndexes = fne;
var e1 = {};
Object.defineProperty(e1, "__esModule", {
  value: !0
});
e1.BumpType = void 0;
e1.BumpType = {
  NONE: 0,
  CPFP: 1,
  RBF: 2
};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var e = {
    getUnconfirmedReceivedBalance: !0,
    getUnconfirmedSentBalance: !0,
    fixBalance: !0,
    getBalanceFromAccountState: !0,
    getBalanceFromTxLog: !0,
    getBalancesFromAccountStateFactory: !0,
    getDefaultPathIndexes: !0,
    BumpType: !0
  };
  Object.defineProperty(t, "BumpType", {
    enumerable: !0,
    get: function() {
      return d.BumpType;
    }
  }), Object.defineProperty(t, "fixBalance", {
    enumerable: !0,
    get: function() {
      return a.fixBalance;
    }
  }), Object.defineProperty(t, "getBalanceFromAccountState", {
    enumerable: !0,
    get: function() {
      return a.getBalanceFromAccountState;
    }
  }), Object.defineProperty(t, "getBalanceFromTxLog", {
    enumerable: !0,
    get: function() {
      return a.getBalanceFromTxLog;
    }
  }), Object.defineProperty(t, "getBalancesFromAccountStateFactory", {
    enumerable: !0,
    get: function() {
      return a.getBalancesFromAccountStateFactory;
    }
  }), Object.defineProperty(t, "getDefaultPathIndexes", {
    enumerable: !0,
    get: function() {
      return u.getDefaultPathIndexes;
    }
  }), Object.defineProperty(t, "getUnconfirmedReceivedBalance", {
    enumerable: !0,
    get: function() {
      return a.getUnconfirmedReceivedBalance;
    }
  }), Object.defineProperty(t, "getUnconfirmedSentBalance", {
    enumerable: !0,
    get: function() {
      return a.getUnconfirmedSentBalance;
    }
  });
  var r = e7;
  Object.keys(r).forEach(function(l) {
    l === "default" || l === "__esModule" || Object.prototype.hasOwnProperty.call(e, l) || l in t && t[l] === r[l] || Object.defineProperty(t, l, {
      enumerable: !0,
      get: function() {
        return r[l];
      }
    });
  });
  var n = n7;
  Object.keys(n).forEach(function(l) {
    l === "default" || l === "__esModule" || Object.prototype.hasOwnProperty.call(e, l) || l in t && t[l] === n[l] || Object.defineProperty(t, l, {
      enumerable: !0,
      get: function() {
        return n[l];
      }
    });
  });
  var i = Zy;
  Object.keys(i).forEach(function(l) {
    l === "default" || l === "__esModule" || Object.prototype.hasOwnProperty.call(e, l) || l in t && t[l] === i[l] || Object.defineProperty(t, l, {
      enumerable: !0,
      get: function() {
        return i[l];
      }
    });
  });
  var s = Jy;
  Object.keys(s).forEach(function(l) {
    l === "default" || l === "__esModule" || Object.prototype.hasOwnProperty.call(e, l) || l in t && t[l] === s[l] || Object.defineProperty(t, l, {
      enumerable: !0,
      get: function() {
        return s[l];
      }
    });
  });
  var a = _i, o = Gl;
  Object.keys(o).forEach(function(l) {
    l === "default" || l === "__esModule" || Object.prototype.hasOwnProperty.call(e, l) || l in t && t[l] === o[l] || Object.defineProperty(t, l, {
      enumerable: !0,
      get: function() {
        return o[l];
      }
    });
  });
  var c = Yy;
  Object.keys(c).forEach(function(l) {
    l === "default" || l === "__esModule" || Object.prototype.hasOwnProperty.call(e, l) || l in t && t[l] === c[l] || Object.defineProperty(t, l, {
      enumerable: !0,
      get: function() {
        return c[l];
      }
    });
  });
  var f = Qy;
  Object.keys(f).forEach(function(l) {
    l === "default" || l === "__esModule" || Object.prototype.hasOwnProperty.call(e, l) || l in t && t[l] === f[l] || Object.defineProperty(t, l, {
      enumerable: !0,
      get: function() {
        return f[l];
      }
    });
  });
  var u = Xy, d = e1;
})(dre);
const qp = 2147483648;
var os = function(t) {
  if (!Array.isArray(t))
    throw new Error("Input must be an Array");
  if (t.length === 0)
    throw new Error("Path must contain at least one level");
  for (var e = 0; e < t.length; e++)
    if (typeof t[e] != "number")
      throw new Error("Path element is not a number");
  this.path = t;
};
os.validatePathArray = function(t) {
  try {
    return os.fromPathArray(t), !0;
  } catch {
    return !1;
  }
};
os.validateString = function(t, e) {
  try {
    return os.fromString(t, e), !0;
  } catch {
    return !1;
  }
};
os.fromPathArray = function(t) {
  return new os(t);
};
os.fromString = function(t, e) {
  if (/^m\//i.test(t))
    t = t.slice(2);
  else if (e)
    throw new Error("Root element is required");
  for (var r = t.split("/"), n = new Array(r.length), i = 0; i < r.length; i++) {
    var s = /(\d+)([hH\']?)/.exec(r[i]);
    if (s === null)
      throw new Error("Invalid input");
    if (n[i] = parseInt(s[1], 10), n[i] >= qp)
      throw new Error("Invalid child index");
    if (s[2] === "h" || s[2] === "H" || s[2] === "'")
      n[i] += qp;
    else if (s[2].length != 0)
      throw new Error("Invalid modifier");
  }
  return new os(n);
};
os.prototype.toPathArray = function() {
  return this.path;
};
os.prototype.toString = function(t, e) {
  for (var r = new Array(this.path.length), n = 0; n < this.path.length; n++) {
    var i = this.path[n];
    i & qp ? r[n] = (i & ~qp) + (e ? "h" : "'") : r[n] = i;
  }
  return (t ? "" : "m/") + r.join("/");
};
os.prototype.inspect = function() {
  return "BIPPath <" + this.toString() + ">";
};
var dne = os, Om = ko, lne = Lt.Buffer, hne = function(t) {
  function e(s) {
    var a = t(s);
    return Om.encode(lne.concat([
      s,
      a
    ], s.length + 4));
  }
  function r(s) {
    var a = s.slice(0, -4), o = s.slice(-4), c = t(a);
    if (!(o[0] ^ c[0] | o[1] ^ c[1] | o[2] ^ c[2] | o[3] ^ c[3]))
      return a;
  }
  function n(s) {
    var a = Om.decodeUnsafe(s);
    if (a)
      return r(a);
  }
  function i(s) {
    var a = Om.decode(s), o = r(a);
    if (!o)
      throw new Error("Invalid checksum");
    return o;
  }
  return {
    encode: e,
    decode: i,
    decodeUnsafe: n
  };
}, K4 = Dc(), pne = hne;
function yne(t) {
  var e = K4("sha256").update(t).digest();
  return K4("sha256").update(e).digest();
}
var bne = pne(yne);
const vr = {
  IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
  TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
  TWEAK_MUL: "The tweak was out of range or equal to zero",
  CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
  SECKEY_INVALID: "Private Key is invalid",
  PUBKEY_PARSE: "Public Key could not be parsed",
  PUBKEY_SERIALIZE: "Public Key serialization error",
  PUBKEY_COMBINE: "The sum of the public keys is not valid",
  SIG_PARSE: "Signature could not be parsed",
  SIGN: "The nonce generation function failed, or the private key was invalid",
  RECOVER: "Public key could not be recover",
  ECDH: "Scalar was invalid (zero or overflow)"
};
function ts(t, e) {
  if (!t)
    throw new Error(e);
}
function ur(t, e, r) {
  if (ts(e instanceof Uint8Array, `Expected ${t} to be an Uint8Array`), r !== void 0)
    if (Array.isArray(r)) {
      const n = r.join(", "), i = `Expected ${t} to be an Uint8Array with length [${n}]`;
      ts(r.includes(e.length), i);
    } else {
      const n = `Expected ${t} to be an Uint8Array with length ${r}`;
      ts(e.length === r, n);
    }
}
function Uo(t) {
  ts(pu(t) === "Boolean", "Expected compressed to be a Boolean");
}
function ls(t = (r) => new Uint8Array(r), e) {
  return typeof t == "function" && (t = t(e)), ur("output", t, e), t;
}
function pu(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
var gne = (t) => ({
  contextRandomize(e) {
    switch (ts(
      e === null || e instanceof Uint8Array,
      "Expected seed to be an Uint8Array or null"
    ), e !== null && ur("seed", e, 32), t.contextRandomize(e)) {
      case 1:
        throw new Error(vr.CONTEXT_RANDOMIZE_UNKNOW);
    }
  },
  privateKeyVerify(e) {
    return ur("private key", e, 32), t.privateKeyVerify(e) === 0;
  },
  privateKeyNegate(e) {
    switch (ur("private key", e, 32), t.privateKeyNegate(e)) {
      case 0:
        return e;
      case 1:
        throw new Error(vr.IMPOSSIBLE_CASE);
    }
  },
  privateKeyTweakAdd(e, r) {
    switch (ur("private key", e, 32), ur("tweak", r, 32), t.privateKeyTweakAdd(e, r)) {
      case 0:
        return e;
      case 1:
        throw new Error(vr.TWEAK_ADD);
    }
  },
  privateKeyTweakMul(e, r) {
    switch (ur("private key", e, 32), ur("tweak", r, 32), t.privateKeyTweakMul(e, r)) {
      case 0:
        return e;
      case 1:
        throw new Error(vr.TWEAK_MUL);
    }
  },
  publicKeyVerify(e) {
    return ur("public key", e, [33, 65]), t.publicKeyVerify(e) === 0;
  },
  publicKeyCreate(e, r = !0, n) {
    switch (ur("private key", e, 32), Uo(r), n = ls(n, r ? 33 : 65), t.publicKeyCreate(n, e)) {
      case 0:
        return n;
      case 1:
        throw new Error(vr.SECKEY_INVALID);
      case 2:
        throw new Error(vr.PUBKEY_SERIALIZE);
    }
  },
  publicKeyConvert(e, r = !0, n) {
    switch (ur("public key", e, [33, 65]), Uo(r), n = ls(n, r ? 33 : 65), t.publicKeyConvert(n, e)) {
      case 0:
        return n;
      case 1:
        throw new Error(vr.PUBKEY_PARSE);
      case 2:
        throw new Error(vr.PUBKEY_SERIALIZE);
    }
  },
  publicKeyNegate(e, r = !0, n) {
    switch (ur("public key", e, [33, 65]), Uo(r), n = ls(n, r ? 33 : 65), t.publicKeyNegate(n, e)) {
      case 0:
        return n;
      case 1:
        throw new Error(vr.PUBKEY_PARSE);
      case 2:
        throw new Error(vr.IMPOSSIBLE_CASE);
      case 3:
        throw new Error(vr.PUBKEY_SERIALIZE);
    }
  },
  publicKeyCombine(e, r = !0, n) {
    ts(Array.isArray(e), "Expected public keys to be an Array"), ts(e.length > 0, "Expected public keys array will have more than zero items");
    for (const i of e)
      ur("public key", i, [33, 65]);
    switch (Uo(r), n = ls(n, r ? 33 : 65), t.publicKeyCombine(n, e)) {
      case 0:
        return n;
      case 1:
        throw new Error(vr.PUBKEY_PARSE);
      case 2:
        throw new Error(vr.PUBKEY_COMBINE);
      case 3:
        throw new Error(vr.PUBKEY_SERIALIZE);
    }
  },
  publicKeyTweakAdd(e, r, n = !0, i) {
    switch (ur("public key", e, [33, 65]), ur("tweak", r, 32), Uo(n), i = ls(i, n ? 33 : 65), t.publicKeyTweakAdd(i, e, r)) {
      case 0:
        return i;
      case 1:
        throw new Error(vr.PUBKEY_PARSE);
      case 2:
        throw new Error(vr.TWEAK_ADD);
    }
  },
  publicKeyTweakMul(e, r, n = !0, i) {
    switch (ur("public key", e, [33, 65]), ur("tweak", r, 32), Uo(n), i = ls(i, n ? 33 : 65), t.publicKeyTweakMul(i, e, r)) {
      case 0:
        return i;
      case 1:
        throw new Error(vr.PUBKEY_PARSE);
      case 2:
        throw new Error(vr.TWEAK_MUL);
    }
  },
  signatureNormalize(e) {
    switch (ur("signature", e, 64), t.signatureNormalize(e)) {
      case 0:
        return e;
      case 1:
        throw new Error(vr.SIG_PARSE);
    }
  },
  signatureExport(e, r) {
    ur("signature", e, 64), r = ls(r, 72);
    const n = { output: r, outputlen: 72 };
    switch (t.signatureExport(n, e)) {
      case 0:
        return r.slice(0, n.outputlen);
      case 1:
        throw new Error(vr.SIG_PARSE);
      case 2:
        throw new Error(vr.IMPOSSIBLE_CASE);
    }
  },
  signatureImport(e, r) {
    switch (ur("signature", e), r = ls(r, 64), t.signatureImport(r, e)) {
      case 0:
        return r;
      case 1:
        throw new Error(vr.SIG_PARSE);
      case 2:
        throw new Error(vr.IMPOSSIBLE_CASE);
    }
  },
  ecdsaSign(e, r, n = {}, i) {
    ur("message", e, 32), ur("private key", r, 32), ts(pu(n) === "Object", "Expected options to be an Object"), n.data !== void 0 && ur("options.data", n.data), n.noncefn !== void 0 && ts(pu(n.noncefn) === "Function", "Expected options.noncefn to be a Function"), i = ls(i, 64);
    const s = { signature: i, recid: null };
    switch (t.ecdsaSign(s, e, r, n.data, n.noncefn)) {
      case 0:
        return s;
      case 1:
        throw new Error(vr.SIGN);
      case 2:
        throw new Error(vr.IMPOSSIBLE_CASE);
    }
  },
  ecdsaVerify(e, r, n) {
    switch (ur("signature", e, 64), ur("message", r, 32), ur("public key", n, [33, 65]), t.ecdsaVerify(e, r, n)) {
      case 0:
        return !0;
      case 3:
        return !1;
      case 1:
        throw new Error(vr.SIG_PARSE);
      case 2:
        throw new Error(vr.PUBKEY_PARSE);
    }
  },
  ecdsaRecover(e, r, n, i = !0, s) {
    switch (ur("signature", e, 64), ts(
      pu(r) === "Number" && r >= 0 && r <= 3,
      "Expected recovery id to be a Number within interval [0, 3]"
    ), ur("message", n, 32), Uo(i), s = ls(s, i ? 33 : 65), t.ecdsaRecover(s, e, r, n)) {
      case 0:
        return s;
      case 1:
        throw new Error(vr.SIG_PARSE);
      case 2:
        throw new Error(vr.RECOVER);
      case 3:
        throw new Error(vr.IMPOSSIBLE_CASE);
    }
  },
  ecdh(e, r, n = {}, i) {
    switch (ur("public key", e, [33, 65]), ur("private key", r, 32), ts(pu(n) === "Object", "Expected options to be an Object"), n.data !== void 0 && ur("options.data", n.data), n.hashfn !== void 0 ? (ts(pu(n.hashfn) === "Function", "Expected options.hashfn to be a Function"), n.xbuf !== void 0 && ur("options.xbuf", n.xbuf, 32), n.ybuf !== void 0 && ur("options.ybuf", n.ybuf, 32), ur("output", i)) : i = ls(i, 32), t.ecdh(i, e, r, n.data, n.hashfn, n.xbuf, n.ybuf)) {
      case 0:
        return i;
      case 1:
        throw new Error(vr.PUBKEY_PARSE);
      case 2:
        throw new Error(vr.ECDH);
    }
  }
});
const mne = N0().ec, $s = new mne("secp256k1"), sr = $s.curve, zr = sr.n.constructor;
function vne(t, e) {
  let r = new zr(e);
  if (r.cmp(sr.p) >= 0)
    return null;
  r = r.toRed(sr.red);
  let n = r.redSqr().redIMul(r).redIAdd(sr.b).redSqrt();
  return t === 3 !== n.isOdd() && (n = n.redNeg()), $s.keyPair({ pub: { x: r, y: n } });
}
function wne(t, e, r) {
  let n = new zr(e), i = new zr(r);
  if (n.cmp(sr.p) >= 0 || i.cmp(sr.p) >= 0 || (n = n.toRed(sr.red), i = i.toRed(sr.red), (t === 6 || t === 7) && i.isOdd() !== (t === 7)))
    return null;
  const s = n.redSqr().redIMul(n);
  return i.redSqr().redISub(s.redIAdd(sr.b)).isZero() ? $s.keyPair({ pub: { x: n, y: i } }) : null;
}
function Qa(t) {
  const e = t[0];
  switch (e) {
    case 2:
    case 3:
      return t.length !== 33 ? null : vne(e, t.subarray(1, 33));
    case 4:
    case 6:
    case 7:
      return t.length !== 65 ? null : wne(e, t.subarray(1, 33), t.subarray(33, 65));
    default:
      return null;
  }
}
function Lo(t, e) {
  const r = e.encode(null, t.length === 33);
  for (let n = 0; n < t.length; ++n)
    t[n] = r[n];
}
var _ne = {
  contextRandomize() {
    return 0;
  },
  privateKeyVerify(t) {
    const e = new zr(t);
    return e.cmp(sr.n) < 0 && !e.isZero() ? 0 : 1;
  },
  privateKeyNegate(t) {
    const e = new zr(t), r = sr.n.sub(e).umod(sr.n).toArrayLike(Uint8Array, "be", 32);
    return t.set(r), 0;
  },
  privateKeyTweakAdd(t, e) {
    const r = new zr(e);
    if (r.cmp(sr.n) >= 0 || (r.iadd(new zr(t)), r.cmp(sr.n) >= 0 && r.isub(sr.n), r.isZero()))
      return 1;
    const n = r.toArrayLike(Uint8Array, "be", 32);
    return t.set(n), 0;
  },
  privateKeyTweakMul(t, e) {
    let r = new zr(e);
    if (r.cmp(sr.n) >= 0 || r.isZero())
      return 1;
    r.imul(new zr(t)), r.cmp(sr.n) >= 0 && (r = r.umod(sr.n));
    const n = r.toArrayLike(Uint8Array, "be", 32);
    return t.set(n), 0;
  },
  publicKeyVerify(t) {
    return Qa(t) === null ? 1 : 0;
  },
  publicKeyCreate(t, e) {
    const r = new zr(e);
    if (r.cmp(sr.n) >= 0 || r.isZero())
      return 1;
    const n = $s.keyFromPrivate(e).getPublic();
    return Lo(t, n), 0;
  },
  publicKeyConvert(t, e) {
    const r = Qa(e);
    if (r === null)
      return 1;
    const n = r.getPublic();
    return Lo(t, n), 0;
  },
  publicKeyNegate(t, e) {
    const r = Qa(e);
    if (r === null)
      return 1;
    const n = r.getPublic();
    return n.y = n.y.redNeg(), Lo(t, n), 0;
  },
  publicKeyCombine(t, e) {
    const r = new Array(e.length);
    for (let i = 0; i < e.length; ++i)
      if (r[i] = Qa(e[i]), r[i] === null)
        return 1;
    let n = r[0].getPublic();
    for (let i = 1; i < r.length; ++i)
      n = n.add(r[i].pub);
    return n.isInfinity() ? 2 : (Lo(t, n), 0);
  },
  publicKeyTweakAdd(t, e, r) {
    const n = Qa(e);
    if (n === null)
      return 1;
    if (r = new zr(r), r.cmp(sr.n) >= 0)
      return 2;
    const i = n.getPublic().add(sr.g.mul(r));
    return i.isInfinity() ? 2 : (Lo(t, i), 0);
  },
  publicKeyTweakMul(t, e, r) {
    const n = Qa(e);
    if (n === null)
      return 1;
    if (r = new zr(r), r.cmp(sr.n) >= 0 || r.isZero())
      return 2;
    const i = n.getPublic().mul(r);
    return Lo(t, i), 0;
  },
  signatureNormalize(t) {
    const e = new zr(t.subarray(0, 32)), r = new zr(t.subarray(32, 64));
    return e.cmp(sr.n) >= 0 || r.cmp(sr.n) >= 0 ? 1 : (r.cmp($s.nh) === 1 && t.set(sr.n.sub(r).toArrayLike(Uint8Array, "be", 32), 32), 0);
  },
  // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
  // Adapted for Uint8Array instead Buffer
  signatureExport(t, e) {
    const r = e.subarray(0, 32), n = e.subarray(32, 64);
    if (new zr(r).cmp(sr.n) >= 0 || new zr(n).cmp(sr.n) >= 0)
      return 1;
    const { output: i } = t;
    let s = i.subarray(4, 37);
    s[0] = 0, s.set(r, 1);
    let a = 33, o = 0;
    for (; a > 1 && s[o] === 0 && !(s[o + 1] & 128); --a, ++o)
      ;
    if (s = s.subarray(o), s[0] & 128 || a > 1 && s[0] === 0 && !(s[1] & 128))
      return 1;
    let c = i.subarray(39, 72);
    c[0] = 0, c.set(n, 1);
    let f = 33, u = 0;
    for (; f > 1 && c[u] === 0 && !(c[u + 1] & 128); --f, ++u)
      ;
    return c = c.subarray(u), c[0] & 128 || f > 1 && c[0] === 0 && !(c[1] & 128) ? 1 : (t.outputlen = 6 + a + f, i[0] = 48, i[1] = t.outputlen - 2, i[2] = 2, i[3] = s.length, i.set(s, 4), i[4 + a] = 2, i[5 + a] = c.length, i.set(c, 6 + a), 0);
  },
  // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
  // Adapted for Uint8Array instead Buffer
  signatureImport(t, e) {
    if (e.length < 8 || e.length > 72 || e[0] !== 48 || e[1] !== e.length - 2 || e[2] !== 2)
      return 1;
    const r = e[3];
    if (r === 0 || 5 + r >= e.length || e[4 + r] !== 2)
      return 1;
    const n = e[5 + r];
    if (n === 0 || 6 + r + n !== e.length || e[4] & 128 || r > 1 && e[4] === 0 && !(e[5] & 128) || e[r + 6] & 128 || n > 1 && e[r + 6] === 0 && !(e[r + 7] & 128))
      return 1;
    let i = e.subarray(4, 4 + r);
    if (i.length === 33 && i[0] === 0 && (i = i.subarray(1)), i.length > 32)
      return 1;
    let s = e.subarray(6 + r);
    if (s.length === 33 && s[0] === 0 && (s = s.slice(1)), s.length > 32)
      throw new Error("S length is too long");
    let a = new zr(i);
    a.cmp(sr.n) >= 0 && (a = new zr(0));
    let o = new zr(e.subarray(6 + r));
    return o.cmp(sr.n) >= 0 && (o = new zr(0)), t.set(a.toArrayLike(Uint8Array, "be", 32), 0), t.set(o.toArrayLike(Uint8Array, "be", 32), 32), 0;
  },
  ecdsaSign(t, e, r, n, i) {
    if (i) {
      const o = i;
      i = (c) => {
        const f = o(e, r, null, n, c);
        if (!(f instanceof Uint8Array && f.length === 32))
          throw new Error("This is the way");
        return new zr(f);
      };
    }
    const s = new zr(r);
    if (s.cmp(sr.n) >= 0 || s.isZero())
      return 1;
    let a;
    try {
      a = $s.sign(e, r, { canonical: !0, k: i, pers: n });
    } catch {
      return 1;
    }
    return t.signature.set(a.r.toArrayLike(Uint8Array, "be", 32), 0), t.signature.set(a.s.toArrayLike(Uint8Array, "be", 32), 32), t.recid = a.recoveryParam, 0;
  },
  ecdsaVerify(t, e, r) {
    const n = { r: t.subarray(0, 32), s: t.subarray(32, 64) }, i = new zr(n.r), s = new zr(n.s);
    if (i.cmp(sr.n) >= 0 || s.cmp(sr.n) >= 0)
      return 1;
    if (s.cmp($s.nh) === 1 || i.isZero() || s.isZero())
      return 3;
    const a = Qa(r);
    if (a === null)
      return 2;
    const o = a.getPublic();
    return $s.verify(e, n, o) ? 0 : 3;
  },
  ecdsaRecover(t, e, r, n) {
    const i = { r: e.slice(0, 32), s: e.slice(32, 64) }, s = new zr(i.r), a = new zr(i.s);
    if (s.cmp(sr.n) >= 0 || a.cmp(sr.n) >= 0)
      return 1;
    if (s.isZero() || a.isZero())
      return 2;
    let o;
    try {
      o = $s.recoverPubKey(n, i, r);
    } catch {
      return 2;
    }
    return Lo(t, o), 0;
  },
  ecdh(t, e, r, n, i, s, a) {
    const o = Qa(e);
    if (o === null)
      return 1;
    const c = new zr(r);
    if (c.cmp(sr.n) >= 0 || c.isZero())
      return 2;
    const f = o.getPublic().mul(c);
    if (i === void 0) {
      const u = f.encode(null, !0), d = $s.hash().update(u).digest();
      for (let l = 0; l < 32; ++l)
        t[l] = d[l];
    } else {
      s || (s = new Uint8Array(32));
      const u = f.getX().toArray("be", 32);
      for (let y = 0; y < 32; ++y)
        s[y] = u[y];
      a || (a = new Uint8Array(32));
      const d = f.getY().toArray("be", 32);
      for (let y = 0; y < 32; ++y)
        a[y] = d[y];
      const l = i(s, a, n);
      if (!(l instanceof Uint8Array && l.length === t.length))
        return 2;
      t.set(l);
    }
    return 0;
  }
}, Sne = gne(_ne), Ys = $d(), ci = Lt.Buffer, t1 = H2(), L_ = bne, Ene = A0, Ao = Sne, xne = ci.from("Bitcoin seed", "utf8"), Wp = 2147483648, Ane = 78, b7 = { private: 76066276, public: 76067358 };
function ln(t) {
  this.versions = t || b7, this.depth = 0, this.index = 0, this._privateKey = null, this._publicKey = null, this.chainCode = null, this._fingerprint = 0, this.parentFingerprint = 0;
}
Object.defineProperty(ln.prototype, "fingerprint", { get: function() {
  return this._fingerprint;
} });
Object.defineProperty(ln.prototype, "identifier", { get: function() {
  return this._identifier;
} });
Object.defineProperty(ln.prototype, "pubKeyHash", { get: function() {
  return this.identifier;
} });
Object.defineProperty(ln.prototype, "privateKey", {
  get: function() {
    return this._privateKey;
  },
  set: function(t) {
    Ys.equal(t.length, 32, "Private key must be 32 bytes."), Ys(Ao.privateKeyVerify(t) === !0, "Invalid private key"), this._privateKey = t, this._publicKey = ci.from(Ao.publicKeyCreate(t, !0)), this._identifier = v7(this.publicKey), this._fingerprint = this._identifier.slice(0, 4).readUInt32BE(0);
  }
});
function g7(t, e) {
  t._publicKey = ci.from(e), t._identifier = v7(e), t._fingerprint = t._identifier.slice(0, 4).readUInt32BE(0), t._privateKey = null;
}
Object.defineProperty(ln.prototype, "publicKey", {
  get: function() {
    return this._publicKey;
  },
  set: function(t) {
    Ys(t.length === 33 || t.length === 65, "Public key must be 33 or 65 bytes."), Ys(Ao.publicKeyVerify(t) === !0, "Invalid public key");
    const e = t.length === 65 ? Ao.publicKeyConvert(t, !0) : t;
    g7(this, e);
  }
});
Object.defineProperty(ln.prototype, "privateExtendedKey", {
  get: function() {
    return this._privateKey ? L_.encode(m7(this, this.versions.private, ci.concat([ci.alloc(1, 0), this.privateKey]))) : null;
  }
});
Object.defineProperty(ln.prototype, "publicExtendedKey", {
  get: function() {
    return L_.encode(m7(this, this.versions.public, this.publicKey));
  }
});
ln.prototype.derive = function(t) {
  if (t === "m" || t === "M" || t === "m'" || t === "M'")
    return this;
  var e = t.split("/"), r = this;
  return e.forEach(function(n, i) {
    if (i === 0) {
      Ys(/^[mM]{1}/.test(n), 'Path must start with "m" or "M"');
      return;
    }
    var s = n.length > 1 && n[n.length - 1] === "'", a = parseInt(n, 10);
    Ys(a < Wp, "Invalid index"), s && (a += Wp), r = r.deriveChild(a);
  }), r;
};
ln.prototype.deriveChild = function(t) {
  var e = t >= Wp, r = ci.allocUnsafe(4);
  r.writeUInt32BE(t, 0);
  var n;
  if (e) {
    Ys(this.privateKey, "Could not derive hardened child key");
    var i = this.privateKey, s = ci.alloc(1, 0);
    i = ci.concat([s, i]), n = ci.concat([i, r]);
  } else
    n = ci.concat([this.publicKey, r]);
  var a = t1.createHmac("sha512", this.chainCode).update(n).digest(), o = a.slice(0, 32), c = a.slice(32), f = new ln(this.versions);
  if (this.privateKey)
    try {
      f.privateKey = ci.from(Ao.privateKeyTweakAdd(ci.from(this.privateKey), o));
    } catch {
      return this.deriveChild(t + 1);
    }
  else
    try {
      f.publicKey = ci.from(Ao.publicKeyTweakAdd(ci.from(this.publicKey), o, !0));
    } catch {
      return this.deriveChild(t + 1);
    }
  return f.chainCode = c, f.depth = this.depth + 1, f.parentFingerprint = this.fingerprint, f.index = t, f;
};
ln.prototype.sign = function(t) {
  return ci.from(Ao.ecdsaSign(Uint8Array.from(t), Uint8Array.from(this.privateKey)).signature);
};
ln.prototype.verify = function(t, e) {
  return Ao.ecdsaVerify(
    Uint8Array.from(e),
    Uint8Array.from(t),
    Uint8Array.from(this.publicKey)
  );
};
ln.prototype.wipePrivateData = function() {
  return this._privateKey && t1.randomBytes(this._privateKey.length).copy(this._privateKey), this._privateKey = null, this;
};
ln.prototype.toJSON = function() {
  return {
    xpriv: this.privateExtendedKey,
    xpub: this.publicExtendedKey
  };
};
ln.fromMasterSeed = function(t, e) {
  var r = t1.createHmac("sha512", xne).update(t).digest(), n = r.slice(0, 32), i = r.slice(32), s = new ln(e);
  return s.chainCode = i, s.privateKey = n, s;
};
ln.fromExtendedKey = function(t, e, r) {
  e = e || b7, r = r || !1;
  var n = new ln(e), i = L_.decode(t), s = i.readUInt32BE(0);
  Ys(s === e.private || s === e.public, "Version mismatch: does not match private or public"), n.depth = i.readUInt8(4), n.parentFingerprint = i.readUInt32BE(5), n.index = i.readUInt32BE(9), n.chainCode = i.slice(13, 45);
  var a = i.slice(45);
  return a.readUInt8(0) === 0 ? (Ys(s === e.private, "Version mismatch: version does not match private"), n.privateKey = a.slice(1)) : (Ys(s === e.public, "Version mismatch: version does not match public"), r ? g7(n, a) : n.publicKey = a), n;
};
ln.fromJSON = function(t) {
  return ln.fromExtendedKey(t.xpriv);
};
function m7(t, e, r) {
  var n = ci.allocUnsafe(Ane);
  n.writeUInt32BE(e, 0), n.writeUInt8(t.depth, 4);
  var i = t.depth ? t.parentFingerprint : 0;
  return n.writeUInt32BE(i, 5), n.writeUInt32BE(t.index, 9), t.chainCode.copy(n, 13), r.copy(n, 45), n;
}
function v7(t) {
  var e = t1.createHash("sha256").update(t).digest();
  return new Ene().update(e).digest();
}
ln.HARDENED_OFFSET = Wp;
var Ine = ln, r1 = {};
Object.defineProperty(r1, "__esModule", {
  value: !0
});
r1.default = void 0;
r1.fromMasterSeed = One;
var Tne = w7(ww), zp = w7(Ine);
function w7(t) {
  return t && t.__esModule ? t : { default: t };
}
function kne(t, e, r) {
  return e = Rne(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Rne(t) {
  var e = Pne(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Pne(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function One() {
  return ms.create(zp.default.fromMasterSeed.apply(zp.default, arguments));
}
class ms {
  constructor(e) {
    this._hdkey = e;
  }
  static create(e) {
    return new ms(e);
  }
  static fromJSON(e) {
    typeof e == "string" && (e = JSON.parse(e));
    const r = zp.default.fromJSON(e);
    return new ms(r);
  }
  static fromXPub(e, {
    skipVerification: r = !1
  } = {}) {
    const n = zp.default.fromExtendedKey(e, null, r);
    return new ms(n);
  }
  static fromXPriv(...e) {
    return ms.fromXPub(...e);
  }
  derive(e) {
    if (typeof e == "number") {
      if (!Number.isSafeInteger(e))
        throw new RangeError("number must be safe integer");
      return ms.create(this._hdkey.deriveChild(e));
    }
    if (typeof e == "string")
      return ms.create(this._hdkey.derive(e));
    throw new TypeError("unknown type, expected a number or a path");
  }
  wipePrivateData() {
    this._hdkey.wipePrivateData();
  }
  inspect() {
    return this.toJSON();
  }
  toJSON() {
    return this._hdkey.toJSON();
  }
  toString() {
    return JSON.stringify(this.inspect(), null, 2);
  }
  get privateKey() {
    return this._hdkey.privateKey;
  }
  get publicKey() {
    return this._hdkey.publicKey;
  }
  get xPub() {
    return this._hdkey.publicExtendedKey;
  }
  get identifier() {
    return this._hdkey.identifier;
  }
}
r1.default = ms;
kne(ms, "memoizedFromXPub", (0, Tne.default)(ms.fromXPub));
var _7 = { exports: {} };
(function(t) {
  (function(e, r, n) {
    t.exports ? t.exports = n() : r[e] = n();
  })("urljoin", Ne, function() {
    function e(r) {
      var n = [];
      if (r.length === 0)
        return "";
      if (typeof r[0] != "string")
        throw new TypeError("Url must be a string. Received " + r[0]);
      if (r[0].match(/^[^/:]+:\/*$/) && r.length > 1) {
        var i = r.shift();
        r[0] = i + r[0];
      }
      r[0].match(/^file:\/\/\//) ? r[0] = r[0].replace(/^([^/:]+):\/*/, "$1:///") : r[0] = r[0].replace(/^([^/:]+):\/*/, "$1://");
      for (var s = 0; s < r.length; s++) {
        var a = r[s];
        if (typeof a != "string")
          throw new TypeError("Url must be a string. Received " + a);
        a !== "" && (s > 0 && (a = a.replace(/^[\/]+/, "")), s < r.length - 1 ? a = a.replace(/[\/]+$/, "") : a = a.replace(/[\/]+$/, "/"), n.push(a));
      }
      var o = n.join("/");
      o = o.replace(/\/(\?|&|#[^!])/g, "$1");
      var c = o.split("?");
      return o = c.shift() + (c.length > 0 ? "?" : "") + c.join("&"), o;
    }
    return function() {
      var r;
      return typeof arguments[0] == "object" ? r = arguments[0] : r = [].slice.call(arguments), e(r);
    };
  });
})(_7);
var Bne = _7.exports;
const Mne = /* @__PURE__ */ Ln(Bne);
var i2 = { exports: {} }, Bm, V4;
function Cne() {
  if (V4)
    return Bm;
  V4 = 1;
  var t = 1e3, e = t * 60, r = e * 60, n = r * 24, i = n * 7, s = n * 365.25;
  Bm = function(u, d) {
    d = d || {};
    var l = typeof u;
    if (l === "string" && u.length > 0)
      return a(u);
    if (l === "number" && isFinite(u))
      return d.long ? c(u) : o(u);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(u)
    );
  };
  function a(u) {
    if (u = String(u), !(u.length > 100)) {
      var d = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        u
      );
      if (d) {
        var l = parseFloat(d[1]), h = (d[2] || "ms").toLowerCase();
        switch (h) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return l * s;
          case "weeks":
          case "week":
          case "w":
            return l * i;
          case "days":
          case "day":
          case "d":
            return l * n;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return l * r;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return l * e;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return l * t;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return l;
          default:
            return;
        }
      }
    }
  }
  function o(u) {
    var d = Math.abs(u);
    return d >= n ? Math.round(u / n) + "d" : d >= r ? Math.round(u / r) + "h" : d >= e ? Math.round(u / e) + "m" : d >= t ? Math.round(u / t) + "s" : u + "ms";
  }
  function c(u) {
    var d = Math.abs(u);
    return d >= n ? f(u, d, n, "day") : d >= r ? f(u, d, r, "hour") : d >= e ? f(u, d, e, "minute") : d >= t ? f(u, d, t, "second") : u + " ms";
  }
  function f(u, d, l, h) {
    var y = d >= l * 1.5;
    return Math.round(u / l) + " " + h + (y ? "s" : "");
  }
  return Bm;
}
function Nne(t) {
  r.debug = r, r.default = r, r.coerce = c, r.disable = s, r.enable = i, r.enabled = a, r.humanize = Cne(), r.destroy = f, Object.keys(t).forEach((u) => {
    r[u] = t[u];
  }), r.names = [], r.skips = [], r.formatters = {};
  function e(u) {
    let d = 0;
    for (let l = 0; l < u.length; l++)
      d = (d << 5) - d + u.charCodeAt(l), d |= 0;
    return r.colors[Math.abs(d) % r.colors.length];
  }
  r.selectColor = e;
  function r(u) {
    let d, l = null, h, y;
    function p(...b) {
      if (!p.enabled)
        return;
      const v = p, x = Number(/* @__PURE__ */ new Date()), I = x - (d || x);
      v.diff = I, v.prev = d, v.curr = x, d = x, b[0] = r.coerce(b[0]), typeof b[0] != "string" && b.unshift("%O");
      let L = 0;
      b[0] = b[0].replace(/%([a-zA-Z%])/g, (C, D) => {
        if (C === "%%")
          return "%";
        L++;
        const F = r.formatters[D];
        if (typeof F == "function") {
          const G = b[L];
          C = F.call(v, G), b.splice(L, 1), L--;
        }
        return C;
      }), r.formatArgs.call(v, b), (v.log || r.log).apply(v, b);
    }
    return p.namespace = u, p.useColors = r.useColors(), p.color = r.selectColor(u), p.extend = n, p.destroy = r.destroy, Object.defineProperty(p, "enabled", {
      enumerable: !0,
      configurable: !1,
      get: () => l !== null ? l : (h !== r.namespaces && (h = r.namespaces, y = r.enabled(u)), y),
      set: (b) => {
        l = b;
      }
    }), typeof r.init == "function" && r.init(p), p;
  }
  function n(u, d) {
    const l = r(this.namespace + (typeof d > "u" ? ":" : d) + u);
    return l.log = this.log, l;
  }
  function i(u) {
    r.save(u), r.namespaces = u, r.names = [], r.skips = [];
    let d;
    const l = (typeof u == "string" ? u : "").split(/[\s,]+/), h = l.length;
    for (d = 0; d < h; d++)
      l[d] && (u = l[d].replace(/\*/g, ".*?"), u[0] === "-" ? r.skips.push(new RegExp("^" + u.slice(1) + "$")) : r.names.push(new RegExp("^" + u + "$")));
  }
  function s() {
    const u = [
      ...r.names.map(o),
      ...r.skips.map(o).map((d) => "-" + d)
    ].join(",");
    return r.enable(""), u;
  }
  function a(u) {
    if (u[u.length - 1] === "*")
      return !0;
    let d, l;
    for (d = 0, l = r.skips.length; d < l; d++)
      if (r.skips[d].test(u))
        return !1;
    for (d = 0, l = r.names.length; d < l; d++)
      if (r.names[d].test(u))
        return !0;
    return !1;
  }
  function o(u) {
    return u.toString().substring(2, u.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  function c(u) {
    return u instanceof Error ? u.stack || u.message : u;
  }
  function f() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }
  return r.enable(r.load()), r;
}
var Une = Nne;
(function(t, e) {
  e.formatArgs = n, e.save = i, e.load = s, e.useColors = r, e.storage = a(), e.destroy = /* @__PURE__ */ (() => {
    let c = !1;
    return () => {
      c || (c = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), e.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function r() {
    return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function n(c) {
    if (c[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + c[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), !this.useColors)
      return;
    const f = "color: " + this.color;
    c.splice(1, 0, f, "color: inherit");
    let u = 0, d = 0;
    c[0].replace(/%[a-zA-Z%]/g, (l) => {
      l !== "%%" && (u++, l === "%c" && (d = u));
    }), c.splice(d, 0, f);
  }
  e.log = console.debug || console.log || (() => {
  });
  function i(c) {
    try {
      c ? e.storage.setItem("debug", c) : e.storage.removeItem("debug");
    } catch {
    }
  }
  function s() {
    let c;
    try {
      c = e.storage.getItem("debug");
    } catch {
    }
    return !c && typeof ut < "u" && "env" in ut && (c = ut.env.DEBUG), c;
  }
  function a() {
    try {
      return localStorage;
    } catch {
    }
  }
  t.exports = Une(e);
  const { formatters: o } = t.exports;
  o.j = function(c) {
    try {
      return JSON.stringify(c);
    } catch (f) {
      return "[UnexpectedJSONParseError]: " + f.message;
    }
  };
})(i2, i2.exports);
var Lne = i2.exports;
const Dne = /* @__PURE__ */ Ln(Lne);
var D_ = { exports: {} };
const Fne = (t, e) => Math.floor(Math.random() * (e - t + 1) + t), H4 = () => {
  const t = new Error("Delay aborted");
  return t.name = "AbortError", t;
}, Kp = ({ clearTimeout: t, setTimeout: e, willResolve: r }) => (n, { value: i, signal: s } = {}) => {
  if (s && s.aborted)
    return Promise.reject(H4());
  let a, o, c;
  const f = t || clearTimeout, u = () => {
    f(a), c(H4());
  }, d = () => {
    s && s.removeEventListener("abort", u);
  }, l = new Promise((h, y) => {
    o = () => {
      d(), r ? h(i) : y(i);
    }, c = y, a = (e || setTimeout)(o, n);
  });
  return s && s.addEventListener("abort", u, { once: !0 }), l.clear = () => {
    f(a), a = null, o();
  }, l;
}, of = Kp({ willResolve: !0 });
of.reject = Kp({ willResolve: !1 });
of.range = (t, e, r) => of(Fne(t, e), r);
of.createWithTimers = ({ clearTimeout: t, setTimeout: e }) => {
  const r = Kp({ clearTimeout: t, setTimeout: e, willResolve: !0 });
  return r.reject = Kp({ clearTimeout: t, setTimeout: e, willResolve: !1 }), r;
};
D_.exports = of;
D_.exports.default = of;
var jne = D_.exports;
const G4 = /* @__PURE__ */ Ln(jne);
var $ne = function(t, e) {
  const r = Object.assign({ concurrency: 1 }, e).concurrency;
  if (typeof r != "number" || isNaN(r) || r <= 0)
    throw new TypeError(`Invalid concurrency value: ${r}`);
  let n = 0;
  const i = [];
  function s() {
    i.length > 0 ? i.shift().resolve() : n -= 1;
  }
  return function() {
    let a;
    return n >= r ? a = new Promise((o) => i.push({ resolve: o })) : (a = Promise.resolve(), n += 1), a.then(() => t.apply(this, arguments)).then((o) => (s(), o), (o) => {
      throw s(), o;
    });
  };
};
const qne = /* @__PURE__ */ Ln($ne), Wne = "wss://solana.a.exodus.io/ws", zne = xo("15s"), Kne = xo("60s"), Vne = xo("50s"), Ds = Dne("exodus:solana-api");
class Hne {
  constructor({
    endpoint: e = Wne,
    address: r,
    tokensAddresses: n = [],
    callback: i,
    onMsg: s,
    reconnectCallback: a = () => {
    },
    reconnectDelay: o = zne
  }) {
    this.address = r, this.tokensAddresses = n, this.endpoint = e, this.callback = i, this.onMsg = s, this.reconnectCallback = a, this.reconnectDelay = o, this.shutdown = !1, this.ws = null, this.rpcQueue = {}, this.messageQueue = [], this.inProcessMessages = !1, this.pingTimeout = null, this.reconnectTimeout = null, this.txCache = {}, this.sendMessage = qne(
      async (c, f = []) => new Promise((u, d) => {
        if (this.isClosed || this.shutdown)
          return d(new Error("connection not started"));
        const l = Math.floor(Math.random() * 1e7) + 1;
        this.rpcQueue[l] = { resolve: u, reject: d }, this.rpcQueue[l].timeout = setTimeout(() => {
          delete this.rpcQueue[l], console.log(`solana ws: reply timeout (${c}) - ${JSON.stringify(f)} - ${l}`), u(null);
        }, Vne), typeof this.rpcQueue[l].timeout.unref == "function" && this.rpcQueue[l].timeout.unref(), this.ws.send(JSON.stringify({ jsonrpc: "2.0", method: c, params: f, id: l }));
      }),
      { concurrency: 15 }
    );
  }
  newSocket(e) {
    const r = new URL(e);
    r.protocol = "wss:", e = `${r}`, Ds("Opening WS to:", e);
    const n = new Wo.WebSocket(`${e}`);
    return n.addEventListener("message", this.onMessage.bind(this)), n.addEventListener("open", this.onOpen.bind(this)), n.addEventListener("close", this.onClose.bind(this)), n.addEventListener("error", this.onError.bind(this)), n;
  }
  get isConnecting() {
    return !!(this.ws && this.ws.readyState === Wo.WebSocket.CONNECTING);
  }
  get isOpen() {
    return !!(this.ws && this.ws.readyState === Wo.WebSocket.OPEN);
  }
  get isClosing() {
    return !!(this.ws && this.ws.readyState === Wo.WebSocket.CLOSING);
  }
  get isClosed() {
    return !this.ws || this.ws.readyState === Wo.WebSocket.CLOSED;
  }
  get running() {
    return !!(!this.isClosed || this.inProcessMessages || this.messageQueue.length > 0);
  }
  get connectionState() {
    return this.isConnecting ? "CONNECTING" : this.isOpen ? "OPEN" : this.isClosing ? "CLOSING" : this.isClosed ? "CLOSED" : "NONE";
  }
  doPing() {
    this.ws && (this.ws.ping(), this.pingTimeout = setTimeout(this.doPing.bind(this), Kne));
  }
  doRestart() {
    this.reconnectTimeout = setTimeout(async () => {
      try {
        Ds("reconnecting ws..."), this.start(), await this.reconnectCallback();
      } catch (e) {
        console.log(`Error in reconnect callback: ${e.message}`);
      }
    }, this.reconnectDelay);
  }
  onMessage(e) {
    try {
      const r = JSON.parse(e.data);
      if (Ds("new ws msg:", r), r.error)
        kt.get(this.rpcQueue, r.id) ? (this.rpcQueue[r.id].reject(new Error(r.error.message)), clearTimeout(this.rpcQueue[r.id].timeout), delete this.rpcQueue[r.id]) : Ds("Unsupported WS message:", r.error.message);
      else {
        if (kt.get(this.rpcQueue, r.id))
          clearTimeout(this.rpcQueue[r.id].timeout), this.rpcQueue[r.id].resolve(r.result), delete this.rpcQueue[r.id];
        else if (r.method) {
          const n = { method: r.method, ...kt.get(r, "params.result", r.result) };
          Ds("pushing msg to queue", n), this.messageQueue.push(n);
        }
        this.processMessages(r);
      }
    } catch (r) {
      Ds(r), Ds("Cannot parse msg:", e.data);
    }
  }
  onOpen(e) {
    Ds("Opened WS"), [...this.tokensAddresses, this.address].forEach((n) => {
      this.ws.send(
        JSON.stringify({
          jsonrpc: "2.0",
          method: "accountSubscribe",
          params: [
            n,
            {
              encoding: "jsonParsed"
            }
          ],
          id: 1
        })
      ), this.ws.send(
        JSON.stringify({
          jsonrpc: "2.0",
          method: "logsSubscribe",
          params: [{ mentions: [n] }, { commitment: "finalized" }],
          id: 2
        })
      );
    });
  }
  onError(e) {
    Ds("Error on WS:", e.data);
  }
  onClose(e) {
    Ds("Closing WS"), clearTimeout(this.pingTimeout), clearTimeout(this.reconnectTimeout), this.shutdown || this.doRestart();
  }
  async processMessages(e) {
    if (this.onMsg && await this.onMsg(e), this.inProcessMessages)
      return null;
    this.inProcessMessages = !0;
    try {
      for (; this.messageQueue.length > 0; ) {
        const r = this.messageQueue.splice(0, this.messageQueue.length);
        await this.callback(r);
      }
    } catch (r) {
      console.log(`Solana: error processing streams: ${r.message}`);
    } finally {
      this.inProcessMessages = !1;
    }
  }
  async close() {
    clearTimeout(this.reconnectTimeout), clearTimeout(this.pingTimeout), this.ws && (this.isConnecting || this.isOpen) && (await G4(xo("1s")), await this.ws.close(), await this.ws.terminate());
  }
  async start() {
    try {
      if (!this.isClosed || this.shutdown)
        return;
      this.ws = this.newSocket(this.endpoint);
    } catch (e) {
      console.log("Solana: error starting WS:", e), this.doRestart();
    }
  }
  async stop() {
    if (!this.shutdown)
      for (this.shutdown = !0, await this.close(); this.running; )
        await G4(xo("1s"));
  }
}
const Gne = "https://solana.a.exodus.io", Zne = "wss://solana.a.exodus.io/ws", Jne = !0;
class Yne {
  constructor({ rpcUrl: e, wsUrl: r, assets: n, txsLimit: i }) {
    /**
     * Broadcast a signed transaction
     */
    Zt(this, "broadcastTransaction", async (e, r) => {
      console.log("Solana broadcasting TX:", e);
      const i = [e, { ...{ encoding: "base64", preflightCommitment: "confirmed" }, ...r }], s = ["Blockhash not found"];
      return gG(
        async () => {
          try {
            const o = await this.rpcCall("sendTransaction", i, { forceHttp: !0 });
            return console.log(`tx ${JSON.stringify(o)} sent!`), o || null;
          } catch (o) {
            throw o.message && !s.some((c) => o.message.includes(c)) && (o.finalError = !0), console.warn("Error broadcasting tx. Retrying...", o), o;
          }
        },
        { delayTimesMs: ["6s", "6s", "8s", "10s"] }
      )();
    });
    Zt(this, "simulateTransaction", async (e, r) => {
      const {
        value: { accounts: n, unitsConsumed: i, err: s }
      } = await this.rpcCall("simulateTransaction", [e, r]);
      return { accounts: n, unitsConsumed: i, err: s };
    });
    Zt(this, "resolveSimulationSideEffects", async (e, r) => {
      const n = [], i = [], s = e.map(async (l) => {
        const h = await this.getBalance(l.address);
        return {
          name: "SOL",
          symbol: "SOL",
          balance: W8(l.amount, h),
          decimal: zJ,
          type: "SOL"
        };
      }), a = (l, h) => async (...y) => {
        try {
          return await l.apply(this, y);
        } catch (p) {
          if (p.message && p.message.includes("could not find account"))
            return h;
          throw p;
        }
      }, o = a(this.getTokenBalance, "0"), c = a(this.getDecimals, 0), f = a(this.getSupply, "0"), u = r.map(async (l) => {
        try {
          const [h, y, p] = await Promise.all([
            this.getMetaplexMetadata(l.mint),
            o(l.address),
            c(l.mint)
          ]), b = h || { name: null, symbol: null };
          let v = {
            collectionId: null,
            collectionName: null,
            collectionTitle: null,
            title: null
          };
          if (p === 0 && await f(l.mint) === "1")
            try {
              const {
                id: I,
                collectionName: L,
                collectionTitle: P,
                title: C
              } = await FI.api.getNFTByMintAddress(l.mint);
              v = {
                collectionId: I,
                collectionTitle: P,
                collectionName: L,
                title: C
              }, b.name = b.name || P, b.symbol = b.symbol || L;
            } catch (I) {
              console.warn(I);
            }
          return {
            balance: W8(l.amount, y),
            decimal: p,
            nft: v,
            address: l.address,
            mint: l.mint,
            name: b.name,
            symbol: b.symbol,
            type: "TOKEN"
          };
        } catch (h) {
          return console.warn(h), {
            balance: null
          };
        }
      });
      return (await Promise.all([...s, ...u])).forEach((l) => {
        l.balance !== null && (l.balance > 0 ? n.push(l) : i.push(l));
      }), {
        willReceive: n,
        willSend: i
      };
    });
    Zt(this, "simulateUnsignedTransaction", async ({ message: e, transactionMessage: r }) => {
      const { config: n, accountAddresses: i } = ZJ(
        r || e
      ), s = new Array(e.header.numRequiredSignatures || 1).fill(null), a = fre(
        ve.from(e.serialize()),
        s
      ).toString("base64"), { accounts: o, unitsConsumed: c, err: f } = await this.simulateTransaction(a, {
        ...n,
        replaceRecentBlockhash: !0,
        sigVerify: !1
      });
      return {
        accounts: o,
        accountAddresses: i,
        unitsConsumed: c,
        err: f
      };
    });
    /**
     * Simulate transaction and return side effects
     */
    Zt(this, "simulateAndRetrieveSideEffects", async (e, r, n) => {
      const { accounts: i, accountAddresses: s } = await this.simulateUnsignedTransaction({
        message: e,
        transactionMessage: n
      }), { solAccounts: a, tokenAccounts: o } = YJ(
        i,
        s,
        r
      );
      return this.resolveSimulationSideEffects(a, o);
    });
    this.setServer(e), this.setWsEndpoint(r), this.setTokens(n), this.tokensToSkip = {}, this.txsLimit = i, this.connections = {}, this.getSupply = kt.memoize(async (s) => {
      const a = await this.rpcCall("getTokenSupply", [s]);
      return kt.get(a, "value.amount");
    });
  }
  setServer(e) {
    this.rpcUrl = e || Gne, this.api = aH(this.rpcUrl);
  }
  setWsEndpoint(e) {
    this.wsUrl = e || Zne;
  }
  setTokens(e = {}) {
    const r = kt.pickBy(e, (n) => n.assetType === "SOLANA_TOKEN");
    this.tokens = new Map(Object.values(r).map((n) => [n.mintAddress, n]));
  }
  request(e, r = "application/json") {
    return Ww(Mne(this.rpcUrl, e)).headers({
      "Content-Type": r
    });
  }
  async watchAddress({
    address: e,
    tokensAddresses: r = [],
    onMessage: n,
    handleAccounts: i,
    handleTransfers: s,
    handleReconnect: a,
    reconnectDelay: o
  }) {
    if (this.connections[e])
      return;
    const c = new Hne({
      endpoint: this.wsUrl,
      address: e,
      tokensAddresses: r,
      onMsg: (f) => n(f),
      callback: (f) => this.handleUpdates({ updates: f, address: e, handleAccounts: i, handleTransfers: s }),
      reconnectCallback: a,
      reconnectDelay: o
    });
    return this.connections[e] = c, c.start();
  }
  async unwatchAddress({ address: e }) {
    this.connections[e] && (await this.connections[e].stop(), delete this.connections[e]);
  }
  async handleUpdates({ updates: e, address: r, handleAccounts: n, handleTransfers: i }) {
    if (i)
      return i(e);
  }
  async rpcCall(e, r = [], { address: n = "", forceHttp: i = Jne } = {}) {
    const s = this.connections[n] || kt.sample(Object.values(this.connections));
    return kt.get(s, "isOpen") && !kt.get(s, "shutdown") && !i ? s.sendMessage(e, r) : this.api.post({ method: e, params: r });
  }
  getTokenByAddress(e) {
    return this.tokens.get(e);
  }
  isTokenSupported(e) {
    return this.tokens.has(e);
  }
  async getEpochInfo() {
    const { epoch: e } = await this.rpcCall("getEpochInfo");
    return Number(e);
  }
  async getStakeActivation(e) {
    const { state: r } = await this.rpcCall("getStakeActivation", [e]);
    return r;
  }
  async getRecentBlockHash(e) {
    const r = await this.rpcCall(
      "getLatestBlockhash",
      [{ commitment: e || "finalized", encoding: "jsonParsed" }],
      { forceHttp: !0 }
    );
    return kt.get(r, "value.blockhash");
  }
  // Transaction structure: https://docs.solana.com/apps/jsonrpc-api#transaction-structure
  async getTransactionById(e) {
    return this.rpcCall("getTransaction", [
      e,
      { encoding: "jsonParsed", maxSupportedTransactionVersion: 0 }
    ]);
  }
  async getFee() {
    const e = await this.rpcCall("getRecentBlockhash", [
      { commitment: "finalized", encoding: "jsonParsed" }
    ]);
    return kt.get(e, "value.feeCalculator.lamportsPerSignature");
  }
  async getPriorityFee(e) {
    return (await this.rpcCall("getPriorityFeeEstimate", [
      { transaction: e, options: { recommended: !0 } }
    ])).priorityFeeEstimate;
  }
  async getBalance(e) {
    const r = await this.rpcCall("getBalance", [e, { encoding: "jsonParsed" }], {
      address: e
    });
    return kt.get(r, "value", 0);
  }
  async getBlockTime(e) {
    return this.rpcCall("getBlockTime", [e]);
  }
  async getConfirmedSignaturesForAddress(e, { until: r, before: n, limit: i } = {}) {
    return r = r || void 0, this.rpcCall("getSignaturesForAddress", [e, { until: r, before: n, limit: i }], { address: e });
  }
  /**
   * Get transactions from an address
   */
  async getTransactions(e, { cursor: r, before: n, limit: i, includeUnparsed: s = !1 } = {}) {
    i = i || this.txsLimit;
    let a = [];
    try {
      const c = r, f = await this.getTokenAccountsByOwner(e), u = f.filter(({ tokenName: p }) => p !== "unknown").map(({ tokenAccountAddress: p }) => p), d = [e, ...u];
      let h = (await Promise.all(
        d.map(
          (p) => this.getConfirmedSignaturesForAddress(p, {
            until: c,
            before: n,
            limit: i
          })
        )
      )).flat();
      h = kt.uniqBy(h, "signature"), (await Promise.all(h.map((p) => this.getTransactionById(p.signature)))).forEach((p) => {
        if (!p)
          return;
        const b = p.blockTime * 1e3, v = this.parseTransaction(e, p, f, {
          includeUnparsed: s
        });
        !v.from && !s || (v.dexTxs && (v.dexTxs.forEach((x) => {
          a.push({
            timestamp: b,
            date: new Date(b),
            ...x
          });
        }), delete v.dexTxs), a.push({
          timestamp: b,
          date: new Date(b),
          ...v
        }));
      });
    } catch (c) {
      throw console.warn("Solana error:", c), c;
    }
    a = kt.orderBy(a, ["timestamp"], ["desc"]);
    const o = a[0] ? a[0].id : r;
    return { transactions: a, newCursor: o };
  }
  parseTransaction(e, r, n, { includeUnparsed: i = !1 } = {}) {
    var D;
    let { fee: s, preBalances: a, postBalances: o, preTokenBalances: c, postTokenBalances: f, innerInstructions: u } = r.meta;
    a = a || [], o = o || [], c = c || [], f = f || [], u = u || [];
    let { instructions: d, accountKeys: l } = r.transaction.message;
    const h = () => {
      const F = l.findIndex((re) => re.pubkey === e), G = F === 0 ? s : 0;
      return {
        unparsed: !0,
        amount: F === -1 ? 0 : o[F] - a[F] + G,
        fee: G,
        data: {
          meta: r.meta
        }
      };
    }, y = () => {
      const F = c.filter(
        (re) => re.owner === e
      );
      return f.filter(
        (re) => re.owner === e
      ).map((re) => {
        const ie = n.find(
          (N) => N.mintAddress === re.mint
        ), ee = F.find(
          (N) => N.accountIndex === re.accountIndex
        ), $ = new Ss(kt.get(ee, "uiTokenAmount.amount", "0"), 10), E = new Ss(kt.get(re, "uiTokenAmount.amount", "0"), 10).sub($);
        if (!ie || E.isZero())
          return null;
        const U = u.find((N) => {
          const O = E.isNeg() ? e : null;
          return N.token.mintAddress === ie.mintAddress && O === N.owner;
        });
        if (!U)
          return null;
        const { from: W, to: _, owner: R } = U;
        return {
          id: r.transaction.signatures[0],
          slot: r.slot,
          owner: R,
          from: W,
          to: _,
          amount: E.abs().toString(),
          // inconsistent with the rest, but it can and did overflow
          fee: 0,
          token: ie,
          data: {
            inner: !0
          }
        };
      }).filter((re) => !!re);
    };
    d = d.filter((F) => F.parsed).map((F) => ({
      program: F.program,
      // system or spl-token
      type: F.parsed.type,
      // transfer, createAccount, initializeAccount
      ...F.parsed.info
    }));
    let p = kt.find(d, (F) => [F.source, F.destination].includes(e) ? F.program === "system" && F.type === "transfer" : !1);
    const b = p || (D = d.find(
      ({ type: F, owner: G, destination: re }) => F === "closeAccount" && G === e && re === e
    )) == null ? void 0 : D.account;
    u = u.reduce((F, G) => [...F, ...G.instructions], []).map((F) => {
      const G = kt.get(F, "parsed.type");
      if (!(F.parsed && F.program === "spl-token" && ["transfer", "transferChecked", "transferCheckedWithFee"].includes(G)))
        return null;
      const ie = kt.get(F, "parsed.info.source"), ee = kt.get(F, "parsed.info.destination"), $ = Number(
        kt.get(F, "parsed.info.amount", 0) || kt.get(F, "parsed.info.tokenAmount.amount", 0)
      ), w = r.transaction.signatures[0];
      if (b && ee === b) {
        const _ = (R) => R && R === b ? e : R;
        p = {
          id: w,
          from: _(ie),
          to: _(ee),
          amount: $,
          fee: s
        };
        return;
      }
      const E = n.find(({ tokenAccountAddress: _ }) => [ie, ee].includes(_));
      if (!E)
        return;
      const U = n.some(({ tokenAccountAddress: _ }) => [ie].includes(_)), W = {
        id: w,
        slot: r.slot,
        owner: U ? e : null,
        from: ie,
        to: ee,
        amount: $,
        token: E,
        fee: U ? s : 0
      };
      return E ? W : null;
    }).filter((F) => !!F);
    const v = kt.find(d, { program: "system", type: "createAccountWithSeed" }), x = kt.find(d, { program: "stake", type: "withdraw" }), I = kt.find(d, { program: "stake", type: "deactivate" }), L = p && c.length === 0 && f.length === 0;
    let P = {};
    if (L) {
      const F = e === p.source;
      P = {
        owner: p.source,
        from: p.source,
        to: p.destination,
        amount: p.lamports,
        // number
        fee: F ? s : 0
      };
    } else if (v)
      P = {
        owner: v.base,
        from: v.base,
        to: v.base,
        amount: v.lamports,
        fee: s,
        staking: {
          method: "createAccountWithSeed",
          seed: v.seed,
          stakeAddresses: [v.newAccount],
          stake: v.lamports
        }
      };
    else if (x) {
      const F = kt.map(
        kt.filter(d, { program: "stake", type: "withdraw" }),
        "stakeAccount"
      );
      P = {
        owner: x.withdrawAuthority,
        from: x.stakeAccount,
        to: x.destination,
        amount: x.lamports,
        fee: s,
        staking: {
          method: "withdraw",
          stakeAddresses: F,
          stake: x.lamports
        }
      };
    } else if (I) {
      const F = kt.map(
        kt.filter(d, { program: "stake", type: "deactivate" }),
        "stakeAccount"
      );
      P = {
        owner: I.stakeAuthority,
        from: I.stakeAuthority,
        to: I.stakeAccount,
        // obsolete
        amount: 0,
        fee: s,
        staking: {
          method: "undelegate",
          stakeAddresses: F
        }
      };
    } else {
      Xi.ok(
        Array.isArray(n),
        "tokenAccountsByOwner is required when parsing token tx"
      );
      const F = kt.filter(d, ({ program: G, type: re }) => G === "spl-token" && ["transfer", "transferChecked", "transferCheckedWithFee"].includes(re)).map((G) => {
        let re = kt.find(n, { tokenAccountAddress: G.source });
        const ie = !!re;
        if (ie || (re = kt.find(n, {
          tokenAccountAddress: G.destination
        })), !re)
          return null;
        const ee = ie ? e : null;
        return delete re.balance, delete re.owner, {
          owner: ee,
          token: re,
          from: G.source,
          to: G.destination,
          amount: Number(G.amount || kt.get(G, "tokenAmount.amount", 0)),
          // supporting types: transfer, transferChecked, transferCheckedWithFee
          fee: ie ? s : 0
          // in lamports
        };
      });
      if (F.length > 0)
        P = F.reduce((G, re) => re ? G.token ? (G.token.ticker === re.token.ticker && (G.amount += re.amount), G) : re : G, {});
      else if (c && f) {
        const G = kt.mapKeys(l, (ee, $) => $);
        Object.values(G).forEach((ee) => {
          const $ = !!kt.find(n, {
            tokenAccountAddress: ee.pubkey
          });
          ee.owner = $ ? e : null;
        });
        const re = c.filter((ee) => G[ee.accountIndex].owner === e && this.isTokenSupported(ee.mint)), ie = f.filter((ee) => G[ee.accountIndex].owner === e && this.isTokenSupported(ee.mint));
        (re.length > 0 || ie.length > 0 || p) && (P = {}, i && u.length > 0 ? (P = h(), P.dexTxs = y()) : (p && (P = p.from && p.to ? p : {
          owner: p.source,
          from: p.source,
          to: p.destination,
          amount: p.lamports,
          // number
          fee: e === p.source ? s : 0
        }), u.length > 0 && (P.dexTxs = u, !P.from && !p && (P = P.dexTxs[0], P.dexTxs = u.slice(1)))));
      }
    }
    return Object.keys(P).length === 0 && i && (P = h()), {
      id: r.transaction.signatures[0],
      slot: r.slot,
      error: r.meta.err !== null,
      ...P
    };
  }
  async getWalletTokensList({ tokenAccounts: e }) {
    const r = [];
    for (const n of e) {
      const i = n.mintAddress;
      if (!this.tokensToSkip[i] && n.balance !== "0") {
        if (!this.tokens.has(i) && await this.getSupply(i) === "1") {
          this.tokensToSkip[i] = !0;
          continue;
        }
        r.push(i);
      }
    }
    return r;
  }
  async getTokenAccountsByOwner(e, r) {
    const [{ value: n }, { value: i }] = await Promise.all([
      this.rpcCall(
        "getTokenAccountsByOwner",
        [e, { programId: Zg.toBase58() }, { encoding: "jsonParsed" }],
        { address: e }
      ),
      this.rpcCall(
        "getTokenAccountsByOwner",
        [e, { programId: _h.toBase58() }, { encoding: "jsonParsed" }],
        { address: e }
      )
    ]), s = [...n, ...i], a = [];
    for (const o of s) {
      const { pubkey: c, account: f } = o, u = kt.get(f, "data.parsed.info.mint"), d = this.getTokenByAddress(u) || {
        name: "unknown",
        ticker: "UNKNOWN",
        decimals: 0
      }, l = kt.get(f, "data.parsed.info.tokenAmount.amount", "0"), h = kt.get(f, "owner", null), { feeBasisPoints: y = 0, maximumFee: p = 0 } = h === _h.toBase58() ? await this.getTokenFeeBasisPoints(u) : {};
      a.push({
        tokenAccountAddress: c,
        owner: e,
        tokenName: d.name,
        ticker: d.ticker,
        balance: l,
        mintAddress: u,
        tokenProgram: h,
        decimals: d.decimals,
        feeBasisPoints: y,
        maximumFee: p
      });
    }
    return r ? a.filter(({ ticker: o }) => o === r) : a;
  }
  async getTokensBalance({ address: e, filterByTokens: r = [], tokenAccounts: n }) {
    return (n || await this.getTokenAccountsByOwner(e)).reduce((s, { tokenName: a, balance: o }) => (a === "unknown" || r.length > 0 && !r.includes(a) || (s[a] ? s[a] += Number(o) : s[a] = Number(o)), s), {});
  }
  async isAssociatedTokenAccountActive(e) {
    try {
      return await this.rpcCall("getTokenAccountBalance", [e]), !0;
    } catch {
      return !1;
    }
  }
  // Returns account balance of a SPL Token account.
  async getTokenBalance(e) {
    const r = await this.rpcCall("getTokenAccountBalance", [e]);
    return kt.get(r, "value.amount");
  }
  async getAccountInfo(e, r = "jsonParsed") {
    const { value: n } = await this.rpcCall(
      "getAccountInfo",
      [e, { encoding: r, commitment: "single" }],
      { address: e }
    );
    return n;
  }
  async isSpl(e) {
    const { owner: r } = await this.getAccountInfo(e);
    return [Zg.toBase58(), _h.toBase58()].includes(r);
  }
  async getTokenFeeBasisPoints(e) {
    const r = await this.getAccountInfo(e), { transferFeeBasisPoints: n, maximumFee: i } = kt.get(
      r,
      "data.parsed.info.extensions[0].state.newerTransferFee",
      { transferFeeBasisPoints: 0, maximumFee: 0 }
    );
    return { feeBasisPoints: n, maximumFee: i };
  }
  async getMetaplexMetadata(e) {
    const r = VJ(e), n = await this.getAccountInfo(r, "base64"), i = kt.get(n, "data[0]");
    return i ? HJ(ve.from(i, "base64")) : null;
  }
  async getDecimals(e) {
    const r = await this.rpcCall("getTokenSupply", [e]);
    return kt.get(r, "value.decimals", null);
  }
  async getAddressType(e) {
    const r = await this.getAccountInfo(e);
    if (r === null)
      return null;
    const n = {
      executable: r.executable,
      owner: r.owner,
      lamports: r.lamports
    };
    return n.owner === $J.toBase58() ? "solana" : n.owner === Zg.toBase58() ? "token" : n.owner === _h.toBase58() ? "token-2022" : null;
  }
  async getTokenAddressOwner(e) {
    const r = await this.getAccountInfo(e);
    return kt.get(r, "data.parsed.info.owner", null);
  }
  async getAddressMint(e) {
    const r = await this.getAccountInfo(e);
    return kt.get(r, "data.parsed.info.mint", null);
  }
  async isTokenAddress(e) {
    const r = await this.getAddressType(e);
    return ["token", "token-2022"].includes(r);
  }
  async isSOLaddress(e) {
    return await this.getAddressType(e) === "solana";
  }
  async getStakeAccountsInfo(e) {
    const r = [
      qJ.toBase58(),
      {
        filters: [
          {
            memcmp: {
              offset: 12,
              bytes: e
            }
          }
        ],
        encoding: "jsonParsed"
      }
    ], n = await this.rpcCall("getProgramAccounts", r, { address: e }), i = {};
    let s = 0, a = 0, o = 0, c = 0, f = 0;
    for (const u of n) {
      const d = u.pubkey, l = kt.get(u, "account.lamports", 0), h = kt.get(u, "account.data.parsed.info.stake.delegation", {});
      i[d] = h, i[d].lamports = l, i[d].activationEpoch = Number(i[d].activationEpoch) || 0, i[d].deactivationEpoch = Number(i[d].deactivationEpoch) || 0;
      let y = "inactive";
      h.activationEpoch && (y = await this.getStakeActivation(d)), i[d].state = y, i[d].isDeactivating = y === "deactivating", i[d].canWithdraw = y === "inactive", i[d].stake = Number(i[d].stake) || 0, s += i[d].stake, a += ["active", "activating"].includes(i[d].state) ? l : 0, o += i[d].state === "activating" ? l : 0, c += i[d].canWithdraw ? l : 0, f += i[d].isDeactivating ? l : 0;
    }
    return { accounts: i, totalStake: s, locked: a, withdrawable: c, pending: f, activating: o };
  }
  async getRewards(e = []) {
    if (e.length === 0)
      return 0;
    const r = await this.request("rewards").post({ addresses: e }).error(500, () => ({})).error(400, () => ({})).json();
    return Object.values(r).reduce((n, i) => n + i, 0);
  }
  async getMinimumBalanceForRentExemption(e) {
    return this.rpcCall("getMinimumBalanceForRentExemption", [e]);
  }
  async getProgramAccounts(e, r) {
    return this.rpcCall("getProgramAccounts", [e, r]);
  }
  async getMultipleAccounts(e, r) {
    const n = await this.rpcCall("getMultipleAccounts", [e, r]);
    return n && n.value ? n.value : [];
  }
  async getFeeForMessage(e, r) {
    const n = await this.rpcCall("getFeeForMessage", [
      ve.from(e.serialize()).toString("base64"),
      { commitment: r }
    ]);
    return kt.get(n, "value");
  }
}
var Qne = {}, Mf = {}, Zl = {};
Object.defineProperty(Zl, "__esModule", {
  value: !0
});
Zl.isChangeAddress = eie;
Zl.isExchangeAddress = Xne;
Zl.isReceiveAddress = tie;
function Xne(t) {
  return t.pathArray[0] === 2;
}
function eie(t) {
  return t.pathArray[0] === 1;
}
function tie(t) {
  return t.pathArray[0] === 0;
}
Object.defineProperty(Mf, "__esModule", {
  value: !0
});
Mf.default = void 0;
var rie = sie(dne), nie = iie(Zl);
let S7;
function E7(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (E7 = function(n) {
    return n ? r : e;
  })(t);
}
function iie(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var r = E7(e);
  if (r && r.has(t))
    return r.get(t);
  var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in t)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(t, s)) {
      var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
      a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
    }
  return n.default = t, r && r.set(t, n), n;
}
function sie(t) {
  return t && t.__esModule ? t : { default: t };
}
function s2(t, e, r) {
  return e = aie(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function aie(t) {
  var e = oie(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function oie(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
S7 = Symbol.toStringTag;
class Mu {
  constructor(e, r) {
    s2(this, "address", void 0), s2(this, "meta", void 0), this.address = e, this.meta = r || {};
  }
  static create(e, r) {
    return Object.freeze(new Mu(e, r));
  }
  static fromJSON(e) {
    return typeof e == "string" && (e = JSON.parse(e)), Mu.create(e.address, e.meta || e.path);
  }
  get pathArray() {
    return rie.default.fromString(this.meta.path || "m/0/0").toPathArray();
  }
  toJSON() {
    return {
      address: this.address,
      meta: this.meta
    };
  }
  toString() {
    return this.address;
  }
  get [S7]() {
    return this.address;
  }
  static isAddress(e) {
    return typeof e == "object" && (e instanceof Mu || "address" in e && "meta" in e);
  }
}
Mf.default = Mu;
s2(Mu, "util", nie);
var Jl = {};
const cie = gy;
var uie = cie.omit;
const x7 = {
  construct: (t, e) => new Proxy(new t(...e), x7),
  set: (t, e, r) => {
    const n = `Trying to set value of property (${e}) of frozen object.`;
    typeof ut > "u" ? (console.warn.bind(console) || console.error.bind(console) || console.log.bind(console))(n) : ut.emitWarning(n, "ProxyFreezeWarning");
  }
};
function fie(t) {
  if (typeof t != "function" && typeof t != "object")
    throw new Error("proxyFreeze only supports constructor functions or objects.");
  return new Proxy(t, x7);
}
var A7 = fie, Zc = {};
Object.defineProperty(Zc, "__esModule", {
  value: !0
});
Zc.default = void 0;
var die = T7(hr), Rh = T7(Mf);
let I7;
function T7(t) {
  return t && t.__esModule ? t : { default: t };
}
function F_(t, e, r) {
  return e = lie(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function lie(t) {
  var e = hie(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function hie(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
I7 = Symbol.iterator;
class Gs {
  constructor() {
    F_(this, "_data", void 0), this._data = /* @__PURE__ */ new Map();
  }
  static fromArray(e) {
    const r = e.map((i) => {
      if (typeof i == "string")
        return Rh.default.create(i);
      if (typeof i == "object")
        return Rh.default.fromJSON(i);
      if (i instanceof Rh.default)
        return i;
      throw console.dir(i), new Error("AddressSet#fromArray(): unknown type");
    }), n = new Gs();
    for (const i of r)
      n._data.set(i.address, i);
    return n;
  }
  add(e) {
    (0, die.default)(Rh.default.isAddress(e), "Must be an instance of an Address.");
    const r = new Gs();
    return r._data = new Map(this._data), r._data.set(e.address, e), r;
  }
  delete(e) {
    return this.remove(e);
  }
  get(e) {
    return this._data.get(String(e));
  }
  has(e) {
    return !!this._data.get(String(e));
  }
  remove(e) {
    const r = this.get(e);
    if (!r)
      return this;
    const n = new Gs();
    return n._data = new Map(this._data), n._data.delete(r.address), n;
  }
  sort(e) {
    let r = [...this];
    return r = r.sort(e), Gs.fromArray(r);
  }
  toArray() {
    return [...this._data.values()];
  }
  toAddressStrings() {
    return [...this._data.keys()];
  }
  toString() {
    return [...this._data.keys()].join(", ");
  }
  union(e) {
    const r = [...this], n = [...e], i = [...r, ...n];
    return Gs.fromArray(i);
  }
  [I7]() {
    return this._data.values();
  }
  get size() {
    return this._data.size;
  }
}
Zc.default = Gs;
F_(Gs, "EMPTY", Gs.fromArray([]));
F_(Gs, "PATH_SORTER", (t, e) => {
  const r = t.pathArray, n = e.pathArray;
  if (r[0] < n[0])
    return -1;
  if (r[0] > n[0])
    return 1;
  if (r[0] === n[0])
    return r[1] < n[1] ? -1 : r[1] > n[1] ? 1 : 0;
});
var la = {};
Object.defineProperty(la, "__esModule", {
  value: !0
});
la.currenciesForAsset = $_;
la.ensureCurrencies = void 0;
la.normalizeTxJSON = R7;
la.normalizeTxsJSON = gie;
la.unitTypeToJSON = void 0;
var pie = Yl(yi), yie = Yl(Pw), bie = Yl(Lw), j_ = Yl(xf), bo = Yl(hr);
function Yl(t) {
  return t && t.__esModule ? t : { default: t };
}
const k7 = (t) => (0, j_.default)(t.units, (e) => e.power);
la.unitTypeToJSON = k7;
function R7({
  json: t,
  asset: e
}) {
  if ((0, bo.default)(t, "normalizeTxJSON: `json` object is required"), t.version !== void 0)
    return t;
  (0, bo.default)(!t.coinAmount || t.coinName, "normalizeTxJSON: `coinName` is required with `coinAmount`"), (0, bo.default)(e, "normalizeTxJSON: `asset` object and `coinName` are required");
  const r = {
    ...t,
    version: 1
  };
  return t.feeAmount && !t.feeCoinName && (r.feeCoinName = e.feeAsset.name), t.currencies || (r.currencies = (0, j_.default)($_(e), k7)), {
    ...t,
    ...r
  };
}
function gie({
  json: t,
  assets: e
}) {
  return t ? ((0, bo.default)((0, pie.default)(t), "normalizeTxsJSON: `json` array is required"), (0, bo.default)(e, "normalizeTxJSON: `assets` object is required"), t.map((r) => R7({
    json: r,
    asset: r.coinName ? e[r.coinName] : void 0
  }))) : [];
}
const mie = (t, e) => (0, yie.default)(t.currencies) ? ((0, bo.default)(e, "ensureCurrencies: expected `assets` when `json` doesn't contain `currencies`"), (0, bo.default)(t.coinName, "ensureCurrencies: expected `json.coinName`"), (0, bo.default)(e[t.coinName], `ensureCurrencies: asset not found for ${t.coinName}`), {
  ...t,
  currencies: $_(e[t.coinName])
}) : t;
la.ensureCurrencies = mie;
function vie(t) {
  return Object.fromEntries((0, bie.default)([t, t.baseAsset, t.feeAsset], (e) => e.name).map((e) => [e.name, e]));
}
function $_(t) {
  return (0, j_.default)(vie(t), (e) => e.currency);
}
Object.defineProperty(Jl, "__esModule", {
  value: !0
});
Jl.default = void 0;
var Z4 = Wa(xf), wie = Wa(uie), _ie = Wa(Bw), Sie = Wa(Ul), Eie = Wa(Pw), J4 = Wa(zc), hs = Wa(hr), xie = Wa(A7), Vp = Ps, Ph = Wa(Zc), Aie = la;
function Wa(t) {
  return t && t.__esModule ? t : { default: t };
}
const Y4 = Symbol("Tx");
class pd {
  constructor({
    json: e,
    initSymbol: r
  }) {
    const {
      txId: n,
      error: i,
      date: s,
      confirmations: a,
      dropped: o,
      coinAmount: c,
      coinName: f,
      feeAmount: u,
      feeCoinName: d,
      selfSend: l,
      from: h,
      to: y,
      meta: p,
      data: b,
      tokens: v,
      token: x,
      addresses: I,
      currencies: L
    } = e;
    (0, hs.default)(r === Y4, "Tx: please use Tx.fromJSON()."), (0, hs.default)(!(0, Eie.default)(L), "Tx: `currencies` is required"), (0, hs.default)(!h || Array.isArray(h), "Tx: `from` has to be an array."), (0, hs.default)(!y || (0, Sie.default)(y), "Tx: `to` has to be a string."), (0, hs.default)(!v || Array.isArray(v), "Tx: `tokens` has to be an array."), (0, hs.default)(!I || Array.isArray(I) || I instanceof Ph.default, "Tx: unknown `addresses` type"), (0, hs.default)(!c || f, "Tx: `coinName` is required with `coinAmount`"), (0, hs.default)(!u || d, "Tx: `feeCoinName` is required with `feeAmount`"), this.currencies = (0, Z4.default)(L, (P) => P instanceof Vp.UnitType ? P : Vp.UnitType.create(P)), this.txId = n, this.error = i || null, this.date = s ? new Date(s) : /* @__PURE__ */ new Date(), this.confirmations = typeof a == "number" ? a : -1, o !== void 0 && (this.dropped = !!o && this.confirmations <= 0), c && ((0, hs.default)(this.currencies[f], `Tx: currency for ${f} missing`), this.coinAmount = Q4(c, this.currencies[f]), this.coinName = f), u && ((0, hs.default)(this.currencies[d], `Tx: currency for ${d} missing`), this.feeAmount = Q4(u, this.currencies[d]), this.feeCoinName = d), this.selfSend = l || !1, this.from = h || [], y && (this.to = y), this.tokens = v || (x ? [x] : []), this.data = b || {}, this.meta = p ? {
      ...p
    } : {}, this.addresses = Array.isArray(I) ? Ph.default.fromArray(I) : I instanceof Ph.default ? I : Ph.default.EMPTY, this.version = 1;
  }
  static fromJSON(e) {
    const r = typeof e == "string" ? JSON.parse(e) : e, n = new pd({
      json: r,
      initSymbol: Y4
    });
    return (0, xie.default)(n);
  }
  clone() {
    return pd.fromJSON(this);
  }
  equals(e) {
    return this === e || (0, J4.default)(this.toJSON(), e.toJSON());
  }
  toJSON() {
    const e = {
      ...this
    };
    return this.coinAmount && (e.coinAmount = this.coinAmount.toDefaultString({
      unit: !0
    })), this.feeAmount && (e.feeAmount = this.feeAmount.toDefaultString({
      unit: !0
    })), e.date = e.date.toISOString(), this.addresses && (e.addresses = [...this.addresses].map((r) => r.toJSON()), e.addresses.length === 0 && delete e.addresses), e.selfSend || delete e.selfSend, e.from.length === 0 && delete e.from, Object.keys(e.data).length === 0 && delete e.data, e.error || delete e.error, Object.keys(e.meta).length === 0 && delete e.meta, e.tokens.length === 0 && delete e.tokens, e.currencies = (0, Z4.default)(this.currencies, Aie.unitTypeToJSON), e;
  }
  toString() {
    return String(this.txId);
  }
  update(e) {
    const r = this.toJSON();
    return e = (0, wie.default)(e, ["version"]), Object.keys(e).every((i) => (0, J4.default)(r[i], e[i])) ? this : pd.fromJSON((0, _ie.default)({}, r, e));
  }
  get accepted() {
    return (this.received || this.sent && this.confirmations >= 0) && !this.dropped;
  }
  get confirmed() {
    return this.confirmations > 0;
  }
  get pending() {
    return this.confirmations <= 0 && !this.dropped;
  }
  get failed() {
    return this.error || this.dropped;
  }
  get sent() {
    return this.coinName === "tezos" && this.data.delegate ? !0 : !!(this.coinAmount.isNegative || this.to || this.selfSend);
  }
  get received() {
    return !this.sent;
  }
  get token() {
    return this.tokens[0] || null;
  }
}
Jl.default = pd;
function Q4(t, e) {
  return (0, hs.default)(e instanceof Vp.UnitType, "Currency must be an instance of UnitType"), (0, Vp.isNumberUnit)(t) ? t : e.parse(typeof t == "string" ? t : t.value + " " + t.unit);
}
var Ql = {};
const Iie = py;
var Tie = Iie.sortBy;
Object.defineProperty(Ql, "__esModule", {
  value: !0
});
Ql.default = void 0;
var kie = za(Lw), Rie = za(uI), Zf = za(Tie), Pie = za(zc), Oie = za(V9), Bie = za(K9), Oh = za(hr), Bh = za(Mf), Mh = za(Zc), Mie = Cie(Ps);
let P7;
function O7(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (O7 = function(n) {
    return n ? r : e;
  })(t);
}
function Cie(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var r = O7(e);
  if (r && r.has(t))
    return r.get(t);
  var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in t)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(t, s)) {
      var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
      a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
    }
  return n.default = t, r && r.set(t, n), n;
}
function za(t) {
  return t && t.__esModule ? t : { default: t };
}
function Nie(t, e, r) {
  return e = Uie(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Uie(t) {
  var e = Lie(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Lie(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
P7 = Symbol.iterator;
class pn {
  constructor({
    currency: e
  } = {}) {
    Nie(this, P7, function* () {
      const n = this.toArray();
      for (const i of n)
        yield i;
    }), this.currency = e, this._data = null;
  }
  static createEmpty(e) {
    return pn.fromArray([], e);
  }
  static fromArray(e, {
    addressMap: r,
    ...n
  } = {}) {
    const i = n.currency || Die(e);
    i == null && e == null ? console.warn("UtxoCollection.fromArray(): both currency and utxoArray are null.") : i == null && e.length === 0 && console.warn("UtxoCollection.fromArray(): currency is null and utxoArray has zero items."), e = (0, kie.default)(e, (o) => `${o.txId}:${o.vout}`);
    const s = e.map((o) => ((0, Oh.default)(o.address, "utxo.address must be provided"), (0, Oh.default)(o.address instanceof Bh.default || r, "Must pass addressMap if utxo.address is not of type Address"), o.address = o.address instanceof Bh.default ? o.address : r[o.address], {
      ...o,
      value: (0, Mie.isNumberUnit)(o.value) ? o.value : i.parse(o.value)
    }));
    var a = new pn({
      currency: i
    });
    return a._data = Object.freeze((0, Oie.default)(s, (o) => o.address.toString())), a;
  }
  static fromJSON(e, {
    currency: r
  }) {
    typeof e == "string" && (e = JSON.parse(e));
    const n = {};
    Object.keys(e).forEach((s) => {
      const a = new Bh.default(e[s].address, {
        path: e[s].path
      }), o = (0, Zf.default)(e[s].utxos, (c) => r.parse(c.value).toDefaultNumber());
      n[s] = o.map((c) => ({
        ...c,
        address: a,
        value: r.parse(c.value)
      }));
    });
    const i = new pn({
      currency: r
    });
    return i._data = Object.freeze(n), i;
  }
  clone() {
    return pn.fromArray(this.toArray(), {
      ...this
    });
  }
  equals(e) {
    return (0, Pie.default)(this.toJSON(), e.toJSON());
  }
  difference(e) {
    const r = (a) => {
      const o = {};
      return a.toArray().forEach((c) => {
        const f = `${c.txId}/${c.vout}`;
        o[f] = c;
      }), o;
    }, n = r(this), i = r(e), s = [];
    return Object.keys(n).forEach((a) => {
      i[a] || s.push(n[a]);
    }), pn.fromArray(s, {
      ...this
    });
  }
  getAddressUtxos(e) {
    return (0, Oh.default)(e.toString() in this._data, `${e} is not present in this UTXO collection`), pn.fromArray(this._data[e], {
      ...this
    });
  }
  getTxIdUtxos(e) {
    var r = this.toArray().filter((n) => n.txId === e);
    return pn.fromArray(r, {
      ...this
    });
  }
  getAddressesForTxId(e) {
    const n = this.toArray().filter((i) => i.txId === e).map((i) => i.address);
    return Mh.default.fromArray(n);
  }
  getAddressPathsMap() {
    return [...this.addresses].reduce((e, r) => Object.assign(e, {
      [r.toString()]: r.meta.path
    }), {});
  }
  hasAddressUtxos(e) {
    return String(e) in this._data;
  }
  inspect() {
    return `<UtxoCollection size: ${this.size}, value: ${this.value.toString()}>`;
  }
  isEmpty() {
    return this._data == null || Object.keys(this._data).length === 0;
  }
  merge(e) {
    let r = this;
    for (const n of e.addresses)
      r = r.setAddressUtxos(n, e.getAddressUtxos(n));
    return r;
  }
  removeAddressUtxos(e) {
    const r = {
      ...this._data
    };
    delete r[e.toString()];
    const n = new pn({
      ...this
    });
    return n._data = Object.freeze(r), n;
  }
  select(e, r) {
    const n = pn.createEmpty({
      currency: this.currency
    });
    if (e.gt(this.value))
      return [n, this.clone()];
    const i = (f, u) => {
      let d = n, l = n;
      if (f.size === 0)
        return [d, l];
      const h = u.defaultUnit.unitName === "BTC" ? (0, Zf.default)(f.toArray(), (v) => !v.confirmations, (v) => v.value.toDefaultNumber()) : (0, Zf.default)(f.toArray(), (v) => v.value.toDefaultNumber()), y = [];
      let b = h[0].value.unitType.ZERO;
      for (const v of h)
        if (y.push(v), b = b.add(v.value), b.gte(u))
          return d = pn.fromArray(y, {
            ...this
          }), l = f.difference(d), [d, l];
      return d = pn.fromArray(y, {
        ...this
      }), l = f.difference(d), [d, l];
    };
    let [s, a] = i(this, e);
    const o = r({
      inputs: s
    }), c = e.add(o);
    if (c.gt(s.value))
      if (c.lte(this.value)) {
        const f = r({
          inputs: a
        });
        if (c.add(f).gte(this.value))
          return [this, n];
        const [d, l] = i(a, o.add(f));
        a = l, s = s.union(d);
      } else
        return [n, this];
    return [s, a];
  }
  updateConfirmations(e) {
    return pn.fromArray(this.toArray().map((r) => {
      const n = e.find((i) => i.txId === r.txId);
      return n && (r.confirmations = n.confirmations), r;
    }), {
      ...this
    });
  }
  addUtxo(e, r) {
    return pn.fromArray([...this.toArray(), e], {
      addressMap: r
    });
  }
  setAddressUtxos(e, r, {
    addressMap: n
  } = {}) {
    if (Array.isArray(r))
      return r.length === 0 ? this.removeAddressUtxos(e) : pn.fromArray(r, {
        ...this,
        addressMap: n
      });
    if ((0, Oh.default)(r instanceof pn, "utxos must be an Array or UtxoCollection"), r.size === 0)
      return this.removeAddressUtxos(e);
    const i = {
      ...this._data,
      [e.toString()]: r.toArray()
    }, s = new pn({
      ...this
    });
    return s._data = Object.freeze(i), s;
  }
  toArray() {
    return Object.values(this._data).flat();
  }
  toPriorityOrderedArray() {
    return (0, Zf.default)(this.toArray(), (e) => !e.confirmations && e.rbfEnabled, (e) => !e.confirmations, (e) => e.value.toDefaultNumber());
  }
  toJSON() {
    const e = {};
    return [...this.addresses].forEach((r) => {
      const n = r.toString(), i = (0, Zf.default)(this._data[n], (s) => s.value.toDefaultNumber());
      e[n] = {
        address: n,
        path: r.meta.path,
        utxos: i.map((s) => (s = {
          ...s,
          value: s.value.toString()
        }, delete s.address, s))
      };
    }), e;
  }
  union(e) {
    const r = this.toArray(), n = e.toArray();
    return pn.fromArray([...r, ...n], {
      ...this
    });
  }
  filter(e) {
    return pn.fromArray(this.toArray().filter(e), {
      ...this
    });
  }
  unionOverwrite(e) {
    const r = this.toArray(), n = e.toArray(), s = [...(0, Bie.default)(r, n, (a) => `${a.txId}:${a.vout}`), ...n];
    return pn.fromArray(s, {
      ...this
    });
  }
  get addresses() {
    if (this._addresses)
      return this._addresses;
    const e = [];
    return Object.entries(this._data).forEach(([r, n]) => {
      Array.isArray(n) && n.length !== 0 && e.push(n[0].address || Bh.default.create(r));
    }), e.length === 0 ? (this._addresses = Mh.default.EMPTY, this._addresses) : (e.sort(Mh.default.PATH_SORTER), this._addresses = Mh.default.fromArray(e), this._addresses);
  }
  get empty() {
    return this._data == null || Object.keys(this._data).length === 0;
  }
  get size() {
    return typeof this._size == "number" ? this._size : (this._size = this.toArray().length, this._size);
  }
  get txIds() {
    return (0, Rie.default)(this.toArray().map((e) => e.txId));
  }
  get value() {
    return this._value ? this._value : (this._value = this.toArray().reduce((e, r) => e.add(r.value), this.currency.ZERO), this._value);
  }
}
Ql.default = pn;
function Die(t) {
  if (Array.isArray(t)) {
    for (const e of t)
      if (typeof e.value == "object" && e.value.unitType)
        return e.value.unitType;
  }
}
var n1 = {}, i1 = {};
Object.defineProperty(i1, "__esModule", {
  value: !0
});
i1.sortByAsc = Fie;
i1.sortByDesc = jie;
function Fie(t) {
  return [...t].sort((e, r) => {
    if (!B7(e.date, r.date))
      throw new TypeError("TxSet.util.sortByAsc() objects must be Dates or numbers");
    return e.date - r.date;
  });
}
function jie(t) {
  return [...t].sort((e, r) => {
    if (!B7(e.date, r.date))
      throw new TypeError("TxSet.util.sortByAsc() objects must be Dates or numbers");
    return r.date - e.date;
  });
}
function B7(t, e) {
  return t instanceof Date && e instanceof Date || typeof t == "number" && typeof e == "number";
}
Object.defineProperty(n1, "__esModule", {
  value: !0
});
n1.default = void 0;
var Mm = q_(hr), Cm = q_(Jl), $ie = q_(Zc), qie = Wie(i1);
let M7;
function C7(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (C7 = function(n) {
    return n ? r : e;
  })(t);
}
function Wie(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var r = C7(e);
  if (r && r.has(t))
    return r.get(t);
  var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in t)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(t, s)) {
      var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
      a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
    }
  return n.default = t, r && r.set(t, n), n;
}
function q_(t) {
  return t && t.__esModule ? t : { default: t };
}
function zie(t, e, r) {
  return e = Kie(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Kie(t) {
  var e = Vie(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Vie(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
const N7 = Symbol("TxSet"), Fo = ({
  txs: t
}) => new go({
  txs: t,
  initSymbol: N7
}), X4 = {};
M7 = Symbol.iterator;
class go {
  constructor({
    txs: e,
    initSymbol: r
  }) {
    (0, Mm.default)(r === N7, "please use TxSet.EMPTY or TxSet.fromArray()"), (0, Mm.default)(e, "txs are required when constructing TxSet"), (0, Mm.default)(e instanceof Map, "txs must be a Map");
    const n = [...e.values()];
    n.sort(ex), this._txs = new Map(n.map((i) => [i.txId, i])), this._order = n.map((i) => i.txId), this.addresses = $ie.default.fromArray(n.flatMap((i) => [...i.addresses]));
  }
  static fromArray(e = []) {
    if (!Array.isArray(e))
      return console.warn("Unexpected non-array value:", e), go.EMPTY;
    e = e.map((n) => n instanceof Cm.default ? n : Cm.default.fromJSON(n));
    const r = new Map(e.map((n) => [n.txId, n]));
    return Fo({
      txs: r
    });
  }
  add(e) {
    const r = this.get(e.txId);
    if (r && ex(r, e) > 0)
      return this;
    const n = new Map(this._txs);
    return n.set(e.txId, e), Fo({
      txs: n
    });
  }
  clone() {
    return Fo({
      txs: new Map(this._txs)
    });
  }
  delete(e) {
    const r = this.get(e);
    if (!r)
      return this;
    const n = new Map(this._txs);
    return n.delete(r.txId), Fo({
      txs: n
    });
  }
  equals(e) {
    return this._order.length !== e._order.length ? !1 : this._order.every((r, n) => r === e._order[n]);
  }
  deepEquals(e) {
    return this === e ? !0 : this.size !== e.size ? !1 : [...this].every((r) => {
      const n = e.get(r);
      if (n)
        return r === n || r.equals(n);
    });
  }
  get(e) {
    return this._txs.get(String(e));
  }
  getAt(e) {
    return this.get(this._order[e]);
  }
  has(e) {
    return this._txs.has(String(e));
  }
  toJSON() {
    return [...this].map((e) => e.toJSON());
  }
  union(e) {
    const r = [...this], n = [...e], i = [...r, ...n], s = go.fromArray(i);
    return this.deepEquals(s) ? this : s;
  }
  update(e) {
    if (e instanceof go && e.deepEquals(this))
      return this;
    const r = new Map([...e].map((n) => {
      const i = this.get(n.txId), s = {
        ...i,
        ...n
      };
      i && (Math.sign(s.coinAmount.toNumber()) === Math.sign(i.coinAmount.toNumber()) && !s.feeAmount && (s.coinAmount = i.coinAmount), i.meta && (s.meta = {
        ...i.meta
      }));
      const a = Cm.default.fromJSON(s);
      return [a.txId, a];
    }));
    return Fo({
      txs: r
    });
  }
  updateTxsProperties(e) {
    const r = new Map(this._txs);
    let n = !1;
    for (const i of e) {
      const s = r.get(i.txId);
      if (s) {
        const a = s.update(i);
        s.equals(a) || (r.set(i.txId, a), n = !0);
      }
    }
    return n ? Fo({
      txs: r
    }) : this;
  }
  getMutations() {
    if (this._mutations)
      return this._mutations;
    let e;
    return this._mutations = [...this].map((r) => {
      try {
        return e === void 0 && (e = r.coinAmount.unitType.ZERO), r.dropped || r.data.replacedBy || (r.error || (e = e.add(r.coinAmount)), r.feeAmount && r.feeAmount.unitType.equals(r.coinAmount.unitType) && (e = e.sub(r.feeAmount))), e.isNegative && !X4[r.txId] && (console.warn("negative balance in mutations calculation", {
          tx: r,
          balance: e
        }), X4[r.txId] = r.txId), {
          tx: r,
          balance: e
        };
      } catch (n) {
        throw r && (console.warn("failed to calculate mutation for tx", r.toJSON()), Object.assign(n, {
          asset: r.coinName,
          extraInfo: JSON.stringify(r.toJSON())
        })), n;
      }
    }), this._mutations;
  }
  [M7]() {
    return this._txs.values();
  }
  get size() {
    return this._txs.size;
  }
}
n1.default = go;
zie(go, "util", qie);
go.EMPTY = Fo({
  txs: /* @__PURE__ */ new Map()
});
function ex(t, e) {
  let r = t.date - e.date;
  return r === 0 && (r = t.txId.localeCompare(e.txId)), r;
}
var s1 = {}, Xl = {};
Object.defineProperty(Xl, "__esModule", {
  value: !0
});
Xl.default = void 0;
var U7 = W_(cI), tx = W_(zc), rx = W_(hr);
function W_(t) {
  return t && t.__esModule ? t : { default: t };
}
class Gd {
  constructor(e = {}) {
    (0, rx.default)(typeof e.txId == "string", `expected "txId", received: ${e.txId}`), Object.assign(this, e), this.txId = e.txId, this.message = e.message || "";
  }
  static fromJSON(e) {
    return typeof e == "string" && (e = JSON.parse(e)), new Gd(e);
  }
  toJSON() {
    const e = {
      ...this
    };
    if (this.sends) {
      e.sends = {};
      for (const [r, n] of Object.entries(this.sends))
        e.sends[r] = {
          ...n
        };
    }
    return e;
  }
  toString() {
    return String(this.txId);
  }
  equals(e) {
    return e ? this === e || (0, tx.default)(this.toJSON(), e.toJSON()) : !1;
  }
  update(e) {
    if (e = Hie(e), e.txId && e.txId !== this.txId)
      throw new Error('"txId" cannot be changed once it is set');
    const r = this.toJSON();
    return Object.keys(e).every((i) => (0, tx.default)(r[i], e[i])) ? this : Gd.fromJSON({
      ...r,
      ...e
    });
  }
  getMessage({
    to: e
  } = {}) {
    if (e && this.sends) {
      const r = Object.entries(this.sends);
      for (const [n, {
        message: i
      }] of r)
        if (n.toLowerCase() === e.toLowerCase() && i)
          return i;
    }
    return this.message || "";
  }
  setMessage({
    to: e,
    message: r
  }) {
    if ((0, rx.default)(typeof r == "string", 'expected string "message"'), !e)
      return this.update({
        message: r
      });
    const n = this.toJSON();
    Gie({
      personalNote: n,
      to: e
    });
    const i = (0, U7.default)(n, ["sends", e, "message"], r);
    return this.update(i);
  }
}
Xl.default = Gd;
const Hie = (t) => t instanceof Gd ? t.toJSON() : t, Gie = ({
  personalNote: t,
  to: e
}) => {
  delete t.message, t.sends && Object.keys(t.sends || {}).forEach((r) => {
    const n = r.toLowerCase();
    r !== n && n === e && (0, U7.default)(t, ["sends", r, "message"], null);
  });
};
Object.defineProperty(s1, "__esModule", {
  value: !0
});
s1.default = void 0;
var nx = Zie(Xl);
function Zie(t) {
  return t && t.__esModule ? t : { default: t };
}
class Ra {
  constructor(e) {
    if (this._items = /* @__PURE__ */ new Map(), e)
      for (const r of e) {
        const n = ix(r);
        this._items.set(String(n), n);
      }
  }
  static fromArray(e) {
    return e == null ? Ra.EMPTY : new Ra(e);
  }
  add(e) {
    if (e = Jie(e), e.length === 0)
      return this;
    const r = Ra.fromArray(e), n = /* @__PURE__ */ new Set(), i = [];
    if ([...r].forEach((a) => {
      const o = this.get(a);
      if (!o) {
        i.push(a);
        return;
      }
      o.equals(a) || (i.push(a), n.add(o));
    }), i.length === 0)
      return this;
    const s = [...[...this].filter((a) => !n.has(a)), ...i];
    return Ra.fromArray(s);
  }
  clone() {
    return Ra.fromArray([...this]);
  }
  equals(e) {
    return this === e ? !0 : this.size !== e.size ? !1 : [...this].every((r) => {
      const n = e.get(r);
      return n && n.equals(r);
    });
  }
  get(e) {
    const r = typeof e == "string" ? e : e.txId;
    if (!r)
      throw new Error("expected txId or Object/PersonalNote with property txId");
    return this._items.get(r);
  }
  has(e) {
    return this._items.has(String(e));
  }
  toJSON() {
    return [...this].map((e) => e.toJSON());
  }
  update(e) {
    const r = e.map((n) => {
      const i = this.get(n);
      return i ? i.update(n) : ix(n);
    });
    return this.add(r);
  }
  [Symbol.iterator]() {
    return this._items.values();
  }
  get size() {
    return this._items.size;
  }
}
Ra.EMPTY = new Ra();
const ix = (t) => t instanceof nx.default ? t : nx.default.fromJSON(t), Jie = (t) => Array.isArray(t) ? t : [t].flat();
var Yie = Ra;
s1.default = Yie;
var a1 = {}, kr = {};
Object.defineProperty(kr, "__esModule", {
  value: !0
});
kr.getDefaultLabel = kr.default = kr.TREZOR_SRC = kr.SOFTWARE_SEED_SOURCES = kr.SEED_SRC = kr.LEDGER_SRC = kr.LABEL_MAX_LENGTH = kr.HARDWARE_SOURCES = kr.FTX_SRC = kr.EXODUS_SRC = kr.DEFAULT_ICONS = kr.DEFAULT_COLORS = kr.CUSTODIAL_SOURCES = void 0;
var Qie = o1(Bw), Xie = o1(H9), sx = o1(zc), ese = o1(A7);
function o1(t) {
  return t && t.__esModule ? t : { default: t };
}
function qn(t, e, r) {
  return e = tse(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function tse(t) {
  var e = rse(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function rse(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
const wa = "exodus";
kr.EXODUS_SRC = wa;
const L7 = "seed";
kr.SEED_SRC = L7;
const z_ = "trezor";
kr.TREZOR_SRC = z_;
const K_ = "ledger";
kr.LEDGER_SRC = K_;
const V_ = "ftx";
kr.FTX_SRC = V_;
const a2 = [V_];
kr.CUSTODIAL_SOURCES = a2;
const D7 = [z_, K_];
kr.HARDWARE_SOURCES = D7;
const F7 = [wa, L7];
kr.SOFTWARE_SEED_SOURCES = F7;
const H_ = Object.freeze({
  exodus: "#ff3974",
  seed: "#ff3974",
  trezor: "#7b39ff",
  ledger: "#f5e400",
  ftx: "#00b4c2"
});
kr.DEFAULT_COLORS = H_;
const G_ = Object.freeze({
  exodus: "exodus",
  seed: "exodus",
  trezor: "trezor",
  ledger: "trezor",
  ftx: "ftx"
});
kr.DEFAULT_ICONS = G_;
const Hp = 100;
kr.LABEL_MAX_LENGTH = Hp;
const nse = (t) => t[0].toUpperCase() + t.slice(1), j7 = ({
  source: t,
  index: e
}) => e === 0 ? nse(t) : "";
kr.getDefaultLabel = j7;
const ise = (t) => typeof t == "string" && /^#[\dA-Fa-f]{3,6}$/.test(t), sse = ["id", "source", "index"];
class Fi {
  constructor({
    source: e,
    index: r,
    id: n,
    label: i,
    model: s,
    lastConnected: a,
    is2FA: o,
    color: c,
    icon: f,
    enabled: u = !0
  }) {
    qn(this, "source", void 0), qn(this, "index", void 0), qn(this, "id", void 0), qn(this, "label", void 0), qn(this, "model", void 0), qn(this, "lastConnected", void 0), qn(this, "is2FA", void 0), qn(this, "color", void 0), qn(this, "icon", void 0), qn(this, "enabled", void 0);
    const d = a2.includes(e);
    if (e) {
      if (r == null && !d)
        throw new Error('expected "index" for a wallet account');
      if (e === wa && n)
        throw new Error('unexpected option "id" for an exodus wallet account');
      if (!n && e !== wa)
        throw new Error('expected option "id" for a non-exodus wallet account');
      if (e === wa && a)
        throw new Error('unexpected option "lastConnected" for a software wallet account');
      if (e === wa && s)
        throw new Error('unexpected option "model" for a software wallet account');
    } else
      throw new Error('expected "source" for a wallet account');
    if (e !== wa && o)
      throw new Error("is2FA: true is only valid for an exodus walletAccount");
    if (c = c || H_[e], f = f || G_[e], i = i || j7({
      source: e,
      index: r
    }), i.length > Hp && (i = i.slice(0, Hp)), !ise(c))
      throw new Error('expected "color" to be a hex string');
    if (typeof f != "string" || f.length === 0)
      throw new Error('expected "icon" to be a non-empty string');
    return this.source = e, this.index = (0, Xie.default)(r) ? null : r, this.id = n, this.label = i || "", this.model = s, this.lastConnected = a, this.is2FA = o, this.color = c, this.icon = f, this.enabled = u, (0, ese.default)(this);
  }
  toString() {
    return [this.source, this.index, this.id].filter((e) => e != null).join("_");
  }
  toJSON() {
    const e = {
      source: this.source,
      index: this.index,
      label: this.label,
      model: this.model,
      lastConnected: this.lastConnected,
      is2FA: this.is2FA,
      color: this.color,
      icon: this.icon,
      enabled: this.enabled
    };
    return this.id != null && (e.id = this.id), e;
  }
  equals(e) {
    return this === e || (0, sx.default)(this.toJSON(), e.toJSON());
  }
  update(e) {
    e instanceof Fi && (e = e.toJSON());
    const r = this.toJSON();
    return Object.keys(e).every((i) => (0, sx.default)(r[i], e[i])) ? this : (sse.forEach((i) => {
      if (e[i] && e[i] !== this[i])
        throw new Error(`property "${i}" is immutable`);
    }), new Fi((0, Qie.default)({}, r, e)));
  }
  get isSoftware() {
    return F7.includes(this.source);
  }
  get isHardware() {
    return D7.includes(this.source);
  }
  get isCustodial() {
    return a2.includes(this.source);
  }
  static get DEFAULT_NAME() {
    return Fi.DEFAULT.toString();
  }
  static get DEFAULT() {
    return new Fi({
      source: wa,
      index: 0
    });
  }
}
kr.default = Fi;
qn(Fi, "LABEL_MAX_LENGTH", Hp);
qn(Fi, "DEFAULT_COLORS", H_);
qn(Fi, "DEFAULT_ICONS", G_);
qn(Fi, "EXODUS_SRC", wa);
qn(Fi, "TREZOR_SRC", z_);
qn(Fi, "LEDGER_SRC", K_);
qn(Fi, "FTX_SRC", V_);
Object.defineProperty(a1, "__esModule", {
  value: !0
});
a1.default = void 0;
var ase = Z_(eI), ax = Z_(xf), o2 = Z_(kr);
function Z_(t) {
  return t && t.__esModule ? t : { default: t };
}
const ox = (t) => t instanceof o2.default ? t : new o2.default(t);
class cf {
  constructor(e = {}) {
    this._byName = (0, ax.default)(e, ox);
  }
  toJSON() {
    return (0, ax.default)(this._byName, (e) => e.toJSON());
  }
  get(e) {
    if (e instanceof o2.default && (e = e.toString()), this._byName.hasOwnProperty(e))
      return this._byName[e];
  }
  names() {
    return Object.keys(this._byName);
  }
  update(e) {
    e instanceof cf && (e = e.toJSON());
    const r = (0, ase.default)({
      ...this._byName
    }, e, (n, i) => n ? n.update(i) : ox(i));
    return new cf(r);
  }
  equals(e) {
    if (this === e)
      return !0;
    const r = Object.keys(e.toJSON()).sort(), n = this.names().sort();
    return r.length !== n.length ? !1 : n.every((i) => {
      const s = this.get(i), a = e.get(i);
      return a && s.equals(a);
    });
  }
}
cf.EMPTY = new cf();
var ose = cf;
a1.default = ose;
var Jc = {};
const cse = Kc;
var $7 = cse.isPlainObject, c1 = {};
const use = my;
var fse = use.pick, uf = {};
function dse(t = []) {
  const e = [
    ...t,
    {
      type: "date",
      test: (s) => s instanceof Date,
      serialize: (s) => s.toJSON(),
      deserialize: (s) => new Date(s)
    },
    {
      type: "buffer",
      test: (s) => s instanceof ve,
      serialize: (s) => s.toString("base64"),
      deserialize: (s) => ve.from(s, "base64")
    },
    {
      type: "uint8array",
      test: (s) => s instanceof Uint8Array,
      serialize: (s) => ve.from(s).toString("base64"),
      deserialize: (s) => {
        const a = ve.from(s, "base64"), o = new Uint8Array(a.length);
        return o.set(a), o;
      }
    },
    {
      type: "array",
      test: ns.isArray,
      serialize: (s) => s.map((a) => n(a)),
      deserialize: (s) => s.map((a) => i(a))
    },
    {
      type: "object",
      test: ns.isObject,
      serialize: (s) => ns.mapValues(s, (a) => n(a)),
      deserialize: (s) => ns.mapValues(s, (a) => i(a))
    }
  ], r = new Set(e.map((s) => s.type)), n = (s) => {
    const a = e.find((o) => o.test(s));
    return a ? { t: a.type, v: a.serialize(s) } : s;
  }, i = (s) => ns.isObject(s) && Object.keys(s).length === 2 && "v" in s && r.has(s.t) ? e.find((a) => a.type === s.t).deserialize(s.v) : s;
  return { serialize: n, deserialize: i };
}
const lse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dse
}, Symbol.toStringTag, { value: "Module" })), hse = /* @__PURE__ */ ta(lse);
Object.defineProperty(uf, "__esModule", {
  value: !0
});
uf.serialize = uf.deserialize = void 0;
var pse = J_(xf), Nm = bse(Ps), cx = J_(Ql), yse = J_(hse);
function q7(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (q7 = function(n) {
    return n ? r : e;
  })(t);
}
function bse(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var r = q7(e);
  if (r && r.has(t))
    return r.get(t);
  var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in t)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(t, s)) {
      var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
      a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
    }
  return n.default = t, r && r.set(t, n), n;
}
function J_(t) {
  return t && t.__esModule ? t : { default: t };
}
const ux = (t) => (0, pse.default)(t.units, (e) => e.power), gse = [{
  type: "numberunit",
  test: (t) => t instanceof Nm.default,
  serialize: (t) => ({
    v: t.toString(),
    u: ux(t.unitType)
  }),
  deserialize: (t) => Nm.UnitType.create(t.u).parse(t.v)
}, {
  type: "utxocollection",
  test: (t) => t instanceof cx.default,
  serialize: (t) => ({
    v: t.toJSON(),
    u: ux(t.currency)
  }),
  deserialize: (t) => cx.default.fromJSON(t.v, {
    currency: Nm.UnitType.create(t.u)
  })
}], {
  serialize: mse,
  deserialize: vse
} = (0, yse.default)(gse);
uf.deserialize = vse;
uf.serialize = mse;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var e = {};
  t.default = void 0;
  var r = o(Ul), n = o(xf), i = o(fse), s = o(zc), a = uf;
  Object.keys(a).forEach(function(h) {
    h === "default" || h === "__esModule" || Object.prototype.hasOwnProperty.call(e, h) || h in t && t[h] === a[h] || Object.defineProperty(t, h, {
      enumerable: !0,
      get: function() {
        return a[h];
      }
    });
  });
  function o(h) {
    return h && h.__esModule ? h : { default: h };
  }
  function c(h, y, p) {
    return y = f(y), y in h ? Object.defineProperty(h, y, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : h[y] = p, h;
  }
  function f(h) {
    var y = u(h, "string");
    return typeof y == "symbol" ? y : String(y);
  }
  function u(h, y) {
    if (typeof h != "object" || h === null)
      return h;
    var p = h[Symbol.toPrimitive];
    if (p !== void 0) {
      var b = p.call(h, y || "default");
      if (typeof b != "object")
        return b;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (y === "string" ? String : Number)(h);
  }
  class d {
    static _getAllFieldNames() {
      return this._allFieldNames || (this._allFieldNames = Object.keys(this.defaults), this._allFieldNames.push("_version")), this._allFieldNames;
    }
    static _getFieldNames() {
      const y = this._getAllFieldNames();
      return this._fieldNames || (this._fieldNames = y.filter((p) => p !== "mem")), this._fieldNames;
    }
    static serialize(y, {
      includeMem: p = !1
    } = {}) {
      const b = p ? this._getAllFieldNames() : this._getFieldNames();
      return (0, a.serialize)((0, i.default)(y, b));
    }
    static deserialize(y) {
      const p = y && y.v && y.v._version === 1 ? (0, a.deserialize)(y) : this._legacyParse(y);
      return new this(p);
    }
    static fromJSON(y) {
      return this.deserialize(y);
    }
    static create(y) {
      return new this(y);
    }
    constructor(y = {}) {
      const {
        defaults: p
      } = this.constructor;
      if (this.constructor === d)
        throw new Error("Instantiating the base AccountState class is forbidden, please instantiate a subclass instance");
      const b = {
        ...p,
        ...(0, i.default)(y, this.constructor._getAllFieldNames())
      };
      Object.assign(this, b, {
        _version: 1
      });
    }
    static _legacyParse(y) {
      return this._postParse((0, n.default)(y, (p, b) => {
        if (this._dateKeys.includes(b) && p)
          return new Date(p);
        const v = (0, r.default)(p) && this._tokens.find((x) => l(x).test(p));
        return v ? v.currency.parse(p) : p;
      }));
    }
    static _postParse(y) {
      return y;
    }
    toJSON(y) {
      return this.constructor.serialize(this, y);
    }
    equals(y, p = {
      includeMem: !0
    }) {
      return this === y || (0, s.default)(this.toJSON(p), y.toJSON(p));
    }
    merge(y) {
      return this.constructor.create({
        ...this,
        ...y
      });
    }
    contains(y) {
      return this.equals(this.merge(y));
    }
  }
  t.default = d, c(d, "defaults", {}), c(d, "_allFieldNames", null), c(d, "_fieldNames", null), c(d, "_version", 0), c(d, "_tokens", []), c(d, "_dateKeys", []);
  function l(h) {
    const y = Object.keys(h.currency.units);
    return new RegExp(` (${y.join("|")})$`);
  }
})(c1);
Object.defineProperty(Jc, "__esModule", {
  value: !0
});
Jc.default = void 0;
var wse = eh(Ul), _se = eh($7), Um = eh(Aw), Lm = eh(hr), fx = Ps, Ch = c1, dx = eh(kr);
function eh(t) {
  return t && t.__esModule ? t : { default: t };
}
const Sse = {
  aero: ["failed", "overdue", "expired"],
  ch: ["failed", "overdue", "expired"],
  chf: ["failed", "overdue", "expired"],
  cic: ["failed", "overdue", "expired"],
  cn: ["failed", "expired"],
  "inch-eth": ["failed"],
  "inch-bsc": ["failed"],
  "inch-matic": ["failed"],
  cs: ["failed", "timeout"],
  csus: ["failed", "timeout"],
  sw: ["failed", "expired"],
  fa: ["cancelled"],
  he: ["failed", "overdue", "hold", "expired"],
  fox: ["failed", "timeout", "unknown"],
  ne: ["canceled"],
  nrnb: ["overdue", "error"]
}, lx = {
  aero: ["refunded"],
  ch: ["refunded"],
  chf: ["refunded"],
  cic: ["refunded"],
  cn: ["refunded"],
  cs: ["refunded"],
  csus: ["refunded"],
  sw: ["refunded"],
  fa: ["refunded"],
  he: ["refunded"],
  fox: ["cancelled"],
  ne: ["refunded"],
  nrnb: ["refunded"]
}, Ese = /* @__PURE__ */ new Set(["optimistic-complete", "potential-complete"]), hx = Symbol("Order");
class Gp {
  constructor(e, r) {
    if ((0, Lm.default)(r === hx, "please use Order.fromJSON()"), this.orderId = e.orderId, (0, Lm.default)(typeof this.orderId == "string", `orderId must be a string, received: ${this.orderId}`), e.fromAmount !== void 0 && !(0, fx.isNumberUnit)(e.fromAmount))
      throw new Error("fromAmount must be of type: NumberUnit");
    if (e.toAmount !== void 0 && !(0, fx.isNumberUnit)(e.toAmount))
      throw new Error("toAmount must be of type: NumberUnit");
    this.status = e.status || "", e.errorDetails && (this.errorDetails = e.errorDetails), this.date = e.date ? e.date instanceof Date ? e.date : new Date(e.date) : /* @__PURE__ */ new Date(), e.fromTxId && (this.fromTxId = e.fromTxId), e.toTxId && (this.toTxId = e.toTxId), e.txIds && (this.txIds = e.txIds), e.fromAsset && (this.fromAsset = String(e.fromAsset)), e.fromAmount && (this.fromAmount = e.fromAmount), e.toAsset && (this.toAsset = String(e.toAsset)), e.toAmount && (this.toAmount = e.toAmount), this.fromWalletAccount = e.fromWalletAccount || dx.default.DEFAULT_NAME, this.toWalletAccount = e.toWalletAccount || dx.default.DEFAULT_NAME, e.svc || console.log(`${e.orderId} has no 'svc' field set.`), this.svc = e.svc || "ss", e.svcOptions && (this.svcOptions = e.svcOptions), e.message !== void 0 && e.message !== "null" && (this.message = e.message), typeof e.synced == "boolean" && (this.synced = e.synced), typeof e.region == "string" && (this.region = e.region), typeof e.displaySvc == "string" && (this.displaySvc = e.displaySvc), this.toTxId = e.toTxId, this.potentialToTxIds = e.potentialToTxIds || [], this._version = 1;
  }
  static fromJSON(e) {
    (0, Lm.default)(e && ((0, wse.default)(e) || (0, _se.default)(e)), "fromJSON: requires a string or a plain object"), typeof e == "string" && (e = JSON.parse(e));
    const r = e.fromAmount ? (0, Ch.deserialize)(e.fromAmount) : void 0, n = e.toAmount ? (0, Ch.deserialize)(e.toAmount) : void 0;
    return new Gp({
      ...e,
      fromAmount: r,
      toAmount: n
    }, hx);
  }
  inspect() {
    return `[Order ${this.orderId}]`;
  }
  toJSON() {
    const e = {
      ...this,
      date: this.date.toISOString()
    };
    return e.fromAmount && (e.fromAmount = (0, Ch.serialize)(e.fromAmount)), e.toAmount && (e.toAmount = (0, Ch.serialize)(e.toAmount)), e._version = 1, e;
  }
  toJSONLegacy() {
    console.log("Order: calling deprecated function order.toJSONLegacy(), use orderToJSONLegacy() instead");
    const e = {
      ...this,
      date: this.date.toISOString()
    };
    return e.fromAmount && (e.fromAmount = e.fromAmount.toString()), e.toAmount && (e.toAmount = e.toAmount.toString()), delete e._version, e;
  }
  toString() {
    return String(this.orderId);
  }
  update(e) {
    return Gp.fromJSON({
      ...this.toJSON(),
      ...e
    });
  }
  get exodusStatus() {
    return this.status === "e2e-syncing" ? "syncing" : this.status === "complete-verified" ? "complete" : this.status === "failed-final" || (0, Um.default)(lx, this.svc, []).includes(this.status) ? "failed" : "in-progress";
  }
  get error() {
    return (0, Um.default)(Sse, this.svc, []).includes(this.status) || (0, Um.default)(lx, this.svc, []).includes(this.status) ? !0 : this.status === "failed-final";
  }
  get finalized() {
    return ["failed-final", "complete-verified"].includes(this.status);
  }
  get floatingRate() {
    return this.svc === "ch" && this.status !== "complete-verified";
  }
  get hasOptimisticStatus() {
    return Ese.has(this.status);
  }
  get exchangeApp() {
    return this.svc === "ftx" ? "ftx" : "exodus";
  }
}
Jc.default = Gp;
var th = {};
Object.defineProperty(th, "__esModule", {
  value: !0
});
th.default = void 0;
var px = W7(Jc), yx = W7(hr);
function W7(t) {
  return t && t.__esModule ? t : { default: t };
}
const z7 = Symbol("OrderSet"), yu = ({
  items: t
}) => new ff({
  items: t,
  initSymbol: z7
});
class ff {
  constructor({
    items: e,
    initSymbol: r
  }) {
    (0, yx.default)(r === z7, "please use OrderSet.EMPTY or OrderSet.fromArray()"), (0, yx.default)(e instanceof Map, "items must be a Map");
    const n = [...e.values()];
    n.sort((s, a) => a.date - s.date);
    const i = /* @__PURE__ */ new Map();
    for (const s of n)
      s.txIds && s.txIds.forEach(({
        txId: a
      }) => {
        Dm(i, a, s.orderId);
      }), Dm(i, s.fromTxId, s.orderId), Dm(i, s.toTxId, s.orderId);
    this._items = new Map(n.map((s) => [String(s), s])), this._txMap = i, this._sortOrder = n.map((s) => s.orderId);
  }
  static fromArray(e) {
    return e == null ? ff.EMPTY : yu({
      items: new Map(e.map(xse).map((r) => [String(r), r]))
    });
  }
  add(e) {
    return this.addBulk([e]);
  }
  addBulk(e) {
    if (!e)
      return this;
    for (const r of e)
      this.get(r) && console.log("OrderSet#add() already has #{item.orderId}");
    return yu({
      items: new Map([...this._items.values(), ...e].map((r) => [String(r), r]))
    });
  }
  clone() {
    return yu({
      items: new Map(this._items)
    });
  }
  delete(e) {
    const r = this.get(e);
    if (!r)
      return this;
    const n = new Map(this._items);
    return n.delete(r.orderId), yu({
      items: n
    });
  }
  equals(e) {
    if (this._sortOrder.length !== e._sortOrder.length)
      return !1;
    const r = this._sortOrder.length;
    for (let n = 0; n < r; ++n)
      if (this._sortOrder[n] !== e._sortOrder[n])
        return !1;
    return !0;
  }
  get(e) {
    return this._items.get(String(e));
  }
  getAt(e) {
    return this.get(this._sortOrder[e]);
  }
  getByTxId(e, r = 0) {
    const n = this._txMap.get(e) || [];
    return this._items.get(n[r]);
  }
  getAllByTxId(e) {
    return (this._txMap.get(e) || []).map((n) => this._items.get(n));
  }
  has(e) {
    return this._items.has(String(e));
  }
  toJSON() {
    return [...this].map((e) => e.toJSON());
  }
  toJSONLegacy() {
    return console.log("OrderSet: calling deprecated function orderSet.toJSONLegacy(), use orderSetToJSONLegacy() instead"), [...this].map((e) => e.toJSONLegacy());
  }
  union(e) {
    const r = [...this], n = [...e], i = [...r, ...n];
    return ff.fromArray(i);
  }
  update(e) {
    const r = new Map(this._items);
    for (const n of e) {
      const i = r.get(String(n));
      if (!i) {
        console.log("OrderSet#update() order does not contain an `orderId`. Skipping...");
        continue;
      }
      r.set(String(n), i.update(n));
    }
    return yu({
      items: r
    });
  }
  [Symbol.iterator]() {
    return this._items.values();
  }
  get size() {
    return this._items.size;
  }
}
th.default = ff;
ff.EMPTY = yu({
  items: /* @__PURE__ */ new Map()
});
function xse(t) {
  return t instanceof px.default ? t : px.default.fromJSON(t);
}
function Dm(t, e, r) {
  if (e) {
    const n = t.get(e) || [];
    if (n.includes(r))
      return;
    t.set(e, [...n, r]);
  }
}
var Ca = {}, Ar = {};
Object.defineProperty(Ar, "__esModule", {
  value: !0
});
Ar.STATUS_MAP = Ar.STALE_STATUS = Ar.SARDINE_ORDER_STATUS = Ar.RAMP_ORDER_STATUS = Ar.PROVIDERS = Ar.PAYPAL_ORDER_STATUS = Ar.ORDER_TYPES = Ar.ORDER_STATUS_TO_SARDINE_STATUS = Ar.ORDER_STATUS_TO_RAMP_STATUS = Ar.ORDER_STATUS_TO_PAYPAL_STATUS = Ar.ORDER_STATUS_TO_MOONPAY_STATUS = Ar.ORDER_STATUS = Ar.MOONPAY_ORDER_STATUS = Ar.COMPLETE_STATUS = void 0;
const Ase = {
  __proto__: null,
  buy: "buy",
  sell: "sell"
};
Ar.ORDER_TYPES = Ase;
const qi = {
  __proto__: null,
  complete: "complete",
  failed: "failed",
  in_progress: "in-progress"
};
Ar.ORDER_STATUS = qi;
const ji = {
  __proto__: null,
  moonpay: "moonpay",
  paypal: "paypal",
  ramp: "ramp",
  sardine: "sardine"
};
Ar.PROVIDERS = ji;
const _a = {
  __proto__: null,
  completed: "completed",
  failed: "failed",
  pending: "pending",
  waiting_authorization: "waitingAuthorization",
  waiting_deposit: "waitingForDeposit",
  waiting_payment: "waitingPayment"
};
Ar.MOONPAY_ORDER_STATUS = _a;
const K7 = {
  __proto__: null,
  [qi.complete]: [_a.completed],
  [qi.failed]: [_a.failed],
  [qi.in_progress]: [_a.waiting_payment, _a.pending, _a.waiting_authorization, _a.waiting_deposit]
};
Ar.ORDER_STATUS_TO_MOONPAY_STATUS = K7;
const tc = {
  __proto__: null,
  completed: "COMPLETED",
  failed: "FAILED",
  initiated: "INITIATED",
  pending: "PENDING"
};
Ar.PAYPAL_ORDER_STATUS = tc;
const V7 = {
  __proto__: null,
  [qi.complete]: [tc.completed],
  [qi.failed]: [tc.failed],
  [qi.in_progress]: [tc.initiated, tc.pending]
};
Ar.ORDER_STATUS_TO_PAYPAL_STATUS = V7;
const fi = {
  __proto__: null,
  cancelled: "CANCELLED",
  expired: "EXPIRED",
  fiat_received: "FIAT_RECEIVED",
  fiat_sent: "FIAT_SENT",
  initialized: "INITIALIZED",
  payment_executed: "PAYMENT_EXECUTED",
  payment_failed: "PAYMENT_FAILED",
  payment_in_progress: "PAYMENT_IN_PROGRESS",
  payment_started: "PAYMENT_STARTED",
  released: "RELEASED",
  releasing: "RELEASING",
  review_rejected: "REVIEW_REJECTED"
};
Ar.RAMP_ORDER_STATUS = fi;
const H7 = {
  __proto__: null,
  [qi.complete]: [fi.released],
  [qi.failed]: [fi.cancelled, fi.expired, fi.payment_failed, fi.review_rejected],
  [qi.in_progress]: [fi.fiat_received, fi.fiat_sent, fi.initialized, fi.payment_executed, fi.payment_in_progress, fi.payment_started, fi.releasing]
};
Ar.ORDER_STATUS_TO_RAMP_STATUS = H7;
const Sa = {
  __proto__: null,
  complete: "Complete",
  declined: "Declined",
  draft: "Draft",
  expired: "Expired",
  processed: "Processed",
  user_custody: "UserCustody"
};
Ar.SARDINE_ORDER_STATUS = Sa;
const G7 = {
  __proto__: null,
  [qi.complete]: [Sa.complete],
  [qi.failed]: [Sa.declined, Sa.expired],
  [qi.in_progress]: [Sa.draft, Sa.user_custody, Sa.processed]
};
Ar.ORDER_STATUS_TO_SARDINE_STATUS = G7;
const Ise = {
  __proto__: null,
  [ji.ramp]: fi.expired,
  [ji.paypal]: tc.failed,
  [ji.moonpay]: _a.failed,
  [ji.sardine]: Sa.expired
};
Ar.STALE_STATUS = Ise;
const Tse = {
  __proto__: null,
  [ji.ramp]: fi.released,
  [ji.paypal]: tc.completed,
  [ji.moonpay]: _a.completed,
  [ji.sardine]: Sa.complete
};
Ar.COMPLETE_STATUS = Tse;
const kse = {
  __proto__: null,
  [ji.moonpay]: K7,
  [ji.paypal]: V7,
  [ji.ramp]: H7,
  [ji.sardine]: G7
};
Ar.STATUS_MAP = kse;
var df = {};
Object.defineProperty(df, "__esModule", {
  value: !0
});
df.isOrderAmountLegacyNumber = df.isOrderAmountLegacyDefaultUnitString = void 0;
const Rse = (t) => typeof t == "number" || typeof t == "string" && !isNaN(Number(t));
df.isOrderAmountLegacyNumber = Rse;
const Pse = (t, e) => typeof t == "string" && /^(\d+\.?\d*)\s+(\w+)$/.test(t);
df.isOrderAmountLegacyDefaultUnitString = Pse;
Object.defineProperty(Ca, "__esModule", {
  value: !0
});
Ca.fusionOrderToOrderAdapter = Ca.default = Ca.adapter = void 0;
var Ose = J7(zc), c2 = Bse(Ps), cn = J7(hr), Zd = Ar, rc = c1, bx = df;
function Z7(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (Z7 = function(n) {
    return n ? r : e;
  })(t);
}
function Bse(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var r = Z7(e);
  if (r && r.has(t))
    return r.get(t);
  var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in t)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(t, s)) {
      var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
      a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
    }
  return n.default = t, r && r.set(t, n), n;
}
function J7(t) {
  return t && t.__esModule ? t : { default: t };
}
function Mse(t, e, r) {
  return e = Cse(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Cse(t) {
  var e = Nse(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Nse(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Use(t, e) {
  Lse(t, e), e.add(t);
}
function Lse(t, e) {
  if (e.has(t))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function gx(t, e, r) {
  if (!e.has(t))
    throw new TypeError("attempted to get private field on non-instance");
  return r;
}
const Dse = (t, e) => {
  if (!e)
    throw new Error("assets is required");
  const r = {
    ...t
  }, n = t.orderType === Zd.ORDER_TYPES.buy, i = n ? t.toAsset : t.fromAsset, s = n ? t.toAmount : t.fromAmount, a = e[i].currency, o = !s || (0, bx.isOrderAmountLegacyNumber)(s) ? (0, rc.serialize)(a.defaultUnit(s ?? 0)) : (0, bx.isOrderAmountLegacyDefaultUnitString)(s) ? (0, rc.serialize)(a.parse(s)) : s;
  return r.fromAmount = n ? t.fromAmount : o, r.toAmount = n ? o : t.toAmount, r;
};
Ca.fusionOrderToOrderAdapter = Dse;
const Fse = ({
  createdAt: t,
  fee: e = 0,
  from: r,
  id: n,
  networkFee: i = 0,
  provider: s,
  providerId: a,
  rate: o,
  status: c,
  to: f,
  totalFee: u = 0,
  txId: d,
  type: l,
  walletAccount: h,
  walletAddress: y
}, p) => {
  if (!p)
    throw new Error("assets is required");
  const b = l === Zd.ORDER_TYPES.buy, v = b ? r : f, x = b ? f : r, I = p[x.asset], L = (0, rc.serialize)(I.currency.defaultUnit((x == null ? void 0 : x.amount) || 0));
  return {
    date: t,
    exodusRate: o,
    fees: {
      networkFee: i,
      providerFee: e,
      processingFee: 0,
      totalFee: u
    },
    fiatValue: v.amount,
    fromAddress: b ? null : y,
    fromAmount: b ? v.amount : L,
    fromAsset: r.asset,
    fromWalletAccount: b ? null : h,
    orderId: n,
    orderType: l,
    provider: s,
    providerOrderId: a,
    providerRate: o,
    status: c,
    toAddress: b ? y : null,
    toAmount: b ? L : v.amount,
    toAsset: f.asset,
    toWalletAccount: b ? h : null,
    txId: d
  };
};
Ca.adapter = Fse;
const Y7 = Symbol("FiatOrder");
var Fm = /* @__PURE__ */ new WeakSet();
class Cu {
  constructor(e, r) {
    Use(this, Fm), Cu.validate(e, r), Object.assign(this, e), this.exodusStatus === "complete" && this.errorMessage && (console.log("ignoring error given error complete"), delete this.errorMessage);
  }
  get exodusStatus() {
    const e = Zd.STATUS_MAP[this.provider], r = Object.entries(e).find(([, n]) => n.includes(this.status));
    return r ? r[0] : "in-progress";
  }
  get error() {
    return !!this.errorMessage;
  }
  get isBuy() {
    return this.orderType === "buy";
  }
  get isSell() {
    return this.orderType === "sell";
  }
  get cryptoAmount() {
    return this.isBuy ? this.toAmount : this.fromAmount;
  }
  get cryptoAsset() {
    return this.isBuy ? this.toAsset : this.fromAsset;
  }
  get txIds() {
    return this.txId ? [this.txId] : [];
  }
  static fromJSON(e) {
    const r = e.orderType === Zd.ORDER_TYPES.buy;
    return new Cu({
      ...e,
      date: e.date instanceof Date ? e.date : new Date(e.date),
      ...r ? {
        toAmount: (0, rc.deserialize)(e.toAmount)
      } : {
        fromAmount: (0, rc.deserialize)(e.fromAmount)
      }
    }, Y7);
  }
  equals(e) {
    const r = new Set(Object.keys(e)), n = new Set(Object.keys(this.toJSON()));
    return n.size === r.size && [...n].every((s) => r.has(s)) ? gx(this, Fm, mx).call(this, e) : !1;
  }
  inspect() {
    return `[${this.constructor.name} ${this.orderId}]`;
  }
  toJSON() {
    return {
      ...this,
      date: this.date.toISOString(),
      ...this.isBuy ? {
        toAmount: (0, rc.serialize)(this.toAmount)
      } : {
        fromAmount: (0, rc.serialize)(this.fromAmount)
      }
    };
  }
  toString() {
    return this.orderId;
  }
  update(e) {
    return gx(this, Fm, mx).call(this, e) ? this : Cu.fromJSON({
      ...this.toJSON(),
      ...e
    });
  }
}
Ca.default = Cu;
function mx(t) {
  return Object.keys(t).every((e) => {
    const r = t[e];
    if (r instanceof Date)
      return this[e].toISOString() === r.toISOString();
    if ((0, c2.isNumberUnit)(r)) {
      var n;
      return (n = this[e]) === null || n === void 0 ? void 0 : n.equals(r);
    }
    return (0, Ose.default)(this[e], t[e]);
  });
}
Mse(Cu, "validate", (t, e) => {
  (0, cn.default)(e === Y7, "please use Order.fromJSON()"), (0, cn.default)(typeof t.orderId == "string", 'expected string "orderId"'), (0, cn.default)(["buy", "sell"].includes(t.orderType), 'expected "orderType" of value "buy" | "sell"'), (0, cn.default)(typeof t.provider == "string" && Zd.STATUS_MAP[t.provider], "invalid provider"), (0, cn.default)(typeof t.status == "string", 'expected string "status"'), (0, cn.default)(typeof t.fromAddress == "string" || t.fromAddress === null, 'expected string or null "fromAddress"'), (0, cn.default)(typeof t.fromWalletAccount == "string" || t.fromWalletAccount === null, 'expected string or null "fromWalletAccount"'), (0, cn.default)(typeof t.fromAmount == "number" || t.fromAmount instanceof c2.default, 'expected number or NumberUnit "fromAmount"'), (0, cn.default)(typeof t.fromAsset == "string", 'expected string "fromAsset"'), (0, cn.default)(typeof t.toAddress == "string" || t.toAddress === null, 'expected string or null "toAddress"'), (0, cn.default)(typeof t.toWalletAccount == "string" || t.toWalletAccount === null, 'expected string or null "toWalletAccount"'), (0, cn.default)(typeof t.toAmount == "number" || t.toAmount instanceof c2.default, 'expected number or NumberUnit "toAmount"'), (0, cn.default)(typeof t.toAsset == "string", 'expected string "toAsset"'), (0, cn.default)(typeof t.fiatValue == "number", 'expected number "fiatValue"'), (0, cn.default)(typeof t.providerRate == "number", 'expected number "providerRate"'), (0, cn.default)(typeof t.exodusRate == "number", 'expected number "exodusRate"'), t.feesWereSubsidized !== void 0 && (0, cn.default)(typeof t.feesWereSubsidized == "boolean", 'expected boolean "feesWereSubsidized"'), t.errorMessage && (0, cn.default)(typeof t.errorMessage == "string", 'expected string "errorMessage"'), t.fees && (0, cn.default)(typeof t.fees == "object", 'expected object "fees"'), t.hideInHistory !== void 0 && (0, cn.default)(typeof t.hideInHistory == "boolean", 'expected boolean "hideInHistory"'), t.supportMessage != null && (0, cn.default)(typeof t.supportMessage == "string", 'expected string "supportMessage"'), t.showedFailureBanner !== void 0 && (0, cn.default)(typeof t.showedFailureBanner == "boolean", 'expected boolean "showedFailureBanner"');
});
var u1 = {};
Object.defineProperty(u1, "__esModule", {
  value: !0
});
u1.default = void 0;
var jse = X7(hr), $se = X7(Ca);
let Q7;
function X7(t) {
  return t && t.__esModule ? t : { default: t };
}
function vx(t, e) {
  qse(t, e), e.add(t);
}
function qse(t, e) {
  if (e.has(t))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Wse(t, e, r) {
  return e = zse(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function zse(t) {
  var e = Kse(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Kse(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function au(t, e, r) {
  if (!e.has(t))
    throw new TypeError("attempted to get private field on non-instance");
  return r;
}
const u2 = Symbol("FiatOrderSet");
var Nh = /* @__PURE__ */ new WeakSet(), Uh = /* @__PURE__ */ new WeakSet();
Q7 = Symbol.iterator;
class rs {
  constructor({
    items: e,
    initSymbol: r
  }) {
    vx(this, Uh), vx(this, Nh), (0, jse.default)(r === u2, "please use FiatOrderSet.EMPTY or FiatOrderSet.fromArray()");
    const n = [...e.values()];
    n.sort((i, s) => s.date - i.date), this._items = e, this._sortOrder = n.map((i) => i.orderId), this._txMap = /* @__PURE__ */ new Map();
    for (const i of n) {
      if (!i.txId)
        continue;
      const s = au(this, Nh, jm).call(this, i.txId);
      s.includes(String(i)) || this._txMap.set(i.txId, [...s, String(i)]);
    }
  }
  static fromArray(e) {
    return !e || Array.isArray(e) && e.length === 0 ? rs.EMPTY : new rs({
      items: new Map(e.map(Vse).map((r) => [String(r), r])),
      initSymbol: u2
    });
  }
  add(e) {
    if (!this.has(e))
      return rs.fromArray([...this, e]);
  }
  clone() {
    return rs.fromArray(this.toJSON());
  }
  delete(e) {
    if (this.has(e))
      return rs.fromArray(this.toJSON().filter(({
        orderId: r
      }) => r !== String(e)));
  }
  equals(e) {
    if (this.size !== e.size)
      return !1;
    for (let r = 0; r < this.size; ++r)
      if (au(this, Uh, $m).call(this, r) !== au(e, Uh, $m).call(e, r))
        return !1;
    return !0;
  }
  has(e) {
    return this._items.has(String(e));
  }
  get(e) {
    return this._items.get(String(e));
  }
  getAt(e) {
    return this.get(au(this, Uh, $m).call(this, e));
  }
  getByTxId(e, r = 0) {
    const n = au(this, Nh, jm).call(this, e);
    return this.get(n[r]);
  }
  getAllByTxId(e) {
    return au(this, Nh, jm).call(this, e).map((r) => this.get(r));
  }
  toJSON() {
    return [...this].map((e) => e.toJSON());
  }
  [Q7]() {
    return this._items.values();
  }
  get size() {
    return this._items.size;
  }
  union(e) {
    const r = [...this], n = [...e], i = [...r, ...n];
    return rs.fromArray(i);
  }
  update(e) {
    const r = [];
    for (const n of e) {
      const i = this.get(n);
      if (i) {
        const s = i.update({
          ...n
        });
        i !== s && r.push(s);
      }
    }
    return r.length === 0 ? this : rs.fromArray([...this.toJSON(), ...r]);
  }
}
u1.default = rs;
function jm(t) {
  return this._txMap.get(t) || [];
}
function $m(t) {
  return this._sortOrder[t];
}
Wse(rs, "EMPTY", new rs({
  items: /* @__PURE__ */ new Map(),
  initSymbol: u2
}));
function Vse(t) {
  return t instanceof rs ? t : $se.default.fromJSON(t);
}
var Nc = {};
Object.defineProperty(Nc, "__esModule", {
  value: !0
});
Nc.orderToJSONLegacy = Nc.orderFromJSONLegacy = void 0;
var wx = f1(Ul), Hse = f1($7), f2 = f1(hr), Gse = Ps, d2 = f1(Jc);
function f1(t) {
  return t && t.__esModule ? t : { default: t };
}
const Zse = (t, {
  assets: e
}) => {
  if ((0, f2.default)((0, wx.default)(t) || (0, Hse.default)(t), "fromJSONLegacy: requires a string or a plain object"), (0, wx.default)(t) && (t = JSON.parse(t)), t._version)
    return d2.default.fromJSON(t);
  (0, f2.default)(e, "fromJSONLegacy(): assets is required to parse legacy Order");
  const {
    fromAsset: r,
    toAsset: n
  } = t, i = t.fromAmount ? _x({
    amount: t.fromAmount,
    asset: e[r]
  }) : void 0, s = t.toAmount ? _x({
    amount: t.toAmount,
    asset: e[n]
  }) : void 0;
  return d2.default.fromJSON({
    ...t,
    fromAmount: i,
    toAmount: s
  });
};
Nc.orderFromJSONLegacy = Zse;
const Jse = (t) => {
  (0, f2.default)(t && t instanceof d2.default, "toJSONLegacy: requires an Order");
  const e = {
    ...t,
    date: t.date.toISOString()
  };
  return e.fromAmount && (e.fromAmount = e.fromAmount.toDefaultString({
    unit: !0
  })), e.toAmount && (e.toAmount = e.toAmount.toDefaultString({
    unit: !0
  })), delete e._version, e;
};
Nc.orderToJSONLegacy = Jse;
const _x = ({
  asset: t,
  amount: e
}) => (0, Gse.isNumberUnit)(e) ? e : t ? t.currency.parse(e) : void 0;
var lf = {};
Object.defineProperty(lf, "__esModule", {
  value: !0
});
lf.orderSetToJSONLegacy = lf.orderSetFromJSONLegacy = void 0;
var Yse = Y_(hr), eR = Nc, Qse = Y_(Jc), l2 = Y_(th);
function Y_(t) {
  return t && t.__esModule ? t : { default: t };
}
const Xse = (t, {
  assets: e
}) => t == null ? l2.default.EMPTY : l2.default.fromArray(t.map((r) => tae(r, e)));
lf.orderSetFromJSONLegacy = Xse;
const eae = (t) => ((0, Yse.default)(t instanceof l2.default, "orderSetToJSONLegacy: expecting an OrderSet"), [...t].map((e) => (0, eR.orderToJSONLegacy)(e)));
lf.orderSetToJSONLegacy = eae;
const tae = (t, e) => t instanceof Qse.default ? t : (0, eR.orderFromJSONLegacy)(t, {
  assets: e
});
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "AccountState", {
    enumerable: !0,
    get: function() {
      return p.default;
    }
  }), Object.defineProperty(t, "Address", {
    enumerable: !0,
    get: function() {
      return e.default;
    }
  }), Object.defineProperty(t, "AddressSet", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), t.FIAT_ORDER = void 0, Object.defineProperty(t, "FiatOrder", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), Object.defineProperty(t, "FiatOrderSet", {
    enumerable: !0,
    get: function() {
      return y.default;
    }
  }), Object.defineProperty(t, "Order", {
    enumerable: !0,
    get: function() {
      return u.default;
    }
  }), Object.defineProperty(t, "OrderSet", {
    enumerable: !0,
    get: function() {
      return d.default;
    }
  }), Object.defineProperty(t, "PersonalNote", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(t, "PersonalNoteSet", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(t, "Tx", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(t, "TxSet", {
    enumerable: !0,
    get: function() {
      return s.default;
    }
  }), Object.defineProperty(t, "UtxoCollection", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  }), Object.defineProperty(t, "WalletAccount", {
    enumerable: !0,
    get: function() {
      return f.default;
    }
  }), Object.defineProperty(t, "WalletAccountSet", {
    enumerable: !0,
    get: function() {
      return c.default;
    }
  }), Object.defineProperty(t, "currenciesForAsset", {
    enumerable: !0,
    get: function() {
      return b.currenciesForAsset;
    }
  }), Object.defineProperty(t, "ensureCurrencies", {
    enumerable: !0,
    get: function() {
      return b.ensureCurrencies;
    }
  }), Object.defineProperty(t, "fiatFusionOrderToOrderAdapter", {
    enumerable: !0,
    get: function() {
      return l.fusionOrderToOrderAdapter;
    }
  }), Object.defineProperty(t, "fiatOrderAdapter", {
    enumerable: !0,
    get: function() {
      return l.adapter;
    }
  }), Object.defineProperty(t, "normalizeTxJSON", {
    enumerable: !0,
    get: function() {
      return b.normalizeTxJSON;
    }
  }), Object.defineProperty(t, "normalizeTxsJSON", {
    enumerable: !0,
    get: function() {
      return b.normalizeTxsJSON;
    }
  }), Object.defineProperty(t, "orderFromJSONLegacy", {
    enumerable: !0,
    get: function() {
      return v.orderFromJSONLegacy;
    }
  }), Object.defineProperty(t, "orderSetFromJSONLegacy", {
    enumerable: !0,
    get: function() {
      return x.orderSetFromJSONLegacy;
    }
  }), Object.defineProperty(t, "orderSetToJSONLegacy", {
    enumerable: !0,
    get: function() {
      return x.orderSetToJSONLegacy;
    }
  }), Object.defineProperty(t, "orderToJSONLegacy", {
    enumerable: !0,
    get: function() {
      return v.orderToJSONLegacy;
    }
  });
  var e = P(Mf), r = P(Jl), n = P(Zc), i = P(Ql), s = P(n1), a = P(s1), o = P(Xl), c = P(a1), f = P(kr), u = P(Jc), d = P(th), l = L(Ca), h = L(Ar);
  t.FIAT_ORDER = h;
  var y = P(u1), p = P(c1), b = la, v = Nc, x = lf;
  function I(C) {
    if (typeof WeakMap != "function")
      return null;
    var D = /* @__PURE__ */ new WeakMap(), F = /* @__PURE__ */ new WeakMap();
    return (I = function(G) {
      return G ? F : D;
    })(C);
  }
  function L(C, D) {
    if (!D && C && C.__esModule)
      return C;
    if (C === null || typeof C != "object" && typeof C != "function")
      return { default: C };
    var F = I(D);
    if (F && F.has(C))
      return F.get(C);
    var G = {}, re = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var ie in C)
      if (ie !== "default" && Object.prototype.hasOwnProperty.call(C, ie)) {
        var ee = re ? Object.getOwnPropertyDescriptor(C, ie) : null;
        ee && (ee.get || ee.set) ? Object.defineProperty(G, ie, ee) : G[ie] = C[ie];
      }
    return G.default = C, F && F.set(C, G), G;
  }
  function P(C) {
    return C && C.__esModule ? C : { default: C };
  }
})(Qne);
xo("2m");
xo("30s");
xo("30s");
const rae = UV(J0.keyBy(EI, (t) => t.name));
new Yne({ assets: rae });
class nae extends Error {
  constructor() {
    super("Versioned transactions are not supported."), this.name = "VERSIONED_TRANSACTION_UNSUPPORTED";
  }
}
const iae = /* @__PURE__ */ new Set(["legacy", 0]);
function h2(t) {
  return tR(t) ? ve.from(t.serialize({ requireAllSignatures: !1 })) : ve.from(t.serialize());
}
function qm(t) {
  return h2(t).toString("base64");
}
function np(t) {
  try {
    return LU.from(t);
  } catch {
    if (!L6)
      throw new nae();
    return L6.deserialize(Uint8Array.from(t));
  }
}
function Sx(t) {
  const e = ve.from(t, "base64");
  return np(e);
}
function tR(t) {
  return !Number.isInteger(t.version);
}
function Ex(t, e) {
  t.signatures = e.signatures;
}
var to, ro, a0, Du;
class sae extends S2 {
  constructor({ transport: r, accountsObservable: n }) {
    super({ transport: r });
    ct(this, to, null);
    ct(this, ro, () => {
      if (!this.isConnected)
        throw new kL();
    });
    ct(this, a0, (r) => {
      var i;
      const n = new Gt(r[0]);
      (i = ke(this, to)) != null && i.equals(n) || (ir(this, to, n), this.emitAndIgnoreErrors("accountChanged", n));
    });
    ct(this, Du, async (r, n = !1) => {
      let i = "";
      const s = r.filter(tR);
      for (const a of s)
        a.feePayer || (a.feePayer = this.publicKey), !a.signatures.length && (!a.recentBlockhash || n) && (i || (i = await this._callRpcMethod("sol_getLatestBlockhash", ["finalized"])), a.recentBlockhash = i);
    });
    Zt(this, "connect", async ({ onlyIfTrusted: r = !1 } = {}) => {
      const n = await this._callRpcMethod("sol_connect", [r]), i = OL(n);
      return ir(this, to, i), this.emitAndIgnoreErrors("connect", i), { publicKey: i };
    });
    Zt(this, "disconnect", () => {
      ke(this, ro).call(this), ir(this, to, null), this.emitAndIgnoreErrors("disconnect");
    });
    Zt(this, "signTransaction", async (r) => {
      ke(this, ro).call(this);
      const n = r instanceof Uint8Array, i = n ? np(r) : r;
      await ke(this, Du).call(this, [i]);
      const s = qm(i), a = await this._callRpcMethod("sol_signTransaction", [s]), o = Sx(a);
      return Ex(i, o), n ? h2(i) : i;
    });
    Zt(this, "signAllTransactions", async (r) => {
      ke(this, ro).call(this);
      const n = r[0] instanceof Uint8Array, i = n ? r.map((c) => np(c)) : r;
      await ke(this, Du).call(this, i);
      const s = i.map((c) => qm(c)), o = (await this._callRpcMethod("sol_signAllTransactions", [s])).map((c) => Sx(c));
      return i.forEach((c, f) => {
        const u = o[f];
        Ex(c, u);
      }), n ? i.map((c) => h2(c)) : i;
    });
    Zt(this, "signAndSendTransaction", async (r, n = {}) => {
      ke(this, ro).call(this);
      const i = r instanceof Uint8Array, s = i ? np(r) : r;
      await ke(this, Du).call(this, [s], !0);
      const a = qm(s), c = await this._callRpcMethod("sol_signAndSendTransaction", [a, n]);
      return { signature: i ? DL(c) : c };
    });
    Zt(this, "signMessage", async (r, n = "utf8") => {
      if (ke(this, ro).call(this), !["hex", "utf8"].includes(n))
        throw new RL();
      const s = BL(r), a = await this._callRpcMethod("sol_signMessage", [s, n]);
      return { signature: FL(a), publicKey: this.publicKey };
    });
    Zt(this, "postMessage", () => {
      throw new TL();
    });
    Zt(this, "request", (r) => {
      const { method: n, params: i = [] } = r;
      if (n === "isConnected")
        return this._callRpcMethod("sol_isConnected", []);
      if (![
        "connect",
        "disconnect",
        "signTransaction",
        "signAllTransactions",
        "signAndSendTransaction",
        "signMessage",
        "postMessage"
      ].includes(n))
        throw new PL();
      return this[n](...i);
    });
    this.on("connect", () => {
      const i = n.observe((s) => {
        ke(this, a0).call(this, s);
      });
      this.on("disconnect", i);
    });
  }
  get supportedTransactionVersions() {
    return iae;
  }
  get publicKey() {
    return ke(this, to);
  }
  get isConnected() {
    return !!this.publicKey;
  }
}
to = new WeakMap(), ro = new WeakMap(), a0 = new WeakMap(), Du = new WeakMap();
const rR = "solana:signAndSendTransaction", nR = "solana:signMessage", iR = "solana:signTransaction", aae = "standard:connect", oae = "standard:disconnect", cae = "standard:events", uae = "solana:mainnet", Q_ = [uae];
function Wm(t) {
  return Q_.includes(t);
}
const fae = Q_, dae = [
  rR,
  iR,
  nR
];
var ol, cl, ul, fl, dl, ll;
const X_ = class X_ {
  constructor({ address: e, publicKey: r, label: n, icon: i }) {
    ct(this, ol, void 0);
    ct(this, cl, void 0);
    ct(this, ul, void 0);
    ct(this, fl, void 0);
    ct(this, dl, void 0);
    ct(this, ll, void 0);
    ir(this, ol, e), ir(this, cl, r), ir(this, ul, fae), ir(this, fl, dae), ir(this, dl, n), ir(this, ll, i), new.target === X_ && Object.freeze(this);
  }
  get address() {
    return ke(this, ol);
  }
  get publicKey() {
    return ke(this, cl).slice();
  }
  get chains() {
    return ke(this, ul).slice();
  }
  get features() {
    return ke(this, fl).slice();
  }
  get label() {
    return ke(this, dl);
  }
  get icon() {
    return ke(this, ll);
  }
};
ol = new WeakMap(), cl = new WeakMap(), ul = new WeakMap(), fl = new WeakMap(), dl = new WeakMap(), ll = new WeakMap();
let p2 = X_;
function lae(t, e) {
  return hae(t, e);
}
function hae(t, e) {
  if (t === e)
    return !0;
  const r = t.length;
  if (r !== e.length)
    return !1;
  for (let n = 0; n < r; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
var no, o0, hl, pl, $n, vi, c0, yl, y2, u0, sR, uc, bl, f0, d0, l0, gl, h0, ml;
class pae extends Gx {
  constructor({ provider: r, name: n, icon: i }) {
    super({ name: n, icon: i });
    ct(this, yl);
    ct(this, u0);
    ct(this, no, /* @__PURE__ */ Object.create(null));
    ct(this, o0, "1.0.0");
    ct(this, hl, void 0);
    ct(this, pl, void 0);
    ct(this, $n, null);
    ct(this, vi, void 0);
    ct(this, c0, (r, n) => {
      var i;
      return (i = ke(this, no)[r]) != null && i.push(n) || (ke(this, no)[r] = [n]), () => Oo(this, u0, sR).call(this, r, n);
    });
    ct(this, uc, () => {
      var n;
      const r = (n = ke(this, vi).publicKey) == null ? void 0 : n.toBase58();
      if (r) {
        const i = ke(this, vi).publicKey.toBytes(), s = ke(this, $n);
        (!s || s.address !== r || !lae(s.publicKey, i)) && (ir(this, $n, new p2({ address: r, publicKey: i })), Oo(this, yl, y2).call(this, "change", { accounts: this.accounts }));
      }
    });
    ct(this, bl, () => {
      ke(this, $n) && (ir(this, $n, null), Oo(this, yl, y2).call(this, "change", { accounts: this.accounts }));
    });
    ct(this, f0, () => {
      ke(this, vi).publicKey ? ke(this, uc).call(this) : ke(this, bl).call(this);
    });
    ct(this, d0, async ({ silent: r } = {}) => (ke(this, $n) || await ke(this, vi).connect(r ? { onlyIfTrusted: !0 } : void 0), ke(this, uc).call(this), { accounts: this.accounts }));
    ct(this, l0, async () => {
      await ke(this, vi).disconnect();
    });
    ct(this, gl, async (...r) => {
      if (!ke(this, $n))
        throw new Error("not connected");
      const n = [];
      if (r.length === 1) {
        const { transaction: i, account: s, chain: a, options: o } = r[0], { minContextSlot: c, preflightCommitment: f, skipPreflight: u, maxRetries: d } = o || {};
        if (s !== ke(this, $n))
          throw new Error("invalid account");
        if (!Wm(a))
          throw new Error("invalid chain");
        const { signature: l } = await ke(this, vi).signAndSendTransaction(i, {
          maxRetries: d,
          minContextSlot: c,
          preflightCommitment: f,
          skipPreflight: u
        });
        n.push({ signature: l });
      } else if (r.length > 1)
        for (const i of r)
          n.push(...await ke(this, gl).call(this, i));
      return n;
    });
    ct(this, h0, async (...r) => {
      if (!ke(this, $n))
        throw new Error("not connected");
      const n = [];
      if (r.length === 1) {
        const { transaction: i, account: s, chain: a } = r[0];
        if (s !== ke(this, $n))
          throw new Error("invalid account");
        if (a && !Wm(a))
          throw new Error("invalid chain");
        const o = await ke(this, vi).signTransaction(i);
        n.push({ signedTransaction: o });
      } else if (r.length > 1) {
        let i;
        for (const o of r) {
          if (o.account !== ke(this, $n))
            throw new Error("invalid account");
          if (o.chain) {
            if (!Wm(o.chain))
              throw new Error("invalid chain");
            if (i) {
              if (o.chain !== i)
                throw new Error("conflicting chain");
            } else
              i = o.chain;
          }
        }
        const s = r.map(({ transaction: o }) => o), a = await ke(this, vi).signAllTransactions(s);
        n.push(...a.map((o) => ({
          signedTransaction: o
        })));
      }
      return n;
    });
    ct(this, ml, async (...r) => {
      if (!ke(this, $n))
        throw new Error("not connected");
      const n = [];
      if (r.length === 1) {
        const { message: i, account: s } = r[0];
        if (s !== ke(this, $n))
          throw new Error("invalid account");
        const { signature: a } = await ke(this, vi).signMessage(i);
        n.push({ signedMessage: i, signature: a });
      } else if (r.length > 1)
        for (const i of r)
          n.push(...await ke(this, ml).call(this, i));
      return n;
    });
    if (!r)
      throw new Error("Solana Provider is required!");
    ir(this, hl, n), ir(this, pl, i), ir(this, vi, r), r.on("connect", ke(this, uc), this), r.on("disconnect", ke(this, bl), this), r.on("accountChanged", ke(this, f0), this), ke(this, uc).call(this);
  }
  get version() {
    return ke(this, o0);
  }
  get name() {
    return ke(this, hl);
  }
  get icon() {
    return ke(this, pl);
  }
  get chains() {
    return Q_.slice();
  }
  get features() {
    const { supportedTransactionVersions: r } = ke(this, vi);
    return {
      [aae]: {
        version: "1.0.0",
        connect: ke(this, d0)
      },
      [oae]: {
        version: "1.0.0",
        disconnect: ke(this, l0)
      },
      [cae]: {
        version: "1.0.0",
        on: ke(this, c0)
      },
      [rR]: {
        version: "1.0.0",
        supportedTransactionVersions: Array.from(r),
        signAndSendTransaction: ke(this, gl)
      },
      [iR]: {
        version: "1.0.0",
        supportedTransactionVersions: Array.from(r),
        signTransaction: ke(this, h0)
      },
      [nR]: {
        version: "1.0.0",
        signMessage: ke(this, ml)
      }
    };
  }
  get accounts() {
    return ke(this, $n) ? [ke(this, $n)] : [];
  }
}
no = new WeakMap(), o0 = new WeakMap(), hl = new WeakMap(), pl = new WeakMap(), $n = new WeakMap(), vi = new WeakMap(), c0 = new WeakMap(), yl = new WeakSet(), y2 = function(r, ...n) {
  var i;
  (i = ke(this, no)[r]) == null || i.forEach((s) => s.apply(null, n));
}, u0 = new WeakSet(), sR = function(r, n) {
  var i;
  ke(this, no)[r] = (i = ke(this, no)[r]) == null ? void 0 : i.filter((s) => n !== s);
}, uc = new WeakMap(), bl = new WeakMap(), f0 = new WeakMap(), d0 = new WeakMap(), l0 = new WeakMap(), gl = new WeakMap(), h0 = new WeakMap(), ml = new WeakMap();
var yae = ({ transport: t, accountsObservable: e, injectWindow: r = !1, walletStandard: n = !0 }) => {
  let i = new sae({ transport: t, accountsObservable: e });
  return i.defineFlag(qu), _2(i, m2, qu), n && Jx(new pae({ name: v2, icon: w2, provider: i })), r && (window.solana = i), i;
};
const zm = () => {
  let t = [];
  function e(n) {
    t.forEach((i) => i(n));
  }
  function r(n) {
    return t.push(n), () => {
      t = t.filter((i) => i !== n);
    };
  }
  return { notify: e, observe: r };
};
function bae(t, e) {
  const { bitcoin: r, ethereum: n, solana: i } = e;
  let s;
  if (r) {
    const c = zm();
    s = $P({
      accountsObservable: c,
      transport: t,
      injectWindow: r.dangerouslyInjectWindow,
      walletStandard: r.walletStandard
    }), window.addEventListener("message", (f) => {
      f.data === "wallet:locked" && c.notify([]);
    });
  }
  let a;
  if (n) {
    const c = zm();
    a = tO({
      transport: t,
      accountsObservable: c,
      injectWindow: n.dangerouslyInjectWindow,
      eip6963: n.eip6963
    }), window.addEventListener("message", (f) => {
      f.data === "wallet:locked" && c.notify([]);
    });
  }
  let o;
  if (i) {
    const c = zm();
    o = yae({
      transport: t,
      accountsObservable: c,
      injectWindow: i.dangerouslyInjectWindow,
      walletStandard: i.walletStandard
    }), window.addEventListener("message", (f) => {
      f.data === "wallet:locked" && c.notify([]);
    });
  }
  return {
    bitcoin: s,
    ethereum: a,
    solana: o
  };
}
const Km = "requests", gae = "0x[0-9a-fA-F]+", mae = new RegExp(
  [
    //
    `${gae}_eth_accounts`
    // To allow Wagmi to reconnect on refresh.
  ].join("|"),
  "g"
), vae = () => {
  const t = (s, a) => {
    localStorage.setItem(`${Km}:${s}`, JSON.stringify(a));
  }, e = (s, a) => {
    mae.test(s) && t(s, a);
  }, r = (s) => {
    const a = localStorage.getItem(`${Km}:${s}`);
    if (!a)
      return a;
    let o = a;
    try {
      o = JSON.parse(a);
    } catch {
    }
    return o;
  };
  return { saveResponse: e, fetchResponse: (s) => r(s), clear: () => {
    Object.keys(localStorage).filter((s) => s.startsWith(`${Km}:`)).forEach((s) => localStorage.removeItem(s));
  } };
}, wae = () => {
  let t = Zm();
  return t.resolved = !1, { awaitReady: () => t.promise, isReady: () => !!t.resolved, setReady: () => {
    t.resolve(), t.resolved = !0;
  }, resetReady: () => {
    t = Zm(), t.resolved = !1;
  } };
};
function _ae(t) {
  return t ? `${jo}?appId=${t}` : jo;
}
function Sae(t) {
  const e = document.createElement("iframe"), r = _ae(t);
  return e.setAttribute("src", r), e.style.width = "100%", e.style.height = "100%", e.style.display = "none", e.style.border = "none", e.style.colorScheme = "normal", e.allow = "clipboard-write; publickey-credentials-get *", e;
}
const Lh = (t) => t != null && typeof t == "object", aR = (t, e) => {
  if (!Lh(t) || !Lh(e))
    return t === e;
  const r = Object.keys(t), n = Object.keys(e);
  if (r.length !== n.length)
    return !1;
  for (const i of r) {
    const s = t[i], a = e[i], o = Lh(s) && Lh(a);
    if (o && !aR(s, a) || !o && s !== a)
      return !1;
  }
  return !0;
}, Eae = typeof window < "u", xae = Eae ? /\(.*Win.*\)/.test(navigator.userAgent) : !1, xx = xae ? 456 : 424, Ax = 664, Aae = async ({ target: t }) => new Promise((r) => {
  const n = window.screen.width / 2 - xx / 2, i = window.screen.height / 2 - Ax / 2, s = window.open(t, "popup", `toolbar=no,location=no,status=no,menubar=no,resizable=no,scrollbars=no,width=${xx},height=${Ax},top=${i},left=${n},`);
  if (!s) {
    r(null);
    return;
  }
  const a = (o) => {
    o.data === "rpc:ready" && (window.removeEventListener("message", a), r(s));
  };
  window.addEventListener("message", a), s.focus();
});
function Iae() {
  const t = document.querySelector(
    'head > meta[property="og:site_name"]'
  );
  if (t)
    return t.content;
  const e = document.querySelector(
    'head > meta[name="title"]'
  );
  return e ? e.content : document.title;
}
async function Tae() {
  return {
    title: Iae()
  };
}
const kae = "linear-gradient(193deg, rgba(211, 221, 108, 0.15) 8.94%, rgba(211, 221, 108, 0.00) 24.81%, rgba(217, 177, 216, 0.00) 63.19%, rgba(217, 177, 216, 0.28) 93.8%), linear-gradient(180deg, #FFF 62.19%, #F5F5F5 91%)", Rae = 540, Pae = '<svg width="104" height="113" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" width="98" height="98" rx="49" fill="url(#passkeys-a)" style="mix-blend-mode:darken"/><g filter="url(#passkeys-b)"><rect x="12" y="9" width="80" height="80" rx="40" fill="#fff" shape-rendering="crispEdges"/><rect x="12.5" y="9.5" width="79" height="79" rx="39.5" stroke="url(#passkeys-c)" stroke-opacity=".09" shape-rendering="crispEdges"/><g clip-path="url(#passkeys-d)"><g filter="url(#passkeys-e)"><rect x="35" y="32" width="34" height="32" rx="9" fill="#181818"/><rect x="35.4" y="32.4" width="33.2" height="31.2" rx="8.6" stroke="url(#passkeys-f)" stroke-opacity=".09" stroke-width=".8"/></g><rect x="51" y="38" width="12" height="11" rx="3" fill="#fff"/></g></g><defs><linearGradient id="passkeys-a" x1="82.625" y1="40.425" x2="-2.155" y2="77.7" gradientUnits="userSpaceOnUse"><stop stop-color="#D3DD6C"/><stop offset=".088" stop-color="#CEBFA2"/><stop offset=".286" stop-color="#CEB0C8" stop-opacity=".5"/><stop offset=".583" stop-color="#CFCAC6" stop-opacity="0"/></linearGradient><linearGradient id="passkeys-c" x1="52" y1="9" x2="52" y2="89" gradientUnits="userSpaceOnUse"><stop stop-color="#151515" stop-opacity="0"/><stop offset=".681" stop-color="#151515"/></linearGradient><linearGradient id="passkeys-f" x1="52" y1="32" x2="52" y2="64" gradientUnits="userSpaceOnUse"><stop stop-color="#151515" stop-opacity="0"/><stop offset=".681" stop-color="#151515"/></linearGradient><filter id="passkeys-b" x="0" y="7" width="104" height="106" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" in="SourceAlpha" result="effect1_dropShadow_2288_4118"/><feOffset dy="2"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" in="SourceAlpha" result="effect2_dropShadow_2288_4118"/><feOffset dy="4"/><feGaussianBlur stdDeviation="4"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"/><feBlend in2="effect1_dropShadow_2288_4118" result="effect2_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius=".635" in="SourceAlpha" result="effect3_dropShadow_2288_4118"/><feOffset dy=".635"/><feGaussianBlur stdDeviation=".635"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend in2="effect2_dropShadow_2288_4118" result="effect3_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius=".635" in="SourceAlpha" result="effect4_dropShadow_2288_4118"/><feOffset dy="1.27"/><feGaussianBlur stdDeviation="1.27"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"/><feBlend in2="effect3_dropShadow_2288_4118" result="effect4_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" in="SourceAlpha" result="effect5_dropShadow_2288_4118"/><feOffset dy="4"/><feGaussianBlur stdDeviation="3"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"/><feBlend in2="effect4_dropShadow_2288_4118" result="effect5_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="4" in="SourceAlpha" result="effect6_dropShadow_2288_4118"/><feOffset dy="12"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend in2="effect5_dropShadow_2288_4118" result="effect6_dropShadow_2288_4118"/><feBlend in="SourceGraphic" in2="effect6_dropShadow_2288_4118" result="shape"/></filter><filter id="passkeys-e" x="30.2" y="30.4" width="43.6" height="41.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="1.6" in="SourceAlpha" result="effect1_dropShadow_2288_4118"/><feOffset dy="1.6"/><feGaussianBlur stdDeviation="1.6"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="1.6" in="SourceAlpha" result="effect2_dropShadow_2288_4118"/><feOffset dy="3.2"/><feGaussianBlur stdDeviation="3.2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"/><feBlend in2="effect1_dropShadow_2288_4118" result="effect2_dropShadow_2288_4118"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_2288_4118" result="shape"/></filter><clipPath id="passkeys-d"><path fill="#fff" transform="translate(32 29)" d="M0 0h40v40H0z"/></clipPath></defs></svg>', Oae = '<svg width="104" height="112" viewBox="0 0 104 112" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="52" cy="48" r="48" fill="url(#paint0_linear_7014_172)" style="mix-blend-mode:darken"/><g filter="url(#filter0_dddddd_7014_172)"><circle cx="52" cy="48" r="40" fill="#181818"/><circle cx="52" cy="48" r="39.5" stroke="url(#paint1_linear_7014_172)" stroke-opacity="0.09"/></g><ellipse cx="41.6512" cy="47.6512" rx="7.65123" ry="7.65123" fill="white"/><ellipse cx="62.349" cy="47.6512" rx="7.65123" ry="7.65123" fill="white"/><ellipse cx="1.69244" cy="1.69244" rx="1.69244" ry="1.69244" transform="matrix(1 0 0 -1 64.335 50.4112)" fill="#181818"/><ellipse cx="1.69244" cy="1.69244" rx="1.69244" ry="1.69244" transform="matrix(1 0 0 -1 42.8979 50.4112)" fill="#181818"/><ellipse cx="10" cy="10" rx="10" ry="10" transform="matrix(1 0 0 -1 52.437 40)" fill="#181818"/><ellipse cx="10" cy="10" rx="10" ry="10" transform="matrix(1 0 0 -1 31 40)" fill="#181818"/><defs><filter id="filter0_dddddd_7014_172" x="0" y="6" width="104" height="106" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect1_dropShadow_7014_172"/><feOffset dy="2"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7014_172"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect2_dropShadow_7014_172"/><feOffset dy="4"/><feGaussianBlur stdDeviation="4"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"/><feBlend mode="normal" in2="effect1_dropShadow_7014_172" result="effect2_dropShadow_7014_172"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="0.635" operator="erode" in="SourceAlpha" result="effect3_dropShadow_7014_172"/><feOffset dy="0.635"/><feGaussianBlur stdDeviation="0.635"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend mode="normal" in2="effect2_dropShadow_7014_172" result="effect3_dropShadow_7014_172"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="0.635" operator="erode" in="SourceAlpha" result="effect4_dropShadow_7014_172"/><feOffset dy="1.27"/><feGaussianBlur stdDeviation="1.27"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"/><feBlend mode="normal" in2="effect3_dropShadow_7014_172" result="effect4_dropShadow_7014_172"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect5_dropShadow_7014_172"/><feOffset dy="4"/><feGaussianBlur stdDeviation="3"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"/><feBlend mode="normal" in2="effect4_dropShadow_7014_172" result="effect5_dropShadow_7014_172"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect6_dropShadow_7014_172"/><feOffset dy="12"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend mode="normal" in2="effect5_dropShadow_7014_172" result="effect6_dropShadow_7014_172"/><feBlend mode="normal" in="SourceGraphic" in2="effect6_dropShadow_7014_172" result="shape"/></filter><linearGradient id="paint0_linear_7014_172" x1="82" y1="39.6" x2="-1.05" y2="76.1139" gradientUnits="userSpaceOnUse"><stop stop-color="#D3DD6C"/><stop offset="0.0877097" stop-color="#CEBFA2"/><stop offset="0.285812" stop-color="#CEB0C8" stop-opacity="0.5"/><stop offset="0.582843" stop-color="#CFCAC6" stop-opacity="0"/></linearGradient><linearGradient id="paint1_linear_7014_172" x1="52" y1="8" x2="52" y2="88" gradientUnits="userSpaceOnUse"><stop stop-color="#151515" stop-opacity="0"/><stop offset="0.681179" stop-color="#151515"/></linearGradient></defs></svg>';
class Bae {
  constructor() {
    Zt(this, "parseFromString", () => "");
  }
}
const Mae = new (typeof window > "u" ? Bae : DOMParser)();
function Ix(t) {
  return Mae.parseFromString(
    t,
    "image/svg+xml"
  ).firstChild;
}
const Tx = {
  popup: Ix(Pae),
  private: Ix(Oae)
};
function b2({ element: t, style: e }) {
  Object.assign(t.style, e);
}
function kx(t) {
  const { element: e } = t;
  e.style.cssText = "", b2(t);
}
function Cae() {
  const t = {
    default: [],
    fullScreen: []
  }, e = window.matchMedia(
    `(max-width: ${Rae}px)`
  ), r = (s, a) => {
    Object.entries(a).forEach(
      ([o, c]) => t[o].push({ element: s, style: c })
    ), kx({ element: s, style: a.default }), e.matches && b2({ element: s, style: a.fullScreen });
  }, n = () => {
    if (e.matches) {
      t.fullScreen.forEach(b2);
      return;
    }
    t.default.forEach(kx);
  };
  return e.addEventListener("change", n), {
    registerStyles: r,
    removeResponsiveListeners: () => {
      e.removeEventListener("change", n);
    }
  };
}
const Nae = {
  background: "#181818",
  color: "#fff",
  padding: "14px",
  border: "none",
  borderRadius: "12px",
  width: "100%"
}, Uae = {
  border: "none",
  color: "#181818",
  background: "none"
}, Lae = {
  primary: Nae,
  secondary: Uae
};
function Dae() {
  const t = document.createElement("div");
  return t.style.background = "rgba(0, 0, 0, 0.5)", t.style.bottom = "0", t.style.left = "0", t.style.opacity = "0", t.style.overflow = "auto", t.style.position = "fixed", t.style.display = "flex", t.style.alignItems = "flex-start", t.style.right = "0", t.style.top = "0", t.style.transition = "opacity 0.3s ease-in-out", t.style.zIndex = "999999999", setTimeout(() => t.style.opacity = "1", 100), t;
}
function Fae({
  width: t = 400,
  height: e = 430,
  registerStyles: r
}) {
  const n = document.createElement("div");
  return n.ariaModal = "true", n.role = "dialog", n.tabIndex = -1, n.dataset.clickOutsideContext = "wallet-widget", r(n, {
    default: {
      boxSizing: "border-box",
      alignItems: "center",
      background: kae,
      borderRadius: "32px",
      color: "black",
      display: "flex",
      flexDirection: "column",
      fontWeight: "500",
      gap: "16px",
      margin: "10vh auto",
      minHeight: `${e}px`,
      outline: "none",
      padding: "40px",
      position: "relative",
      width: `${t}px`
    },
    fullScreen: {
      alignSelf: "flex-end",
      width: "100%",
      maxHeight: "85vh",
      margin: "0",
      padding: "40px 24px 24px",
      borderBottomLeftRadius: "0",
      borderBottomRightRadius: "0"
    }
  }), n;
}
function Rx({ value: t, size: e = 18, color: r = "#000" }) {
  const n = document.createElement("p");
  return n.textContent = t, n.style.color = r, n.style.fontSize = `${e}px`, n.style.lineHeight = "110%", n.style.textAlign = "center", n;
}
function Px({ value: t, variant: e = "primary" }) {
  const r = document.createElement("button"), n = Lae[e] || {};
  return r.textContent = t, r.style.cursor = "pointer", r.style.fontSize = "16px", Object.assign(r.style, n), r;
}
function jae({ title: t, message: e }) {
  const r = document.createElement("div");
  r.style.alignItems = "center", r.style.display = "flex", r.style.flex = "1", r.style.flexDirection = "column", r.style.gap = "16px";
  const n = Rx({ value: t, size: 24 }), i = Rx({
    value: e,
    size: 18,
    color: "#737373"
  });
  return r.append(n), r.append(i), r;
}
function Ox({
  title: t,
  message: e,
  icon: r = "popup",
  acceptText: n = "Continue",
  cancelText: i = "Cancel"
}) {
  const { registerStyles: s, removeResponsiveListeners: a } = Cae(), o = Dae(), c = Fae({ registerStyles: s }), f = jae({ title: t, message: e }), u = Px({ value: n, variant: "primary" }), d = Px({
    value: i,
    variant: "secondary"
  });
  return Tx[r] && c.append(Tx[r] || void 0), c.append(f), c.append(u), i && c.append(d), o.append(c), document.body.append(o), new Promise((l) => {
    const h = (y) => () => {
      a(), o.remove(), l(y);
    };
    u.addEventListener("click", h(!0)), i && d.addEventListener("click", h(!1));
  });
}
const oR = (t, e) => JSON.stringify({
  jsonrpc: "2.0",
  id: t,
  result: e
}), $ae = (t, e, r) => JSON.stringify({
  jsonrpc: "2.0",
  id: t,
  method: e,
  params: r
}), qae = ({
  getIframe: t
}) => {
  let e, r, n;
  const i = Tae();
  let s;
  i.then((p) => {
    s = p;
  });
  const a = async ({ target: p }) => ((!e || e != null && e.closed) && (n = void 0), n ? n.then((b) => (e.focus(), b)) : (r = p, e = await Aae({ target: p }), e ? { success: !0, error: null } : { success: !1, error: "popup blocked" })), o = async () => {
    await n, n = void 0, r = void 0, e == null || e.close();
  }, c = ({ id: p, response: b }) => {
    const v = oR(p, b), x = { type: ev, input: v }, { element: I, url: L } = t();
    I.contentWindow.postMessage(x, L);
  }, f = async ({ id: p, params: b }) => {
    const v = await Ox(b);
    return c({ id: p, response: v });
  }, u = async ({ id: p, params: b }) => (await Ox({ cancelText: null, acceptText: "Close", ...b }), c({ id: p, response: !0 })), d = async ({ id: p, method: b, params: v }) => {
    const { target: x, ...I } = v, L = await a({ target: x });
    if (!L.success)
      return c({ id: p, response: L });
    await n, await i;
    const P = {
      type: ev,
      input: $ae(p, b, {
        ...I,
        metadata: s
      })
    };
    e.postMessage(P, r);
  }, l = {
    confirm: f,
    notify: u
  };
  return { handleRequest: async (p) => {
    const { id: b, method: v, params: x } = JSON.parse(p.data.input);
    return (l[v] || d)({ id: b, method: v, params: x });
  }, handleResponse: (p) => {
    const { element: b, url: v } = t();
    b.contentWindow.postMessage(p.data, v), o();
  } };
}, cR = typeof window < "u", Wae = {
  providers: {},
  renderWidget: async () => {
    throw new Error(
      "`renderWidget` is not available in non-browser environments."
    );
  },
  setWidgetConfig: async () => {
    throw new Error(
      "`setWidgetConfig` is not available in non-browser environments."
    );
  },
  experimental_expand: () => {
    throw new Error(
      "`experimental_expand` is not available in non-browser environments."
    );
  },
  experimental_destroyWidget: () => {
    throw new Error(
      "`experimental_destroyWidget` is not available in non-browser environments."
    );
  }
}, zae = (t, e, r) => {
  const n = new URL(t);
  return n.searchParams.append(e, r), n.toString();
}, Kae = (t, e) => {
  const { data: r, origin: n } = t;
  return !(!e.includes(n) || typeof r != "object" || r.type !== "provider:response");
}, Vae = "3.3.4", Hae = ut.env.NODE_ENV === "test";
let Jf = null;
const ece = (t) => {
  if (!cR)
    return Wae;
  if (Jf && !Hae)
    return console.warn(
      "@passkeys/core: 'createWallet' was called more than once. This is not supported."
    ), Jf;
  const { appId: e, providers: r, networks: n } = vP(t), i = Sae(e), s = vae(), a = /* @__PURE__ */ new Map(), { awaitReady: o, isReady: c, setReady: f, resetReady: u } = wae(), d = (E) => {
    E.data === wP && f();
  };
  window.addEventListener("message", d);
  const l = (E) => {
    E.data === _P && s.clear();
  };
  window.addEventListener("message", l);
  const { handleRequest: h, handleResponse: y } = qae({
    getIframe: () => ({
      element: i,
      url: jo
    })
  }), p = async (E) => {
    if (E.data.type !== ev)
      return;
    !!JSON.parse(E.data.input).method ? await h(E) : await y(E);
  };
  window.addEventListener("message", p);
  const b = async (E) => {
    const U = JSON.parse(E);
    if (a.set(U.id, { input: E, payload: U, deferred: Zm() }), !c()) {
      const W = U.method, _ = s.fetchResponse(W);
      if (_) {
        window.postMessage({
          type: AP,
          input: oR(U.id, _),
          fromCache: !0
        });
        return;
      }
    }
    await o(), i.contentWindow.postMessage(
      {
        type: xP,
        input: E
      },
      jo
    );
  }, v = /* @__PURE__ */ new Set(), I = { write: b, on: (E, U) => {
    const W = (_) => {
      if (!Kae(_, [jo, location.origin]))
        return;
      const R = JSON.parse(_.data.input), N = a.get(R.id);
      if (N) {
        const { method: O } = N.payload, g = R.result;
        s.saveResponse(O, g), N.deferred.resolve(), a.delete(R.id);
      }
      U(_.data.input);
    };
    v.add(W), window.addEventListener("message", W);
  } };
  let L;
  const P = (E) => {
    i.contentWindow.postMessage(
      { type: EP, config: E },
      jo
    );
  }, C = (E) => {
    !E || aR(E, L) || (L = E, c() && P(E));
  };
  let D = Promise.resolve();
  const F = async (E) => {
    await D, i.parentElement !== E && (await o(), u(), await Promise.allSettled(
      [...a.values()].map(({ deferred: U }) => U.promise)
    ), i.style.display = "initial", i.src = zae(
      i.src,
      "theme",
      JSON.stringify((L == null ? void 0 : L.theme) || {})
    ), E.append(i), await o(), L && P(L));
  }, G = () => {
    D = Promise.resolve(), u(), document.body.append(i), i.style.display = "none", a.forEach(({ input: E }) => b(E));
  }, re = async (E) => E ? (D = F(E), D) : G(), ie = async ({ path: E } = {}) => {
    await o(), E && i.contentWindow.postMessage(
      { type: SP, path: E },
      jo
    ), window.postMessage({ type: "wallet:resize", expanded: !0 });
  }, ee = () => {
    [
      ...v,
      d,
      l,
      p
    ].forEach(
      (U) => window.removeEventListener("message", U)
    ), v.clear(), a.clear(), s.clear(), i.remove(), Jf = null;
  };
  document.body.append(i);
  let $ = r;
  return n && ($ = n, console.warn("`networks` option is deprecated, use `providers` instead.")), Jf = {
    providers: bae(I, $),
    renderWidget: re,
    setWidgetConfig: C,
    // eslint-disable-next-line camelcase
    experimental_expand: ie,
    // eslint-disable-next-line camelcase
    experimental_destroyWidget: ee
  }, Jf;
};
cR && Object.defineProperty(window, "__passkeys-core-version__", {
  value: Vae,
  writable: !1,
  enumerable: !1
});
export {
  ece as createWallet
};
